/* eslint-disable */
/*eslint-disable*/
import * as $protobuf from "protobufjs/minimal";

// Common aliases
const $Reader = $protobuf.Reader, $Writer = $protobuf.Writer, $util = $protobuf.util;

// Exported root namespace
const $root = $protobuf.roots.payment3_paymentmethod_coordinator || ($protobuf.roots.payment3_paymentmethod_coordinator = {});

export const payment3_paymentmethod_coordinatorpb = $root.payment3_paymentmethod_coordinatorpb = (() => {

    /**
     * Namespace payment3_paymentmethod_coordinatorpb.
     * @exports payment3_paymentmethod_coordinatorpb
     * @namespace
     */
    const payment3_paymentmethod_coordinatorpb = {};

    payment3_paymentmethod_coordinatorpb.CreatePaymentMethodRegistrationRequest = (function() {

        /**
         * Properties of a CreatePaymentMethodRegistrationRequest.
         * @memberof payment3_paymentmethod_coordinatorpb
         * @interface ICreatePaymentMethodRegistrationRequest
         * @property {payment3_paymentmethodpb.IPaymentMethod|null} [paymentMethod] CreatePaymentMethodRegistrationRequest paymentMethod
         * @property {payment3_paymentmethod_coordinatorpb.IDefaultPaymentMethodCheck|null} [defaultCheck] CreatePaymentMethodRegistrationRequest defaultCheck
         */

        /**
         * Constructs a new CreatePaymentMethodRegistrationRequest.
         * @memberof payment3_paymentmethod_coordinatorpb
         * @classdesc Represents a CreatePaymentMethodRegistrationRequest.
         * @implements ICreatePaymentMethodRegistrationRequest
         * @constructor
         * @param {payment3_paymentmethod_coordinatorpb.ICreatePaymentMethodRegistrationRequest=} [p] Properties to set
         */
        function CreatePaymentMethodRegistrationRequest(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * CreatePaymentMethodRegistrationRequest paymentMethod.
         * @member {payment3_paymentmethodpb.IPaymentMethod|null|undefined} paymentMethod
         * @memberof payment3_paymentmethod_coordinatorpb.CreatePaymentMethodRegistrationRequest
         * @instance
         */
        CreatePaymentMethodRegistrationRequest.prototype.paymentMethod = null;

        /**
         * CreatePaymentMethodRegistrationRequest defaultCheck.
         * @member {payment3_paymentmethod_coordinatorpb.IDefaultPaymentMethodCheck|null|undefined} defaultCheck
         * @memberof payment3_paymentmethod_coordinatorpb.CreatePaymentMethodRegistrationRequest
         * @instance
         */
        CreatePaymentMethodRegistrationRequest.prototype.defaultCheck = null;

        /**
         * Creates a new CreatePaymentMethodRegistrationRequest instance using the specified properties.
         * @function create
         * @memberof payment3_paymentmethod_coordinatorpb.CreatePaymentMethodRegistrationRequest
         * @static
         * @param {payment3_paymentmethod_coordinatorpb.ICreatePaymentMethodRegistrationRequest=} [properties] Properties to set
         * @returns {payment3_paymentmethod_coordinatorpb.CreatePaymentMethodRegistrationRequest} CreatePaymentMethodRegistrationRequest instance
         */
        CreatePaymentMethodRegistrationRequest.create = function create(properties) {
            return new CreatePaymentMethodRegistrationRequest(properties);
        };

        /**
         * Encodes the specified CreatePaymentMethodRegistrationRequest message. Does not implicitly {@link payment3_paymentmethod_coordinatorpb.CreatePaymentMethodRegistrationRequest.verify|verify} messages.
         * @function encode
         * @memberof payment3_paymentmethod_coordinatorpb.CreatePaymentMethodRegistrationRequest
         * @static
         * @param {payment3_paymentmethod_coordinatorpb.ICreatePaymentMethodRegistrationRequest} m CreatePaymentMethodRegistrationRequest message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CreatePaymentMethodRegistrationRequest.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.paymentMethod != null && Object.hasOwnProperty.call(m, "paymentMethod"))
                $root.payment3_paymentmethodpb.PaymentMethod.encode(m.paymentMethod, w.uint32(10).fork()).ldelim();
            if (m.defaultCheck != null && Object.hasOwnProperty.call(m, "defaultCheck"))
                $root.payment3_paymentmethod_coordinatorpb.DefaultPaymentMethodCheck.encode(m.defaultCheck, w.uint32(802).fork()).ldelim();
            return w;
        };

        /**
         * Decodes a CreatePaymentMethodRegistrationRequest message from the specified reader or buffer.
         * @function decode
         * @memberof payment3_paymentmethod_coordinatorpb.CreatePaymentMethodRegistrationRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {payment3_paymentmethod_coordinatorpb.CreatePaymentMethodRegistrationRequest} CreatePaymentMethodRegistrationRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CreatePaymentMethodRegistrationRequest.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.payment3_paymentmethod_coordinatorpb.CreatePaymentMethodRegistrationRequest();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.paymentMethod = $root.payment3_paymentmethodpb.PaymentMethod.decode(r, r.uint32());
                    break;
                case 100:
                    m.defaultCheck = $root.payment3_paymentmethod_coordinatorpb.DefaultPaymentMethodCheck.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return CreatePaymentMethodRegistrationRequest;
    })();

    payment3_paymentmethod_coordinatorpb.DefaultPaymentMethodCheck = (function() {

        /**
         * Properties of a DefaultPaymentMethodCheck.
         * @memberof payment3_paymentmethod_coordinatorpb
         * @interface IDefaultPaymentMethodCheck
         * @property {boolean|null} [checkDefault] DefaultPaymentMethodCheck checkDefault
         * @property {string|null} [contractID] DefaultPaymentMethodCheck contractID
         */

        /**
         * Constructs a new DefaultPaymentMethodCheck.
         * @memberof payment3_paymentmethod_coordinatorpb
         * @classdesc Represents a DefaultPaymentMethodCheck.
         * @implements IDefaultPaymentMethodCheck
         * @constructor
         * @param {payment3_paymentmethod_coordinatorpb.IDefaultPaymentMethodCheck=} [p] Properties to set
         */
        function DefaultPaymentMethodCheck(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * DefaultPaymentMethodCheck checkDefault.
         * @member {boolean} checkDefault
         * @memberof payment3_paymentmethod_coordinatorpb.DefaultPaymentMethodCheck
         * @instance
         */
        DefaultPaymentMethodCheck.prototype.checkDefault = false;

        /**
         * DefaultPaymentMethodCheck contractID.
         * @member {string} contractID
         * @memberof payment3_paymentmethod_coordinatorpb.DefaultPaymentMethodCheck
         * @instance
         */
        DefaultPaymentMethodCheck.prototype.contractID = "";

        /**
         * Creates a new DefaultPaymentMethodCheck instance using the specified properties.
         * @function create
         * @memberof payment3_paymentmethod_coordinatorpb.DefaultPaymentMethodCheck
         * @static
         * @param {payment3_paymentmethod_coordinatorpb.IDefaultPaymentMethodCheck=} [properties] Properties to set
         * @returns {payment3_paymentmethod_coordinatorpb.DefaultPaymentMethodCheck} DefaultPaymentMethodCheck instance
         */
        DefaultPaymentMethodCheck.create = function create(properties) {
            return new DefaultPaymentMethodCheck(properties);
        };

        /**
         * Encodes the specified DefaultPaymentMethodCheck message. Does not implicitly {@link payment3_paymentmethod_coordinatorpb.DefaultPaymentMethodCheck.verify|verify} messages.
         * @function encode
         * @memberof payment3_paymentmethod_coordinatorpb.DefaultPaymentMethodCheck
         * @static
         * @param {payment3_paymentmethod_coordinatorpb.IDefaultPaymentMethodCheck} m DefaultPaymentMethodCheck message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        DefaultPaymentMethodCheck.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.checkDefault != null && Object.hasOwnProperty.call(m, "checkDefault"))
                w.uint32(808).bool(m.checkDefault);
            if (m.contractID != null && Object.hasOwnProperty.call(m, "contractID"))
                w.uint32(818).string(m.contractID);
            return w;
        };

        /**
         * Decodes a DefaultPaymentMethodCheck message from the specified reader or buffer.
         * @function decode
         * @memberof payment3_paymentmethod_coordinatorpb.DefaultPaymentMethodCheck
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {payment3_paymentmethod_coordinatorpb.DefaultPaymentMethodCheck} DefaultPaymentMethodCheck
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        DefaultPaymentMethodCheck.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.payment3_paymentmethod_coordinatorpb.DefaultPaymentMethodCheck();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 101:
                    m.checkDefault = r.bool();
                    break;
                case 102:
                    m.contractID = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return DefaultPaymentMethodCheck;
    })();

    payment3_paymentmethod_coordinatorpb.UpdatePaymentMethodPatchRequest = (function() {

        /**
         * Properties of an UpdatePaymentMethodPatchRequest.
         * @memberof payment3_paymentmethod_coordinatorpb
         * @interface IUpdatePaymentMethodPatchRequest
         * @property {payment3_paymentmethodpb.IOwner|null} [owner] UpdatePaymentMethodPatchRequest owner
         */

        /**
         * Constructs a new UpdatePaymentMethodPatchRequest.
         * @memberof payment3_paymentmethod_coordinatorpb
         * @classdesc Represents an UpdatePaymentMethodPatchRequest.
         * @implements IUpdatePaymentMethodPatchRequest
         * @constructor
         * @param {payment3_paymentmethod_coordinatorpb.IUpdatePaymentMethodPatchRequest=} [p] Properties to set
         */
        function UpdatePaymentMethodPatchRequest(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * UpdatePaymentMethodPatchRequest owner.
         * @member {payment3_paymentmethodpb.IOwner|null|undefined} owner
         * @memberof payment3_paymentmethod_coordinatorpb.UpdatePaymentMethodPatchRequest
         * @instance
         */
        UpdatePaymentMethodPatchRequest.prototype.owner = null;

        /**
         * Creates a new UpdatePaymentMethodPatchRequest instance using the specified properties.
         * @function create
         * @memberof payment3_paymentmethod_coordinatorpb.UpdatePaymentMethodPatchRequest
         * @static
         * @param {payment3_paymentmethod_coordinatorpb.IUpdatePaymentMethodPatchRequest=} [properties] Properties to set
         * @returns {payment3_paymentmethod_coordinatorpb.UpdatePaymentMethodPatchRequest} UpdatePaymentMethodPatchRequest instance
         */
        UpdatePaymentMethodPatchRequest.create = function create(properties) {
            return new UpdatePaymentMethodPatchRequest(properties);
        };

        /**
         * Encodes the specified UpdatePaymentMethodPatchRequest message. Does not implicitly {@link payment3_paymentmethod_coordinatorpb.UpdatePaymentMethodPatchRequest.verify|verify} messages.
         * @function encode
         * @memberof payment3_paymentmethod_coordinatorpb.UpdatePaymentMethodPatchRequest
         * @static
         * @param {payment3_paymentmethod_coordinatorpb.IUpdatePaymentMethodPatchRequest} m UpdatePaymentMethodPatchRequest message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UpdatePaymentMethodPatchRequest.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.owner != null && Object.hasOwnProperty.call(m, "owner"))
                $root.payment3_paymentmethodpb.Owner.encode(m.owner, w.uint32(10).fork()).ldelim();
            return w;
        };

        /**
         * Decodes an UpdatePaymentMethodPatchRequest message from the specified reader or buffer.
         * @function decode
         * @memberof payment3_paymentmethod_coordinatorpb.UpdatePaymentMethodPatchRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {payment3_paymentmethod_coordinatorpb.UpdatePaymentMethodPatchRequest} UpdatePaymentMethodPatchRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UpdatePaymentMethodPatchRequest.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.payment3_paymentmethod_coordinatorpb.UpdatePaymentMethodPatchRequest();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.owner = $root.payment3_paymentmethodpb.Owner.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return UpdatePaymentMethodPatchRequest;
    })();

    payment3_paymentmethod_coordinatorpb.CreatePaymentMethodRegistrationResponse = (function() {

        /**
         * Properties of a CreatePaymentMethodRegistrationResponse.
         * @memberof payment3_paymentmethod_coordinatorpb
         * @interface ICreatePaymentMethodRegistrationResponse
         * @property {payment3_paymentmethod_coordinatorpb.IPaymentMethodRegistration|null} [registration] CreatePaymentMethodRegistrationResponse registration
         * @property {Array.<contractpb.IContractCustomerInfo>|null} [displayCustomer] CreatePaymentMethodRegistrationResponse displayCustomer
         * @property {Array.<addresspb.IAddress>|null} [displayAddress] CreatePaymentMethodRegistrationResponse displayAddress
         * @property {boolean|null} [defaultPaymentMethodExists] CreatePaymentMethodRegistrationResponse defaultPaymentMethodExists
         */

        /**
         * Constructs a new CreatePaymentMethodRegistrationResponse.
         * @memberof payment3_paymentmethod_coordinatorpb
         * @classdesc Represents a CreatePaymentMethodRegistrationResponse.
         * @implements ICreatePaymentMethodRegistrationResponse
         * @constructor
         * @param {payment3_paymentmethod_coordinatorpb.ICreatePaymentMethodRegistrationResponse=} [p] Properties to set
         */
        function CreatePaymentMethodRegistrationResponse(p) {
            this.displayCustomer = [];
            this.displayAddress = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * CreatePaymentMethodRegistrationResponse registration.
         * @member {payment3_paymentmethod_coordinatorpb.IPaymentMethodRegistration|null|undefined} registration
         * @memberof payment3_paymentmethod_coordinatorpb.CreatePaymentMethodRegistrationResponse
         * @instance
         */
        CreatePaymentMethodRegistrationResponse.prototype.registration = null;

        /**
         * CreatePaymentMethodRegistrationResponse displayCustomer.
         * @member {Array.<contractpb.IContractCustomerInfo>} displayCustomer
         * @memberof payment3_paymentmethod_coordinatorpb.CreatePaymentMethodRegistrationResponse
         * @instance
         */
        CreatePaymentMethodRegistrationResponse.prototype.displayCustomer = $util.emptyArray;

        /**
         * CreatePaymentMethodRegistrationResponse displayAddress.
         * @member {Array.<addresspb.IAddress>} displayAddress
         * @memberof payment3_paymentmethod_coordinatorpb.CreatePaymentMethodRegistrationResponse
         * @instance
         */
        CreatePaymentMethodRegistrationResponse.prototype.displayAddress = $util.emptyArray;

        /**
         * CreatePaymentMethodRegistrationResponse defaultPaymentMethodExists.
         * @member {boolean} defaultPaymentMethodExists
         * @memberof payment3_paymentmethod_coordinatorpb.CreatePaymentMethodRegistrationResponse
         * @instance
         */
        CreatePaymentMethodRegistrationResponse.prototype.defaultPaymentMethodExists = false;

        /**
         * Creates a new CreatePaymentMethodRegistrationResponse instance using the specified properties.
         * @function create
         * @memberof payment3_paymentmethod_coordinatorpb.CreatePaymentMethodRegistrationResponse
         * @static
         * @param {payment3_paymentmethod_coordinatorpb.ICreatePaymentMethodRegistrationResponse=} [properties] Properties to set
         * @returns {payment3_paymentmethod_coordinatorpb.CreatePaymentMethodRegistrationResponse} CreatePaymentMethodRegistrationResponse instance
         */
        CreatePaymentMethodRegistrationResponse.create = function create(properties) {
            return new CreatePaymentMethodRegistrationResponse(properties);
        };

        /**
         * Encodes the specified CreatePaymentMethodRegistrationResponse message. Does not implicitly {@link payment3_paymentmethod_coordinatorpb.CreatePaymentMethodRegistrationResponse.verify|verify} messages.
         * @function encode
         * @memberof payment3_paymentmethod_coordinatorpb.CreatePaymentMethodRegistrationResponse
         * @static
         * @param {payment3_paymentmethod_coordinatorpb.ICreatePaymentMethodRegistrationResponse} m CreatePaymentMethodRegistrationResponse message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CreatePaymentMethodRegistrationResponse.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.registration != null && Object.hasOwnProperty.call(m, "registration"))
                $root.payment3_paymentmethod_coordinatorpb.PaymentMethodRegistration.encode(m.registration, w.uint32(802).fork()).ldelim();
            if (m.displayCustomer != null && m.displayCustomer.length) {
                for (var i = 0; i < m.displayCustomer.length; ++i)
                    $root.contractpb.ContractCustomerInfo.encode(m.displayCustomer[i], w.uint32(1602).fork()).ldelim();
            }
            if (m.displayAddress != null && m.displayAddress.length) {
                for (var i = 0; i < m.displayAddress.length; ++i)
                    $root.addresspb.Address.encode(m.displayAddress[i], w.uint32(2402).fork()).ldelim();
            }
            if (m.defaultPaymentMethodExists != null && Object.hasOwnProperty.call(m, "defaultPaymentMethodExists"))
                w.uint32(3200).bool(m.defaultPaymentMethodExists);
            return w;
        };

        /**
         * Decodes a CreatePaymentMethodRegistrationResponse message from the specified reader or buffer.
         * @function decode
         * @memberof payment3_paymentmethod_coordinatorpb.CreatePaymentMethodRegistrationResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {payment3_paymentmethod_coordinatorpb.CreatePaymentMethodRegistrationResponse} CreatePaymentMethodRegistrationResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CreatePaymentMethodRegistrationResponse.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.payment3_paymentmethod_coordinatorpb.CreatePaymentMethodRegistrationResponse();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 100:
                    m.registration = $root.payment3_paymentmethod_coordinatorpb.PaymentMethodRegistration.decode(r, r.uint32());
                    break;
                case 200:
                    if (!(m.displayCustomer && m.displayCustomer.length))
                        m.displayCustomer = [];
                    m.displayCustomer.push($root.contractpb.ContractCustomerInfo.decode(r, r.uint32()));
                    break;
                case 300:
                    if (!(m.displayAddress && m.displayAddress.length))
                        m.displayAddress = [];
                    m.displayAddress.push($root.addresspb.Address.decode(r, r.uint32()));
                    break;
                case 400:
                    m.defaultPaymentMethodExists = r.bool();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return CreatePaymentMethodRegistrationResponse;
    })();

    payment3_paymentmethod_coordinatorpb.PaymentMethodRegistration = (function() {

        /**
         * Properties of a PaymentMethodRegistration.
         * @memberof payment3_paymentmethod_coordinatorpb
         * @interface IPaymentMethodRegistration
         * @property {string|null} [registrationID] PaymentMethodRegistration registrationID
         * @property {payment3_commonpb.Brand|null} [brand] PaymentMethodRegistration brand
         * @property {payment3_commonpb.PaymentProcessor|null} [processor] PaymentMethodRegistration processor
         * @property {payment3_stripe_gatewaypb.IStripeRegistration|null} [stripe] PaymentMethodRegistration stripe
         * @property {payment3_paymentus_gatewaypb.IPaymentusRegistration|null} [paymentus] PaymentMethodRegistration paymentus
         * @property {payment3_braintree_gatewaypb.IBraintreeRegistration|null} [braintree] PaymentMethodRegistration braintree
         */

        /**
         * Constructs a new PaymentMethodRegistration.
         * @memberof payment3_paymentmethod_coordinatorpb
         * @classdesc Represents a PaymentMethodRegistration.
         * @implements IPaymentMethodRegistration
         * @constructor
         * @param {payment3_paymentmethod_coordinatorpb.IPaymentMethodRegistration=} [p] Properties to set
         */
        function PaymentMethodRegistration(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * PaymentMethodRegistration registrationID.
         * @member {string} registrationID
         * @memberof payment3_paymentmethod_coordinatorpb.PaymentMethodRegistration
         * @instance
         */
        PaymentMethodRegistration.prototype.registrationID = "";

        /**
         * PaymentMethodRegistration brand.
         * @member {payment3_commonpb.Brand} brand
         * @memberof payment3_paymentmethod_coordinatorpb.PaymentMethodRegistration
         * @instance
         */
        PaymentMethodRegistration.prototype.brand = 0;

        /**
         * PaymentMethodRegistration processor.
         * @member {payment3_commonpb.PaymentProcessor} processor
         * @memberof payment3_paymentmethod_coordinatorpb.PaymentMethodRegistration
         * @instance
         */
        PaymentMethodRegistration.prototype.processor = 0;

        /**
         * PaymentMethodRegistration stripe.
         * @member {payment3_stripe_gatewaypb.IStripeRegistration|null|undefined} stripe
         * @memberof payment3_paymentmethod_coordinatorpb.PaymentMethodRegistration
         * @instance
         */
        PaymentMethodRegistration.prototype.stripe = null;

        /**
         * PaymentMethodRegistration paymentus.
         * @member {payment3_paymentus_gatewaypb.IPaymentusRegistration|null|undefined} paymentus
         * @memberof payment3_paymentmethod_coordinatorpb.PaymentMethodRegistration
         * @instance
         */
        PaymentMethodRegistration.prototype.paymentus = null;

        /**
         * PaymentMethodRegistration braintree.
         * @member {payment3_braintree_gatewaypb.IBraintreeRegistration|null|undefined} braintree
         * @memberof payment3_paymentmethod_coordinatorpb.PaymentMethodRegistration
         * @instance
         */
        PaymentMethodRegistration.prototype.braintree = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        /**
         * PaymentMethodRegistration processorRegistration.
         * @member {"stripe"|"paymentus"|"braintree"|undefined} processorRegistration
         * @memberof payment3_paymentmethod_coordinatorpb.PaymentMethodRegistration
         * @instance
         */
        Object.defineProperty(PaymentMethodRegistration.prototype, "processorRegistration", {
            get: $util.oneOfGetter($oneOfFields = ["stripe", "paymentus", "braintree"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new PaymentMethodRegistration instance using the specified properties.
         * @function create
         * @memberof payment3_paymentmethod_coordinatorpb.PaymentMethodRegistration
         * @static
         * @param {payment3_paymentmethod_coordinatorpb.IPaymentMethodRegistration=} [properties] Properties to set
         * @returns {payment3_paymentmethod_coordinatorpb.PaymentMethodRegistration} PaymentMethodRegistration instance
         */
        PaymentMethodRegistration.create = function create(properties) {
            return new PaymentMethodRegistration(properties);
        };

        /**
         * Encodes the specified PaymentMethodRegistration message. Does not implicitly {@link payment3_paymentmethod_coordinatorpb.PaymentMethodRegistration.verify|verify} messages.
         * @function encode
         * @memberof payment3_paymentmethod_coordinatorpb.PaymentMethodRegistration
         * @static
         * @param {payment3_paymentmethod_coordinatorpb.IPaymentMethodRegistration} m PaymentMethodRegistration message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PaymentMethodRegistration.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.registrationID != null && Object.hasOwnProperty.call(m, "registrationID"))
                w.uint32(10).string(m.registrationID);
            if (m.brand != null && Object.hasOwnProperty.call(m, "brand"))
                w.uint32(16).int32(m.brand);
            if (m.processor != null && Object.hasOwnProperty.call(m, "processor"))
                w.uint32(800).int32(m.processor);
            if (m.stripe != null && Object.hasOwnProperty.call(m, "stripe"))
                $root.payment3_stripe_gatewaypb.StripeRegistration.encode(m.stripe, w.uint32(810).fork()).ldelim();
            if (m.paymentus != null && Object.hasOwnProperty.call(m, "paymentus"))
                $root.payment3_paymentus_gatewaypb.PaymentusRegistration.encode(m.paymentus, w.uint32(818).fork()).ldelim();
            if (m.braintree != null && Object.hasOwnProperty.call(m, "braintree"))
                $root.payment3_braintree_gatewaypb.BraintreeRegistration.encode(m.braintree, w.uint32(826).fork()).ldelim();
            return w;
        };

        /**
         * Decodes a PaymentMethodRegistration message from the specified reader or buffer.
         * @function decode
         * @memberof payment3_paymentmethod_coordinatorpb.PaymentMethodRegistration
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {payment3_paymentmethod_coordinatorpb.PaymentMethodRegistration} PaymentMethodRegistration
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PaymentMethodRegistration.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.payment3_paymentmethod_coordinatorpb.PaymentMethodRegistration();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.registrationID = r.string();
                    break;
                case 2:
                    m.brand = r.int32();
                    break;
                case 100:
                    m.processor = r.int32();
                    break;
                case 101:
                    m.stripe = $root.payment3_stripe_gatewaypb.StripeRegistration.decode(r, r.uint32());
                    break;
                case 102:
                    m.paymentus = $root.payment3_paymentus_gatewaypb.PaymentusRegistration.decode(r, r.uint32());
                    break;
                case 103:
                    m.braintree = $root.payment3_braintree_gatewaypb.BraintreeRegistration.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return PaymentMethodRegistration;
    })();

    payment3_paymentmethod_coordinatorpb.CreatePaymentMethodRequest = (function() {

        /**
         * Properties of a CreatePaymentMethodRequest.
         * @memberof payment3_paymentmethod_coordinatorpb
         * @interface ICreatePaymentMethodRequest
         * @property {string|null} [registrationID] CreatePaymentMethodRequest registrationID
         * @property {payment3_paymentmethodpb.IPaymentMethod|null} [paymentMethod] CreatePaymentMethodRequest paymentMethod
         */

        /**
         * Constructs a new CreatePaymentMethodRequest.
         * @memberof payment3_paymentmethod_coordinatorpb
         * @classdesc Represents a CreatePaymentMethodRequest.
         * @implements ICreatePaymentMethodRequest
         * @constructor
         * @param {payment3_paymentmethod_coordinatorpb.ICreatePaymentMethodRequest=} [p] Properties to set
         */
        function CreatePaymentMethodRequest(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * CreatePaymentMethodRequest registrationID.
         * @member {string} registrationID
         * @memberof payment3_paymentmethod_coordinatorpb.CreatePaymentMethodRequest
         * @instance
         */
        CreatePaymentMethodRequest.prototype.registrationID = "";

        /**
         * CreatePaymentMethodRequest paymentMethod.
         * @member {payment3_paymentmethodpb.IPaymentMethod|null|undefined} paymentMethod
         * @memberof payment3_paymentmethod_coordinatorpb.CreatePaymentMethodRequest
         * @instance
         */
        CreatePaymentMethodRequest.prototype.paymentMethod = null;

        /**
         * Creates a new CreatePaymentMethodRequest instance using the specified properties.
         * @function create
         * @memberof payment3_paymentmethod_coordinatorpb.CreatePaymentMethodRequest
         * @static
         * @param {payment3_paymentmethod_coordinatorpb.ICreatePaymentMethodRequest=} [properties] Properties to set
         * @returns {payment3_paymentmethod_coordinatorpb.CreatePaymentMethodRequest} CreatePaymentMethodRequest instance
         */
        CreatePaymentMethodRequest.create = function create(properties) {
            return new CreatePaymentMethodRequest(properties);
        };

        /**
         * Encodes the specified CreatePaymentMethodRequest message. Does not implicitly {@link payment3_paymentmethod_coordinatorpb.CreatePaymentMethodRequest.verify|verify} messages.
         * @function encode
         * @memberof payment3_paymentmethod_coordinatorpb.CreatePaymentMethodRequest
         * @static
         * @param {payment3_paymentmethod_coordinatorpb.ICreatePaymentMethodRequest} m CreatePaymentMethodRequest message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CreatePaymentMethodRequest.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.registrationID != null && Object.hasOwnProperty.call(m, "registrationID"))
                w.uint32(10).string(m.registrationID);
            if (m.paymentMethod != null && Object.hasOwnProperty.call(m, "paymentMethod"))
                $root.payment3_paymentmethodpb.PaymentMethod.encode(m.paymentMethod, w.uint32(18).fork()).ldelim();
            return w;
        };

        /**
         * Decodes a CreatePaymentMethodRequest message from the specified reader or buffer.
         * @function decode
         * @memberof payment3_paymentmethod_coordinatorpb.CreatePaymentMethodRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {payment3_paymentmethod_coordinatorpb.CreatePaymentMethodRequest} CreatePaymentMethodRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CreatePaymentMethodRequest.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.payment3_paymentmethod_coordinatorpb.CreatePaymentMethodRequest();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.registrationID = r.string();
                    break;
                case 2:
                    m.paymentMethod = $root.payment3_paymentmethodpb.PaymentMethod.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return CreatePaymentMethodRequest;
    })();

    payment3_paymentmethod_coordinatorpb.CreatePaymentMethodResponse = (function() {

        /**
         * Properties of a CreatePaymentMethodResponse.
         * @memberof payment3_paymentmethod_coordinatorpb
         * @interface ICreatePaymentMethodResponse
         * @property {payment3_paymentmethodpb.IPaymentMethod|null} [paymentMethod] CreatePaymentMethodResponse paymentMethod
         */

        /**
         * Constructs a new CreatePaymentMethodResponse.
         * @memberof payment3_paymentmethod_coordinatorpb
         * @classdesc Represents a CreatePaymentMethodResponse.
         * @implements ICreatePaymentMethodResponse
         * @constructor
         * @param {payment3_paymentmethod_coordinatorpb.ICreatePaymentMethodResponse=} [p] Properties to set
         */
        function CreatePaymentMethodResponse(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * CreatePaymentMethodResponse paymentMethod.
         * @member {payment3_paymentmethodpb.IPaymentMethod|null|undefined} paymentMethod
         * @memberof payment3_paymentmethod_coordinatorpb.CreatePaymentMethodResponse
         * @instance
         */
        CreatePaymentMethodResponse.prototype.paymentMethod = null;

        /**
         * Creates a new CreatePaymentMethodResponse instance using the specified properties.
         * @function create
         * @memberof payment3_paymentmethod_coordinatorpb.CreatePaymentMethodResponse
         * @static
         * @param {payment3_paymentmethod_coordinatorpb.ICreatePaymentMethodResponse=} [properties] Properties to set
         * @returns {payment3_paymentmethod_coordinatorpb.CreatePaymentMethodResponse} CreatePaymentMethodResponse instance
         */
        CreatePaymentMethodResponse.create = function create(properties) {
            return new CreatePaymentMethodResponse(properties);
        };

        /**
         * Encodes the specified CreatePaymentMethodResponse message. Does not implicitly {@link payment3_paymentmethod_coordinatorpb.CreatePaymentMethodResponse.verify|verify} messages.
         * @function encode
         * @memberof payment3_paymentmethod_coordinatorpb.CreatePaymentMethodResponse
         * @static
         * @param {payment3_paymentmethod_coordinatorpb.ICreatePaymentMethodResponse} m CreatePaymentMethodResponse message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CreatePaymentMethodResponse.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.paymentMethod != null && Object.hasOwnProperty.call(m, "paymentMethod"))
                $root.payment3_paymentmethodpb.PaymentMethod.encode(m.paymentMethod, w.uint32(10).fork()).ldelim();
            return w;
        };

        /**
         * Decodes a CreatePaymentMethodResponse message from the specified reader or buffer.
         * @function decode
         * @memberof payment3_paymentmethod_coordinatorpb.CreatePaymentMethodResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {payment3_paymentmethod_coordinatorpb.CreatePaymentMethodResponse} CreatePaymentMethodResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CreatePaymentMethodResponse.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.payment3_paymentmethod_coordinatorpb.CreatePaymentMethodResponse();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.paymentMethod = $root.payment3_paymentmethodpb.PaymentMethod.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return CreatePaymentMethodResponse;
    })();

    payment3_paymentmethod_coordinatorpb.CreatePaymentMethodRegistration = (function() {

        /**
         * Constructs a new CreatePaymentMethodRegistration service.
         * @memberof payment3_paymentmethod_coordinatorpb
         * @classdesc Represents a CreatePaymentMethodRegistration
         * @extends $protobuf.rpc.Service
         * @constructor
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         */
        function CreatePaymentMethodRegistration(rpcImpl, requestDelimited, responseDelimited) {
            $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
        }

        (CreatePaymentMethodRegistration.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = CreatePaymentMethodRegistration;

        /**
         * Creates new CreatePaymentMethodRegistration service using the specified rpc implementation.
         * @function create
         * @memberof payment3_paymentmethod_coordinatorpb.CreatePaymentMethodRegistration
         * @static
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         * @returns {CreatePaymentMethodRegistration} RPC service. Useful where requests and/or responses are streamed.
         */
        CreatePaymentMethodRegistration.create = function create(rpcImpl, requestDelimited, responseDelimited) {
            return new this(rpcImpl, requestDelimited, responseDelimited);
        };

        /**
         * Callback as used by {@link payment3_paymentmethod_coordinatorpb.CreatePaymentMethodRegistration#post}.
         * @memberof payment3_paymentmethod_coordinatorpb.CreatePaymentMethodRegistration
         * @typedef PostCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {payment3_paymentmethod_coordinatorpb.CreatePaymentMethodRegistrationResponse} [response] CreatePaymentMethodRegistrationResponse
         */

        /**
         * Calls Post.
         * @function post
         * @memberof payment3_paymentmethod_coordinatorpb.CreatePaymentMethodRegistration
         * @instance
         * @param {payment3_paymentmethod_coordinatorpb.ICreatePaymentMethodRegistrationRequest} request CreatePaymentMethodRegistrationRequest message or plain object
         * @param {payment3_paymentmethod_coordinatorpb.CreatePaymentMethodRegistration.PostCallback} callback Node-style callback called with the error, if any, and CreatePaymentMethodRegistrationResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(CreatePaymentMethodRegistration.prototype.post = function post(request, callback) {
            return this.rpcCall(post, $root.payment3_paymentmethod_coordinatorpb.CreatePaymentMethodRegistrationRequest, $root.payment3_paymentmethod_coordinatorpb.CreatePaymentMethodRegistrationResponse, request, callback);
        }, "name", { value: "Post" });

        /**
         * Calls Post.
         * @function post
         * @memberof payment3_paymentmethod_coordinatorpb.CreatePaymentMethodRegistration
         * @instance
         * @param {payment3_paymentmethod_coordinatorpb.ICreatePaymentMethodRegistrationRequest} request CreatePaymentMethodRegistrationRequest message or plain object
         * @returns {Promise<payment3_paymentmethod_coordinatorpb.CreatePaymentMethodRegistrationResponse>} Promise
         * @variation 2
         */

        return CreatePaymentMethodRegistration;
    })();

    payment3_paymentmethod_coordinatorpb.CreatePaymentMethod = (function() {

        /**
         * Constructs a new CreatePaymentMethod service.
         * @memberof payment3_paymentmethod_coordinatorpb
         * @classdesc Represents a CreatePaymentMethod
         * @extends $protobuf.rpc.Service
         * @constructor
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         */
        function CreatePaymentMethod(rpcImpl, requestDelimited, responseDelimited) {
            $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
        }

        (CreatePaymentMethod.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = CreatePaymentMethod;

        /**
         * Creates new CreatePaymentMethod service using the specified rpc implementation.
         * @function create
         * @memberof payment3_paymentmethod_coordinatorpb.CreatePaymentMethod
         * @static
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         * @returns {CreatePaymentMethod} RPC service. Useful where requests and/or responses are streamed.
         */
        CreatePaymentMethod.create = function create(rpcImpl, requestDelimited, responseDelimited) {
            return new this(rpcImpl, requestDelimited, responseDelimited);
        };

        /**
         * Callback as used by {@link payment3_paymentmethod_coordinatorpb.CreatePaymentMethod#post}.
         * @memberof payment3_paymentmethod_coordinatorpb.CreatePaymentMethod
         * @typedef PostCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {payment3_paymentmethod_coordinatorpb.CreatePaymentMethodResponse} [response] CreatePaymentMethodResponse
         */

        /**
         * Calls Post.
         * @function post
         * @memberof payment3_paymentmethod_coordinatorpb.CreatePaymentMethod
         * @instance
         * @param {payment3_paymentmethod_coordinatorpb.ICreatePaymentMethodRequest} request CreatePaymentMethodRequest message or plain object
         * @param {payment3_paymentmethod_coordinatorpb.CreatePaymentMethod.PostCallback} callback Node-style callback called with the error, if any, and CreatePaymentMethodResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(CreatePaymentMethod.prototype.post = function post(request, callback) {
            return this.rpcCall(post, $root.payment3_paymentmethod_coordinatorpb.CreatePaymentMethodRequest, $root.payment3_paymentmethod_coordinatorpb.CreatePaymentMethodResponse, request, callback);
        }, "name", { value: "Post" });

        /**
         * Calls Post.
         * @function post
         * @memberof payment3_paymentmethod_coordinatorpb.CreatePaymentMethod
         * @instance
         * @param {payment3_paymentmethod_coordinatorpb.ICreatePaymentMethodRequest} request CreatePaymentMethodRequest message or plain object
         * @returns {Promise<payment3_paymentmethod_coordinatorpb.CreatePaymentMethodResponse>} Promise
         * @variation 2
         */

        return CreatePaymentMethod;
    })();

    payment3_paymentmethod_coordinatorpb.GetCustomerDisbursementInvoice = (function() {

        /**
         * Constructs a new GetCustomerDisbursementInvoice service.
         * @memberof payment3_paymentmethod_coordinatorpb
         * @classdesc Represents a GetCustomerDisbursementInvoice
         * @extends $protobuf.rpc.Service
         * @constructor
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         */
        function GetCustomerDisbursementInvoice(rpcImpl, requestDelimited, responseDelimited) {
            $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
        }

        (GetCustomerDisbursementInvoice.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = GetCustomerDisbursementInvoice;

        /**
         * Creates new GetCustomerDisbursementInvoice service using the specified rpc implementation.
         * @function create
         * @memberof payment3_paymentmethod_coordinatorpb.GetCustomerDisbursementInvoice
         * @static
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         * @returns {GetCustomerDisbursementInvoice} RPC service. Useful where requests and/or responses are streamed.
         */
        GetCustomerDisbursementInvoice.create = function create(rpcImpl, requestDelimited, responseDelimited) {
            return new this(rpcImpl, requestDelimited, responseDelimited);
        };

        /**
         * Callback as used by {@link payment3_paymentmethod_coordinatorpb.GetCustomerDisbursementInvoice#get}.
         * @memberof payment3_paymentmethod_coordinatorpb.GetCustomerDisbursementInvoice
         * @typedef GetCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {payment3_paymentmethod_coordinatorpb.GetCustomerDisbursementResponse} [response] GetCustomerDisbursementResponse
         */

        /**
         * Calls Get.
         * @function get
         * @memberof payment3_paymentmethod_coordinatorpb.GetCustomerDisbursementInvoice
         * @instance
         * @param {google.protobuf.IEmpty} request Empty message or plain object
         * @param {payment3_paymentmethod_coordinatorpb.GetCustomerDisbursementInvoice.GetCallback} callback Node-style callback called with the error, if any, and GetCustomerDisbursementResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(GetCustomerDisbursementInvoice.prototype.get = function get(request, callback) {
            return this.rpcCall(get, $root.google.protobuf.Empty, $root.payment3_paymentmethod_coordinatorpb.GetCustomerDisbursementResponse, request, callback);
        }, "name", { value: "Get" });

        /**
         * Calls Get.
         * @function get
         * @memberof payment3_paymentmethod_coordinatorpb.GetCustomerDisbursementInvoice
         * @instance
         * @param {google.protobuf.IEmpty} request Empty message or plain object
         * @returns {Promise<payment3_paymentmethod_coordinatorpb.GetCustomerDisbursementResponse>} Promise
         * @variation 2
         */

        return GetCustomerDisbursementInvoice;
    })();

    payment3_paymentmethod_coordinatorpb.PaymentMethodRegistrationInternal = (function() {

        /**
         * Properties of a PaymentMethodRegistrationInternal.
         * @memberof payment3_paymentmethod_coordinatorpb
         * @interface IPaymentMethodRegistrationInternal
         * @property {payment3_commonpb.PaymentProcessor|null} [processor] PaymentMethodRegistrationInternal processor
         * @property {payment3_stripe_gatewaypb.IStripeRegistration|null} [stripe] PaymentMethodRegistrationInternal stripe
         * @property {payment3_paymentus_gatewaypb.IPaymentusRegistration|null} [paymentus] PaymentMethodRegistrationInternal paymentus
         * @property {payment3_braintree_gatewaypb.IBraintreeRegistration|null} [braintree] PaymentMethodRegistrationInternal braintree
         * @property {payment3_stripe_gatewaypb.IStripeRegistrationInternal|null} [stripeInternal] PaymentMethodRegistrationInternal stripeInternal
         * @property {payment3_paymentus_gatewaypb.IPaymentusRegistrationInternal|null} [paymentusInternal] PaymentMethodRegistrationInternal paymentusInternal
         * @property {payment3_braintree_gatewaypb.IBraintreeRegistrationInternal|null} [braintreeInternal] PaymentMethodRegistrationInternal braintreeInternal
         */

        /**
         * Constructs a new PaymentMethodRegistrationInternal.
         * @memberof payment3_paymentmethod_coordinatorpb
         * @classdesc Represents a PaymentMethodRegistrationInternal.
         * @implements IPaymentMethodRegistrationInternal
         * @constructor
         * @param {payment3_paymentmethod_coordinatorpb.IPaymentMethodRegistrationInternal=} [p] Properties to set
         */
        function PaymentMethodRegistrationInternal(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * PaymentMethodRegistrationInternal processor.
         * @member {payment3_commonpb.PaymentProcessor} processor
         * @memberof payment3_paymentmethod_coordinatorpb.PaymentMethodRegistrationInternal
         * @instance
         */
        PaymentMethodRegistrationInternal.prototype.processor = 0;

        /**
         * PaymentMethodRegistrationInternal stripe.
         * @member {payment3_stripe_gatewaypb.IStripeRegistration|null|undefined} stripe
         * @memberof payment3_paymentmethod_coordinatorpb.PaymentMethodRegistrationInternal
         * @instance
         */
        PaymentMethodRegistrationInternal.prototype.stripe = null;

        /**
         * PaymentMethodRegistrationInternal paymentus.
         * @member {payment3_paymentus_gatewaypb.IPaymentusRegistration|null|undefined} paymentus
         * @memberof payment3_paymentmethod_coordinatorpb.PaymentMethodRegistrationInternal
         * @instance
         */
        PaymentMethodRegistrationInternal.prototype.paymentus = null;

        /**
         * PaymentMethodRegistrationInternal braintree.
         * @member {payment3_braintree_gatewaypb.IBraintreeRegistration|null|undefined} braintree
         * @memberof payment3_paymentmethod_coordinatorpb.PaymentMethodRegistrationInternal
         * @instance
         */
        PaymentMethodRegistrationInternal.prototype.braintree = null;

        /**
         * PaymentMethodRegistrationInternal stripeInternal.
         * @member {payment3_stripe_gatewaypb.IStripeRegistrationInternal|null|undefined} stripeInternal
         * @memberof payment3_paymentmethod_coordinatorpb.PaymentMethodRegistrationInternal
         * @instance
         */
        PaymentMethodRegistrationInternal.prototype.stripeInternal = null;

        /**
         * PaymentMethodRegistrationInternal paymentusInternal.
         * @member {payment3_paymentus_gatewaypb.IPaymentusRegistrationInternal|null|undefined} paymentusInternal
         * @memberof payment3_paymentmethod_coordinatorpb.PaymentMethodRegistrationInternal
         * @instance
         */
        PaymentMethodRegistrationInternal.prototype.paymentusInternal = null;

        /**
         * PaymentMethodRegistrationInternal braintreeInternal.
         * @member {payment3_braintree_gatewaypb.IBraintreeRegistrationInternal|null|undefined} braintreeInternal
         * @memberof payment3_paymentmethod_coordinatorpb.PaymentMethodRegistrationInternal
         * @instance
         */
        PaymentMethodRegistrationInternal.prototype.braintreeInternal = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        /**
         * PaymentMethodRegistrationInternal processorRegistration.
         * @member {"stripe"|"paymentus"|"braintree"|undefined} processorRegistration
         * @memberof payment3_paymentmethod_coordinatorpb.PaymentMethodRegistrationInternal
         * @instance
         */
        Object.defineProperty(PaymentMethodRegistrationInternal.prototype, "processorRegistration", {
            get: $util.oneOfGetter($oneOfFields = ["stripe", "paymentus", "braintree"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * PaymentMethodRegistrationInternal processorRegistrationInternal.
         * @member {"stripeInternal"|"paymentusInternal"|"braintreeInternal"|undefined} processorRegistrationInternal
         * @memberof payment3_paymentmethod_coordinatorpb.PaymentMethodRegistrationInternal
         * @instance
         */
        Object.defineProperty(PaymentMethodRegistrationInternal.prototype, "processorRegistrationInternal", {
            get: $util.oneOfGetter($oneOfFields = ["stripeInternal", "paymentusInternal", "braintreeInternal"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new PaymentMethodRegistrationInternal instance using the specified properties.
         * @function create
         * @memberof payment3_paymentmethod_coordinatorpb.PaymentMethodRegistrationInternal
         * @static
         * @param {payment3_paymentmethod_coordinatorpb.IPaymentMethodRegistrationInternal=} [properties] Properties to set
         * @returns {payment3_paymentmethod_coordinatorpb.PaymentMethodRegistrationInternal} PaymentMethodRegistrationInternal instance
         */
        PaymentMethodRegistrationInternal.create = function create(properties) {
            return new PaymentMethodRegistrationInternal(properties);
        };

        /**
         * Encodes the specified PaymentMethodRegistrationInternal message. Does not implicitly {@link payment3_paymentmethod_coordinatorpb.PaymentMethodRegistrationInternal.verify|verify} messages.
         * @function encode
         * @memberof payment3_paymentmethod_coordinatorpb.PaymentMethodRegistrationInternal
         * @static
         * @param {payment3_paymentmethod_coordinatorpb.IPaymentMethodRegistrationInternal} m PaymentMethodRegistrationInternal message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PaymentMethodRegistrationInternal.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.processor != null && Object.hasOwnProperty.call(m, "processor"))
                w.uint32(800).int32(m.processor);
            if (m.stripe != null && Object.hasOwnProperty.call(m, "stripe"))
                $root.payment3_stripe_gatewaypb.StripeRegistration.encode(m.stripe, w.uint32(810).fork()).ldelim();
            if (m.paymentus != null && Object.hasOwnProperty.call(m, "paymentus"))
                $root.payment3_paymentus_gatewaypb.PaymentusRegistration.encode(m.paymentus, w.uint32(818).fork()).ldelim();
            if (m.braintree != null && Object.hasOwnProperty.call(m, "braintree"))
                $root.payment3_braintree_gatewaypb.BraintreeRegistration.encode(m.braintree, w.uint32(826).fork()).ldelim();
            if (m.stripeInternal != null && Object.hasOwnProperty.call(m, "stripeInternal"))
                $root.payment3_stripe_gatewaypb.StripeRegistrationInternal.encode(m.stripeInternal, w.uint32(1610).fork()).ldelim();
            if (m.paymentusInternal != null && Object.hasOwnProperty.call(m, "paymentusInternal"))
                $root.payment3_paymentus_gatewaypb.PaymentusRegistrationInternal.encode(m.paymentusInternal, w.uint32(1618).fork()).ldelim();
            if (m.braintreeInternal != null && Object.hasOwnProperty.call(m, "braintreeInternal"))
                $root.payment3_braintree_gatewaypb.BraintreeRegistrationInternal.encode(m.braintreeInternal, w.uint32(1626).fork()).ldelim();
            return w;
        };

        /**
         * Decodes a PaymentMethodRegistrationInternal message from the specified reader or buffer.
         * @function decode
         * @memberof payment3_paymentmethod_coordinatorpb.PaymentMethodRegistrationInternal
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {payment3_paymentmethod_coordinatorpb.PaymentMethodRegistrationInternal} PaymentMethodRegistrationInternal
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PaymentMethodRegistrationInternal.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.payment3_paymentmethod_coordinatorpb.PaymentMethodRegistrationInternal();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 100:
                    m.processor = r.int32();
                    break;
                case 101:
                    m.stripe = $root.payment3_stripe_gatewaypb.StripeRegistration.decode(r, r.uint32());
                    break;
                case 102:
                    m.paymentus = $root.payment3_paymentus_gatewaypb.PaymentusRegistration.decode(r, r.uint32());
                    break;
                case 103:
                    m.braintree = $root.payment3_braintree_gatewaypb.BraintreeRegistration.decode(r, r.uint32());
                    break;
                case 201:
                    m.stripeInternal = $root.payment3_stripe_gatewaypb.StripeRegistrationInternal.decode(r, r.uint32());
                    break;
                case 202:
                    m.paymentusInternal = $root.payment3_paymentus_gatewaypb.PaymentusRegistrationInternal.decode(r, r.uint32());
                    break;
                case 203:
                    m.braintreeInternal = $root.payment3_braintree_gatewaypb.BraintreeRegistrationInternal.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return PaymentMethodRegistrationInternal;
    })();

    payment3_paymentmethod_coordinatorpb.FinishPaymentMethodRequest = (function() {

        /**
         * Properties of a FinishPaymentMethodRequest.
         * @memberof payment3_paymentmethod_coordinatorpb
         * @interface IFinishPaymentMethodRequest
         * @property {payment3_paymentmethodpb.IPaymentMethod|null} [paymentMethod] FinishPaymentMethodRequest paymentMethod
         * @property {payment3_paymentmethod_coordinatorpb.IPaymentMethodRegistrationInternal|null} [paymentMethodInternal] FinishPaymentMethodRequest paymentMethodInternal
         */

        /**
         * Constructs a new FinishPaymentMethodRequest.
         * @memberof payment3_paymentmethod_coordinatorpb
         * @classdesc Represents a FinishPaymentMethodRequest.
         * @implements IFinishPaymentMethodRequest
         * @constructor
         * @param {payment3_paymentmethod_coordinatorpb.IFinishPaymentMethodRequest=} [p] Properties to set
         */
        function FinishPaymentMethodRequest(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * FinishPaymentMethodRequest paymentMethod.
         * @member {payment3_paymentmethodpb.IPaymentMethod|null|undefined} paymentMethod
         * @memberof payment3_paymentmethod_coordinatorpb.FinishPaymentMethodRequest
         * @instance
         */
        FinishPaymentMethodRequest.prototype.paymentMethod = null;

        /**
         * FinishPaymentMethodRequest paymentMethodInternal.
         * @member {payment3_paymentmethod_coordinatorpb.IPaymentMethodRegistrationInternal|null|undefined} paymentMethodInternal
         * @memberof payment3_paymentmethod_coordinatorpb.FinishPaymentMethodRequest
         * @instance
         */
        FinishPaymentMethodRequest.prototype.paymentMethodInternal = null;

        /**
         * Creates a new FinishPaymentMethodRequest instance using the specified properties.
         * @function create
         * @memberof payment3_paymentmethod_coordinatorpb.FinishPaymentMethodRequest
         * @static
         * @param {payment3_paymentmethod_coordinatorpb.IFinishPaymentMethodRequest=} [properties] Properties to set
         * @returns {payment3_paymentmethod_coordinatorpb.FinishPaymentMethodRequest} FinishPaymentMethodRequest instance
         */
        FinishPaymentMethodRequest.create = function create(properties) {
            return new FinishPaymentMethodRequest(properties);
        };

        /**
         * Encodes the specified FinishPaymentMethodRequest message. Does not implicitly {@link payment3_paymentmethod_coordinatorpb.FinishPaymentMethodRequest.verify|verify} messages.
         * @function encode
         * @memberof payment3_paymentmethod_coordinatorpb.FinishPaymentMethodRequest
         * @static
         * @param {payment3_paymentmethod_coordinatorpb.IFinishPaymentMethodRequest} m FinishPaymentMethodRequest message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        FinishPaymentMethodRequest.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.paymentMethod != null && Object.hasOwnProperty.call(m, "paymentMethod"))
                $root.payment3_paymentmethodpb.PaymentMethod.encode(m.paymentMethod, w.uint32(802).fork()).ldelim();
            if (m.paymentMethodInternal != null && Object.hasOwnProperty.call(m, "paymentMethodInternal"))
                $root.payment3_paymentmethod_coordinatorpb.PaymentMethodRegistrationInternal.encode(m.paymentMethodInternal, w.uint32(1602).fork()).ldelim();
            return w;
        };

        /**
         * Decodes a FinishPaymentMethodRequest message from the specified reader or buffer.
         * @function decode
         * @memberof payment3_paymentmethod_coordinatorpb.FinishPaymentMethodRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {payment3_paymentmethod_coordinatorpb.FinishPaymentMethodRequest} FinishPaymentMethodRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        FinishPaymentMethodRequest.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.payment3_paymentmethod_coordinatorpb.FinishPaymentMethodRequest();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 100:
                    m.paymentMethod = $root.payment3_paymentmethodpb.PaymentMethod.decode(r, r.uint32());
                    break;
                case 200:
                    m.paymentMethodInternal = $root.payment3_paymentmethod_coordinatorpb.PaymentMethodRegistrationInternal.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return FinishPaymentMethodRequest;
    })();

    payment3_paymentmethod_coordinatorpb.FinishPaymentMethodResponse = (function() {

        /**
         * Properties of a FinishPaymentMethodResponse.
         * @memberof payment3_paymentmethod_coordinatorpb
         * @interface IFinishPaymentMethodResponse
         * @property {payment3_paymentmethodpb.IPaymentMethod|null} [paymentMethod] FinishPaymentMethodResponse paymentMethod
         */

        /**
         * Constructs a new FinishPaymentMethodResponse.
         * @memberof payment3_paymentmethod_coordinatorpb
         * @classdesc Represents a FinishPaymentMethodResponse.
         * @implements IFinishPaymentMethodResponse
         * @constructor
         * @param {payment3_paymentmethod_coordinatorpb.IFinishPaymentMethodResponse=} [p] Properties to set
         */
        function FinishPaymentMethodResponse(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * FinishPaymentMethodResponse paymentMethod.
         * @member {payment3_paymentmethodpb.IPaymentMethod|null|undefined} paymentMethod
         * @memberof payment3_paymentmethod_coordinatorpb.FinishPaymentMethodResponse
         * @instance
         */
        FinishPaymentMethodResponse.prototype.paymentMethod = null;

        /**
         * Creates a new FinishPaymentMethodResponse instance using the specified properties.
         * @function create
         * @memberof payment3_paymentmethod_coordinatorpb.FinishPaymentMethodResponse
         * @static
         * @param {payment3_paymentmethod_coordinatorpb.IFinishPaymentMethodResponse=} [properties] Properties to set
         * @returns {payment3_paymentmethod_coordinatorpb.FinishPaymentMethodResponse} FinishPaymentMethodResponse instance
         */
        FinishPaymentMethodResponse.create = function create(properties) {
            return new FinishPaymentMethodResponse(properties);
        };

        /**
         * Encodes the specified FinishPaymentMethodResponse message. Does not implicitly {@link payment3_paymentmethod_coordinatorpb.FinishPaymentMethodResponse.verify|verify} messages.
         * @function encode
         * @memberof payment3_paymentmethod_coordinatorpb.FinishPaymentMethodResponse
         * @static
         * @param {payment3_paymentmethod_coordinatorpb.IFinishPaymentMethodResponse} m FinishPaymentMethodResponse message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        FinishPaymentMethodResponse.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.paymentMethod != null && Object.hasOwnProperty.call(m, "paymentMethod"))
                $root.payment3_paymentmethodpb.PaymentMethod.encode(m.paymentMethod, w.uint32(802).fork()).ldelim();
            return w;
        };

        /**
         * Decodes a FinishPaymentMethodResponse message from the specified reader or buffer.
         * @function decode
         * @memberof payment3_paymentmethod_coordinatorpb.FinishPaymentMethodResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {payment3_paymentmethod_coordinatorpb.FinishPaymentMethodResponse} FinishPaymentMethodResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        FinishPaymentMethodResponse.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.payment3_paymentmethod_coordinatorpb.FinishPaymentMethodResponse();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 100:
                    m.paymentMethod = $root.payment3_paymentmethodpb.PaymentMethod.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return FinishPaymentMethodResponse;
    })();

    payment3_paymentmethod_coordinatorpb.GetPaymentusTokenResponse = (function() {

        /**
         * Properties of a GetPaymentusTokenResponse.
         * @memberof payment3_paymentmethod_coordinatorpb
         * @interface IGetPaymentusTokenResponse
         * @property {string|null} [paymentusToken] GetPaymentusTokenResponse paymentusToken
         */

        /**
         * Constructs a new GetPaymentusTokenResponse.
         * @memberof payment3_paymentmethod_coordinatorpb
         * @classdesc Represents a GetPaymentusTokenResponse.
         * @implements IGetPaymentusTokenResponse
         * @constructor
         * @param {payment3_paymentmethod_coordinatorpb.IGetPaymentusTokenResponse=} [p] Properties to set
         */
        function GetPaymentusTokenResponse(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * GetPaymentusTokenResponse paymentusToken.
         * @member {string} paymentusToken
         * @memberof payment3_paymentmethod_coordinatorpb.GetPaymentusTokenResponse
         * @instance
         */
        GetPaymentusTokenResponse.prototype.paymentusToken = "";

        /**
         * Creates a new GetPaymentusTokenResponse instance using the specified properties.
         * @function create
         * @memberof payment3_paymentmethod_coordinatorpb.GetPaymentusTokenResponse
         * @static
         * @param {payment3_paymentmethod_coordinatorpb.IGetPaymentusTokenResponse=} [properties] Properties to set
         * @returns {payment3_paymentmethod_coordinatorpb.GetPaymentusTokenResponse} GetPaymentusTokenResponse instance
         */
        GetPaymentusTokenResponse.create = function create(properties) {
            return new GetPaymentusTokenResponse(properties);
        };

        /**
         * Encodes the specified GetPaymentusTokenResponse message. Does not implicitly {@link payment3_paymentmethod_coordinatorpb.GetPaymentusTokenResponse.verify|verify} messages.
         * @function encode
         * @memberof payment3_paymentmethod_coordinatorpb.GetPaymentusTokenResponse
         * @static
         * @param {payment3_paymentmethod_coordinatorpb.IGetPaymentusTokenResponse} m GetPaymentusTokenResponse message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetPaymentusTokenResponse.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.paymentusToken != null && Object.hasOwnProperty.call(m, "paymentusToken"))
                w.uint32(802).string(m.paymentusToken);
            return w;
        };

        /**
         * Decodes a GetPaymentusTokenResponse message from the specified reader or buffer.
         * @function decode
         * @memberof payment3_paymentmethod_coordinatorpb.GetPaymentusTokenResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {payment3_paymentmethod_coordinatorpb.GetPaymentusTokenResponse} GetPaymentusTokenResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetPaymentusTokenResponse.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.payment3_paymentmethod_coordinatorpb.GetPaymentusTokenResponse();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 100:
                    m.paymentusToken = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return GetPaymentusTokenResponse;
    })();

    payment3_paymentmethod_coordinatorpb.GetCustomerDisbursementResponse = (function() {

        /**
         * Properties of a GetCustomerDisbursementResponse.
         * @memberof payment3_paymentmethod_coordinatorpb
         * @interface IGetCustomerDisbursementResponse
         * @property {common.IMoney|null} [remainingDisbursementAmount] GetCustomerDisbursementResponse remainingDisbursementAmount
         */

        /**
         * Constructs a new GetCustomerDisbursementResponse.
         * @memberof payment3_paymentmethod_coordinatorpb
         * @classdesc Represents a GetCustomerDisbursementResponse.
         * @implements IGetCustomerDisbursementResponse
         * @constructor
         * @param {payment3_paymentmethod_coordinatorpb.IGetCustomerDisbursementResponse=} [p] Properties to set
         */
        function GetCustomerDisbursementResponse(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * GetCustomerDisbursementResponse remainingDisbursementAmount.
         * @member {common.IMoney|null|undefined} remainingDisbursementAmount
         * @memberof payment3_paymentmethod_coordinatorpb.GetCustomerDisbursementResponse
         * @instance
         */
        GetCustomerDisbursementResponse.prototype.remainingDisbursementAmount = null;

        /**
         * Creates a new GetCustomerDisbursementResponse instance using the specified properties.
         * @function create
         * @memberof payment3_paymentmethod_coordinatorpb.GetCustomerDisbursementResponse
         * @static
         * @param {payment3_paymentmethod_coordinatorpb.IGetCustomerDisbursementResponse=} [properties] Properties to set
         * @returns {payment3_paymentmethod_coordinatorpb.GetCustomerDisbursementResponse} GetCustomerDisbursementResponse instance
         */
        GetCustomerDisbursementResponse.create = function create(properties) {
            return new GetCustomerDisbursementResponse(properties);
        };

        /**
         * Encodes the specified GetCustomerDisbursementResponse message. Does not implicitly {@link payment3_paymentmethod_coordinatorpb.GetCustomerDisbursementResponse.verify|verify} messages.
         * @function encode
         * @memberof payment3_paymentmethod_coordinatorpb.GetCustomerDisbursementResponse
         * @static
         * @param {payment3_paymentmethod_coordinatorpb.IGetCustomerDisbursementResponse} m GetCustomerDisbursementResponse message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetCustomerDisbursementResponse.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.remainingDisbursementAmount != null && Object.hasOwnProperty.call(m, "remainingDisbursementAmount"))
                $root.common.Money.encode(m.remainingDisbursementAmount, w.uint32(18).fork()).ldelim();
            return w;
        };

        /**
         * Decodes a GetCustomerDisbursementResponse message from the specified reader or buffer.
         * @function decode
         * @memberof payment3_paymentmethod_coordinatorpb.GetCustomerDisbursementResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {payment3_paymentmethod_coordinatorpb.GetCustomerDisbursementResponse} GetCustomerDisbursementResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetCustomerDisbursementResponse.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.payment3_paymentmethod_coordinatorpb.GetCustomerDisbursementResponse();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 2:
                    m.remainingDisbursementAmount = $root.common.Money.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return GetCustomerDisbursementResponse;
    })();

    payment3_paymentmethod_coordinatorpb.ResolvedContractDetailsRequest = (function() {

        /**
         * Properties of a ResolvedContractDetailsRequest.
         * @memberof payment3_paymentmethod_coordinatorpb
         * @interface IResolvedContractDetailsRequest
         * @property {Array.<string>|null} [contractID] ResolvedContractDetailsRequest contractID
         * @property {Array.<payment3_paymentmethod_coordinatorpb.IQueryDisbursementDetailsCriteria>|null} [details] ResolvedContractDetailsRequest details
         */

        /**
         * Constructs a new ResolvedContractDetailsRequest.
         * @memberof payment3_paymentmethod_coordinatorpb
         * @classdesc Represents a ResolvedContractDetailsRequest.
         * @implements IResolvedContractDetailsRequest
         * @constructor
         * @param {payment3_paymentmethod_coordinatorpb.IResolvedContractDetailsRequest=} [p] Properties to set
         */
        function ResolvedContractDetailsRequest(p) {
            this.contractID = [];
            this.details = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * ResolvedContractDetailsRequest contractID.
         * @member {Array.<string>} contractID
         * @memberof payment3_paymentmethod_coordinatorpb.ResolvedContractDetailsRequest
         * @instance
         */
        ResolvedContractDetailsRequest.prototype.contractID = $util.emptyArray;

        /**
         * ResolvedContractDetailsRequest details.
         * @member {Array.<payment3_paymentmethod_coordinatorpb.IQueryDisbursementDetailsCriteria>} details
         * @memberof payment3_paymentmethod_coordinatorpb.ResolvedContractDetailsRequest
         * @instance
         */
        ResolvedContractDetailsRequest.prototype.details = $util.emptyArray;

        /**
         * Creates a new ResolvedContractDetailsRequest instance using the specified properties.
         * @function create
         * @memberof payment3_paymentmethod_coordinatorpb.ResolvedContractDetailsRequest
         * @static
         * @param {payment3_paymentmethod_coordinatorpb.IResolvedContractDetailsRequest=} [properties] Properties to set
         * @returns {payment3_paymentmethod_coordinatorpb.ResolvedContractDetailsRequest} ResolvedContractDetailsRequest instance
         */
        ResolvedContractDetailsRequest.create = function create(properties) {
            return new ResolvedContractDetailsRequest(properties);
        };

        /**
         * Encodes the specified ResolvedContractDetailsRequest message. Does not implicitly {@link payment3_paymentmethod_coordinatorpb.ResolvedContractDetailsRequest.verify|verify} messages.
         * @function encode
         * @memberof payment3_paymentmethod_coordinatorpb.ResolvedContractDetailsRequest
         * @static
         * @param {payment3_paymentmethod_coordinatorpb.IResolvedContractDetailsRequest} m ResolvedContractDetailsRequest message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ResolvedContractDetailsRequest.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.contractID != null && m.contractID.length) {
                for (var i = 0; i < m.contractID.length; ++i)
                    w.uint32(10).string(m.contractID[i]);
            }
            if (m.details != null && m.details.length) {
                for (var i = 0; i < m.details.length; ++i)
                    $root.payment3_paymentmethod_coordinatorpb.QueryDisbursementDetailsCriteria.encode(m.details[i], w.uint32(18).fork()).ldelim();
            }
            return w;
        };

        /**
         * Decodes a ResolvedContractDetailsRequest message from the specified reader or buffer.
         * @function decode
         * @memberof payment3_paymentmethod_coordinatorpb.ResolvedContractDetailsRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {payment3_paymentmethod_coordinatorpb.ResolvedContractDetailsRequest} ResolvedContractDetailsRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ResolvedContractDetailsRequest.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.payment3_paymentmethod_coordinatorpb.ResolvedContractDetailsRequest();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    if (!(m.contractID && m.contractID.length))
                        m.contractID = [];
                    m.contractID.push(r.string());
                    break;
                case 2:
                    if (!(m.details && m.details.length))
                        m.details = [];
                    m.details.push($root.payment3_paymentmethod_coordinatorpb.QueryDisbursementDetailsCriteria.decode(r, r.uint32()));
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return ResolvedContractDetailsRequest;
    })();

    payment3_paymentmethod_coordinatorpb.QueryDisbursementDetailsCriteria = (function() {

        /**
         * Properties of a QueryDisbursementDetailsCriteria.
         * @memberof payment3_paymentmethod_coordinatorpb
         * @interface IQueryDisbursementDetailsCriteria
         * @property {string|null} [contractID] QueryDisbursementDetailsCriteria contractID
         * @property {string|null} [customerID] QueryDisbursementDetailsCriteria customerID
         */

        /**
         * Constructs a new QueryDisbursementDetailsCriteria.
         * @memberof payment3_paymentmethod_coordinatorpb
         * @classdesc Represents a QueryDisbursementDetailsCriteria.
         * @implements IQueryDisbursementDetailsCriteria
         * @constructor
         * @param {payment3_paymentmethod_coordinatorpb.IQueryDisbursementDetailsCriteria=} [p] Properties to set
         */
        function QueryDisbursementDetailsCriteria(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * QueryDisbursementDetailsCriteria contractID.
         * @member {string} contractID
         * @memberof payment3_paymentmethod_coordinatorpb.QueryDisbursementDetailsCriteria
         * @instance
         */
        QueryDisbursementDetailsCriteria.prototype.contractID = "";

        /**
         * QueryDisbursementDetailsCriteria customerID.
         * @member {string} customerID
         * @memberof payment3_paymentmethod_coordinatorpb.QueryDisbursementDetailsCriteria
         * @instance
         */
        QueryDisbursementDetailsCriteria.prototype.customerID = "";

        /**
         * Creates a new QueryDisbursementDetailsCriteria instance using the specified properties.
         * @function create
         * @memberof payment3_paymentmethod_coordinatorpb.QueryDisbursementDetailsCriteria
         * @static
         * @param {payment3_paymentmethod_coordinatorpb.IQueryDisbursementDetailsCriteria=} [properties] Properties to set
         * @returns {payment3_paymentmethod_coordinatorpb.QueryDisbursementDetailsCriteria} QueryDisbursementDetailsCriteria instance
         */
        QueryDisbursementDetailsCriteria.create = function create(properties) {
            return new QueryDisbursementDetailsCriteria(properties);
        };

        /**
         * Encodes the specified QueryDisbursementDetailsCriteria message. Does not implicitly {@link payment3_paymentmethod_coordinatorpb.QueryDisbursementDetailsCriteria.verify|verify} messages.
         * @function encode
         * @memberof payment3_paymentmethod_coordinatorpb.QueryDisbursementDetailsCriteria
         * @static
         * @param {payment3_paymentmethod_coordinatorpb.IQueryDisbursementDetailsCriteria} m QueryDisbursementDetailsCriteria message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        QueryDisbursementDetailsCriteria.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.contractID != null && Object.hasOwnProperty.call(m, "contractID"))
                w.uint32(82).string(m.contractID);
            if (m.customerID != null && Object.hasOwnProperty.call(m, "customerID"))
                w.uint32(162).string(m.customerID);
            return w;
        };

        /**
         * Decodes a QueryDisbursementDetailsCriteria message from the specified reader or buffer.
         * @function decode
         * @memberof payment3_paymentmethod_coordinatorpb.QueryDisbursementDetailsCriteria
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {payment3_paymentmethod_coordinatorpb.QueryDisbursementDetailsCriteria} QueryDisbursementDetailsCriteria
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        QueryDisbursementDetailsCriteria.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.payment3_paymentmethod_coordinatorpb.QueryDisbursementDetailsCriteria();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 10:
                    m.contractID = r.string();
                    break;
                case 20:
                    m.customerID = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return QueryDisbursementDetailsCriteria;
    })();

    payment3_paymentmethod_coordinatorpb.ResolvedContractDetailsResponse = (function() {

        /**
         * Properties of a ResolvedContractDetailsResponse.
         * @memberof payment3_paymentmethod_coordinatorpb
         * @interface IResolvedContractDetailsResponse
         * @property {Object.<string,payment3_paymentmethodpb.IDisbursementDetails>|null} [contractDetailMap] ResolvedContractDetailsResponse contractDetailMap
         */

        /**
         * Constructs a new ResolvedContractDetailsResponse.
         * @memberof payment3_paymentmethod_coordinatorpb
         * @classdesc Represents a ResolvedContractDetailsResponse.
         * @implements IResolvedContractDetailsResponse
         * @constructor
         * @param {payment3_paymentmethod_coordinatorpb.IResolvedContractDetailsResponse=} [p] Properties to set
         */
        function ResolvedContractDetailsResponse(p) {
            this.contractDetailMap = {};
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * ResolvedContractDetailsResponse contractDetailMap.
         * @member {Object.<string,payment3_paymentmethodpb.IDisbursementDetails>} contractDetailMap
         * @memberof payment3_paymentmethod_coordinatorpb.ResolvedContractDetailsResponse
         * @instance
         */
        ResolvedContractDetailsResponse.prototype.contractDetailMap = $util.emptyObject;

        /**
         * Creates a new ResolvedContractDetailsResponse instance using the specified properties.
         * @function create
         * @memberof payment3_paymentmethod_coordinatorpb.ResolvedContractDetailsResponse
         * @static
         * @param {payment3_paymentmethod_coordinatorpb.IResolvedContractDetailsResponse=} [properties] Properties to set
         * @returns {payment3_paymentmethod_coordinatorpb.ResolvedContractDetailsResponse} ResolvedContractDetailsResponse instance
         */
        ResolvedContractDetailsResponse.create = function create(properties) {
            return new ResolvedContractDetailsResponse(properties);
        };

        /**
         * Encodes the specified ResolvedContractDetailsResponse message. Does not implicitly {@link payment3_paymentmethod_coordinatorpb.ResolvedContractDetailsResponse.verify|verify} messages.
         * @function encode
         * @memberof payment3_paymentmethod_coordinatorpb.ResolvedContractDetailsResponse
         * @static
         * @param {payment3_paymentmethod_coordinatorpb.IResolvedContractDetailsResponse} m ResolvedContractDetailsResponse message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ResolvedContractDetailsResponse.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.contractDetailMap != null && Object.hasOwnProperty.call(m, "contractDetailMap")) {
                for (var ks = Object.keys(m.contractDetailMap), i = 0; i < ks.length; ++i) {
                    w.uint32(10).fork().uint32(10).string(ks[i]);
                    $root.payment3_paymentmethodpb.DisbursementDetails.encode(m.contractDetailMap[ks[i]], w.uint32(18).fork()).ldelim().ldelim();
                }
            }
            return w;
        };

        /**
         * Decodes a ResolvedContractDetailsResponse message from the specified reader or buffer.
         * @function decode
         * @memberof payment3_paymentmethod_coordinatorpb.ResolvedContractDetailsResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {payment3_paymentmethod_coordinatorpb.ResolvedContractDetailsResponse} ResolvedContractDetailsResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ResolvedContractDetailsResponse.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.payment3_paymentmethod_coordinatorpb.ResolvedContractDetailsResponse(), k, value;
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    if (m.contractDetailMap === $util.emptyObject)
                        m.contractDetailMap = {};
                    var c2 = r.uint32() + r.pos;
                    k = "";
                    value = null;
                    while (r.pos < c2) {
                        var tag2 = r.uint32();
                        switch (tag2 >>> 3) {
                        case 1:
                            k = r.string();
                            break;
                        case 2:
                            value = $root.payment3_paymentmethodpb.DisbursementDetails.decode(r, r.uint32());
                            break;
                        default:
                            r.skipType(tag2 & 7);
                            break;
                        }
                    }
                    m.contractDetailMap[k] = value;
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return ResolvedContractDetailsResponse;
    })();

    payment3_paymentmethod_coordinatorpb.ResolvedContractDetails = (function() {

        /**
         * Constructs a new ResolvedContractDetails service.
         * @memberof payment3_paymentmethod_coordinatorpb
         * @classdesc Represents a ResolvedContractDetails
         * @extends $protobuf.rpc.Service
         * @constructor
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         */
        function ResolvedContractDetails(rpcImpl, requestDelimited, responseDelimited) {
            $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
        }

        (ResolvedContractDetails.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = ResolvedContractDetails;

        /**
         * Creates new ResolvedContractDetails service using the specified rpc implementation.
         * @function create
         * @memberof payment3_paymentmethod_coordinatorpb.ResolvedContractDetails
         * @static
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         * @returns {ResolvedContractDetails} RPC service. Useful where requests and/or responses are streamed.
         */
        ResolvedContractDetails.create = function create(rpcImpl, requestDelimited, responseDelimited) {
            return new this(rpcImpl, requestDelimited, responseDelimited);
        };

        /**
         * Callback as used by {@link payment3_paymentmethod_coordinatorpb.ResolvedContractDetails#post}.
         * @memberof payment3_paymentmethod_coordinatorpb.ResolvedContractDetails
         * @typedef PostCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {payment3_paymentmethod_coordinatorpb.ResolvedContractDetailsResponse} [response] ResolvedContractDetailsResponse
         */

        /**
         * Calls Post.
         * @function post
         * @memberof payment3_paymentmethod_coordinatorpb.ResolvedContractDetails
         * @instance
         * @param {payment3_paymentmethod_coordinatorpb.IResolvedContractDetailsRequest} request ResolvedContractDetailsRequest message or plain object
         * @param {payment3_paymentmethod_coordinatorpb.ResolvedContractDetails.PostCallback} callback Node-style callback called with the error, if any, and ResolvedContractDetailsResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(ResolvedContractDetails.prototype.post = function post(request, callback) {
            return this.rpcCall(post, $root.payment3_paymentmethod_coordinatorpb.ResolvedContractDetailsRequest, $root.payment3_paymentmethod_coordinatorpb.ResolvedContractDetailsResponse, request, callback);
        }, "name", { value: "Post" });

        /**
         * Calls Post.
         * @function post
         * @memberof payment3_paymentmethod_coordinatorpb.ResolvedContractDetails
         * @instance
         * @param {payment3_paymentmethod_coordinatorpb.IResolvedContractDetailsRequest} request ResolvedContractDetailsRequest message or plain object
         * @returns {Promise<payment3_paymentmethod_coordinatorpb.ResolvedContractDetailsResponse>} Promise
         * @variation 2
         */

        return ResolvedContractDetails;
    })();

    return payment3_paymentmethod_coordinatorpb;
})();

export const common = $root.common = (() => {

    /**
     * Namespace common.
     * @exports common
     * @namespace
     */
    const common = {};

    /**
     * Tenant enum.
     * @name common.Tenant
     * @enum {number}
     * @property {number} TENANT_UNDEFINED=0 TENANT_UNDEFINED value
     * @property {number} TEST=1 TEST value
     * @property {number} AHS=2 AHS value
     * @property {number} CD=3 CD value
     * @property {number} HSA=4 HSA value
     * @property {number} OG=5 OG value
     * @property {number} LM=6 LM value
     * @property {number} FRONTDOOR=7 FRONTDOOR value
     * @property {number} AHSPC=8 AHSPC value
     * @property {number} HSAPC=9 HSAPC value
     * @property {number} FTDR=10 FTDR value
     * @property {number} HBW210=11 HBW210 value
     */
    common.Tenant = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "TENANT_UNDEFINED"] = 0;
        values[valuesById[1] = "TEST"] = 1;
        values[valuesById[2] = "AHS"] = 2;
        values[valuesById[3] = "CD"] = 3;
        values[valuesById[4] = "HSA"] = 4;
        values[valuesById[5] = "OG"] = 5;
        values[valuesById[6] = "LM"] = 6;
        values[valuesById[7] = "FRONTDOOR"] = 7;
        values[valuesById[8] = "AHSPC"] = 8;
        values[valuesById[9] = "HSAPC"] = 9;
        values[valuesById[10] = "FTDR"] = 10;
        values[valuesById[11] = "HBW210"] = 11;
        return values;
    })();

    /**
     * Alert enum.
     * @name common.Alert
     * @enum {number}
     * @property {number} ALERTS_UNDEFINED=0 ALERTS_UNDEFINED value
     * @property {number} ALERTS_UNSCHEDULED=1 ALERTS_UNSCHEDULED value
     * @property {number} ALERTS_NEED_STATUS_UPDATE=2 ALERTS_NEED_STATUS_UPDATE value
     * @property {number} ALERTS_OPEN_LONGER_THAN_AVERAGE=3 ALERTS_OPEN_LONGER_THAN_AVERAGE value
     * @property {number} ALERTS_SCHEDULE_NEXT_APPOINTMENT=4 ALERTS_SCHEDULE_NEXT_APPOINTMENT value
     * @property {number} ALERTS_RESUBMIT_REQUEST=5 ALERTS_RESUBMIT_REQUEST value
     * @property {number} ALERTS_TODAYS_APPOINTMENT=6 ALERTS_TODAYS_APPOINTMENT value
     * @property {number} ALERTS_AUTHO_STATUS_UPDATED=7 ALERTS_AUTHO_STATUS_UPDATED value
     */
    common.Alert = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "ALERTS_UNDEFINED"] = 0;
        values[valuesById[1] = "ALERTS_UNSCHEDULED"] = 1;
        values[valuesById[2] = "ALERTS_NEED_STATUS_UPDATE"] = 2;
        values[valuesById[3] = "ALERTS_OPEN_LONGER_THAN_AVERAGE"] = 3;
        values[valuesById[4] = "ALERTS_SCHEDULE_NEXT_APPOINTMENT"] = 4;
        values[valuesById[5] = "ALERTS_RESUBMIT_REQUEST"] = 5;
        values[valuesById[6] = "ALERTS_TODAYS_APPOINTMENT"] = 6;
        values[valuesById[7] = "ALERTS_AUTHO_STATUS_UPDATED"] = 7;
        return values;
    })();

    /**
     * Status enum.
     * @name common.Status
     * @enum {number}
     * @property {number} STATUS_UNDEFINED=0 STATUS_UNDEFINED value
     * @property {number} SUCCESS=1 SUCCESS value
     * @property {number} FAIL=2 FAIL value
     */
    common.Status = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "STATUS_UNDEFINED"] = 0;
        values[valuesById[1] = "SUCCESS"] = 1;
        values[valuesById[2] = "FAIL"] = 2;
        return values;
    })();

    /**
     * UserRole enum.
     * @name common.UserRole
     * @enum {number}
     * @property {number} USER_ROLE_UNDEFINED=0 USER_ROLE_UNDEFINED value
     * @property {number} CONTRACTOR=1 CONTRACTOR value
     * @property {number} AGENT=2 AGENT value
     * @property {number} ADMIN=3 ADMIN value
     * @property {number} TECHNICIAN=4 TECHNICIAN value
     * @property {number} PARTNER=5 PARTNER value
     * @property {number} CUSTOMER=6 CUSTOMER value
     * @property {number} DEVELOPER=7 DEVELOPER value
     * @property {number} EXTERNAL_PARTNER=8 EXTERNAL_PARTNER value
     */
    common.UserRole = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "USER_ROLE_UNDEFINED"] = 0;
        values[valuesById[1] = "CONTRACTOR"] = 1;
        values[valuesById[2] = "AGENT"] = 2;
        values[valuesById[3] = "ADMIN"] = 3;
        values[valuesById[4] = "TECHNICIAN"] = 4;
        values[valuesById[5] = "PARTNER"] = 5;
        values[valuesById[6] = "CUSTOMER"] = 6;
        values[valuesById[7] = "DEVELOPER"] = 7;
        values[valuesById[8] = "EXTERNAL_PARTNER"] = 8;
        return values;
    })();

    /**
     * Application enum.
     * @name common.Application
     * @enum {number}
     * @property {number} Application_UNKNOWN=0 Application_UNKNOWN value
     * @property {number} Application_CNTRTRPRTL=1 Application_CNTRTRPRTL value
     * @property {number} Application_MYACCOUNT=2 Application_MYACCOUNT value
     * @property {number} Application_CSC=3 Application_CSC value
     * @property {number} Application_MOBILEAPP=4 Application_MOBILEAPP value
     * @property {number} Application_ESTREVIEW=5 Application_ESTREVIEW value
     * @property {number} Application_DISTHRDPRT=6 Application_DISTHRDPRT value
     * @property {number} Application_DPCONN=7 Application_DPCONN value
     * @property {number} Application_DISPATCHME=8 Application_DISPATCHME value
     * @property {number} Application_DISPMEPRTL=9 Application_DISPMEPRTL value
     * @property {number} Application_SC=10 Application_SC value
     * @property {number} Application_SC_RENEWALS=11 Application_SC_RENEWALS value
     * @property {number} Application_MA_RENEWALS=12 Application_MA_RENEWALS value
     * @property {number} Application_CONTRACT_MS=13 Application_CONTRACT_MS value
     * @property {number} Application_RENEWAL_ORCHESTRATOR=14 Application_RENEWAL_ORCHESTRATOR value
     * @property {number} Application_WEBSERVICE=15 Application_WEBSERVICE value
     * @property {number} Application_CL=16 Application_CL value
     * @property {number} Application_SC_DTC=17 Application_SC_DTC value
     * @property {number} Application_SC_RE=18 Application_SC_RE value
     * @property {number} Application_RENEWALS_BATCH_JOB=19 Application_RENEWALS_BATCH_JOB value
     */
    common.Application = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "Application_UNKNOWN"] = 0;
        values[valuesById[1] = "Application_CNTRTRPRTL"] = 1;
        values[valuesById[2] = "Application_MYACCOUNT"] = 2;
        values[valuesById[3] = "Application_CSC"] = 3;
        values[valuesById[4] = "Application_MOBILEAPP"] = 4;
        values[valuesById[5] = "Application_ESTREVIEW"] = 5;
        values[valuesById[6] = "Application_DISTHRDPRT"] = 6;
        values[valuesById[7] = "Application_DPCONN"] = 7;
        values[valuesById[8] = "Application_DISPATCHME"] = 8;
        values[valuesById[9] = "Application_DISPMEPRTL"] = 9;
        values[valuesById[10] = "Application_SC"] = 10;
        values[valuesById[11] = "Application_SC_RENEWALS"] = 11;
        values[valuesById[12] = "Application_MA_RENEWALS"] = 12;
        values[valuesById[13] = "Application_CONTRACT_MS"] = 13;
        values[valuesById[14] = "Application_RENEWAL_ORCHESTRATOR"] = 14;
        values[valuesById[15] = "Application_WEBSERVICE"] = 15;
        values[valuesById[16] = "Application_CL"] = 16;
        values[valuesById[17] = "Application_SC_DTC"] = 17;
        values[valuesById[18] = "Application_SC_RE"] = 18;
        values[valuesById[19] = "Application_RENEWALS_BATCH_JOB"] = 19;
        return values;
    })();

    common.HealthCheckDetail = (function() {

        /**
         * Properties of a HealthCheckDetail.
         * @memberof common
         * @interface IHealthCheckDetail
         * @property {string|null} [componentID] HealthCheckDetail componentID
         * @property {string|null} [type] HealthCheckDetail type
         * @property {number|null} [observedValue] HealthCheckDetail observedValue
         * @property {string|null} [observedUnit] HealthCheckDetail observedUnit
         * @property {string|null} [status] HealthCheckDetail status
         * @property {google.protobuf.ITimestamp|null} [time] HealthCheckDetail time
         * @property {string|null} [output] HealthCheckDetail output
         */

        /**
         * Constructs a new HealthCheckDetail.
         * @memberof common
         * @classdesc Represents a HealthCheckDetail.
         * @implements IHealthCheckDetail
         * @constructor
         * @param {common.IHealthCheckDetail=} [p] Properties to set
         */
        function HealthCheckDetail(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * HealthCheckDetail componentID.
         * @member {string} componentID
         * @memberof common.HealthCheckDetail
         * @instance
         */
        HealthCheckDetail.prototype.componentID = "";

        /**
         * HealthCheckDetail type.
         * @member {string} type
         * @memberof common.HealthCheckDetail
         * @instance
         */
        HealthCheckDetail.prototype.type = "";

        /**
         * HealthCheckDetail observedValue.
         * @member {number} observedValue
         * @memberof common.HealthCheckDetail
         * @instance
         */
        HealthCheckDetail.prototype.observedValue = 0;

        /**
         * HealthCheckDetail observedUnit.
         * @member {string} observedUnit
         * @memberof common.HealthCheckDetail
         * @instance
         */
        HealthCheckDetail.prototype.observedUnit = "";

        /**
         * HealthCheckDetail status.
         * @member {string} status
         * @memberof common.HealthCheckDetail
         * @instance
         */
        HealthCheckDetail.prototype.status = "";

        /**
         * HealthCheckDetail time.
         * @member {google.protobuf.ITimestamp|null|undefined} time
         * @memberof common.HealthCheckDetail
         * @instance
         */
        HealthCheckDetail.prototype.time = null;

        /**
         * HealthCheckDetail output.
         * @member {string} output
         * @memberof common.HealthCheckDetail
         * @instance
         */
        HealthCheckDetail.prototype.output = "";

        /**
         * Creates a new HealthCheckDetail instance using the specified properties.
         * @function create
         * @memberof common.HealthCheckDetail
         * @static
         * @param {common.IHealthCheckDetail=} [properties] Properties to set
         * @returns {common.HealthCheckDetail} HealthCheckDetail instance
         */
        HealthCheckDetail.create = function create(properties) {
            return new HealthCheckDetail(properties);
        };

        /**
         * Encodes the specified HealthCheckDetail message. Does not implicitly {@link common.HealthCheckDetail.verify|verify} messages.
         * @function encode
         * @memberof common.HealthCheckDetail
         * @static
         * @param {common.IHealthCheckDetail} m HealthCheckDetail message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        HealthCheckDetail.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.componentID != null && Object.hasOwnProperty.call(m, "componentID"))
                w.uint32(10).string(m.componentID);
            if (m.type != null && Object.hasOwnProperty.call(m, "type"))
                w.uint32(18).string(m.type);
            if (m.observedValue != null && Object.hasOwnProperty.call(m, "observedValue"))
                w.uint32(25).double(m.observedValue);
            if (m.observedUnit != null && Object.hasOwnProperty.call(m, "observedUnit"))
                w.uint32(34).string(m.observedUnit);
            if (m.status != null && Object.hasOwnProperty.call(m, "status"))
                w.uint32(42).string(m.status);
            if (m.time != null && Object.hasOwnProperty.call(m, "time"))
                $root.google.protobuf.Timestamp.encode(m.time, w.uint32(50).fork()).ldelim();
            if (m.output != null && Object.hasOwnProperty.call(m, "output"))
                w.uint32(58).string(m.output);
            return w;
        };

        /**
         * Decodes a HealthCheckDetail message from the specified reader or buffer.
         * @function decode
         * @memberof common.HealthCheckDetail
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {common.HealthCheckDetail} HealthCheckDetail
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        HealthCheckDetail.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.common.HealthCheckDetail();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.componentID = r.string();
                    break;
                case 2:
                    m.type = r.string();
                    break;
                case 3:
                    m.observedValue = r.double();
                    break;
                case 4:
                    m.observedUnit = r.string();
                    break;
                case 5:
                    m.status = r.string();
                    break;
                case 6:
                    m.time = $root.google.protobuf.Timestamp.decode(r, r.uint32());
                    break;
                case 7:
                    m.output = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return HealthCheckDetail;
    })();

    common.NamedHealthCheckDetail = (function() {

        /**
         * Properties of a NamedHealthCheckDetail.
         * @memberof common
         * @interface INamedHealthCheckDetail
         * @property {string|null} [name] NamedHealthCheckDetail name
         * @property {Array.<common.IHealthCheckDetail>|null} [details] NamedHealthCheckDetail details
         */

        /**
         * Constructs a new NamedHealthCheckDetail.
         * @memberof common
         * @classdesc Represents a NamedHealthCheckDetail.
         * @implements INamedHealthCheckDetail
         * @constructor
         * @param {common.INamedHealthCheckDetail=} [p] Properties to set
         */
        function NamedHealthCheckDetail(p) {
            this.details = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * NamedHealthCheckDetail name.
         * @member {string} name
         * @memberof common.NamedHealthCheckDetail
         * @instance
         */
        NamedHealthCheckDetail.prototype.name = "";

        /**
         * NamedHealthCheckDetail details.
         * @member {Array.<common.IHealthCheckDetail>} details
         * @memberof common.NamedHealthCheckDetail
         * @instance
         */
        NamedHealthCheckDetail.prototype.details = $util.emptyArray;

        /**
         * Creates a new NamedHealthCheckDetail instance using the specified properties.
         * @function create
         * @memberof common.NamedHealthCheckDetail
         * @static
         * @param {common.INamedHealthCheckDetail=} [properties] Properties to set
         * @returns {common.NamedHealthCheckDetail} NamedHealthCheckDetail instance
         */
        NamedHealthCheckDetail.create = function create(properties) {
            return new NamedHealthCheckDetail(properties);
        };

        /**
         * Encodes the specified NamedHealthCheckDetail message. Does not implicitly {@link common.NamedHealthCheckDetail.verify|verify} messages.
         * @function encode
         * @memberof common.NamedHealthCheckDetail
         * @static
         * @param {common.INamedHealthCheckDetail} m NamedHealthCheckDetail message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        NamedHealthCheckDetail.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.name != null && Object.hasOwnProperty.call(m, "name"))
                w.uint32(10).string(m.name);
            if (m.details != null && m.details.length) {
                for (var i = 0; i < m.details.length; ++i)
                    $root.common.HealthCheckDetail.encode(m.details[i], w.uint32(18).fork()).ldelim();
            }
            return w;
        };

        /**
         * Decodes a NamedHealthCheckDetail message from the specified reader or buffer.
         * @function decode
         * @memberof common.NamedHealthCheckDetail
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {common.NamedHealthCheckDetail} NamedHealthCheckDetail
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        NamedHealthCheckDetail.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.common.NamedHealthCheckDetail();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.name = r.string();
                    break;
                case 2:
                    if (!(m.details && m.details.length))
                        m.details = [];
                    m.details.push($root.common.HealthCheckDetail.decode(r, r.uint32()));
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return NamedHealthCheckDetail;
    })();

    common.HealthCheck = (function() {

        /**
         * Properties of a HealthCheck.
         * @memberof common
         * @interface IHealthCheck
         * @property {string|null} [status] HealthCheck status
         * @property {string|null} [version] HealthCheck version
         * @property {string|null} [releaseID] HealthCheck releaseID
         * @property {Array.<string>|null} [notes] HealthCheck notes
         * @property {string|null} [output] HealthCheck output
         * @property {Array.<common.INamedHealthCheckDetail>|null} [details] HealthCheck details
         */

        /**
         * Constructs a new HealthCheck.
         * @memberof common
         * @classdesc Represents a HealthCheck.
         * @implements IHealthCheck
         * @constructor
         * @param {common.IHealthCheck=} [p] Properties to set
         */
        function HealthCheck(p) {
            this.notes = [];
            this.details = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * HealthCheck status.
         * @member {string} status
         * @memberof common.HealthCheck
         * @instance
         */
        HealthCheck.prototype.status = "";

        /**
         * HealthCheck version.
         * @member {string} version
         * @memberof common.HealthCheck
         * @instance
         */
        HealthCheck.prototype.version = "";

        /**
         * HealthCheck releaseID.
         * @member {string} releaseID
         * @memberof common.HealthCheck
         * @instance
         */
        HealthCheck.prototype.releaseID = "";

        /**
         * HealthCheck notes.
         * @member {Array.<string>} notes
         * @memberof common.HealthCheck
         * @instance
         */
        HealthCheck.prototype.notes = $util.emptyArray;

        /**
         * HealthCheck output.
         * @member {string} output
         * @memberof common.HealthCheck
         * @instance
         */
        HealthCheck.prototype.output = "";

        /**
         * HealthCheck details.
         * @member {Array.<common.INamedHealthCheckDetail>} details
         * @memberof common.HealthCheck
         * @instance
         */
        HealthCheck.prototype.details = $util.emptyArray;

        /**
         * Creates a new HealthCheck instance using the specified properties.
         * @function create
         * @memberof common.HealthCheck
         * @static
         * @param {common.IHealthCheck=} [properties] Properties to set
         * @returns {common.HealthCheck} HealthCheck instance
         */
        HealthCheck.create = function create(properties) {
            return new HealthCheck(properties);
        };

        /**
         * Encodes the specified HealthCheck message. Does not implicitly {@link common.HealthCheck.verify|verify} messages.
         * @function encode
         * @memberof common.HealthCheck
         * @static
         * @param {common.IHealthCheck} m HealthCheck message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        HealthCheck.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.status != null && Object.hasOwnProperty.call(m, "status"))
                w.uint32(10).string(m.status);
            if (m.version != null && Object.hasOwnProperty.call(m, "version"))
                w.uint32(18).string(m.version);
            if (m.releaseID != null && Object.hasOwnProperty.call(m, "releaseID"))
                w.uint32(26).string(m.releaseID);
            if (m.notes != null && m.notes.length) {
                for (var i = 0; i < m.notes.length; ++i)
                    w.uint32(34).string(m.notes[i]);
            }
            if (m.output != null && Object.hasOwnProperty.call(m, "output"))
                w.uint32(42).string(m.output);
            if (m.details != null && m.details.length) {
                for (var i = 0; i < m.details.length; ++i)
                    $root.common.NamedHealthCheckDetail.encode(m.details[i], w.uint32(50).fork()).ldelim();
            }
            return w;
        };

        /**
         * Decodes a HealthCheck message from the specified reader or buffer.
         * @function decode
         * @memberof common.HealthCheck
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {common.HealthCheck} HealthCheck
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        HealthCheck.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.common.HealthCheck();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.status = r.string();
                    break;
                case 2:
                    m.version = r.string();
                    break;
                case 3:
                    m.releaseID = r.string();
                    break;
                case 4:
                    if (!(m.notes && m.notes.length))
                        m.notes = [];
                    m.notes.push(r.string());
                    break;
                case 5:
                    m.output = r.string();
                    break;
                case 6:
                    if (!(m.details && m.details.length))
                        m.details = [];
                    m.details.push($root.common.NamedHealthCheckDetail.decode(r, r.uint32()));
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return HealthCheck;
    })();

    common.HealthCheckResponse = (function() {

        /**
         * Properties of a HealthCheckResponse.
         * @memberof common
         * @interface IHealthCheckResponse
         * @property {common.IHealthCheck|null} [health] HealthCheckResponse health
         */

        /**
         * Constructs a new HealthCheckResponse.
         * @memberof common
         * @classdesc Represents a HealthCheckResponse.
         * @implements IHealthCheckResponse
         * @constructor
         * @param {common.IHealthCheckResponse=} [p] Properties to set
         */
        function HealthCheckResponse(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * HealthCheckResponse health.
         * @member {common.IHealthCheck|null|undefined} health
         * @memberof common.HealthCheckResponse
         * @instance
         */
        HealthCheckResponse.prototype.health = null;

        /**
         * Creates a new HealthCheckResponse instance using the specified properties.
         * @function create
         * @memberof common.HealthCheckResponse
         * @static
         * @param {common.IHealthCheckResponse=} [properties] Properties to set
         * @returns {common.HealthCheckResponse} HealthCheckResponse instance
         */
        HealthCheckResponse.create = function create(properties) {
            return new HealthCheckResponse(properties);
        };

        /**
         * Encodes the specified HealthCheckResponse message. Does not implicitly {@link common.HealthCheckResponse.verify|verify} messages.
         * @function encode
         * @memberof common.HealthCheckResponse
         * @static
         * @param {common.IHealthCheckResponse} m HealthCheckResponse message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        HealthCheckResponse.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.health != null && Object.hasOwnProperty.call(m, "health"))
                $root.common.HealthCheck.encode(m.health, w.uint32(10).fork()).ldelim();
            return w;
        };

        /**
         * Decodes a HealthCheckResponse message from the specified reader or buffer.
         * @function decode
         * @memberof common.HealthCheckResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {common.HealthCheckResponse} HealthCheckResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        HealthCheckResponse.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.common.HealthCheckResponse();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.health = $root.common.HealthCheck.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return HealthCheckResponse;
    })();

    common.Timeslot = (function() {

        /**
         * Properties of a Timeslot.
         * @memberof common
         * @interface ITimeslot
         * @property {google.protobuf.ITimestamp|null} [start] Timeslot start
         * @property {google.protobuf.ITimestamp|null} [end] Timeslot end
         */

        /**
         * Constructs a new Timeslot.
         * @memberof common
         * @classdesc Represents a Timeslot.
         * @implements ITimeslot
         * @constructor
         * @param {common.ITimeslot=} [p] Properties to set
         */
        function Timeslot(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * Timeslot start.
         * @member {google.protobuf.ITimestamp|null|undefined} start
         * @memberof common.Timeslot
         * @instance
         */
        Timeslot.prototype.start = null;

        /**
         * Timeslot end.
         * @member {google.protobuf.ITimestamp|null|undefined} end
         * @memberof common.Timeslot
         * @instance
         */
        Timeslot.prototype.end = null;

        /**
         * Creates a new Timeslot instance using the specified properties.
         * @function create
         * @memberof common.Timeslot
         * @static
         * @param {common.ITimeslot=} [properties] Properties to set
         * @returns {common.Timeslot} Timeslot instance
         */
        Timeslot.create = function create(properties) {
            return new Timeslot(properties);
        };

        /**
         * Encodes the specified Timeslot message. Does not implicitly {@link common.Timeslot.verify|verify} messages.
         * @function encode
         * @memberof common.Timeslot
         * @static
         * @param {common.ITimeslot} m Timeslot message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Timeslot.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.start != null && Object.hasOwnProperty.call(m, "start"))
                $root.google.protobuf.Timestamp.encode(m.start, w.uint32(10).fork()).ldelim();
            if (m.end != null && Object.hasOwnProperty.call(m, "end"))
                $root.google.protobuf.Timestamp.encode(m.end, w.uint32(18).fork()).ldelim();
            return w;
        };

        /**
         * Decodes a Timeslot message from the specified reader or buffer.
         * @function decode
         * @memberof common.Timeslot
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {common.Timeslot} Timeslot
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Timeslot.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.common.Timeslot();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.start = $root.google.protobuf.Timestamp.decode(r, r.uint32());
                    break;
                case 2:
                    m.end = $root.google.protobuf.Timestamp.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return Timeslot;
    })();

    common.ErrorResponse = (function() {

        /**
         * Properties of an ErrorResponse.
         * @memberof common
         * @interface IErrorResponse
         * @property {Array.<common.IError>|null} [errors] ErrorResponse errors
         */

        /**
         * Constructs a new ErrorResponse.
         * @memberof common
         * @classdesc Represents an ErrorResponse.
         * @implements IErrorResponse
         * @constructor
         * @param {common.IErrorResponse=} [p] Properties to set
         */
        function ErrorResponse(p) {
            this.errors = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * ErrorResponse errors.
         * @member {Array.<common.IError>} errors
         * @memberof common.ErrorResponse
         * @instance
         */
        ErrorResponse.prototype.errors = $util.emptyArray;

        /**
         * Creates a new ErrorResponse instance using the specified properties.
         * @function create
         * @memberof common.ErrorResponse
         * @static
         * @param {common.IErrorResponse=} [properties] Properties to set
         * @returns {common.ErrorResponse} ErrorResponse instance
         */
        ErrorResponse.create = function create(properties) {
            return new ErrorResponse(properties);
        };

        /**
         * Encodes the specified ErrorResponse message. Does not implicitly {@link common.ErrorResponse.verify|verify} messages.
         * @function encode
         * @memberof common.ErrorResponse
         * @static
         * @param {common.IErrorResponse} m ErrorResponse message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ErrorResponse.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.errors != null && m.errors.length) {
                for (var i = 0; i < m.errors.length; ++i)
                    $root.common.Error.encode(m.errors[i], w.uint32(10).fork()).ldelim();
            }
            return w;
        };

        /**
         * Decodes an ErrorResponse message from the specified reader or buffer.
         * @function decode
         * @memberof common.ErrorResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {common.ErrorResponse} ErrorResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ErrorResponse.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.common.ErrorResponse();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    if (!(m.errors && m.errors.length))
                        m.errors = [];
                    m.errors.push($root.common.Error.decode(r, r.uint32()));
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return ErrorResponse;
    })();

    common.Error = (function() {

        /**
         * Properties of an Error.
         * @memberof common
         * @interface IError
         * @property {string|null} [message] Error message
         * @property {string|null} [code] Error code
         */

        /**
         * Constructs a new Error.
         * @memberof common
         * @classdesc Represents an Error.
         * @implements IError
         * @constructor
         * @param {common.IError=} [p] Properties to set
         */
        function Error(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * Error message.
         * @member {string} message
         * @memberof common.Error
         * @instance
         */
        Error.prototype.message = "";

        /**
         * Error code.
         * @member {string} code
         * @memberof common.Error
         * @instance
         */
        Error.prototype.code = "";

        /**
         * Creates a new Error instance using the specified properties.
         * @function create
         * @memberof common.Error
         * @static
         * @param {common.IError=} [properties] Properties to set
         * @returns {common.Error} Error instance
         */
        Error.create = function create(properties) {
            return new Error(properties);
        };

        /**
         * Encodes the specified Error message. Does not implicitly {@link common.Error.verify|verify} messages.
         * @function encode
         * @memberof common.Error
         * @static
         * @param {common.IError} m Error message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Error.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.message != null && Object.hasOwnProperty.call(m, "message"))
                w.uint32(10).string(m.message);
            if (m.code != null && Object.hasOwnProperty.call(m, "code"))
                w.uint32(18).string(m.code);
            return w;
        };

        /**
         * Decodes an Error message from the specified reader or buffer.
         * @function decode
         * @memberof common.Error
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {common.Error} Error
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Error.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.common.Error();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.message = r.string();
                    break;
                case 2:
                    m.code = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return Error;
    })();

    common.Money = (function() {

        /**
         * Properties of a Money.
         * @memberof common
         * @interface IMoney
         * @property {string|null} [currencyCode] Money currencyCode
         * @property {number|Long|null} [units] Money units
         * @property {number|null} [nanos] Money nanos
         */

        /**
         * Constructs a new Money.
         * @memberof common
         * @classdesc Represents a Money.
         * @implements IMoney
         * @constructor
         * @param {common.IMoney=} [p] Properties to set
         */
        function Money(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * Money currencyCode.
         * @member {string} currencyCode
         * @memberof common.Money
         * @instance
         */
        Money.prototype.currencyCode = "";

        /**
         * Money units.
         * @member {number|Long} units
         * @memberof common.Money
         * @instance
         */
        Money.prototype.units = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Money nanos.
         * @member {number} nanos
         * @memberof common.Money
         * @instance
         */
        Money.prototype.nanos = 0;

        /**
         * Creates a new Money instance using the specified properties.
         * @function create
         * @memberof common.Money
         * @static
         * @param {common.IMoney=} [properties] Properties to set
         * @returns {common.Money} Money instance
         */
        Money.create = function create(properties) {
            return new Money(properties);
        };

        /**
         * Encodes the specified Money message. Does not implicitly {@link common.Money.verify|verify} messages.
         * @function encode
         * @memberof common.Money
         * @static
         * @param {common.IMoney} m Money message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Money.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.currencyCode != null && Object.hasOwnProperty.call(m, "currencyCode"))
                w.uint32(10).string(m.currencyCode);
            if (m.units != null && Object.hasOwnProperty.call(m, "units"))
                w.uint32(16).int64(m.units);
            if (m.nanos != null && Object.hasOwnProperty.call(m, "nanos"))
                w.uint32(24).int32(m.nanos);
            return w;
        };

        /**
         * Decodes a Money message from the specified reader or buffer.
         * @function decode
         * @memberof common.Money
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {common.Money} Money
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Money.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.common.Money();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.currencyCode = r.string();
                    break;
                case 2:
                    m.units = r.int64();
                    break;
                case 3:
                    m.nanos = r.int32();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return Money;
    })();

    common.Date = (function() {

        /**
         * Properties of a Date.
         * @memberof common
         * @interface IDate
         * @property {number|null} [year] Date year
         * @property {number|null} [month] Date month
         * @property {number|null} [day] Date day
         */

        /**
         * Constructs a new Date.
         * @memberof common
         * @classdesc Represents a Date.
         * @implements IDate
         * @constructor
         * @param {common.IDate=} [p] Properties to set
         */
        function Date(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * Date year.
         * @member {number} year
         * @memberof common.Date
         * @instance
         */
        Date.prototype.year = 0;

        /**
         * Date month.
         * @member {number} month
         * @memberof common.Date
         * @instance
         */
        Date.prototype.month = 0;

        /**
         * Date day.
         * @member {number} day
         * @memberof common.Date
         * @instance
         */
        Date.prototype.day = 0;

        /**
         * Creates a new Date instance using the specified properties.
         * @function create
         * @memberof common.Date
         * @static
         * @param {common.IDate=} [properties] Properties to set
         * @returns {common.Date} Date instance
         */
        Date.create = function create(properties) {
            return new Date(properties);
        };

        /**
         * Encodes the specified Date message. Does not implicitly {@link common.Date.verify|verify} messages.
         * @function encode
         * @memberof common.Date
         * @static
         * @param {common.IDate} m Date message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Date.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.year != null && Object.hasOwnProperty.call(m, "year"))
                w.uint32(8).int32(m.year);
            if (m.month != null && Object.hasOwnProperty.call(m, "month"))
                w.uint32(16).int32(m.month);
            if (m.day != null && Object.hasOwnProperty.call(m, "day"))
                w.uint32(24).int32(m.day);
            return w;
        };

        /**
         * Decodes a Date message from the specified reader or buffer.
         * @function decode
         * @memberof common.Date
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {common.Date} Date
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Date.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.common.Date();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.year = r.int32();
                    break;
                case 2:
                    m.month = r.int32();
                    break;
                case 3:
                    m.day = r.int32();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return Date;
    })();

    common.GeoLocation = (function() {

        /**
         * Properties of a GeoLocation.
         * @memberof common
         * @interface IGeoLocation
         * @property {number|null} [latitude] GeoLocation latitude
         * @property {number|null} [longitude] GeoLocation longitude
         */

        /**
         * Constructs a new GeoLocation.
         * @memberof common
         * @classdesc Represents a GeoLocation.
         * @implements IGeoLocation
         * @constructor
         * @param {common.IGeoLocation=} [p] Properties to set
         */
        function GeoLocation(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * GeoLocation latitude.
         * @member {number} latitude
         * @memberof common.GeoLocation
         * @instance
         */
        GeoLocation.prototype.latitude = 0;

        /**
         * GeoLocation longitude.
         * @member {number} longitude
         * @memberof common.GeoLocation
         * @instance
         */
        GeoLocation.prototype.longitude = 0;

        /**
         * Creates a new GeoLocation instance using the specified properties.
         * @function create
         * @memberof common.GeoLocation
         * @static
         * @param {common.IGeoLocation=} [properties] Properties to set
         * @returns {common.GeoLocation} GeoLocation instance
         */
        GeoLocation.create = function create(properties) {
            return new GeoLocation(properties);
        };

        /**
         * Encodes the specified GeoLocation message. Does not implicitly {@link common.GeoLocation.verify|verify} messages.
         * @function encode
         * @memberof common.GeoLocation
         * @static
         * @param {common.IGeoLocation} m GeoLocation message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GeoLocation.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.latitude != null && Object.hasOwnProperty.call(m, "latitude"))
                w.uint32(13).float(m.latitude);
            if (m.longitude != null && Object.hasOwnProperty.call(m, "longitude"))
                w.uint32(21).float(m.longitude);
            return w;
        };

        /**
         * Decodes a GeoLocation message from the specified reader or buffer.
         * @function decode
         * @memberof common.GeoLocation
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {common.GeoLocation} GeoLocation
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GeoLocation.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.common.GeoLocation();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.latitude = r.float();
                    break;
                case 2:
                    m.longitude = r.float();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return GeoLocation;
    })();

    /**
     * Locale enum.
     * @name common.Locale
     * @enum {number}
     * @property {number} EN=0 EN value
     * @property {number} ES=1 ES value
     */
    common.Locale = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "EN"] = 0;
        values[valuesById[1] = "ES"] = 1;
        return values;
    })();

    common.Range_U32 = (function() {

        /**
         * Properties of a Range_U32.
         * @memberof common
         * @interface IRange_U32
         * @property {number|null} [min] Range_U32 min
         * @property {number|null} [max] Range_U32 max
         */

        /**
         * Constructs a new Range_U32.
         * @memberof common
         * @classdesc Represents a Range_U32.
         * @implements IRange_U32
         * @constructor
         * @param {common.IRange_U32=} [p] Properties to set
         */
        function Range_U32(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * Range_U32 min.
         * @member {number} min
         * @memberof common.Range_U32
         * @instance
         */
        Range_U32.prototype.min = 0;

        /**
         * Range_U32 max.
         * @member {number} max
         * @memberof common.Range_U32
         * @instance
         */
        Range_U32.prototype.max = 0;

        /**
         * Creates a new Range_U32 instance using the specified properties.
         * @function create
         * @memberof common.Range_U32
         * @static
         * @param {common.IRange_U32=} [properties] Properties to set
         * @returns {common.Range_U32} Range_U32 instance
         */
        Range_U32.create = function create(properties) {
            return new Range_U32(properties);
        };

        /**
         * Encodes the specified Range_U32 message. Does not implicitly {@link common.Range_U32.verify|verify} messages.
         * @function encode
         * @memberof common.Range_U32
         * @static
         * @param {common.IRange_U32} m Range_U32 message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Range_U32.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.min != null && Object.hasOwnProperty.call(m, "min"))
                w.uint32(8).uint32(m.min);
            if (m.max != null && Object.hasOwnProperty.call(m, "max"))
                w.uint32(16).uint32(m.max);
            return w;
        };

        /**
         * Decodes a Range_U32 message from the specified reader or buffer.
         * @function decode
         * @memberof common.Range_U32
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {common.Range_U32} Range_U32
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Range_U32.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.common.Range_U32();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.min = r.uint32();
                    break;
                case 2:
                    m.max = r.uint32();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return Range_U32;
    })();

    common.ApplicationSource = (function() {

        /**
         * Properties of an ApplicationSource.
         * @memberof common
         * @interface IApplicationSource
         * @property {string|null} [name] ApplicationSource name
         * @property {string|null} [version] ApplicationSource version
         * @property {string|null} [authorVersion] ApplicationSource authorVersion
         */

        /**
         * Constructs a new ApplicationSource.
         * @memberof common
         * @classdesc Represents an ApplicationSource.
         * @implements IApplicationSource
         * @constructor
         * @param {common.IApplicationSource=} [p] Properties to set
         */
        function ApplicationSource(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * ApplicationSource name.
         * @member {string} name
         * @memberof common.ApplicationSource
         * @instance
         */
        ApplicationSource.prototype.name = "";

        /**
         * ApplicationSource version.
         * @member {string} version
         * @memberof common.ApplicationSource
         * @instance
         */
        ApplicationSource.prototype.version = "";

        /**
         * ApplicationSource authorVersion.
         * @member {string} authorVersion
         * @memberof common.ApplicationSource
         * @instance
         */
        ApplicationSource.prototype.authorVersion = "";

        /**
         * Creates a new ApplicationSource instance using the specified properties.
         * @function create
         * @memberof common.ApplicationSource
         * @static
         * @param {common.IApplicationSource=} [properties] Properties to set
         * @returns {common.ApplicationSource} ApplicationSource instance
         */
        ApplicationSource.create = function create(properties) {
            return new ApplicationSource(properties);
        };

        /**
         * Encodes the specified ApplicationSource message. Does not implicitly {@link common.ApplicationSource.verify|verify} messages.
         * @function encode
         * @memberof common.ApplicationSource
         * @static
         * @param {common.IApplicationSource} m ApplicationSource message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ApplicationSource.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.name != null && Object.hasOwnProperty.call(m, "name"))
                w.uint32(10).string(m.name);
            if (m.version != null && Object.hasOwnProperty.call(m, "version"))
                w.uint32(18).string(m.version);
            if (m.authorVersion != null && Object.hasOwnProperty.call(m, "authorVersion"))
                w.uint32(26).string(m.authorVersion);
            return w;
        };

        /**
         * Decodes an ApplicationSource message from the specified reader or buffer.
         * @function decode
         * @memberof common.ApplicationSource
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {common.ApplicationSource} ApplicationSource
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ApplicationSource.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.common.ApplicationSource();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.name = r.string();
                    break;
                case 2:
                    m.version = r.string();
                    break;
                case 3:
                    m.authorVersion = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return ApplicationSource;
    })();

    common.Pagination = (function() {

        /**
         * Properties of a Pagination.
         * @memberof common
         * @interface IPagination
         * @property {number|null} [currentPage] Pagination currentPage
         * @property {number|null} [itemsPerPage] Pagination itemsPerPage
         * @property {number|null} [totalPages] Pagination totalPages
         * @property {number|null} [totalRecords] Pagination totalRecords
         */

        /**
         * Constructs a new Pagination.
         * @memberof common
         * @classdesc Represents a Pagination.
         * @implements IPagination
         * @constructor
         * @param {common.IPagination=} [p] Properties to set
         */
        function Pagination(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * Pagination currentPage.
         * @member {number} currentPage
         * @memberof common.Pagination
         * @instance
         */
        Pagination.prototype.currentPage = 0;

        /**
         * Pagination itemsPerPage.
         * @member {number} itemsPerPage
         * @memberof common.Pagination
         * @instance
         */
        Pagination.prototype.itemsPerPage = 0;

        /**
         * Pagination totalPages.
         * @member {number} totalPages
         * @memberof common.Pagination
         * @instance
         */
        Pagination.prototype.totalPages = 0;

        /**
         * Pagination totalRecords.
         * @member {number} totalRecords
         * @memberof common.Pagination
         * @instance
         */
        Pagination.prototype.totalRecords = 0;

        /**
         * Creates a new Pagination instance using the specified properties.
         * @function create
         * @memberof common.Pagination
         * @static
         * @param {common.IPagination=} [properties] Properties to set
         * @returns {common.Pagination} Pagination instance
         */
        Pagination.create = function create(properties) {
            return new Pagination(properties);
        };

        /**
         * Encodes the specified Pagination message. Does not implicitly {@link common.Pagination.verify|verify} messages.
         * @function encode
         * @memberof common.Pagination
         * @static
         * @param {common.IPagination} m Pagination message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Pagination.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.currentPage != null && Object.hasOwnProperty.call(m, "currentPage"))
                w.uint32(8).int32(m.currentPage);
            if (m.itemsPerPage != null && Object.hasOwnProperty.call(m, "itemsPerPage"))
                w.uint32(16).int32(m.itemsPerPage);
            if (m.totalPages != null && Object.hasOwnProperty.call(m, "totalPages"))
                w.uint32(24).int32(m.totalPages);
            if (m.totalRecords != null && Object.hasOwnProperty.call(m, "totalRecords"))
                w.uint32(32).int32(m.totalRecords);
            return w;
        };

        /**
         * Decodes a Pagination message from the specified reader or buffer.
         * @function decode
         * @memberof common.Pagination
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {common.Pagination} Pagination
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Pagination.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.common.Pagination();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.currentPage = r.int32();
                    break;
                case 2:
                    m.itemsPerPage = r.int32();
                    break;
                case 3:
                    m.totalPages = r.int32();
                    break;
                case 4:
                    m.totalRecords = r.int32();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return Pagination;
    })();

    common.PaginationRequest = (function() {

        /**
         * Properties of a PaginationRequest.
         * @memberof common
         * @interface IPaginationRequest
         * @property {number|null} [currentPage] PaginationRequest currentPage
         * @property {number|null} [itemsPerPage] PaginationRequest itemsPerPage
         */

        /**
         * Constructs a new PaginationRequest.
         * @memberof common
         * @classdesc Represents a PaginationRequest.
         * @implements IPaginationRequest
         * @constructor
         * @param {common.IPaginationRequest=} [p] Properties to set
         */
        function PaginationRequest(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * PaginationRequest currentPage.
         * @member {number} currentPage
         * @memberof common.PaginationRequest
         * @instance
         */
        PaginationRequest.prototype.currentPage = 0;

        /**
         * PaginationRequest itemsPerPage.
         * @member {number} itemsPerPage
         * @memberof common.PaginationRequest
         * @instance
         */
        PaginationRequest.prototype.itemsPerPage = 0;

        /**
         * Creates a new PaginationRequest instance using the specified properties.
         * @function create
         * @memberof common.PaginationRequest
         * @static
         * @param {common.IPaginationRequest=} [properties] Properties to set
         * @returns {common.PaginationRequest} PaginationRequest instance
         */
        PaginationRequest.create = function create(properties) {
            return new PaginationRequest(properties);
        };

        /**
         * Encodes the specified PaginationRequest message. Does not implicitly {@link common.PaginationRequest.verify|verify} messages.
         * @function encode
         * @memberof common.PaginationRequest
         * @static
         * @param {common.IPaginationRequest} m PaginationRequest message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PaginationRequest.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.currentPage != null && Object.hasOwnProperty.call(m, "currentPage"))
                w.uint32(8).uint32(m.currentPage);
            if (m.itemsPerPage != null && Object.hasOwnProperty.call(m, "itemsPerPage"))
                w.uint32(16).uint32(m.itemsPerPage);
            return w;
        };

        /**
         * Decodes a PaginationRequest message from the specified reader or buffer.
         * @function decode
         * @memberof common.PaginationRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {common.PaginationRequest} PaginationRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PaginationRequest.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.common.PaginationRequest();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.currentPage = r.uint32();
                    break;
                case 2:
                    m.itemsPerPage = r.uint32();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return PaginationRequest;
    })();

    /**
     * USStateAlphaCode enum.
     * @name common.USStateAlphaCode
     * @enum {number}
     * @property {number} UnknownState=0 UnknownState value
     * @property {number} AL=1 AL value
     * @property {number} AK=2 AK value
     * @property {number} AZ=3 AZ value
     * @property {number} AR=4 AR value
     * @property {number} CA=5 CA value
     * @property {number} CO=6 CO value
     * @property {number} CT=7 CT value
     * @property {number} DE=11 DE value
     * @property {number} DC=12 DC value
     * @property {number} FL=13 FL value
     * @property {number} GA=21 GA value
     * @property {number} HI=22 HI value
     * @property {number} ID=23 ID value
     * @property {number} IL=24 IL value
     * @property {number} IN=25 IN value
     * @property {number} IA=26 IA value
     * @property {number} KS=31 KS value
     * @property {number} KY=32 KY value
     * @property {number} LA=33 LA value
     * @property {number} ME=41 ME value
     * @property {number} MD=42 MD value
     * @property {number} MA=43 MA value
     * @property {number} MI=44 MI value
     * @property {number} MN=45 MN value
     * @property {number} MS=46 MS value
     * @property {number} MO=47 MO value
     * @property {number} MT=48 MT value
     * @property {number} NE=51 NE value
     * @property {number} NV=52 NV value
     * @property {number} NH=53 NH value
     * @property {number} NJ=54 NJ value
     * @property {number} NM=55 NM value
     * @property {number} NY=56 NY value
     * @property {number} NC=57 NC value
     * @property {number} ND=58 ND value
     * @property {number} OH=61 OH value
     * @property {number} OK=62 OK value
     * @property {number} OR=63 OR value
     * @property {number} PA=64 PA value
     * @property {number} RI=65 RI value
     * @property {number} SC=66 SC value
     * @property {number} SD=67 SD value
     * @property {number} TN=71 TN value
     * @property {number} TX=72 TX value
     * @property {number} UT=73 UT value
     * @property {number} VT=74 VT value
     * @property {number} VA=75 VA value
     * @property {number} WA=76 WA value
     * @property {number} WV=77 WV value
     * @property {number} WI=78 WI value
     * @property {number} WY=79 WY value
     */
    common.USStateAlphaCode = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "UnknownState"] = 0;
        values[valuesById[1] = "AL"] = 1;
        values[valuesById[2] = "AK"] = 2;
        values[valuesById[3] = "AZ"] = 3;
        values[valuesById[4] = "AR"] = 4;
        values[valuesById[5] = "CA"] = 5;
        values[valuesById[6] = "CO"] = 6;
        values[valuesById[7] = "CT"] = 7;
        values[valuesById[11] = "DE"] = 11;
        values[valuesById[12] = "DC"] = 12;
        values[valuesById[13] = "FL"] = 13;
        values[valuesById[21] = "GA"] = 21;
        values[valuesById[22] = "HI"] = 22;
        values[valuesById[23] = "ID"] = 23;
        values[valuesById[24] = "IL"] = 24;
        values[valuesById[25] = "IN"] = 25;
        values[valuesById[26] = "IA"] = 26;
        values[valuesById[31] = "KS"] = 31;
        values[valuesById[32] = "KY"] = 32;
        values[valuesById[33] = "LA"] = 33;
        values[valuesById[41] = "ME"] = 41;
        values[valuesById[42] = "MD"] = 42;
        values[valuesById[43] = "MA"] = 43;
        values[valuesById[44] = "MI"] = 44;
        values[valuesById[45] = "MN"] = 45;
        values[valuesById[46] = "MS"] = 46;
        values[valuesById[47] = "MO"] = 47;
        values[valuesById[48] = "MT"] = 48;
        values[valuesById[51] = "NE"] = 51;
        values[valuesById[52] = "NV"] = 52;
        values[valuesById[53] = "NH"] = 53;
        values[valuesById[54] = "NJ"] = 54;
        values[valuesById[55] = "NM"] = 55;
        values[valuesById[56] = "NY"] = 56;
        values[valuesById[57] = "NC"] = 57;
        values[valuesById[58] = "ND"] = 58;
        values[valuesById[61] = "OH"] = 61;
        values[valuesById[62] = "OK"] = 62;
        values[valuesById[63] = "OR"] = 63;
        values[valuesById[64] = "PA"] = 64;
        values[valuesById[65] = "RI"] = 65;
        values[valuesById[66] = "SC"] = 66;
        values[valuesById[67] = "SD"] = 67;
        values[valuesById[71] = "TN"] = 71;
        values[valuesById[72] = "TX"] = 72;
        values[valuesById[73] = "UT"] = 73;
        values[valuesById[74] = "VT"] = 74;
        values[valuesById[75] = "VA"] = 75;
        values[valuesById[76] = "WA"] = 76;
        values[valuesById[77] = "WV"] = 77;
        values[valuesById[78] = "WI"] = 78;
        values[valuesById[79] = "WY"] = 79;
        return values;
    })();

    common.AuditTrailEntry = (function() {

        /**
         * Properties of an AuditTrailEntry.
         * @memberof common
         * @interface IAuditTrailEntry
         * @property {google.protobuf.ITimestamp|null} [createdOn] AuditTrailEntry createdOn
         * @property {string|null} [createdBy] AuditTrailEntry createdBy
         * @property {Array.<common.AuditTrailEntry.IAuditTrailEntryDetail>|null} [details] AuditTrailEntry details
         */

        /**
         * Constructs a new AuditTrailEntry.
         * @memberof common
         * @classdesc Represents an AuditTrailEntry.
         * @implements IAuditTrailEntry
         * @constructor
         * @param {common.IAuditTrailEntry=} [p] Properties to set
         */
        function AuditTrailEntry(p) {
            this.details = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * AuditTrailEntry createdOn.
         * @member {google.protobuf.ITimestamp|null|undefined} createdOn
         * @memberof common.AuditTrailEntry
         * @instance
         */
        AuditTrailEntry.prototype.createdOn = null;

        /**
         * AuditTrailEntry createdBy.
         * @member {string} createdBy
         * @memberof common.AuditTrailEntry
         * @instance
         */
        AuditTrailEntry.prototype.createdBy = "";

        /**
         * AuditTrailEntry details.
         * @member {Array.<common.AuditTrailEntry.IAuditTrailEntryDetail>} details
         * @memberof common.AuditTrailEntry
         * @instance
         */
        AuditTrailEntry.prototype.details = $util.emptyArray;

        /**
         * Creates a new AuditTrailEntry instance using the specified properties.
         * @function create
         * @memberof common.AuditTrailEntry
         * @static
         * @param {common.IAuditTrailEntry=} [properties] Properties to set
         * @returns {common.AuditTrailEntry} AuditTrailEntry instance
         */
        AuditTrailEntry.create = function create(properties) {
            return new AuditTrailEntry(properties);
        };

        /**
         * Encodes the specified AuditTrailEntry message. Does not implicitly {@link common.AuditTrailEntry.verify|verify} messages.
         * @function encode
         * @memberof common.AuditTrailEntry
         * @static
         * @param {common.IAuditTrailEntry} m AuditTrailEntry message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AuditTrailEntry.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.createdOn != null && Object.hasOwnProperty.call(m, "createdOn"))
                $root.google.protobuf.Timestamp.encode(m.createdOn, w.uint32(10).fork()).ldelim();
            if (m.createdBy != null && Object.hasOwnProperty.call(m, "createdBy"))
                w.uint32(18).string(m.createdBy);
            if (m.details != null && m.details.length) {
                for (var i = 0; i < m.details.length; ++i)
                    $root.common.AuditTrailEntry.AuditTrailEntryDetail.encode(m.details[i], w.uint32(26).fork()).ldelim();
            }
            return w;
        };

        /**
         * Decodes an AuditTrailEntry message from the specified reader or buffer.
         * @function decode
         * @memberof common.AuditTrailEntry
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {common.AuditTrailEntry} AuditTrailEntry
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AuditTrailEntry.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.common.AuditTrailEntry();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.createdOn = $root.google.protobuf.Timestamp.decode(r, r.uint32());
                    break;
                case 2:
                    m.createdBy = r.string();
                    break;
                case 3:
                    if (!(m.details && m.details.length))
                        m.details = [];
                    m.details.push($root.common.AuditTrailEntry.AuditTrailEntryDetail.decode(r, r.uint32()));
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        AuditTrailEntry.AuditTrailEntryDetail = (function() {

            /**
             * Properties of an AuditTrailEntryDetail.
             * @memberof common.AuditTrailEntry
             * @interface IAuditTrailEntryDetail
             * @property {string|null} [type] AuditTrailEntryDetail type
             * @property {Object.<string,string>|null} [old] AuditTrailEntryDetail old
             * @property {Object.<string,string>|null} ["new"] AuditTrailEntryDetail new
             */

            /**
             * Constructs a new AuditTrailEntryDetail.
             * @memberof common.AuditTrailEntry
             * @classdesc Represents an AuditTrailEntryDetail.
             * @implements IAuditTrailEntryDetail
             * @constructor
             * @param {common.AuditTrailEntry.IAuditTrailEntryDetail=} [p] Properties to set
             */
            function AuditTrailEntryDetail(p) {
                this.old = {};
                this["new"] = {};
                if (p)
                    for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                        if (p[ks[i]] != null)
                            this[ks[i]] = p[ks[i]];
            }

            /**
             * AuditTrailEntryDetail type.
             * @member {string} type
             * @memberof common.AuditTrailEntry.AuditTrailEntryDetail
             * @instance
             */
            AuditTrailEntryDetail.prototype.type = "";

            /**
             * AuditTrailEntryDetail old.
             * @member {Object.<string,string>} old
             * @memberof common.AuditTrailEntry.AuditTrailEntryDetail
             * @instance
             */
            AuditTrailEntryDetail.prototype.old = $util.emptyObject;

            /**
             * AuditTrailEntryDetail new.
             * @member {Object.<string,string>} new
             * @memberof common.AuditTrailEntry.AuditTrailEntryDetail
             * @instance
             */
            AuditTrailEntryDetail.prototype["new"] = $util.emptyObject;

            /**
             * Creates a new AuditTrailEntryDetail instance using the specified properties.
             * @function create
             * @memberof common.AuditTrailEntry.AuditTrailEntryDetail
             * @static
             * @param {common.AuditTrailEntry.IAuditTrailEntryDetail=} [properties] Properties to set
             * @returns {common.AuditTrailEntry.AuditTrailEntryDetail} AuditTrailEntryDetail instance
             */
            AuditTrailEntryDetail.create = function create(properties) {
                return new AuditTrailEntryDetail(properties);
            };

            /**
             * Encodes the specified AuditTrailEntryDetail message. Does not implicitly {@link common.AuditTrailEntry.AuditTrailEntryDetail.verify|verify} messages.
             * @function encode
             * @memberof common.AuditTrailEntry.AuditTrailEntryDetail
             * @static
             * @param {common.AuditTrailEntry.IAuditTrailEntryDetail} m AuditTrailEntryDetail message or plain object to encode
             * @param {$protobuf.Writer} [w] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            AuditTrailEntryDetail.encode = function encode(m, w) {
                if (!w)
                    w = $Writer.create();
                if (m.type != null && Object.hasOwnProperty.call(m, "type"))
                    w.uint32(10).string(m.type);
                if (m.old != null && Object.hasOwnProperty.call(m, "old")) {
                    for (var ks = Object.keys(m.old), i = 0; i < ks.length; ++i) {
                        w.uint32(18).fork().uint32(10).string(ks[i]).uint32(18).string(m.old[ks[i]]).ldelim();
                    }
                }
                if (m["new"] != null && Object.hasOwnProperty.call(m, "new")) {
                    for (var ks = Object.keys(m["new"]), i = 0; i < ks.length; ++i) {
                        w.uint32(26).fork().uint32(10).string(ks[i]).uint32(18).string(m["new"][ks[i]]).ldelim();
                    }
                }
                return w;
            };

            /**
             * Decodes an AuditTrailEntryDetail message from the specified reader or buffer.
             * @function decode
             * @memberof common.AuditTrailEntry.AuditTrailEntryDetail
             * @static
             * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
             * @param {number} [l] Message length if known beforehand
             * @returns {common.AuditTrailEntry.AuditTrailEntryDetail} AuditTrailEntryDetail
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            AuditTrailEntryDetail.decode = function decode(r, l) {
                if (!(r instanceof $Reader))
                    r = $Reader.create(r);
                var c = l === undefined ? r.len : r.pos + l, m = new $root.common.AuditTrailEntry.AuditTrailEntryDetail(), k, value;
                while (r.pos < c) {
                    var t = r.uint32();
                    switch (t >>> 3) {
                    case 1:
                        m.type = r.string();
                        break;
                    case 2:
                        if (m.old === $util.emptyObject)
                            m.old = {};
                        var c2 = r.uint32() + r.pos;
                        k = "";
                        value = "";
                        while (r.pos < c2) {
                            var tag2 = r.uint32();
                            switch (tag2 >>> 3) {
                            case 1:
                                k = r.string();
                                break;
                            case 2:
                                value = r.string();
                                break;
                            default:
                                r.skipType(tag2 & 7);
                                break;
                            }
                        }
                        m.old[k] = value;
                        break;
                    case 3:
                        if (m["new"] === $util.emptyObject)
                            m["new"] = {};
                        var c2 = r.uint32() + r.pos;
                        k = "";
                        value = "";
                        while (r.pos < c2) {
                            var tag2 = r.uint32();
                            switch (tag2 >>> 3) {
                            case 1:
                                k = r.string();
                                break;
                            case 2:
                                value = r.string();
                                break;
                            default:
                                r.skipType(tag2 & 7);
                                break;
                            }
                        }
                        m["new"][k] = value;
                        break;
                    default:
                        r.skipType(t & 7);
                        break;
                    }
                }
                return m;
            };

            return AuditTrailEntryDetail;
        })();

        return AuditTrailEntry;
    })();

    return common;
})();

export const payment3_commonpb = $root.payment3_commonpb = (() => {

    /**
     * Namespace payment3_commonpb.
     * @exports payment3_commonpb
     * @namespace
     */
    const payment3_commonpb = {};

    /**
     * PaymentProcessor enum.
     * @name payment3_commonpb.PaymentProcessor
     * @enum {number}
     * @property {number} Undefined_PaymentProcessor=0 Undefined_PaymentProcessor value
     * @property {number} Stripe=1 Stripe value
     * @property {number} Paymentus=2 Paymentus value
     * @property {number} Braintree=3 Braintree value
     * @property {number} JDECheck=4 JDECheck value
     * @property {number} JDEACH=5 JDEACH value
     * @property {number} PayPal=6 PayPal value
     * @property {number} JPMC=7 JPMC value
     */
    payment3_commonpb.PaymentProcessor = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "Undefined_PaymentProcessor"] = 0;
        values[valuesById[1] = "Stripe"] = 1;
        values[valuesById[2] = "Paymentus"] = 2;
        values[valuesById[3] = "Braintree"] = 3;
        values[valuesById[4] = "JDECheck"] = 4;
        values[valuesById[5] = "JDEACH"] = 5;
        values[valuesById[6] = "PayPal"] = 6;
        values[valuesById[7] = "JPMC"] = 7;
        return values;
    })();

    /**
     * Brand enum.
     * @name payment3_commonpb.Brand
     * @enum {number}
     * @property {number} Undefined_Brand=0 Undefined_Brand value
     * @property {number} HSA=1 HSA value
     * @property {number} AHS=2 AHS value
     * @property {number} HomeServicePlan=4 HomeServicePlan value
     * @property {number} FTDR=5 FTDR value
     * @property {number} HBW210=6 HBW210 value
     * @property {number} Unknown=7 Unknown value
     * @property {number} FrontdoorPro=8 FrontdoorPro value
     */
    payment3_commonpb.Brand = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "Undefined_Brand"] = 0;
        values[valuesById[1] = "HSA"] = 1;
        values[valuesById[2] = "AHS"] = 2;
        values[valuesById[4] = "HomeServicePlan"] = 4;
        values[valuesById[5] = "FTDR"] = 5;
        values[valuesById[6] = "HBW210"] = 6;
        values[valuesById[7] = "Unknown"] = 7;
        values[valuesById[8] = "FrontdoorPro"] = 8;
        return values;
    })();

    /**
     * Subbrand enum.
     * @name payment3_commonpb.Subbrand
     * @enum {number}
     * @property {number} Undefined_SubBrand=0 Undefined_SubBrand value
     * @property {number} HBW210NewHome=1 HBW210NewHome value
     * @property {number} HBW210Resale=2 HBW210Resale value
     * @property {number} HBW210Insurance=3 HBW210Insurance value
     */
    payment3_commonpb.Subbrand = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "Undefined_SubBrand"] = 0;
        values[valuesById[1] = "HBW210NewHome"] = 1;
        values[valuesById[2] = "HBW210Resale"] = 2;
        values[valuesById[3] = "HBW210Insurance"] = 3;
        return values;
    })();

    payment3_commonpb.DatabaseRecord = (function() {

        /**
         * Properties of a DatabaseRecord.
         * @memberof payment3_commonpb
         * @interface IDatabaseRecord
         * @property {google.protobuf.ITimestamp|null} [deletedAt] DatabaseRecord deletedAt
         * @property {google.protobuf.ITimestamp|null} [createdAt] DatabaseRecord createdAt
         * @property {google.protobuf.ITimestamp|null} [updatedAt] DatabaseRecord updatedAt
         */

        /**
         * Constructs a new DatabaseRecord.
         * @memberof payment3_commonpb
         * @classdesc Represents a DatabaseRecord.
         * @implements IDatabaseRecord
         * @constructor
         * @param {payment3_commonpb.IDatabaseRecord=} [p] Properties to set
         */
        function DatabaseRecord(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * DatabaseRecord deletedAt.
         * @member {google.protobuf.ITimestamp|null|undefined} deletedAt
         * @memberof payment3_commonpb.DatabaseRecord
         * @instance
         */
        DatabaseRecord.prototype.deletedAt = null;

        /**
         * DatabaseRecord createdAt.
         * @member {google.protobuf.ITimestamp|null|undefined} createdAt
         * @memberof payment3_commonpb.DatabaseRecord
         * @instance
         */
        DatabaseRecord.prototype.createdAt = null;

        /**
         * DatabaseRecord updatedAt.
         * @member {google.protobuf.ITimestamp|null|undefined} updatedAt
         * @memberof payment3_commonpb.DatabaseRecord
         * @instance
         */
        DatabaseRecord.prototype.updatedAt = null;

        /**
         * Creates a new DatabaseRecord instance using the specified properties.
         * @function create
         * @memberof payment3_commonpb.DatabaseRecord
         * @static
         * @param {payment3_commonpb.IDatabaseRecord=} [properties] Properties to set
         * @returns {payment3_commonpb.DatabaseRecord} DatabaseRecord instance
         */
        DatabaseRecord.create = function create(properties) {
            return new DatabaseRecord(properties);
        };

        /**
         * Encodes the specified DatabaseRecord message. Does not implicitly {@link payment3_commonpb.DatabaseRecord.verify|verify} messages.
         * @function encode
         * @memberof payment3_commonpb.DatabaseRecord
         * @static
         * @param {payment3_commonpb.IDatabaseRecord} m DatabaseRecord message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        DatabaseRecord.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.deletedAt != null && Object.hasOwnProperty.call(m, "deletedAt"))
                $root.google.protobuf.Timestamp.encode(m.deletedAt, w.uint32(10).fork()).ldelim();
            if (m.createdAt != null && Object.hasOwnProperty.call(m, "createdAt"))
                $root.google.protobuf.Timestamp.encode(m.createdAt, w.uint32(18).fork()).ldelim();
            if (m.updatedAt != null && Object.hasOwnProperty.call(m, "updatedAt"))
                $root.google.protobuf.Timestamp.encode(m.updatedAt, w.uint32(26).fork()).ldelim();
            return w;
        };

        /**
         * Decodes a DatabaseRecord message from the specified reader or buffer.
         * @function decode
         * @memberof payment3_commonpb.DatabaseRecord
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {payment3_commonpb.DatabaseRecord} DatabaseRecord
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        DatabaseRecord.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.payment3_commonpb.DatabaseRecord();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.deletedAt = $root.google.protobuf.Timestamp.decode(r, r.uint32());
                    break;
                case 2:
                    m.createdAt = $root.google.protobuf.Timestamp.decode(r, r.uint32());
                    break;
                case 3:
                    m.updatedAt = $root.google.protobuf.Timestamp.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return DatabaseRecord;
    })();

    return payment3_commonpb;
})();

export const payment3_paymentmethodpb = $root.payment3_paymentmethodpb = (() => {

    /**
     * Namespace payment3_paymentmethodpb.
     * @exports payment3_paymentmethodpb
     * @namespace
     */
    const payment3_paymentmethodpb = {};

    payment3_paymentmethodpb.CreateUpdatePaymentMethodRequest = (function() {

        /**
         * Properties of a CreateUpdatePaymentMethodRequest.
         * @memberof payment3_paymentmethodpb
         * @interface ICreateUpdatePaymentMethodRequest
         * @property {payment3_paymentmethodpb.IPaymentMethod|null} [paymentMethod] CreateUpdatePaymentMethodRequest paymentMethod
         */

        /**
         * Constructs a new CreateUpdatePaymentMethodRequest.
         * @memberof payment3_paymentmethodpb
         * @classdesc Represents a CreateUpdatePaymentMethodRequest.
         * @implements ICreateUpdatePaymentMethodRequest
         * @constructor
         * @param {payment3_paymentmethodpb.ICreateUpdatePaymentMethodRequest=} [p] Properties to set
         */
        function CreateUpdatePaymentMethodRequest(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * CreateUpdatePaymentMethodRequest paymentMethod.
         * @member {payment3_paymentmethodpb.IPaymentMethod|null|undefined} paymentMethod
         * @memberof payment3_paymentmethodpb.CreateUpdatePaymentMethodRequest
         * @instance
         */
        CreateUpdatePaymentMethodRequest.prototype.paymentMethod = null;

        /**
         * Creates a new CreateUpdatePaymentMethodRequest instance using the specified properties.
         * @function create
         * @memberof payment3_paymentmethodpb.CreateUpdatePaymentMethodRequest
         * @static
         * @param {payment3_paymentmethodpb.ICreateUpdatePaymentMethodRequest=} [properties] Properties to set
         * @returns {payment3_paymentmethodpb.CreateUpdatePaymentMethodRequest} CreateUpdatePaymentMethodRequest instance
         */
        CreateUpdatePaymentMethodRequest.create = function create(properties) {
            return new CreateUpdatePaymentMethodRequest(properties);
        };

        /**
         * Encodes the specified CreateUpdatePaymentMethodRequest message. Does not implicitly {@link payment3_paymentmethodpb.CreateUpdatePaymentMethodRequest.verify|verify} messages.
         * @function encode
         * @memberof payment3_paymentmethodpb.CreateUpdatePaymentMethodRequest
         * @static
         * @param {payment3_paymentmethodpb.ICreateUpdatePaymentMethodRequest} m CreateUpdatePaymentMethodRequest message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CreateUpdatePaymentMethodRequest.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.paymentMethod != null && Object.hasOwnProperty.call(m, "paymentMethod"))
                $root.payment3_paymentmethodpb.PaymentMethod.encode(m.paymentMethod, w.uint32(10).fork()).ldelim();
            return w;
        };

        /**
         * Decodes a CreateUpdatePaymentMethodRequest message from the specified reader or buffer.
         * @function decode
         * @memberof payment3_paymentmethodpb.CreateUpdatePaymentMethodRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {payment3_paymentmethodpb.CreateUpdatePaymentMethodRequest} CreateUpdatePaymentMethodRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CreateUpdatePaymentMethodRequest.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.payment3_paymentmethodpb.CreateUpdatePaymentMethodRequest();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.paymentMethod = $root.payment3_paymentmethodpb.PaymentMethod.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return CreateUpdatePaymentMethodRequest;
    })();

    payment3_paymentmethodpb.CreatePaymentMethodResponse = (function() {

        /**
         * Properties of a CreatePaymentMethodResponse.
         * @memberof payment3_paymentmethodpb
         * @interface ICreatePaymentMethodResponse
         * @property {string|null} [paymentMethodID] CreatePaymentMethodResponse paymentMethodID
         */

        /**
         * Constructs a new CreatePaymentMethodResponse.
         * @memberof payment3_paymentmethodpb
         * @classdesc Represents a CreatePaymentMethodResponse.
         * @implements ICreatePaymentMethodResponse
         * @constructor
         * @param {payment3_paymentmethodpb.ICreatePaymentMethodResponse=} [p] Properties to set
         */
        function CreatePaymentMethodResponse(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * CreatePaymentMethodResponse paymentMethodID.
         * @member {string} paymentMethodID
         * @memberof payment3_paymentmethodpb.CreatePaymentMethodResponse
         * @instance
         */
        CreatePaymentMethodResponse.prototype.paymentMethodID = "";

        /**
         * Creates a new CreatePaymentMethodResponse instance using the specified properties.
         * @function create
         * @memberof payment3_paymentmethodpb.CreatePaymentMethodResponse
         * @static
         * @param {payment3_paymentmethodpb.ICreatePaymentMethodResponse=} [properties] Properties to set
         * @returns {payment3_paymentmethodpb.CreatePaymentMethodResponse} CreatePaymentMethodResponse instance
         */
        CreatePaymentMethodResponse.create = function create(properties) {
            return new CreatePaymentMethodResponse(properties);
        };

        /**
         * Encodes the specified CreatePaymentMethodResponse message. Does not implicitly {@link payment3_paymentmethodpb.CreatePaymentMethodResponse.verify|verify} messages.
         * @function encode
         * @memberof payment3_paymentmethodpb.CreatePaymentMethodResponse
         * @static
         * @param {payment3_paymentmethodpb.ICreatePaymentMethodResponse} m CreatePaymentMethodResponse message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CreatePaymentMethodResponse.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.paymentMethodID != null && Object.hasOwnProperty.call(m, "paymentMethodID"))
                w.uint32(10).string(m.paymentMethodID);
            return w;
        };

        /**
         * Decodes a CreatePaymentMethodResponse message from the specified reader or buffer.
         * @function decode
         * @memberof payment3_paymentmethodpb.CreatePaymentMethodResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {payment3_paymentmethodpb.CreatePaymentMethodResponse} CreatePaymentMethodResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CreatePaymentMethodResponse.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.payment3_paymentmethodpb.CreatePaymentMethodResponse();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.paymentMethodID = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return CreatePaymentMethodResponse;
    })();

    payment3_paymentmethodpb.GetPaymentMethodResponse = (function() {

        /**
         * Properties of a GetPaymentMethodResponse.
         * @memberof payment3_paymentmethodpb
         * @interface IGetPaymentMethodResponse
         * @property {payment3_paymentmethodpb.IPaymentMethod|null} [paymentMethod] GetPaymentMethodResponse paymentMethod
         */

        /**
         * Constructs a new GetPaymentMethodResponse.
         * @memberof payment3_paymentmethodpb
         * @classdesc Represents a GetPaymentMethodResponse.
         * @implements IGetPaymentMethodResponse
         * @constructor
         * @param {payment3_paymentmethodpb.IGetPaymentMethodResponse=} [p] Properties to set
         */
        function GetPaymentMethodResponse(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * GetPaymentMethodResponse paymentMethod.
         * @member {payment3_paymentmethodpb.IPaymentMethod|null|undefined} paymentMethod
         * @memberof payment3_paymentmethodpb.GetPaymentMethodResponse
         * @instance
         */
        GetPaymentMethodResponse.prototype.paymentMethod = null;

        /**
         * Creates a new GetPaymentMethodResponse instance using the specified properties.
         * @function create
         * @memberof payment3_paymentmethodpb.GetPaymentMethodResponse
         * @static
         * @param {payment3_paymentmethodpb.IGetPaymentMethodResponse=} [properties] Properties to set
         * @returns {payment3_paymentmethodpb.GetPaymentMethodResponse} GetPaymentMethodResponse instance
         */
        GetPaymentMethodResponse.create = function create(properties) {
            return new GetPaymentMethodResponse(properties);
        };

        /**
         * Encodes the specified GetPaymentMethodResponse message. Does not implicitly {@link payment3_paymentmethodpb.GetPaymentMethodResponse.verify|verify} messages.
         * @function encode
         * @memberof payment3_paymentmethodpb.GetPaymentMethodResponse
         * @static
         * @param {payment3_paymentmethodpb.IGetPaymentMethodResponse} m GetPaymentMethodResponse message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetPaymentMethodResponse.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.paymentMethod != null && Object.hasOwnProperty.call(m, "paymentMethod"))
                $root.payment3_paymentmethodpb.PaymentMethod.encode(m.paymentMethod, w.uint32(10).fork()).ldelim();
            return w;
        };

        /**
         * Decodes a GetPaymentMethodResponse message from the specified reader or buffer.
         * @function decode
         * @memberof payment3_paymentmethodpb.GetPaymentMethodResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {payment3_paymentmethodpb.GetPaymentMethodResponse} GetPaymentMethodResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetPaymentMethodResponse.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.payment3_paymentmethodpb.GetPaymentMethodResponse();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.paymentMethod = $root.payment3_paymentmethodpb.PaymentMethod.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return GetPaymentMethodResponse;
    })();

    payment3_paymentmethodpb.UndeletePaymentMethodRequest = (function() {

        /**
         * Properties of an UndeletePaymentMethodRequest.
         * @memberof payment3_paymentmethodpb
         * @interface IUndeletePaymentMethodRequest
         * @property {Array.<string>|null} [paymentMethodID] UndeletePaymentMethodRequest paymentMethodID
         */

        /**
         * Constructs a new UndeletePaymentMethodRequest.
         * @memberof payment3_paymentmethodpb
         * @classdesc Represents an UndeletePaymentMethodRequest.
         * @implements IUndeletePaymentMethodRequest
         * @constructor
         * @param {payment3_paymentmethodpb.IUndeletePaymentMethodRequest=} [p] Properties to set
         */
        function UndeletePaymentMethodRequest(p) {
            this.paymentMethodID = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * UndeletePaymentMethodRequest paymentMethodID.
         * @member {Array.<string>} paymentMethodID
         * @memberof payment3_paymentmethodpb.UndeletePaymentMethodRequest
         * @instance
         */
        UndeletePaymentMethodRequest.prototype.paymentMethodID = $util.emptyArray;

        /**
         * Creates a new UndeletePaymentMethodRequest instance using the specified properties.
         * @function create
         * @memberof payment3_paymentmethodpb.UndeletePaymentMethodRequest
         * @static
         * @param {payment3_paymentmethodpb.IUndeletePaymentMethodRequest=} [properties] Properties to set
         * @returns {payment3_paymentmethodpb.UndeletePaymentMethodRequest} UndeletePaymentMethodRequest instance
         */
        UndeletePaymentMethodRequest.create = function create(properties) {
            return new UndeletePaymentMethodRequest(properties);
        };

        /**
         * Encodes the specified UndeletePaymentMethodRequest message. Does not implicitly {@link payment3_paymentmethodpb.UndeletePaymentMethodRequest.verify|verify} messages.
         * @function encode
         * @memberof payment3_paymentmethodpb.UndeletePaymentMethodRequest
         * @static
         * @param {payment3_paymentmethodpb.IUndeletePaymentMethodRequest} m UndeletePaymentMethodRequest message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UndeletePaymentMethodRequest.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.paymentMethodID != null && m.paymentMethodID.length) {
                for (var i = 0; i < m.paymentMethodID.length; ++i)
                    w.uint32(10).string(m.paymentMethodID[i]);
            }
            return w;
        };

        /**
         * Decodes an UndeletePaymentMethodRequest message from the specified reader or buffer.
         * @function decode
         * @memberof payment3_paymentmethodpb.UndeletePaymentMethodRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {payment3_paymentmethodpb.UndeletePaymentMethodRequest} UndeletePaymentMethodRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UndeletePaymentMethodRequest.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.payment3_paymentmethodpb.UndeletePaymentMethodRequest();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    if (!(m.paymentMethodID && m.paymentMethodID.length))
                        m.paymentMethodID = [];
                    m.paymentMethodID.push(r.string());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return UndeletePaymentMethodRequest;
    })();

    payment3_paymentmethodpb.PaymentMethod = (function() {

        /**
         * Properties of a PaymentMethod.
         * @memberof payment3_paymentmethodpb
         * @interface IPaymentMethod
         * @property {string|null} [paymentMethodID] PaymentMethod paymentMethodID
         * @property {boolean|null} [includedInWallet] PaymentMethod includedInWallet
         * @property {payment3_commonpb.Brand|null} [brand] PaymentMethod brand
         * @property {payment3_commonpb.Subbrand|null} [subbrand] PaymentMethod subbrand
         * @property {payment3_paymentmethodpb.IPaymentMethodDetails|null} [details] PaymentMethod details
         * @property {payment3_paymentmethodpb.IProcessorPaymentMethod|null} [processor] PaymentMethod processor
         * @property {payment3_paymentmethodpb.IOwner|null} [owner] PaymentMethod owner
         * @property {payment3_paymentmethodpb.IDisbursementDetails|null} [disbursementDetails] PaymentMethod disbursementDetails
         * @property {common.IApplicationSource|null} [source] PaymentMethod source
         * @property {payment3_commonpb.IDatabaseRecord|null} [db] PaymentMethod db
         */

        /**
         * Constructs a new PaymentMethod.
         * @memberof payment3_paymentmethodpb
         * @classdesc Represents a PaymentMethod.
         * @implements IPaymentMethod
         * @constructor
         * @param {payment3_paymentmethodpb.IPaymentMethod=} [p] Properties to set
         */
        function PaymentMethod(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * PaymentMethod paymentMethodID.
         * @member {string} paymentMethodID
         * @memberof payment3_paymentmethodpb.PaymentMethod
         * @instance
         */
        PaymentMethod.prototype.paymentMethodID = "";

        /**
         * PaymentMethod includedInWallet.
         * @member {boolean} includedInWallet
         * @memberof payment3_paymentmethodpb.PaymentMethod
         * @instance
         */
        PaymentMethod.prototype.includedInWallet = false;

        /**
         * PaymentMethod brand.
         * @member {payment3_commonpb.Brand} brand
         * @memberof payment3_paymentmethodpb.PaymentMethod
         * @instance
         */
        PaymentMethod.prototype.brand = 0;

        /**
         * PaymentMethod subbrand.
         * @member {payment3_commonpb.Subbrand} subbrand
         * @memberof payment3_paymentmethodpb.PaymentMethod
         * @instance
         */
        PaymentMethod.prototype.subbrand = 0;

        /**
         * PaymentMethod details.
         * @member {payment3_paymentmethodpb.IPaymentMethodDetails|null|undefined} details
         * @memberof payment3_paymentmethodpb.PaymentMethod
         * @instance
         */
        PaymentMethod.prototype.details = null;

        /**
         * PaymentMethod processor.
         * @member {payment3_paymentmethodpb.IProcessorPaymentMethod|null|undefined} processor
         * @memberof payment3_paymentmethodpb.PaymentMethod
         * @instance
         */
        PaymentMethod.prototype.processor = null;

        /**
         * PaymentMethod owner.
         * @member {payment3_paymentmethodpb.IOwner|null|undefined} owner
         * @memberof payment3_paymentmethodpb.PaymentMethod
         * @instance
         */
        PaymentMethod.prototype.owner = null;

        /**
         * PaymentMethod disbursementDetails.
         * @member {payment3_paymentmethodpb.IDisbursementDetails|null|undefined} disbursementDetails
         * @memberof payment3_paymentmethodpb.PaymentMethod
         * @instance
         */
        PaymentMethod.prototype.disbursementDetails = null;

        /**
         * PaymentMethod source.
         * @member {common.IApplicationSource|null|undefined} source
         * @memberof payment3_paymentmethodpb.PaymentMethod
         * @instance
         */
        PaymentMethod.prototype.source = null;

        /**
         * PaymentMethod db.
         * @member {payment3_commonpb.IDatabaseRecord|null|undefined} db
         * @memberof payment3_paymentmethodpb.PaymentMethod
         * @instance
         */
        PaymentMethod.prototype.db = null;

        /**
         * Creates a new PaymentMethod instance using the specified properties.
         * @function create
         * @memberof payment3_paymentmethodpb.PaymentMethod
         * @static
         * @param {payment3_paymentmethodpb.IPaymentMethod=} [properties] Properties to set
         * @returns {payment3_paymentmethodpb.PaymentMethod} PaymentMethod instance
         */
        PaymentMethod.create = function create(properties) {
            return new PaymentMethod(properties);
        };

        /**
         * Encodes the specified PaymentMethod message. Does not implicitly {@link payment3_paymentmethodpb.PaymentMethod.verify|verify} messages.
         * @function encode
         * @memberof payment3_paymentmethodpb.PaymentMethod
         * @static
         * @param {payment3_paymentmethodpb.IPaymentMethod} m PaymentMethod message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PaymentMethod.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.paymentMethodID != null && Object.hasOwnProperty.call(m, "paymentMethodID"))
                w.uint32(82).string(m.paymentMethodID);
            if (m.includedInWallet != null && Object.hasOwnProperty.call(m, "includedInWallet"))
                w.uint32(160).bool(m.includedInWallet);
            if (m.brand != null && Object.hasOwnProperty.call(m, "brand"))
                w.uint32(240).int32(m.brand);
            if (m.subbrand != null && Object.hasOwnProperty.call(m, "subbrand"))
                w.uint32(320).int32(m.subbrand);
            if (m.details != null && Object.hasOwnProperty.call(m, "details"))
                $root.payment3_paymentmethodpb.PaymentMethodDetails.encode(m.details, w.uint32(802).fork()).ldelim();
            if (m.processor != null && Object.hasOwnProperty.call(m, "processor"))
                $root.payment3_paymentmethodpb.ProcessorPaymentMethod.encode(m.processor, w.uint32(1602).fork()).ldelim();
            if (m.owner != null && Object.hasOwnProperty.call(m, "owner"))
                $root.payment3_paymentmethodpb.Owner.encode(m.owner, w.uint32(2402).fork()).ldelim();
            if (m.disbursementDetails != null && Object.hasOwnProperty.call(m, "disbursementDetails"))
                $root.payment3_paymentmethodpb.DisbursementDetails.encode(m.disbursementDetails, w.uint32(3202).fork()).ldelim();
            if (m.source != null && Object.hasOwnProperty.call(m, "source"))
                $root.common.ApplicationSource.encode(m.source, w.uint32(6402).fork()).ldelim();
            if (m.db != null && Object.hasOwnProperty.call(m, "db"))
                $root.payment3_commonpb.DatabaseRecord.encode(m.db, w.uint32(7202).fork()).ldelim();
            return w;
        };

        /**
         * Decodes a PaymentMethod message from the specified reader or buffer.
         * @function decode
         * @memberof payment3_paymentmethodpb.PaymentMethod
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {payment3_paymentmethodpb.PaymentMethod} PaymentMethod
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PaymentMethod.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.payment3_paymentmethodpb.PaymentMethod();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 10:
                    m.paymentMethodID = r.string();
                    break;
                case 20:
                    m.includedInWallet = r.bool();
                    break;
                case 30:
                    m.brand = r.int32();
                    break;
                case 40:
                    m.subbrand = r.int32();
                    break;
                case 100:
                    m.details = $root.payment3_paymentmethodpb.PaymentMethodDetails.decode(r, r.uint32());
                    break;
                case 200:
                    m.processor = $root.payment3_paymentmethodpb.ProcessorPaymentMethod.decode(r, r.uint32());
                    break;
                case 300:
                    m.owner = $root.payment3_paymentmethodpb.Owner.decode(r, r.uint32());
                    break;
                case 400:
                    m.disbursementDetails = $root.payment3_paymentmethodpb.DisbursementDetails.decode(r, r.uint32());
                    break;
                case 800:
                    m.source = $root.common.ApplicationSource.decode(r, r.uint32());
                    break;
                case 900:
                    m.db = $root.payment3_commonpb.DatabaseRecord.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return PaymentMethod;
    })();

    payment3_paymentmethodpb.DisbursementDetails = (function() {

        /**
         * Properties of a DisbursementDetails.
         * @memberof payment3_paymentmethodpb
         * @interface IDisbursementDetails
         * @property {payment3_paymentmethodpb.ICustomerDetails|null} [customer] DisbursementDetails customer
         * @property {payment3_paymentmethodpb.IAddressDetails|null} [address] DisbursementDetails address
         * @property {string|null} [CustomerID] DisbursementDetails CustomerID
         * @property {string|null} [AddressID] DisbursementDetails AddressID
         */

        /**
         * Constructs a new DisbursementDetails.
         * @memberof payment3_paymentmethodpb
         * @classdesc Represents a DisbursementDetails.
         * @implements IDisbursementDetails
         * @constructor
         * @param {payment3_paymentmethodpb.IDisbursementDetails=} [p] Properties to set
         */
        function DisbursementDetails(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * DisbursementDetails customer.
         * @member {payment3_paymentmethodpb.ICustomerDetails|null|undefined} customer
         * @memberof payment3_paymentmethodpb.DisbursementDetails
         * @instance
         */
        DisbursementDetails.prototype.customer = null;

        /**
         * DisbursementDetails address.
         * @member {payment3_paymentmethodpb.IAddressDetails|null|undefined} address
         * @memberof payment3_paymentmethodpb.DisbursementDetails
         * @instance
         */
        DisbursementDetails.prototype.address = null;

        /**
         * DisbursementDetails CustomerID.
         * @member {string} CustomerID
         * @memberof payment3_paymentmethodpb.DisbursementDetails
         * @instance
         */
        DisbursementDetails.prototype.CustomerID = "";

        /**
         * DisbursementDetails AddressID.
         * @member {string} AddressID
         * @memberof payment3_paymentmethodpb.DisbursementDetails
         * @instance
         */
        DisbursementDetails.prototype.AddressID = "";

        /**
         * Creates a new DisbursementDetails instance using the specified properties.
         * @function create
         * @memberof payment3_paymentmethodpb.DisbursementDetails
         * @static
         * @param {payment3_paymentmethodpb.IDisbursementDetails=} [properties] Properties to set
         * @returns {payment3_paymentmethodpb.DisbursementDetails} DisbursementDetails instance
         */
        DisbursementDetails.create = function create(properties) {
            return new DisbursementDetails(properties);
        };

        /**
         * Encodes the specified DisbursementDetails message. Does not implicitly {@link payment3_paymentmethodpb.DisbursementDetails.verify|verify} messages.
         * @function encode
         * @memberof payment3_paymentmethodpb.DisbursementDetails
         * @static
         * @param {payment3_paymentmethodpb.IDisbursementDetails} m DisbursementDetails message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        DisbursementDetails.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.CustomerID != null && Object.hasOwnProperty.call(m, "CustomerID"))
                w.uint32(82).string(m.CustomerID);
            if (m.AddressID != null && Object.hasOwnProperty.call(m, "AddressID"))
                w.uint32(162).string(m.AddressID);
            if (m.customer != null && Object.hasOwnProperty.call(m, "customer"))
                $root.payment3_paymentmethodpb.CustomerDetails.encode(m.customer, w.uint32(802).fork()).ldelim();
            if (m.address != null && Object.hasOwnProperty.call(m, "address"))
                $root.payment3_paymentmethodpb.AddressDetails.encode(m.address, w.uint32(1602).fork()).ldelim();
            return w;
        };

        /**
         * Decodes a DisbursementDetails message from the specified reader or buffer.
         * @function decode
         * @memberof payment3_paymentmethodpb.DisbursementDetails
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {payment3_paymentmethodpb.DisbursementDetails} DisbursementDetails
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        DisbursementDetails.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.payment3_paymentmethodpb.DisbursementDetails();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 100:
                    m.customer = $root.payment3_paymentmethodpb.CustomerDetails.decode(r, r.uint32());
                    break;
                case 200:
                    m.address = $root.payment3_paymentmethodpb.AddressDetails.decode(r, r.uint32());
                    break;
                case 10:
                    m.CustomerID = r.string();
                    break;
                case 20:
                    m.AddressID = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return DisbursementDetails;
    })();

    payment3_paymentmethodpb.CustomerDetails = (function() {

        /**
         * Properties of a CustomerDetails.
         * @memberof payment3_paymentmethodpb
         * @interface ICustomerDetails
         * @property {string|null} [customerID] CustomerDetails customerID
         * @property {string|null} [fullName] CustomerDetails fullName
         * @property {string|null} [firstName] CustomerDetails firstName
         * @property {string|null} [middleName] CustomerDetails middleName
         * @property {string|null} [lastName] CustomerDetails lastName
         * @property {string|null} [customerType] CustomerDetails customerType
         * @property {string|null} [email] CustomerDetails email
         */

        /**
         * Constructs a new CustomerDetails.
         * @memberof payment3_paymentmethodpb
         * @classdesc Represents a CustomerDetails.
         * @implements ICustomerDetails
         * @constructor
         * @param {payment3_paymentmethodpb.ICustomerDetails=} [p] Properties to set
         */
        function CustomerDetails(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * CustomerDetails customerID.
         * @member {string} customerID
         * @memberof payment3_paymentmethodpb.CustomerDetails
         * @instance
         */
        CustomerDetails.prototype.customerID = "";

        /**
         * CustomerDetails fullName.
         * @member {string} fullName
         * @memberof payment3_paymentmethodpb.CustomerDetails
         * @instance
         */
        CustomerDetails.prototype.fullName = "";

        /**
         * CustomerDetails firstName.
         * @member {string} firstName
         * @memberof payment3_paymentmethodpb.CustomerDetails
         * @instance
         */
        CustomerDetails.prototype.firstName = "";

        /**
         * CustomerDetails middleName.
         * @member {string} middleName
         * @memberof payment3_paymentmethodpb.CustomerDetails
         * @instance
         */
        CustomerDetails.prototype.middleName = "";

        /**
         * CustomerDetails lastName.
         * @member {string} lastName
         * @memberof payment3_paymentmethodpb.CustomerDetails
         * @instance
         */
        CustomerDetails.prototype.lastName = "";

        /**
         * CustomerDetails customerType.
         * @member {string} customerType
         * @memberof payment3_paymentmethodpb.CustomerDetails
         * @instance
         */
        CustomerDetails.prototype.customerType = "";

        /**
         * CustomerDetails email.
         * @member {string} email
         * @memberof payment3_paymentmethodpb.CustomerDetails
         * @instance
         */
        CustomerDetails.prototype.email = "";

        /**
         * Creates a new CustomerDetails instance using the specified properties.
         * @function create
         * @memberof payment3_paymentmethodpb.CustomerDetails
         * @static
         * @param {payment3_paymentmethodpb.ICustomerDetails=} [properties] Properties to set
         * @returns {payment3_paymentmethodpb.CustomerDetails} CustomerDetails instance
         */
        CustomerDetails.create = function create(properties) {
            return new CustomerDetails(properties);
        };

        /**
         * Encodes the specified CustomerDetails message. Does not implicitly {@link payment3_paymentmethodpb.CustomerDetails.verify|verify} messages.
         * @function encode
         * @memberof payment3_paymentmethodpb.CustomerDetails
         * @static
         * @param {payment3_paymentmethodpb.ICustomerDetails} m CustomerDetails message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CustomerDetails.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.customerID != null && Object.hasOwnProperty.call(m, "customerID"))
                w.uint32(82).string(m.customerID);
            if (m.fullName != null && Object.hasOwnProperty.call(m, "fullName"))
                w.uint32(90).string(m.fullName);
            if (m.firstName != null && Object.hasOwnProperty.call(m, "firstName"))
                w.uint32(98).string(m.firstName);
            if (m.middleName != null && Object.hasOwnProperty.call(m, "middleName"))
                w.uint32(106).string(m.middleName);
            if (m.lastName != null && Object.hasOwnProperty.call(m, "lastName"))
                w.uint32(114).string(m.lastName);
            if (m.customerType != null && Object.hasOwnProperty.call(m, "customerType"))
                w.uint32(122).string(m.customerType);
            if (m.email != null && Object.hasOwnProperty.call(m, "email"))
                w.uint32(130).string(m.email);
            return w;
        };

        /**
         * Decodes a CustomerDetails message from the specified reader or buffer.
         * @function decode
         * @memberof payment3_paymentmethodpb.CustomerDetails
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {payment3_paymentmethodpb.CustomerDetails} CustomerDetails
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CustomerDetails.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.payment3_paymentmethodpb.CustomerDetails();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 10:
                    m.customerID = r.string();
                    break;
                case 11:
                    m.fullName = r.string();
                    break;
                case 12:
                    m.firstName = r.string();
                    break;
                case 13:
                    m.middleName = r.string();
                    break;
                case 14:
                    m.lastName = r.string();
                    break;
                case 15:
                    m.customerType = r.string();
                    break;
                case 16:
                    m.email = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return CustomerDetails;
    })();

    payment3_paymentmethodpb.AddressDetails = (function() {

        /**
         * Properties of an AddressDetails.
         * @memberof payment3_paymentmethodpb
         * @interface IAddressDetails
         * @property {payment3_paymentmethodpb.AddressType|null} [type] AddressDetails type
         * @property {string|null} [country] AddressDetails country
         * @property {string|null} [addressLine1] AddressDetails addressLine1
         * @property {string|null} [addressLine2] AddressDetails addressLine2
         * @property {string|null} [city] AddressDetails city
         * @property {string|null} [state] AddressDetails state
         * @property {string|null} [zip] AddressDetails zip
         */

        /**
         * Constructs a new AddressDetails.
         * @memberof payment3_paymentmethodpb
         * @classdesc Represents an AddressDetails.
         * @implements IAddressDetails
         * @constructor
         * @param {payment3_paymentmethodpb.IAddressDetails=} [p] Properties to set
         */
        function AddressDetails(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * AddressDetails type.
         * @member {payment3_paymentmethodpb.AddressType} type
         * @memberof payment3_paymentmethodpb.AddressDetails
         * @instance
         */
        AddressDetails.prototype.type = 0;

        /**
         * AddressDetails country.
         * @member {string} country
         * @memberof payment3_paymentmethodpb.AddressDetails
         * @instance
         */
        AddressDetails.prototype.country = "";

        /**
         * AddressDetails addressLine1.
         * @member {string} addressLine1
         * @memberof payment3_paymentmethodpb.AddressDetails
         * @instance
         */
        AddressDetails.prototype.addressLine1 = "";

        /**
         * AddressDetails addressLine2.
         * @member {string} addressLine2
         * @memberof payment3_paymentmethodpb.AddressDetails
         * @instance
         */
        AddressDetails.prototype.addressLine2 = "";

        /**
         * AddressDetails city.
         * @member {string} city
         * @memberof payment3_paymentmethodpb.AddressDetails
         * @instance
         */
        AddressDetails.prototype.city = "";

        /**
         * AddressDetails state.
         * @member {string} state
         * @memberof payment3_paymentmethodpb.AddressDetails
         * @instance
         */
        AddressDetails.prototype.state = "";

        /**
         * AddressDetails zip.
         * @member {string} zip
         * @memberof payment3_paymentmethodpb.AddressDetails
         * @instance
         */
        AddressDetails.prototype.zip = "";

        /**
         * Creates a new AddressDetails instance using the specified properties.
         * @function create
         * @memberof payment3_paymentmethodpb.AddressDetails
         * @static
         * @param {payment3_paymentmethodpb.IAddressDetails=} [properties] Properties to set
         * @returns {payment3_paymentmethodpb.AddressDetails} AddressDetails instance
         */
        AddressDetails.create = function create(properties) {
            return new AddressDetails(properties);
        };

        /**
         * Encodes the specified AddressDetails message. Does not implicitly {@link payment3_paymentmethodpb.AddressDetails.verify|verify} messages.
         * @function encode
         * @memberof payment3_paymentmethodpb.AddressDetails
         * @static
         * @param {payment3_paymentmethodpb.IAddressDetails} m AddressDetails message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AddressDetails.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.type != null && Object.hasOwnProperty.call(m, "type"))
                w.uint32(168).int32(m.type);
            if (m.country != null && Object.hasOwnProperty.call(m, "country"))
                w.uint32(178).string(m.country);
            if (m.addressLine1 != null && Object.hasOwnProperty.call(m, "addressLine1"))
                w.uint32(186).string(m.addressLine1);
            if (m.addressLine2 != null && Object.hasOwnProperty.call(m, "addressLine2"))
                w.uint32(194).string(m.addressLine2);
            if (m.city != null && Object.hasOwnProperty.call(m, "city"))
                w.uint32(202).string(m.city);
            if (m.state != null && Object.hasOwnProperty.call(m, "state"))
                w.uint32(210).string(m.state);
            if (m.zip != null && Object.hasOwnProperty.call(m, "zip"))
                w.uint32(218).string(m.zip);
            return w;
        };

        /**
         * Decodes an AddressDetails message from the specified reader or buffer.
         * @function decode
         * @memberof payment3_paymentmethodpb.AddressDetails
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {payment3_paymentmethodpb.AddressDetails} AddressDetails
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AddressDetails.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.payment3_paymentmethodpb.AddressDetails();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 21:
                    m.type = r.int32();
                    break;
                case 22:
                    m.country = r.string();
                    break;
                case 23:
                    m.addressLine1 = r.string();
                    break;
                case 24:
                    m.addressLine2 = r.string();
                    break;
                case 25:
                    m.city = r.string();
                    break;
                case 26:
                    m.state = r.string();
                    break;
                case 27:
                    m.zip = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return AddressDetails;
    })();

    /**
     * AddressType enum.
     * @name payment3_paymentmethodpb.AddressType
     * @enum {number}
     * @property {number} Undefined_AddressType=0 Undefined_AddressType value
     * @property {number} BillingAddress=1 BillingAddress value
     * @property {number} MailingAddress=2 MailingAddress value
     * @property {number} PropertyAddress=3 PropertyAddress value
     */
    payment3_paymentmethodpb.AddressType = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "Undefined_AddressType"] = 0;
        values[valuesById[1] = "BillingAddress"] = 1;
        values[valuesById[2] = "MailingAddress"] = 2;
        values[valuesById[3] = "PropertyAddress"] = 3;
        return values;
    })();

    payment3_paymentmethodpb.PaymentMethodDetails = (function() {

        /**
         * Properties of a PaymentMethodDetails.
         * @memberof payment3_paymentmethodpb
         * @interface IPaymentMethodDetails
         * @property {payment3_paymentmethodpb.PaymentMethodType|null} [type] PaymentMethodDetails type
         * @property {payment3_paymentmethodpb.ICreditCardDetails|null} [cc] PaymentMethodDetails cc
         * @property {payment3_paymentmethodpb.IACHDetails|null} [ach] PaymentMethodDetails ach
         * @property {payment3_paymentmethodpb.IPayPalDetails|null} [paypal] PaymentMethodDetails paypal
         * @property {payment3_paymentmethodpb.ICheckDetails|null} [check] PaymentMethodDetails check
         * @property {payment3_paymentmethodpb.CashFlow|null} [cashFlow] PaymentMethodDetails cashFlow
         */

        /**
         * Constructs a new PaymentMethodDetails.
         * @memberof payment3_paymentmethodpb
         * @classdesc Represents a PaymentMethodDetails.
         * @implements IPaymentMethodDetails
         * @constructor
         * @param {payment3_paymentmethodpb.IPaymentMethodDetails=} [p] Properties to set
         */
        function PaymentMethodDetails(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * PaymentMethodDetails type.
         * @member {payment3_paymentmethodpb.PaymentMethodType} type
         * @memberof payment3_paymentmethodpb.PaymentMethodDetails
         * @instance
         */
        PaymentMethodDetails.prototype.type = 0;

        /**
         * PaymentMethodDetails cc.
         * @member {payment3_paymentmethodpb.ICreditCardDetails|null|undefined} cc
         * @memberof payment3_paymentmethodpb.PaymentMethodDetails
         * @instance
         */
        PaymentMethodDetails.prototype.cc = null;

        /**
         * PaymentMethodDetails ach.
         * @member {payment3_paymentmethodpb.IACHDetails|null|undefined} ach
         * @memberof payment3_paymentmethodpb.PaymentMethodDetails
         * @instance
         */
        PaymentMethodDetails.prototype.ach = null;

        /**
         * PaymentMethodDetails paypal.
         * @member {payment3_paymentmethodpb.IPayPalDetails|null|undefined} paypal
         * @memberof payment3_paymentmethodpb.PaymentMethodDetails
         * @instance
         */
        PaymentMethodDetails.prototype.paypal = null;

        /**
         * PaymentMethodDetails check.
         * @member {payment3_paymentmethodpb.ICheckDetails|null|undefined} check
         * @memberof payment3_paymentmethodpb.PaymentMethodDetails
         * @instance
         */
        PaymentMethodDetails.prototype.check = null;

        /**
         * PaymentMethodDetails cashFlow.
         * @member {payment3_paymentmethodpb.CashFlow} cashFlow
         * @memberof payment3_paymentmethodpb.PaymentMethodDetails
         * @instance
         */
        PaymentMethodDetails.prototype.cashFlow = 0;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        /**
         * PaymentMethodDetails details.
         * @member {"cc"|"ach"|"paypal"|"check"|undefined} details
         * @memberof payment3_paymentmethodpb.PaymentMethodDetails
         * @instance
         */
        Object.defineProperty(PaymentMethodDetails.prototype, "details", {
            get: $util.oneOfGetter($oneOfFields = ["cc", "ach", "paypal", "check"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new PaymentMethodDetails instance using the specified properties.
         * @function create
         * @memberof payment3_paymentmethodpb.PaymentMethodDetails
         * @static
         * @param {payment3_paymentmethodpb.IPaymentMethodDetails=} [properties] Properties to set
         * @returns {payment3_paymentmethodpb.PaymentMethodDetails} PaymentMethodDetails instance
         */
        PaymentMethodDetails.create = function create(properties) {
            return new PaymentMethodDetails(properties);
        };

        /**
         * Encodes the specified PaymentMethodDetails message. Does not implicitly {@link payment3_paymentmethodpb.PaymentMethodDetails.verify|verify} messages.
         * @function encode
         * @memberof payment3_paymentmethodpb.PaymentMethodDetails
         * @static
         * @param {payment3_paymentmethodpb.IPaymentMethodDetails} m PaymentMethodDetails message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PaymentMethodDetails.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.type != null && Object.hasOwnProperty.call(m, "type"))
                w.uint32(800).int32(m.type);
            if (m.cc != null && Object.hasOwnProperty.call(m, "cc"))
                $root.payment3_paymentmethodpb.CreditCardDetails.encode(m.cc, w.uint32(810).fork()).ldelim();
            if (m.ach != null && Object.hasOwnProperty.call(m, "ach"))
                $root.payment3_paymentmethodpb.ACHDetails.encode(m.ach, w.uint32(818).fork()).ldelim();
            if (m.paypal != null && Object.hasOwnProperty.call(m, "paypal"))
                $root.payment3_paymentmethodpb.PayPalDetails.encode(m.paypal, w.uint32(826).fork()).ldelim();
            if (m.check != null && Object.hasOwnProperty.call(m, "check"))
                $root.payment3_paymentmethodpb.CheckDetails.encode(m.check, w.uint32(834).fork()).ldelim();
            if (m.cashFlow != null && Object.hasOwnProperty.call(m, "cashFlow"))
                w.uint32(1600).int32(m.cashFlow);
            return w;
        };

        /**
         * Decodes a PaymentMethodDetails message from the specified reader or buffer.
         * @function decode
         * @memberof payment3_paymentmethodpb.PaymentMethodDetails
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {payment3_paymentmethodpb.PaymentMethodDetails} PaymentMethodDetails
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PaymentMethodDetails.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.payment3_paymentmethodpb.PaymentMethodDetails();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 100:
                    m.type = r.int32();
                    break;
                case 101:
                    m.cc = $root.payment3_paymentmethodpb.CreditCardDetails.decode(r, r.uint32());
                    break;
                case 102:
                    m.ach = $root.payment3_paymentmethodpb.ACHDetails.decode(r, r.uint32());
                    break;
                case 103:
                    m.paypal = $root.payment3_paymentmethodpb.PayPalDetails.decode(r, r.uint32());
                    break;
                case 104:
                    m.check = $root.payment3_paymentmethodpb.CheckDetails.decode(r, r.uint32());
                    break;
                case 200:
                    m.cashFlow = r.int32();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return PaymentMethodDetails;
    })();

    /**
     * PaymentMethodType enum.
     * @name payment3_paymentmethodpb.PaymentMethodType
     * @enum {number}
     * @property {number} Undefined_PaymentMethodType=0 Undefined_PaymentMethodType value
     * @property {number} CreditCard=1 CreditCard value
     * @property {number} ACH=2 ACH value
     * @property {number} PayPal=3 PayPal value
     * @property {number} Check=4 Check value
     */
    payment3_paymentmethodpb.PaymentMethodType = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "Undefined_PaymentMethodType"] = 0;
        values[valuesById[1] = "CreditCard"] = 1;
        values[valuesById[2] = "ACH"] = 2;
        values[valuesById[3] = "PayPal"] = 3;
        values[valuesById[4] = "Check"] = 4;
        return values;
    })();

    /**
     * CashFlow enum.
     * @name payment3_paymentmethodpb.CashFlow
     * @enum {number}
     * @property {number} Undefined_CashFlow=0 Undefined_CashFlow value
     * @property {number} Receivable=1 Receivable value
     * @property {number} Payable=2 Payable value
     */
    payment3_paymentmethodpb.CashFlow = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "Undefined_CashFlow"] = 0;
        values[valuesById[1] = "Receivable"] = 1;
        values[valuesById[2] = "Payable"] = 2;
        return values;
    })();

    payment3_paymentmethodpb.CreditCardDetails = (function() {

        /**
         * Properties of a CreditCardDetails.
         * @memberof payment3_paymentmethodpb
         * @interface ICreditCardDetails
         * @property {string|null} [last4] CreditCardDetails last4
         * @property {common.IDate|null} [expirationDate] CreditCardDetails expirationDate
         * @property {payment3_paymentmethodpb.CreditCardBrand|null} [brand] CreditCardDetails brand
         * @property {payment3_paymentmethodpb.ICreditCardBillingDetails|null} [billingDetails] CreditCardDetails billingDetails
         */

        /**
         * Constructs a new CreditCardDetails.
         * @memberof payment3_paymentmethodpb
         * @classdesc Represents a CreditCardDetails.
         * @implements ICreditCardDetails
         * @constructor
         * @param {payment3_paymentmethodpb.ICreditCardDetails=} [p] Properties to set
         */
        function CreditCardDetails(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * CreditCardDetails last4.
         * @member {string} last4
         * @memberof payment3_paymentmethodpb.CreditCardDetails
         * @instance
         */
        CreditCardDetails.prototype.last4 = "";

        /**
         * CreditCardDetails expirationDate.
         * @member {common.IDate|null|undefined} expirationDate
         * @memberof payment3_paymentmethodpb.CreditCardDetails
         * @instance
         */
        CreditCardDetails.prototype.expirationDate = null;

        /**
         * CreditCardDetails brand.
         * @member {payment3_paymentmethodpb.CreditCardBrand} brand
         * @memberof payment3_paymentmethodpb.CreditCardDetails
         * @instance
         */
        CreditCardDetails.prototype.brand = 0;

        /**
         * CreditCardDetails billingDetails.
         * @member {payment3_paymentmethodpb.ICreditCardBillingDetails|null|undefined} billingDetails
         * @memberof payment3_paymentmethodpb.CreditCardDetails
         * @instance
         */
        CreditCardDetails.prototype.billingDetails = null;

        /**
         * Creates a new CreditCardDetails instance using the specified properties.
         * @function create
         * @memberof payment3_paymentmethodpb.CreditCardDetails
         * @static
         * @param {payment3_paymentmethodpb.ICreditCardDetails=} [properties] Properties to set
         * @returns {payment3_paymentmethodpb.CreditCardDetails} CreditCardDetails instance
         */
        CreditCardDetails.create = function create(properties) {
            return new CreditCardDetails(properties);
        };

        /**
         * Encodes the specified CreditCardDetails message. Does not implicitly {@link payment3_paymentmethodpb.CreditCardDetails.verify|verify} messages.
         * @function encode
         * @memberof payment3_paymentmethodpb.CreditCardDetails
         * @static
         * @param {payment3_paymentmethodpb.ICreditCardDetails} m CreditCardDetails message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CreditCardDetails.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.last4 != null && Object.hasOwnProperty.call(m, "last4"))
                w.uint32(10).string(m.last4);
            if (m.expirationDate != null && Object.hasOwnProperty.call(m, "expirationDate"))
                $root.common.Date.encode(m.expirationDate, w.uint32(18).fork()).ldelim();
            if (m.brand != null && Object.hasOwnProperty.call(m, "brand"))
                w.uint32(24).int32(m.brand);
            if (m.billingDetails != null && Object.hasOwnProperty.call(m, "billingDetails"))
                $root.payment3_paymentmethodpb.CreditCardBillingDetails.encode(m.billingDetails, w.uint32(34).fork()).ldelim();
            return w;
        };

        /**
         * Decodes a CreditCardDetails message from the specified reader or buffer.
         * @function decode
         * @memberof payment3_paymentmethodpb.CreditCardDetails
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {payment3_paymentmethodpb.CreditCardDetails} CreditCardDetails
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CreditCardDetails.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.payment3_paymentmethodpb.CreditCardDetails();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.last4 = r.string();
                    break;
                case 2:
                    m.expirationDate = $root.common.Date.decode(r, r.uint32());
                    break;
                case 3:
                    m.brand = r.int32();
                    break;
                case 4:
                    m.billingDetails = $root.payment3_paymentmethodpb.CreditCardBillingDetails.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return CreditCardDetails;
    })();

    payment3_paymentmethodpb.CreditCardBillingDetails = (function() {

        /**
         * Properties of a CreditCardBillingDetails.
         * @memberof payment3_paymentmethodpb
         * @interface ICreditCardBillingDetails
         * @property {string|null} [country] CreditCardBillingDetails country
         * @property {string|null} [name] CreditCardBillingDetails name
         * @property {string|null} [city] CreditCardBillingDetails city
         * @property {string|null} [state] CreditCardBillingDetails state
         * @property {string|null} [zip] CreditCardBillingDetails zip
         * @property {string|null} [phone] CreditCardBillingDetails phone
         * @property {string|null} [email] CreditCardBillingDetails email
         * @property {string|null} [addressLine1] CreditCardBillingDetails addressLine1
         * @property {string|null} [addressLine2] CreditCardBillingDetails addressLine2
         */

        /**
         * Constructs a new CreditCardBillingDetails.
         * @memberof payment3_paymentmethodpb
         * @classdesc Represents a CreditCardBillingDetails.
         * @implements ICreditCardBillingDetails
         * @constructor
         * @param {payment3_paymentmethodpb.ICreditCardBillingDetails=} [p] Properties to set
         */
        function CreditCardBillingDetails(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * CreditCardBillingDetails country.
         * @member {string} country
         * @memberof payment3_paymentmethodpb.CreditCardBillingDetails
         * @instance
         */
        CreditCardBillingDetails.prototype.country = "";

        /**
         * CreditCardBillingDetails name.
         * @member {string} name
         * @memberof payment3_paymentmethodpb.CreditCardBillingDetails
         * @instance
         */
        CreditCardBillingDetails.prototype.name = "";

        /**
         * CreditCardBillingDetails city.
         * @member {string} city
         * @memberof payment3_paymentmethodpb.CreditCardBillingDetails
         * @instance
         */
        CreditCardBillingDetails.prototype.city = "";

        /**
         * CreditCardBillingDetails state.
         * @member {string} state
         * @memberof payment3_paymentmethodpb.CreditCardBillingDetails
         * @instance
         */
        CreditCardBillingDetails.prototype.state = "";

        /**
         * CreditCardBillingDetails zip.
         * @member {string} zip
         * @memberof payment3_paymentmethodpb.CreditCardBillingDetails
         * @instance
         */
        CreditCardBillingDetails.prototype.zip = "";

        /**
         * CreditCardBillingDetails phone.
         * @member {string} phone
         * @memberof payment3_paymentmethodpb.CreditCardBillingDetails
         * @instance
         */
        CreditCardBillingDetails.prototype.phone = "";

        /**
         * CreditCardBillingDetails email.
         * @member {string} email
         * @memberof payment3_paymentmethodpb.CreditCardBillingDetails
         * @instance
         */
        CreditCardBillingDetails.prototype.email = "";

        /**
         * CreditCardBillingDetails addressLine1.
         * @member {string} addressLine1
         * @memberof payment3_paymentmethodpb.CreditCardBillingDetails
         * @instance
         */
        CreditCardBillingDetails.prototype.addressLine1 = "";

        /**
         * CreditCardBillingDetails addressLine2.
         * @member {string} addressLine2
         * @memberof payment3_paymentmethodpb.CreditCardBillingDetails
         * @instance
         */
        CreditCardBillingDetails.prototype.addressLine2 = "";

        /**
         * Creates a new CreditCardBillingDetails instance using the specified properties.
         * @function create
         * @memberof payment3_paymentmethodpb.CreditCardBillingDetails
         * @static
         * @param {payment3_paymentmethodpb.ICreditCardBillingDetails=} [properties] Properties to set
         * @returns {payment3_paymentmethodpb.CreditCardBillingDetails} CreditCardBillingDetails instance
         */
        CreditCardBillingDetails.create = function create(properties) {
            return new CreditCardBillingDetails(properties);
        };

        /**
         * Encodes the specified CreditCardBillingDetails message. Does not implicitly {@link payment3_paymentmethodpb.CreditCardBillingDetails.verify|verify} messages.
         * @function encode
         * @memberof payment3_paymentmethodpb.CreditCardBillingDetails
         * @static
         * @param {payment3_paymentmethodpb.ICreditCardBillingDetails} m CreditCardBillingDetails message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CreditCardBillingDetails.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.country != null && Object.hasOwnProperty.call(m, "country"))
                w.uint32(10).string(m.country);
            if (m.name != null && Object.hasOwnProperty.call(m, "name"))
                w.uint32(18).string(m.name);
            if (m.city != null && Object.hasOwnProperty.call(m, "city"))
                w.uint32(34).string(m.city);
            if (m.state != null && Object.hasOwnProperty.call(m, "state"))
                w.uint32(42).string(m.state);
            if (m.zip != null && Object.hasOwnProperty.call(m, "zip"))
                w.uint32(50).string(m.zip);
            if (m.phone != null && Object.hasOwnProperty.call(m, "phone"))
                w.uint32(58).string(m.phone);
            if (m.email != null && Object.hasOwnProperty.call(m, "email"))
                w.uint32(66).string(m.email);
            if (m.addressLine1 != null && Object.hasOwnProperty.call(m, "addressLine1"))
                w.uint32(74).string(m.addressLine1);
            if (m.addressLine2 != null && Object.hasOwnProperty.call(m, "addressLine2"))
                w.uint32(82).string(m.addressLine2);
            return w;
        };

        /**
         * Decodes a CreditCardBillingDetails message from the specified reader or buffer.
         * @function decode
         * @memberof payment3_paymentmethodpb.CreditCardBillingDetails
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {payment3_paymentmethodpb.CreditCardBillingDetails} CreditCardBillingDetails
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CreditCardBillingDetails.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.payment3_paymentmethodpb.CreditCardBillingDetails();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.country = r.string();
                    break;
                case 2:
                    m.name = r.string();
                    break;
                case 4:
                    m.city = r.string();
                    break;
                case 5:
                    m.state = r.string();
                    break;
                case 6:
                    m.zip = r.string();
                    break;
                case 7:
                    m.phone = r.string();
                    break;
                case 8:
                    m.email = r.string();
                    break;
                case 9:
                    m.addressLine1 = r.string();
                    break;
                case 10:
                    m.addressLine2 = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return CreditCardBillingDetails;
    })();

    /**
     * CreditCardBrand enum.
     * @name payment3_paymentmethodpb.CreditCardBrand
     * @enum {number}
     * @property {number} Undefined_Brand=0 Undefined_Brand value
     * @property {number} AmericanExpress=10 AmericanExpress value
     * @property {number} DinersClub=20 DinersClub value
     * @property {number} Discover=30 Discover value
     * @property {number} JCB=40 JCB value
     * @property {number} MasterCard=50 MasterCard value
     * @property {number} UnionPay=60 UnionPay value
     * @property {number} Visa=70 Visa value
     * @property {number} BrandUnknown=200 BrandUnknown value
     */
    payment3_paymentmethodpb.CreditCardBrand = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "Undefined_Brand"] = 0;
        values[valuesById[10] = "AmericanExpress"] = 10;
        values[valuesById[20] = "DinersClub"] = 20;
        values[valuesById[30] = "Discover"] = 30;
        values[valuesById[40] = "JCB"] = 40;
        values[valuesById[50] = "MasterCard"] = 50;
        values[valuesById[60] = "UnionPay"] = 60;
        values[valuesById[70] = "Visa"] = 70;
        values[valuesById[200] = "BrandUnknown"] = 200;
        return values;
    })();

    payment3_paymentmethodpb.ACHDetails = (function() {

        /**
         * Properties of a ACHDetails.
         * @memberof payment3_paymentmethodpb
         * @interface IACHDetails
         * @property {string|null} [routingNumber] ACHDetails routingNumber
         * @property {string|null} [last4] ACHDetails last4
         * @property {string|null} [encryptedAccountNumber] ACHDetails encryptedAccountNumber
         */

        /**
         * Constructs a new ACHDetails.
         * @memberof payment3_paymentmethodpb
         * @classdesc Represents a ACHDetails.
         * @implements IACHDetails
         * @constructor
         * @param {payment3_paymentmethodpb.IACHDetails=} [p] Properties to set
         */
        function ACHDetails(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * ACHDetails routingNumber.
         * @member {string} routingNumber
         * @memberof payment3_paymentmethodpb.ACHDetails
         * @instance
         */
        ACHDetails.prototype.routingNumber = "";

        /**
         * ACHDetails last4.
         * @member {string} last4
         * @memberof payment3_paymentmethodpb.ACHDetails
         * @instance
         */
        ACHDetails.prototype.last4 = "";

        /**
         * ACHDetails encryptedAccountNumber.
         * @member {string} encryptedAccountNumber
         * @memberof payment3_paymentmethodpb.ACHDetails
         * @instance
         */
        ACHDetails.prototype.encryptedAccountNumber = "";

        /**
         * Creates a new ACHDetails instance using the specified properties.
         * @function create
         * @memberof payment3_paymentmethodpb.ACHDetails
         * @static
         * @param {payment3_paymentmethodpb.IACHDetails=} [properties] Properties to set
         * @returns {payment3_paymentmethodpb.ACHDetails} ACHDetails instance
         */
        ACHDetails.create = function create(properties) {
            return new ACHDetails(properties);
        };

        /**
         * Encodes the specified ACHDetails message. Does not implicitly {@link payment3_paymentmethodpb.ACHDetails.verify|verify} messages.
         * @function encode
         * @memberof payment3_paymentmethodpb.ACHDetails
         * @static
         * @param {payment3_paymentmethodpb.IACHDetails} m ACHDetails message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ACHDetails.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.routingNumber != null && Object.hasOwnProperty.call(m, "routingNumber"))
                w.uint32(10).string(m.routingNumber);
            if (m.last4 != null && Object.hasOwnProperty.call(m, "last4"))
                w.uint32(18).string(m.last4);
            if (m.encryptedAccountNumber != null && Object.hasOwnProperty.call(m, "encryptedAccountNumber"))
                w.uint32(26).string(m.encryptedAccountNumber);
            return w;
        };

        /**
         * Decodes a ACHDetails message from the specified reader or buffer.
         * @function decode
         * @memberof payment3_paymentmethodpb.ACHDetails
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {payment3_paymentmethodpb.ACHDetails} ACHDetails
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ACHDetails.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.payment3_paymentmethodpb.ACHDetails();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.routingNumber = r.string();
                    break;
                case 2:
                    m.last4 = r.string();
                    break;
                case 3:
                    m.encryptedAccountNumber = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return ACHDetails;
    })();

    payment3_paymentmethodpb.PayPalDetails = (function() {

        /**
         * Properties of a PayPalDetails.
         * @memberof payment3_paymentmethodpb
         * @interface IPayPalDetails
         * @property {string|null} [email] PayPalDetails email
         * @property {string|null} [firstName] PayPalDetails firstName
         * @property {string|null} [lastName] PayPalDetails lastName
         */

        /**
         * Constructs a new PayPalDetails.
         * @memberof payment3_paymentmethodpb
         * @classdesc Represents a PayPalDetails.
         * @implements IPayPalDetails
         * @constructor
         * @param {payment3_paymentmethodpb.IPayPalDetails=} [p] Properties to set
         */
        function PayPalDetails(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * PayPalDetails email.
         * @member {string} email
         * @memberof payment3_paymentmethodpb.PayPalDetails
         * @instance
         */
        PayPalDetails.prototype.email = "";

        /**
         * PayPalDetails firstName.
         * @member {string} firstName
         * @memberof payment3_paymentmethodpb.PayPalDetails
         * @instance
         */
        PayPalDetails.prototype.firstName = "";

        /**
         * PayPalDetails lastName.
         * @member {string} lastName
         * @memberof payment3_paymentmethodpb.PayPalDetails
         * @instance
         */
        PayPalDetails.prototype.lastName = "";

        /**
         * Creates a new PayPalDetails instance using the specified properties.
         * @function create
         * @memberof payment3_paymentmethodpb.PayPalDetails
         * @static
         * @param {payment3_paymentmethodpb.IPayPalDetails=} [properties] Properties to set
         * @returns {payment3_paymentmethodpb.PayPalDetails} PayPalDetails instance
         */
        PayPalDetails.create = function create(properties) {
            return new PayPalDetails(properties);
        };

        /**
         * Encodes the specified PayPalDetails message. Does not implicitly {@link payment3_paymentmethodpb.PayPalDetails.verify|verify} messages.
         * @function encode
         * @memberof payment3_paymentmethodpb.PayPalDetails
         * @static
         * @param {payment3_paymentmethodpb.IPayPalDetails} m PayPalDetails message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PayPalDetails.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.email != null && Object.hasOwnProperty.call(m, "email"))
                w.uint32(10).string(m.email);
            if (m.firstName != null && Object.hasOwnProperty.call(m, "firstName"))
                w.uint32(18).string(m.firstName);
            if (m.lastName != null && Object.hasOwnProperty.call(m, "lastName"))
                w.uint32(26).string(m.lastName);
            return w;
        };

        /**
         * Decodes a PayPalDetails message from the specified reader or buffer.
         * @function decode
         * @memberof payment3_paymentmethodpb.PayPalDetails
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {payment3_paymentmethodpb.PayPalDetails} PayPalDetails
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PayPalDetails.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.payment3_paymentmethodpb.PayPalDetails();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.email = r.string();
                    break;
                case 2:
                    m.firstName = r.string();
                    break;
                case 3:
                    m.lastName = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return PayPalDetails;
    })();

    payment3_paymentmethodpb.CheckDetails = (function() {

        /**
         * Properties of a CheckDetails.
         * @memberof payment3_paymentmethodpb
         * @interface ICheckDetails
         * @property {string|null} [name] CheckDetails name
         * @property {string|null} [street1] CheckDetails street1
         * @property {string|null} [street2] CheckDetails street2
         * @property {string|null} [city] CheckDetails city
         * @property {string|null} [state] CheckDetails state
         * @property {string|null} [zip] CheckDetails zip
         * @property {string|null} [email] CheckDetails email
         */

        /**
         * Constructs a new CheckDetails.
         * @memberof payment3_paymentmethodpb
         * @classdesc Represents a CheckDetails.
         * @implements ICheckDetails
         * @constructor
         * @param {payment3_paymentmethodpb.ICheckDetails=} [p] Properties to set
         */
        function CheckDetails(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * CheckDetails name.
         * @member {string} name
         * @memberof payment3_paymentmethodpb.CheckDetails
         * @instance
         */
        CheckDetails.prototype.name = "";

        /**
         * CheckDetails street1.
         * @member {string} street1
         * @memberof payment3_paymentmethodpb.CheckDetails
         * @instance
         */
        CheckDetails.prototype.street1 = "";

        /**
         * CheckDetails street2.
         * @member {string} street2
         * @memberof payment3_paymentmethodpb.CheckDetails
         * @instance
         */
        CheckDetails.prototype.street2 = "";

        /**
         * CheckDetails city.
         * @member {string} city
         * @memberof payment3_paymentmethodpb.CheckDetails
         * @instance
         */
        CheckDetails.prototype.city = "";

        /**
         * CheckDetails state.
         * @member {string} state
         * @memberof payment3_paymentmethodpb.CheckDetails
         * @instance
         */
        CheckDetails.prototype.state = "";

        /**
         * CheckDetails zip.
         * @member {string} zip
         * @memberof payment3_paymentmethodpb.CheckDetails
         * @instance
         */
        CheckDetails.prototype.zip = "";

        /**
         * CheckDetails email.
         * @member {string} email
         * @memberof payment3_paymentmethodpb.CheckDetails
         * @instance
         */
        CheckDetails.prototype.email = "";

        /**
         * Creates a new CheckDetails instance using the specified properties.
         * @function create
         * @memberof payment3_paymentmethodpb.CheckDetails
         * @static
         * @param {payment3_paymentmethodpb.ICheckDetails=} [properties] Properties to set
         * @returns {payment3_paymentmethodpb.CheckDetails} CheckDetails instance
         */
        CheckDetails.create = function create(properties) {
            return new CheckDetails(properties);
        };

        /**
         * Encodes the specified CheckDetails message. Does not implicitly {@link payment3_paymentmethodpb.CheckDetails.verify|verify} messages.
         * @function encode
         * @memberof payment3_paymentmethodpb.CheckDetails
         * @static
         * @param {payment3_paymentmethodpb.ICheckDetails} m CheckDetails message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CheckDetails.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.name != null && Object.hasOwnProperty.call(m, "name"))
                w.uint32(10).string(m.name);
            if (m.street1 != null && Object.hasOwnProperty.call(m, "street1"))
                w.uint32(18).string(m.street1);
            if (m.street2 != null && Object.hasOwnProperty.call(m, "street2"))
                w.uint32(26).string(m.street2);
            if (m.city != null && Object.hasOwnProperty.call(m, "city"))
                w.uint32(34).string(m.city);
            if (m.state != null && Object.hasOwnProperty.call(m, "state"))
                w.uint32(42).string(m.state);
            if (m.zip != null && Object.hasOwnProperty.call(m, "zip"))
                w.uint32(50).string(m.zip);
            if (m.email != null && Object.hasOwnProperty.call(m, "email"))
                w.uint32(58).string(m.email);
            return w;
        };

        /**
         * Decodes a CheckDetails message from the specified reader or buffer.
         * @function decode
         * @memberof payment3_paymentmethodpb.CheckDetails
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {payment3_paymentmethodpb.CheckDetails} CheckDetails
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CheckDetails.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.payment3_paymentmethodpb.CheckDetails();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.name = r.string();
                    break;
                case 2:
                    m.street1 = r.string();
                    break;
                case 3:
                    m.street2 = r.string();
                    break;
                case 4:
                    m.city = r.string();
                    break;
                case 5:
                    m.state = r.string();
                    break;
                case 6:
                    m.zip = r.string();
                    break;
                case 7:
                    m.email = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return CheckDetails;
    })();

    payment3_paymentmethodpb.ProcessorPaymentMethod = (function() {

        /**
         * Properties of a ProcessorPaymentMethod.
         * @memberof payment3_paymentmethodpb
         * @interface IProcessorPaymentMethod
         * @property {payment3_commonpb.PaymentProcessor|null} [processor] ProcessorPaymentMethod processor
         * @property {payment3_paymentmethodpb.IStripePaymentMethod|null} [stripe] ProcessorPaymentMethod stripe
         * @property {payment3_paymentmethodpb.IPaymentusPaymentMethod|null} [paymentus] ProcessorPaymentMethod paymentus
         * @property {payment3_paymentmethodpb.IBraintreePaymentMethod|null} [braintree] ProcessorPaymentMethod braintree
         * @property {payment3_paymentmethodpb.IJDEACHPaymentMethod|null} [jdeACH] ProcessorPaymentMethod jdeACH
         * @property {payment3_paymentmethodpb.IJDECheckPaymentMethod|null} [jdeCheck] ProcessorPaymentMethod jdeCheck
         * @property {payment3_commonpb.Brand|null} [brand] ProcessorPaymentMethod brand
         * @property {payment3_commonpb.Subbrand|null} [subbrand] ProcessorPaymentMethod subbrand
         */

        /**
         * Constructs a new ProcessorPaymentMethod.
         * @memberof payment3_paymentmethodpb
         * @classdesc Represents a ProcessorPaymentMethod.
         * @implements IProcessorPaymentMethod
         * @constructor
         * @param {payment3_paymentmethodpb.IProcessorPaymentMethod=} [p] Properties to set
         */
        function ProcessorPaymentMethod(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * ProcessorPaymentMethod processor.
         * @member {payment3_commonpb.PaymentProcessor} processor
         * @memberof payment3_paymentmethodpb.ProcessorPaymentMethod
         * @instance
         */
        ProcessorPaymentMethod.prototype.processor = 0;

        /**
         * ProcessorPaymentMethod stripe.
         * @member {payment3_paymentmethodpb.IStripePaymentMethod|null|undefined} stripe
         * @memberof payment3_paymentmethodpb.ProcessorPaymentMethod
         * @instance
         */
        ProcessorPaymentMethod.prototype.stripe = null;

        /**
         * ProcessorPaymentMethod paymentus.
         * @member {payment3_paymentmethodpb.IPaymentusPaymentMethod|null|undefined} paymentus
         * @memberof payment3_paymentmethodpb.ProcessorPaymentMethod
         * @instance
         */
        ProcessorPaymentMethod.prototype.paymentus = null;

        /**
         * ProcessorPaymentMethod braintree.
         * @member {payment3_paymentmethodpb.IBraintreePaymentMethod|null|undefined} braintree
         * @memberof payment3_paymentmethodpb.ProcessorPaymentMethod
         * @instance
         */
        ProcessorPaymentMethod.prototype.braintree = null;

        /**
         * ProcessorPaymentMethod jdeACH.
         * @member {payment3_paymentmethodpb.IJDEACHPaymentMethod|null|undefined} jdeACH
         * @memberof payment3_paymentmethodpb.ProcessorPaymentMethod
         * @instance
         */
        ProcessorPaymentMethod.prototype.jdeACH = null;

        /**
         * ProcessorPaymentMethod jdeCheck.
         * @member {payment3_paymentmethodpb.IJDECheckPaymentMethod|null|undefined} jdeCheck
         * @memberof payment3_paymentmethodpb.ProcessorPaymentMethod
         * @instance
         */
        ProcessorPaymentMethod.prototype.jdeCheck = null;

        /**
         * ProcessorPaymentMethod brand.
         * @member {payment3_commonpb.Brand} brand
         * @memberof payment3_paymentmethodpb.ProcessorPaymentMethod
         * @instance
         */
        ProcessorPaymentMethod.prototype.brand = 0;

        /**
         * ProcessorPaymentMethod subbrand.
         * @member {payment3_commonpb.Subbrand} subbrand
         * @memberof payment3_paymentmethodpb.ProcessorPaymentMethod
         * @instance
         */
        ProcessorPaymentMethod.prototype.subbrand = 0;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        /**
         * ProcessorPaymentMethod processorPaymentMethod.
         * @member {"stripe"|"paymentus"|"braintree"|"jdeACH"|"jdeCheck"|undefined} processorPaymentMethod
         * @memberof payment3_paymentmethodpb.ProcessorPaymentMethod
         * @instance
         */
        Object.defineProperty(ProcessorPaymentMethod.prototype, "processorPaymentMethod", {
            get: $util.oneOfGetter($oneOfFields = ["stripe", "paymentus", "braintree", "jdeACH", "jdeCheck"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new ProcessorPaymentMethod instance using the specified properties.
         * @function create
         * @memberof payment3_paymentmethodpb.ProcessorPaymentMethod
         * @static
         * @param {payment3_paymentmethodpb.IProcessorPaymentMethod=} [properties] Properties to set
         * @returns {payment3_paymentmethodpb.ProcessorPaymentMethod} ProcessorPaymentMethod instance
         */
        ProcessorPaymentMethod.create = function create(properties) {
            return new ProcessorPaymentMethod(properties);
        };

        /**
         * Encodes the specified ProcessorPaymentMethod message. Does not implicitly {@link payment3_paymentmethodpb.ProcessorPaymentMethod.verify|verify} messages.
         * @function encode
         * @memberof payment3_paymentmethodpb.ProcessorPaymentMethod
         * @static
         * @param {payment3_paymentmethodpb.IProcessorPaymentMethod} m ProcessorPaymentMethod message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ProcessorPaymentMethod.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.processor != null && Object.hasOwnProperty.call(m, "processor"))
                w.uint32(800).int32(m.processor);
            if (m.stripe != null && Object.hasOwnProperty.call(m, "stripe"))
                $root.payment3_paymentmethodpb.StripePaymentMethod.encode(m.stripe, w.uint32(810).fork()).ldelim();
            if (m.paymentus != null && Object.hasOwnProperty.call(m, "paymentus"))
                $root.payment3_paymentmethodpb.PaymentusPaymentMethod.encode(m.paymentus, w.uint32(818).fork()).ldelim();
            if (m.braintree != null && Object.hasOwnProperty.call(m, "braintree"))
                $root.payment3_paymentmethodpb.BraintreePaymentMethod.encode(m.braintree, w.uint32(826).fork()).ldelim();
            if (m.jdeACH != null && Object.hasOwnProperty.call(m, "jdeACH"))
                $root.payment3_paymentmethodpb.JDEACHPaymentMethod.encode(m.jdeACH, w.uint32(834).fork()).ldelim();
            if (m.jdeCheck != null && Object.hasOwnProperty.call(m, "jdeCheck"))
                $root.payment3_paymentmethodpb.JDECheckPaymentMethod.encode(m.jdeCheck, w.uint32(842).fork()).ldelim();
            if (m.brand != null && Object.hasOwnProperty.call(m, "brand"))
                w.uint32(848).int32(m.brand);
            if (m.subbrand != null && Object.hasOwnProperty.call(m, "subbrand"))
                w.uint32(856).int32(m.subbrand);
            return w;
        };

        /**
         * Decodes a ProcessorPaymentMethod message from the specified reader or buffer.
         * @function decode
         * @memberof payment3_paymentmethodpb.ProcessorPaymentMethod
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {payment3_paymentmethodpb.ProcessorPaymentMethod} ProcessorPaymentMethod
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ProcessorPaymentMethod.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.payment3_paymentmethodpb.ProcessorPaymentMethod();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 100:
                    m.processor = r.int32();
                    break;
                case 101:
                    m.stripe = $root.payment3_paymentmethodpb.StripePaymentMethod.decode(r, r.uint32());
                    break;
                case 102:
                    m.paymentus = $root.payment3_paymentmethodpb.PaymentusPaymentMethod.decode(r, r.uint32());
                    break;
                case 103:
                    m.braintree = $root.payment3_paymentmethodpb.BraintreePaymentMethod.decode(r, r.uint32());
                    break;
                case 104:
                    m.jdeACH = $root.payment3_paymentmethodpb.JDEACHPaymentMethod.decode(r, r.uint32());
                    break;
                case 105:
                    m.jdeCheck = $root.payment3_paymentmethodpb.JDECheckPaymentMethod.decode(r, r.uint32());
                    break;
                case 106:
                    m.brand = r.int32();
                    break;
                case 107:
                    m.subbrand = r.int32();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return ProcessorPaymentMethod;
    })();

    payment3_paymentmethodpb.StripePaymentMethod = (function() {

        /**
         * Properties of a StripePaymentMethod.
         * @memberof payment3_paymentmethodpb
         * @interface IStripePaymentMethod
         * @property {string|null} [paymentMethodID] StripePaymentMethod paymentMethodID
         * @property {string|null} [setupIntentID] StripePaymentMethod setupIntentID
         * @property {string|null} [cardID] StripePaymentMethod cardID
         * @property {string|null} [cardFingerprint] StripePaymentMethod cardFingerprint
         * @property {google.protobuf.ITimestamp|null} [cauDate] StripePaymentMethod cauDate
         */

        /**
         * Constructs a new StripePaymentMethod.
         * @memberof payment3_paymentmethodpb
         * @classdesc Represents a StripePaymentMethod.
         * @implements IStripePaymentMethod
         * @constructor
         * @param {payment3_paymentmethodpb.IStripePaymentMethod=} [p] Properties to set
         */
        function StripePaymentMethod(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * StripePaymentMethod paymentMethodID.
         * @member {string} paymentMethodID
         * @memberof payment3_paymentmethodpb.StripePaymentMethod
         * @instance
         */
        StripePaymentMethod.prototype.paymentMethodID = "";

        /**
         * StripePaymentMethod setupIntentID.
         * @member {string} setupIntentID
         * @memberof payment3_paymentmethodpb.StripePaymentMethod
         * @instance
         */
        StripePaymentMethod.prototype.setupIntentID = "";

        /**
         * StripePaymentMethod cardID.
         * @member {string} cardID
         * @memberof payment3_paymentmethodpb.StripePaymentMethod
         * @instance
         */
        StripePaymentMethod.prototype.cardID = "";

        /**
         * StripePaymentMethod cardFingerprint.
         * @member {string} cardFingerprint
         * @memberof payment3_paymentmethodpb.StripePaymentMethod
         * @instance
         */
        StripePaymentMethod.prototype.cardFingerprint = "";

        /**
         * StripePaymentMethod cauDate.
         * @member {google.protobuf.ITimestamp|null|undefined} cauDate
         * @memberof payment3_paymentmethodpb.StripePaymentMethod
         * @instance
         */
        StripePaymentMethod.prototype.cauDate = null;

        /**
         * Creates a new StripePaymentMethod instance using the specified properties.
         * @function create
         * @memberof payment3_paymentmethodpb.StripePaymentMethod
         * @static
         * @param {payment3_paymentmethodpb.IStripePaymentMethod=} [properties] Properties to set
         * @returns {payment3_paymentmethodpb.StripePaymentMethod} StripePaymentMethod instance
         */
        StripePaymentMethod.create = function create(properties) {
            return new StripePaymentMethod(properties);
        };

        /**
         * Encodes the specified StripePaymentMethod message. Does not implicitly {@link payment3_paymentmethodpb.StripePaymentMethod.verify|verify} messages.
         * @function encode
         * @memberof payment3_paymentmethodpb.StripePaymentMethod
         * @static
         * @param {payment3_paymentmethodpb.IStripePaymentMethod} m StripePaymentMethod message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        StripePaymentMethod.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.paymentMethodID != null && Object.hasOwnProperty.call(m, "paymentMethodID"))
                w.uint32(10).string(m.paymentMethodID);
            if (m.setupIntentID != null && Object.hasOwnProperty.call(m, "setupIntentID"))
                w.uint32(18).string(m.setupIntentID);
            if (m.cardID != null && Object.hasOwnProperty.call(m, "cardID"))
                w.uint32(26).string(m.cardID);
            if (m.cardFingerprint != null && Object.hasOwnProperty.call(m, "cardFingerprint"))
                w.uint32(34).string(m.cardFingerprint);
            if (m.cauDate != null && Object.hasOwnProperty.call(m, "cauDate"))
                $root.google.protobuf.Timestamp.encode(m.cauDate, w.uint32(42).fork()).ldelim();
            return w;
        };

        /**
         * Decodes a StripePaymentMethod message from the specified reader or buffer.
         * @function decode
         * @memberof payment3_paymentmethodpb.StripePaymentMethod
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {payment3_paymentmethodpb.StripePaymentMethod} StripePaymentMethod
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        StripePaymentMethod.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.payment3_paymentmethodpb.StripePaymentMethod();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.paymentMethodID = r.string();
                    break;
                case 2:
                    m.setupIntentID = r.string();
                    break;
                case 3:
                    m.cardID = r.string();
                    break;
                case 4:
                    m.cardFingerprint = r.string();
                    break;
                case 5:
                    m.cauDate = $root.google.protobuf.Timestamp.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return StripePaymentMethod;
    })();

    payment3_paymentmethodpb.PaymentusPaymentMethod = (function() {

        /**
         * Properties of a PaymentusPaymentMethod.
         * @memberof payment3_paymentmethodpb
         * @interface IPaymentusPaymentMethod
         * @property {string|null} [email] PaymentusPaymentMethod email
         * @property {string|null} [paymentusAccountToken] PaymentusPaymentMethod paymentusAccountToken
         * @property {string|null} [securePayload] PaymentusPaymentMethod securePayload
         */

        /**
         * Constructs a new PaymentusPaymentMethod.
         * @memberof payment3_paymentmethodpb
         * @classdesc Represents a PaymentusPaymentMethod.
         * @implements IPaymentusPaymentMethod
         * @constructor
         * @param {payment3_paymentmethodpb.IPaymentusPaymentMethod=} [p] Properties to set
         */
        function PaymentusPaymentMethod(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * PaymentusPaymentMethod email.
         * @member {string} email
         * @memberof payment3_paymentmethodpb.PaymentusPaymentMethod
         * @instance
         */
        PaymentusPaymentMethod.prototype.email = "";

        /**
         * PaymentusPaymentMethod paymentusAccountToken.
         * @member {string} paymentusAccountToken
         * @memberof payment3_paymentmethodpb.PaymentusPaymentMethod
         * @instance
         */
        PaymentusPaymentMethod.prototype.paymentusAccountToken = "";

        /**
         * PaymentusPaymentMethod securePayload.
         * @member {string} securePayload
         * @memberof payment3_paymentmethodpb.PaymentusPaymentMethod
         * @instance
         */
        PaymentusPaymentMethod.prototype.securePayload = "";

        /**
         * Creates a new PaymentusPaymentMethod instance using the specified properties.
         * @function create
         * @memberof payment3_paymentmethodpb.PaymentusPaymentMethod
         * @static
         * @param {payment3_paymentmethodpb.IPaymentusPaymentMethod=} [properties] Properties to set
         * @returns {payment3_paymentmethodpb.PaymentusPaymentMethod} PaymentusPaymentMethod instance
         */
        PaymentusPaymentMethod.create = function create(properties) {
            return new PaymentusPaymentMethod(properties);
        };

        /**
         * Encodes the specified PaymentusPaymentMethod message. Does not implicitly {@link payment3_paymentmethodpb.PaymentusPaymentMethod.verify|verify} messages.
         * @function encode
         * @memberof payment3_paymentmethodpb.PaymentusPaymentMethod
         * @static
         * @param {payment3_paymentmethodpb.IPaymentusPaymentMethod} m PaymentusPaymentMethod message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PaymentusPaymentMethod.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.email != null && Object.hasOwnProperty.call(m, "email"))
                w.uint32(10).string(m.email);
            if (m.paymentusAccountToken != null && Object.hasOwnProperty.call(m, "paymentusAccountToken"))
                w.uint32(18).string(m.paymentusAccountToken);
            if (m.securePayload != null && Object.hasOwnProperty.call(m, "securePayload"))
                w.uint32(42).string(m.securePayload);
            return w;
        };

        /**
         * Decodes a PaymentusPaymentMethod message from the specified reader or buffer.
         * @function decode
         * @memberof payment3_paymentmethodpb.PaymentusPaymentMethod
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {payment3_paymentmethodpb.PaymentusPaymentMethod} PaymentusPaymentMethod
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PaymentusPaymentMethod.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.payment3_paymentmethodpb.PaymentusPaymentMethod();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.email = r.string();
                    break;
                case 2:
                    m.paymentusAccountToken = r.string();
                    break;
                case 5:
                    m.securePayload = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return PaymentusPaymentMethod;
    })();

    payment3_paymentmethodpb.BraintreePaymentMethod = (function() {

        /**
         * Properties of a BraintreePaymentMethod.
         * @memberof payment3_paymentmethodpb
         * @interface IBraintreePaymentMethod
         * @property {string|null} [braintreeCustomerID] BraintreePaymentMethod braintreeCustomerID
         * @property {string|null} [payPalPayerID] BraintreePaymentMethod payPalPayerID
         * @property {string|null} [paymentMethodToken] BraintreePaymentMethod paymentMethodToken
         * @property {string|null} [paymentMethodID] BraintreePaymentMethod paymentMethodID
         * @property {string|null} [nonce] BraintreePaymentMethod nonce
         */

        /**
         * Constructs a new BraintreePaymentMethod.
         * @memberof payment3_paymentmethodpb
         * @classdesc Represents a BraintreePaymentMethod.
         * @implements IBraintreePaymentMethod
         * @constructor
         * @param {payment3_paymentmethodpb.IBraintreePaymentMethod=} [p] Properties to set
         */
        function BraintreePaymentMethod(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * BraintreePaymentMethod braintreeCustomerID.
         * @member {string} braintreeCustomerID
         * @memberof payment3_paymentmethodpb.BraintreePaymentMethod
         * @instance
         */
        BraintreePaymentMethod.prototype.braintreeCustomerID = "";

        /**
         * BraintreePaymentMethod payPalPayerID.
         * @member {string} payPalPayerID
         * @memberof payment3_paymentmethodpb.BraintreePaymentMethod
         * @instance
         */
        BraintreePaymentMethod.prototype.payPalPayerID = "";

        /**
         * BraintreePaymentMethod paymentMethodToken.
         * @member {string} paymentMethodToken
         * @memberof payment3_paymentmethodpb.BraintreePaymentMethod
         * @instance
         */
        BraintreePaymentMethod.prototype.paymentMethodToken = "";

        /**
         * BraintreePaymentMethod paymentMethodID.
         * @member {string} paymentMethodID
         * @memberof payment3_paymentmethodpb.BraintreePaymentMethod
         * @instance
         */
        BraintreePaymentMethod.prototype.paymentMethodID = "";

        /**
         * BraintreePaymentMethod nonce.
         * @member {string} nonce
         * @memberof payment3_paymentmethodpb.BraintreePaymentMethod
         * @instance
         */
        BraintreePaymentMethod.prototype.nonce = "";

        /**
         * Creates a new BraintreePaymentMethod instance using the specified properties.
         * @function create
         * @memberof payment3_paymentmethodpb.BraintreePaymentMethod
         * @static
         * @param {payment3_paymentmethodpb.IBraintreePaymentMethod=} [properties] Properties to set
         * @returns {payment3_paymentmethodpb.BraintreePaymentMethod} BraintreePaymentMethod instance
         */
        BraintreePaymentMethod.create = function create(properties) {
            return new BraintreePaymentMethod(properties);
        };

        /**
         * Encodes the specified BraintreePaymentMethod message. Does not implicitly {@link payment3_paymentmethodpb.BraintreePaymentMethod.verify|verify} messages.
         * @function encode
         * @memberof payment3_paymentmethodpb.BraintreePaymentMethod
         * @static
         * @param {payment3_paymentmethodpb.IBraintreePaymentMethod} m BraintreePaymentMethod message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        BraintreePaymentMethod.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.braintreeCustomerID != null && Object.hasOwnProperty.call(m, "braintreeCustomerID"))
                w.uint32(162).string(m.braintreeCustomerID);
            if (m.payPalPayerID != null && Object.hasOwnProperty.call(m, "payPalPayerID"))
                w.uint32(242).string(m.payPalPayerID);
            if (m.paymentMethodToken != null && Object.hasOwnProperty.call(m, "paymentMethodToken"))
                w.uint32(322).string(m.paymentMethodToken);
            if (m.paymentMethodID != null && Object.hasOwnProperty.call(m, "paymentMethodID"))
                w.uint32(402).string(m.paymentMethodID);
            if (m.nonce != null && Object.hasOwnProperty.call(m, "nonce"))
                w.uint32(7202).string(m.nonce);
            return w;
        };

        /**
         * Decodes a BraintreePaymentMethod message from the specified reader or buffer.
         * @function decode
         * @memberof payment3_paymentmethodpb.BraintreePaymentMethod
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {payment3_paymentmethodpb.BraintreePaymentMethod} BraintreePaymentMethod
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        BraintreePaymentMethod.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.payment3_paymentmethodpb.BraintreePaymentMethod();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 20:
                    m.braintreeCustomerID = r.string();
                    break;
                case 30:
                    m.payPalPayerID = r.string();
                    break;
                case 40:
                    m.paymentMethodToken = r.string();
                    break;
                case 50:
                    m.paymentMethodID = r.string();
                    break;
                case 900:
                    m.nonce = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return BraintreePaymentMethod;
    })();

    payment3_paymentmethodpb.JDECheckPaymentMethod = (function() {

        /**
         * Properties of a JDECheckPaymentMethod.
         * @memberof payment3_paymentmethodpb
         * @interface IJDECheckPaymentMethod
         */

        /**
         * Constructs a new JDECheckPaymentMethod.
         * @memberof payment3_paymentmethodpb
         * @classdesc Represents a JDECheckPaymentMethod.
         * @implements IJDECheckPaymentMethod
         * @constructor
         * @param {payment3_paymentmethodpb.IJDECheckPaymentMethod=} [p] Properties to set
         */
        function JDECheckPaymentMethod(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * Creates a new JDECheckPaymentMethod instance using the specified properties.
         * @function create
         * @memberof payment3_paymentmethodpb.JDECheckPaymentMethod
         * @static
         * @param {payment3_paymentmethodpb.IJDECheckPaymentMethod=} [properties] Properties to set
         * @returns {payment3_paymentmethodpb.JDECheckPaymentMethod} JDECheckPaymentMethod instance
         */
        JDECheckPaymentMethod.create = function create(properties) {
            return new JDECheckPaymentMethod(properties);
        };

        /**
         * Encodes the specified JDECheckPaymentMethod message. Does not implicitly {@link payment3_paymentmethodpb.JDECheckPaymentMethod.verify|verify} messages.
         * @function encode
         * @memberof payment3_paymentmethodpb.JDECheckPaymentMethod
         * @static
         * @param {payment3_paymentmethodpb.IJDECheckPaymentMethod} m JDECheckPaymentMethod message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        JDECheckPaymentMethod.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            return w;
        };

        /**
         * Decodes a JDECheckPaymentMethod message from the specified reader or buffer.
         * @function decode
         * @memberof payment3_paymentmethodpb.JDECheckPaymentMethod
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {payment3_paymentmethodpb.JDECheckPaymentMethod} JDECheckPaymentMethod
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        JDECheckPaymentMethod.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.payment3_paymentmethodpb.JDECheckPaymentMethod();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return JDECheckPaymentMethod;
    })();

    payment3_paymentmethodpb.JDEACHPaymentMethod = (function() {

        /**
         * Properties of a JDEACHPaymentMethod.
         * @memberof payment3_paymentmethodpb
         * @interface IJDEACHPaymentMethod
         */

        /**
         * Constructs a new JDEACHPaymentMethod.
         * @memberof payment3_paymentmethodpb
         * @classdesc Represents a JDEACHPaymentMethod.
         * @implements IJDEACHPaymentMethod
         * @constructor
         * @param {payment3_paymentmethodpb.IJDEACHPaymentMethod=} [p] Properties to set
         */
        function JDEACHPaymentMethod(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * Creates a new JDEACHPaymentMethod instance using the specified properties.
         * @function create
         * @memberof payment3_paymentmethodpb.JDEACHPaymentMethod
         * @static
         * @param {payment3_paymentmethodpb.IJDEACHPaymentMethod=} [properties] Properties to set
         * @returns {payment3_paymentmethodpb.JDEACHPaymentMethod} JDEACHPaymentMethod instance
         */
        JDEACHPaymentMethod.create = function create(properties) {
            return new JDEACHPaymentMethod(properties);
        };

        /**
         * Encodes the specified JDEACHPaymentMethod message. Does not implicitly {@link payment3_paymentmethodpb.JDEACHPaymentMethod.verify|verify} messages.
         * @function encode
         * @memberof payment3_paymentmethodpb.JDEACHPaymentMethod
         * @static
         * @param {payment3_paymentmethodpb.IJDEACHPaymentMethod} m JDEACHPaymentMethod message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        JDEACHPaymentMethod.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            return w;
        };

        /**
         * Decodes a JDEACHPaymentMethod message from the specified reader or buffer.
         * @function decode
         * @memberof payment3_paymentmethodpb.JDEACHPaymentMethod
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {payment3_paymentmethodpb.JDEACHPaymentMethod} JDEACHPaymentMethod
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        JDEACHPaymentMethod.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.payment3_paymentmethodpb.JDEACHPaymentMethod();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return JDEACHPaymentMethod;
    })();

    payment3_paymentmethodpb.UpdatePaymentMethodPatchRequest = (function() {

        /**
         * Properties of an UpdatePaymentMethodPatchRequest.
         * @memberof payment3_paymentmethodpb
         * @interface IUpdatePaymentMethodPatchRequest
         * @property {payment3_paymentmethodpb.IOwner|null} [owner] UpdatePaymentMethodPatchRequest owner
         */

        /**
         * Constructs a new UpdatePaymentMethodPatchRequest.
         * @memberof payment3_paymentmethodpb
         * @classdesc Represents an UpdatePaymentMethodPatchRequest.
         * @implements IUpdatePaymentMethodPatchRequest
         * @constructor
         * @param {payment3_paymentmethodpb.IUpdatePaymentMethodPatchRequest=} [p] Properties to set
         */
        function UpdatePaymentMethodPatchRequest(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * UpdatePaymentMethodPatchRequest owner.
         * @member {payment3_paymentmethodpb.IOwner|null|undefined} owner
         * @memberof payment3_paymentmethodpb.UpdatePaymentMethodPatchRequest
         * @instance
         */
        UpdatePaymentMethodPatchRequest.prototype.owner = null;

        /**
         * Creates a new UpdatePaymentMethodPatchRequest instance using the specified properties.
         * @function create
         * @memberof payment3_paymentmethodpb.UpdatePaymentMethodPatchRequest
         * @static
         * @param {payment3_paymentmethodpb.IUpdatePaymentMethodPatchRequest=} [properties] Properties to set
         * @returns {payment3_paymentmethodpb.UpdatePaymentMethodPatchRequest} UpdatePaymentMethodPatchRequest instance
         */
        UpdatePaymentMethodPatchRequest.create = function create(properties) {
            return new UpdatePaymentMethodPatchRequest(properties);
        };

        /**
         * Encodes the specified UpdatePaymentMethodPatchRequest message. Does not implicitly {@link payment3_paymentmethodpb.UpdatePaymentMethodPatchRequest.verify|verify} messages.
         * @function encode
         * @memberof payment3_paymentmethodpb.UpdatePaymentMethodPatchRequest
         * @static
         * @param {payment3_paymentmethodpb.IUpdatePaymentMethodPatchRequest} m UpdatePaymentMethodPatchRequest message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UpdatePaymentMethodPatchRequest.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.owner != null && Object.hasOwnProperty.call(m, "owner"))
                $root.payment3_paymentmethodpb.Owner.encode(m.owner, w.uint32(10).fork()).ldelim();
            return w;
        };

        /**
         * Decodes an UpdatePaymentMethodPatchRequest message from the specified reader or buffer.
         * @function decode
         * @memberof payment3_paymentmethodpb.UpdatePaymentMethodPatchRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {payment3_paymentmethodpb.UpdatePaymentMethodPatchRequest} UpdatePaymentMethodPatchRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UpdatePaymentMethodPatchRequest.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.payment3_paymentmethodpb.UpdatePaymentMethodPatchRequest();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.owner = $root.payment3_paymentmethodpb.Owner.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return UpdatePaymentMethodPatchRequest;
    })();

    payment3_paymentmethodpb.Owner = (function() {

        /**
         * Properties of an Owner.
         * @memberof payment3_paymentmethodpb
         * @interface IOwner
         * @property {string|null} [name] Owner name
         * @property {payment3_paymentmethodpb.IOwnerIdentity|null} [ownerIdentity] Owner ownerIdentity
         */

        /**
         * Constructs a new Owner.
         * @memberof payment3_paymentmethodpb
         * @classdesc Represents an Owner.
         * @implements IOwner
         * @constructor
         * @param {payment3_paymentmethodpb.IOwner=} [p] Properties to set
         */
        function Owner(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * Owner name.
         * @member {string} name
         * @memberof payment3_paymentmethodpb.Owner
         * @instance
         */
        Owner.prototype.name = "";

        /**
         * Owner ownerIdentity.
         * @member {payment3_paymentmethodpb.IOwnerIdentity|null|undefined} ownerIdentity
         * @memberof payment3_paymentmethodpb.Owner
         * @instance
         */
        Owner.prototype.ownerIdentity = null;

        /**
         * Creates a new Owner instance using the specified properties.
         * @function create
         * @memberof payment3_paymentmethodpb.Owner
         * @static
         * @param {payment3_paymentmethodpb.IOwner=} [properties] Properties to set
         * @returns {payment3_paymentmethodpb.Owner} Owner instance
         */
        Owner.create = function create(properties) {
            return new Owner(properties);
        };

        /**
         * Encodes the specified Owner message. Does not implicitly {@link payment3_paymentmethodpb.Owner.verify|verify} messages.
         * @function encode
         * @memberof payment3_paymentmethodpb.Owner
         * @static
         * @param {payment3_paymentmethodpb.IOwner} m Owner message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Owner.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.name != null && Object.hasOwnProperty.call(m, "name"))
                w.uint32(802).string(m.name);
            if (m.ownerIdentity != null && Object.hasOwnProperty.call(m, "ownerIdentity"))
                $root.payment3_paymentmethodpb.OwnerIdentity.encode(m.ownerIdentity, w.uint32(1602).fork()).ldelim();
            return w;
        };

        /**
         * Decodes an Owner message from the specified reader or buffer.
         * @function decode
         * @memberof payment3_paymentmethodpb.Owner
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {payment3_paymentmethodpb.Owner} Owner
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Owner.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.payment3_paymentmethodpb.Owner();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 100:
                    m.name = r.string();
                    break;
                case 200:
                    m.ownerIdentity = $root.payment3_paymentmethodpb.OwnerIdentity.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return Owner;
    })();

    payment3_paymentmethodpb.OwnerIdentity = (function() {

        /**
         * Properties of an OwnerIdentity.
         * @memberof payment3_paymentmethodpb
         * @interface IOwnerIdentity
         * @property {payment3_paymentmethodpb.OwnerIdentityType|null} [type] OwnerIdentity type
         * @property {payment3_paymentmethodpb.IContractIdentity|null} [contractIdentity] OwnerIdentity contractIdentity
         * @property {payment3_paymentmethodpb.ICustomerIdentity|null} [customerIdentity] OwnerIdentity customerIdentity
         * @property {payment3_paymentmethodpb.IApplianceReplacementIdentity|null} [replacementIdentity] OwnerIdentity replacementIdentity
         * @property {payment3_paymentmethodpb.IDispatchIdentity|null} [dispatchIdentity] OwnerIdentity dispatchIdentity
         * @property {payment3_paymentmethodpb.IOrderIdentity|null} [orderIdentity] OwnerIdentity orderIdentity
         * @property {payment3_paymentmethodpb.IQuoteIdentity|null} [quoteIdentity] OwnerIdentity quoteIdentity
         * @property {payment3_paymentmethodpb.IExternalContractIdentity|null} [externalContractIdentity] OwnerIdentity externalContractIdentity
         * @property {payment3_paymentmethodpb.IExternalCustomerIdentity|null} [externalCustomerIdentity] OwnerIdentity externalCustomerIdentity
         */

        /**
         * Constructs a new OwnerIdentity.
         * @memberof payment3_paymentmethodpb
         * @classdesc Represents an OwnerIdentity.
         * @implements IOwnerIdentity
         * @constructor
         * @param {payment3_paymentmethodpb.IOwnerIdentity=} [p] Properties to set
         */
        function OwnerIdentity(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * OwnerIdentity type.
         * @member {payment3_paymentmethodpb.OwnerIdentityType} type
         * @memberof payment3_paymentmethodpb.OwnerIdentity
         * @instance
         */
        OwnerIdentity.prototype.type = 0;

        /**
         * OwnerIdentity contractIdentity.
         * @member {payment3_paymentmethodpb.IContractIdentity|null|undefined} contractIdentity
         * @memberof payment3_paymentmethodpb.OwnerIdentity
         * @instance
         */
        OwnerIdentity.prototype.contractIdentity = null;

        /**
         * OwnerIdentity customerIdentity.
         * @member {payment3_paymentmethodpb.ICustomerIdentity|null|undefined} customerIdentity
         * @memberof payment3_paymentmethodpb.OwnerIdentity
         * @instance
         */
        OwnerIdentity.prototype.customerIdentity = null;

        /**
         * OwnerIdentity replacementIdentity.
         * @member {payment3_paymentmethodpb.IApplianceReplacementIdentity|null|undefined} replacementIdentity
         * @memberof payment3_paymentmethodpb.OwnerIdentity
         * @instance
         */
        OwnerIdentity.prototype.replacementIdentity = null;

        /**
         * OwnerIdentity dispatchIdentity.
         * @member {payment3_paymentmethodpb.IDispatchIdentity|null|undefined} dispatchIdentity
         * @memberof payment3_paymentmethodpb.OwnerIdentity
         * @instance
         */
        OwnerIdentity.prototype.dispatchIdentity = null;

        /**
         * OwnerIdentity orderIdentity.
         * @member {payment3_paymentmethodpb.IOrderIdentity|null|undefined} orderIdentity
         * @memberof payment3_paymentmethodpb.OwnerIdentity
         * @instance
         */
        OwnerIdentity.prototype.orderIdentity = null;

        /**
         * OwnerIdentity quoteIdentity.
         * @member {payment3_paymentmethodpb.IQuoteIdentity|null|undefined} quoteIdentity
         * @memberof payment3_paymentmethodpb.OwnerIdentity
         * @instance
         */
        OwnerIdentity.prototype.quoteIdentity = null;

        /**
         * OwnerIdentity externalContractIdentity.
         * @member {payment3_paymentmethodpb.IExternalContractIdentity|null|undefined} externalContractIdentity
         * @memberof payment3_paymentmethodpb.OwnerIdentity
         * @instance
         */
        OwnerIdentity.prototype.externalContractIdentity = null;

        /**
         * OwnerIdentity externalCustomerIdentity.
         * @member {payment3_paymentmethodpb.IExternalCustomerIdentity|null|undefined} externalCustomerIdentity
         * @memberof payment3_paymentmethodpb.OwnerIdentity
         * @instance
         */
        OwnerIdentity.prototype.externalCustomerIdentity = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        /**
         * OwnerIdentity identity.
         * @member {"contractIdentity"|"customerIdentity"|"replacementIdentity"|"dispatchIdentity"|"orderIdentity"|"quoteIdentity"|"externalContractIdentity"|"externalCustomerIdentity"|undefined} identity
         * @memberof payment3_paymentmethodpb.OwnerIdentity
         * @instance
         */
        Object.defineProperty(OwnerIdentity.prototype, "identity", {
            get: $util.oneOfGetter($oneOfFields = ["contractIdentity", "customerIdentity", "replacementIdentity", "dispatchIdentity", "orderIdentity", "quoteIdentity", "externalContractIdentity", "externalCustomerIdentity"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new OwnerIdentity instance using the specified properties.
         * @function create
         * @memberof payment3_paymentmethodpb.OwnerIdentity
         * @static
         * @param {payment3_paymentmethodpb.IOwnerIdentity=} [properties] Properties to set
         * @returns {payment3_paymentmethodpb.OwnerIdentity} OwnerIdentity instance
         */
        OwnerIdentity.create = function create(properties) {
            return new OwnerIdentity(properties);
        };

        /**
         * Encodes the specified OwnerIdentity message. Does not implicitly {@link payment3_paymentmethodpb.OwnerIdentity.verify|verify} messages.
         * @function encode
         * @memberof payment3_paymentmethodpb.OwnerIdentity
         * @static
         * @param {payment3_paymentmethodpb.IOwnerIdentity} m OwnerIdentity message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        OwnerIdentity.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.type != null && Object.hasOwnProperty.call(m, "type"))
                w.uint32(800).int32(m.type);
            if (m.contractIdentity != null && Object.hasOwnProperty.call(m, "contractIdentity"))
                $root.payment3_paymentmethodpb.ContractIdentity.encode(m.contractIdentity, w.uint32(810).fork()).ldelim();
            if (m.customerIdentity != null && Object.hasOwnProperty.call(m, "customerIdentity"))
                $root.payment3_paymentmethodpb.CustomerIdentity.encode(m.customerIdentity, w.uint32(826).fork()).ldelim();
            if (m.replacementIdentity != null && Object.hasOwnProperty.call(m, "replacementIdentity"))
                $root.payment3_paymentmethodpb.ApplianceReplacementIdentity.encode(m.replacementIdentity, w.uint32(882).fork()).ldelim();
            if (m.dispatchIdentity != null && Object.hasOwnProperty.call(m, "dispatchIdentity"))
                $root.payment3_paymentmethodpb.DispatchIdentity.encode(m.dispatchIdentity, w.uint32(962).fork()).ldelim();
            if (m.orderIdentity != null && Object.hasOwnProperty.call(m, "orderIdentity"))
                $root.payment3_paymentmethodpb.OrderIdentity.encode(m.orderIdentity, w.uint32(1042).fork()).ldelim();
            if (m.quoteIdentity != null && Object.hasOwnProperty.call(m, "quoteIdentity"))
                $root.payment3_paymentmethodpb.QuoteIdentity.encode(m.quoteIdentity, w.uint32(1122).fork()).ldelim();
            if (m.externalContractIdentity != null && Object.hasOwnProperty.call(m, "externalContractIdentity"))
                $root.payment3_paymentmethodpb.ExternalContractIdentity.encode(m.externalContractIdentity, w.uint32(1202).fork()).ldelim();
            if (m.externalCustomerIdentity != null && Object.hasOwnProperty.call(m, "externalCustomerIdentity"))
                $root.payment3_paymentmethodpb.ExternalCustomerIdentity.encode(m.externalCustomerIdentity, w.uint32(1282).fork()).ldelim();
            return w;
        };

        /**
         * Decodes an OwnerIdentity message from the specified reader or buffer.
         * @function decode
         * @memberof payment3_paymentmethodpb.OwnerIdentity
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {payment3_paymentmethodpb.OwnerIdentity} OwnerIdentity
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        OwnerIdentity.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.payment3_paymentmethodpb.OwnerIdentity();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 100:
                    m.type = r.int32();
                    break;
                case 101:
                    m.contractIdentity = $root.payment3_paymentmethodpb.ContractIdentity.decode(r, r.uint32());
                    break;
                case 103:
                    m.customerIdentity = $root.payment3_paymentmethodpb.CustomerIdentity.decode(r, r.uint32());
                    break;
                case 110:
                    m.replacementIdentity = $root.payment3_paymentmethodpb.ApplianceReplacementIdentity.decode(r, r.uint32());
                    break;
                case 120:
                    m.dispatchIdentity = $root.payment3_paymentmethodpb.DispatchIdentity.decode(r, r.uint32());
                    break;
                case 130:
                    m.orderIdentity = $root.payment3_paymentmethodpb.OrderIdentity.decode(r, r.uint32());
                    break;
                case 140:
                    m.quoteIdentity = $root.payment3_paymentmethodpb.QuoteIdentity.decode(r, r.uint32());
                    break;
                case 150:
                    m.externalContractIdentity = $root.payment3_paymentmethodpb.ExternalContractIdentity.decode(r, r.uint32());
                    break;
                case 160:
                    m.externalCustomerIdentity = $root.payment3_paymentmethodpb.ExternalCustomerIdentity.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return OwnerIdentity;
    })();

    /**
     * OwnerIdentityType enum.
     * @name payment3_paymentmethodpb.OwnerIdentityType
     * @enum {number}
     * @property {number} Undefined_IdentityType=0 Undefined_IdentityType value
     * @property {number} ContractIdentityType=1 ContractIdentityType value
     * @property {number} ReplacementIdentityType=2 ReplacementIdentityType value
     * @property {number} CustomerIdentityType=3 CustomerIdentityType value
     * @property {number} DispatchIdentityType=4 DispatchIdentityType value
     * @property {number} OrderIdentityType=5 OrderIdentityType value
     * @property {number} QuoteIdentityType=6 QuoteIdentityType value
     * @property {number} ExternalContractIdentityType=7 ExternalContractIdentityType value
     * @property {number} ExternalCustomerIdentityType=8 ExternalCustomerIdentityType value
     */
    payment3_paymentmethodpb.OwnerIdentityType = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "Undefined_IdentityType"] = 0;
        values[valuesById[1] = "ContractIdentityType"] = 1;
        values[valuesById[2] = "ReplacementIdentityType"] = 2;
        values[valuesById[3] = "CustomerIdentityType"] = 3;
        values[valuesById[4] = "DispatchIdentityType"] = 4;
        values[valuesById[5] = "OrderIdentityType"] = 5;
        values[valuesById[6] = "QuoteIdentityType"] = 6;
        values[valuesById[7] = "ExternalContractIdentityType"] = 7;
        values[valuesById[8] = "ExternalCustomerIdentityType"] = 8;
        return values;
    })();

    payment3_paymentmethodpb.ContractIdentity = (function() {

        /**
         * Properties of a ContractIdentity.
         * @memberof payment3_paymentmethodpb
         * @interface IContractIdentity
         * @property {string|null} [contractID] ContractIdentity contractID
         * @property {string|null} [contractPaymentID] ContractIdentity contractPaymentID
         */

        /**
         * Constructs a new ContractIdentity.
         * @memberof payment3_paymentmethodpb
         * @classdesc Represents a ContractIdentity.
         * @implements IContractIdentity
         * @constructor
         * @param {payment3_paymentmethodpb.IContractIdentity=} [p] Properties to set
         */
        function ContractIdentity(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * ContractIdentity contractID.
         * @member {string} contractID
         * @memberof payment3_paymentmethodpb.ContractIdentity
         * @instance
         */
        ContractIdentity.prototype.contractID = "";

        /**
         * ContractIdentity contractPaymentID.
         * @member {string} contractPaymentID
         * @memberof payment3_paymentmethodpb.ContractIdentity
         * @instance
         */
        ContractIdentity.prototype.contractPaymentID = "";

        /**
         * Creates a new ContractIdentity instance using the specified properties.
         * @function create
         * @memberof payment3_paymentmethodpb.ContractIdentity
         * @static
         * @param {payment3_paymentmethodpb.IContractIdentity=} [properties] Properties to set
         * @returns {payment3_paymentmethodpb.ContractIdentity} ContractIdentity instance
         */
        ContractIdentity.create = function create(properties) {
            return new ContractIdentity(properties);
        };

        /**
         * Encodes the specified ContractIdentity message. Does not implicitly {@link payment3_paymentmethodpb.ContractIdentity.verify|verify} messages.
         * @function encode
         * @memberof payment3_paymentmethodpb.ContractIdentity
         * @static
         * @param {payment3_paymentmethodpb.IContractIdentity} m ContractIdentity message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ContractIdentity.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.contractID != null && Object.hasOwnProperty.call(m, "contractID"))
                w.uint32(10).string(m.contractID);
            if (m.contractPaymentID != null && Object.hasOwnProperty.call(m, "contractPaymentID"))
                w.uint32(18).string(m.contractPaymentID);
            return w;
        };

        /**
         * Decodes a ContractIdentity message from the specified reader or buffer.
         * @function decode
         * @memberof payment3_paymentmethodpb.ContractIdentity
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {payment3_paymentmethodpb.ContractIdentity} ContractIdentity
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ContractIdentity.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.payment3_paymentmethodpb.ContractIdentity();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.contractID = r.string();
                    break;
                case 2:
                    m.contractPaymentID = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return ContractIdentity;
    })();

    payment3_paymentmethodpb.CustomerIdentity = (function() {

        /**
         * Properties of a CustomerIdentity.
         * @memberof payment3_paymentmethodpb
         * @interface ICustomerIdentity
         * @property {string|null} [customerID] CustomerIdentity customerID
         */

        /**
         * Constructs a new CustomerIdentity.
         * @memberof payment3_paymentmethodpb
         * @classdesc Represents a CustomerIdentity.
         * @implements ICustomerIdentity
         * @constructor
         * @param {payment3_paymentmethodpb.ICustomerIdentity=} [p] Properties to set
         */
        function CustomerIdentity(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * CustomerIdentity customerID.
         * @member {string} customerID
         * @memberof payment3_paymentmethodpb.CustomerIdentity
         * @instance
         */
        CustomerIdentity.prototype.customerID = "";

        /**
         * Creates a new CustomerIdentity instance using the specified properties.
         * @function create
         * @memberof payment3_paymentmethodpb.CustomerIdentity
         * @static
         * @param {payment3_paymentmethodpb.ICustomerIdentity=} [properties] Properties to set
         * @returns {payment3_paymentmethodpb.CustomerIdentity} CustomerIdentity instance
         */
        CustomerIdentity.create = function create(properties) {
            return new CustomerIdentity(properties);
        };

        /**
         * Encodes the specified CustomerIdentity message. Does not implicitly {@link payment3_paymentmethodpb.CustomerIdentity.verify|verify} messages.
         * @function encode
         * @memberof payment3_paymentmethodpb.CustomerIdentity
         * @static
         * @param {payment3_paymentmethodpb.ICustomerIdentity} m CustomerIdentity message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CustomerIdentity.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.customerID != null && Object.hasOwnProperty.call(m, "customerID"))
                w.uint32(10).string(m.customerID);
            return w;
        };

        /**
         * Decodes a CustomerIdentity message from the specified reader or buffer.
         * @function decode
         * @memberof payment3_paymentmethodpb.CustomerIdentity
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {payment3_paymentmethodpb.CustomerIdentity} CustomerIdentity
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CustomerIdentity.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.payment3_paymentmethodpb.CustomerIdentity();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.customerID = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return CustomerIdentity;
    })();

    payment3_paymentmethodpb.ApplianceReplacementIdentity = (function() {

        /**
         * Properties of an ApplianceReplacementIdentity.
         * @memberof payment3_paymentmethodpb
         * @interface IApplianceReplacementIdentity
         * @property {string|null} [replacementID] ApplianceReplacementIdentity replacementID
         */

        /**
         * Constructs a new ApplianceReplacementIdentity.
         * @memberof payment3_paymentmethodpb
         * @classdesc Represents an ApplianceReplacementIdentity.
         * @implements IApplianceReplacementIdentity
         * @constructor
         * @param {payment3_paymentmethodpb.IApplianceReplacementIdentity=} [p] Properties to set
         */
        function ApplianceReplacementIdentity(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * ApplianceReplacementIdentity replacementID.
         * @member {string} replacementID
         * @memberof payment3_paymentmethodpb.ApplianceReplacementIdentity
         * @instance
         */
        ApplianceReplacementIdentity.prototype.replacementID = "";

        /**
         * Creates a new ApplianceReplacementIdentity instance using the specified properties.
         * @function create
         * @memberof payment3_paymentmethodpb.ApplianceReplacementIdentity
         * @static
         * @param {payment3_paymentmethodpb.IApplianceReplacementIdentity=} [properties] Properties to set
         * @returns {payment3_paymentmethodpb.ApplianceReplacementIdentity} ApplianceReplacementIdentity instance
         */
        ApplianceReplacementIdentity.create = function create(properties) {
            return new ApplianceReplacementIdentity(properties);
        };

        /**
         * Encodes the specified ApplianceReplacementIdentity message. Does not implicitly {@link payment3_paymentmethodpb.ApplianceReplacementIdentity.verify|verify} messages.
         * @function encode
         * @memberof payment3_paymentmethodpb.ApplianceReplacementIdentity
         * @static
         * @param {payment3_paymentmethodpb.IApplianceReplacementIdentity} m ApplianceReplacementIdentity message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ApplianceReplacementIdentity.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.replacementID != null && Object.hasOwnProperty.call(m, "replacementID"))
                w.uint32(10).string(m.replacementID);
            return w;
        };

        /**
         * Decodes an ApplianceReplacementIdentity message from the specified reader or buffer.
         * @function decode
         * @memberof payment3_paymentmethodpb.ApplianceReplacementIdentity
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {payment3_paymentmethodpb.ApplianceReplacementIdentity} ApplianceReplacementIdentity
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ApplianceReplacementIdentity.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.payment3_paymentmethodpb.ApplianceReplacementIdentity();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.replacementID = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return ApplianceReplacementIdentity;
    })();

    payment3_paymentmethodpb.DispatchIdentity = (function() {

        /**
         * Properties of a DispatchIdentity.
         * @memberof payment3_paymentmethodpb
         * @interface IDispatchIdentity
         * @property {string|null} [dispatchID] DispatchIdentity dispatchID
         */

        /**
         * Constructs a new DispatchIdentity.
         * @memberof payment3_paymentmethodpb
         * @classdesc Represents a DispatchIdentity.
         * @implements IDispatchIdentity
         * @constructor
         * @param {payment3_paymentmethodpb.IDispatchIdentity=} [p] Properties to set
         */
        function DispatchIdentity(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * DispatchIdentity dispatchID.
         * @member {string} dispatchID
         * @memberof payment3_paymentmethodpb.DispatchIdentity
         * @instance
         */
        DispatchIdentity.prototype.dispatchID = "";

        /**
         * Creates a new DispatchIdentity instance using the specified properties.
         * @function create
         * @memberof payment3_paymentmethodpb.DispatchIdentity
         * @static
         * @param {payment3_paymentmethodpb.IDispatchIdentity=} [properties] Properties to set
         * @returns {payment3_paymentmethodpb.DispatchIdentity} DispatchIdentity instance
         */
        DispatchIdentity.create = function create(properties) {
            return new DispatchIdentity(properties);
        };

        /**
         * Encodes the specified DispatchIdentity message. Does not implicitly {@link payment3_paymentmethodpb.DispatchIdentity.verify|verify} messages.
         * @function encode
         * @memberof payment3_paymentmethodpb.DispatchIdentity
         * @static
         * @param {payment3_paymentmethodpb.IDispatchIdentity} m DispatchIdentity message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        DispatchIdentity.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.dispatchID != null && Object.hasOwnProperty.call(m, "dispatchID"))
                w.uint32(10).string(m.dispatchID);
            return w;
        };

        /**
         * Decodes a DispatchIdentity message from the specified reader or buffer.
         * @function decode
         * @memberof payment3_paymentmethodpb.DispatchIdentity
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {payment3_paymentmethodpb.DispatchIdentity} DispatchIdentity
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        DispatchIdentity.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.payment3_paymentmethodpb.DispatchIdentity();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.dispatchID = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return DispatchIdentity;
    })();

    payment3_paymentmethodpb.OrderIdentity = (function() {

        /**
         * Properties of an OrderIdentity.
         * @memberof payment3_paymentmethodpb
         * @interface IOrderIdentity
         * @property {string|null} [orderID] OrderIdentity orderID
         */

        /**
         * Constructs a new OrderIdentity.
         * @memberof payment3_paymentmethodpb
         * @classdesc Represents an OrderIdentity.
         * @implements IOrderIdentity
         * @constructor
         * @param {payment3_paymentmethodpb.IOrderIdentity=} [p] Properties to set
         */
        function OrderIdentity(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * OrderIdentity orderID.
         * @member {string} orderID
         * @memberof payment3_paymentmethodpb.OrderIdentity
         * @instance
         */
        OrderIdentity.prototype.orderID = "";

        /**
         * Creates a new OrderIdentity instance using the specified properties.
         * @function create
         * @memberof payment3_paymentmethodpb.OrderIdentity
         * @static
         * @param {payment3_paymentmethodpb.IOrderIdentity=} [properties] Properties to set
         * @returns {payment3_paymentmethodpb.OrderIdentity} OrderIdentity instance
         */
        OrderIdentity.create = function create(properties) {
            return new OrderIdentity(properties);
        };

        /**
         * Encodes the specified OrderIdentity message. Does not implicitly {@link payment3_paymentmethodpb.OrderIdentity.verify|verify} messages.
         * @function encode
         * @memberof payment3_paymentmethodpb.OrderIdentity
         * @static
         * @param {payment3_paymentmethodpb.IOrderIdentity} m OrderIdentity message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        OrderIdentity.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.orderID != null && Object.hasOwnProperty.call(m, "orderID"))
                w.uint32(10).string(m.orderID);
            return w;
        };

        /**
         * Decodes an OrderIdentity message from the specified reader or buffer.
         * @function decode
         * @memberof payment3_paymentmethodpb.OrderIdentity
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {payment3_paymentmethodpb.OrderIdentity} OrderIdentity
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        OrderIdentity.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.payment3_paymentmethodpb.OrderIdentity();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.orderID = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return OrderIdentity;
    })();

    payment3_paymentmethodpb.QuoteIdentity = (function() {

        /**
         * Properties of a QuoteIdentity.
         * @memberof payment3_paymentmethodpb
         * @interface IQuoteIdentity
         * @property {string|null} [quoteID] QuoteIdentity quoteID
         */

        /**
         * Constructs a new QuoteIdentity.
         * @memberof payment3_paymentmethodpb
         * @classdesc Represents a QuoteIdentity.
         * @implements IQuoteIdentity
         * @constructor
         * @param {payment3_paymentmethodpb.IQuoteIdentity=} [p] Properties to set
         */
        function QuoteIdentity(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * QuoteIdentity quoteID.
         * @member {string} quoteID
         * @memberof payment3_paymentmethodpb.QuoteIdentity
         * @instance
         */
        QuoteIdentity.prototype.quoteID = "";

        /**
         * Creates a new QuoteIdentity instance using the specified properties.
         * @function create
         * @memberof payment3_paymentmethodpb.QuoteIdentity
         * @static
         * @param {payment3_paymentmethodpb.IQuoteIdentity=} [properties] Properties to set
         * @returns {payment3_paymentmethodpb.QuoteIdentity} QuoteIdentity instance
         */
        QuoteIdentity.create = function create(properties) {
            return new QuoteIdentity(properties);
        };

        /**
         * Encodes the specified QuoteIdentity message. Does not implicitly {@link payment3_paymentmethodpb.QuoteIdentity.verify|verify} messages.
         * @function encode
         * @memberof payment3_paymentmethodpb.QuoteIdentity
         * @static
         * @param {payment3_paymentmethodpb.IQuoteIdentity} m QuoteIdentity message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        QuoteIdentity.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.quoteID != null && Object.hasOwnProperty.call(m, "quoteID"))
                w.uint32(10).string(m.quoteID);
            return w;
        };

        /**
         * Decodes a QuoteIdentity message from the specified reader or buffer.
         * @function decode
         * @memberof payment3_paymentmethodpb.QuoteIdentity
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {payment3_paymentmethodpb.QuoteIdentity} QuoteIdentity
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        QuoteIdentity.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.payment3_paymentmethodpb.QuoteIdentity();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.quoteID = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return QuoteIdentity;
    })();

    payment3_paymentmethodpb.ExternalContractIdentity = (function() {

        /**
         * Properties of an ExternalContractIdentity.
         * @memberof payment3_paymentmethodpb
         * @interface IExternalContractIdentity
         * @property {string|null} [externalContractID] ExternalContractIdentity externalContractID
         */

        /**
         * Constructs a new ExternalContractIdentity.
         * @memberof payment3_paymentmethodpb
         * @classdesc Represents an ExternalContractIdentity.
         * @implements IExternalContractIdentity
         * @constructor
         * @param {payment3_paymentmethodpb.IExternalContractIdentity=} [p] Properties to set
         */
        function ExternalContractIdentity(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * ExternalContractIdentity externalContractID.
         * @member {string} externalContractID
         * @memberof payment3_paymentmethodpb.ExternalContractIdentity
         * @instance
         */
        ExternalContractIdentity.prototype.externalContractID = "";

        /**
         * Creates a new ExternalContractIdentity instance using the specified properties.
         * @function create
         * @memberof payment3_paymentmethodpb.ExternalContractIdentity
         * @static
         * @param {payment3_paymentmethodpb.IExternalContractIdentity=} [properties] Properties to set
         * @returns {payment3_paymentmethodpb.ExternalContractIdentity} ExternalContractIdentity instance
         */
        ExternalContractIdentity.create = function create(properties) {
            return new ExternalContractIdentity(properties);
        };

        /**
         * Encodes the specified ExternalContractIdentity message. Does not implicitly {@link payment3_paymentmethodpb.ExternalContractIdentity.verify|verify} messages.
         * @function encode
         * @memberof payment3_paymentmethodpb.ExternalContractIdentity
         * @static
         * @param {payment3_paymentmethodpb.IExternalContractIdentity} m ExternalContractIdentity message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ExternalContractIdentity.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.externalContractID != null && Object.hasOwnProperty.call(m, "externalContractID"))
                w.uint32(10).string(m.externalContractID);
            return w;
        };

        /**
         * Decodes an ExternalContractIdentity message from the specified reader or buffer.
         * @function decode
         * @memberof payment3_paymentmethodpb.ExternalContractIdentity
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {payment3_paymentmethodpb.ExternalContractIdentity} ExternalContractIdentity
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ExternalContractIdentity.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.payment3_paymentmethodpb.ExternalContractIdentity();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.externalContractID = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return ExternalContractIdentity;
    })();

    payment3_paymentmethodpb.ExternalCustomerIdentity = (function() {

        /**
         * Properties of an ExternalCustomerIdentity.
         * @memberof payment3_paymentmethodpb
         * @interface IExternalCustomerIdentity
         * @property {string|null} [externalCustomerID] ExternalCustomerIdentity externalCustomerID
         */

        /**
         * Constructs a new ExternalCustomerIdentity.
         * @memberof payment3_paymentmethodpb
         * @classdesc Represents an ExternalCustomerIdentity.
         * @implements IExternalCustomerIdentity
         * @constructor
         * @param {payment3_paymentmethodpb.IExternalCustomerIdentity=} [p] Properties to set
         */
        function ExternalCustomerIdentity(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * ExternalCustomerIdentity externalCustomerID.
         * @member {string} externalCustomerID
         * @memberof payment3_paymentmethodpb.ExternalCustomerIdentity
         * @instance
         */
        ExternalCustomerIdentity.prototype.externalCustomerID = "";

        /**
         * Creates a new ExternalCustomerIdentity instance using the specified properties.
         * @function create
         * @memberof payment3_paymentmethodpb.ExternalCustomerIdentity
         * @static
         * @param {payment3_paymentmethodpb.IExternalCustomerIdentity=} [properties] Properties to set
         * @returns {payment3_paymentmethodpb.ExternalCustomerIdentity} ExternalCustomerIdentity instance
         */
        ExternalCustomerIdentity.create = function create(properties) {
            return new ExternalCustomerIdentity(properties);
        };

        /**
         * Encodes the specified ExternalCustomerIdentity message. Does not implicitly {@link payment3_paymentmethodpb.ExternalCustomerIdentity.verify|verify} messages.
         * @function encode
         * @memberof payment3_paymentmethodpb.ExternalCustomerIdentity
         * @static
         * @param {payment3_paymentmethodpb.IExternalCustomerIdentity} m ExternalCustomerIdentity message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ExternalCustomerIdentity.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.externalCustomerID != null && Object.hasOwnProperty.call(m, "externalCustomerID"))
                w.uint32(10).string(m.externalCustomerID);
            return w;
        };

        /**
         * Decodes an ExternalCustomerIdentity message from the specified reader or buffer.
         * @function decode
         * @memberof payment3_paymentmethodpb.ExternalCustomerIdentity
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {payment3_paymentmethodpb.ExternalCustomerIdentity} ExternalCustomerIdentity
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ExternalCustomerIdentity.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.payment3_paymentmethodpb.ExternalCustomerIdentity();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.externalCustomerID = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return ExternalCustomerIdentity;
    })();

    payment3_paymentmethodpb.QueryPaymentMethodsRequest = (function() {

        /**
         * Properties of a QueryPaymentMethodsRequest.
         * @memberof payment3_paymentmethodpb
         * @interface IQueryPaymentMethodsRequest
         * @property {payment3_paymentmethodpb.IQueryPaymentMethodsCriteria|null} [criteria] QueryPaymentMethodsRequest criteria
         */

        /**
         * Constructs a new QueryPaymentMethodsRequest.
         * @memberof payment3_paymentmethodpb
         * @classdesc Represents a QueryPaymentMethodsRequest.
         * @implements IQueryPaymentMethodsRequest
         * @constructor
         * @param {payment3_paymentmethodpb.IQueryPaymentMethodsRequest=} [p] Properties to set
         */
        function QueryPaymentMethodsRequest(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * QueryPaymentMethodsRequest criteria.
         * @member {payment3_paymentmethodpb.IQueryPaymentMethodsCriteria|null|undefined} criteria
         * @memberof payment3_paymentmethodpb.QueryPaymentMethodsRequest
         * @instance
         */
        QueryPaymentMethodsRequest.prototype.criteria = null;

        /**
         * Creates a new QueryPaymentMethodsRequest instance using the specified properties.
         * @function create
         * @memberof payment3_paymentmethodpb.QueryPaymentMethodsRequest
         * @static
         * @param {payment3_paymentmethodpb.IQueryPaymentMethodsRequest=} [properties] Properties to set
         * @returns {payment3_paymentmethodpb.QueryPaymentMethodsRequest} QueryPaymentMethodsRequest instance
         */
        QueryPaymentMethodsRequest.create = function create(properties) {
            return new QueryPaymentMethodsRequest(properties);
        };

        /**
         * Encodes the specified QueryPaymentMethodsRequest message. Does not implicitly {@link payment3_paymentmethodpb.QueryPaymentMethodsRequest.verify|verify} messages.
         * @function encode
         * @memberof payment3_paymentmethodpb.QueryPaymentMethodsRequest
         * @static
         * @param {payment3_paymentmethodpb.IQueryPaymentMethodsRequest} m QueryPaymentMethodsRequest message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        QueryPaymentMethodsRequest.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.criteria != null && Object.hasOwnProperty.call(m, "criteria"))
                $root.payment3_paymentmethodpb.QueryPaymentMethodsCriteria.encode(m.criteria, w.uint32(82).fork()).ldelim();
            return w;
        };

        /**
         * Decodes a QueryPaymentMethodsRequest message from the specified reader or buffer.
         * @function decode
         * @memberof payment3_paymentmethodpb.QueryPaymentMethodsRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {payment3_paymentmethodpb.QueryPaymentMethodsRequest} QueryPaymentMethodsRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        QueryPaymentMethodsRequest.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.payment3_paymentmethodpb.QueryPaymentMethodsRequest();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 10:
                    m.criteria = $root.payment3_paymentmethodpb.QueryPaymentMethodsCriteria.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return QueryPaymentMethodsRequest;
    })();

    payment3_paymentmethodpb.QueryPaymentMethodsCriteria = (function() {

        /**
         * Properties of a QueryPaymentMethodsCriteria.
         * @memberof payment3_paymentmethodpb
         * @interface IQueryPaymentMethodsCriteria
         * @property {payment3_paymentmethodpb.IQueryPaymentMethodsOwner|null} [owner] QueryPaymentMethodsCriteria owner
         * @property {payment3_paymentmethodpb.IQueryProcessorPaymentMethod|null} [processorPaymentMethod] QueryPaymentMethodsCriteria processorPaymentMethod
         * @property {payment3_paymentmethodpb.IQueryPaymentMethodID|null} [queryPaymentMethod] QueryPaymentMethodsCriteria queryPaymentMethod
         */

        /**
         * Constructs a new QueryPaymentMethodsCriteria.
         * @memberof payment3_paymentmethodpb
         * @classdesc Represents a QueryPaymentMethodsCriteria.
         * @implements IQueryPaymentMethodsCriteria
         * @constructor
         * @param {payment3_paymentmethodpb.IQueryPaymentMethodsCriteria=} [p] Properties to set
         */
        function QueryPaymentMethodsCriteria(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * QueryPaymentMethodsCriteria owner.
         * @member {payment3_paymentmethodpb.IQueryPaymentMethodsOwner|null|undefined} owner
         * @memberof payment3_paymentmethodpb.QueryPaymentMethodsCriteria
         * @instance
         */
        QueryPaymentMethodsCriteria.prototype.owner = null;

        /**
         * QueryPaymentMethodsCriteria processorPaymentMethod.
         * @member {payment3_paymentmethodpb.IQueryProcessorPaymentMethod|null|undefined} processorPaymentMethod
         * @memberof payment3_paymentmethodpb.QueryPaymentMethodsCriteria
         * @instance
         */
        QueryPaymentMethodsCriteria.prototype.processorPaymentMethod = null;

        /**
         * QueryPaymentMethodsCriteria queryPaymentMethod.
         * @member {payment3_paymentmethodpb.IQueryPaymentMethodID|null|undefined} queryPaymentMethod
         * @memberof payment3_paymentmethodpb.QueryPaymentMethodsCriteria
         * @instance
         */
        QueryPaymentMethodsCriteria.prototype.queryPaymentMethod = null;

        /**
         * Creates a new QueryPaymentMethodsCriteria instance using the specified properties.
         * @function create
         * @memberof payment3_paymentmethodpb.QueryPaymentMethodsCriteria
         * @static
         * @param {payment3_paymentmethodpb.IQueryPaymentMethodsCriteria=} [properties] Properties to set
         * @returns {payment3_paymentmethodpb.QueryPaymentMethodsCriteria} QueryPaymentMethodsCriteria instance
         */
        QueryPaymentMethodsCriteria.create = function create(properties) {
            return new QueryPaymentMethodsCriteria(properties);
        };

        /**
         * Encodes the specified QueryPaymentMethodsCriteria message. Does not implicitly {@link payment3_paymentmethodpb.QueryPaymentMethodsCriteria.verify|verify} messages.
         * @function encode
         * @memberof payment3_paymentmethodpb.QueryPaymentMethodsCriteria
         * @static
         * @param {payment3_paymentmethodpb.IQueryPaymentMethodsCriteria} m QueryPaymentMethodsCriteria message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        QueryPaymentMethodsCriteria.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.owner != null && Object.hasOwnProperty.call(m, "owner"))
                $root.payment3_paymentmethodpb.QueryPaymentMethodsOwner.encode(m.owner, w.uint32(82).fork()).ldelim();
            if (m.processorPaymentMethod != null && Object.hasOwnProperty.call(m, "processorPaymentMethod"))
                $root.payment3_paymentmethodpb.QueryProcessorPaymentMethod.encode(m.processorPaymentMethod, w.uint32(162).fork()).ldelim();
            if (m.queryPaymentMethod != null && Object.hasOwnProperty.call(m, "queryPaymentMethod"))
                $root.payment3_paymentmethodpb.QueryPaymentMethodID.encode(m.queryPaymentMethod, w.uint32(242).fork()).ldelim();
            return w;
        };

        /**
         * Decodes a QueryPaymentMethodsCriteria message from the specified reader or buffer.
         * @function decode
         * @memberof payment3_paymentmethodpb.QueryPaymentMethodsCriteria
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {payment3_paymentmethodpb.QueryPaymentMethodsCriteria} QueryPaymentMethodsCriteria
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        QueryPaymentMethodsCriteria.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.payment3_paymentmethodpb.QueryPaymentMethodsCriteria();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 10:
                    m.owner = $root.payment3_paymentmethodpb.QueryPaymentMethodsOwner.decode(r, r.uint32());
                    break;
                case 20:
                    m.processorPaymentMethod = $root.payment3_paymentmethodpb.QueryProcessorPaymentMethod.decode(r, r.uint32());
                    break;
                case 30:
                    m.queryPaymentMethod = $root.payment3_paymentmethodpb.QueryPaymentMethodID.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return QueryPaymentMethodsCriteria;
    })();

    payment3_paymentmethodpb.QueryPaymentMethodsOwner = (function() {

        /**
         * Properties of a QueryPaymentMethodsOwner.
         * @memberof payment3_paymentmethodpb
         * @interface IQueryPaymentMethodsOwner
         * @property {Array.<string>|null} [contractID] QueryPaymentMethodsOwner contractID
         * @property {Array.<string>|null} [customerID] QueryPaymentMethodsOwner customerID
         * @property {Array.<string>|null} [applianceReplacementID] QueryPaymentMethodsOwner applianceReplacementID
         * @property {Array.<string>|null} [dispatchID] QueryPaymentMethodsOwner dispatchID
         * @property {Array.<string>|null} [externalContractID] QueryPaymentMethodsOwner externalContractID
         * @property {Array.<string>|null} [externalCustomerID] QueryPaymentMethodsOwner externalCustomerID
         */

        /**
         * Constructs a new QueryPaymentMethodsOwner.
         * @memberof payment3_paymentmethodpb
         * @classdesc Represents a QueryPaymentMethodsOwner.
         * @implements IQueryPaymentMethodsOwner
         * @constructor
         * @param {payment3_paymentmethodpb.IQueryPaymentMethodsOwner=} [p] Properties to set
         */
        function QueryPaymentMethodsOwner(p) {
            this.contractID = [];
            this.customerID = [];
            this.applianceReplacementID = [];
            this.dispatchID = [];
            this.externalContractID = [];
            this.externalCustomerID = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * QueryPaymentMethodsOwner contractID.
         * @member {Array.<string>} contractID
         * @memberof payment3_paymentmethodpb.QueryPaymentMethodsOwner
         * @instance
         */
        QueryPaymentMethodsOwner.prototype.contractID = $util.emptyArray;

        /**
         * QueryPaymentMethodsOwner customerID.
         * @member {Array.<string>} customerID
         * @memberof payment3_paymentmethodpb.QueryPaymentMethodsOwner
         * @instance
         */
        QueryPaymentMethodsOwner.prototype.customerID = $util.emptyArray;

        /**
         * QueryPaymentMethodsOwner applianceReplacementID.
         * @member {Array.<string>} applianceReplacementID
         * @memberof payment3_paymentmethodpb.QueryPaymentMethodsOwner
         * @instance
         */
        QueryPaymentMethodsOwner.prototype.applianceReplacementID = $util.emptyArray;

        /**
         * QueryPaymentMethodsOwner dispatchID.
         * @member {Array.<string>} dispatchID
         * @memberof payment3_paymentmethodpb.QueryPaymentMethodsOwner
         * @instance
         */
        QueryPaymentMethodsOwner.prototype.dispatchID = $util.emptyArray;

        /**
         * QueryPaymentMethodsOwner externalContractID.
         * @member {Array.<string>} externalContractID
         * @memberof payment3_paymentmethodpb.QueryPaymentMethodsOwner
         * @instance
         */
        QueryPaymentMethodsOwner.prototype.externalContractID = $util.emptyArray;

        /**
         * QueryPaymentMethodsOwner externalCustomerID.
         * @member {Array.<string>} externalCustomerID
         * @memberof payment3_paymentmethodpb.QueryPaymentMethodsOwner
         * @instance
         */
        QueryPaymentMethodsOwner.prototype.externalCustomerID = $util.emptyArray;

        /**
         * Creates a new QueryPaymentMethodsOwner instance using the specified properties.
         * @function create
         * @memberof payment3_paymentmethodpb.QueryPaymentMethodsOwner
         * @static
         * @param {payment3_paymentmethodpb.IQueryPaymentMethodsOwner=} [properties] Properties to set
         * @returns {payment3_paymentmethodpb.QueryPaymentMethodsOwner} QueryPaymentMethodsOwner instance
         */
        QueryPaymentMethodsOwner.create = function create(properties) {
            return new QueryPaymentMethodsOwner(properties);
        };

        /**
         * Encodes the specified QueryPaymentMethodsOwner message. Does not implicitly {@link payment3_paymentmethodpb.QueryPaymentMethodsOwner.verify|verify} messages.
         * @function encode
         * @memberof payment3_paymentmethodpb.QueryPaymentMethodsOwner
         * @static
         * @param {payment3_paymentmethodpb.IQueryPaymentMethodsOwner} m QueryPaymentMethodsOwner message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        QueryPaymentMethodsOwner.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.contractID != null && m.contractID.length) {
                for (var i = 0; i < m.contractID.length; ++i)
                    w.uint32(82).string(m.contractID[i]);
            }
            if (m.customerID != null && m.customerID.length) {
                for (var i = 0; i < m.customerID.length; ++i)
                    w.uint32(162).string(m.customerID[i]);
            }
            if (m.applianceReplacementID != null && m.applianceReplacementID.length) {
                for (var i = 0; i < m.applianceReplacementID.length; ++i)
                    w.uint32(242).string(m.applianceReplacementID[i]);
            }
            if (m.dispatchID != null && m.dispatchID.length) {
                for (var i = 0; i < m.dispatchID.length; ++i)
                    w.uint32(322).string(m.dispatchID[i]);
            }
            if (m.externalContractID != null && m.externalContractID.length) {
                for (var i = 0; i < m.externalContractID.length; ++i)
                    w.uint32(402).string(m.externalContractID[i]);
            }
            if (m.externalCustomerID != null && m.externalCustomerID.length) {
                for (var i = 0; i < m.externalCustomerID.length; ++i)
                    w.uint32(482).string(m.externalCustomerID[i]);
            }
            return w;
        };

        /**
         * Decodes a QueryPaymentMethodsOwner message from the specified reader or buffer.
         * @function decode
         * @memberof payment3_paymentmethodpb.QueryPaymentMethodsOwner
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {payment3_paymentmethodpb.QueryPaymentMethodsOwner} QueryPaymentMethodsOwner
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        QueryPaymentMethodsOwner.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.payment3_paymentmethodpb.QueryPaymentMethodsOwner();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 10:
                    if (!(m.contractID && m.contractID.length))
                        m.contractID = [];
                    m.contractID.push(r.string());
                    break;
                case 20:
                    if (!(m.customerID && m.customerID.length))
                        m.customerID = [];
                    m.customerID.push(r.string());
                    break;
                case 30:
                    if (!(m.applianceReplacementID && m.applianceReplacementID.length))
                        m.applianceReplacementID = [];
                    m.applianceReplacementID.push(r.string());
                    break;
                case 40:
                    if (!(m.dispatchID && m.dispatchID.length))
                        m.dispatchID = [];
                    m.dispatchID.push(r.string());
                    break;
                case 50:
                    if (!(m.externalContractID && m.externalContractID.length))
                        m.externalContractID = [];
                    m.externalContractID.push(r.string());
                    break;
                case 60:
                    if (!(m.externalCustomerID && m.externalCustomerID.length))
                        m.externalCustomerID = [];
                    m.externalCustomerID.push(r.string());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return QueryPaymentMethodsOwner;
    })();

    payment3_paymentmethodpb.QueryProcessorPaymentMethod = (function() {

        /**
         * Properties of a QueryProcessorPaymentMethod.
         * @memberof payment3_paymentmethodpb
         * @interface IQueryProcessorPaymentMethod
         * @property {payment3_commonpb.PaymentProcessor|null} [processor] QueryProcessorPaymentMethod processor
         * @property {payment3_paymentmethodpb.IQueryStripePaymentMethod|null} [Stripe] QueryProcessorPaymentMethod Stripe
         * @property {payment3_paymentmethodpb.IQueryPaymentusPaymentMethod|null} [Paymentus] QueryProcessorPaymentMethod Paymentus
         */

        /**
         * Constructs a new QueryProcessorPaymentMethod.
         * @memberof payment3_paymentmethodpb
         * @classdesc Represents a QueryProcessorPaymentMethod.
         * @implements IQueryProcessorPaymentMethod
         * @constructor
         * @param {payment3_paymentmethodpb.IQueryProcessorPaymentMethod=} [p] Properties to set
         */
        function QueryProcessorPaymentMethod(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * QueryProcessorPaymentMethod processor.
         * @member {payment3_commonpb.PaymentProcessor} processor
         * @memberof payment3_paymentmethodpb.QueryProcessorPaymentMethod
         * @instance
         */
        QueryProcessorPaymentMethod.prototype.processor = 0;

        /**
         * QueryProcessorPaymentMethod Stripe.
         * @member {payment3_paymentmethodpb.IQueryStripePaymentMethod|null|undefined} Stripe
         * @memberof payment3_paymentmethodpb.QueryProcessorPaymentMethod
         * @instance
         */
        QueryProcessorPaymentMethod.prototype.Stripe = null;

        /**
         * QueryProcessorPaymentMethod Paymentus.
         * @member {payment3_paymentmethodpb.IQueryPaymentusPaymentMethod|null|undefined} Paymentus
         * @memberof payment3_paymentmethodpb.QueryProcessorPaymentMethod
         * @instance
         */
        QueryProcessorPaymentMethod.prototype.Paymentus = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        /**
         * QueryProcessorPaymentMethod processorPaymentMethod.
         * @member {"Stripe"|"Paymentus"|undefined} processorPaymentMethod
         * @memberof payment3_paymentmethodpb.QueryProcessorPaymentMethod
         * @instance
         */
        Object.defineProperty(QueryProcessorPaymentMethod.prototype, "processorPaymentMethod", {
            get: $util.oneOfGetter($oneOfFields = ["Stripe", "Paymentus"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new QueryProcessorPaymentMethod instance using the specified properties.
         * @function create
         * @memberof payment3_paymentmethodpb.QueryProcessorPaymentMethod
         * @static
         * @param {payment3_paymentmethodpb.IQueryProcessorPaymentMethod=} [properties] Properties to set
         * @returns {payment3_paymentmethodpb.QueryProcessorPaymentMethod} QueryProcessorPaymentMethod instance
         */
        QueryProcessorPaymentMethod.create = function create(properties) {
            return new QueryProcessorPaymentMethod(properties);
        };

        /**
         * Encodes the specified QueryProcessorPaymentMethod message. Does not implicitly {@link payment3_paymentmethodpb.QueryProcessorPaymentMethod.verify|verify} messages.
         * @function encode
         * @memberof payment3_paymentmethodpb.QueryProcessorPaymentMethod
         * @static
         * @param {payment3_paymentmethodpb.IQueryProcessorPaymentMethod} m QueryProcessorPaymentMethod message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        QueryProcessorPaymentMethod.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.processor != null && Object.hasOwnProperty.call(m, "processor"))
                w.uint32(800).int32(m.processor);
            if (m.Stripe != null && Object.hasOwnProperty.call(m, "Stripe"))
                $root.payment3_paymentmethodpb.QueryStripePaymentMethod.encode(m.Stripe, w.uint32(1602).fork()).ldelim();
            if (m.Paymentus != null && Object.hasOwnProperty.call(m, "Paymentus"))
                $root.payment3_paymentmethodpb.QueryPaymentusPaymentMethod.encode(m.Paymentus, w.uint32(2402).fork()).ldelim();
            return w;
        };

        /**
         * Decodes a QueryProcessorPaymentMethod message from the specified reader or buffer.
         * @function decode
         * @memberof payment3_paymentmethodpb.QueryProcessorPaymentMethod
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {payment3_paymentmethodpb.QueryProcessorPaymentMethod} QueryProcessorPaymentMethod
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        QueryProcessorPaymentMethod.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.payment3_paymentmethodpb.QueryProcessorPaymentMethod();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 100:
                    m.processor = r.int32();
                    break;
                case 200:
                    m.Stripe = $root.payment3_paymentmethodpb.QueryStripePaymentMethod.decode(r, r.uint32());
                    break;
                case 300:
                    m.Paymentus = $root.payment3_paymentmethodpb.QueryPaymentusPaymentMethod.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return QueryProcessorPaymentMethod;
    })();

    payment3_paymentmethodpb.QueryPaymentMethodID = (function() {

        /**
         * Properties of a QueryPaymentMethodID.
         * @memberof payment3_paymentmethodpb
         * @interface IQueryPaymentMethodID
         * @property {Array.<string>|null} [paymentMethodID] QueryPaymentMethodID paymentMethodID
         * @property {boolean|null} [isDeleted] QueryPaymentMethodID isDeleted
         */

        /**
         * Constructs a new QueryPaymentMethodID.
         * @memberof payment3_paymentmethodpb
         * @classdesc Represents a QueryPaymentMethodID.
         * @implements IQueryPaymentMethodID
         * @constructor
         * @param {payment3_paymentmethodpb.IQueryPaymentMethodID=} [p] Properties to set
         */
        function QueryPaymentMethodID(p) {
            this.paymentMethodID = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * QueryPaymentMethodID paymentMethodID.
         * @member {Array.<string>} paymentMethodID
         * @memberof payment3_paymentmethodpb.QueryPaymentMethodID
         * @instance
         */
        QueryPaymentMethodID.prototype.paymentMethodID = $util.emptyArray;

        /**
         * QueryPaymentMethodID isDeleted.
         * @member {boolean} isDeleted
         * @memberof payment3_paymentmethodpb.QueryPaymentMethodID
         * @instance
         */
        QueryPaymentMethodID.prototype.isDeleted = false;

        /**
         * Creates a new QueryPaymentMethodID instance using the specified properties.
         * @function create
         * @memberof payment3_paymentmethodpb.QueryPaymentMethodID
         * @static
         * @param {payment3_paymentmethodpb.IQueryPaymentMethodID=} [properties] Properties to set
         * @returns {payment3_paymentmethodpb.QueryPaymentMethodID} QueryPaymentMethodID instance
         */
        QueryPaymentMethodID.create = function create(properties) {
            return new QueryPaymentMethodID(properties);
        };

        /**
         * Encodes the specified QueryPaymentMethodID message. Does not implicitly {@link payment3_paymentmethodpb.QueryPaymentMethodID.verify|verify} messages.
         * @function encode
         * @memberof payment3_paymentmethodpb.QueryPaymentMethodID
         * @static
         * @param {payment3_paymentmethodpb.IQueryPaymentMethodID} m QueryPaymentMethodID message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        QueryPaymentMethodID.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.paymentMethodID != null && m.paymentMethodID.length) {
                for (var i = 0; i < m.paymentMethodID.length; ++i)
                    w.uint32(82).string(m.paymentMethodID[i]);
            }
            if (m.isDeleted != null && Object.hasOwnProperty.call(m, "isDeleted"))
                w.uint32(800).bool(m.isDeleted);
            return w;
        };

        /**
         * Decodes a QueryPaymentMethodID message from the specified reader or buffer.
         * @function decode
         * @memberof payment3_paymentmethodpb.QueryPaymentMethodID
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {payment3_paymentmethodpb.QueryPaymentMethodID} QueryPaymentMethodID
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        QueryPaymentMethodID.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.payment3_paymentmethodpb.QueryPaymentMethodID();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 10:
                    if (!(m.paymentMethodID && m.paymentMethodID.length))
                        m.paymentMethodID = [];
                    m.paymentMethodID.push(r.string());
                    break;
                case 100:
                    m.isDeleted = r.bool();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return QueryPaymentMethodID;
    })();

    payment3_paymentmethodpb.QueryStripePaymentMethod = (function() {

        /**
         * Properties of a QueryStripePaymentMethod.
         * @memberof payment3_paymentmethodpb
         * @interface IQueryStripePaymentMethod
         * @property {Array.<string>|null} [paymentMethodId] QueryStripePaymentMethod paymentMethodId
         * @property {Array.<string>|null} [cardFingerprint] QueryStripePaymentMethod cardFingerprint
         */

        /**
         * Constructs a new QueryStripePaymentMethod.
         * @memberof payment3_paymentmethodpb
         * @classdesc Represents a QueryStripePaymentMethod.
         * @implements IQueryStripePaymentMethod
         * @constructor
         * @param {payment3_paymentmethodpb.IQueryStripePaymentMethod=} [p] Properties to set
         */
        function QueryStripePaymentMethod(p) {
            this.paymentMethodId = [];
            this.cardFingerprint = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * QueryStripePaymentMethod paymentMethodId.
         * @member {Array.<string>} paymentMethodId
         * @memberof payment3_paymentmethodpb.QueryStripePaymentMethod
         * @instance
         */
        QueryStripePaymentMethod.prototype.paymentMethodId = $util.emptyArray;

        /**
         * QueryStripePaymentMethod cardFingerprint.
         * @member {Array.<string>} cardFingerprint
         * @memberof payment3_paymentmethodpb.QueryStripePaymentMethod
         * @instance
         */
        QueryStripePaymentMethod.prototype.cardFingerprint = $util.emptyArray;

        /**
         * Creates a new QueryStripePaymentMethod instance using the specified properties.
         * @function create
         * @memberof payment3_paymentmethodpb.QueryStripePaymentMethod
         * @static
         * @param {payment3_paymentmethodpb.IQueryStripePaymentMethod=} [properties] Properties to set
         * @returns {payment3_paymentmethodpb.QueryStripePaymentMethod} QueryStripePaymentMethod instance
         */
        QueryStripePaymentMethod.create = function create(properties) {
            return new QueryStripePaymentMethod(properties);
        };

        /**
         * Encodes the specified QueryStripePaymentMethod message. Does not implicitly {@link payment3_paymentmethodpb.QueryStripePaymentMethod.verify|verify} messages.
         * @function encode
         * @memberof payment3_paymentmethodpb.QueryStripePaymentMethod
         * @static
         * @param {payment3_paymentmethodpb.IQueryStripePaymentMethod} m QueryStripePaymentMethod message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        QueryStripePaymentMethod.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.paymentMethodId != null && m.paymentMethodId.length) {
                for (var i = 0; i < m.paymentMethodId.length; ++i)
                    w.uint32(802).string(m.paymentMethodId[i]);
            }
            if (m.cardFingerprint != null && m.cardFingerprint.length) {
                for (var i = 0; i < m.cardFingerprint.length; ++i)
                    w.uint32(1602).string(m.cardFingerprint[i]);
            }
            return w;
        };

        /**
         * Decodes a QueryStripePaymentMethod message from the specified reader or buffer.
         * @function decode
         * @memberof payment3_paymentmethodpb.QueryStripePaymentMethod
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {payment3_paymentmethodpb.QueryStripePaymentMethod} QueryStripePaymentMethod
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        QueryStripePaymentMethod.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.payment3_paymentmethodpb.QueryStripePaymentMethod();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 100:
                    if (!(m.paymentMethodId && m.paymentMethodId.length))
                        m.paymentMethodId = [];
                    m.paymentMethodId.push(r.string());
                    break;
                case 200:
                    if (!(m.cardFingerprint && m.cardFingerprint.length))
                        m.cardFingerprint = [];
                    m.cardFingerprint.push(r.string());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return QueryStripePaymentMethod;
    })();

    payment3_paymentmethodpb.QueryPaymentusPaymentMethod = (function() {

        /**
         * Properties of a QueryPaymentusPaymentMethod.
         * @memberof payment3_paymentmethodpb
         * @interface IQueryPaymentusPaymentMethod
         * @property {Array.<string>|null} [paymentusAccountToken] QueryPaymentusPaymentMethod paymentusAccountToken
         */

        /**
         * Constructs a new QueryPaymentusPaymentMethod.
         * @memberof payment3_paymentmethodpb
         * @classdesc Represents a QueryPaymentusPaymentMethod.
         * @implements IQueryPaymentusPaymentMethod
         * @constructor
         * @param {payment3_paymentmethodpb.IQueryPaymentusPaymentMethod=} [p] Properties to set
         */
        function QueryPaymentusPaymentMethod(p) {
            this.paymentusAccountToken = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * QueryPaymentusPaymentMethod paymentusAccountToken.
         * @member {Array.<string>} paymentusAccountToken
         * @memberof payment3_paymentmethodpb.QueryPaymentusPaymentMethod
         * @instance
         */
        QueryPaymentusPaymentMethod.prototype.paymentusAccountToken = $util.emptyArray;

        /**
         * Creates a new QueryPaymentusPaymentMethod instance using the specified properties.
         * @function create
         * @memberof payment3_paymentmethodpb.QueryPaymentusPaymentMethod
         * @static
         * @param {payment3_paymentmethodpb.IQueryPaymentusPaymentMethod=} [properties] Properties to set
         * @returns {payment3_paymentmethodpb.QueryPaymentusPaymentMethod} QueryPaymentusPaymentMethod instance
         */
        QueryPaymentusPaymentMethod.create = function create(properties) {
            return new QueryPaymentusPaymentMethod(properties);
        };

        /**
         * Encodes the specified QueryPaymentusPaymentMethod message. Does not implicitly {@link payment3_paymentmethodpb.QueryPaymentusPaymentMethod.verify|verify} messages.
         * @function encode
         * @memberof payment3_paymentmethodpb.QueryPaymentusPaymentMethod
         * @static
         * @param {payment3_paymentmethodpb.IQueryPaymentusPaymentMethod} m QueryPaymentusPaymentMethod message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        QueryPaymentusPaymentMethod.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.paymentusAccountToken != null && m.paymentusAccountToken.length) {
                for (var i = 0; i < m.paymentusAccountToken.length; ++i)
                    w.uint32(802).string(m.paymentusAccountToken[i]);
            }
            return w;
        };

        /**
         * Decodes a QueryPaymentusPaymentMethod message from the specified reader or buffer.
         * @function decode
         * @memberof payment3_paymentmethodpb.QueryPaymentusPaymentMethod
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {payment3_paymentmethodpb.QueryPaymentusPaymentMethod} QueryPaymentusPaymentMethod
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        QueryPaymentusPaymentMethod.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.payment3_paymentmethodpb.QueryPaymentusPaymentMethod();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 100:
                    if (!(m.paymentusAccountToken && m.paymentusAccountToken.length))
                        m.paymentusAccountToken = [];
                    m.paymentusAccountToken.push(r.string());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return QueryPaymentusPaymentMethod;
    })();

    payment3_paymentmethodpb.QueryPaymentMethodsResponse = (function() {

        /**
         * Properties of a QueryPaymentMethodsResponse.
         * @memberof payment3_paymentmethodpb
         * @interface IQueryPaymentMethodsResponse
         * @property {Array.<payment3_paymentmethodpb.IPaymentMethod>|null} [paymentMethod] QueryPaymentMethodsResponse paymentMethod
         */

        /**
         * Constructs a new QueryPaymentMethodsResponse.
         * @memberof payment3_paymentmethodpb
         * @classdesc Represents a QueryPaymentMethodsResponse.
         * @implements IQueryPaymentMethodsResponse
         * @constructor
         * @param {payment3_paymentmethodpb.IQueryPaymentMethodsResponse=} [p] Properties to set
         */
        function QueryPaymentMethodsResponse(p) {
            this.paymentMethod = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * QueryPaymentMethodsResponse paymentMethod.
         * @member {Array.<payment3_paymentmethodpb.IPaymentMethod>} paymentMethod
         * @memberof payment3_paymentmethodpb.QueryPaymentMethodsResponse
         * @instance
         */
        QueryPaymentMethodsResponse.prototype.paymentMethod = $util.emptyArray;

        /**
         * Creates a new QueryPaymentMethodsResponse instance using the specified properties.
         * @function create
         * @memberof payment3_paymentmethodpb.QueryPaymentMethodsResponse
         * @static
         * @param {payment3_paymentmethodpb.IQueryPaymentMethodsResponse=} [properties] Properties to set
         * @returns {payment3_paymentmethodpb.QueryPaymentMethodsResponse} QueryPaymentMethodsResponse instance
         */
        QueryPaymentMethodsResponse.create = function create(properties) {
            return new QueryPaymentMethodsResponse(properties);
        };

        /**
         * Encodes the specified QueryPaymentMethodsResponse message. Does not implicitly {@link payment3_paymentmethodpb.QueryPaymentMethodsResponse.verify|verify} messages.
         * @function encode
         * @memberof payment3_paymentmethodpb.QueryPaymentMethodsResponse
         * @static
         * @param {payment3_paymentmethodpb.IQueryPaymentMethodsResponse} m QueryPaymentMethodsResponse message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        QueryPaymentMethodsResponse.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.paymentMethod != null && m.paymentMethod.length) {
                for (var i = 0; i < m.paymentMethod.length; ++i)
                    $root.payment3_paymentmethodpb.PaymentMethod.encode(m.paymentMethod[i], w.uint32(82).fork()).ldelim();
            }
            return w;
        };

        /**
         * Decodes a QueryPaymentMethodsResponse message from the specified reader or buffer.
         * @function decode
         * @memberof payment3_paymentmethodpb.QueryPaymentMethodsResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {payment3_paymentmethodpb.QueryPaymentMethodsResponse} QueryPaymentMethodsResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        QueryPaymentMethodsResponse.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.payment3_paymentmethodpb.QueryPaymentMethodsResponse();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 10:
                    if (!(m.paymentMethod && m.paymentMethod.length))
                        m.paymentMethod = [];
                    m.paymentMethod.push($root.payment3_paymentmethodpb.PaymentMethod.decode(r, r.uint32()));
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return QueryPaymentMethodsResponse;
    })();

    payment3_paymentmethodpb.SnowflakePaymentMethod = (function() {

        /**
         * Properties of a SnowflakePaymentMethod.
         * @memberof payment3_paymentmethodpb
         * @interface ISnowflakePaymentMethod
         * @property {payment3_paymentmethodpb.IPaymentMethod|null} [paymentMethod] SnowflakePaymentMethod paymentMethod
         * @property {payment3_paymentmethodpb.EventType|null} [eventType] SnowflakePaymentMethod eventType
         */

        /**
         * Constructs a new SnowflakePaymentMethod.
         * @memberof payment3_paymentmethodpb
         * @classdesc Represents a SnowflakePaymentMethod.
         * @implements ISnowflakePaymentMethod
         * @constructor
         * @param {payment3_paymentmethodpb.ISnowflakePaymentMethod=} [p] Properties to set
         */
        function SnowflakePaymentMethod(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * SnowflakePaymentMethod paymentMethod.
         * @member {payment3_paymentmethodpb.IPaymentMethod|null|undefined} paymentMethod
         * @memberof payment3_paymentmethodpb.SnowflakePaymentMethod
         * @instance
         */
        SnowflakePaymentMethod.prototype.paymentMethod = null;

        /**
         * SnowflakePaymentMethod eventType.
         * @member {payment3_paymentmethodpb.EventType} eventType
         * @memberof payment3_paymentmethodpb.SnowflakePaymentMethod
         * @instance
         */
        SnowflakePaymentMethod.prototype.eventType = 0;

        /**
         * Creates a new SnowflakePaymentMethod instance using the specified properties.
         * @function create
         * @memberof payment3_paymentmethodpb.SnowflakePaymentMethod
         * @static
         * @param {payment3_paymentmethodpb.ISnowflakePaymentMethod=} [properties] Properties to set
         * @returns {payment3_paymentmethodpb.SnowflakePaymentMethod} SnowflakePaymentMethod instance
         */
        SnowflakePaymentMethod.create = function create(properties) {
            return new SnowflakePaymentMethod(properties);
        };

        /**
         * Encodes the specified SnowflakePaymentMethod message. Does not implicitly {@link payment3_paymentmethodpb.SnowflakePaymentMethod.verify|verify} messages.
         * @function encode
         * @memberof payment3_paymentmethodpb.SnowflakePaymentMethod
         * @static
         * @param {payment3_paymentmethodpb.ISnowflakePaymentMethod} m SnowflakePaymentMethod message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SnowflakePaymentMethod.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.paymentMethod != null && Object.hasOwnProperty.call(m, "paymentMethod"))
                $root.payment3_paymentmethodpb.PaymentMethod.encode(m.paymentMethod, w.uint32(10).fork()).ldelim();
            if (m.eventType != null && Object.hasOwnProperty.call(m, "eventType"))
                w.uint32(16).int32(m.eventType);
            return w;
        };

        /**
         * Decodes a SnowflakePaymentMethod message from the specified reader or buffer.
         * @function decode
         * @memberof payment3_paymentmethodpb.SnowflakePaymentMethod
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {payment3_paymentmethodpb.SnowflakePaymentMethod} SnowflakePaymentMethod
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SnowflakePaymentMethod.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.payment3_paymentmethodpb.SnowflakePaymentMethod();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.paymentMethod = $root.payment3_paymentmethodpb.PaymentMethod.decode(r, r.uint32());
                    break;
                case 2:
                    m.eventType = r.int32();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return SnowflakePaymentMethod;
    })();

    /**
     * EventType enum.
     * @name payment3_paymentmethodpb.EventType
     * @enum {number}
     * @property {number} Unknown_EventType=0 Unknown_EventType value
     * @property {number} CAU=1 CAU value
     * @property {number} PaymentMethodPayableCreated=2 PaymentMethodPayableCreated value
     */
    payment3_paymentmethodpb.EventType = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "Unknown_EventType"] = 0;
        values[valuesById[1] = "CAU"] = 1;
        values[valuesById[2] = "PaymentMethodPayableCreated"] = 2;
        return values;
    })();

    payment3_paymentmethodpb.CreateMigrationPaymentMethodRequest = (function() {

        /**
         * Properties of a CreateMigrationPaymentMethodRequest.
         * @memberof payment3_paymentmethodpb
         * @interface ICreateMigrationPaymentMethodRequest
         * @property {string|null} [externalPaymentMethodID] CreateMigrationPaymentMethodRequest externalPaymentMethodID
         * @property {string|null} [externalContractID] CreateMigrationPaymentMethodRequest externalContractID
         * @property {payment3_commonpb.Brand|null} [brand] CreateMigrationPaymentMethodRequest brand
         * @property {payment3_commonpb.Subbrand|null} [subbrand] CreateMigrationPaymentMethodRequest subbrand
         * @property {payment3_paymentmethodpb.IStripeMigrationPaymentMethod|null} [paymentMethod] CreateMigrationPaymentMethodRequest paymentMethod
         */

        /**
         * Constructs a new CreateMigrationPaymentMethodRequest.
         * @memberof payment3_paymentmethodpb
         * @classdesc Represents a CreateMigrationPaymentMethodRequest.
         * @implements ICreateMigrationPaymentMethodRequest
         * @constructor
         * @param {payment3_paymentmethodpb.ICreateMigrationPaymentMethodRequest=} [p] Properties to set
         */
        function CreateMigrationPaymentMethodRequest(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * CreateMigrationPaymentMethodRequest externalPaymentMethodID.
         * @member {string} externalPaymentMethodID
         * @memberof payment3_paymentmethodpb.CreateMigrationPaymentMethodRequest
         * @instance
         */
        CreateMigrationPaymentMethodRequest.prototype.externalPaymentMethodID = "";

        /**
         * CreateMigrationPaymentMethodRequest externalContractID.
         * @member {string} externalContractID
         * @memberof payment3_paymentmethodpb.CreateMigrationPaymentMethodRequest
         * @instance
         */
        CreateMigrationPaymentMethodRequest.prototype.externalContractID = "";

        /**
         * CreateMigrationPaymentMethodRequest brand.
         * @member {payment3_commonpb.Brand} brand
         * @memberof payment3_paymentmethodpb.CreateMigrationPaymentMethodRequest
         * @instance
         */
        CreateMigrationPaymentMethodRequest.prototype.brand = 0;

        /**
         * CreateMigrationPaymentMethodRequest subbrand.
         * @member {payment3_commonpb.Subbrand} subbrand
         * @memberof payment3_paymentmethodpb.CreateMigrationPaymentMethodRequest
         * @instance
         */
        CreateMigrationPaymentMethodRequest.prototype.subbrand = 0;

        /**
         * CreateMigrationPaymentMethodRequest paymentMethod.
         * @member {payment3_paymentmethodpb.IStripeMigrationPaymentMethod|null|undefined} paymentMethod
         * @memberof payment3_paymentmethodpb.CreateMigrationPaymentMethodRequest
         * @instance
         */
        CreateMigrationPaymentMethodRequest.prototype.paymentMethod = null;

        /**
         * Creates a new CreateMigrationPaymentMethodRequest instance using the specified properties.
         * @function create
         * @memberof payment3_paymentmethodpb.CreateMigrationPaymentMethodRequest
         * @static
         * @param {payment3_paymentmethodpb.ICreateMigrationPaymentMethodRequest=} [properties] Properties to set
         * @returns {payment3_paymentmethodpb.CreateMigrationPaymentMethodRequest} CreateMigrationPaymentMethodRequest instance
         */
        CreateMigrationPaymentMethodRequest.create = function create(properties) {
            return new CreateMigrationPaymentMethodRequest(properties);
        };

        /**
         * Encodes the specified CreateMigrationPaymentMethodRequest message. Does not implicitly {@link payment3_paymentmethodpb.CreateMigrationPaymentMethodRequest.verify|verify} messages.
         * @function encode
         * @memberof payment3_paymentmethodpb.CreateMigrationPaymentMethodRequest
         * @static
         * @param {payment3_paymentmethodpb.ICreateMigrationPaymentMethodRequest} m CreateMigrationPaymentMethodRequest message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CreateMigrationPaymentMethodRequest.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.externalPaymentMethodID != null && Object.hasOwnProperty.call(m, "externalPaymentMethodID"))
                w.uint32(10).string(m.externalPaymentMethodID);
            if (m.externalContractID != null && Object.hasOwnProperty.call(m, "externalContractID"))
                w.uint32(18).string(m.externalContractID);
            if (m.brand != null && Object.hasOwnProperty.call(m, "brand"))
                w.uint32(24).int32(m.brand);
            if (m.subbrand != null && Object.hasOwnProperty.call(m, "subbrand"))
                w.uint32(32).int32(m.subbrand);
            if (m.paymentMethod != null && Object.hasOwnProperty.call(m, "paymentMethod"))
                $root.payment3_paymentmethodpb.StripeMigrationPaymentMethod.encode(m.paymentMethod, w.uint32(42).fork()).ldelim();
            return w;
        };

        /**
         * Decodes a CreateMigrationPaymentMethodRequest message from the specified reader or buffer.
         * @function decode
         * @memberof payment3_paymentmethodpb.CreateMigrationPaymentMethodRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {payment3_paymentmethodpb.CreateMigrationPaymentMethodRequest} CreateMigrationPaymentMethodRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CreateMigrationPaymentMethodRequest.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.payment3_paymentmethodpb.CreateMigrationPaymentMethodRequest();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.externalPaymentMethodID = r.string();
                    break;
                case 2:
                    m.externalContractID = r.string();
                    break;
                case 3:
                    m.brand = r.int32();
                    break;
                case 4:
                    m.subbrand = r.int32();
                    break;
                case 5:
                    m.paymentMethod = $root.payment3_paymentmethodpb.StripeMigrationPaymentMethod.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return CreateMigrationPaymentMethodRequest;
    })();

    payment3_paymentmethodpb.StripeMigrationPaymentMethod = (function() {

        /**
         * Properties of a StripeMigrationPaymentMethod.
         * @memberof payment3_paymentmethodpb
         * @interface IStripeMigrationPaymentMethod
         * @property {string|null} [paymentMethodID] StripeMigrationPaymentMethod paymentMethodID
         * @property {string|null} [oldExternalPaymentMethodID] StripeMigrationPaymentMethod oldExternalPaymentMethodID
         * @property {payment3_paymentmethodpb.ICreditCardInfo|null} [creditCardInfo] StripeMigrationPaymentMethod creditCardInfo
         */

        /**
         * Constructs a new StripeMigrationPaymentMethod.
         * @memberof payment3_paymentmethodpb
         * @classdesc Represents a StripeMigrationPaymentMethod.
         * @implements IStripeMigrationPaymentMethod
         * @constructor
         * @param {payment3_paymentmethodpb.IStripeMigrationPaymentMethod=} [p] Properties to set
         */
        function StripeMigrationPaymentMethod(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * StripeMigrationPaymentMethod paymentMethodID.
         * @member {string} paymentMethodID
         * @memberof payment3_paymentmethodpb.StripeMigrationPaymentMethod
         * @instance
         */
        StripeMigrationPaymentMethod.prototype.paymentMethodID = "";

        /**
         * StripeMigrationPaymentMethod oldExternalPaymentMethodID.
         * @member {string} oldExternalPaymentMethodID
         * @memberof payment3_paymentmethodpb.StripeMigrationPaymentMethod
         * @instance
         */
        StripeMigrationPaymentMethod.prototype.oldExternalPaymentMethodID = "";

        /**
         * StripeMigrationPaymentMethod creditCardInfo.
         * @member {payment3_paymentmethodpb.ICreditCardInfo|null|undefined} creditCardInfo
         * @memberof payment3_paymentmethodpb.StripeMigrationPaymentMethod
         * @instance
         */
        StripeMigrationPaymentMethod.prototype.creditCardInfo = null;

        /**
         * Creates a new StripeMigrationPaymentMethod instance using the specified properties.
         * @function create
         * @memberof payment3_paymentmethodpb.StripeMigrationPaymentMethod
         * @static
         * @param {payment3_paymentmethodpb.IStripeMigrationPaymentMethod=} [properties] Properties to set
         * @returns {payment3_paymentmethodpb.StripeMigrationPaymentMethod} StripeMigrationPaymentMethod instance
         */
        StripeMigrationPaymentMethod.create = function create(properties) {
            return new StripeMigrationPaymentMethod(properties);
        };

        /**
         * Encodes the specified StripeMigrationPaymentMethod message. Does not implicitly {@link payment3_paymentmethodpb.StripeMigrationPaymentMethod.verify|verify} messages.
         * @function encode
         * @memberof payment3_paymentmethodpb.StripeMigrationPaymentMethod
         * @static
         * @param {payment3_paymentmethodpb.IStripeMigrationPaymentMethod} m StripeMigrationPaymentMethod message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        StripeMigrationPaymentMethod.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.paymentMethodID != null && Object.hasOwnProperty.call(m, "paymentMethodID"))
                w.uint32(10).string(m.paymentMethodID);
            if (m.oldExternalPaymentMethodID != null && Object.hasOwnProperty.call(m, "oldExternalPaymentMethodID"))
                w.uint32(18).string(m.oldExternalPaymentMethodID);
            if (m.creditCardInfo != null && Object.hasOwnProperty.call(m, "creditCardInfo"))
                $root.payment3_paymentmethodpb.CreditCardInfo.encode(m.creditCardInfo, w.uint32(26).fork()).ldelim();
            return w;
        };

        /**
         * Decodes a StripeMigrationPaymentMethod message from the specified reader or buffer.
         * @function decode
         * @memberof payment3_paymentmethodpb.StripeMigrationPaymentMethod
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {payment3_paymentmethodpb.StripeMigrationPaymentMethod} StripeMigrationPaymentMethod
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        StripeMigrationPaymentMethod.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.payment3_paymentmethodpb.StripeMigrationPaymentMethod();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.paymentMethodID = r.string();
                    break;
                case 2:
                    m.oldExternalPaymentMethodID = r.string();
                    break;
                case 3:
                    m.creditCardInfo = $root.payment3_paymentmethodpb.CreditCardInfo.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return StripeMigrationPaymentMethod;
    })();

    payment3_paymentmethodpb.CreditCardInfo = (function() {

        /**
         * Properties of a CreditCardInfo.
         * @memberof payment3_paymentmethodpb
         * @interface ICreditCardInfo
         * @property {string|null} [fingerprint] CreditCardInfo fingerprint
         * @property {payment3_paymentmethodpb.CreditCardBrand|null} [type] CreditCardInfo type
         * @property {string|null} [last4] CreditCardInfo last4
         * @property {common.IDate|null} [expirationDate] CreditCardInfo expirationDate
         */

        /**
         * Constructs a new CreditCardInfo.
         * @memberof payment3_paymentmethodpb
         * @classdesc Represents a CreditCardInfo.
         * @implements ICreditCardInfo
         * @constructor
         * @param {payment3_paymentmethodpb.ICreditCardInfo=} [p] Properties to set
         */
        function CreditCardInfo(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * CreditCardInfo fingerprint.
         * @member {string} fingerprint
         * @memberof payment3_paymentmethodpb.CreditCardInfo
         * @instance
         */
        CreditCardInfo.prototype.fingerprint = "";

        /**
         * CreditCardInfo type.
         * @member {payment3_paymentmethodpb.CreditCardBrand} type
         * @memberof payment3_paymentmethodpb.CreditCardInfo
         * @instance
         */
        CreditCardInfo.prototype.type = 0;

        /**
         * CreditCardInfo last4.
         * @member {string} last4
         * @memberof payment3_paymentmethodpb.CreditCardInfo
         * @instance
         */
        CreditCardInfo.prototype.last4 = "";

        /**
         * CreditCardInfo expirationDate.
         * @member {common.IDate|null|undefined} expirationDate
         * @memberof payment3_paymentmethodpb.CreditCardInfo
         * @instance
         */
        CreditCardInfo.prototype.expirationDate = null;

        /**
         * Creates a new CreditCardInfo instance using the specified properties.
         * @function create
         * @memberof payment3_paymentmethodpb.CreditCardInfo
         * @static
         * @param {payment3_paymentmethodpb.ICreditCardInfo=} [properties] Properties to set
         * @returns {payment3_paymentmethodpb.CreditCardInfo} CreditCardInfo instance
         */
        CreditCardInfo.create = function create(properties) {
            return new CreditCardInfo(properties);
        };

        /**
         * Encodes the specified CreditCardInfo message. Does not implicitly {@link payment3_paymentmethodpb.CreditCardInfo.verify|verify} messages.
         * @function encode
         * @memberof payment3_paymentmethodpb.CreditCardInfo
         * @static
         * @param {payment3_paymentmethodpb.ICreditCardInfo} m CreditCardInfo message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CreditCardInfo.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.fingerprint != null && Object.hasOwnProperty.call(m, "fingerprint"))
                w.uint32(10).string(m.fingerprint);
            if (m.type != null && Object.hasOwnProperty.call(m, "type"))
                w.uint32(16).int32(m.type);
            if (m.last4 != null && Object.hasOwnProperty.call(m, "last4"))
                w.uint32(26).string(m.last4);
            if (m.expirationDate != null && Object.hasOwnProperty.call(m, "expirationDate"))
                $root.common.Date.encode(m.expirationDate, w.uint32(34).fork()).ldelim();
            return w;
        };

        /**
         * Decodes a CreditCardInfo message from the specified reader or buffer.
         * @function decode
         * @memberof payment3_paymentmethodpb.CreditCardInfo
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {payment3_paymentmethodpb.CreditCardInfo} CreditCardInfo
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CreditCardInfo.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.payment3_paymentmethodpb.CreditCardInfo();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.fingerprint = r.string();
                    break;
                case 2:
                    m.type = r.int32();
                    break;
                case 3:
                    m.last4 = r.string();
                    break;
                case 4:
                    m.expirationDate = $root.common.Date.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return CreditCardInfo;
    })();

    payment3_paymentmethodpb.CreateMigrationPaymentMethodResponse = (function() {

        /**
         * Properties of a CreateMigrationPaymentMethodResponse.
         * @memberof payment3_paymentmethodpb
         * @interface ICreateMigrationPaymentMethodResponse
         * @property {string|null} [paymentMethodID] CreateMigrationPaymentMethodResponse paymentMethodID
         */

        /**
         * Constructs a new CreateMigrationPaymentMethodResponse.
         * @memberof payment3_paymentmethodpb
         * @classdesc Represents a CreateMigrationPaymentMethodResponse.
         * @implements ICreateMigrationPaymentMethodResponse
         * @constructor
         * @param {payment3_paymentmethodpb.ICreateMigrationPaymentMethodResponse=} [p] Properties to set
         */
        function CreateMigrationPaymentMethodResponse(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * CreateMigrationPaymentMethodResponse paymentMethodID.
         * @member {string} paymentMethodID
         * @memberof payment3_paymentmethodpb.CreateMigrationPaymentMethodResponse
         * @instance
         */
        CreateMigrationPaymentMethodResponse.prototype.paymentMethodID = "";

        /**
         * Creates a new CreateMigrationPaymentMethodResponse instance using the specified properties.
         * @function create
         * @memberof payment3_paymentmethodpb.CreateMigrationPaymentMethodResponse
         * @static
         * @param {payment3_paymentmethodpb.ICreateMigrationPaymentMethodResponse=} [properties] Properties to set
         * @returns {payment3_paymentmethodpb.CreateMigrationPaymentMethodResponse} CreateMigrationPaymentMethodResponse instance
         */
        CreateMigrationPaymentMethodResponse.create = function create(properties) {
            return new CreateMigrationPaymentMethodResponse(properties);
        };

        /**
         * Encodes the specified CreateMigrationPaymentMethodResponse message. Does not implicitly {@link payment3_paymentmethodpb.CreateMigrationPaymentMethodResponse.verify|verify} messages.
         * @function encode
         * @memberof payment3_paymentmethodpb.CreateMigrationPaymentMethodResponse
         * @static
         * @param {payment3_paymentmethodpb.ICreateMigrationPaymentMethodResponse} m CreateMigrationPaymentMethodResponse message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CreateMigrationPaymentMethodResponse.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.paymentMethodID != null && Object.hasOwnProperty.call(m, "paymentMethodID"))
                w.uint32(10).string(m.paymentMethodID);
            return w;
        };

        /**
         * Decodes a CreateMigrationPaymentMethodResponse message from the specified reader or buffer.
         * @function decode
         * @memberof payment3_paymentmethodpb.CreateMigrationPaymentMethodResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {payment3_paymentmethodpb.CreateMigrationPaymentMethodResponse} CreateMigrationPaymentMethodResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CreateMigrationPaymentMethodResponse.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.payment3_paymentmethodpb.CreateMigrationPaymentMethodResponse();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.paymentMethodID = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return CreateMigrationPaymentMethodResponse;
    })();

    return payment3_paymentmethodpb;
})();

export const payment3_stripe_gatewaypb = $root.payment3_stripe_gatewaypb = (() => {

    /**
     * Namespace payment3_stripe_gatewaypb.
     * @exports payment3_stripe_gatewaypb
     * @namespace
     */
    const payment3_stripe_gatewaypb = {};

    payment3_stripe_gatewaypb.StripeRegistrationInternal = (function() {

        /**
         * Properties of a StripeRegistrationInternal.
         * @memberof payment3_stripe_gatewaypb
         * @interface IStripeRegistrationInternal
         * @property {string|null} [setupIntent] StripeRegistrationInternal setupIntent
         */

        /**
         * Constructs a new StripeRegistrationInternal.
         * @memberof payment3_stripe_gatewaypb
         * @classdesc Represents a StripeRegistrationInternal.
         * @implements IStripeRegistrationInternal
         * @constructor
         * @param {payment3_stripe_gatewaypb.IStripeRegistrationInternal=} [p] Properties to set
         */
        function StripeRegistrationInternal(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * StripeRegistrationInternal setupIntent.
         * @member {string} setupIntent
         * @memberof payment3_stripe_gatewaypb.StripeRegistrationInternal
         * @instance
         */
        StripeRegistrationInternal.prototype.setupIntent = "";

        /**
         * Creates a new StripeRegistrationInternal instance using the specified properties.
         * @function create
         * @memberof payment3_stripe_gatewaypb.StripeRegistrationInternal
         * @static
         * @param {payment3_stripe_gatewaypb.IStripeRegistrationInternal=} [properties] Properties to set
         * @returns {payment3_stripe_gatewaypb.StripeRegistrationInternal} StripeRegistrationInternal instance
         */
        StripeRegistrationInternal.create = function create(properties) {
            return new StripeRegistrationInternal(properties);
        };

        /**
         * Encodes the specified StripeRegistrationInternal message. Does not implicitly {@link payment3_stripe_gatewaypb.StripeRegistrationInternal.verify|verify} messages.
         * @function encode
         * @memberof payment3_stripe_gatewaypb.StripeRegistrationInternal
         * @static
         * @param {payment3_stripe_gatewaypb.IStripeRegistrationInternal} m StripeRegistrationInternal message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        StripeRegistrationInternal.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.setupIntent != null && Object.hasOwnProperty.call(m, "setupIntent"))
                w.uint32(802).string(m.setupIntent);
            return w;
        };

        /**
         * Decodes a StripeRegistrationInternal message from the specified reader or buffer.
         * @function decode
         * @memberof payment3_stripe_gatewaypb.StripeRegistrationInternal
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {payment3_stripe_gatewaypb.StripeRegistrationInternal} StripeRegistrationInternal
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        StripeRegistrationInternal.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.payment3_stripe_gatewaypb.StripeRegistrationInternal();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 100:
                    m.setupIntent = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return StripeRegistrationInternal;
    })();

    payment3_stripe_gatewaypb.StripeRegistration = (function() {

        /**
         * Properties of a StripeRegistration.
         * @memberof payment3_stripe_gatewaypb
         * @interface IStripeRegistration
         * @property {string|null} [publicKey] StripeRegistration publicKey
         * @property {string|null} [setupIntentClientSecret] StripeRegistration setupIntentClientSecret
         * @property {string|null} [setupIntentID] StripeRegistration setupIntentID
         */

        /**
         * Constructs a new StripeRegistration.
         * @memberof payment3_stripe_gatewaypb
         * @classdesc Represents a StripeRegistration.
         * @implements IStripeRegistration
         * @constructor
         * @param {payment3_stripe_gatewaypb.IStripeRegistration=} [p] Properties to set
         */
        function StripeRegistration(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * StripeRegistration publicKey.
         * @member {string} publicKey
         * @memberof payment3_stripe_gatewaypb.StripeRegistration
         * @instance
         */
        StripeRegistration.prototype.publicKey = "";

        /**
         * StripeRegistration setupIntentClientSecret.
         * @member {string} setupIntentClientSecret
         * @memberof payment3_stripe_gatewaypb.StripeRegistration
         * @instance
         */
        StripeRegistration.prototype.setupIntentClientSecret = "";

        /**
         * StripeRegistration setupIntentID.
         * @member {string} setupIntentID
         * @memberof payment3_stripe_gatewaypb.StripeRegistration
         * @instance
         */
        StripeRegistration.prototype.setupIntentID = "";

        /**
         * Creates a new StripeRegistration instance using the specified properties.
         * @function create
         * @memberof payment3_stripe_gatewaypb.StripeRegistration
         * @static
         * @param {payment3_stripe_gatewaypb.IStripeRegistration=} [properties] Properties to set
         * @returns {payment3_stripe_gatewaypb.StripeRegistration} StripeRegistration instance
         */
        StripeRegistration.create = function create(properties) {
            return new StripeRegistration(properties);
        };

        /**
         * Encodes the specified StripeRegistration message. Does not implicitly {@link payment3_stripe_gatewaypb.StripeRegistration.verify|verify} messages.
         * @function encode
         * @memberof payment3_stripe_gatewaypb.StripeRegistration
         * @static
         * @param {payment3_stripe_gatewaypb.IStripeRegistration} m StripeRegistration message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        StripeRegistration.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.publicKey != null && Object.hasOwnProperty.call(m, "publicKey"))
                w.uint32(802).string(m.publicKey);
            if (m.setupIntentClientSecret != null && Object.hasOwnProperty.call(m, "setupIntentClientSecret"))
                w.uint32(1602).string(m.setupIntentClientSecret);
            if (m.setupIntentID != null && Object.hasOwnProperty.call(m, "setupIntentID"))
                w.uint32(2402).string(m.setupIntentID);
            return w;
        };

        /**
         * Decodes a StripeRegistration message from the specified reader or buffer.
         * @function decode
         * @memberof payment3_stripe_gatewaypb.StripeRegistration
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {payment3_stripe_gatewaypb.StripeRegistration} StripeRegistration
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        StripeRegistration.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.payment3_stripe_gatewaypb.StripeRegistration();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 100:
                    m.publicKey = r.string();
                    break;
                case 200:
                    m.setupIntentClientSecret = r.string();
                    break;
                case 300:
                    m.setupIntentID = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return StripeRegistration;
    })();

    /**
     * PaymentIntentStatus enum.
     * @name payment3_stripe_gatewaypb.PaymentIntentStatus
     * @enum {number}
     * @property {number} Unknown_PaymentIntentStatus=0 Unknown_PaymentIntentStatus value
     * @property {number} succeeded=900 succeeded value
     * @property {number} requiresPaymentMethod=901 requiresPaymentMethod value
     * @property {number} requiresConfirmation=902 requiresConfirmation value
     * @property {number} requiresAction=903 requiresAction value
     * @property {number} requiresCapture=904 requiresCapture value
     * @property {number} canceled=905 canceled value
     * @property {number} processing=906 processing value
     */
    payment3_stripe_gatewaypb.PaymentIntentStatus = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "Unknown_PaymentIntentStatus"] = 0;
        values[valuesById[900] = "succeeded"] = 900;
        values[valuesById[901] = "requiresPaymentMethod"] = 901;
        values[valuesById[902] = "requiresConfirmation"] = 902;
        values[valuesById[903] = "requiresAction"] = 903;
        values[valuesById[904] = "requiresCapture"] = 904;
        values[valuesById[905] = "canceled"] = 905;
        values[valuesById[906] = "processing"] = 906;
        return values;
    })();

    payment3_stripe_gatewaypb.StripeRefundCriteria = (function() {

        /**
         * Properties of a StripeRefundCriteria.
         * @memberof payment3_stripe_gatewaypb
         * @interface IStripeRefundCriteria
         * @property {Array.<string>|null} [paymentIntentId] StripeRefundCriteria paymentIntentId
         * @property {Array.<string>|null} [chargeId] StripeRefundCriteria chargeId
         * @property {payment3_commonpb.Brand|null} [brand] StripeRefundCriteria brand
         * @property {payment3_commonpb.Subbrand|null} [subbrand] StripeRefundCriteria subbrand
         */

        /**
         * Constructs a new StripeRefundCriteria.
         * @memberof payment3_stripe_gatewaypb
         * @classdesc Represents a StripeRefundCriteria.
         * @implements IStripeRefundCriteria
         * @constructor
         * @param {payment3_stripe_gatewaypb.IStripeRefundCriteria=} [p] Properties to set
         */
        function StripeRefundCriteria(p) {
            this.paymentIntentId = [];
            this.chargeId = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * StripeRefundCriteria paymentIntentId.
         * @member {Array.<string>} paymentIntentId
         * @memberof payment3_stripe_gatewaypb.StripeRefundCriteria
         * @instance
         */
        StripeRefundCriteria.prototype.paymentIntentId = $util.emptyArray;

        /**
         * StripeRefundCriteria chargeId.
         * @member {Array.<string>} chargeId
         * @memberof payment3_stripe_gatewaypb.StripeRefundCriteria
         * @instance
         */
        StripeRefundCriteria.prototype.chargeId = $util.emptyArray;

        /**
         * StripeRefundCriteria brand.
         * @member {payment3_commonpb.Brand} brand
         * @memberof payment3_stripe_gatewaypb.StripeRefundCriteria
         * @instance
         */
        StripeRefundCriteria.prototype.brand = 0;

        /**
         * StripeRefundCriteria subbrand.
         * @member {payment3_commonpb.Subbrand} subbrand
         * @memberof payment3_stripe_gatewaypb.StripeRefundCriteria
         * @instance
         */
        StripeRefundCriteria.prototype.subbrand = 0;

        /**
         * Creates a new StripeRefundCriteria instance using the specified properties.
         * @function create
         * @memberof payment3_stripe_gatewaypb.StripeRefundCriteria
         * @static
         * @param {payment3_stripe_gatewaypb.IStripeRefundCriteria=} [properties] Properties to set
         * @returns {payment3_stripe_gatewaypb.StripeRefundCriteria} StripeRefundCriteria instance
         */
        StripeRefundCriteria.create = function create(properties) {
            return new StripeRefundCriteria(properties);
        };

        /**
         * Encodes the specified StripeRefundCriteria message. Does not implicitly {@link payment3_stripe_gatewaypb.StripeRefundCriteria.verify|verify} messages.
         * @function encode
         * @memberof payment3_stripe_gatewaypb.StripeRefundCriteria
         * @static
         * @param {payment3_stripe_gatewaypb.IStripeRefundCriteria} m StripeRefundCriteria message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        StripeRefundCriteria.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.paymentIntentId != null && m.paymentIntentId.length) {
                for (var i = 0; i < m.paymentIntentId.length; ++i)
                    w.uint32(82).string(m.paymentIntentId[i]);
            }
            if (m.chargeId != null && m.chargeId.length) {
                for (var i = 0; i < m.chargeId.length; ++i)
                    w.uint32(162).string(m.chargeId[i]);
            }
            if (m.brand != null && Object.hasOwnProperty.call(m, "brand"))
                w.uint32(240).int32(m.brand);
            if (m.subbrand != null && Object.hasOwnProperty.call(m, "subbrand"))
                w.uint32(320).int32(m.subbrand);
            return w;
        };

        /**
         * Decodes a StripeRefundCriteria message from the specified reader or buffer.
         * @function decode
         * @memberof payment3_stripe_gatewaypb.StripeRefundCriteria
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {payment3_stripe_gatewaypb.StripeRefundCriteria} StripeRefundCriteria
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        StripeRefundCriteria.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.payment3_stripe_gatewaypb.StripeRefundCriteria();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 10:
                    if (!(m.paymentIntentId && m.paymentIntentId.length))
                        m.paymentIntentId = [];
                    m.paymentIntentId.push(r.string());
                    break;
                case 20:
                    if (!(m.chargeId && m.chargeId.length))
                        m.chargeId = [];
                    m.chargeId.push(r.string());
                    break;
                case 30:
                    m.brand = r.int32();
                    break;
                case 40:
                    m.subbrand = r.int32();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return StripeRefundCriteria;
    })();

    return payment3_stripe_gatewaypb;
})();

export const payment3_paymentus_gatewaypb = $root.payment3_paymentus_gatewaypb = (() => {

    /**
     * Namespace payment3_paymentus_gatewaypb.
     * @exports payment3_paymentus_gatewaypb
     * @namespace
     */
    const payment3_paymentus_gatewaypb = {};

    payment3_paymentus_gatewaypb.PaymentusRegistrationInternal = (function() {

        /**
         * Properties of a PaymentusRegistrationInternal.
         * @memberof payment3_paymentus_gatewaypb
         * @interface IPaymentusRegistrationInternal
         * @property {number|Long|null} [externalReference] PaymentusRegistrationInternal externalReference
         * @property {string|null} [email] PaymentusRegistrationInternal email
         */

        /**
         * Constructs a new PaymentusRegistrationInternal.
         * @memberof payment3_paymentus_gatewaypb
         * @classdesc Represents a PaymentusRegistrationInternal.
         * @implements IPaymentusRegistrationInternal
         * @constructor
         * @param {payment3_paymentus_gatewaypb.IPaymentusRegistrationInternal=} [p] Properties to set
         */
        function PaymentusRegistrationInternal(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * PaymentusRegistrationInternal externalReference.
         * @member {number|Long} externalReference
         * @memberof payment3_paymentus_gatewaypb.PaymentusRegistrationInternal
         * @instance
         */
        PaymentusRegistrationInternal.prototype.externalReference = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * PaymentusRegistrationInternal email.
         * @member {string} email
         * @memberof payment3_paymentus_gatewaypb.PaymentusRegistrationInternal
         * @instance
         */
        PaymentusRegistrationInternal.prototype.email = "";

        /**
         * Creates a new PaymentusRegistrationInternal instance using the specified properties.
         * @function create
         * @memberof payment3_paymentus_gatewaypb.PaymentusRegistrationInternal
         * @static
         * @param {payment3_paymentus_gatewaypb.IPaymentusRegistrationInternal=} [properties] Properties to set
         * @returns {payment3_paymentus_gatewaypb.PaymentusRegistrationInternal} PaymentusRegistrationInternal instance
         */
        PaymentusRegistrationInternal.create = function create(properties) {
            return new PaymentusRegistrationInternal(properties);
        };

        /**
         * Encodes the specified PaymentusRegistrationInternal message. Does not implicitly {@link payment3_paymentus_gatewaypb.PaymentusRegistrationInternal.verify|verify} messages.
         * @function encode
         * @memberof payment3_paymentus_gatewaypb.PaymentusRegistrationInternal
         * @static
         * @param {payment3_paymentus_gatewaypb.IPaymentusRegistrationInternal} m PaymentusRegistrationInternal message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PaymentusRegistrationInternal.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.externalReference != null && Object.hasOwnProperty.call(m, "externalReference"))
                w.uint32(800).int64(m.externalReference);
            if (m.email != null && Object.hasOwnProperty.call(m, "email"))
                w.uint32(1002).string(m.email);
            return w;
        };

        /**
         * Decodes a PaymentusRegistrationInternal message from the specified reader or buffer.
         * @function decode
         * @memberof payment3_paymentus_gatewaypb.PaymentusRegistrationInternal
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {payment3_paymentus_gatewaypb.PaymentusRegistrationInternal} PaymentusRegistrationInternal
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PaymentusRegistrationInternal.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.payment3_paymentus_gatewaypb.PaymentusRegistrationInternal();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 100:
                    m.externalReference = r.int64();
                    break;
                case 125:
                    m.email = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return PaymentusRegistrationInternal;
    })();

    payment3_paymentus_gatewaypb.PaymentusRegistration = (function() {

        /**
         * Properties of a PaymentusRegistration.
         * @memberof payment3_paymentus_gatewaypb
         * @interface IPaymentusRegistration
         * @property {string|null} [authSSOToken] PaymentusRegistration authSSOToken
         * @property {string|null} [encodedRegistrationPayload] PaymentusRegistration encodedRegistrationPayload
         */

        /**
         * Constructs a new PaymentusRegistration.
         * @memberof payment3_paymentus_gatewaypb
         * @classdesc Represents a PaymentusRegistration.
         * @implements IPaymentusRegistration
         * @constructor
         * @param {payment3_paymentus_gatewaypb.IPaymentusRegistration=} [p] Properties to set
         */
        function PaymentusRegistration(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * PaymentusRegistration authSSOToken.
         * @member {string} authSSOToken
         * @memberof payment3_paymentus_gatewaypb.PaymentusRegistration
         * @instance
         */
        PaymentusRegistration.prototype.authSSOToken = "";

        /**
         * PaymentusRegistration encodedRegistrationPayload.
         * @member {string} encodedRegistrationPayload
         * @memberof payment3_paymentus_gatewaypb.PaymentusRegistration
         * @instance
         */
        PaymentusRegistration.prototype.encodedRegistrationPayload = "";

        /**
         * Creates a new PaymentusRegistration instance using the specified properties.
         * @function create
         * @memberof payment3_paymentus_gatewaypb.PaymentusRegistration
         * @static
         * @param {payment3_paymentus_gatewaypb.IPaymentusRegistration=} [properties] Properties to set
         * @returns {payment3_paymentus_gatewaypb.PaymentusRegistration} PaymentusRegistration instance
         */
        PaymentusRegistration.create = function create(properties) {
            return new PaymentusRegistration(properties);
        };

        /**
         * Encodes the specified PaymentusRegistration message. Does not implicitly {@link payment3_paymentus_gatewaypb.PaymentusRegistration.verify|verify} messages.
         * @function encode
         * @memberof payment3_paymentus_gatewaypb.PaymentusRegistration
         * @static
         * @param {payment3_paymentus_gatewaypb.IPaymentusRegistration} m PaymentusRegistration message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PaymentusRegistration.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.authSSOToken != null && Object.hasOwnProperty.call(m, "authSSOToken"))
                w.uint32(802).string(m.authSSOToken);
            if (m.encodedRegistrationPayload != null && Object.hasOwnProperty.call(m, "encodedRegistrationPayload"))
                w.uint32(1002).string(m.encodedRegistrationPayload);
            return w;
        };

        /**
         * Decodes a PaymentusRegistration message from the specified reader or buffer.
         * @function decode
         * @memberof payment3_paymentus_gatewaypb.PaymentusRegistration
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {payment3_paymentus_gatewaypb.PaymentusRegistration} PaymentusRegistration
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PaymentusRegistration.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.payment3_paymentus_gatewaypb.PaymentusRegistration();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 100:
                    m.authSSOToken = r.string();
                    break;
                case 125:
                    m.encodedRegistrationPayload = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return PaymentusRegistration;
    })();

    payment3_paymentus_gatewaypb.RegistrationPayload = (function() {

        /**
         * Properties of a RegistrationPayload.
         * @memberof payment3_paymentus_gatewaypb
         * @interface IRegistrationPayload
         * @property {string|null} [externalOwnerId] RegistrationPayload externalOwnerId
         * @property {string|null} [paymentusAccountToken] RegistrationPayload paymentusAccountToken
         * @property {string|null} [routingNumber] RegistrationPayload routingNumber
         * @property {string|null} [last4] RegistrationPayload last4
         */

        /**
         * Constructs a new RegistrationPayload.
         * @memberof payment3_paymentus_gatewaypb
         * @classdesc Represents a RegistrationPayload.
         * @implements IRegistrationPayload
         * @constructor
         * @param {payment3_paymentus_gatewaypb.IRegistrationPayload=} [p] Properties to set
         */
        function RegistrationPayload(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * RegistrationPayload externalOwnerId.
         * @member {string} externalOwnerId
         * @memberof payment3_paymentus_gatewaypb.RegistrationPayload
         * @instance
         */
        RegistrationPayload.prototype.externalOwnerId = "";

        /**
         * RegistrationPayload paymentusAccountToken.
         * @member {string} paymentusAccountToken
         * @memberof payment3_paymentus_gatewaypb.RegistrationPayload
         * @instance
         */
        RegistrationPayload.prototype.paymentusAccountToken = "";

        /**
         * RegistrationPayload routingNumber.
         * @member {string} routingNumber
         * @memberof payment3_paymentus_gatewaypb.RegistrationPayload
         * @instance
         */
        RegistrationPayload.prototype.routingNumber = "";

        /**
         * RegistrationPayload last4.
         * @member {string} last4
         * @memberof payment3_paymentus_gatewaypb.RegistrationPayload
         * @instance
         */
        RegistrationPayload.prototype.last4 = "";

        /**
         * Creates a new RegistrationPayload instance using the specified properties.
         * @function create
         * @memberof payment3_paymentus_gatewaypb.RegistrationPayload
         * @static
         * @param {payment3_paymentus_gatewaypb.IRegistrationPayload=} [properties] Properties to set
         * @returns {payment3_paymentus_gatewaypb.RegistrationPayload} RegistrationPayload instance
         */
        RegistrationPayload.create = function create(properties) {
            return new RegistrationPayload(properties);
        };

        /**
         * Encodes the specified RegistrationPayload message. Does not implicitly {@link payment3_paymentus_gatewaypb.RegistrationPayload.verify|verify} messages.
         * @function encode
         * @memberof payment3_paymentus_gatewaypb.RegistrationPayload
         * @static
         * @param {payment3_paymentus_gatewaypb.IRegistrationPayload} m RegistrationPayload message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RegistrationPayload.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.externalOwnerId != null && Object.hasOwnProperty.call(m, "externalOwnerId"))
                w.uint32(802).string(m.externalOwnerId);
            if (m.paymentusAccountToken != null && Object.hasOwnProperty.call(m, "paymentusAccountToken"))
                w.uint32(1002).string(m.paymentusAccountToken);
            if (m.routingNumber != null && Object.hasOwnProperty.call(m, "routingNumber"))
                w.uint32(1202).string(m.routingNumber);
            if (m.last4 != null && Object.hasOwnProperty.call(m, "last4"))
                w.uint32(1402).string(m.last4);
            return w;
        };

        /**
         * Decodes a RegistrationPayload message from the specified reader or buffer.
         * @function decode
         * @memberof payment3_paymentus_gatewaypb.RegistrationPayload
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {payment3_paymentus_gatewaypb.RegistrationPayload} RegistrationPayload
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RegistrationPayload.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.payment3_paymentus_gatewaypb.RegistrationPayload();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 100:
                    m.externalOwnerId = r.string();
                    break;
                case 125:
                    m.paymentusAccountToken = r.string();
                    break;
                case 150:
                    m.routingNumber = r.string();
                    break;
                case 175:
                    m.last4 = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return RegistrationPayload;
    })();

    return payment3_paymentus_gatewaypb;
})();

export const payment3_braintree_gatewaypb = $root.payment3_braintree_gatewaypb = (() => {

    /**
     * Namespace payment3_braintree_gatewaypb.
     * @exports payment3_braintree_gatewaypb
     * @namespace
     */
    const payment3_braintree_gatewaypb = {};

    payment3_braintree_gatewaypb.BraintreeRegistrationInternal = (function() {

        /**
         * Properties of a BraintreeRegistrationInternal.
         * @memberof payment3_braintree_gatewaypb
         * @interface IBraintreeRegistrationInternal
         */

        /**
         * Constructs a new BraintreeRegistrationInternal.
         * @memberof payment3_braintree_gatewaypb
         * @classdesc Represents a BraintreeRegistrationInternal.
         * @implements IBraintreeRegistrationInternal
         * @constructor
         * @param {payment3_braintree_gatewaypb.IBraintreeRegistrationInternal=} [p] Properties to set
         */
        function BraintreeRegistrationInternal(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * Creates a new BraintreeRegistrationInternal instance using the specified properties.
         * @function create
         * @memberof payment3_braintree_gatewaypb.BraintreeRegistrationInternal
         * @static
         * @param {payment3_braintree_gatewaypb.IBraintreeRegistrationInternal=} [properties] Properties to set
         * @returns {payment3_braintree_gatewaypb.BraintreeRegistrationInternal} BraintreeRegistrationInternal instance
         */
        BraintreeRegistrationInternal.create = function create(properties) {
            return new BraintreeRegistrationInternal(properties);
        };

        /**
         * Encodes the specified BraintreeRegistrationInternal message. Does not implicitly {@link payment3_braintree_gatewaypb.BraintreeRegistrationInternal.verify|verify} messages.
         * @function encode
         * @memberof payment3_braintree_gatewaypb.BraintreeRegistrationInternal
         * @static
         * @param {payment3_braintree_gatewaypb.IBraintreeRegistrationInternal} m BraintreeRegistrationInternal message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        BraintreeRegistrationInternal.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            return w;
        };

        /**
         * Decodes a BraintreeRegistrationInternal message from the specified reader or buffer.
         * @function decode
         * @memberof payment3_braintree_gatewaypb.BraintreeRegistrationInternal
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {payment3_braintree_gatewaypb.BraintreeRegistrationInternal} BraintreeRegistrationInternal
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        BraintreeRegistrationInternal.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.payment3_braintree_gatewaypb.BraintreeRegistrationInternal();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return BraintreeRegistrationInternal;
    })();

    payment3_braintree_gatewaypb.BraintreeRegistration = (function() {

        /**
         * Properties of a BraintreeRegistration.
         * @memberof payment3_braintree_gatewaypb
         * @interface IBraintreeRegistration
         * @property {string|null} [payPalClientID] BraintreeRegistration payPalClientID
         * @property {string|null} [clientToken] BraintreeRegistration clientToken
         * @property {string|null} [merchantDisplayName] BraintreeRegistration merchantDisplayName
         */

        /**
         * Constructs a new BraintreeRegistration.
         * @memberof payment3_braintree_gatewaypb
         * @classdesc Represents a BraintreeRegistration.
         * @implements IBraintreeRegistration
         * @constructor
         * @param {payment3_braintree_gatewaypb.IBraintreeRegistration=} [p] Properties to set
         */
        function BraintreeRegistration(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * BraintreeRegistration payPalClientID.
         * @member {string} payPalClientID
         * @memberof payment3_braintree_gatewaypb.BraintreeRegistration
         * @instance
         */
        BraintreeRegistration.prototype.payPalClientID = "";

        /**
         * BraintreeRegistration clientToken.
         * @member {string} clientToken
         * @memberof payment3_braintree_gatewaypb.BraintreeRegistration
         * @instance
         */
        BraintreeRegistration.prototype.clientToken = "";

        /**
         * BraintreeRegistration merchantDisplayName.
         * @member {string} merchantDisplayName
         * @memberof payment3_braintree_gatewaypb.BraintreeRegistration
         * @instance
         */
        BraintreeRegistration.prototype.merchantDisplayName = "";

        /**
         * Creates a new BraintreeRegistration instance using the specified properties.
         * @function create
         * @memberof payment3_braintree_gatewaypb.BraintreeRegistration
         * @static
         * @param {payment3_braintree_gatewaypb.IBraintreeRegistration=} [properties] Properties to set
         * @returns {payment3_braintree_gatewaypb.BraintreeRegistration} BraintreeRegistration instance
         */
        BraintreeRegistration.create = function create(properties) {
            return new BraintreeRegistration(properties);
        };

        /**
         * Encodes the specified BraintreeRegistration message. Does not implicitly {@link payment3_braintree_gatewaypb.BraintreeRegistration.verify|verify} messages.
         * @function encode
         * @memberof payment3_braintree_gatewaypb.BraintreeRegistration
         * @static
         * @param {payment3_braintree_gatewaypb.IBraintreeRegistration} m BraintreeRegistration message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        BraintreeRegistration.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.payPalClientID != null && Object.hasOwnProperty.call(m, "payPalClientID"))
                w.uint32(82).string(m.payPalClientID);
            if (m.clientToken != null && Object.hasOwnProperty.call(m, "clientToken"))
                w.uint32(162).string(m.clientToken);
            if (m.merchantDisplayName != null && Object.hasOwnProperty.call(m, "merchantDisplayName"))
                w.uint32(242).string(m.merchantDisplayName);
            return w;
        };

        /**
         * Decodes a BraintreeRegistration message from the specified reader or buffer.
         * @function decode
         * @memberof payment3_braintree_gatewaypb.BraintreeRegistration
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {payment3_braintree_gatewaypb.BraintreeRegistration} BraintreeRegistration
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        BraintreeRegistration.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.payment3_braintree_gatewaypb.BraintreeRegistration();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 10:
                    m.payPalClientID = r.string();
                    break;
                case 20:
                    m.clientToken = r.string();
                    break;
                case 30:
                    m.merchantDisplayName = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return BraintreeRegistration;
    })();

    /**
     * BraintreeTransactionStatus enum.
     * @name payment3_braintree_gatewaypb.BraintreeTransactionStatus
     * @enum {number}
     * @property {number} Unknown_TransactionStatus=0 Unknown_TransactionStatus value
     * @property {number} authorized=100 authorized value
     * @property {number} submittedForSettlement=101 submittedForSettlement value
     * @property {number} settling=102 settling value
     * @property {number} settled=103 settled value
     * @property {number} processorDeclined=104 processorDeclined value
     * @property {number} gatewayRejected=105 gatewayRejected value
     * @property {number} failed=106 failed value
     * @property {number} voided=107 voided value
     * @property {number} settlementDeclined=108 settlementDeclined value
     * @property {number} settlementPending=109 settlementPending value
     * @property {number} settlementConfirmed=110 settlementConfirmed value
     * @property {number} open=111 open value
     * @property {number} accepted=112 accepted value
     * @property {number} disputed=113 disputed value
     * @property {number} expired=114 expired value
     */
    payment3_braintree_gatewaypb.BraintreeTransactionStatus = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "Unknown_TransactionStatus"] = 0;
        values[valuesById[100] = "authorized"] = 100;
        values[valuesById[101] = "submittedForSettlement"] = 101;
        values[valuesById[102] = "settling"] = 102;
        values[valuesById[103] = "settled"] = 103;
        values[valuesById[104] = "processorDeclined"] = 104;
        values[valuesById[105] = "gatewayRejected"] = 105;
        values[valuesById[106] = "failed"] = 106;
        values[valuesById[107] = "voided"] = 107;
        values[valuesById[108] = "settlementDeclined"] = 108;
        values[valuesById[109] = "settlementPending"] = 109;
        values[valuesById[110] = "settlementConfirmed"] = 110;
        values[valuesById[111] = "open"] = 111;
        values[valuesById[112] = "accepted"] = 112;
        values[valuesById[113] = "disputed"] = 113;
        values[valuesById[114] = "expired"] = 114;
        return values;
    })();

    return payment3_braintree_gatewaypb;
})();

export const contractpb = $root.contractpb = (() => {

    /**
     * Namespace contractpb.
     * @exports contractpb
     * @namespace
     */
    const contractpb = {};

    contractpb.HealthCheckDetail = (function() {

        /**
         * Properties of a HealthCheckDetail.
         * @memberof contractpb
         * @interface IHealthCheckDetail
         * @property {string|null} [componentID] HealthCheckDetail componentID
         * @property {string|null} [type] HealthCheckDetail type
         * @property {number|null} [observedValue] HealthCheckDetail observedValue
         * @property {string|null} [observedUnit] HealthCheckDetail observedUnit
         * @property {string|null} [status] HealthCheckDetail status
         * @property {google.protobuf.ITimestamp|null} [time] HealthCheckDetail time
         * @property {string|null} [output] HealthCheckDetail output
         */

        /**
         * Constructs a new HealthCheckDetail.
         * @memberof contractpb
         * @classdesc Represents a HealthCheckDetail.
         * @implements IHealthCheckDetail
         * @constructor
         * @param {contractpb.IHealthCheckDetail=} [p] Properties to set
         */
        function HealthCheckDetail(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * HealthCheckDetail componentID.
         * @member {string} componentID
         * @memberof contractpb.HealthCheckDetail
         * @instance
         */
        HealthCheckDetail.prototype.componentID = "";

        /**
         * HealthCheckDetail type.
         * @member {string} type
         * @memberof contractpb.HealthCheckDetail
         * @instance
         */
        HealthCheckDetail.prototype.type = "";

        /**
         * HealthCheckDetail observedValue.
         * @member {number} observedValue
         * @memberof contractpb.HealthCheckDetail
         * @instance
         */
        HealthCheckDetail.prototype.observedValue = 0;

        /**
         * HealthCheckDetail observedUnit.
         * @member {string} observedUnit
         * @memberof contractpb.HealthCheckDetail
         * @instance
         */
        HealthCheckDetail.prototype.observedUnit = "";

        /**
         * HealthCheckDetail status.
         * @member {string} status
         * @memberof contractpb.HealthCheckDetail
         * @instance
         */
        HealthCheckDetail.prototype.status = "";

        /**
         * HealthCheckDetail time.
         * @member {google.protobuf.ITimestamp|null|undefined} time
         * @memberof contractpb.HealthCheckDetail
         * @instance
         */
        HealthCheckDetail.prototype.time = null;

        /**
         * HealthCheckDetail output.
         * @member {string} output
         * @memberof contractpb.HealthCheckDetail
         * @instance
         */
        HealthCheckDetail.prototype.output = "";

        /**
         * Creates a new HealthCheckDetail instance using the specified properties.
         * @function create
         * @memberof contractpb.HealthCheckDetail
         * @static
         * @param {contractpb.IHealthCheckDetail=} [properties] Properties to set
         * @returns {contractpb.HealthCheckDetail} HealthCheckDetail instance
         */
        HealthCheckDetail.create = function create(properties) {
            return new HealthCheckDetail(properties);
        };

        /**
         * Encodes the specified HealthCheckDetail message. Does not implicitly {@link contractpb.HealthCheckDetail.verify|verify} messages.
         * @function encode
         * @memberof contractpb.HealthCheckDetail
         * @static
         * @param {contractpb.IHealthCheckDetail} m HealthCheckDetail message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        HealthCheckDetail.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.componentID != null && Object.hasOwnProperty.call(m, "componentID"))
                w.uint32(10).string(m.componentID);
            if (m.type != null && Object.hasOwnProperty.call(m, "type"))
                w.uint32(18).string(m.type);
            if (m.observedValue != null && Object.hasOwnProperty.call(m, "observedValue"))
                w.uint32(25).double(m.observedValue);
            if (m.observedUnit != null && Object.hasOwnProperty.call(m, "observedUnit"))
                w.uint32(34).string(m.observedUnit);
            if (m.status != null && Object.hasOwnProperty.call(m, "status"))
                w.uint32(42).string(m.status);
            if (m.time != null && Object.hasOwnProperty.call(m, "time"))
                $root.google.protobuf.Timestamp.encode(m.time, w.uint32(50).fork()).ldelim();
            if (m.output != null && Object.hasOwnProperty.call(m, "output"))
                w.uint32(58).string(m.output);
            return w;
        };

        /**
         * Decodes a HealthCheckDetail message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.HealthCheckDetail
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.HealthCheckDetail} HealthCheckDetail
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        HealthCheckDetail.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.HealthCheckDetail();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.componentID = r.string();
                    break;
                case 2:
                    m.type = r.string();
                    break;
                case 3:
                    m.observedValue = r.double();
                    break;
                case 4:
                    m.observedUnit = r.string();
                    break;
                case 5:
                    m.status = r.string();
                    break;
                case 6:
                    m.time = $root.google.protobuf.Timestamp.decode(r, r.uint32());
                    break;
                case 7:
                    m.output = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return HealthCheckDetail;
    })();

    contractpb.NamedHealthCheckDetail = (function() {

        /**
         * Properties of a NamedHealthCheckDetail.
         * @memberof contractpb
         * @interface INamedHealthCheckDetail
         * @property {string|null} [name] NamedHealthCheckDetail name
         * @property {Array.<contractpb.IHealthCheckDetail>|null} [details] NamedHealthCheckDetail details
         */

        /**
         * Constructs a new NamedHealthCheckDetail.
         * @memberof contractpb
         * @classdesc Represents a NamedHealthCheckDetail.
         * @implements INamedHealthCheckDetail
         * @constructor
         * @param {contractpb.INamedHealthCheckDetail=} [p] Properties to set
         */
        function NamedHealthCheckDetail(p) {
            this.details = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * NamedHealthCheckDetail name.
         * @member {string} name
         * @memberof contractpb.NamedHealthCheckDetail
         * @instance
         */
        NamedHealthCheckDetail.prototype.name = "";

        /**
         * NamedHealthCheckDetail details.
         * @member {Array.<contractpb.IHealthCheckDetail>} details
         * @memberof contractpb.NamedHealthCheckDetail
         * @instance
         */
        NamedHealthCheckDetail.prototype.details = $util.emptyArray;

        /**
         * Creates a new NamedHealthCheckDetail instance using the specified properties.
         * @function create
         * @memberof contractpb.NamedHealthCheckDetail
         * @static
         * @param {contractpb.INamedHealthCheckDetail=} [properties] Properties to set
         * @returns {contractpb.NamedHealthCheckDetail} NamedHealthCheckDetail instance
         */
        NamedHealthCheckDetail.create = function create(properties) {
            return new NamedHealthCheckDetail(properties);
        };

        /**
         * Encodes the specified NamedHealthCheckDetail message. Does not implicitly {@link contractpb.NamedHealthCheckDetail.verify|verify} messages.
         * @function encode
         * @memberof contractpb.NamedHealthCheckDetail
         * @static
         * @param {contractpb.INamedHealthCheckDetail} m NamedHealthCheckDetail message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        NamedHealthCheckDetail.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.name != null && Object.hasOwnProperty.call(m, "name"))
                w.uint32(10).string(m.name);
            if (m.details != null && m.details.length) {
                for (var i = 0; i < m.details.length; ++i)
                    $root.contractpb.HealthCheckDetail.encode(m.details[i], w.uint32(18).fork()).ldelim();
            }
            return w;
        };

        /**
         * Decodes a NamedHealthCheckDetail message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.NamedHealthCheckDetail
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.NamedHealthCheckDetail} NamedHealthCheckDetail
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        NamedHealthCheckDetail.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.NamedHealthCheckDetail();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.name = r.string();
                    break;
                case 2:
                    if (!(m.details && m.details.length))
                        m.details = [];
                    m.details.push($root.contractpb.HealthCheckDetail.decode(r, r.uint32()));
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return NamedHealthCheckDetail;
    })();

    contractpb.HealthCheck = (function() {

        /**
         * Properties of a HealthCheck.
         * @memberof contractpb
         * @interface IHealthCheck
         * @property {string|null} [status] HealthCheck status
         * @property {string|null} [version] HealthCheck version
         * @property {string|null} [releaseID] HealthCheck releaseID
         * @property {Array.<string>|null} [notes] HealthCheck notes
         * @property {string|null} [output] HealthCheck output
         * @property {Array.<contractpb.INamedHealthCheckDetail>|null} [details] HealthCheck details
         */

        /**
         * Constructs a new HealthCheck.
         * @memberof contractpb
         * @classdesc Represents a HealthCheck.
         * @implements IHealthCheck
         * @constructor
         * @param {contractpb.IHealthCheck=} [p] Properties to set
         */
        function HealthCheck(p) {
            this.notes = [];
            this.details = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * HealthCheck status.
         * @member {string} status
         * @memberof contractpb.HealthCheck
         * @instance
         */
        HealthCheck.prototype.status = "";

        /**
         * HealthCheck version.
         * @member {string} version
         * @memberof contractpb.HealthCheck
         * @instance
         */
        HealthCheck.prototype.version = "";

        /**
         * HealthCheck releaseID.
         * @member {string} releaseID
         * @memberof contractpb.HealthCheck
         * @instance
         */
        HealthCheck.prototype.releaseID = "";

        /**
         * HealthCheck notes.
         * @member {Array.<string>} notes
         * @memberof contractpb.HealthCheck
         * @instance
         */
        HealthCheck.prototype.notes = $util.emptyArray;

        /**
         * HealthCheck output.
         * @member {string} output
         * @memberof contractpb.HealthCheck
         * @instance
         */
        HealthCheck.prototype.output = "";

        /**
         * HealthCheck details.
         * @member {Array.<contractpb.INamedHealthCheckDetail>} details
         * @memberof contractpb.HealthCheck
         * @instance
         */
        HealthCheck.prototype.details = $util.emptyArray;

        /**
         * Creates a new HealthCheck instance using the specified properties.
         * @function create
         * @memberof contractpb.HealthCheck
         * @static
         * @param {contractpb.IHealthCheck=} [properties] Properties to set
         * @returns {contractpb.HealthCheck} HealthCheck instance
         */
        HealthCheck.create = function create(properties) {
            return new HealthCheck(properties);
        };

        /**
         * Encodes the specified HealthCheck message. Does not implicitly {@link contractpb.HealthCheck.verify|verify} messages.
         * @function encode
         * @memberof contractpb.HealthCheck
         * @static
         * @param {contractpb.IHealthCheck} m HealthCheck message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        HealthCheck.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.status != null && Object.hasOwnProperty.call(m, "status"))
                w.uint32(10).string(m.status);
            if (m.version != null && Object.hasOwnProperty.call(m, "version"))
                w.uint32(18).string(m.version);
            if (m.releaseID != null && Object.hasOwnProperty.call(m, "releaseID"))
                w.uint32(26).string(m.releaseID);
            if (m.notes != null && m.notes.length) {
                for (var i = 0; i < m.notes.length; ++i)
                    w.uint32(34).string(m.notes[i]);
            }
            if (m.output != null && Object.hasOwnProperty.call(m, "output"))
                w.uint32(42).string(m.output);
            if (m.details != null && m.details.length) {
                for (var i = 0; i < m.details.length; ++i)
                    $root.contractpb.NamedHealthCheckDetail.encode(m.details[i], w.uint32(50).fork()).ldelim();
            }
            return w;
        };

        /**
         * Decodes a HealthCheck message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.HealthCheck
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.HealthCheck} HealthCheck
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        HealthCheck.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.HealthCheck();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.status = r.string();
                    break;
                case 2:
                    m.version = r.string();
                    break;
                case 3:
                    m.releaseID = r.string();
                    break;
                case 4:
                    if (!(m.notes && m.notes.length))
                        m.notes = [];
                    m.notes.push(r.string());
                    break;
                case 5:
                    m.output = r.string();
                    break;
                case 6:
                    if (!(m.details && m.details.length))
                        m.details = [];
                    m.details.push($root.contractpb.NamedHealthCheckDetail.decode(r, r.uint32()));
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return HealthCheck;
    })();

    contractpb.HealthCheckResponse = (function() {

        /**
         * Properties of a HealthCheckResponse.
         * @memberof contractpb
         * @interface IHealthCheckResponse
         * @property {contractpb.IHealthCheck|null} [health] HealthCheckResponse health
         */

        /**
         * Constructs a new HealthCheckResponse.
         * @memberof contractpb
         * @classdesc Represents a HealthCheckResponse.
         * @implements IHealthCheckResponse
         * @constructor
         * @param {contractpb.IHealthCheckResponse=} [p] Properties to set
         */
        function HealthCheckResponse(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * HealthCheckResponse health.
         * @member {contractpb.IHealthCheck|null|undefined} health
         * @memberof contractpb.HealthCheckResponse
         * @instance
         */
        HealthCheckResponse.prototype.health = null;

        /**
         * Creates a new HealthCheckResponse instance using the specified properties.
         * @function create
         * @memberof contractpb.HealthCheckResponse
         * @static
         * @param {contractpb.IHealthCheckResponse=} [properties] Properties to set
         * @returns {contractpb.HealthCheckResponse} HealthCheckResponse instance
         */
        HealthCheckResponse.create = function create(properties) {
            return new HealthCheckResponse(properties);
        };

        /**
         * Encodes the specified HealthCheckResponse message. Does not implicitly {@link contractpb.HealthCheckResponse.verify|verify} messages.
         * @function encode
         * @memberof contractpb.HealthCheckResponse
         * @static
         * @param {contractpb.IHealthCheckResponse} m HealthCheckResponse message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        HealthCheckResponse.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.health != null && Object.hasOwnProperty.call(m, "health"))
                $root.contractpb.HealthCheck.encode(m.health, w.uint32(10).fork()).ldelim();
            return w;
        };

        /**
         * Decodes a HealthCheckResponse message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.HealthCheckResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.HealthCheckResponse} HealthCheckResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        HealthCheckResponse.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.HealthCheckResponse();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.health = $root.contractpb.HealthCheck.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return HealthCheckResponse;
    })();

    contractpb.RequestValidationErrorResponse = (function() {

        /**
         * Properties of a RequestValidationErrorResponse.
         * @memberof contractpb
         * @interface IRequestValidationErrorResponse
         * @property {Array.<string>|null} [errors] RequestValidationErrorResponse errors
         */

        /**
         * Constructs a new RequestValidationErrorResponse.
         * @memberof contractpb
         * @classdesc Represents a RequestValidationErrorResponse.
         * @implements IRequestValidationErrorResponse
         * @constructor
         * @param {contractpb.IRequestValidationErrorResponse=} [p] Properties to set
         */
        function RequestValidationErrorResponse(p) {
            this.errors = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * RequestValidationErrorResponse errors.
         * @member {Array.<string>} errors
         * @memberof contractpb.RequestValidationErrorResponse
         * @instance
         */
        RequestValidationErrorResponse.prototype.errors = $util.emptyArray;

        /**
         * Creates a new RequestValidationErrorResponse instance using the specified properties.
         * @function create
         * @memberof contractpb.RequestValidationErrorResponse
         * @static
         * @param {contractpb.IRequestValidationErrorResponse=} [properties] Properties to set
         * @returns {contractpb.RequestValidationErrorResponse} RequestValidationErrorResponse instance
         */
        RequestValidationErrorResponse.create = function create(properties) {
            return new RequestValidationErrorResponse(properties);
        };

        /**
         * Encodes the specified RequestValidationErrorResponse message. Does not implicitly {@link contractpb.RequestValidationErrorResponse.verify|verify} messages.
         * @function encode
         * @memberof contractpb.RequestValidationErrorResponse
         * @static
         * @param {contractpb.IRequestValidationErrorResponse} m RequestValidationErrorResponse message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RequestValidationErrorResponse.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.errors != null && m.errors.length) {
                for (var i = 0; i < m.errors.length; ++i)
                    w.uint32(10).string(m.errors[i]);
            }
            return w;
        };

        /**
         * Decodes a RequestValidationErrorResponse message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.RequestValidationErrorResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.RequestValidationErrorResponse} RequestValidationErrorResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RequestValidationErrorResponse.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.RequestValidationErrorResponse();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    if (!(m.errors && m.errors.length))
                        m.errors = [];
                    m.errors.push(r.string());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return RequestValidationErrorResponse;
    })();

    contractpb.ContractDate = (function() {

        /**
         * Properties of a ContractDate.
         * @memberof contractpb
         * @interface IContractDate
         * @property {string|null} [type] ContractDate type
         * @property {string|null} [effective] ContractDate effective
         * @property {string|null} [expiration] ContractDate expiration
         */

        /**
         * Constructs a new ContractDate.
         * @memberof contractpb
         * @classdesc Represents a ContractDate.
         * @implements IContractDate
         * @constructor
         * @param {contractpb.IContractDate=} [p] Properties to set
         */
        function ContractDate(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * ContractDate type.
         * @member {string} type
         * @memberof contractpb.ContractDate
         * @instance
         */
        ContractDate.prototype.type = "";

        /**
         * ContractDate effective.
         * @member {string} effective
         * @memberof contractpb.ContractDate
         * @instance
         */
        ContractDate.prototype.effective = "";

        /**
         * ContractDate expiration.
         * @member {string} expiration
         * @memberof contractpb.ContractDate
         * @instance
         */
        ContractDate.prototype.expiration = "";

        /**
         * Creates a new ContractDate instance using the specified properties.
         * @function create
         * @memberof contractpb.ContractDate
         * @static
         * @param {contractpb.IContractDate=} [properties] Properties to set
         * @returns {contractpb.ContractDate} ContractDate instance
         */
        ContractDate.create = function create(properties) {
            return new ContractDate(properties);
        };

        /**
         * Encodes the specified ContractDate message. Does not implicitly {@link contractpb.ContractDate.verify|verify} messages.
         * @function encode
         * @memberof contractpb.ContractDate
         * @static
         * @param {contractpb.IContractDate} m ContractDate message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ContractDate.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.type != null && Object.hasOwnProperty.call(m, "type"))
                w.uint32(10).string(m.type);
            if (m.effective != null && Object.hasOwnProperty.call(m, "effective"))
                w.uint32(18).string(m.effective);
            if (m.expiration != null && Object.hasOwnProperty.call(m, "expiration"))
                w.uint32(26).string(m.expiration);
            return w;
        };

        /**
         * Decodes a ContractDate message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.ContractDate
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.ContractDate} ContractDate
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ContractDate.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.ContractDate();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.type = r.string();
                    break;
                case 2:
                    m.effective = r.string();
                    break;
                case 3:
                    m.expiration = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return ContractDate;
    })();

    contractpb.ContractDates = (function() {

        /**
         * Properties of a ContractDates.
         * @memberof contractpb
         * @interface IContractDates
         * @property {Array.<contractpb.IContractDate>|null} [dates] ContractDates dates
         */

        /**
         * Constructs a new ContractDates.
         * @memberof contractpb
         * @classdesc Represents a ContractDates.
         * @implements IContractDates
         * @constructor
         * @param {contractpb.IContractDates=} [p] Properties to set
         */
        function ContractDates(p) {
            this.dates = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * ContractDates dates.
         * @member {Array.<contractpb.IContractDate>} dates
         * @memberof contractpb.ContractDates
         * @instance
         */
        ContractDates.prototype.dates = $util.emptyArray;

        /**
         * Creates a new ContractDates instance using the specified properties.
         * @function create
         * @memberof contractpb.ContractDates
         * @static
         * @param {contractpb.IContractDates=} [properties] Properties to set
         * @returns {contractpb.ContractDates} ContractDates instance
         */
        ContractDates.create = function create(properties) {
            return new ContractDates(properties);
        };

        /**
         * Encodes the specified ContractDates message. Does not implicitly {@link contractpb.ContractDates.verify|verify} messages.
         * @function encode
         * @memberof contractpb.ContractDates
         * @static
         * @param {contractpb.IContractDates} m ContractDates message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ContractDates.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.dates != null && m.dates.length) {
                for (var i = 0; i < m.dates.length; ++i)
                    $root.contractpb.ContractDate.encode(m.dates[i], w.uint32(10).fork()).ldelim();
            }
            return w;
        };

        /**
         * Decodes a ContractDates message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.ContractDates
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.ContractDates} ContractDates
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ContractDates.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.ContractDates();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    if (!(m.dates && m.dates.length))
                        m.dates = [];
                    m.dates.push($root.contractpb.ContractDate.decode(r, r.uint32()));
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return ContractDates;
    })();

    contractpb.ContractDetail = (function() {

        /**
         * Properties of a ContractDetail.
         * @memberof contractpb
         * @interface IContractDetail
         * @property {string|null} [type] ContractDetail type
         * @property {string|null} [value] ContractDetail value
         */

        /**
         * Constructs a new ContractDetail.
         * @memberof contractpb
         * @classdesc Represents a ContractDetail.
         * @implements IContractDetail
         * @constructor
         * @param {contractpb.IContractDetail=} [p] Properties to set
         */
        function ContractDetail(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * ContractDetail type.
         * @member {string} type
         * @memberof contractpb.ContractDetail
         * @instance
         */
        ContractDetail.prototype.type = "";

        /**
         * ContractDetail value.
         * @member {string} value
         * @memberof contractpb.ContractDetail
         * @instance
         */
        ContractDetail.prototype.value = "";

        /**
         * Creates a new ContractDetail instance using the specified properties.
         * @function create
         * @memberof contractpb.ContractDetail
         * @static
         * @param {contractpb.IContractDetail=} [properties] Properties to set
         * @returns {contractpb.ContractDetail} ContractDetail instance
         */
        ContractDetail.create = function create(properties) {
            return new ContractDetail(properties);
        };

        /**
         * Encodes the specified ContractDetail message. Does not implicitly {@link contractpb.ContractDetail.verify|verify} messages.
         * @function encode
         * @memberof contractpb.ContractDetail
         * @static
         * @param {contractpb.IContractDetail} m ContractDetail message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ContractDetail.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.type != null && Object.hasOwnProperty.call(m, "type"))
                w.uint32(10).string(m.type);
            if (m.value != null && Object.hasOwnProperty.call(m, "value"))
                w.uint32(18).string(m.value);
            return w;
        };

        /**
         * Decodes a ContractDetail message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.ContractDetail
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.ContractDetail} ContractDetail
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ContractDetail.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.ContractDetail();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.type = r.string();
                    break;
                case 2:
                    m.value = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return ContractDetail;
    })();

    contractpb.ContractDetailsInfo = (function() {

        /**
         * Properties of a ContractDetailsInfo.
         * @memberof contractpb
         * @interface IContractDetailsInfo
         * @property {string|null} [type] ContractDetailsInfo type
         * @property {string|null} [value] ContractDetailsInfo value
         * @property {string|null} [typePrefix] ContractDetailsInfo typePrefix
         * @property {string|null} [lastModified] ContractDetailsInfo lastModified
         */

        /**
         * Constructs a new ContractDetailsInfo.
         * @memberof contractpb
         * @classdesc Represents a ContractDetailsInfo.
         * @implements IContractDetailsInfo
         * @constructor
         * @param {contractpb.IContractDetailsInfo=} [p] Properties to set
         */
        function ContractDetailsInfo(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * ContractDetailsInfo type.
         * @member {string} type
         * @memberof contractpb.ContractDetailsInfo
         * @instance
         */
        ContractDetailsInfo.prototype.type = "";

        /**
         * ContractDetailsInfo value.
         * @member {string} value
         * @memberof contractpb.ContractDetailsInfo
         * @instance
         */
        ContractDetailsInfo.prototype.value = "";

        /**
         * ContractDetailsInfo typePrefix.
         * @member {string} typePrefix
         * @memberof contractpb.ContractDetailsInfo
         * @instance
         */
        ContractDetailsInfo.prototype.typePrefix = "";

        /**
         * ContractDetailsInfo lastModified.
         * @member {string} lastModified
         * @memberof contractpb.ContractDetailsInfo
         * @instance
         */
        ContractDetailsInfo.prototype.lastModified = "";

        /**
         * Creates a new ContractDetailsInfo instance using the specified properties.
         * @function create
         * @memberof contractpb.ContractDetailsInfo
         * @static
         * @param {contractpb.IContractDetailsInfo=} [properties] Properties to set
         * @returns {contractpb.ContractDetailsInfo} ContractDetailsInfo instance
         */
        ContractDetailsInfo.create = function create(properties) {
            return new ContractDetailsInfo(properties);
        };

        /**
         * Encodes the specified ContractDetailsInfo message. Does not implicitly {@link contractpb.ContractDetailsInfo.verify|verify} messages.
         * @function encode
         * @memberof contractpb.ContractDetailsInfo
         * @static
         * @param {contractpb.IContractDetailsInfo} m ContractDetailsInfo message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ContractDetailsInfo.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.type != null && Object.hasOwnProperty.call(m, "type"))
                w.uint32(10).string(m.type);
            if (m.value != null && Object.hasOwnProperty.call(m, "value"))
                w.uint32(18).string(m.value);
            if (m.typePrefix != null && Object.hasOwnProperty.call(m, "typePrefix"))
                w.uint32(26).string(m.typePrefix);
            if (m.lastModified != null && Object.hasOwnProperty.call(m, "lastModified"))
                w.uint32(34).string(m.lastModified);
            return w;
        };

        /**
         * Decodes a ContractDetailsInfo message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.ContractDetailsInfo
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.ContractDetailsInfo} ContractDetailsInfo
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ContractDetailsInfo.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.ContractDetailsInfo();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.type = r.string();
                    break;
                case 2:
                    m.value = r.string();
                    break;
                case 3:
                    m.typePrefix = r.string();
                    break;
                case 4:
                    m.lastModified = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return ContractDetailsInfo;
    })();

    /**
     * ContractType enum.
     * @name contractpb.ContractType
     * @enum {number}
     * @property {number} UNDEFINED_CONTRACT_TYPE=0 UNDEFINED_CONTRACT_TYPE value
     * @property {number} NEWCONTRACT=1 NEWCONTRACT value
     * @property {number} UPGRADED=2 UPGRADED value
     * @property {number} RENEWED=3 RENEWED value
     * @property {number} PRORATED=4 PRORATED value
     * @property {number} GIFT=5 GIFT value
     */
    contractpb.ContractType = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "UNDEFINED_CONTRACT_TYPE"] = 0;
        values[valuesById[1] = "NEWCONTRACT"] = 1;
        values[valuesById[2] = "UPGRADED"] = 2;
        values[valuesById[3] = "RENEWED"] = 3;
        values[valuesById[4] = "PRORATED"] = 4;
        values[valuesById[5] = "GIFT"] = 5;
        return values;
    })();

    contractpb.ContractDetails = (function() {

        /**
         * Properties of a ContractDetails.
         * @memberof contractpb
         * @interface IContractDetails
         * @property {Array.<contractpb.IContractDetail>|null} [details] ContractDetails details
         * @property {contractpb.ContractType|null} [contractType] ContractDetails contractType
         */

        /**
         * Constructs a new ContractDetails.
         * @memberof contractpb
         * @classdesc Represents a ContractDetails.
         * @implements IContractDetails
         * @constructor
         * @param {contractpb.IContractDetails=} [p] Properties to set
         */
        function ContractDetails(p) {
            this.details = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * ContractDetails details.
         * @member {Array.<contractpb.IContractDetail>} details
         * @memberof contractpb.ContractDetails
         * @instance
         */
        ContractDetails.prototype.details = $util.emptyArray;

        /**
         * ContractDetails contractType.
         * @member {contractpb.ContractType} contractType
         * @memberof contractpb.ContractDetails
         * @instance
         */
        ContractDetails.prototype.contractType = 0;

        /**
         * Creates a new ContractDetails instance using the specified properties.
         * @function create
         * @memberof contractpb.ContractDetails
         * @static
         * @param {contractpb.IContractDetails=} [properties] Properties to set
         * @returns {contractpb.ContractDetails} ContractDetails instance
         */
        ContractDetails.create = function create(properties) {
            return new ContractDetails(properties);
        };

        /**
         * Encodes the specified ContractDetails message. Does not implicitly {@link contractpb.ContractDetails.verify|verify} messages.
         * @function encode
         * @memberof contractpb.ContractDetails
         * @static
         * @param {contractpb.IContractDetails} m ContractDetails message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ContractDetails.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.details != null && m.details.length) {
                for (var i = 0; i < m.details.length; ++i)
                    $root.contractpb.ContractDetail.encode(m.details[i], w.uint32(10).fork()).ldelim();
            }
            if (m.contractType != null && Object.hasOwnProperty.call(m, "contractType"))
                w.uint32(16).int32(m.contractType);
            return w;
        };

        /**
         * Decodes a ContractDetails message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.ContractDetails
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.ContractDetails} ContractDetails
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ContractDetails.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.ContractDetails();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    if (!(m.details && m.details.length))
                        m.details = [];
                    m.details.push($root.contractpb.ContractDetail.decode(r, r.uint32()));
                    break;
                case 2:
                    m.contractType = r.int32();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return ContractDetails;
    })();

    contractpb.ContractCustomers = (function() {

        /**
         * Properties of a ContractCustomers.
         * @memberof contractpb
         * @interface IContractCustomers
         * @property {Array.<contractpb.IContractCustomer>|null} [customers] ContractCustomers customers
         */

        /**
         * Constructs a new ContractCustomers.
         * @memberof contractpb
         * @classdesc Represents a ContractCustomers.
         * @implements IContractCustomers
         * @constructor
         * @param {contractpb.IContractCustomers=} [p] Properties to set
         */
        function ContractCustomers(p) {
            this.customers = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * ContractCustomers customers.
         * @member {Array.<contractpb.IContractCustomer>} customers
         * @memberof contractpb.ContractCustomers
         * @instance
         */
        ContractCustomers.prototype.customers = $util.emptyArray;

        /**
         * Creates a new ContractCustomers instance using the specified properties.
         * @function create
         * @memberof contractpb.ContractCustomers
         * @static
         * @param {contractpb.IContractCustomers=} [properties] Properties to set
         * @returns {contractpb.ContractCustomers} ContractCustomers instance
         */
        ContractCustomers.create = function create(properties) {
            return new ContractCustomers(properties);
        };

        /**
         * Encodes the specified ContractCustomers message. Does not implicitly {@link contractpb.ContractCustomers.verify|verify} messages.
         * @function encode
         * @memberof contractpb.ContractCustomers
         * @static
         * @param {contractpb.IContractCustomers} m ContractCustomers message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ContractCustomers.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.customers != null && m.customers.length) {
                for (var i = 0; i < m.customers.length; ++i)
                    $root.contractpb.ContractCustomer.encode(m.customers[i], w.uint32(10).fork()).ldelim();
            }
            return w;
        };

        /**
         * Decodes a ContractCustomers message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.ContractCustomers
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.ContractCustomers} ContractCustomers
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ContractCustomers.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.ContractCustomers();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    if (!(m.customers && m.customers.length))
                        m.customers = [];
                    m.customers.push($root.contractpb.ContractCustomer.decode(r, r.uint32()));
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return ContractCustomers;
    })();

    /**
     * ContractCustomerType enum.
     * @name contractpb.ContractCustomerType
     * @enum {number}
     * @property {number} UNKNOWN_CUSTOMER_TYPE=0 UNKNOWN_CUSTOMER_TYPE value
     * @property {number} BUYER=1 BUYER value
     * @property {number} COBUYER=2 COBUYER value
     * @property {number} SELLER=3 SELLER value
     * @property {number} COSELLER=4 COSELLER value
     * @property {number} ADMIN=5 ADMIN value
     * @property {number} AUTHORIZER=6 AUTHORIZER value
     * @property {number} CONTACT=7 CONTACT value
     * @property {number} GIFTER=8 GIFTER value
     */
    contractpb.ContractCustomerType = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "UNKNOWN_CUSTOMER_TYPE"] = 0;
        values[valuesById[1] = "BUYER"] = 1;
        values[valuesById[2] = "COBUYER"] = 2;
        values[valuesById[3] = "SELLER"] = 3;
        values[valuesById[4] = "COSELLER"] = 4;
        values[valuesById[5] = "ADMIN"] = 5;
        values[valuesById[6] = "AUTHORIZER"] = 6;
        values[valuesById[7] = "CONTACT"] = 7;
        values[valuesById[8] = "GIFTER"] = 8;
        return values;
    })();

    /**
     * SalesChannel enum.
     * @name contractpb.SalesChannel
     * @enum {number}
     * @property {number} UNKNOWN_SALES_CHANNEL=0 UNKNOWN_SALES_CHANNEL value
     * @property {number} RE=1 RE value
     * @property {number} RN=2 RN value
     * @property {number} IN=3 IN value
     * @property {number} CBR=4 CBR value
     * @property {number} DC=5 DC value
     * @property {number} OD=6 OD value
     * @property {number} RTL=7 RTL value
     */
    contractpb.SalesChannel = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "UNKNOWN_SALES_CHANNEL"] = 0;
        values[valuesById[1] = "RE"] = 1;
        values[valuesById[2] = "RN"] = 2;
        values[valuesById[3] = "IN"] = 3;
        values[valuesById[4] = "CBR"] = 4;
        values[valuesById[5] = "DC"] = 5;
        values[valuesById[6] = "OD"] = 6;
        values[valuesById[7] = "RTL"] = 7;
        return values;
    })();

    contractpb.ContractCustomer = (function() {

        /**
         * Properties of a ContractCustomer.
         * @memberof contractpb
         * @interface IContractCustomer
         * @property {string|null} [ID] ContractCustomer ID
         * @property {contractpb.ContractCustomerType|null} [type] ContractCustomer type
         */

        /**
         * Constructs a new ContractCustomer.
         * @memberof contractpb
         * @classdesc Represents a ContractCustomer.
         * @implements IContractCustomer
         * @constructor
         * @param {contractpb.IContractCustomer=} [p] Properties to set
         */
        function ContractCustomer(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * ContractCustomer ID.
         * @member {string} ID
         * @memberof contractpb.ContractCustomer
         * @instance
         */
        ContractCustomer.prototype.ID = "";

        /**
         * ContractCustomer type.
         * @member {contractpb.ContractCustomerType} type
         * @memberof contractpb.ContractCustomer
         * @instance
         */
        ContractCustomer.prototype.type = 0;

        /**
         * Creates a new ContractCustomer instance using the specified properties.
         * @function create
         * @memberof contractpb.ContractCustomer
         * @static
         * @param {contractpb.IContractCustomer=} [properties] Properties to set
         * @returns {contractpb.ContractCustomer} ContractCustomer instance
         */
        ContractCustomer.create = function create(properties) {
            return new ContractCustomer(properties);
        };

        /**
         * Encodes the specified ContractCustomer message. Does not implicitly {@link contractpb.ContractCustomer.verify|verify} messages.
         * @function encode
         * @memberof contractpb.ContractCustomer
         * @static
         * @param {contractpb.IContractCustomer} m ContractCustomer message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ContractCustomer.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.ID != null && Object.hasOwnProperty.call(m, "ID"))
                w.uint32(10).string(m.ID);
            if (m.type != null && Object.hasOwnProperty.call(m, "type"))
                w.uint32(16).int32(m.type);
            return w;
        };

        /**
         * Decodes a ContractCustomer message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.ContractCustomer
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.ContractCustomer} ContractCustomer
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ContractCustomer.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.ContractCustomer();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.ID = r.string();
                    break;
                case 2:
                    m.type = r.int32();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return ContractCustomer;
    })();

    contractpb.CustomerSearch = (function() {

        /**
         * Properties of a CustomerSearch.
         * @memberof contractpb
         * @interface ICustomerSearch
         * @property {contractpb.ICustomer|null} [customer] CustomerSearch customer
         * @property {number|null} [size] CustomerSearch size
         * @property {number|null} [from] CustomerSearch from
         */

        /**
         * Constructs a new CustomerSearch.
         * @memberof contractpb
         * @classdesc Represents a CustomerSearch.
         * @implements ICustomerSearch
         * @constructor
         * @param {contractpb.ICustomerSearch=} [p] Properties to set
         */
        function CustomerSearch(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * CustomerSearch customer.
         * @member {contractpb.ICustomer|null|undefined} customer
         * @memberof contractpb.CustomerSearch
         * @instance
         */
        CustomerSearch.prototype.customer = null;

        /**
         * CustomerSearch size.
         * @member {number} size
         * @memberof contractpb.CustomerSearch
         * @instance
         */
        CustomerSearch.prototype.size = 0;

        /**
         * CustomerSearch from.
         * @member {number} from
         * @memberof contractpb.CustomerSearch
         * @instance
         */
        CustomerSearch.prototype.from = 0;

        /**
         * Creates a new CustomerSearch instance using the specified properties.
         * @function create
         * @memberof contractpb.CustomerSearch
         * @static
         * @param {contractpb.ICustomerSearch=} [properties] Properties to set
         * @returns {contractpb.CustomerSearch} CustomerSearch instance
         */
        CustomerSearch.create = function create(properties) {
            return new CustomerSearch(properties);
        };

        /**
         * Encodes the specified CustomerSearch message. Does not implicitly {@link contractpb.CustomerSearch.verify|verify} messages.
         * @function encode
         * @memberof contractpb.CustomerSearch
         * @static
         * @param {contractpb.ICustomerSearch} m CustomerSearch message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CustomerSearch.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.customer != null && Object.hasOwnProperty.call(m, "customer"))
                $root.contractpb.Customer.encode(m.customer, w.uint32(10).fork()).ldelim();
            if (m.size != null && Object.hasOwnProperty.call(m, "size"))
                w.uint32(16).int32(m.size);
            if (m.from != null && Object.hasOwnProperty.call(m, "from"))
                w.uint32(24).int32(m.from);
            return w;
        };

        /**
         * Decodes a CustomerSearch message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.CustomerSearch
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.CustomerSearch} CustomerSearch
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CustomerSearch.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.CustomerSearch();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.customer = $root.contractpb.Customer.decode(r, r.uint32());
                    break;
                case 2:
                    m.size = r.int32();
                    break;
                case 3:
                    m.from = r.int32();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return CustomerSearch;
    })();

    contractpb.Customer = (function() {

        /**
         * Properties of a Customer.
         * @memberof contractpb
         * @interface ICustomer
         * @property {Array.<contractpb.IContractVerificationDetails>|null} [contracts] Customer contracts
         */

        /**
         * Constructs a new Customer.
         * @memberof contractpb
         * @classdesc Represents a Customer.
         * @implements ICustomer
         * @constructor
         * @param {contractpb.ICustomer=} [p] Properties to set
         */
        function Customer(p) {
            this.contracts = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * Customer contracts.
         * @member {Array.<contractpb.IContractVerificationDetails>} contracts
         * @memberof contractpb.Customer
         * @instance
         */
        Customer.prototype.contracts = $util.emptyArray;

        /**
         * Creates a new Customer instance using the specified properties.
         * @function create
         * @memberof contractpb.Customer
         * @static
         * @param {contractpb.ICustomer=} [properties] Properties to set
         * @returns {contractpb.Customer} Customer instance
         */
        Customer.create = function create(properties) {
            return new Customer(properties);
        };

        /**
         * Encodes the specified Customer message. Does not implicitly {@link contractpb.Customer.verify|verify} messages.
         * @function encode
         * @memberof contractpb.Customer
         * @static
         * @param {contractpb.ICustomer} m Customer message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Customer.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.contracts != null && m.contracts.length) {
                for (var i = 0; i < m.contracts.length; ++i)
                    $root.contractpb.ContractVerificationDetails.encode(m.contracts[i], w.uint32(10).fork()).ldelim();
            }
            return w;
        };

        /**
         * Decodes a Customer message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.Customer
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.Customer} Customer
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Customer.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.Customer();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    if (!(m.contracts && m.contracts.length))
                        m.contracts = [];
                    m.contracts.push($root.contractpb.ContractVerificationDetails.decode(r, r.uint32()));
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return Customer;
    })();

    contractpb.ContractVerificationDetails = (function() {

        /**
         * Properties of a ContractVerificationDetails.
         * @memberof contractpb
         * @interface IContractVerificationDetails
         * @property {number|null} [contractId] ContractVerificationDetails contractId
         * @property {string|null} [contractStatus] ContractVerificationDetails contractStatus
         * @property {string|null} [contractEffectiveDate] ContractVerificationDetails contractEffectiveDate
         * @property {string|null} [contractExpirationDate] ContractVerificationDetails contractExpirationDate
         * @property {string|null} [zipCode] ContractVerificationDetails zipCode
         * @property {string|null} [unitNumber] ContractVerificationDetails unitNumber
         * @property {string|null} [originalSalesChannel] ContractVerificationDetails originalSalesChannel
         * @property {common.Tenant|null} [tenantID] ContractVerificationDetails tenantID
         * @property {string|null} [productType] ContractVerificationDetails productType
         */

        /**
         * Constructs a new ContractVerificationDetails.
         * @memberof contractpb
         * @classdesc Represents a ContractVerificationDetails.
         * @implements IContractVerificationDetails
         * @constructor
         * @param {contractpb.IContractVerificationDetails=} [p] Properties to set
         */
        function ContractVerificationDetails(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * ContractVerificationDetails contractId.
         * @member {number} contractId
         * @memberof contractpb.ContractVerificationDetails
         * @instance
         */
        ContractVerificationDetails.prototype.contractId = 0;

        /**
         * ContractVerificationDetails contractStatus.
         * @member {string} contractStatus
         * @memberof contractpb.ContractVerificationDetails
         * @instance
         */
        ContractVerificationDetails.prototype.contractStatus = "";

        /**
         * ContractVerificationDetails contractEffectiveDate.
         * @member {string} contractEffectiveDate
         * @memberof contractpb.ContractVerificationDetails
         * @instance
         */
        ContractVerificationDetails.prototype.contractEffectiveDate = "";

        /**
         * ContractVerificationDetails contractExpirationDate.
         * @member {string} contractExpirationDate
         * @memberof contractpb.ContractVerificationDetails
         * @instance
         */
        ContractVerificationDetails.prototype.contractExpirationDate = "";

        /**
         * ContractVerificationDetails zipCode.
         * @member {string} zipCode
         * @memberof contractpb.ContractVerificationDetails
         * @instance
         */
        ContractVerificationDetails.prototype.zipCode = "";

        /**
         * ContractVerificationDetails unitNumber.
         * @member {string} unitNumber
         * @memberof contractpb.ContractVerificationDetails
         * @instance
         */
        ContractVerificationDetails.prototype.unitNumber = "";

        /**
         * ContractVerificationDetails originalSalesChannel.
         * @member {string} originalSalesChannel
         * @memberof contractpb.ContractVerificationDetails
         * @instance
         */
        ContractVerificationDetails.prototype.originalSalesChannel = "";

        /**
         * ContractVerificationDetails tenantID.
         * @member {common.Tenant} tenantID
         * @memberof contractpb.ContractVerificationDetails
         * @instance
         */
        ContractVerificationDetails.prototype.tenantID = 0;

        /**
         * ContractVerificationDetails productType.
         * @member {string} productType
         * @memberof contractpb.ContractVerificationDetails
         * @instance
         */
        ContractVerificationDetails.prototype.productType = "";

        /**
         * Creates a new ContractVerificationDetails instance using the specified properties.
         * @function create
         * @memberof contractpb.ContractVerificationDetails
         * @static
         * @param {contractpb.IContractVerificationDetails=} [properties] Properties to set
         * @returns {contractpb.ContractVerificationDetails} ContractVerificationDetails instance
         */
        ContractVerificationDetails.create = function create(properties) {
            return new ContractVerificationDetails(properties);
        };

        /**
         * Encodes the specified ContractVerificationDetails message. Does not implicitly {@link contractpb.ContractVerificationDetails.verify|verify} messages.
         * @function encode
         * @memberof contractpb.ContractVerificationDetails
         * @static
         * @param {contractpb.IContractVerificationDetails} m ContractVerificationDetails message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ContractVerificationDetails.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.contractId != null && Object.hasOwnProperty.call(m, "contractId"))
                w.uint32(8).int32(m.contractId);
            if (m.contractStatus != null && Object.hasOwnProperty.call(m, "contractStatus"))
                w.uint32(18).string(m.contractStatus);
            if (m.contractEffectiveDate != null && Object.hasOwnProperty.call(m, "contractEffectiveDate"))
                w.uint32(26).string(m.contractEffectiveDate);
            if (m.contractExpirationDate != null && Object.hasOwnProperty.call(m, "contractExpirationDate"))
                w.uint32(34).string(m.contractExpirationDate);
            if (m.zipCode != null && Object.hasOwnProperty.call(m, "zipCode"))
                w.uint32(42).string(m.zipCode);
            if (m.unitNumber != null && Object.hasOwnProperty.call(m, "unitNumber"))
                w.uint32(50).string(m.unitNumber);
            if (m.originalSalesChannel != null && Object.hasOwnProperty.call(m, "originalSalesChannel"))
                w.uint32(58).string(m.originalSalesChannel);
            if (m.tenantID != null && Object.hasOwnProperty.call(m, "tenantID"))
                w.uint32(64).int32(m.tenantID);
            if (m.productType != null && Object.hasOwnProperty.call(m, "productType"))
                w.uint32(74).string(m.productType);
            return w;
        };

        /**
         * Decodes a ContractVerificationDetails message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.ContractVerificationDetails
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.ContractVerificationDetails} ContractVerificationDetails
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ContractVerificationDetails.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.ContractVerificationDetails();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.contractId = r.int32();
                    break;
                case 2:
                    m.contractStatus = r.string();
                    break;
                case 3:
                    m.contractEffectiveDate = r.string();
                    break;
                case 4:
                    m.contractExpirationDate = r.string();
                    break;
                case 5:
                    m.zipCode = r.string();
                    break;
                case 6:
                    m.unitNumber = r.string();
                    break;
                case 7:
                    m.originalSalesChannel = r.string();
                    break;
                case 8:
                    m.tenantID = r.int32();
                    break;
                case 9:
                    m.productType = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return ContractVerificationDetails;
    })();

    contractpb.ContractSearchRequest = (function() {

        /**
         * Properties of a ContractSearchRequest.
         * @memberof contractpb
         * @interface IContractSearchRequest
         * @property {string|null} [ID] ContractSearchRequest ID
         * @property {contractpb.IContractSearchProperty|null} [property] ContractSearchRequest property
         * @property {contractpb.IContractSearchCustomer|null} [customer] ContractSearchRequest customer
         * @property {contractpb.IContractSearchOffice|null} [office] ContractSearchRequest office
         * @property {contractpb.IContractSearchAgent|null} [agent] ContractSearchRequest agent
         * @property {Array.<string>|null} [status] ContractSearchRequest status
         * @property {number|null} [size] ContractSearchRequest size
         * @property {number|null} [from] ContractSearchRequest from
         * @property {contractpb.ContractSearchRequest.IEntryDateRange|null} [entryDateRange] ContractSearchRequest entryDateRange
         * @property {boolean|null} [entryDateAscending] ContractSearchRequest entryDateAscending
         * @property {contractpb.SalesChannel|null} [salesChannel] ContractSearchRequest salesChannel
         * @property {contractpb.ContractSearchRequest.CompanyCode|null} [companyCode] ContractSearchRequest companyCode
         * @property {boolean|null} [current] ContractSearchRequest current
         * @property {boolean|null} [sort] ContractSearchRequest sort
         */

        /**
         * Constructs a new ContractSearchRequest.
         * @memberof contractpb
         * @classdesc Represents a ContractSearchRequest.
         * @implements IContractSearchRequest
         * @constructor
         * @param {contractpb.IContractSearchRequest=} [p] Properties to set
         */
        function ContractSearchRequest(p) {
            this.status = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * ContractSearchRequest ID.
         * @member {string} ID
         * @memberof contractpb.ContractSearchRequest
         * @instance
         */
        ContractSearchRequest.prototype.ID = "";

        /**
         * ContractSearchRequest property.
         * @member {contractpb.IContractSearchProperty|null|undefined} property
         * @memberof contractpb.ContractSearchRequest
         * @instance
         */
        ContractSearchRequest.prototype.property = null;

        /**
         * ContractSearchRequest customer.
         * @member {contractpb.IContractSearchCustomer|null|undefined} customer
         * @memberof contractpb.ContractSearchRequest
         * @instance
         */
        ContractSearchRequest.prototype.customer = null;

        /**
         * ContractSearchRequest office.
         * @member {contractpb.IContractSearchOffice|null|undefined} office
         * @memberof contractpb.ContractSearchRequest
         * @instance
         */
        ContractSearchRequest.prototype.office = null;

        /**
         * ContractSearchRequest agent.
         * @member {contractpb.IContractSearchAgent|null|undefined} agent
         * @memberof contractpb.ContractSearchRequest
         * @instance
         */
        ContractSearchRequest.prototype.agent = null;

        /**
         * ContractSearchRequest status.
         * @member {Array.<string>} status
         * @memberof contractpb.ContractSearchRequest
         * @instance
         */
        ContractSearchRequest.prototype.status = $util.emptyArray;

        /**
         * ContractSearchRequest size.
         * @member {number} size
         * @memberof contractpb.ContractSearchRequest
         * @instance
         */
        ContractSearchRequest.prototype.size = 0;

        /**
         * ContractSearchRequest from.
         * @member {number} from
         * @memberof contractpb.ContractSearchRequest
         * @instance
         */
        ContractSearchRequest.prototype.from = 0;

        /**
         * ContractSearchRequest entryDateRange.
         * @member {contractpb.ContractSearchRequest.IEntryDateRange|null|undefined} entryDateRange
         * @memberof contractpb.ContractSearchRequest
         * @instance
         */
        ContractSearchRequest.prototype.entryDateRange = null;

        /**
         * ContractSearchRequest entryDateAscending.
         * @member {boolean} entryDateAscending
         * @memberof contractpb.ContractSearchRequest
         * @instance
         */
        ContractSearchRequest.prototype.entryDateAscending = false;

        /**
         * ContractSearchRequest salesChannel.
         * @member {contractpb.SalesChannel} salesChannel
         * @memberof contractpb.ContractSearchRequest
         * @instance
         */
        ContractSearchRequest.prototype.salesChannel = 0;

        /**
         * ContractSearchRequest companyCode.
         * @member {contractpb.ContractSearchRequest.CompanyCode} companyCode
         * @memberof contractpb.ContractSearchRequest
         * @instance
         */
        ContractSearchRequest.prototype.companyCode = 0;

        /**
         * ContractSearchRequest current.
         * @member {boolean} current
         * @memberof contractpb.ContractSearchRequest
         * @instance
         */
        ContractSearchRequest.prototype.current = false;

        /**
         * ContractSearchRequest sort.
         * @member {boolean} sort
         * @memberof contractpb.ContractSearchRequest
         * @instance
         */
        ContractSearchRequest.prototype.sort = false;

        /**
         * Creates a new ContractSearchRequest instance using the specified properties.
         * @function create
         * @memberof contractpb.ContractSearchRequest
         * @static
         * @param {contractpb.IContractSearchRequest=} [properties] Properties to set
         * @returns {contractpb.ContractSearchRequest} ContractSearchRequest instance
         */
        ContractSearchRequest.create = function create(properties) {
            return new ContractSearchRequest(properties);
        };

        /**
         * Encodes the specified ContractSearchRequest message. Does not implicitly {@link contractpb.ContractSearchRequest.verify|verify} messages.
         * @function encode
         * @memberof contractpb.ContractSearchRequest
         * @static
         * @param {contractpb.IContractSearchRequest} m ContractSearchRequest message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ContractSearchRequest.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.ID != null && Object.hasOwnProperty.call(m, "ID"))
                w.uint32(10).string(m.ID);
            if (m.property != null && Object.hasOwnProperty.call(m, "property"))
                $root.contractpb.ContractSearchProperty.encode(m.property, w.uint32(18).fork()).ldelim();
            if (m.customer != null && Object.hasOwnProperty.call(m, "customer"))
                $root.contractpb.ContractSearchCustomer.encode(m.customer, w.uint32(26).fork()).ldelim();
            if (m.office != null && Object.hasOwnProperty.call(m, "office"))
                $root.contractpb.ContractSearchOffice.encode(m.office, w.uint32(34).fork()).ldelim();
            if (m.agent != null && Object.hasOwnProperty.call(m, "agent"))
                $root.contractpb.ContractSearchAgent.encode(m.agent, w.uint32(42).fork()).ldelim();
            if (m.status != null && m.status.length) {
                for (var i = 0; i < m.status.length; ++i)
                    w.uint32(50).string(m.status[i]);
            }
            if (m.size != null && Object.hasOwnProperty.call(m, "size"))
                w.uint32(56).int32(m.size);
            if (m.from != null && Object.hasOwnProperty.call(m, "from"))
                w.uint32(64).int32(m.from);
            if (m.entryDateRange != null && Object.hasOwnProperty.call(m, "entryDateRange"))
                $root.contractpb.ContractSearchRequest.EntryDateRange.encode(m.entryDateRange, w.uint32(74).fork()).ldelim();
            if (m.entryDateAscending != null && Object.hasOwnProperty.call(m, "entryDateAscending"))
                w.uint32(80).bool(m.entryDateAscending);
            if (m.salesChannel != null && Object.hasOwnProperty.call(m, "salesChannel"))
                w.uint32(88).int32(m.salesChannel);
            if (m.companyCode != null && Object.hasOwnProperty.call(m, "companyCode"))
                w.uint32(96).int32(m.companyCode);
            if (m.current != null && Object.hasOwnProperty.call(m, "current"))
                w.uint32(104).bool(m.current);
            if (m.sort != null && Object.hasOwnProperty.call(m, "sort"))
                w.uint32(112).bool(m.sort);
            return w;
        };

        /**
         * Decodes a ContractSearchRequest message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.ContractSearchRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.ContractSearchRequest} ContractSearchRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ContractSearchRequest.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.ContractSearchRequest();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.ID = r.string();
                    break;
                case 2:
                    m.property = $root.contractpb.ContractSearchProperty.decode(r, r.uint32());
                    break;
                case 3:
                    m.customer = $root.contractpb.ContractSearchCustomer.decode(r, r.uint32());
                    break;
                case 4:
                    m.office = $root.contractpb.ContractSearchOffice.decode(r, r.uint32());
                    break;
                case 5:
                    m.agent = $root.contractpb.ContractSearchAgent.decode(r, r.uint32());
                    break;
                case 6:
                    if (!(m.status && m.status.length))
                        m.status = [];
                    m.status.push(r.string());
                    break;
                case 7:
                    m.size = r.int32();
                    break;
                case 8:
                    m.from = r.int32();
                    break;
                case 9:
                    m.entryDateRange = $root.contractpb.ContractSearchRequest.EntryDateRange.decode(r, r.uint32());
                    break;
                case 10:
                    m.entryDateAscending = r.bool();
                    break;
                case 11:
                    m.salesChannel = r.int32();
                    break;
                case 12:
                    m.companyCode = r.int32();
                    break;
                case 13:
                    m.current = r.bool();
                    break;
                case 14:
                    m.sort = r.bool();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        ContractSearchRequest.EntryDateRange = (function() {

            /**
             * Properties of an EntryDateRange.
             * @memberof contractpb.ContractSearchRequest
             * @interface IEntryDateRange
             * @property {google.protobuf.ITimestamp|null} [to] EntryDateRange to
             * @property {google.protobuf.ITimestamp|null} [from] EntryDateRange from
             */

            /**
             * Constructs a new EntryDateRange.
             * @memberof contractpb.ContractSearchRequest
             * @classdesc Represents an EntryDateRange.
             * @implements IEntryDateRange
             * @constructor
             * @param {contractpb.ContractSearchRequest.IEntryDateRange=} [p] Properties to set
             */
            function EntryDateRange(p) {
                if (p)
                    for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                        if (p[ks[i]] != null)
                            this[ks[i]] = p[ks[i]];
            }

            /**
             * EntryDateRange to.
             * @member {google.protobuf.ITimestamp|null|undefined} to
             * @memberof contractpb.ContractSearchRequest.EntryDateRange
             * @instance
             */
            EntryDateRange.prototype.to = null;

            /**
             * EntryDateRange from.
             * @member {google.protobuf.ITimestamp|null|undefined} from
             * @memberof contractpb.ContractSearchRequest.EntryDateRange
             * @instance
             */
            EntryDateRange.prototype.from = null;

            /**
             * Creates a new EntryDateRange instance using the specified properties.
             * @function create
             * @memberof contractpb.ContractSearchRequest.EntryDateRange
             * @static
             * @param {contractpb.ContractSearchRequest.IEntryDateRange=} [properties] Properties to set
             * @returns {contractpb.ContractSearchRequest.EntryDateRange} EntryDateRange instance
             */
            EntryDateRange.create = function create(properties) {
                return new EntryDateRange(properties);
            };

            /**
             * Encodes the specified EntryDateRange message. Does not implicitly {@link contractpb.ContractSearchRequest.EntryDateRange.verify|verify} messages.
             * @function encode
             * @memberof contractpb.ContractSearchRequest.EntryDateRange
             * @static
             * @param {contractpb.ContractSearchRequest.IEntryDateRange} m EntryDateRange message or plain object to encode
             * @param {$protobuf.Writer} [w] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            EntryDateRange.encode = function encode(m, w) {
                if (!w)
                    w = $Writer.create();
                if (m.to != null && Object.hasOwnProperty.call(m, "to"))
                    $root.google.protobuf.Timestamp.encode(m.to, w.uint32(10).fork()).ldelim();
                if (m.from != null && Object.hasOwnProperty.call(m, "from"))
                    $root.google.protobuf.Timestamp.encode(m.from, w.uint32(18).fork()).ldelim();
                return w;
            };

            /**
             * Decodes an EntryDateRange message from the specified reader or buffer.
             * @function decode
             * @memberof contractpb.ContractSearchRequest.EntryDateRange
             * @static
             * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
             * @param {number} [l] Message length if known beforehand
             * @returns {contractpb.ContractSearchRequest.EntryDateRange} EntryDateRange
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            EntryDateRange.decode = function decode(r, l) {
                if (!(r instanceof $Reader))
                    r = $Reader.create(r);
                var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.ContractSearchRequest.EntryDateRange();
                while (r.pos < c) {
                    var t = r.uint32();
                    switch (t >>> 3) {
                    case 1:
                        m.to = $root.google.protobuf.Timestamp.decode(r, r.uint32());
                        break;
                    case 2:
                        m.from = $root.google.protobuf.Timestamp.decode(r, r.uint32());
                        break;
                    default:
                        r.skipType(t & 7);
                        break;
                    }
                }
                return m;
            };

            return EntryDateRange;
        })();

        /**
         * CompanyCode enum.
         * @name contractpb.ContractSearchRequest.CompanyCode
         * @enum {number}
         * @property {number} unknown=0 unknown value
         * @property {number} ahs=1 ahs value
         * @property {number} hsa=2 hsa value
         * @property {number} ftdr=3 ftdr value
         * @property {number} hbw210=4 hbw210 value
         */
        ContractSearchRequest.CompanyCode = (function() {
            const valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "unknown"] = 0;
            values[valuesById[1] = "ahs"] = 1;
            values[valuesById[2] = "hsa"] = 2;
            values[valuesById[3] = "ftdr"] = 3;
            values[valuesById[4] = "hbw210"] = 4;
            return values;
        })();

        return ContractSearchRequest;
    })();

    contractpb.ContractSearchProperty = (function() {

        /**
         * Properties of a ContractSearchProperty.
         * @memberof contractpb
         * @interface IContractSearchProperty
         * @property {string|null} [ID] ContractSearchProperty ID
         * @property {string|null} [type] ContractSearchProperty type
         * @property {string|null} [dwellingType] ContractSearchProperty dwellingType
         * @property {string|null} [streetAddress] ContractSearchProperty streetAddress
         * @property {string|null} [streetAddress2] ContractSearchProperty streetAddress2
         * @property {string|null} [city] ContractSearchProperty city
         * @property {string|null} [state] ContractSearchProperty state
         * @property {string|null} [zip] ContractSearchProperty zip
         * @property {string|null} [zipFour] ContractSearchProperty zipFour
         */

        /**
         * Constructs a new ContractSearchProperty.
         * @memberof contractpb
         * @classdesc Represents a ContractSearchProperty.
         * @implements IContractSearchProperty
         * @constructor
         * @param {contractpb.IContractSearchProperty=} [p] Properties to set
         */
        function ContractSearchProperty(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * ContractSearchProperty ID.
         * @member {string} ID
         * @memberof contractpb.ContractSearchProperty
         * @instance
         */
        ContractSearchProperty.prototype.ID = "";

        /**
         * ContractSearchProperty type.
         * @member {string} type
         * @memberof contractpb.ContractSearchProperty
         * @instance
         */
        ContractSearchProperty.prototype.type = "";

        /**
         * ContractSearchProperty dwellingType.
         * @member {string} dwellingType
         * @memberof contractpb.ContractSearchProperty
         * @instance
         */
        ContractSearchProperty.prototype.dwellingType = "";

        /**
         * ContractSearchProperty streetAddress.
         * @member {string} streetAddress
         * @memberof contractpb.ContractSearchProperty
         * @instance
         */
        ContractSearchProperty.prototype.streetAddress = "";

        /**
         * ContractSearchProperty streetAddress2.
         * @member {string} streetAddress2
         * @memberof contractpb.ContractSearchProperty
         * @instance
         */
        ContractSearchProperty.prototype.streetAddress2 = "";

        /**
         * ContractSearchProperty city.
         * @member {string} city
         * @memberof contractpb.ContractSearchProperty
         * @instance
         */
        ContractSearchProperty.prototype.city = "";

        /**
         * ContractSearchProperty state.
         * @member {string} state
         * @memberof contractpb.ContractSearchProperty
         * @instance
         */
        ContractSearchProperty.prototype.state = "";

        /**
         * ContractSearchProperty zip.
         * @member {string} zip
         * @memberof contractpb.ContractSearchProperty
         * @instance
         */
        ContractSearchProperty.prototype.zip = "";

        /**
         * ContractSearchProperty zipFour.
         * @member {string} zipFour
         * @memberof contractpb.ContractSearchProperty
         * @instance
         */
        ContractSearchProperty.prototype.zipFour = "";

        /**
         * Creates a new ContractSearchProperty instance using the specified properties.
         * @function create
         * @memberof contractpb.ContractSearchProperty
         * @static
         * @param {contractpb.IContractSearchProperty=} [properties] Properties to set
         * @returns {contractpb.ContractSearchProperty} ContractSearchProperty instance
         */
        ContractSearchProperty.create = function create(properties) {
            return new ContractSearchProperty(properties);
        };

        /**
         * Encodes the specified ContractSearchProperty message. Does not implicitly {@link contractpb.ContractSearchProperty.verify|verify} messages.
         * @function encode
         * @memberof contractpb.ContractSearchProperty
         * @static
         * @param {contractpb.IContractSearchProperty} m ContractSearchProperty message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ContractSearchProperty.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.ID != null && Object.hasOwnProperty.call(m, "ID"))
                w.uint32(10).string(m.ID);
            if (m.type != null && Object.hasOwnProperty.call(m, "type"))
                w.uint32(18).string(m.type);
            if (m.dwellingType != null && Object.hasOwnProperty.call(m, "dwellingType"))
                w.uint32(26).string(m.dwellingType);
            if (m.streetAddress != null && Object.hasOwnProperty.call(m, "streetAddress"))
                w.uint32(34).string(m.streetAddress);
            if (m.streetAddress2 != null && Object.hasOwnProperty.call(m, "streetAddress2"))
                w.uint32(42).string(m.streetAddress2);
            if (m.city != null && Object.hasOwnProperty.call(m, "city"))
                w.uint32(50).string(m.city);
            if (m.state != null && Object.hasOwnProperty.call(m, "state"))
                w.uint32(58).string(m.state);
            if (m.zip != null && Object.hasOwnProperty.call(m, "zip"))
                w.uint32(66).string(m.zip);
            if (m.zipFour != null && Object.hasOwnProperty.call(m, "zipFour"))
                w.uint32(74).string(m.zipFour);
            return w;
        };

        /**
         * Decodes a ContractSearchProperty message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.ContractSearchProperty
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.ContractSearchProperty} ContractSearchProperty
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ContractSearchProperty.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.ContractSearchProperty();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.ID = r.string();
                    break;
                case 2:
                    m.type = r.string();
                    break;
                case 3:
                    m.dwellingType = r.string();
                    break;
                case 4:
                    m.streetAddress = r.string();
                    break;
                case 5:
                    m.streetAddress2 = r.string();
                    break;
                case 6:
                    m.city = r.string();
                    break;
                case 7:
                    m.state = r.string();
                    break;
                case 8:
                    m.zip = r.string();
                    break;
                case 9:
                    m.zipFour = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return ContractSearchProperty;
    })();

    contractpb.ContractProperty = (function() {

        /**
         * Properties of a ContractProperty.
         * @memberof contractpb
         * @interface IContractProperty
         * @property {string|null} [ID] ContractProperty ID
         * @property {string|null} [type] ContractProperty type
         * @property {string|null} [dwellingType] ContractProperty dwellingType
         * @property {string|null} [streetAddress] ContractProperty streetAddress
         * @property {string|null} [streetAddress2] ContractProperty streetAddress2
         * @property {string|null} [city] ContractProperty city
         * @property {string|null} [state] ContractProperty state
         * @property {string|null} [zip] ContractProperty zip
         * @property {string|null} [zipFour] ContractProperty zipFour
         * @property {string|null} [streetNumber] ContractProperty streetNumber
         * @property {string|null} [streetDirection] ContractProperty streetDirection
         * @property {string|null} [streetName] ContractProperty streetName
         * @property {string|null} [unitType] ContractProperty unitType
         * @property {string|null} [unitNumber] ContractProperty unitNumber
         * @property {number|null} [squareFeet] ContractProperty squareFeet
         * @property {string|null} [yearBuilt] ContractProperty yearBuilt
         * @property {number|null} [numberMotherLawUnits] ContractProperty numberMotherLawUnits
         * @property {number|null} [propertyValue] ContractProperty propertyValue
         * @property {string|null} [addressUUID] ContractProperty addressUUID
         * @property {boolean|null} [verifiedAddress] ContractProperty verifiedAddress
         */

        /**
         * Constructs a new ContractProperty.
         * @memberof contractpb
         * @classdesc Represents a ContractProperty.
         * @implements IContractProperty
         * @constructor
         * @param {contractpb.IContractProperty=} [p] Properties to set
         */
        function ContractProperty(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * ContractProperty ID.
         * @member {string} ID
         * @memberof contractpb.ContractProperty
         * @instance
         */
        ContractProperty.prototype.ID = "";

        /**
         * ContractProperty type.
         * @member {string} type
         * @memberof contractpb.ContractProperty
         * @instance
         */
        ContractProperty.prototype.type = "";

        /**
         * ContractProperty dwellingType.
         * @member {string} dwellingType
         * @memberof contractpb.ContractProperty
         * @instance
         */
        ContractProperty.prototype.dwellingType = "";

        /**
         * ContractProperty streetAddress.
         * @member {string} streetAddress
         * @memberof contractpb.ContractProperty
         * @instance
         */
        ContractProperty.prototype.streetAddress = "";

        /**
         * ContractProperty streetAddress2.
         * @member {string} streetAddress2
         * @memberof contractpb.ContractProperty
         * @instance
         */
        ContractProperty.prototype.streetAddress2 = "";

        /**
         * ContractProperty city.
         * @member {string} city
         * @memberof contractpb.ContractProperty
         * @instance
         */
        ContractProperty.prototype.city = "";

        /**
         * ContractProperty state.
         * @member {string} state
         * @memberof contractpb.ContractProperty
         * @instance
         */
        ContractProperty.prototype.state = "";

        /**
         * ContractProperty zip.
         * @member {string} zip
         * @memberof contractpb.ContractProperty
         * @instance
         */
        ContractProperty.prototype.zip = "";

        /**
         * ContractProperty zipFour.
         * @member {string} zipFour
         * @memberof contractpb.ContractProperty
         * @instance
         */
        ContractProperty.prototype.zipFour = "";

        /**
         * ContractProperty streetNumber.
         * @member {string} streetNumber
         * @memberof contractpb.ContractProperty
         * @instance
         */
        ContractProperty.prototype.streetNumber = "";

        /**
         * ContractProperty streetDirection.
         * @member {string} streetDirection
         * @memberof contractpb.ContractProperty
         * @instance
         */
        ContractProperty.prototype.streetDirection = "";

        /**
         * ContractProperty streetName.
         * @member {string} streetName
         * @memberof contractpb.ContractProperty
         * @instance
         */
        ContractProperty.prototype.streetName = "";

        /**
         * ContractProperty unitType.
         * @member {string} unitType
         * @memberof contractpb.ContractProperty
         * @instance
         */
        ContractProperty.prototype.unitType = "";

        /**
         * ContractProperty unitNumber.
         * @member {string} unitNumber
         * @memberof contractpb.ContractProperty
         * @instance
         */
        ContractProperty.prototype.unitNumber = "";

        /**
         * ContractProperty squareFeet.
         * @member {number} squareFeet
         * @memberof contractpb.ContractProperty
         * @instance
         */
        ContractProperty.prototype.squareFeet = 0;

        /**
         * ContractProperty yearBuilt.
         * @member {string} yearBuilt
         * @memberof contractpb.ContractProperty
         * @instance
         */
        ContractProperty.prototype.yearBuilt = "";

        /**
         * ContractProperty numberMotherLawUnits.
         * @member {number} numberMotherLawUnits
         * @memberof contractpb.ContractProperty
         * @instance
         */
        ContractProperty.prototype.numberMotherLawUnits = 0;

        /**
         * ContractProperty propertyValue.
         * @member {number} propertyValue
         * @memberof contractpb.ContractProperty
         * @instance
         */
        ContractProperty.prototype.propertyValue = 0;

        /**
         * ContractProperty addressUUID.
         * @member {string} addressUUID
         * @memberof contractpb.ContractProperty
         * @instance
         */
        ContractProperty.prototype.addressUUID = "";

        /**
         * ContractProperty verifiedAddress.
         * @member {boolean} verifiedAddress
         * @memberof contractpb.ContractProperty
         * @instance
         */
        ContractProperty.prototype.verifiedAddress = false;

        /**
         * Creates a new ContractProperty instance using the specified properties.
         * @function create
         * @memberof contractpb.ContractProperty
         * @static
         * @param {contractpb.IContractProperty=} [properties] Properties to set
         * @returns {contractpb.ContractProperty} ContractProperty instance
         */
        ContractProperty.create = function create(properties) {
            return new ContractProperty(properties);
        };

        /**
         * Encodes the specified ContractProperty message. Does not implicitly {@link contractpb.ContractProperty.verify|verify} messages.
         * @function encode
         * @memberof contractpb.ContractProperty
         * @static
         * @param {contractpb.IContractProperty} m ContractProperty message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ContractProperty.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.ID != null && Object.hasOwnProperty.call(m, "ID"))
                w.uint32(10).string(m.ID);
            if (m.type != null && Object.hasOwnProperty.call(m, "type"))
                w.uint32(18).string(m.type);
            if (m.dwellingType != null && Object.hasOwnProperty.call(m, "dwellingType"))
                w.uint32(26).string(m.dwellingType);
            if (m.streetAddress != null && Object.hasOwnProperty.call(m, "streetAddress"))
                w.uint32(34).string(m.streetAddress);
            if (m.streetAddress2 != null && Object.hasOwnProperty.call(m, "streetAddress2"))
                w.uint32(42).string(m.streetAddress2);
            if (m.city != null && Object.hasOwnProperty.call(m, "city"))
                w.uint32(50).string(m.city);
            if (m.state != null && Object.hasOwnProperty.call(m, "state"))
                w.uint32(58).string(m.state);
            if (m.zip != null && Object.hasOwnProperty.call(m, "zip"))
                w.uint32(66).string(m.zip);
            if (m.zipFour != null && Object.hasOwnProperty.call(m, "zipFour"))
                w.uint32(74).string(m.zipFour);
            if (m.streetNumber != null && Object.hasOwnProperty.call(m, "streetNumber"))
                w.uint32(82).string(m.streetNumber);
            if (m.streetDirection != null && Object.hasOwnProperty.call(m, "streetDirection"))
                w.uint32(90).string(m.streetDirection);
            if (m.streetName != null && Object.hasOwnProperty.call(m, "streetName"))
                w.uint32(98).string(m.streetName);
            if (m.unitType != null && Object.hasOwnProperty.call(m, "unitType"))
                w.uint32(106).string(m.unitType);
            if (m.unitNumber != null && Object.hasOwnProperty.call(m, "unitNumber"))
                w.uint32(114).string(m.unitNumber);
            if (m.squareFeet != null && Object.hasOwnProperty.call(m, "squareFeet"))
                w.uint32(120).int32(m.squareFeet);
            if (m.yearBuilt != null && Object.hasOwnProperty.call(m, "yearBuilt"))
                w.uint32(130).string(m.yearBuilt);
            if (m.numberMotherLawUnits != null && Object.hasOwnProperty.call(m, "numberMotherLawUnits"))
                w.uint32(136).int32(m.numberMotherLawUnits);
            if (m.propertyValue != null && Object.hasOwnProperty.call(m, "propertyValue"))
                w.uint32(144).int32(m.propertyValue);
            if (m.addressUUID != null && Object.hasOwnProperty.call(m, "addressUUID"))
                w.uint32(154).string(m.addressUUID);
            if (m.verifiedAddress != null && Object.hasOwnProperty.call(m, "verifiedAddress"))
                w.uint32(160).bool(m.verifiedAddress);
            return w;
        };

        /**
         * Decodes a ContractProperty message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.ContractProperty
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.ContractProperty} ContractProperty
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ContractProperty.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.ContractProperty();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.ID = r.string();
                    break;
                case 2:
                    m.type = r.string();
                    break;
                case 3:
                    m.dwellingType = r.string();
                    break;
                case 4:
                    m.streetAddress = r.string();
                    break;
                case 5:
                    m.streetAddress2 = r.string();
                    break;
                case 6:
                    m.city = r.string();
                    break;
                case 7:
                    m.state = r.string();
                    break;
                case 8:
                    m.zip = r.string();
                    break;
                case 9:
                    m.zipFour = r.string();
                    break;
                case 10:
                    m.streetNumber = r.string();
                    break;
                case 11:
                    m.streetDirection = r.string();
                    break;
                case 12:
                    m.streetName = r.string();
                    break;
                case 13:
                    m.unitType = r.string();
                    break;
                case 14:
                    m.unitNumber = r.string();
                    break;
                case 15:
                    m.squareFeet = r.int32();
                    break;
                case 16:
                    m.yearBuilt = r.string();
                    break;
                case 17:
                    m.numberMotherLawUnits = r.int32();
                    break;
                case 18:
                    m.propertyValue = r.int32();
                    break;
                case 19:
                    m.addressUUID = r.string();
                    break;
                case 20:
                    m.verifiedAddress = r.bool();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return ContractProperty;
    })();

    contractpb.ContractSearchCustomer = (function() {

        /**
         * Properties of a ContractSearchCustomer.
         * @memberof contractpb
         * @interface IContractSearchCustomer
         * @property {string|null} [ID] ContractSearchCustomer ID
         * @property {string|null} [phone] ContractSearchCustomer phone
         */

        /**
         * Constructs a new ContractSearchCustomer.
         * @memberof contractpb
         * @classdesc Represents a ContractSearchCustomer.
         * @implements IContractSearchCustomer
         * @constructor
         * @param {contractpb.IContractSearchCustomer=} [p] Properties to set
         */
        function ContractSearchCustomer(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * ContractSearchCustomer ID.
         * @member {string} ID
         * @memberof contractpb.ContractSearchCustomer
         * @instance
         */
        ContractSearchCustomer.prototype.ID = "";

        /**
         * ContractSearchCustomer phone.
         * @member {string} phone
         * @memberof contractpb.ContractSearchCustomer
         * @instance
         */
        ContractSearchCustomer.prototype.phone = "";

        /**
         * Creates a new ContractSearchCustomer instance using the specified properties.
         * @function create
         * @memberof contractpb.ContractSearchCustomer
         * @static
         * @param {contractpb.IContractSearchCustomer=} [properties] Properties to set
         * @returns {contractpb.ContractSearchCustomer} ContractSearchCustomer instance
         */
        ContractSearchCustomer.create = function create(properties) {
            return new ContractSearchCustomer(properties);
        };

        /**
         * Encodes the specified ContractSearchCustomer message. Does not implicitly {@link contractpb.ContractSearchCustomer.verify|verify} messages.
         * @function encode
         * @memberof contractpb.ContractSearchCustomer
         * @static
         * @param {contractpb.IContractSearchCustomer} m ContractSearchCustomer message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ContractSearchCustomer.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.ID != null && Object.hasOwnProperty.call(m, "ID"))
                w.uint32(10).string(m.ID);
            if (m.phone != null && Object.hasOwnProperty.call(m, "phone"))
                w.uint32(18).string(m.phone);
            return w;
        };

        /**
         * Decodes a ContractSearchCustomer message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.ContractSearchCustomer
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.ContractSearchCustomer} ContractSearchCustomer
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ContractSearchCustomer.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.ContractSearchCustomer();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.ID = r.string();
                    break;
                case 2:
                    m.phone = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return ContractSearchCustomer;
    })();

    contractpb.ContractSearchOffice = (function() {

        /**
         * Properties of a ContractSearchOffice.
         * @memberof contractpb
         * @interface IContractSearchOffice
         * @property {string|null} [ID] ContractSearchOffice ID
         * @property {string|null} [type] ContractSearchOffice type
         * @property {string|null} [representing] ContractSearchOffice representing
         */

        /**
         * Constructs a new ContractSearchOffice.
         * @memberof contractpb
         * @classdesc Represents a ContractSearchOffice.
         * @implements IContractSearchOffice
         * @constructor
         * @param {contractpb.IContractSearchOffice=} [p] Properties to set
         */
        function ContractSearchOffice(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * ContractSearchOffice ID.
         * @member {string} ID
         * @memberof contractpb.ContractSearchOffice
         * @instance
         */
        ContractSearchOffice.prototype.ID = "";

        /**
         * ContractSearchOffice type.
         * @member {string} type
         * @memberof contractpb.ContractSearchOffice
         * @instance
         */
        ContractSearchOffice.prototype.type = "";

        /**
         * ContractSearchOffice representing.
         * @member {string} representing
         * @memberof contractpb.ContractSearchOffice
         * @instance
         */
        ContractSearchOffice.prototype.representing = "";

        /**
         * Creates a new ContractSearchOffice instance using the specified properties.
         * @function create
         * @memberof contractpb.ContractSearchOffice
         * @static
         * @param {contractpb.IContractSearchOffice=} [properties] Properties to set
         * @returns {contractpb.ContractSearchOffice} ContractSearchOffice instance
         */
        ContractSearchOffice.create = function create(properties) {
            return new ContractSearchOffice(properties);
        };

        /**
         * Encodes the specified ContractSearchOffice message. Does not implicitly {@link contractpb.ContractSearchOffice.verify|verify} messages.
         * @function encode
         * @memberof contractpb.ContractSearchOffice
         * @static
         * @param {contractpb.IContractSearchOffice} m ContractSearchOffice message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ContractSearchOffice.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.ID != null && Object.hasOwnProperty.call(m, "ID"))
                w.uint32(10).string(m.ID);
            if (m.type != null && Object.hasOwnProperty.call(m, "type"))
                w.uint32(18).string(m.type);
            if (m.representing != null && Object.hasOwnProperty.call(m, "representing"))
                w.uint32(34).string(m.representing);
            return w;
        };

        /**
         * Decodes a ContractSearchOffice message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.ContractSearchOffice
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.ContractSearchOffice} ContractSearchOffice
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ContractSearchOffice.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.ContractSearchOffice();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.ID = r.string();
                    break;
                case 2:
                    m.type = r.string();
                    break;
                case 4:
                    m.representing = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return ContractSearchOffice;
    })();

    contractpb.ContractSearchAgent = (function() {

        /**
         * Properties of a ContractSearchAgent.
         * @memberof contractpb
         * @interface IContractSearchAgent
         * @property {string|null} [ID] ContractSearchAgent ID
         * @property {string|null} [type] ContractSearchAgent type
         * @property {string|null} [representing] ContractSearchAgent representing
         */

        /**
         * Constructs a new ContractSearchAgent.
         * @memberof contractpb
         * @classdesc Represents a ContractSearchAgent.
         * @implements IContractSearchAgent
         * @constructor
         * @param {contractpb.IContractSearchAgent=} [p] Properties to set
         */
        function ContractSearchAgent(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * ContractSearchAgent ID.
         * @member {string} ID
         * @memberof contractpb.ContractSearchAgent
         * @instance
         */
        ContractSearchAgent.prototype.ID = "";

        /**
         * ContractSearchAgent type.
         * @member {string} type
         * @memberof contractpb.ContractSearchAgent
         * @instance
         */
        ContractSearchAgent.prototype.type = "";

        /**
         * ContractSearchAgent representing.
         * @member {string} representing
         * @memberof contractpb.ContractSearchAgent
         * @instance
         */
        ContractSearchAgent.prototype.representing = "";

        /**
         * Creates a new ContractSearchAgent instance using the specified properties.
         * @function create
         * @memberof contractpb.ContractSearchAgent
         * @static
         * @param {contractpb.IContractSearchAgent=} [properties] Properties to set
         * @returns {contractpb.ContractSearchAgent} ContractSearchAgent instance
         */
        ContractSearchAgent.create = function create(properties) {
            return new ContractSearchAgent(properties);
        };

        /**
         * Encodes the specified ContractSearchAgent message. Does not implicitly {@link contractpb.ContractSearchAgent.verify|verify} messages.
         * @function encode
         * @memberof contractpb.ContractSearchAgent
         * @static
         * @param {contractpb.IContractSearchAgent} m ContractSearchAgent message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ContractSearchAgent.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.ID != null && Object.hasOwnProperty.call(m, "ID"))
                w.uint32(10).string(m.ID);
            if (m.type != null && Object.hasOwnProperty.call(m, "type"))
                w.uint32(18).string(m.type);
            if (m.representing != null && Object.hasOwnProperty.call(m, "representing"))
                w.uint32(26).string(m.representing);
            return w;
        };

        /**
         * Decodes a ContractSearchAgent message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.ContractSearchAgent
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.ContractSearchAgent} ContractSearchAgent
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ContractSearchAgent.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.ContractSearchAgent();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.ID = r.string();
                    break;
                case 2:
                    m.type = r.string();
                    break;
                case 3:
                    m.representing = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return ContractSearchAgent;
    })();

    contractpb.ContractSearchResponse = (function() {

        /**
         * Properties of a ContractSearchResponse.
         * @memberof contractpb
         * @interface IContractSearchResponse
         * @property {Array.<string>|null} [contractIDs] ContractSearchResponse contractIDs
         * @property {number|null} [from] ContractSearchResponse from
         * @property {number|null} [total] ContractSearchResponse total
         * @property {contractpb.IContractSearchDebugInfo|null} [debug] ContractSearchResponse debug
         */

        /**
         * Constructs a new ContractSearchResponse.
         * @memberof contractpb
         * @classdesc Represents a ContractSearchResponse.
         * @implements IContractSearchResponse
         * @constructor
         * @param {contractpb.IContractSearchResponse=} [p] Properties to set
         */
        function ContractSearchResponse(p) {
            this.contractIDs = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * ContractSearchResponse contractIDs.
         * @member {Array.<string>} contractIDs
         * @memberof contractpb.ContractSearchResponse
         * @instance
         */
        ContractSearchResponse.prototype.contractIDs = $util.emptyArray;

        /**
         * ContractSearchResponse from.
         * @member {number} from
         * @memberof contractpb.ContractSearchResponse
         * @instance
         */
        ContractSearchResponse.prototype.from = 0;

        /**
         * ContractSearchResponse total.
         * @member {number} total
         * @memberof contractpb.ContractSearchResponse
         * @instance
         */
        ContractSearchResponse.prototype.total = 0;

        /**
         * ContractSearchResponse debug.
         * @member {contractpb.IContractSearchDebugInfo|null|undefined} debug
         * @memberof contractpb.ContractSearchResponse
         * @instance
         */
        ContractSearchResponse.prototype.debug = null;

        /**
         * Creates a new ContractSearchResponse instance using the specified properties.
         * @function create
         * @memberof contractpb.ContractSearchResponse
         * @static
         * @param {contractpb.IContractSearchResponse=} [properties] Properties to set
         * @returns {contractpb.ContractSearchResponse} ContractSearchResponse instance
         */
        ContractSearchResponse.create = function create(properties) {
            return new ContractSearchResponse(properties);
        };

        /**
         * Encodes the specified ContractSearchResponse message. Does not implicitly {@link contractpb.ContractSearchResponse.verify|verify} messages.
         * @function encode
         * @memberof contractpb.ContractSearchResponse
         * @static
         * @param {contractpb.IContractSearchResponse} m ContractSearchResponse message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ContractSearchResponse.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.contractIDs != null && m.contractIDs.length) {
                for (var i = 0; i < m.contractIDs.length; ++i)
                    w.uint32(10).string(m.contractIDs[i]);
            }
            if (m.from != null && Object.hasOwnProperty.call(m, "from"))
                w.uint32(16).int32(m.from);
            if (m.total != null && Object.hasOwnProperty.call(m, "total"))
                w.uint32(24).int32(m.total);
            if (m.debug != null && Object.hasOwnProperty.call(m, "debug"))
                $root.contractpb.ContractSearchDebugInfo.encode(m.debug, w.uint32(34).fork()).ldelim();
            return w;
        };

        /**
         * Decodes a ContractSearchResponse message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.ContractSearchResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.ContractSearchResponse} ContractSearchResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ContractSearchResponse.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.ContractSearchResponse();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    if (!(m.contractIDs && m.contractIDs.length))
                        m.contractIDs = [];
                    m.contractIDs.push(r.string());
                    break;
                case 2:
                    m.from = r.int32();
                    break;
                case 3:
                    m.total = r.int32();
                    break;
                case 4:
                    m.debug = $root.contractpb.ContractSearchDebugInfo.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return ContractSearchResponse;
    })();

    contractpb.ContractSearchDebugInfo = (function() {

        /**
         * Properties of a ContractSearchDebugInfo.
         * @memberof contractpb
         * @interface IContractSearchDebugInfo
         * @property {Array.<contractpb.IContractSearchDebugContract>|null} [elasticSearchResults] ContractSearchDebugInfo elasticSearchResults
         */

        /**
         * Constructs a new ContractSearchDebugInfo.
         * @memberof contractpb
         * @classdesc Represents a ContractSearchDebugInfo.
         * @implements IContractSearchDebugInfo
         * @constructor
         * @param {contractpb.IContractSearchDebugInfo=} [p] Properties to set
         */
        function ContractSearchDebugInfo(p) {
            this.elasticSearchResults = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * ContractSearchDebugInfo elasticSearchResults.
         * @member {Array.<contractpb.IContractSearchDebugContract>} elasticSearchResults
         * @memberof contractpb.ContractSearchDebugInfo
         * @instance
         */
        ContractSearchDebugInfo.prototype.elasticSearchResults = $util.emptyArray;

        /**
         * Creates a new ContractSearchDebugInfo instance using the specified properties.
         * @function create
         * @memberof contractpb.ContractSearchDebugInfo
         * @static
         * @param {contractpb.IContractSearchDebugInfo=} [properties] Properties to set
         * @returns {contractpb.ContractSearchDebugInfo} ContractSearchDebugInfo instance
         */
        ContractSearchDebugInfo.create = function create(properties) {
            return new ContractSearchDebugInfo(properties);
        };

        /**
         * Encodes the specified ContractSearchDebugInfo message. Does not implicitly {@link contractpb.ContractSearchDebugInfo.verify|verify} messages.
         * @function encode
         * @memberof contractpb.ContractSearchDebugInfo
         * @static
         * @param {contractpb.IContractSearchDebugInfo} m ContractSearchDebugInfo message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ContractSearchDebugInfo.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.elasticSearchResults != null && m.elasticSearchResults.length) {
                for (var i = 0; i < m.elasticSearchResults.length; ++i)
                    $root.contractpb.ContractSearchDebugContract.encode(m.elasticSearchResults[i], w.uint32(10).fork()).ldelim();
            }
            return w;
        };

        /**
         * Decodes a ContractSearchDebugInfo message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.ContractSearchDebugInfo
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.ContractSearchDebugInfo} ContractSearchDebugInfo
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ContractSearchDebugInfo.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.ContractSearchDebugInfo();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    if (!(m.elasticSearchResults && m.elasticSearchResults.length))
                        m.elasticSearchResults = [];
                    m.elasticSearchResults.push($root.contractpb.ContractSearchDebugContract.decode(r, r.uint32()));
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return ContractSearchDebugInfo;
    })();

    contractpb.ContractSearchDebugContract = (function() {

        /**
         * Properties of a ContractSearchDebugContract.
         * @memberof contractpb
         * @interface IContractSearchDebugContract
         * @property {string|null} [contractID] ContractSearchDebugContract contractID
         * @property {Array.<contractpb.IContractSearchDebugContractField>|null} [data] ContractSearchDebugContract data
         */

        /**
         * Constructs a new ContractSearchDebugContract.
         * @memberof contractpb
         * @classdesc Represents a ContractSearchDebugContract.
         * @implements IContractSearchDebugContract
         * @constructor
         * @param {contractpb.IContractSearchDebugContract=} [p] Properties to set
         */
        function ContractSearchDebugContract(p) {
            this.data = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * ContractSearchDebugContract contractID.
         * @member {string} contractID
         * @memberof contractpb.ContractSearchDebugContract
         * @instance
         */
        ContractSearchDebugContract.prototype.contractID = "";

        /**
         * ContractSearchDebugContract data.
         * @member {Array.<contractpb.IContractSearchDebugContractField>} data
         * @memberof contractpb.ContractSearchDebugContract
         * @instance
         */
        ContractSearchDebugContract.prototype.data = $util.emptyArray;

        /**
         * Creates a new ContractSearchDebugContract instance using the specified properties.
         * @function create
         * @memberof contractpb.ContractSearchDebugContract
         * @static
         * @param {contractpb.IContractSearchDebugContract=} [properties] Properties to set
         * @returns {contractpb.ContractSearchDebugContract} ContractSearchDebugContract instance
         */
        ContractSearchDebugContract.create = function create(properties) {
            return new ContractSearchDebugContract(properties);
        };

        /**
         * Encodes the specified ContractSearchDebugContract message. Does not implicitly {@link contractpb.ContractSearchDebugContract.verify|verify} messages.
         * @function encode
         * @memberof contractpb.ContractSearchDebugContract
         * @static
         * @param {contractpb.IContractSearchDebugContract} m ContractSearchDebugContract message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ContractSearchDebugContract.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.contractID != null && Object.hasOwnProperty.call(m, "contractID"))
                w.uint32(10).string(m.contractID);
            if (m.data != null && m.data.length) {
                for (var i = 0; i < m.data.length; ++i)
                    $root.contractpb.ContractSearchDebugContractField.encode(m.data[i], w.uint32(18).fork()).ldelim();
            }
            return w;
        };

        /**
         * Decodes a ContractSearchDebugContract message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.ContractSearchDebugContract
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.ContractSearchDebugContract} ContractSearchDebugContract
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ContractSearchDebugContract.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.ContractSearchDebugContract();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.contractID = r.string();
                    break;
                case 2:
                    if (!(m.data && m.data.length))
                        m.data = [];
                    m.data.push($root.contractpb.ContractSearchDebugContractField.decode(r, r.uint32()));
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return ContractSearchDebugContract;
    })();

    contractpb.ContractSearchDebugContractField = (function() {

        /**
         * Properties of a ContractSearchDebugContractField.
         * @memberof contractpb
         * @interface IContractSearchDebugContractField
         * @property {string|null} [name] ContractSearchDebugContractField name
         * @property {boolean|null} [found] ContractSearchDebugContractField found
         */

        /**
         * Constructs a new ContractSearchDebugContractField.
         * @memberof contractpb
         * @classdesc Represents a ContractSearchDebugContractField.
         * @implements IContractSearchDebugContractField
         * @constructor
         * @param {contractpb.IContractSearchDebugContractField=} [p] Properties to set
         */
        function ContractSearchDebugContractField(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * ContractSearchDebugContractField name.
         * @member {string} name
         * @memberof contractpb.ContractSearchDebugContractField
         * @instance
         */
        ContractSearchDebugContractField.prototype.name = "";

        /**
         * ContractSearchDebugContractField found.
         * @member {boolean} found
         * @memberof contractpb.ContractSearchDebugContractField
         * @instance
         */
        ContractSearchDebugContractField.prototype.found = false;

        /**
         * Creates a new ContractSearchDebugContractField instance using the specified properties.
         * @function create
         * @memberof contractpb.ContractSearchDebugContractField
         * @static
         * @param {contractpb.IContractSearchDebugContractField=} [properties] Properties to set
         * @returns {contractpb.ContractSearchDebugContractField} ContractSearchDebugContractField instance
         */
        ContractSearchDebugContractField.create = function create(properties) {
            return new ContractSearchDebugContractField(properties);
        };

        /**
         * Encodes the specified ContractSearchDebugContractField message. Does not implicitly {@link contractpb.ContractSearchDebugContractField.verify|verify} messages.
         * @function encode
         * @memberof contractpb.ContractSearchDebugContractField
         * @static
         * @param {contractpb.IContractSearchDebugContractField} m ContractSearchDebugContractField message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ContractSearchDebugContractField.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.name != null && Object.hasOwnProperty.call(m, "name"))
                w.uint32(10).string(m.name);
            if (m.found != null && Object.hasOwnProperty.call(m, "found"))
                w.uint32(16).bool(m.found);
            return w;
        };

        /**
         * Decodes a ContractSearchDebugContractField message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.ContractSearchDebugContractField
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.ContractSearchDebugContractField} ContractSearchDebugContractField
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ContractSearchDebugContractField.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.ContractSearchDebugContractField();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.name = r.string();
                    break;
                case 2:
                    m.found = r.bool();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return ContractSearchDebugContractField;
    })();

    contractpb.ContractSearch = (function() {

        /**
         * Properties of a ContractSearch.
         * @memberof contractpb
         * @interface IContractSearch
         * @property {string|null} [ID] ContractSearch ID
         * @property {string|null} [status] ContractSearch status
         * @property {string|null} [companyCode] ContractSearch companyCode
         * @property {string|null} [originalSalesChannel] ContractSearch originalSalesChannel
         * @property {string|null} [salesChannel] ContractSearch salesChannel
         * @property {string|null} [productVersionID] ContractSearch productVersionID
         * @property {string|null} [productSalesChannel] ContractSearch productSalesChannel
         * @property {contractpb.IContractSearchProperty|null} [property] ContractSearch property
         */

        /**
         * Constructs a new ContractSearch.
         * @memberof contractpb
         * @classdesc Represents a ContractSearch.
         * @implements IContractSearch
         * @constructor
         * @param {contractpb.IContractSearch=} [p] Properties to set
         */
        function ContractSearch(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * ContractSearch ID.
         * @member {string} ID
         * @memberof contractpb.ContractSearch
         * @instance
         */
        ContractSearch.prototype.ID = "";

        /**
         * ContractSearch status.
         * @member {string} status
         * @memberof contractpb.ContractSearch
         * @instance
         */
        ContractSearch.prototype.status = "";

        /**
         * ContractSearch companyCode.
         * @member {string} companyCode
         * @memberof contractpb.ContractSearch
         * @instance
         */
        ContractSearch.prototype.companyCode = "";

        /**
         * ContractSearch originalSalesChannel.
         * @member {string} originalSalesChannel
         * @memberof contractpb.ContractSearch
         * @instance
         */
        ContractSearch.prototype.originalSalesChannel = "";

        /**
         * ContractSearch salesChannel.
         * @member {string} salesChannel
         * @memberof contractpb.ContractSearch
         * @instance
         */
        ContractSearch.prototype.salesChannel = "";

        /**
         * ContractSearch productVersionID.
         * @member {string} productVersionID
         * @memberof contractpb.ContractSearch
         * @instance
         */
        ContractSearch.prototype.productVersionID = "";

        /**
         * ContractSearch productSalesChannel.
         * @member {string} productSalesChannel
         * @memberof contractpb.ContractSearch
         * @instance
         */
        ContractSearch.prototype.productSalesChannel = "";

        /**
         * ContractSearch property.
         * @member {contractpb.IContractSearchProperty|null|undefined} property
         * @memberof contractpb.ContractSearch
         * @instance
         */
        ContractSearch.prototype.property = null;

        /**
         * Creates a new ContractSearch instance using the specified properties.
         * @function create
         * @memberof contractpb.ContractSearch
         * @static
         * @param {contractpb.IContractSearch=} [properties] Properties to set
         * @returns {contractpb.ContractSearch} ContractSearch instance
         */
        ContractSearch.create = function create(properties) {
            return new ContractSearch(properties);
        };

        /**
         * Encodes the specified ContractSearch message. Does not implicitly {@link contractpb.ContractSearch.verify|verify} messages.
         * @function encode
         * @memberof contractpb.ContractSearch
         * @static
         * @param {contractpb.IContractSearch} m ContractSearch message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ContractSearch.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.ID != null && Object.hasOwnProperty.call(m, "ID"))
                w.uint32(10).string(m.ID);
            if (m.status != null && Object.hasOwnProperty.call(m, "status"))
                w.uint32(18).string(m.status);
            if (m.companyCode != null && Object.hasOwnProperty.call(m, "companyCode"))
                w.uint32(26).string(m.companyCode);
            if (m.originalSalesChannel != null && Object.hasOwnProperty.call(m, "originalSalesChannel"))
                w.uint32(34).string(m.originalSalesChannel);
            if (m.salesChannel != null && Object.hasOwnProperty.call(m, "salesChannel"))
                w.uint32(42).string(m.salesChannel);
            if (m.productVersionID != null && Object.hasOwnProperty.call(m, "productVersionID"))
                w.uint32(50).string(m.productVersionID);
            if (m.productSalesChannel != null && Object.hasOwnProperty.call(m, "productSalesChannel"))
                w.uint32(58).string(m.productSalesChannel);
            if (m.property != null && Object.hasOwnProperty.call(m, "property"))
                $root.contractpb.ContractSearchProperty.encode(m.property, w.uint32(66).fork()).ldelim();
            return w;
        };

        /**
         * Decodes a ContractSearch message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.ContractSearch
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.ContractSearch} ContractSearch
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ContractSearch.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.ContractSearch();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.ID = r.string();
                    break;
                case 2:
                    m.status = r.string();
                    break;
                case 3:
                    m.companyCode = r.string();
                    break;
                case 4:
                    m.originalSalesChannel = r.string();
                    break;
                case 5:
                    m.salesChannel = r.string();
                    break;
                case 6:
                    m.productVersionID = r.string();
                    break;
                case 7:
                    m.productSalesChannel = r.string();
                    break;
                case 8:
                    m.property = $root.contractpb.ContractSearchProperty.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return ContractSearch;
    })();

    contractpb.ContractHistory = (function() {

        /**
         * Properties of a ContractHistory.
         * @memberof contractpb
         * @interface IContractHistory
         * @property {string|null} [userID] ContractHistory userID
         * @property {string|null} [type] ContractHistory type
         * @property {string|null} [data] ContractHistory data
         * @property {string|null} [dateTimeStamp] ContractHistory dateTimeStamp
         */

        /**
         * Constructs a new ContractHistory.
         * @memberof contractpb
         * @classdesc Represents a ContractHistory.
         * @implements IContractHistory
         * @constructor
         * @param {contractpb.IContractHistory=} [p] Properties to set
         */
        function ContractHistory(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * ContractHistory userID.
         * @member {string} userID
         * @memberof contractpb.ContractHistory
         * @instance
         */
        ContractHistory.prototype.userID = "";

        /**
         * ContractHistory type.
         * @member {string} type
         * @memberof contractpb.ContractHistory
         * @instance
         */
        ContractHistory.prototype.type = "";

        /**
         * ContractHistory data.
         * @member {string} data
         * @memberof contractpb.ContractHistory
         * @instance
         */
        ContractHistory.prototype.data = "";

        /**
         * ContractHistory dateTimeStamp.
         * @member {string} dateTimeStamp
         * @memberof contractpb.ContractHistory
         * @instance
         */
        ContractHistory.prototype.dateTimeStamp = "";

        /**
         * Creates a new ContractHistory instance using the specified properties.
         * @function create
         * @memberof contractpb.ContractHistory
         * @static
         * @param {contractpb.IContractHistory=} [properties] Properties to set
         * @returns {contractpb.ContractHistory} ContractHistory instance
         */
        ContractHistory.create = function create(properties) {
            return new ContractHistory(properties);
        };

        /**
         * Encodes the specified ContractHistory message. Does not implicitly {@link contractpb.ContractHistory.verify|verify} messages.
         * @function encode
         * @memberof contractpb.ContractHistory
         * @static
         * @param {contractpb.IContractHistory} m ContractHistory message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ContractHistory.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.userID != null && Object.hasOwnProperty.call(m, "userID"))
                w.uint32(18).string(m.userID);
            if (m.type != null && Object.hasOwnProperty.call(m, "type"))
                w.uint32(26).string(m.type);
            if (m.data != null && Object.hasOwnProperty.call(m, "data"))
                w.uint32(34).string(m.data);
            if (m.dateTimeStamp != null && Object.hasOwnProperty.call(m, "dateTimeStamp"))
                w.uint32(42).string(m.dateTimeStamp);
            return w;
        };

        /**
         * Decodes a ContractHistory message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.ContractHistory
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.ContractHistory} ContractHistory
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ContractHistory.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.ContractHistory();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 2:
                    m.userID = r.string();
                    break;
                case 3:
                    m.type = r.string();
                    break;
                case 4:
                    m.data = r.string();
                    break;
                case 5:
                    m.dateTimeStamp = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return ContractHistory;
    })();

    contractpb.ContractHistoryResponse = (function() {

        /**
         * Properties of a ContractHistoryResponse.
         * @memberof contractpb
         * @interface IContractHistoryResponse
         * @property {Array.<contractpb.IContractHistory>|null} [history] ContractHistoryResponse history
         */

        /**
         * Constructs a new ContractHistoryResponse.
         * @memberof contractpb
         * @classdesc Represents a ContractHistoryResponse.
         * @implements IContractHistoryResponse
         * @constructor
         * @param {contractpb.IContractHistoryResponse=} [p] Properties to set
         */
        function ContractHistoryResponse(p) {
            this.history = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * ContractHistoryResponse history.
         * @member {Array.<contractpb.IContractHistory>} history
         * @memberof contractpb.ContractHistoryResponse
         * @instance
         */
        ContractHistoryResponse.prototype.history = $util.emptyArray;

        /**
         * Creates a new ContractHistoryResponse instance using the specified properties.
         * @function create
         * @memberof contractpb.ContractHistoryResponse
         * @static
         * @param {contractpb.IContractHistoryResponse=} [properties] Properties to set
         * @returns {contractpb.ContractHistoryResponse} ContractHistoryResponse instance
         */
        ContractHistoryResponse.create = function create(properties) {
            return new ContractHistoryResponse(properties);
        };

        /**
         * Encodes the specified ContractHistoryResponse message. Does not implicitly {@link contractpb.ContractHistoryResponse.verify|verify} messages.
         * @function encode
         * @memberof contractpb.ContractHistoryResponse
         * @static
         * @param {contractpb.IContractHistoryResponse} m ContractHistoryResponse message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ContractHistoryResponse.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.history != null && m.history.length) {
                for (var i = 0; i < m.history.length; ++i)
                    $root.contractpb.ContractHistory.encode(m.history[i], w.uint32(10).fork()).ldelim();
            }
            return w;
        };

        /**
         * Decodes a ContractHistoryResponse message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.ContractHistoryResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.ContractHistoryResponse} ContractHistoryResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ContractHistoryResponse.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.ContractHistoryResponse();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    if (!(m.history && m.history.length))
                        m.history = [];
                    m.history.push($root.contractpb.ContractHistory.decode(r, r.uint32()));
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return ContractHistoryResponse;
    })();

    contractpb.ContractRequest = (function() {

        /**
         * Properties of a ContractRequest.
         * @memberof contractpb
         * @interface IContractRequest
         * @property {string|null} [requestTypeCode] ContractRequest requestTypeCode
         * @property {string|null} [requestTypePrefix] ContractRequest requestTypePrefix
         * @property {string|null} [userID] ContractRequest userID
         * @property {string|null} [reasonTypeCode] ContractRequest reasonTypeCode
         * @property {string|null} [reasonTypePrefix] ContractRequest reasonTypePrefix
         * @property {string|null} [reasonText] ContractRequest reasonText
         */

        /**
         * Constructs a new ContractRequest.
         * @memberof contractpb
         * @classdesc Represents a ContractRequest.
         * @implements IContractRequest
         * @constructor
         * @param {contractpb.IContractRequest=} [p] Properties to set
         */
        function ContractRequest(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * ContractRequest requestTypeCode.
         * @member {string} requestTypeCode
         * @memberof contractpb.ContractRequest
         * @instance
         */
        ContractRequest.prototype.requestTypeCode = "";

        /**
         * ContractRequest requestTypePrefix.
         * @member {string} requestTypePrefix
         * @memberof contractpb.ContractRequest
         * @instance
         */
        ContractRequest.prototype.requestTypePrefix = "";

        /**
         * ContractRequest userID.
         * @member {string} userID
         * @memberof contractpb.ContractRequest
         * @instance
         */
        ContractRequest.prototype.userID = "";

        /**
         * ContractRequest reasonTypeCode.
         * @member {string} reasonTypeCode
         * @memberof contractpb.ContractRequest
         * @instance
         */
        ContractRequest.prototype.reasonTypeCode = "";

        /**
         * ContractRequest reasonTypePrefix.
         * @member {string} reasonTypePrefix
         * @memberof contractpb.ContractRequest
         * @instance
         */
        ContractRequest.prototype.reasonTypePrefix = "";

        /**
         * ContractRequest reasonText.
         * @member {string} reasonText
         * @memberof contractpb.ContractRequest
         * @instance
         */
        ContractRequest.prototype.reasonText = "";

        /**
         * Creates a new ContractRequest instance using the specified properties.
         * @function create
         * @memberof contractpb.ContractRequest
         * @static
         * @param {contractpb.IContractRequest=} [properties] Properties to set
         * @returns {contractpb.ContractRequest} ContractRequest instance
         */
        ContractRequest.create = function create(properties) {
            return new ContractRequest(properties);
        };

        /**
         * Encodes the specified ContractRequest message. Does not implicitly {@link contractpb.ContractRequest.verify|verify} messages.
         * @function encode
         * @memberof contractpb.ContractRequest
         * @static
         * @param {contractpb.IContractRequest} m ContractRequest message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ContractRequest.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.requestTypeCode != null && Object.hasOwnProperty.call(m, "requestTypeCode"))
                w.uint32(10).string(m.requestTypeCode);
            if (m.requestTypePrefix != null && Object.hasOwnProperty.call(m, "requestTypePrefix"))
                w.uint32(18).string(m.requestTypePrefix);
            if (m.userID != null && Object.hasOwnProperty.call(m, "userID"))
                w.uint32(26).string(m.userID);
            if (m.reasonTypeCode != null && Object.hasOwnProperty.call(m, "reasonTypeCode"))
                w.uint32(34).string(m.reasonTypeCode);
            if (m.reasonTypePrefix != null && Object.hasOwnProperty.call(m, "reasonTypePrefix"))
                w.uint32(42).string(m.reasonTypePrefix);
            if (m.reasonText != null && Object.hasOwnProperty.call(m, "reasonText"))
                w.uint32(50).string(m.reasonText);
            return w;
        };

        /**
         * Decodes a ContractRequest message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.ContractRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.ContractRequest} ContractRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ContractRequest.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.ContractRequest();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.requestTypeCode = r.string();
                    break;
                case 2:
                    m.requestTypePrefix = r.string();
                    break;
                case 3:
                    m.userID = r.string();
                    break;
                case 4:
                    m.reasonTypeCode = r.string();
                    break;
                case 5:
                    m.reasonTypePrefix = r.string();
                    break;
                case 6:
                    m.reasonText = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return ContractRequest;
    })();

    contractpb.ContractEFulfillmentResponse = (function() {

        /**
         * Properties of a ContractEFulfillmentResponse.
         * @memberof contractpb
         * @interface IContractEFulfillmentResponse
         * @property {google.protobuf.IBoolValue|null} [eFulfillmentEnabled] ContractEFulfillmentResponse eFulfillmentEnabled
         * @property {boolean|null} [eFulfillmentAccessible] ContractEFulfillmentResponse eFulfillmentAccessible
         */

        /**
         * Constructs a new ContractEFulfillmentResponse.
         * @memberof contractpb
         * @classdesc Represents a ContractEFulfillmentResponse.
         * @implements IContractEFulfillmentResponse
         * @constructor
         * @param {contractpb.IContractEFulfillmentResponse=} [p] Properties to set
         */
        function ContractEFulfillmentResponse(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * ContractEFulfillmentResponse eFulfillmentEnabled.
         * @member {google.protobuf.IBoolValue|null|undefined} eFulfillmentEnabled
         * @memberof contractpb.ContractEFulfillmentResponse
         * @instance
         */
        ContractEFulfillmentResponse.prototype.eFulfillmentEnabled = null;

        /**
         * ContractEFulfillmentResponse eFulfillmentAccessible.
         * @member {boolean} eFulfillmentAccessible
         * @memberof contractpb.ContractEFulfillmentResponse
         * @instance
         */
        ContractEFulfillmentResponse.prototype.eFulfillmentAccessible = false;

        /**
         * Creates a new ContractEFulfillmentResponse instance using the specified properties.
         * @function create
         * @memberof contractpb.ContractEFulfillmentResponse
         * @static
         * @param {contractpb.IContractEFulfillmentResponse=} [properties] Properties to set
         * @returns {contractpb.ContractEFulfillmentResponse} ContractEFulfillmentResponse instance
         */
        ContractEFulfillmentResponse.create = function create(properties) {
            return new ContractEFulfillmentResponse(properties);
        };

        /**
         * Encodes the specified ContractEFulfillmentResponse message. Does not implicitly {@link contractpb.ContractEFulfillmentResponse.verify|verify} messages.
         * @function encode
         * @memberof contractpb.ContractEFulfillmentResponse
         * @static
         * @param {contractpb.IContractEFulfillmentResponse} m ContractEFulfillmentResponse message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ContractEFulfillmentResponse.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.eFulfillmentEnabled != null && Object.hasOwnProperty.call(m, "eFulfillmentEnabled"))
                $root.google.protobuf.BoolValue.encode(m.eFulfillmentEnabled, w.uint32(10).fork()).ldelim();
            if (m.eFulfillmentAccessible != null && Object.hasOwnProperty.call(m, "eFulfillmentAccessible"))
                w.uint32(16).bool(m.eFulfillmentAccessible);
            return w;
        };

        /**
         * Decodes a ContractEFulfillmentResponse message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.ContractEFulfillmentResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.ContractEFulfillmentResponse} ContractEFulfillmentResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ContractEFulfillmentResponse.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.ContractEFulfillmentResponse();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.eFulfillmentEnabled = $root.google.protobuf.BoolValue.decode(r, r.uint32());
                    break;
                case 2:
                    m.eFulfillmentAccessible = r.bool();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return ContractEFulfillmentResponse;
    })();

    contractpb.ContractEFulfillmentRequest = (function() {

        /**
         * Properties of a ContractEFulfillmentRequest.
         * @memberof contractpb
         * @interface IContractEFulfillmentRequest
         * @property {boolean|null} [eFulfillmentEnabled] ContractEFulfillmentRequest eFulfillmentEnabled
         * @property {string|null} [customerID] ContractEFulfillmentRequest customerID
         */

        /**
         * Constructs a new ContractEFulfillmentRequest.
         * @memberof contractpb
         * @classdesc Represents a ContractEFulfillmentRequest.
         * @implements IContractEFulfillmentRequest
         * @constructor
         * @param {contractpb.IContractEFulfillmentRequest=} [p] Properties to set
         */
        function ContractEFulfillmentRequest(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * ContractEFulfillmentRequest eFulfillmentEnabled.
         * @member {boolean} eFulfillmentEnabled
         * @memberof contractpb.ContractEFulfillmentRequest
         * @instance
         */
        ContractEFulfillmentRequest.prototype.eFulfillmentEnabled = false;

        /**
         * ContractEFulfillmentRequest customerID.
         * @member {string} customerID
         * @memberof contractpb.ContractEFulfillmentRequest
         * @instance
         */
        ContractEFulfillmentRequest.prototype.customerID = "";

        /**
         * Creates a new ContractEFulfillmentRequest instance using the specified properties.
         * @function create
         * @memberof contractpb.ContractEFulfillmentRequest
         * @static
         * @param {contractpb.IContractEFulfillmentRequest=} [properties] Properties to set
         * @returns {contractpb.ContractEFulfillmentRequest} ContractEFulfillmentRequest instance
         */
        ContractEFulfillmentRequest.create = function create(properties) {
            return new ContractEFulfillmentRequest(properties);
        };

        /**
         * Encodes the specified ContractEFulfillmentRequest message. Does not implicitly {@link contractpb.ContractEFulfillmentRequest.verify|verify} messages.
         * @function encode
         * @memberof contractpb.ContractEFulfillmentRequest
         * @static
         * @param {contractpb.IContractEFulfillmentRequest} m ContractEFulfillmentRequest message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ContractEFulfillmentRequest.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.eFulfillmentEnabled != null && Object.hasOwnProperty.call(m, "eFulfillmentEnabled"))
                w.uint32(8).bool(m.eFulfillmentEnabled);
            if (m.customerID != null && Object.hasOwnProperty.call(m, "customerID"))
                w.uint32(18).string(m.customerID);
            return w;
        };

        /**
         * Decodes a ContractEFulfillmentRequest message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.ContractEFulfillmentRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.ContractEFulfillmentRequest} ContractEFulfillmentRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ContractEFulfillmentRequest.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.ContractEFulfillmentRequest();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.eFulfillmentEnabled = r.bool();
                    break;
                case 2:
                    m.customerID = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return ContractEFulfillmentRequest;
    })();

    contractpb.ContractOffices = (function() {

        /**
         * Properties of a ContractOffices.
         * @memberof contractpb
         * @interface IContractOffices
         * @property {Array.<contractpb.IContractOffice>|null} [offices] ContractOffices offices
         */

        /**
         * Constructs a new ContractOffices.
         * @memberof contractpb
         * @classdesc Represents a ContractOffices.
         * @implements IContractOffices
         * @constructor
         * @param {contractpb.IContractOffices=} [p] Properties to set
         */
        function ContractOffices(p) {
            this.offices = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * ContractOffices offices.
         * @member {Array.<contractpb.IContractOffice>} offices
         * @memberof contractpb.ContractOffices
         * @instance
         */
        ContractOffices.prototype.offices = $util.emptyArray;

        /**
         * Creates a new ContractOffices instance using the specified properties.
         * @function create
         * @memberof contractpb.ContractOffices
         * @static
         * @param {contractpb.IContractOffices=} [properties] Properties to set
         * @returns {contractpb.ContractOffices} ContractOffices instance
         */
        ContractOffices.create = function create(properties) {
            return new ContractOffices(properties);
        };

        /**
         * Encodes the specified ContractOffices message. Does not implicitly {@link contractpb.ContractOffices.verify|verify} messages.
         * @function encode
         * @memberof contractpb.ContractOffices
         * @static
         * @param {contractpb.IContractOffices} m ContractOffices message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ContractOffices.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.offices != null && m.offices.length) {
                for (var i = 0; i < m.offices.length; ++i)
                    $root.contractpb.ContractOffice.encode(m.offices[i], w.uint32(10).fork()).ldelim();
            }
            return w;
        };

        /**
         * Decodes a ContractOffices message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.ContractOffices
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.ContractOffices} ContractOffices
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ContractOffices.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.ContractOffices();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    if (!(m.offices && m.offices.length))
                        m.offices = [];
                    m.offices.push($root.contractpb.ContractOffice.decode(r, r.uint32()));
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return ContractOffices;
    })();

    contractpb.ContractOffice = (function() {

        /**
         * Properties of a ContractOffice.
         * @memberof contractpb
         * @interface IContractOffice
         * @property {string|null} [ID] ContractOffice ID
         * @property {string|null} [typeCode] ContractOffice typeCode
         * @property {string|null} [represents] ContractOffice represents
         * @property {string|null} [initiating] ContractOffice initiating
         * @property {string|null} [agentID] ContractOffice agentID
         */

        /**
         * Constructs a new ContractOffice.
         * @memberof contractpb
         * @classdesc Represents a ContractOffice.
         * @implements IContractOffice
         * @constructor
         * @param {contractpb.IContractOffice=} [p] Properties to set
         */
        function ContractOffice(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * ContractOffice ID.
         * @member {string} ID
         * @memberof contractpb.ContractOffice
         * @instance
         */
        ContractOffice.prototype.ID = "";

        /**
         * ContractOffice typeCode.
         * @member {string} typeCode
         * @memberof contractpb.ContractOffice
         * @instance
         */
        ContractOffice.prototype.typeCode = "";

        /**
         * ContractOffice represents.
         * @member {string} represents
         * @memberof contractpb.ContractOffice
         * @instance
         */
        ContractOffice.prototype.represents = "";

        /**
         * ContractOffice initiating.
         * @member {string} initiating
         * @memberof contractpb.ContractOffice
         * @instance
         */
        ContractOffice.prototype.initiating = "";

        /**
         * ContractOffice agentID.
         * @member {string} agentID
         * @memberof contractpb.ContractOffice
         * @instance
         */
        ContractOffice.prototype.agentID = "";

        /**
         * Creates a new ContractOffice instance using the specified properties.
         * @function create
         * @memberof contractpb.ContractOffice
         * @static
         * @param {contractpb.IContractOffice=} [properties] Properties to set
         * @returns {contractpb.ContractOffice} ContractOffice instance
         */
        ContractOffice.create = function create(properties) {
            return new ContractOffice(properties);
        };

        /**
         * Encodes the specified ContractOffice message. Does not implicitly {@link contractpb.ContractOffice.verify|verify} messages.
         * @function encode
         * @memberof contractpb.ContractOffice
         * @static
         * @param {contractpb.IContractOffice} m ContractOffice message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ContractOffice.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.ID != null && Object.hasOwnProperty.call(m, "ID"))
                w.uint32(10).string(m.ID);
            if (m.typeCode != null && Object.hasOwnProperty.call(m, "typeCode"))
                w.uint32(18).string(m.typeCode);
            if (m.represents != null && Object.hasOwnProperty.call(m, "represents"))
                w.uint32(26).string(m.represents);
            if (m.initiating != null && Object.hasOwnProperty.call(m, "initiating"))
                w.uint32(34).string(m.initiating);
            if (m.agentID != null && Object.hasOwnProperty.call(m, "agentID"))
                w.uint32(74).string(m.agentID);
            return w;
        };

        /**
         * Decodes a ContractOffice message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.ContractOffice
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.ContractOffice} ContractOffice
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ContractOffice.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.ContractOffice();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.ID = r.string();
                    break;
                case 2:
                    m.typeCode = r.string();
                    break;
                case 3:
                    m.represents = r.string();
                    break;
                case 4:
                    m.initiating = r.string();
                    break;
                case 9:
                    m.agentID = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return ContractOffice;
    })();

    contractpb.ContractListResponse = (function() {

        /**
         * Properties of a ContractListResponse.
         * @memberof contractpb
         * @interface IContractListResponse
         * @property {Array.<contractpb.IContractResponse>|null} [contracts] ContractListResponse contracts
         */

        /**
         * Constructs a new ContractListResponse.
         * @memberof contractpb
         * @classdesc Represents a ContractListResponse.
         * @implements IContractListResponse
         * @constructor
         * @param {contractpb.IContractListResponse=} [p] Properties to set
         */
        function ContractListResponse(p) {
            this.contracts = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * ContractListResponse contracts.
         * @member {Array.<contractpb.IContractResponse>} contracts
         * @memberof contractpb.ContractListResponse
         * @instance
         */
        ContractListResponse.prototype.contracts = $util.emptyArray;

        /**
         * Creates a new ContractListResponse instance using the specified properties.
         * @function create
         * @memberof contractpb.ContractListResponse
         * @static
         * @param {contractpb.IContractListResponse=} [properties] Properties to set
         * @returns {contractpb.ContractListResponse} ContractListResponse instance
         */
        ContractListResponse.create = function create(properties) {
            return new ContractListResponse(properties);
        };

        /**
         * Encodes the specified ContractListResponse message. Does not implicitly {@link contractpb.ContractListResponse.verify|verify} messages.
         * @function encode
         * @memberof contractpb.ContractListResponse
         * @static
         * @param {contractpb.IContractListResponse} m ContractListResponse message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ContractListResponse.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.contracts != null && m.contracts.length) {
                for (var i = 0; i < m.contracts.length; ++i)
                    $root.contractpb.ContractResponse.encode(m.contracts[i], w.uint32(10).fork()).ldelim();
            }
            return w;
        };

        /**
         * Decodes a ContractListResponse message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.ContractListResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.ContractListResponse} ContractListResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ContractListResponse.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.ContractListResponse();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    if (!(m.contracts && m.contracts.length))
                        m.contracts = [];
                    m.contracts.push($root.contractpb.ContractResponse.decode(r, r.uint32()));
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return ContractListResponse;
    })();

    contractpb.ContractResponse = (function() {

        /**
         * Properties of a ContractResponse.
         * @memberof contractpb
         * @interface IContractResponse
         * @property {string|null} [ID] ContractResponse ID
         * @property {string|null} [previousContractID] ContractResponse previousContractID
         * @property {string|null} [nextContractID] ContractResponse nextContractID
         * @property {string|null} [productVersionID] ContractResponse productVersionID
         * @property {string|null} [productVersionDescription] ContractResponse productVersionDescription
         * @property {string|null} [companyCode] ContractResponse companyCode
         * @property {string|null} [contractStatus] ContractResponse contractStatus
         * @property {string|null} [salesChannel] ContractResponse salesChannel
         * @property {string|null} [originalSalesChannel] ContractResponse originalSalesChannel
         * @property {google.protobuf.IBoolValue|null} [eFulfillmentEnabled] ContractResponse eFulfillmentEnabled
         * @property {Array.<contractpb.IContractDetail>|null} [details] ContractResponse details
         * @property {Array.<contractpb.IContractDate>|null} [dates] ContractResponse dates
         * @property {Array.<contractpb.IContractCustomer>|null} [customers] ContractResponse customers
         * @property {Array.<contractpb.IContractOffice>|null} [offices] ContractResponse offices
         * @property {string|null} [propertyID] ContractResponse propertyID
         * @property {string|null} [salesSourceID] ContractResponse salesSourceID
         * @property {common.Tenant|null} [tenantID] ContractResponse tenantID
         * @property {string|null} [productType] ContractResponse productType
         * @property {contractpb.IAddress|null} [addressDetails] ContractResponse addressDetails
         * @property {contractpb.ContractType|null} [contractType] ContractResponse contractType
         * @property {string|null} [previousProductType] ContractResponse previousProductType
         * @property {string|null} [currentProductType] ContractResponse currentProductType
         * @property {contractpb.IInvoiceDetails|null} [invoiceDetails] ContractResponse invoiceDetails
         */

        /**
         * Constructs a new ContractResponse.
         * @memberof contractpb
         * @classdesc Represents a ContractResponse.
         * @implements IContractResponse
         * @constructor
         * @param {contractpb.IContractResponse=} [p] Properties to set
         */
        function ContractResponse(p) {
            this.details = [];
            this.dates = [];
            this.customers = [];
            this.offices = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * ContractResponse ID.
         * @member {string} ID
         * @memberof contractpb.ContractResponse
         * @instance
         */
        ContractResponse.prototype.ID = "";

        /**
         * ContractResponse previousContractID.
         * @member {string} previousContractID
         * @memberof contractpb.ContractResponse
         * @instance
         */
        ContractResponse.prototype.previousContractID = "";

        /**
         * ContractResponse nextContractID.
         * @member {string} nextContractID
         * @memberof contractpb.ContractResponse
         * @instance
         */
        ContractResponse.prototype.nextContractID = "";

        /**
         * ContractResponse productVersionID.
         * @member {string} productVersionID
         * @memberof contractpb.ContractResponse
         * @instance
         */
        ContractResponse.prototype.productVersionID = "";

        /**
         * ContractResponse productVersionDescription.
         * @member {string} productVersionDescription
         * @memberof contractpb.ContractResponse
         * @instance
         */
        ContractResponse.prototype.productVersionDescription = "";

        /**
         * ContractResponse companyCode.
         * @member {string} companyCode
         * @memberof contractpb.ContractResponse
         * @instance
         */
        ContractResponse.prototype.companyCode = "";

        /**
         * ContractResponse contractStatus.
         * @member {string} contractStatus
         * @memberof contractpb.ContractResponse
         * @instance
         */
        ContractResponse.prototype.contractStatus = "";

        /**
         * ContractResponse salesChannel.
         * @member {string} salesChannel
         * @memberof contractpb.ContractResponse
         * @instance
         */
        ContractResponse.prototype.salesChannel = "";

        /**
         * ContractResponse originalSalesChannel.
         * @member {string} originalSalesChannel
         * @memberof contractpb.ContractResponse
         * @instance
         */
        ContractResponse.prototype.originalSalesChannel = "";

        /**
         * ContractResponse eFulfillmentEnabled.
         * @member {google.protobuf.IBoolValue|null|undefined} eFulfillmentEnabled
         * @memberof contractpb.ContractResponse
         * @instance
         */
        ContractResponse.prototype.eFulfillmentEnabled = null;

        /**
         * ContractResponse details.
         * @member {Array.<contractpb.IContractDetail>} details
         * @memberof contractpb.ContractResponse
         * @instance
         */
        ContractResponse.prototype.details = $util.emptyArray;

        /**
         * ContractResponse dates.
         * @member {Array.<contractpb.IContractDate>} dates
         * @memberof contractpb.ContractResponse
         * @instance
         */
        ContractResponse.prototype.dates = $util.emptyArray;

        /**
         * ContractResponse customers.
         * @member {Array.<contractpb.IContractCustomer>} customers
         * @memberof contractpb.ContractResponse
         * @instance
         */
        ContractResponse.prototype.customers = $util.emptyArray;

        /**
         * ContractResponse offices.
         * @member {Array.<contractpb.IContractOffice>} offices
         * @memberof contractpb.ContractResponse
         * @instance
         */
        ContractResponse.prototype.offices = $util.emptyArray;

        /**
         * ContractResponse propertyID.
         * @member {string} propertyID
         * @memberof contractpb.ContractResponse
         * @instance
         */
        ContractResponse.prototype.propertyID = "";

        /**
         * ContractResponse salesSourceID.
         * @member {string} salesSourceID
         * @memberof contractpb.ContractResponse
         * @instance
         */
        ContractResponse.prototype.salesSourceID = "";

        /**
         * ContractResponse tenantID.
         * @member {common.Tenant} tenantID
         * @memberof contractpb.ContractResponse
         * @instance
         */
        ContractResponse.prototype.tenantID = 0;

        /**
         * ContractResponse productType.
         * @member {string} productType
         * @memberof contractpb.ContractResponse
         * @instance
         */
        ContractResponse.prototype.productType = "";

        /**
         * ContractResponse addressDetails.
         * @member {contractpb.IAddress|null|undefined} addressDetails
         * @memberof contractpb.ContractResponse
         * @instance
         */
        ContractResponse.prototype.addressDetails = null;

        /**
         * ContractResponse contractType.
         * @member {contractpb.ContractType} contractType
         * @memberof contractpb.ContractResponse
         * @instance
         */
        ContractResponse.prototype.contractType = 0;

        /**
         * ContractResponse previousProductType.
         * @member {string} previousProductType
         * @memberof contractpb.ContractResponse
         * @instance
         */
        ContractResponse.prototype.previousProductType = "";

        /**
         * ContractResponse currentProductType.
         * @member {string} currentProductType
         * @memberof contractpb.ContractResponse
         * @instance
         */
        ContractResponse.prototype.currentProductType = "";

        /**
         * ContractResponse invoiceDetails.
         * @member {contractpb.IInvoiceDetails|null|undefined} invoiceDetails
         * @memberof contractpb.ContractResponse
         * @instance
         */
        ContractResponse.prototype.invoiceDetails = null;

        /**
         * Creates a new ContractResponse instance using the specified properties.
         * @function create
         * @memberof contractpb.ContractResponse
         * @static
         * @param {contractpb.IContractResponse=} [properties] Properties to set
         * @returns {contractpb.ContractResponse} ContractResponse instance
         */
        ContractResponse.create = function create(properties) {
            return new ContractResponse(properties);
        };

        /**
         * Encodes the specified ContractResponse message. Does not implicitly {@link contractpb.ContractResponse.verify|verify} messages.
         * @function encode
         * @memberof contractpb.ContractResponse
         * @static
         * @param {contractpb.IContractResponse} m ContractResponse message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ContractResponse.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.ID != null && Object.hasOwnProperty.call(m, "ID"))
                w.uint32(10).string(m.ID);
            if (m.previousContractID != null && Object.hasOwnProperty.call(m, "previousContractID"))
                w.uint32(18).string(m.previousContractID);
            if (m.nextContractID != null && Object.hasOwnProperty.call(m, "nextContractID"))
                w.uint32(26).string(m.nextContractID);
            if (m.productVersionID != null && Object.hasOwnProperty.call(m, "productVersionID"))
                w.uint32(34).string(m.productVersionID);
            if (m.productVersionDescription != null && Object.hasOwnProperty.call(m, "productVersionDescription"))
                w.uint32(42).string(m.productVersionDescription);
            if (m.companyCode != null && Object.hasOwnProperty.call(m, "companyCode"))
                w.uint32(50).string(m.companyCode);
            if (m.contractStatus != null && Object.hasOwnProperty.call(m, "contractStatus"))
                w.uint32(58).string(m.contractStatus);
            if (m.salesChannel != null && Object.hasOwnProperty.call(m, "salesChannel"))
                w.uint32(66).string(m.salesChannel);
            if (m.originalSalesChannel != null && Object.hasOwnProperty.call(m, "originalSalesChannel"))
                w.uint32(74).string(m.originalSalesChannel);
            if (m.eFulfillmentEnabled != null && Object.hasOwnProperty.call(m, "eFulfillmentEnabled"))
                $root.google.protobuf.BoolValue.encode(m.eFulfillmentEnabled, w.uint32(90).fork()).ldelim();
            if (m.details != null && m.details.length) {
                for (var i = 0; i < m.details.length; ++i)
                    $root.contractpb.ContractDetail.encode(m.details[i], w.uint32(98).fork()).ldelim();
            }
            if (m.dates != null && m.dates.length) {
                for (var i = 0; i < m.dates.length; ++i)
                    $root.contractpb.ContractDate.encode(m.dates[i], w.uint32(106).fork()).ldelim();
            }
            if (m.customers != null && m.customers.length) {
                for (var i = 0; i < m.customers.length; ++i)
                    $root.contractpb.ContractCustomer.encode(m.customers[i], w.uint32(114).fork()).ldelim();
            }
            if (m.offices != null && m.offices.length) {
                for (var i = 0; i < m.offices.length; ++i)
                    $root.contractpb.ContractOffice.encode(m.offices[i], w.uint32(130).fork()).ldelim();
            }
            if (m.propertyID != null && Object.hasOwnProperty.call(m, "propertyID"))
                w.uint32(138).string(m.propertyID);
            if (m.salesSourceID != null && Object.hasOwnProperty.call(m, "salesSourceID"))
                w.uint32(146).string(m.salesSourceID);
            if (m.tenantID != null && Object.hasOwnProperty.call(m, "tenantID"))
                w.uint32(152).int32(m.tenantID);
            if (m.productType != null && Object.hasOwnProperty.call(m, "productType"))
                w.uint32(162).string(m.productType);
            if (m.addressDetails != null && Object.hasOwnProperty.call(m, "addressDetails"))
                $root.contractpb.Address.encode(m.addressDetails, w.uint32(170).fork()).ldelim();
            if (m.contractType != null && Object.hasOwnProperty.call(m, "contractType"))
                w.uint32(176).int32(m.contractType);
            if (m.previousProductType != null && Object.hasOwnProperty.call(m, "previousProductType"))
                w.uint32(186).string(m.previousProductType);
            if (m.currentProductType != null && Object.hasOwnProperty.call(m, "currentProductType"))
                w.uint32(194).string(m.currentProductType);
            if (m.invoiceDetails != null && Object.hasOwnProperty.call(m, "invoiceDetails"))
                $root.contractpb.InvoiceDetails.encode(m.invoiceDetails, w.uint32(202).fork()).ldelim();
            return w;
        };

        /**
         * Decodes a ContractResponse message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.ContractResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.ContractResponse} ContractResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ContractResponse.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.ContractResponse();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.ID = r.string();
                    break;
                case 2:
                    m.previousContractID = r.string();
                    break;
                case 3:
                    m.nextContractID = r.string();
                    break;
                case 4:
                    m.productVersionID = r.string();
                    break;
                case 5:
                    m.productVersionDescription = r.string();
                    break;
                case 6:
                    m.companyCode = r.string();
                    break;
                case 7:
                    m.contractStatus = r.string();
                    break;
                case 8:
                    m.salesChannel = r.string();
                    break;
                case 9:
                    m.originalSalesChannel = r.string();
                    break;
                case 11:
                    m.eFulfillmentEnabled = $root.google.protobuf.BoolValue.decode(r, r.uint32());
                    break;
                case 12:
                    if (!(m.details && m.details.length))
                        m.details = [];
                    m.details.push($root.contractpb.ContractDetail.decode(r, r.uint32()));
                    break;
                case 13:
                    if (!(m.dates && m.dates.length))
                        m.dates = [];
                    m.dates.push($root.contractpb.ContractDate.decode(r, r.uint32()));
                    break;
                case 14:
                    if (!(m.customers && m.customers.length))
                        m.customers = [];
                    m.customers.push($root.contractpb.ContractCustomer.decode(r, r.uint32()));
                    break;
                case 16:
                    if (!(m.offices && m.offices.length))
                        m.offices = [];
                    m.offices.push($root.contractpb.ContractOffice.decode(r, r.uint32()));
                    break;
                case 17:
                    m.propertyID = r.string();
                    break;
                case 18:
                    m.salesSourceID = r.string();
                    break;
                case 19:
                    m.tenantID = r.int32();
                    break;
                case 20:
                    m.productType = r.string();
                    break;
                case 21:
                    m.addressDetails = $root.contractpb.Address.decode(r, r.uint32());
                    break;
                case 22:
                    m.contractType = r.int32();
                    break;
                case 23:
                    m.previousProductType = r.string();
                    break;
                case 24:
                    m.currentProductType = r.string();
                    break;
                case 25:
                    m.invoiceDetails = $root.contractpb.InvoiceDetails.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return ContractResponse;
    })();

    contractpb.ExpiringContractsStartBatch = (function() {

        /**
         * Properties of an ExpiringContractsStartBatch.
         * @memberof contractpb
         * @interface IExpiringContractsStartBatch
         * @property {number|null} [NumContracts] ExpiringContractsStartBatch NumContracts
         */

        /**
         * Constructs a new ExpiringContractsStartBatch.
         * @memberof contractpb
         * @classdesc Represents an ExpiringContractsStartBatch.
         * @implements IExpiringContractsStartBatch
         * @constructor
         * @param {contractpb.IExpiringContractsStartBatch=} [p] Properties to set
         */
        function ExpiringContractsStartBatch(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * ExpiringContractsStartBatch NumContracts.
         * @member {number} NumContracts
         * @memberof contractpb.ExpiringContractsStartBatch
         * @instance
         */
        ExpiringContractsStartBatch.prototype.NumContracts = 0;

        /**
         * Creates a new ExpiringContractsStartBatch instance using the specified properties.
         * @function create
         * @memberof contractpb.ExpiringContractsStartBatch
         * @static
         * @param {contractpb.IExpiringContractsStartBatch=} [properties] Properties to set
         * @returns {contractpb.ExpiringContractsStartBatch} ExpiringContractsStartBatch instance
         */
        ExpiringContractsStartBatch.create = function create(properties) {
            return new ExpiringContractsStartBatch(properties);
        };

        /**
         * Encodes the specified ExpiringContractsStartBatch message. Does not implicitly {@link contractpb.ExpiringContractsStartBatch.verify|verify} messages.
         * @function encode
         * @memberof contractpb.ExpiringContractsStartBatch
         * @static
         * @param {contractpb.IExpiringContractsStartBatch} m ExpiringContractsStartBatch message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ExpiringContractsStartBatch.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.NumContracts != null && Object.hasOwnProperty.call(m, "NumContracts"))
                w.uint32(8).int32(m.NumContracts);
            return w;
        };

        /**
         * Decodes an ExpiringContractsStartBatch message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.ExpiringContractsStartBatch
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.ExpiringContractsStartBatch} ExpiringContractsStartBatch
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ExpiringContractsStartBatch.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.ExpiringContractsStartBatch();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.NumContracts = r.int32();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return ExpiringContractsStartBatch;
    })();

    contractpb.ExpiringContract = (function() {

        /**
         * Properties of an ExpiringContract.
         * @memberof contractpb
         * @interface IExpiringContract
         * @property {string|null} [ContractID] ExpiringContract ContractID
         * @property {string|null} [Expiration] ExpiringContract Expiration
         * @property {string|null} [companyCode] ExpiringContract companyCode
         * @property {boolean|null} [IsEvergreen] ExpiringContract IsEvergreen
         */

        /**
         * Constructs a new ExpiringContract.
         * @memberof contractpb
         * @classdesc Represents an ExpiringContract.
         * @implements IExpiringContract
         * @constructor
         * @param {contractpb.IExpiringContract=} [p] Properties to set
         */
        function ExpiringContract(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * ExpiringContract ContractID.
         * @member {string} ContractID
         * @memberof contractpb.ExpiringContract
         * @instance
         */
        ExpiringContract.prototype.ContractID = "";

        /**
         * ExpiringContract Expiration.
         * @member {string} Expiration
         * @memberof contractpb.ExpiringContract
         * @instance
         */
        ExpiringContract.prototype.Expiration = "";

        /**
         * ExpiringContract companyCode.
         * @member {string} companyCode
         * @memberof contractpb.ExpiringContract
         * @instance
         */
        ExpiringContract.prototype.companyCode = "";

        /**
         * ExpiringContract IsEvergreen.
         * @member {boolean} IsEvergreen
         * @memberof contractpb.ExpiringContract
         * @instance
         */
        ExpiringContract.prototype.IsEvergreen = false;

        /**
         * Creates a new ExpiringContract instance using the specified properties.
         * @function create
         * @memberof contractpb.ExpiringContract
         * @static
         * @param {contractpb.IExpiringContract=} [properties] Properties to set
         * @returns {contractpb.ExpiringContract} ExpiringContract instance
         */
        ExpiringContract.create = function create(properties) {
            return new ExpiringContract(properties);
        };

        /**
         * Encodes the specified ExpiringContract message. Does not implicitly {@link contractpb.ExpiringContract.verify|verify} messages.
         * @function encode
         * @memberof contractpb.ExpiringContract
         * @static
         * @param {contractpb.IExpiringContract} m ExpiringContract message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ExpiringContract.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.ContractID != null && Object.hasOwnProperty.call(m, "ContractID"))
                w.uint32(10).string(m.ContractID);
            if (m.Expiration != null && Object.hasOwnProperty.call(m, "Expiration"))
                w.uint32(18).string(m.Expiration);
            if (m.companyCode != null && Object.hasOwnProperty.call(m, "companyCode"))
                w.uint32(26).string(m.companyCode);
            if (m.IsEvergreen != null && Object.hasOwnProperty.call(m, "IsEvergreen"))
                w.uint32(32).bool(m.IsEvergreen);
            return w;
        };

        /**
         * Decodes an ExpiringContract message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.ExpiringContract
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.ExpiringContract} ExpiringContract
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ExpiringContract.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.ExpiringContract();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.ContractID = r.string();
                    break;
                case 2:
                    m.Expiration = r.string();
                    break;
                case 3:
                    m.companyCode = r.string();
                    break;
                case 4:
                    m.IsEvergreen = r.bool();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return ExpiringContract;
    })();

    contractpb.Phone = (function() {

        /**
         * Properties of a Phone.
         * @memberof contractpb
         * @interface IPhone
         * @property {string|null} [number] Phone number
         * @property {string|null} [type] Phone type
         * @property {string|null} [extension] Phone extension
         */

        /**
         * Constructs a new Phone.
         * @memberof contractpb
         * @classdesc Represents a Phone.
         * @implements IPhone
         * @constructor
         * @param {contractpb.IPhone=} [p] Properties to set
         */
        function Phone(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * Phone number.
         * @member {string} number
         * @memberof contractpb.Phone
         * @instance
         */
        Phone.prototype.number = "";

        /**
         * Phone type.
         * @member {string} type
         * @memberof contractpb.Phone
         * @instance
         */
        Phone.prototype.type = "";

        /**
         * Phone extension.
         * @member {string} extension
         * @memberof contractpb.Phone
         * @instance
         */
        Phone.prototype.extension = "";

        /**
         * Creates a new Phone instance using the specified properties.
         * @function create
         * @memberof contractpb.Phone
         * @static
         * @param {contractpb.IPhone=} [properties] Properties to set
         * @returns {contractpb.Phone} Phone instance
         */
        Phone.create = function create(properties) {
            return new Phone(properties);
        };

        /**
         * Encodes the specified Phone message. Does not implicitly {@link contractpb.Phone.verify|verify} messages.
         * @function encode
         * @memberof contractpb.Phone
         * @static
         * @param {contractpb.IPhone} m Phone message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Phone.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.number != null && Object.hasOwnProperty.call(m, "number"))
                w.uint32(10).string(m.number);
            if (m.type != null && Object.hasOwnProperty.call(m, "type"))
                w.uint32(18).string(m.type);
            if (m.extension != null && Object.hasOwnProperty.call(m, "extension"))
                w.uint32(26).string(m.extension);
            return w;
        };

        /**
         * Decodes a Phone message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.Phone
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.Phone} Phone
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Phone.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.Phone();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.number = r.string();
                    break;
                case 2:
                    m.type = r.string();
                    break;
                case 3:
                    m.extension = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return Phone;
    })();

    contractpb.CreateContractRequest = (function() {

        /**
         * Properties of a CreateContractRequest.
         * @memberof contractpb
         * @interface ICreateContractRequest
         * @property {string|null} [contractID] CreateContractRequest contractID
         * @property {string|null} [companyCode] CreateContractRequest companyCode
         * @property {string|null} [salesChannel] CreateContractRequest salesChannel
         * @property {string|null} [salesSourceID] CreateContractRequest salesSourceID
         * @property {Array.<contractpb.ISalesPerson>|null} [salesPersons] CreateContractRequest salesPersons
         * @property {contractpb.IContractProperty|null} [propertyAddress] CreateContractRequest propertyAddress
         * @property {contractpb.IContractProperty|null} [mailingAddress] CreateContractRequest mailingAddress
         * @property {Array.<contractpb.IAgent>|null} [agents] CreateContractRequest agents
         * @property {Array.<contractpb.ICustomerDetail>|null} [customerDetails] CreateContractRequest customerDetails
         * @property {Array.<contractpb.IContractDate>|null} [contractDates] CreateContractRequest contractDates
         * @property {Array.<contractpb.IContractNote>|null} [contractNotes] CreateContractRequest contractNotes
         * @property {contractpb.IPaymentDetail|null} [paymentDetail] CreateContractRequest paymentDetail
         * @property {contractpb.IProductPriceDetail|null} [productPriceDetail] CreateContractRequest productPriceDetail
         * @property {string|null} [salesAgentID] CreateContractRequest salesAgentID
         * @property {string|null} [partnerID] CreateContractRequest partnerID
         * @property {string|null} [userName] CreateContractRequest userName
         * @property {string|null} [referenceID] CreateContractRequest referenceID
         * @property {string|null} [escrowNumber] CreateContractRequest escrowNumber
         * @property {contractpb.IRealEstateOffice|null} [initiatingOffice] CreateContractRequest initiatingOffice
         * @property {contractpb.IRealEstateOffice|null} [cooperatingOffice] CreateContractRequest cooperatingOffice
         * @property {contractpb.IRealEstateOffice|null} [closingOffice] CreateContractRequest closingOffice
         * @property {string|null} [proratedContractID] CreateContractRequest proratedContractID
         * @property {common.IMoney|null} [prorationCredit] CreateContractRequest prorationCredit
         * @property {string|null} [MLSValue] CreateContractRequest MLSValue
         * @property {string|null} [sourceApplication] CreateContractRequest sourceApplication
         * @property {common.Tenant|null} [tenantID] CreateContractRequest tenantID
         * @property {string|null} [mailingAddressID] CreateContractRequest mailingAddressID
         * @property {string|null} [propertyID] CreateContractRequest propertyID
         * @property {Array.<contractpb.IContractDetail>|null} [contractDetails] CreateContractRequest contractDetails
         * @property {common.IMoney|null} [diagnosisFee] CreateContractRequest diagnosisFee
         * @property {common.IMoney|null} [maintenanceFee] CreateContractRequest maintenanceFee
         * @property {string|null} [previousContractID] CreateContractRequest previousContractID
         * @property {google.protobuf.IBoolValue|null} [autoRenew] CreateContractRequest autoRenew
         * @property {boolean|null} [isEvergreen] CreateContractRequest isEvergreen
         */

        /**
         * Constructs a new CreateContractRequest.
         * @memberof contractpb
         * @classdesc Represents a CreateContractRequest.
         * @implements ICreateContractRequest
         * @constructor
         * @param {contractpb.ICreateContractRequest=} [p] Properties to set
         */
        function CreateContractRequest(p) {
            this.salesPersons = [];
            this.agents = [];
            this.customerDetails = [];
            this.contractDates = [];
            this.contractNotes = [];
            this.contractDetails = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * CreateContractRequest contractID.
         * @member {string} contractID
         * @memberof contractpb.CreateContractRequest
         * @instance
         */
        CreateContractRequest.prototype.contractID = "";

        /**
         * CreateContractRequest companyCode.
         * @member {string} companyCode
         * @memberof contractpb.CreateContractRequest
         * @instance
         */
        CreateContractRequest.prototype.companyCode = "";

        /**
         * CreateContractRequest salesChannel.
         * @member {string} salesChannel
         * @memberof contractpb.CreateContractRequest
         * @instance
         */
        CreateContractRequest.prototype.salesChannel = "";

        /**
         * CreateContractRequest salesSourceID.
         * @member {string} salesSourceID
         * @memberof contractpb.CreateContractRequest
         * @instance
         */
        CreateContractRequest.prototype.salesSourceID = "";

        /**
         * CreateContractRequest salesPersons.
         * @member {Array.<contractpb.ISalesPerson>} salesPersons
         * @memberof contractpb.CreateContractRequest
         * @instance
         */
        CreateContractRequest.prototype.salesPersons = $util.emptyArray;

        /**
         * CreateContractRequest propertyAddress.
         * @member {contractpb.IContractProperty|null|undefined} propertyAddress
         * @memberof contractpb.CreateContractRequest
         * @instance
         */
        CreateContractRequest.prototype.propertyAddress = null;

        /**
         * CreateContractRequest mailingAddress.
         * @member {contractpb.IContractProperty|null|undefined} mailingAddress
         * @memberof contractpb.CreateContractRequest
         * @instance
         */
        CreateContractRequest.prototype.mailingAddress = null;

        /**
         * CreateContractRequest agents.
         * @member {Array.<contractpb.IAgent>} agents
         * @memberof contractpb.CreateContractRequest
         * @instance
         */
        CreateContractRequest.prototype.agents = $util.emptyArray;

        /**
         * CreateContractRequest customerDetails.
         * @member {Array.<contractpb.ICustomerDetail>} customerDetails
         * @memberof contractpb.CreateContractRequest
         * @instance
         */
        CreateContractRequest.prototype.customerDetails = $util.emptyArray;

        /**
         * CreateContractRequest contractDates.
         * @member {Array.<contractpb.IContractDate>} contractDates
         * @memberof contractpb.CreateContractRequest
         * @instance
         */
        CreateContractRequest.prototype.contractDates = $util.emptyArray;

        /**
         * CreateContractRequest contractNotes.
         * @member {Array.<contractpb.IContractNote>} contractNotes
         * @memberof contractpb.CreateContractRequest
         * @instance
         */
        CreateContractRequest.prototype.contractNotes = $util.emptyArray;

        /**
         * CreateContractRequest paymentDetail.
         * @member {contractpb.IPaymentDetail|null|undefined} paymentDetail
         * @memberof contractpb.CreateContractRequest
         * @instance
         */
        CreateContractRequest.prototype.paymentDetail = null;

        /**
         * CreateContractRequest productPriceDetail.
         * @member {contractpb.IProductPriceDetail|null|undefined} productPriceDetail
         * @memberof contractpb.CreateContractRequest
         * @instance
         */
        CreateContractRequest.prototype.productPriceDetail = null;

        /**
         * CreateContractRequest salesAgentID.
         * @member {string} salesAgentID
         * @memberof contractpb.CreateContractRequest
         * @instance
         */
        CreateContractRequest.prototype.salesAgentID = "";

        /**
         * CreateContractRequest partnerID.
         * @member {string} partnerID
         * @memberof contractpb.CreateContractRequest
         * @instance
         */
        CreateContractRequest.prototype.partnerID = "";

        /**
         * CreateContractRequest userName.
         * @member {string} userName
         * @memberof contractpb.CreateContractRequest
         * @instance
         */
        CreateContractRequest.prototype.userName = "";

        /**
         * CreateContractRequest referenceID.
         * @member {string} referenceID
         * @memberof contractpb.CreateContractRequest
         * @instance
         */
        CreateContractRequest.prototype.referenceID = "";

        /**
         * CreateContractRequest escrowNumber.
         * @member {string} escrowNumber
         * @memberof contractpb.CreateContractRequest
         * @instance
         */
        CreateContractRequest.prototype.escrowNumber = "";

        /**
         * CreateContractRequest initiatingOffice.
         * @member {contractpb.IRealEstateOffice|null|undefined} initiatingOffice
         * @memberof contractpb.CreateContractRequest
         * @instance
         */
        CreateContractRequest.prototype.initiatingOffice = null;

        /**
         * CreateContractRequest cooperatingOffice.
         * @member {contractpb.IRealEstateOffice|null|undefined} cooperatingOffice
         * @memberof contractpb.CreateContractRequest
         * @instance
         */
        CreateContractRequest.prototype.cooperatingOffice = null;

        /**
         * CreateContractRequest closingOffice.
         * @member {contractpb.IRealEstateOffice|null|undefined} closingOffice
         * @memberof contractpb.CreateContractRequest
         * @instance
         */
        CreateContractRequest.prototype.closingOffice = null;

        /**
         * CreateContractRequest proratedContractID.
         * @member {string} proratedContractID
         * @memberof contractpb.CreateContractRequest
         * @instance
         */
        CreateContractRequest.prototype.proratedContractID = "";

        /**
         * CreateContractRequest prorationCredit.
         * @member {common.IMoney|null|undefined} prorationCredit
         * @memberof contractpb.CreateContractRequest
         * @instance
         */
        CreateContractRequest.prototype.prorationCredit = null;

        /**
         * CreateContractRequest MLSValue.
         * @member {string} MLSValue
         * @memberof contractpb.CreateContractRequest
         * @instance
         */
        CreateContractRequest.prototype.MLSValue = "";

        /**
         * CreateContractRequest sourceApplication.
         * @member {string} sourceApplication
         * @memberof contractpb.CreateContractRequest
         * @instance
         */
        CreateContractRequest.prototype.sourceApplication = "";

        /**
         * CreateContractRequest tenantID.
         * @member {common.Tenant} tenantID
         * @memberof contractpb.CreateContractRequest
         * @instance
         */
        CreateContractRequest.prototype.tenantID = 0;

        /**
         * CreateContractRequest mailingAddressID.
         * @member {string} mailingAddressID
         * @memberof contractpb.CreateContractRequest
         * @instance
         */
        CreateContractRequest.prototype.mailingAddressID = "";

        /**
         * CreateContractRequest propertyID.
         * @member {string} propertyID
         * @memberof contractpb.CreateContractRequest
         * @instance
         */
        CreateContractRequest.prototype.propertyID = "";

        /**
         * CreateContractRequest contractDetails.
         * @member {Array.<contractpb.IContractDetail>} contractDetails
         * @memberof contractpb.CreateContractRequest
         * @instance
         */
        CreateContractRequest.prototype.contractDetails = $util.emptyArray;

        /**
         * CreateContractRequest diagnosisFee.
         * @member {common.IMoney|null|undefined} diagnosisFee
         * @memberof contractpb.CreateContractRequest
         * @instance
         */
        CreateContractRequest.prototype.diagnosisFee = null;

        /**
         * CreateContractRequest maintenanceFee.
         * @member {common.IMoney|null|undefined} maintenanceFee
         * @memberof contractpb.CreateContractRequest
         * @instance
         */
        CreateContractRequest.prototype.maintenanceFee = null;

        /**
         * CreateContractRequest previousContractID.
         * @member {string} previousContractID
         * @memberof contractpb.CreateContractRequest
         * @instance
         */
        CreateContractRequest.prototype.previousContractID = "";

        /**
         * CreateContractRequest autoRenew.
         * @member {google.protobuf.IBoolValue|null|undefined} autoRenew
         * @memberof contractpb.CreateContractRequest
         * @instance
         */
        CreateContractRequest.prototype.autoRenew = null;

        /**
         * CreateContractRequest isEvergreen.
         * @member {boolean} isEvergreen
         * @memberof contractpb.CreateContractRequest
         * @instance
         */
        CreateContractRequest.prototype.isEvergreen = false;

        /**
         * Creates a new CreateContractRequest instance using the specified properties.
         * @function create
         * @memberof contractpb.CreateContractRequest
         * @static
         * @param {contractpb.ICreateContractRequest=} [properties] Properties to set
         * @returns {contractpb.CreateContractRequest} CreateContractRequest instance
         */
        CreateContractRequest.create = function create(properties) {
            return new CreateContractRequest(properties);
        };

        /**
         * Encodes the specified CreateContractRequest message. Does not implicitly {@link contractpb.CreateContractRequest.verify|verify} messages.
         * @function encode
         * @memberof contractpb.CreateContractRequest
         * @static
         * @param {contractpb.ICreateContractRequest} m CreateContractRequest message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CreateContractRequest.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.contractID != null && Object.hasOwnProperty.call(m, "contractID"))
                w.uint32(10).string(m.contractID);
            if (m.companyCode != null && Object.hasOwnProperty.call(m, "companyCode"))
                w.uint32(18).string(m.companyCode);
            if (m.salesChannel != null && Object.hasOwnProperty.call(m, "salesChannel"))
                w.uint32(26).string(m.salesChannel);
            if (m.salesSourceID != null && Object.hasOwnProperty.call(m, "salesSourceID"))
                w.uint32(34).string(m.salesSourceID);
            if (m.salesPersons != null && m.salesPersons.length) {
                for (var i = 0; i < m.salesPersons.length; ++i)
                    $root.contractpb.SalesPerson.encode(m.salesPersons[i], w.uint32(42).fork()).ldelim();
            }
            if (m.propertyAddress != null && Object.hasOwnProperty.call(m, "propertyAddress"))
                $root.contractpb.ContractProperty.encode(m.propertyAddress, w.uint32(50).fork()).ldelim();
            if (m.mailingAddress != null && Object.hasOwnProperty.call(m, "mailingAddress"))
                $root.contractpb.ContractProperty.encode(m.mailingAddress, w.uint32(58).fork()).ldelim();
            if (m.agents != null && m.agents.length) {
                for (var i = 0; i < m.agents.length; ++i)
                    $root.contractpb.Agent.encode(m.agents[i], w.uint32(66).fork()).ldelim();
            }
            if (m.customerDetails != null && m.customerDetails.length) {
                for (var i = 0; i < m.customerDetails.length; ++i)
                    $root.contractpb.CustomerDetail.encode(m.customerDetails[i], w.uint32(74).fork()).ldelim();
            }
            if (m.contractDates != null && m.contractDates.length) {
                for (var i = 0; i < m.contractDates.length; ++i)
                    $root.contractpb.ContractDate.encode(m.contractDates[i], w.uint32(82).fork()).ldelim();
            }
            if (m.contractNotes != null && m.contractNotes.length) {
                for (var i = 0; i < m.contractNotes.length; ++i)
                    $root.contractpb.ContractNote.encode(m.contractNotes[i], w.uint32(90).fork()).ldelim();
            }
            if (m.paymentDetail != null && Object.hasOwnProperty.call(m, "paymentDetail"))
                $root.contractpb.PaymentDetail.encode(m.paymentDetail, w.uint32(98).fork()).ldelim();
            if (m.productPriceDetail != null && Object.hasOwnProperty.call(m, "productPriceDetail"))
                $root.contractpb.ProductPriceDetail.encode(m.productPriceDetail, w.uint32(106).fork()).ldelim();
            if (m.salesAgentID != null && Object.hasOwnProperty.call(m, "salesAgentID"))
                w.uint32(114).string(m.salesAgentID);
            if (m.partnerID != null && Object.hasOwnProperty.call(m, "partnerID"))
                w.uint32(122).string(m.partnerID);
            if (m.userName != null && Object.hasOwnProperty.call(m, "userName"))
                w.uint32(130).string(m.userName);
            if (m.referenceID != null && Object.hasOwnProperty.call(m, "referenceID"))
                w.uint32(138).string(m.referenceID);
            if (m.escrowNumber != null && Object.hasOwnProperty.call(m, "escrowNumber"))
                w.uint32(146).string(m.escrowNumber);
            if (m.initiatingOffice != null && Object.hasOwnProperty.call(m, "initiatingOffice"))
                $root.contractpb.RealEstateOffice.encode(m.initiatingOffice, w.uint32(154).fork()).ldelim();
            if (m.cooperatingOffice != null && Object.hasOwnProperty.call(m, "cooperatingOffice"))
                $root.contractpb.RealEstateOffice.encode(m.cooperatingOffice, w.uint32(162).fork()).ldelim();
            if (m.closingOffice != null && Object.hasOwnProperty.call(m, "closingOffice"))
                $root.contractpb.RealEstateOffice.encode(m.closingOffice, w.uint32(170).fork()).ldelim();
            if (m.proratedContractID != null && Object.hasOwnProperty.call(m, "proratedContractID"))
                w.uint32(178).string(m.proratedContractID);
            if (m.prorationCredit != null && Object.hasOwnProperty.call(m, "prorationCredit"))
                $root.common.Money.encode(m.prorationCredit, w.uint32(186).fork()).ldelim();
            if (m.MLSValue != null && Object.hasOwnProperty.call(m, "MLSValue"))
                w.uint32(194).string(m.MLSValue);
            if (m.sourceApplication != null && Object.hasOwnProperty.call(m, "sourceApplication"))
                w.uint32(202).string(m.sourceApplication);
            if (m.tenantID != null && Object.hasOwnProperty.call(m, "tenantID"))
                w.uint32(208).int32(m.tenantID);
            if (m.mailingAddressID != null && Object.hasOwnProperty.call(m, "mailingAddressID"))
                w.uint32(218).string(m.mailingAddressID);
            if (m.propertyID != null && Object.hasOwnProperty.call(m, "propertyID"))
                w.uint32(226).string(m.propertyID);
            if (m.contractDetails != null && m.contractDetails.length) {
                for (var i = 0; i < m.contractDetails.length; ++i)
                    $root.contractpb.ContractDetail.encode(m.contractDetails[i], w.uint32(234).fork()).ldelim();
            }
            if (m.diagnosisFee != null && Object.hasOwnProperty.call(m, "diagnosisFee"))
                $root.common.Money.encode(m.diagnosisFee, w.uint32(242).fork()).ldelim();
            if (m.maintenanceFee != null && Object.hasOwnProperty.call(m, "maintenanceFee"))
                $root.common.Money.encode(m.maintenanceFee, w.uint32(250).fork()).ldelim();
            if (m.previousContractID != null && Object.hasOwnProperty.call(m, "previousContractID"))
                w.uint32(258).string(m.previousContractID);
            if (m.autoRenew != null && Object.hasOwnProperty.call(m, "autoRenew"))
                $root.google.protobuf.BoolValue.encode(m.autoRenew, w.uint32(266).fork()).ldelim();
            if (m.isEvergreen != null && Object.hasOwnProperty.call(m, "isEvergreen"))
                w.uint32(272).bool(m.isEvergreen);
            return w;
        };

        /**
         * Decodes a CreateContractRequest message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.CreateContractRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.CreateContractRequest} CreateContractRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CreateContractRequest.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.CreateContractRequest();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.contractID = r.string();
                    break;
                case 2:
                    m.companyCode = r.string();
                    break;
                case 3:
                    m.salesChannel = r.string();
                    break;
                case 4:
                    m.salesSourceID = r.string();
                    break;
                case 5:
                    if (!(m.salesPersons && m.salesPersons.length))
                        m.salesPersons = [];
                    m.salesPersons.push($root.contractpb.SalesPerson.decode(r, r.uint32()));
                    break;
                case 6:
                    m.propertyAddress = $root.contractpb.ContractProperty.decode(r, r.uint32());
                    break;
                case 7:
                    m.mailingAddress = $root.contractpb.ContractProperty.decode(r, r.uint32());
                    break;
                case 8:
                    if (!(m.agents && m.agents.length))
                        m.agents = [];
                    m.agents.push($root.contractpb.Agent.decode(r, r.uint32()));
                    break;
                case 9:
                    if (!(m.customerDetails && m.customerDetails.length))
                        m.customerDetails = [];
                    m.customerDetails.push($root.contractpb.CustomerDetail.decode(r, r.uint32()));
                    break;
                case 10:
                    if (!(m.contractDates && m.contractDates.length))
                        m.contractDates = [];
                    m.contractDates.push($root.contractpb.ContractDate.decode(r, r.uint32()));
                    break;
                case 11:
                    if (!(m.contractNotes && m.contractNotes.length))
                        m.contractNotes = [];
                    m.contractNotes.push($root.contractpb.ContractNote.decode(r, r.uint32()));
                    break;
                case 12:
                    m.paymentDetail = $root.contractpb.PaymentDetail.decode(r, r.uint32());
                    break;
                case 13:
                    m.productPriceDetail = $root.contractpb.ProductPriceDetail.decode(r, r.uint32());
                    break;
                case 14:
                    m.salesAgentID = r.string();
                    break;
                case 15:
                    m.partnerID = r.string();
                    break;
                case 16:
                    m.userName = r.string();
                    break;
                case 17:
                    m.referenceID = r.string();
                    break;
                case 18:
                    m.escrowNumber = r.string();
                    break;
                case 19:
                    m.initiatingOffice = $root.contractpb.RealEstateOffice.decode(r, r.uint32());
                    break;
                case 20:
                    m.cooperatingOffice = $root.contractpb.RealEstateOffice.decode(r, r.uint32());
                    break;
                case 21:
                    m.closingOffice = $root.contractpb.RealEstateOffice.decode(r, r.uint32());
                    break;
                case 22:
                    m.proratedContractID = r.string();
                    break;
                case 23:
                    m.prorationCredit = $root.common.Money.decode(r, r.uint32());
                    break;
                case 24:
                    m.MLSValue = r.string();
                    break;
                case 25:
                    m.sourceApplication = r.string();
                    break;
                case 26:
                    m.tenantID = r.int32();
                    break;
                case 27:
                    m.mailingAddressID = r.string();
                    break;
                case 28:
                    m.propertyID = r.string();
                    break;
                case 29:
                    if (!(m.contractDetails && m.contractDetails.length))
                        m.contractDetails = [];
                    m.contractDetails.push($root.contractpb.ContractDetail.decode(r, r.uint32()));
                    break;
                case 30:
                    m.diagnosisFee = $root.common.Money.decode(r, r.uint32());
                    break;
                case 31:
                    m.maintenanceFee = $root.common.Money.decode(r, r.uint32());
                    break;
                case 32:
                    m.previousContractID = r.string();
                    break;
                case 33:
                    m.autoRenew = $root.google.protobuf.BoolValue.decode(r, r.uint32());
                    break;
                case 34:
                    m.isEvergreen = r.bool();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return CreateContractRequest;
    })();

    contractpb.RealEstateOffice = (function() {

        /**
         * Properties of a RealEstateOffice.
         * @memberof contractpb
         * @interface IRealEstateOffice
         * @property {string|null} [officeID] RealEstateOffice officeID
         * @property {contractpb.IAgent|null} [agent] RealEstateOffice agent
         * @property {contractpb.RepresentsSide|null} [represents] RealEstateOffice represents
         */

        /**
         * Constructs a new RealEstateOffice.
         * @memberof contractpb
         * @classdesc Represents a RealEstateOffice.
         * @implements IRealEstateOffice
         * @constructor
         * @param {contractpb.IRealEstateOffice=} [p] Properties to set
         */
        function RealEstateOffice(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * RealEstateOffice officeID.
         * @member {string} officeID
         * @memberof contractpb.RealEstateOffice
         * @instance
         */
        RealEstateOffice.prototype.officeID = "";

        /**
         * RealEstateOffice agent.
         * @member {contractpb.IAgent|null|undefined} agent
         * @memberof contractpb.RealEstateOffice
         * @instance
         */
        RealEstateOffice.prototype.agent = null;

        /**
         * RealEstateOffice represents.
         * @member {contractpb.RepresentsSide} represents
         * @memberof contractpb.RealEstateOffice
         * @instance
         */
        RealEstateOffice.prototype.represents = 0;

        /**
         * Creates a new RealEstateOffice instance using the specified properties.
         * @function create
         * @memberof contractpb.RealEstateOffice
         * @static
         * @param {contractpb.IRealEstateOffice=} [properties] Properties to set
         * @returns {contractpb.RealEstateOffice} RealEstateOffice instance
         */
        RealEstateOffice.create = function create(properties) {
            return new RealEstateOffice(properties);
        };

        /**
         * Encodes the specified RealEstateOffice message. Does not implicitly {@link contractpb.RealEstateOffice.verify|verify} messages.
         * @function encode
         * @memberof contractpb.RealEstateOffice
         * @static
         * @param {contractpb.IRealEstateOffice} m RealEstateOffice message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RealEstateOffice.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.officeID != null && Object.hasOwnProperty.call(m, "officeID"))
                w.uint32(10).string(m.officeID);
            if (m.agent != null && Object.hasOwnProperty.call(m, "agent"))
                $root.contractpb.Agent.encode(m.agent, w.uint32(18).fork()).ldelim();
            if (m.represents != null && Object.hasOwnProperty.call(m, "represents"))
                w.uint32(24).int32(m.represents);
            return w;
        };

        /**
         * Decodes a RealEstateOffice message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.RealEstateOffice
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.RealEstateOffice} RealEstateOffice
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RealEstateOffice.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.RealEstateOffice();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.officeID = r.string();
                    break;
                case 2:
                    m.agent = $root.contractpb.Agent.decode(r, r.uint32());
                    break;
                case 3:
                    m.represents = r.int32();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return RealEstateOffice;
    })();

    contractpb.SalesPerson = (function() {

        /**
         * Properties of a SalesPerson.
         * @memberof contractpb
         * @interface ISalesPerson
         * @property {string|null} [salesPersonID] SalesPerson salesPersonID
         * @property {string|null} [salesPersontypeCode] SalesPerson salesPersontypeCode
         */

        /**
         * Constructs a new SalesPerson.
         * @memberof contractpb
         * @classdesc Represents a SalesPerson.
         * @implements ISalesPerson
         * @constructor
         * @param {contractpb.ISalesPerson=} [p] Properties to set
         */
        function SalesPerson(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * SalesPerson salesPersonID.
         * @member {string} salesPersonID
         * @memberof contractpb.SalesPerson
         * @instance
         */
        SalesPerson.prototype.salesPersonID = "";

        /**
         * SalesPerson salesPersontypeCode.
         * @member {string} salesPersontypeCode
         * @memberof contractpb.SalesPerson
         * @instance
         */
        SalesPerson.prototype.salesPersontypeCode = "";

        /**
         * Creates a new SalesPerson instance using the specified properties.
         * @function create
         * @memberof contractpb.SalesPerson
         * @static
         * @param {contractpb.ISalesPerson=} [properties] Properties to set
         * @returns {contractpb.SalesPerson} SalesPerson instance
         */
        SalesPerson.create = function create(properties) {
            return new SalesPerson(properties);
        };

        /**
         * Encodes the specified SalesPerson message. Does not implicitly {@link contractpb.SalesPerson.verify|verify} messages.
         * @function encode
         * @memberof contractpb.SalesPerson
         * @static
         * @param {contractpb.ISalesPerson} m SalesPerson message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SalesPerson.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.salesPersonID != null && Object.hasOwnProperty.call(m, "salesPersonID"))
                w.uint32(10).string(m.salesPersonID);
            if (m.salesPersontypeCode != null && Object.hasOwnProperty.call(m, "salesPersontypeCode"))
                w.uint32(18).string(m.salesPersontypeCode);
            return w;
        };

        /**
         * Decodes a SalesPerson message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.SalesPerson
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.SalesPerson} SalesPerson
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SalesPerson.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.SalesPerson();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.salesPersonID = r.string();
                    break;
                case 2:
                    m.salesPersontypeCode = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return SalesPerson;
    })();

    contractpb.Agent = (function() {

        /**
         * Properties of an Agent.
         * @memberof contractpb
         * @interface IAgent
         * @property {string|null} [fullName] Agent fullName
         * @property {string|null} [agentID] Agent agentID
         */

        /**
         * Constructs a new Agent.
         * @memberof contractpb
         * @classdesc Represents an Agent.
         * @implements IAgent
         * @constructor
         * @param {contractpb.IAgent=} [p] Properties to set
         */
        function Agent(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * Agent fullName.
         * @member {string} fullName
         * @memberof contractpb.Agent
         * @instance
         */
        Agent.prototype.fullName = "";

        /**
         * Agent agentID.
         * @member {string} agentID
         * @memberof contractpb.Agent
         * @instance
         */
        Agent.prototype.agentID = "";

        /**
         * Creates a new Agent instance using the specified properties.
         * @function create
         * @memberof contractpb.Agent
         * @static
         * @param {contractpb.IAgent=} [properties] Properties to set
         * @returns {contractpb.Agent} Agent instance
         */
        Agent.create = function create(properties) {
            return new Agent(properties);
        };

        /**
         * Encodes the specified Agent message. Does not implicitly {@link contractpb.Agent.verify|verify} messages.
         * @function encode
         * @memberof contractpb.Agent
         * @static
         * @param {contractpb.IAgent} m Agent message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Agent.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.fullName != null && Object.hasOwnProperty.call(m, "fullName"))
                w.uint32(10).string(m.fullName);
            if (m.agentID != null && Object.hasOwnProperty.call(m, "agentID"))
                w.uint32(18).string(m.agentID);
            return w;
        };

        /**
         * Decodes an Agent message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.Agent
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.Agent} Agent
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Agent.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.Agent();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.fullName = r.string();
                    break;
                case 2:
                    m.agentID = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return Agent;
    })();

    /**
     * RepresentsSide enum.
     * @name contractpb.RepresentsSide
     * @enum {number}
     * @property {number} REPRESENTS_UNKNOWN=0 REPRESENTS_UNKNOWN value
     * @property {number} REPRESENTS_BUYER=1 REPRESENTS_BUYER value
     * @property {number} REPRESENTS_SELLER=2 REPRESENTS_SELLER value
     * @property {number} REPRESENTS_BOTH=3 REPRESENTS_BOTH value
     */
    contractpb.RepresentsSide = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "REPRESENTS_UNKNOWN"] = 0;
        values[valuesById[1] = "REPRESENTS_BUYER"] = 1;
        values[valuesById[2] = "REPRESENTS_SELLER"] = 2;
        values[valuesById[3] = "REPRESENTS_BOTH"] = 3;
        return values;
    })();

    contractpb.ContractNote = (function() {

        /**
         * Properties of a ContractNote.
         * @memberof contractpb
         * @interface IContractNote
         * @property {string|null} [typeCode] ContractNote typeCode
         * @property {string|null} [reasonText] ContractNote reasonText
         */

        /**
         * Constructs a new ContractNote.
         * @memberof contractpb
         * @classdesc Represents a ContractNote.
         * @implements IContractNote
         * @constructor
         * @param {contractpb.IContractNote=} [p] Properties to set
         */
        function ContractNote(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * ContractNote typeCode.
         * @member {string} typeCode
         * @memberof contractpb.ContractNote
         * @instance
         */
        ContractNote.prototype.typeCode = "";

        /**
         * ContractNote reasonText.
         * @member {string} reasonText
         * @memberof contractpb.ContractNote
         * @instance
         */
        ContractNote.prototype.reasonText = "";

        /**
         * Creates a new ContractNote instance using the specified properties.
         * @function create
         * @memberof contractpb.ContractNote
         * @static
         * @param {contractpb.IContractNote=} [properties] Properties to set
         * @returns {contractpb.ContractNote} ContractNote instance
         */
        ContractNote.create = function create(properties) {
            return new ContractNote(properties);
        };

        /**
         * Encodes the specified ContractNote message. Does not implicitly {@link contractpb.ContractNote.verify|verify} messages.
         * @function encode
         * @memberof contractpb.ContractNote
         * @static
         * @param {contractpb.IContractNote} m ContractNote message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ContractNote.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.typeCode != null && Object.hasOwnProperty.call(m, "typeCode"))
                w.uint32(10).string(m.typeCode);
            if (m.reasonText != null && Object.hasOwnProperty.call(m, "reasonText"))
                w.uint32(18).string(m.reasonText);
            return w;
        };

        /**
         * Decodes a ContractNote message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.ContractNote
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.ContractNote} ContractNote
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ContractNote.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.ContractNote();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.typeCode = r.string();
                    break;
                case 2:
                    m.reasonText = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return ContractNote;
    })();

    contractpb.PaymentDetail = (function() {

        /**
         * Properties of a PaymentDetail.
         * @memberof contractpb
         * @interface IPaymentDetail
         * @property {string|null} [paymentType] PaymentDetail paymentType
         * @property {string|null} [paymentTypeCode] PaymentDetail paymentTypeCode
         * @property {string|null} [sourceTypeCode] PaymentDetail sourceTypeCode
         * @property {string|null} [transactionState] PaymentDetail transactionState
         * @property {number|null} [transactionAmount] PaymentDetail transactionAmount
         * @property {string|null} [paymentProcessingDate] PaymentDetail paymentProcessingDate
         * @property {string|null} [autoBillIndicator] PaymentDetail autoBillIndicator
         * @property {string|null} [paymentExtractedDate] PaymentDetail paymentExtractedDate
         * @property {string|null} [creditCardType] PaymentDetail creditCardType
         * @property {string|null} [ccExpDate] PaymentDetail ccExpDate
         * @property {string|null} [ccNumber] PaymentDetail ccNumber
         * @property {string|null} [cardHolderFName] PaymentDetail cardHolderFName
         * @property {string|null} [cardHolderLName] PaymentDetail cardHolderLName
         * @property {string|null} [routingNumber] PaymentDetail routingNumber
         * @property {string|null} [accountNumber] PaymentDetail accountNumber
         * @property {string|null} [accountType] PaymentDetail accountType
         * @property {string|null} [resubmitIndicator] PaymentDetail resubmitIndicator
         * @property {string|null} [achSecCode] PaymentDetail achSecCode
         * @property {string|null} [cardID] PaymentDetail cardID
         * @property {string|null} [accountID] PaymentDetail accountID
         * @property {string|null} [tokenFlag] PaymentDetail tokenFlag
         * @property {contractpb.IContractProperty|null} [billingAddress] PaymentDetail billingAddress
         * @property {string|null} [achHolderFName] PaymentDetail achHolderFName
         * @property {string|null} [achHolderLName] PaymentDetail achHolderLName
         */

        /**
         * Constructs a new PaymentDetail.
         * @memberof contractpb
         * @classdesc Represents a PaymentDetail.
         * @implements IPaymentDetail
         * @constructor
         * @param {contractpb.IPaymentDetail=} [p] Properties to set
         */
        function PaymentDetail(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * PaymentDetail paymentType.
         * @member {string} paymentType
         * @memberof contractpb.PaymentDetail
         * @instance
         */
        PaymentDetail.prototype.paymentType = "";

        /**
         * PaymentDetail paymentTypeCode.
         * @member {string} paymentTypeCode
         * @memberof contractpb.PaymentDetail
         * @instance
         */
        PaymentDetail.prototype.paymentTypeCode = "";

        /**
         * PaymentDetail sourceTypeCode.
         * @member {string} sourceTypeCode
         * @memberof contractpb.PaymentDetail
         * @instance
         */
        PaymentDetail.prototype.sourceTypeCode = "";

        /**
         * PaymentDetail transactionState.
         * @member {string} transactionState
         * @memberof contractpb.PaymentDetail
         * @instance
         */
        PaymentDetail.prototype.transactionState = "";

        /**
         * PaymentDetail transactionAmount.
         * @member {number} transactionAmount
         * @memberof contractpb.PaymentDetail
         * @instance
         */
        PaymentDetail.prototype.transactionAmount = 0;

        /**
         * PaymentDetail paymentProcessingDate.
         * @member {string} paymentProcessingDate
         * @memberof contractpb.PaymentDetail
         * @instance
         */
        PaymentDetail.prototype.paymentProcessingDate = "";

        /**
         * PaymentDetail autoBillIndicator.
         * @member {string} autoBillIndicator
         * @memberof contractpb.PaymentDetail
         * @instance
         */
        PaymentDetail.prototype.autoBillIndicator = "";

        /**
         * PaymentDetail paymentExtractedDate.
         * @member {string} paymentExtractedDate
         * @memberof contractpb.PaymentDetail
         * @instance
         */
        PaymentDetail.prototype.paymentExtractedDate = "";

        /**
         * PaymentDetail creditCardType.
         * @member {string} creditCardType
         * @memberof contractpb.PaymentDetail
         * @instance
         */
        PaymentDetail.prototype.creditCardType = "";

        /**
         * PaymentDetail ccExpDate.
         * @member {string} ccExpDate
         * @memberof contractpb.PaymentDetail
         * @instance
         */
        PaymentDetail.prototype.ccExpDate = "";

        /**
         * PaymentDetail ccNumber.
         * @member {string} ccNumber
         * @memberof contractpb.PaymentDetail
         * @instance
         */
        PaymentDetail.prototype.ccNumber = "";

        /**
         * PaymentDetail cardHolderFName.
         * @member {string} cardHolderFName
         * @memberof contractpb.PaymentDetail
         * @instance
         */
        PaymentDetail.prototype.cardHolderFName = "";

        /**
         * PaymentDetail cardHolderLName.
         * @member {string} cardHolderLName
         * @memberof contractpb.PaymentDetail
         * @instance
         */
        PaymentDetail.prototype.cardHolderLName = "";

        /**
         * PaymentDetail routingNumber.
         * @member {string} routingNumber
         * @memberof contractpb.PaymentDetail
         * @instance
         */
        PaymentDetail.prototype.routingNumber = "";

        /**
         * PaymentDetail accountNumber.
         * @member {string} accountNumber
         * @memberof contractpb.PaymentDetail
         * @instance
         */
        PaymentDetail.prototype.accountNumber = "";

        /**
         * PaymentDetail accountType.
         * @member {string} accountType
         * @memberof contractpb.PaymentDetail
         * @instance
         */
        PaymentDetail.prototype.accountType = "";

        /**
         * PaymentDetail resubmitIndicator.
         * @member {string} resubmitIndicator
         * @memberof contractpb.PaymentDetail
         * @instance
         */
        PaymentDetail.prototype.resubmitIndicator = "";

        /**
         * PaymentDetail achSecCode.
         * @member {string} achSecCode
         * @memberof contractpb.PaymentDetail
         * @instance
         */
        PaymentDetail.prototype.achSecCode = "";

        /**
         * PaymentDetail cardID.
         * @member {string} cardID
         * @memberof contractpb.PaymentDetail
         * @instance
         */
        PaymentDetail.prototype.cardID = "";

        /**
         * PaymentDetail accountID.
         * @member {string} accountID
         * @memberof contractpb.PaymentDetail
         * @instance
         */
        PaymentDetail.prototype.accountID = "";

        /**
         * PaymentDetail tokenFlag.
         * @member {string} tokenFlag
         * @memberof contractpb.PaymentDetail
         * @instance
         */
        PaymentDetail.prototype.tokenFlag = "";

        /**
         * PaymentDetail billingAddress.
         * @member {contractpb.IContractProperty|null|undefined} billingAddress
         * @memberof contractpb.PaymentDetail
         * @instance
         */
        PaymentDetail.prototype.billingAddress = null;

        /**
         * PaymentDetail achHolderFName.
         * @member {string} achHolderFName
         * @memberof contractpb.PaymentDetail
         * @instance
         */
        PaymentDetail.prototype.achHolderFName = "";

        /**
         * PaymentDetail achHolderLName.
         * @member {string} achHolderLName
         * @memberof contractpb.PaymentDetail
         * @instance
         */
        PaymentDetail.prototype.achHolderLName = "";

        /**
         * Creates a new PaymentDetail instance using the specified properties.
         * @function create
         * @memberof contractpb.PaymentDetail
         * @static
         * @param {contractpb.IPaymentDetail=} [properties] Properties to set
         * @returns {contractpb.PaymentDetail} PaymentDetail instance
         */
        PaymentDetail.create = function create(properties) {
            return new PaymentDetail(properties);
        };

        /**
         * Encodes the specified PaymentDetail message. Does not implicitly {@link contractpb.PaymentDetail.verify|verify} messages.
         * @function encode
         * @memberof contractpb.PaymentDetail
         * @static
         * @param {contractpb.IPaymentDetail} m PaymentDetail message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PaymentDetail.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.paymentType != null && Object.hasOwnProperty.call(m, "paymentType"))
                w.uint32(10).string(m.paymentType);
            if (m.paymentTypeCode != null && Object.hasOwnProperty.call(m, "paymentTypeCode"))
                w.uint32(18).string(m.paymentTypeCode);
            if (m.sourceTypeCode != null && Object.hasOwnProperty.call(m, "sourceTypeCode"))
                w.uint32(26).string(m.sourceTypeCode);
            if (m.transactionState != null && Object.hasOwnProperty.call(m, "transactionState"))
                w.uint32(34).string(m.transactionState);
            if (m.transactionAmount != null && Object.hasOwnProperty.call(m, "transactionAmount"))
                w.uint32(45).float(m.transactionAmount);
            if (m.paymentProcessingDate != null && Object.hasOwnProperty.call(m, "paymentProcessingDate"))
                w.uint32(50).string(m.paymentProcessingDate);
            if (m.autoBillIndicator != null && Object.hasOwnProperty.call(m, "autoBillIndicator"))
                w.uint32(58).string(m.autoBillIndicator);
            if (m.paymentExtractedDate != null && Object.hasOwnProperty.call(m, "paymentExtractedDate"))
                w.uint32(66).string(m.paymentExtractedDate);
            if (m.creditCardType != null && Object.hasOwnProperty.call(m, "creditCardType"))
                w.uint32(74).string(m.creditCardType);
            if (m.ccExpDate != null && Object.hasOwnProperty.call(m, "ccExpDate"))
                w.uint32(82).string(m.ccExpDate);
            if (m.ccNumber != null && Object.hasOwnProperty.call(m, "ccNumber"))
                w.uint32(90).string(m.ccNumber);
            if (m.cardHolderFName != null && Object.hasOwnProperty.call(m, "cardHolderFName"))
                w.uint32(98).string(m.cardHolderFName);
            if (m.cardHolderLName != null && Object.hasOwnProperty.call(m, "cardHolderLName"))
                w.uint32(106).string(m.cardHolderLName);
            if (m.routingNumber != null && Object.hasOwnProperty.call(m, "routingNumber"))
                w.uint32(114).string(m.routingNumber);
            if (m.accountNumber != null && Object.hasOwnProperty.call(m, "accountNumber"))
                w.uint32(122).string(m.accountNumber);
            if (m.accountType != null && Object.hasOwnProperty.call(m, "accountType"))
                w.uint32(130).string(m.accountType);
            if (m.resubmitIndicator != null && Object.hasOwnProperty.call(m, "resubmitIndicator"))
                w.uint32(138).string(m.resubmitIndicator);
            if (m.achSecCode != null && Object.hasOwnProperty.call(m, "achSecCode"))
                w.uint32(146).string(m.achSecCode);
            if (m.cardID != null && Object.hasOwnProperty.call(m, "cardID"))
                w.uint32(154).string(m.cardID);
            if (m.accountID != null && Object.hasOwnProperty.call(m, "accountID"))
                w.uint32(162).string(m.accountID);
            if (m.tokenFlag != null && Object.hasOwnProperty.call(m, "tokenFlag"))
                w.uint32(170).string(m.tokenFlag);
            if (m.billingAddress != null && Object.hasOwnProperty.call(m, "billingAddress"))
                $root.contractpb.ContractProperty.encode(m.billingAddress, w.uint32(178).fork()).ldelim();
            if (m.achHolderFName != null && Object.hasOwnProperty.call(m, "achHolderFName"))
                w.uint32(186).string(m.achHolderFName);
            if (m.achHolderLName != null && Object.hasOwnProperty.call(m, "achHolderLName"))
                w.uint32(194).string(m.achHolderLName);
            return w;
        };

        /**
         * Decodes a PaymentDetail message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.PaymentDetail
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.PaymentDetail} PaymentDetail
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PaymentDetail.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.PaymentDetail();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.paymentType = r.string();
                    break;
                case 2:
                    m.paymentTypeCode = r.string();
                    break;
                case 3:
                    m.sourceTypeCode = r.string();
                    break;
                case 4:
                    m.transactionState = r.string();
                    break;
                case 5:
                    m.transactionAmount = r.float();
                    break;
                case 6:
                    m.paymentProcessingDate = r.string();
                    break;
                case 7:
                    m.autoBillIndicator = r.string();
                    break;
                case 8:
                    m.paymentExtractedDate = r.string();
                    break;
                case 9:
                    m.creditCardType = r.string();
                    break;
                case 10:
                    m.ccExpDate = r.string();
                    break;
                case 11:
                    m.ccNumber = r.string();
                    break;
                case 12:
                    m.cardHolderFName = r.string();
                    break;
                case 13:
                    m.cardHolderLName = r.string();
                    break;
                case 14:
                    m.routingNumber = r.string();
                    break;
                case 15:
                    m.accountNumber = r.string();
                    break;
                case 16:
                    m.accountType = r.string();
                    break;
                case 17:
                    m.resubmitIndicator = r.string();
                    break;
                case 18:
                    m.achSecCode = r.string();
                    break;
                case 19:
                    m.cardID = r.string();
                    break;
                case 20:
                    m.accountID = r.string();
                    break;
                case 21:
                    m.tokenFlag = r.string();
                    break;
                case 22:
                    m.billingAddress = $root.contractpb.ContractProperty.decode(r, r.uint32());
                    break;
                case 23:
                    m.achHolderFName = r.string();
                    break;
                case 24:
                    m.achHolderLName = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return PaymentDetail;
    })();

    contractpb.ProductPriceDetail = (function() {

        /**
         * Properties of a ProductPriceDetail.
         * @memberof contractpb
         * @interface IProductPriceDetail
         * @property {string|null} [productVersionID] ProductPriceDetail productVersionID
         * @property {number|null} [basePrice] ProductPriceDetail basePrice
         * @property {number|null} [optionPrice] ProductPriceDetail optionPrice
         * @property {number|null} [salesTax] ProductPriceDetail salesTax
         * @property {Array.<contractpb.ICoverage>|null} [coverages] ProductPriceDetail coverages
         * @property {Array.<contractpb.IMonies>|null} [monies] ProductPriceDetail monies
         * @property {string|null} [quoteID] ProductPriceDetail quoteID
         * @property {number|null} [paymentPlan] ProductPriceDetail paymentPlan
         * @property {Array.<string>|null} [discountCode] ProductPriceDetail discountCode
         * @property {coreproductpb.TypedValue.ITimePeriod|null} [contractTerm] ProductPriceDetail contractTerm
         */

        /**
         * Constructs a new ProductPriceDetail.
         * @memberof contractpb
         * @classdesc Represents a ProductPriceDetail.
         * @implements IProductPriceDetail
         * @constructor
         * @param {contractpb.IProductPriceDetail=} [p] Properties to set
         */
        function ProductPriceDetail(p) {
            this.coverages = [];
            this.monies = [];
            this.discountCode = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * ProductPriceDetail productVersionID.
         * @member {string} productVersionID
         * @memberof contractpb.ProductPriceDetail
         * @instance
         */
        ProductPriceDetail.prototype.productVersionID = "";

        /**
         * ProductPriceDetail basePrice.
         * @member {number} basePrice
         * @memberof contractpb.ProductPriceDetail
         * @instance
         */
        ProductPriceDetail.prototype.basePrice = 0;

        /**
         * ProductPriceDetail optionPrice.
         * @member {number} optionPrice
         * @memberof contractpb.ProductPriceDetail
         * @instance
         */
        ProductPriceDetail.prototype.optionPrice = 0;

        /**
         * ProductPriceDetail salesTax.
         * @member {number} salesTax
         * @memberof contractpb.ProductPriceDetail
         * @instance
         */
        ProductPriceDetail.prototype.salesTax = 0;

        /**
         * ProductPriceDetail coverages.
         * @member {Array.<contractpb.ICoverage>} coverages
         * @memberof contractpb.ProductPriceDetail
         * @instance
         */
        ProductPriceDetail.prototype.coverages = $util.emptyArray;

        /**
         * ProductPriceDetail monies.
         * @member {Array.<contractpb.IMonies>} monies
         * @memberof contractpb.ProductPriceDetail
         * @instance
         */
        ProductPriceDetail.prototype.monies = $util.emptyArray;

        /**
         * ProductPriceDetail quoteID.
         * @member {string} quoteID
         * @memberof contractpb.ProductPriceDetail
         * @instance
         */
        ProductPriceDetail.prototype.quoteID = "";

        /**
         * ProductPriceDetail paymentPlan.
         * @member {number} paymentPlan
         * @memberof contractpb.ProductPriceDetail
         * @instance
         */
        ProductPriceDetail.prototype.paymentPlan = 0;

        /**
         * ProductPriceDetail discountCode.
         * @member {Array.<string>} discountCode
         * @memberof contractpb.ProductPriceDetail
         * @instance
         */
        ProductPriceDetail.prototype.discountCode = $util.emptyArray;

        /**
         * ProductPriceDetail contractTerm.
         * @member {coreproductpb.TypedValue.ITimePeriod|null|undefined} contractTerm
         * @memberof contractpb.ProductPriceDetail
         * @instance
         */
        ProductPriceDetail.prototype.contractTerm = null;

        /**
         * Creates a new ProductPriceDetail instance using the specified properties.
         * @function create
         * @memberof contractpb.ProductPriceDetail
         * @static
         * @param {contractpb.IProductPriceDetail=} [properties] Properties to set
         * @returns {contractpb.ProductPriceDetail} ProductPriceDetail instance
         */
        ProductPriceDetail.create = function create(properties) {
            return new ProductPriceDetail(properties);
        };

        /**
         * Encodes the specified ProductPriceDetail message. Does not implicitly {@link contractpb.ProductPriceDetail.verify|verify} messages.
         * @function encode
         * @memberof contractpb.ProductPriceDetail
         * @static
         * @param {contractpb.IProductPriceDetail} m ProductPriceDetail message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ProductPriceDetail.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.productVersionID != null && Object.hasOwnProperty.call(m, "productVersionID"))
                w.uint32(10).string(m.productVersionID);
            if (m.basePrice != null && Object.hasOwnProperty.call(m, "basePrice"))
                w.uint32(17).double(m.basePrice);
            if (m.optionPrice != null && Object.hasOwnProperty.call(m, "optionPrice"))
                w.uint32(25).double(m.optionPrice);
            if (m.salesTax != null && Object.hasOwnProperty.call(m, "salesTax"))
                w.uint32(33).double(m.salesTax);
            if (m.coverages != null && m.coverages.length) {
                for (var i = 0; i < m.coverages.length; ++i)
                    $root.contractpb.Coverage.encode(m.coverages[i], w.uint32(42).fork()).ldelim();
            }
            if (m.monies != null && m.monies.length) {
                for (var i = 0; i < m.monies.length; ++i)
                    $root.contractpb.Monies.encode(m.monies[i], w.uint32(50).fork()).ldelim();
            }
            if (m.quoteID != null && Object.hasOwnProperty.call(m, "quoteID"))
                w.uint32(58).string(m.quoteID);
            if (m.paymentPlan != null && Object.hasOwnProperty.call(m, "paymentPlan"))
                w.uint32(64).int32(m.paymentPlan);
            if (m.discountCode != null && m.discountCode.length) {
                for (var i = 0; i < m.discountCode.length; ++i)
                    w.uint32(74).string(m.discountCode[i]);
            }
            if (m.contractTerm != null && Object.hasOwnProperty.call(m, "contractTerm"))
                $root.coreproductpb.TypedValue.TimePeriod.encode(m.contractTerm, w.uint32(82).fork()).ldelim();
            return w;
        };

        /**
         * Decodes a ProductPriceDetail message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.ProductPriceDetail
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.ProductPriceDetail} ProductPriceDetail
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ProductPriceDetail.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.ProductPriceDetail();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.productVersionID = r.string();
                    break;
                case 2:
                    m.basePrice = r.double();
                    break;
                case 3:
                    m.optionPrice = r.double();
                    break;
                case 4:
                    m.salesTax = r.double();
                    break;
                case 5:
                    if (!(m.coverages && m.coverages.length))
                        m.coverages = [];
                    m.coverages.push($root.contractpb.Coverage.decode(r, r.uint32()));
                    break;
                case 6:
                    if (!(m.monies && m.monies.length))
                        m.monies = [];
                    m.monies.push($root.contractpb.Monies.decode(r, r.uint32()));
                    break;
                case 7:
                    m.quoteID = r.string();
                    break;
                case 8:
                    m.paymentPlan = r.int32();
                    break;
                case 9:
                    if (!(m.discountCode && m.discountCode.length))
                        m.discountCode = [];
                    m.discountCode.push(r.string());
                    break;
                case 10:
                    m.contractTerm = $root.coreproductpb.TypedValue.TimePeriod.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return ProductPriceDetail;
    })();

    /**
     * CoverageType enum.
     * @name contractpb.CoverageType
     * @enum {number}
     * @property {number} UNDEFINED_COVERAGE=0 UNDEFINED_COVERAGE value
     * @property {number} BASE_COVERAGE=1 BASE_COVERAGE value
     * @property {number} ADDON_COVERAGE=2 ADDON_COVERAGE value
     */
    contractpb.CoverageType = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "UNDEFINED_COVERAGE"] = 0;
        values[valuesById[1] = "BASE_COVERAGE"] = 1;
        values[valuesById[2] = "ADDON_COVERAGE"] = 2;
        return values;
    })();

    contractpb.Coverage = (function() {

        /**
         * Properties of a Coverage.
         * @memberof contractpb
         * @interface ICoverage
         * @property {string|null} [coverageID] Coverage coverageID
         * @property {number|null} [quantity] Coverage quantity
         * @property {string|null} [groupID] Coverage groupID
         * @property {string|null} [productVersionID] Coverage productVersionID
         * @property {number|null} [coverageCost] Coverage coverageCost
         * @property {number|null} [groupCost] Coverage groupCost
         * @property {contractpb.CoverageType|null} [coverageType] Coverage coverageType
         */

        /**
         * Constructs a new Coverage.
         * @memberof contractpb
         * @classdesc Represents a Coverage.
         * @implements ICoverage
         * @constructor
         * @param {contractpb.ICoverage=} [p] Properties to set
         */
        function Coverage(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * Coverage coverageID.
         * @member {string} coverageID
         * @memberof contractpb.Coverage
         * @instance
         */
        Coverage.prototype.coverageID = "";

        /**
         * Coverage quantity.
         * @member {number} quantity
         * @memberof contractpb.Coverage
         * @instance
         */
        Coverage.prototype.quantity = 0;

        /**
         * Coverage groupID.
         * @member {string} groupID
         * @memberof contractpb.Coverage
         * @instance
         */
        Coverage.prototype.groupID = "";

        /**
         * Coverage productVersionID.
         * @member {string} productVersionID
         * @memberof contractpb.Coverage
         * @instance
         */
        Coverage.prototype.productVersionID = "";

        /**
         * Coverage coverageCost.
         * @member {number} coverageCost
         * @memberof contractpb.Coverage
         * @instance
         */
        Coverage.prototype.coverageCost = 0;

        /**
         * Coverage groupCost.
         * @member {number} groupCost
         * @memberof contractpb.Coverage
         * @instance
         */
        Coverage.prototype.groupCost = 0;

        /**
         * Coverage coverageType.
         * @member {contractpb.CoverageType} coverageType
         * @memberof contractpb.Coverage
         * @instance
         */
        Coverage.prototype.coverageType = 0;

        /**
         * Creates a new Coverage instance using the specified properties.
         * @function create
         * @memberof contractpb.Coverage
         * @static
         * @param {contractpb.ICoverage=} [properties] Properties to set
         * @returns {contractpb.Coverage} Coverage instance
         */
        Coverage.create = function create(properties) {
            return new Coverage(properties);
        };

        /**
         * Encodes the specified Coverage message. Does not implicitly {@link contractpb.Coverage.verify|verify} messages.
         * @function encode
         * @memberof contractpb.Coverage
         * @static
         * @param {contractpb.ICoverage} m Coverage message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Coverage.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.coverageID != null && Object.hasOwnProperty.call(m, "coverageID"))
                w.uint32(10).string(m.coverageID);
            if (m.quantity != null && Object.hasOwnProperty.call(m, "quantity"))
                w.uint32(16).int32(m.quantity);
            if (m.groupID != null && Object.hasOwnProperty.call(m, "groupID"))
                w.uint32(26).string(m.groupID);
            if (m.productVersionID != null && Object.hasOwnProperty.call(m, "productVersionID"))
                w.uint32(34).string(m.productVersionID);
            if (m.coverageCost != null && Object.hasOwnProperty.call(m, "coverageCost"))
                w.uint32(41).double(m.coverageCost);
            if (m.groupCost != null && Object.hasOwnProperty.call(m, "groupCost"))
                w.uint32(49).double(m.groupCost);
            if (m.coverageType != null && Object.hasOwnProperty.call(m, "coverageType"))
                w.uint32(56).int32(m.coverageType);
            return w;
        };

        /**
         * Decodes a Coverage message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.Coverage
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.Coverage} Coverage
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Coverage.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.Coverage();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.coverageID = r.string();
                    break;
                case 2:
                    m.quantity = r.int32();
                    break;
                case 3:
                    m.groupID = r.string();
                    break;
                case 4:
                    m.productVersionID = r.string();
                    break;
                case 5:
                    m.coverageCost = r.double();
                    break;
                case 6:
                    m.groupCost = r.double();
                    break;
                case 7:
                    m.coverageType = r.int32();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return Coverage;
    })();

    contractpb.Monies = (function() {

        /**
         * Properties of a Monies.
         * @memberof contractpb
         * @interface IMonies
         * @property {string|null} [type] Monies type
         * @property {number|null} [amount] Monies amount
         */

        /**
         * Constructs a new Monies.
         * @memberof contractpb
         * @classdesc Represents a Monies.
         * @implements IMonies
         * @constructor
         * @param {contractpb.IMonies=} [p] Properties to set
         */
        function Monies(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * Monies type.
         * @member {string} type
         * @memberof contractpb.Monies
         * @instance
         */
        Monies.prototype.type = "";

        /**
         * Monies amount.
         * @member {number} amount
         * @memberof contractpb.Monies
         * @instance
         */
        Monies.prototype.amount = 0;

        /**
         * Creates a new Monies instance using the specified properties.
         * @function create
         * @memberof contractpb.Monies
         * @static
         * @param {contractpb.IMonies=} [properties] Properties to set
         * @returns {contractpb.Monies} Monies instance
         */
        Monies.create = function create(properties) {
            return new Monies(properties);
        };

        /**
         * Encodes the specified Monies message. Does not implicitly {@link contractpb.Monies.verify|verify} messages.
         * @function encode
         * @memberof contractpb.Monies
         * @static
         * @param {contractpb.IMonies} m Monies message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Monies.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.type != null && Object.hasOwnProperty.call(m, "type"))
                w.uint32(10).string(m.type);
            if (m.amount != null && Object.hasOwnProperty.call(m, "amount"))
                w.uint32(17).double(m.amount);
            return w;
        };

        /**
         * Decodes a Monies message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.Monies
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.Monies} Monies
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Monies.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.Monies();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.type = r.string();
                    break;
                case 2:
                    m.amount = r.double();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return Monies;
    })();

    contractpb.CreateContractResponse = (function() {

        /**
         * Properties of a CreateContractResponse.
         * @memberof contractpb
         * @interface ICreateContractResponse
         * @property {string|null} [contractID] CreateContractResponse contractID
         * @property {string|null} [customerID] CreateContractResponse customerID
         * @property {string|null} [buyerCustomerID] CreateContractResponse buyerCustomerID
         */

        /**
         * Constructs a new CreateContractResponse.
         * @memberof contractpb
         * @classdesc Represents a CreateContractResponse.
         * @implements ICreateContractResponse
         * @constructor
         * @param {contractpb.ICreateContractResponse=} [p] Properties to set
         */
        function CreateContractResponse(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * CreateContractResponse contractID.
         * @member {string} contractID
         * @memberof contractpb.CreateContractResponse
         * @instance
         */
        CreateContractResponse.prototype.contractID = "";

        /**
         * CreateContractResponse customerID.
         * @member {string} customerID
         * @memberof contractpb.CreateContractResponse
         * @instance
         */
        CreateContractResponse.prototype.customerID = "";

        /**
         * CreateContractResponse buyerCustomerID.
         * @member {string} buyerCustomerID
         * @memberof contractpb.CreateContractResponse
         * @instance
         */
        CreateContractResponse.prototype.buyerCustomerID = "";

        /**
         * Creates a new CreateContractResponse instance using the specified properties.
         * @function create
         * @memberof contractpb.CreateContractResponse
         * @static
         * @param {contractpb.ICreateContractResponse=} [properties] Properties to set
         * @returns {contractpb.CreateContractResponse} CreateContractResponse instance
         */
        CreateContractResponse.create = function create(properties) {
            return new CreateContractResponse(properties);
        };

        /**
         * Encodes the specified CreateContractResponse message. Does not implicitly {@link contractpb.CreateContractResponse.verify|verify} messages.
         * @function encode
         * @memberof contractpb.CreateContractResponse
         * @static
         * @param {contractpb.ICreateContractResponse} m CreateContractResponse message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CreateContractResponse.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.contractID != null && Object.hasOwnProperty.call(m, "contractID"))
                w.uint32(10).string(m.contractID);
            if (m.customerID != null && Object.hasOwnProperty.call(m, "customerID"))
                w.uint32(18).string(m.customerID);
            if (m.buyerCustomerID != null && Object.hasOwnProperty.call(m, "buyerCustomerID"))
                w.uint32(26).string(m.buyerCustomerID);
            return w;
        };

        /**
         * Decodes a CreateContractResponse message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.CreateContractResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.CreateContractResponse} CreateContractResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CreateContractResponse.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.CreateContractResponse();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.contractID = r.string();
                    break;
                case 2:
                    m.customerID = r.string();
                    break;
                case 3:
                    m.buyerCustomerID = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return CreateContractResponse;
    })();

    contractpb.EligibleProductVersionsRequest = (function() {

        /**
         * Properties of an EligibleProductVersionsRequest.
         * @memberof contractpb
         * @interface IEligibleProductVersionsRequest
         * @property {string|null} [callingApplication] EligibleProductVersionsRequest callingApplication
         * @property {boolean|null} [isAHSInternalApplication] EligibleProductVersionsRequest isAHSInternalApplication
         * @property {boolean|null} [isSoldViaWeb] EligibleProductVersionsRequest isSoldViaWeb
         * @property {string|null} [productID] EligibleProductVersionsRequest productID
         * @property {string|null} [companyCode] EligibleProductVersionsRequest companyCode
         * @property {string|null} [salesChannel] EligibleProductVersionsRequest salesChannel
         * @property {string|null} [listingType] EligibleProductVersionsRequest listingType
         * @property {string|null} [salesSourceID] EligibleProductVersionsRequest salesSourceID
         * @property {string|null} [zipCode] EligibleProductVersionsRequest zipCode
         * @property {string|null} [dwellingType] EligibleProductVersionsRequest dwellingType
         * @property {number|Long|null} [sizeOfHome] EligibleProductVersionsRequest sizeOfHome
         * @property {google.protobuf.ITimestamp|null} [dateBuilt] EligibleProductVersionsRequest dateBuilt
         * @property {number|Long|null} [motherInLawUnits] EligibleProductVersionsRequest motherInLawUnits
         */

        /**
         * Constructs a new EligibleProductVersionsRequest.
         * @memberof contractpb
         * @classdesc Represents an EligibleProductVersionsRequest.
         * @implements IEligibleProductVersionsRequest
         * @constructor
         * @param {contractpb.IEligibleProductVersionsRequest=} [p] Properties to set
         */
        function EligibleProductVersionsRequest(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * EligibleProductVersionsRequest callingApplication.
         * @member {string} callingApplication
         * @memberof contractpb.EligibleProductVersionsRequest
         * @instance
         */
        EligibleProductVersionsRequest.prototype.callingApplication = "";

        /**
         * EligibleProductVersionsRequest isAHSInternalApplication.
         * @member {boolean} isAHSInternalApplication
         * @memberof contractpb.EligibleProductVersionsRequest
         * @instance
         */
        EligibleProductVersionsRequest.prototype.isAHSInternalApplication = false;

        /**
         * EligibleProductVersionsRequest isSoldViaWeb.
         * @member {boolean} isSoldViaWeb
         * @memberof contractpb.EligibleProductVersionsRequest
         * @instance
         */
        EligibleProductVersionsRequest.prototype.isSoldViaWeb = false;

        /**
         * EligibleProductVersionsRequest productID.
         * @member {string} productID
         * @memberof contractpb.EligibleProductVersionsRequest
         * @instance
         */
        EligibleProductVersionsRequest.prototype.productID = "";

        /**
         * EligibleProductVersionsRequest companyCode.
         * @member {string} companyCode
         * @memberof contractpb.EligibleProductVersionsRequest
         * @instance
         */
        EligibleProductVersionsRequest.prototype.companyCode = "";

        /**
         * EligibleProductVersionsRequest salesChannel.
         * @member {string} salesChannel
         * @memberof contractpb.EligibleProductVersionsRequest
         * @instance
         */
        EligibleProductVersionsRequest.prototype.salesChannel = "";

        /**
         * EligibleProductVersionsRequest listingType.
         * @member {string} listingType
         * @memberof contractpb.EligibleProductVersionsRequest
         * @instance
         */
        EligibleProductVersionsRequest.prototype.listingType = "";

        /**
         * EligibleProductVersionsRequest salesSourceID.
         * @member {string} salesSourceID
         * @memberof contractpb.EligibleProductVersionsRequest
         * @instance
         */
        EligibleProductVersionsRequest.prototype.salesSourceID = "";

        /**
         * EligibleProductVersionsRequest zipCode.
         * @member {string} zipCode
         * @memberof contractpb.EligibleProductVersionsRequest
         * @instance
         */
        EligibleProductVersionsRequest.prototype.zipCode = "";

        /**
         * EligibleProductVersionsRequest dwellingType.
         * @member {string} dwellingType
         * @memberof contractpb.EligibleProductVersionsRequest
         * @instance
         */
        EligibleProductVersionsRequest.prototype.dwellingType = "";

        /**
         * EligibleProductVersionsRequest sizeOfHome.
         * @member {number|Long} sizeOfHome
         * @memberof contractpb.EligibleProductVersionsRequest
         * @instance
         */
        EligibleProductVersionsRequest.prototype.sizeOfHome = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * EligibleProductVersionsRequest dateBuilt.
         * @member {google.protobuf.ITimestamp|null|undefined} dateBuilt
         * @memberof contractpb.EligibleProductVersionsRequest
         * @instance
         */
        EligibleProductVersionsRequest.prototype.dateBuilt = null;

        /**
         * EligibleProductVersionsRequest motherInLawUnits.
         * @member {number|Long} motherInLawUnits
         * @memberof contractpb.EligibleProductVersionsRequest
         * @instance
         */
        EligibleProductVersionsRequest.prototype.motherInLawUnits = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Creates a new EligibleProductVersionsRequest instance using the specified properties.
         * @function create
         * @memberof contractpb.EligibleProductVersionsRequest
         * @static
         * @param {contractpb.IEligibleProductVersionsRequest=} [properties] Properties to set
         * @returns {contractpb.EligibleProductVersionsRequest} EligibleProductVersionsRequest instance
         */
        EligibleProductVersionsRequest.create = function create(properties) {
            return new EligibleProductVersionsRequest(properties);
        };

        /**
         * Encodes the specified EligibleProductVersionsRequest message. Does not implicitly {@link contractpb.EligibleProductVersionsRequest.verify|verify} messages.
         * @function encode
         * @memberof contractpb.EligibleProductVersionsRequest
         * @static
         * @param {contractpb.IEligibleProductVersionsRequest} m EligibleProductVersionsRequest message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        EligibleProductVersionsRequest.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.callingApplication != null && Object.hasOwnProperty.call(m, "callingApplication"))
                w.uint32(10).string(m.callingApplication);
            if (m.isAHSInternalApplication != null && Object.hasOwnProperty.call(m, "isAHSInternalApplication"))
                w.uint32(16).bool(m.isAHSInternalApplication);
            if (m.isSoldViaWeb != null && Object.hasOwnProperty.call(m, "isSoldViaWeb"))
                w.uint32(24).bool(m.isSoldViaWeb);
            if (m.productID != null && Object.hasOwnProperty.call(m, "productID"))
                w.uint32(34).string(m.productID);
            if (m.companyCode != null && Object.hasOwnProperty.call(m, "companyCode"))
                w.uint32(42).string(m.companyCode);
            if (m.salesChannel != null && Object.hasOwnProperty.call(m, "salesChannel"))
                w.uint32(50).string(m.salesChannel);
            if (m.listingType != null && Object.hasOwnProperty.call(m, "listingType"))
                w.uint32(58).string(m.listingType);
            if (m.salesSourceID != null && Object.hasOwnProperty.call(m, "salesSourceID"))
                w.uint32(66).string(m.salesSourceID);
            if (m.zipCode != null && Object.hasOwnProperty.call(m, "zipCode"))
                w.uint32(74).string(m.zipCode);
            if (m.dwellingType != null && Object.hasOwnProperty.call(m, "dwellingType"))
                w.uint32(82).string(m.dwellingType);
            if (m.sizeOfHome != null && Object.hasOwnProperty.call(m, "sizeOfHome"))
                w.uint32(88).int64(m.sizeOfHome);
            if (m.dateBuilt != null && Object.hasOwnProperty.call(m, "dateBuilt"))
                $root.google.protobuf.Timestamp.encode(m.dateBuilt, w.uint32(98).fork()).ldelim();
            if (m.motherInLawUnits != null && Object.hasOwnProperty.call(m, "motherInLawUnits"))
                w.uint32(104).int64(m.motherInLawUnits);
            return w;
        };

        /**
         * Decodes an EligibleProductVersionsRequest message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.EligibleProductVersionsRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.EligibleProductVersionsRequest} EligibleProductVersionsRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        EligibleProductVersionsRequest.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.EligibleProductVersionsRequest();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.callingApplication = r.string();
                    break;
                case 2:
                    m.isAHSInternalApplication = r.bool();
                    break;
                case 3:
                    m.isSoldViaWeb = r.bool();
                    break;
                case 4:
                    m.productID = r.string();
                    break;
                case 5:
                    m.companyCode = r.string();
                    break;
                case 6:
                    m.salesChannel = r.string();
                    break;
                case 7:
                    m.listingType = r.string();
                    break;
                case 8:
                    m.salesSourceID = r.string();
                    break;
                case 9:
                    m.zipCode = r.string();
                    break;
                case 10:
                    m.dwellingType = r.string();
                    break;
                case 11:
                    m.sizeOfHome = r.int64();
                    break;
                case 12:
                    m.dateBuilt = $root.google.protobuf.Timestamp.decode(r, r.uint32());
                    break;
                case 13:
                    m.motherInLawUnits = r.int64();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return EligibleProductVersionsRequest;
    })();

    contractpb.EligibleProductVersionsResponse = (function() {

        /**
         * Properties of an EligibleProductVersionsResponse.
         * @memberof contractpb
         * @interface IEligibleProductVersionsResponse
         * @property {Array.<contractpb.IEligibleProductVersion>|null} [data] EligibleProductVersionsResponse data
         */

        /**
         * Constructs a new EligibleProductVersionsResponse.
         * @memberof contractpb
         * @classdesc Represents an EligibleProductVersionsResponse.
         * @implements IEligibleProductVersionsResponse
         * @constructor
         * @param {contractpb.IEligibleProductVersionsResponse=} [p] Properties to set
         */
        function EligibleProductVersionsResponse(p) {
            this.data = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * EligibleProductVersionsResponse data.
         * @member {Array.<contractpb.IEligibleProductVersion>} data
         * @memberof contractpb.EligibleProductVersionsResponse
         * @instance
         */
        EligibleProductVersionsResponse.prototype.data = $util.emptyArray;

        /**
         * Creates a new EligibleProductVersionsResponse instance using the specified properties.
         * @function create
         * @memberof contractpb.EligibleProductVersionsResponse
         * @static
         * @param {contractpb.IEligibleProductVersionsResponse=} [properties] Properties to set
         * @returns {contractpb.EligibleProductVersionsResponse} EligibleProductVersionsResponse instance
         */
        EligibleProductVersionsResponse.create = function create(properties) {
            return new EligibleProductVersionsResponse(properties);
        };

        /**
         * Encodes the specified EligibleProductVersionsResponse message. Does not implicitly {@link contractpb.EligibleProductVersionsResponse.verify|verify} messages.
         * @function encode
         * @memberof contractpb.EligibleProductVersionsResponse
         * @static
         * @param {contractpb.IEligibleProductVersionsResponse} m EligibleProductVersionsResponse message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        EligibleProductVersionsResponse.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.data != null && m.data.length) {
                for (var i = 0; i < m.data.length; ++i)
                    $root.contractpb.EligibleProductVersion.encode(m.data[i], w.uint32(10).fork()).ldelim();
            }
            return w;
        };

        /**
         * Decodes an EligibleProductVersionsResponse message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.EligibleProductVersionsResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.EligibleProductVersionsResponse} EligibleProductVersionsResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        EligibleProductVersionsResponse.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.EligibleProductVersionsResponse();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    if (!(m.data && m.data.length))
                        m.data = [];
                    m.data.push($root.contractpb.EligibleProductVersion.decode(r, r.uint32()));
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return EligibleProductVersionsResponse;
    })();

    contractpb.EligibleProductVersion = (function() {

        /**
         * Properties of an EligibleProductVersion.
         * @memberof contractpb
         * @interface IEligibleProductVersion
         * @property {string|null} [planID] EligibleProductVersion planID
         * @property {string|null} [productVersionID] EligibleProductVersion productVersionID
         * @property {string|null} [description] EligibleProductVersion description
         * @property {google.protobuf.ITimestamp|null} [effectiveDate] EligibleProductVersion effectiveDate
         * @property {google.protobuf.ITimestamp|null} [expirationDate] EligibleProductVersion expirationDate
         * @property {string|null} [serviceFee] EligibleProductVersion serviceFee
         * @property {string|null} [coverageType] EligibleProductVersion coverageType
         * @property {string|null} [legacyPVID] EligibleProductVersion legacyPVID
         * @property {string|null} [webDescription] EligibleProductVersion webDescription
         */

        /**
         * Constructs a new EligibleProductVersion.
         * @memberof contractpb
         * @classdesc Represents an EligibleProductVersion.
         * @implements IEligibleProductVersion
         * @constructor
         * @param {contractpb.IEligibleProductVersion=} [p] Properties to set
         */
        function EligibleProductVersion(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * EligibleProductVersion planID.
         * @member {string} planID
         * @memberof contractpb.EligibleProductVersion
         * @instance
         */
        EligibleProductVersion.prototype.planID = "";

        /**
         * EligibleProductVersion productVersionID.
         * @member {string} productVersionID
         * @memberof contractpb.EligibleProductVersion
         * @instance
         */
        EligibleProductVersion.prototype.productVersionID = "";

        /**
         * EligibleProductVersion description.
         * @member {string} description
         * @memberof contractpb.EligibleProductVersion
         * @instance
         */
        EligibleProductVersion.prototype.description = "";

        /**
         * EligibleProductVersion effectiveDate.
         * @member {google.protobuf.ITimestamp|null|undefined} effectiveDate
         * @memberof contractpb.EligibleProductVersion
         * @instance
         */
        EligibleProductVersion.prototype.effectiveDate = null;

        /**
         * EligibleProductVersion expirationDate.
         * @member {google.protobuf.ITimestamp|null|undefined} expirationDate
         * @memberof contractpb.EligibleProductVersion
         * @instance
         */
        EligibleProductVersion.prototype.expirationDate = null;

        /**
         * EligibleProductVersion serviceFee.
         * @member {string} serviceFee
         * @memberof contractpb.EligibleProductVersion
         * @instance
         */
        EligibleProductVersion.prototype.serviceFee = "";

        /**
         * EligibleProductVersion coverageType.
         * @member {string} coverageType
         * @memberof contractpb.EligibleProductVersion
         * @instance
         */
        EligibleProductVersion.prototype.coverageType = "";

        /**
         * EligibleProductVersion legacyPVID.
         * @member {string} legacyPVID
         * @memberof contractpb.EligibleProductVersion
         * @instance
         */
        EligibleProductVersion.prototype.legacyPVID = "";

        /**
         * EligibleProductVersion webDescription.
         * @member {string} webDescription
         * @memberof contractpb.EligibleProductVersion
         * @instance
         */
        EligibleProductVersion.prototype.webDescription = "";

        /**
         * Creates a new EligibleProductVersion instance using the specified properties.
         * @function create
         * @memberof contractpb.EligibleProductVersion
         * @static
         * @param {contractpb.IEligibleProductVersion=} [properties] Properties to set
         * @returns {contractpb.EligibleProductVersion} EligibleProductVersion instance
         */
        EligibleProductVersion.create = function create(properties) {
            return new EligibleProductVersion(properties);
        };

        /**
         * Encodes the specified EligibleProductVersion message. Does not implicitly {@link contractpb.EligibleProductVersion.verify|verify} messages.
         * @function encode
         * @memberof contractpb.EligibleProductVersion
         * @static
         * @param {contractpb.IEligibleProductVersion} m EligibleProductVersion message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        EligibleProductVersion.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.planID != null && Object.hasOwnProperty.call(m, "planID"))
                w.uint32(10).string(m.planID);
            if (m.productVersionID != null && Object.hasOwnProperty.call(m, "productVersionID"))
                w.uint32(18).string(m.productVersionID);
            if (m.description != null && Object.hasOwnProperty.call(m, "description"))
                w.uint32(26).string(m.description);
            if (m.effectiveDate != null && Object.hasOwnProperty.call(m, "effectiveDate"))
                $root.google.protobuf.Timestamp.encode(m.effectiveDate, w.uint32(34).fork()).ldelim();
            if (m.expirationDate != null && Object.hasOwnProperty.call(m, "expirationDate"))
                $root.google.protobuf.Timestamp.encode(m.expirationDate, w.uint32(42).fork()).ldelim();
            if (m.serviceFee != null && Object.hasOwnProperty.call(m, "serviceFee"))
                w.uint32(50).string(m.serviceFee);
            if (m.coverageType != null && Object.hasOwnProperty.call(m, "coverageType"))
                w.uint32(58).string(m.coverageType);
            if (m.legacyPVID != null && Object.hasOwnProperty.call(m, "legacyPVID"))
                w.uint32(66).string(m.legacyPVID);
            if (m.webDescription != null && Object.hasOwnProperty.call(m, "webDescription"))
                w.uint32(74).string(m.webDescription);
            return w;
        };

        /**
         * Decodes an EligibleProductVersion message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.EligibleProductVersion
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.EligibleProductVersion} EligibleProductVersion
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        EligibleProductVersion.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.EligibleProductVersion();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.planID = r.string();
                    break;
                case 2:
                    m.productVersionID = r.string();
                    break;
                case 3:
                    m.description = r.string();
                    break;
                case 4:
                    m.effectiveDate = $root.google.protobuf.Timestamp.decode(r, r.uint32());
                    break;
                case 5:
                    m.expirationDate = $root.google.protobuf.Timestamp.decode(r, r.uint32());
                    break;
                case 6:
                    m.serviceFee = r.string();
                    break;
                case 7:
                    m.coverageType = r.string();
                    break;
                case 8:
                    m.legacyPVID = r.string();
                    break;
                case 9:
                    m.webDescription = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return EligibleProductVersion;
    })();

    contractpb.CancelContractRequest = (function() {

        /**
         * Properties of a CancelContractRequest.
         * @memberof contractpb
         * @interface ICancelContractRequest
         * @property {string|null} [contractID] CancelContractRequest contractID
         * @property {string|null} [reasonType] CancelContractRequest reasonType
         * @property {string|null} [reasonDescription] CancelContractRequest reasonDescription
         * @property {string|null} [userID] CancelContractRequest userID
         */

        /**
         * Constructs a new CancelContractRequest.
         * @memberof contractpb
         * @classdesc Represents a CancelContractRequest.
         * @implements ICancelContractRequest
         * @constructor
         * @param {contractpb.ICancelContractRequest=} [p] Properties to set
         */
        function CancelContractRequest(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * CancelContractRequest contractID.
         * @member {string} contractID
         * @memberof contractpb.CancelContractRequest
         * @instance
         */
        CancelContractRequest.prototype.contractID = "";

        /**
         * CancelContractRequest reasonType.
         * @member {string} reasonType
         * @memberof contractpb.CancelContractRequest
         * @instance
         */
        CancelContractRequest.prototype.reasonType = "";

        /**
         * CancelContractRequest reasonDescription.
         * @member {string} reasonDescription
         * @memberof contractpb.CancelContractRequest
         * @instance
         */
        CancelContractRequest.prototype.reasonDescription = "";

        /**
         * CancelContractRequest userID.
         * @member {string} userID
         * @memberof contractpb.CancelContractRequest
         * @instance
         */
        CancelContractRequest.prototype.userID = "";

        /**
         * Creates a new CancelContractRequest instance using the specified properties.
         * @function create
         * @memberof contractpb.CancelContractRequest
         * @static
         * @param {contractpb.ICancelContractRequest=} [properties] Properties to set
         * @returns {contractpb.CancelContractRequest} CancelContractRequest instance
         */
        CancelContractRequest.create = function create(properties) {
            return new CancelContractRequest(properties);
        };

        /**
         * Encodes the specified CancelContractRequest message. Does not implicitly {@link contractpb.CancelContractRequest.verify|verify} messages.
         * @function encode
         * @memberof contractpb.CancelContractRequest
         * @static
         * @param {contractpb.ICancelContractRequest} m CancelContractRequest message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CancelContractRequest.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.contractID != null && Object.hasOwnProperty.call(m, "contractID"))
                w.uint32(10).string(m.contractID);
            if (m.reasonType != null && Object.hasOwnProperty.call(m, "reasonType"))
                w.uint32(18).string(m.reasonType);
            if (m.reasonDescription != null && Object.hasOwnProperty.call(m, "reasonDescription"))
                w.uint32(26).string(m.reasonDescription);
            if (m.userID != null && Object.hasOwnProperty.call(m, "userID"))
                w.uint32(34).string(m.userID);
            return w;
        };

        /**
         * Decodes a CancelContractRequest message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.CancelContractRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.CancelContractRequest} CancelContractRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CancelContractRequest.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.CancelContractRequest();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.contractID = r.string();
                    break;
                case 2:
                    m.reasonType = r.string();
                    break;
                case 3:
                    m.reasonDescription = r.string();
                    break;
                case 4:
                    m.userID = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return CancelContractRequest;
    })();

    contractpb.ScheduleFulfillmentResponse = (function() {

        /**
         * Properties of a ScheduleFulfillmentResponse.
         * @memberof contractpb
         * @interface IScheduleFulfillmentResponse
         * @property {Array.<contractpb.IScheduleFulfillment>|null} [fulfilments] ScheduleFulfillmentResponse fulfilments
         */

        /**
         * Constructs a new ScheduleFulfillmentResponse.
         * @memberof contractpb
         * @classdesc Represents a ScheduleFulfillmentResponse.
         * @implements IScheduleFulfillmentResponse
         * @constructor
         * @param {contractpb.IScheduleFulfillmentResponse=} [p] Properties to set
         */
        function ScheduleFulfillmentResponse(p) {
            this.fulfilments = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * ScheduleFulfillmentResponse fulfilments.
         * @member {Array.<contractpb.IScheduleFulfillment>} fulfilments
         * @memberof contractpb.ScheduleFulfillmentResponse
         * @instance
         */
        ScheduleFulfillmentResponse.prototype.fulfilments = $util.emptyArray;

        /**
         * Creates a new ScheduleFulfillmentResponse instance using the specified properties.
         * @function create
         * @memberof contractpb.ScheduleFulfillmentResponse
         * @static
         * @param {contractpb.IScheduleFulfillmentResponse=} [properties] Properties to set
         * @returns {contractpb.ScheduleFulfillmentResponse} ScheduleFulfillmentResponse instance
         */
        ScheduleFulfillmentResponse.create = function create(properties) {
            return new ScheduleFulfillmentResponse(properties);
        };

        /**
         * Encodes the specified ScheduleFulfillmentResponse message. Does not implicitly {@link contractpb.ScheduleFulfillmentResponse.verify|verify} messages.
         * @function encode
         * @memberof contractpb.ScheduleFulfillmentResponse
         * @static
         * @param {contractpb.IScheduleFulfillmentResponse} m ScheduleFulfillmentResponse message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ScheduleFulfillmentResponse.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.fulfilments != null && m.fulfilments.length) {
                for (var i = 0; i < m.fulfilments.length; ++i)
                    $root.contractpb.ScheduleFulfillment.encode(m.fulfilments[i], w.uint32(10).fork()).ldelim();
            }
            return w;
        };

        /**
         * Decodes a ScheduleFulfillmentResponse message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.ScheduleFulfillmentResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.ScheduleFulfillmentResponse} ScheduleFulfillmentResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ScheduleFulfillmentResponse.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.ScheduleFulfillmentResponse();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    if (!(m.fulfilments && m.fulfilments.length))
                        m.fulfilments = [];
                    m.fulfilments.push($root.contractpb.ScheduleFulfillment.decode(r, r.uint32()));
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return ScheduleFulfillmentResponse;
    })();

    contractpb.ScheduleFulfillment = (function() {

        /**
         * Properties of a ScheduleFulfillment.
         * @memberof contractpb
         * @interface IScheduleFulfillment
         * @property {string|null} [formCode] ScheduleFulfillment formCode
         * @property {string|null} [fulfillmentTypeID] ScheduleFulfillment fulfillmentTypeID
         * @property {string|null} [deliveryMethodID] ScheduleFulfillment deliveryMethodID
         * @property {contractpb.ScheduleFulfillment.IDates|null} [dates] ScheduleFulfillment dates
         * @property {contractpb.ScheduleFulfillment.IRejection|null} [rejection] ScheduleFulfillment rejection
         * @property {string|null} [productVersionID] ScheduleFulfillment productVersionID
         * @property {string|null} [propertyID] ScheduleFulfillment propertyID
         * @property {string|null} [customerID] ScheduleFulfillment customerID
         * @property {contractpb.ScheduleFulfillment.IOffice|null} [office] ScheduleFulfillment office
         */

        /**
         * Constructs a new ScheduleFulfillment.
         * @memberof contractpb
         * @classdesc Represents a ScheduleFulfillment.
         * @implements IScheduleFulfillment
         * @constructor
         * @param {contractpb.IScheduleFulfillment=} [p] Properties to set
         */
        function ScheduleFulfillment(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * ScheduleFulfillment formCode.
         * @member {string} formCode
         * @memberof contractpb.ScheduleFulfillment
         * @instance
         */
        ScheduleFulfillment.prototype.formCode = "";

        /**
         * ScheduleFulfillment fulfillmentTypeID.
         * @member {string} fulfillmentTypeID
         * @memberof contractpb.ScheduleFulfillment
         * @instance
         */
        ScheduleFulfillment.prototype.fulfillmentTypeID = "";

        /**
         * ScheduleFulfillment deliveryMethodID.
         * @member {string} deliveryMethodID
         * @memberof contractpb.ScheduleFulfillment
         * @instance
         */
        ScheduleFulfillment.prototype.deliveryMethodID = "";

        /**
         * ScheduleFulfillment dates.
         * @member {contractpb.ScheduleFulfillment.IDates|null|undefined} dates
         * @memberof contractpb.ScheduleFulfillment
         * @instance
         */
        ScheduleFulfillment.prototype.dates = null;

        /**
         * ScheduleFulfillment rejection.
         * @member {contractpb.ScheduleFulfillment.IRejection|null|undefined} rejection
         * @memberof contractpb.ScheduleFulfillment
         * @instance
         */
        ScheduleFulfillment.prototype.rejection = null;

        /**
         * ScheduleFulfillment productVersionID.
         * @member {string} productVersionID
         * @memberof contractpb.ScheduleFulfillment
         * @instance
         */
        ScheduleFulfillment.prototype.productVersionID = "";

        /**
         * ScheduleFulfillment propertyID.
         * @member {string} propertyID
         * @memberof contractpb.ScheduleFulfillment
         * @instance
         */
        ScheduleFulfillment.prototype.propertyID = "";

        /**
         * ScheduleFulfillment customerID.
         * @member {string} customerID
         * @memberof contractpb.ScheduleFulfillment
         * @instance
         */
        ScheduleFulfillment.prototype.customerID = "";

        /**
         * ScheduleFulfillment office.
         * @member {contractpb.ScheduleFulfillment.IOffice|null|undefined} office
         * @memberof contractpb.ScheduleFulfillment
         * @instance
         */
        ScheduleFulfillment.prototype.office = null;

        /**
         * Creates a new ScheduleFulfillment instance using the specified properties.
         * @function create
         * @memberof contractpb.ScheduleFulfillment
         * @static
         * @param {contractpb.IScheduleFulfillment=} [properties] Properties to set
         * @returns {contractpb.ScheduleFulfillment} ScheduleFulfillment instance
         */
        ScheduleFulfillment.create = function create(properties) {
            return new ScheduleFulfillment(properties);
        };

        /**
         * Encodes the specified ScheduleFulfillment message. Does not implicitly {@link contractpb.ScheduleFulfillment.verify|verify} messages.
         * @function encode
         * @memberof contractpb.ScheduleFulfillment
         * @static
         * @param {contractpb.IScheduleFulfillment} m ScheduleFulfillment message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ScheduleFulfillment.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.formCode != null && Object.hasOwnProperty.call(m, "formCode"))
                w.uint32(10).string(m.formCode);
            if (m.fulfillmentTypeID != null && Object.hasOwnProperty.call(m, "fulfillmentTypeID"))
                w.uint32(18).string(m.fulfillmentTypeID);
            if (m.deliveryMethodID != null && Object.hasOwnProperty.call(m, "deliveryMethodID"))
                w.uint32(26).string(m.deliveryMethodID);
            if (m.dates != null && Object.hasOwnProperty.call(m, "dates"))
                $root.contractpb.ScheduleFulfillment.Dates.encode(m.dates, w.uint32(34).fork()).ldelim();
            if (m.rejection != null && Object.hasOwnProperty.call(m, "rejection"))
                $root.contractpb.ScheduleFulfillment.Rejection.encode(m.rejection, w.uint32(42).fork()).ldelim();
            if (m.productVersionID != null && Object.hasOwnProperty.call(m, "productVersionID"))
                w.uint32(58).string(m.productVersionID);
            if (m.propertyID != null && Object.hasOwnProperty.call(m, "propertyID"))
                w.uint32(66).string(m.propertyID);
            if (m.customerID != null && Object.hasOwnProperty.call(m, "customerID"))
                w.uint32(74).string(m.customerID);
            if (m.office != null && Object.hasOwnProperty.call(m, "office"))
                $root.contractpb.ScheduleFulfillment.Office.encode(m.office, w.uint32(82).fork()).ldelim();
            return w;
        };

        /**
         * Decodes a ScheduleFulfillment message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.ScheduleFulfillment
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.ScheduleFulfillment} ScheduleFulfillment
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ScheduleFulfillment.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.ScheduleFulfillment();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.formCode = r.string();
                    break;
                case 2:
                    m.fulfillmentTypeID = r.string();
                    break;
                case 3:
                    m.deliveryMethodID = r.string();
                    break;
                case 4:
                    m.dates = $root.contractpb.ScheduleFulfillment.Dates.decode(r, r.uint32());
                    break;
                case 5:
                    m.rejection = $root.contractpb.ScheduleFulfillment.Rejection.decode(r, r.uint32());
                    break;
                case 7:
                    m.productVersionID = r.string();
                    break;
                case 8:
                    m.propertyID = r.string();
                    break;
                case 9:
                    m.customerID = r.string();
                    break;
                case 10:
                    m.office = $root.contractpb.ScheduleFulfillment.Office.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        ScheduleFulfillment.Dates = (function() {

            /**
             * Properties of a Dates.
             * @memberof contractpb.ScheduleFulfillment
             * @interface IDates
             * @property {string|null} [scheduled] Dates scheduled
             * @property {string|null} [printed] Dates printed
             * @property {string|null} [effective] Dates effective
             */

            /**
             * Constructs a new Dates.
             * @memberof contractpb.ScheduleFulfillment
             * @classdesc Represents a Dates.
             * @implements IDates
             * @constructor
             * @param {contractpb.ScheduleFulfillment.IDates=} [p] Properties to set
             */
            function Dates(p) {
                if (p)
                    for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                        if (p[ks[i]] != null)
                            this[ks[i]] = p[ks[i]];
            }

            /**
             * Dates scheduled.
             * @member {string} scheduled
             * @memberof contractpb.ScheduleFulfillment.Dates
             * @instance
             */
            Dates.prototype.scheduled = "";

            /**
             * Dates printed.
             * @member {string} printed
             * @memberof contractpb.ScheduleFulfillment.Dates
             * @instance
             */
            Dates.prototype.printed = "";

            /**
             * Dates effective.
             * @member {string} effective
             * @memberof contractpb.ScheduleFulfillment.Dates
             * @instance
             */
            Dates.prototype.effective = "";

            /**
             * Creates a new Dates instance using the specified properties.
             * @function create
             * @memberof contractpb.ScheduleFulfillment.Dates
             * @static
             * @param {contractpb.ScheduleFulfillment.IDates=} [properties] Properties to set
             * @returns {contractpb.ScheduleFulfillment.Dates} Dates instance
             */
            Dates.create = function create(properties) {
                return new Dates(properties);
            };

            /**
             * Encodes the specified Dates message. Does not implicitly {@link contractpb.ScheduleFulfillment.Dates.verify|verify} messages.
             * @function encode
             * @memberof contractpb.ScheduleFulfillment.Dates
             * @static
             * @param {contractpb.ScheduleFulfillment.IDates} m Dates message or plain object to encode
             * @param {$protobuf.Writer} [w] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Dates.encode = function encode(m, w) {
                if (!w)
                    w = $Writer.create();
                if (m.scheduled != null && Object.hasOwnProperty.call(m, "scheduled"))
                    w.uint32(10).string(m.scheduled);
                if (m.printed != null && Object.hasOwnProperty.call(m, "printed"))
                    w.uint32(18).string(m.printed);
                if (m.effective != null && Object.hasOwnProperty.call(m, "effective"))
                    w.uint32(26).string(m.effective);
                return w;
            };

            /**
             * Decodes a Dates message from the specified reader or buffer.
             * @function decode
             * @memberof contractpb.ScheduleFulfillment.Dates
             * @static
             * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
             * @param {number} [l] Message length if known beforehand
             * @returns {contractpb.ScheduleFulfillment.Dates} Dates
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Dates.decode = function decode(r, l) {
                if (!(r instanceof $Reader))
                    r = $Reader.create(r);
                var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.ScheduleFulfillment.Dates();
                while (r.pos < c) {
                    var t = r.uint32();
                    switch (t >>> 3) {
                    case 1:
                        m.scheduled = r.string();
                        break;
                    case 2:
                        m.printed = r.string();
                        break;
                    case 3:
                        m.effective = r.string();
                        break;
                    default:
                        r.skipType(t & 7);
                        break;
                    }
                }
                return m;
            };

            return Dates;
        })();

        ScheduleFulfillment.Rejection = (function() {

            /**
             * Properties of a Rejection.
             * @memberof contractpb.ScheduleFulfillment
             * @interface IRejection
             * @property {google.protobuf.IBoolValue|null} [byUser] Rejection byUser
             * @property {string|null} [type] Rejection type
             */

            /**
             * Constructs a new Rejection.
             * @memberof contractpb.ScheduleFulfillment
             * @classdesc Represents a Rejection.
             * @implements IRejection
             * @constructor
             * @param {contractpb.ScheduleFulfillment.IRejection=} [p] Properties to set
             */
            function Rejection(p) {
                if (p)
                    for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                        if (p[ks[i]] != null)
                            this[ks[i]] = p[ks[i]];
            }

            /**
             * Rejection byUser.
             * @member {google.protobuf.IBoolValue|null|undefined} byUser
             * @memberof contractpb.ScheduleFulfillment.Rejection
             * @instance
             */
            Rejection.prototype.byUser = null;

            /**
             * Rejection type.
             * @member {string} type
             * @memberof contractpb.ScheduleFulfillment.Rejection
             * @instance
             */
            Rejection.prototype.type = "";

            /**
             * Creates a new Rejection instance using the specified properties.
             * @function create
             * @memberof contractpb.ScheduleFulfillment.Rejection
             * @static
             * @param {contractpb.ScheduleFulfillment.IRejection=} [properties] Properties to set
             * @returns {contractpb.ScheduleFulfillment.Rejection} Rejection instance
             */
            Rejection.create = function create(properties) {
                return new Rejection(properties);
            };

            /**
             * Encodes the specified Rejection message. Does not implicitly {@link contractpb.ScheduleFulfillment.Rejection.verify|verify} messages.
             * @function encode
             * @memberof contractpb.ScheduleFulfillment.Rejection
             * @static
             * @param {contractpb.ScheduleFulfillment.IRejection} m Rejection message or plain object to encode
             * @param {$protobuf.Writer} [w] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Rejection.encode = function encode(m, w) {
                if (!w)
                    w = $Writer.create();
                if (m.byUser != null && Object.hasOwnProperty.call(m, "byUser"))
                    $root.google.protobuf.BoolValue.encode(m.byUser, w.uint32(10).fork()).ldelim();
                if (m.type != null && Object.hasOwnProperty.call(m, "type"))
                    w.uint32(18).string(m.type);
                return w;
            };

            /**
             * Decodes a Rejection message from the specified reader or buffer.
             * @function decode
             * @memberof contractpb.ScheduleFulfillment.Rejection
             * @static
             * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
             * @param {number} [l] Message length if known beforehand
             * @returns {contractpb.ScheduleFulfillment.Rejection} Rejection
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Rejection.decode = function decode(r, l) {
                if (!(r instanceof $Reader))
                    r = $Reader.create(r);
                var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.ScheduleFulfillment.Rejection();
                while (r.pos < c) {
                    var t = r.uint32();
                    switch (t >>> 3) {
                    case 1:
                        m.byUser = $root.google.protobuf.BoolValue.decode(r, r.uint32());
                        break;
                    case 2:
                        m.type = r.string();
                        break;
                    default:
                        r.skipType(t & 7);
                        break;
                    }
                }
                return m;
            };

            return Rejection;
        })();

        ScheduleFulfillment.Office = (function() {

            /**
             * Properties of an Office.
             * @memberof contractpb.ScheduleFulfillment
             * @interface IOffice
             * @property {string|null} [ID] Office ID
             * @property {string|null} [type] Office type
             */

            /**
             * Constructs a new Office.
             * @memberof contractpb.ScheduleFulfillment
             * @classdesc Represents an Office.
             * @implements IOffice
             * @constructor
             * @param {contractpb.ScheduleFulfillment.IOffice=} [p] Properties to set
             */
            function Office(p) {
                if (p)
                    for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                        if (p[ks[i]] != null)
                            this[ks[i]] = p[ks[i]];
            }

            /**
             * Office ID.
             * @member {string} ID
             * @memberof contractpb.ScheduleFulfillment.Office
             * @instance
             */
            Office.prototype.ID = "";

            /**
             * Office type.
             * @member {string} type
             * @memberof contractpb.ScheduleFulfillment.Office
             * @instance
             */
            Office.prototype.type = "";

            /**
             * Creates a new Office instance using the specified properties.
             * @function create
             * @memberof contractpb.ScheduleFulfillment.Office
             * @static
             * @param {contractpb.ScheduleFulfillment.IOffice=} [properties] Properties to set
             * @returns {contractpb.ScheduleFulfillment.Office} Office instance
             */
            Office.create = function create(properties) {
                return new Office(properties);
            };

            /**
             * Encodes the specified Office message. Does not implicitly {@link contractpb.ScheduleFulfillment.Office.verify|verify} messages.
             * @function encode
             * @memberof contractpb.ScheduleFulfillment.Office
             * @static
             * @param {contractpb.ScheduleFulfillment.IOffice} m Office message or plain object to encode
             * @param {$protobuf.Writer} [w] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Office.encode = function encode(m, w) {
                if (!w)
                    w = $Writer.create();
                if (m.ID != null && Object.hasOwnProperty.call(m, "ID"))
                    w.uint32(10).string(m.ID);
                if (m.type != null && Object.hasOwnProperty.call(m, "type"))
                    w.uint32(18).string(m.type);
                return w;
            };

            /**
             * Decodes an Office message from the specified reader or buffer.
             * @function decode
             * @memberof contractpb.ScheduleFulfillment.Office
             * @static
             * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
             * @param {number} [l] Message length if known beforehand
             * @returns {contractpb.ScheduleFulfillment.Office} Office
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Office.decode = function decode(r, l) {
                if (!(r instanceof $Reader))
                    r = $Reader.create(r);
                var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.ScheduleFulfillment.Office();
                while (r.pos < c) {
                    var t = r.uint32();
                    switch (t >>> 3) {
                    case 1:
                        m.ID = r.string();
                        break;
                    case 2:
                        m.type = r.string();
                        break;
                    default:
                        r.skipType(t & 7);
                        break;
                    }
                }
                return m;
            };

            return Office;
        })();

        return ScheduleFulfillment;
    })();

    contractpb.CustomerDetail = (function() {

        /**
         * Properties of a CustomerDetail.
         * @memberof contractpb
         * @interface ICustomerDetail
         * @property {string|null} [customerID] CustomerDetail customerID
         * @property {string|null} [typeCode] CustomerDetail typeCode
         * @property {string|null} [typePrefix] CustomerDetail typePrefix
         * @property {Array.<contractpb.IPhone>|null} [phones] CustomerDetail phones
         * @property {string|null} [firstName] CustomerDetail firstName
         * @property {string|null} [lastName] CustomerDetail lastName
         * @property {string|null} [middleInitial] CustomerDetail middleInitial
         * @property {string|null} [email] CustomerDetail email
         * @property {boolean|null} [mailingPreference] CustomerDetail mailingPreference
         * @property {contractpb.IContractProperty|null} [mailingAddress] CustomerDetail mailingAddress
         */

        /**
         * Constructs a new CustomerDetail.
         * @memberof contractpb
         * @classdesc Represents a CustomerDetail.
         * @implements ICustomerDetail
         * @constructor
         * @param {contractpb.ICustomerDetail=} [p] Properties to set
         */
        function CustomerDetail(p) {
            this.phones = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * CustomerDetail customerID.
         * @member {string} customerID
         * @memberof contractpb.CustomerDetail
         * @instance
         */
        CustomerDetail.prototype.customerID = "";

        /**
         * CustomerDetail typeCode.
         * @member {string} typeCode
         * @memberof contractpb.CustomerDetail
         * @instance
         */
        CustomerDetail.prototype.typeCode = "";

        /**
         * CustomerDetail typePrefix.
         * @member {string} typePrefix
         * @memberof contractpb.CustomerDetail
         * @instance
         */
        CustomerDetail.prototype.typePrefix = "";

        /**
         * CustomerDetail phones.
         * @member {Array.<contractpb.IPhone>} phones
         * @memberof contractpb.CustomerDetail
         * @instance
         */
        CustomerDetail.prototype.phones = $util.emptyArray;

        /**
         * CustomerDetail firstName.
         * @member {string} firstName
         * @memberof contractpb.CustomerDetail
         * @instance
         */
        CustomerDetail.prototype.firstName = "";

        /**
         * CustomerDetail lastName.
         * @member {string} lastName
         * @memberof contractpb.CustomerDetail
         * @instance
         */
        CustomerDetail.prototype.lastName = "";

        /**
         * CustomerDetail middleInitial.
         * @member {string} middleInitial
         * @memberof contractpb.CustomerDetail
         * @instance
         */
        CustomerDetail.prototype.middleInitial = "";

        /**
         * CustomerDetail email.
         * @member {string} email
         * @memberof contractpb.CustomerDetail
         * @instance
         */
        CustomerDetail.prototype.email = "";

        /**
         * CustomerDetail mailingPreference.
         * @member {boolean} mailingPreference
         * @memberof contractpb.CustomerDetail
         * @instance
         */
        CustomerDetail.prototype.mailingPreference = false;

        /**
         * CustomerDetail mailingAddress.
         * @member {contractpb.IContractProperty|null|undefined} mailingAddress
         * @memberof contractpb.CustomerDetail
         * @instance
         */
        CustomerDetail.prototype.mailingAddress = null;

        /**
         * Creates a new CustomerDetail instance using the specified properties.
         * @function create
         * @memberof contractpb.CustomerDetail
         * @static
         * @param {contractpb.ICustomerDetail=} [properties] Properties to set
         * @returns {contractpb.CustomerDetail} CustomerDetail instance
         */
        CustomerDetail.create = function create(properties) {
            return new CustomerDetail(properties);
        };

        /**
         * Encodes the specified CustomerDetail message. Does not implicitly {@link contractpb.CustomerDetail.verify|verify} messages.
         * @function encode
         * @memberof contractpb.CustomerDetail
         * @static
         * @param {contractpb.ICustomerDetail} m CustomerDetail message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CustomerDetail.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.customerID != null && Object.hasOwnProperty.call(m, "customerID"))
                w.uint32(10).string(m.customerID);
            if (m.typeCode != null && Object.hasOwnProperty.call(m, "typeCode"))
                w.uint32(18).string(m.typeCode);
            if (m.typePrefix != null && Object.hasOwnProperty.call(m, "typePrefix"))
                w.uint32(26).string(m.typePrefix);
            if (m.phones != null && m.phones.length) {
                for (var i = 0; i < m.phones.length; ++i)
                    $root.contractpb.Phone.encode(m.phones[i], w.uint32(34).fork()).ldelim();
            }
            if (m.firstName != null && Object.hasOwnProperty.call(m, "firstName"))
                w.uint32(42).string(m.firstName);
            if (m.lastName != null && Object.hasOwnProperty.call(m, "lastName"))
                w.uint32(50).string(m.lastName);
            if (m.middleInitial != null && Object.hasOwnProperty.call(m, "middleInitial"))
                w.uint32(58).string(m.middleInitial);
            if (m.email != null && Object.hasOwnProperty.call(m, "email"))
                w.uint32(66).string(m.email);
            if (m.mailingPreference != null && Object.hasOwnProperty.call(m, "mailingPreference"))
                w.uint32(72).bool(m.mailingPreference);
            if (m.mailingAddress != null && Object.hasOwnProperty.call(m, "mailingAddress"))
                $root.contractpb.ContractProperty.encode(m.mailingAddress, w.uint32(82).fork()).ldelim();
            return w;
        };

        /**
         * Decodes a CustomerDetail message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.CustomerDetail
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.CustomerDetail} CustomerDetail
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CustomerDetail.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.CustomerDetail();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.customerID = r.string();
                    break;
                case 2:
                    m.typeCode = r.string();
                    break;
                case 3:
                    m.typePrefix = r.string();
                    break;
                case 4:
                    if (!(m.phones && m.phones.length))
                        m.phones = [];
                    m.phones.push($root.contractpb.Phone.decode(r, r.uint32()));
                    break;
                case 5:
                    m.firstName = r.string();
                    break;
                case 6:
                    m.lastName = r.string();
                    break;
                case 7:
                    m.middleInitial = r.string();
                    break;
                case 8:
                    m.email = r.string();
                    break;
                case 9:
                    m.mailingPreference = r.bool();
                    break;
                case 10:
                    m.mailingAddress = $root.contractpb.ContractProperty.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return CustomerDetail;
    })();

    contractpb.ContractDownloadResponse = (function() {

        /**
         * Properties of a ContractDownloadResponse.
         * @memberof contractpb
         * @interface IContractDownloadResponse
         * @property {string|null} [DownloadLink] ContractDownloadResponse DownloadLink
         */

        /**
         * Constructs a new ContractDownloadResponse.
         * @memberof contractpb
         * @classdesc Represents a ContractDownloadResponse.
         * @implements IContractDownloadResponse
         * @constructor
         * @param {contractpb.IContractDownloadResponse=} [p] Properties to set
         */
        function ContractDownloadResponse(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * ContractDownloadResponse DownloadLink.
         * @member {string} DownloadLink
         * @memberof contractpb.ContractDownloadResponse
         * @instance
         */
        ContractDownloadResponse.prototype.DownloadLink = "";

        /**
         * Creates a new ContractDownloadResponse instance using the specified properties.
         * @function create
         * @memberof contractpb.ContractDownloadResponse
         * @static
         * @param {contractpb.IContractDownloadResponse=} [properties] Properties to set
         * @returns {contractpb.ContractDownloadResponse} ContractDownloadResponse instance
         */
        ContractDownloadResponse.create = function create(properties) {
            return new ContractDownloadResponse(properties);
        };

        /**
         * Encodes the specified ContractDownloadResponse message. Does not implicitly {@link contractpb.ContractDownloadResponse.verify|verify} messages.
         * @function encode
         * @memberof contractpb.ContractDownloadResponse
         * @static
         * @param {contractpb.IContractDownloadResponse} m ContractDownloadResponse message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ContractDownloadResponse.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.DownloadLink != null && Object.hasOwnProperty.call(m, "DownloadLink"))
                w.uint32(10).string(m.DownloadLink);
            return w;
        };

        /**
         * Decodes a ContractDownloadResponse message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.ContractDownloadResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.ContractDownloadResponse} ContractDownloadResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ContractDownloadResponse.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.ContractDownloadResponse();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.DownloadLink = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return ContractDownloadResponse;
    })();

    contractpb.NextContractIDResponse = (function() {

        /**
         * Properties of a NextContractIDResponse.
         * @memberof contractpb
         * @interface INextContractIDResponse
         * @property {string|null} [contractID] NextContractIDResponse contractID
         */

        /**
         * Constructs a new NextContractIDResponse.
         * @memberof contractpb
         * @classdesc Represents a NextContractIDResponse.
         * @implements INextContractIDResponse
         * @constructor
         * @param {contractpb.INextContractIDResponse=} [p] Properties to set
         */
        function NextContractIDResponse(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * NextContractIDResponse contractID.
         * @member {string} contractID
         * @memberof contractpb.NextContractIDResponse
         * @instance
         */
        NextContractIDResponse.prototype.contractID = "";

        /**
         * Creates a new NextContractIDResponse instance using the specified properties.
         * @function create
         * @memberof contractpb.NextContractIDResponse
         * @static
         * @param {contractpb.INextContractIDResponse=} [properties] Properties to set
         * @returns {contractpb.NextContractIDResponse} NextContractIDResponse instance
         */
        NextContractIDResponse.create = function create(properties) {
            return new NextContractIDResponse(properties);
        };

        /**
         * Encodes the specified NextContractIDResponse message. Does not implicitly {@link contractpb.NextContractIDResponse.verify|verify} messages.
         * @function encode
         * @memberof contractpb.NextContractIDResponse
         * @static
         * @param {contractpb.INextContractIDResponse} m NextContractIDResponse message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        NextContractIDResponse.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.contractID != null && Object.hasOwnProperty.call(m, "contractID"))
                w.uint32(10).string(m.contractID);
            return w;
        };

        /**
         * Decodes a NextContractIDResponse message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.NextContractIDResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.NextContractIDResponse} NextContractIDResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        NextContractIDResponse.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.NextContractIDResponse();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.contractID = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return NextContractIDResponse;
    })();

    contractpb.CustomerDetailsByEmailID = (function() {

        /**
         * Properties of a CustomerDetailsByEmailID.
         * @memberof contractpb
         * @interface ICustomerDetailsByEmailID
         * @property {Array.<contractpb.ICustomerDetailByEmailID>|null} [details] CustomerDetailsByEmailID details
         */

        /**
         * Constructs a new CustomerDetailsByEmailID.
         * @memberof contractpb
         * @classdesc Represents a CustomerDetailsByEmailID.
         * @implements ICustomerDetailsByEmailID
         * @constructor
         * @param {contractpb.ICustomerDetailsByEmailID=} [p] Properties to set
         */
        function CustomerDetailsByEmailID(p) {
            this.details = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * CustomerDetailsByEmailID details.
         * @member {Array.<contractpb.ICustomerDetailByEmailID>} details
         * @memberof contractpb.CustomerDetailsByEmailID
         * @instance
         */
        CustomerDetailsByEmailID.prototype.details = $util.emptyArray;

        /**
         * Creates a new CustomerDetailsByEmailID instance using the specified properties.
         * @function create
         * @memberof contractpb.CustomerDetailsByEmailID
         * @static
         * @param {contractpb.ICustomerDetailsByEmailID=} [properties] Properties to set
         * @returns {contractpb.CustomerDetailsByEmailID} CustomerDetailsByEmailID instance
         */
        CustomerDetailsByEmailID.create = function create(properties) {
            return new CustomerDetailsByEmailID(properties);
        };

        /**
         * Encodes the specified CustomerDetailsByEmailID message. Does not implicitly {@link contractpb.CustomerDetailsByEmailID.verify|verify} messages.
         * @function encode
         * @memberof contractpb.CustomerDetailsByEmailID
         * @static
         * @param {contractpb.ICustomerDetailsByEmailID} m CustomerDetailsByEmailID message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CustomerDetailsByEmailID.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.details != null && m.details.length) {
                for (var i = 0; i < m.details.length; ++i)
                    $root.contractpb.CustomerDetailByEmailID.encode(m.details[i], w.uint32(10).fork()).ldelim();
            }
            return w;
        };

        /**
         * Decodes a CustomerDetailsByEmailID message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.CustomerDetailsByEmailID
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.CustomerDetailsByEmailID} CustomerDetailsByEmailID
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CustomerDetailsByEmailID.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.CustomerDetailsByEmailID();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    if (!(m.details && m.details.length))
                        m.details = [];
                    m.details.push($root.contractpb.CustomerDetailByEmailID.decode(r, r.uint32()));
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return CustomerDetailsByEmailID;
    })();

    contractpb.CustomerDetailByEmailID = (function() {

        /**
         * Properties of a CustomerDetailByEmailID.
         * @memberof contractpb
         * @interface ICustomerDetailByEmailID
         * @property {string|null} [streetNumber] CustomerDetailByEmailID streetNumber
         * @property {string|null} [streetDirection] CustomerDetailByEmailID streetDirection
         * @property {string|null} [streetName] CustomerDetailByEmailID streetName
         * @property {string|null} [cityName] CustomerDetailByEmailID cityName
         * @property {string|null} [state] CustomerDetailByEmailID state
         * @property {string|null} [zipCode] CustomerDetailByEmailID zipCode
         */

        /**
         * Constructs a new CustomerDetailByEmailID.
         * @memberof contractpb
         * @classdesc Represents a CustomerDetailByEmailID.
         * @implements ICustomerDetailByEmailID
         * @constructor
         * @param {contractpb.ICustomerDetailByEmailID=} [p] Properties to set
         */
        function CustomerDetailByEmailID(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * CustomerDetailByEmailID streetNumber.
         * @member {string} streetNumber
         * @memberof contractpb.CustomerDetailByEmailID
         * @instance
         */
        CustomerDetailByEmailID.prototype.streetNumber = "";

        /**
         * CustomerDetailByEmailID streetDirection.
         * @member {string} streetDirection
         * @memberof contractpb.CustomerDetailByEmailID
         * @instance
         */
        CustomerDetailByEmailID.prototype.streetDirection = "";

        /**
         * CustomerDetailByEmailID streetName.
         * @member {string} streetName
         * @memberof contractpb.CustomerDetailByEmailID
         * @instance
         */
        CustomerDetailByEmailID.prototype.streetName = "";

        /**
         * CustomerDetailByEmailID cityName.
         * @member {string} cityName
         * @memberof contractpb.CustomerDetailByEmailID
         * @instance
         */
        CustomerDetailByEmailID.prototype.cityName = "";

        /**
         * CustomerDetailByEmailID state.
         * @member {string} state
         * @memberof contractpb.CustomerDetailByEmailID
         * @instance
         */
        CustomerDetailByEmailID.prototype.state = "";

        /**
         * CustomerDetailByEmailID zipCode.
         * @member {string} zipCode
         * @memberof contractpb.CustomerDetailByEmailID
         * @instance
         */
        CustomerDetailByEmailID.prototype.zipCode = "";

        /**
         * Creates a new CustomerDetailByEmailID instance using the specified properties.
         * @function create
         * @memberof contractpb.CustomerDetailByEmailID
         * @static
         * @param {contractpb.ICustomerDetailByEmailID=} [properties] Properties to set
         * @returns {contractpb.CustomerDetailByEmailID} CustomerDetailByEmailID instance
         */
        CustomerDetailByEmailID.create = function create(properties) {
            return new CustomerDetailByEmailID(properties);
        };

        /**
         * Encodes the specified CustomerDetailByEmailID message. Does not implicitly {@link contractpb.CustomerDetailByEmailID.verify|verify} messages.
         * @function encode
         * @memberof contractpb.CustomerDetailByEmailID
         * @static
         * @param {contractpb.ICustomerDetailByEmailID} m CustomerDetailByEmailID message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CustomerDetailByEmailID.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.streetNumber != null && Object.hasOwnProperty.call(m, "streetNumber"))
                w.uint32(10).string(m.streetNumber);
            if (m.streetDirection != null && Object.hasOwnProperty.call(m, "streetDirection"))
                w.uint32(18).string(m.streetDirection);
            if (m.streetName != null && Object.hasOwnProperty.call(m, "streetName"))
                w.uint32(26).string(m.streetName);
            if (m.cityName != null && Object.hasOwnProperty.call(m, "cityName"))
                w.uint32(34).string(m.cityName);
            if (m.state != null && Object.hasOwnProperty.call(m, "state"))
                w.uint32(42).string(m.state);
            if (m.zipCode != null && Object.hasOwnProperty.call(m, "zipCode"))
                w.uint32(50).string(m.zipCode);
            return w;
        };

        /**
         * Decodes a CustomerDetailByEmailID message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.CustomerDetailByEmailID
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.CustomerDetailByEmailID} CustomerDetailByEmailID
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CustomerDetailByEmailID.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.CustomerDetailByEmailID();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.streetNumber = r.string();
                    break;
                case 2:
                    m.streetDirection = r.string();
                    break;
                case 3:
                    m.streetName = r.string();
                    break;
                case 4:
                    m.cityName = r.string();
                    break;
                case 5:
                    m.state = r.string();
                    break;
                case 6:
                    m.zipCode = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return CustomerDetailByEmailID;
    })();

    contractpb.CustomerDetailsByProperty = (function() {

        /**
         * Properties of a CustomerDetailsByProperty.
         * @memberof contractpb
         * @interface ICustomerDetailsByProperty
         * @property {Array.<contractpb.ICustomerDetailByProperty>|null} [details] CustomerDetailsByProperty details
         */

        /**
         * Constructs a new CustomerDetailsByProperty.
         * @memberof contractpb
         * @classdesc Represents a CustomerDetailsByProperty.
         * @implements ICustomerDetailsByProperty
         * @constructor
         * @param {contractpb.ICustomerDetailsByProperty=} [p] Properties to set
         */
        function CustomerDetailsByProperty(p) {
            this.details = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * CustomerDetailsByProperty details.
         * @member {Array.<contractpb.ICustomerDetailByProperty>} details
         * @memberof contractpb.CustomerDetailsByProperty
         * @instance
         */
        CustomerDetailsByProperty.prototype.details = $util.emptyArray;

        /**
         * Creates a new CustomerDetailsByProperty instance using the specified properties.
         * @function create
         * @memberof contractpb.CustomerDetailsByProperty
         * @static
         * @param {contractpb.ICustomerDetailsByProperty=} [properties] Properties to set
         * @returns {contractpb.CustomerDetailsByProperty} CustomerDetailsByProperty instance
         */
        CustomerDetailsByProperty.create = function create(properties) {
            return new CustomerDetailsByProperty(properties);
        };

        /**
         * Encodes the specified CustomerDetailsByProperty message. Does not implicitly {@link contractpb.CustomerDetailsByProperty.verify|verify} messages.
         * @function encode
         * @memberof contractpb.CustomerDetailsByProperty
         * @static
         * @param {contractpb.ICustomerDetailsByProperty} m CustomerDetailsByProperty message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CustomerDetailsByProperty.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.details != null && m.details.length) {
                for (var i = 0; i < m.details.length; ++i)
                    $root.contractpb.CustomerDetailByProperty.encode(m.details[i], w.uint32(10).fork()).ldelim();
            }
            return w;
        };

        /**
         * Decodes a CustomerDetailsByProperty message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.CustomerDetailsByProperty
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.CustomerDetailsByProperty} CustomerDetailsByProperty
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CustomerDetailsByProperty.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.CustomerDetailsByProperty();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    if (!(m.details && m.details.length))
                        m.details = [];
                    m.details.push($root.contractpb.CustomerDetailByProperty.decode(r, r.uint32()));
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return CustomerDetailsByProperty;
    })();

    contractpb.CustomerDetailByProperty = (function() {

        /**
         * Properties of a CustomerDetailByProperty.
         * @memberof contractpb
         * @interface ICustomerDetailByProperty
         * @property {string|null} [streetNumber] CustomerDetailByProperty streetNumber
         * @property {string|null} [streetDirection] CustomerDetailByProperty streetDirection
         * @property {string|null} [streetName] CustomerDetailByProperty streetName
         * @property {string|null} [unitNumber] CustomerDetailByProperty unitNumber
         * @property {string|null} [cityName] CustomerDetailByProperty cityName
         * @property {string|null} [state] CustomerDetailByProperty state
         * @property {string|null} [zipCode] CustomerDetailByProperty zipCode
         * @property {string|null} [contractID] CustomerDetailByProperty contractID
         * @property {google.protobuf.ITimestamp|null} [expirationDate] CustomerDetailByProperty expirationDate
         */

        /**
         * Constructs a new CustomerDetailByProperty.
         * @memberof contractpb
         * @classdesc Represents a CustomerDetailByProperty.
         * @implements ICustomerDetailByProperty
         * @constructor
         * @param {contractpb.ICustomerDetailByProperty=} [p] Properties to set
         */
        function CustomerDetailByProperty(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * CustomerDetailByProperty streetNumber.
         * @member {string} streetNumber
         * @memberof contractpb.CustomerDetailByProperty
         * @instance
         */
        CustomerDetailByProperty.prototype.streetNumber = "";

        /**
         * CustomerDetailByProperty streetDirection.
         * @member {string} streetDirection
         * @memberof contractpb.CustomerDetailByProperty
         * @instance
         */
        CustomerDetailByProperty.prototype.streetDirection = "";

        /**
         * CustomerDetailByProperty streetName.
         * @member {string} streetName
         * @memberof contractpb.CustomerDetailByProperty
         * @instance
         */
        CustomerDetailByProperty.prototype.streetName = "";

        /**
         * CustomerDetailByProperty unitNumber.
         * @member {string} unitNumber
         * @memberof contractpb.CustomerDetailByProperty
         * @instance
         */
        CustomerDetailByProperty.prototype.unitNumber = "";

        /**
         * CustomerDetailByProperty cityName.
         * @member {string} cityName
         * @memberof contractpb.CustomerDetailByProperty
         * @instance
         */
        CustomerDetailByProperty.prototype.cityName = "";

        /**
         * CustomerDetailByProperty state.
         * @member {string} state
         * @memberof contractpb.CustomerDetailByProperty
         * @instance
         */
        CustomerDetailByProperty.prototype.state = "";

        /**
         * CustomerDetailByProperty zipCode.
         * @member {string} zipCode
         * @memberof contractpb.CustomerDetailByProperty
         * @instance
         */
        CustomerDetailByProperty.prototype.zipCode = "";

        /**
         * CustomerDetailByProperty contractID.
         * @member {string} contractID
         * @memberof contractpb.CustomerDetailByProperty
         * @instance
         */
        CustomerDetailByProperty.prototype.contractID = "";

        /**
         * CustomerDetailByProperty expirationDate.
         * @member {google.protobuf.ITimestamp|null|undefined} expirationDate
         * @memberof contractpb.CustomerDetailByProperty
         * @instance
         */
        CustomerDetailByProperty.prototype.expirationDate = null;

        /**
         * Creates a new CustomerDetailByProperty instance using the specified properties.
         * @function create
         * @memberof contractpb.CustomerDetailByProperty
         * @static
         * @param {contractpb.ICustomerDetailByProperty=} [properties] Properties to set
         * @returns {contractpb.CustomerDetailByProperty} CustomerDetailByProperty instance
         */
        CustomerDetailByProperty.create = function create(properties) {
            return new CustomerDetailByProperty(properties);
        };

        /**
         * Encodes the specified CustomerDetailByProperty message. Does not implicitly {@link contractpb.CustomerDetailByProperty.verify|verify} messages.
         * @function encode
         * @memberof contractpb.CustomerDetailByProperty
         * @static
         * @param {contractpb.ICustomerDetailByProperty} m CustomerDetailByProperty message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CustomerDetailByProperty.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.streetNumber != null && Object.hasOwnProperty.call(m, "streetNumber"))
                w.uint32(10).string(m.streetNumber);
            if (m.streetDirection != null && Object.hasOwnProperty.call(m, "streetDirection"))
                w.uint32(18).string(m.streetDirection);
            if (m.streetName != null && Object.hasOwnProperty.call(m, "streetName"))
                w.uint32(26).string(m.streetName);
            if (m.unitNumber != null && Object.hasOwnProperty.call(m, "unitNumber"))
                w.uint32(34).string(m.unitNumber);
            if (m.cityName != null && Object.hasOwnProperty.call(m, "cityName"))
                w.uint32(42).string(m.cityName);
            if (m.state != null && Object.hasOwnProperty.call(m, "state"))
                w.uint32(50).string(m.state);
            if (m.zipCode != null && Object.hasOwnProperty.call(m, "zipCode"))
                w.uint32(58).string(m.zipCode);
            if (m.contractID != null && Object.hasOwnProperty.call(m, "contractID"))
                w.uint32(66).string(m.contractID);
            if (m.expirationDate != null && Object.hasOwnProperty.call(m, "expirationDate"))
                $root.google.protobuf.Timestamp.encode(m.expirationDate, w.uint32(74).fork()).ldelim();
            return w;
        };

        /**
         * Decodes a CustomerDetailByProperty message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.CustomerDetailByProperty
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.CustomerDetailByProperty} CustomerDetailByProperty
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CustomerDetailByProperty.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.CustomerDetailByProperty();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.streetNumber = r.string();
                    break;
                case 2:
                    m.streetDirection = r.string();
                    break;
                case 3:
                    m.streetName = r.string();
                    break;
                case 4:
                    m.unitNumber = r.string();
                    break;
                case 5:
                    m.cityName = r.string();
                    break;
                case 6:
                    m.state = r.string();
                    break;
                case 7:
                    m.zipCode = r.string();
                    break;
                case 8:
                    m.contractID = r.string();
                    break;
                case 9:
                    m.expirationDate = $root.google.protobuf.Timestamp.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return CustomerDetailByProperty;
    })();

    contractpb.ContractCampaign = (function() {

        /**
         * Properties of a ContractCampaign.
         * @memberof contractpb
         * @interface IContractCampaign
         * @property {string|null} [promoCode] ContractCampaign promoCode
         * @property {string|null} [lastModifiedBy] ContractCampaign lastModifiedBy
         */

        /**
         * Constructs a new ContractCampaign.
         * @memberof contractpb
         * @classdesc Represents a ContractCampaign.
         * @implements IContractCampaign
         * @constructor
         * @param {contractpb.IContractCampaign=} [p] Properties to set
         */
        function ContractCampaign(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * ContractCampaign promoCode.
         * @member {string} promoCode
         * @memberof contractpb.ContractCampaign
         * @instance
         */
        ContractCampaign.prototype.promoCode = "";

        /**
         * ContractCampaign lastModifiedBy.
         * @member {string} lastModifiedBy
         * @memberof contractpb.ContractCampaign
         * @instance
         */
        ContractCampaign.prototype.lastModifiedBy = "";

        /**
         * Creates a new ContractCampaign instance using the specified properties.
         * @function create
         * @memberof contractpb.ContractCampaign
         * @static
         * @param {contractpb.IContractCampaign=} [properties] Properties to set
         * @returns {contractpb.ContractCampaign} ContractCampaign instance
         */
        ContractCampaign.create = function create(properties) {
            return new ContractCampaign(properties);
        };

        /**
         * Encodes the specified ContractCampaign message. Does not implicitly {@link contractpb.ContractCampaign.verify|verify} messages.
         * @function encode
         * @memberof contractpb.ContractCampaign
         * @static
         * @param {contractpb.IContractCampaign} m ContractCampaign message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ContractCampaign.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.promoCode != null && Object.hasOwnProperty.call(m, "promoCode"))
                w.uint32(10).string(m.promoCode);
            if (m.lastModifiedBy != null && Object.hasOwnProperty.call(m, "lastModifiedBy"))
                w.uint32(18).string(m.lastModifiedBy);
            return w;
        };

        /**
         * Decodes a ContractCampaign message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.ContractCampaign
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.ContractCampaign} ContractCampaign
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ContractCampaign.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.ContractCampaign();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.promoCode = r.string();
                    break;
                case 2:
                    m.lastModifiedBy = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return ContractCampaign;
    })();

    contractpb.GetContractCampaignResponse = (function() {

        /**
         * Properties of a GetContractCampaignResponse.
         * @memberof contractpb
         * @interface IGetContractCampaignResponse
         * @property {string|null} [contractID] GetContractCampaignResponse contractID
         * @property {Array.<contractpb.IContractCampaign>|null} [contractCampaigns] GetContractCampaignResponse contractCampaigns
         */

        /**
         * Constructs a new GetContractCampaignResponse.
         * @memberof contractpb
         * @classdesc Represents a GetContractCampaignResponse.
         * @implements IGetContractCampaignResponse
         * @constructor
         * @param {contractpb.IGetContractCampaignResponse=} [p] Properties to set
         */
        function GetContractCampaignResponse(p) {
            this.contractCampaigns = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * GetContractCampaignResponse contractID.
         * @member {string} contractID
         * @memberof contractpb.GetContractCampaignResponse
         * @instance
         */
        GetContractCampaignResponse.prototype.contractID = "";

        /**
         * GetContractCampaignResponse contractCampaigns.
         * @member {Array.<contractpb.IContractCampaign>} contractCampaigns
         * @memberof contractpb.GetContractCampaignResponse
         * @instance
         */
        GetContractCampaignResponse.prototype.contractCampaigns = $util.emptyArray;

        /**
         * Creates a new GetContractCampaignResponse instance using the specified properties.
         * @function create
         * @memberof contractpb.GetContractCampaignResponse
         * @static
         * @param {contractpb.IGetContractCampaignResponse=} [properties] Properties to set
         * @returns {contractpb.GetContractCampaignResponse} GetContractCampaignResponse instance
         */
        GetContractCampaignResponse.create = function create(properties) {
            return new GetContractCampaignResponse(properties);
        };

        /**
         * Encodes the specified GetContractCampaignResponse message. Does not implicitly {@link contractpb.GetContractCampaignResponse.verify|verify} messages.
         * @function encode
         * @memberof contractpb.GetContractCampaignResponse
         * @static
         * @param {contractpb.IGetContractCampaignResponse} m GetContractCampaignResponse message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetContractCampaignResponse.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.contractID != null && Object.hasOwnProperty.call(m, "contractID"))
                w.uint32(10).string(m.contractID);
            if (m.contractCampaigns != null && m.contractCampaigns.length) {
                for (var i = 0; i < m.contractCampaigns.length; ++i)
                    $root.contractpb.ContractCampaign.encode(m.contractCampaigns[i], w.uint32(18).fork()).ldelim();
            }
            return w;
        };

        /**
         * Decodes a GetContractCampaignResponse message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.GetContractCampaignResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.GetContractCampaignResponse} GetContractCampaignResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetContractCampaignResponse.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.GetContractCampaignResponse();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.contractID = r.string();
                    break;
                case 2:
                    if (!(m.contractCampaigns && m.contractCampaigns.length))
                        m.contractCampaigns = [];
                    m.contractCampaigns.push($root.contractpb.ContractCampaign.decode(r, r.uint32()));
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return GetContractCampaignResponse;
    })();

    contractpb.CreateContractCampaignRequest = (function() {

        /**
         * Properties of a CreateContractCampaignRequest.
         * @memberof contractpb
         * @interface ICreateContractCampaignRequest
         * @property {string|null} [contractID] CreateContractCampaignRequest contractID
         * @property {string|null} [promoCode] CreateContractCampaignRequest promoCode
         * @property {string|null} [userName] CreateContractCampaignRequest userName
         */

        /**
         * Constructs a new CreateContractCampaignRequest.
         * @memberof contractpb
         * @classdesc Represents a CreateContractCampaignRequest.
         * @implements ICreateContractCampaignRequest
         * @constructor
         * @param {contractpb.ICreateContractCampaignRequest=} [p] Properties to set
         */
        function CreateContractCampaignRequest(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * CreateContractCampaignRequest contractID.
         * @member {string} contractID
         * @memberof contractpb.CreateContractCampaignRequest
         * @instance
         */
        CreateContractCampaignRequest.prototype.contractID = "";

        /**
         * CreateContractCampaignRequest promoCode.
         * @member {string} promoCode
         * @memberof contractpb.CreateContractCampaignRequest
         * @instance
         */
        CreateContractCampaignRequest.prototype.promoCode = "";

        /**
         * CreateContractCampaignRequest userName.
         * @member {string} userName
         * @memberof contractpb.CreateContractCampaignRequest
         * @instance
         */
        CreateContractCampaignRequest.prototype.userName = "";

        /**
         * Creates a new CreateContractCampaignRequest instance using the specified properties.
         * @function create
         * @memberof contractpb.CreateContractCampaignRequest
         * @static
         * @param {contractpb.ICreateContractCampaignRequest=} [properties] Properties to set
         * @returns {contractpb.CreateContractCampaignRequest} CreateContractCampaignRequest instance
         */
        CreateContractCampaignRequest.create = function create(properties) {
            return new CreateContractCampaignRequest(properties);
        };

        /**
         * Encodes the specified CreateContractCampaignRequest message. Does not implicitly {@link contractpb.CreateContractCampaignRequest.verify|verify} messages.
         * @function encode
         * @memberof contractpb.CreateContractCampaignRequest
         * @static
         * @param {contractpb.ICreateContractCampaignRequest} m CreateContractCampaignRequest message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CreateContractCampaignRequest.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.contractID != null && Object.hasOwnProperty.call(m, "contractID"))
                w.uint32(10).string(m.contractID);
            if (m.promoCode != null && Object.hasOwnProperty.call(m, "promoCode"))
                w.uint32(18).string(m.promoCode);
            if (m.userName != null && Object.hasOwnProperty.call(m, "userName"))
                w.uint32(26).string(m.userName);
            return w;
        };

        /**
         * Decodes a CreateContractCampaignRequest message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.CreateContractCampaignRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.CreateContractCampaignRequest} CreateContractCampaignRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CreateContractCampaignRequest.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.CreateContractCampaignRequest();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.contractID = r.string();
                    break;
                case 2:
                    m.promoCode = r.string();
                    break;
                case 3:
                    m.userName = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return CreateContractCampaignRequest;
    })();

    contractpb.CreateContractCampaignResponse = (function() {

        /**
         * Properties of a CreateContractCampaignResponse.
         * @memberof contractpb
         * @interface ICreateContractCampaignResponse
         * @property {string|null} [result] CreateContractCampaignResponse result
         */

        /**
         * Constructs a new CreateContractCampaignResponse.
         * @memberof contractpb
         * @classdesc Represents a CreateContractCampaignResponse.
         * @implements ICreateContractCampaignResponse
         * @constructor
         * @param {contractpb.ICreateContractCampaignResponse=} [p] Properties to set
         */
        function CreateContractCampaignResponse(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * CreateContractCampaignResponse result.
         * @member {string} result
         * @memberof contractpb.CreateContractCampaignResponse
         * @instance
         */
        CreateContractCampaignResponse.prototype.result = "";

        /**
         * Creates a new CreateContractCampaignResponse instance using the specified properties.
         * @function create
         * @memberof contractpb.CreateContractCampaignResponse
         * @static
         * @param {contractpb.ICreateContractCampaignResponse=} [properties] Properties to set
         * @returns {contractpb.CreateContractCampaignResponse} CreateContractCampaignResponse instance
         */
        CreateContractCampaignResponse.create = function create(properties) {
            return new CreateContractCampaignResponse(properties);
        };

        /**
         * Encodes the specified CreateContractCampaignResponse message. Does not implicitly {@link contractpb.CreateContractCampaignResponse.verify|verify} messages.
         * @function encode
         * @memberof contractpb.CreateContractCampaignResponse
         * @static
         * @param {contractpb.ICreateContractCampaignResponse} m CreateContractCampaignResponse message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CreateContractCampaignResponse.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.result != null && Object.hasOwnProperty.call(m, "result"))
                w.uint32(10).string(m.result);
            return w;
        };

        /**
         * Decodes a CreateContractCampaignResponse message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.CreateContractCampaignResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.CreateContractCampaignResponse} CreateContractCampaignResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CreateContractCampaignResponse.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.CreateContractCampaignResponse();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.result = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return CreateContractCampaignResponse;
    })();

    contractpb.GetContractPropertiesResponse = (function() {

        /**
         * Properties of a GetContractPropertiesResponse.
         * @memberof contractpb
         * @interface IGetContractPropertiesResponse
         * @property {Array.<contractpb.GetContractPropertiesResponse.IContractPropertyWithContractID>|null} [properties] GetContractPropertiesResponse properties
         */

        /**
         * Constructs a new GetContractPropertiesResponse.
         * @memberof contractpb
         * @classdesc Represents a GetContractPropertiesResponse.
         * @implements IGetContractPropertiesResponse
         * @constructor
         * @param {contractpb.IGetContractPropertiesResponse=} [p] Properties to set
         */
        function GetContractPropertiesResponse(p) {
            this.properties = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * GetContractPropertiesResponse properties.
         * @member {Array.<contractpb.GetContractPropertiesResponse.IContractPropertyWithContractID>} properties
         * @memberof contractpb.GetContractPropertiesResponse
         * @instance
         */
        GetContractPropertiesResponse.prototype.properties = $util.emptyArray;

        /**
         * Creates a new GetContractPropertiesResponse instance using the specified properties.
         * @function create
         * @memberof contractpb.GetContractPropertiesResponse
         * @static
         * @param {contractpb.IGetContractPropertiesResponse=} [properties] Properties to set
         * @returns {contractpb.GetContractPropertiesResponse} GetContractPropertiesResponse instance
         */
        GetContractPropertiesResponse.create = function create(properties) {
            return new GetContractPropertiesResponse(properties);
        };

        /**
         * Encodes the specified GetContractPropertiesResponse message. Does not implicitly {@link contractpb.GetContractPropertiesResponse.verify|verify} messages.
         * @function encode
         * @memberof contractpb.GetContractPropertiesResponse
         * @static
         * @param {contractpb.IGetContractPropertiesResponse} m GetContractPropertiesResponse message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetContractPropertiesResponse.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.properties != null && m.properties.length) {
                for (var i = 0; i < m.properties.length; ++i)
                    $root.contractpb.GetContractPropertiesResponse.ContractPropertyWithContractID.encode(m.properties[i], w.uint32(10).fork()).ldelim();
            }
            return w;
        };

        /**
         * Decodes a GetContractPropertiesResponse message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.GetContractPropertiesResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.GetContractPropertiesResponse} GetContractPropertiesResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetContractPropertiesResponse.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.GetContractPropertiesResponse();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    if (!(m.properties && m.properties.length))
                        m.properties = [];
                    m.properties.push($root.contractpb.GetContractPropertiesResponse.ContractPropertyWithContractID.decode(r, r.uint32()));
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        GetContractPropertiesResponse.ContractPropertyWithContractID = (function() {

            /**
             * Properties of a ContractPropertyWithContractID.
             * @memberof contractpb.GetContractPropertiesResponse
             * @interface IContractPropertyWithContractID
             * @property {string|null} [contractID] ContractPropertyWithContractID contractID
             * @property {contractpb.IContractProperty|null} [property] ContractPropertyWithContractID property
             */

            /**
             * Constructs a new ContractPropertyWithContractID.
             * @memberof contractpb.GetContractPropertiesResponse
             * @classdesc Represents a ContractPropertyWithContractID.
             * @implements IContractPropertyWithContractID
             * @constructor
             * @param {contractpb.GetContractPropertiesResponse.IContractPropertyWithContractID=} [p] Properties to set
             */
            function ContractPropertyWithContractID(p) {
                if (p)
                    for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                        if (p[ks[i]] != null)
                            this[ks[i]] = p[ks[i]];
            }

            /**
             * ContractPropertyWithContractID contractID.
             * @member {string} contractID
             * @memberof contractpb.GetContractPropertiesResponse.ContractPropertyWithContractID
             * @instance
             */
            ContractPropertyWithContractID.prototype.contractID = "";

            /**
             * ContractPropertyWithContractID property.
             * @member {contractpb.IContractProperty|null|undefined} property
             * @memberof contractpb.GetContractPropertiesResponse.ContractPropertyWithContractID
             * @instance
             */
            ContractPropertyWithContractID.prototype.property = null;

            /**
             * Creates a new ContractPropertyWithContractID instance using the specified properties.
             * @function create
             * @memberof contractpb.GetContractPropertiesResponse.ContractPropertyWithContractID
             * @static
             * @param {contractpb.GetContractPropertiesResponse.IContractPropertyWithContractID=} [properties] Properties to set
             * @returns {contractpb.GetContractPropertiesResponse.ContractPropertyWithContractID} ContractPropertyWithContractID instance
             */
            ContractPropertyWithContractID.create = function create(properties) {
                return new ContractPropertyWithContractID(properties);
            };

            /**
             * Encodes the specified ContractPropertyWithContractID message. Does not implicitly {@link contractpb.GetContractPropertiesResponse.ContractPropertyWithContractID.verify|verify} messages.
             * @function encode
             * @memberof contractpb.GetContractPropertiesResponse.ContractPropertyWithContractID
             * @static
             * @param {contractpb.GetContractPropertiesResponse.IContractPropertyWithContractID} m ContractPropertyWithContractID message or plain object to encode
             * @param {$protobuf.Writer} [w] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ContractPropertyWithContractID.encode = function encode(m, w) {
                if (!w)
                    w = $Writer.create();
                if (m.contractID != null && Object.hasOwnProperty.call(m, "contractID"))
                    w.uint32(10).string(m.contractID);
                if (m.property != null && Object.hasOwnProperty.call(m, "property"))
                    $root.contractpb.ContractProperty.encode(m.property, w.uint32(18).fork()).ldelim();
                return w;
            };

            /**
             * Decodes a ContractPropertyWithContractID message from the specified reader or buffer.
             * @function decode
             * @memberof contractpb.GetContractPropertiesResponse.ContractPropertyWithContractID
             * @static
             * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
             * @param {number} [l] Message length if known beforehand
             * @returns {contractpb.GetContractPropertiesResponse.ContractPropertyWithContractID} ContractPropertyWithContractID
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ContractPropertyWithContractID.decode = function decode(r, l) {
                if (!(r instanceof $Reader))
                    r = $Reader.create(r);
                var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.GetContractPropertiesResponse.ContractPropertyWithContractID();
                while (r.pos < c) {
                    var t = r.uint32();
                    switch (t >>> 3) {
                    case 1:
                        m.contractID = r.string();
                        break;
                    case 2:
                        m.property = $root.contractpb.ContractProperty.decode(r, r.uint32());
                        break;
                    default:
                        r.skipType(t & 7);
                        break;
                    }
                }
                return m;
            };

            return ContractPropertyWithContractID;
        })();

        return GetContractPropertiesResponse;
    })();

    contractpb.UpdateContractProperty = (function() {

        /**
         * Properties of an UpdateContractProperty.
         * @memberof contractpb
         * @interface IUpdateContractProperty
         * @property {string|null} [dwellingType] UpdateContractProperty dwellingType
         * @property {number|null} [squareFeet] UpdateContractProperty squareFeet
         * @property {string|null} [yearBuilt] UpdateContractProperty yearBuilt
         * @property {string|null} [mlsNumber] UpdateContractProperty mlsNumber
         * @property {string|null} [userId] UpdateContractProperty userId
         */

        /**
         * Constructs a new UpdateContractProperty.
         * @memberof contractpb
         * @classdesc Represents an UpdateContractProperty.
         * @implements IUpdateContractProperty
         * @constructor
         * @param {contractpb.IUpdateContractProperty=} [p] Properties to set
         */
        function UpdateContractProperty(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * UpdateContractProperty dwellingType.
         * @member {string} dwellingType
         * @memberof contractpb.UpdateContractProperty
         * @instance
         */
        UpdateContractProperty.prototype.dwellingType = "";

        /**
         * UpdateContractProperty squareFeet.
         * @member {number} squareFeet
         * @memberof contractpb.UpdateContractProperty
         * @instance
         */
        UpdateContractProperty.prototype.squareFeet = 0;

        /**
         * UpdateContractProperty yearBuilt.
         * @member {string} yearBuilt
         * @memberof contractpb.UpdateContractProperty
         * @instance
         */
        UpdateContractProperty.prototype.yearBuilt = "";

        /**
         * UpdateContractProperty mlsNumber.
         * @member {string} mlsNumber
         * @memberof contractpb.UpdateContractProperty
         * @instance
         */
        UpdateContractProperty.prototype.mlsNumber = "";

        /**
         * UpdateContractProperty userId.
         * @member {string} userId
         * @memberof contractpb.UpdateContractProperty
         * @instance
         */
        UpdateContractProperty.prototype.userId = "";

        /**
         * Creates a new UpdateContractProperty instance using the specified properties.
         * @function create
         * @memberof contractpb.UpdateContractProperty
         * @static
         * @param {contractpb.IUpdateContractProperty=} [properties] Properties to set
         * @returns {contractpb.UpdateContractProperty} UpdateContractProperty instance
         */
        UpdateContractProperty.create = function create(properties) {
            return new UpdateContractProperty(properties);
        };

        /**
         * Encodes the specified UpdateContractProperty message. Does not implicitly {@link contractpb.UpdateContractProperty.verify|verify} messages.
         * @function encode
         * @memberof contractpb.UpdateContractProperty
         * @static
         * @param {contractpb.IUpdateContractProperty} m UpdateContractProperty message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UpdateContractProperty.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.dwellingType != null && Object.hasOwnProperty.call(m, "dwellingType"))
                w.uint32(10).string(m.dwellingType);
            if (m.squareFeet != null && Object.hasOwnProperty.call(m, "squareFeet"))
                w.uint32(16).int32(m.squareFeet);
            if (m.yearBuilt != null && Object.hasOwnProperty.call(m, "yearBuilt"))
                w.uint32(26).string(m.yearBuilt);
            if (m.mlsNumber != null && Object.hasOwnProperty.call(m, "mlsNumber"))
                w.uint32(34).string(m.mlsNumber);
            if (m.userId != null && Object.hasOwnProperty.call(m, "userId"))
                w.uint32(42).string(m.userId);
            return w;
        };

        /**
         * Decodes an UpdateContractProperty message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.UpdateContractProperty
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.UpdateContractProperty} UpdateContractProperty
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UpdateContractProperty.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.UpdateContractProperty();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.dwellingType = r.string();
                    break;
                case 2:
                    m.squareFeet = r.int32();
                    break;
                case 3:
                    m.yearBuilt = r.string();
                    break;
                case 4:
                    m.mlsNumber = r.string();
                    break;
                case 5:
                    m.userId = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return UpdateContractProperty;
    })();

    contractpb.ContractOfficeStateDepartment = (function() {

        /**
         * Properties of a ContractOfficeStateDepartment.
         * @memberof contractpb
         * @interface IContractOfficeStateDepartment
         * @property {contractpb.IContractOffice|null} [office] ContractOfficeStateDepartment office
         * @property {string|null} [propertyZipCode] ContractOfficeStateDepartment propertyZipCode
         * @property {string|null} [propertyState] ContractOfficeStateDepartment propertyState
         * @property {number|Long|null} [productPlanID] ContractOfficeStateDepartment productPlanID
         */

        /**
         * Constructs a new ContractOfficeStateDepartment.
         * @memberof contractpb
         * @classdesc Represents a ContractOfficeStateDepartment.
         * @implements IContractOfficeStateDepartment
         * @constructor
         * @param {contractpb.IContractOfficeStateDepartment=} [p] Properties to set
         */
        function ContractOfficeStateDepartment(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * ContractOfficeStateDepartment office.
         * @member {contractpb.IContractOffice|null|undefined} office
         * @memberof contractpb.ContractOfficeStateDepartment
         * @instance
         */
        ContractOfficeStateDepartment.prototype.office = null;

        /**
         * ContractOfficeStateDepartment propertyZipCode.
         * @member {string} propertyZipCode
         * @memberof contractpb.ContractOfficeStateDepartment
         * @instance
         */
        ContractOfficeStateDepartment.prototype.propertyZipCode = "";

        /**
         * ContractOfficeStateDepartment propertyState.
         * @member {string} propertyState
         * @memberof contractpb.ContractOfficeStateDepartment
         * @instance
         */
        ContractOfficeStateDepartment.prototype.propertyState = "";

        /**
         * ContractOfficeStateDepartment productPlanID.
         * @member {number|Long} productPlanID
         * @memberof contractpb.ContractOfficeStateDepartment
         * @instance
         */
        ContractOfficeStateDepartment.prototype.productPlanID = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Creates a new ContractOfficeStateDepartment instance using the specified properties.
         * @function create
         * @memberof contractpb.ContractOfficeStateDepartment
         * @static
         * @param {contractpb.IContractOfficeStateDepartment=} [properties] Properties to set
         * @returns {contractpb.ContractOfficeStateDepartment} ContractOfficeStateDepartment instance
         */
        ContractOfficeStateDepartment.create = function create(properties) {
            return new ContractOfficeStateDepartment(properties);
        };

        /**
         * Encodes the specified ContractOfficeStateDepartment message. Does not implicitly {@link contractpb.ContractOfficeStateDepartment.verify|verify} messages.
         * @function encode
         * @memberof contractpb.ContractOfficeStateDepartment
         * @static
         * @param {contractpb.IContractOfficeStateDepartment} m ContractOfficeStateDepartment message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ContractOfficeStateDepartment.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.office != null && Object.hasOwnProperty.call(m, "office"))
                $root.contractpb.ContractOffice.encode(m.office, w.uint32(10).fork()).ldelim();
            if (m.propertyZipCode != null && Object.hasOwnProperty.call(m, "propertyZipCode"))
                w.uint32(18).string(m.propertyZipCode);
            if (m.propertyState != null && Object.hasOwnProperty.call(m, "propertyState"))
                w.uint32(26).string(m.propertyState);
            if (m.productPlanID != null && Object.hasOwnProperty.call(m, "productPlanID"))
                w.uint32(32).int64(m.productPlanID);
            return w;
        };

        /**
         * Decodes a ContractOfficeStateDepartment message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.ContractOfficeStateDepartment
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.ContractOfficeStateDepartment} ContractOfficeStateDepartment
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ContractOfficeStateDepartment.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.ContractOfficeStateDepartment();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.office = $root.contractpb.ContractOffice.decode(r, r.uint32());
                    break;
                case 2:
                    m.propertyZipCode = r.string();
                    break;
                case 3:
                    m.propertyState = r.string();
                    break;
                case 4:
                    m.productPlanID = r.int64();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return ContractOfficeStateDepartment;
    })();

    contractpb.AdditionalHomeEligibilityRequest = (function() {

        /**
         * Properties of an AdditionalHomeEligibilityRequest.
         * @memberof contractpb
         * @interface IAdditionalHomeEligibilityRequest
         * @property {string|null} [email] AdditionalHomeEligibilityRequest email
         * @property {contractpb.IContractProperty|null} [address] AdditionalHomeEligibilityRequest address
         */

        /**
         * Constructs a new AdditionalHomeEligibilityRequest.
         * @memberof contractpb
         * @classdesc Represents an AdditionalHomeEligibilityRequest.
         * @implements IAdditionalHomeEligibilityRequest
         * @constructor
         * @param {contractpb.IAdditionalHomeEligibilityRequest=} [p] Properties to set
         */
        function AdditionalHomeEligibilityRequest(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * AdditionalHomeEligibilityRequest email.
         * @member {string} email
         * @memberof contractpb.AdditionalHomeEligibilityRequest
         * @instance
         */
        AdditionalHomeEligibilityRequest.prototype.email = "";

        /**
         * AdditionalHomeEligibilityRequest address.
         * @member {contractpb.IContractProperty|null|undefined} address
         * @memberof contractpb.AdditionalHomeEligibilityRequest
         * @instance
         */
        AdditionalHomeEligibilityRequest.prototype.address = null;

        /**
         * Creates a new AdditionalHomeEligibilityRequest instance using the specified properties.
         * @function create
         * @memberof contractpb.AdditionalHomeEligibilityRequest
         * @static
         * @param {contractpb.IAdditionalHomeEligibilityRequest=} [properties] Properties to set
         * @returns {contractpb.AdditionalHomeEligibilityRequest} AdditionalHomeEligibilityRequest instance
         */
        AdditionalHomeEligibilityRequest.create = function create(properties) {
            return new AdditionalHomeEligibilityRequest(properties);
        };

        /**
         * Encodes the specified AdditionalHomeEligibilityRequest message. Does not implicitly {@link contractpb.AdditionalHomeEligibilityRequest.verify|verify} messages.
         * @function encode
         * @memberof contractpb.AdditionalHomeEligibilityRequest
         * @static
         * @param {contractpb.IAdditionalHomeEligibilityRequest} m AdditionalHomeEligibilityRequest message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AdditionalHomeEligibilityRequest.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.email != null && Object.hasOwnProperty.call(m, "email"))
                w.uint32(10).string(m.email);
            if (m.address != null && Object.hasOwnProperty.call(m, "address"))
                $root.contractpb.ContractProperty.encode(m.address, w.uint32(18).fork()).ldelim();
            return w;
        };

        /**
         * Decodes an AdditionalHomeEligibilityRequest message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.AdditionalHomeEligibilityRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.AdditionalHomeEligibilityRequest} AdditionalHomeEligibilityRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AdditionalHomeEligibilityRequest.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.AdditionalHomeEligibilityRequest();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.email = r.string();
                    break;
                case 2:
                    m.address = $root.contractpb.ContractProperty.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return AdditionalHomeEligibilityRequest;
    })();

    contractpb.AdditionalHomeEligibilityResponse = (function() {

        /**
         * Properties of an AdditionalHomeEligibilityResponse.
         * @memberof contractpb
         * @interface IAdditionalHomeEligibilityResponse
         * @property {string|null} [result] AdditionalHomeEligibilityResponse result
         * @property {string|null} [reason] AdditionalHomeEligibilityResponse reason
         * @property {string|null} [error] AdditionalHomeEligibilityResponse error
         */

        /**
         * Constructs a new AdditionalHomeEligibilityResponse.
         * @memberof contractpb
         * @classdesc Represents an AdditionalHomeEligibilityResponse.
         * @implements IAdditionalHomeEligibilityResponse
         * @constructor
         * @param {contractpb.IAdditionalHomeEligibilityResponse=} [p] Properties to set
         */
        function AdditionalHomeEligibilityResponse(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * AdditionalHomeEligibilityResponse result.
         * @member {string} result
         * @memberof contractpb.AdditionalHomeEligibilityResponse
         * @instance
         */
        AdditionalHomeEligibilityResponse.prototype.result = "";

        /**
         * AdditionalHomeEligibilityResponse reason.
         * @member {string} reason
         * @memberof contractpb.AdditionalHomeEligibilityResponse
         * @instance
         */
        AdditionalHomeEligibilityResponse.prototype.reason = "";

        /**
         * AdditionalHomeEligibilityResponse error.
         * @member {string} error
         * @memberof contractpb.AdditionalHomeEligibilityResponse
         * @instance
         */
        AdditionalHomeEligibilityResponse.prototype.error = "";

        /**
         * Creates a new AdditionalHomeEligibilityResponse instance using the specified properties.
         * @function create
         * @memberof contractpb.AdditionalHomeEligibilityResponse
         * @static
         * @param {contractpb.IAdditionalHomeEligibilityResponse=} [properties] Properties to set
         * @returns {contractpb.AdditionalHomeEligibilityResponse} AdditionalHomeEligibilityResponse instance
         */
        AdditionalHomeEligibilityResponse.create = function create(properties) {
            return new AdditionalHomeEligibilityResponse(properties);
        };

        /**
         * Encodes the specified AdditionalHomeEligibilityResponse message. Does not implicitly {@link contractpb.AdditionalHomeEligibilityResponse.verify|verify} messages.
         * @function encode
         * @memberof contractpb.AdditionalHomeEligibilityResponse
         * @static
         * @param {contractpb.IAdditionalHomeEligibilityResponse} m AdditionalHomeEligibilityResponse message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AdditionalHomeEligibilityResponse.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.result != null && Object.hasOwnProperty.call(m, "result"))
                w.uint32(10).string(m.result);
            if (m.reason != null && Object.hasOwnProperty.call(m, "reason"))
                w.uint32(18).string(m.reason);
            if (m.error != null && Object.hasOwnProperty.call(m, "error"))
                w.uint32(50).string(m.error);
            return w;
        };

        /**
         * Decodes an AdditionalHomeEligibilityResponse message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.AdditionalHomeEligibilityResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.AdditionalHomeEligibilityResponse} AdditionalHomeEligibilityResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AdditionalHomeEligibilityResponse.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.AdditionalHomeEligibilityResponse();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.result = r.string();
                    break;
                case 2:
                    m.reason = r.string();
                    break;
                case 6:
                    m.error = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return AdditionalHomeEligibilityResponse;
    })();

    contractpb.ExistingCustomerRequest = (function() {

        /**
         * Properties of an ExistingCustomerRequest.
         * @memberof contractpb
         * @interface IExistingCustomerRequest
         * @property {string|null} [email] ExistingCustomerRequest email
         * @property {contractpb.IContractProperty|null} [address] ExistingCustomerRequest address
         */

        /**
         * Constructs a new ExistingCustomerRequest.
         * @memberof contractpb
         * @classdesc Represents an ExistingCustomerRequest.
         * @implements IExistingCustomerRequest
         * @constructor
         * @param {contractpb.IExistingCustomerRequest=} [p] Properties to set
         */
        function ExistingCustomerRequest(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * ExistingCustomerRequest email.
         * @member {string} email
         * @memberof contractpb.ExistingCustomerRequest
         * @instance
         */
        ExistingCustomerRequest.prototype.email = "";

        /**
         * ExistingCustomerRequest address.
         * @member {contractpb.IContractProperty|null|undefined} address
         * @memberof contractpb.ExistingCustomerRequest
         * @instance
         */
        ExistingCustomerRequest.prototype.address = null;

        /**
         * Creates a new ExistingCustomerRequest instance using the specified properties.
         * @function create
         * @memberof contractpb.ExistingCustomerRequest
         * @static
         * @param {contractpb.IExistingCustomerRequest=} [properties] Properties to set
         * @returns {contractpb.ExistingCustomerRequest} ExistingCustomerRequest instance
         */
        ExistingCustomerRequest.create = function create(properties) {
            return new ExistingCustomerRequest(properties);
        };

        /**
         * Encodes the specified ExistingCustomerRequest message. Does not implicitly {@link contractpb.ExistingCustomerRequest.verify|verify} messages.
         * @function encode
         * @memberof contractpb.ExistingCustomerRequest
         * @static
         * @param {contractpb.IExistingCustomerRequest} m ExistingCustomerRequest message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ExistingCustomerRequest.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.email != null && Object.hasOwnProperty.call(m, "email"))
                w.uint32(10).string(m.email);
            if (m.address != null && Object.hasOwnProperty.call(m, "address"))
                $root.contractpb.ContractProperty.encode(m.address, w.uint32(18).fork()).ldelim();
            return w;
        };

        /**
         * Decodes an ExistingCustomerRequest message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.ExistingCustomerRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.ExistingCustomerRequest} ExistingCustomerRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ExistingCustomerRequest.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.ExistingCustomerRequest();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.email = r.string();
                    break;
                case 2:
                    m.address = $root.contractpb.ContractProperty.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return ExistingCustomerRequest;
    })();

    contractpb.ExistingCustomerResponse = (function() {

        /**
         * Properties of an ExistingCustomerResponse.
         * @memberof contractpb
         * @interface IExistingCustomerResponse
         * @property {string|null} [contractID] ExistingCustomerResponse contractID
         * @property {google.protobuf.ITimestamp|null} [expirationDate] ExistingCustomerResponse expirationDate
         */

        /**
         * Constructs a new ExistingCustomerResponse.
         * @memberof contractpb
         * @classdesc Represents an ExistingCustomerResponse.
         * @implements IExistingCustomerResponse
         * @constructor
         * @param {contractpb.IExistingCustomerResponse=} [p] Properties to set
         */
        function ExistingCustomerResponse(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * ExistingCustomerResponse contractID.
         * @member {string} contractID
         * @memberof contractpb.ExistingCustomerResponse
         * @instance
         */
        ExistingCustomerResponse.prototype.contractID = "";

        /**
         * ExistingCustomerResponse expirationDate.
         * @member {google.protobuf.ITimestamp|null|undefined} expirationDate
         * @memberof contractpb.ExistingCustomerResponse
         * @instance
         */
        ExistingCustomerResponse.prototype.expirationDate = null;

        /**
         * Creates a new ExistingCustomerResponse instance using the specified properties.
         * @function create
         * @memberof contractpb.ExistingCustomerResponse
         * @static
         * @param {contractpb.IExistingCustomerResponse=} [properties] Properties to set
         * @returns {contractpb.ExistingCustomerResponse} ExistingCustomerResponse instance
         */
        ExistingCustomerResponse.create = function create(properties) {
            return new ExistingCustomerResponse(properties);
        };

        /**
         * Encodes the specified ExistingCustomerResponse message. Does not implicitly {@link contractpb.ExistingCustomerResponse.verify|verify} messages.
         * @function encode
         * @memberof contractpb.ExistingCustomerResponse
         * @static
         * @param {contractpb.IExistingCustomerResponse} m ExistingCustomerResponse message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ExistingCustomerResponse.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.contractID != null && Object.hasOwnProperty.call(m, "contractID"))
                w.uint32(10).string(m.contractID);
            if (m.expirationDate != null && Object.hasOwnProperty.call(m, "expirationDate"))
                $root.google.protobuf.Timestamp.encode(m.expirationDate, w.uint32(18).fork()).ldelim();
            return w;
        };

        /**
         * Decodes an ExistingCustomerResponse message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.ExistingCustomerResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.ExistingCustomerResponse} ExistingCustomerResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ExistingCustomerResponse.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.ExistingCustomerResponse();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.contractID = r.string();
                    break;
                case 2:
                    m.expirationDate = $root.google.protobuf.Timestamp.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return ExistingCustomerResponse;
    })();

    contractpb.UpdateProductCoveragesRequest = (function() {

        /**
         * Properties of an UpdateProductCoveragesRequest.
         * @memberof contractpb
         * @interface IUpdateProductCoveragesRequest
         * @property {string|null} [productVersionID] UpdateProductCoveragesRequest productVersionID
         * @property {Array.<contractpb.UpdateProductCoveragesRequest.ICoverage>|null} [optionalCoverages] UpdateProductCoveragesRequest optionalCoverages
         * @property {Array.<contractpb.UpdateProductCoveragesRequest.ICoverage>|null} [groupCoverages] UpdateProductCoveragesRequest groupCoverages
         * @property {string|null} [orderMethod] UpdateProductCoveragesRequest orderMethod
         */

        /**
         * Constructs a new UpdateProductCoveragesRequest.
         * @memberof contractpb
         * @classdesc Represents an UpdateProductCoveragesRequest.
         * @implements IUpdateProductCoveragesRequest
         * @constructor
         * @param {contractpb.IUpdateProductCoveragesRequest=} [p] Properties to set
         */
        function UpdateProductCoveragesRequest(p) {
            this.optionalCoverages = [];
            this.groupCoverages = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * UpdateProductCoveragesRequest productVersionID.
         * @member {string} productVersionID
         * @memberof contractpb.UpdateProductCoveragesRequest
         * @instance
         */
        UpdateProductCoveragesRequest.prototype.productVersionID = "";

        /**
         * UpdateProductCoveragesRequest optionalCoverages.
         * @member {Array.<contractpb.UpdateProductCoveragesRequest.ICoverage>} optionalCoverages
         * @memberof contractpb.UpdateProductCoveragesRequest
         * @instance
         */
        UpdateProductCoveragesRequest.prototype.optionalCoverages = $util.emptyArray;

        /**
         * UpdateProductCoveragesRequest groupCoverages.
         * @member {Array.<contractpb.UpdateProductCoveragesRequest.ICoverage>} groupCoverages
         * @memberof contractpb.UpdateProductCoveragesRequest
         * @instance
         */
        UpdateProductCoveragesRequest.prototype.groupCoverages = $util.emptyArray;

        /**
         * UpdateProductCoveragesRequest orderMethod.
         * @member {string} orderMethod
         * @memberof contractpb.UpdateProductCoveragesRequest
         * @instance
         */
        UpdateProductCoveragesRequest.prototype.orderMethod = "";

        /**
         * Creates a new UpdateProductCoveragesRequest instance using the specified properties.
         * @function create
         * @memberof contractpb.UpdateProductCoveragesRequest
         * @static
         * @param {contractpb.IUpdateProductCoveragesRequest=} [properties] Properties to set
         * @returns {contractpb.UpdateProductCoveragesRequest} UpdateProductCoveragesRequest instance
         */
        UpdateProductCoveragesRequest.create = function create(properties) {
            return new UpdateProductCoveragesRequest(properties);
        };

        /**
         * Encodes the specified UpdateProductCoveragesRequest message. Does not implicitly {@link contractpb.UpdateProductCoveragesRequest.verify|verify} messages.
         * @function encode
         * @memberof contractpb.UpdateProductCoveragesRequest
         * @static
         * @param {contractpb.IUpdateProductCoveragesRequest} m UpdateProductCoveragesRequest message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UpdateProductCoveragesRequest.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.productVersionID != null && Object.hasOwnProperty.call(m, "productVersionID"))
                w.uint32(10).string(m.productVersionID);
            if (m.optionalCoverages != null && m.optionalCoverages.length) {
                for (var i = 0; i < m.optionalCoverages.length; ++i)
                    $root.contractpb.UpdateProductCoveragesRequest.Coverage.encode(m.optionalCoverages[i], w.uint32(18).fork()).ldelim();
            }
            if (m.groupCoverages != null && m.groupCoverages.length) {
                for (var i = 0; i < m.groupCoverages.length; ++i)
                    $root.contractpb.UpdateProductCoveragesRequest.Coverage.encode(m.groupCoverages[i], w.uint32(26).fork()).ldelim();
            }
            if (m.orderMethod != null && Object.hasOwnProperty.call(m, "orderMethod"))
                w.uint32(34).string(m.orderMethod);
            return w;
        };

        /**
         * Decodes an UpdateProductCoveragesRequest message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.UpdateProductCoveragesRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.UpdateProductCoveragesRequest} UpdateProductCoveragesRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UpdateProductCoveragesRequest.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.UpdateProductCoveragesRequest();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.productVersionID = r.string();
                    break;
                case 2:
                    if (!(m.optionalCoverages && m.optionalCoverages.length))
                        m.optionalCoverages = [];
                    m.optionalCoverages.push($root.contractpb.UpdateProductCoveragesRequest.Coverage.decode(r, r.uint32()));
                    break;
                case 3:
                    if (!(m.groupCoverages && m.groupCoverages.length))
                        m.groupCoverages = [];
                    m.groupCoverages.push($root.contractpb.UpdateProductCoveragesRequest.Coverage.decode(r, r.uint32()));
                    break;
                case 4:
                    m.orderMethod = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        UpdateProductCoveragesRequest.Coverage = (function() {

            /**
             * Properties of a Coverage.
             * @memberof contractpb.UpdateProductCoveragesRequest
             * @interface ICoverage
             * @property {string|null} [id] Coverage id
             * @property {number|null} [quantity] Coverage quantity
             */

            /**
             * Constructs a new Coverage.
             * @memberof contractpb.UpdateProductCoveragesRequest
             * @classdesc Represents a Coverage.
             * @implements ICoverage
             * @constructor
             * @param {contractpb.UpdateProductCoveragesRequest.ICoverage=} [p] Properties to set
             */
            function Coverage(p) {
                if (p)
                    for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                        if (p[ks[i]] != null)
                            this[ks[i]] = p[ks[i]];
            }

            /**
             * Coverage id.
             * @member {string} id
             * @memberof contractpb.UpdateProductCoveragesRequest.Coverage
             * @instance
             */
            Coverage.prototype.id = "";

            /**
             * Coverage quantity.
             * @member {number} quantity
             * @memberof contractpb.UpdateProductCoveragesRequest.Coverage
             * @instance
             */
            Coverage.prototype.quantity = 0;

            /**
             * Creates a new Coverage instance using the specified properties.
             * @function create
             * @memberof contractpb.UpdateProductCoveragesRequest.Coverage
             * @static
             * @param {contractpb.UpdateProductCoveragesRequest.ICoverage=} [properties] Properties to set
             * @returns {contractpb.UpdateProductCoveragesRequest.Coverage} Coverage instance
             */
            Coverage.create = function create(properties) {
                return new Coverage(properties);
            };

            /**
             * Encodes the specified Coverage message. Does not implicitly {@link contractpb.UpdateProductCoveragesRequest.Coverage.verify|verify} messages.
             * @function encode
             * @memberof contractpb.UpdateProductCoveragesRequest.Coverage
             * @static
             * @param {contractpb.UpdateProductCoveragesRequest.ICoverage} m Coverage message or plain object to encode
             * @param {$protobuf.Writer} [w] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Coverage.encode = function encode(m, w) {
                if (!w)
                    w = $Writer.create();
                if (m.id != null && Object.hasOwnProperty.call(m, "id"))
                    w.uint32(10).string(m.id);
                if (m.quantity != null && Object.hasOwnProperty.call(m, "quantity"))
                    w.uint32(16).int32(m.quantity);
                return w;
            };

            /**
             * Decodes a Coverage message from the specified reader or buffer.
             * @function decode
             * @memberof contractpb.UpdateProductCoveragesRequest.Coverage
             * @static
             * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
             * @param {number} [l] Message length if known beforehand
             * @returns {contractpb.UpdateProductCoveragesRequest.Coverage} Coverage
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Coverage.decode = function decode(r, l) {
                if (!(r instanceof $Reader))
                    r = $Reader.create(r);
                var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.UpdateProductCoveragesRequest.Coverage();
                while (r.pos < c) {
                    var t = r.uint32();
                    switch (t >>> 3) {
                    case 1:
                        m.id = r.string();
                        break;
                    case 2:
                        m.quantity = r.int32();
                        break;
                    default:
                        r.skipType(t & 7);
                        break;
                    }
                }
                return m;
            };

            return Coverage;
        })();

        return UpdateProductCoveragesRequest;
    })();

    contractpb.PlanAndCoveragesResponse = (function() {

        /**
         * Properties of a PlanAndCoveragesResponse.
         * @memberof contractpb
         * @interface IPlanAndCoveragesResponse
         * @property {string|null} [productVersionID] PlanAndCoveragesResponse productVersionID
         * @property {Array.<contractpb.PlanAndCoveragesResponse.ICoverage>|null} [optionalCoverages] PlanAndCoveragesResponse optionalCoverages
         * @property {Array.<contractpb.PlanAndCoveragesResponse.IGroupCoverage>|null} [groupCoverages] PlanAndCoveragesResponse groupCoverages
         */

        /**
         * Constructs a new PlanAndCoveragesResponse.
         * @memberof contractpb
         * @classdesc Represents a PlanAndCoveragesResponse.
         * @implements IPlanAndCoveragesResponse
         * @constructor
         * @param {contractpb.IPlanAndCoveragesResponse=} [p] Properties to set
         */
        function PlanAndCoveragesResponse(p) {
            this.optionalCoverages = [];
            this.groupCoverages = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * PlanAndCoveragesResponse productVersionID.
         * @member {string} productVersionID
         * @memberof contractpb.PlanAndCoveragesResponse
         * @instance
         */
        PlanAndCoveragesResponse.prototype.productVersionID = "";

        /**
         * PlanAndCoveragesResponse optionalCoverages.
         * @member {Array.<contractpb.PlanAndCoveragesResponse.ICoverage>} optionalCoverages
         * @memberof contractpb.PlanAndCoveragesResponse
         * @instance
         */
        PlanAndCoveragesResponse.prototype.optionalCoverages = $util.emptyArray;

        /**
         * PlanAndCoveragesResponse groupCoverages.
         * @member {Array.<contractpb.PlanAndCoveragesResponse.IGroupCoverage>} groupCoverages
         * @memberof contractpb.PlanAndCoveragesResponse
         * @instance
         */
        PlanAndCoveragesResponse.prototype.groupCoverages = $util.emptyArray;

        /**
         * Creates a new PlanAndCoveragesResponse instance using the specified properties.
         * @function create
         * @memberof contractpb.PlanAndCoveragesResponse
         * @static
         * @param {contractpb.IPlanAndCoveragesResponse=} [properties] Properties to set
         * @returns {contractpb.PlanAndCoveragesResponse} PlanAndCoveragesResponse instance
         */
        PlanAndCoveragesResponse.create = function create(properties) {
            return new PlanAndCoveragesResponse(properties);
        };

        /**
         * Encodes the specified PlanAndCoveragesResponse message. Does not implicitly {@link contractpb.PlanAndCoveragesResponse.verify|verify} messages.
         * @function encode
         * @memberof contractpb.PlanAndCoveragesResponse
         * @static
         * @param {contractpb.IPlanAndCoveragesResponse} m PlanAndCoveragesResponse message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PlanAndCoveragesResponse.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.productVersionID != null && Object.hasOwnProperty.call(m, "productVersionID"))
                w.uint32(10).string(m.productVersionID);
            if (m.optionalCoverages != null && m.optionalCoverages.length) {
                for (var i = 0; i < m.optionalCoverages.length; ++i)
                    $root.contractpb.PlanAndCoveragesResponse.Coverage.encode(m.optionalCoverages[i], w.uint32(18).fork()).ldelim();
            }
            if (m.groupCoverages != null && m.groupCoverages.length) {
                for (var i = 0; i < m.groupCoverages.length; ++i)
                    $root.contractpb.PlanAndCoveragesResponse.GroupCoverage.encode(m.groupCoverages[i], w.uint32(26).fork()).ldelim();
            }
            return w;
        };

        /**
         * Decodes a PlanAndCoveragesResponse message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.PlanAndCoveragesResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.PlanAndCoveragesResponse} PlanAndCoveragesResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PlanAndCoveragesResponse.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.PlanAndCoveragesResponse();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.productVersionID = r.string();
                    break;
                case 2:
                    if (!(m.optionalCoverages && m.optionalCoverages.length))
                        m.optionalCoverages = [];
                    m.optionalCoverages.push($root.contractpb.PlanAndCoveragesResponse.Coverage.decode(r, r.uint32()));
                    break;
                case 3:
                    if (!(m.groupCoverages && m.groupCoverages.length))
                        m.groupCoverages = [];
                    m.groupCoverages.push($root.contractpb.PlanAndCoveragesResponse.GroupCoverage.decode(r, r.uint32()));
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        PlanAndCoveragesResponse.Coverage = (function() {

            /**
             * Properties of a Coverage.
             * @memberof contractpb.PlanAndCoveragesResponse
             * @interface ICoverage
             * @property {string|null} [ID] Coverage ID
             * @property {number|null} [quantity] Coverage quantity
             * @property {number|null} [cost] Coverage cost
             */

            /**
             * Constructs a new Coverage.
             * @memberof contractpb.PlanAndCoveragesResponse
             * @classdesc Represents a Coverage.
             * @implements ICoverage
             * @constructor
             * @param {contractpb.PlanAndCoveragesResponse.ICoverage=} [p] Properties to set
             */
            function Coverage(p) {
                if (p)
                    for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                        if (p[ks[i]] != null)
                            this[ks[i]] = p[ks[i]];
            }

            /**
             * Coverage ID.
             * @member {string} ID
             * @memberof contractpb.PlanAndCoveragesResponse.Coverage
             * @instance
             */
            Coverage.prototype.ID = "";

            /**
             * Coverage quantity.
             * @member {number} quantity
             * @memberof contractpb.PlanAndCoveragesResponse.Coverage
             * @instance
             */
            Coverage.prototype.quantity = 0;

            /**
             * Coverage cost.
             * @member {number} cost
             * @memberof contractpb.PlanAndCoveragesResponse.Coverage
             * @instance
             */
            Coverage.prototype.cost = 0;

            /**
             * Creates a new Coverage instance using the specified properties.
             * @function create
             * @memberof contractpb.PlanAndCoveragesResponse.Coverage
             * @static
             * @param {contractpb.PlanAndCoveragesResponse.ICoverage=} [properties] Properties to set
             * @returns {contractpb.PlanAndCoveragesResponse.Coverage} Coverage instance
             */
            Coverage.create = function create(properties) {
                return new Coverage(properties);
            };

            /**
             * Encodes the specified Coverage message. Does not implicitly {@link contractpb.PlanAndCoveragesResponse.Coverage.verify|verify} messages.
             * @function encode
             * @memberof contractpb.PlanAndCoveragesResponse.Coverage
             * @static
             * @param {contractpb.PlanAndCoveragesResponse.ICoverage} m Coverage message or plain object to encode
             * @param {$protobuf.Writer} [w] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Coverage.encode = function encode(m, w) {
                if (!w)
                    w = $Writer.create();
                if (m.ID != null && Object.hasOwnProperty.call(m, "ID"))
                    w.uint32(10).string(m.ID);
                if (m.quantity != null && Object.hasOwnProperty.call(m, "quantity"))
                    w.uint32(16).int32(m.quantity);
                if (m.cost != null && Object.hasOwnProperty.call(m, "cost"))
                    w.uint32(25).double(m.cost);
                return w;
            };

            /**
             * Decodes a Coverage message from the specified reader or buffer.
             * @function decode
             * @memberof contractpb.PlanAndCoveragesResponse.Coverage
             * @static
             * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
             * @param {number} [l] Message length if known beforehand
             * @returns {contractpb.PlanAndCoveragesResponse.Coverage} Coverage
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Coverage.decode = function decode(r, l) {
                if (!(r instanceof $Reader))
                    r = $Reader.create(r);
                var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.PlanAndCoveragesResponse.Coverage();
                while (r.pos < c) {
                    var t = r.uint32();
                    switch (t >>> 3) {
                    case 1:
                        m.ID = r.string();
                        break;
                    case 2:
                        m.quantity = r.int32();
                        break;
                    case 3:
                        m.cost = r.double();
                        break;
                    default:
                        r.skipType(t & 7);
                        break;
                    }
                }
                return m;
            };

            return Coverage;
        })();

        PlanAndCoveragesResponse.GroupCoverage = (function() {

            /**
             * Properties of a GroupCoverage.
             * @memberof contractpb.PlanAndCoveragesResponse
             * @interface IGroupCoverage
             * @property {string|null} [ID] GroupCoverage ID
             * @property {number|null} [cost] GroupCoverage cost
             * @property {Array.<contractpb.PlanAndCoveragesResponse.ICoverage>|null} [coverages] GroupCoverage coverages
             */

            /**
             * Constructs a new GroupCoverage.
             * @memberof contractpb.PlanAndCoveragesResponse
             * @classdesc Represents a GroupCoverage.
             * @implements IGroupCoverage
             * @constructor
             * @param {contractpb.PlanAndCoveragesResponse.IGroupCoverage=} [p] Properties to set
             */
            function GroupCoverage(p) {
                this.coverages = [];
                if (p)
                    for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                        if (p[ks[i]] != null)
                            this[ks[i]] = p[ks[i]];
            }

            /**
             * GroupCoverage ID.
             * @member {string} ID
             * @memberof contractpb.PlanAndCoveragesResponse.GroupCoverage
             * @instance
             */
            GroupCoverage.prototype.ID = "";

            /**
             * GroupCoverage cost.
             * @member {number} cost
             * @memberof contractpb.PlanAndCoveragesResponse.GroupCoverage
             * @instance
             */
            GroupCoverage.prototype.cost = 0;

            /**
             * GroupCoverage coverages.
             * @member {Array.<contractpb.PlanAndCoveragesResponse.ICoverage>} coverages
             * @memberof contractpb.PlanAndCoveragesResponse.GroupCoverage
             * @instance
             */
            GroupCoverage.prototype.coverages = $util.emptyArray;

            /**
             * Creates a new GroupCoverage instance using the specified properties.
             * @function create
             * @memberof contractpb.PlanAndCoveragesResponse.GroupCoverage
             * @static
             * @param {contractpb.PlanAndCoveragesResponse.IGroupCoverage=} [properties] Properties to set
             * @returns {contractpb.PlanAndCoveragesResponse.GroupCoverage} GroupCoverage instance
             */
            GroupCoverage.create = function create(properties) {
                return new GroupCoverage(properties);
            };

            /**
             * Encodes the specified GroupCoverage message. Does not implicitly {@link contractpb.PlanAndCoveragesResponse.GroupCoverage.verify|verify} messages.
             * @function encode
             * @memberof contractpb.PlanAndCoveragesResponse.GroupCoverage
             * @static
             * @param {contractpb.PlanAndCoveragesResponse.IGroupCoverage} m GroupCoverage message or plain object to encode
             * @param {$protobuf.Writer} [w] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GroupCoverage.encode = function encode(m, w) {
                if (!w)
                    w = $Writer.create();
                if (m.ID != null && Object.hasOwnProperty.call(m, "ID"))
                    w.uint32(10).string(m.ID);
                if (m.cost != null && Object.hasOwnProperty.call(m, "cost"))
                    w.uint32(17).double(m.cost);
                if (m.coverages != null && m.coverages.length) {
                    for (var i = 0; i < m.coverages.length; ++i)
                        $root.contractpb.PlanAndCoveragesResponse.Coverage.encode(m.coverages[i], w.uint32(26).fork()).ldelim();
                }
                return w;
            };

            /**
             * Decodes a GroupCoverage message from the specified reader or buffer.
             * @function decode
             * @memberof contractpb.PlanAndCoveragesResponse.GroupCoverage
             * @static
             * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
             * @param {number} [l] Message length if known beforehand
             * @returns {contractpb.PlanAndCoveragesResponse.GroupCoverage} GroupCoverage
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GroupCoverage.decode = function decode(r, l) {
                if (!(r instanceof $Reader))
                    r = $Reader.create(r);
                var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.PlanAndCoveragesResponse.GroupCoverage();
                while (r.pos < c) {
                    var t = r.uint32();
                    switch (t >>> 3) {
                    case 1:
                        m.ID = r.string();
                        break;
                    case 2:
                        m.cost = r.double();
                        break;
                    case 3:
                        if (!(m.coverages && m.coverages.length))
                            m.coverages = [];
                        m.coverages.push($root.contractpb.PlanAndCoveragesResponse.Coverage.decode(r, r.uint32()));
                        break;
                    default:
                        r.skipType(t & 7);
                        break;
                    }
                }
                return m;
            };

            return GroupCoverage;
        })();

        return PlanAndCoveragesResponse;
    })();

    contractpb.CreateQuoteByContractIDRequest = (function() {

        /**
         * Properties of a CreateQuoteByContractIDRequest.
         * @memberof contractpb
         * @interface ICreateQuoteByContractIDRequest
         * @property {string|null} [orderMethod] CreateQuoteByContractIDRequest orderMethod
         */

        /**
         * Constructs a new CreateQuoteByContractIDRequest.
         * @memberof contractpb
         * @classdesc Represents a CreateQuoteByContractIDRequest.
         * @implements ICreateQuoteByContractIDRequest
         * @constructor
         * @param {contractpb.ICreateQuoteByContractIDRequest=} [p] Properties to set
         */
        function CreateQuoteByContractIDRequest(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * CreateQuoteByContractIDRequest orderMethod.
         * @member {string} orderMethod
         * @memberof contractpb.CreateQuoteByContractIDRequest
         * @instance
         */
        CreateQuoteByContractIDRequest.prototype.orderMethod = "";

        /**
         * Creates a new CreateQuoteByContractIDRequest instance using the specified properties.
         * @function create
         * @memberof contractpb.CreateQuoteByContractIDRequest
         * @static
         * @param {contractpb.ICreateQuoteByContractIDRequest=} [properties] Properties to set
         * @returns {contractpb.CreateQuoteByContractIDRequest} CreateQuoteByContractIDRequest instance
         */
        CreateQuoteByContractIDRequest.create = function create(properties) {
            return new CreateQuoteByContractIDRequest(properties);
        };

        /**
         * Encodes the specified CreateQuoteByContractIDRequest message. Does not implicitly {@link contractpb.CreateQuoteByContractIDRequest.verify|verify} messages.
         * @function encode
         * @memberof contractpb.CreateQuoteByContractIDRequest
         * @static
         * @param {contractpb.ICreateQuoteByContractIDRequest} m CreateQuoteByContractIDRequest message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CreateQuoteByContractIDRequest.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.orderMethod != null && Object.hasOwnProperty.call(m, "orderMethod"))
                w.uint32(10).string(m.orderMethod);
            return w;
        };

        /**
         * Decodes a CreateQuoteByContractIDRequest message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.CreateQuoteByContractIDRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.CreateQuoteByContractIDRequest} CreateQuoteByContractIDRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CreateQuoteByContractIDRequest.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.CreateQuoteByContractIDRequest();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.orderMethod = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return CreateQuoteByContractIDRequest;
    })();

    contractpb.CreateQuoteByContractIDResponse = (function() {

        /**
         * Properties of a CreateQuoteByContractIDResponse.
         * @memberof contractpb
         * @interface ICreateQuoteByContractIDResponse
         * @property {string|null} [quoteID] CreateQuoteByContractIDResponse quoteID
         */

        /**
         * Constructs a new CreateQuoteByContractIDResponse.
         * @memberof contractpb
         * @classdesc Represents a CreateQuoteByContractIDResponse.
         * @implements ICreateQuoteByContractIDResponse
         * @constructor
         * @param {contractpb.ICreateQuoteByContractIDResponse=} [p] Properties to set
         */
        function CreateQuoteByContractIDResponse(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * CreateQuoteByContractIDResponse quoteID.
         * @member {string} quoteID
         * @memberof contractpb.CreateQuoteByContractIDResponse
         * @instance
         */
        CreateQuoteByContractIDResponse.prototype.quoteID = "";

        /**
         * Creates a new CreateQuoteByContractIDResponse instance using the specified properties.
         * @function create
         * @memberof contractpb.CreateQuoteByContractIDResponse
         * @static
         * @param {contractpb.ICreateQuoteByContractIDResponse=} [properties] Properties to set
         * @returns {contractpb.CreateQuoteByContractIDResponse} CreateQuoteByContractIDResponse instance
         */
        CreateQuoteByContractIDResponse.create = function create(properties) {
            return new CreateQuoteByContractIDResponse(properties);
        };

        /**
         * Encodes the specified CreateQuoteByContractIDResponse message. Does not implicitly {@link contractpb.CreateQuoteByContractIDResponse.verify|verify} messages.
         * @function encode
         * @memberof contractpb.CreateQuoteByContractIDResponse
         * @static
         * @param {contractpb.ICreateQuoteByContractIDResponse} m CreateQuoteByContractIDResponse message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CreateQuoteByContractIDResponse.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.quoteID != null && Object.hasOwnProperty.call(m, "quoteID"))
                w.uint32(10).string(m.quoteID);
            return w;
        };

        /**
         * Decodes a CreateQuoteByContractIDResponse message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.CreateQuoteByContractIDResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.CreateQuoteByContractIDResponse} CreateQuoteByContractIDResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CreateQuoteByContractIDResponse.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.CreateQuoteByContractIDResponse();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.quoteID = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return CreateQuoteByContractIDResponse;
    })();

    /**
     * ContractPriceDataSource enum.
     * @name contractpb.ContractPriceDataSource
     * @enum {number}
     * @property {number} UNKNOWN_DATA_SOURCE=0 UNKNOWN_DATA_SOURCE value
     * @property {number} STAR=1 STAR value
     * @property {number} QUOTE=2 QUOTE value
     */
    contractpb.ContractPriceDataSource = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "UNKNOWN_DATA_SOURCE"] = 0;
        values[valuesById[1] = "STAR"] = 1;
        values[valuesById[2] = "QUOTE"] = 2;
        return values;
    })();

    contractpb.ContractPriceRequest = (function() {

        /**
         * Properties of a ContractPriceRequest.
         * @memberof contractpb
         * @interface IContractPriceRequest
         * @property {string|null} [contractID] ContractPriceRequest contractID
         * @property {contractpb.ContractPriceDataSource|null} [dataSource] ContractPriceRequest dataSource
         */

        /**
         * Constructs a new ContractPriceRequest.
         * @memberof contractpb
         * @classdesc Represents a ContractPriceRequest.
         * @implements IContractPriceRequest
         * @constructor
         * @param {contractpb.IContractPriceRequest=} [p] Properties to set
         */
        function ContractPriceRequest(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * ContractPriceRequest contractID.
         * @member {string} contractID
         * @memberof contractpb.ContractPriceRequest
         * @instance
         */
        ContractPriceRequest.prototype.contractID = "";

        /**
         * ContractPriceRequest dataSource.
         * @member {contractpb.ContractPriceDataSource} dataSource
         * @memberof contractpb.ContractPriceRequest
         * @instance
         */
        ContractPriceRequest.prototype.dataSource = 0;

        /**
         * Creates a new ContractPriceRequest instance using the specified properties.
         * @function create
         * @memberof contractpb.ContractPriceRequest
         * @static
         * @param {contractpb.IContractPriceRequest=} [properties] Properties to set
         * @returns {contractpb.ContractPriceRequest} ContractPriceRequest instance
         */
        ContractPriceRequest.create = function create(properties) {
            return new ContractPriceRequest(properties);
        };

        /**
         * Encodes the specified ContractPriceRequest message. Does not implicitly {@link contractpb.ContractPriceRequest.verify|verify} messages.
         * @function encode
         * @memberof contractpb.ContractPriceRequest
         * @static
         * @param {contractpb.IContractPriceRequest} m ContractPriceRequest message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ContractPriceRequest.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.contractID != null && Object.hasOwnProperty.call(m, "contractID"))
                w.uint32(10).string(m.contractID);
            if (m.dataSource != null && Object.hasOwnProperty.call(m, "dataSource"))
                w.uint32(16).int32(m.dataSource);
            return w;
        };

        /**
         * Decodes a ContractPriceRequest message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.ContractPriceRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.ContractPriceRequest} ContractPriceRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ContractPriceRequest.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.ContractPriceRequest();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.contractID = r.string();
                    break;
                case 2:
                    m.dataSource = r.int32();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return ContractPriceRequest;
    })();

    contractpb.ContractPriceResponse = (function() {

        /**
         * Properties of a ContractPriceResponse.
         * @memberof contractpb
         * @interface IContractPriceResponse
         * @property {contractpb.ContractPriceDataSource|null} [dataSource] ContractPriceResponse dataSource
         * @property {string|null} [quoteId] ContractPriceResponse quoteId
         * @property {contractpb.ContractPriceResponse.IContractPricing|null} [contractPricing] ContractPriceResponse contractPricing
         * @property {contractpb.ContractPriceResponse.IQuoteDetails|null} [quoteDetails] ContractPriceResponse quoteDetails
         */

        /**
         * Constructs a new ContractPriceResponse.
         * @memberof contractpb
         * @classdesc Represents a ContractPriceResponse.
         * @implements IContractPriceResponse
         * @constructor
         * @param {contractpb.IContractPriceResponse=} [p] Properties to set
         */
        function ContractPriceResponse(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * ContractPriceResponse dataSource.
         * @member {contractpb.ContractPriceDataSource} dataSource
         * @memberof contractpb.ContractPriceResponse
         * @instance
         */
        ContractPriceResponse.prototype.dataSource = 0;

        /**
         * ContractPriceResponse quoteId.
         * @member {string} quoteId
         * @memberof contractpb.ContractPriceResponse
         * @instance
         */
        ContractPriceResponse.prototype.quoteId = "";

        /**
         * ContractPriceResponse contractPricing.
         * @member {contractpb.ContractPriceResponse.IContractPricing|null|undefined} contractPricing
         * @memberof contractpb.ContractPriceResponse
         * @instance
         */
        ContractPriceResponse.prototype.contractPricing = null;

        /**
         * ContractPriceResponse quoteDetails.
         * @member {contractpb.ContractPriceResponse.IQuoteDetails|null|undefined} quoteDetails
         * @memberof contractpb.ContractPriceResponse
         * @instance
         */
        ContractPriceResponse.prototype.quoteDetails = null;

        /**
         * Creates a new ContractPriceResponse instance using the specified properties.
         * @function create
         * @memberof contractpb.ContractPriceResponse
         * @static
         * @param {contractpb.IContractPriceResponse=} [properties] Properties to set
         * @returns {contractpb.ContractPriceResponse} ContractPriceResponse instance
         */
        ContractPriceResponse.create = function create(properties) {
            return new ContractPriceResponse(properties);
        };

        /**
         * Encodes the specified ContractPriceResponse message. Does not implicitly {@link contractpb.ContractPriceResponse.verify|verify} messages.
         * @function encode
         * @memberof contractpb.ContractPriceResponse
         * @static
         * @param {contractpb.IContractPriceResponse} m ContractPriceResponse message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ContractPriceResponse.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.dataSource != null && Object.hasOwnProperty.call(m, "dataSource"))
                w.uint32(8).int32(m.dataSource);
            if (m.quoteId != null && Object.hasOwnProperty.call(m, "quoteId"))
                w.uint32(18).string(m.quoteId);
            if (m.contractPricing != null && Object.hasOwnProperty.call(m, "contractPricing"))
                $root.contractpb.ContractPriceResponse.ContractPricing.encode(m.contractPricing, w.uint32(26).fork()).ldelim();
            if (m.quoteDetails != null && Object.hasOwnProperty.call(m, "quoteDetails"))
                $root.contractpb.ContractPriceResponse.QuoteDetails.encode(m.quoteDetails, w.uint32(34).fork()).ldelim();
            return w;
        };

        /**
         * Decodes a ContractPriceResponse message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.ContractPriceResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.ContractPriceResponse} ContractPriceResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ContractPriceResponse.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.ContractPriceResponse();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.dataSource = r.int32();
                    break;
                case 2:
                    m.quoteId = r.string();
                    break;
                case 3:
                    m.contractPricing = $root.contractpb.ContractPriceResponse.ContractPricing.decode(r, r.uint32());
                    break;
                case 4:
                    m.quoteDetails = $root.contractpb.ContractPriceResponse.QuoteDetails.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        ContractPriceResponse.ContractPricing = (function() {

            /**
             * Properties of a ContractPricing.
             * @memberof contractpb.ContractPriceResponse
             * @interface IContractPricing
             * @property {contractpb.ContractPriceResponse.ContractPricing.ITotals|null} [totals] ContractPricing totals
             * @property {contractpb.ContractPriceResponse.ContractPricing.IBreakdown|null} [breakdown] ContractPricing breakdown
             */

            /**
             * Constructs a new ContractPricing.
             * @memberof contractpb.ContractPriceResponse
             * @classdesc Represents a ContractPricing.
             * @implements IContractPricing
             * @constructor
             * @param {contractpb.ContractPriceResponse.IContractPricing=} [p] Properties to set
             */
            function ContractPricing(p) {
                if (p)
                    for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                        if (p[ks[i]] != null)
                            this[ks[i]] = p[ks[i]];
            }

            /**
             * ContractPricing totals.
             * @member {contractpb.ContractPriceResponse.ContractPricing.ITotals|null|undefined} totals
             * @memberof contractpb.ContractPriceResponse.ContractPricing
             * @instance
             */
            ContractPricing.prototype.totals = null;

            /**
             * ContractPricing breakdown.
             * @member {contractpb.ContractPriceResponse.ContractPricing.IBreakdown|null|undefined} breakdown
             * @memberof contractpb.ContractPriceResponse.ContractPricing
             * @instance
             */
            ContractPricing.prototype.breakdown = null;

            /**
             * Creates a new ContractPricing instance using the specified properties.
             * @function create
             * @memberof contractpb.ContractPriceResponse.ContractPricing
             * @static
             * @param {contractpb.ContractPriceResponse.IContractPricing=} [properties] Properties to set
             * @returns {contractpb.ContractPriceResponse.ContractPricing} ContractPricing instance
             */
            ContractPricing.create = function create(properties) {
                return new ContractPricing(properties);
            };

            /**
             * Encodes the specified ContractPricing message. Does not implicitly {@link contractpb.ContractPriceResponse.ContractPricing.verify|verify} messages.
             * @function encode
             * @memberof contractpb.ContractPriceResponse.ContractPricing
             * @static
             * @param {contractpb.ContractPriceResponse.IContractPricing} m ContractPricing message or plain object to encode
             * @param {$protobuf.Writer} [w] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ContractPricing.encode = function encode(m, w) {
                if (!w)
                    w = $Writer.create();
                if (m.totals != null && Object.hasOwnProperty.call(m, "totals"))
                    $root.contractpb.ContractPriceResponse.ContractPricing.Totals.encode(m.totals, w.uint32(10).fork()).ldelim();
                if (m.breakdown != null && Object.hasOwnProperty.call(m, "breakdown"))
                    $root.contractpb.ContractPriceResponse.ContractPricing.Breakdown.encode(m.breakdown, w.uint32(18).fork()).ldelim();
                return w;
            };

            /**
             * Decodes a ContractPricing message from the specified reader or buffer.
             * @function decode
             * @memberof contractpb.ContractPriceResponse.ContractPricing
             * @static
             * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
             * @param {number} [l] Message length if known beforehand
             * @returns {contractpb.ContractPriceResponse.ContractPricing} ContractPricing
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ContractPricing.decode = function decode(r, l) {
                if (!(r instanceof $Reader))
                    r = $Reader.create(r);
                var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.ContractPriceResponse.ContractPricing();
                while (r.pos < c) {
                    var t = r.uint32();
                    switch (t >>> 3) {
                    case 1:
                        m.totals = $root.contractpb.ContractPriceResponse.ContractPricing.Totals.decode(r, r.uint32());
                        break;
                    case 2:
                        m.breakdown = $root.contractpb.ContractPriceResponse.ContractPricing.Breakdown.decode(r, r.uint32());
                        break;
                    default:
                        r.skipType(t & 7);
                        break;
                    }
                }
                return m;
            };

            ContractPricing.Totals = (function() {

                /**
                 * Properties of a Totals.
                 * @memberof contractpb.ContractPriceResponse.ContractPricing
                 * @interface ITotals
                 * @property {number|null} [price] Totals price
                 * @property {number|null} [tax] Totals tax
                 * @property {number|null} [taxableAmount] Totals taxableAmount
                 * @property {number|null} [sellersCoverageAmount] Totals sellersCoverageAmount
                 */

                /**
                 * Constructs a new Totals.
                 * @memberof contractpb.ContractPriceResponse.ContractPricing
                 * @classdesc Represents a Totals.
                 * @implements ITotals
                 * @constructor
                 * @param {contractpb.ContractPriceResponse.ContractPricing.ITotals=} [p] Properties to set
                 */
                function Totals(p) {
                    if (p)
                        for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                            if (p[ks[i]] != null)
                                this[ks[i]] = p[ks[i]];
                }

                /**
                 * Totals price.
                 * @member {number} price
                 * @memberof contractpb.ContractPriceResponse.ContractPricing.Totals
                 * @instance
                 */
                Totals.prototype.price = 0;

                /**
                 * Totals tax.
                 * @member {number} tax
                 * @memberof contractpb.ContractPriceResponse.ContractPricing.Totals
                 * @instance
                 */
                Totals.prototype.tax = 0;

                /**
                 * Totals taxableAmount.
                 * @member {number} taxableAmount
                 * @memberof contractpb.ContractPriceResponse.ContractPricing.Totals
                 * @instance
                 */
                Totals.prototype.taxableAmount = 0;

                /**
                 * Totals sellersCoverageAmount.
                 * @member {number} sellersCoverageAmount
                 * @memberof contractpb.ContractPriceResponse.ContractPricing.Totals
                 * @instance
                 */
                Totals.prototype.sellersCoverageAmount = 0;

                /**
                 * Creates a new Totals instance using the specified properties.
                 * @function create
                 * @memberof contractpb.ContractPriceResponse.ContractPricing.Totals
                 * @static
                 * @param {contractpb.ContractPriceResponse.ContractPricing.ITotals=} [properties] Properties to set
                 * @returns {contractpb.ContractPriceResponse.ContractPricing.Totals} Totals instance
                 */
                Totals.create = function create(properties) {
                    return new Totals(properties);
                };

                /**
                 * Encodes the specified Totals message. Does not implicitly {@link contractpb.ContractPriceResponse.ContractPricing.Totals.verify|verify} messages.
                 * @function encode
                 * @memberof contractpb.ContractPriceResponse.ContractPricing.Totals
                 * @static
                 * @param {contractpb.ContractPriceResponse.ContractPricing.ITotals} m Totals message or plain object to encode
                 * @param {$protobuf.Writer} [w] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Totals.encode = function encode(m, w) {
                    if (!w)
                        w = $Writer.create();
                    if (m.price != null && Object.hasOwnProperty.call(m, "price"))
                        w.uint32(9).double(m.price);
                    if (m.tax != null && Object.hasOwnProperty.call(m, "tax"))
                        w.uint32(17).double(m.tax);
                    if (m.taxableAmount != null && Object.hasOwnProperty.call(m, "taxableAmount"))
                        w.uint32(25).double(m.taxableAmount);
                    if (m.sellersCoverageAmount != null && Object.hasOwnProperty.call(m, "sellersCoverageAmount"))
                        w.uint32(37).float(m.sellersCoverageAmount);
                    return w;
                };

                /**
                 * Decodes a Totals message from the specified reader or buffer.
                 * @function decode
                 * @memberof contractpb.ContractPriceResponse.ContractPricing.Totals
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
                 * @param {number} [l] Message length if known beforehand
                 * @returns {contractpb.ContractPriceResponse.ContractPricing.Totals} Totals
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Totals.decode = function decode(r, l) {
                    if (!(r instanceof $Reader))
                        r = $Reader.create(r);
                    var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.ContractPriceResponse.ContractPricing.Totals();
                    while (r.pos < c) {
                        var t = r.uint32();
                        switch (t >>> 3) {
                        case 1:
                            m.price = r.double();
                            break;
                        case 2:
                            m.tax = r.double();
                            break;
                        case 3:
                            m.taxableAmount = r.double();
                            break;
                        case 4:
                            m.sellersCoverageAmount = r.float();
                            break;
                        default:
                            r.skipType(t & 7);
                            break;
                        }
                    }
                    return m;
                };

                return Totals;
            })();

            ContractPricing.Breakdown = (function() {

                /**
                 * Properties of a Breakdown.
                 * @memberof contractpb.ContractPriceResponse.ContractPricing
                 * @interface IBreakdown
                 * @property {contractpb.ContractPriceResponse.ContractPricing.Breakdown.ITotalsItem|null} [productTotals] Breakdown productTotals
                 * @property {contractpb.ContractPriceResponse.ContractPricing.Breakdown.ITotalsItem|null} [optionalTotals] Breakdown optionalTotals
                 * @property {contractpb.ContractPriceResponse.ContractPricing.Breakdown.ITotalsItem|null} [groupTotals] Breakdown groupTotals
                 * @property {contractpb.ContractPriceResponse.ContractPricing.Breakdown.ISellersCoverage|null} [sellersCoverage] Breakdown sellersCoverage
                 * @property {number|null} [productTierGuestUnitPrice] Breakdown productTierGuestUnitPrice
                 */

                /**
                 * Constructs a new Breakdown.
                 * @memberof contractpb.ContractPriceResponse.ContractPricing
                 * @classdesc Represents a Breakdown.
                 * @implements IBreakdown
                 * @constructor
                 * @param {contractpb.ContractPriceResponse.ContractPricing.IBreakdown=} [p] Properties to set
                 */
                function Breakdown(p) {
                    if (p)
                        for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                            if (p[ks[i]] != null)
                                this[ks[i]] = p[ks[i]];
                }

                /**
                 * Breakdown productTotals.
                 * @member {contractpb.ContractPriceResponse.ContractPricing.Breakdown.ITotalsItem|null|undefined} productTotals
                 * @memberof contractpb.ContractPriceResponse.ContractPricing.Breakdown
                 * @instance
                 */
                Breakdown.prototype.productTotals = null;

                /**
                 * Breakdown optionalTotals.
                 * @member {contractpb.ContractPriceResponse.ContractPricing.Breakdown.ITotalsItem|null|undefined} optionalTotals
                 * @memberof contractpb.ContractPriceResponse.ContractPricing.Breakdown
                 * @instance
                 */
                Breakdown.prototype.optionalTotals = null;

                /**
                 * Breakdown groupTotals.
                 * @member {contractpb.ContractPriceResponse.ContractPricing.Breakdown.ITotalsItem|null|undefined} groupTotals
                 * @memberof contractpb.ContractPriceResponse.ContractPricing.Breakdown
                 * @instance
                 */
                Breakdown.prototype.groupTotals = null;

                /**
                 * Breakdown sellersCoverage.
                 * @member {contractpb.ContractPriceResponse.ContractPricing.Breakdown.ISellersCoverage|null|undefined} sellersCoverage
                 * @memberof contractpb.ContractPriceResponse.ContractPricing.Breakdown
                 * @instance
                 */
                Breakdown.prototype.sellersCoverage = null;

                /**
                 * Breakdown productTierGuestUnitPrice.
                 * @member {number} productTierGuestUnitPrice
                 * @memberof contractpb.ContractPriceResponse.ContractPricing.Breakdown
                 * @instance
                 */
                Breakdown.prototype.productTierGuestUnitPrice = 0;

                /**
                 * Creates a new Breakdown instance using the specified properties.
                 * @function create
                 * @memberof contractpb.ContractPriceResponse.ContractPricing.Breakdown
                 * @static
                 * @param {contractpb.ContractPriceResponse.ContractPricing.IBreakdown=} [properties] Properties to set
                 * @returns {contractpb.ContractPriceResponse.ContractPricing.Breakdown} Breakdown instance
                 */
                Breakdown.create = function create(properties) {
                    return new Breakdown(properties);
                };

                /**
                 * Encodes the specified Breakdown message. Does not implicitly {@link contractpb.ContractPriceResponse.ContractPricing.Breakdown.verify|verify} messages.
                 * @function encode
                 * @memberof contractpb.ContractPriceResponse.ContractPricing.Breakdown
                 * @static
                 * @param {contractpb.ContractPriceResponse.ContractPricing.IBreakdown} m Breakdown message or plain object to encode
                 * @param {$protobuf.Writer} [w] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Breakdown.encode = function encode(m, w) {
                    if (!w)
                        w = $Writer.create();
                    if (m.productTotals != null && Object.hasOwnProperty.call(m, "productTotals"))
                        $root.contractpb.ContractPriceResponse.ContractPricing.Breakdown.TotalsItem.encode(m.productTotals, w.uint32(10).fork()).ldelim();
                    if (m.optionalTotals != null && Object.hasOwnProperty.call(m, "optionalTotals"))
                        $root.contractpb.ContractPriceResponse.ContractPricing.Breakdown.TotalsItem.encode(m.optionalTotals, w.uint32(18).fork()).ldelim();
                    if (m.groupTotals != null && Object.hasOwnProperty.call(m, "groupTotals"))
                        $root.contractpb.ContractPriceResponse.ContractPricing.Breakdown.TotalsItem.encode(m.groupTotals, w.uint32(26).fork()).ldelim();
                    if (m.sellersCoverage != null && Object.hasOwnProperty.call(m, "sellersCoverage"))
                        $root.contractpb.ContractPriceResponse.ContractPricing.Breakdown.SellersCoverage.encode(m.sellersCoverage, w.uint32(34).fork()).ldelim();
                    if (m.productTierGuestUnitPrice != null && Object.hasOwnProperty.call(m, "productTierGuestUnitPrice"))
                        w.uint32(41).double(m.productTierGuestUnitPrice);
                    return w;
                };

                /**
                 * Decodes a Breakdown message from the specified reader or buffer.
                 * @function decode
                 * @memberof contractpb.ContractPriceResponse.ContractPricing.Breakdown
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
                 * @param {number} [l] Message length if known beforehand
                 * @returns {contractpb.ContractPriceResponse.ContractPricing.Breakdown} Breakdown
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Breakdown.decode = function decode(r, l) {
                    if (!(r instanceof $Reader))
                        r = $Reader.create(r);
                    var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.ContractPriceResponse.ContractPricing.Breakdown();
                    while (r.pos < c) {
                        var t = r.uint32();
                        switch (t >>> 3) {
                        case 1:
                            m.productTotals = $root.contractpb.ContractPriceResponse.ContractPricing.Breakdown.TotalsItem.decode(r, r.uint32());
                            break;
                        case 2:
                            m.optionalTotals = $root.contractpb.ContractPriceResponse.ContractPricing.Breakdown.TotalsItem.decode(r, r.uint32());
                            break;
                        case 3:
                            m.groupTotals = $root.contractpb.ContractPriceResponse.ContractPricing.Breakdown.TotalsItem.decode(r, r.uint32());
                            break;
                        case 4:
                            m.sellersCoverage = $root.contractpb.ContractPriceResponse.ContractPricing.Breakdown.SellersCoverage.decode(r, r.uint32());
                            break;
                        case 5:
                            m.productTierGuestUnitPrice = r.double();
                            break;
                        default:
                            r.skipType(t & 7);
                            break;
                        }
                    }
                    return m;
                };

                Breakdown.TotalsItem = (function() {

                    /**
                     * Properties of a TotalsItem.
                     * @memberof contractpb.ContractPriceResponse.ContractPricing.Breakdown
                     * @interface ITotalsItem
                     * @property {number|null} [price] TotalsItem price
                     */

                    /**
                     * Constructs a new TotalsItem.
                     * @memberof contractpb.ContractPriceResponse.ContractPricing.Breakdown
                     * @classdesc Represents a TotalsItem.
                     * @implements ITotalsItem
                     * @constructor
                     * @param {contractpb.ContractPriceResponse.ContractPricing.Breakdown.ITotalsItem=} [p] Properties to set
                     */
                    function TotalsItem(p) {
                        if (p)
                            for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                                if (p[ks[i]] != null)
                                    this[ks[i]] = p[ks[i]];
                    }

                    /**
                     * TotalsItem price.
                     * @member {number} price
                     * @memberof contractpb.ContractPriceResponse.ContractPricing.Breakdown.TotalsItem
                     * @instance
                     */
                    TotalsItem.prototype.price = 0;

                    /**
                     * Creates a new TotalsItem instance using the specified properties.
                     * @function create
                     * @memberof contractpb.ContractPriceResponse.ContractPricing.Breakdown.TotalsItem
                     * @static
                     * @param {contractpb.ContractPriceResponse.ContractPricing.Breakdown.ITotalsItem=} [properties] Properties to set
                     * @returns {contractpb.ContractPriceResponse.ContractPricing.Breakdown.TotalsItem} TotalsItem instance
                     */
                    TotalsItem.create = function create(properties) {
                        return new TotalsItem(properties);
                    };

                    /**
                     * Encodes the specified TotalsItem message. Does not implicitly {@link contractpb.ContractPriceResponse.ContractPricing.Breakdown.TotalsItem.verify|verify} messages.
                     * @function encode
                     * @memberof contractpb.ContractPriceResponse.ContractPricing.Breakdown.TotalsItem
                     * @static
                     * @param {contractpb.ContractPriceResponse.ContractPricing.Breakdown.ITotalsItem} m TotalsItem message or plain object to encode
                     * @param {$protobuf.Writer} [w] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    TotalsItem.encode = function encode(m, w) {
                        if (!w)
                            w = $Writer.create();
                        if (m.price != null && Object.hasOwnProperty.call(m, "price"))
                            w.uint32(9).double(m.price);
                        return w;
                    };

                    /**
                     * Decodes a TotalsItem message from the specified reader or buffer.
                     * @function decode
                     * @memberof contractpb.ContractPriceResponse.ContractPricing.Breakdown.TotalsItem
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
                     * @param {number} [l] Message length if known beforehand
                     * @returns {contractpb.ContractPriceResponse.ContractPricing.Breakdown.TotalsItem} TotalsItem
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    TotalsItem.decode = function decode(r, l) {
                        if (!(r instanceof $Reader))
                            r = $Reader.create(r);
                        var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.ContractPriceResponse.ContractPricing.Breakdown.TotalsItem();
                        while (r.pos < c) {
                            var t = r.uint32();
                            switch (t >>> 3) {
                            case 1:
                                m.price = r.double();
                                break;
                            default:
                                r.skipType(t & 7);
                                break;
                            }
                        }
                        return m;
                    };

                    return TotalsItem;
                })();

                Breakdown.SellersCoverage = (function() {

                    /**
                     * Properties of a SellersCoverage.
                     * @memberof contractpb.ContractPriceResponse.ContractPricing.Breakdown
                     * @interface ISellersCoverage
                     * @property {number|null} [listingDays] SellersCoverage listingDays
                     * @property {number|null} [dailyRate] SellersCoverage dailyRate
                     */

                    /**
                     * Constructs a new SellersCoverage.
                     * @memberof contractpb.ContractPriceResponse.ContractPricing.Breakdown
                     * @classdesc Represents a SellersCoverage.
                     * @implements ISellersCoverage
                     * @constructor
                     * @param {contractpb.ContractPriceResponse.ContractPricing.Breakdown.ISellersCoverage=} [p] Properties to set
                     */
                    function SellersCoverage(p) {
                        if (p)
                            for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                                if (p[ks[i]] != null)
                                    this[ks[i]] = p[ks[i]];
                    }

                    /**
                     * SellersCoverage listingDays.
                     * @member {number} listingDays
                     * @memberof contractpb.ContractPriceResponse.ContractPricing.Breakdown.SellersCoverage
                     * @instance
                     */
                    SellersCoverage.prototype.listingDays = 0;

                    /**
                     * SellersCoverage dailyRate.
                     * @member {number} dailyRate
                     * @memberof contractpb.ContractPriceResponse.ContractPricing.Breakdown.SellersCoverage
                     * @instance
                     */
                    SellersCoverage.prototype.dailyRate = 0;

                    /**
                     * Creates a new SellersCoverage instance using the specified properties.
                     * @function create
                     * @memberof contractpb.ContractPriceResponse.ContractPricing.Breakdown.SellersCoverage
                     * @static
                     * @param {contractpb.ContractPriceResponse.ContractPricing.Breakdown.ISellersCoverage=} [properties] Properties to set
                     * @returns {contractpb.ContractPriceResponse.ContractPricing.Breakdown.SellersCoverage} SellersCoverage instance
                     */
                    SellersCoverage.create = function create(properties) {
                        return new SellersCoverage(properties);
                    };

                    /**
                     * Encodes the specified SellersCoverage message. Does not implicitly {@link contractpb.ContractPriceResponse.ContractPricing.Breakdown.SellersCoverage.verify|verify} messages.
                     * @function encode
                     * @memberof contractpb.ContractPriceResponse.ContractPricing.Breakdown.SellersCoverage
                     * @static
                     * @param {contractpb.ContractPriceResponse.ContractPricing.Breakdown.ISellersCoverage} m SellersCoverage message or plain object to encode
                     * @param {$protobuf.Writer} [w] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    SellersCoverage.encode = function encode(m, w) {
                        if (!w)
                            w = $Writer.create();
                        if (m.listingDays != null && Object.hasOwnProperty.call(m, "listingDays"))
                            w.uint32(8).int32(m.listingDays);
                        if (m.dailyRate != null && Object.hasOwnProperty.call(m, "dailyRate"))
                            w.uint32(21).float(m.dailyRate);
                        return w;
                    };

                    /**
                     * Decodes a SellersCoverage message from the specified reader or buffer.
                     * @function decode
                     * @memberof contractpb.ContractPriceResponse.ContractPricing.Breakdown.SellersCoverage
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
                     * @param {number} [l] Message length if known beforehand
                     * @returns {contractpb.ContractPriceResponse.ContractPricing.Breakdown.SellersCoverage} SellersCoverage
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    SellersCoverage.decode = function decode(r, l) {
                        if (!(r instanceof $Reader))
                            r = $Reader.create(r);
                        var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.ContractPriceResponse.ContractPricing.Breakdown.SellersCoverage();
                        while (r.pos < c) {
                            var t = r.uint32();
                            switch (t >>> 3) {
                            case 1:
                                m.listingDays = r.int32();
                                break;
                            case 2:
                                m.dailyRate = r.float();
                                break;
                            default:
                                r.skipType(t & 7);
                                break;
                            }
                        }
                        return m;
                    };

                    return SellersCoverage;
                })();

                return Breakdown;
            })();

            return ContractPricing;
        })();

        ContractPriceResponse.QuoteDetails = (function() {

            /**
             * Properties of a QuoteDetails.
             * @memberof contractpb.ContractPriceResponse
             * @interface IQuoteDetails
             * @property {number|null} [earnixRuleId] QuoteDetails earnixRuleId
             * @property {google.protobuf.ITimestamp|null} [timestamp] QuoteDetails timestamp
             */

            /**
             * Constructs a new QuoteDetails.
             * @memberof contractpb.ContractPriceResponse
             * @classdesc Represents a QuoteDetails.
             * @implements IQuoteDetails
             * @constructor
             * @param {contractpb.ContractPriceResponse.IQuoteDetails=} [p] Properties to set
             */
            function QuoteDetails(p) {
                if (p)
                    for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                        if (p[ks[i]] != null)
                            this[ks[i]] = p[ks[i]];
            }

            /**
             * QuoteDetails earnixRuleId.
             * @member {number} earnixRuleId
             * @memberof contractpb.ContractPriceResponse.QuoteDetails
             * @instance
             */
            QuoteDetails.prototype.earnixRuleId = 0;

            /**
             * QuoteDetails timestamp.
             * @member {google.protobuf.ITimestamp|null|undefined} timestamp
             * @memberof contractpb.ContractPriceResponse.QuoteDetails
             * @instance
             */
            QuoteDetails.prototype.timestamp = null;

            /**
             * Creates a new QuoteDetails instance using the specified properties.
             * @function create
             * @memberof contractpb.ContractPriceResponse.QuoteDetails
             * @static
             * @param {contractpb.ContractPriceResponse.IQuoteDetails=} [properties] Properties to set
             * @returns {contractpb.ContractPriceResponse.QuoteDetails} QuoteDetails instance
             */
            QuoteDetails.create = function create(properties) {
                return new QuoteDetails(properties);
            };

            /**
             * Encodes the specified QuoteDetails message. Does not implicitly {@link contractpb.ContractPriceResponse.QuoteDetails.verify|verify} messages.
             * @function encode
             * @memberof contractpb.ContractPriceResponse.QuoteDetails
             * @static
             * @param {contractpb.ContractPriceResponse.IQuoteDetails} m QuoteDetails message or plain object to encode
             * @param {$protobuf.Writer} [w] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            QuoteDetails.encode = function encode(m, w) {
                if (!w)
                    w = $Writer.create();
                if (m.earnixRuleId != null && Object.hasOwnProperty.call(m, "earnixRuleId"))
                    w.uint32(8).int32(m.earnixRuleId);
                if (m.timestamp != null && Object.hasOwnProperty.call(m, "timestamp"))
                    $root.google.protobuf.Timestamp.encode(m.timestamp, w.uint32(18).fork()).ldelim();
                return w;
            };

            /**
             * Decodes a QuoteDetails message from the specified reader or buffer.
             * @function decode
             * @memberof contractpb.ContractPriceResponse.QuoteDetails
             * @static
             * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
             * @param {number} [l] Message length if known beforehand
             * @returns {contractpb.ContractPriceResponse.QuoteDetails} QuoteDetails
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            QuoteDetails.decode = function decode(r, l) {
                if (!(r instanceof $Reader))
                    r = $Reader.create(r);
                var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.ContractPriceResponse.QuoteDetails();
                while (r.pos < c) {
                    var t = r.uint32();
                    switch (t >>> 3) {
                    case 1:
                        m.earnixRuleId = r.int32();
                        break;
                    case 2:
                        m.timestamp = $root.google.protobuf.Timestamp.decode(r, r.uint32());
                        break;
                    default:
                        r.skipType(t & 7);
                        break;
                    }
                }
                return m;
            };

            return QuoteDetails;
        })();

        return ContractPriceResponse;
    })();

    contractpb.CustomerSearchFilter = (function() {

        /**
         * Properties of a CustomerSearchFilter.
         * @memberof contractpb
         * @interface ICustomerSearchFilter
         * @property {string|null} [customerID] CustomerSearchFilter customerID
         * @property {Array.<string>|null} [phoneNumbers] CustomerSearchFilter phoneNumbers
         * @property {Array.<string>|null} [emails] CustomerSearchFilter emails
         * @property {google.protobuf.IBoolValue|null} [emailPreference] CustomerSearchFilter emailPreference
         */

        /**
         * Constructs a new CustomerSearchFilter.
         * @memberof contractpb
         * @classdesc Represents a CustomerSearchFilter.
         * @implements ICustomerSearchFilter
         * @constructor
         * @param {contractpb.ICustomerSearchFilter=} [p] Properties to set
         */
        function CustomerSearchFilter(p) {
            this.phoneNumbers = [];
            this.emails = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * CustomerSearchFilter customerID.
         * @member {string} customerID
         * @memberof contractpb.CustomerSearchFilter
         * @instance
         */
        CustomerSearchFilter.prototype.customerID = "";

        /**
         * CustomerSearchFilter phoneNumbers.
         * @member {Array.<string>} phoneNumbers
         * @memberof contractpb.CustomerSearchFilter
         * @instance
         */
        CustomerSearchFilter.prototype.phoneNumbers = $util.emptyArray;

        /**
         * CustomerSearchFilter emails.
         * @member {Array.<string>} emails
         * @memberof contractpb.CustomerSearchFilter
         * @instance
         */
        CustomerSearchFilter.prototype.emails = $util.emptyArray;

        /**
         * CustomerSearchFilter emailPreference.
         * @member {google.protobuf.IBoolValue|null|undefined} emailPreference
         * @memberof contractpb.CustomerSearchFilter
         * @instance
         */
        CustomerSearchFilter.prototype.emailPreference = null;

        /**
         * Creates a new CustomerSearchFilter instance using the specified properties.
         * @function create
         * @memberof contractpb.CustomerSearchFilter
         * @static
         * @param {contractpb.ICustomerSearchFilter=} [properties] Properties to set
         * @returns {contractpb.CustomerSearchFilter} CustomerSearchFilter instance
         */
        CustomerSearchFilter.create = function create(properties) {
            return new CustomerSearchFilter(properties);
        };

        /**
         * Encodes the specified CustomerSearchFilter message. Does not implicitly {@link contractpb.CustomerSearchFilter.verify|verify} messages.
         * @function encode
         * @memberof contractpb.CustomerSearchFilter
         * @static
         * @param {contractpb.ICustomerSearchFilter} m CustomerSearchFilter message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CustomerSearchFilter.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.customerID != null && Object.hasOwnProperty.call(m, "customerID"))
                w.uint32(10).string(m.customerID);
            if (m.phoneNumbers != null && m.phoneNumbers.length) {
                for (var i = 0; i < m.phoneNumbers.length; ++i)
                    w.uint32(18).string(m.phoneNumbers[i]);
            }
            if (m.emails != null && m.emails.length) {
                for (var i = 0; i < m.emails.length; ++i)
                    w.uint32(26).string(m.emails[i]);
            }
            if (m.emailPreference != null && Object.hasOwnProperty.call(m, "emailPreference"))
                $root.google.protobuf.BoolValue.encode(m.emailPreference, w.uint32(34).fork()).ldelim();
            return w;
        };

        /**
         * Decodes a CustomerSearchFilter message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.CustomerSearchFilter
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.CustomerSearchFilter} CustomerSearchFilter
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CustomerSearchFilter.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.CustomerSearchFilter();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.customerID = r.string();
                    break;
                case 2:
                    if (!(m.phoneNumbers && m.phoneNumbers.length))
                        m.phoneNumbers = [];
                    m.phoneNumbers.push(r.string());
                    break;
                case 3:
                    if (!(m.emails && m.emails.length))
                        m.emails = [];
                    m.emails.push(r.string());
                    break;
                case 4:
                    m.emailPreference = $root.google.protobuf.BoolValue.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return CustomerSearchFilter;
    })();

    /**
     * OfficeType enum.
     * @name contractpb.OfficeType
     * @enum {number}
     * @property {number} INVALID_OFFICE=0 INVALID_OFFICE value
     * @property {number} INITIATING_OFFICE=1 INITIATING_OFFICE value
     * @property {number} COOPERATING_OFFICE=2 COOPERATING_OFFICE value
     * @property {number} CLOSING_OFFICE=3 CLOSING_OFFICE value
     */
    contractpb.OfficeType = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "INVALID_OFFICE"] = 0;
        values[valuesById[1] = "INITIATING_OFFICE"] = 1;
        values[valuesById[2] = "COOPERATING_OFFICE"] = 2;
        values[valuesById[3] = "CLOSING_OFFICE"] = 3;
        return values;
    })();

    contractpb.OfficeSearchFilter = (function() {

        /**
         * Properties of an OfficeSearchFilter.
         * @memberof contractpb
         * @interface IOfficeSearchFilter
         * @property {string|null} [officeID] OfficeSearchFilter officeID
         * @property {Array.<contractpb.OfficeType>|null} [types] OfficeSearchFilter types
         * @property {Array.<contractpb.RepresentsSide>|null} [representsSides] OfficeSearchFilter representsSides
         */

        /**
         * Constructs a new OfficeSearchFilter.
         * @memberof contractpb
         * @classdesc Represents an OfficeSearchFilter.
         * @implements IOfficeSearchFilter
         * @constructor
         * @param {contractpb.IOfficeSearchFilter=} [p] Properties to set
         */
        function OfficeSearchFilter(p) {
            this.types = [];
            this.representsSides = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * OfficeSearchFilter officeID.
         * @member {string} officeID
         * @memberof contractpb.OfficeSearchFilter
         * @instance
         */
        OfficeSearchFilter.prototype.officeID = "";

        /**
         * OfficeSearchFilter types.
         * @member {Array.<contractpb.OfficeType>} types
         * @memberof contractpb.OfficeSearchFilter
         * @instance
         */
        OfficeSearchFilter.prototype.types = $util.emptyArray;

        /**
         * OfficeSearchFilter representsSides.
         * @member {Array.<contractpb.RepresentsSide>} representsSides
         * @memberof contractpb.OfficeSearchFilter
         * @instance
         */
        OfficeSearchFilter.prototype.representsSides = $util.emptyArray;

        /**
         * Creates a new OfficeSearchFilter instance using the specified properties.
         * @function create
         * @memberof contractpb.OfficeSearchFilter
         * @static
         * @param {contractpb.IOfficeSearchFilter=} [properties] Properties to set
         * @returns {contractpb.OfficeSearchFilter} OfficeSearchFilter instance
         */
        OfficeSearchFilter.create = function create(properties) {
            return new OfficeSearchFilter(properties);
        };

        /**
         * Encodes the specified OfficeSearchFilter message. Does not implicitly {@link contractpb.OfficeSearchFilter.verify|verify} messages.
         * @function encode
         * @memberof contractpb.OfficeSearchFilter
         * @static
         * @param {contractpb.IOfficeSearchFilter} m OfficeSearchFilter message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        OfficeSearchFilter.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.officeID != null && Object.hasOwnProperty.call(m, "officeID"))
                w.uint32(10).string(m.officeID);
            if (m.types != null && m.types.length) {
                w.uint32(18).fork();
                for (var i = 0; i < m.types.length; ++i)
                    w.int32(m.types[i]);
                w.ldelim();
            }
            if (m.representsSides != null && m.representsSides.length) {
                w.uint32(26).fork();
                for (var i = 0; i < m.representsSides.length; ++i)
                    w.int32(m.representsSides[i]);
                w.ldelim();
            }
            return w;
        };

        /**
         * Decodes an OfficeSearchFilter message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.OfficeSearchFilter
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.OfficeSearchFilter} OfficeSearchFilter
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        OfficeSearchFilter.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.OfficeSearchFilter();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.officeID = r.string();
                    break;
                case 2:
                    if (!(m.types && m.types.length))
                        m.types = [];
                    if ((t & 7) === 2) {
                        var c2 = r.uint32() + r.pos;
                        while (r.pos < c2)
                            m.types.push(r.int32());
                    } else
                        m.types.push(r.int32());
                    break;
                case 3:
                    if (!(m.representsSides && m.representsSides.length))
                        m.representsSides = [];
                    if ((t & 7) === 2) {
                        var c2 = r.uint32() + r.pos;
                        while (r.pos < c2)
                            m.representsSides.push(r.int32());
                    } else
                        m.representsSides.push(r.int32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return OfficeSearchFilter;
    })();

    contractpb.AgentSearchFilter = (function() {

        /**
         * Properties of an AgentSearchFilter.
         * @memberof contractpb
         * @interface IAgentSearchFilter
         * @property {string|null} [agentID] AgentSearchFilter agentID
         * @property {Array.<contractpb.AgentSearchFilter.AgentSearchType>|null} [type] AgentSearchFilter type
         * @property {Array.<contractpb.RepresentsSide>|null} [representing] AgentSearchFilter representing
         */

        /**
         * Constructs a new AgentSearchFilter.
         * @memberof contractpb
         * @classdesc Represents an AgentSearchFilter.
         * @implements IAgentSearchFilter
         * @constructor
         * @param {contractpb.IAgentSearchFilter=} [p] Properties to set
         */
        function AgentSearchFilter(p) {
            this.type = [];
            this.representing = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * AgentSearchFilter agentID.
         * @member {string} agentID
         * @memberof contractpb.AgentSearchFilter
         * @instance
         */
        AgentSearchFilter.prototype.agentID = "";

        /**
         * AgentSearchFilter type.
         * @member {Array.<contractpb.AgentSearchFilter.AgentSearchType>} type
         * @memberof contractpb.AgentSearchFilter
         * @instance
         */
        AgentSearchFilter.prototype.type = $util.emptyArray;

        /**
         * AgentSearchFilter representing.
         * @member {Array.<contractpb.RepresentsSide>} representing
         * @memberof contractpb.AgentSearchFilter
         * @instance
         */
        AgentSearchFilter.prototype.representing = $util.emptyArray;

        /**
         * Creates a new AgentSearchFilter instance using the specified properties.
         * @function create
         * @memberof contractpb.AgentSearchFilter
         * @static
         * @param {contractpb.IAgentSearchFilter=} [properties] Properties to set
         * @returns {contractpb.AgentSearchFilter} AgentSearchFilter instance
         */
        AgentSearchFilter.create = function create(properties) {
            return new AgentSearchFilter(properties);
        };

        /**
         * Encodes the specified AgentSearchFilter message. Does not implicitly {@link contractpb.AgentSearchFilter.verify|verify} messages.
         * @function encode
         * @memberof contractpb.AgentSearchFilter
         * @static
         * @param {contractpb.IAgentSearchFilter} m AgentSearchFilter message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AgentSearchFilter.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.agentID != null && Object.hasOwnProperty.call(m, "agentID"))
                w.uint32(10).string(m.agentID);
            if (m.type != null && m.type.length) {
                w.uint32(18).fork();
                for (var i = 0; i < m.type.length; ++i)
                    w.int32(m.type[i]);
                w.ldelim();
            }
            if (m.representing != null && m.representing.length) {
                w.uint32(26).fork();
                for (var i = 0; i < m.representing.length; ++i)
                    w.int32(m.representing[i]);
                w.ldelim();
            }
            return w;
        };

        /**
         * Decodes an AgentSearchFilter message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.AgentSearchFilter
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.AgentSearchFilter} AgentSearchFilter
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AgentSearchFilter.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.AgentSearchFilter();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.agentID = r.string();
                    break;
                case 2:
                    if (!(m.type && m.type.length))
                        m.type = [];
                    if ((t & 7) === 2) {
                        var c2 = r.uint32() + r.pos;
                        while (r.pos < c2)
                            m.type.push(r.int32());
                    } else
                        m.type.push(r.int32());
                    break;
                case 3:
                    if (!(m.representing && m.representing.length))
                        m.representing = [];
                    if ((t & 7) === 2) {
                        var c2 = r.uint32() + r.pos;
                        while (r.pos < c2)
                            m.representing.push(r.int32());
                    } else
                        m.representing.push(r.int32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        /**
         * AgentSearchType enum.
         * @name contractpb.AgentSearchFilter.AgentSearchType
         * @enum {number}
         * @property {number} RE=0 RE value
         * @property {number} CC=1 CC value
         */
        AgentSearchFilter.AgentSearchType = (function() {
            const valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "RE"] = 0;
            values[valuesById[1] = "CC"] = 1;
            return values;
        })();

        return AgentSearchFilter;
    })();

    contractpb.DateFilter = (function() {

        /**
         * Properties of a DateFilter.
         * @memberof contractpb
         * @interface IDateFilter
         * @property {common.IDate|null} [to] DateFilter to
         * @property {common.IDate|null} [from] DateFilter from
         * @property {Array.<contractpb.DateType>|null} [dateTypes] DateFilter dateTypes
         * @property {contractpb.DateSearchType|null} [dateSearchType] DateFilter dateSearchType
         */

        /**
         * Constructs a new DateFilter.
         * @memberof contractpb
         * @classdesc Represents a DateFilter.
         * @implements IDateFilter
         * @constructor
         * @param {contractpb.IDateFilter=} [p] Properties to set
         */
        function DateFilter(p) {
            this.dateTypes = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * DateFilter to.
         * @member {common.IDate|null|undefined} to
         * @memberof contractpb.DateFilter
         * @instance
         */
        DateFilter.prototype.to = null;

        /**
         * DateFilter from.
         * @member {common.IDate|null|undefined} from
         * @memberof contractpb.DateFilter
         * @instance
         */
        DateFilter.prototype.from = null;

        /**
         * DateFilter dateTypes.
         * @member {Array.<contractpb.DateType>} dateTypes
         * @memberof contractpb.DateFilter
         * @instance
         */
        DateFilter.prototype.dateTypes = $util.emptyArray;

        /**
         * DateFilter dateSearchType.
         * @member {contractpb.DateSearchType} dateSearchType
         * @memberof contractpb.DateFilter
         * @instance
         */
        DateFilter.prototype.dateSearchType = 0;

        /**
         * Creates a new DateFilter instance using the specified properties.
         * @function create
         * @memberof contractpb.DateFilter
         * @static
         * @param {contractpb.IDateFilter=} [properties] Properties to set
         * @returns {contractpb.DateFilter} DateFilter instance
         */
        DateFilter.create = function create(properties) {
            return new DateFilter(properties);
        };

        /**
         * Encodes the specified DateFilter message. Does not implicitly {@link contractpb.DateFilter.verify|verify} messages.
         * @function encode
         * @memberof contractpb.DateFilter
         * @static
         * @param {contractpb.IDateFilter} m DateFilter message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        DateFilter.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.to != null && Object.hasOwnProperty.call(m, "to"))
                $root.common.Date.encode(m.to, w.uint32(10).fork()).ldelim();
            if (m.from != null && Object.hasOwnProperty.call(m, "from"))
                $root.common.Date.encode(m.from, w.uint32(18).fork()).ldelim();
            if (m.dateTypes != null && m.dateTypes.length) {
                w.uint32(26).fork();
                for (var i = 0; i < m.dateTypes.length; ++i)
                    w.int32(m.dateTypes[i]);
                w.ldelim();
            }
            if (m.dateSearchType != null && Object.hasOwnProperty.call(m, "dateSearchType"))
                w.uint32(32).int32(m.dateSearchType);
            return w;
        };

        /**
         * Decodes a DateFilter message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.DateFilter
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.DateFilter} DateFilter
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        DateFilter.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.DateFilter();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.to = $root.common.Date.decode(r, r.uint32());
                    break;
                case 2:
                    m.from = $root.common.Date.decode(r, r.uint32());
                    break;
                case 3:
                    if (!(m.dateTypes && m.dateTypes.length))
                        m.dateTypes = [];
                    if ((t & 7) === 2) {
                        var c2 = r.uint32() + r.pos;
                        while (r.pos < c2)
                            m.dateTypes.push(r.int32());
                    } else
                        m.dateTypes.push(r.int32());
                    break;
                case 4:
                    m.dateSearchType = r.int32();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return DateFilter;
    })();

    /**
     * DateSearchType enum.
     * @name contractpb.DateSearchType
     * @enum {number}
     * @property {number} DATE_SEARCH_TYPE_UNDEFINED=0 DATE_SEARCH_TYPE_UNDEFINED value
     * @property {number} EFFECTIVE=1 EFFECTIVE value
     * @property {number} EXPIRATION=2 EXPIRATION value
     */
    contractpb.DateSearchType = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "DATE_SEARCH_TYPE_UNDEFINED"] = 0;
        values[valuesById[1] = "EFFECTIVE"] = 1;
        values[valuesById[2] = "EXPIRATION"] = 2;
        return values;
    })();

    /**
     * DateType enum.
     * @name contractpb.DateType
     * @enum {number}
     * @property {number} NO_DATE=0 NO_DATE value
     * @property {number} HOLD=1 HOLD value
     * @property {number} ESTCOE=2 ESTCOE value
     * @property {number} HOLDDATE=3 HOLDDATE value
     * @property {number} CLOSPAY=4 CLOSPAY value
     * @property {number} ENTRYDATE=5 ENTRYDATE value
     * @property {number} LISTCOVEFF=6 LISTCOVEFF value
     * @property {number} LISTDATE=7 LISTDATE value
     * @property {number} TAXDATE=8 TAXDATE value
     * @property {number} EFFDATE=9 EFFDATE value
     * @property {number} START=10 START value
     * @property {number} EXP=11 EXP value
     * @property {number} ARCHDATE=12 ARCHDATE value
     * @property {number} PRM_GL_PRD=13 PRM_GL_PRD value
     * @property {number} ACCTDATE=14 ACCTDATE value
     * @property {number} WEB_CANCEL=15 WEB_CANCEL value
     * @property {number} WEBCANCEL=16 WEBCANCEL value
     * @property {number} LIST=17 LIST value
     * @property {number} PRICEDATE=18 PRICEDATE value
     * @property {number} WRSALEDATE=19 WRSALEDATE value
     * @property {number} WRPROCDATE=20 WRPROCDATE value
     * @property {number} EFF=21 EFF value
     */
    contractpb.DateType = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "NO_DATE"] = 0;
        values[valuesById[1] = "HOLD"] = 1;
        values[valuesById[2] = "ESTCOE"] = 2;
        values[valuesById[3] = "HOLDDATE"] = 3;
        values[valuesById[4] = "CLOSPAY"] = 4;
        values[valuesById[5] = "ENTRYDATE"] = 5;
        values[valuesById[6] = "LISTCOVEFF"] = 6;
        values[valuesById[7] = "LISTDATE"] = 7;
        values[valuesById[8] = "TAXDATE"] = 8;
        values[valuesById[9] = "EFFDATE"] = 9;
        values[valuesById[10] = "START"] = 10;
        values[valuesById[11] = "EXP"] = 11;
        values[valuesById[12] = "ARCHDATE"] = 12;
        values[valuesById[13] = "PRM_GL_PRD"] = 13;
        values[valuesById[14] = "ACCTDATE"] = 14;
        values[valuesById[15] = "WEB_CANCEL"] = 15;
        values[valuesById[16] = "WEBCANCEL"] = 16;
        values[valuesById[17] = "LIST"] = 17;
        values[valuesById[18] = "PRICEDATE"] = 18;
        values[valuesById[19] = "WRSALEDATE"] = 19;
        values[valuesById[20] = "WRPROCDATE"] = 20;
        values[valuesById[21] = "EFF"] = 21;
        return values;
    })();

    /**
     * ContractStatus enum.
     * @name contractpb.ContractStatus
     * @enum {number}
     * @property {number} CONTRACT_STATUS_UNDEFINED=0 CONTRACT_STATUS_UNDEFINED value
     * @property {number} A=1 A value
     * @property {number} L=2 L value
     * @property {number} X=3 X value
     * @property {number} C=4 C value
     * @property {number} H=5 H value
     */
    contractpb.ContractStatus = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "CONTRACT_STATUS_UNDEFINED"] = 0;
        values[valuesById[1] = "A"] = 1;
        values[valuesById[2] = "L"] = 2;
        values[valuesById[3] = "X"] = 3;
        values[valuesById[4] = "C"] = 4;
        values[valuesById[5] = "H"] = 5;
        return values;
    })();

    contractpb.SearchFilters = (function() {

        /**
         * Properties of a SearchFilters.
         * @memberof contractpb
         * @interface ISearchFilters
         * @property {contractpb.IContractPropertySearchFilter|null} [coveredPropertyAddress] SearchFilters coveredPropertyAddress
         * @property {contractpb.ICustomerSearchFilter|null} [customerSearchFilter] SearchFilters customerSearchFilter
         * @property {Array.<contractpb.IOfficeSearchFilter>|null} [officeSearchFilters] SearchFilters officeSearchFilters
         * @property {Array.<contractpb.IAgentSearchFilter>|null} [agentSearchFilters] SearchFilters agentSearchFilters
         * @property {Array.<contractpb.ContractStatus>|null} [statuses] SearchFilters statuses
         * @property {contractpb.IDateFilter|null} [entryDateRange] SearchFilters entryDateRange
         * @property {Array.<contractpb.SalesChannel>|null} [salesChannels] SearchFilters salesChannels
         * @property {boolean|null} [isContractCurrent] SearchFilters isContractCurrent
         * @property {Array.<common.Tenant>|null} [tenant] SearchFilters tenant
         * @property {Array.<string>|null} [pvId] SearchFilters pvId
         * @property {number|null} [productId] SearchFilters productId
         * @property {contractpb.IRenewalsSearchFilter|null} [renewalSearch] SearchFilters renewalSearch
         * @property {contractpb.IInvoiceSearchFilter|null} [invoiceSearchFilter] SearchFilters invoiceSearchFilter
         * @property {Array.<contractpb.IContractDetail>|null} [contractDetails] SearchFilters contractDetails
         */

        /**
         * Constructs a new SearchFilters.
         * @memberof contractpb
         * @classdesc Represents a SearchFilters.
         * @implements ISearchFilters
         * @constructor
         * @param {contractpb.ISearchFilters=} [p] Properties to set
         */
        function SearchFilters(p) {
            this.officeSearchFilters = [];
            this.agentSearchFilters = [];
            this.statuses = [];
            this.salesChannels = [];
            this.tenant = [];
            this.pvId = [];
            this.contractDetails = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * SearchFilters coveredPropertyAddress.
         * @member {contractpb.IContractPropertySearchFilter|null|undefined} coveredPropertyAddress
         * @memberof contractpb.SearchFilters
         * @instance
         */
        SearchFilters.prototype.coveredPropertyAddress = null;

        /**
         * SearchFilters customerSearchFilter.
         * @member {contractpb.ICustomerSearchFilter|null|undefined} customerSearchFilter
         * @memberof contractpb.SearchFilters
         * @instance
         */
        SearchFilters.prototype.customerSearchFilter = null;

        /**
         * SearchFilters officeSearchFilters.
         * @member {Array.<contractpb.IOfficeSearchFilter>} officeSearchFilters
         * @memberof contractpb.SearchFilters
         * @instance
         */
        SearchFilters.prototype.officeSearchFilters = $util.emptyArray;

        /**
         * SearchFilters agentSearchFilters.
         * @member {Array.<contractpb.IAgentSearchFilter>} agentSearchFilters
         * @memberof contractpb.SearchFilters
         * @instance
         */
        SearchFilters.prototype.agentSearchFilters = $util.emptyArray;

        /**
         * SearchFilters statuses.
         * @member {Array.<contractpb.ContractStatus>} statuses
         * @memberof contractpb.SearchFilters
         * @instance
         */
        SearchFilters.prototype.statuses = $util.emptyArray;

        /**
         * SearchFilters entryDateRange.
         * @member {contractpb.IDateFilter|null|undefined} entryDateRange
         * @memberof contractpb.SearchFilters
         * @instance
         */
        SearchFilters.prototype.entryDateRange = null;

        /**
         * SearchFilters salesChannels.
         * @member {Array.<contractpb.SalesChannel>} salesChannels
         * @memberof contractpb.SearchFilters
         * @instance
         */
        SearchFilters.prototype.salesChannels = $util.emptyArray;

        /**
         * SearchFilters isContractCurrent.
         * @member {boolean} isContractCurrent
         * @memberof contractpb.SearchFilters
         * @instance
         */
        SearchFilters.prototype.isContractCurrent = false;

        /**
         * SearchFilters tenant.
         * @member {Array.<common.Tenant>} tenant
         * @memberof contractpb.SearchFilters
         * @instance
         */
        SearchFilters.prototype.tenant = $util.emptyArray;

        /**
         * SearchFilters pvId.
         * @member {Array.<string>} pvId
         * @memberof contractpb.SearchFilters
         * @instance
         */
        SearchFilters.prototype.pvId = $util.emptyArray;

        /**
         * SearchFilters productId.
         * @member {number} productId
         * @memberof contractpb.SearchFilters
         * @instance
         */
        SearchFilters.prototype.productId = 0;

        /**
         * SearchFilters renewalSearch.
         * @member {contractpb.IRenewalsSearchFilter|null|undefined} renewalSearch
         * @memberof contractpb.SearchFilters
         * @instance
         */
        SearchFilters.prototype.renewalSearch = null;

        /**
         * SearchFilters invoiceSearchFilter.
         * @member {contractpb.IInvoiceSearchFilter|null|undefined} invoiceSearchFilter
         * @memberof contractpb.SearchFilters
         * @instance
         */
        SearchFilters.prototype.invoiceSearchFilter = null;

        /**
         * SearchFilters contractDetails.
         * @member {Array.<contractpb.IContractDetail>} contractDetails
         * @memberof contractpb.SearchFilters
         * @instance
         */
        SearchFilters.prototype.contractDetails = $util.emptyArray;

        /**
         * Creates a new SearchFilters instance using the specified properties.
         * @function create
         * @memberof contractpb.SearchFilters
         * @static
         * @param {contractpb.ISearchFilters=} [properties] Properties to set
         * @returns {contractpb.SearchFilters} SearchFilters instance
         */
        SearchFilters.create = function create(properties) {
            return new SearchFilters(properties);
        };

        /**
         * Encodes the specified SearchFilters message. Does not implicitly {@link contractpb.SearchFilters.verify|verify} messages.
         * @function encode
         * @memberof contractpb.SearchFilters
         * @static
         * @param {contractpb.ISearchFilters} m SearchFilters message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SearchFilters.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.coveredPropertyAddress != null && Object.hasOwnProperty.call(m, "coveredPropertyAddress"))
                $root.contractpb.ContractPropertySearchFilter.encode(m.coveredPropertyAddress, w.uint32(10).fork()).ldelim();
            if (m.customerSearchFilter != null && Object.hasOwnProperty.call(m, "customerSearchFilter"))
                $root.contractpb.CustomerSearchFilter.encode(m.customerSearchFilter, w.uint32(18).fork()).ldelim();
            if (m.officeSearchFilters != null && m.officeSearchFilters.length) {
                for (var i = 0; i < m.officeSearchFilters.length; ++i)
                    $root.contractpb.OfficeSearchFilter.encode(m.officeSearchFilters[i], w.uint32(26).fork()).ldelim();
            }
            if (m.agentSearchFilters != null && m.agentSearchFilters.length) {
                for (var i = 0; i < m.agentSearchFilters.length; ++i)
                    $root.contractpb.AgentSearchFilter.encode(m.agentSearchFilters[i], w.uint32(34).fork()).ldelim();
            }
            if (m.statuses != null && m.statuses.length) {
                w.uint32(42).fork();
                for (var i = 0; i < m.statuses.length; ++i)
                    w.int32(m.statuses[i]);
                w.ldelim();
            }
            if (m.entryDateRange != null && Object.hasOwnProperty.call(m, "entryDateRange"))
                $root.contractpb.DateFilter.encode(m.entryDateRange, w.uint32(50).fork()).ldelim();
            if (m.salesChannels != null && m.salesChannels.length) {
                w.uint32(58).fork();
                for (var i = 0; i < m.salesChannels.length; ++i)
                    w.int32(m.salesChannels[i]);
                w.ldelim();
            }
            if (m.isContractCurrent != null && Object.hasOwnProperty.call(m, "isContractCurrent"))
                w.uint32(64).bool(m.isContractCurrent);
            if (m.tenant != null && m.tenant.length) {
                w.uint32(74).fork();
                for (var i = 0; i < m.tenant.length; ++i)
                    w.int32(m.tenant[i]);
                w.ldelim();
            }
            if (m.pvId != null && m.pvId.length) {
                for (var i = 0; i < m.pvId.length; ++i)
                    w.uint32(82).string(m.pvId[i]);
            }
            if (m.productId != null && Object.hasOwnProperty.call(m, "productId"))
                w.uint32(88).int32(m.productId);
            if (m.renewalSearch != null && Object.hasOwnProperty.call(m, "renewalSearch"))
                $root.contractpb.RenewalsSearchFilter.encode(m.renewalSearch, w.uint32(106).fork()).ldelim();
            if (m.invoiceSearchFilter != null && Object.hasOwnProperty.call(m, "invoiceSearchFilter"))
                $root.contractpb.InvoiceSearchFilter.encode(m.invoiceSearchFilter, w.uint32(114).fork()).ldelim();
            if (m.contractDetails != null && m.contractDetails.length) {
                for (var i = 0; i < m.contractDetails.length; ++i)
                    $root.contractpb.ContractDetail.encode(m.contractDetails[i], w.uint32(122).fork()).ldelim();
            }
            return w;
        };

        /**
         * Decodes a SearchFilters message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.SearchFilters
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.SearchFilters} SearchFilters
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SearchFilters.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.SearchFilters();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.coveredPropertyAddress = $root.contractpb.ContractPropertySearchFilter.decode(r, r.uint32());
                    break;
                case 2:
                    m.customerSearchFilter = $root.contractpb.CustomerSearchFilter.decode(r, r.uint32());
                    break;
                case 3:
                    if (!(m.officeSearchFilters && m.officeSearchFilters.length))
                        m.officeSearchFilters = [];
                    m.officeSearchFilters.push($root.contractpb.OfficeSearchFilter.decode(r, r.uint32()));
                    break;
                case 4:
                    if (!(m.agentSearchFilters && m.agentSearchFilters.length))
                        m.agentSearchFilters = [];
                    m.agentSearchFilters.push($root.contractpb.AgentSearchFilter.decode(r, r.uint32()));
                    break;
                case 5:
                    if (!(m.statuses && m.statuses.length))
                        m.statuses = [];
                    if ((t & 7) === 2) {
                        var c2 = r.uint32() + r.pos;
                        while (r.pos < c2)
                            m.statuses.push(r.int32());
                    } else
                        m.statuses.push(r.int32());
                    break;
                case 6:
                    m.entryDateRange = $root.contractpb.DateFilter.decode(r, r.uint32());
                    break;
                case 7:
                    if (!(m.salesChannels && m.salesChannels.length))
                        m.salesChannels = [];
                    if ((t & 7) === 2) {
                        var c2 = r.uint32() + r.pos;
                        while (r.pos < c2)
                            m.salesChannels.push(r.int32());
                    } else
                        m.salesChannels.push(r.int32());
                    break;
                case 8:
                    m.isContractCurrent = r.bool();
                    break;
                case 9:
                    if (!(m.tenant && m.tenant.length))
                        m.tenant = [];
                    if ((t & 7) === 2) {
                        var c2 = r.uint32() + r.pos;
                        while (r.pos < c2)
                            m.tenant.push(r.int32());
                    } else
                        m.tenant.push(r.int32());
                    break;
                case 10:
                    if (!(m.pvId && m.pvId.length))
                        m.pvId = [];
                    m.pvId.push(r.string());
                    break;
                case 11:
                    m.productId = r.int32();
                    break;
                case 13:
                    m.renewalSearch = $root.contractpb.RenewalsSearchFilter.decode(r, r.uint32());
                    break;
                case 14:
                    m.invoiceSearchFilter = $root.contractpb.InvoiceSearchFilter.decode(r, r.uint32());
                    break;
                case 15:
                    if (!(m.contractDetails && m.contractDetails.length))
                        m.contractDetails = [];
                    m.contractDetails.push($root.contractpb.ContractDetail.decode(r, r.uint32()));
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return SearchFilters;
    })();

    /**
     * InvoiceMonths enum.
     * @name contractpb.InvoiceMonths
     * @enum {number}
     * @property {number} UNKNOWN_MONTH=0 UNKNOWN_MONTH value
     * @property {number} JANUARY=1 JANUARY value
     * @property {number} FEBRUARY=2 FEBRUARY value
     * @property {number} MARCH=3 MARCH value
     * @property {number} APRIL=4 APRIL value
     * @property {number} MAY=5 MAY value
     * @property {number} JUNE=6 JUNE value
     * @property {number} JULY=7 JULY value
     * @property {number} AUGUST=8 AUGUST value
     * @property {number} SEPTEMBER=9 SEPTEMBER value
     * @property {number} OCTOBER=10 OCTOBER value
     * @property {number} NOVEMBER=11 NOVEMBER value
     * @property {number} DECEMBER=12 DECEMBER value
     */
    contractpb.InvoiceMonths = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "UNKNOWN_MONTH"] = 0;
        values[valuesById[1] = "JANUARY"] = 1;
        values[valuesById[2] = "FEBRUARY"] = 2;
        values[valuesById[3] = "MARCH"] = 3;
        values[valuesById[4] = "APRIL"] = 4;
        values[valuesById[5] = "MAY"] = 5;
        values[valuesById[6] = "JUNE"] = 6;
        values[valuesById[7] = "JULY"] = 7;
        values[valuesById[8] = "AUGUST"] = 8;
        values[valuesById[9] = "SEPTEMBER"] = 9;
        values[valuesById[10] = "OCTOBER"] = 10;
        values[valuesById[11] = "NOVEMBER"] = 11;
        values[valuesById[12] = "DECEMBER"] = 12;
        return values;
    })();

    contractpb.InvoiceSearchFilter = (function() {

        /**
         * Properties of an InvoiceSearchFilter.
         * @memberof contractpb
         * @interface IInvoiceSearchFilter
         * @property {Array.<number>|null} [invoiceDays] InvoiceSearchFilter invoiceDays
         * @property {contractpb.InvoiceMonths|null} [invoiceMonth] InvoiceSearchFilter invoiceMonth
         * @property {boolean|null} [prevInvoices] InvoiceSearchFilter prevInvoices
         * @property {number|null} [invoiceYear] InvoiceSearchFilter invoiceYear
         */

        /**
         * Constructs a new InvoiceSearchFilter.
         * @memberof contractpb
         * @classdesc Represents an InvoiceSearchFilter.
         * @implements IInvoiceSearchFilter
         * @constructor
         * @param {contractpb.IInvoiceSearchFilter=} [p] Properties to set
         */
        function InvoiceSearchFilter(p) {
            this.invoiceDays = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * InvoiceSearchFilter invoiceDays.
         * @member {Array.<number>} invoiceDays
         * @memberof contractpb.InvoiceSearchFilter
         * @instance
         */
        InvoiceSearchFilter.prototype.invoiceDays = $util.emptyArray;

        /**
         * InvoiceSearchFilter invoiceMonth.
         * @member {contractpb.InvoiceMonths} invoiceMonth
         * @memberof contractpb.InvoiceSearchFilter
         * @instance
         */
        InvoiceSearchFilter.prototype.invoiceMonth = 0;

        /**
         * InvoiceSearchFilter prevInvoices.
         * @member {boolean} prevInvoices
         * @memberof contractpb.InvoiceSearchFilter
         * @instance
         */
        InvoiceSearchFilter.prototype.prevInvoices = false;

        /**
         * InvoiceSearchFilter invoiceYear.
         * @member {number} invoiceYear
         * @memberof contractpb.InvoiceSearchFilter
         * @instance
         */
        InvoiceSearchFilter.prototype.invoiceYear = 0;

        /**
         * Creates a new InvoiceSearchFilter instance using the specified properties.
         * @function create
         * @memberof contractpb.InvoiceSearchFilter
         * @static
         * @param {contractpb.IInvoiceSearchFilter=} [properties] Properties to set
         * @returns {contractpb.InvoiceSearchFilter} InvoiceSearchFilter instance
         */
        InvoiceSearchFilter.create = function create(properties) {
            return new InvoiceSearchFilter(properties);
        };

        /**
         * Encodes the specified InvoiceSearchFilter message. Does not implicitly {@link contractpb.InvoiceSearchFilter.verify|verify} messages.
         * @function encode
         * @memberof contractpb.InvoiceSearchFilter
         * @static
         * @param {contractpb.IInvoiceSearchFilter} m InvoiceSearchFilter message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        InvoiceSearchFilter.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.invoiceDays != null && m.invoiceDays.length) {
                w.uint32(10).fork();
                for (var i = 0; i < m.invoiceDays.length; ++i)
                    w.int32(m.invoiceDays[i]);
                w.ldelim();
            }
            if (m.invoiceMonth != null && Object.hasOwnProperty.call(m, "invoiceMonth"))
                w.uint32(16).int32(m.invoiceMonth);
            if (m.prevInvoices != null && Object.hasOwnProperty.call(m, "prevInvoices"))
                w.uint32(24).bool(m.prevInvoices);
            if (m.invoiceYear != null && Object.hasOwnProperty.call(m, "invoiceYear"))
                w.uint32(32).int32(m.invoiceYear);
            return w;
        };

        /**
         * Decodes an InvoiceSearchFilter message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.InvoiceSearchFilter
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.InvoiceSearchFilter} InvoiceSearchFilter
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        InvoiceSearchFilter.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.InvoiceSearchFilter();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    if (!(m.invoiceDays && m.invoiceDays.length))
                        m.invoiceDays = [];
                    if ((t & 7) === 2) {
                        var c2 = r.uint32() + r.pos;
                        while (r.pos < c2)
                            m.invoiceDays.push(r.int32());
                    } else
                        m.invoiceDays.push(r.int32());
                    break;
                case 2:
                    m.invoiceMonth = r.int32();
                    break;
                case 3:
                    m.prevInvoices = r.bool();
                    break;
                case 4:
                    m.invoiceYear = r.int32();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return InvoiceSearchFilter;
    })();

    contractpb.RenewalsSearchFilter = (function() {

        /**
         * Properties of a RenewalsSearchFilter.
         * @memberof contractpb
         * @interface IRenewalsSearchFilter
         * @property {google.protobuf.IBoolValue|null} [renewalBatchFlag] RenewalsSearchFilter renewalBatchFlag
         * @property {google.protobuf.IBoolValue|null} [excludeNextContractID] RenewalsSearchFilter excludeNextContractID
         */

        /**
         * Constructs a new RenewalsSearchFilter.
         * @memberof contractpb
         * @classdesc Represents a RenewalsSearchFilter.
         * @implements IRenewalsSearchFilter
         * @constructor
         * @param {contractpb.IRenewalsSearchFilter=} [p] Properties to set
         */
        function RenewalsSearchFilter(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * RenewalsSearchFilter renewalBatchFlag.
         * @member {google.protobuf.IBoolValue|null|undefined} renewalBatchFlag
         * @memberof contractpb.RenewalsSearchFilter
         * @instance
         */
        RenewalsSearchFilter.prototype.renewalBatchFlag = null;

        /**
         * RenewalsSearchFilter excludeNextContractID.
         * @member {google.protobuf.IBoolValue|null|undefined} excludeNextContractID
         * @memberof contractpb.RenewalsSearchFilter
         * @instance
         */
        RenewalsSearchFilter.prototype.excludeNextContractID = null;

        /**
         * Creates a new RenewalsSearchFilter instance using the specified properties.
         * @function create
         * @memberof contractpb.RenewalsSearchFilter
         * @static
         * @param {contractpb.IRenewalsSearchFilter=} [properties] Properties to set
         * @returns {contractpb.RenewalsSearchFilter} RenewalsSearchFilter instance
         */
        RenewalsSearchFilter.create = function create(properties) {
            return new RenewalsSearchFilter(properties);
        };

        /**
         * Encodes the specified RenewalsSearchFilter message. Does not implicitly {@link contractpb.RenewalsSearchFilter.verify|verify} messages.
         * @function encode
         * @memberof contractpb.RenewalsSearchFilter
         * @static
         * @param {contractpb.IRenewalsSearchFilter} m RenewalsSearchFilter message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RenewalsSearchFilter.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.renewalBatchFlag != null && Object.hasOwnProperty.call(m, "renewalBatchFlag"))
                $root.google.protobuf.BoolValue.encode(m.renewalBatchFlag, w.uint32(10).fork()).ldelim();
            if (m.excludeNextContractID != null && Object.hasOwnProperty.call(m, "excludeNextContractID"))
                $root.google.protobuf.BoolValue.encode(m.excludeNextContractID, w.uint32(98).fork()).ldelim();
            return w;
        };

        /**
         * Decodes a RenewalsSearchFilter message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.RenewalsSearchFilter
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.RenewalsSearchFilter} RenewalsSearchFilter
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RenewalsSearchFilter.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.RenewalsSearchFilter();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.renewalBatchFlag = $root.google.protobuf.BoolValue.decode(r, r.uint32());
                    break;
                case 12:
                    m.excludeNextContractID = $root.google.protobuf.BoolValue.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return RenewalsSearchFilter;
    })();

    contractpb.SearchRequestUsingSearchFilters = (function() {

        /**
         * Properties of a SearchRequestUsingSearchFilters.
         * @memberof contractpb
         * @interface ISearchRequestUsingSearchFilters
         * @property {contractpb.ISearchFilters|null} [searchFilter] SearchRequestUsingSearchFilters searchFilter
         * @property {google.protobuf.IInt32Value|null} [pageNumber] SearchRequestUsingSearchFilters pageNumber
         * @property {google.protobuf.IInt32Value|null} [size] SearchRequestUsingSearchFilters size
         */

        /**
         * Constructs a new SearchRequestUsingSearchFilters.
         * @memberof contractpb
         * @classdesc Represents a SearchRequestUsingSearchFilters.
         * @implements ISearchRequestUsingSearchFilters
         * @constructor
         * @param {contractpb.ISearchRequestUsingSearchFilters=} [p] Properties to set
         */
        function SearchRequestUsingSearchFilters(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * SearchRequestUsingSearchFilters searchFilter.
         * @member {contractpb.ISearchFilters|null|undefined} searchFilter
         * @memberof contractpb.SearchRequestUsingSearchFilters
         * @instance
         */
        SearchRequestUsingSearchFilters.prototype.searchFilter = null;

        /**
         * SearchRequestUsingSearchFilters pageNumber.
         * @member {google.protobuf.IInt32Value|null|undefined} pageNumber
         * @memberof contractpb.SearchRequestUsingSearchFilters
         * @instance
         */
        SearchRequestUsingSearchFilters.prototype.pageNumber = null;

        /**
         * SearchRequestUsingSearchFilters size.
         * @member {google.protobuf.IInt32Value|null|undefined} size
         * @memberof contractpb.SearchRequestUsingSearchFilters
         * @instance
         */
        SearchRequestUsingSearchFilters.prototype.size = null;

        /**
         * Creates a new SearchRequestUsingSearchFilters instance using the specified properties.
         * @function create
         * @memberof contractpb.SearchRequestUsingSearchFilters
         * @static
         * @param {contractpb.ISearchRequestUsingSearchFilters=} [properties] Properties to set
         * @returns {contractpb.SearchRequestUsingSearchFilters} SearchRequestUsingSearchFilters instance
         */
        SearchRequestUsingSearchFilters.create = function create(properties) {
            return new SearchRequestUsingSearchFilters(properties);
        };

        /**
         * Encodes the specified SearchRequestUsingSearchFilters message. Does not implicitly {@link contractpb.SearchRequestUsingSearchFilters.verify|verify} messages.
         * @function encode
         * @memberof contractpb.SearchRequestUsingSearchFilters
         * @static
         * @param {contractpb.ISearchRequestUsingSearchFilters} m SearchRequestUsingSearchFilters message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SearchRequestUsingSearchFilters.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.searchFilter != null && Object.hasOwnProperty.call(m, "searchFilter"))
                $root.contractpb.SearchFilters.encode(m.searchFilter, w.uint32(10).fork()).ldelim();
            if (m.pageNumber != null && Object.hasOwnProperty.call(m, "pageNumber"))
                $root.google.protobuf.Int32Value.encode(m.pageNumber, w.uint32(18).fork()).ldelim();
            if (m.size != null && Object.hasOwnProperty.call(m, "size"))
                $root.google.protobuf.Int32Value.encode(m.size, w.uint32(26).fork()).ldelim();
            return w;
        };

        /**
         * Decodes a SearchRequestUsingSearchFilters message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.SearchRequestUsingSearchFilters
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.SearchRequestUsingSearchFilters} SearchRequestUsingSearchFilters
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SearchRequestUsingSearchFilters.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.SearchRequestUsingSearchFilters();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.searchFilter = $root.contractpb.SearchFilters.decode(r, r.uint32());
                    break;
                case 2:
                    m.pageNumber = $root.google.protobuf.Int32Value.decode(r, r.uint32());
                    break;
                case 3:
                    m.size = $root.google.protobuf.Int32Value.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return SearchRequestUsingSearchFilters;
    })();

    /**
     * ResponseField enum.
     * @name contractpb.ResponseField
     * @enum {number}
     * @property {number} CR_ONLY_CONTRACT_ID=0 CR_ONLY_CONTRACT_ID value
     * @property {number} CR_ALL_DATA=1 CR_ALL_DATA value
     * @property {number} CR_CONTRACT_DATA=2 CR_CONTRACT_DATA value
     * @property {number} CR_CUSTOMER_DATA=3 CR_CUSTOMER_DATA value
     * @property {number} CR_COVERED_PROPERTY_ADDRESS=4 CR_COVERED_PROPERTY_ADDRESS value
     * @property {number} CR_MAILING_ADDRESS=5 CR_MAILING_ADDRESS value
     * @property {number} CR_CHANNEL_SPECIFIC_DATA=6 CR_CHANNEL_SPECIFIC_DATA value
     * @property {number} CR_CONTRACT_NOTES=7 CR_CONTRACT_NOTES value
     * @property {number} CR_PRODUCT_AND_COVERAGES=8 CR_PRODUCT_AND_COVERAGES value
     * @property {number} CR_FUTURE_EFFECTIVE_INFO=9 CR_FUTURE_EFFECTIVE_INFO value
     * @property {number} CR_CANCELLATION_INFO=10 CR_CANCELLATION_INFO value
     */
    contractpb.ResponseField = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "CR_ONLY_CONTRACT_ID"] = 0;
        values[valuesById[1] = "CR_ALL_DATA"] = 1;
        values[valuesById[2] = "CR_CONTRACT_DATA"] = 2;
        values[valuesById[3] = "CR_CUSTOMER_DATA"] = 3;
        values[valuesById[4] = "CR_COVERED_PROPERTY_ADDRESS"] = 4;
        values[valuesById[5] = "CR_MAILING_ADDRESS"] = 5;
        values[valuesById[6] = "CR_CHANNEL_SPECIFIC_DATA"] = 6;
        values[valuesById[7] = "CR_CONTRACT_NOTES"] = 7;
        values[valuesById[8] = "CR_PRODUCT_AND_COVERAGES"] = 8;
        values[valuesById[9] = "CR_FUTURE_EFFECTIVE_INFO"] = 9;
        values[valuesById[10] = "CR_CANCELLATION_INFO"] = 10;
        return values;
    })();

    /**
     * SalesPersonTypeCode enum.
     * @name contractpb.SalesPersonTypeCode
     * @enum {number}
     * @property {number} NO_TYPE=0 NO_TYPE value
     * @property {number} GEN=1 GEN value
     * @property {number} CLOSER=2 CLOSER value
     */
    contractpb.SalesPersonTypeCode = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "NO_TYPE"] = 0;
        values[valuesById[1] = "GEN"] = 1;
        values[valuesById[2] = "CLOSER"] = 2;
        return values;
    })();

    contractpb.SalesPersonInfo = (function() {

        /**
         * Properties of a SalesPersonInfo.
         * @memberof contractpb
         * @interface ISalesPersonInfo
         * @property {string|null} [salesPersonID] SalesPersonInfo salesPersonID
         * @property {contractpb.SalesPersonTypeCode|null} [salesPersonTypeCode] SalesPersonInfo salesPersonTypeCode
         */

        /**
         * Constructs a new SalesPersonInfo.
         * @memberof contractpb
         * @classdesc Represents a SalesPersonInfo.
         * @implements ISalesPersonInfo
         * @constructor
         * @param {contractpb.ISalesPersonInfo=} [p] Properties to set
         */
        function SalesPersonInfo(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * SalesPersonInfo salesPersonID.
         * @member {string} salesPersonID
         * @memberof contractpb.SalesPersonInfo
         * @instance
         */
        SalesPersonInfo.prototype.salesPersonID = "";

        /**
         * SalesPersonInfo salesPersonTypeCode.
         * @member {contractpb.SalesPersonTypeCode} salesPersonTypeCode
         * @memberof contractpb.SalesPersonInfo
         * @instance
         */
        SalesPersonInfo.prototype.salesPersonTypeCode = 0;

        /**
         * Creates a new SalesPersonInfo instance using the specified properties.
         * @function create
         * @memberof contractpb.SalesPersonInfo
         * @static
         * @param {contractpb.ISalesPersonInfo=} [properties] Properties to set
         * @returns {contractpb.SalesPersonInfo} SalesPersonInfo instance
         */
        SalesPersonInfo.create = function create(properties) {
            return new SalesPersonInfo(properties);
        };

        /**
         * Encodes the specified SalesPersonInfo message. Does not implicitly {@link contractpb.SalesPersonInfo.verify|verify} messages.
         * @function encode
         * @memberof contractpb.SalesPersonInfo
         * @static
         * @param {contractpb.ISalesPersonInfo} m SalesPersonInfo message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SalesPersonInfo.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.salesPersonID != null && Object.hasOwnProperty.call(m, "salesPersonID"))
                w.uint32(10).string(m.salesPersonID);
            if (m.salesPersonTypeCode != null && Object.hasOwnProperty.call(m, "salesPersonTypeCode"))
                w.uint32(16).int32(m.salesPersonTypeCode);
            return w;
        };

        /**
         * Decodes a SalesPersonInfo message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.SalesPersonInfo
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.SalesPersonInfo} SalesPersonInfo
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SalesPersonInfo.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.SalesPersonInfo();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.salesPersonID = r.string();
                    break;
                case 2:
                    m.salesPersonTypeCode = r.int32();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return SalesPersonInfo;
    })();

    contractpb.ContractPropertyInfo = (function() {

        /**
         * Properties of a ContractPropertyInfo.
         * @memberof contractpb
         * @interface IContractPropertyInfo
         * @property {number|null} [ID] ContractPropertyInfo ID
         * @property {string|null} [type] ContractPropertyInfo type
         * @property {string|null} [dwellingType] ContractPropertyInfo dwellingType
         * @property {string|null} [unitType] ContractPropertyInfo unitType
         * @property {string|null} [unitNumber] ContractPropertyInfo unitNumber
         * @property {number|null} [squareFeet] ContractPropertyInfo squareFeet
         * @property {number|null} [yearBuilt] ContractPropertyInfo yearBuilt
         * @property {number|null} [numberMotherLawUnit] ContractPropertyInfo numberMotherLawUnit
         * @property {number|null} [costOfProperty] ContractPropertyInfo costOfProperty
         * @property {contractpb.IAddress|null} [address] ContractPropertyInfo address
         */

        /**
         * Constructs a new ContractPropertyInfo.
         * @memberof contractpb
         * @classdesc Represents a ContractPropertyInfo.
         * @implements IContractPropertyInfo
         * @constructor
         * @param {contractpb.IContractPropertyInfo=} [p] Properties to set
         */
        function ContractPropertyInfo(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * ContractPropertyInfo ID.
         * @member {number} ID
         * @memberof contractpb.ContractPropertyInfo
         * @instance
         */
        ContractPropertyInfo.prototype.ID = 0;

        /**
         * ContractPropertyInfo type.
         * @member {string} type
         * @memberof contractpb.ContractPropertyInfo
         * @instance
         */
        ContractPropertyInfo.prototype.type = "";

        /**
         * ContractPropertyInfo dwellingType.
         * @member {string} dwellingType
         * @memberof contractpb.ContractPropertyInfo
         * @instance
         */
        ContractPropertyInfo.prototype.dwellingType = "";

        /**
         * ContractPropertyInfo unitType.
         * @member {string} unitType
         * @memberof contractpb.ContractPropertyInfo
         * @instance
         */
        ContractPropertyInfo.prototype.unitType = "";

        /**
         * ContractPropertyInfo unitNumber.
         * @member {string} unitNumber
         * @memberof contractpb.ContractPropertyInfo
         * @instance
         */
        ContractPropertyInfo.prototype.unitNumber = "";

        /**
         * ContractPropertyInfo squareFeet.
         * @member {number} squareFeet
         * @memberof contractpb.ContractPropertyInfo
         * @instance
         */
        ContractPropertyInfo.prototype.squareFeet = 0;

        /**
         * ContractPropertyInfo yearBuilt.
         * @member {number} yearBuilt
         * @memberof contractpb.ContractPropertyInfo
         * @instance
         */
        ContractPropertyInfo.prototype.yearBuilt = 0;

        /**
         * ContractPropertyInfo numberMotherLawUnit.
         * @member {number} numberMotherLawUnit
         * @memberof contractpb.ContractPropertyInfo
         * @instance
         */
        ContractPropertyInfo.prototype.numberMotherLawUnit = 0;

        /**
         * ContractPropertyInfo costOfProperty.
         * @member {number} costOfProperty
         * @memberof contractpb.ContractPropertyInfo
         * @instance
         */
        ContractPropertyInfo.prototype.costOfProperty = 0;

        /**
         * ContractPropertyInfo address.
         * @member {contractpb.IAddress|null|undefined} address
         * @memberof contractpb.ContractPropertyInfo
         * @instance
         */
        ContractPropertyInfo.prototype.address = null;

        /**
         * Creates a new ContractPropertyInfo instance using the specified properties.
         * @function create
         * @memberof contractpb.ContractPropertyInfo
         * @static
         * @param {contractpb.IContractPropertyInfo=} [properties] Properties to set
         * @returns {contractpb.ContractPropertyInfo} ContractPropertyInfo instance
         */
        ContractPropertyInfo.create = function create(properties) {
            return new ContractPropertyInfo(properties);
        };

        /**
         * Encodes the specified ContractPropertyInfo message. Does not implicitly {@link contractpb.ContractPropertyInfo.verify|verify} messages.
         * @function encode
         * @memberof contractpb.ContractPropertyInfo
         * @static
         * @param {contractpb.IContractPropertyInfo} m ContractPropertyInfo message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ContractPropertyInfo.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.ID != null && Object.hasOwnProperty.call(m, "ID"))
                w.uint32(8).int32(m.ID);
            if (m.type != null && Object.hasOwnProperty.call(m, "type"))
                w.uint32(18).string(m.type);
            if (m.dwellingType != null && Object.hasOwnProperty.call(m, "dwellingType"))
                w.uint32(26).string(m.dwellingType);
            if (m.unitType != null && Object.hasOwnProperty.call(m, "unitType"))
                w.uint32(106).string(m.unitType);
            if (m.unitNumber != null && Object.hasOwnProperty.call(m, "unitNumber"))
                w.uint32(114).string(m.unitNumber);
            if (m.squareFeet != null && Object.hasOwnProperty.call(m, "squareFeet"))
                w.uint32(120).int32(m.squareFeet);
            if (m.yearBuilt != null && Object.hasOwnProperty.call(m, "yearBuilt"))
                w.uint32(128).int32(m.yearBuilt);
            if (m.numberMotherLawUnit != null && Object.hasOwnProperty.call(m, "numberMotherLawUnit"))
                w.uint32(136).int32(m.numberMotherLawUnit);
            if (m.costOfProperty != null && Object.hasOwnProperty.call(m, "costOfProperty"))
                w.uint32(144).int32(m.costOfProperty);
            if (m.address != null && Object.hasOwnProperty.call(m, "address"))
                $root.contractpb.Address.encode(m.address, w.uint32(154).fork()).ldelim();
            return w;
        };

        /**
         * Decodes a ContractPropertyInfo message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.ContractPropertyInfo
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.ContractPropertyInfo} ContractPropertyInfo
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ContractPropertyInfo.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.ContractPropertyInfo();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.ID = r.int32();
                    break;
                case 2:
                    m.type = r.string();
                    break;
                case 3:
                    m.dwellingType = r.string();
                    break;
                case 13:
                    m.unitType = r.string();
                    break;
                case 14:
                    m.unitNumber = r.string();
                    break;
                case 15:
                    m.squareFeet = r.int32();
                    break;
                case 16:
                    m.yearBuilt = r.int32();
                    break;
                case 17:
                    m.numberMotherLawUnit = r.int32();
                    break;
                case 18:
                    m.costOfProperty = r.int32();
                    break;
                case 19:
                    m.address = $root.contractpb.Address.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return ContractPropertyInfo;
    })();

    contractpb.Address = (function() {

        /**
         * Properties of an Address.
         * @memberof contractpb
         * @interface IAddress
         * @property {string|null} [city] Address city
         * @property {string|null} [state] Address state
         * @property {string|null} [zip] Address zip
         * @property {string|null} [zipFour] Address zipFour
         * @property {string|null} [streetNumber] Address streetNumber
         * @property {string|null} [streetDirection] Address streetDirection
         * @property {string|null} [streetName] Address streetName
         * @property {string|null} [addressUUID] Address addressUUID
         * @property {string|null} [unitType] Address unitType
         * @property {string|null} [unitNumber] Address unitNumber
         */

        /**
         * Constructs a new Address.
         * @memberof contractpb
         * @classdesc Represents an Address.
         * @implements IAddress
         * @constructor
         * @param {contractpb.IAddress=} [p] Properties to set
         */
        function Address(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * Address city.
         * @member {string} city
         * @memberof contractpb.Address
         * @instance
         */
        Address.prototype.city = "";

        /**
         * Address state.
         * @member {string} state
         * @memberof contractpb.Address
         * @instance
         */
        Address.prototype.state = "";

        /**
         * Address zip.
         * @member {string} zip
         * @memberof contractpb.Address
         * @instance
         */
        Address.prototype.zip = "";

        /**
         * Address zipFour.
         * @member {string} zipFour
         * @memberof contractpb.Address
         * @instance
         */
        Address.prototype.zipFour = "";

        /**
         * Address streetNumber.
         * @member {string} streetNumber
         * @memberof contractpb.Address
         * @instance
         */
        Address.prototype.streetNumber = "";

        /**
         * Address streetDirection.
         * @member {string} streetDirection
         * @memberof contractpb.Address
         * @instance
         */
        Address.prototype.streetDirection = "";

        /**
         * Address streetName.
         * @member {string} streetName
         * @memberof contractpb.Address
         * @instance
         */
        Address.prototype.streetName = "";

        /**
         * Address addressUUID.
         * @member {string} addressUUID
         * @memberof contractpb.Address
         * @instance
         */
        Address.prototype.addressUUID = "";

        /**
         * Address unitType.
         * @member {string} unitType
         * @memberof contractpb.Address
         * @instance
         */
        Address.prototype.unitType = "";

        /**
         * Address unitNumber.
         * @member {string} unitNumber
         * @memberof contractpb.Address
         * @instance
         */
        Address.prototype.unitNumber = "";

        /**
         * Creates a new Address instance using the specified properties.
         * @function create
         * @memberof contractpb.Address
         * @static
         * @param {contractpb.IAddress=} [properties] Properties to set
         * @returns {contractpb.Address} Address instance
         */
        Address.create = function create(properties) {
            return new Address(properties);
        };

        /**
         * Encodes the specified Address message. Does not implicitly {@link contractpb.Address.verify|verify} messages.
         * @function encode
         * @memberof contractpb.Address
         * @static
         * @param {contractpb.IAddress} m Address message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Address.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.city != null && Object.hasOwnProperty.call(m, "city"))
                w.uint32(50).string(m.city);
            if (m.state != null && Object.hasOwnProperty.call(m, "state"))
                w.uint32(58).string(m.state);
            if (m.zip != null && Object.hasOwnProperty.call(m, "zip"))
                w.uint32(66).string(m.zip);
            if (m.zipFour != null && Object.hasOwnProperty.call(m, "zipFour"))
                w.uint32(74).string(m.zipFour);
            if (m.streetNumber != null && Object.hasOwnProperty.call(m, "streetNumber"))
                w.uint32(82).string(m.streetNumber);
            if (m.streetDirection != null && Object.hasOwnProperty.call(m, "streetDirection"))
                w.uint32(90).string(m.streetDirection);
            if (m.streetName != null && Object.hasOwnProperty.call(m, "streetName"))
                w.uint32(98).string(m.streetName);
            if (m.addressUUID != null && Object.hasOwnProperty.call(m, "addressUUID"))
                w.uint32(106).string(m.addressUUID);
            if (m.unitType != null && Object.hasOwnProperty.call(m, "unitType"))
                w.uint32(114).string(m.unitType);
            if (m.unitNumber != null && Object.hasOwnProperty.call(m, "unitNumber"))
                w.uint32(122).string(m.unitNumber);
            return w;
        };

        /**
         * Decodes an Address message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.Address
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.Address} Address
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Address.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.Address();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 6:
                    m.city = r.string();
                    break;
                case 7:
                    m.state = r.string();
                    break;
                case 8:
                    m.zip = r.string();
                    break;
                case 9:
                    m.zipFour = r.string();
                    break;
                case 10:
                    m.streetNumber = r.string();
                    break;
                case 11:
                    m.streetDirection = r.string();
                    break;
                case 12:
                    m.streetName = r.string();
                    break;
                case 13:
                    m.addressUUID = r.string();
                    break;
                case 14:
                    m.unitType = r.string();
                    break;
                case 15:
                    m.unitNumber = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return Address;
    })();

    contractpb.ContractPropertySearchFilter = (function() {

        /**
         * Properties of a ContractPropertySearchFilter.
         * @memberof contractpb
         * @interface IContractPropertySearchFilter
         * @property {number|null} [propertyId] ContractPropertySearchFilter propertyId
         * @property {contractpb.IAddressSearchFilter|null} [address] ContractPropertySearchFilter address
         */

        /**
         * Constructs a new ContractPropertySearchFilter.
         * @memberof contractpb
         * @classdesc Represents a ContractPropertySearchFilter.
         * @implements IContractPropertySearchFilter
         * @constructor
         * @param {contractpb.IContractPropertySearchFilter=} [p] Properties to set
         */
        function ContractPropertySearchFilter(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * ContractPropertySearchFilter propertyId.
         * @member {number|null|undefined} propertyId
         * @memberof contractpb.ContractPropertySearchFilter
         * @instance
         */
        ContractPropertySearchFilter.prototype.propertyId = null;

        /**
         * ContractPropertySearchFilter address.
         * @member {contractpb.IAddressSearchFilter|null|undefined} address
         * @memberof contractpb.ContractPropertySearchFilter
         * @instance
         */
        ContractPropertySearchFilter.prototype.address = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        /**
         * ContractPropertySearchFilter propertyAddress.
         * @member {"propertyId"|"address"|undefined} propertyAddress
         * @memberof contractpb.ContractPropertySearchFilter
         * @instance
         */
        Object.defineProperty(ContractPropertySearchFilter.prototype, "propertyAddress", {
            get: $util.oneOfGetter($oneOfFields = ["propertyId", "address"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new ContractPropertySearchFilter instance using the specified properties.
         * @function create
         * @memberof contractpb.ContractPropertySearchFilter
         * @static
         * @param {contractpb.IContractPropertySearchFilter=} [properties] Properties to set
         * @returns {contractpb.ContractPropertySearchFilter} ContractPropertySearchFilter instance
         */
        ContractPropertySearchFilter.create = function create(properties) {
            return new ContractPropertySearchFilter(properties);
        };

        /**
         * Encodes the specified ContractPropertySearchFilter message. Does not implicitly {@link contractpb.ContractPropertySearchFilter.verify|verify} messages.
         * @function encode
         * @memberof contractpb.ContractPropertySearchFilter
         * @static
         * @param {contractpb.IContractPropertySearchFilter} m ContractPropertySearchFilter message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ContractPropertySearchFilter.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.propertyId != null && Object.hasOwnProperty.call(m, "propertyId"))
                w.uint32(8).int32(m.propertyId);
            if (m.address != null && Object.hasOwnProperty.call(m, "address"))
                $root.contractpb.AddressSearchFilter.encode(m.address, w.uint32(18).fork()).ldelim();
            return w;
        };

        /**
         * Decodes a ContractPropertySearchFilter message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.ContractPropertySearchFilter
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.ContractPropertySearchFilter} ContractPropertySearchFilter
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ContractPropertySearchFilter.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.ContractPropertySearchFilter();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.propertyId = r.int32();
                    break;
                case 2:
                    m.address = $root.contractpb.AddressSearchFilter.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return ContractPropertySearchFilter;
    })();

    contractpb.AddressSearchFilter = (function() {

        /**
         * Properties of an AddressSearchFilter.
         * @memberof contractpb
         * @interface IAddressSearchFilter
         * @property {string|null} [addressUUID] AddressSearchFilter addressUUID
         * @property {contractpb.IAddressInfo|null} [address] AddressSearchFilter address
         */

        /**
         * Constructs a new AddressSearchFilter.
         * @memberof contractpb
         * @classdesc This filter will allow to enter only one of either address UUID or addressInfo Object.
         * @implements IAddressSearchFilter
         * @constructor
         * @param {contractpb.IAddressSearchFilter=} [p] Properties to set
         */
        function AddressSearchFilter(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * AddressSearchFilter addressUUID.
         * @member {string|null|undefined} addressUUID
         * @memberof contractpb.AddressSearchFilter
         * @instance
         */
        AddressSearchFilter.prototype.addressUUID = null;

        /**
         * AddressSearchFilter address.
         * @member {contractpb.IAddressInfo|null|undefined} address
         * @memberof contractpb.AddressSearchFilter
         * @instance
         */
        AddressSearchFilter.prototype.address = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        /**
         * AddressSearchFilter addressIdentifier.
         * @member {"addressUUID"|"address"|undefined} addressIdentifier
         * @memberof contractpb.AddressSearchFilter
         * @instance
         */
        Object.defineProperty(AddressSearchFilter.prototype, "addressIdentifier", {
            get: $util.oneOfGetter($oneOfFields = ["addressUUID", "address"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new AddressSearchFilter instance using the specified properties.
         * @function create
         * @memberof contractpb.AddressSearchFilter
         * @static
         * @param {contractpb.IAddressSearchFilter=} [properties] Properties to set
         * @returns {contractpb.AddressSearchFilter} AddressSearchFilter instance
         */
        AddressSearchFilter.create = function create(properties) {
            return new AddressSearchFilter(properties);
        };

        /**
         * Encodes the specified AddressSearchFilter message. Does not implicitly {@link contractpb.AddressSearchFilter.verify|verify} messages.
         * @function encode
         * @memberof contractpb.AddressSearchFilter
         * @static
         * @param {contractpb.IAddressSearchFilter} m AddressSearchFilter message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AddressSearchFilter.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.addressUUID != null && Object.hasOwnProperty.call(m, "addressUUID"))
                w.uint32(10).string(m.addressUUID);
            if (m.address != null && Object.hasOwnProperty.call(m, "address"))
                $root.contractpb.AddressInfo.encode(m.address, w.uint32(18).fork()).ldelim();
            return w;
        };

        /**
         * Decodes an AddressSearchFilter message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.AddressSearchFilter
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.AddressSearchFilter} AddressSearchFilter
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AddressSearchFilter.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.AddressSearchFilter();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.addressUUID = r.string();
                    break;
                case 2:
                    m.address = $root.contractpb.AddressInfo.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return AddressSearchFilter;
    })();

    contractpb.AddressInfo = (function() {

        /**
         * Properties of an AddressInfo.
         * @memberof contractpb
         * @interface IAddressInfo
         * @property {string|null} [city] AddressInfo city
         * @property {string|null} [state] AddressInfo state
         * @property {string|null} [zip] AddressInfo zip
         * @property {string|null} [zipFour] AddressInfo zipFour
         * @property {string|null} [streetNumber] AddressInfo streetNumber
         * @property {string|null} [streetDirection] AddressInfo streetDirection
         * @property {string|null} [streetName] AddressInfo streetName
         */

        /**
         * Constructs a new AddressInfo.
         * @memberof contractpb
         * @classdesc This message is same as Address Message with a exception of UUID abscent
         * @implements IAddressInfo
         * @constructor
         * @param {contractpb.IAddressInfo=} [p] Properties to set
         */
        function AddressInfo(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * AddressInfo city.
         * @member {string} city
         * @memberof contractpb.AddressInfo
         * @instance
         */
        AddressInfo.prototype.city = "";

        /**
         * AddressInfo state.
         * @member {string} state
         * @memberof contractpb.AddressInfo
         * @instance
         */
        AddressInfo.prototype.state = "";

        /**
         * AddressInfo zip.
         * @member {string} zip
         * @memberof contractpb.AddressInfo
         * @instance
         */
        AddressInfo.prototype.zip = "";

        /**
         * AddressInfo zipFour.
         * @member {string} zipFour
         * @memberof contractpb.AddressInfo
         * @instance
         */
        AddressInfo.prototype.zipFour = "";

        /**
         * AddressInfo streetNumber.
         * @member {string} streetNumber
         * @memberof contractpb.AddressInfo
         * @instance
         */
        AddressInfo.prototype.streetNumber = "";

        /**
         * AddressInfo streetDirection.
         * @member {string} streetDirection
         * @memberof contractpb.AddressInfo
         * @instance
         */
        AddressInfo.prototype.streetDirection = "";

        /**
         * AddressInfo streetName.
         * @member {string} streetName
         * @memberof contractpb.AddressInfo
         * @instance
         */
        AddressInfo.prototype.streetName = "";

        /**
         * Creates a new AddressInfo instance using the specified properties.
         * @function create
         * @memberof contractpb.AddressInfo
         * @static
         * @param {contractpb.IAddressInfo=} [properties] Properties to set
         * @returns {contractpb.AddressInfo} AddressInfo instance
         */
        AddressInfo.create = function create(properties) {
            return new AddressInfo(properties);
        };

        /**
         * Encodes the specified AddressInfo message. Does not implicitly {@link contractpb.AddressInfo.verify|verify} messages.
         * @function encode
         * @memberof contractpb.AddressInfo
         * @static
         * @param {contractpb.IAddressInfo} m AddressInfo message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AddressInfo.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.city != null && Object.hasOwnProperty.call(m, "city"))
                w.uint32(10).string(m.city);
            if (m.state != null && Object.hasOwnProperty.call(m, "state"))
                w.uint32(18).string(m.state);
            if (m.zip != null && Object.hasOwnProperty.call(m, "zip"))
                w.uint32(26).string(m.zip);
            if (m.zipFour != null && Object.hasOwnProperty.call(m, "zipFour"))
                w.uint32(34).string(m.zipFour);
            if (m.streetNumber != null && Object.hasOwnProperty.call(m, "streetNumber"))
                w.uint32(42).string(m.streetNumber);
            if (m.streetDirection != null && Object.hasOwnProperty.call(m, "streetDirection"))
                w.uint32(50).string(m.streetDirection);
            if (m.streetName != null && Object.hasOwnProperty.call(m, "streetName"))
                w.uint32(58).string(m.streetName);
            return w;
        };

        /**
         * Decodes an AddressInfo message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.AddressInfo
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.AddressInfo} AddressInfo
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AddressInfo.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.AddressInfo();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.city = r.string();
                    break;
                case 2:
                    m.state = r.string();
                    break;
                case 3:
                    m.zip = r.string();
                    break;
                case 4:
                    m.zipFour = r.string();
                    break;
                case 5:
                    m.streetNumber = r.string();
                    break;
                case 6:
                    m.streetDirection = r.string();
                    break;
                case 7:
                    m.streetName = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return AddressInfo;
    })();

    /**
     * PhoneType enum.
     * @name contractpb.PhoneType
     * @enum {number}
     * @property {number} CELL=0 CELL value
     * @property {number} FAX=1 FAX value
     * @property {number} HOME=2 HOME value
     * @property {number} OFF=3 OFF value
     * @property {number} PAGER=4 PAGER value
     * @property {number} AUTO=5 AUTO value
     * @property {number} FAMILY=6 FAMILY value
     * @property {number} WORK=7 WORK value
     * @property {number} TENANT=8 TENANT value
     * @property {number} REALTOR=9 REALTOR value
     * @property {number} RELOCOMP=10 RELOCOMP value
     * @property {number} PROPMGR=11 PROPMGR value
     * @property {number} MRSOFF=12 MRSOFF value
     * @property {number} ZZ=13 ZZ value
     * @property {number} PRIMARY=14 PRIMARY value
     * @property {number} FXHOLD=15 FXHOLD value
     * @property {number} TENANTOF=16 TENANTOF value
     * @property {number} CELLHIS=17 CELLHIS value
     * @property {number} CELLHER=18 CELLHER value
     * @property {number} TALKTO=19 TALKTO value
     * @property {number} HOMEWORK=20 HOMEWORK value
     * @property {number} MROFF=21 MROFF value
     * @property {number} EMERGENCY=22 EMERGENCY value
     * @property {number} EMERAFTER=23 EMERAFTER value
     * @property {number} BUYERPHONE=24 BUYERPHONE value
     * @property {number} SECONDARY=25 SECONDARY value
     */
    contractpb.PhoneType = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "CELL"] = 0;
        values[valuesById[1] = "FAX"] = 1;
        values[valuesById[2] = "HOME"] = 2;
        values[valuesById[3] = "OFF"] = 3;
        values[valuesById[4] = "PAGER"] = 4;
        values[valuesById[5] = "AUTO"] = 5;
        values[valuesById[6] = "FAMILY"] = 6;
        values[valuesById[7] = "WORK"] = 7;
        values[valuesById[8] = "TENANT"] = 8;
        values[valuesById[9] = "REALTOR"] = 9;
        values[valuesById[10] = "RELOCOMP"] = 10;
        values[valuesById[11] = "PROPMGR"] = 11;
        values[valuesById[12] = "MRSOFF"] = 12;
        values[valuesById[13] = "ZZ"] = 13;
        values[valuesById[14] = "PRIMARY"] = 14;
        values[valuesById[15] = "FXHOLD"] = 15;
        values[valuesById[16] = "TENANTOF"] = 16;
        values[valuesById[17] = "CELLHIS"] = 17;
        values[valuesById[18] = "CELLHER"] = 18;
        values[valuesById[19] = "TALKTO"] = 19;
        values[valuesById[20] = "HOMEWORK"] = 20;
        values[valuesById[21] = "MROFF"] = 21;
        values[valuesById[22] = "EMERGENCY"] = 22;
        values[valuesById[23] = "EMERAFTER"] = 23;
        values[valuesById[24] = "BUYERPHONE"] = 24;
        values[valuesById[25] = "SECONDARY"] = 25;
        return values;
    })();

    contractpb.PhoneInfo = (function() {

        /**
         * Properties of a PhoneInfo.
         * @memberof contractpb
         * @interface IPhoneInfo
         * @property {string|null} [number] PhoneInfo number
         * @property {contractpb.PhoneType|null} [type] PhoneInfo type
         * @property {string|null} [extension] PhoneInfo extension
         */

        /**
         * Constructs a new PhoneInfo.
         * @memberof contractpb
         * @classdesc Represents a PhoneInfo.
         * @implements IPhoneInfo
         * @constructor
         * @param {contractpb.IPhoneInfo=} [p] Properties to set
         */
        function PhoneInfo(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * PhoneInfo number.
         * @member {string} number
         * @memberof contractpb.PhoneInfo
         * @instance
         */
        PhoneInfo.prototype.number = "";

        /**
         * PhoneInfo type.
         * @member {contractpb.PhoneType} type
         * @memberof contractpb.PhoneInfo
         * @instance
         */
        PhoneInfo.prototype.type = 0;

        /**
         * PhoneInfo extension.
         * @member {string} extension
         * @memberof contractpb.PhoneInfo
         * @instance
         */
        PhoneInfo.prototype.extension = "";

        /**
         * Creates a new PhoneInfo instance using the specified properties.
         * @function create
         * @memberof contractpb.PhoneInfo
         * @static
         * @param {contractpb.IPhoneInfo=} [properties] Properties to set
         * @returns {contractpb.PhoneInfo} PhoneInfo instance
         */
        PhoneInfo.create = function create(properties) {
            return new PhoneInfo(properties);
        };

        /**
         * Encodes the specified PhoneInfo message. Does not implicitly {@link contractpb.PhoneInfo.verify|verify} messages.
         * @function encode
         * @memberof contractpb.PhoneInfo
         * @static
         * @param {contractpb.IPhoneInfo} m PhoneInfo message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PhoneInfo.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.number != null && Object.hasOwnProperty.call(m, "number"))
                w.uint32(10).string(m.number);
            if (m.type != null && Object.hasOwnProperty.call(m, "type"))
                w.uint32(16).int32(m.type);
            if (m.extension != null && Object.hasOwnProperty.call(m, "extension"))
                w.uint32(26).string(m.extension);
            return w;
        };

        /**
         * Decodes a PhoneInfo message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.PhoneInfo
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.PhoneInfo} PhoneInfo
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PhoneInfo.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.PhoneInfo();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.number = r.string();
                    break;
                case 2:
                    m.type = r.int32();
                    break;
                case 3:
                    m.extension = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return PhoneInfo;
    })();

    contractpb.ContractCustomerInfo = (function() {

        /**
         * Properties of a ContractCustomerInfo.
         * @memberof contractpb
         * @interface IContractCustomerInfo
         * @property {string|null} [contractID] ContractCustomerInfo contractID
         * @property {string|null} [customerID] ContractCustomerInfo customerID
         * @property {contractpb.ContractCustomerType|null} [typeCode] ContractCustomerInfo typeCode
         * @property {string|null} [typePrefix] ContractCustomerInfo typePrefix
         * @property {Array.<contractpb.IPhoneInfo>|null} [phone] ContractCustomerInfo phone
         * @property {string|null} [firstName] ContractCustomerInfo firstName
         * @property {string|null} [lastName] ContractCustomerInfo lastName
         * @property {string|null} [middleInitial] ContractCustomerInfo middleInitial
         * @property {string|null} [email] ContractCustomerInfo email
         * @property {google.protobuf.IBoolValue|null} [emailPreference] ContractCustomerInfo emailPreference
         */

        /**
         * Constructs a new ContractCustomerInfo.
         * @memberof contractpb
         * @classdesc Represents a ContractCustomerInfo.
         * @implements IContractCustomerInfo
         * @constructor
         * @param {contractpb.IContractCustomerInfo=} [p] Properties to set
         */
        function ContractCustomerInfo(p) {
            this.phone = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * ContractCustomerInfo contractID.
         * @member {string} contractID
         * @memberof contractpb.ContractCustomerInfo
         * @instance
         */
        ContractCustomerInfo.prototype.contractID = "";

        /**
         * ContractCustomerInfo customerID.
         * @member {string} customerID
         * @memberof contractpb.ContractCustomerInfo
         * @instance
         */
        ContractCustomerInfo.prototype.customerID = "";

        /**
         * ContractCustomerInfo typeCode.
         * @member {contractpb.ContractCustomerType} typeCode
         * @memberof contractpb.ContractCustomerInfo
         * @instance
         */
        ContractCustomerInfo.prototype.typeCode = 0;

        /**
         * ContractCustomerInfo typePrefix.
         * @member {string} typePrefix
         * @memberof contractpb.ContractCustomerInfo
         * @instance
         */
        ContractCustomerInfo.prototype.typePrefix = "";

        /**
         * ContractCustomerInfo phone.
         * @member {Array.<contractpb.IPhoneInfo>} phone
         * @memberof contractpb.ContractCustomerInfo
         * @instance
         */
        ContractCustomerInfo.prototype.phone = $util.emptyArray;

        /**
         * ContractCustomerInfo firstName.
         * @member {string} firstName
         * @memberof contractpb.ContractCustomerInfo
         * @instance
         */
        ContractCustomerInfo.prototype.firstName = "";

        /**
         * ContractCustomerInfo lastName.
         * @member {string} lastName
         * @memberof contractpb.ContractCustomerInfo
         * @instance
         */
        ContractCustomerInfo.prototype.lastName = "";

        /**
         * ContractCustomerInfo middleInitial.
         * @member {string} middleInitial
         * @memberof contractpb.ContractCustomerInfo
         * @instance
         */
        ContractCustomerInfo.prototype.middleInitial = "";

        /**
         * ContractCustomerInfo email.
         * @member {string} email
         * @memberof contractpb.ContractCustomerInfo
         * @instance
         */
        ContractCustomerInfo.prototype.email = "";

        /**
         * ContractCustomerInfo emailPreference.
         * @member {google.protobuf.IBoolValue|null|undefined} emailPreference
         * @memberof contractpb.ContractCustomerInfo
         * @instance
         */
        ContractCustomerInfo.prototype.emailPreference = null;

        /**
         * Creates a new ContractCustomerInfo instance using the specified properties.
         * @function create
         * @memberof contractpb.ContractCustomerInfo
         * @static
         * @param {contractpb.IContractCustomerInfo=} [properties] Properties to set
         * @returns {contractpb.ContractCustomerInfo} ContractCustomerInfo instance
         */
        ContractCustomerInfo.create = function create(properties) {
            return new ContractCustomerInfo(properties);
        };

        /**
         * Encodes the specified ContractCustomerInfo message. Does not implicitly {@link contractpb.ContractCustomerInfo.verify|verify} messages.
         * @function encode
         * @memberof contractpb.ContractCustomerInfo
         * @static
         * @param {contractpb.IContractCustomerInfo} m ContractCustomerInfo message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ContractCustomerInfo.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.contractID != null && Object.hasOwnProperty.call(m, "contractID"))
                w.uint32(10).string(m.contractID);
            if (m.customerID != null && Object.hasOwnProperty.call(m, "customerID"))
                w.uint32(18).string(m.customerID);
            if (m.typeCode != null && Object.hasOwnProperty.call(m, "typeCode"))
                w.uint32(24).int32(m.typeCode);
            if (m.typePrefix != null && Object.hasOwnProperty.call(m, "typePrefix"))
                w.uint32(34).string(m.typePrefix);
            if (m.phone != null && m.phone.length) {
                for (var i = 0; i < m.phone.length; ++i)
                    $root.contractpb.PhoneInfo.encode(m.phone[i], w.uint32(42).fork()).ldelim();
            }
            if (m.firstName != null && Object.hasOwnProperty.call(m, "firstName"))
                w.uint32(50).string(m.firstName);
            if (m.lastName != null && Object.hasOwnProperty.call(m, "lastName"))
                w.uint32(58).string(m.lastName);
            if (m.middleInitial != null && Object.hasOwnProperty.call(m, "middleInitial"))
                w.uint32(66).string(m.middleInitial);
            if (m.email != null && Object.hasOwnProperty.call(m, "email"))
                w.uint32(74).string(m.email);
            if (m.emailPreference != null && Object.hasOwnProperty.call(m, "emailPreference"))
                $root.google.protobuf.BoolValue.encode(m.emailPreference, w.uint32(82).fork()).ldelim();
            return w;
        };

        /**
         * Decodes a ContractCustomerInfo message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.ContractCustomerInfo
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.ContractCustomerInfo} ContractCustomerInfo
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ContractCustomerInfo.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.ContractCustomerInfo();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.contractID = r.string();
                    break;
                case 2:
                    m.customerID = r.string();
                    break;
                case 3:
                    m.typeCode = r.int32();
                    break;
                case 4:
                    m.typePrefix = r.string();
                    break;
                case 5:
                    if (!(m.phone && m.phone.length))
                        m.phone = [];
                    m.phone.push($root.contractpb.PhoneInfo.decode(r, r.uint32()));
                    break;
                case 6:
                    m.firstName = r.string();
                    break;
                case 7:
                    m.lastName = r.string();
                    break;
                case 8:
                    m.middleInitial = r.string();
                    break;
                case 9:
                    m.email = r.string();
                    break;
                case 10:
                    m.emailPreference = $root.google.protobuf.BoolValue.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return ContractCustomerInfo;
    })();

    /**
     * PaymentType enum.
     * @name contractpb.PaymentType
     * @enum {number}
     * @property {number} INVALID_PAYMENT_TYPE=0 INVALID_PAYMENT_TYPE value
     * @property {number} CC=1 CC value
     * @property {number} CK=2 CK value
     * @property {number} CPN=3 CPN value
     * @property {number} CON=4 CON value
     * @property {number} ACH=5 ACH value
     * @property {number} GC=6 GC value
     * @property {number} MG=7 MG value
     * @property {number} DIRECTBILL=8 DIRECTBILL value
     */
    contractpb.PaymentType = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "INVALID_PAYMENT_TYPE"] = 0;
        values[valuesById[1] = "CC"] = 1;
        values[valuesById[2] = "CK"] = 2;
        values[valuesById[3] = "CPN"] = 3;
        values[valuesById[4] = "CON"] = 4;
        values[valuesById[5] = "ACH"] = 5;
        values[valuesById[6] = "GC"] = 6;
        values[valuesById[7] = "MG"] = 7;
        values[valuesById[8] = "DIRECTBILL"] = 8;
        return values;
    })();

    /**
     * PaymentTypeCode enum.
     * @name contractpb.PaymentTypeCode
     * @enum {number}
     * @property {number} INVALID_TYPE_CODE=0 INVALID_TYPE_CODE value
     * @property {number} SERVICEFEE=1 SERVICEFEE value
     * @property {number} OPTION=2 OPTION value
     * @property {number} TOTAL=3 TOTAL value
     * @property {number} INSTPAY=4 INSTPAY value
     * @property {number} TERMOPT=5 TERMOPT value
     * @property {number} RENEWAL=6 RENEWAL value
     * @property {number} CANCELFEE=7 CANCELFEE value
     * @property {number} SVCCOST=8 SVCCOST value
     */
    contractpb.PaymentTypeCode = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "INVALID_TYPE_CODE"] = 0;
        values[valuesById[1] = "SERVICEFEE"] = 1;
        values[valuesById[2] = "OPTION"] = 2;
        values[valuesById[3] = "TOTAL"] = 3;
        values[valuesById[4] = "INSTPAY"] = 4;
        values[valuesById[5] = "TERMOPT"] = 5;
        values[valuesById[6] = "RENEWAL"] = 6;
        values[valuesById[7] = "CANCELFEE"] = 7;
        values[valuesById[8] = "SVCCOST"] = 8;
        return values;
    })();

    /**
     * SourceTypeCode enum.
     * @name contractpb.SourceTypeCode
     * @enum {number}
     * @property {number} INVALID_SOURCE_TYPE=0 INVALID_SOURCE_TYPE value
     * @property {number} AUTOPAY=1 AUTOPAY value
     * @property {number} SALESENTRY=2 SALESENTRY value
     * @property {number} SERVICE=3 SERVICE value
     * @property {number} ACCOUNTING=4 ACCOUNTING value
     * @property {number} CMS=5 CMS value
     * @property {number} WEBSERVICE=6 WEBSERVICE value
     * @property {number} SERVSMART=7 SERVSMART value
     * @property {number} SALECENTRAL=8 SALECENTRAL value
     * @property {number} CSC=9 CSC value
     * @property {number} IVR=10 IVR value
     */
    contractpb.SourceTypeCode = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "INVALID_SOURCE_TYPE"] = 0;
        values[valuesById[1] = "AUTOPAY"] = 1;
        values[valuesById[2] = "SALESENTRY"] = 2;
        values[valuesById[3] = "SERVICE"] = 3;
        values[valuesById[4] = "ACCOUNTING"] = 4;
        values[valuesById[5] = "CMS"] = 5;
        values[valuesById[6] = "WEBSERVICE"] = 6;
        values[valuesById[7] = "SERVSMART"] = 7;
        values[valuesById[8] = "SALECENTRAL"] = 8;
        values[valuesById[9] = "CSC"] = 9;
        values[valuesById[10] = "IVR"] = 10;
        return values;
    })();

    /**
     * TransactionState enum.
     * @name contractpb.TransactionState
     * @enum {number}
     * @property {number} INVALID_STATE=0 INVALID_STATE value
     * @property {number} CHKPRMRCVD=1 CHKPRMRCVD value
     * @property {number} HOLD_CHECK=2 HOLD_CHECK value
     * @property {number} PROCESSED=3 PROCESSED value
     * @property {number} ERRORPYMEX=4 ERRORPYMEX value
     * @property {number} ERRORENTER=5 ERRORENTER value
     * @property {number} READY=6 READY value
     * @property {number} EXTRACTED=7 EXTRACTED value
     * @property {number} TRANS_RCVD=8 TRANS_RCVD value
     * @property {number} IN_TMPTABL=9 IN_TMPTABL value
     * @property {number} ERRORSQLFS=10 ERRORSQLFS value
     * @property {number} CLOSED=11 CLOSED value
     * @property {number} ERRORMD=12 ERRORMD value
     * @property {number} RDY_TOLOAD=13 RDY_TOLOAD value
     * @property {number} ADD_MODIFY=14 ADD_MODIFY value
     * @property {number} PROCESSING=15 PROCESSING value
     * @property {number} CANCEL=16 CANCEL value
     */
    contractpb.TransactionState = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "INVALID_STATE"] = 0;
        values[valuesById[1] = "CHKPRMRCVD"] = 1;
        values[valuesById[2] = "HOLD_CHECK"] = 2;
        values[valuesById[3] = "PROCESSED"] = 3;
        values[valuesById[4] = "ERRORPYMEX"] = 4;
        values[valuesById[5] = "ERRORENTER"] = 5;
        values[valuesById[6] = "READY"] = 6;
        values[valuesById[7] = "EXTRACTED"] = 7;
        values[valuesById[8] = "TRANS_RCVD"] = 8;
        values[valuesById[9] = "IN_TMPTABL"] = 9;
        values[valuesById[10] = "ERRORSQLFS"] = 10;
        values[valuesById[11] = "CLOSED"] = 11;
        values[valuesById[12] = "ERRORMD"] = 12;
        values[valuesById[13] = "RDY_TOLOAD"] = 13;
        values[valuesById[14] = "ADD_MODIFY"] = 14;
        values[valuesById[15] = "PROCESSING"] = 15;
        values[valuesById[16] = "CANCEL"] = 16;
        return values;
    })();

    /**
     * CreditCardType enum.
     * @name contractpb.CreditCardType
     * @enum {number}
     * @property {number} INVALID_CARD_TYPE=0 INVALID_CARD_TYPE value
     * @property {number} AMEX=1 AMEX value
     * @property {number} MC=2 MC value
     * @property {number} VISA=3 VISA value
     * @property {number} DSC=4 DSC value
     */
    contractpb.CreditCardType = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "INVALID_CARD_TYPE"] = 0;
        values[valuesById[1] = "AMEX"] = 1;
        values[valuesById[2] = "MC"] = 2;
        values[valuesById[3] = "VISA"] = 3;
        values[valuesById[4] = "DSC"] = 4;
        return values;
    })();

    /**
     * AchSecCode enum.
     * @name contractpb.AchSecCode
     * @enum {number}
     * @property {number} INVALID_CODE=0 INVALID_CODE value
     * @property {number} TEL=1 TEL value
     * @property {number} PPD=2 PPD value
     * @property {number} WEB=3 WEB value
     */
    contractpb.AchSecCode = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "INVALID_CODE"] = 0;
        values[valuesById[1] = "TEL"] = 1;
        values[valuesById[2] = "PPD"] = 2;
        values[valuesById[3] = "WEB"] = 3;
        return values;
    })();

    contractpb.CreditCardDetails = (function() {

        /**
         * Properties of a CreditCardDetails.
         * @memberof contractpb
         * @interface ICreditCardDetails
         * @property {contractpb.CreditCardType|null} [creditCardType] CreditCardDetails creditCardType
         * @property {string|null} [ccExpDate] CreditCardDetails ccExpDate
         * @property {string|null} [cardID] CreditCardDetails cardID
         */

        /**
         * Constructs a new CreditCardDetails.
         * @memberof contractpb
         * @classdesc Represents a CreditCardDetails.
         * @implements ICreditCardDetails
         * @constructor
         * @param {contractpb.ICreditCardDetails=} [p] Properties to set
         */
        function CreditCardDetails(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * CreditCardDetails creditCardType.
         * @member {contractpb.CreditCardType} creditCardType
         * @memberof contractpb.CreditCardDetails
         * @instance
         */
        CreditCardDetails.prototype.creditCardType = 0;

        /**
         * CreditCardDetails ccExpDate.
         * @member {string} ccExpDate
         * @memberof contractpb.CreditCardDetails
         * @instance
         */
        CreditCardDetails.prototype.ccExpDate = "";

        /**
         * CreditCardDetails cardID.
         * @member {string} cardID
         * @memberof contractpb.CreditCardDetails
         * @instance
         */
        CreditCardDetails.prototype.cardID = "";

        /**
         * Creates a new CreditCardDetails instance using the specified properties.
         * @function create
         * @memberof contractpb.CreditCardDetails
         * @static
         * @param {contractpb.ICreditCardDetails=} [properties] Properties to set
         * @returns {contractpb.CreditCardDetails} CreditCardDetails instance
         */
        CreditCardDetails.create = function create(properties) {
            return new CreditCardDetails(properties);
        };

        /**
         * Encodes the specified CreditCardDetails message. Does not implicitly {@link contractpb.CreditCardDetails.verify|verify} messages.
         * @function encode
         * @memberof contractpb.CreditCardDetails
         * @static
         * @param {contractpb.ICreditCardDetails} m CreditCardDetails message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CreditCardDetails.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.creditCardType != null && Object.hasOwnProperty.call(m, "creditCardType"))
                w.uint32(8).int32(m.creditCardType);
            if (m.ccExpDate != null && Object.hasOwnProperty.call(m, "ccExpDate"))
                w.uint32(18).string(m.ccExpDate);
            if (m.cardID != null && Object.hasOwnProperty.call(m, "cardID"))
                w.uint32(26).string(m.cardID);
            return w;
        };

        /**
         * Decodes a CreditCardDetails message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.CreditCardDetails
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.CreditCardDetails} CreditCardDetails
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CreditCardDetails.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.CreditCardDetails();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.creditCardType = r.int32();
                    break;
                case 2:
                    m.ccExpDate = r.string();
                    break;
                case 3:
                    m.cardID = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return CreditCardDetails;
    })();

    contractpb.ACHDetails = (function() {

        /**
         * Properties of a ACHDetails.
         * @memberof contractpb
         * @interface IACHDetails
         * @property {contractpb.AchSecCode|null} [achSecCode] ACHDetails achSecCode
         * @property {string|null} [achHolderFName] ACHDetails achHolderFName
         * @property {string|null} [achHolderLName] ACHDetails achHolderLName
         * @property {string|null} [routingNumber] ACHDetails routingNumber
         * @property {string|null} [accountNumber] ACHDetails accountNumber
         * @property {string|null} [accountType] ACHDetails accountType
         */

        /**
         * Constructs a new ACHDetails.
         * @memberof contractpb
         * @classdesc Represents a ACHDetails.
         * @implements IACHDetails
         * @constructor
         * @param {contractpb.IACHDetails=} [p] Properties to set
         */
        function ACHDetails(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * ACHDetails achSecCode.
         * @member {contractpb.AchSecCode} achSecCode
         * @memberof contractpb.ACHDetails
         * @instance
         */
        ACHDetails.prototype.achSecCode = 0;

        /**
         * ACHDetails achHolderFName.
         * @member {string} achHolderFName
         * @memberof contractpb.ACHDetails
         * @instance
         */
        ACHDetails.prototype.achHolderFName = "";

        /**
         * ACHDetails achHolderLName.
         * @member {string} achHolderLName
         * @memberof contractpb.ACHDetails
         * @instance
         */
        ACHDetails.prototype.achHolderLName = "";

        /**
         * ACHDetails routingNumber.
         * @member {string} routingNumber
         * @memberof contractpb.ACHDetails
         * @instance
         */
        ACHDetails.prototype.routingNumber = "";

        /**
         * ACHDetails accountNumber.
         * @member {string} accountNumber
         * @memberof contractpb.ACHDetails
         * @instance
         */
        ACHDetails.prototype.accountNumber = "";

        /**
         * ACHDetails accountType.
         * @member {string} accountType
         * @memberof contractpb.ACHDetails
         * @instance
         */
        ACHDetails.prototype.accountType = "";

        /**
         * Creates a new ACHDetails instance using the specified properties.
         * @function create
         * @memberof contractpb.ACHDetails
         * @static
         * @param {contractpb.IACHDetails=} [properties] Properties to set
         * @returns {contractpb.ACHDetails} ACHDetails instance
         */
        ACHDetails.create = function create(properties) {
            return new ACHDetails(properties);
        };

        /**
         * Encodes the specified ACHDetails message. Does not implicitly {@link contractpb.ACHDetails.verify|verify} messages.
         * @function encode
         * @memberof contractpb.ACHDetails
         * @static
         * @param {contractpb.IACHDetails} m ACHDetails message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ACHDetails.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.achSecCode != null && Object.hasOwnProperty.call(m, "achSecCode"))
                w.uint32(8).int32(m.achSecCode);
            if (m.achHolderFName != null && Object.hasOwnProperty.call(m, "achHolderFName"))
                w.uint32(18).string(m.achHolderFName);
            if (m.achHolderLName != null && Object.hasOwnProperty.call(m, "achHolderLName"))
                w.uint32(26).string(m.achHolderLName);
            if (m.routingNumber != null && Object.hasOwnProperty.call(m, "routingNumber"))
                w.uint32(34).string(m.routingNumber);
            if (m.accountNumber != null && Object.hasOwnProperty.call(m, "accountNumber"))
                w.uint32(42).string(m.accountNumber);
            if (m.accountType != null && Object.hasOwnProperty.call(m, "accountType"))
                w.uint32(50).string(m.accountType);
            return w;
        };

        /**
         * Decodes a ACHDetails message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.ACHDetails
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.ACHDetails} ACHDetails
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ACHDetails.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.ACHDetails();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.achSecCode = r.int32();
                    break;
                case 2:
                    m.achHolderFName = r.string();
                    break;
                case 3:
                    m.achHolderLName = r.string();
                    break;
                case 4:
                    m.routingNumber = r.string();
                    break;
                case 5:
                    m.accountNumber = r.string();
                    break;
                case 6:
                    m.accountType = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return ACHDetails;
    })();

    contractpb.PaymentDetails = (function() {

        /**
         * Properties of a PaymentDetails.
         * @memberof contractpb
         * @interface IPaymentDetails
         * @property {contractpb.PaymentType|null} [paymentType] PaymentDetails paymentType
         * @property {contractpb.PaymentTypeCode|null} [paymentTypeCode] PaymentDetails paymentTypeCode
         * @property {contractpb.SourceTypeCode|null} [sourceTypeCode] PaymentDetails sourceTypeCode
         * @property {contractpb.TransactionState|null} [transactionState] PaymentDetails transactionState
         * @property {number|null} [transactionAmount] PaymentDetails transactionAmount
         * @property {string|null} [paymentProcessingDate] PaymentDetails paymentProcessingDate
         * @property {string|null} [autoBillIndicator] PaymentDetails autoBillIndicator
         * @property {string|null} [paymentExtractedDate] PaymentDetails paymentExtractedDate
         * @property {string|null} [resubmitIndicator] PaymentDetails resubmitIndicator
         * @property {string|null} [accountID] PaymentDetails accountID
         * @property {string|null} [tokenFlag] PaymentDetails tokenFlag
         * @property {contractpb.IContractPropertyInfo|null} [billingAddress] PaymentDetails billingAddress
         * @property {contractpb.ICreditCardDetails|null} [creditCardDetail] PaymentDetails creditCardDetail
         * @property {contractpb.IACHDetails|null} [achDetail] PaymentDetails achDetail
         */

        /**
         * Constructs a new PaymentDetails.
         * @memberof contractpb
         * @classdesc Represents a PaymentDetails.
         * @implements IPaymentDetails
         * @constructor
         * @param {contractpb.IPaymentDetails=} [p] Properties to set
         */
        function PaymentDetails(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * PaymentDetails paymentType.
         * @member {contractpb.PaymentType} paymentType
         * @memberof contractpb.PaymentDetails
         * @instance
         */
        PaymentDetails.prototype.paymentType = 0;

        /**
         * PaymentDetails paymentTypeCode.
         * @member {contractpb.PaymentTypeCode} paymentTypeCode
         * @memberof contractpb.PaymentDetails
         * @instance
         */
        PaymentDetails.prototype.paymentTypeCode = 0;

        /**
         * PaymentDetails sourceTypeCode.
         * @member {contractpb.SourceTypeCode} sourceTypeCode
         * @memberof contractpb.PaymentDetails
         * @instance
         */
        PaymentDetails.prototype.sourceTypeCode = 0;

        /**
         * PaymentDetails transactionState.
         * @member {contractpb.TransactionState} transactionState
         * @memberof contractpb.PaymentDetails
         * @instance
         */
        PaymentDetails.prototype.transactionState = 0;

        /**
         * PaymentDetails transactionAmount.
         * @member {number} transactionAmount
         * @memberof contractpb.PaymentDetails
         * @instance
         */
        PaymentDetails.prototype.transactionAmount = 0;

        /**
         * PaymentDetails paymentProcessingDate.
         * @member {string} paymentProcessingDate
         * @memberof contractpb.PaymentDetails
         * @instance
         */
        PaymentDetails.prototype.paymentProcessingDate = "";

        /**
         * PaymentDetails autoBillIndicator.
         * @member {string} autoBillIndicator
         * @memberof contractpb.PaymentDetails
         * @instance
         */
        PaymentDetails.prototype.autoBillIndicator = "";

        /**
         * PaymentDetails paymentExtractedDate.
         * @member {string} paymentExtractedDate
         * @memberof contractpb.PaymentDetails
         * @instance
         */
        PaymentDetails.prototype.paymentExtractedDate = "";

        /**
         * PaymentDetails resubmitIndicator.
         * @member {string} resubmitIndicator
         * @memberof contractpb.PaymentDetails
         * @instance
         */
        PaymentDetails.prototype.resubmitIndicator = "";

        /**
         * PaymentDetails accountID.
         * @member {string} accountID
         * @memberof contractpb.PaymentDetails
         * @instance
         */
        PaymentDetails.prototype.accountID = "";

        /**
         * PaymentDetails tokenFlag.
         * @member {string} tokenFlag
         * @memberof contractpb.PaymentDetails
         * @instance
         */
        PaymentDetails.prototype.tokenFlag = "";

        /**
         * PaymentDetails billingAddress.
         * @member {contractpb.IContractPropertyInfo|null|undefined} billingAddress
         * @memberof contractpb.PaymentDetails
         * @instance
         */
        PaymentDetails.prototype.billingAddress = null;

        /**
         * PaymentDetails creditCardDetail.
         * @member {contractpb.ICreditCardDetails|null|undefined} creditCardDetail
         * @memberof contractpb.PaymentDetails
         * @instance
         */
        PaymentDetails.prototype.creditCardDetail = null;

        /**
         * PaymentDetails achDetail.
         * @member {contractpb.IACHDetails|null|undefined} achDetail
         * @memberof contractpb.PaymentDetails
         * @instance
         */
        PaymentDetails.prototype.achDetail = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        /**
         * PaymentDetails PaymentTypeDetails.
         * @member {"creditCardDetail"|"achDetail"|undefined} PaymentTypeDetails
         * @memberof contractpb.PaymentDetails
         * @instance
         */
        Object.defineProperty(PaymentDetails.prototype, "PaymentTypeDetails", {
            get: $util.oneOfGetter($oneOfFields = ["creditCardDetail", "achDetail"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new PaymentDetails instance using the specified properties.
         * @function create
         * @memberof contractpb.PaymentDetails
         * @static
         * @param {contractpb.IPaymentDetails=} [properties] Properties to set
         * @returns {contractpb.PaymentDetails} PaymentDetails instance
         */
        PaymentDetails.create = function create(properties) {
            return new PaymentDetails(properties);
        };

        /**
         * Encodes the specified PaymentDetails message. Does not implicitly {@link contractpb.PaymentDetails.verify|verify} messages.
         * @function encode
         * @memberof contractpb.PaymentDetails
         * @static
         * @param {contractpb.IPaymentDetails} m PaymentDetails message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PaymentDetails.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.paymentType != null && Object.hasOwnProperty.call(m, "paymentType"))
                w.uint32(8).int32(m.paymentType);
            if (m.paymentTypeCode != null && Object.hasOwnProperty.call(m, "paymentTypeCode"))
                w.uint32(16).int32(m.paymentTypeCode);
            if (m.sourceTypeCode != null && Object.hasOwnProperty.call(m, "sourceTypeCode"))
                w.uint32(24).int32(m.sourceTypeCode);
            if (m.transactionState != null && Object.hasOwnProperty.call(m, "transactionState"))
                w.uint32(32).int32(m.transactionState);
            if (m.transactionAmount != null && Object.hasOwnProperty.call(m, "transactionAmount"))
                w.uint32(45).float(m.transactionAmount);
            if (m.paymentProcessingDate != null && Object.hasOwnProperty.call(m, "paymentProcessingDate"))
                w.uint32(50).string(m.paymentProcessingDate);
            if (m.autoBillIndicator != null && Object.hasOwnProperty.call(m, "autoBillIndicator"))
                w.uint32(58).string(m.autoBillIndicator);
            if (m.paymentExtractedDate != null && Object.hasOwnProperty.call(m, "paymentExtractedDate"))
                w.uint32(66).string(m.paymentExtractedDate);
            if (m.resubmitIndicator != null && Object.hasOwnProperty.call(m, "resubmitIndicator"))
                w.uint32(74).string(m.resubmitIndicator);
            if (m.accountID != null && Object.hasOwnProperty.call(m, "accountID"))
                w.uint32(82).string(m.accountID);
            if (m.tokenFlag != null && Object.hasOwnProperty.call(m, "tokenFlag"))
                w.uint32(90).string(m.tokenFlag);
            if (m.billingAddress != null && Object.hasOwnProperty.call(m, "billingAddress"))
                $root.contractpb.ContractPropertyInfo.encode(m.billingAddress, w.uint32(98).fork()).ldelim();
            if (m.creditCardDetail != null && Object.hasOwnProperty.call(m, "creditCardDetail"))
                $root.contractpb.CreditCardDetails.encode(m.creditCardDetail, w.uint32(106).fork()).ldelim();
            if (m.achDetail != null && Object.hasOwnProperty.call(m, "achDetail"))
                $root.contractpb.ACHDetails.encode(m.achDetail, w.uint32(114).fork()).ldelim();
            return w;
        };

        /**
         * Decodes a PaymentDetails message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.PaymentDetails
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.PaymentDetails} PaymentDetails
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PaymentDetails.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.PaymentDetails();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.paymentType = r.int32();
                    break;
                case 2:
                    m.paymentTypeCode = r.int32();
                    break;
                case 3:
                    m.sourceTypeCode = r.int32();
                    break;
                case 4:
                    m.transactionState = r.int32();
                    break;
                case 5:
                    m.transactionAmount = r.float();
                    break;
                case 6:
                    m.paymentProcessingDate = r.string();
                    break;
                case 7:
                    m.autoBillIndicator = r.string();
                    break;
                case 8:
                    m.paymentExtractedDate = r.string();
                    break;
                case 9:
                    m.resubmitIndicator = r.string();
                    break;
                case 10:
                    m.accountID = r.string();
                    break;
                case 11:
                    m.tokenFlag = r.string();
                    break;
                case 12:
                    m.billingAddress = $root.contractpb.ContractPropertyInfo.decode(r, r.uint32());
                    break;
                case 13:
                    m.creditCardDetail = $root.contractpb.CreditCardDetails.decode(r, r.uint32());
                    break;
                case 14:
                    m.achDetail = $root.contractpb.ACHDetails.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return PaymentDetails;
    })();

    /**
     * MonieType enum.
     * @name contractpb.MonieType
     * @enum {number}
     * @property {number} INVALID_MONIE_TYPE=0 INVALID_MONIE_TYPE value
     * @property {number} PERDIEM=1 PERDIEM value
     * @property {number} PERDIEMCAP=2 PERDIEMCAP value
     * @property {number} ACTDISC=3 ACTDISC value
     * @property {number} SVCFEEDUE=4 SVCFEEDUE value
     * @property {number} SERVICEFEES=5 SERVICEFEES value
     * @property {number} ACTCONC=6 ACTCONC value
     * @property {number} OPEN=7 OPEN value
     * @property {number} CLOSREV=8 CLOSREV value
     * @property {number} LISTREV=9 LISTREV value
     * @property {number} LISTDUE=10 LISTDUE value
     * @property {number} ACTCOUPON=11 ACTCOUPON value
     * @property {number} FULL=12 FULL value
     * @property {number} PAYMNT=13 PAYMNT value
     * @property {number} INSTALL=14 INSTALL value
     * @property {number} PMTPLANFEE=15 PMTPLANFEE value
     * @property {number} PAID=16 PAID value
     * @property {number} TAXABLEAMT=17 TAXABLEAMT value
     * @property {number} TAXDUE=18 TAXDUE value
     * @property {number} CREDITAMT=19 CREDITAMT value
     * @property {number} CONTRACT=20 CONTRACT value
     * @property {number} PENDCONC=21 PENDCONC value
     * @property {number} PENDCOUPON=22 PENDCOUPON value
     * @property {number} TAXAMTPOST=23 TAXAMTPOST value
     * @property {number} TAXLISTBIL=24 TAXLISTBIL value
     * @property {number} TAXLISTREV=25 TAXLISTREV value
     * @property {number} PRICE=26 PRICE value
     * @property {number} TAXPAID=27 TAXPAID value
     * @property {number} CLOSNONREV=28 CLOSNONREV value
     * @property {number} PRIREVREC=29 PRIREVREC value
     * @property {number} CURREVREC=30 CURREVREC value
     * @property {number} LISTBILLED=31 LISTBILLED value
     * @property {number} DISCOUNT=32 DISCOUNT value
     */
    contractpb.MonieType = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "INVALID_MONIE_TYPE"] = 0;
        values[valuesById[1] = "PERDIEM"] = 1;
        values[valuesById[2] = "PERDIEMCAP"] = 2;
        values[valuesById[3] = "ACTDISC"] = 3;
        values[valuesById[4] = "SVCFEEDUE"] = 4;
        values[valuesById[5] = "SERVICEFEES"] = 5;
        values[valuesById[6] = "ACTCONC"] = 6;
        values[valuesById[7] = "OPEN"] = 7;
        values[valuesById[8] = "CLOSREV"] = 8;
        values[valuesById[9] = "LISTREV"] = 9;
        values[valuesById[10] = "LISTDUE"] = 10;
        values[valuesById[11] = "ACTCOUPON"] = 11;
        values[valuesById[12] = "FULL"] = 12;
        values[valuesById[13] = "PAYMNT"] = 13;
        values[valuesById[14] = "INSTALL"] = 14;
        values[valuesById[15] = "PMTPLANFEE"] = 15;
        values[valuesById[16] = "PAID"] = 16;
        values[valuesById[17] = "TAXABLEAMT"] = 17;
        values[valuesById[18] = "TAXDUE"] = 18;
        values[valuesById[19] = "CREDITAMT"] = 19;
        values[valuesById[20] = "CONTRACT"] = 20;
        values[valuesById[21] = "PENDCONC"] = 21;
        values[valuesById[22] = "PENDCOUPON"] = 22;
        values[valuesById[23] = "TAXAMTPOST"] = 23;
        values[valuesById[24] = "TAXLISTBIL"] = 24;
        values[valuesById[25] = "TAXLISTREV"] = 25;
        values[valuesById[26] = "PRICE"] = 26;
        values[valuesById[27] = "TAXPAID"] = 27;
        values[valuesById[28] = "CLOSNONREV"] = 28;
        values[valuesById[29] = "PRIREVREC"] = 29;
        values[valuesById[30] = "CURREVREC"] = 30;
        values[valuesById[31] = "LISTBILLED"] = 31;
        values[valuesById[32] = "DISCOUNT"] = 32;
        return values;
    })();

    contractpb.MoniesInfo = (function() {

        /**
         * Properties of a MoniesInfo.
         * @memberof contractpb
         * @interface IMoniesInfo
         * @property {contractpb.MonieType|null} [type] MoniesInfo type
         * @property {number|null} [amount] MoniesInfo amount
         */

        /**
         * Constructs a new MoniesInfo.
         * @memberof contractpb
         * @classdesc Represents a MoniesInfo.
         * @implements IMoniesInfo
         * @constructor
         * @param {contractpb.IMoniesInfo=} [p] Properties to set
         */
        function MoniesInfo(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * MoniesInfo type.
         * @member {contractpb.MonieType} type
         * @memberof contractpb.MoniesInfo
         * @instance
         */
        MoniesInfo.prototype.type = 0;

        /**
         * MoniesInfo amount.
         * @member {number} amount
         * @memberof contractpb.MoniesInfo
         * @instance
         */
        MoniesInfo.prototype.amount = 0;

        /**
         * Creates a new MoniesInfo instance using the specified properties.
         * @function create
         * @memberof contractpb.MoniesInfo
         * @static
         * @param {contractpb.IMoniesInfo=} [properties] Properties to set
         * @returns {contractpb.MoniesInfo} MoniesInfo instance
         */
        MoniesInfo.create = function create(properties) {
            return new MoniesInfo(properties);
        };

        /**
         * Encodes the specified MoniesInfo message. Does not implicitly {@link contractpb.MoniesInfo.verify|verify} messages.
         * @function encode
         * @memberof contractpb.MoniesInfo
         * @static
         * @param {contractpb.IMoniesInfo} m MoniesInfo message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MoniesInfo.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.type != null && Object.hasOwnProperty.call(m, "type"))
                w.uint32(8).int32(m.type);
            if (m.amount != null && Object.hasOwnProperty.call(m, "amount"))
                w.uint32(17).double(m.amount);
            return w;
        };

        /**
         * Decodes a MoniesInfo message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.MoniesInfo
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.MoniesInfo} MoniesInfo
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MoniesInfo.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.MoniesInfo();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.type = r.int32();
                    break;
                case 2:
                    m.amount = r.double();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return MoniesInfo;
    })();

    contractpb.ProductPriceDetailInfo = (function() {

        /**
         * Properties of a ProductPriceDetailInfo.
         * @memberof contractpb
         * @interface IProductPriceDetailInfo
         * @property {string|null} [productVersionID] ProductPriceDetailInfo productVersionID
         * @property {number|null} [basePrice] ProductPriceDetailInfo basePrice
         * @property {number|null} [optionPrice] ProductPriceDetailInfo optionPrice
         * @property {number|null} [salesTax] ProductPriceDetailInfo salesTax
         * @property {Array.<contractpb.ICoverage>|null} [coverages] ProductPriceDetailInfo coverages
         * @property {Array.<contractpb.IMoniesInfo>|null} [monies] ProductPriceDetailInfo monies
         * @property {Array.<string>|null} [discountCodes] ProductPriceDetailInfo discountCodes
         */

        /**
         * Constructs a new ProductPriceDetailInfo.
         * @memberof contractpb
         * @classdesc Represents a ProductPriceDetailInfo.
         * @implements IProductPriceDetailInfo
         * @constructor
         * @param {contractpb.IProductPriceDetailInfo=} [p] Properties to set
         */
        function ProductPriceDetailInfo(p) {
            this.coverages = [];
            this.monies = [];
            this.discountCodes = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * ProductPriceDetailInfo productVersionID.
         * @member {string} productVersionID
         * @memberof contractpb.ProductPriceDetailInfo
         * @instance
         */
        ProductPriceDetailInfo.prototype.productVersionID = "";

        /**
         * ProductPriceDetailInfo basePrice.
         * @member {number} basePrice
         * @memberof contractpb.ProductPriceDetailInfo
         * @instance
         */
        ProductPriceDetailInfo.prototype.basePrice = 0;

        /**
         * ProductPriceDetailInfo optionPrice.
         * @member {number} optionPrice
         * @memberof contractpb.ProductPriceDetailInfo
         * @instance
         */
        ProductPriceDetailInfo.prototype.optionPrice = 0;

        /**
         * ProductPriceDetailInfo salesTax.
         * @member {number} salesTax
         * @memberof contractpb.ProductPriceDetailInfo
         * @instance
         */
        ProductPriceDetailInfo.prototype.salesTax = 0;

        /**
         * ProductPriceDetailInfo coverages.
         * @member {Array.<contractpb.ICoverage>} coverages
         * @memberof contractpb.ProductPriceDetailInfo
         * @instance
         */
        ProductPriceDetailInfo.prototype.coverages = $util.emptyArray;

        /**
         * ProductPriceDetailInfo monies.
         * @member {Array.<contractpb.IMoniesInfo>} monies
         * @memberof contractpb.ProductPriceDetailInfo
         * @instance
         */
        ProductPriceDetailInfo.prototype.monies = $util.emptyArray;

        /**
         * ProductPriceDetailInfo discountCodes.
         * @member {Array.<string>} discountCodes
         * @memberof contractpb.ProductPriceDetailInfo
         * @instance
         */
        ProductPriceDetailInfo.prototype.discountCodes = $util.emptyArray;

        /**
         * Creates a new ProductPriceDetailInfo instance using the specified properties.
         * @function create
         * @memberof contractpb.ProductPriceDetailInfo
         * @static
         * @param {contractpb.IProductPriceDetailInfo=} [properties] Properties to set
         * @returns {contractpb.ProductPriceDetailInfo} ProductPriceDetailInfo instance
         */
        ProductPriceDetailInfo.create = function create(properties) {
            return new ProductPriceDetailInfo(properties);
        };

        /**
         * Encodes the specified ProductPriceDetailInfo message. Does not implicitly {@link contractpb.ProductPriceDetailInfo.verify|verify} messages.
         * @function encode
         * @memberof contractpb.ProductPriceDetailInfo
         * @static
         * @param {contractpb.IProductPriceDetailInfo} m ProductPriceDetailInfo message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ProductPriceDetailInfo.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.productVersionID != null && Object.hasOwnProperty.call(m, "productVersionID"))
                w.uint32(10).string(m.productVersionID);
            if (m.basePrice != null && Object.hasOwnProperty.call(m, "basePrice"))
                w.uint32(17).double(m.basePrice);
            if (m.optionPrice != null && Object.hasOwnProperty.call(m, "optionPrice"))
                w.uint32(25).double(m.optionPrice);
            if (m.salesTax != null && Object.hasOwnProperty.call(m, "salesTax"))
                w.uint32(33).double(m.salesTax);
            if (m.coverages != null && m.coverages.length) {
                for (var i = 0; i < m.coverages.length; ++i)
                    $root.contractpb.Coverage.encode(m.coverages[i], w.uint32(42).fork()).ldelim();
            }
            if (m.monies != null && m.monies.length) {
                for (var i = 0; i < m.monies.length; ++i)
                    $root.contractpb.MoniesInfo.encode(m.monies[i], w.uint32(50).fork()).ldelim();
            }
            if (m.discountCodes != null && m.discountCodes.length) {
                for (var i = 0; i < m.discountCodes.length; ++i)
                    w.uint32(74).string(m.discountCodes[i]);
            }
            return w;
        };

        /**
         * Decodes a ProductPriceDetailInfo message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.ProductPriceDetailInfo
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.ProductPriceDetailInfo} ProductPriceDetailInfo
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ProductPriceDetailInfo.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.ProductPriceDetailInfo();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.productVersionID = r.string();
                    break;
                case 2:
                    m.basePrice = r.double();
                    break;
                case 3:
                    m.optionPrice = r.double();
                    break;
                case 4:
                    m.salesTax = r.double();
                    break;
                case 5:
                    if (!(m.coverages && m.coverages.length))
                        m.coverages = [];
                    m.coverages.push($root.contractpb.Coverage.decode(r, r.uint32()));
                    break;
                case 6:
                    if (!(m.monies && m.monies.length))
                        m.monies = [];
                    m.monies.push($root.contractpb.MoniesInfo.decode(r, r.uint32()));
                    break;
                case 9:
                    if (!(m.discountCodes && m.discountCodes.length))
                        m.discountCodes = [];
                    m.discountCodes.push(r.string());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return ProductPriceDetailInfo;
    })();

    contractpb.FutureEffectiveInfo = (function() {

        /**
         * Properties of a FutureEffectiveInfo.
         * @memberof contractpb
         * @interface IFutureEffectiveInfo
         * @property {string|null} [productVersionID] FutureEffectiveInfo productVersionID
         * @property {string|null} [quoteID] FutureEffectiveInfo quoteID
         * @property {string|null} [marketScore] FutureEffectiveInfo marketScore
         * @property {string|null} [tncID] FutureEffectiveInfo tncID
         * @property {string|null} [effectiveDate] FutureEffectiveInfo effectiveDate
         * @property {string|null} [orderID] FutureEffectiveInfo orderID
         */

        /**
         * Constructs a new FutureEffectiveInfo.
         * @memberof contractpb
         * @classdesc Represents a FutureEffectiveInfo.
         * @implements IFutureEffectiveInfo
         * @constructor
         * @param {contractpb.IFutureEffectiveInfo=} [p] Properties to set
         */
        function FutureEffectiveInfo(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * FutureEffectiveInfo productVersionID.
         * @member {string} productVersionID
         * @memberof contractpb.FutureEffectiveInfo
         * @instance
         */
        FutureEffectiveInfo.prototype.productVersionID = "";

        /**
         * FutureEffectiveInfo quoteID.
         * @member {string} quoteID
         * @memberof contractpb.FutureEffectiveInfo
         * @instance
         */
        FutureEffectiveInfo.prototype.quoteID = "";

        /**
         * FutureEffectiveInfo marketScore.
         * @member {string} marketScore
         * @memberof contractpb.FutureEffectiveInfo
         * @instance
         */
        FutureEffectiveInfo.prototype.marketScore = "";

        /**
         * FutureEffectiveInfo tncID.
         * @member {string} tncID
         * @memberof contractpb.FutureEffectiveInfo
         * @instance
         */
        FutureEffectiveInfo.prototype.tncID = "";

        /**
         * FutureEffectiveInfo effectiveDate.
         * @member {string} effectiveDate
         * @memberof contractpb.FutureEffectiveInfo
         * @instance
         */
        FutureEffectiveInfo.prototype.effectiveDate = "";

        /**
         * FutureEffectiveInfo orderID.
         * @member {string} orderID
         * @memberof contractpb.FutureEffectiveInfo
         * @instance
         */
        FutureEffectiveInfo.prototype.orderID = "";

        /**
         * Creates a new FutureEffectiveInfo instance using the specified properties.
         * @function create
         * @memberof contractpb.FutureEffectiveInfo
         * @static
         * @param {contractpb.IFutureEffectiveInfo=} [properties] Properties to set
         * @returns {contractpb.FutureEffectiveInfo} FutureEffectiveInfo instance
         */
        FutureEffectiveInfo.create = function create(properties) {
            return new FutureEffectiveInfo(properties);
        };

        /**
         * Encodes the specified FutureEffectiveInfo message. Does not implicitly {@link contractpb.FutureEffectiveInfo.verify|verify} messages.
         * @function encode
         * @memberof contractpb.FutureEffectiveInfo
         * @static
         * @param {contractpb.IFutureEffectiveInfo} m FutureEffectiveInfo message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        FutureEffectiveInfo.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.productVersionID != null && Object.hasOwnProperty.call(m, "productVersionID"))
                w.uint32(10).string(m.productVersionID);
            if (m.quoteID != null && Object.hasOwnProperty.call(m, "quoteID"))
                w.uint32(18).string(m.quoteID);
            if (m.marketScore != null && Object.hasOwnProperty.call(m, "marketScore"))
                w.uint32(26).string(m.marketScore);
            if (m.tncID != null && Object.hasOwnProperty.call(m, "tncID"))
                w.uint32(34).string(m.tncID);
            if (m.effectiveDate != null && Object.hasOwnProperty.call(m, "effectiveDate"))
                w.uint32(42).string(m.effectiveDate);
            if (m.orderID != null && Object.hasOwnProperty.call(m, "orderID"))
                w.uint32(50).string(m.orderID);
            return w;
        };

        /**
         * Decodes a FutureEffectiveInfo message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.FutureEffectiveInfo
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.FutureEffectiveInfo} FutureEffectiveInfo
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        FutureEffectiveInfo.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.FutureEffectiveInfo();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.productVersionID = r.string();
                    break;
                case 2:
                    m.quoteID = r.string();
                    break;
                case 3:
                    m.marketScore = r.string();
                    break;
                case 4:
                    m.tncID = r.string();
                    break;
                case 5:
                    m.effectiveDate = r.string();
                    break;
                case 6:
                    m.orderID = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return FutureEffectiveInfo;
    })();

    contractpb.ContractData = (function() {

        /**
         * Properties of a ContractData.
         * @memberof contractpb
         * @interface IContractData
         * @property {string|null} [companyCode] ContractData companyCode
         * @property {string|null} [salesChannel] ContractData salesChannel
         * @property {Array.<contractpb.IContractDate>|null} [contractDates] ContractData contractDates
         * @property {string|null} [salesAgentID] ContractData salesAgentID
         * @property {string|null} [partnerID] ContractData partnerID
         * @property {string|null} [referenceID] ContractData referenceID
         * @property {Array.<contractpb.IAgent>|null} [agents] ContractData agents
         * @property {string|null} [originalSalesChannel] ContractData originalSalesChannel
         * @property {coreproductpb.TypedValue.ITimePeriod|null} [contractTerm] ContractData contractTerm
         * @property {number|null} [invoiceDay] ContractData invoiceDay
         * @property {contractpb.InvoiceMonths|null} [invoiceMonth] ContractData invoiceMonth
         * @property {number|null} [invoiceYear] ContractData invoiceYear
         * @property {Array.<contractpb.IContractDetailsInfo>|null} [contractDetailsInfo] ContractData contractDetailsInfo
         * @property {string|null} [nextContractID] ContractData nextContractID
         * @property {contractpb.IInvoiceDetails|null} [invoiceDetails] ContractData invoiceDetails
         * @property {string|null} [previousContractID] ContractData previousContractID
         * @property {common.IDate|null} [contractExpiryDate] ContractData contractExpiryDate
         */

        /**
         * Constructs a new ContractData.
         * @memberof contractpb
         * @classdesc Represents a ContractData.
         * @implements IContractData
         * @constructor
         * @param {contractpb.IContractData=} [p] Properties to set
         */
        function ContractData(p) {
            this.contractDates = [];
            this.agents = [];
            this.contractDetailsInfo = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * ContractData companyCode.
         * @member {string} companyCode
         * @memberof contractpb.ContractData
         * @instance
         */
        ContractData.prototype.companyCode = "";

        /**
         * ContractData salesChannel.
         * @member {string} salesChannel
         * @memberof contractpb.ContractData
         * @instance
         */
        ContractData.prototype.salesChannel = "";

        /**
         * ContractData contractDates.
         * @member {Array.<contractpb.IContractDate>} contractDates
         * @memberof contractpb.ContractData
         * @instance
         */
        ContractData.prototype.contractDates = $util.emptyArray;

        /**
         * ContractData salesAgentID.
         * @member {string} salesAgentID
         * @memberof contractpb.ContractData
         * @instance
         */
        ContractData.prototype.salesAgentID = "";

        /**
         * ContractData partnerID.
         * @member {string} partnerID
         * @memberof contractpb.ContractData
         * @instance
         */
        ContractData.prototype.partnerID = "";

        /**
         * ContractData referenceID.
         * @member {string} referenceID
         * @memberof contractpb.ContractData
         * @instance
         */
        ContractData.prototype.referenceID = "";

        /**
         * ContractData agents.
         * @member {Array.<contractpb.IAgent>} agents
         * @memberof contractpb.ContractData
         * @instance
         */
        ContractData.prototype.agents = $util.emptyArray;

        /**
         * ContractData originalSalesChannel.
         * @member {string} originalSalesChannel
         * @memberof contractpb.ContractData
         * @instance
         */
        ContractData.prototype.originalSalesChannel = "";

        /**
         * ContractData contractTerm.
         * @member {coreproductpb.TypedValue.ITimePeriod|null|undefined} contractTerm
         * @memberof contractpb.ContractData
         * @instance
         */
        ContractData.prototype.contractTerm = null;

        /**
         * ContractData invoiceDay.
         * @member {number} invoiceDay
         * @memberof contractpb.ContractData
         * @instance
         */
        ContractData.prototype.invoiceDay = 0;

        /**
         * ContractData invoiceMonth.
         * @member {contractpb.InvoiceMonths} invoiceMonth
         * @memberof contractpb.ContractData
         * @instance
         */
        ContractData.prototype.invoiceMonth = 0;

        /**
         * ContractData invoiceYear.
         * @member {number} invoiceYear
         * @memberof contractpb.ContractData
         * @instance
         */
        ContractData.prototype.invoiceYear = 0;

        /**
         * ContractData contractDetailsInfo.
         * @member {Array.<contractpb.IContractDetailsInfo>} contractDetailsInfo
         * @memberof contractpb.ContractData
         * @instance
         */
        ContractData.prototype.contractDetailsInfo = $util.emptyArray;

        /**
         * ContractData nextContractID.
         * @member {string} nextContractID
         * @memberof contractpb.ContractData
         * @instance
         */
        ContractData.prototype.nextContractID = "";

        /**
         * ContractData invoiceDetails.
         * @member {contractpb.IInvoiceDetails|null|undefined} invoiceDetails
         * @memberof contractpb.ContractData
         * @instance
         */
        ContractData.prototype.invoiceDetails = null;

        /**
         * ContractData previousContractID.
         * @member {string} previousContractID
         * @memberof contractpb.ContractData
         * @instance
         */
        ContractData.prototype.previousContractID = "";

        /**
         * ContractData contractExpiryDate.
         * @member {common.IDate|null|undefined} contractExpiryDate
         * @memberof contractpb.ContractData
         * @instance
         */
        ContractData.prototype.contractExpiryDate = null;

        /**
         * Creates a new ContractData instance using the specified properties.
         * @function create
         * @memberof contractpb.ContractData
         * @static
         * @param {contractpb.IContractData=} [properties] Properties to set
         * @returns {contractpb.ContractData} ContractData instance
         */
        ContractData.create = function create(properties) {
            return new ContractData(properties);
        };

        /**
         * Encodes the specified ContractData message. Does not implicitly {@link contractpb.ContractData.verify|verify} messages.
         * @function encode
         * @memberof contractpb.ContractData
         * @static
         * @param {contractpb.IContractData} m ContractData message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ContractData.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.companyCode != null && Object.hasOwnProperty.call(m, "companyCode"))
                w.uint32(10).string(m.companyCode);
            if (m.salesChannel != null && Object.hasOwnProperty.call(m, "salesChannel"))
                w.uint32(18).string(m.salesChannel);
            if (m.contractDates != null && m.contractDates.length) {
                for (var i = 0; i < m.contractDates.length; ++i)
                    $root.contractpb.ContractDate.encode(m.contractDates[i], w.uint32(26).fork()).ldelim();
            }
            if (m.salesAgentID != null && Object.hasOwnProperty.call(m, "salesAgentID"))
                w.uint32(34).string(m.salesAgentID);
            if (m.partnerID != null && Object.hasOwnProperty.call(m, "partnerID"))
                w.uint32(42).string(m.partnerID);
            if (m.referenceID != null && Object.hasOwnProperty.call(m, "referenceID"))
                w.uint32(50).string(m.referenceID);
            if (m.agents != null && m.agents.length) {
                for (var i = 0; i < m.agents.length; ++i)
                    $root.contractpb.Agent.encode(m.agents[i], w.uint32(58).fork()).ldelim();
            }
            if (m.originalSalesChannel != null && Object.hasOwnProperty.call(m, "originalSalesChannel"))
                w.uint32(66).string(m.originalSalesChannel);
            if (m.contractTerm != null && Object.hasOwnProperty.call(m, "contractTerm"))
                $root.coreproductpb.TypedValue.TimePeriod.encode(m.contractTerm, w.uint32(74).fork()).ldelim();
            if (m.invoiceDay != null && Object.hasOwnProperty.call(m, "invoiceDay"))
                w.uint32(80).int32(m.invoiceDay);
            if (m.invoiceMonth != null && Object.hasOwnProperty.call(m, "invoiceMonth"))
                w.uint32(88).int32(m.invoiceMonth);
            if (m.invoiceYear != null && Object.hasOwnProperty.call(m, "invoiceYear"))
                w.uint32(96).int32(m.invoiceYear);
            if (m.contractDetailsInfo != null && m.contractDetailsInfo.length) {
                for (var i = 0; i < m.contractDetailsInfo.length; ++i)
                    $root.contractpb.ContractDetailsInfo.encode(m.contractDetailsInfo[i], w.uint32(106).fork()).ldelim();
            }
            if (m.nextContractID != null && Object.hasOwnProperty.call(m, "nextContractID"))
                w.uint32(114).string(m.nextContractID);
            if (m.invoiceDetails != null && Object.hasOwnProperty.call(m, "invoiceDetails"))
                $root.contractpb.InvoiceDetails.encode(m.invoiceDetails, w.uint32(122).fork()).ldelim();
            if (m.previousContractID != null && Object.hasOwnProperty.call(m, "previousContractID"))
                w.uint32(130).string(m.previousContractID);
            if (m.contractExpiryDate != null && Object.hasOwnProperty.call(m, "contractExpiryDate"))
                $root.common.Date.encode(m.contractExpiryDate, w.uint32(138).fork()).ldelim();
            return w;
        };

        /**
         * Decodes a ContractData message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.ContractData
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.ContractData} ContractData
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ContractData.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.ContractData();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.companyCode = r.string();
                    break;
                case 2:
                    m.salesChannel = r.string();
                    break;
                case 3:
                    if (!(m.contractDates && m.contractDates.length))
                        m.contractDates = [];
                    m.contractDates.push($root.contractpb.ContractDate.decode(r, r.uint32()));
                    break;
                case 4:
                    m.salesAgentID = r.string();
                    break;
                case 5:
                    m.partnerID = r.string();
                    break;
                case 6:
                    m.referenceID = r.string();
                    break;
                case 7:
                    if (!(m.agents && m.agents.length))
                        m.agents = [];
                    m.agents.push($root.contractpb.Agent.decode(r, r.uint32()));
                    break;
                case 8:
                    m.originalSalesChannel = r.string();
                    break;
                case 9:
                    m.contractTerm = $root.coreproductpb.TypedValue.TimePeriod.decode(r, r.uint32());
                    break;
                case 10:
                    m.invoiceDay = r.int32();
                    break;
                case 11:
                    m.invoiceMonth = r.int32();
                    break;
                case 12:
                    m.invoiceYear = r.int32();
                    break;
                case 13:
                    if (!(m.contractDetailsInfo && m.contractDetailsInfo.length))
                        m.contractDetailsInfo = [];
                    m.contractDetailsInfo.push($root.contractpb.ContractDetailsInfo.decode(r, r.uint32()));
                    break;
                case 14:
                    m.nextContractID = r.string();
                    break;
                case 15:
                    m.invoiceDetails = $root.contractpb.InvoiceDetails.decode(r, r.uint32());
                    break;
                case 16:
                    m.previousContractID = r.string();
                    break;
                case 17:
                    m.contractExpiryDate = $root.common.Date.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return ContractData;
    })();

    contractpb.InvoiceDetails = (function() {

        /**
         * Properties of an InvoiceDetails.
         * @memberof contractpb
         * @interface IInvoiceDetails
         * @property {number|null} [invoiceDay] InvoiceDetails invoiceDay
         * @property {contractpb.InvoiceMonths|null} [invoiceMonth] InvoiceDetails invoiceMonth
         * @property {number|null} [invoiceYear] InvoiceDetails invoiceYear
         * @property {number|null} [invoiceDayUpdateCounter] InvoiceDetails invoiceDayUpdateCounter
         * @property {string|null} [invoiceDayLastModified] InvoiceDetails invoiceDayLastModified
         */

        /**
         * Constructs a new InvoiceDetails.
         * @memberof contractpb
         * @classdesc Represents an InvoiceDetails.
         * @implements IInvoiceDetails
         * @constructor
         * @param {contractpb.IInvoiceDetails=} [p] Properties to set
         */
        function InvoiceDetails(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * InvoiceDetails invoiceDay.
         * @member {number} invoiceDay
         * @memberof contractpb.InvoiceDetails
         * @instance
         */
        InvoiceDetails.prototype.invoiceDay = 0;

        /**
         * InvoiceDetails invoiceMonth.
         * @member {contractpb.InvoiceMonths} invoiceMonth
         * @memberof contractpb.InvoiceDetails
         * @instance
         */
        InvoiceDetails.prototype.invoiceMonth = 0;

        /**
         * InvoiceDetails invoiceYear.
         * @member {number} invoiceYear
         * @memberof contractpb.InvoiceDetails
         * @instance
         */
        InvoiceDetails.prototype.invoiceYear = 0;

        /**
         * InvoiceDetails invoiceDayUpdateCounter.
         * @member {number} invoiceDayUpdateCounter
         * @memberof contractpb.InvoiceDetails
         * @instance
         */
        InvoiceDetails.prototype.invoiceDayUpdateCounter = 0;

        /**
         * InvoiceDetails invoiceDayLastModified.
         * @member {string} invoiceDayLastModified
         * @memberof contractpb.InvoiceDetails
         * @instance
         */
        InvoiceDetails.prototype.invoiceDayLastModified = "";

        /**
         * Creates a new InvoiceDetails instance using the specified properties.
         * @function create
         * @memberof contractpb.InvoiceDetails
         * @static
         * @param {contractpb.IInvoiceDetails=} [properties] Properties to set
         * @returns {contractpb.InvoiceDetails} InvoiceDetails instance
         */
        InvoiceDetails.create = function create(properties) {
            return new InvoiceDetails(properties);
        };

        /**
         * Encodes the specified InvoiceDetails message. Does not implicitly {@link contractpb.InvoiceDetails.verify|verify} messages.
         * @function encode
         * @memberof contractpb.InvoiceDetails
         * @static
         * @param {contractpb.IInvoiceDetails} m InvoiceDetails message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        InvoiceDetails.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.invoiceDay != null && Object.hasOwnProperty.call(m, "invoiceDay"))
                w.uint32(8).int32(m.invoiceDay);
            if (m.invoiceMonth != null && Object.hasOwnProperty.call(m, "invoiceMonth"))
                w.uint32(16).int32(m.invoiceMonth);
            if (m.invoiceYear != null && Object.hasOwnProperty.call(m, "invoiceYear"))
                w.uint32(24).int32(m.invoiceYear);
            if (m.invoiceDayUpdateCounter != null && Object.hasOwnProperty.call(m, "invoiceDayUpdateCounter"))
                w.uint32(32).int32(m.invoiceDayUpdateCounter);
            if (m.invoiceDayLastModified != null && Object.hasOwnProperty.call(m, "invoiceDayLastModified"))
                w.uint32(42).string(m.invoiceDayLastModified);
            return w;
        };

        /**
         * Decodes an InvoiceDetails message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.InvoiceDetails
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.InvoiceDetails} InvoiceDetails
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        InvoiceDetails.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.InvoiceDetails();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.invoiceDay = r.int32();
                    break;
                case 2:
                    m.invoiceMonth = r.int32();
                    break;
                case 3:
                    m.invoiceYear = r.int32();
                    break;
                case 4:
                    m.invoiceDayUpdateCounter = r.int32();
                    break;
                case 5:
                    m.invoiceDayLastModified = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return InvoiceDetails;
    })();

    contractpb.REChannelData = (function() {

        /**
         * Properties of a REChannelData.
         * @memberof contractpb
         * @interface IREChannelData
         * @property {contractpb.IRealEstateOffice|null} [initiatingOffice] REChannelData initiatingOffice
         * @property {contractpb.IRealEstateOffice|null} [cooperatingOffice] REChannelData cooperatingOffice
         * @property {contractpb.IRealEstateOffice|null} [closingOffice] REChannelData closingOffice
         * @property {string|null} [proratedContractID] REChannelData proratedContractID
         * @property {common.IMoney|null} [prorationCredit] REChannelData prorationCredit
         * @property {string|null} [escrowNumber] REChannelData escrowNumber
         */

        /**
         * Constructs a new REChannelData.
         * @memberof contractpb
         * @classdesc Represents a REChannelData.
         * @implements IREChannelData
         * @constructor
         * @param {contractpb.IREChannelData=} [p] Properties to set
         */
        function REChannelData(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * REChannelData initiatingOffice.
         * @member {contractpb.IRealEstateOffice|null|undefined} initiatingOffice
         * @memberof contractpb.REChannelData
         * @instance
         */
        REChannelData.prototype.initiatingOffice = null;

        /**
         * REChannelData cooperatingOffice.
         * @member {contractpb.IRealEstateOffice|null|undefined} cooperatingOffice
         * @memberof contractpb.REChannelData
         * @instance
         */
        REChannelData.prototype.cooperatingOffice = null;

        /**
         * REChannelData closingOffice.
         * @member {contractpb.IRealEstateOffice|null|undefined} closingOffice
         * @memberof contractpb.REChannelData
         * @instance
         */
        REChannelData.prototype.closingOffice = null;

        /**
         * REChannelData proratedContractID.
         * @member {string} proratedContractID
         * @memberof contractpb.REChannelData
         * @instance
         */
        REChannelData.prototype.proratedContractID = "";

        /**
         * REChannelData prorationCredit.
         * @member {common.IMoney|null|undefined} prorationCredit
         * @memberof contractpb.REChannelData
         * @instance
         */
        REChannelData.prototype.prorationCredit = null;

        /**
         * REChannelData escrowNumber.
         * @member {string} escrowNumber
         * @memberof contractpb.REChannelData
         * @instance
         */
        REChannelData.prototype.escrowNumber = "";

        /**
         * Creates a new REChannelData instance using the specified properties.
         * @function create
         * @memberof contractpb.REChannelData
         * @static
         * @param {contractpb.IREChannelData=} [properties] Properties to set
         * @returns {contractpb.REChannelData} REChannelData instance
         */
        REChannelData.create = function create(properties) {
            return new REChannelData(properties);
        };

        /**
         * Encodes the specified REChannelData message. Does not implicitly {@link contractpb.REChannelData.verify|verify} messages.
         * @function encode
         * @memberof contractpb.REChannelData
         * @static
         * @param {contractpb.IREChannelData} m REChannelData message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        REChannelData.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.initiatingOffice != null && Object.hasOwnProperty.call(m, "initiatingOffice"))
                $root.contractpb.RealEstateOffice.encode(m.initiatingOffice, w.uint32(10).fork()).ldelim();
            if (m.cooperatingOffice != null && Object.hasOwnProperty.call(m, "cooperatingOffice"))
                $root.contractpb.RealEstateOffice.encode(m.cooperatingOffice, w.uint32(18).fork()).ldelim();
            if (m.closingOffice != null && Object.hasOwnProperty.call(m, "closingOffice"))
                $root.contractpb.RealEstateOffice.encode(m.closingOffice, w.uint32(26).fork()).ldelim();
            if (m.proratedContractID != null && Object.hasOwnProperty.call(m, "proratedContractID"))
                w.uint32(34).string(m.proratedContractID);
            if (m.prorationCredit != null && Object.hasOwnProperty.call(m, "prorationCredit"))
                $root.common.Money.encode(m.prorationCredit, w.uint32(42).fork()).ldelim();
            if (m.escrowNumber != null && Object.hasOwnProperty.call(m, "escrowNumber"))
                w.uint32(50).string(m.escrowNumber);
            return w;
        };

        /**
         * Decodes a REChannelData message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.REChannelData
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.REChannelData} REChannelData
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        REChannelData.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.REChannelData();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.initiatingOffice = $root.contractpb.RealEstateOffice.decode(r, r.uint32());
                    break;
                case 2:
                    m.cooperatingOffice = $root.contractpb.RealEstateOffice.decode(r, r.uint32());
                    break;
                case 3:
                    m.closingOffice = $root.contractpb.RealEstateOffice.decode(r, r.uint32());
                    break;
                case 4:
                    m.proratedContractID = r.string();
                    break;
                case 5:
                    m.prorationCredit = $root.common.Money.decode(r, r.uint32());
                    break;
                case 6:
                    m.escrowNumber = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return REChannelData;
    })();

    contractpb.DCChannelData = (function() {

        /**
         * Properties of a DCChannelData.
         * @memberof contractpb
         * @interface IDCChannelData
         * @property {string|null} [salesSourceID] DCChannelData salesSourceID
         * @property {Array.<contractpb.ISalesPersonInfo>|null} [salesPersons] DCChannelData salesPersons
         */

        /**
         * Constructs a new DCChannelData.
         * @memberof contractpb
         * @classdesc Represents a DCChannelData.
         * @implements IDCChannelData
         * @constructor
         * @param {contractpb.IDCChannelData=} [p] Properties to set
         */
        function DCChannelData(p) {
            this.salesPersons = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * DCChannelData salesSourceID.
         * @member {string} salesSourceID
         * @memberof contractpb.DCChannelData
         * @instance
         */
        DCChannelData.prototype.salesSourceID = "";

        /**
         * DCChannelData salesPersons.
         * @member {Array.<contractpb.ISalesPersonInfo>} salesPersons
         * @memberof contractpb.DCChannelData
         * @instance
         */
        DCChannelData.prototype.salesPersons = $util.emptyArray;

        /**
         * Creates a new DCChannelData instance using the specified properties.
         * @function create
         * @memberof contractpb.DCChannelData
         * @static
         * @param {contractpb.IDCChannelData=} [properties] Properties to set
         * @returns {contractpb.DCChannelData} DCChannelData instance
         */
        DCChannelData.create = function create(properties) {
            return new DCChannelData(properties);
        };

        /**
         * Encodes the specified DCChannelData message. Does not implicitly {@link contractpb.DCChannelData.verify|verify} messages.
         * @function encode
         * @memberof contractpb.DCChannelData
         * @static
         * @param {contractpb.IDCChannelData} m DCChannelData message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        DCChannelData.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.salesSourceID != null && Object.hasOwnProperty.call(m, "salesSourceID"))
                w.uint32(10).string(m.salesSourceID);
            if (m.salesPersons != null && m.salesPersons.length) {
                for (var i = 0; i < m.salesPersons.length; ++i)
                    $root.contractpb.SalesPersonInfo.encode(m.salesPersons[i], w.uint32(18).fork()).ldelim();
            }
            return w;
        };

        /**
         * Decodes a DCChannelData message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.DCChannelData
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.DCChannelData} DCChannelData
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        DCChannelData.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.DCChannelData();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.salesSourceID = r.string();
                    break;
                case 2:
                    if (!(m.salesPersons && m.salesPersons.length))
                        m.salesPersons = [];
                    m.salesPersons.push($root.contractpb.SalesPersonInfo.decode(r, r.uint32()));
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return DCChannelData;
    })();

    contractpb.ContractInfo = (function() {

        /**
         * Properties of a ContractInfo.
         * @memberof contractpb
         * @interface IContractInfo
         * @property {string|null} [contractID] ContractInfo contractID
         * @property {string|null} [contractStatus] ContractInfo contractStatus
         * @property {contractpb.IContractData|null} [contractData] ContractInfo contractData
         * @property {Array.<contractpb.IContractCustomerInfo>|null} [customerDetails] ContractInfo customerDetails
         * @property {contractpb.IContractPropertyInfo|null} [coveredPropertyAddress] ContractInfo coveredPropertyAddress
         * @property {contractpb.IContractPropertyInfo|null} [mailingAddress] ContractInfo mailingAddress
         * @property {contractpb.IREChannelData|null} [reChannelData] ContractInfo reChannelData
         * @property {contractpb.IDCChannelData|null} [dcChannelData] ContractInfo dcChannelData
         * @property {Array.<contractpb.IContractNote>|null} [contractNotes] ContractInfo contractNotes
         * @property {contractpb.IProductPriceDetailInfo|null} [productPriceDetail] ContractInfo productPriceDetail
         * @property {Array.<contractpb.IFutureEffectiveInfo>|null} [futureEffectiveInfo] ContractInfo futureEffectiveInfo
         * @property {string|null} [salesSourceID] ContractInfo salesSourceID
         * @property {contractpb.IContractCancellationInfo|null} [cancellationInfo] ContractInfo cancellationInfo
         * @property {contractpb.IProductDetails|null} [productDetails] ContractInfo productDetails
         */

        /**
         * Constructs a new ContractInfo.
         * @memberof contractpb
         * @classdesc Represents a ContractInfo.
         * @implements IContractInfo
         * @constructor
         * @param {contractpb.IContractInfo=} [p] Properties to set
         */
        function ContractInfo(p) {
            this.customerDetails = [];
            this.contractNotes = [];
            this.futureEffectiveInfo = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * ContractInfo contractID.
         * @member {string} contractID
         * @memberof contractpb.ContractInfo
         * @instance
         */
        ContractInfo.prototype.contractID = "";

        /**
         * ContractInfo contractStatus.
         * @member {string} contractStatus
         * @memberof contractpb.ContractInfo
         * @instance
         */
        ContractInfo.prototype.contractStatus = "";

        /**
         * ContractInfo contractData.
         * @member {contractpb.IContractData|null|undefined} contractData
         * @memberof contractpb.ContractInfo
         * @instance
         */
        ContractInfo.prototype.contractData = null;

        /**
         * ContractInfo customerDetails.
         * @member {Array.<contractpb.IContractCustomerInfo>} customerDetails
         * @memberof contractpb.ContractInfo
         * @instance
         */
        ContractInfo.prototype.customerDetails = $util.emptyArray;

        /**
         * ContractInfo coveredPropertyAddress.
         * @member {contractpb.IContractPropertyInfo|null|undefined} coveredPropertyAddress
         * @memberof contractpb.ContractInfo
         * @instance
         */
        ContractInfo.prototype.coveredPropertyAddress = null;

        /**
         * ContractInfo mailingAddress.
         * @member {contractpb.IContractPropertyInfo|null|undefined} mailingAddress
         * @memberof contractpb.ContractInfo
         * @instance
         */
        ContractInfo.prototype.mailingAddress = null;

        /**
         * ContractInfo reChannelData.
         * @member {contractpb.IREChannelData|null|undefined} reChannelData
         * @memberof contractpb.ContractInfo
         * @instance
         */
        ContractInfo.prototype.reChannelData = null;

        /**
         * ContractInfo dcChannelData.
         * @member {contractpb.IDCChannelData|null|undefined} dcChannelData
         * @memberof contractpb.ContractInfo
         * @instance
         */
        ContractInfo.prototype.dcChannelData = null;

        /**
         * ContractInfo contractNotes.
         * @member {Array.<contractpb.IContractNote>} contractNotes
         * @memberof contractpb.ContractInfo
         * @instance
         */
        ContractInfo.prototype.contractNotes = $util.emptyArray;

        /**
         * ContractInfo productPriceDetail.
         * @member {contractpb.IProductPriceDetailInfo|null|undefined} productPriceDetail
         * @memberof contractpb.ContractInfo
         * @instance
         */
        ContractInfo.prototype.productPriceDetail = null;

        /**
         * ContractInfo futureEffectiveInfo.
         * @member {Array.<contractpb.IFutureEffectiveInfo>} futureEffectiveInfo
         * @memberof contractpb.ContractInfo
         * @instance
         */
        ContractInfo.prototype.futureEffectiveInfo = $util.emptyArray;

        /**
         * ContractInfo salesSourceID.
         * @member {string} salesSourceID
         * @memberof contractpb.ContractInfo
         * @instance
         */
        ContractInfo.prototype.salesSourceID = "";

        /**
         * ContractInfo cancellationInfo.
         * @member {contractpb.IContractCancellationInfo|null|undefined} cancellationInfo
         * @memberof contractpb.ContractInfo
         * @instance
         */
        ContractInfo.prototype.cancellationInfo = null;

        /**
         * ContractInfo productDetails.
         * @member {contractpb.IProductDetails|null|undefined} productDetails
         * @memberof contractpb.ContractInfo
         * @instance
         */
        ContractInfo.prototype.productDetails = null;

        /**
         * Creates a new ContractInfo instance using the specified properties.
         * @function create
         * @memberof contractpb.ContractInfo
         * @static
         * @param {contractpb.IContractInfo=} [properties] Properties to set
         * @returns {contractpb.ContractInfo} ContractInfo instance
         */
        ContractInfo.create = function create(properties) {
            return new ContractInfo(properties);
        };

        /**
         * Encodes the specified ContractInfo message. Does not implicitly {@link contractpb.ContractInfo.verify|verify} messages.
         * @function encode
         * @memberof contractpb.ContractInfo
         * @static
         * @param {contractpb.IContractInfo} m ContractInfo message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ContractInfo.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.contractID != null && Object.hasOwnProperty.call(m, "contractID"))
                w.uint32(10).string(m.contractID);
            if (m.contractStatus != null && Object.hasOwnProperty.call(m, "contractStatus"))
                w.uint32(18).string(m.contractStatus);
            if (m.contractData != null && Object.hasOwnProperty.call(m, "contractData"))
                $root.contractpb.ContractData.encode(m.contractData, w.uint32(26).fork()).ldelim();
            if (m.customerDetails != null && m.customerDetails.length) {
                for (var i = 0; i < m.customerDetails.length; ++i)
                    $root.contractpb.ContractCustomerInfo.encode(m.customerDetails[i], w.uint32(34).fork()).ldelim();
            }
            if (m.coveredPropertyAddress != null && Object.hasOwnProperty.call(m, "coveredPropertyAddress"))
                $root.contractpb.ContractPropertyInfo.encode(m.coveredPropertyAddress, w.uint32(42).fork()).ldelim();
            if (m.mailingAddress != null && Object.hasOwnProperty.call(m, "mailingAddress"))
                $root.contractpb.ContractPropertyInfo.encode(m.mailingAddress, w.uint32(50).fork()).ldelim();
            if (m.reChannelData != null && Object.hasOwnProperty.call(m, "reChannelData"))
                $root.contractpb.REChannelData.encode(m.reChannelData, w.uint32(58).fork()).ldelim();
            if (m.dcChannelData != null && Object.hasOwnProperty.call(m, "dcChannelData"))
                $root.contractpb.DCChannelData.encode(m.dcChannelData, w.uint32(66).fork()).ldelim();
            if (m.contractNotes != null && m.contractNotes.length) {
                for (var i = 0; i < m.contractNotes.length; ++i)
                    $root.contractpb.ContractNote.encode(m.contractNotes[i], w.uint32(74).fork()).ldelim();
            }
            if (m.productPriceDetail != null && Object.hasOwnProperty.call(m, "productPriceDetail"))
                $root.contractpb.ProductPriceDetailInfo.encode(m.productPriceDetail, w.uint32(82).fork()).ldelim();
            if (m.futureEffectiveInfo != null && m.futureEffectiveInfo.length) {
                for (var i = 0; i < m.futureEffectiveInfo.length; ++i)
                    $root.contractpb.FutureEffectiveInfo.encode(m.futureEffectiveInfo[i], w.uint32(90).fork()).ldelim();
            }
            if (m.salesSourceID != null && Object.hasOwnProperty.call(m, "salesSourceID"))
                w.uint32(98).string(m.salesSourceID);
            if (m.cancellationInfo != null && Object.hasOwnProperty.call(m, "cancellationInfo"))
                $root.contractpb.ContractCancellationInfo.encode(m.cancellationInfo, w.uint32(106).fork()).ldelim();
            if (m.productDetails != null && Object.hasOwnProperty.call(m, "productDetails"))
                $root.contractpb.ProductDetails.encode(m.productDetails, w.uint32(114).fork()).ldelim();
            return w;
        };

        /**
         * Decodes a ContractInfo message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.ContractInfo
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.ContractInfo} ContractInfo
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ContractInfo.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.ContractInfo();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.contractID = r.string();
                    break;
                case 2:
                    m.contractStatus = r.string();
                    break;
                case 3:
                    m.contractData = $root.contractpb.ContractData.decode(r, r.uint32());
                    break;
                case 4:
                    if (!(m.customerDetails && m.customerDetails.length))
                        m.customerDetails = [];
                    m.customerDetails.push($root.contractpb.ContractCustomerInfo.decode(r, r.uint32()));
                    break;
                case 5:
                    m.coveredPropertyAddress = $root.contractpb.ContractPropertyInfo.decode(r, r.uint32());
                    break;
                case 6:
                    m.mailingAddress = $root.contractpb.ContractPropertyInfo.decode(r, r.uint32());
                    break;
                case 7:
                    m.reChannelData = $root.contractpb.REChannelData.decode(r, r.uint32());
                    break;
                case 8:
                    m.dcChannelData = $root.contractpb.DCChannelData.decode(r, r.uint32());
                    break;
                case 9:
                    if (!(m.contractNotes && m.contractNotes.length))
                        m.contractNotes = [];
                    m.contractNotes.push($root.contractpb.ContractNote.decode(r, r.uint32()));
                    break;
                case 10:
                    m.productPriceDetail = $root.contractpb.ProductPriceDetailInfo.decode(r, r.uint32());
                    break;
                case 11:
                    if (!(m.futureEffectiveInfo && m.futureEffectiveInfo.length))
                        m.futureEffectiveInfo = [];
                    m.futureEffectiveInfo.push($root.contractpb.FutureEffectiveInfo.decode(r, r.uint32()));
                    break;
                case 12:
                    m.salesSourceID = r.string();
                    break;
                case 13:
                    m.cancellationInfo = $root.contractpb.ContractCancellationInfo.decode(r, r.uint32());
                    break;
                case 14:
                    m.productDetails = $root.contractpb.ProductDetails.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return ContractInfo;
    })();

    contractpb.ProductDetails = (function() {

        /**
         * Properties of a ProductDetails.
         * @memberof contractpb
         * @interface IProductDetails
         * @property {string|null} [productVersionID] ProductDetails productVersionID
         * @property {number|null} [productID] ProductDetails productID
         */

        /**
         * Constructs a new ProductDetails.
         * @memberof contractpb
         * @classdesc Represents a ProductDetails.
         * @implements IProductDetails
         * @constructor
         * @param {contractpb.IProductDetails=} [p] Properties to set
         */
        function ProductDetails(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * ProductDetails productVersionID.
         * @member {string} productVersionID
         * @memberof contractpb.ProductDetails
         * @instance
         */
        ProductDetails.prototype.productVersionID = "";

        /**
         * ProductDetails productID.
         * @member {number} productID
         * @memberof contractpb.ProductDetails
         * @instance
         */
        ProductDetails.prototype.productID = 0;

        /**
         * Creates a new ProductDetails instance using the specified properties.
         * @function create
         * @memberof contractpb.ProductDetails
         * @static
         * @param {contractpb.IProductDetails=} [properties] Properties to set
         * @returns {contractpb.ProductDetails} ProductDetails instance
         */
        ProductDetails.create = function create(properties) {
            return new ProductDetails(properties);
        };

        /**
         * Encodes the specified ProductDetails message. Does not implicitly {@link contractpb.ProductDetails.verify|verify} messages.
         * @function encode
         * @memberof contractpb.ProductDetails
         * @static
         * @param {contractpb.IProductDetails} m ProductDetails message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ProductDetails.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.productVersionID != null && Object.hasOwnProperty.call(m, "productVersionID"))
                w.uint32(10).string(m.productVersionID);
            if (m.productID != null && Object.hasOwnProperty.call(m, "productID"))
                w.uint32(16).int32(m.productID);
            return w;
        };

        /**
         * Decodes a ProductDetails message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.ProductDetails
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.ProductDetails} ProductDetails
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ProductDetails.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.ProductDetails();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.productVersionID = r.string();
                    break;
                case 2:
                    m.productID = r.int32();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return ProductDetails;
    })();

    contractpb.ContractCancellationInfo = (function() {

        /**
         * Properties of a ContractCancellationInfo.
         * @memberof contractpb
         * @interface IContractCancellationInfo
         * @property {string|null} [cancellationDate] ContractCancellationInfo cancellationDate
         * @property {string|null} [effectiveDate] ContractCancellationInfo effectiveDate
         * @property {string|null} [expiryDate] ContractCancellationInfo expiryDate
         * @property {number|null} [refundAmount] ContractCancellationInfo refundAmount
         * @property {number|null} [adminFee] ContractCancellationInfo adminFee
         * @property {number|null} [totalPaid] ContractCancellationInfo totalPaid
         * @property {number|null} [totalPrice] ContractCancellationInfo totalPrice
         * @property {number|null} [activeCost] ContractCancellationInfo activeCost
         * @property {string|null} [lastModified] ContractCancellationInfo lastModified
         * @property {string|null} [letterType] ContractCancellationInfo letterType
         * @property {string|null} [reasonText] ContractCancellationInfo reasonText
         */

        /**
         * Constructs a new ContractCancellationInfo.
         * @memberof contractpb
         * @classdesc Represents a ContractCancellationInfo.
         * @implements IContractCancellationInfo
         * @constructor
         * @param {contractpb.IContractCancellationInfo=} [p] Properties to set
         */
        function ContractCancellationInfo(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * ContractCancellationInfo cancellationDate.
         * @member {string} cancellationDate
         * @memberof contractpb.ContractCancellationInfo
         * @instance
         */
        ContractCancellationInfo.prototype.cancellationDate = "";

        /**
         * ContractCancellationInfo effectiveDate.
         * @member {string} effectiveDate
         * @memberof contractpb.ContractCancellationInfo
         * @instance
         */
        ContractCancellationInfo.prototype.effectiveDate = "";

        /**
         * ContractCancellationInfo expiryDate.
         * @member {string} expiryDate
         * @memberof contractpb.ContractCancellationInfo
         * @instance
         */
        ContractCancellationInfo.prototype.expiryDate = "";

        /**
         * ContractCancellationInfo refundAmount.
         * @member {number} refundAmount
         * @memberof contractpb.ContractCancellationInfo
         * @instance
         */
        ContractCancellationInfo.prototype.refundAmount = 0;

        /**
         * ContractCancellationInfo adminFee.
         * @member {number} adminFee
         * @memberof contractpb.ContractCancellationInfo
         * @instance
         */
        ContractCancellationInfo.prototype.adminFee = 0;

        /**
         * ContractCancellationInfo totalPaid.
         * @member {number} totalPaid
         * @memberof contractpb.ContractCancellationInfo
         * @instance
         */
        ContractCancellationInfo.prototype.totalPaid = 0;

        /**
         * ContractCancellationInfo totalPrice.
         * @member {number} totalPrice
         * @memberof contractpb.ContractCancellationInfo
         * @instance
         */
        ContractCancellationInfo.prototype.totalPrice = 0;

        /**
         * ContractCancellationInfo activeCost.
         * @member {number} activeCost
         * @memberof contractpb.ContractCancellationInfo
         * @instance
         */
        ContractCancellationInfo.prototype.activeCost = 0;

        /**
         * ContractCancellationInfo lastModified.
         * @member {string} lastModified
         * @memberof contractpb.ContractCancellationInfo
         * @instance
         */
        ContractCancellationInfo.prototype.lastModified = "";

        /**
         * ContractCancellationInfo letterType.
         * @member {string} letterType
         * @memberof contractpb.ContractCancellationInfo
         * @instance
         */
        ContractCancellationInfo.prototype.letterType = "";

        /**
         * ContractCancellationInfo reasonText.
         * @member {string} reasonText
         * @memberof contractpb.ContractCancellationInfo
         * @instance
         */
        ContractCancellationInfo.prototype.reasonText = "";

        /**
         * Creates a new ContractCancellationInfo instance using the specified properties.
         * @function create
         * @memberof contractpb.ContractCancellationInfo
         * @static
         * @param {contractpb.IContractCancellationInfo=} [properties] Properties to set
         * @returns {contractpb.ContractCancellationInfo} ContractCancellationInfo instance
         */
        ContractCancellationInfo.create = function create(properties) {
            return new ContractCancellationInfo(properties);
        };

        /**
         * Encodes the specified ContractCancellationInfo message. Does not implicitly {@link contractpb.ContractCancellationInfo.verify|verify} messages.
         * @function encode
         * @memberof contractpb.ContractCancellationInfo
         * @static
         * @param {contractpb.IContractCancellationInfo} m ContractCancellationInfo message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ContractCancellationInfo.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.cancellationDate != null && Object.hasOwnProperty.call(m, "cancellationDate"))
                w.uint32(10).string(m.cancellationDate);
            if (m.effectiveDate != null && Object.hasOwnProperty.call(m, "effectiveDate"))
                w.uint32(18).string(m.effectiveDate);
            if (m.expiryDate != null && Object.hasOwnProperty.call(m, "expiryDate"))
                w.uint32(26).string(m.expiryDate);
            if (m.refundAmount != null && Object.hasOwnProperty.call(m, "refundAmount"))
                w.uint32(33).double(m.refundAmount);
            if (m.adminFee != null && Object.hasOwnProperty.call(m, "adminFee"))
                w.uint32(41).double(m.adminFee);
            if (m.totalPaid != null && Object.hasOwnProperty.call(m, "totalPaid"))
                w.uint32(49).double(m.totalPaid);
            if (m.totalPrice != null && Object.hasOwnProperty.call(m, "totalPrice"))
                w.uint32(57).double(m.totalPrice);
            if (m.activeCost != null && Object.hasOwnProperty.call(m, "activeCost"))
                w.uint32(65).double(m.activeCost);
            if (m.lastModified != null && Object.hasOwnProperty.call(m, "lastModified"))
                w.uint32(74).string(m.lastModified);
            if (m.letterType != null && Object.hasOwnProperty.call(m, "letterType"))
                w.uint32(82).string(m.letterType);
            if (m.reasonText != null && Object.hasOwnProperty.call(m, "reasonText"))
                w.uint32(90).string(m.reasonText);
            return w;
        };

        /**
         * Decodes a ContractCancellationInfo message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.ContractCancellationInfo
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.ContractCancellationInfo} ContractCancellationInfo
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ContractCancellationInfo.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.ContractCancellationInfo();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.cancellationDate = r.string();
                    break;
                case 2:
                    m.effectiveDate = r.string();
                    break;
                case 3:
                    m.expiryDate = r.string();
                    break;
                case 4:
                    m.refundAmount = r.double();
                    break;
                case 5:
                    m.adminFee = r.double();
                    break;
                case 6:
                    m.totalPaid = r.double();
                    break;
                case 7:
                    m.totalPrice = r.double();
                    break;
                case 8:
                    m.activeCost = r.double();
                    break;
                case 9:
                    m.lastModified = r.string();
                    break;
                case 10:
                    m.letterType = r.string();
                    break;
                case 11:
                    m.reasonText = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return ContractCancellationInfo;
    })();

    /**
     * SortMechanism enum.
     * @name contractpb.SortMechanism
     * @enum {number}
     * @property {number} DESCENDING=0 DESCENDING value
     * @property {number} ASCENDING=1 ASCENDING value
     */
    contractpb.SortMechanism = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "DESCENDING"] = 0;
        values[valuesById[1] = "ASCENDING"] = 1;
        return values;
    })();

    /**
     * SortField enum.
     * @name contractpb.SortField
     * @enum {number}
     * @property {number} CREATION_DATE=0 CREATION_DATE value
     * @property {number} COMPANY_CODE=1 COMPANY_CODE value
     * @property {number} CONTRACT_STATUS=2 CONTRACT_STATUS value
     * @property {number} SALES_CHANNEL=3 SALES_CHANNEL value
     * @property {number} CITY=4 CITY value
     * @property {number} STATE=5 STATE value
     * @property {number} ZIPCODE=6 ZIPCODE value
     */
    contractpb.SortField = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "CREATION_DATE"] = 0;
        values[valuesById[1] = "COMPANY_CODE"] = 1;
        values[valuesById[2] = "CONTRACT_STATUS"] = 2;
        values[valuesById[3] = "SALES_CHANNEL"] = 3;
        values[valuesById[4] = "CITY"] = 4;
        values[valuesById[5] = "STATE"] = 5;
        values[valuesById[6] = "ZIPCODE"] = 6;
        return values;
    })();

    contractpb.ContractIDs = (function() {

        /**
         * Properties of a ContractIDs.
         * @memberof contractpb
         * @interface IContractIDs
         * @property {Array.<string>|null} [contractIDs] ContractIDs contractIDs
         */

        /**
         * Constructs a new ContractIDs.
         * @memberof contractpb
         * @classdesc Represents a ContractIDs.
         * @implements IContractIDs
         * @constructor
         * @param {contractpb.IContractIDs=} [p] Properties to set
         */
        function ContractIDs(p) {
            this.contractIDs = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * ContractIDs contractIDs.
         * @member {Array.<string>} contractIDs
         * @memberof contractpb.ContractIDs
         * @instance
         */
        ContractIDs.prototype.contractIDs = $util.emptyArray;

        /**
         * Creates a new ContractIDs instance using the specified properties.
         * @function create
         * @memberof contractpb.ContractIDs
         * @static
         * @param {contractpb.IContractIDs=} [properties] Properties to set
         * @returns {contractpb.ContractIDs} ContractIDs instance
         */
        ContractIDs.create = function create(properties) {
            return new ContractIDs(properties);
        };

        /**
         * Encodes the specified ContractIDs message. Does not implicitly {@link contractpb.ContractIDs.verify|verify} messages.
         * @function encode
         * @memberof contractpb.ContractIDs
         * @static
         * @param {contractpb.IContractIDs} m ContractIDs message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ContractIDs.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.contractIDs != null && m.contractIDs.length) {
                for (var i = 0; i < m.contractIDs.length; ++i)
                    w.uint32(10).string(m.contractIDs[i]);
            }
            return w;
        };

        /**
         * Decodes a ContractIDs message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.ContractIDs
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.ContractIDs} ContractIDs
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ContractIDs.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.ContractIDs();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    if (!(m.contractIDs && m.contractIDs.length))
                        m.contractIDs = [];
                    m.contractIDs.push(r.string());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return ContractIDs;
    })();

    contractpb.SortCriteria = (function() {

        /**
         * Properties of a SortCriteria.
         * @memberof contractpb
         * @interface ISortCriteria
         * @property {contractpb.SortField|null} [sortField] SortCriteria sortField
         * @property {contractpb.SortMechanism|null} [sortMechanism] SortCriteria sortMechanism
         */

        /**
         * Constructs a new SortCriteria.
         * @memberof contractpb
         * @classdesc Represents a SortCriteria.
         * @implements ISortCriteria
         * @constructor
         * @param {contractpb.ISortCriteria=} [p] Properties to set
         */
        function SortCriteria(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * SortCriteria sortField.
         * @member {contractpb.SortField} sortField
         * @memberof contractpb.SortCriteria
         * @instance
         */
        SortCriteria.prototype.sortField = 0;

        /**
         * SortCriteria sortMechanism.
         * @member {contractpb.SortMechanism} sortMechanism
         * @memberof contractpb.SortCriteria
         * @instance
         */
        SortCriteria.prototype.sortMechanism = 0;

        /**
         * Creates a new SortCriteria instance using the specified properties.
         * @function create
         * @memberof contractpb.SortCriteria
         * @static
         * @param {contractpb.ISortCriteria=} [properties] Properties to set
         * @returns {contractpb.SortCriteria} SortCriteria instance
         */
        SortCriteria.create = function create(properties) {
            return new SortCriteria(properties);
        };

        /**
         * Encodes the specified SortCriteria message. Does not implicitly {@link contractpb.SortCriteria.verify|verify} messages.
         * @function encode
         * @memberof contractpb.SortCriteria
         * @static
         * @param {contractpb.ISortCriteria} m SortCriteria message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SortCriteria.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.sortField != null && Object.hasOwnProperty.call(m, "sortField"))
                w.uint32(8).int32(m.sortField);
            if (m.sortMechanism != null && Object.hasOwnProperty.call(m, "sortMechanism"))
                w.uint32(16).int32(m.sortMechanism);
            return w;
        };

        /**
         * Decodes a SortCriteria message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.SortCriteria
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.SortCriteria} SortCriteria
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SortCriteria.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.SortCriteria();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.sortField = r.int32();
                    break;
                case 2:
                    m.sortMechanism = r.int32();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return SortCriteria;
    })();

    contractpb.ContractUnifiedSearchRequest = (function() {

        /**
         * Properties of a ContractUnifiedSearchRequest.
         * @memberof contractpb
         * @interface IContractUnifiedSearchRequest
         * @property {contractpb.IContractIDs|null} [contractSearchID] ContractUnifiedSearchRequest contractSearchID
         * @property {contractpb.ISearchRequestUsingSearchFilters|null} [searchFilter] ContractUnifiedSearchRequest searchFilter
         * @property {Array.<contractpb.ISortCriteria>|null} [sortCriterias] ContractUnifiedSearchRequest sortCriterias
         * @property {Array.<contractpb.ResponseField>|null} [responseFields] ContractUnifiedSearchRequest responseFields
         * @property {boolean|null} [responseThroughKafka] ContractUnifiedSearchRequest responseThroughKafka
         * @property {string|null} [requestID] ContractUnifiedSearchRequest requestID
         * @property {string|null} [kafkaTopicName] ContractUnifiedSearchRequest kafkaTopicName
         */

        /**
         * Constructs a new ContractUnifiedSearchRequest.
         * @memberof contractpb
         * @classdesc POST /contract/v2/search
         * @implements IContractUnifiedSearchRequest
         * @constructor
         * @param {contractpb.IContractUnifiedSearchRequest=} [p] Properties to set
         */
        function ContractUnifiedSearchRequest(p) {
            this.sortCriterias = [];
            this.responseFields = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * ContractUnifiedSearchRequest contractSearchID.
         * @member {contractpb.IContractIDs|null|undefined} contractSearchID
         * @memberof contractpb.ContractUnifiedSearchRequest
         * @instance
         */
        ContractUnifiedSearchRequest.prototype.contractSearchID = null;

        /**
         * ContractUnifiedSearchRequest searchFilter.
         * @member {contractpb.ISearchRequestUsingSearchFilters|null|undefined} searchFilter
         * @memberof contractpb.ContractUnifiedSearchRequest
         * @instance
         */
        ContractUnifiedSearchRequest.prototype.searchFilter = null;

        /**
         * ContractUnifiedSearchRequest sortCriterias.
         * @member {Array.<contractpb.ISortCriteria>} sortCriterias
         * @memberof contractpb.ContractUnifiedSearchRequest
         * @instance
         */
        ContractUnifiedSearchRequest.prototype.sortCriterias = $util.emptyArray;

        /**
         * ContractUnifiedSearchRequest responseFields.
         * @member {Array.<contractpb.ResponseField>} responseFields
         * @memberof contractpb.ContractUnifiedSearchRequest
         * @instance
         */
        ContractUnifiedSearchRequest.prototype.responseFields = $util.emptyArray;

        /**
         * ContractUnifiedSearchRequest responseThroughKafka.
         * @member {boolean} responseThroughKafka
         * @memberof contractpb.ContractUnifiedSearchRequest
         * @instance
         */
        ContractUnifiedSearchRequest.prototype.responseThroughKafka = false;

        /**
         * ContractUnifiedSearchRequest requestID.
         * @member {string} requestID
         * @memberof contractpb.ContractUnifiedSearchRequest
         * @instance
         */
        ContractUnifiedSearchRequest.prototype.requestID = "";

        /**
         * ContractUnifiedSearchRequest kafkaTopicName.
         * @member {string} kafkaTopicName
         * @memberof contractpb.ContractUnifiedSearchRequest
         * @instance
         */
        ContractUnifiedSearchRequest.prototype.kafkaTopicName = "";

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        /**
         * ContractUnifiedSearchRequest searchParams.
         * @member {"contractSearchID"|"searchFilter"|undefined} searchParams
         * @memberof contractpb.ContractUnifiedSearchRequest
         * @instance
         */
        Object.defineProperty(ContractUnifiedSearchRequest.prototype, "searchParams", {
            get: $util.oneOfGetter($oneOfFields = ["contractSearchID", "searchFilter"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new ContractUnifiedSearchRequest instance using the specified properties.
         * @function create
         * @memberof contractpb.ContractUnifiedSearchRequest
         * @static
         * @param {contractpb.IContractUnifiedSearchRequest=} [properties] Properties to set
         * @returns {contractpb.ContractUnifiedSearchRequest} ContractUnifiedSearchRequest instance
         */
        ContractUnifiedSearchRequest.create = function create(properties) {
            return new ContractUnifiedSearchRequest(properties);
        };

        /**
         * Encodes the specified ContractUnifiedSearchRequest message. Does not implicitly {@link contractpb.ContractUnifiedSearchRequest.verify|verify} messages.
         * @function encode
         * @memberof contractpb.ContractUnifiedSearchRequest
         * @static
         * @param {contractpb.IContractUnifiedSearchRequest} m ContractUnifiedSearchRequest message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ContractUnifiedSearchRequest.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.contractSearchID != null && Object.hasOwnProperty.call(m, "contractSearchID"))
                $root.contractpb.ContractIDs.encode(m.contractSearchID, w.uint32(10).fork()).ldelim();
            if (m.searchFilter != null && Object.hasOwnProperty.call(m, "searchFilter"))
                $root.contractpb.SearchRequestUsingSearchFilters.encode(m.searchFilter, w.uint32(18).fork()).ldelim();
            if (m.sortCriterias != null && m.sortCriterias.length) {
                for (var i = 0; i < m.sortCriterias.length; ++i)
                    $root.contractpb.SortCriteria.encode(m.sortCriterias[i], w.uint32(26).fork()).ldelim();
            }
            if (m.responseFields != null && m.responseFields.length) {
                w.uint32(34).fork();
                for (var i = 0; i < m.responseFields.length; ++i)
                    w.int32(m.responseFields[i]);
                w.ldelim();
            }
            if (m.responseThroughKafka != null && Object.hasOwnProperty.call(m, "responseThroughKafka"))
                w.uint32(40).bool(m.responseThroughKafka);
            if (m.requestID != null && Object.hasOwnProperty.call(m, "requestID"))
                w.uint32(50).string(m.requestID);
            if (m.kafkaTopicName != null && Object.hasOwnProperty.call(m, "kafkaTopicName"))
                w.uint32(58).string(m.kafkaTopicName);
            return w;
        };

        /**
         * Decodes a ContractUnifiedSearchRequest message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.ContractUnifiedSearchRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.ContractUnifiedSearchRequest} ContractUnifiedSearchRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ContractUnifiedSearchRequest.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.ContractUnifiedSearchRequest();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.contractSearchID = $root.contractpb.ContractIDs.decode(r, r.uint32());
                    break;
                case 2:
                    m.searchFilter = $root.contractpb.SearchRequestUsingSearchFilters.decode(r, r.uint32());
                    break;
                case 3:
                    if (!(m.sortCriterias && m.sortCriterias.length))
                        m.sortCriterias = [];
                    m.sortCriterias.push($root.contractpb.SortCriteria.decode(r, r.uint32()));
                    break;
                case 4:
                    if (!(m.responseFields && m.responseFields.length))
                        m.responseFields = [];
                    if ((t & 7) === 2) {
                        var c2 = r.uint32() + r.pos;
                        while (r.pos < c2)
                            m.responseFields.push(r.int32());
                    } else
                        m.responseFields.push(r.int32());
                    break;
                case 5:
                    m.responseThroughKafka = r.bool();
                    break;
                case 6:
                    m.requestID = r.string();
                    break;
                case 7:
                    m.kafkaTopicName = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return ContractUnifiedSearchRequest;
    })();

    contractpb.ContractSearchSuccessResponse = (function() {

        /**
         * Properties of a ContractSearchSuccessResponse.
         * @memberof contractpb
         * @interface IContractSearchSuccessResponse
         * @property {Array.<contractpb.IContractInfo>|null} [contractInfos] ContractSearchSuccessResponse contractInfos
         * @property {common.IPagination|null} [pageInfo] ContractSearchSuccessResponse pageInfo
         * @property {string|null} [requestId] ContractSearchSuccessResponse requestId
         */

        /**
         * Constructs a new ContractSearchSuccessResponse.
         * @memberof contractpb
         * @classdesc Represents a ContractSearchSuccessResponse.
         * @implements IContractSearchSuccessResponse
         * @constructor
         * @param {contractpb.IContractSearchSuccessResponse=} [p] Properties to set
         */
        function ContractSearchSuccessResponse(p) {
            this.contractInfos = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * ContractSearchSuccessResponse contractInfos.
         * @member {Array.<contractpb.IContractInfo>} contractInfos
         * @memberof contractpb.ContractSearchSuccessResponse
         * @instance
         */
        ContractSearchSuccessResponse.prototype.contractInfos = $util.emptyArray;

        /**
         * ContractSearchSuccessResponse pageInfo.
         * @member {common.IPagination|null|undefined} pageInfo
         * @memberof contractpb.ContractSearchSuccessResponse
         * @instance
         */
        ContractSearchSuccessResponse.prototype.pageInfo = null;

        /**
         * ContractSearchSuccessResponse requestId.
         * @member {string} requestId
         * @memberof contractpb.ContractSearchSuccessResponse
         * @instance
         */
        ContractSearchSuccessResponse.prototype.requestId = "";

        /**
         * Creates a new ContractSearchSuccessResponse instance using the specified properties.
         * @function create
         * @memberof contractpb.ContractSearchSuccessResponse
         * @static
         * @param {contractpb.IContractSearchSuccessResponse=} [properties] Properties to set
         * @returns {contractpb.ContractSearchSuccessResponse} ContractSearchSuccessResponse instance
         */
        ContractSearchSuccessResponse.create = function create(properties) {
            return new ContractSearchSuccessResponse(properties);
        };

        /**
         * Encodes the specified ContractSearchSuccessResponse message. Does not implicitly {@link contractpb.ContractSearchSuccessResponse.verify|verify} messages.
         * @function encode
         * @memberof contractpb.ContractSearchSuccessResponse
         * @static
         * @param {contractpb.IContractSearchSuccessResponse} m ContractSearchSuccessResponse message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ContractSearchSuccessResponse.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.contractInfos != null && m.contractInfos.length) {
                for (var i = 0; i < m.contractInfos.length; ++i)
                    $root.contractpb.ContractInfo.encode(m.contractInfos[i], w.uint32(10).fork()).ldelim();
            }
            if (m.pageInfo != null && Object.hasOwnProperty.call(m, "pageInfo"))
                $root.common.Pagination.encode(m.pageInfo, w.uint32(18).fork()).ldelim();
            if (m.requestId != null && Object.hasOwnProperty.call(m, "requestId"))
                w.uint32(26).string(m.requestId);
            return w;
        };

        /**
         * Decodes a ContractSearchSuccessResponse message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.ContractSearchSuccessResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.ContractSearchSuccessResponse} ContractSearchSuccessResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ContractSearchSuccessResponse.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.ContractSearchSuccessResponse();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    if (!(m.contractInfos && m.contractInfos.length))
                        m.contractInfos = [];
                    m.contractInfos.push($root.contractpb.ContractInfo.decode(r, r.uint32()));
                    break;
                case 2:
                    m.pageInfo = $root.common.Pagination.decode(r, r.uint32());
                    break;
                case 3:
                    m.requestId = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return ContractSearchSuccessResponse;
    })();

    contractpb.ErrorsWrapper = (function() {

        /**
         * Properties of an ErrorsWrapper.
         * @memberof contractpb
         * @interface IErrorsWrapper
         * @property {Array.<common.IError>|null} [errors] ErrorsWrapper errors
         */

        /**
         * Constructs a new ErrorsWrapper.
         * @memberof contractpb
         * @classdesc Represents an ErrorsWrapper.
         * @implements IErrorsWrapper
         * @constructor
         * @param {contractpb.IErrorsWrapper=} [p] Properties to set
         */
        function ErrorsWrapper(p) {
            this.errors = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * ErrorsWrapper errors.
         * @member {Array.<common.IError>} errors
         * @memberof contractpb.ErrorsWrapper
         * @instance
         */
        ErrorsWrapper.prototype.errors = $util.emptyArray;

        /**
         * Creates a new ErrorsWrapper instance using the specified properties.
         * @function create
         * @memberof contractpb.ErrorsWrapper
         * @static
         * @param {contractpb.IErrorsWrapper=} [properties] Properties to set
         * @returns {contractpb.ErrorsWrapper} ErrorsWrapper instance
         */
        ErrorsWrapper.create = function create(properties) {
            return new ErrorsWrapper(properties);
        };

        /**
         * Encodes the specified ErrorsWrapper message. Does not implicitly {@link contractpb.ErrorsWrapper.verify|verify} messages.
         * @function encode
         * @memberof contractpb.ErrorsWrapper
         * @static
         * @param {contractpb.IErrorsWrapper} m ErrorsWrapper message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ErrorsWrapper.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.errors != null && m.errors.length) {
                for (var i = 0; i < m.errors.length; ++i)
                    $root.common.Error.encode(m.errors[i], w.uint32(10).fork()).ldelim();
            }
            return w;
        };

        /**
         * Decodes an ErrorsWrapper message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.ErrorsWrapper
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.ErrorsWrapper} ErrorsWrapper
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ErrorsWrapper.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.ErrorsWrapper();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    if (!(m.errors && m.errors.length))
                        m.errors = [];
                    m.errors.push($root.common.Error.decode(r, r.uint32()));
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return ErrorsWrapper;
    })();

    contractpb.ContractUnifiedSearchResponse = (function() {

        /**
         * Properties of a ContractUnifiedSearchResponse.
         * @memberof contractpb
         * @interface IContractUnifiedSearchResponse
         * @property {contractpb.IErrorsWrapper|null} [errorResponse] ContractUnifiedSearchResponse errorResponse
         * @property {contractpb.IContractSearchSuccessResponse|null} [successResponse] ContractUnifiedSearchResponse successResponse
         */

        /**
         * Constructs a new ContractUnifiedSearchResponse.
         * @memberof contractpb
         * @classdesc Represents a ContractUnifiedSearchResponse.
         * @implements IContractUnifiedSearchResponse
         * @constructor
         * @param {contractpb.IContractUnifiedSearchResponse=} [p] Properties to set
         */
        function ContractUnifiedSearchResponse(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * ContractUnifiedSearchResponse errorResponse.
         * @member {contractpb.IErrorsWrapper|null|undefined} errorResponse
         * @memberof contractpb.ContractUnifiedSearchResponse
         * @instance
         */
        ContractUnifiedSearchResponse.prototype.errorResponse = null;

        /**
         * ContractUnifiedSearchResponse successResponse.
         * @member {contractpb.IContractSearchSuccessResponse|null|undefined} successResponse
         * @memberof contractpb.ContractUnifiedSearchResponse
         * @instance
         */
        ContractUnifiedSearchResponse.prototype.successResponse = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        /**
         * ContractUnifiedSearchResponse response.
         * @member {"errorResponse"|"successResponse"|undefined} response
         * @memberof contractpb.ContractUnifiedSearchResponse
         * @instance
         */
        Object.defineProperty(ContractUnifiedSearchResponse.prototype, "response", {
            get: $util.oneOfGetter($oneOfFields = ["errorResponse", "successResponse"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new ContractUnifiedSearchResponse instance using the specified properties.
         * @function create
         * @memberof contractpb.ContractUnifiedSearchResponse
         * @static
         * @param {contractpb.IContractUnifiedSearchResponse=} [properties] Properties to set
         * @returns {contractpb.ContractUnifiedSearchResponse} ContractUnifiedSearchResponse instance
         */
        ContractUnifiedSearchResponse.create = function create(properties) {
            return new ContractUnifiedSearchResponse(properties);
        };

        /**
         * Encodes the specified ContractUnifiedSearchResponse message. Does not implicitly {@link contractpb.ContractUnifiedSearchResponse.verify|verify} messages.
         * @function encode
         * @memberof contractpb.ContractUnifiedSearchResponse
         * @static
         * @param {contractpb.IContractUnifiedSearchResponse} m ContractUnifiedSearchResponse message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ContractUnifiedSearchResponse.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.errorResponse != null && Object.hasOwnProperty.call(m, "errorResponse"))
                $root.contractpb.ErrorsWrapper.encode(m.errorResponse, w.uint32(10).fork()).ldelim();
            if (m.successResponse != null && Object.hasOwnProperty.call(m, "successResponse"))
                $root.contractpb.ContractSearchSuccessResponse.encode(m.successResponse, w.uint32(18).fork()).ldelim();
            return w;
        };

        /**
         * Decodes a ContractUnifiedSearchResponse message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.ContractUnifiedSearchResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.ContractUnifiedSearchResponse} ContractUnifiedSearchResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ContractUnifiedSearchResponse.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.ContractUnifiedSearchResponse();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.errorResponse = $root.contractpb.ErrorsWrapper.decode(r, r.uint32());
                    break;
                case 2:
                    m.successResponse = $root.contractpb.ContractSearchSuccessResponse.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return ContractUnifiedSearchResponse;
    })();

    contractpb.UpdateCoveragesRequest = (function() {

        /**
         * Properties of an UpdateCoveragesRequest.
         * @memberof contractpb
         * @interface IUpdateCoveragesRequest
         * @property {contractpb.IContractDetailsRequest|null} [contractDetailsRequest] UpdateCoveragesRequest contractDetailsRequest
         * @property {contractpb.IRequestMetaData|null} [reqMetaData] UpdateCoveragesRequest reqMetaData
         */

        /**
         * Constructs a new UpdateCoveragesRequest.
         * @memberof contractpb
         * @classdesc POST /contract/v1/coverages
         * @implements IUpdateCoveragesRequest
         * @constructor
         * @param {contractpb.IUpdateCoveragesRequest=} [p] Properties to set
         */
        function UpdateCoveragesRequest(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * UpdateCoveragesRequest contractDetailsRequest.
         * @member {contractpb.IContractDetailsRequest|null|undefined} contractDetailsRequest
         * @memberof contractpb.UpdateCoveragesRequest
         * @instance
         */
        UpdateCoveragesRequest.prototype.contractDetailsRequest = null;

        /**
         * UpdateCoveragesRequest reqMetaData.
         * @member {contractpb.IRequestMetaData|null|undefined} reqMetaData
         * @memberof contractpb.UpdateCoveragesRequest
         * @instance
         */
        UpdateCoveragesRequest.prototype.reqMetaData = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        /**
         * UpdateCoveragesRequest updateCoveragesReq.
         * @member {"contractDetailsRequest"|"reqMetaData"|undefined} updateCoveragesReq
         * @memberof contractpb.UpdateCoveragesRequest
         * @instance
         */
        Object.defineProperty(UpdateCoveragesRequest.prototype, "updateCoveragesReq", {
            get: $util.oneOfGetter($oneOfFields = ["contractDetailsRequest", "reqMetaData"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new UpdateCoveragesRequest instance using the specified properties.
         * @function create
         * @memberof contractpb.UpdateCoveragesRequest
         * @static
         * @param {contractpb.IUpdateCoveragesRequest=} [properties] Properties to set
         * @returns {contractpb.UpdateCoveragesRequest} UpdateCoveragesRequest instance
         */
        UpdateCoveragesRequest.create = function create(properties) {
            return new UpdateCoveragesRequest(properties);
        };

        /**
         * Encodes the specified UpdateCoveragesRequest message. Does not implicitly {@link contractpb.UpdateCoveragesRequest.verify|verify} messages.
         * @function encode
         * @memberof contractpb.UpdateCoveragesRequest
         * @static
         * @param {contractpb.IUpdateCoveragesRequest} m UpdateCoveragesRequest message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UpdateCoveragesRequest.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.contractDetailsRequest != null && Object.hasOwnProperty.call(m, "contractDetailsRequest"))
                $root.contractpb.ContractDetailsRequest.encode(m.contractDetailsRequest, w.uint32(10).fork()).ldelim();
            if (m.reqMetaData != null && Object.hasOwnProperty.call(m, "reqMetaData"))
                $root.contractpb.RequestMetaData.encode(m.reqMetaData, w.uint32(18).fork()).ldelim();
            return w;
        };

        /**
         * Decodes an UpdateCoveragesRequest message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.UpdateCoveragesRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.UpdateCoveragesRequest} UpdateCoveragesRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UpdateCoveragesRequest.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.UpdateCoveragesRequest();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.contractDetailsRequest = $root.contractpb.ContractDetailsRequest.decode(r, r.uint32());
                    break;
                case 2:
                    m.reqMetaData = $root.contractpb.RequestMetaData.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return UpdateCoveragesRequest;
    })();

    contractpb.ContractDetailsRequest = (function() {

        /**
         * Properties of a ContractDetailsRequest.
         * @memberof contractpb
         * @interface IContractDetailsRequest
         * @property {string|null} [contractID] ContractDetailsRequest contractID
         * @property {common.Tenant|null} [tenantID] ContractDetailsRequest tenantID
         * @property {string|null} [salesChannel] ContractDetailsRequest salesChannel
         * @property {string|null} [userName] ContractDetailsRequest userName
         * @property {string|null} [productVersionID] ContractDetailsRequest productVersionID
         * @property {string|null} [quoteID] ContractDetailsRequest quoteID
         * @property {Array.<contractpb.IFeature>|null} [addOnFeatures] ContractDetailsRequest addOnFeatures
         * @property {Array.<contractpb.IFeatureBundle>|null} [addOnBundles] ContractDetailsRequest addOnBundles
         * @property {Array.<contractpb.IMonies>|null} [monies] ContractDetailsRequest monies
         * @property {string|null} [sourceApplication] ContractDetailsRequest sourceApplication
         * @property {Array.<contractpb.IContractNote>|null} [contractNotes] ContractDetailsRequest contractNotes
         * @property {common.IDate|null} [futureEffectiveDate] ContractDetailsRequest futureEffectiveDate
         * @property {string|null} [tncID] ContractDetailsRequest tncID
         * @property {string|null} [paymentID] ContractDetailsRequest paymentID
         * @property {string|null} [invoiceID] ContractDetailsRequest invoiceID
         * @property {string|null} [salesPersonID] ContractDetailsRequest salesPersonID
         * @property {string|null} [salesPersonName] ContractDetailsRequest salesPersonName
         * @property {string|null} [newContractID] ContractDetailsRequest newContractID
         * @property {string|null} [orderID] ContractDetailsRequest orderID
         * @property {number|null} [paymentPlan] ContractDetailsRequest paymentPlan
         * @property {string|null} [discountCode] ContractDetailsRequest discountCode
         * @property {Array.<contractpb.IFeatureBundle>|null} [baseBundles] ContractDetailsRequest baseBundles
         * @property {contractpb.IPaymentDetailV2|null} [paymentDetail] ContractDetailsRequest paymentDetail
         * @property {string|null} [salesSourceID] ContractDetailsRequest salesSourceID
         * @property {string|null} [salesAgentID] ContractDetailsRequest salesAgentID
         * @property {string|null} [partnerID] ContractDetailsRequest partnerID
         * @property {string|null} [propertyID] ContractDetailsRequest propertyID
         * @property {string|null} [mailingAddressID] ContractDetailsRequest mailingAddressID
         * @property {Array.<contractpb.ISalesPerson>|null} [salesPersons] ContractDetailsRequest salesPersons
         * @property {Array.<contractpb.ICustomerDetail>|null} [customerDetails] ContractDetailsRequest customerDetails
         * @property {common.IMoney|null} [diagnosisFee] ContractDetailsRequest diagnosisFee
         * @property {common.IMoney|null} [maintenanceFee] ContractDetailsRequest maintenanceFee
         * @property {coreproductpb.TypedValue.ITimePeriod|null} [contractTerm] ContractDetailsRequest contractTerm
         * @property {google.protobuf.ITimestamp|null} [contractEffExpirationDate] ContractDetailsRequest contractEffExpirationDate
         */

        /**
         * Constructs a new ContractDetailsRequest.
         * @memberof contractpb
         * @classdesc Represents a ContractDetailsRequest.
         * @implements IContractDetailsRequest
         * @constructor
         * @param {contractpb.IContractDetailsRequest=} [p] Properties to set
         */
        function ContractDetailsRequest(p) {
            this.addOnFeatures = [];
            this.addOnBundles = [];
            this.monies = [];
            this.contractNotes = [];
            this.baseBundles = [];
            this.salesPersons = [];
            this.customerDetails = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * ContractDetailsRequest contractID.
         * @member {string} contractID
         * @memberof contractpb.ContractDetailsRequest
         * @instance
         */
        ContractDetailsRequest.prototype.contractID = "";

        /**
         * ContractDetailsRequest tenantID.
         * @member {common.Tenant} tenantID
         * @memberof contractpb.ContractDetailsRequest
         * @instance
         */
        ContractDetailsRequest.prototype.tenantID = 0;

        /**
         * ContractDetailsRequest salesChannel.
         * @member {string} salesChannel
         * @memberof contractpb.ContractDetailsRequest
         * @instance
         */
        ContractDetailsRequest.prototype.salesChannel = "";

        /**
         * ContractDetailsRequest userName.
         * @member {string} userName
         * @memberof contractpb.ContractDetailsRequest
         * @instance
         */
        ContractDetailsRequest.prototype.userName = "";

        /**
         * ContractDetailsRequest productVersionID.
         * @member {string} productVersionID
         * @memberof contractpb.ContractDetailsRequest
         * @instance
         */
        ContractDetailsRequest.prototype.productVersionID = "";

        /**
         * ContractDetailsRequest quoteID.
         * @member {string} quoteID
         * @memberof contractpb.ContractDetailsRequest
         * @instance
         */
        ContractDetailsRequest.prototype.quoteID = "";

        /**
         * ContractDetailsRequest addOnFeatures.
         * @member {Array.<contractpb.IFeature>} addOnFeatures
         * @memberof contractpb.ContractDetailsRequest
         * @instance
         */
        ContractDetailsRequest.prototype.addOnFeatures = $util.emptyArray;

        /**
         * ContractDetailsRequest addOnBundles.
         * @member {Array.<contractpb.IFeatureBundle>} addOnBundles
         * @memberof contractpb.ContractDetailsRequest
         * @instance
         */
        ContractDetailsRequest.prototype.addOnBundles = $util.emptyArray;

        /**
         * ContractDetailsRequest monies.
         * @member {Array.<contractpb.IMonies>} monies
         * @memberof contractpb.ContractDetailsRequest
         * @instance
         */
        ContractDetailsRequest.prototype.monies = $util.emptyArray;

        /**
         * ContractDetailsRequest sourceApplication.
         * @member {string} sourceApplication
         * @memberof contractpb.ContractDetailsRequest
         * @instance
         */
        ContractDetailsRequest.prototype.sourceApplication = "";

        /**
         * ContractDetailsRequest contractNotes.
         * @member {Array.<contractpb.IContractNote>} contractNotes
         * @memberof contractpb.ContractDetailsRequest
         * @instance
         */
        ContractDetailsRequest.prototype.contractNotes = $util.emptyArray;

        /**
         * ContractDetailsRequest futureEffectiveDate.
         * @member {common.IDate|null|undefined} futureEffectiveDate
         * @memberof contractpb.ContractDetailsRequest
         * @instance
         */
        ContractDetailsRequest.prototype.futureEffectiveDate = null;

        /**
         * ContractDetailsRequest tncID.
         * @member {string} tncID
         * @memberof contractpb.ContractDetailsRequest
         * @instance
         */
        ContractDetailsRequest.prototype.tncID = "";

        /**
         * ContractDetailsRequest paymentID.
         * @member {string} paymentID
         * @memberof contractpb.ContractDetailsRequest
         * @instance
         */
        ContractDetailsRequest.prototype.paymentID = "";

        /**
         * ContractDetailsRequest invoiceID.
         * @member {string} invoiceID
         * @memberof contractpb.ContractDetailsRequest
         * @instance
         */
        ContractDetailsRequest.prototype.invoiceID = "";

        /**
         * ContractDetailsRequest salesPersonID.
         * @member {string} salesPersonID
         * @memberof contractpb.ContractDetailsRequest
         * @instance
         */
        ContractDetailsRequest.prototype.salesPersonID = "";

        /**
         * ContractDetailsRequest salesPersonName.
         * @member {string} salesPersonName
         * @memberof contractpb.ContractDetailsRequest
         * @instance
         */
        ContractDetailsRequest.prototype.salesPersonName = "";

        /**
         * ContractDetailsRequest newContractID.
         * @member {string} newContractID
         * @memberof contractpb.ContractDetailsRequest
         * @instance
         */
        ContractDetailsRequest.prototype.newContractID = "";

        /**
         * ContractDetailsRequest orderID.
         * @member {string} orderID
         * @memberof contractpb.ContractDetailsRequest
         * @instance
         */
        ContractDetailsRequest.prototype.orderID = "";

        /**
         * ContractDetailsRequest paymentPlan.
         * @member {number} paymentPlan
         * @memberof contractpb.ContractDetailsRequest
         * @instance
         */
        ContractDetailsRequest.prototype.paymentPlan = 0;

        /**
         * ContractDetailsRequest discountCode.
         * @member {string} discountCode
         * @memberof contractpb.ContractDetailsRequest
         * @instance
         */
        ContractDetailsRequest.prototype.discountCode = "";

        /**
         * ContractDetailsRequest baseBundles.
         * @member {Array.<contractpb.IFeatureBundle>} baseBundles
         * @memberof contractpb.ContractDetailsRequest
         * @instance
         */
        ContractDetailsRequest.prototype.baseBundles = $util.emptyArray;

        /**
         * ContractDetailsRequest paymentDetail.
         * @member {contractpb.IPaymentDetailV2|null|undefined} paymentDetail
         * @memberof contractpb.ContractDetailsRequest
         * @instance
         */
        ContractDetailsRequest.prototype.paymentDetail = null;

        /**
         * ContractDetailsRequest salesSourceID.
         * @member {string} salesSourceID
         * @memberof contractpb.ContractDetailsRequest
         * @instance
         */
        ContractDetailsRequest.prototype.salesSourceID = "";

        /**
         * ContractDetailsRequest salesAgentID.
         * @member {string} salesAgentID
         * @memberof contractpb.ContractDetailsRequest
         * @instance
         */
        ContractDetailsRequest.prototype.salesAgentID = "";

        /**
         * ContractDetailsRequest partnerID.
         * @member {string} partnerID
         * @memberof contractpb.ContractDetailsRequest
         * @instance
         */
        ContractDetailsRequest.prototype.partnerID = "";

        /**
         * ContractDetailsRequest propertyID.
         * @member {string} propertyID
         * @memberof contractpb.ContractDetailsRequest
         * @instance
         */
        ContractDetailsRequest.prototype.propertyID = "";

        /**
         * ContractDetailsRequest mailingAddressID.
         * @member {string} mailingAddressID
         * @memberof contractpb.ContractDetailsRequest
         * @instance
         */
        ContractDetailsRequest.prototype.mailingAddressID = "";

        /**
         * ContractDetailsRequest salesPersons.
         * @member {Array.<contractpb.ISalesPerson>} salesPersons
         * @memberof contractpb.ContractDetailsRequest
         * @instance
         */
        ContractDetailsRequest.prototype.salesPersons = $util.emptyArray;

        /**
         * ContractDetailsRequest customerDetails.
         * @member {Array.<contractpb.ICustomerDetail>} customerDetails
         * @memberof contractpb.ContractDetailsRequest
         * @instance
         */
        ContractDetailsRequest.prototype.customerDetails = $util.emptyArray;

        /**
         * ContractDetailsRequest diagnosisFee.
         * @member {common.IMoney|null|undefined} diagnosisFee
         * @memberof contractpb.ContractDetailsRequest
         * @instance
         */
        ContractDetailsRequest.prototype.diagnosisFee = null;

        /**
         * ContractDetailsRequest maintenanceFee.
         * @member {common.IMoney|null|undefined} maintenanceFee
         * @memberof contractpb.ContractDetailsRequest
         * @instance
         */
        ContractDetailsRequest.prototype.maintenanceFee = null;

        /**
         * ContractDetailsRequest contractTerm.
         * @member {coreproductpb.TypedValue.ITimePeriod|null|undefined} contractTerm
         * @memberof contractpb.ContractDetailsRequest
         * @instance
         */
        ContractDetailsRequest.prototype.contractTerm = null;

        /**
         * ContractDetailsRequest contractEffExpirationDate.
         * @member {google.protobuf.ITimestamp|null|undefined} contractEffExpirationDate
         * @memberof contractpb.ContractDetailsRequest
         * @instance
         */
        ContractDetailsRequest.prototype.contractEffExpirationDate = null;

        /**
         * Creates a new ContractDetailsRequest instance using the specified properties.
         * @function create
         * @memberof contractpb.ContractDetailsRequest
         * @static
         * @param {contractpb.IContractDetailsRequest=} [properties] Properties to set
         * @returns {contractpb.ContractDetailsRequest} ContractDetailsRequest instance
         */
        ContractDetailsRequest.create = function create(properties) {
            return new ContractDetailsRequest(properties);
        };

        /**
         * Encodes the specified ContractDetailsRequest message. Does not implicitly {@link contractpb.ContractDetailsRequest.verify|verify} messages.
         * @function encode
         * @memberof contractpb.ContractDetailsRequest
         * @static
         * @param {contractpb.IContractDetailsRequest} m ContractDetailsRequest message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ContractDetailsRequest.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.contractID != null && Object.hasOwnProperty.call(m, "contractID"))
                w.uint32(10).string(m.contractID);
            if (m.tenantID != null && Object.hasOwnProperty.call(m, "tenantID"))
                w.uint32(16).int32(m.tenantID);
            if (m.salesChannel != null && Object.hasOwnProperty.call(m, "salesChannel"))
                w.uint32(26).string(m.salesChannel);
            if (m.userName != null && Object.hasOwnProperty.call(m, "userName"))
                w.uint32(34).string(m.userName);
            if (m.productVersionID != null && Object.hasOwnProperty.call(m, "productVersionID"))
                w.uint32(42).string(m.productVersionID);
            if (m.quoteID != null && Object.hasOwnProperty.call(m, "quoteID"))
                w.uint32(50).string(m.quoteID);
            if (m.addOnFeatures != null && m.addOnFeatures.length) {
                for (var i = 0; i < m.addOnFeatures.length; ++i)
                    $root.contractpb.Feature.encode(m.addOnFeatures[i], w.uint32(58).fork()).ldelim();
            }
            if (m.addOnBundles != null && m.addOnBundles.length) {
                for (var i = 0; i < m.addOnBundles.length; ++i)
                    $root.contractpb.FeatureBundle.encode(m.addOnBundles[i], w.uint32(66).fork()).ldelim();
            }
            if (m.monies != null && m.monies.length) {
                for (var i = 0; i < m.monies.length; ++i)
                    $root.contractpb.Monies.encode(m.monies[i], w.uint32(74).fork()).ldelim();
            }
            if (m.sourceApplication != null && Object.hasOwnProperty.call(m, "sourceApplication"))
                w.uint32(82).string(m.sourceApplication);
            if (m.contractNotes != null && m.contractNotes.length) {
                for (var i = 0; i < m.contractNotes.length; ++i)
                    $root.contractpb.ContractNote.encode(m.contractNotes[i], w.uint32(90).fork()).ldelim();
            }
            if (m.futureEffectiveDate != null && Object.hasOwnProperty.call(m, "futureEffectiveDate"))
                $root.common.Date.encode(m.futureEffectiveDate, w.uint32(98).fork()).ldelim();
            if (m.tncID != null && Object.hasOwnProperty.call(m, "tncID"))
                w.uint32(106).string(m.tncID);
            if (m.paymentID != null && Object.hasOwnProperty.call(m, "paymentID"))
                w.uint32(114).string(m.paymentID);
            if (m.invoiceID != null && Object.hasOwnProperty.call(m, "invoiceID"))
                w.uint32(122).string(m.invoiceID);
            if (m.salesPersonID != null && Object.hasOwnProperty.call(m, "salesPersonID"))
                w.uint32(130).string(m.salesPersonID);
            if (m.salesPersonName != null && Object.hasOwnProperty.call(m, "salesPersonName"))
                w.uint32(138).string(m.salesPersonName);
            if (m.newContractID != null && Object.hasOwnProperty.call(m, "newContractID"))
                w.uint32(146).string(m.newContractID);
            if (m.orderID != null && Object.hasOwnProperty.call(m, "orderID"))
                w.uint32(154).string(m.orderID);
            if (m.paymentPlan != null && Object.hasOwnProperty.call(m, "paymentPlan"))
                w.uint32(160).int32(m.paymentPlan);
            if (m.discountCode != null && Object.hasOwnProperty.call(m, "discountCode"))
                w.uint32(170).string(m.discountCode);
            if (m.baseBundles != null && m.baseBundles.length) {
                for (var i = 0; i < m.baseBundles.length; ++i)
                    $root.contractpb.FeatureBundle.encode(m.baseBundles[i], w.uint32(178).fork()).ldelim();
            }
            if (m.paymentDetail != null && Object.hasOwnProperty.call(m, "paymentDetail"))
                $root.contractpb.PaymentDetailV2.encode(m.paymentDetail, w.uint32(186).fork()).ldelim();
            if (m.salesSourceID != null && Object.hasOwnProperty.call(m, "salesSourceID"))
                w.uint32(194).string(m.salesSourceID);
            if (m.salesAgentID != null && Object.hasOwnProperty.call(m, "salesAgentID"))
                w.uint32(202).string(m.salesAgentID);
            if (m.partnerID != null && Object.hasOwnProperty.call(m, "partnerID"))
                w.uint32(210).string(m.partnerID);
            if (m.propertyID != null && Object.hasOwnProperty.call(m, "propertyID"))
                w.uint32(218).string(m.propertyID);
            if (m.mailingAddressID != null && Object.hasOwnProperty.call(m, "mailingAddressID"))
                w.uint32(226).string(m.mailingAddressID);
            if (m.salesPersons != null && m.salesPersons.length) {
                for (var i = 0; i < m.salesPersons.length; ++i)
                    $root.contractpb.SalesPerson.encode(m.salesPersons[i], w.uint32(234).fork()).ldelim();
            }
            if (m.customerDetails != null && m.customerDetails.length) {
                for (var i = 0; i < m.customerDetails.length; ++i)
                    $root.contractpb.CustomerDetail.encode(m.customerDetails[i], w.uint32(242).fork()).ldelim();
            }
            if (m.diagnosisFee != null && Object.hasOwnProperty.call(m, "diagnosisFee"))
                $root.common.Money.encode(m.diagnosisFee, w.uint32(250).fork()).ldelim();
            if (m.maintenanceFee != null && Object.hasOwnProperty.call(m, "maintenanceFee"))
                $root.common.Money.encode(m.maintenanceFee, w.uint32(258).fork()).ldelim();
            if (m.contractTerm != null && Object.hasOwnProperty.call(m, "contractTerm"))
                $root.coreproductpb.TypedValue.TimePeriod.encode(m.contractTerm, w.uint32(266).fork()).ldelim();
            if (m.contractEffExpirationDate != null && Object.hasOwnProperty.call(m, "contractEffExpirationDate"))
                $root.google.protobuf.Timestamp.encode(m.contractEffExpirationDate, w.uint32(274).fork()).ldelim();
            return w;
        };

        /**
         * Decodes a ContractDetailsRequest message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.ContractDetailsRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.ContractDetailsRequest} ContractDetailsRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ContractDetailsRequest.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.ContractDetailsRequest();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.contractID = r.string();
                    break;
                case 2:
                    m.tenantID = r.int32();
                    break;
                case 3:
                    m.salesChannel = r.string();
                    break;
                case 4:
                    m.userName = r.string();
                    break;
                case 5:
                    m.productVersionID = r.string();
                    break;
                case 6:
                    m.quoteID = r.string();
                    break;
                case 7:
                    if (!(m.addOnFeatures && m.addOnFeatures.length))
                        m.addOnFeatures = [];
                    m.addOnFeatures.push($root.contractpb.Feature.decode(r, r.uint32()));
                    break;
                case 8:
                    if (!(m.addOnBundles && m.addOnBundles.length))
                        m.addOnBundles = [];
                    m.addOnBundles.push($root.contractpb.FeatureBundle.decode(r, r.uint32()));
                    break;
                case 9:
                    if (!(m.monies && m.monies.length))
                        m.monies = [];
                    m.monies.push($root.contractpb.Monies.decode(r, r.uint32()));
                    break;
                case 10:
                    m.sourceApplication = r.string();
                    break;
                case 11:
                    if (!(m.contractNotes && m.contractNotes.length))
                        m.contractNotes = [];
                    m.contractNotes.push($root.contractpb.ContractNote.decode(r, r.uint32()));
                    break;
                case 12:
                    m.futureEffectiveDate = $root.common.Date.decode(r, r.uint32());
                    break;
                case 13:
                    m.tncID = r.string();
                    break;
                case 14:
                    m.paymentID = r.string();
                    break;
                case 15:
                    m.invoiceID = r.string();
                    break;
                case 16:
                    m.salesPersonID = r.string();
                    break;
                case 17:
                    m.salesPersonName = r.string();
                    break;
                case 18:
                    m.newContractID = r.string();
                    break;
                case 19:
                    m.orderID = r.string();
                    break;
                case 20:
                    m.paymentPlan = r.int32();
                    break;
                case 21:
                    m.discountCode = r.string();
                    break;
                case 22:
                    if (!(m.baseBundles && m.baseBundles.length))
                        m.baseBundles = [];
                    m.baseBundles.push($root.contractpb.FeatureBundle.decode(r, r.uint32()));
                    break;
                case 23:
                    m.paymentDetail = $root.contractpb.PaymentDetailV2.decode(r, r.uint32());
                    break;
                case 24:
                    m.salesSourceID = r.string();
                    break;
                case 25:
                    m.salesAgentID = r.string();
                    break;
                case 26:
                    m.partnerID = r.string();
                    break;
                case 27:
                    m.propertyID = r.string();
                    break;
                case 28:
                    m.mailingAddressID = r.string();
                    break;
                case 29:
                    if (!(m.salesPersons && m.salesPersons.length))
                        m.salesPersons = [];
                    m.salesPersons.push($root.contractpb.SalesPerson.decode(r, r.uint32()));
                    break;
                case 30:
                    if (!(m.customerDetails && m.customerDetails.length))
                        m.customerDetails = [];
                    m.customerDetails.push($root.contractpb.CustomerDetail.decode(r, r.uint32()));
                    break;
                case 31:
                    m.diagnosisFee = $root.common.Money.decode(r, r.uint32());
                    break;
                case 32:
                    m.maintenanceFee = $root.common.Money.decode(r, r.uint32());
                    break;
                case 33:
                    m.contractTerm = $root.coreproductpb.TypedValue.TimePeriod.decode(r, r.uint32());
                    break;
                case 34:
                    m.contractEffExpirationDate = $root.google.protobuf.Timestamp.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return ContractDetailsRequest;
    })();

    contractpb.UpdateCoveragesResponse = (function() {

        /**
         * Properties of an UpdateCoveragesResponse.
         * @memberof contractpb
         * @interface IUpdateCoveragesResponse
         * @property {contractpb.IRequestMetaData|null} [reqMetaData] UpdateCoveragesResponse reqMetaData
         */

        /**
         * Constructs a new UpdateCoveragesResponse.
         * @memberof contractpb
         * @classdesc POST /contract/v1/coverages
         * HttpStatusCode:
         * * 202: Status Accepted. Will be sent if request has been accepted
         * * 208: Already Reported. Will be sent if request for given contract was already sent earlier and is under process
         * * 400: Bad Request. Will be sent if request does not contain a mandatory field or request param is in incorrect data format
         * * 500: Internal Server Error. Will be sent if there is an unexpected error in processing the request.
         * @implements IUpdateCoveragesResponse
         * @constructor
         * @param {contractpb.IUpdateCoveragesResponse=} [p] Properties to set
         */
        function UpdateCoveragesResponse(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * UpdateCoveragesResponse reqMetaData.
         * @member {contractpb.IRequestMetaData|null|undefined} reqMetaData
         * @memberof contractpb.UpdateCoveragesResponse
         * @instance
         */
        UpdateCoveragesResponse.prototype.reqMetaData = null;

        /**
         * Creates a new UpdateCoveragesResponse instance using the specified properties.
         * @function create
         * @memberof contractpb.UpdateCoveragesResponse
         * @static
         * @param {contractpb.IUpdateCoveragesResponse=} [properties] Properties to set
         * @returns {contractpb.UpdateCoveragesResponse} UpdateCoveragesResponse instance
         */
        UpdateCoveragesResponse.create = function create(properties) {
            return new UpdateCoveragesResponse(properties);
        };

        /**
         * Encodes the specified UpdateCoveragesResponse message. Does not implicitly {@link contractpb.UpdateCoveragesResponse.verify|verify} messages.
         * @function encode
         * @memberof contractpb.UpdateCoveragesResponse
         * @static
         * @param {contractpb.IUpdateCoveragesResponse} m UpdateCoveragesResponse message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UpdateCoveragesResponse.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.reqMetaData != null && Object.hasOwnProperty.call(m, "reqMetaData"))
                $root.contractpb.RequestMetaData.encode(m.reqMetaData, w.uint32(10).fork()).ldelim();
            return w;
        };

        /**
         * Decodes an UpdateCoveragesResponse message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.UpdateCoveragesResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.UpdateCoveragesResponse} UpdateCoveragesResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UpdateCoveragesResponse.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.UpdateCoveragesResponse();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.reqMetaData = $root.contractpb.RequestMetaData.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return UpdateCoveragesResponse;
    })();

    contractpb.FeatureAttributes = (function() {

        /**
         * Properties of a FeatureAttributes.
         * @memberof contractpb
         * @interface IFeatureAttributes
         * @property {number|null} [quantity] FeatureAttributes quantity
         * @property {number|null} [cost] FeatureAttributes cost
         */

        /**
         * Constructs a new FeatureAttributes.
         * @memberof contractpb
         * @classdesc Represents a FeatureAttributes.
         * @implements IFeatureAttributes
         * @constructor
         * @param {contractpb.IFeatureAttributes=} [p] Properties to set
         */
        function FeatureAttributes(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * FeatureAttributes quantity.
         * @member {number} quantity
         * @memberof contractpb.FeatureAttributes
         * @instance
         */
        FeatureAttributes.prototype.quantity = 0;

        /**
         * FeatureAttributes cost.
         * @member {number} cost
         * @memberof contractpb.FeatureAttributes
         * @instance
         */
        FeatureAttributes.prototype.cost = 0;

        /**
         * Creates a new FeatureAttributes instance using the specified properties.
         * @function create
         * @memberof contractpb.FeatureAttributes
         * @static
         * @param {contractpb.IFeatureAttributes=} [properties] Properties to set
         * @returns {contractpb.FeatureAttributes} FeatureAttributes instance
         */
        FeatureAttributes.create = function create(properties) {
            return new FeatureAttributes(properties);
        };

        /**
         * Encodes the specified FeatureAttributes message. Does not implicitly {@link contractpb.FeatureAttributes.verify|verify} messages.
         * @function encode
         * @memberof contractpb.FeatureAttributes
         * @static
         * @param {contractpb.IFeatureAttributes} m FeatureAttributes message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        FeatureAttributes.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.quantity != null && Object.hasOwnProperty.call(m, "quantity"))
                w.uint32(8).int32(m.quantity);
            if (m.cost != null && Object.hasOwnProperty.call(m, "cost"))
                w.uint32(17).double(m.cost);
            return w;
        };

        /**
         * Decodes a FeatureAttributes message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.FeatureAttributes
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.FeatureAttributes} FeatureAttributes
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        FeatureAttributes.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.FeatureAttributes();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.quantity = r.int32();
                    break;
                case 2:
                    m.cost = r.double();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return FeatureAttributes;
    })();

    contractpb.Feature = (function() {

        /**
         * Properties of a Feature.
         * @memberof contractpb
         * @interface IFeature
         * @property {coreproductpb.FeatureMasterDataType|null} [featureType] Feature featureType
         * @property {string|null} [featureID] Feature featureID
         * @property {contractpb.IFeatureAttributes|null} [featureAttributes] Feature featureAttributes
         */

        /**
         * Constructs a new Feature.
         * @memberof contractpb
         * @classdesc Represents a Feature.
         * @implements IFeature
         * @constructor
         * @param {contractpb.IFeature=} [p] Properties to set
         */
        function Feature(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * Feature featureType.
         * @member {coreproductpb.FeatureMasterDataType} featureType
         * @memberof contractpb.Feature
         * @instance
         */
        Feature.prototype.featureType = 0;

        /**
         * Feature featureID.
         * @member {string} featureID
         * @memberof contractpb.Feature
         * @instance
         */
        Feature.prototype.featureID = "";

        /**
         * Feature featureAttributes.
         * @member {contractpb.IFeatureAttributes|null|undefined} featureAttributes
         * @memberof contractpb.Feature
         * @instance
         */
        Feature.prototype.featureAttributes = null;

        /**
         * Creates a new Feature instance using the specified properties.
         * @function create
         * @memberof contractpb.Feature
         * @static
         * @param {contractpb.IFeature=} [properties] Properties to set
         * @returns {contractpb.Feature} Feature instance
         */
        Feature.create = function create(properties) {
            return new Feature(properties);
        };

        /**
         * Encodes the specified Feature message. Does not implicitly {@link contractpb.Feature.verify|verify} messages.
         * @function encode
         * @memberof contractpb.Feature
         * @static
         * @param {contractpb.IFeature} m Feature message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Feature.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.featureType != null && Object.hasOwnProperty.call(m, "featureType"))
                w.uint32(8).int32(m.featureType);
            if (m.featureID != null && Object.hasOwnProperty.call(m, "featureID"))
                w.uint32(18).string(m.featureID);
            if (m.featureAttributes != null && Object.hasOwnProperty.call(m, "featureAttributes"))
                $root.contractpb.FeatureAttributes.encode(m.featureAttributes, w.uint32(26).fork()).ldelim();
            return w;
        };

        /**
         * Decodes a Feature message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.Feature
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.Feature} Feature
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Feature.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.Feature();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.featureType = r.int32();
                    break;
                case 2:
                    m.featureID = r.string();
                    break;
                case 3:
                    m.featureAttributes = $root.contractpb.FeatureAttributes.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return Feature;
    })();

    contractpb.FeatureBundleAttributes = (function() {

        /**
         * Properties of a FeatureBundleAttributes.
         * @memberof contractpb
         * @interface IFeatureBundleAttributes
         * @property {number|null} [cost] FeatureBundleAttributes cost
         */

        /**
         * Constructs a new FeatureBundleAttributes.
         * @memberof contractpb
         * @classdesc Represents a FeatureBundleAttributes.
         * @implements IFeatureBundleAttributes
         * @constructor
         * @param {contractpb.IFeatureBundleAttributes=} [p] Properties to set
         */
        function FeatureBundleAttributes(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * FeatureBundleAttributes cost.
         * @member {number} cost
         * @memberof contractpb.FeatureBundleAttributes
         * @instance
         */
        FeatureBundleAttributes.prototype.cost = 0;

        /**
         * Creates a new FeatureBundleAttributes instance using the specified properties.
         * @function create
         * @memberof contractpb.FeatureBundleAttributes
         * @static
         * @param {contractpb.IFeatureBundleAttributes=} [properties] Properties to set
         * @returns {contractpb.FeatureBundleAttributes} FeatureBundleAttributes instance
         */
        FeatureBundleAttributes.create = function create(properties) {
            return new FeatureBundleAttributes(properties);
        };

        /**
         * Encodes the specified FeatureBundleAttributes message. Does not implicitly {@link contractpb.FeatureBundleAttributes.verify|verify} messages.
         * @function encode
         * @memberof contractpb.FeatureBundleAttributes
         * @static
         * @param {contractpb.IFeatureBundleAttributes} m FeatureBundleAttributes message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        FeatureBundleAttributes.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.cost != null && Object.hasOwnProperty.call(m, "cost"))
                w.uint32(9).double(m.cost);
            return w;
        };

        /**
         * Decodes a FeatureBundleAttributes message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.FeatureBundleAttributes
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.FeatureBundleAttributes} FeatureBundleAttributes
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        FeatureBundleAttributes.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.FeatureBundleAttributes();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.cost = r.double();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return FeatureBundleAttributes;
    })();

    contractpb.UpdateContractRequest = (function() {

        /**
         * Properties of an UpdateContractRequest.
         * @memberof contractpb
         * @interface IUpdateContractRequest
         * @property {common.Tenant|null} [tenantID] UpdateContractRequest tenantID
         * @property {contractpb.IContractAttributes|null} [contractAttributes] UpdateContractRequest contractAttributes
         */

        /**
         * Constructs a new UpdateContractRequest.
         * @memberof contractpb
         * @classdesc Represents an UpdateContractRequest.
         * @implements IUpdateContractRequest
         * @constructor
         * @param {contractpb.IUpdateContractRequest=} [p] Properties to set
         */
        function UpdateContractRequest(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * UpdateContractRequest tenantID.
         * @member {common.Tenant} tenantID
         * @memberof contractpb.UpdateContractRequest
         * @instance
         */
        UpdateContractRequest.prototype.tenantID = 0;

        /**
         * UpdateContractRequest contractAttributes.
         * @member {contractpb.IContractAttributes|null|undefined} contractAttributes
         * @memberof contractpb.UpdateContractRequest
         * @instance
         */
        UpdateContractRequest.prototype.contractAttributes = null;

        /**
         * Creates a new UpdateContractRequest instance using the specified properties.
         * @function create
         * @memberof contractpb.UpdateContractRequest
         * @static
         * @param {contractpb.IUpdateContractRequest=} [properties] Properties to set
         * @returns {contractpb.UpdateContractRequest} UpdateContractRequest instance
         */
        UpdateContractRequest.create = function create(properties) {
            return new UpdateContractRequest(properties);
        };

        /**
         * Encodes the specified UpdateContractRequest message. Does not implicitly {@link contractpb.UpdateContractRequest.verify|verify} messages.
         * @function encode
         * @memberof contractpb.UpdateContractRequest
         * @static
         * @param {contractpb.IUpdateContractRequest} m UpdateContractRequest message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UpdateContractRequest.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.tenantID != null && Object.hasOwnProperty.call(m, "tenantID"))
                w.uint32(8).int32(m.tenantID);
            if (m.contractAttributes != null && Object.hasOwnProperty.call(m, "contractAttributes"))
                $root.contractpb.ContractAttributes.encode(m.contractAttributes, w.uint32(18).fork()).ldelim();
            return w;
        };

        /**
         * Decodes an UpdateContractRequest message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.UpdateContractRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.UpdateContractRequest} UpdateContractRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UpdateContractRequest.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.UpdateContractRequest();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.tenantID = r.int32();
                    break;
                case 2:
                    m.contractAttributes = $root.contractpb.ContractAttributes.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return UpdateContractRequest;
    })();

    contractpb.ContractAttributes = (function() {

        /**
         * Properties of a ContractAttributes.
         * @memberof contractpb
         * @interface IContractAttributes
         * @property {string|null} [renewalBatchFlag] ContractAttributes renewalBatchFlag
         * @property {string|null} [salesChannel] ContractAttributes salesChannel
         * @property {contractpb.IUpdateQuotesRelatedInfo|null} [updateInfo] ContractAttributes updateInfo
         * @property {number|null} [newInvoiceDay] ContractAttributes newInvoiceDay
         * @property {string|null} [salesSourceID] ContractAttributes salesSourceID
         */

        /**
         * Constructs a new ContractAttributes.
         * @memberof contractpb
         * @classdesc Represents a ContractAttributes.
         * @implements IContractAttributes
         * @constructor
         * @param {contractpb.IContractAttributes=} [p] Properties to set
         */
        function ContractAttributes(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * ContractAttributes renewalBatchFlag.
         * @member {string} renewalBatchFlag
         * @memberof contractpb.ContractAttributes
         * @instance
         */
        ContractAttributes.prototype.renewalBatchFlag = "";

        /**
         * ContractAttributes salesChannel.
         * @member {string} salesChannel
         * @memberof contractpb.ContractAttributes
         * @instance
         */
        ContractAttributes.prototype.salesChannel = "";

        /**
         * ContractAttributes updateInfo.
         * @member {contractpb.IUpdateQuotesRelatedInfo|null|undefined} updateInfo
         * @memberof contractpb.ContractAttributes
         * @instance
         */
        ContractAttributes.prototype.updateInfo = null;

        /**
         * ContractAttributes newInvoiceDay.
         * @member {number} newInvoiceDay
         * @memberof contractpb.ContractAttributes
         * @instance
         */
        ContractAttributes.prototype.newInvoiceDay = 0;

        /**
         * ContractAttributes salesSourceID.
         * @member {string} salesSourceID
         * @memberof contractpb.ContractAttributes
         * @instance
         */
        ContractAttributes.prototype.salesSourceID = "";

        /**
         * Creates a new ContractAttributes instance using the specified properties.
         * @function create
         * @memberof contractpb.ContractAttributes
         * @static
         * @param {contractpb.IContractAttributes=} [properties] Properties to set
         * @returns {contractpb.ContractAttributes} ContractAttributes instance
         */
        ContractAttributes.create = function create(properties) {
            return new ContractAttributes(properties);
        };

        /**
         * Encodes the specified ContractAttributes message. Does not implicitly {@link contractpb.ContractAttributes.verify|verify} messages.
         * @function encode
         * @memberof contractpb.ContractAttributes
         * @static
         * @param {contractpb.IContractAttributes} m ContractAttributes message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ContractAttributes.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.renewalBatchFlag != null && Object.hasOwnProperty.call(m, "renewalBatchFlag"))
                w.uint32(10).string(m.renewalBatchFlag);
            if (m.salesChannel != null && Object.hasOwnProperty.call(m, "salesChannel"))
                w.uint32(18).string(m.salesChannel);
            if (m.updateInfo != null && Object.hasOwnProperty.call(m, "updateInfo"))
                $root.contractpb.UpdateQuotesRelatedInfo.encode(m.updateInfo, w.uint32(26).fork()).ldelim();
            if (m.newInvoiceDay != null && Object.hasOwnProperty.call(m, "newInvoiceDay"))
                w.uint32(32).int32(m.newInvoiceDay);
            if (m.salesSourceID != null && Object.hasOwnProperty.call(m, "salesSourceID"))
                w.uint32(42).string(m.salesSourceID);
            return w;
        };

        /**
         * Decodes a ContractAttributes message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.ContractAttributes
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.ContractAttributes} ContractAttributes
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ContractAttributes.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.ContractAttributes();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.renewalBatchFlag = r.string();
                    break;
                case 2:
                    m.salesChannel = r.string();
                    break;
                case 3:
                    m.updateInfo = $root.contractpb.UpdateQuotesRelatedInfo.decode(r, r.uint32());
                    break;
                case 4:
                    m.newInvoiceDay = r.int32();
                    break;
                case 5:
                    m.salesSourceID = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return ContractAttributes;
    })();

    contractpb.UpdateQuotesRelatedInfo = (function() {

        /**
         * Properties of an UpdateQuotesRelatedInfo.
         * @memberof contractpb
         * @interface IUpdateQuotesRelatedInfo
         * @property {string|null} [quoteID] UpdateQuotesRelatedInfo quoteID
         * @property {string|null} [username] UpdateQuotesRelatedInfo username
         * @property {Array.<contractpb.IMonies>|null} [monies] UpdateQuotesRelatedInfo monies
         * @property {string|null} [tncID] UpdateQuotesRelatedInfo tncID
         * @property {common.IDate|null} [futuredate] UpdateQuotesRelatedInfo futuredate
         */

        /**
         * Constructs a new UpdateQuotesRelatedInfo.
         * @memberof contractpb
         * @classdesc Represents an UpdateQuotesRelatedInfo.
         * @implements IUpdateQuotesRelatedInfo
         * @constructor
         * @param {contractpb.IUpdateQuotesRelatedInfo=} [p] Properties to set
         */
        function UpdateQuotesRelatedInfo(p) {
            this.monies = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * UpdateQuotesRelatedInfo quoteID.
         * @member {string} quoteID
         * @memberof contractpb.UpdateQuotesRelatedInfo
         * @instance
         */
        UpdateQuotesRelatedInfo.prototype.quoteID = "";

        /**
         * UpdateQuotesRelatedInfo username.
         * @member {string} username
         * @memberof contractpb.UpdateQuotesRelatedInfo
         * @instance
         */
        UpdateQuotesRelatedInfo.prototype.username = "";

        /**
         * UpdateQuotesRelatedInfo monies.
         * @member {Array.<contractpb.IMonies>} monies
         * @memberof contractpb.UpdateQuotesRelatedInfo
         * @instance
         */
        UpdateQuotesRelatedInfo.prototype.monies = $util.emptyArray;

        /**
         * UpdateQuotesRelatedInfo tncID.
         * @member {string} tncID
         * @memberof contractpb.UpdateQuotesRelatedInfo
         * @instance
         */
        UpdateQuotesRelatedInfo.prototype.tncID = "";

        /**
         * UpdateQuotesRelatedInfo futuredate.
         * @member {common.IDate|null|undefined} futuredate
         * @memberof contractpb.UpdateQuotesRelatedInfo
         * @instance
         */
        UpdateQuotesRelatedInfo.prototype.futuredate = null;

        /**
         * Creates a new UpdateQuotesRelatedInfo instance using the specified properties.
         * @function create
         * @memberof contractpb.UpdateQuotesRelatedInfo
         * @static
         * @param {contractpb.IUpdateQuotesRelatedInfo=} [properties] Properties to set
         * @returns {contractpb.UpdateQuotesRelatedInfo} UpdateQuotesRelatedInfo instance
         */
        UpdateQuotesRelatedInfo.create = function create(properties) {
            return new UpdateQuotesRelatedInfo(properties);
        };

        /**
         * Encodes the specified UpdateQuotesRelatedInfo message. Does not implicitly {@link contractpb.UpdateQuotesRelatedInfo.verify|verify} messages.
         * @function encode
         * @memberof contractpb.UpdateQuotesRelatedInfo
         * @static
         * @param {contractpb.IUpdateQuotesRelatedInfo} m UpdateQuotesRelatedInfo message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UpdateQuotesRelatedInfo.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.quoteID != null && Object.hasOwnProperty.call(m, "quoteID"))
                w.uint32(10).string(m.quoteID);
            if (m.username != null && Object.hasOwnProperty.call(m, "username"))
                w.uint32(18).string(m.username);
            if (m.monies != null && m.monies.length) {
                for (var i = 0; i < m.monies.length; ++i)
                    $root.contractpb.Monies.encode(m.monies[i], w.uint32(26).fork()).ldelim();
            }
            if (m.tncID != null && Object.hasOwnProperty.call(m, "tncID"))
                w.uint32(34).string(m.tncID);
            if (m.futuredate != null && Object.hasOwnProperty.call(m, "futuredate"))
                $root.common.Date.encode(m.futuredate, w.uint32(42).fork()).ldelim();
            return w;
        };

        /**
         * Decodes an UpdateQuotesRelatedInfo message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.UpdateQuotesRelatedInfo
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.UpdateQuotesRelatedInfo} UpdateQuotesRelatedInfo
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UpdateQuotesRelatedInfo.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.UpdateQuotesRelatedInfo();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.quoteID = r.string();
                    break;
                case 2:
                    m.username = r.string();
                    break;
                case 3:
                    if (!(m.monies && m.monies.length))
                        m.monies = [];
                    m.monies.push($root.contractpb.Monies.decode(r, r.uint32()));
                    break;
                case 4:
                    m.tncID = r.string();
                    break;
                case 5:
                    m.futuredate = $root.common.Date.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return UpdateQuotesRelatedInfo;
    })();

    contractpb.UpdateContractResponse = (function() {

        /**
         * Properties of an UpdateContractResponse.
         * @memberof contractpb
         * @interface IUpdateContractResponse
         * @property {common.IError|null} [error] UpdateContractResponse error
         */

        /**
         * Constructs a new UpdateContractResponse.
         * @memberof contractpb
         * @classdesc Represents an UpdateContractResponse.
         * @implements IUpdateContractResponse
         * @constructor
         * @param {contractpb.IUpdateContractResponse=} [p] Properties to set
         */
        function UpdateContractResponse(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * UpdateContractResponse error.
         * @member {common.IError|null|undefined} error
         * @memberof contractpb.UpdateContractResponse
         * @instance
         */
        UpdateContractResponse.prototype.error = null;

        /**
         * Creates a new UpdateContractResponse instance using the specified properties.
         * @function create
         * @memberof contractpb.UpdateContractResponse
         * @static
         * @param {contractpb.IUpdateContractResponse=} [properties] Properties to set
         * @returns {contractpb.UpdateContractResponse} UpdateContractResponse instance
         */
        UpdateContractResponse.create = function create(properties) {
            return new UpdateContractResponse(properties);
        };

        /**
         * Encodes the specified UpdateContractResponse message. Does not implicitly {@link contractpb.UpdateContractResponse.verify|verify} messages.
         * @function encode
         * @memberof contractpb.UpdateContractResponse
         * @static
         * @param {contractpb.IUpdateContractResponse} m UpdateContractResponse message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UpdateContractResponse.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.error != null && Object.hasOwnProperty.call(m, "error"))
                $root.common.Error.encode(m.error, w.uint32(10).fork()).ldelim();
            return w;
        };

        /**
         * Decodes an UpdateContractResponse message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.UpdateContractResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.UpdateContractResponse} UpdateContractResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UpdateContractResponse.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.UpdateContractResponse();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.error = $root.common.Error.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return UpdateContractResponse;
    })();

    contractpb.FeatureBundle = (function() {

        /**
         * Properties of a FeatureBundle.
         * @memberof contractpb
         * @interface IFeatureBundle
         * @property {string|null} [bundleID] FeatureBundle bundleID
         * @property {contractpb.IFeatureBundleAttributes|null} [featureBundleAttributes] FeatureBundle featureBundleAttributes
         * @property {Array.<contractpb.IFeature>|null} [baseFeatures] FeatureBundle baseFeatures
         * @property {Array.<contractpb.IFeature>|null} [addOnFeatures] FeatureBundle addOnFeatures
         */

        /**
         * Constructs a new FeatureBundle.
         * @memberof contractpb
         * @classdesc Represents a FeatureBundle.
         * @implements IFeatureBundle
         * @constructor
         * @param {contractpb.IFeatureBundle=} [p] Properties to set
         */
        function FeatureBundle(p) {
            this.baseFeatures = [];
            this.addOnFeatures = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * FeatureBundle bundleID.
         * @member {string} bundleID
         * @memberof contractpb.FeatureBundle
         * @instance
         */
        FeatureBundle.prototype.bundleID = "";

        /**
         * FeatureBundle featureBundleAttributes.
         * @member {contractpb.IFeatureBundleAttributes|null|undefined} featureBundleAttributes
         * @memberof contractpb.FeatureBundle
         * @instance
         */
        FeatureBundle.prototype.featureBundleAttributes = null;

        /**
         * FeatureBundle baseFeatures.
         * @member {Array.<contractpb.IFeature>} baseFeatures
         * @memberof contractpb.FeatureBundle
         * @instance
         */
        FeatureBundle.prototype.baseFeatures = $util.emptyArray;

        /**
         * FeatureBundle addOnFeatures.
         * @member {Array.<contractpb.IFeature>} addOnFeatures
         * @memberof contractpb.FeatureBundle
         * @instance
         */
        FeatureBundle.prototype.addOnFeatures = $util.emptyArray;

        /**
         * Creates a new FeatureBundle instance using the specified properties.
         * @function create
         * @memberof contractpb.FeatureBundle
         * @static
         * @param {contractpb.IFeatureBundle=} [properties] Properties to set
         * @returns {contractpb.FeatureBundle} FeatureBundle instance
         */
        FeatureBundle.create = function create(properties) {
            return new FeatureBundle(properties);
        };

        /**
         * Encodes the specified FeatureBundle message. Does not implicitly {@link contractpb.FeatureBundle.verify|verify} messages.
         * @function encode
         * @memberof contractpb.FeatureBundle
         * @static
         * @param {contractpb.IFeatureBundle} m FeatureBundle message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        FeatureBundle.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.bundleID != null && Object.hasOwnProperty.call(m, "bundleID"))
                w.uint32(10).string(m.bundleID);
            if (m.featureBundleAttributes != null && Object.hasOwnProperty.call(m, "featureBundleAttributes"))
                $root.contractpb.FeatureBundleAttributes.encode(m.featureBundleAttributes, w.uint32(18).fork()).ldelim();
            if (m.baseFeatures != null && m.baseFeatures.length) {
                for (var i = 0; i < m.baseFeatures.length; ++i)
                    $root.contractpb.Feature.encode(m.baseFeatures[i], w.uint32(26).fork()).ldelim();
            }
            if (m.addOnFeatures != null && m.addOnFeatures.length) {
                for (var i = 0; i < m.addOnFeatures.length; ++i)
                    $root.contractpb.Feature.encode(m.addOnFeatures[i], w.uint32(34).fork()).ldelim();
            }
            return w;
        };

        /**
         * Decodes a FeatureBundle message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.FeatureBundle
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.FeatureBundle} FeatureBundle
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        FeatureBundle.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.FeatureBundle();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.bundleID = r.string();
                    break;
                case 2:
                    m.featureBundleAttributes = $root.contractpb.FeatureBundleAttributes.decode(r, r.uint32());
                    break;
                case 3:
                    if (!(m.baseFeatures && m.baseFeatures.length))
                        m.baseFeatures = [];
                    m.baseFeatures.push($root.contractpb.Feature.decode(r, r.uint32()));
                    break;
                case 4:
                    if (!(m.addOnFeatures && m.addOnFeatures.length))
                        m.addOnFeatures = [];
                    m.addOnFeatures.push($root.contractpb.Feature.decode(r, r.uint32()));
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return FeatureBundle;
    })();

    contractpb.PaymentDetailV2 = (function() {

        /**
         * Properties of a PaymentDetailV2.
         * @memberof contractpb
         * @interface IPaymentDetailV2
         * @property {string|null} [paymentType] PaymentDetailV2 paymentType
         * @property {string|null} [paymentTypeCode] PaymentDetailV2 paymentTypeCode
         * @property {string|null} [sourceTypeCode] PaymentDetailV2 sourceTypeCode
         * @property {string|null} [transactionState] PaymentDetailV2 transactionState
         * @property {number|null} [transactionAmount] PaymentDetailV2 transactionAmount
         * @property {string|null} [paymentProcessingDate] PaymentDetailV2 paymentProcessingDate
         * @property {string|null} [autoBillIndicator] PaymentDetailV2 autoBillIndicator
         * @property {string|null} [paymentExtractedDate] PaymentDetailV2 paymentExtractedDate
         * @property {string|null} [resubmitIndicator] PaymentDetailV2 resubmitIndicator
         * @property {string|null} [paymentMethodID] PaymentDetailV2 paymentMethodID
         * @property {string|null} [tokenFlag] PaymentDetailV2 tokenFlag
         * @property {string|null} [billingAddressID] PaymentDetailV2 billingAddressID
         * @property {contractpb.IContractProperty|null} [billingAddress] PaymentDetailV2 billingAddress
         * @property {contractpb.PaymentDetailV2.ICCDetails|null} [ccDetails] PaymentDetailV2 ccDetails
         * @property {contractpb.PaymentDetailV2.IACHDetails|null} [achDetails] PaymentDetailV2 achDetails
         */

        /**
         * Constructs a new PaymentDetailV2.
         * @memberof contractpb
         * @classdesc Represents a PaymentDetailV2.
         * @implements IPaymentDetailV2
         * @constructor
         * @param {contractpb.IPaymentDetailV2=} [p] Properties to set
         */
        function PaymentDetailV2(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * PaymentDetailV2 paymentType.
         * @member {string} paymentType
         * @memberof contractpb.PaymentDetailV2
         * @instance
         */
        PaymentDetailV2.prototype.paymentType = "";

        /**
         * PaymentDetailV2 paymentTypeCode.
         * @member {string} paymentTypeCode
         * @memberof contractpb.PaymentDetailV2
         * @instance
         */
        PaymentDetailV2.prototype.paymentTypeCode = "";

        /**
         * PaymentDetailV2 sourceTypeCode.
         * @member {string} sourceTypeCode
         * @memberof contractpb.PaymentDetailV2
         * @instance
         */
        PaymentDetailV2.prototype.sourceTypeCode = "";

        /**
         * PaymentDetailV2 transactionState.
         * @member {string} transactionState
         * @memberof contractpb.PaymentDetailV2
         * @instance
         */
        PaymentDetailV2.prototype.transactionState = "";

        /**
         * PaymentDetailV2 transactionAmount.
         * @member {number} transactionAmount
         * @memberof contractpb.PaymentDetailV2
         * @instance
         */
        PaymentDetailV2.prototype.transactionAmount = 0;

        /**
         * PaymentDetailV2 paymentProcessingDate.
         * @member {string} paymentProcessingDate
         * @memberof contractpb.PaymentDetailV2
         * @instance
         */
        PaymentDetailV2.prototype.paymentProcessingDate = "";

        /**
         * PaymentDetailV2 autoBillIndicator.
         * @member {string} autoBillIndicator
         * @memberof contractpb.PaymentDetailV2
         * @instance
         */
        PaymentDetailV2.prototype.autoBillIndicator = "";

        /**
         * PaymentDetailV2 paymentExtractedDate.
         * @member {string} paymentExtractedDate
         * @memberof contractpb.PaymentDetailV2
         * @instance
         */
        PaymentDetailV2.prototype.paymentExtractedDate = "";

        /**
         * PaymentDetailV2 resubmitIndicator.
         * @member {string} resubmitIndicator
         * @memberof contractpb.PaymentDetailV2
         * @instance
         */
        PaymentDetailV2.prototype.resubmitIndicator = "";

        /**
         * PaymentDetailV2 paymentMethodID.
         * @member {string} paymentMethodID
         * @memberof contractpb.PaymentDetailV2
         * @instance
         */
        PaymentDetailV2.prototype.paymentMethodID = "";

        /**
         * PaymentDetailV2 tokenFlag.
         * @member {string} tokenFlag
         * @memberof contractpb.PaymentDetailV2
         * @instance
         */
        PaymentDetailV2.prototype.tokenFlag = "";

        /**
         * PaymentDetailV2 billingAddressID.
         * @member {string} billingAddressID
         * @memberof contractpb.PaymentDetailV2
         * @instance
         */
        PaymentDetailV2.prototype.billingAddressID = "";

        /**
         * PaymentDetailV2 billingAddress.
         * @member {contractpb.IContractProperty|null|undefined} billingAddress
         * @memberof contractpb.PaymentDetailV2
         * @instance
         */
        PaymentDetailV2.prototype.billingAddress = null;

        /**
         * PaymentDetailV2 ccDetails.
         * @member {contractpb.PaymentDetailV2.ICCDetails|null|undefined} ccDetails
         * @memberof contractpb.PaymentDetailV2
         * @instance
         */
        PaymentDetailV2.prototype.ccDetails = null;

        /**
         * PaymentDetailV2 achDetails.
         * @member {contractpb.PaymentDetailV2.IACHDetails|null|undefined} achDetails
         * @memberof contractpb.PaymentDetailV2
         * @instance
         */
        PaymentDetailV2.prototype.achDetails = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        /**
         * PaymentDetailV2 paymentTypeDetails.
         * @member {"ccDetails"|"achDetails"|undefined} paymentTypeDetails
         * @memberof contractpb.PaymentDetailV2
         * @instance
         */
        Object.defineProperty(PaymentDetailV2.prototype, "paymentTypeDetails", {
            get: $util.oneOfGetter($oneOfFields = ["ccDetails", "achDetails"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new PaymentDetailV2 instance using the specified properties.
         * @function create
         * @memberof contractpb.PaymentDetailV2
         * @static
         * @param {contractpb.IPaymentDetailV2=} [properties] Properties to set
         * @returns {contractpb.PaymentDetailV2} PaymentDetailV2 instance
         */
        PaymentDetailV2.create = function create(properties) {
            return new PaymentDetailV2(properties);
        };

        /**
         * Encodes the specified PaymentDetailV2 message. Does not implicitly {@link contractpb.PaymentDetailV2.verify|verify} messages.
         * @function encode
         * @memberof contractpb.PaymentDetailV2
         * @static
         * @param {contractpb.IPaymentDetailV2} m PaymentDetailV2 message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PaymentDetailV2.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.paymentType != null && Object.hasOwnProperty.call(m, "paymentType"))
                w.uint32(10).string(m.paymentType);
            if (m.paymentTypeCode != null && Object.hasOwnProperty.call(m, "paymentTypeCode"))
                w.uint32(18).string(m.paymentTypeCode);
            if (m.sourceTypeCode != null && Object.hasOwnProperty.call(m, "sourceTypeCode"))
                w.uint32(26).string(m.sourceTypeCode);
            if (m.transactionState != null && Object.hasOwnProperty.call(m, "transactionState"))
                w.uint32(34).string(m.transactionState);
            if (m.transactionAmount != null && Object.hasOwnProperty.call(m, "transactionAmount"))
                w.uint32(45).float(m.transactionAmount);
            if (m.paymentProcessingDate != null && Object.hasOwnProperty.call(m, "paymentProcessingDate"))
                w.uint32(50).string(m.paymentProcessingDate);
            if (m.autoBillIndicator != null && Object.hasOwnProperty.call(m, "autoBillIndicator"))
                w.uint32(58).string(m.autoBillIndicator);
            if (m.paymentExtractedDate != null && Object.hasOwnProperty.call(m, "paymentExtractedDate"))
                w.uint32(66).string(m.paymentExtractedDate);
            if (m.resubmitIndicator != null && Object.hasOwnProperty.call(m, "resubmitIndicator"))
                w.uint32(74).string(m.resubmitIndicator);
            if (m.paymentMethodID != null && Object.hasOwnProperty.call(m, "paymentMethodID"))
                w.uint32(82).string(m.paymentMethodID);
            if (m.tokenFlag != null && Object.hasOwnProperty.call(m, "tokenFlag"))
                w.uint32(90).string(m.tokenFlag);
            if (m.billingAddressID != null && Object.hasOwnProperty.call(m, "billingAddressID"))
                w.uint32(98).string(m.billingAddressID);
            if (m.billingAddress != null && Object.hasOwnProperty.call(m, "billingAddress"))
                $root.contractpb.ContractProperty.encode(m.billingAddress, w.uint32(106).fork()).ldelim();
            if (m.ccDetails != null && Object.hasOwnProperty.call(m, "ccDetails"))
                $root.contractpb.PaymentDetailV2.CCDetails.encode(m.ccDetails, w.uint32(114).fork()).ldelim();
            if (m.achDetails != null && Object.hasOwnProperty.call(m, "achDetails"))
                $root.contractpb.PaymentDetailV2.ACHDetails.encode(m.achDetails, w.uint32(122).fork()).ldelim();
            return w;
        };

        /**
         * Decodes a PaymentDetailV2 message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.PaymentDetailV2
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.PaymentDetailV2} PaymentDetailV2
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PaymentDetailV2.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.PaymentDetailV2();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.paymentType = r.string();
                    break;
                case 2:
                    m.paymentTypeCode = r.string();
                    break;
                case 3:
                    m.sourceTypeCode = r.string();
                    break;
                case 4:
                    m.transactionState = r.string();
                    break;
                case 5:
                    m.transactionAmount = r.float();
                    break;
                case 6:
                    m.paymentProcessingDate = r.string();
                    break;
                case 7:
                    m.autoBillIndicator = r.string();
                    break;
                case 8:
                    m.paymentExtractedDate = r.string();
                    break;
                case 9:
                    m.resubmitIndicator = r.string();
                    break;
                case 10:
                    m.paymentMethodID = r.string();
                    break;
                case 11:
                    m.tokenFlag = r.string();
                    break;
                case 12:
                    m.billingAddressID = r.string();
                    break;
                case 13:
                    m.billingAddress = $root.contractpb.ContractProperty.decode(r, r.uint32());
                    break;
                case 14:
                    m.ccDetails = $root.contractpb.PaymentDetailV2.CCDetails.decode(r, r.uint32());
                    break;
                case 15:
                    m.achDetails = $root.contractpb.PaymentDetailV2.ACHDetails.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        PaymentDetailV2.CCDetails = (function() {

            /**
             * Properties of a CCDetails.
             * @memberof contractpb.PaymentDetailV2
             * @interface ICCDetails
             * @property {string|null} [ccNumber] CCDetails ccNumber
             * @property {string|null} [cardHolderFName] CCDetails cardHolderFName
             * @property {string|null} [cardHolderLName] CCDetails cardHolderLName
             * @property {string|null} [creditCardType] CCDetails creditCardType
             * @property {string|null} [ccExpDate] CCDetails ccExpDate
             */

            /**
             * Constructs a new CCDetails.
             * @memberof contractpb.PaymentDetailV2
             * @classdesc Represents a CCDetails.
             * @implements ICCDetails
             * @constructor
             * @param {contractpb.PaymentDetailV2.ICCDetails=} [p] Properties to set
             */
            function CCDetails(p) {
                if (p)
                    for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                        if (p[ks[i]] != null)
                            this[ks[i]] = p[ks[i]];
            }

            /**
             * CCDetails ccNumber.
             * @member {string} ccNumber
             * @memberof contractpb.PaymentDetailV2.CCDetails
             * @instance
             */
            CCDetails.prototype.ccNumber = "";

            /**
             * CCDetails cardHolderFName.
             * @member {string} cardHolderFName
             * @memberof contractpb.PaymentDetailV2.CCDetails
             * @instance
             */
            CCDetails.prototype.cardHolderFName = "";

            /**
             * CCDetails cardHolderLName.
             * @member {string} cardHolderLName
             * @memberof contractpb.PaymentDetailV2.CCDetails
             * @instance
             */
            CCDetails.prototype.cardHolderLName = "";

            /**
             * CCDetails creditCardType.
             * @member {string} creditCardType
             * @memberof contractpb.PaymentDetailV2.CCDetails
             * @instance
             */
            CCDetails.prototype.creditCardType = "";

            /**
             * CCDetails ccExpDate.
             * @member {string} ccExpDate
             * @memberof contractpb.PaymentDetailV2.CCDetails
             * @instance
             */
            CCDetails.prototype.ccExpDate = "";

            /**
             * Creates a new CCDetails instance using the specified properties.
             * @function create
             * @memberof contractpb.PaymentDetailV2.CCDetails
             * @static
             * @param {contractpb.PaymentDetailV2.ICCDetails=} [properties] Properties to set
             * @returns {contractpb.PaymentDetailV2.CCDetails} CCDetails instance
             */
            CCDetails.create = function create(properties) {
                return new CCDetails(properties);
            };

            /**
             * Encodes the specified CCDetails message. Does not implicitly {@link contractpb.PaymentDetailV2.CCDetails.verify|verify} messages.
             * @function encode
             * @memberof contractpb.PaymentDetailV2.CCDetails
             * @static
             * @param {contractpb.PaymentDetailV2.ICCDetails} m CCDetails message or plain object to encode
             * @param {$protobuf.Writer} [w] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            CCDetails.encode = function encode(m, w) {
                if (!w)
                    w = $Writer.create();
                if (m.ccNumber != null && Object.hasOwnProperty.call(m, "ccNumber"))
                    w.uint32(10).string(m.ccNumber);
                if (m.cardHolderFName != null && Object.hasOwnProperty.call(m, "cardHolderFName"))
                    w.uint32(18).string(m.cardHolderFName);
                if (m.cardHolderLName != null && Object.hasOwnProperty.call(m, "cardHolderLName"))
                    w.uint32(26).string(m.cardHolderLName);
                if (m.creditCardType != null && Object.hasOwnProperty.call(m, "creditCardType"))
                    w.uint32(34).string(m.creditCardType);
                if (m.ccExpDate != null && Object.hasOwnProperty.call(m, "ccExpDate"))
                    w.uint32(42).string(m.ccExpDate);
                return w;
            };

            /**
             * Decodes a CCDetails message from the specified reader or buffer.
             * @function decode
             * @memberof contractpb.PaymentDetailV2.CCDetails
             * @static
             * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
             * @param {number} [l] Message length if known beforehand
             * @returns {contractpb.PaymentDetailV2.CCDetails} CCDetails
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            CCDetails.decode = function decode(r, l) {
                if (!(r instanceof $Reader))
                    r = $Reader.create(r);
                var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.PaymentDetailV2.CCDetails();
                while (r.pos < c) {
                    var t = r.uint32();
                    switch (t >>> 3) {
                    case 1:
                        m.ccNumber = r.string();
                        break;
                    case 2:
                        m.cardHolderFName = r.string();
                        break;
                    case 3:
                        m.cardHolderLName = r.string();
                        break;
                    case 4:
                        m.creditCardType = r.string();
                        break;
                    case 5:
                        m.ccExpDate = r.string();
                        break;
                    default:
                        r.skipType(t & 7);
                        break;
                    }
                }
                return m;
            };

            return CCDetails;
        })();

        PaymentDetailV2.ACHDetails = (function() {

            /**
             * Properties of a ACHDetails.
             * @memberof contractpb.PaymentDetailV2
             * @interface IACHDetails
             * @property {string|null} [accountNumber] ACHDetails accountNumber
             * @property {string|null} [accountType] ACHDetails accountType
             * @property {string|null} [achSecCode] ACHDetails achSecCode
             * @property {string|null} [achHolderFName] ACHDetails achHolderFName
             * @property {string|null} [achHolderLName] ACHDetails achHolderLName
             * @property {string|null} [routingNumber] ACHDetails routingNumber
             */

            /**
             * Constructs a new ACHDetails.
             * @memberof contractpb.PaymentDetailV2
             * @classdesc Represents a ACHDetails.
             * @implements IACHDetails
             * @constructor
             * @param {contractpb.PaymentDetailV2.IACHDetails=} [p] Properties to set
             */
            function ACHDetails(p) {
                if (p)
                    for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                        if (p[ks[i]] != null)
                            this[ks[i]] = p[ks[i]];
            }

            /**
             * ACHDetails accountNumber.
             * @member {string} accountNumber
             * @memberof contractpb.PaymentDetailV2.ACHDetails
             * @instance
             */
            ACHDetails.prototype.accountNumber = "";

            /**
             * ACHDetails accountType.
             * @member {string} accountType
             * @memberof contractpb.PaymentDetailV2.ACHDetails
             * @instance
             */
            ACHDetails.prototype.accountType = "";

            /**
             * ACHDetails achSecCode.
             * @member {string} achSecCode
             * @memberof contractpb.PaymentDetailV2.ACHDetails
             * @instance
             */
            ACHDetails.prototype.achSecCode = "";

            /**
             * ACHDetails achHolderFName.
             * @member {string} achHolderFName
             * @memberof contractpb.PaymentDetailV2.ACHDetails
             * @instance
             */
            ACHDetails.prototype.achHolderFName = "";

            /**
             * ACHDetails achHolderLName.
             * @member {string} achHolderLName
             * @memberof contractpb.PaymentDetailV2.ACHDetails
             * @instance
             */
            ACHDetails.prototype.achHolderLName = "";

            /**
             * ACHDetails routingNumber.
             * @member {string} routingNumber
             * @memberof contractpb.PaymentDetailV2.ACHDetails
             * @instance
             */
            ACHDetails.prototype.routingNumber = "";

            /**
             * Creates a new ACHDetails instance using the specified properties.
             * @function create
             * @memberof contractpb.PaymentDetailV2.ACHDetails
             * @static
             * @param {contractpb.PaymentDetailV2.IACHDetails=} [properties] Properties to set
             * @returns {contractpb.PaymentDetailV2.ACHDetails} ACHDetails instance
             */
            ACHDetails.create = function create(properties) {
                return new ACHDetails(properties);
            };

            /**
             * Encodes the specified ACHDetails message. Does not implicitly {@link contractpb.PaymentDetailV2.ACHDetails.verify|verify} messages.
             * @function encode
             * @memberof contractpb.PaymentDetailV2.ACHDetails
             * @static
             * @param {contractpb.PaymentDetailV2.IACHDetails} m ACHDetails message or plain object to encode
             * @param {$protobuf.Writer} [w] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ACHDetails.encode = function encode(m, w) {
                if (!w)
                    w = $Writer.create();
                if (m.accountNumber != null && Object.hasOwnProperty.call(m, "accountNumber"))
                    w.uint32(10).string(m.accountNumber);
                if (m.accountType != null && Object.hasOwnProperty.call(m, "accountType"))
                    w.uint32(18).string(m.accountType);
                if (m.achSecCode != null && Object.hasOwnProperty.call(m, "achSecCode"))
                    w.uint32(26).string(m.achSecCode);
                if (m.achHolderFName != null && Object.hasOwnProperty.call(m, "achHolderFName"))
                    w.uint32(34).string(m.achHolderFName);
                if (m.achHolderLName != null && Object.hasOwnProperty.call(m, "achHolderLName"))
                    w.uint32(42).string(m.achHolderLName);
                if (m.routingNumber != null && Object.hasOwnProperty.call(m, "routingNumber"))
                    w.uint32(50).string(m.routingNumber);
                return w;
            };

            /**
             * Decodes a ACHDetails message from the specified reader or buffer.
             * @function decode
             * @memberof contractpb.PaymentDetailV2.ACHDetails
             * @static
             * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
             * @param {number} [l] Message length if known beforehand
             * @returns {contractpb.PaymentDetailV2.ACHDetails} ACHDetails
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ACHDetails.decode = function decode(r, l) {
                if (!(r instanceof $Reader))
                    r = $Reader.create(r);
                var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.PaymentDetailV2.ACHDetails();
                while (r.pos < c) {
                    var t = r.uint32();
                    switch (t >>> 3) {
                    case 1:
                        m.accountNumber = r.string();
                        break;
                    case 2:
                        m.accountType = r.string();
                        break;
                    case 3:
                        m.achSecCode = r.string();
                        break;
                    case 4:
                        m.achHolderFName = r.string();
                        break;
                    case 5:
                        m.achHolderLName = r.string();
                        break;
                    case 6:
                        m.routingNumber = r.string();
                        break;
                    default:
                        r.skipType(t & 7);
                        break;
                    }
                }
                return m;
            };

            return ACHDetails;
        })();

        return PaymentDetailV2;
    })();

    contractpb.InvoiceDayUpdateKafkaEvent = (function() {

        /**
         * Properties of an InvoiceDayUpdateKafkaEvent.
         * @memberof contractpb
         * @interface IInvoiceDayUpdateKafkaEvent
         * @property {string|null} [contractID] InvoiceDayUpdateKafkaEvent contractID
         * @property {number|null} [invoiceDay] InvoiceDayUpdateKafkaEvent invoiceDay
         * @property {common.Tenant|null} [tenantID] InvoiceDayUpdateKafkaEvent tenantID
         */

        /**
         * Constructs a new InvoiceDayUpdateKafkaEvent.
         * @memberof contractpb
         * @classdesc Represents an InvoiceDayUpdateKafkaEvent.
         * @implements IInvoiceDayUpdateKafkaEvent
         * @constructor
         * @param {contractpb.IInvoiceDayUpdateKafkaEvent=} [p] Properties to set
         */
        function InvoiceDayUpdateKafkaEvent(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * InvoiceDayUpdateKafkaEvent contractID.
         * @member {string} contractID
         * @memberof contractpb.InvoiceDayUpdateKafkaEvent
         * @instance
         */
        InvoiceDayUpdateKafkaEvent.prototype.contractID = "";

        /**
         * InvoiceDayUpdateKafkaEvent invoiceDay.
         * @member {number} invoiceDay
         * @memberof contractpb.InvoiceDayUpdateKafkaEvent
         * @instance
         */
        InvoiceDayUpdateKafkaEvent.prototype.invoiceDay = 0;

        /**
         * InvoiceDayUpdateKafkaEvent tenantID.
         * @member {common.Tenant} tenantID
         * @memberof contractpb.InvoiceDayUpdateKafkaEvent
         * @instance
         */
        InvoiceDayUpdateKafkaEvent.prototype.tenantID = 0;

        /**
         * Creates a new InvoiceDayUpdateKafkaEvent instance using the specified properties.
         * @function create
         * @memberof contractpb.InvoiceDayUpdateKafkaEvent
         * @static
         * @param {contractpb.IInvoiceDayUpdateKafkaEvent=} [properties] Properties to set
         * @returns {contractpb.InvoiceDayUpdateKafkaEvent} InvoiceDayUpdateKafkaEvent instance
         */
        InvoiceDayUpdateKafkaEvent.create = function create(properties) {
            return new InvoiceDayUpdateKafkaEvent(properties);
        };

        /**
         * Encodes the specified InvoiceDayUpdateKafkaEvent message. Does not implicitly {@link contractpb.InvoiceDayUpdateKafkaEvent.verify|verify} messages.
         * @function encode
         * @memberof contractpb.InvoiceDayUpdateKafkaEvent
         * @static
         * @param {contractpb.IInvoiceDayUpdateKafkaEvent} m InvoiceDayUpdateKafkaEvent message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        InvoiceDayUpdateKafkaEvent.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.contractID != null && Object.hasOwnProperty.call(m, "contractID"))
                w.uint32(10).string(m.contractID);
            if (m.invoiceDay != null && Object.hasOwnProperty.call(m, "invoiceDay"))
                w.uint32(16).int32(m.invoiceDay);
            if (m.tenantID != null && Object.hasOwnProperty.call(m, "tenantID"))
                w.uint32(24).int32(m.tenantID);
            return w;
        };

        /**
         * Decodes an InvoiceDayUpdateKafkaEvent message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.InvoiceDayUpdateKafkaEvent
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.InvoiceDayUpdateKafkaEvent} InvoiceDayUpdateKafkaEvent
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        InvoiceDayUpdateKafkaEvent.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.InvoiceDayUpdateKafkaEvent();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.contractID = r.string();
                    break;
                case 2:
                    m.invoiceDay = r.int32();
                    break;
                case 3:
                    m.tenantID = r.int32();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return InvoiceDayUpdateKafkaEvent;
    })();

    contractpb.UpdateCoverageKafkaEvent = (function() {

        /**
         * Properties of an UpdateCoverageKafkaEvent.
         * @memberof contractpb
         * @interface IUpdateCoverageKafkaEvent
         * @property {string|null} [contractID] UpdateCoverageKafkaEvent contractID
         * @property {string|null} [salesChannel] UpdateCoverageKafkaEvent salesChannel
         * @property {common.Tenant|null} [tenantID] UpdateCoverageKafkaEvent tenantID
         * @property {string|null} [updateTimeStamp] UpdateCoverageKafkaEvent updateTimeStamp
         * @property {boolean|null} [success] UpdateCoverageKafkaEvent success
         * @property {string|null} [failureReason] UpdateCoverageKafkaEvent failureReason
         * @property {string|null} [sourceApplication] UpdateCoverageKafkaEvent sourceApplication
         * @property {string|null} [quoteID] UpdateCoverageKafkaEvent quoteID
         * @property {string|null} [productType] UpdateCoverageKafkaEvent productType
         * @property {string|null} [orderID] UpdateCoverageKafkaEvent orderID
         * @property {string|null} [newContractID] UpdateCoverageKafkaEvent newContractID
         * @property {string|null} [buyerCustomerID] UpdateCoverageKafkaEvent buyerCustomerID
         * @property {string|null} [payerCustomerID] UpdateCoverageKafkaEvent payerCustomerID
         * @property {string|null} [effectiveDate] UpdateCoverageKafkaEvent effectiveDate
         * @property {boolean|null} [preProcessedData] UpdateCoverageKafkaEvent preProcessedData
         */

        /**
         * Constructs a new UpdateCoverageKafkaEvent.
         * @memberof contractpb
         * @classdesc Represents an UpdateCoverageKafkaEvent.
         * @implements IUpdateCoverageKafkaEvent
         * @constructor
         * @param {contractpb.IUpdateCoverageKafkaEvent=} [p] Properties to set
         */
        function UpdateCoverageKafkaEvent(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * UpdateCoverageKafkaEvent contractID.
         * @member {string} contractID
         * @memberof contractpb.UpdateCoverageKafkaEvent
         * @instance
         */
        UpdateCoverageKafkaEvent.prototype.contractID = "";

        /**
         * UpdateCoverageKafkaEvent salesChannel.
         * @member {string} salesChannel
         * @memberof contractpb.UpdateCoverageKafkaEvent
         * @instance
         */
        UpdateCoverageKafkaEvent.prototype.salesChannel = "";

        /**
         * UpdateCoverageKafkaEvent tenantID.
         * @member {common.Tenant} tenantID
         * @memberof contractpb.UpdateCoverageKafkaEvent
         * @instance
         */
        UpdateCoverageKafkaEvent.prototype.tenantID = 0;

        /**
         * UpdateCoverageKafkaEvent updateTimeStamp.
         * @member {string} updateTimeStamp
         * @memberof contractpb.UpdateCoverageKafkaEvent
         * @instance
         */
        UpdateCoverageKafkaEvent.prototype.updateTimeStamp = "";

        /**
         * UpdateCoverageKafkaEvent success.
         * @member {boolean} success
         * @memberof contractpb.UpdateCoverageKafkaEvent
         * @instance
         */
        UpdateCoverageKafkaEvent.prototype.success = false;

        /**
         * UpdateCoverageKafkaEvent failureReason.
         * @member {string} failureReason
         * @memberof contractpb.UpdateCoverageKafkaEvent
         * @instance
         */
        UpdateCoverageKafkaEvent.prototype.failureReason = "";

        /**
         * UpdateCoverageKafkaEvent sourceApplication.
         * @member {string} sourceApplication
         * @memberof contractpb.UpdateCoverageKafkaEvent
         * @instance
         */
        UpdateCoverageKafkaEvent.prototype.sourceApplication = "";

        /**
         * UpdateCoverageKafkaEvent quoteID.
         * @member {string} quoteID
         * @memberof contractpb.UpdateCoverageKafkaEvent
         * @instance
         */
        UpdateCoverageKafkaEvent.prototype.quoteID = "";

        /**
         * UpdateCoverageKafkaEvent productType.
         * @member {string} productType
         * @memberof contractpb.UpdateCoverageKafkaEvent
         * @instance
         */
        UpdateCoverageKafkaEvent.prototype.productType = "";

        /**
         * UpdateCoverageKafkaEvent orderID.
         * @member {string} orderID
         * @memberof contractpb.UpdateCoverageKafkaEvent
         * @instance
         */
        UpdateCoverageKafkaEvent.prototype.orderID = "";

        /**
         * UpdateCoverageKafkaEvent newContractID.
         * @member {string} newContractID
         * @memberof contractpb.UpdateCoverageKafkaEvent
         * @instance
         */
        UpdateCoverageKafkaEvent.prototype.newContractID = "";

        /**
         * UpdateCoverageKafkaEvent buyerCustomerID.
         * @member {string} buyerCustomerID
         * @memberof contractpb.UpdateCoverageKafkaEvent
         * @instance
         */
        UpdateCoverageKafkaEvent.prototype.buyerCustomerID = "";

        /**
         * UpdateCoverageKafkaEvent payerCustomerID.
         * @member {string} payerCustomerID
         * @memberof contractpb.UpdateCoverageKafkaEvent
         * @instance
         */
        UpdateCoverageKafkaEvent.prototype.payerCustomerID = "";

        /**
         * UpdateCoverageKafkaEvent effectiveDate.
         * @member {string} effectiveDate
         * @memberof contractpb.UpdateCoverageKafkaEvent
         * @instance
         */
        UpdateCoverageKafkaEvent.prototype.effectiveDate = "";

        /**
         * UpdateCoverageKafkaEvent preProcessedData.
         * @member {boolean} preProcessedData
         * @memberof contractpb.UpdateCoverageKafkaEvent
         * @instance
         */
        UpdateCoverageKafkaEvent.prototype.preProcessedData = false;

        /**
         * Creates a new UpdateCoverageKafkaEvent instance using the specified properties.
         * @function create
         * @memberof contractpb.UpdateCoverageKafkaEvent
         * @static
         * @param {contractpb.IUpdateCoverageKafkaEvent=} [properties] Properties to set
         * @returns {contractpb.UpdateCoverageKafkaEvent} UpdateCoverageKafkaEvent instance
         */
        UpdateCoverageKafkaEvent.create = function create(properties) {
            return new UpdateCoverageKafkaEvent(properties);
        };

        /**
         * Encodes the specified UpdateCoverageKafkaEvent message. Does not implicitly {@link contractpb.UpdateCoverageKafkaEvent.verify|verify} messages.
         * @function encode
         * @memberof contractpb.UpdateCoverageKafkaEvent
         * @static
         * @param {contractpb.IUpdateCoverageKafkaEvent} m UpdateCoverageKafkaEvent message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UpdateCoverageKafkaEvent.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.contractID != null && Object.hasOwnProperty.call(m, "contractID"))
                w.uint32(10).string(m.contractID);
            if (m.salesChannel != null && Object.hasOwnProperty.call(m, "salesChannel"))
                w.uint32(18).string(m.salesChannel);
            if (m.tenantID != null && Object.hasOwnProperty.call(m, "tenantID"))
                w.uint32(24).int32(m.tenantID);
            if (m.updateTimeStamp != null && Object.hasOwnProperty.call(m, "updateTimeStamp"))
                w.uint32(34).string(m.updateTimeStamp);
            if (m.success != null && Object.hasOwnProperty.call(m, "success"))
                w.uint32(40).bool(m.success);
            if (m.failureReason != null && Object.hasOwnProperty.call(m, "failureReason"))
                w.uint32(50).string(m.failureReason);
            if (m.sourceApplication != null && Object.hasOwnProperty.call(m, "sourceApplication"))
                w.uint32(58).string(m.sourceApplication);
            if (m.quoteID != null && Object.hasOwnProperty.call(m, "quoteID"))
                w.uint32(66).string(m.quoteID);
            if (m.productType != null && Object.hasOwnProperty.call(m, "productType"))
                w.uint32(74).string(m.productType);
            if (m.orderID != null && Object.hasOwnProperty.call(m, "orderID"))
                w.uint32(82).string(m.orderID);
            if (m.newContractID != null && Object.hasOwnProperty.call(m, "newContractID"))
                w.uint32(90).string(m.newContractID);
            if (m.buyerCustomerID != null && Object.hasOwnProperty.call(m, "buyerCustomerID"))
                w.uint32(98).string(m.buyerCustomerID);
            if (m.payerCustomerID != null && Object.hasOwnProperty.call(m, "payerCustomerID"))
                w.uint32(106).string(m.payerCustomerID);
            if (m.effectiveDate != null && Object.hasOwnProperty.call(m, "effectiveDate"))
                w.uint32(114).string(m.effectiveDate);
            if (m.preProcessedData != null && Object.hasOwnProperty.call(m, "preProcessedData"))
                w.uint32(120).bool(m.preProcessedData);
            return w;
        };

        /**
         * Decodes an UpdateCoverageKafkaEvent message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.UpdateCoverageKafkaEvent
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.UpdateCoverageKafkaEvent} UpdateCoverageKafkaEvent
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UpdateCoverageKafkaEvent.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.UpdateCoverageKafkaEvent();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.contractID = r.string();
                    break;
                case 2:
                    m.salesChannel = r.string();
                    break;
                case 3:
                    m.tenantID = r.int32();
                    break;
                case 4:
                    m.updateTimeStamp = r.string();
                    break;
                case 5:
                    m.success = r.bool();
                    break;
                case 6:
                    m.failureReason = r.string();
                    break;
                case 7:
                    m.sourceApplication = r.string();
                    break;
                case 8:
                    m.quoteID = r.string();
                    break;
                case 9:
                    m.productType = r.string();
                    break;
                case 10:
                    m.orderID = r.string();
                    break;
                case 11:
                    m.newContractID = r.string();
                    break;
                case 12:
                    m.buyerCustomerID = r.string();
                    break;
                case 13:
                    m.payerCustomerID = r.string();
                    break;
                case 14:
                    m.effectiveDate = r.string();
                    break;
                case 15:
                    m.preProcessedData = r.bool();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return UpdateCoverageKafkaEvent;
    })();

    contractpb.RequestMetaData = (function() {

        /**
         * Properties of a RequestMetaData.
         * @memberof contractpb
         * @interface IRequestMetaData
         * @property {string|null} [requestID] RequestMetaData requestID
         */

        /**
         * Constructs a new RequestMetaData.
         * @memberof contractpb
         * @classdesc Represents a RequestMetaData.
         * @implements IRequestMetaData
         * @constructor
         * @param {contractpb.IRequestMetaData=} [p] Properties to set
         */
        function RequestMetaData(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * RequestMetaData requestID.
         * @member {string} requestID
         * @memberof contractpb.RequestMetaData
         * @instance
         */
        RequestMetaData.prototype.requestID = "";

        /**
         * Creates a new RequestMetaData instance using the specified properties.
         * @function create
         * @memberof contractpb.RequestMetaData
         * @static
         * @param {contractpb.IRequestMetaData=} [properties] Properties to set
         * @returns {contractpb.RequestMetaData} RequestMetaData instance
         */
        RequestMetaData.create = function create(properties) {
            return new RequestMetaData(properties);
        };

        /**
         * Encodes the specified RequestMetaData message. Does not implicitly {@link contractpb.RequestMetaData.verify|verify} messages.
         * @function encode
         * @memberof contractpb.RequestMetaData
         * @static
         * @param {contractpb.IRequestMetaData} m RequestMetaData message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RequestMetaData.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.requestID != null && Object.hasOwnProperty.call(m, "requestID"))
                w.uint32(10).string(m.requestID);
            return w;
        };

        /**
         * Decodes a RequestMetaData message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.RequestMetaData
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.RequestMetaData} RequestMetaData
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RequestMetaData.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.RequestMetaData();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.requestID = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return RequestMetaData;
    })();

    contractpb.ContractCoverageRequest = (function() {

        /**
         * Properties of a ContractCoverageRequest.
         * @memberof contractpb
         * @interface IContractCoverageRequest
         * @property {string|null} [contractId] ContractCoverageRequest contractId
         */

        /**
         * Constructs a new ContractCoverageRequest.
         * @memberof contractpb
         * @classdesc GET /contract/v1/coverages request Object
         * @implements IContractCoverageRequest
         * @constructor
         * @param {contractpb.IContractCoverageRequest=} [p] Properties to set
         */
        function ContractCoverageRequest(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * ContractCoverageRequest contractId.
         * @member {string} contractId
         * @memberof contractpb.ContractCoverageRequest
         * @instance
         */
        ContractCoverageRequest.prototype.contractId = "";

        /**
         * Creates a new ContractCoverageRequest instance using the specified properties.
         * @function create
         * @memberof contractpb.ContractCoverageRequest
         * @static
         * @param {contractpb.IContractCoverageRequest=} [properties] Properties to set
         * @returns {contractpb.ContractCoverageRequest} ContractCoverageRequest instance
         */
        ContractCoverageRequest.create = function create(properties) {
            return new ContractCoverageRequest(properties);
        };

        /**
         * Encodes the specified ContractCoverageRequest message. Does not implicitly {@link contractpb.ContractCoverageRequest.verify|verify} messages.
         * @function encode
         * @memberof contractpb.ContractCoverageRequest
         * @static
         * @param {contractpb.IContractCoverageRequest} m ContractCoverageRequest message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ContractCoverageRequest.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.contractId != null && Object.hasOwnProperty.call(m, "contractId"))
                w.uint32(10).string(m.contractId);
            return w;
        };

        /**
         * Decodes a ContractCoverageRequest message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.ContractCoverageRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.ContractCoverageRequest} ContractCoverageRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ContractCoverageRequest.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.ContractCoverageRequest();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.contractId = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return ContractCoverageRequest;
    })();

    contractpb.UpdateContractStatusKafkaEvent = (function() {

        /**
         * Properties of an UpdateContractStatusKafkaEvent.
         * @memberof contractpb
         * @interface IUpdateContractStatusKafkaEvent
         * @property {common.Tenant|null} [tenantID] UpdateContractStatusKafkaEvent tenantID
         * @property {string|null} [contractId] UpdateContractStatusKafkaEvent contractId
         * @property {contractpb.ContractStatus|null} [previousStatus] UpdateContractStatusKafkaEvent previousStatus
         * @property {contractpb.ContractStatus|null} [newStatus] UpdateContractStatusKafkaEvent newStatus
         * @property {string|null} [productType] UpdateContractStatusKafkaEvent productType
         * @property {string|null} [salesChannel] UpdateContractStatusKafkaEvent salesChannel
         * @property {boolean|null} [success] UpdateContractStatusKafkaEvent success
         * @property {string|null} [failureReason] UpdateContractStatusKafkaEvent failureReason
         * @property {string|null} [orderID] UpdateContractStatusKafkaEvent orderID
         */

        /**
         * Constructs a new UpdateContractStatusKafkaEvent.
         * @memberof contractpb
         * @classdesc Represents an UpdateContractStatusKafkaEvent.
         * @implements IUpdateContractStatusKafkaEvent
         * @constructor
         * @param {contractpb.IUpdateContractStatusKafkaEvent=} [p] Properties to set
         */
        function UpdateContractStatusKafkaEvent(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * UpdateContractStatusKafkaEvent tenantID.
         * @member {common.Tenant} tenantID
         * @memberof contractpb.UpdateContractStatusKafkaEvent
         * @instance
         */
        UpdateContractStatusKafkaEvent.prototype.tenantID = 0;

        /**
         * UpdateContractStatusKafkaEvent contractId.
         * @member {string} contractId
         * @memberof contractpb.UpdateContractStatusKafkaEvent
         * @instance
         */
        UpdateContractStatusKafkaEvent.prototype.contractId = "";

        /**
         * UpdateContractStatusKafkaEvent previousStatus.
         * @member {contractpb.ContractStatus} previousStatus
         * @memberof contractpb.UpdateContractStatusKafkaEvent
         * @instance
         */
        UpdateContractStatusKafkaEvent.prototype.previousStatus = 0;

        /**
         * UpdateContractStatusKafkaEvent newStatus.
         * @member {contractpb.ContractStatus} newStatus
         * @memberof contractpb.UpdateContractStatusKafkaEvent
         * @instance
         */
        UpdateContractStatusKafkaEvent.prototype.newStatus = 0;

        /**
         * UpdateContractStatusKafkaEvent productType.
         * @member {string} productType
         * @memberof contractpb.UpdateContractStatusKafkaEvent
         * @instance
         */
        UpdateContractStatusKafkaEvent.prototype.productType = "";

        /**
         * UpdateContractStatusKafkaEvent salesChannel.
         * @member {string} salesChannel
         * @memberof contractpb.UpdateContractStatusKafkaEvent
         * @instance
         */
        UpdateContractStatusKafkaEvent.prototype.salesChannel = "";

        /**
         * UpdateContractStatusKafkaEvent success.
         * @member {boolean} success
         * @memberof contractpb.UpdateContractStatusKafkaEvent
         * @instance
         */
        UpdateContractStatusKafkaEvent.prototype.success = false;

        /**
         * UpdateContractStatusKafkaEvent failureReason.
         * @member {string} failureReason
         * @memberof contractpb.UpdateContractStatusKafkaEvent
         * @instance
         */
        UpdateContractStatusKafkaEvent.prototype.failureReason = "";

        /**
         * UpdateContractStatusKafkaEvent orderID.
         * @member {string} orderID
         * @memberof contractpb.UpdateContractStatusKafkaEvent
         * @instance
         */
        UpdateContractStatusKafkaEvent.prototype.orderID = "";

        /**
         * Creates a new UpdateContractStatusKafkaEvent instance using the specified properties.
         * @function create
         * @memberof contractpb.UpdateContractStatusKafkaEvent
         * @static
         * @param {contractpb.IUpdateContractStatusKafkaEvent=} [properties] Properties to set
         * @returns {contractpb.UpdateContractStatusKafkaEvent} UpdateContractStatusKafkaEvent instance
         */
        UpdateContractStatusKafkaEvent.create = function create(properties) {
            return new UpdateContractStatusKafkaEvent(properties);
        };

        /**
         * Encodes the specified UpdateContractStatusKafkaEvent message. Does not implicitly {@link contractpb.UpdateContractStatusKafkaEvent.verify|verify} messages.
         * @function encode
         * @memberof contractpb.UpdateContractStatusKafkaEvent
         * @static
         * @param {contractpb.IUpdateContractStatusKafkaEvent} m UpdateContractStatusKafkaEvent message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UpdateContractStatusKafkaEvent.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.tenantID != null && Object.hasOwnProperty.call(m, "tenantID"))
                w.uint32(8).int32(m.tenantID);
            if (m.contractId != null && Object.hasOwnProperty.call(m, "contractId"))
                w.uint32(18).string(m.contractId);
            if (m.previousStatus != null && Object.hasOwnProperty.call(m, "previousStatus"))
                w.uint32(24).int32(m.previousStatus);
            if (m.newStatus != null && Object.hasOwnProperty.call(m, "newStatus"))
                w.uint32(32).int32(m.newStatus);
            if (m.productType != null && Object.hasOwnProperty.call(m, "productType"))
                w.uint32(42).string(m.productType);
            if (m.salesChannel != null && Object.hasOwnProperty.call(m, "salesChannel"))
                w.uint32(50).string(m.salesChannel);
            if (m.success != null && Object.hasOwnProperty.call(m, "success"))
                w.uint32(56).bool(m.success);
            if (m.failureReason != null && Object.hasOwnProperty.call(m, "failureReason"))
                w.uint32(66).string(m.failureReason);
            if (m.orderID != null && Object.hasOwnProperty.call(m, "orderID"))
                w.uint32(74).string(m.orderID);
            return w;
        };

        /**
         * Decodes an UpdateContractStatusKafkaEvent message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.UpdateContractStatusKafkaEvent
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.UpdateContractStatusKafkaEvent} UpdateContractStatusKafkaEvent
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UpdateContractStatusKafkaEvent.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.UpdateContractStatusKafkaEvent();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.tenantID = r.int32();
                    break;
                case 2:
                    m.contractId = r.string();
                    break;
                case 3:
                    m.previousStatus = r.int32();
                    break;
                case 4:
                    m.newStatus = r.int32();
                    break;
                case 5:
                    m.productType = r.string();
                    break;
                case 6:
                    m.salesChannel = r.string();
                    break;
                case 7:
                    m.success = r.bool();
                    break;
                case 8:
                    m.failureReason = r.string();
                    break;
                case 9:
                    m.orderID = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return UpdateContractStatusKafkaEvent;
    })();

    contractpb.ContractStatusObject = (function() {

        /**
         * Properties of a ContractStatusObject.
         * @memberof contractpb
         * @interface IContractStatusObject
         * @property {common.Tenant|null} [tenantID] ContractStatusObject tenantID
         * @property {string|null} [contractId] ContractStatusObject contractId
         * @property {contractpb.ContractStatus|null} [status] ContractStatusObject status
         * @property {string|null} [ahsUserID] ContractStatusObject ahsUserID
         * @property {google.protobuf.ITimestamp|null} [holdDate] ContractStatusObject holdDate
         */

        /**
         * Constructs a new ContractStatusObject.
         * @memberof contractpb
         * @classdesc Represents a ContractStatusObject.
         * @implements IContractStatusObject
         * @constructor
         * @param {contractpb.IContractStatusObject=} [p] Properties to set
         */
        function ContractStatusObject(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * ContractStatusObject tenantID.
         * @member {common.Tenant} tenantID
         * @memberof contractpb.ContractStatusObject
         * @instance
         */
        ContractStatusObject.prototype.tenantID = 0;

        /**
         * ContractStatusObject contractId.
         * @member {string} contractId
         * @memberof contractpb.ContractStatusObject
         * @instance
         */
        ContractStatusObject.prototype.contractId = "";

        /**
         * ContractStatusObject status.
         * @member {contractpb.ContractStatus} status
         * @memberof contractpb.ContractStatusObject
         * @instance
         */
        ContractStatusObject.prototype.status = 0;

        /**
         * ContractStatusObject ahsUserID.
         * @member {string} ahsUserID
         * @memberof contractpb.ContractStatusObject
         * @instance
         */
        ContractStatusObject.prototype.ahsUserID = "";

        /**
         * ContractStatusObject holdDate.
         * @member {google.protobuf.ITimestamp|null|undefined} holdDate
         * @memberof contractpb.ContractStatusObject
         * @instance
         */
        ContractStatusObject.prototype.holdDate = null;

        /**
         * Creates a new ContractStatusObject instance using the specified properties.
         * @function create
         * @memberof contractpb.ContractStatusObject
         * @static
         * @param {contractpb.IContractStatusObject=} [properties] Properties to set
         * @returns {contractpb.ContractStatusObject} ContractStatusObject instance
         */
        ContractStatusObject.create = function create(properties) {
            return new ContractStatusObject(properties);
        };

        /**
         * Encodes the specified ContractStatusObject message. Does not implicitly {@link contractpb.ContractStatusObject.verify|verify} messages.
         * @function encode
         * @memberof contractpb.ContractStatusObject
         * @static
         * @param {contractpb.IContractStatusObject} m ContractStatusObject message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ContractStatusObject.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.tenantID != null && Object.hasOwnProperty.call(m, "tenantID"))
                w.uint32(8).int32(m.tenantID);
            if (m.contractId != null && Object.hasOwnProperty.call(m, "contractId"))
                w.uint32(18).string(m.contractId);
            if (m.status != null && Object.hasOwnProperty.call(m, "status"))
                w.uint32(24).int32(m.status);
            if (m.ahsUserID != null && Object.hasOwnProperty.call(m, "ahsUserID"))
                w.uint32(34).string(m.ahsUserID);
            if (m.holdDate != null && Object.hasOwnProperty.call(m, "holdDate"))
                $root.google.protobuf.Timestamp.encode(m.holdDate, w.uint32(42).fork()).ldelim();
            return w;
        };

        /**
         * Decodes a ContractStatusObject message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.ContractStatusObject
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.ContractStatusObject} ContractStatusObject
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ContractStatusObject.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.ContractStatusObject();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.tenantID = r.int32();
                    break;
                case 2:
                    m.contractId = r.string();
                    break;
                case 3:
                    m.status = r.int32();
                    break;
                case 4:
                    m.ahsUserID = r.string();
                    break;
                case 5:
                    m.holdDate = $root.google.protobuf.Timestamp.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return ContractStatusObject;
    })();

    contractpb.ContractStatusObjectList = (function() {

        /**
         * Properties of a ContractStatusObjectList.
         * @memberof contractpb
         * @interface IContractStatusObjectList
         * @property {Array.<contractpb.IContractStatusObject>|null} [contractStatuses] ContractStatusObjectList contractStatuses
         */

        /**
         * Constructs a new ContractStatusObjectList.
         * @memberof contractpb
         * @classdesc PATCH /contract/v1/updatestatus
         * Note: For now this API request Object will only cater the request of activating contracts
         * @implements IContractStatusObjectList
         * @constructor
         * @param {contractpb.IContractStatusObjectList=} [p] Properties to set
         */
        function ContractStatusObjectList(p) {
            this.contractStatuses = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * ContractStatusObjectList contractStatuses.
         * @member {Array.<contractpb.IContractStatusObject>} contractStatuses
         * @memberof contractpb.ContractStatusObjectList
         * @instance
         */
        ContractStatusObjectList.prototype.contractStatuses = $util.emptyArray;

        /**
         * Creates a new ContractStatusObjectList instance using the specified properties.
         * @function create
         * @memberof contractpb.ContractStatusObjectList
         * @static
         * @param {contractpb.IContractStatusObjectList=} [properties] Properties to set
         * @returns {contractpb.ContractStatusObjectList} ContractStatusObjectList instance
         */
        ContractStatusObjectList.create = function create(properties) {
            return new ContractStatusObjectList(properties);
        };

        /**
         * Encodes the specified ContractStatusObjectList message. Does not implicitly {@link contractpb.ContractStatusObjectList.verify|verify} messages.
         * @function encode
         * @memberof contractpb.ContractStatusObjectList
         * @static
         * @param {contractpb.IContractStatusObjectList} m ContractStatusObjectList message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ContractStatusObjectList.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.contractStatuses != null && m.contractStatuses.length) {
                for (var i = 0; i < m.contractStatuses.length; ++i)
                    $root.contractpb.ContractStatusObject.encode(m.contractStatuses[i], w.uint32(10).fork()).ldelim();
            }
            return w;
        };

        /**
         * Decodes a ContractStatusObjectList message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.ContractStatusObjectList
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.ContractStatusObjectList} ContractStatusObjectList
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ContractStatusObjectList.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.ContractStatusObjectList();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    if (!(m.contractStatuses && m.contractStatuses.length))
                        m.contractStatuses = [];
                    m.contractStatuses.push($root.contractpb.ContractStatusObject.decode(r, r.uint32()));
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return ContractStatusObjectList;
    })();

    contractpb.UpdateContractStatusRequest = (function() {

        /**
         * Properties of an UpdateContractStatusRequest.
         * @memberof contractpb
         * @interface IUpdateContractStatusRequest
         * @property {contractpb.IContractStatusObjectList|null} [contractStatusObjectList] UpdateContractStatusRequest contractStatusObjectList
         * @property {contractpb.IRequestMetaData|null} [reqMetaData] UpdateContractStatusRequest reqMetaData
         */

        /**
         * Constructs a new UpdateContractStatusRequest.
         * @memberof contractpb
         * @classdesc Represents an UpdateContractStatusRequest.
         * @implements IUpdateContractStatusRequest
         * @constructor
         * @param {contractpb.IUpdateContractStatusRequest=} [p] Properties to set
         */
        function UpdateContractStatusRequest(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * UpdateContractStatusRequest contractStatusObjectList.
         * @member {contractpb.IContractStatusObjectList|null|undefined} contractStatusObjectList
         * @memberof contractpb.UpdateContractStatusRequest
         * @instance
         */
        UpdateContractStatusRequest.prototype.contractStatusObjectList = null;

        /**
         * UpdateContractStatusRequest reqMetaData.
         * @member {contractpb.IRequestMetaData|null|undefined} reqMetaData
         * @memberof contractpb.UpdateContractStatusRequest
         * @instance
         */
        UpdateContractStatusRequest.prototype.reqMetaData = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        /**
         * UpdateContractStatusRequest updateStatusRequest.
         * @member {"contractStatusObjectList"|"reqMetaData"|undefined} updateStatusRequest
         * @memberof contractpb.UpdateContractStatusRequest
         * @instance
         */
        Object.defineProperty(UpdateContractStatusRequest.prototype, "updateStatusRequest", {
            get: $util.oneOfGetter($oneOfFields = ["contractStatusObjectList", "reqMetaData"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new UpdateContractStatusRequest instance using the specified properties.
         * @function create
         * @memberof contractpb.UpdateContractStatusRequest
         * @static
         * @param {contractpb.IUpdateContractStatusRequest=} [properties] Properties to set
         * @returns {contractpb.UpdateContractStatusRequest} UpdateContractStatusRequest instance
         */
        UpdateContractStatusRequest.create = function create(properties) {
            return new UpdateContractStatusRequest(properties);
        };

        /**
         * Encodes the specified UpdateContractStatusRequest message. Does not implicitly {@link contractpb.UpdateContractStatusRequest.verify|verify} messages.
         * @function encode
         * @memberof contractpb.UpdateContractStatusRequest
         * @static
         * @param {contractpb.IUpdateContractStatusRequest} m UpdateContractStatusRequest message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UpdateContractStatusRequest.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.contractStatusObjectList != null && Object.hasOwnProperty.call(m, "contractStatusObjectList"))
                $root.contractpb.ContractStatusObjectList.encode(m.contractStatusObjectList, w.uint32(10).fork()).ldelim();
            if (m.reqMetaData != null && Object.hasOwnProperty.call(m, "reqMetaData"))
                $root.contractpb.RequestMetaData.encode(m.reqMetaData, w.uint32(18).fork()).ldelim();
            return w;
        };

        /**
         * Decodes an UpdateContractStatusRequest message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.UpdateContractStatusRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.UpdateContractStatusRequest} UpdateContractStatusRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UpdateContractStatusRequest.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.UpdateContractStatusRequest();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.contractStatusObjectList = $root.contractpb.ContractStatusObjectList.decode(r, r.uint32());
                    break;
                case 2:
                    m.reqMetaData = $root.contractpb.RequestMetaData.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return UpdateContractStatusRequest;
    })();

    contractpb.UpdateContractStatusResponse = (function() {

        /**
         * Properties of an UpdateContractStatusResponse.
         * @memberof contractpb
         * @interface IUpdateContractStatusResponse
         * @property {Array.<common.IError>|null} [errors] UpdateContractStatusResponse errors
         */

        /**
         * Constructs a new UpdateContractStatusResponse.
         * @memberof contractpb
         * @classdesc Represents an UpdateContractStatusResponse.
         * @implements IUpdateContractStatusResponse
         * @constructor
         * @param {contractpb.IUpdateContractStatusResponse=} [p] Properties to set
         */
        function UpdateContractStatusResponse(p) {
            this.errors = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * UpdateContractStatusResponse errors.
         * @member {Array.<common.IError>} errors
         * @memberof contractpb.UpdateContractStatusResponse
         * @instance
         */
        UpdateContractStatusResponse.prototype.errors = $util.emptyArray;

        /**
         * Creates a new UpdateContractStatusResponse instance using the specified properties.
         * @function create
         * @memberof contractpb.UpdateContractStatusResponse
         * @static
         * @param {contractpb.IUpdateContractStatusResponse=} [properties] Properties to set
         * @returns {contractpb.UpdateContractStatusResponse} UpdateContractStatusResponse instance
         */
        UpdateContractStatusResponse.create = function create(properties) {
            return new UpdateContractStatusResponse(properties);
        };

        /**
         * Encodes the specified UpdateContractStatusResponse message. Does not implicitly {@link contractpb.UpdateContractStatusResponse.verify|verify} messages.
         * @function encode
         * @memberof contractpb.UpdateContractStatusResponse
         * @static
         * @param {contractpb.IUpdateContractStatusResponse} m UpdateContractStatusResponse message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UpdateContractStatusResponse.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.errors != null && m.errors.length) {
                for (var i = 0; i < m.errors.length; ++i)
                    $root.common.Error.encode(m.errors[i], w.uint32(10).fork()).ldelim();
            }
            return w;
        };

        /**
         * Decodes an UpdateContractStatusResponse message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.UpdateContractStatusResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.UpdateContractStatusResponse} UpdateContractStatusResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UpdateContractStatusResponse.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.UpdateContractStatusResponse();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    if (!(m.errors && m.errors.length))
                        m.errors = [];
                    m.errors.push($root.common.Error.decode(r, r.uint32()));
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return UpdateContractStatusResponse;
    })();

    contractpb.ContractDownloadResponseV2 = (function() {

        /**
         * Properties of a ContractDownloadResponseV2.
         * @memberof contractpb
         * @interface IContractDownloadResponseV2
         * @property {string|null} [downloadLink] ContractDownloadResponseV2 downloadLink
         * @property {string|null} [mostRecentB64EncodedFile] ContractDownloadResponseV2 mostRecentB64EncodedFile
         */

        /**
         * Constructs a new ContractDownloadResponseV2.
         * @memberof contractpb
         * @classdesc Represents a ContractDownloadResponseV2.
         * @implements IContractDownloadResponseV2
         * @constructor
         * @param {contractpb.IContractDownloadResponseV2=} [p] Properties to set
         */
        function ContractDownloadResponseV2(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * ContractDownloadResponseV2 downloadLink.
         * @member {string|null|undefined} downloadLink
         * @memberof contractpb.ContractDownloadResponseV2
         * @instance
         */
        ContractDownloadResponseV2.prototype.downloadLink = null;

        /**
         * ContractDownloadResponseV2 mostRecentB64EncodedFile.
         * @member {string|null|undefined} mostRecentB64EncodedFile
         * @memberof contractpb.ContractDownloadResponseV2
         * @instance
         */
        ContractDownloadResponseV2.prototype.mostRecentB64EncodedFile = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        /**
         * ContractDownloadResponseV2 documentResponse.
         * @member {"downloadLink"|"mostRecentB64EncodedFile"|undefined} documentResponse
         * @memberof contractpb.ContractDownloadResponseV2
         * @instance
         */
        Object.defineProperty(ContractDownloadResponseV2.prototype, "documentResponse", {
            get: $util.oneOfGetter($oneOfFields = ["downloadLink", "mostRecentB64EncodedFile"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new ContractDownloadResponseV2 instance using the specified properties.
         * @function create
         * @memberof contractpb.ContractDownloadResponseV2
         * @static
         * @param {contractpb.IContractDownloadResponseV2=} [properties] Properties to set
         * @returns {contractpb.ContractDownloadResponseV2} ContractDownloadResponseV2 instance
         */
        ContractDownloadResponseV2.create = function create(properties) {
            return new ContractDownloadResponseV2(properties);
        };

        /**
         * Encodes the specified ContractDownloadResponseV2 message. Does not implicitly {@link contractpb.ContractDownloadResponseV2.verify|verify} messages.
         * @function encode
         * @memberof contractpb.ContractDownloadResponseV2
         * @static
         * @param {contractpb.IContractDownloadResponseV2} m ContractDownloadResponseV2 message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ContractDownloadResponseV2.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.downloadLink != null && Object.hasOwnProperty.call(m, "downloadLink"))
                w.uint32(10).string(m.downloadLink);
            if (m.mostRecentB64EncodedFile != null && Object.hasOwnProperty.call(m, "mostRecentB64EncodedFile"))
                w.uint32(18).string(m.mostRecentB64EncodedFile);
            return w;
        };

        /**
         * Decodes a ContractDownloadResponseV2 message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.ContractDownloadResponseV2
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.ContractDownloadResponseV2} ContractDownloadResponseV2
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ContractDownloadResponseV2.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.ContractDownloadResponseV2();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.downloadLink = r.string();
                    break;
                case 2:
                    m.mostRecentB64EncodedFile = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return ContractDownloadResponseV2;
    })();

    contractpb.ContractDownloadRequestV2 = (function() {

        /**
         * Properties of a ContractDownloadRequestV2.
         * @memberof contractpb
         * @interface IContractDownloadRequestV2
         * @property {string|null} [contractID] ContractDownloadRequestV2 contractID
         */

        /**
         * Constructs a new ContractDownloadRequestV2.
         * @memberof contractpb
         * @classdesc Represents a ContractDownloadRequestV2.
         * @implements IContractDownloadRequestV2
         * @constructor
         * @param {contractpb.IContractDownloadRequestV2=} [p] Properties to set
         */
        function ContractDownloadRequestV2(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * ContractDownloadRequestV2 contractID.
         * @member {string} contractID
         * @memberof contractpb.ContractDownloadRequestV2
         * @instance
         */
        ContractDownloadRequestV2.prototype.contractID = "";

        /**
         * Creates a new ContractDownloadRequestV2 instance using the specified properties.
         * @function create
         * @memberof contractpb.ContractDownloadRequestV2
         * @static
         * @param {contractpb.IContractDownloadRequestV2=} [properties] Properties to set
         * @returns {contractpb.ContractDownloadRequestV2} ContractDownloadRequestV2 instance
         */
        ContractDownloadRequestV2.create = function create(properties) {
            return new ContractDownloadRequestV2(properties);
        };

        /**
         * Encodes the specified ContractDownloadRequestV2 message. Does not implicitly {@link contractpb.ContractDownloadRequestV2.verify|verify} messages.
         * @function encode
         * @memberof contractpb.ContractDownloadRequestV2
         * @static
         * @param {contractpb.IContractDownloadRequestV2} m ContractDownloadRequestV2 message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ContractDownloadRequestV2.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.contractID != null && Object.hasOwnProperty.call(m, "contractID"))
                w.uint32(10).string(m.contractID);
            return w;
        };

        /**
         * Decodes a ContractDownloadRequestV2 message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.ContractDownloadRequestV2
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.ContractDownloadRequestV2} ContractDownloadRequestV2
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ContractDownloadRequestV2.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.ContractDownloadRequestV2();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.contractID = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return ContractDownloadRequestV2;
    })();

    /**
     * RequestStatus enum.
     * @name contractpb.RequestStatus
     * @enum {number}
     * @property {number} UNDEFINED=0 UNDEFINED value
     * @property {number} PENDING=1 PENDING value
     * @property {number} SUCCEEDED=2 SUCCEEDED value
     * @property {number} ABORTED=3 ABORTED value
     * @property {number} SUCCEEDED_NOT_PUBLISHED=4 SUCCEEDED_NOT_PUBLISHED value
     * @property {number} ABORTED_NOT_PUBLISHED=5 ABORTED_NOT_PUBLISHED value
     * @property {number} FAILED=6 FAILED value
     * @property {number} REQUEST_NOT_ACCEPTED=7 REQUEST_NOT_ACCEPTED value
     * @property {number} INTERMEDIATE=8 INTERMEDIATE value
     * @property {number} PARTIAL_SUCCESS=9 PARTIAL_SUCCESS value
     * @property {number} UPDATE_COVERAGES_CANCEL_CONTRACT_FAILED=51 UPDATE_COVERAGES_CANCEL_CONTRACT_FAILED value
     * @property {number} UPDATE_COVERAGES_CANCEL_CONTRACT_COMMUNICATION_FAILED=52 UPDATE_COVERAGES_CANCEL_CONTRACT_COMMUNICATION_FAILED value
     * @property {number} UPDATE_COVERAGES_CREATE_CONTRACT_FAILED=53 UPDATE_COVERAGES_CREATE_CONTRACT_FAILED value
     * @property {number} UPDATE_COVERAGES_UPDATE_COVERAGES_FAILED=54 UPDATE_COVERAGES_UPDATE_COVERAGES_FAILED value
     * @property {number} UPDATE_STATUS_FAILED=101 UPDATE_STATUS_FAILED value
     * @property {number} UPDATE_STATUS_STAR_PENDING=102 UPDATE_STATUS_STAR_PENDING value
     * @property {number} UPDATE_STATUS_MONGO_PENDING=103 UPDATE_STATUS_MONGO_PENDING value
     * @property {number} UPDATE_STATUS_ES_PENDING=104 UPDATE_STATUS_ES_PENDING value
     * @property {number} UPDATE_STATUS_KAFKA_PENDING=105 UPDATE_STATUS_KAFKA_PENDING value
     * @property {number} CREATE_CONTRACT_DATA_INSERTION_FAILED=151 CREATE_CONTRACT_DATA_INSERTION_FAILED value
     * @property {number} CREATE_CONTRACT_PAYMENT_INSERTION_FAILED=152 CREATE_CONTRACT_PAYMENT_INSERTION_FAILED value
     * @property {number} CREATE_CONTRACT_NOTES_INSERTION_FAILED=153 CREATE_CONTRACT_NOTES_INSERTION_FAILED value
     * @property {number} CREATE_CONTRACT_MONGO_REMAINING_DATA_INSERTION_FAILED=154 CREATE_CONTRACT_MONGO_REMAINING_DATA_INSERTION_FAILED value
     * @property {number} CREATE_CONTRACT_ADD_CARD_FAILED=155 CREATE_CONTRACT_ADD_CARD_FAILED value
     * @property {number} CREATE_CONTRACT_POST_PAYMENT_BY_CARD_ID_FAILED=156 CREATE_CONTRACT_POST_PAYMENT_BY_CARD_ID_FAILED value
     * @property {number} UPDATE_DETAILS_KAFKA_PENDING=201 UPDATE_DETAILS_KAFKA_PENDING value
     * @property {number} UPDATE_DETAILS_MONGO_PENDING=202 UPDATE_DETAILS_MONGO_PENDING value
     * @property {number} UPDATE_DETAILS_ES_PENDING=203 UPDATE_DETAILS_ES_PENDING value
     * @property {number} UPSERT_DATES_MONGO_PENDING=204 UPSERT_DATES_MONGO_PENDING value
     * @property {number} UPSERT_DATES_ES_PENDING=205 UPSERT_DATES_ES_PENDING value
     * @property {number} UPSERT_DATES_SNOWFLAKE_PUBLISH_PENDING=206 UPSERT_DATES_SNOWFLAKE_PUBLISH_PENDING value
     */
    contractpb.RequestStatus = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "UNDEFINED"] = 0;
        values[valuesById[1] = "PENDING"] = 1;
        values[valuesById[2] = "SUCCEEDED"] = 2;
        values[valuesById[3] = "ABORTED"] = 3;
        values[valuesById[4] = "SUCCEEDED_NOT_PUBLISHED"] = 4;
        values[valuesById[5] = "ABORTED_NOT_PUBLISHED"] = 5;
        values[valuesById[6] = "FAILED"] = 6;
        values[valuesById[7] = "REQUEST_NOT_ACCEPTED"] = 7;
        values[valuesById[8] = "INTERMEDIATE"] = 8;
        values[valuesById[9] = "PARTIAL_SUCCESS"] = 9;
        values[valuesById[51] = "UPDATE_COVERAGES_CANCEL_CONTRACT_FAILED"] = 51;
        values[valuesById[52] = "UPDATE_COVERAGES_CANCEL_CONTRACT_COMMUNICATION_FAILED"] = 52;
        values[valuesById[53] = "UPDATE_COVERAGES_CREATE_CONTRACT_FAILED"] = 53;
        values[valuesById[54] = "UPDATE_COVERAGES_UPDATE_COVERAGES_FAILED"] = 54;
        values[valuesById[101] = "UPDATE_STATUS_FAILED"] = 101;
        values[valuesById[102] = "UPDATE_STATUS_STAR_PENDING"] = 102;
        values[valuesById[103] = "UPDATE_STATUS_MONGO_PENDING"] = 103;
        values[valuesById[104] = "UPDATE_STATUS_ES_PENDING"] = 104;
        values[valuesById[105] = "UPDATE_STATUS_KAFKA_PENDING"] = 105;
        values[valuesById[151] = "CREATE_CONTRACT_DATA_INSERTION_FAILED"] = 151;
        values[valuesById[152] = "CREATE_CONTRACT_PAYMENT_INSERTION_FAILED"] = 152;
        values[valuesById[153] = "CREATE_CONTRACT_NOTES_INSERTION_FAILED"] = 153;
        values[valuesById[154] = "CREATE_CONTRACT_MONGO_REMAINING_DATA_INSERTION_FAILED"] = 154;
        values[valuesById[155] = "CREATE_CONTRACT_ADD_CARD_FAILED"] = 155;
        values[valuesById[156] = "CREATE_CONTRACT_POST_PAYMENT_BY_CARD_ID_FAILED"] = 156;
        values[valuesById[201] = "UPDATE_DETAILS_KAFKA_PENDING"] = 201;
        values[valuesById[202] = "UPDATE_DETAILS_MONGO_PENDING"] = 202;
        values[valuesById[203] = "UPDATE_DETAILS_ES_PENDING"] = 203;
        values[valuesById[204] = "UPSERT_DATES_MONGO_PENDING"] = 204;
        values[valuesById[205] = "UPSERT_DATES_ES_PENDING"] = 205;
        values[valuesById[206] = "UPSERT_DATES_SNOWFLAKE_PUBLISH_PENDING"] = 206;
        return values;
    })();

    contractpb.AsyncReqObjectSearchFilter = (function() {

        /**
         * Properties of an AsyncReqObjectSearchFilter.
         * @memberof contractpb
         * @interface IAsyncReqObjectSearchFilter
         * @property {string|null} [requestType] AsyncReqObjectSearchFilter requestType
         * @property {string|null} [contractID] AsyncReqObjectSearchFilter contractID
         * @property {contractpb.RequestStatus|null} [status] AsyncReqObjectSearchFilter status
         */

        /**
         * Constructs a new AsyncReqObjectSearchFilter.
         * @memberof contractpb
         * @classdesc This filter will be applied by doing logical AND between all attributes values, Ignore if any attribute is not passed
         * @implements IAsyncReqObjectSearchFilter
         * @constructor
         * @param {contractpb.IAsyncReqObjectSearchFilter=} [p] Properties to set
         */
        function AsyncReqObjectSearchFilter(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * AsyncReqObjectSearchFilter requestType.
         * @member {string} requestType
         * @memberof contractpb.AsyncReqObjectSearchFilter
         * @instance
         */
        AsyncReqObjectSearchFilter.prototype.requestType = "";

        /**
         * AsyncReqObjectSearchFilter contractID.
         * @member {string} contractID
         * @memberof contractpb.AsyncReqObjectSearchFilter
         * @instance
         */
        AsyncReqObjectSearchFilter.prototype.contractID = "";

        /**
         * AsyncReqObjectSearchFilter status.
         * @member {contractpb.RequestStatus} status
         * @memberof contractpb.AsyncReqObjectSearchFilter
         * @instance
         */
        AsyncReqObjectSearchFilter.prototype.status = 0;

        /**
         * Creates a new AsyncReqObjectSearchFilter instance using the specified properties.
         * @function create
         * @memberof contractpb.AsyncReqObjectSearchFilter
         * @static
         * @param {contractpb.IAsyncReqObjectSearchFilter=} [properties] Properties to set
         * @returns {contractpb.AsyncReqObjectSearchFilter} AsyncReqObjectSearchFilter instance
         */
        AsyncReqObjectSearchFilter.create = function create(properties) {
            return new AsyncReqObjectSearchFilter(properties);
        };

        /**
         * Encodes the specified AsyncReqObjectSearchFilter message. Does not implicitly {@link contractpb.AsyncReqObjectSearchFilter.verify|verify} messages.
         * @function encode
         * @memberof contractpb.AsyncReqObjectSearchFilter
         * @static
         * @param {contractpb.IAsyncReqObjectSearchFilter} m AsyncReqObjectSearchFilter message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AsyncReqObjectSearchFilter.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.requestType != null && Object.hasOwnProperty.call(m, "requestType"))
                w.uint32(10).string(m.requestType);
            if (m.contractID != null && Object.hasOwnProperty.call(m, "contractID"))
                w.uint32(18).string(m.contractID);
            if (m.status != null && Object.hasOwnProperty.call(m, "status"))
                w.uint32(24).int32(m.status);
            return w;
        };

        /**
         * Decodes an AsyncReqObjectSearchFilter message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.AsyncReqObjectSearchFilter
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.AsyncReqObjectSearchFilter} AsyncReqObjectSearchFilter
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AsyncReqObjectSearchFilter.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.AsyncReqObjectSearchFilter();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.requestType = r.string();
                    break;
                case 2:
                    m.contractID = r.string();
                    break;
                case 3:
                    m.status = r.int32();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return AsyncReqObjectSearchFilter;
    })();

    contractpb.AsyncReqObjectRequestIDListFilter = (function() {

        /**
         * Properties of an AsyncReqObjectRequestIDListFilter.
         * @memberof contractpb
         * @interface IAsyncReqObjectRequestIDListFilter
         * @property {Array.<string>|null} [requestIDs] AsyncReqObjectRequestIDListFilter requestIDs
         */

        /**
         * Constructs a new AsyncReqObjectRequestIDListFilter.
         * @memberof contractpb
         * @classdesc Represents an AsyncReqObjectRequestIDListFilter.
         * @implements IAsyncReqObjectRequestIDListFilter
         * @constructor
         * @param {contractpb.IAsyncReqObjectRequestIDListFilter=} [p] Properties to set
         */
        function AsyncReqObjectRequestIDListFilter(p) {
            this.requestIDs = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * AsyncReqObjectRequestIDListFilter requestIDs.
         * @member {Array.<string>} requestIDs
         * @memberof contractpb.AsyncReqObjectRequestIDListFilter
         * @instance
         */
        AsyncReqObjectRequestIDListFilter.prototype.requestIDs = $util.emptyArray;

        /**
         * Creates a new AsyncReqObjectRequestIDListFilter instance using the specified properties.
         * @function create
         * @memberof contractpb.AsyncReqObjectRequestIDListFilter
         * @static
         * @param {contractpb.IAsyncReqObjectRequestIDListFilter=} [properties] Properties to set
         * @returns {contractpb.AsyncReqObjectRequestIDListFilter} AsyncReqObjectRequestIDListFilter instance
         */
        AsyncReqObjectRequestIDListFilter.create = function create(properties) {
            return new AsyncReqObjectRequestIDListFilter(properties);
        };

        /**
         * Encodes the specified AsyncReqObjectRequestIDListFilter message. Does not implicitly {@link contractpb.AsyncReqObjectRequestIDListFilter.verify|verify} messages.
         * @function encode
         * @memberof contractpb.AsyncReqObjectRequestIDListFilter
         * @static
         * @param {contractpb.IAsyncReqObjectRequestIDListFilter} m AsyncReqObjectRequestIDListFilter message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AsyncReqObjectRequestIDListFilter.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.requestIDs != null && m.requestIDs.length) {
                for (var i = 0; i < m.requestIDs.length; ++i)
                    w.uint32(10).string(m.requestIDs[i]);
            }
            return w;
        };

        /**
         * Decodes an AsyncReqObjectRequestIDListFilter message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.AsyncReqObjectRequestIDListFilter
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.AsyncReqObjectRequestIDListFilter} AsyncReqObjectRequestIDListFilter
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AsyncReqObjectRequestIDListFilter.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.AsyncReqObjectRequestIDListFilter();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    if (!(m.requestIDs && m.requestIDs.length))
                        m.requestIDs = [];
                    m.requestIDs.push(r.string());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return AsyncReqObjectRequestIDListFilter;
    })();

    contractpb.AsyncReqDetailsRequest = (function() {

        /**
         * Properties of an AsyncReqDetailsRequest.
         * @memberof contractpb
         * @interface IAsyncReqDetailsRequest
         * @property {contractpb.IAsyncReqObjectRequestIDListFilter|null} [requestIDList] AsyncReqDetailsRequest requestIDList
         * @property {contractpb.IAsyncReqObjectSearchFilter|null} [searchFilter] AsyncReqDetailsRequest searchFilter
         */

        /**
         * Constructs a new AsyncReqDetailsRequest.
         * @memberof contractpb
         * @classdesc Represents an AsyncReqDetailsRequest.
         * @implements IAsyncReqDetailsRequest
         * @constructor
         * @param {contractpb.IAsyncReqDetailsRequest=} [p] Properties to set
         */
        function AsyncReqDetailsRequest(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * AsyncReqDetailsRequest requestIDList.
         * @member {contractpb.IAsyncReqObjectRequestIDListFilter|null|undefined} requestIDList
         * @memberof contractpb.AsyncReqDetailsRequest
         * @instance
         */
        AsyncReqDetailsRequest.prototype.requestIDList = null;

        /**
         * AsyncReqDetailsRequest searchFilter.
         * @member {contractpb.IAsyncReqObjectSearchFilter|null|undefined} searchFilter
         * @memberof contractpb.AsyncReqDetailsRequest
         * @instance
         */
        AsyncReqDetailsRequest.prototype.searchFilter = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        /**
         * AsyncReqDetailsRequest asyncReqDetailsRequest.
         * @member {"requestIDList"|"searchFilter"|undefined} asyncReqDetailsRequest
         * @memberof contractpb.AsyncReqDetailsRequest
         * @instance
         */
        Object.defineProperty(AsyncReqDetailsRequest.prototype, "asyncReqDetailsRequest", {
            get: $util.oneOfGetter($oneOfFields = ["requestIDList", "searchFilter"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new AsyncReqDetailsRequest instance using the specified properties.
         * @function create
         * @memberof contractpb.AsyncReqDetailsRequest
         * @static
         * @param {contractpb.IAsyncReqDetailsRequest=} [properties] Properties to set
         * @returns {contractpb.AsyncReqDetailsRequest} AsyncReqDetailsRequest instance
         */
        AsyncReqDetailsRequest.create = function create(properties) {
            return new AsyncReqDetailsRequest(properties);
        };

        /**
         * Encodes the specified AsyncReqDetailsRequest message. Does not implicitly {@link contractpb.AsyncReqDetailsRequest.verify|verify} messages.
         * @function encode
         * @memberof contractpb.AsyncReqDetailsRequest
         * @static
         * @param {contractpb.IAsyncReqDetailsRequest} m AsyncReqDetailsRequest message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AsyncReqDetailsRequest.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.requestIDList != null && Object.hasOwnProperty.call(m, "requestIDList"))
                $root.contractpb.AsyncReqObjectRequestIDListFilter.encode(m.requestIDList, w.uint32(10).fork()).ldelim();
            if (m.searchFilter != null && Object.hasOwnProperty.call(m, "searchFilter"))
                $root.contractpb.AsyncReqObjectSearchFilter.encode(m.searchFilter, w.uint32(18).fork()).ldelim();
            return w;
        };

        /**
         * Decodes an AsyncReqDetailsRequest message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.AsyncReqDetailsRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.AsyncReqDetailsRequest} AsyncReqDetailsRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AsyncReqDetailsRequest.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.AsyncReqDetailsRequest();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.requestIDList = $root.contractpb.AsyncReqObjectRequestIDListFilter.decode(r, r.uint32());
                    break;
                case 2:
                    m.searchFilter = $root.contractpb.AsyncReqObjectSearchFilter.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return AsyncReqDetailsRequest;
    })();

    contractpb.AsyncReqDetails = (function() {

        /**
         * Properties of an AsyncReqDetails.
         * @memberof contractpb
         * @interface IAsyncReqDetails
         * @property {string|null} [requestID] AsyncReqDetails requestID
         * @property {string|null} [requestTimeStamp] AsyncReqDetails requestTimeStamp
         * @property {contractpb.RequestStatus|null} [status] AsyncReqDetails status
         * @property {string|null} [contractID] AsyncReqDetails contractID
         */

        /**
         * Constructs a new AsyncReqDetails.
         * @memberof contractpb
         * @classdesc Represents an AsyncReqDetails.
         * @implements IAsyncReqDetails
         * @constructor
         * @param {contractpb.IAsyncReqDetails=} [p] Properties to set
         */
        function AsyncReqDetails(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * AsyncReqDetails requestID.
         * @member {string} requestID
         * @memberof contractpb.AsyncReqDetails
         * @instance
         */
        AsyncReqDetails.prototype.requestID = "";

        /**
         * AsyncReqDetails requestTimeStamp.
         * @member {string} requestTimeStamp
         * @memberof contractpb.AsyncReqDetails
         * @instance
         */
        AsyncReqDetails.prototype.requestTimeStamp = "";

        /**
         * AsyncReqDetails status.
         * @member {contractpb.RequestStatus} status
         * @memberof contractpb.AsyncReqDetails
         * @instance
         */
        AsyncReqDetails.prototype.status = 0;

        /**
         * AsyncReqDetails contractID.
         * @member {string} contractID
         * @memberof contractpb.AsyncReqDetails
         * @instance
         */
        AsyncReqDetails.prototype.contractID = "";

        /**
         * Creates a new AsyncReqDetails instance using the specified properties.
         * @function create
         * @memberof contractpb.AsyncReqDetails
         * @static
         * @param {contractpb.IAsyncReqDetails=} [properties] Properties to set
         * @returns {contractpb.AsyncReqDetails} AsyncReqDetails instance
         */
        AsyncReqDetails.create = function create(properties) {
            return new AsyncReqDetails(properties);
        };

        /**
         * Encodes the specified AsyncReqDetails message. Does not implicitly {@link contractpb.AsyncReqDetails.verify|verify} messages.
         * @function encode
         * @memberof contractpb.AsyncReqDetails
         * @static
         * @param {contractpb.IAsyncReqDetails} m AsyncReqDetails message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AsyncReqDetails.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.requestID != null && Object.hasOwnProperty.call(m, "requestID"))
                w.uint32(10).string(m.requestID);
            if (m.requestTimeStamp != null && Object.hasOwnProperty.call(m, "requestTimeStamp"))
                w.uint32(18).string(m.requestTimeStamp);
            if (m.status != null && Object.hasOwnProperty.call(m, "status"))
                w.uint32(24).int32(m.status);
            if (m.contractID != null && Object.hasOwnProperty.call(m, "contractID"))
                w.uint32(34).string(m.contractID);
            return w;
        };

        /**
         * Decodes an AsyncReqDetails message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.AsyncReqDetails
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.AsyncReqDetails} AsyncReqDetails
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AsyncReqDetails.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.AsyncReqDetails();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.requestID = r.string();
                    break;
                case 2:
                    m.requestTimeStamp = r.string();
                    break;
                case 3:
                    m.status = r.int32();
                    break;
                case 4:
                    m.contractID = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return AsyncReqDetails;
    })();

    contractpb.AsyncReqDetailsResponseList = (function() {

        /**
         * Properties of an AsyncReqDetailsResponseList.
         * @memberof contractpb
         * @interface IAsyncReqDetailsResponseList
         * @property {Array.<contractpb.IAsyncReqDetails>|null} [asyncReqDetails] AsyncReqDetailsResponseList asyncReqDetails
         */

        /**
         * Constructs a new AsyncReqDetailsResponseList.
         * @memberof contractpb
         * @classdesc Represents an AsyncReqDetailsResponseList.
         * @implements IAsyncReqDetailsResponseList
         * @constructor
         * @param {contractpb.IAsyncReqDetailsResponseList=} [p] Properties to set
         */
        function AsyncReqDetailsResponseList(p) {
            this.asyncReqDetails = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * AsyncReqDetailsResponseList asyncReqDetails.
         * @member {Array.<contractpb.IAsyncReqDetails>} asyncReqDetails
         * @memberof contractpb.AsyncReqDetailsResponseList
         * @instance
         */
        AsyncReqDetailsResponseList.prototype.asyncReqDetails = $util.emptyArray;

        /**
         * Creates a new AsyncReqDetailsResponseList instance using the specified properties.
         * @function create
         * @memberof contractpb.AsyncReqDetailsResponseList
         * @static
         * @param {contractpb.IAsyncReqDetailsResponseList=} [properties] Properties to set
         * @returns {contractpb.AsyncReqDetailsResponseList} AsyncReqDetailsResponseList instance
         */
        AsyncReqDetailsResponseList.create = function create(properties) {
            return new AsyncReqDetailsResponseList(properties);
        };

        /**
         * Encodes the specified AsyncReqDetailsResponseList message. Does not implicitly {@link contractpb.AsyncReqDetailsResponseList.verify|verify} messages.
         * @function encode
         * @memberof contractpb.AsyncReqDetailsResponseList
         * @static
         * @param {contractpb.IAsyncReqDetailsResponseList} m AsyncReqDetailsResponseList message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AsyncReqDetailsResponseList.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.asyncReqDetails != null && m.asyncReqDetails.length) {
                for (var i = 0; i < m.asyncReqDetails.length; ++i)
                    $root.contractpb.AsyncReqDetails.encode(m.asyncReqDetails[i], w.uint32(10).fork()).ldelim();
            }
            return w;
        };

        /**
         * Decodes an AsyncReqDetailsResponseList message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.AsyncReqDetailsResponseList
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.AsyncReqDetailsResponseList} AsyncReqDetailsResponseList
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AsyncReqDetailsResponseList.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.AsyncReqDetailsResponseList();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    if (!(m.asyncReqDetails && m.asyncReqDetails.length))
                        m.asyncReqDetails = [];
                    m.asyncReqDetails.push($root.contractpb.AsyncReqDetails.decode(r, r.uint32()));
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return AsyncReqDetailsResponseList;
    })();

    contractpb.AsyncReqDetailsResponse = (function() {

        /**
         * Properties of an AsyncReqDetailsResponse.
         * @memberof contractpb
         * @interface IAsyncReqDetailsResponse
         * @property {contractpb.IAsyncReqDetailsResponseList|null} [asyncReqDetailsResponseList] AsyncReqDetailsResponse asyncReqDetailsResponseList
         * @property {common.IError|null} [error] AsyncReqDetailsResponse error
         */

        /**
         * Constructs a new AsyncReqDetailsResponse.
         * @memberof contractpb
         * @classdesc Represents an AsyncReqDetailsResponse.
         * @implements IAsyncReqDetailsResponse
         * @constructor
         * @param {contractpb.IAsyncReqDetailsResponse=} [p] Properties to set
         */
        function AsyncReqDetailsResponse(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * AsyncReqDetailsResponse asyncReqDetailsResponseList.
         * @member {contractpb.IAsyncReqDetailsResponseList|null|undefined} asyncReqDetailsResponseList
         * @memberof contractpb.AsyncReqDetailsResponse
         * @instance
         */
        AsyncReqDetailsResponse.prototype.asyncReqDetailsResponseList = null;

        /**
         * AsyncReqDetailsResponse error.
         * @member {common.IError|null|undefined} error
         * @memberof contractpb.AsyncReqDetailsResponse
         * @instance
         */
        AsyncReqDetailsResponse.prototype.error = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        /**
         * AsyncReqDetailsResponse asyncReqDetailsResponse.
         * @member {"asyncReqDetailsResponseList"|"error"|undefined} asyncReqDetailsResponse
         * @memberof contractpb.AsyncReqDetailsResponse
         * @instance
         */
        Object.defineProperty(AsyncReqDetailsResponse.prototype, "asyncReqDetailsResponse", {
            get: $util.oneOfGetter($oneOfFields = ["asyncReqDetailsResponseList", "error"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new AsyncReqDetailsResponse instance using the specified properties.
         * @function create
         * @memberof contractpb.AsyncReqDetailsResponse
         * @static
         * @param {contractpb.IAsyncReqDetailsResponse=} [properties] Properties to set
         * @returns {contractpb.AsyncReqDetailsResponse} AsyncReqDetailsResponse instance
         */
        AsyncReqDetailsResponse.create = function create(properties) {
            return new AsyncReqDetailsResponse(properties);
        };

        /**
         * Encodes the specified AsyncReqDetailsResponse message. Does not implicitly {@link contractpb.AsyncReqDetailsResponse.verify|verify} messages.
         * @function encode
         * @memberof contractpb.AsyncReqDetailsResponse
         * @static
         * @param {contractpb.IAsyncReqDetailsResponse} m AsyncReqDetailsResponse message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AsyncReqDetailsResponse.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.asyncReqDetailsResponseList != null && Object.hasOwnProperty.call(m, "asyncReqDetailsResponseList"))
                $root.contractpb.AsyncReqDetailsResponseList.encode(m.asyncReqDetailsResponseList, w.uint32(10).fork()).ldelim();
            if (m.error != null && Object.hasOwnProperty.call(m, "error"))
                $root.common.Error.encode(m.error, w.uint32(18).fork()).ldelim();
            return w;
        };

        /**
         * Decodes an AsyncReqDetailsResponse message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.AsyncReqDetailsResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.AsyncReqDetailsResponse} AsyncReqDetailsResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AsyncReqDetailsResponse.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.AsyncReqDetailsResponse();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.asyncReqDetailsResponseList = $root.contractpb.AsyncReqDetailsResponseList.decode(r, r.uint32());
                    break;
                case 2:
                    m.error = $root.common.Error.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return AsyncReqDetailsResponse;
    })();

    contractpb.ModifiableAsyncReqDetails = (function() {

        /**
         * Properties of a ModifiableAsyncReqDetails.
         * @memberof contractpb
         * @interface IModifiableAsyncReqDetails
         * @property {string|null} [status] ModifiableAsyncReqDetails status
         * @property {string|null} [failureCount] ModifiableAsyncReqDetails failureCount
         * @property {string|null} [asyncRequestInterimData] ModifiableAsyncReqDetails asyncRequestInterimData
         * @property {string|null} [asyncRequestData] ModifiableAsyncReqDetails asyncRequestData
         * @property {google.protobuf.ITimestamp|null} [requestDateToProcess] ModifiableAsyncReqDetails requestDateToProcess
         * @property {string|null} [requestName] ModifiableAsyncReqDetails requestName
         */

        /**
         * Constructs a new ModifiableAsyncReqDetails.
         * @memberof contractpb
         * @classdesc Represents a ModifiableAsyncReqDetails.
         * @implements IModifiableAsyncReqDetails
         * @constructor
         * @param {contractpb.IModifiableAsyncReqDetails=} [p] Properties to set
         */
        function ModifiableAsyncReqDetails(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * ModifiableAsyncReqDetails status.
         * @member {string} status
         * @memberof contractpb.ModifiableAsyncReqDetails
         * @instance
         */
        ModifiableAsyncReqDetails.prototype.status = "";

        /**
         * ModifiableAsyncReqDetails failureCount.
         * @member {string} failureCount
         * @memberof contractpb.ModifiableAsyncReqDetails
         * @instance
         */
        ModifiableAsyncReqDetails.prototype.failureCount = "";

        /**
         * ModifiableAsyncReqDetails asyncRequestInterimData.
         * @member {string} asyncRequestInterimData
         * @memberof contractpb.ModifiableAsyncReqDetails
         * @instance
         */
        ModifiableAsyncReqDetails.prototype.asyncRequestInterimData = "";

        /**
         * ModifiableAsyncReqDetails asyncRequestData.
         * @member {string} asyncRequestData
         * @memberof contractpb.ModifiableAsyncReqDetails
         * @instance
         */
        ModifiableAsyncReqDetails.prototype.asyncRequestData = "";

        /**
         * ModifiableAsyncReqDetails requestDateToProcess.
         * @member {google.protobuf.ITimestamp|null|undefined} requestDateToProcess
         * @memberof contractpb.ModifiableAsyncReqDetails
         * @instance
         */
        ModifiableAsyncReqDetails.prototype.requestDateToProcess = null;

        /**
         * ModifiableAsyncReqDetails requestName.
         * @member {string} requestName
         * @memberof contractpb.ModifiableAsyncReqDetails
         * @instance
         */
        ModifiableAsyncReqDetails.prototype.requestName = "";

        /**
         * Creates a new ModifiableAsyncReqDetails instance using the specified properties.
         * @function create
         * @memberof contractpb.ModifiableAsyncReqDetails
         * @static
         * @param {contractpb.IModifiableAsyncReqDetails=} [properties] Properties to set
         * @returns {contractpb.ModifiableAsyncReqDetails} ModifiableAsyncReqDetails instance
         */
        ModifiableAsyncReqDetails.create = function create(properties) {
            return new ModifiableAsyncReqDetails(properties);
        };

        /**
         * Encodes the specified ModifiableAsyncReqDetails message. Does not implicitly {@link contractpb.ModifiableAsyncReqDetails.verify|verify} messages.
         * @function encode
         * @memberof contractpb.ModifiableAsyncReqDetails
         * @static
         * @param {contractpb.IModifiableAsyncReqDetails} m ModifiableAsyncReqDetails message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ModifiableAsyncReqDetails.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.status != null && Object.hasOwnProperty.call(m, "status"))
                w.uint32(10).string(m.status);
            if (m.failureCount != null && Object.hasOwnProperty.call(m, "failureCount"))
                w.uint32(18).string(m.failureCount);
            if (m.asyncRequestInterimData != null && Object.hasOwnProperty.call(m, "asyncRequestInterimData"))
                w.uint32(26).string(m.asyncRequestInterimData);
            if (m.asyncRequestData != null && Object.hasOwnProperty.call(m, "asyncRequestData"))
                w.uint32(34).string(m.asyncRequestData);
            if (m.requestDateToProcess != null && Object.hasOwnProperty.call(m, "requestDateToProcess"))
                $root.google.protobuf.Timestamp.encode(m.requestDateToProcess, w.uint32(42).fork()).ldelim();
            if (m.requestName != null && Object.hasOwnProperty.call(m, "requestName"))
                w.uint32(50).string(m.requestName);
            return w;
        };

        /**
         * Decodes a ModifiableAsyncReqDetails message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.ModifiableAsyncReqDetails
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.ModifiableAsyncReqDetails} ModifiableAsyncReqDetails
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ModifiableAsyncReqDetails.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.ModifiableAsyncReqDetails();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.status = r.string();
                    break;
                case 2:
                    m.failureCount = r.string();
                    break;
                case 3:
                    m.asyncRequestInterimData = r.string();
                    break;
                case 4:
                    m.asyncRequestData = r.string();
                    break;
                case 5:
                    m.requestDateToProcess = $root.google.protobuf.Timestamp.decode(r, r.uint32());
                    break;
                case 6:
                    m.requestName = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return ModifiableAsyncReqDetails;
    })();

    contractpb.AsyncReqProcessorUpdateRequest = (function() {

        /**
         * Properties of an AsyncReqProcessorUpdateRequest.
         * @memberof contractpb
         * @interface IAsyncReqProcessorUpdateRequest
         * @property {string|null} [requestID] AsyncReqProcessorUpdateRequest requestID
         * @property {contractpb.IModifiableAsyncReqDetails|null} [newDetails] AsyncReqProcessorUpdateRequest newDetails
         */

        /**
         * Constructs a new AsyncReqProcessorUpdateRequest.
         * @memberof contractpb
         * @classdesc Represents an AsyncReqProcessorUpdateRequest.
         * @implements IAsyncReqProcessorUpdateRequest
         * @constructor
         * @param {contractpb.IAsyncReqProcessorUpdateRequest=} [p] Properties to set
         */
        function AsyncReqProcessorUpdateRequest(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * AsyncReqProcessorUpdateRequest requestID.
         * @member {string} requestID
         * @memberof contractpb.AsyncReqProcessorUpdateRequest
         * @instance
         */
        AsyncReqProcessorUpdateRequest.prototype.requestID = "";

        /**
         * AsyncReqProcessorUpdateRequest newDetails.
         * @member {contractpb.IModifiableAsyncReqDetails|null|undefined} newDetails
         * @memberof contractpb.AsyncReqProcessorUpdateRequest
         * @instance
         */
        AsyncReqProcessorUpdateRequest.prototype.newDetails = null;

        /**
         * Creates a new AsyncReqProcessorUpdateRequest instance using the specified properties.
         * @function create
         * @memberof contractpb.AsyncReqProcessorUpdateRequest
         * @static
         * @param {contractpb.IAsyncReqProcessorUpdateRequest=} [properties] Properties to set
         * @returns {contractpb.AsyncReqProcessorUpdateRequest} AsyncReqProcessorUpdateRequest instance
         */
        AsyncReqProcessorUpdateRequest.create = function create(properties) {
            return new AsyncReqProcessorUpdateRequest(properties);
        };

        /**
         * Encodes the specified AsyncReqProcessorUpdateRequest message. Does not implicitly {@link contractpb.AsyncReqProcessorUpdateRequest.verify|verify} messages.
         * @function encode
         * @memberof contractpb.AsyncReqProcessorUpdateRequest
         * @static
         * @param {contractpb.IAsyncReqProcessorUpdateRequest} m AsyncReqProcessorUpdateRequest message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AsyncReqProcessorUpdateRequest.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.requestID != null && Object.hasOwnProperty.call(m, "requestID"))
                w.uint32(10).string(m.requestID);
            if (m.newDetails != null && Object.hasOwnProperty.call(m, "newDetails"))
                $root.contractpb.ModifiableAsyncReqDetails.encode(m.newDetails, w.uint32(18).fork()).ldelim();
            return w;
        };

        /**
         * Decodes an AsyncReqProcessorUpdateRequest message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.AsyncReqProcessorUpdateRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.AsyncReqProcessorUpdateRequest} AsyncReqProcessorUpdateRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AsyncReqProcessorUpdateRequest.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.AsyncReqProcessorUpdateRequest();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.requestID = r.string();
                    break;
                case 2:
                    m.newDetails = $root.contractpb.ModifiableAsyncReqDetails.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return AsyncReqProcessorUpdateRequest;
    })();

    contractpb.AsyncReqProcessorUpdateResponse = (function() {

        /**
         * Properties of an AsyncReqProcessorUpdateResponse.
         * @memberof contractpb
         * @interface IAsyncReqProcessorUpdateResponse
         * @property {common.IError|null} [error] AsyncReqProcessorUpdateResponse error
         */

        /**
         * Constructs a new AsyncReqProcessorUpdateResponse.
         * @memberof contractpb
         * @classdesc Represents an AsyncReqProcessorUpdateResponse.
         * @implements IAsyncReqProcessorUpdateResponse
         * @constructor
         * @param {contractpb.IAsyncReqProcessorUpdateResponse=} [p] Properties to set
         */
        function AsyncReqProcessorUpdateResponse(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * AsyncReqProcessorUpdateResponse error.
         * @member {common.IError|null|undefined} error
         * @memberof contractpb.AsyncReqProcessorUpdateResponse
         * @instance
         */
        AsyncReqProcessorUpdateResponse.prototype.error = null;

        /**
         * Creates a new AsyncReqProcessorUpdateResponse instance using the specified properties.
         * @function create
         * @memberof contractpb.AsyncReqProcessorUpdateResponse
         * @static
         * @param {contractpb.IAsyncReqProcessorUpdateResponse=} [properties] Properties to set
         * @returns {contractpb.AsyncReqProcessorUpdateResponse} AsyncReqProcessorUpdateResponse instance
         */
        AsyncReqProcessorUpdateResponse.create = function create(properties) {
            return new AsyncReqProcessorUpdateResponse(properties);
        };

        /**
         * Encodes the specified AsyncReqProcessorUpdateResponse message. Does not implicitly {@link contractpb.AsyncReqProcessorUpdateResponse.verify|verify} messages.
         * @function encode
         * @memberof contractpb.AsyncReqProcessorUpdateResponse
         * @static
         * @param {contractpb.IAsyncReqProcessorUpdateResponse} m AsyncReqProcessorUpdateResponse message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AsyncReqProcessorUpdateResponse.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.error != null && Object.hasOwnProperty.call(m, "error"))
                $root.common.Error.encode(m.error, w.uint32(10).fork()).ldelim();
            return w;
        };

        /**
         * Decodes an AsyncReqProcessorUpdateResponse message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.AsyncReqProcessorUpdateResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.AsyncReqProcessorUpdateResponse} AsyncReqProcessorUpdateResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AsyncReqProcessorUpdateResponse.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.AsyncReqProcessorUpdateResponse();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.error = $root.common.Error.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return AsyncReqProcessorUpdateResponse;
    })();

    contractpb.GetContractsOnPvIDReq = (function() {

        /**
         * Properties of a GetContractsOnPvIDReq.
         * @memberof contractpb
         * @interface IGetContractsOnPvIDReq
         * @property {string|null} [pvID] GetContractsOnPvIDReq pvID
         */

        /**
         * Constructs a new GetContractsOnPvIDReq.
         * @memberof contractpb
         * @classdesc Represents a GetContractsOnPvIDReq.
         * @implements IGetContractsOnPvIDReq
         * @constructor
         * @param {contractpb.IGetContractsOnPvIDReq=} [p] Properties to set
         */
        function GetContractsOnPvIDReq(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * GetContractsOnPvIDReq pvID.
         * @member {string} pvID
         * @memberof contractpb.GetContractsOnPvIDReq
         * @instance
         */
        GetContractsOnPvIDReq.prototype.pvID = "";

        /**
         * Creates a new GetContractsOnPvIDReq instance using the specified properties.
         * @function create
         * @memberof contractpb.GetContractsOnPvIDReq
         * @static
         * @param {contractpb.IGetContractsOnPvIDReq=} [properties] Properties to set
         * @returns {contractpb.GetContractsOnPvIDReq} GetContractsOnPvIDReq instance
         */
        GetContractsOnPvIDReq.create = function create(properties) {
            return new GetContractsOnPvIDReq(properties);
        };

        /**
         * Encodes the specified GetContractsOnPvIDReq message. Does not implicitly {@link contractpb.GetContractsOnPvIDReq.verify|verify} messages.
         * @function encode
         * @memberof contractpb.GetContractsOnPvIDReq
         * @static
         * @param {contractpb.IGetContractsOnPvIDReq} m GetContractsOnPvIDReq message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetContractsOnPvIDReq.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.pvID != null && Object.hasOwnProperty.call(m, "pvID"))
                w.uint32(10).string(m.pvID);
            return w;
        };

        /**
         * Decodes a GetContractsOnPvIDReq message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.GetContractsOnPvIDReq
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.GetContractsOnPvIDReq} GetContractsOnPvIDReq
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetContractsOnPvIDReq.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.GetContractsOnPvIDReq();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.pvID = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return GetContractsOnPvIDReq;
    })();

    contractpb.GetContractsOnPvIDResponse = (function() {

        /**
         * Properties of a GetContractsOnPvIDResponse.
         * @memberof contractpb
         * @interface IGetContractsOnPvIDResponse
         * @property {google.protobuf.IBoolValue|null} [found] GetContractsOnPvIDResponse found
         * @property {common.IError|null} [error] GetContractsOnPvIDResponse error
         */

        /**
         * Constructs a new GetContractsOnPvIDResponse.
         * @memberof contractpb
         * @classdesc Represents a GetContractsOnPvIDResponse.
         * @implements IGetContractsOnPvIDResponse
         * @constructor
         * @param {contractpb.IGetContractsOnPvIDResponse=} [p] Properties to set
         */
        function GetContractsOnPvIDResponse(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * GetContractsOnPvIDResponse found.
         * @member {google.protobuf.IBoolValue|null|undefined} found
         * @memberof contractpb.GetContractsOnPvIDResponse
         * @instance
         */
        GetContractsOnPvIDResponse.prototype.found = null;

        /**
         * GetContractsOnPvIDResponse error.
         * @member {common.IError|null|undefined} error
         * @memberof contractpb.GetContractsOnPvIDResponse
         * @instance
         */
        GetContractsOnPvIDResponse.prototype.error = null;

        /**
         * Creates a new GetContractsOnPvIDResponse instance using the specified properties.
         * @function create
         * @memberof contractpb.GetContractsOnPvIDResponse
         * @static
         * @param {contractpb.IGetContractsOnPvIDResponse=} [properties] Properties to set
         * @returns {contractpb.GetContractsOnPvIDResponse} GetContractsOnPvIDResponse instance
         */
        GetContractsOnPvIDResponse.create = function create(properties) {
            return new GetContractsOnPvIDResponse(properties);
        };

        /**
         * Encodes the specified GetContractsOnPvIDResponse message. Does not implicitly {@link contractpb.GetContractsOnPvIDResponse.verify|verify} messages.
         * @function encode
         * @memberof contractpb.GetContractsOnPvIDResponse
         * @static
         * @param {contractpb.IGetContractsOnPvIDResponse} m GetContractsOnPvIDResponse message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetContractsOnPvIDResponse.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.found != null && Object.hasOwnProperty.call(m, "found"))
                $root.google.protobuf.BoolValue.encode(m.found, w.uint32(10).fork()).ldelim();
            if (m.error != null && Object.hasOwnProperty.call(m, "error"))
                $root.common.Error.encode(m.error, w.uint32(18).fork()).ldelim();
            return w;
        };

        /**
         * Decodes a GetContractsOnPvIDResponse message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.GetContractsOnPvIDResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.GetContractsOnPvIDResponse} GetContractsOnPvIDResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetContractsOnPvIDResponse.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.GetContractsOnPvIDResponse();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.found = $root.google.protobuf.BoolValue.decode(r, r.uint32());
                    break;
                case 2:
                    m.error = $root.common.Error.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return GetContractsOnPvIDResponse;
    })();

    contractpb.ExistingCustomerContractsRequestV2 = (function() {

        /**
         * Properties of an ExistingCustomerContractsRequestV2.
         * @memberof contractpb
         * @interface IExistingCustomerContractsRequestV2
         * @property {string|null} [email] ExistingCustomerContractsRequestV2 email
         * @property {string|null} [addressID] ExistingCustomerContractsRequestV2 addressID
         */

        /**
         * Constructs a new ExistingCustomerContractsRequestV2.
         * @memberof contractpb
         * @classdesc GET /contract/v2/existing-customer-contracts
         * @implements IExistingCustomerContractsRequestV2
         * @constructor
         * @param {contractpb.IExistingCustomerContractsRequestV2=} [p] Properties to set
         */
        function ExistingCustomerContractsRequestV2(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * ExistingCustomerContractsRequestV2 email.
         * @member {string} email
         * @memberof contractpb.ExistingCustomerContractsRequestV2
         * @instance
         */
        ExistingCustomerContractsRequestV2.prototype.email = "";

        /**
         * ExistingCustomerContractsRequestV2 addressID.
         * @member {string} addressID
         * @memberof contractpb.ExistingCustomerContractsRequestV2
         * @instance
         */
        ExistingCustomerContractsRequestV2.prototype.addressID = "";

        /**
         * Creates a new ExistingCustomerContractsRequestV2 instance using the specified properties.
         * @function create
         * @memberof contractpb.ExistingCustomerContractsRequestV2
         * @static
         * @param {contractpb.IExistingCustomerContractsRequestV2=} [properties] Properties to set
         * @returns {contractpb.ExistingCustomerContractsRequestV2} ExistingCustomerContractsRequestV2 instance
         */
        ExistingCustomerContractsRequestV2.create = function create(properties) {
            return new ExistingCustomerContractsRequestV2(properties);
        };

        /**
         * Encodes the specified ExistingCustomerContractsRequestV2 message. Does not implicitly {@link contractpb.ExistingCustomerContractsRequestV2.verify|verify} messages.
         * @function encode
         * @memberof contractpb.ExistingCustomerContractsRequestV2
         * @static
         * @param {contractpb.IExistingCustomerContractsRequestV2} m ExistingCustomerContractsRequestV2 message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ExistingCustomerContractsRequestV2.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.email != null && Object.hasOwnProperty.call(m, "email"))
                w.uint32(10).string(m.email);
            if (m.addressID != null && Object.hasOwnProperty.call(m, "addressID"))
                w.uint32(18).string(m.addressID);
            return w;
        };

        /**
         * Decodes an ExistingCustomerContractsRequestV2 message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.ExistingCustomerContractsRequestV2
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.ExistingCustomerContractsRequestV2} ExistingCustomerContractsRequestV2
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ExistingCustomerContractsRequestV2.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.ExistingCustomerContractsRequestV2();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.email = r.string();
                    break;
                case 2:
                    m.addressID = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return ExistingCustomerContractsRequestV2;
    })();

    contractpb.ExistingCustomerContractsResponseV2 = (function() {

        /**
         * Properties of an ExistingCustomerContractsResponseV2.
         * @memberof contractpb
         * @interface IExistingCustomerContractsResponseV2
         * @property {Array.<contractpb.IExistingCustomerContractDetails>|null} [existingCustomerContractDetails] ExistingCustomerContractsResponseV2 existingCustomerContractDetails
         * @property {common.IError|null} [error] ExistingCustomerContractsResponseV2 error
         */

        /**
         * Constructs a new ExistingCustomerContractsResponseV2.
         * @memberof contractpb
         * @classdesc Represents an ExistingCustomerContractsResponseV2.
         * @implements IExistingCustomerContractsResponseV2
         * @constructor
         * @param {contractpb.IExistingCustomerContractsResponseV2=} [p] Properties to set
         */
        function ExistingCustomerContractsResponseV2(p) {
            this.existingCustomerContractDetails = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * ExistingCustomerContractsResponseV2 existingCustomerContractDetails.
         * @member {Array.<contractpb.IExistingCustomerContractDetails>} existingCustomerContractDetails
         * @memberof contractpb.ExistingCustomerContractsResponseV2
         * @instance
         */
        ExistingCustomerContractsResponseV2.prototype.existingCustomerContractDetails = $util.emptyArray;

        /**
         * ExistingCustomerContractsResponseV2 error.
         * @member {common.IError|null|undefined} error
         * @memberof contractpb.ExistingCustomerContractsResponseV2
         * @instance
         */
        ExistingCustomerContractsResponseV2.prototype.error = null;

        /**
         * Creates a new ExistingCustomerContractsResponseV2 instance using the specified properties.
         * @function create
         * @memberof contractpb.ExistingCustomerContractsResponseV2
         * @static
         * @param {contractpb.IExistingCustomerContractsResponseV2=} [properties] Properties to set
         * @returns {contractpb.ExistingCustomerContractsResponseV2} ExistingCustomerContractsResponseV2 instance
         */
        ExistingCustomerContractsResponseV2.create = function create(properties) {
            return new ExistingCustomerContractsResponseV2(properties);
        };

        /**
         * Encodes the specified ExistingCustomerContractsResponseV2 message. Does not implicitly {@link contractpb.ExistingCustomerContractsResponseV2.verify|verify} messages.
         * @function encode
         * @memberof contractpb.ExistingCustomerContractsResponseV2
         * @static
         * @param {contractpb.IExistingCustomerContractsResponseV2} m ExistingCustomerContractsResponseV2 message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ExistingCustomerContractsResponseV2.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.existingCustomerContractDetails != null && m.existingCustomerContractDetails.length) {
                for (var i = 0; i < m.existingCustomerContractDetails.length; ++i)
                    $root.contractpb.ExistingCustomerContractDetails.encode(m.existingCustomerContractDetails[i], w.uint32(10).fork()).ldelim();
            }
            if (m.error != null && Object.hasOwnProperty.call(m, "error"))
                $root.common.Error.encode(m.error, w.uint32(18).fork()).ldelim();
            return w;
        };

        /**
         * Decodes an ExistingCustomerContractsResponseV2 message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.ExistingCustomerContractsResponseV2
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.ExistingCustomerContractsResponseV2} ExistingCustomerContractsResponseV2
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ExistingCustomerContractsResponseV2.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.ExistingCustomerContractsResponseV2();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    if (!(m.existingCustomerContractDetails && m.existingCustomerContractDetails.length))
                        m.existingCustomerContractDetails = [];
                    m.existingCustomerContractDetails.push($root.contractpb.ExistingCustomerContractDetails.decode(r, r.uint32()));
                    break;
                case 2:
                    m.error = $root.common.Error.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return ExistingCustomerContractsResponseV2;
    })();

    contractpb.ExistingCustomerContractDetails = (function() {

        /**
         * Properties of an ExistingCustomerContractDetails.
         * @memberof contractpb
         * @interface IExistingCustomerContractDetails
         * @property {string|null} [contractID] ExistingCustomerContractDetails contractID
         * @property {google.protobuf.ITimestamp|null} [contractExpirationDate] ExistingCustomerContractDetails contractExpirationDate
         * @property {common.Tenant|null} [tenantID] ExistingCustomerContractDetails tenantID
         * @property {string|null} [productType] ExistingCustomerContractDetails productType
         * @property {string|null} [productVersionID] ExistingCustomerContractDetails productVersionID
         * @property {string|null} [salesChannel] ExistingCustomerContractDetails salesChannel
         * @property {string|null} [originalSalesChannel] ExistingCustomerContractDetails originalSalesChannel
         */

        /**
         * Constructs a new ExistingCustomerContractDetails.
         * @memberof contractpb
         * @classdesc Represents an ExistingCustomerContractDetails.
         * @implements IExistingCustomerContractDetails
         * @constructor
         * @param {contractpb.IExistingCustomerContractDetails=} [p] Properties to set
         */
        function ExistingCustomerContractDetails(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * ExistingCustomerContractDetails contractID.
         * @member {string} contractID
         * @memberof contractpb.ExistingCustomerContractDetails
         * @instance
         */
        ExistingCustomerContractDetails.prototype.contractID = "";

        /**
         * ExistingCustomerContractDetails contractExpirationDate.
         * @member {google.protobuf.ITimestamp|null|undefined} contractExpirationDate
         * @memberof contractpb.ExistingCustomerContractDetails
         * @instance
         */
        ExistingCustomerContractDetails.prototype.contractExpirationDate = null;

        /**
         * ExistingCustomerContractDetails tenantID.
         * @member {common.Tenant} tenantID
         * @memberof contractpb.ExistingCustomerContractDetails
         * @instance
         */
        ExistingCustomerContractDetails.prototype.tenantID = 0;

        /**
         * ExistingCustomerContractDetails productType.
         * @member {string} productType
         * @memberof contractpb.ExistingCustomerContractDetails
         * @instance
         */
        ExistingCustomerContractDetails.prototype.productType = "";

        /**
         * ExistingCustomerContractDetails productVersionID.
         * @member {string} productVersionID
         * @memberof contractpb.ExistingCustomerContractDetails
         * @instance
         */
        ExistingCustomerContractDetails.prototype.productVersionID = "";

        /**
         * ExistingCustomerContractDetails salesChannel.
         * @member {string} salesChannel
         * @memberof contractpb.ExistingCustomerContractDetails
         * @instance
         */
        ExistingCustomerContractDetails.prototype.salesChannel = "";

        /**
         * ExistingCustomerContractDetails originalSalesChannel.
         * @member {string} originalSalesChannel
         * @memberof contractpb.ExistingCustomerContractDetails
         * @instance
         */
        ExistingCustomerContractDetails.prototype.originalSalesChannel = "";

        /**
         * Creates a new ExistingCustomerContractDetails instance using the specified properties.
         * @function create
         * @memberof contractpb.ExistingCustomerContractDetails
         * @static
         * @param {contractpb.IExistingCustomerContractDetails=} [properties] Properties to set
         * @returns {contractpb.ExistingCustomerContractDetails} ExistingCustomerContractDetails instance
         */
        ExistingCustomerContractDetails.create = function create(properties) {
            return new ExistingCustomerContractDetails(properties);
        };

        /**
         * Encodes the specified ExistingCustomerContractDetails message. Does not implicitly {@link contractpb.ExistingCustomerContractDetails.verify|verify} messages.
         * @function encode
         * @memberof contractpb.ExistingCustomerContractDetails
         * @static
         * @param {contractpb.IExistingCustomerContractDetails} m ExistingCustomerContractDetails message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ExistingCustomerContractDetails.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.contractID != null && Object.hasOwnProperty.call(m, "contractID"))
                w.uint32(10).string(m.contractID);
            if (m.contractExpirationDate != null && Object.hasOwnProperty.call(m, "contractExpirationDate"))
                $root.google.protobuf.Timestamp.encode(m.contractExpirationDate, w.uint32(18).fork()).ldelim();
            if (m.tenantID != null && Object.hasOwnProperty.call(m, "tenantID"))
                w.uint32(24).int32(m.tenantID);
            if (m.productType != null && Object.hasOwnProperty.call(m, "productType"))
                w.uint32(34).string(m.productType);
            if (m.productVersionID != null && Object.hasOwnProperty.call(m, "productVersionID"))
                w.uint32(42).string(m.productVersionID);
            if (m.salesChannel != null && Object.hasOwnProperty.call(m, "salesChannel"))
                w.uint32(50).string(m.salesChannel);
            if (m.originalSalesChannel != null && Object.hasOwnProperty.call(m, "originalSalesChannel"))
                w.uint32(58).string(m.originalSalesChannel);
            return w;
        };

        /**
         * Decodes an ExistingCustomerContractDetails message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.ExistingCustomerContractDetails
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.ExistingCustomerContractDetails} ExistingCustomerContractDetails
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ExistingCustomerContractDetails.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.ExistingCustomerContractDetails();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.contractID = r.string();
                    break;
                case 2:
                    m.contractExpirationDate = $root.google.protobuf.Timestamp.decode(r, r.uint32());
                    break;
                case 3:
                    m.tenantID = r.int32();
                    break;
                case 4:
                    m.productType = r.string();
                    break;
                case 5:
                    m.productVersionID = r.string();
                    break;
                case 6:
                    m.salesChannel = r.string();
                    break;
                case 7:
                    m.originalSalesChannel = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return ExistingCustomerContractDetails;
    })();

    contractpb.ContractRenewalStatusKafkaEvent = (function() {

        /**
         * Properties of a ContractRenewalStatusKafkaEvent.
         * @memberof contractpb
         * @interface IContractRenewalStatusKafkaEvent
         * @property {common.Tenant|null} [tenantID] ContractRenewalStatusKafkaEvent tenantID
         * @property {string|null} [previousContractId] ContractRenewalStatusKafkaEvent previousContractId
         * @property {string|null} [newContractId] ContractRenewalStatusKafkaEvent newContractId
         * @property {boolean|null} [success] ContractRenewalStatusKafkaEvent success
         * @property {string|null} [failureReason] ContractRenewalStatusKafkaEvent failureReason
         */

        /**
         * Constructs a new ContractRenewalStatusKafkaEvent.
         * @memberof contractpb
         * @classdesc Represents a ContractRenewalStatusKafkaEvent.
         * @implements IContractRenewalStatusKafkaEvent
         * @constructor
         * @param {contractpb.IContractRenewalStatusKafkaEvent=} [p] Properties to set
         */
        function ContractRenewalStatusKafkaEvent(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * ContractRenewalStatusKafkaEvent tenantID.
         * @member {common.Tenant} tenantID
         * @memberof contractpb.ContractRenewalStatusKafkaEvent
         * @instance
         */
        ContractRenewalStatusKafkaEvent.prototype.tenantID = 0;

        /**
         * ContractRenewalStatusKafkaEvent previousContractId.
         * @member {string} previousContractId
         * @memberof contractpb.ContractRenewalStatusKafkaEvent
         * @instance
         */
        ContractRenewalStatusKafkaEvent.prototype.previousContractId = "";

        /**
         * ContractRenewalStatusKafkaEvent newContractId.
         * @member {string} newContractId
         * @memberof contractpb.ContractRenewalStatusKafkaEvent
         * @instance
         */
        ContractRenewalStatusKafkaEvent.prototype.newContractId = "";

        /**
         * ContractRenewalStatusKafkaEvent success.
         * @member {boolean} success
         * @memberof contractpb.ContractRenewalStatusKafkaEvent
         * @instance
         */
        ContractRenewalStatusKafkaEvent.prototype.success = false;

        /**
         * ContractRenewalStatusKafkaEvent failureReason.
         * @member {string} failureReason
         * @memberof contractpb.ContractRenewalStatusKafkaEvent
         * @instance
         */
        ContractRenewalStatusKafkaEvent.prototype.failureReason = "";

        /**
         * Creates a new ContractRenewalStatusKafkaEvent instance using the specified properties.
         * @function create
         * @memberof contractpb.ContractRenewalStatusKafkaEvent
         * @static
         * @param {contractpb.IContractRenewalStatusKafkaEvent=} [properties] Properties to set
         * @returns {contractpb.ContractRenewalStatusKafkaEvent} ContractRenewalStatusKafkaEvent instance
         */
        ContractRenewalStatusKafkaEvent.create = function create(properties) {
            return new ContractRenewalStatusKafkaEvent(properties);
        };

        /**
         * Encodes the specified ContractRenewalStatusKafkaEvent message. Does not implicitly {@link contractpb.ContractRenewalStatusKafkaEvent.verify|verify} messages.
         * @function encode
         * @memberof contractpb.ContractRenewalStatusKafkaEvent
         * @static
         * @param {contractpb.IContractRenewalStatusKafkaEvent} m ContractRenewalStatusKafkaEvent message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ContractRenewalStatusKafkaEvent.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.tenantID != null && Object.hasOwnProperty.call(m, "tenantID"))
                w.uint32(8).int32(m.tenantID);
            if (m.previousContractId != null && Object.hasOwnProperty.call(m, "previousContractId"))
                w.uint32(18).string(m.previousContractId);
            if (m.newContractId != null && Object.hasOwnProperty.call(m, "newContractId"))
                w.uint32(26).string(m.newContractId);
            if (m.success != null && Object.hasOwnProperty.call(m, "success"))
                w.uint32(32).bool(m.success);
            if (m.failureReason != null && Object.hasOwnProperty.call(m, "failureReason"))
                w.uint32(42).string(m.failureReason);
            return w;
        };

        /**
         * Decodes a ContractRenewalStatusKafkaEvent message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.ContractRenewalStatusKafkaEvent
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.ContractRenewalStatusKafkaEvent} ContractRenewalStatusKafkaEvent
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ContractRenewalStatusKafkaEvent.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.ContractRenewalStatusKafkaEvent();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.tenantID = r.int32();
                    break;
                case 2:
                    m.previousContractId = r.string();
                    break;
                case 3:
                    m.newContractId = r.string();
                    break;
                case 4:
                    m.success = r.bool();
                    break;
                case 5:
                    m.failureReason = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return ContractRenewalStatusKafkaEvent;
    })();

    contractpb.CreateContractKafkaEvent = (function() {

        /**
         * Properties of a CreateContractKafkaEvent.
         * @memberof contractpb
         * @interface ICreateContractKafkaEvent
         * @property {string|null} [orderID] CreateContractKafkaEvent orderID
         * @property {string|null} [contractID] CreateContractKafkaEvent contractID
         * @property {string|null} [previousContractID] CreateContractKafkaEvent previousContractID
         * @property {string|null} [buyerCustomerID] CreateContractKafkaEvent buyerCustomerID
         * @property {string|null} [payerCustomerID] CreateContractKafkaEvent payerCustomerID
         * @property {string|null} [salesChannel] CreateContractKafkaEvent salesChannel
         * @property {common.Tenant|null} [tenantID] CreateContractKafkaEvent tenantID
         * @property {string|null} [createTimeStamp] CreateContractKafkaEvent createTimeStamp
         * @property {boolean|null} [success] CreateContractKafkaEvent success
         * @property {string|null} [failureReason] CreateContractKafkaEvent failureReason
         * @property {string|null} [sourceApplication] CreateContractKafkaEvent sourceApplication
         * @property {boolean|null} [autoRenew] CreateContractKafkaEvent autoRenew
         * @property {string|null} [contractID210] CreateContractKafkaEvent contractID210
         */

        /**
         * Constructs a new CreateContractKafkaEvent.
         * @memberof contractpb
         * @classdesc Represents a CreateContractKafkaEvent.
         * @implements ICreateContractKafkaEvent
         * @constructor
         * @param {contractpb.ICreateContractKafkaEvent=} [p] Properties to set
         */
        function CreateContractKafkaEvent(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * CreateContractKafkaEvent orderID.
         * @member {string} orderID
         * @memberof contractpb.CreateContractKafkaEvent
         * @instance
         */
        CreateContractKafkaEvent.prototype.orderID = "";

        /**
         * CreateContractKafkaEvent contractID.
         * @member {string} contractID
         * @memberof contractpb.CreateContractKafkaEvent
         * @instance
         */
        CreateContractKafkaEvent.prototype.contractID = "";

        /**
         * CreateContractKafkaEvent previousContractID.
         * @member {string} previousContractID
         * @memberof contractpb.CreateContractKafkaEvent
         * @instance
         */
        CreateContractKafkaEvent.prototype.previousContractID = "";

        /**
         * CreateContractKafkaEvent buyerCustomerID.
         * @member {string} buyerCustomerID
         * @memberof contractpb.CreateContractKafkaEvent
         * @instance
         */
        CreateContractKafkaEvent.prototype.buyerCustomerID = "";

        /**
         * CreateContractKafkaEvent payerCustomerID.
         * @member {string} payerCustomerID
         * @memberof contractpb.CreateContractKafkaEvent
         * @instance
         */
        CreateContractKafkaEvent.prototype.payerCustomerID = "";

        /**
         * CreateContractKafkaEvent salesChannel.
         * @member {string} salesChannel
         * @memberof contractpb.CreateContractKafkaEvent
         * @instance
         */
        CreateContractKafkaEvent.prototype.salesChannel = "";

        /**
         * CreateContractKafkaEvent tenantID.
         * @member {common.Tenant} tenantID
         * @memberof contractpb.CreateContractKafkaEvent
         * @instance
         */
        CreateContractKafkaEvent.prototype.tenantID = 0;

        /**
         * CreateContractKafkaEvent createTimeStamp.
         * @member {string} createTimeStamp
         * @memberof contractpb.CreateContractKafkaEvent
         * @instance
         */
        CreateContractKafkaEvent.prototype.createTimeStamp = "";

        /**
         * CreateContractKafkaEvent success.
         * @member {boolean} success
         * @memberof contractpb.CreateContractKafkaEvent
         * @instance
         */
        CreateContractKafkaEvent.prototype.success = false;

        /**
         * CreateContractKafkaEvent failureReason.
         * @member {string} failureReason
         * @memberof contractpb.CreateContractKafkaEvent
         * @instance
         */
        CreateContractKafkaEvent.prototype.failureReason = "";

        /**
         * CreateContractKafkaEvent sourceApplication.
         * @member {string} sourceApplication
         * @memberof contractpb.CreateContractKafkaEvent
         * @instance
         */
        CreateContractKafkaEvent.prototype.sourceApplication = "";

        /**
         * CreateContractKafkaEvent autoRenew.
         * @member {boolean} autoRenew
         * @memberof contractpb.CreateContractKafkaEvent
         * @instance
         */
        CreateContractKafkaEvent.prototype.autoRenew = false;

        /**
         * CreateContractKafkaEvent contractID210.
         * @member {string} contractID210
         * @memberof contractpb.CreateContractKafkaEvent
         * @instance
         */
        CreateContractKafkaEvent.prototype.contractID210 = "";

        /**
         * Creates a new CreateContractKafkaEvent instance using the specified properties.
         * @function create
         * @memberof contractpb.CreateContractKafkaEvent
         * @static
         * @param {contractpb.ICreateContractKafkaEvent=} [properties] Properties to set
         * @returns {contractpb.CreateContractKafkaEvent} CreateContractKafkaEvent instance
         */
        CreateContractKafkaEvent.create = function create(properties) {
            return new CreateContractKafkaEvent(properties);
        };

        /**
         * Encodes the specified CreateContractKafkaEvent message. Does not implicitly {@link contractpb.CreateContractKafkaEvent.verify|verify} messages.
         * @function encode
         * @memberof contractpb.CreateContractKafkaEvent
         * @static
         * @param {contractpb.ICreateContractKafkaEvent} m CreateContractKafkaEvent message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CreateContractKafkaEvent.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.orderID != null && Object.hasOwnProperty.call(m, "orderID"))
                w.uint32(10).string(m.orderID);
            if (m.contractID != null && Object.hasOwnProperty.call(m, "contractID"))
                w.uint32(18).string(m.contractID);
            if (m.previousContractID != null && Object.hasOwnProperty.call(m, "previousContractID"))
                w.uint32(26).string(m.previousContractID);
            if (m.buyerCustomerID != null && Object.hasOwnProperty.call(m, "buyerCustomerID"))
                w.uint32(34).string(m.buyerCustomerID);
            if (m.payerCustomerID != null && Object.hasOwnProperty.call(m, "payerCustomerID"))
                w.uint32(42).string(m.payerCustomerID);
            if (m.salesChannel != null && Object.hasOwnProperty.call(m, "salesChannel"))
                w.uint32(50).string(m.salesChannel);
            if (m.tenantID != null && Object.hasOwnProperty.call(m, "tenantID"))
                w.uint32(56).int32(m.tenantID);
            if (m.createTimeStamp != null && Object.hasOwnProperty.call(m, "createTimeStamp"))
                w.uint32(66).string(m.createTimeStamp);
            if (m.success != null && Object.hasOwnProperty.call(m, "success"))
                w.uint32(72).bool(m.success);
            if (m.failureReason != null && Object.hasOwnProperty.call(m, "failureReason"))
                w.uint32(82).string(m.failureReason);
            if (m.sourceApplication != null && Object.hasOwnProperty.call(m, "sourceApplication"))
                w.uint32(90).string(m.sourceApplication);
            if (m.autoRenew != null && Object.hasOwnProperty.call(m, "autoRenew"))
                w.uint32(96).bool(m.autoRenew);
            if (m.contractID210 != null && Object.hasOwnProperty.call(m, "contractID210"))
                w.uint32(106).string(m.contractID210);
            return w;
        };

        /**
         * Decodes a CreateContractKafkaEvent message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.CreateContractKafkaEvent
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.CreateContractKafkaEvent} CreateContractKafkaEvent
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CreateContractKafkaEvent.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.CreateContractKafkaEvent();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.orderID = r.string();
                    break;
                case 2:
                    m.contractID = r.string();
                    break;
                case 3:
                    m.previousContractID = r.string();
                    break;
                case 4:
                    m.buyerCustomerID = r.string();
                    break;
                case 5:
                    m.payerCustomerID = r.string();
                    break;
                case 6:
                    m.salesChannel = r.string();
                    break;
                case 7:
                    m.tenantID = r.int32();
                    break;
                case 8:
                    m.createTimeStamp = r.string();
                    break;
                case 9:
                    m.success = r.bool();
                    break;
                case 10:
                    m.failureReason = r.string();
                    break;
                case 11:
                    m.sourceApplication = r.string();
                    break;
                case 12:
                    m.autoRenew = r.bool();
                    break;
                case 13:
                    m.contractID210 = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return CreateContractKafkaEvent;
    })();

    contractpb.ContractDetailsKafkaEvent = (function() {

        /**
         * Properties of a ContractDetailsKafkaEvent.
         * @memberof contractpb
         * @interface IContractDetailsKafkaEvent
         * @property {string|null} [contractID] ContractDetailsKafkaEvent contractID
         * @property {common.Tenant|null} [tenantID] ContractDetailsKafkaEvent tenantID
         * @property {Array.<contractpb.IContractDetail>|null} [contractDetails] ContractDetailsKafkaEvent contractDetails
         */

        /**
         * Constructs a new ContractDetailsKafkaEvent.
         * @memberof contractpb
         * @classdesc Represents a ContractDetailsKafkaEvent.
         * @implements IContractDetailsKafkaEvent
         * @constructor
         * @param {contractpb.IContractDetailsKafkaEvent=} [p] Properties to set
         */
        function ContractDetailsKafkaEvent(p) {
            this.contractDetails = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * ContractDetailsKafkaEvent contractID.
         * @member {string} contractID
         * @memberof contractpb.ContractDetailsKafkaEvent
         * @instance
         */
        ContractDetailsKafkaEvent.prototype.contractID = "";

        /**
         * ContractDetailsKafkaEvent tenantID.
         * @member {common.Tenant} tenantID
         * @memberof contractpb.ContractDetailsKafkaEvent
         * @instance
         */
        ContractDetailsKafkaEvent.prototype.tenantID = 0;

        /**
         * ContractDetailsKafkaEvent contractDetails.
         * @member {Array.<contractpb.IContractDetail>} contractDetails
         * @memberof contractpb.ContractDetailsKafkaEvent
         * @instance
         */
        ContractDetailsKafkaEvent.prototype.contractDetails = $util.emptyArray;

        /**
         * Creates a new ContractDetailsKafkaEvent instance using the specified properties.
         * @function create
         * @memberof contractpb.ContractDetailsKafkaEvent
         * @static
         * @param {contractpb.IContractDetailsKafkaEvent=} [properties] Properties to set
         * @returns {contractpb.ContractDetailsKafkaEvent} ContractDetailsKafkaEvent instance
         */
        ContractDetailsKafkaEvent.create = function create(properties) {
            return new ContractDetailsKafkaEvent(properties);
        };

        /**
         * Encodes the specified ContractDetailsKafkaEvent message. Does not implicitly {@link contractpb.ContractDetailsKafkaEvent.verify|verify} messages.
         * @function encode
         * @memberof contractpb.ContractDetailsKafkaEvent
         * @static
         * @param {contractpb.IContractDetailsKafkaEvent} m ContractDetailsKafkaEvent message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ContractDetailsKafkaEvent.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.contractID != null && Object.hasOwnProperty.call(m, "contractID"))
                w.uint32(10).string(m.contractID);
            if (m.tenantID != null && Object.hasOwnProperty.call(m, "tenantID"))
                w.uint32(16).int32(m.tenantID);
            if (m.contractDetails != null && m.contractDetails.length) {
                for (var i = 0; i < m.contractDetails.length; ++i)
                    $root.contractpb.ContractDetail.encode(m.contractDetails[i], w.uint32(26).fork()).ldelim();
            }
            return w;
        };

        /**
         * Decodes a ContractDetailsKafkaEvent message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.ContractDetailsKafkaEvent
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.ContractDetailsKafkaEvent} ContractDetailsKafkaEvent
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ContractDetailsKafkaEvent.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.ContractDetailsKafkaEvent();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.contractID = r.string();
                    break;
                case 2:
                    m.tenantID = r.int32();
                    break;
                case 3:
                    if (!(m.contractDetails && m.contractDetails.length))
                        m.contractDetails = [];
                    m.contractDetails.push($root.contractpb.ContractDetail.decode(r, r.uint32()));
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return ContractDetailsKafkaEvent;
    })();

    contractpb.UpdateContractPropertyRequestV2 = (function() {

        /**
         * Properties of an UpdateContractPropertyRequestV2.
         * @memberof contractpb
         * @interface IUpdateContractPropertyRequestV2
         * @property {string|null} [contractID] UpdateContractPropertyRequestV2 contractID
         * @property {contractpb.IContractAddress|null} [addressDetails] UpdateContractPropertyRequestV2 addressDetails
         * @property {contractpb.IContractPropertyV2|null} [propertyDetails] UpdateContractPropertyRequestV2 propertyDetails
         * @property {contractpb.PropertyType|null} [propertyType] UpdateContractPropertyRequestV2 propertyType
         * @property {common.Tenant|null} [tenantID] UpdateContractPropertyRequestV2 tenantID
         * @property {string|null} [userID] UpdateContractPropertyRequestV2 userID
         */

        /**
         * Constructs a new UpdateContractPropertyRequestV2.
         * @memberof contractpb
         * @classdesc Represents an UpdateContractPropertyRequestV2.
         * @implements IUpdateContractPropertyRequestV2
         * @constructor
         * @param {contractpb.IUpdateContractPropertyRequestV2=} [p] Properties to set
         */
        function UpdateContractPropertyRequestV2(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * UpdateContractPropertyRequestV2 contractID.
         * @member {string} contractID
         * @memberof contractpb.UpdateContractPropertyRequestV2
         * @instance
         */
        UpdateContractPropertyRequestV2.prototype.contractID = "";

        /**
         * UpdateContractPropertyRequestV2 addressDetails.
         * @member {contractpb.IContractAddress|null|undefined} addressDetails
         * @memberof contractpb.UpdateContractPropertyRequestV2
         * @instance
         */
        UpdateContractPropertyRequestV2.prototype.addressDetails = null;

        /**
         * UpdateContractPropertyRequestV2 propertyDetails.
         * @member {contractpb.IContractPropertyV2|null|undefined} propertyDetails
         * @memberof contractpb.UpdateContractPropertyRequestV2
         * @instance
         */
        UpdateContractPropertyRequestV2.prototype.propertyDetails = null;

        /**
         * UpdateContractPropertyRequestV2 propertyType.
         * @member {contractpb.PropertyType} propertyType
         * @memberof contractpb.UpdateContractPropertyRequestV2
         * @instance
         */
        UpdateContractPropertyRequestV2.prototype.propertyType = 0;

        /**
         * UpdateContractPropertyRequestV2 tenantID.
         * @member {common.Tenant} tenantID
         * @memberof contractpb.UpdateContractPropertyRequestV2
         * @instance
         */
        UpdateContractPropertyRequestV2.prototype.tenantID = 0;

        /**
         * UpdateContractPropertyRequestV2 userID.
         * @member {string} userID
         * @memberof contractpb.UpdateContractPropertyRequestV2
         * @instance
         */
        UpdateContractPropertyRequestV2.prototype.userID = "";

        /**
         * Creates a new UpdateContractPropertyRequestV2 instance using the specified properties.
         * @function create
         * @memberof contractpb.UpdateContractPropertyRequestV2
         * @static
         * @param {contractpb.IUpdateContractPropertyRequestV2=} [properties] Properties to set
         * @returns {contractpb.UpdateContractPropertyRequestV2} UpdateContractPropertyRequestV2 instance
         */
        UpdateContractPropertyRequestV2.create = function create(properties) {
            return new UpdateContractPropertyRequestV2(properties);
        };

        /**
         * Encodes the specified UpdateContractPropertyRequestV2 message. Does not implicitly {@link contractpb.UpdateContractPropertyRequestV2.verify|verify} messages.
         * @function encode
         * @memberof contractpb.UpdateContractPropertyRequestV2
         * @static
         * @param {contractpb.IUpdateContractPropertyRequestV2} m UpdateContractPropertyRequestV2 message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UpdateContractPropertyRequestV2.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.contractID != null && Object.hasOwnProperty.call(m, "contractID"))
                w.uint32(10).string(m.contractID);
            if (m.addressDetails != null && Object.hasOwnProperty.call(m, "addressDetails"))
                $root.contractpb.ContractAddress.encode(m.addressDetails, w.uint32(18).fork()).ldelim();
            if (m.propertyDetails != null && Object.hasOwnProperty.call(m, "propertyDetails"))
                $root.contractpb.ContractPropertyV2.encode(m.propertyDetails, w.uint32(26).fork()).ldelim();
            if (m.propertyType != null && Object.hasOwnProperty.call(m, "propertyType"))
                w.uint32(32).int32(m.propertyType);
            if (m.tenantID != null && Object.hasOwnProperty.call(m, "tenantID"))
                w.uint32(40).int32(m.tenantID);
            if (m.userID != null && Object.hasOwnProperty.call(m, "userID"))
                w.uint32(50).string(m.userID);
            return w;
        };

        /**
         * Decodes an UpdateContractPropertyRequestV2 message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.UpdateContractPropertyRequestV2
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.UpdateContractPropertyRequestV2} UpdateContractPropertyRequestV2
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UpdateContractPropertyRequestV2.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.UpdateContractPropertyRequestV2();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.contractID = r.string();
                    break;
                case 2:
                    m.addressDetails = $root.contractpb.ContractAddress.decode(r, r.uint32());
                    break;
                case 3:
                    m.propertyDetails = $root.contractpb.ContractPropertyV2.decode(r, r.uint32());
                    break;
                case 4:
                    m.propertyType = r.int32();
                    break;
                case 5:
                    m.tenantID = r.int32();
                    break;
                case 6:
                    m.userID = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return UpdateContractPropertyRequestV2;
    })();

    /**
     * PropertyType enum.
     * @name contractpb.PropertyType
     * @enum {number}
     * @property {number} UNDEFINED_PROPERTY_TYPE=0 UNDEFINED_PROPERTY_TYPE value
     * @property {number} COV=1 COV value
     * @property {number} MA=2 MA value
     */
    contractpb.PropertyType = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "UNDEFINED_PROPERTY_TYPE"] = 0;
        values[valuesById[1] = "COV"] = 1;
        values[valuesById[2] = "MA"] = 2;
        return values;
    })();

    contractpb.ContractPropertyV2 = (function() {

        /**
         * Properties of a ContractPropertyV2.
         * @memberof contractpb
         * @interface IContractPropertyV2
         * @property {number|null} [squareFeet] ContractPropertyV2 squareFeet
         * @property {string|null} [yearBuilt] ContractPropertyV2 yearBuilt
         * @property {number|null} [numberMotherLawUnits] ContractPropertyV2 numberMotherLawUnits
         * @property {string|null} [dwellingType] ContractPropertyV2 dwellingType
         */

        /**
         * Constructs a new ContractPropertyV2.
         * @memberof contractpb
         * @classdesc Represents a ContractPropertyV2.
         * @implements IContractPropertyV2
         * @constructor
         * @param {contractpb.IContractPropertyV2=} [p] Properties to set
         */
        function ContractPropertyV2(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * ContractPropertyV2 squareFeet.
         * @member {number} squareFeet
         * @memberof contractpb.ContractPropertyV2
         * @instance
         */
        ContractPropertyV2.prototype.squareFeet = 0;

        /**
         * ContractPropertyV2 yearBuilt.
         * @member {string} yearBuilt
         * @memberof contractpb.ContractPropertyV2
         * @instance
         */
        ContractPropertyV2.prototype.yearBuilt = "";

        /**
         * ContractPropertyV2 numberMotherLawUnits.
         * @member {number} numberMotherLawUnits
         * @memberof contractpb.ContractPropertyV2
         * @instance
         */
        ContractPropertyV2.prototype.numberMotherLawUnits = 0;

        /**
         * ContractPropertyV2 dwellingType.
         * @member {string} dwellingType
         * @memberof contractpb.ContractPropertyV2
         * @instance
         */
        ContractPropertyV2.prototype.dwellingType = "";

        /**
         * Creates a new ContractPropertyV2 instance using the specified properties.
         * @function create
         * @memberof contractpb.ContractPropertyV2
         * @static
         * @param {contractpb.IContractPropertyV2=} [properties] Properties to set
         * @returns {contractpb.ContractPropertyV2} ContractPropertyV2 instance
         */
        ContractPropertyV2.create = function create(properties) {
            return new ContractPropertyV2(properties);
        };

        /**
         * Encodes the specified ContractPropertyV2 message. Does not implicitly {@link contractpb.ContractPropertyV2.verify|verify} messages.
         * @function encode
         * @memberof contractpb.ContractPropertyV2
         * @static
         * @param {contractpb.IContractPropertyV2} m ContractPropertyV2 message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ContractPropertyV2.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.squareFeet != null && Object.hasOwnProperty.call(m, "squareFeet"))
                w.uint32(8).int32(m.squareFeet);
            if (m.yearBuilt != null && Object.hasOwnProperty.call(m, "yearBuilt"))
                w.uint32(18).string(m.yearBuilt);
            if (m.numberMotherLawUnits != null && Object.hasOwnProperty.call(m, "numberMotherLawUnits"))
                w.uint32(24).int32(m.numberMotherLawUnits);
            if (m.dwellingType != null && Object.hasOwnProperty.call(m, "dwellingType"))
                w.uint32(34).string(m.dwellingType);
            return w;
        };

        /**
         * Decodes a ContractPropertyV2 message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.ContractPropertyV2
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.ContractPropertyV2} ContractPropertyV2
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ContractPropertyV2.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.ContractPropertyV2();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.squareFeet = r.int32();
                    break;
                case 2:
                    m.yearBuilt = r.string();
                    break;
                case 3:
                    m.numberMotherLawUnits = r.int32();
                    break;
                case 4:
                    m.dwellingType = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return ContractPropertyV2;
    })();

    contractpb.ContractAddress = (function() {

        /**
         * Properties of a ContractAddress.
         * @memberof contractpb
         * @interface IContractAddress
         * @property {string|null} [streetAddress] ContractAddress streetAddress
         * @property {string|null} [streetNumber] ContractAddress streetNumber
         * @property {string|null} [streetDirection] ContractAddress streetDirection
         * @property {string|null} [streetName] ContractAddress streetName
         * @property {string|null} [unitNumber] ContractAddress unitNumber
         * @property {string|null} [unitType] ContractAddress unitType
         * @property {string|null} [city] ContractAddress city
         * @property {string|null} [state] ContractAddress state
         * @property {string|null} [zip] ContractAddress zip
         */

        /**
         * Constructs a new ContractAddress.
         * @memberof contractpb
         * @classdesc Represents a ContractAddress.
         * @implements IContractAddress
         * @constructor
         * @param {contractpb.IContractAddress=} [p] Properties to set
         */
        function ContractAddress(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * ContractAddress streetAddress.
         * @member {string} streetAddress
         * @memberof contractpb.ContractAddress
         * @instance
         */
        ContractAddress.prototype.streetAddress = "";

        /**
         * ContractAddress streetNumber.
         * @member {string} streetNumber
         * @memberof contractpb.ContractAddress
         * @instance
         */
        ContractAddress.prototype.streetNumber = "";

        /**
         * ContractAddress streetDirection.
         * @member {string} streetDirection
         * @memberof contractpb.ContractAddress
         * @instance
         */
        ContractAddress.prototype.streetDirection = "";

        /**
         * ContractAddress streetName.
         * @member {string} streetName
         * @memberof contractpb.ContractAddress
         * @instance
         */
        ContractAddress.prototype.streetName = "";

        /**
         * ContractAddress unitNumber.
         * @member {string} unitNumber
         * @memberof contractpb.ContractAddress
         * @instance
         */
        ContractAddress.prototype.unitNumber = "";

        /**
         * ContractAddress unitType.
         * @member {string} unitType
         * @memberof contractpb.ContractAddress
         * @instance
         */
        ContractAddress.prototype.unitType = "";

        /**
         * ContractAddress city.
         * @member {string} city
         * @memberof contractpb.ContractAddress
         * @instance
         */
        ContractAddress.prototype.city = "";

        /**
         * ContractAddress state.
         * @member {string} state
         * @memberof contractpb.ContractAddress
         * @instance
         */
        ContractAddress.prototype.state = "";

        /**
         * ContractAddress zip.
         * @member {string} zip
         * @memberof contractpb.ContractAddress
         * @instance
         */
        ContractAddress.prototype.zip = "";

        /**
         * Creates a new ContractAddress instance using the specified properties.
         * @function create
         * @memberof contractpb.ContractAddress
         * @static
         * @param {contractpb.IContractAddress=} [properties] Properties to set
         * @returns {contractpb.ContractAddress} ContractAddress instance
         */
        ContractAddress.create = function create(properties) {
            return new ContractAddress(properties);
        };

        /**
         * Encodes the specified ContractAddress message. Does not implicitly {@link contractpb.ContractAddress.verify|verify} messages.
         * @function encode
         * @memberof contractpb.ContractAddress
         * @static
         * @param {contractpb.IContractAddress} m ContractAddress message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ContractAddress.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.streetAddress != null && Object.hasOwnProperty.call(m, "streetAddress"))
                w.uint32(10).string(m.streetAddress);
            if (m.streetNumber != null && Object.hasOwnProperty.call(m, "streetNumber"))
                w.uint32(18).string(m.streetNumber);
            if (m.streetDirection != null && Object.hasOwnProperty.call(m, "streetDirection"))
                w.uint32(26).string(m.streetDirection);
            if (m.streetName != null && Object.hasOwnProperty.call(m, "streetName"))
                w.uint32(34).string(m.streetName);
            if (m.unitNumber != null && Object.hasOwnProperty.call(m, "unitNumber"))
                w.uint32(42).string(m.unitNumber);
            if (m.unitType != null && Object.hasOwnProperty.call(m, "unitType"))
                w.uint32(50).string(m.unitType);
            if (m.city != null && Object.hasOwnProperty.call(m, "city"))
                w.uint32(58).string(m.city);
            if (m.state != null && Object.hasOwnProperty.call(m, "state"))
                w.uint32(66).string(m.state);
            if (m.zip != null && Object.hasOwnProperty.call(m, "zip"))
                w.uint32(74).string(m.zip);
            return w;
        };

        /**
         * Decodes a ContractAddress message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.ContractAddress
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.ContractAddress} ContractAddress
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ContractAddress.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.ContractAddress();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.streetAddress = r.string();
                    break;
                case 2:
                    m.streetNumber = r.string();
                    break;
                case 3:
                    m.streetDirection = r.string();
                    break;
                case 4:
                    m.streetName = r.string();
                    break;
                case 5:
                    m.unitNumber = r.string();
                    break;
                case 6:
                    m.unitType = r.string();
                    break;
                case 7:
                    m.city = r.string();
                    break;
                case 8:
                    m.state = r.string();
                    break;
                case 9:
                    m.zip = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return ContractAddress;
    })();

    contractpb.UpdateContractPropertyResponseV2 = (function() {

        /**
         * Properties of an UpdateContractPropertyResponseV2.
         * @memberof contractpb
         * @interface IUpdateContractPropertyResponseV2
         * @property {common.IError|null} [error] UpdateContractPropertyResponseV2 error
         */

        /**
         * Constructs a new UpdateContractPropertyResponseV2.
         * @memberof contractpb
         * @classdesc Represents an UpdateContractPropertyResponseV2.
         * @implements IUpdateContractPropertyResponseV2
         * @constructor
         * @param {contractpb.IUpdateContractPropertyResponseV2=} [p] Properties to set
         */
        function UpdateContractPropertyResponseV2(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * UpdateContractPropertyResponseV2 error.
         * @member {common.IError|null|undefined} error
         * @memberof contractpb.UpdateContractPropertyResponseV2
         * @instance
         */
        UpdateContractPropertyResponseV2.prototype.error = null;

        /**
         * Creates a new UpdateContractPropertyResponseV2 instance using the specified properties.
         * @function create
         * @memberof contractpb.UpdateContractPropertyResponseV2
         * @static
         * @param {contractpb.IUpdateContractPropertyResponseV2=} [properties] Properties to set
         * @returns {contractpb.UpdateContractPropertyResponseV2} UpdateContractPropertyResponseV2 instance
         */
        UpdateContractPropertyResponseV2.create = function create(properties) {
            return new UpdateContractPropertyResponseV2(properties);
        };

        /**
         * Encodes the specified UpdateContractPropertyResponseV2 message. Does not implicitly {@link contractpb.UpdateContractPropertyResponseV2.verify|verify} messages.
         * @function encode
         * @memberof contractpb.UpdateContractPropertyResponseV2
         * @static
         * @param {contractpb.IUpdateContractPropertyResponseV2} m UpdateContractPropertyResponseV2 message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UpdateContractPropertyResponseV2.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.error != null && Object.hasOwnProperty.call(m, "error"))
                $root.common.Error.encode(m.error, w.uint32(10).fork()).ldelim();
            return w;
        };

        /**
         * Decodes an UpdateContractPropertyResponseV2 message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.UpdateContractPropertyResponseV2
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.UpdateContractPropertyResponseV2} UpdateContractPropertyResponseV2
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UpdateContractPropertyResponseV2.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.UpdateContractPropertyResponseV2();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.error = $root.common.Error.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return UpdateContractPropertyResponseV2;
    })();

    contractpb.ContractChangeTrackerRequest = (function() {

        /**
         * Properties of a ContractChangeTrackerRequest.
         * @memberof contractpb
         * @interface IContractChangeTrackerRequest
         * @property {string|null} [contractID] ContractChangeTrackerRequest contractID
         * @property {contractpb.ChangeType|null} [changeType] ContractChangeTrackerRequest changeType
         * @property {common.IDate|null} [effectiveFromDate] ContractChangeTrackerRequest effectiveFromDate
         * @property {common.IDate|null} [effectiveToDate] ContractChangeTrackerRequest effectiveToDate
         */

        /**
         * Constructs a new ContractChangeTrackerRequest.
         * @memberof contractpb
         * @classdesc Represents a ContractChangeTrackerRequest.
         * @implements IContractChangeTrackerRequest
         * @constructor
         * @param {contractpb.IContractChangeTrackerRequest=} [p] Properties to set
         */
        function ContractChangeTrackerRequest(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * ContractChangeTrackerRequest contractID.
         * @member {string} contractID
         * @memberof contractpb.ContractChangeTrackerRequest
         * @instance
         */
        ContractChangeTrackerRequest.prototype.contractID = "";

        /**
         * ContractChangeTrackerRequest changeType.
         * @member {contractpb.ChangeType} changeType
         * @memberof contractpb.ContractChangeTrackerRequest
         * @instance
         */
        ContractChangeTrackerRequest.prototype.changeType = 0;

        /**
         * ContractChangeTrackerRequest effectiveFromDate.
         * @member {common.IDate|null|undefined} effectiveFromDate
         * @memberof contractpb.ContractChangeTrackerRequest
         * @instance
         */
        ContractChangeTrackerRequest.prototype.effectiveFromDate = null;

        /**
         * ContractChangeTrackerRequest effectiveToDate.
         * @member {common.IDate|null|undefined} effectiveToDate
         * @memberof contractpb.ContractChangeTrackerRequest
         * @instance
         */
        ContractChangeTrackerRequest.prototype.effectiveToDate = null;

        /**
         * Creates a new ContractChangeTrackerRequest instance using the specified properties.
         * @function create
         * @memberof contractpb.ContractChangeTrackerRequest
         * @static
         * @param {contractpb.IContractChangeTrackerRequest=} [properties] Properties to set
         * @returns {contractpb.ContractChangeTrackerRequest} ContractChangeTrackerRequest instance
         */
        ContractChangeTrackerRequest.create = function create(properties) {
            return new ContractChangeTrackerRequest(properties);
        };

        /**
         * Encodes the specified ContractChangeTrackerRequest message. Does not implicitly {@link contractpb.ContractChangeTrackerRequest.verify|verify} messages.
         * @function encode
         * @memberof contractpb.ContractChangeTrackerRequest
         * @static
         * @param {contractpb.IContractChangeTrackerRequest} m ContractChangeTrackerRequest message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ContractChangeTrackerRequest.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.contractID != null && Object.hasOwnProperty.call(m, "contractID"))
                w.uint32(10).string(m.contractID);
            if (m.changeType != null && Object.hasOwnProperty.call(m, "changeType"))
                w.uint32(16).int32(m.changeType);
            if (m.effectiveFromDate != null && Object.hasOwnProperty.call(m, "effectiveFromDate"))
                $root.common.Date.encode(m.effectiveFromDate, w.uint32(26).fork()).ldelim();
            if (m.effectiveToDate != null && Object.hasOwnProperty.call(m, "effectiveToDate"))
                $root.common.Date.encode(m.effectiveToDate, w.uint32(34).fork()).ldelim();
            return w;
        };

        /**
         * Decodes a ContractChangeTrackerRequest message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.ContractChangeTrackerRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.ContractChangeTrackerRequest} ContractChangeTrackerRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ContractChangeTrackerRequest.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.ContractChangeTrackerRequest();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.contractID = r.string();
                    break;
                case 2:
                    m.changeType = r.int32();
                    break;
                case 3:
                    m.effectiveFromDate = $root.common.Date.decode(r, r.uint32());
                    break;
                case 4:
                    m.effectiveToDate = $root.common.Date.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return ContractChangeTrackerRequest;
    })();

    contractpb.ContractChangeTrackerResponse = (function() {

        /**
         * Properties of a ContractChangeTrackerResponse.
         * @memberof contractpb
         * @interface IContractChangeTrackerResponse
         * @property {string|null} [contractID] ContractChangeTrackerResponse contractID
         * @property {Array.<contractpb.IContractChange>|null} [contractChanges] ContractChangeTrackerResponse contractChanges
         * @property {google.protobuf.ITimestamp|null} [changeHistoryLastModified] ContractChangeTrackerResponse changeHistoryLastModified
         */

        /**
         * Constructs a new ContractChangeTrackerResponse.
         * @memberof contractpb
         * @classdesc Represents a ContractChangeTrackerResponse.
         * @implements IContractChangeTrackerResponse
         * @constructor
         * @param {contractpb.IContractChangeTrackerResponse=} [p] Properties to set
         */
        function ContractChangeTrackerResponse(p) {
            this.contractChanges = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * ContractChangeTrackerResponse contractID.
         * @member {string} contractID
         * @memberof contractpb.ContractChangeTrackerResponse
         * @instance
         */
        ContractChangeTrackerResponse.prototype.contractID = "";

        /**
         * ContractChangeTrackerResponse contractChanges.
         * @member {Array.<contractpb.IContractChange>} contractChanges
         * @memberof contractpb.ContractChangeTrackerResponse
         * @instance
         */
        ContractChangeTrackerResponse.prototype.contractChanges = $util.emptyArray;

        /**
         * ContractChangeTrackerResponse changeHistoryLastModified.
         * @member {google.protobuf.ITimestamp|null|undefined} changeHistoryLastModified
         * @memberof contractpb.ContractChangeTrackerResponse
         * @instance
         */
        ContractChangeTrackerResponse.prototype.changeHistoryLastModified = null;

        /**
         * Creates a new ContractChangeTrackerResponse instance using the specified properties.
         * @function create
         * @memberof contractpb.ContractChangeTrackerResponse
         * @static
         * @param {contractpb.IContractChangeTrackerResponse=} [properties] Properties to set
         * @returns {contractpb.ContractChangeTrackerResponse} ContractChangeTrackerResponse instance
         */
        ContractChangeTrackerResponse.create = function create(properties) {
            return new ContractChangeTrackerResponse(properties);
        };

        /**
         * Encodes the specified ContractChangeTrackerResponse message. Does not implicitly {@link contractpb.ContractChangeTrackerResponse.verify|verify} messages.
         * @function encode
         * @memberof contractpb.ContractChangeTrackerResponse
         * @static
         * @param {contractpb.IContractChangeTrackerResponse} m ContractChangeTrackerResponse message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ContractChangeTrackerResponse.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.contractID != null && Object.hasOwnProperty.call(m, "contractID"))
                w.uint32(10).string(m.contractID);
            if (m.contractChanges != null && m.contractChanges.length) {
                for (var i = 0; i < m.contractChanges.length; ++i)
                    $root.contractpb.ContractChange.encode(m.contractChanges[i], w.uint32(18).fork()).ldelim();
            }
            if (m.changeHistoryLastModified != null && Object.hasOwnProperty.call(m, "changeHistoryLastModified"))
                $root.google.protobuf.Timestamp.encode(m.changeHistoryLastModified, w.uint32(26).fork()).ldelim();
            return w;
        };

        /**
         * Decodes a ContractChangeTrackerResponse message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.ContractChangeTrackerResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.ContractChangeTrackerResponse} ContractChangeTrackerResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ContractChangeTrackerResponse.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.ContractChangeTrackerResponse();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.contractID = r.string();
                    break;
                case 2:
                    if (!(m.contractChanges && m.contractChanges.length))
                        m.contractChanges = [];
                    m.contractChanges.push($root.contractpb.ContractChange.decode(r, r.uint32()));
                    break;
                case 3:
                    m.changeHistoryLastModified = $root.google.protobuf.Timestamp.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return ContractChangeTrackerResponse;
    })();

    /**
     * ChangeType enum.
     * @name contractpb.ChangeType
     * @enum {number}
     * @property {number} UNDEFINED_CHANGE_TYPE=0 UNDEFINED_CHANGE_TYPE value
     * @property {number} QUOTE_ID=2 QUOTE_ID value
     */
    contractpb.ChangeType = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "UNDEFINED_CHANGE_TYPE"] = 0;
        values[valuesById[2] = "QUOTE_ID"] = 2;
        return values;
    })();

    /**
     * QuoteStatus enum.
     * @name contractpb.QuoteStatus
     * @enum {number}
     * @property {number} UNDEFINED_QUOTE_STATUS=0 UNDEFINED_QUOTE_STATUS value
     * @property {number} ACTIVE=1 ACTIVE value
     * @property {number} COMPLETED=2 COMPLETED value
     * @property {number} CANCELLED=3 CANCELLED value
     * @property {number} FUTURE=4 FUTURE value
     */
    contractpb.QuoteStatus = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "UNDEFINED_QUOTE_STATUS"] = 0;
        values[valuesById[1] = "ACTIVE"] = 1;
        values[valuesById[2] = "COMPLETED"] = 2;
        values[valuesById[3] = "CANCELLED"] = 3;
        values[valuesById[4] = "FUTURE"] = 4;
        return values;
    })();

    contractpb.EventTimeStamps = (function() {

        /**
         * Properties of an EventTimeStamps.
         * @memberof contractpb
         * @interface IEventTimeStamps
         * @property {google.protobuf.ITimestamp|null} [requestTimeStamp] EventTimeStamps requestTimeStamp
         * @property {google.protobuf.ITimestamp|null} [effectiveTimeStamp] EventTimeStamps effectiveTimeStamp
         * @property {google.protobuf.ITimestamp|null} [cancelTimeStamp] EventTimeStamps cancelTimeStamp
         * @property {google.protobuf.ITimestamp|null} [completeTimeStamp] EventTimeStamps completeTimeStamp
         */

        /**
         * Constructs a new EventTimeStamps.
         * @memberof contractpb
         * @classdesc Represents an EventTimeStamps.
         * @implements IEventTimeStamps
         * @constructor
         * @param {contractpb.IEventTimeStamps=} [p] Properties to set
         */
        function EventTimeStamps(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * EventTimeStamps requestTimeStamp.
         * @member {google.protobuf.ITimestamp|null|undefined} requestTimeStamp
         * @memberof contractpb.EventTimeStamps
         * @instance
         */
        EventTimeStamps.prototype.requestTimeStamp = null;

        /**
         * EventTimeStamps effectiveTimeStamp.
         * @member {google.protobuf.ITimestamp|null|undefined} effectiveTimeStamp
         * @memberof contractpb.EventTimeStamps
         * @instance
         */
        EventTimeStamps.prototype.effectiveTimeStamp = null;

        /**
         * EventTimeStamps cancelTimeStamp.
         * @member {google.protobuf.ITimestamp|null|undefined} cancelTimeStamp
         * @memberof contractpb.EventTimeStamps
         * @instance
         */
        EventTimeStamps.prototype.cancelTimeStamp = null;

        /**
         * EventTimeStamps completeTimeStamp.
         * @member {google.protobuf.ITimestamp|null|undefined} completeTimeStamp
         * @memberof contractpb.EventTimeStamps
         * @instance
         */
        EventTimeStamps.prototype.completeTimeStamp = null;

        /**
         * Creates a new EventTimeStamps instance using the specified properties.
         * @function create
         * @memberof contractpb.EventTimeStamps
         * @static
         * @param {contractpb.IEventTimeStamps=} [properties] Properties to set
         * @returns {contractpb.EventTimeStamps} EventTimeStamps instance
         */
        EventTimeStamps.create = function create(properties) {
            return new EventTimeStamps(properties);
        };

        /**
         * Encodes the specified EventTimeStamps message. Does not implicitly {@link contractpb.EventTimeStamps.verify|verify} messages.
         * @function encode
         * @memberof contractpb.EventTimeStamps
         * @static
         * @param {contractpb.IEventTimeStamps} m EventTimeStamps message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        EventTimeStamps.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.requestTimeStamp != null && Object.hasOwnProperty.call(m, "requestTimeStamp"))
                $root.google.protobuf.Timestamp.encode(m.requestTimeStamp, w.uint32(10).fork()).ldelim();
            if (m.effectiveTimeStamp != null && Object.hasOwnProperty.call(m, "effectiveTimeStamp"))
                $root.google.protobuf.Timestamp.encode(m.effectiveTimeStamp, w.uint32(18).fork()).ldelim();
            if (m.cancelTimeStamp != null && Object.hasOwnProperty.call(m, "cancelTimeStamp"))
                $root.google.protobuf.Timestamp.encode(m.cancelTimeStamp, w.uint32(26).fork()).ldelim();
            if (m.completeTimeStamp != null && Object.hasOwnProperty.call(m, "completeTimeStamp"))
                $root.google.protobuf.Timestamp.encode(m.completeTimeStamp, w.uint32(34).fork()).ldelim();
            return w;
        };

        /**
         * Decodes an EventTimeStamps message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.EventTimeStamps
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.EventTimeStamps} EventTimeStamps
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        EventTimeStamps.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.EventTimeStamps();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.requestTimeStamp = $root.google.protobuf.Timestamp.decode(r, r.uint32());
                    break;
                case 2:
                    m.effectiveTimeStamp = $root.google.protobuf.Timestamp.decode(r, r.uint32());
                    break;
                case 3:
                    m.cancelTimeStamp = $root.google.protobuf.Timestamp.decode(r, r.uint32());
                    break;
                case 4:
                    m.completeTimeStamp = $root.google.protobuf.Timestamp.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return EventTimeStamps;
    })();

    contractpb.ContractChange = (function() {

        /**
         * Properties of a ContractChange.
         * @memberof contractpb
         * @interface IContractChange
         * @property {contractpb.IEventTimeStamps|null} [eventTimeStamps] ContractChange eventTimeStamps
         * @property {string|null} [quoteID] ContractChange quoteID
         * @property {contractpb.QuoteStatus|null} [quoteStatus] ContractChange quoteStatus
         * @property {Array.<contractpb.IFeature>|null} [addOnFeatures] ContractChange addOnFeatures
         * @property {Array.<contractpb.IFeatureBundle>|null} [addOnBundles] ContractChange addOnBundles
         * @property {string|null} [productVersionID] ContractChange productVersionID
         * @property {string|null} [paymentID] ContractChange paymentID
         * @property {string|null} [invoiceID] ContractChange invoiceID
         * @property {string|null} [salesPersonID] ContractChange salesPersonID
         * @property {string|null} [salesPersonName] ContractChange salesPersonName
         * @property {string|null} [modifiedBy] ContractChange modifiedBy
         */

        /**
         * Constructs a new ContractChange.
         * @memberof contractpb
         * @classdesc Represents a ContractChange.
         * @implements IContractChange
         * @constructor
         * @param {contractpb.IContractChange=} [p] Properties to set
         */
        function ContractChange(p) {
            this.addOnFeatures = [];
            this.addOnBundles = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * ContractChange eventTimeStamps.
         * @member {contractpb.IEventTimeStamps|null|undefined} eventTimeStamps
         * @memberof contractpb.ContractChange
         * @instance
         */
        ContractChange.prototype.eventTimeStamps = null;

        /**
         * ContractChange quoteID.
         * @member {string} quoteID
         * @memberof contractpb.ContractChange
         * @instance
         */
        ContractChange.prototype.quoteID = "";

        /**
         * ContractChange quoteStatus.
         * @member {contractpb.QuoteStatus} quoteStatus
         * @memberof contractpb.ContractChange
         * @instance
         */
        ContractChange.prototype.quoteStatus = 0;

        /**
         * ContractChange addOnFeatures.
         * @member {Array.<contractpb.IFeature>} addOnFeatures
         * @memberof contractpb.ContractChange
         * @instance
         */
        ContractChange.prototype.addOnFeatures = $util.emptyArray;

        /**
         * ContractChange addOnBundles.
         * @member {Array.<contractpb.IFeatureBundle>} addOnBundles
         * @memberof contractpb.ContractChange
         * @instance
         */
        ContractChange.prototype.addOnBundles = $util.emptyArray;

        /**
         * ContractChange productVersionID.
         * @member {string} productVersionID
         * @memberof contractpb.ContractChange
         * @instance
         */
        ContractChange.prototype.productVersionID = "";

        /**
         * ContractChange paymentID.
         * @member {string} paymentID
         * @memberof contractpb.ContractChange
         * @instance
         */
        ContractChange.prototype.paymentID = "";

        /**
         * ContractChange invoiceID.
         * @member {string} invoiceID
         * @memberof contractpb.ContractChange
         * @instance
         */
        ContractChange.prototype.invoiceID = "";

        /**
         * ContractChange salesPersonID.
         * @member {string} salesPersonID
         * @memberof contractpb.ContractChange
         * @instance
         */
        ContractChange.prototype.salesPersonID = "";

        /**
         * ContractChange salesPersonName.
         * @member {string} salesPersonName
         * @memberof contractpb.ContractChange
         * @instance
         */
        ContractChange.prototype.salesPersonName = "";

        /**
         * ContractChange modifiedBy.
         * @member {string} modifiedBy
         * @memberof contractpb.ContractChange
         * @instance
         */
        ContractChange.prototype.modifiedBy = "";

        /**
         * Creates a new ContractChange instance using the specified properties.
         * @function create
         * @memberof contractpb.ContractChange
         * @static
         * @param {contractpb.IContractChange=} [properties] Properties to set
         * @returns {contractpb.ContractChange} ContractChange instance
         */
        ContractChange.create = function create(properties) {
            return new ContractChange(properties);
        };

        /**
         * Encodes the specified ContractChange message. Does not implicitly {@link contractpb.ContractChange.verify|verify} messages.
         * @function encode
         * @memberof contractpb.ContractChange
         * @static
         * @param {contractpb.IContractChange} m ContractChange message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ContractChange.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.eventTimeStamps != null && Object.hasOwnProperty.call(m, "eventTimeStamps"))
                $root.contractpb.EventTimeStamps.encode(m.eventTimeStamps, w.uint32(10).fork()).ldelim();
            if (m.quoteID != null && Object.hasOwnProperty.call(m, "quoteID"))
                w.uint32(18).string(m.quoteID);
            if (m.quoteStatus != null && Object.hasOwnProperty.call(m, "quoteStatus"))
                w.uint32(24).int32(m.quoteStatus);
            if (m.addOnFeatures != null && m.addOnFeatures.length) {
                for (var i = 0; i < m.addOnFeatures.length; ++i)
                    $root.contractpb.Feature.encode(m.addOnFeatures[i], w.uint32(34).fork()).ldelim();
            }
            if (m.addOnBundles != null && m.addOnBundles.length) {
                for (var i = 0; i < m.addOnBundles.length; ++i)
                    $root.contractpb.FeatureBundle.encode(m.addOnBundles[i], w.uint32(42).fork()).ldelim();
            }
            if (m.productVersionID != null && Object.hasOwnProperty.call(m, "productVersionID"))
                w.uint32(50).string(m.productVersionID);
            if (m.paymentID != null && Object.hasOwnProperty.call(m, "paymentID"))
                w.uint32(58).string(m.paymentID);
            if (m.invoiceID != null && Object.hasOwnProperty.call(m, "invoiceID"))
                w.uint32(66).string(m.invoiceID);
            if (m.salesPersonID != null && Object.hasOwnProperty.call(m, "salesPersonID"))
                w.uint32(74).string(m.salesPersonID);
            if (m.salesPersonName != null && Object.hasOwnProperty.call(m, "salesPersonName"))
                w.uint32(82).string(m.salesPersonName);
            if (m.modifiedBy != null && Object.hasOwnProperty.call(m, "modifiedBy"))
                w.uint32(90).string(m.modifiedBy);
            return w;
        };

        /**
         * Decodes a ContractChange message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.ContractChange
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.ContractChange} ContractChange
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ContractChange.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.ContractChange();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.eventTimeStamps = $root.contractpb.EventTimeStamps.decode(r, r.uint32());
                    break;
                case 2:
                    m.quoteID = r.string();
                    break;
                case 3:
                    m.quoteStatus = r.int32();
                    break;
                case 4:
                    if (!(m.addOnFeatures && m.addOnFeatures.length))
                        m.addOnFeatures = [];
                    m.addOnFeatures.push($root.contractpb.Feature.decode(r, r.uint32()));
                    break;
                case 5:
                    if (!(m.addOnBundles && m.addOnBundles.length))
                        m.addOnBundles = [];
                    m.addOnBundles.push($root.contractpb.FeatureBundle.decode(r, r.uint32()));
                    break;
                case 6:
                    m.productVersionID = r.string();
                    break;
                case 7:
                    m.paymentID = r.string();
                    break;
                case 8:
                    m.invoiceID = r.string();
                    break;
                case 9:
                    m.salesPersonID = r.string();
                    break;
                case 10:
                    m.salesPersonName = r.string();
                    break;
                case 11:
                    m.modifiedBy = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return ContractChange;
    })();

    contractpb.UpdateInvoiceDetailsRequest = (function() {

        /**
         * Properties of an UpdateInvoiceDetailsRequest.
         * @memberof contractpb
         * @interface IUpdateInvoiceDetailsRequest
         * @property {contractpb.IDateRangeFilter|null} [dateRange] UpdateInvoiceDetailsRequest dateRange
         * @property {contractpb.IContractIDs|null} [contractIDs] UpdateInvoiceDetailsRequest contractIDs
         * @property {boolean|null} [forceUpdate] UpdateInvoiceDetailsRequest forceUpdate
         */

        /**
         * Constructs a new UpdateInvoiceDetailsRequest.
         * @memberof contractpb
         * @classdesc PUT contract/v1/invoice-details
         * @implements IUpdateInvoiceDetailsRequest
         * @constructor
         * @param {contractpb.IUpdateInvoiceDetailsRequest=} [p] Properties to set
         */
        function UpdateInvoiceDetailsRequest(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * UpdateInvoiceDetailsRequest dateRange.
         * @member {contractpb.IDateRangeFilter|null|undefined} dateRange
         * @memberof contractpb.UpdateInvoiceDetailsRequest
         * @instance
         */
        UpdateInvoiceDetailsRequest.prototype.dateRange = null;

        /**
         * UpdateInvoiceDetailsRequest contractIDs.
         * @member {contractpb.IContractIDs|null|undefined} contractIDs
         * @memberof contractpb.UpdateInvoiceDetailsRequest
         * @instance
         */
        UpdateInvoiceDetailsRequest.prototype.contractIDs = null;

        /**
         * UpdateInvoiceDetailsRequest forceUpdate.
         * @member {boolean} forceUpdate
         * @memberof contractpb.UpdateInvoiceDetailsRequest
         * @instance
         */
        UpdateInvoiceDetailsRequest.prototype.forceUpdate = false;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        /**
         * UpdateInvoiceDetailsRequest updateInvoiceDetails.
         * @member {"dateRange"|"contractIDs"|undefined} updateInvoiceDetails
         * @memberof contractpb.UpdateInvoiceDetailsRequest
         * @instance
         */
        Object.defineProperty(UpdateInvoiceDetailsRequest.prototype, "updateInvoiceDetails", {
            get: $util.oneOfGetter($oneOfFields = ["dateRange", "contractIDs"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new UpdateInvoiceDetailsRequest instance using the specified properties.
         * @function create
         * @memberof contractpb.UpdateInvoiceDetailsRequest
         * @static
         * @param {contractpb.IUpdateInvoiceDetailsRequest=} [properties] Properties to set
         * @returns {contractpb.UpdateInvoiceDetailsRequest} UpdateInvoiceDetailsRequest instance
         */
        UpdateInvoiceDetailsRequest.create = function create(properties) {
            return new UpdateInvoiceDetailsRequest(properties);
        };

        /**
         * Encodes the specified UpdateInvoiceDetailsRequest message. Does not implicitly {@link contractpb.UpdateInvoiceDetailsRequest.verify|verify} messages.
         * @function encode
         * @memberof contractpb.UpdateInvoiceDetailsRequest
         * @static
         * @param {contractpb.IUpdateInvoiceDetailsRequest} m UpdateInvoiceDetailsRequest message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UpdateInvoiceDetailsRequest.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.dateRange != null && Object.hasOwnProperty.call(m, "dateRange"))
                $root.contractpb.DateRangeFilter.encode(m.dateRange, w.uint32(10).fork()).ldelim();
            if (m.contractIDs != null && Object.hasOwnProperty.call(m, "contractIDs"))
                $root.contractpb.ContractIDs.encode(m.contractIDs, w.uint32(18).fork()).ldelim();
            if (m.forceUpdate != null && Object.hasOwnProperty.call(m, "forceUpdate"))
                w.uint32(24).bool(m.forceUpdate);
            return w;
        };

        /**
         * Decodes an UpdateInvoiceDetailsRequest message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.UpdateInvoiceDetailsRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.UpdateInvoiceDetailsRequest} UpdateInvoiceDetailsRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UpdateInvoiceDetailsRequest.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.UpdateInvoiceDetailsRequest();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.dateRange = $root.contractpb.DateRangeFilter.decode(r, r.uint32());
                    break;
                case 2:
                    m.contractIDs = $root.contractpb.ContractIDs.decode(r, r.uint32());
                    break;
                case 3:
                    m.forceUpdate = r.bool();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return UpdateInvoiceDetailsRequest;
    })();

    contractpb.DateRangeFilter = (function() {

        /**
         * Properties of a DateRangeFilter.
         * @memberof contractpb
         * @interface IDateRangeFilter
         * @property {common.IDate|null} [startDate] DateRangeFilter startDate
         * @property {common.IDate|null} [endDate] DateRangeFilter endDate
         */

        /**
         * Constructs a new DateRangeFilter.
         * @memberof contractpb
         * @classdesc Represents a DateRangeFilter.
         * @implements IDateRangeFilter
         * @constructor
         * @param {contractpb.IDateRangeFilter=} [p] Properties to set
         */
        function DateRangeFilter(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * DateRangeFilter startDate.
         * @member {common.IDate|null|undefined} startDate
         * @memberof contractpb.DateRangeFilter
         * @instance
         */
        DateRangeFilter.prototype.startDate = null;

        /**
         * DateRangeFilter endDate.
         * @member {common.IDate|null|undefined} endDate
         * @memberof contractpb.DateRangeFilter
         * @instance
         */
        DateRangeFilter.prototype.endDate = null;

        /**
         * Creates a new DateRangeFilter instance using the specified properties.
         * @function create
         * @memberof contractpb.DateRangeFilter
         * @static
         * @param {contractpb.IDateRangeFilter=} [properties] Properties to set
         * @returns {contractpb.DateRangeFilter} DateRangeFilter instance
         */
        DateRangeFilter.create = function create(properties) {
            return new DateRangeFilter(properties);
        };

        /**
         * Encodes the specified DateRangeFilter message. Does not implicitly {@link contractpb.DateRangeFilter.verify|verify} messages.
         * @function encode
         * @memberof contractpb.DateRangeFilter
         * @static
         * @param {contractpb.IDateRangeFilter} m DateRangeFilter message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        DateRangeFilter.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.startDate != null && Object.hasOwnProperty.call(m, "startDate"))
                $root.common.Date.encode(m.startDate, w.uint32(10).fork()).ldelim();
            if (m.endDate != null && Object.hasOwnProperty.call(m, "endDate"))
                $root.common.Date.encode(m.endDate, w.uint32(18).fork()).ldelim();
            return w;
        };

        /**
         * Decodes a DateRangeFilter message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.DateRangeFilter
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.DateRangeFilter} DateRangeFilter
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        DateRangeFilter.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.DateRangeFilter();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.startDate = $root.common.Date.decode(r, r.uint32());
                    break;
                case 2:
                    m.endDate = $root.common.Date.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return DateRangeFilter;
    })();

    contractpb.UpdateInvoiceDetailsResponse = (function() {

        /**
         * Properties of an UpdateInvoiceDetailsResponse.
         * @memberof contractpb
         * @interface IUpdateInvoiceDetailsResponse
         * @property {common.IError|null} [error] UpdateInvoiceDetailsResponse error
         */

        /**
         * Constructs a new UpdateInvoiceDetailsResponse.
         * @memberof contractpb
         * @classdesc Represents an UpdateInvoiceDetailsResponse.
         * @implements IUpdateInvoiceDetailsResponse
         * @constructor
         * @param {contractpb.IUpdateInvoiceDetailsResponse=} [p] Properties to set
         */
        function UpdateInvoiceDetailsResponse(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * UpdateInvoiceDetailsResponse error.
         * @member {common.IError|null|undefined} error
         * @memberof contractpb.UpdateInvoiceDetailsResponse
         * @instance
         */
        UpdateInvoiceDetailsResponse.prototype.error = null;

        /**
         * Creates a new UpdateInvoiceDetailsResponse instance using the specified properties.
         * @function create
         * @memberof contractpb.UpdateInvoiceDetailsResponse
         * @static
         * @param {contractpb.IUpdateInvoiceDetailsResponse=} [properties] Properties to set
         * @returns {contractpb.UpdateInvoiceDetailsResponse} UpdateInvoiceDetailsResponse instance
         */
        UpdateInvoiceDetailsResponse.create = function create(properties) {
            return new UpdateInvoiceDetailsResponse(properties);
        };

        /**
         * Encodes the specified UpdateInvoiceDetailsResponse message. Does not implicitly {@link contractpb.UpdateInvoiceDetailsResponse.verify|verify} messages.
         * @function encode
         * @memberof contractpb.UpdateInvoiceDetailsResponse
         * @static
         * @param {contractpb.IUpdateInvoiceDetailsResponse} m UpdateInvoiceDetailsResponse message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UpdateInvoiceDetailsResponse.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.error != null && Object.hasOwnProperty.call(m, "error"))
                $root.common.Error.encode(m.error, w.uint32(10).fork()).ldelim();
            return w;
        };

        /**
         * Decodes an UpdateInvoiceDetailsResponse message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.UpdateInvoiceDetailsResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.UpdateInvoiceDetailsResponse} UpdateInvoiceDetailsResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UpdateInvoiceDetailsResponse.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.UpdateInvoiceDetailsResponse();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.error = $root.common.Error.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return UpdateInvoiceDetailsResponse;
    })();

    contractpb.CancelContractRequestV2 = (function() {

        /**
         * Properties of a CancelContractRequestV2.
         * @memberof contractpb
         * @interface ICancelContractRequestV2
         * @property {string|null} [cancelDate] CancelContractRequestV2 cancelDate
         * @property {string|null} [cancelReason] CancelContractRequestV2 cancelReason
         * @property {string|null} [cancelReasonPrefix] CancelContractRequestV2 cancelReasonPrefix
         * @property {string|null} [contractID] CancelContractRequestV2 contractID
         * @property {string|null} [userName] CancelContractRequestV2 userName
         * @property {string|null} [userID] CancelContractRequestV2 userID
         * @property {string|null} [cancelType] CancelContractRequestV2 cancelType
         * @property {string|null} [customerID] CancelContractRequestV2 customerID
         * @property {string|null} [letterType] CancelContractRequestV2 letterType
         * @property {number|Long|null} [propertyID] CancelContractRequestV2 propertyID
         * @property {boolean|null} [isPayingNow] CancelContractRequestV2 isPayingNow
         * @property {number|null} [premiumPaidAfterCancelDate] CancelContractRequestV2 premiumPaidAfterCancelDate
         * @property {number|null} [refundAmount] CancelContractRequestV2 refundAmount
         * @property {number|null} [adminFee] CancelContractRequestV2 adminFee
         * @property {number|null} [customerOweAmount] CancelContractRequestV2 customerOweAmount
         * @property {string|null} [refundBy] CancelContractRequestV2 refundBy
         * @property {number|null} [paymentReceived] CancelContractRequestV2 paymentReceived
         * @property {boolean|null} [isCustomerOwe] CancelContractRequestV2 isCustomerOwe
         * @property {boolean|null} [isAHSOwesToCustomer] CancelContractRequestV2 isAHSOwesToCustomer
         * @property {number|null} [contractPrice] CancelContractRequestV2 contractPrice
         * @property {number|null} [activeCost] CancelContractRequestV2 activeCost
         * @property {contractpb.IInvoiceAmount|null} [invoiceAmounts] CancelContractRequestV2 invoiceAmounts
         * @property {number|null} [serviceCostRecoveryAmount] CancelContractRequestV2 serviceCostRecoveryAmount
         * @property {string|null} [effectiveDate] CancelContractRequestV2 effectiveDate
         */

        /**
         * Constructs a new CancelContractRequestV2.
         * @memberof contractpb
         * @classdesc Represents a CancelContractRequestV2.
         * @implements ICancelContractRequestV2
         * @constructor
         * @param {contractpb.ICancelContractRequestV2=} [p] Properties to set
         */
        function CancelContractRequestV2(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * CancelContractRequestV2 cancelDate.
         * @member {string} cancelDate
         * @memberof contractpb.CancelContractRequestV2
         * @instance
         */
        CancelContractRequestV2.prototype.cancelDate = "";

        /**
         * CancelContractRequestV2 cancelReason.
         * @member {string} cancelReason
         * @memberof contractpb.CancelContractRequestV2
         * @instance
         */
        CancelContractRequestV2.prototype.cancelReason = "";

        /**
         * CancelContractRequestV2 cancelReasonPrefix.
         * @member {string} cancelReasonPrefix
         * @memberof contractpb.CancelContractRequestV2
         * @instance
         */
        CancelContractRequestV2.prototype.cancelReasonPrefix = "";

        /**
         * CancelContractRequestV2 contractID.
         * @member {string} contractID
         * @memberof contractpb.CancelContractRequestV2
         * @instance
         */
        CancelContractRequestV2.prototype.contractID = "";

        /**
         * CancelContractRequestV2 userName.
         * @member {string} userName
         * @memberof contractpb.CancelContractRequestV2
         * @instance
         */
        CancelContractRequestV2.prototype.userName = "";

        /**
         * CancelContractRequestV2 userID.
         * @member {string} userID
         * @memberof contractpb.CancelContractRequestV2
         * @instance
         */
        CancelContractRequestV2.prototype.userID = "";

        /**
         * CancelContractRequestV2 cancelType.
         * @member {string} cancelType
         * @memberof contractpb.CancelContractRequestV2
         * @instance
         */
        CancelContractRequestV2.prototype.cancelType = "";

        /**
         * CancelContractRequestV2 customerID.
         * @member {string} customerID
         * @memberof contractpb.CancelContractRequestV2
         * @instance
         */
        CancelContractRequestV2.prototype.customerID = "";

        /**
         * CancelContractRequestV2 letterType.
         * @member {string} letterType
         * @memberof contractpb.CancelContractRequestV2
         * @instance
         */
        CancelContractRequestV2.prototype.letterType = "";

        /**
         * CancelContractRequestV2 propertyID.
         * @member {number|Long} propertyID
         * @memberof contractpb.CancelContractRequestV2
         * @instance
         */
        CancelContractRequestV2.prototype.propertyID = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * CancelContractRequestV2 isPayingNow.
         * @member {boolean} isPayingNow
         * @memberof contractpb.CancelContractRequestV2
         * @instance
         */
        CancelContractRequestV2.prototype.isPayingNow = false;

        /**
         * CancelContractRequestV2 premiumPaidAfterCancelDate.
         * @member {number} premiumPaidAfterCancelDate
         * @memberof contractpb.CancelContractRequestV2
         * @instance
         */
        CancelContractRequestV2.prototype.premiumPaidAfterCancelDate = 0;

        /**
         * CancelContractRequestV2 refundAmount.
         * @member {number} refundAmount
         * @memberof contractpb.CancelContractRequestV2
         * @instance
         */
        CancelContractRequestV2.prototype.refundAmount = 0;

        /**
         * CancelContractRequestV2 adminFee.
         * @member {number} adminFee
         * @memberof contractpb.CancelContractRequestV2
         * @instance
         */
        CancelContractRequestV2.prototype.adminFee = 0;

        /**
         * CancelContractRequestV2 customerOweAmount.
         * @member {number} customerOweAmount
         * @memberof contractpb.CancelContractRequestV2
         * @instance
         */
        CancelContractRequestV2.prototype.customerOweAmount = 0;

        /**
         * CancelContractRequestV2 refundBy.
         * @member {string} refundBy
         * @memberof contractpb.CancelContractRequestV2
         * @instance
         */
        CancelContractRequestV2.prototype.refundBy = "";

        /**
         * CancelContractRequestV2 paymentReceived.
         * @member {number} paymentReceived
         * @memberof contractpb.CancelContractRequestV2
         * @instance
         */
        CancelContractRequestV2.prototype.paymentReceived = 0;

        /**
         * CancelContractRequestV2 isCustomerOwe.
         * @member {boolean} isCustomerOwe
         * @memberof contractpb.CancelContractRequestV2
         * @instance
         */
        CancelContractRequestV2.prototype.isCustomerOwe = false;

        /**
         * CancelContractRequestV2 isAHSOwesToCustomer.
         * @member {boolean} isAHSOwesToCustomer
         * @memberof contractpb.CancelContractRequestV2
         * @instance
         */
        CancelContractRequestV2.prototype.isAHSOwesToCustomer = false;

        /**
         * CancelContractRequestV2 contractPrice.
         * @member {number} contractPrice
         * @memberof contractpb.CancelContractRequestV2
         * @instance
         */
        CancelContractRequestV2.prototype.contractPrice = 0;

        /**
         * CancelContractRequestV2 activeCost.
         * @member {number} activeCost
         * @memberof contractpb.CancelContractRequestV2
         * @instance
         */
        CancelContractRequestV2.prototype.activeCost = 0;

        /**
         * CancelContractRequestV2 invoiceAmounts.
         * @member {contractpb.IInvoiceAmount|null|undefined} invoiceAmounts
         * @memberof contractpb.CancelContractRequestV2
         * @instance
         */
        CancelContractRequestV2.prototype.invoiceAmounts = null;

        /**
         * CancelContractRequestV2 serviceCostRecoveryAmount.
         * @member {number} serviceCostRecoveryAmount
         * @memberof contractpb.CancelContractRequestV2
         * @instance
         */
        CancelContractRequestV2.prototype.serviceCostRecoveryAmount = 0;

        /**
         * CancelContractRequestV2 effectiveDate.
         * @member {string} effectiveDate
         * @memberof contractpb.CancelContractRequestV2
         * @instance
         */
        CancelContractRequestV2.prototype.effectiveDate = "";

        /**
         * Creates a new CancelContractRequestV2 instance using the specified properties.
         * @function create
         * @memberof contractpb.CancelContractRequestV2
         * @static
         * @param {contractpb.ICancelContractRequestV2=} [properties] Properties to set
         * @returns {contractpb.CancelContractRequestV2} CancelContractRequestV2 instance
         */
        CancelContractRequestV2.create = function create(properties) {
            return new CancelContractRequestV2(properties);
        };

        /**
         * Encodes the specified CancelContractRequestV2 message. Does not implicitly {@link contractpb.CancelContractRequestV2.verify|verify} messages.
         * @function encode
         * @memberof contractpb.CancelContractRequestV2
         * @static
         * @param {contractpb.ICancelContractRequestV2} m CancelContractRequestV2 message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CancelContractRequestV2.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.cancelDate != null && Object.hasOwnProperty.call(m, "cancelDate"))
                w.uint32(10).string(m.cancelDate);
            if (m.cancelReason != null && Object.hasOwnProperty.call(m, "cancelReason"))
                w.uint32(18).string(m.cancelReason);
            if (m.cancelReasonPrefix != null && Object.hasOwnProperty.call(m, "cancelReasonPrefix"))
                w.uint32(26).string(m.cancelReasonPrefix);
            if (m.contractID != null && Object.hasOwnProperty.call(m, "contractID"))
                w.uint32(34).string(m.contractID);
            if (m.userName != null && Object.hasOwnProperty.call(m, "userName"))
                w.uint32(42).string(m.userName);
            if (m.userID != null && Object.hasOwnProperty.call(m, "userID"))
                w.uint32(50).string(m.userID);
            if (m.cancelType != null && Object.hasOwnProperty.call(m, "cancelType"))
                w.uint32(58).string(m.cancelType);
            if (m.customerID != null && Object.hasOwnProperty.call(m, "customerID"))
                w.uint32(66).string(m.customerID);
            if (m.letterType != null && Object.hasOwnProperty.call(m, "letterType"))
                w.uint32(74).string(m.letterType);
            if (m.propertyID != null && Object.hasOwnProperty.call(m, "propertyID"))
                w.uint32(80).int64(m.propertyID);
            if (m.isPayingNow != null && Object.hasOwnProperty.call(m, "isPayingNow"))
                w.uint32(88).bool(m.isPayingNow);
            if (m.premiumPaidAfterCancelDate != null && Object.hasOwnProperty.call(m, "premiumPaidAfterCancelDate"))
                w.uint32(97).double(m.premiumPaidAfterCancelDate);
            if (m.refundAmount != null && Object.hasOwnProperty.call(m, "refundAmount"))
                w.uint32(105).double(m.refundAmount);
            if (m.adminFee != null && Object.hasOwnProperty.call(m, "adminFee"))
                w.uint32(113).double(m.adminFee);
            if (m.customerOweAmount != null && Object.hasOwnProperty.call(m, "customerOweAmount"))
                w.uint32(121).double(m.customerOweAmount);
            if (m.refundBy != null && Object.hasOwnProperty.call(m, "refundBy"))
                w.uint32(130).string(m.refundBy);
            if (m.paymentReceived != null && Object.hasOwnProperty.call(m, "paymentReceived"))
                w.uint32(137).double(m.paymentReceived);
            if (m.isCustomerOwe != null && Object.hasOwnProperty.call(m, "isCustomerOwe"))
                w.uint32(144).bool(m.isCustomerOwe);
            if (m.isAHSOwesToCustomer != null && Object.hasOwnProperty.call(m, "isAHSOwesToCustomer"))
                w.uint32(152).bool(m.isAHSOwesToCustomer);
            if (m.contractPrice != null && Object.hasOwnProperty.call(m, "contractPrice"))
                w.uint32(161).double(m.contractPrice);
            if (m.activeCost != null && Object.hasOwnProperty.call(m, "activeCost"))
                w.uint32(169).double(m.activeCost);
            if (m.invoiceAmounts != null && Object.hasOwnProperty.call(m, "invoiceAmounts"))
                $root.contractpb.InvoiceAmount.encode(m.invoiceAmounts, w.uint32(178).fork()).ldelim();
            if (m.serviceCostRecoveryAmount != null && Object.hasOwnProperty.call(m, "serviceCostRecoveryAmount"))
                w.uint32(185).double(m.serviceCostRecoveryAmount);
            if (m.effectiveDate != null && Object.hasOwnProperty.call(m, "effectiveDate"))
                w.uint32(194).string(m.effectiveDate);
            return w;
        };

        /**
         * Decodes a CancelContractRequestV2 message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.CancelContractRequestV2
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.CancelContractRequestV2} CancelContractRequestV2
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CancelContractRequestV2.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.CancelContractRequestV2();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.cancelDate = r.string();
                    break;
                case 2:
                    m.cancelReason = r.string();
                    break;
                case 3:
                    m.cancelReasonPrefix = r.string();
                    break;
                case 4:
                    m.contractID = r.string();
                    break;
                case 5:
                    m.userName = r.string();
                    break;
                case 6:
                    m.userID = r.string();
                    break;
                case 7:
                    m.cancelType = r.string();
                    break;
                case 8:
                    m.customerID = r.string();
                    break;
                case 9:
                    m.letterType = r.string();
                    break;
                case 10:
                    m.propertyID = r.int64();
                    break;
                case 11:
                    m.isPayingNow = r.bool();
                    break;
                case 12:
                    m.premiumPaidAfterCancelDate = r.double();
                    break;
                case 13:
                    m.refundAmount = r.double();
                    break;
                case 14:
                    m.adminFee = r.double();
                    break;
                case 15:
                    m.customerOweAmount = r.double();
                    break;
                case 16:
                    m.refundBy = r.string();
                    break;
                case 17:
                    m.paymentReceived = r.double();
                    break;
                case 18:
                    m.isCustomerOwe = r.bool();
                    break;
                case 19:
                    m.isAHSOwesToCustomer = r.bool();
                    break;
                case 20:
                    m.contractPrice = r.double();
                    break;
                case 21:
                    m.activeCost = r.double();
                    break;
                case 22:
                    m.invoiceAmounts = $root.contractpb.InvoiceAmount.decode(r, r.uint32());
                    break;
                case 23:
                    m.serviceCostRecoveryAmount = r.double();
                    break;
                case 24:
                    m.effectiveDate = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return CancelContractRequestV2;
    })();

    contractpb.CancelContractResponseV2 = (function() {

        /**
         * Properties of a CancelContractResponseV2.
         * @memberof contractpb
         * @interface ICancelContractResponseV2
         * @property {boolean|null} [isCancelled] CancelContractResponseV2 isCancelled
         * @property {common.IError|null} [error] CancelContractResponseV2 error
         */

        /**
         * Constructs a new CancelContractResponseV2.
         * @memberof contractpb
         * @classdesc Represents a CancelContractResponseV2.
         * @implements ICancelContractResponseV2
         * @constructor
         * @param {contractpb.ICancelContractResponseV2=} [p] Properties to set
         */
        function CancelContractResponseV2(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * CancelContractResponseV2 isCancelled.
         * @member {boolean} isCancelled
         * @memberof contractpb.CancelContractResponseV2
         * @instance
         */
        CancelContractResponseV2.prototype.isCancelled = false;

        /**
         * CancelContractResponseV2 error.
         * @member {common.IError|null|undefined} error
         * @memberof contractpb.CancelContractResponseV2
         * @instance
         */
        CancelContractResponseV2.prototype.error = null;

        /**
         * Creates a new CancelContractResponseV2 instance using the specified properties.
         * @function create
         * @memberof contractpb.CancelContractResponseV2
         * @static
         * @param {contractpb.ICancelContractResponseV2=} [properties] Properties to set
         * @returns {contractpb.CancelContractResponseV2} CancelContractResponseV2 instance
         */
        CancelContractResponseV2.create = function create(properties) {
            return new CancelContractResponseV2(properties);
        };

        /**
         * Encodes the specified CancelContractResponseV2 message. Does not implicitly {@link contractpb.CancelContractResponseV2.verify|verify} messages.
         * @function encode
         * @memberof contractpb.CancelContractResponseV2
         * @static
         * @param {contractpb.ICancelContractResponseV2} m CancelContractResponseV2 message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CancelContractResponseV2.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.isCancelled != null && Object.hasOwnProperty.call(m, "isCancelled"))
                w.uint32(8).bool(m.isCancelled);
            if (m.error != null && Object.hasOwnProperty.call(m, "error"))
                $root.common.Error.encode(m.error, w.uint32(18).fork()).ldelim();
            return w;
        };

        /**
         * Decodes a CancelContractResponseV2 message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.CancelContractResponseV2
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.CancelContractResponseV2} CancelContractResponseV2
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CancelContractResponseV2.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.CancelContractResponseV2();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.isCancelled = r.bool();
                    break;
                case 2:
                    m.error = $root.common.Error.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return CancelContractResponseV2;
    })();

    contractpb.BillingDateChangeabilityRequest = (function() {

        /**
         * Properties of a BillingDateChangeabilityRequest.
         * @memberof contractpb
         * @interface IBillingDateChangeabilityRequest
         * @property {string|null} [contractId] BillingDateChangeabilityRequest contractId
         */

        /**
         * Constructs a new BillingDateChangeabilityRequest.
         * @memberof contractpb
         * @classdesc Get BillingChangeability /contract/v1/billingdatechangeability request Object
         * this Request will will test/validate if Billing date can be changed for a given contract
         * @implements IBillingDateChangeabilityRequest
         * @constructor
         * @param {contractpb.IBillingDateChangeabilityRequest=} [p] Properties to set
         */
        function BillingDateChangeabilityRequest(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * BillingDateChangeabilityRequest contractId.
         * @member {string} contractId
         * @memberof contractpb.BillingDateChangeabilityRequest
         * @instance
         */
        BillingDateChangeabilityRequest.prototype.contractId = "";

        /**
         * Creates a new BillingDateChangeabilityRequest instance using the specified properties.
         * @function create
         * @memberof contractpb.BillingDateChangeabilityRequest
         * @static
         * @param {contractpb.IBillingDateChangeabilityRequest=} [properties] Properties to set
         * @returns {contractpb.BillingDateChangeabilityRequest} BillingDateChangeabilityRequest instance
         */
        BillingDateChangeabilityRequest.create = function create(properties) {
            return new BillingDateChangeabilityRequest(properties);
        };

        /**
         * Encodes the specified BillingDateChangeabilityRequest message. Does not implicitly {@link contractpb.BillingDateChangeabilityRequest.verify|verify} messages.
         * @function encode
         * @memberof contractpb.BillingDateChangeabilityRequest
         * @static
         * @param {contractpb.IBillingDateChangeabilityRequest} m BillingDateChangeabilityRequest message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        BillingDateChangeabilityRequest.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.contractId != null && Object.hasOwnProperty.call(m, "contractId"))
                w.uint32(10).string(m.contractId);
            return w;
        };

        /**
         * Decodes a BillingDateChangeabilityRequest message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.BillingDateChangeabilityRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.BillingDateChangeabilityRequest} BillingDateChangeabilityRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        BillingDateChangeabilityRequest.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.BillingDateChangeabilityRequest();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.contractId = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return BillingDateChangeabilityRequest;
    })();

    contractpb.BillingDateChangeabilityResponse = (function() {

        /**
         * Properties of a BillingDateChangeabilityResponse.
         * @memberof contractpb
         * @interface IBillingDateChangeabilityResponse
         * @property {boolean|null} [isAllowed] BillingDateChangeabilityResponse isAllowed
         * @property {Array.<common.IError>|null} [errors] BillingDateChangeabilityResponse errors
         */

        /**
         * Constructs a new BillingDateChangeabilityResponse.
         * @memberof contractpb
         * @classdesc Get BillingChangeability /contract/v1/billingdatechangeability response Object
         * @implements IBillingDateChangeabilityResponse
         * @constructor
         * @param {contractpb.IBillingDateChangeabilityResponse=} [p] Properties to set
         */
        function BillingDateChangeabilityResponse(p) {
            this.errors = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * BillingDateChangeabilityResponse isAllowed.
         * @member {boolean} isAllowed
         * @memberof contractpb.BillingDateChangeabilityResponse
         * @instance
         */
        BillingDateChangeabilityResponse.prototype.isAllowed = false;

        /**
         * BillingDateChangeabilityResponse errors.
         * @member {Array.<common.IError>} errors
         * @memberof contractpb.BillingDateChangeabilityResponse
         * @instance
         */
        BillingDateChangeabilityResponse.prototype.errors = $util.emptyArray;

        /**
         * Creates a new BillingDateChangeabilityResponse instance using the specified properties.
         * @function create
         * @memberof contractpb.BillingDateChangeabilityResponse
         * @static
         * @param {contractpb.IBillingDateChangeabilityResponse=} [properties] Properties to set
         * @returns {contractpb.BillingDateChangeabilityResponse} BillingDateChangeabilityResponse instance
         */
        BillingDateChangeabilityResponse.create = function create(properties) {
            return new BillingDateChangeabilityResponse(properties);
        };

        /**
         * Encodes the specified BillingDateChangeabilityResponse message. Does not implicitly {@link contractpb.BillingDateChangeabilityResponse.verify|verify} messages.
         * @function encode
         * @memberof contractpb.BillingDateChangeabilityResponse
         * @static
         * @param {contractpb.IBillingDateChangeabilityResponse} m BillingDateChangeabilityResponse message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        BillingDateChangeabilityResponse.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.isAllowed != null && Object.hasOwnProperty.call(m, "isAllowed"))
                w.uint32(8).bool(m.isAllowed);
            if (m.errors != null && m.errors.length) {
                for (var i = 0; i < m.errors.length; ++i)
                    $root.common.Error.encode(m.errors[i], w.uint32(18).fork()).ldelim();
            }
            return w;
        };

        /**
         * Decodes a BillingDateChangeabilityResponse message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.BillingDateChangeabilityResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.BillingDateChangeabilityResponse} BillingDateChangeabilityResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        BillingDateChangeabilityResponse.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.BillingDateChangeabilityResponse();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.isAllowed = r.bool();
                    break;
                case 2:
                    if (!(m.errors && m.errors.length))
                        m.errors = [];
                    m.errors.push($root.common.Error.decode(r, r.uint32()));
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return BillingDateChangeabilityResponse;
    })();

    contractpb.ImportStarToMongoRequest = (function() {

        /**
         * Properties of an ImportStarToMongoRequest.
         * @memberof contractpb
         * @interface IImportStarToMongoRequest
         * @property {Array.<string>|null} [contractIds] ImportStarToMongoRequest contractIds
         * @property {string|null} [beginDate] ImportStarToMongoRequest beginDate
         * @property {string|null} [endDate] ImportStarToMongoRequest endDate
         */

        /**
         * Constructs a new ImportStarToMongoRequest.
         * @memberof contractpb
         * @classdesc POST /contract/v1/import/star-to-mongo
         * This API is used either via DES or manully to trigger the operation of importing contracts from star to mongo
         * When all 3 fields are provided, the contractIDs list takes precedence. The beginDate and endDate are
         * expected to be in the format DD-MM-YYYY, that is 30-04-2024
         * 
         * Possible Responses:
         * HttpStatusCode:
         * * 204: No Contents, the import operation started successfully
         * * 400: Bad Request, the proto request could not be unmarsharlled etc
         * * 500: Internal Server Error, something went bad with starting the import operations
         * @implements IImportStarToMongoRequest
         * @constructor
         * @param {contractpb.IImportStarToMongoRequest=} [p] Properties to set
         */
        function ImportStarToMongoRequest(p) {
            this.contractIds = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * ImportStarToMongoRequest contractIds.
         * @member {Array.<string>} contractIds
         * @memberof contractpb.ImportStarToMongoRequest
         * @instance
         */
        ImportStarToMongoRequest.prototype.contractIds = $util.emptyArray;

        /**
         * ImportStarToMongoRequest beginDate.
         * @member {string} beginDate
         * @memberof contractpb.ImportStarToMongoRequest
         * @instance
         */
        ImportStarToMongoRequest.prototype.beginDate = "";

        /**
         * ImportStarToMongoRequest endDate.
         * @member {string} endDate
         * @memberof contractpb.ImportStarToMongoRequest
         * @instance
         */
        ImportStarToMongoRequest.prototype.endDate = "";

        /**
         * Creates a new ImportStarToMongoRequest instance using the specified properties.
         * @function create
         * @memberof contractpb.ImportStarToMongoRequest
         * @static
         * @param {contractpb.IImportStarToMongoRequest=} [properties] Properties to set
         * @returns {contractpb.ImportStarToMongoRequest} ImportStarToMongoRequest instance
         */
        ImportStarToMongoRequest.create = function create(properties) {
            return new ImportStarToMongoRequest(properties);
        };

        /**
         * Encodes the specified ImportStarToMongoRequest message. Does not implicitly {@link contractpb.ImportStarToMongoRequest.verify|verify} messages.
         * @function encode
         * @memberof contractpb.ImportStarToMongoRequest
         * @static
         * @param {contractpb.IImportStarToMongoRequest} m ImportStarToMongoRequest message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ImportStarToMongoRequest.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.contractIds != null && m.contractIds.length) {
                for (var i = 0; i < m.contractIds.length; ++i)
                    w.uint32(10).string(m.contractIds[i]);
            }
            if (m.beginDate != null && Object.hasOwnProperty.call(m, "beginDate"))
                w.uint32(18).string(m.beginDate);
            if (m.endDate != null && Object.hasOwnProperty.call(m, "endDate"))
                w.uint32(26).string(m.endDate);
            return w;
        };

        /**
         * Decodes an ImportStarToMongoRequest message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.ImportStarToMongoRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.ImportStarToMongoRequest} ImportStarToMongoRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ImportStarToMongoRequest.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.ImportStarToMongoRequest();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    if (!(m.contractIds && m.contractIds.length))
                        m.contractIds = [];
                    m.contractIds.push(r.string());
                    break;
                case 2:
                    m.beginDate = r.string();
                    break;
                case 3:
                    m.endDate = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return ImportStarToMongoRequest;
    })();

    contractpb.DeleteContractRequest = (function() {

        /**
         * Properties of a DeleteContractRequest.
         * @memberof contractpb
         * @interface IDeleteContractRequest
         * @property {string|null} [salesSourceID] DeleteContractRequest salesSourceID
         */

        /**
         * Constructs a new DeleteContractRequest.
         * @memberof contractpb
         * @classdesc Represents a DeleteContractRequest.
         * @implements IDeleteContractRequest
         * @constructor
         * @param {contractpb.IDeleteContractRequest=} [p] Properties to set
         */
        function DeleteContractRequest(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * DeleteContractRequest salesSourceID.
         * @member {string} salesSourceID
         * @memberof contractpb.DeleteContractRequest
         * @instance
         */
        DeleteContractRequest.prototype.salesSourceID = "";

        /**
         * Creates a new DeleteContractRequest instance using the specified properties.
         * @function create
         * @memberof contractpb.DeleteContractRequest
         * @static
         * @param {contractpb.IDeleteContractRequest=} [properties] Properties to set
         * @returns {contractpb.DeleteContractRequest} DeleteContractRequest instance
         */
        DeleteContractRequest.create = function create(properties) {
            return new DeleteContractRequest(properties);
        };

        /**
         * Encodes the specified DeleteContractRequest message. Does not implicitly {@link contractpb.DeleteContractRequest.verify|verify} messages.
         * @function encode
         * @memberof contractpb.DeleteContractRequest
         * @static
         * @param {contractpb.IDeleteContractRequest} m DeleteContractRequest message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        DeleteContractRequest.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.salesSourceID != null && Object.hasOwnProperty.call(m, "salesSourceID"))
                w.uint32(10).string(m.salesSourceID);
            return w;
        };

        /**
         * Decodes a DeleteContractRequest message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.DeleteContractRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.DeleteContractRequest} DeleteContractRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        DeleteContractRequest.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.DeleteContractRequest();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.salesSourceID = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return DeleteContractRequest;
    })();

    contractpb.DeleteContractResponse = (function() {

        /**
         * Properties of a DeleteContractResponse.
         * @memberof contractpb
         * @interface IDeleteContractResponse
         * @property {common.IError|null} [error] DeleteContractResponse error
         */

        /**
         * Constructs a new DeleteContractResponse.
         * @memberof contractpb
         * @classdesc Represents a DeleteContractResponse.
         * @implements IDeleteContractResponse
         * @constructor
         * @param {contractpb.IDeleteContractResponse=} [p] Properties to set
         */
        function DeleteContractResponse(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * DeleteContractResponse error.
         * @member {common.IError|null|undefined} error
         * @memberof contractpb.DeleteContractResponse
         * @instance
         */
        DeleteContractResponse.prototype.error = null;

        /**
         * Creates a new DeleteContractResponse instance using the specified properties.
         * @function create
         * @memberof contractpb.DeleteContractResponse
         * @static
         * @param {contractpb.IDeleteContractResponse=} [properties] Properties to set
         * @returns {contractpb.DeleteContractResponse} DeleteContractResponse instance
         */
        DeleteContractResponse.create = function create(properties) {
            return new DeleteContractResponse(properties);
        };

        /**
         * Encodes the specified DeleteContractResponse message. Does not implicitly {@link contractpb.DeleteContractResponse.verify|verify} messages.
         * @function encode
         * @memberof contractpb.DeleteContractResponse
         * @static
         * @param {contractpb.IDeleteContractResponse} m DeleteContractResponse message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        DeleteContractResponse.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.error != null && Object.hasOwnProperty.call(m, "error"))
                $root.common.Error.encode(m.error, w.uint32(10).fork()).ldelim();
            return w;
        };

        /**
         * Decodes a DeleteContractResponse message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.DeleteContractResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.DeleteContractResponse} DeleteContractResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        DeleteContractResponse.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.DeleteContractResponse();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.error = $root.common.Error.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return DeleteContractResponse;
    })();

    contractpb.DeleteContractCoverageRequest = (function() {

        /**
         * Properties of a DeleteContractCoverageRequest.
         * @memberof contractpb
         * @interface IDeleteContractCoverageRequest
         * @property {string|null} [contractID] DeleteContractCoverageRequest contractID
         * @property {string|null} [quoteID] DeleteContractCoverageRequest quoteID
         */

        /**
         * Constructs a new DeleteContractCoverageRequest.
         * @memberof contractpb
         * @classdesc Represents a DeleteContractCoverageRequest.
         * @implements IDeleteContractCoverageRequest
         * @constructor
         * @param {contractpb.IDeleteContractCoverageRequest=} [p] Properties to set
         */
        function DeleteContractCoverageRequest(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * DeleteContractCoverageRequest contractID.
         * @member {string} contractID
         * @memberof contractpb.DeleteContractCoverageRequest
         * @instance
         */
        DeleteContractCoverageRequest.prototype.contractID = "";

        /**
         * DeleteContractCoverageRequest quoteID.
         * @member {string} quoteID
         * @memberof contractpb.DeleteContractCoverageRequest
         * @instance
         */
        DeleteContractCoverageRequest.prototype.quoteID = "";

        /**
         * Creates a new DeleteContractCoverageRequest instance using the specified properties.
         * @function create
         * @memberof contractpb.DeleteContractCoverageRequest
         * @static
         * @param {contractpb.IDeleteContractCoverageRequest=} [properties] Properties to set
         * @returns {contractpb.DeleteContractCoverageRequest} DeleteContractCoverageRequest instance
         */
        DeleteContractCoverageRequest.create = function create(properties) {
            return new DeleteContractCoverageRequest(properties);
        };

        /**
         * Encodes the specified DeleteContractCoverageRequest message. Does not implicitly {@link contractpb.DeleteContractCoverageRequest.verify|verify} messages.
         * @function encode
         * @memberof contractpb.DeleteContractCoverageRequest
         * @static
         * @param {contractpb.IDeleteContractCoverageRequest} m DeleteContractCoverageRequest message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        DeleteContractCoverageRequest.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.contractID != null && Object.hasOwnProperty.call(m, "contractID"))
                w.uint32(10).string(m.contractID);
            if (m.quoteID != null && Object.hasOwnProperty.call(m, "quoteID"))
                w.uint32(18).string(m.quoteID);
            return w;
        };

        /**
         * Decodes a DeleteContractCoverageRequest message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.DeleteContractCoverageRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.DeleteContractCoverageRequest} DeleteContractCoverageRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        DeleteContractCoverageRequest.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.DeleteContractCoverageRequest();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.contractID = r.string();
                    break;
                case 2:
                    m.quoteID = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return DeleteContractCoverageRequest;
    })();

    contractpb.DeleteContractCoverageResponse = (function() {

        /**
         * Properties of a DeleteContractCoverageResponse.
         * @memberof contractpb
         * @interface IDeleteContractCoverageResponse
         * @property {common.IError|null} [error] DeleteContractCoverageResponse error
         */

        /**
         * Constructs a new DeleteContractCoverageResponse.
         * @memberof contractpb
         * @classdesc Represents a DeleteContractCoverageResponse.
         * @implements IDeleteContractCoverageResponse
         * @constructor
         * @param {contractpb.IDeleteContractCoverageResponse=} [p] Properties to set
         */
        function DeleteContractCoverageResponse(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * DeleteContractCoverageResponse error.
         * @member {common.IError|null|undefined} error
         * @memberof contractpb.DeleteContractCoverageResponse
         * @instance
         */
        DeleteContractCoverageResponse.prototype.error = null;

        /**
         * Creates a new DeleteContractCoverageResponse instance using the specified properties.
         * @function create
         * @memberof contractpb.DeleteContractCoverageResponse
         * @static
         * @param {contractpb.IDeleteContractCoverageResponse=} [properties] Properties to set
         * @returns {contractpb.DeleteContractCoverageResponse} DeleteContractCoverageResponse instance
         */
        DeleteContractCoverageResponse.create = function create(properties) {
            return new DeleteContractCoverageResponse(properties);
        };

        /**
         * Encodes the specified DeleteContractCoverageResponse message. Does not implicitly {@link contractpb.DeleteContractCoverageResponse.verify|verify} messages.
         * @function encode
         * @memberof contractpb.DeleteContractCoverageResponse
         * @static
         * @param {contractpb.IDeleteContractCoverageResponse} m DeleteContractCoverageResponse message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        DeleteContractCoverageResponse.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.error != null && Object.hasOwnProperty.call(m, "error"))
                $root.common.Error.encode(m.error, w.uint32(10).fork()).ldelim();
            return w;
        };

        /**
         * Decodes a DeleteContractCoverageResponse message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.DeleteContractCoverageResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.DeleteContractCoverageResponse} DeleteContractCoverageResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        DeleteContractCoverageResponse.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.DeleteContractCoverageResponse();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.error = $root.common.Error.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return DeleteContractCoverageResponse;
    })();

    contractpb.GetCancellationCostReq = (function() {

        /**
         * Properties of a GetCancellationCostReq.
         * @memberof contractpb
         * @interface IGetCancellationCostReq
         * @property {string|null} [contractID] GetCancellationCostReq contractID
         * @property {common.IDate|null} [cancelDate] GetCancellationCostReq cancelDate
         * @property {string|null} [cancelReason] GetCancellationCostReq cancelReason
         * @property {string|null} [state] GetCancellationCostReq state
         */

        /**
         * Constructs a new GetCancellationCostReq.
         * @memberof contractpb
         * @classdesc Represents a GetCancellationCostReq.
         * @implements IGetCancellationCostReq
         * @constructor
         * @param {contractpb.IGetCancellationCostReq=} [p] Properties to set
         */
        function GetCancellationCostReq(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * GetCancellationCostReq contractID.
         * @member {string} contractID
         * @memberof contractpb.GetCancellationCostReq
         * @instance
         */
        GetCancellationCostReq.prototype.contractID = "";

        /**
         * GetCancellationCostReq cancelDate.
         * @member {common.IDate|null|undefined} cancelDate
         * @memberof contractpb.GetCancellationCostReq
         * @instance
         */
        GetCancellationCostReq.prototype.cancelDate = null;

        /**
         * GetCancellationCostReq cancelReason.
         * @member {string} cancelReason
         * @memberof contractpb.GetCancellationCostReq
         * @instance
         */
        GetCancellationCostReq.prototype.cancelReason = "";

        /**
         * GetCancellationCostReq state.
         * @member {string} state
         * @memberof contractpb.GetCancellationCostReq
         * @instance
         */
        GetCancellationCostReq.prototype.state = "";

        /**
         * Creates a new GetCancellationCostReq instance using the specified properties.
         * @function create
         * @memberof contractpb.GetCancellationCostReq
         * @static
         * @param {contractpb.IGetCancellationCostReq=} [properties] Properties to set
         * @returns {contractpb.GetCancellationCostReq} GetCancellationCostReq instance
         */
        GetCancellationCostReq.create = function create(properties) {
            return new GetCancellationCostReq(properties);
        };

        /**
         * Encodes the specified GetCancellationCostReq message. Does not implicitly {@link contractpb.GetCancellationCostReq.verify|verify} messages.
         * @function encode
         * @memberof contractpb.GetCancellationCostReq
         * @static
         * @param {contractpb.IGetCancellationCostReq} m GetCancellationCostReq message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetCancellationCostReq.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.contractID != null && Object.hasOwnProperty.call(m, "contractID"))
                w.uint32(10).string(m.contractID);
            if (m.cancelDate != null && Object.hasOwnProperty.call(m, "cancelDate"))
                $root.common.Date.encode(m.cancelDate, w.uint32(18).fork()).ldelim();
            if (m.cancelReason != null && Object.hasOwnProperty.call(m, "cancelReason"))
                w.uint32(26).string(m.cancelReason);
            if (m.state != null && Object.hasOwnProperty.call(m, "state"))
                w.uint32(34).string(m.state);
            return w;
        };

        /**
         * Decodes a GetCancellationCostReq message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.GetCancellationCostReq
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.GetCancellationCostReq} GetCancellationCostReq
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetCancellationCostReq.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.GetCancellationCostReq();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.contractID = r.string();
                    break;
                case 2:
                    m.cancelDate = $root.common.Date.decode(r, r.uint32());
                    break;
                case 3:
                    m.cancelReason = r.string();
                    break;
                case 4:
                    m.state = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return GetCancellationCostReq;
    })();

    contractpb.InvoiceAmount = (function() {

        /**
         * Properties of an InvoiceAmount.
         * @memberof contractpb
         * @interface IInvoiceAmount
         * @property {number|null} [adminFee] InvoiceAmount adminFee
         * @property {number|null} [serviceCost] InvoiceAmount serviceCost
         * @property {number|null} [premium] InvoiceAmount premium
         */

        /**
         * Constructs a new InvoiceAmount.
         * @memberof contractpb
         * @classdesc Represents an InvoiceAmount.
         * @implements IInvoiceAmount
         * @constructor
         * @param {contractpb.IInvoiceAmount=} [p] Properties to set
         */
        function InvoiceAmount(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * InvoiceAmount adminFee.
         * @member {number} adminFee
         * @memberof contractpb.InvoiceAmount
         * @instance
         */
        InvoiceAmount.prototype.adminFee = 0;

        /**
         * InvoiceAmount serviceCost.
         * @member {number} serviceCost
         * @memberof contractpb.InvoiceAmount
         * @instance
         */
        InvoiceAmount.prototype.serviceCost = 0;

        /**
         * InvoiceAmount premium.
         * @member {number} premium
         * @memberof contractpb.InvoiceAmount
         * @instance
         */
        InvoiceAmount.prototype.premium = 0;

        /**
         * Creates a new InvoiceAmount instance using the specified properties.
         * @function create
         * @memberof contractpb.InvoiceAmount
         * @static
         * @param {contractpb.IInvoiceAmount=} [properties] Properties to set
         * @returns {contractpb.InvoiceAmount} InvoiceAmount instance
         */
        InvoiceAmount.create = function create(properties) {
            return new InvoiceAmount(properties);
        };

        /**
         * Encodes the specified InvoiceAmount message. Does not implicitly {@link contractpb.InvoiceAmount.verify|verify} messages.
         * @function encode
         * @memberof contractpb.InvoiceAmount
         * @static
         * @param {contractpb.IInvoiceAmount} m InvoiceAmount message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        InvoiceAmount.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.adminFee != null && Object.hasOwnProperty.call(m, "adminFee"))
                w.uint32(13).float(m.adminFee);
            if (m.serviceCost != null && Object.hasOwnProperty.call(m, "serviceCost"))
                w.uint32(21).float(m.serviceCost);
            if (m.premium != null && Object.hasOwnProperty.call(m, "premium"))
                w.uint32(29).float(m.premium);
            return w;
        };

        /**
         * Decodes an InvoiceAmount message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.InvoiceAmount
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.InvoiceAmount} InvoiceAmount
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        InvoiceAmount.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.InvoiceAmount();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.adminFee = r.float();
                    break;
                case 2:
                    m.serviceCost = r.float();
                    break;
                case 3:
                    m.premium = r.float();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return InvoiceAmount;
    })();

    contractpb.GetCancellationCostResp = (function() {

        /**
         * Properties of a GetCancellationCostResp.
         * @memberof contractpb
         * @interface IGetCancellationCostResp
         * @property {string|null} [contractID] GetCancellationCostResp contractID
         * @property {number|null} [totalPrice] GetCancellationCostResp totalPrice
         * @property {number|null} [daysInForce] GetCancellationCostResp daysInForce
         * @property {number|null} [pricePerDay] GetCancellationCostResp pricePerDay
         * @property {number|null} [activeCost] GetCancellationCostResp activeCost
         * @property {number|null} [totalPaid] GetCancellationCostResp totalPaid
         * @property {number|null} [amountBeforeFees] GetCancellationCostResp amountBeforeFees
         * @property {number|null} [amountAfterFees] GetCancellationCostResp amountAfterFees
         * @property {number|null} [amountDue] GetCancellationCostResp amountDue
         * @property {number|null} [adminFee] GetCancellationCostResp adminFee
         * @property {number|null} [serviceCost] GetCancellationCostResp serviceCost
         * @property {number|null} [serviceCostRecoveryAmount] The service cost recovery.
         * @property {number|null} [premiumPaidAfterContractCancellationDate] GetCancellationCostResp premiumPaidAfterContractCancellationDate
         * @property {number|null} [concessionAmount] GetCancellationCostResp concessionAmount
         * @property {contractpb.IInvoiceAmount|null} [invoice] GetCancellationCostResp invoice
         * @property {string|null} [cancelDate] GetCancellationCostResp cancelDate
         * @property {string|null} [refundBy] GetCancellationCostResp refundBy
         */

        /**
         * Constructs a new GetCancellationCostResp.
         * @memberof contractpb
         * @classdesc Represents a GetCancellationCostResp.
         * @implements IGetCancellationCostResp
         * @constructor
         * @param {contractpb.IGetCancellationCostResp=} [p] Properties to set
         */
        function GetCancellationCostResp(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * GetCancellationCostResp contractID.
         * @member {string} contractID
         * @memberof contractpb.GetCancellationCostResp
         * @instance
         */
        GetCancellationCostResp.prototype.contractID = "";

        /**
         * GetCancellationCostResp totalPrice.
         * @member {number} totalPrice
         * @memberof contractpb.GetCancellationCostResp
         * @instance
         */
        GetCancellationCostResp.prototype.totalPrice = 0;

        /**
         * GetCancellationCostResp daysInForce.
         * @member {number} daysInForce
         * @memberof contractpb.GetCancellationCostResp
         * @instance
         */
        GetCancellationCostResp.prototype.daysInForce = 0;

        /**
         * GetCancellationCostResp pricePerDay.
         * @member {number} pricePerDay
         * @memberof contractpb.GetCancellationCostResp
         * @instance
         */
        GetCancellationCostResp.prototype.pricePerDay = 0;

        /**
         * GetCancellationCostResp activeCost.
         * @member {number} activeCost
         * @memberof contractpb.GetCancellationCostResp
         * @instance
         */
        GetCancellationCostResp.prototype.activeCost = 0;

        /**
         * GetCancellationCostResp totalPaid.
         * @member {number} totalPaid
         * @memberof contractpb.GetCancellationCostResp
         * @instance
         */
        GetCancellationCostResp.prototype.totalPaid = 0;

        /**
         * GetCancellationCostResp amountBeforeFees.
         * @member {number} amountBeforeFees
         * @memberof contractpb.GetCancellationCostResp
         * @instance
         */
        GetCancellationCostResp.prototype.amountBeforeFees = 0;

        /**
         * GetCancellationCostResp amountAfterFees.
         * @member {number} amountAfterFees
         * @memberof contractpb.GetCancellationCostResp
         * @instance
         */
        GetCancellationCostResp.prototype.amountAfterFees = 0;

        /**
         * GetCancellationCostResp amountDue.
         * @member {number} amountDue
         * @memberof contractpb.GetCancellationCostResp
         * @instance
         */
        GetCancellationCostResp.prototype.amountDue = 0;

        /**
         * GetCancellationCostResp adminFee.
         * @member {number} adminFee
         * @memberof contractpb.GetCancellationCostResp
         * @instance
         */
        GetCancellationCostResp.prototype.adminFee = 0;

        /**
         * GetCancellationCostResp serviceCost.
         * @member {number} serviceCost
         * @memberof contractpb.GetCancellationCostResp
         * @instance
         */
        GetCancellationCostResp.prototype.serviceCost = 0;

        /**
         * The service cost recovery.
         * @member {number} serviceCostRecoveryAmount
         * @memberof contractpb.GetCancellationCostResp
         * @instance
         */
        GetCancellationCostResp.prototype.serviceCostRecoveryAmount = 0;

        /**
         * GetCancellationCostResp premiumPaidAfterContractCancellationDate.
         * @member {number} premiumPaidAfterContractCancellationDate
         * @memberof contractpb.GetCancellationCostResp
         * @instance
         */
        GetCancellationCostResp.prototype.premiumPaidAfterContractCancellationDate = 0;

        /**
         * GetCancellationCostResp concessionAmount.
         * @member {number} concessionAmount
         * @memberof contractpb.GetCancellationCostResp
         * @instance
         */
        GetCancellationCostResp.prototype.concessionAmount = 0;

        /**
         * GetCancellationCostResp invoice.
         * @member {contractpb.IInvoiceAmount|null|undefined} invoice
         * @memberof contractpb.GetCancellationCostResp
         * @instance
         */
        GetCancellationCostResp.prototype.invoice = null;

        /**
         * GetCancellationCostResp cancelDate.
         * @member {string} cancelDate
         * @memberof contractpb.GetCancellationCostResp
         * @instance
         */
        GetCancellationCostResp.prototype.cancelDate = "";

        /**
         * GetCancellationCostResp refundBy.
         * @member {string} refundBy
         * @memberof contractpb.GetCancellationCostResp
         * @instance
         */
        GetCancellationCostResp.prototype.refundBy = "";

        /**
         * Creates a new GetCancellationCostResp instance using the specified properties.
         * @function create
         * @memberof contractpb.GetCancellationCostResp
         * @static
         * @param {contractpb.IGetCancellationCostResp=} [properties] Properties to set
         * @returns {contractpb.GetCancellationCostResp} GetCancellationCostResp instance
         */
        GetCancellationCostResp.create = function create(properties) {
            return new GetCancellationCostResp(properties);
        };

        /**
         * Encodes the specified GetCancellationCostResp message. Does not implicitly {@link contractpb.GetCancellationCostResp.verify|verify} messages.
         * @function encode
         * @memberof contractpb.GetCancellationCostResp
         * @static
         * @param {contractpb.IGetCancellationCostResp} m GetCancellationCostResp message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetCancellationCostResp.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.contractID != null && Object.hasOwnProperty.call(m, "contractID"))
                w.uint32(10).string(m.contractID);
            if (m.totalPrice != null && Object.hasOwnProperty.call(m, "totalPrice"))
                w.uint32(17).double(m.totalPrice);
            if (m.daysInForce != null && Object.hasOwnProperty.call(m, "daysInForce"))
                w.uint32(24).int32(m.daysInForce);
            if (m.pricePerDay != null && Object.hasOwnProperty.call(m, "pricePerDay"))
                w.uint32(33).double(m.pricePerDay);
            if (m.activeCost != null && Object.hasOwnProperty.call(m, "activeCost"))
                w.uint32(41).double(m.activeCost);
            if (m.totalPaid != null && Object.hasOwnProperty.call(m, "totalPaid"))
                w.uint32(49).double(m.totalPaid);
            if (m.amountBeforeFees != null && Object.hasOwnProperty.call(m, "amountBeforeFees"))
                w.uint32(57).double(m.amountBeforeFees);
            if (m.amountAfterFees != null && Object.hasOwnProperty.call(m, "amountAfterFees"))
                w.uint32(65).double(m.amountAfterFees);
            if (m.amountDue != null && Object.hasOwnProperty.call(m, "amountDue"))
                w.uint32(73).double(m.amountDue);
            if (m.adminFee != null && Object.hasOwnProperty.call(m, "adminFee"))
                w.uint32(81).double(m.adminFee);
            if (m.serviceCost != null && Object.hasOwnProperty.call(m, "serviceCost"))
                w.uint32(89).double(m.serviceCost);
            if (m.serviceCostRecoveryAmount != null && Object.hasOwnProperty.call(m, "serviceCostRecoveryAmount"))
                w.uint32(97).double(m.serviceCostRecoveryAmount);
            if (m.premiumPaidAfterContractCancellationDate != null && Object.hasOwnProperty.call(m, "premiumPaidAfterContractCancellationDate"))
                w.uint32(105).double(m.premiumPaidAfterContractCancellationDate);
            if (m.concessionAmount != null && Object.hasOwnProperty.call(m, "concessionAmount"))
                w.uint32(113).double(m.concessionAmount);
            if (m.invoice != null && Object.hasOwnProperty.call(m, "invoice"))
                $root.contractpb.InvoiceAmount.encode(m.invoice, w.uint32(122).fork()).ldelim();
            if (m.cancelDate != null && Object.hasOwnProperty.call(m, "cancelDate"))
                w.uint32(130).string(m.cancelDate);
            if (m.refundBy != null && Object.hasOwnProperty.call(m, "refundBy"))
                w.uint32(138).string(m.refundBy);
            return w;
        };

        /**
         * Decodes a GetCancellationCostResp message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.GetCancellationCostResp
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.GetCancellationCostResp} GetCancellationCostResp
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetCancellationCostResp.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.GetCancellationCostResp();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.contractID = r.string();
                    break;
                case 2:
                    m.totalPrice = r.double();
                    break;
                case 3:
                    m.daysInForce = r.int32();
                    break;
                case 4:
                    m.pricePerDay = r.double();
                    break;
                case 5:
                    m.activeCost = r.double();
                    break;
                case 6:
                    m.totalPaid = r.double();
                    break;
                case 7:
                    m.amountBeforeFees = r.double();
                    break;
                case 8:
                    m.amountAfterFees = r.double();
                    break;
                case 9:
                    m.amountDue = r.double();
                    break;
                case 10:
                    m.adminFee = r.double();
                    break;
                case 11:
                    m.serviceCost = r.double();
                    break;
                case 12:
                    m.serviceCostRecoveryAmount = r.double();
                    break;
                case 13:
                    m.premiumPaidAfterContractCancellationDate = r.double();
                    break;
                case 14:
                    m.concessionAmount = r.double();
                    break;
                case 15:
                    m.invoice = $root.contractpb.InvoiceAmount.decode(r, r.uint32());
                    break;
                case 16:
                    m.cancelDate = r.string();
                    break;
                case 17:
                    m.refundBy = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return GetCancellationCostResp;
    })();

    contractpb.GetContractCostsResp = (function() {

        /**
         * Properties of a GetContractCostsResp.
         * @memberof contractpb
         * @interface IGetContractCostsResp
         * @property {contractpb.IGetCancellationCostResp|null} [costSummary] GetContractCostsResp costSummary
         * @property {common.IError|null} [error] GetContractCostsResp error
         */

        /**
         * Constructs a new GetContractCostsResp.
         * @memberof contractpb
         * @classdesc Represents a GetContractCostsResp.
         * @implements IGetContractCostsResp
         * @constructor
         * @param {contractpb.IGetContractCostsResp=} [p] Properties to set
         */
        function GetContractCostsResp(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * GetContractCostsResp costSummary.
         * @member {contractpb.IGetCancellationCostResp|null|undefined} costSummary
         * @memberof contractpb.GetContractCostsResp
         * @instance
         */
        GetContractCostsResp.prototype.costSummary = null;

        /**
         * GetContractCostsResp error.
         * @member {common.IError|null|undefined} error
         * @memberof contractpb.GetContractCostsResp
         * @instance
         */
        GetContractCostsResp.prototype.error = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        /**
         * GetContractCostsResp getContractCostsResponse.
         * @member {"costSummary"|"error"|undefined} getContractCostsResponse
         * @memberof contractpb.GetContractCostsResp
         * @instance
         */
        Object.defineProperty(GetContractCostsResp.prototype, "getContractCostsResponse", {
            get: $util.oneOfGetter($oneOfFields = ["costSummary", "error"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new GetContractCostsResp instance using the specified properties.
         * @function create
         * @memberof contractpb.GetContractCostsResp
         * @static
         * @param {contractpb.IGetContractCostsResp=} [properties] Properties to set
         * @returns {contractpb.GetContractCostsResp} GetContractCostsResp instance
         */
        GetContractCostsResp.create = function create(properties) {
            return new GetContractCostsResp(properties);
        };

        /**
         * Encodes the specified GetContractCostsResp message. Does not implicitly {@link contractpb.GetContractCostsResp.verify|verify} messages.
         * @function encode
         * @memberof contractpb.GetContractCostsResp
         * @static
         * @param {contractpb.IGetContractCostsResp} m GetContractCostsResp message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetContractCostsResp.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.costSummary != null && Object.hasOwnProperty.call(m, "costSummary"))
                $root.contractpb.GetCancellationCostResp.encode(m.costSummary, w.uint32(10).fork()).ldelim();
            if (m.error != null && Object.hasOwnProperty.call(m, "error"))
                $root.common.Error.encode(m.error, w.uint32(18).fork()).ldelim();
            return w;
        };

        /**
         * Decodes a GetContractCostsResp message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.GetContractCostsResp
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.GetContractCostsResp} GetContractCostsResp
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetContractCostsResp.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.GetContractCostsResp();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.costSummary = $root.contractpb.GetCancellationCostResp.decode(r, r.uint32());
                    break;
                case 2:
                    m.error = $root.common.Error.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return GetContractCostsResp;
    })();

    contractpb.GetRenewalHierarchyRequest = (function() {

        /**
         * Properties of a GetRenewalHierarchyRequest.
         * @memberof contractpb
         * @interface IGetRenewalHierarchyRequest
         * @property {string|null} [contractID] GetRenewalHierarchyRequest contractID
         */

        /**
         * Constructs a new GetRenewalHierarchyRequest.
         * @memberof contractpb
         * @classdesc Represents a GetRenewalHierarchyRequest.
         * @implements IGetRenewalHierarchyRequest
         * @constructor
         * @param {contractpb.IGetRenewalHierarchyRequest=} [p] Properties to set
         */
        function GetRenewalHierarchyRequest(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * GetRenewalHierarchyRequest contractID.
         * @member {string} contractID
         * @memberof contractpb.GetRenewalHierarchyRequest
         * @instance
         */
        GetRenewalHierarchyRequest.prototype.contractID = "";

        /**
         * Creates a new GetRenewalHierarchyRequest instance using the specified properties.
         * @function create
         * @memberof contractpb.GetRenewalHierarchyRequest
         * @static
         * @param {contractpb.IGetRenewalHierarchyRequest=} [properties] Properties to set
         * @returns {contractpb.GetRenewalHierarchyRequest} GetRenewalHierarchyRequest instance
         */
        GetRenewalHierarchyRequest.create = function create(properties) {
            return new GetRenewalHierarchyRequest(properties);
        };

        /**
         * Encodes the specified GetRenewalHierarchyRequest message. Does not implicitly {@link contractpb.GetRenewalHierarchyRequest.verify|verify} messages.
         * @function encode
         * @memberof contractpb.GetRenewalHierarchyRequest
         * @static
         * @param {contractpb.IGetRenewalHierarchyRequest} m GetRenewalHierarchyRequest message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetRenewalHierarchyRequest.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.contractID != null && Object.hasOwnProperty.call(m, "contractID"))
                w.uint32(10).string(m.contractID);
            return w;
        };

        /**
         * Decodes a GetRenewalHierarchyRequest message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.GetRenewalHierarchyRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.GetRenewalHierarchyRequest} GetRenewalHierarchyRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetRenewalHierarchyRequest.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.GetRenewalHierarchyRequest();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.contractID = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return GetRenewalHierarchyRequest;
    })();

    contractpb.GetRenewalHierarchyResponse = (function() {

        /**
         * Properties of a GetRenewalHierarchyResponse.
         * @memberof contractpb
         * @interface IGetRenewalHierarchyResponse
         * @property {Array.<string>|null} [contractIDs] GetRenewalHierarchyResponse contractIDs
         * @property {common.IError|null} [error] GetRenewalHierarchyResponse error
         * @property {string|null} [currentContractID] GetRenewalHierarchyResponse currentContractID
         */

        /**
         * Constructs a new GetRenewalHierarchyResponse.
         * @memberof contractpb
         * @classdesc Represents a GetRenewalHierarchyResponse.
         * @implements IGetRenewalHierarchyResponse
         * @constructor
         * @param {contractpb.IGetRenewalHierarchyResponse=} [p] Properties to set
         */
        function GetRenewalHierarchyResponse(p) {
            this.contractIDs = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * GetRenewalHierarchyResponse contractIDs.
         * @member {Array.<string>} contractIDs
         * @memberof contractpb.GetRenewalHierarchyResponse
         * @instance
         */
        GetRenewalHierarchyResponse.prototype.contractIDs = $util.emptyArray;

        /**
         * GetRenewalHierarchyResponse error.
         * @member {common.IError|null|undefined} error
         * @memberof contractpb.GetRenewalHierarchyResponse
         * @instance
         */
        GetRenewalHierarchyResponse.prototype.error = null;

        /**
         * GetRenewalHierarchyResponse currentContractID.
         * @member {string} currentContractID
         * @memberof contractpb.GetRenewalHierarchyResponse
         * @instance
         */
        GetRenewalHierarchyResponse.prototype.currentContractID = "";

        /**
         * Creates a new GetRenewalHierarchyResponse instance using the specified properties.
         * @function create
         * @memberof contractpb.GetRenewalHierarchyResponse
         * @static
         * @param {contractpb.IGetRenewalHierarchyResponse=} [properties] Properties to set
         * @returns {contractpb.GetRenewalHierarchyResponse} GetRenewalHierarchyResponse instance
         */
        GetRenewalHierarchyResponse.create = function create(properties) {
            return new GetRenewalHierarchyResponse(properties);
        };

        /**
         * Encodes the specified GetRenewalHierarchyResponse message. Does not implicitly {@link contractpb.GetRenewalHierarchyResponse.verify|verify} messages.
         * @function encode
         * @memberof contractpb.GetRenewalHierarchyResponse
         * @static
         * @param {contractpb.IGetRenewalHierarchyResponse} m GetRenewalHierarchyResponse message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetRenewalHierarchyResponse.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.contractIDs != null && m.contractIDs.length) {
                for (var i = 0; i < m.contractIDs.length; ++i)
                    w.uint32(10).string(m.contractIDs[i]);
            }
            if (m.error != null && Object.hasOwnProperty.call(m, "error"))
                $root.common.Error.encode(m.error, w.uint32(18).fork()).ldelim();
            if (m.currentContractID != null && Object.hasOwnProperty.call(m, "currentContractID"))
                w.uint32(26).string(m.currentContractID);
            return w;
        };

        /**
         * Decodes a GetRenewalHierarchyResponse message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.GetRenewalHierarchyResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.GetRenewalHierarchyResponse} GetRenewalHierarchyResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetRenewalHierarchyResponse.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.GetRenewalHierarchyResponse();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    if (!(m.contractIDs && m.contractIDs.length))
                        m.contractIDs = [];
                    m.contractIDs.push(r.string());
                    break;
                case 2:
                    m.error = $root.common.Error.decode(r, r.uint32());
                    break;
                case 3:
                    m.currentContractID = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return GetRenewalHierarchyResponse;
    })();

    contractpb.AsyncRequestProcessorReq = (function() {

        /**
         * Properties of an AsyncRequestProcessorReq.
         * @memberof contractpb
         * @interface IAsyncRequestProcessorReq
         * @property {number|null} [priority] AsyncRequestProcessorReq priority
         */

        /**
         * Constructs a new AsyncRequestProcessorReq.
         * @memberof contractpb
         * @classdesc Represents an AsyncRequestProcessorReq.
         * @implements IAsyncRequestProcessorReq
         * @constructor
         * @param {contractpb.IAsyncRequestProcessorReq=} [p] Properties to set
         */
        function AsyncRequestProcessorReq(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * AsyncRequestProcessorReq priority.
         * @member {number} priority
         * @memberof contractpb.AsyncRequestProcessorReq
         * @instance
         */
        AsyncRequestProcessorReq.prototype.priority = 0;

        /**
         * Creates a new AsyncRequestProcessorReq instance using the specified properties.
         * @function create
         * @memberof contractpb.AsyncRequestProcessorReq
         * @static
         * @param {contractpb.IAsyncRequestProcessorReq=} [properties] Properties to set
         * @returns {contractpb.AsyncRequestProcessorReq} AsyncRequestProcessorReq instance
         */
        AsyncRequestProcessorReq.create = function create(properties) {
            return new AsyncRequestProcessorReq(properties);
        };

        /**
         * Encodes the specified AsyncRequestProcessorReq message. Does not implicitly {@link contractpb.AsyncRequestProcessorReq.verify|verify} messages.
         * @function encode
         * @memberof contractpb.AsyncRequestProcessorReq
         * @static
         * @param {contractpb.IAsyncRequestProcessorReq} m AsyncRequestProcessorReq message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AsyncRequestProcessorReq.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.priority != null && Object.hasOwnProperty.call(m, "priority"))
                w.uint32(8).int32(m.priority);
            return w;
        };

        /**
         * Decodes an AsyncRequestProcessorReq message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.AsyncRequestProcessorReq
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.AsyncRequestProcessorReq} AsyncRequestProcessorReq
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AsyncRequestProcessorReq.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.AsyncRequestProcessorReq();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.priority = r.int32();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return AsyncRequestProcessorReq;
    })();

    contractpb.GetContractInvoiceDayDetailsReq = (function() {

        /**
         * Properties of a GetContractInvoiceDayDetailsReq.
         * @memberof contractpb
         * @interface IGetContractInvoiceDayDetailsReq
         * @property {string|null} [contractID] GetContractInvoiceDayDetailsReq contractID
         */

        /**
         * Constructs a new GetContractInvoiceDayDetailsReq.
         * @memberof contractpb
         * @classdesc Represents a GetContractInvoiceDayDetailsReq.
         * @implements IGetContractInvoiceDayDetailsReq
         * @constructor
         * @param {contractpb.IGetContractInvoiceDayDetailsReq=} [p] Properties to set
         */
        function GetContractInvoiceDayDetailsReq(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * GetContractInvoiceDayDetailsReq contractID.
         * @member {string} contractID
         * @memberof contractpb.GetContractInvoiceDayDetailsReq
         * @instance
         */
        GetContractInvoiceDayDetailsReq.prototype.contractID = "";

        /**
         * Creates a new GetContractInvoiceDayDetailsReq instance using the specified properties.
         * @function create
         * @memberof contractpb.GetContractInvoiceDayDetailsReq
         * @static
         * @param {contractpb.IGetContractInvoiceDayDetailsReq=} [properties] Properties to set
         * @returns {contractpb.GetContractInvoiceDayDetailsReq} GetContractInvoiceDayDetailsReq instance
         */
        GetContractInvoiceDayDetailsReq.create = function create(properties) {
            return new GetContractInvoiceDayDetailsReq(properties);
        };

        /**
         * Encodes the specified GetContractInvoiceDayDetailsReq message. Does not implicitly {@link contractpb.GetContractInvoiceDayDetailsReq.verify|verify} messages.
         * @function encode
         * @memberof contractpb.GetContractInvoiceDayDetailsReq
         * @static
         * @param {contractpb.IGetContractInvoiceDayDetailsReq} m GetContractInvoiceDayDetailsReq message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetContractInvoiceDayDetailsReq.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.contractID != null && Object.hasOwnProperty.call(m, "contractID"))
                w.uint32(10).string(m.contractID);
            return w;
        };

        /**
         * Decodes a GetContractInvoiceDayDetailsReq message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.GetContractInvoiceDayDetailsReq
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.GetContractInvoiceDayDetailsReq} GetContractInvoiceDayDetailsReq
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetContractInvoiceDayDetailsReq.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.GetContractInvoiceDayDetailsReq();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.contractID = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return GetContractInvoiceDayDetailsReq;
    })();

    contractpb.GetContractInvoiceDayDetailsResp = (function() {

        /**
         * Properties of a GetContractInvoiceDayDetailsResp.
         * @memberof contractpb
         * @interface IGetContractInvoiceDayDetailsResp
         * @property {common.IError|null} [error] GetContractInvoiceDayDetailsResp error
         * @property {number|null} [invoiceDay] GetContractInvoiceDayDetailsResp invoiceDay
         * @property {google.protobuf.ITimestamp|null} [invoiceDayLastModified] GetContractInvoiceDayDetailsResp invoiceDayLastModified
         * @property {number|null} [invoiceDayUpdateCounter] GetContractInvoiceDayDetailsResp invoiceDayUpdateCounter
         */

        /**
         * Constructs a new GetContractInvoiceDayDetailsResp.
         * @memberof contractpb
         * @classdesc Represents a GetContractInvoiceDayDetailsResp.
         * @implements IGetContractInvoiceDayDetailsResp
         * @constructor
         * @param {contractpb.IGetContractInvoiceDayDetailsResp=} [p] Properties to set
         */
        function GetContractInvoiceDayDetailsResp(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * GetContractInvoiceDayDetailsResp error.
         * @member {common.IError|null|undefined} error
         * @memberof contractpb.GetContractInvoiceDayDetailsResp
         * @instance
         */
        GetContractInvoiceDayDetailsResp.prototype.error = null;

        /**
         * GetContractInvoiceDayDetailsResp invoiceDay.
         * @member {number} invoiceDay
         * @memberof contractpb.GetContractInvoiceDayDetailsResp
         * @instance
         */
        GetContractInvoiceDayDetailsResp.prototype.invoiceDay = 0;

        /**
         * GetContractInvoiceDayDetailsResp invoiceDayLastModified.
         * @member {google.protobuf.ITimestamp|null|undefined} invoiceDayLastModified
         * @memberof contractpb.GetContractInvoiceDayDetailsResp
         * @instance
         */
        GetContractInvoiceDayDetailsResp.prototype.invoiceDayLastModified = null;

        /**
         * GetContractInvoiceDayDetailsResp invoiceDayUpdateCounter.
         * @member {number} invoiceDayUpdateCounter
         * @memberof contractpb.GetContractInvoiceDayDetailsResp
         * @instance
         */
        GetContractInvoiceDayDetailsResp.prototype.invoiceDayUpdateCounter = 0;

        /**
         * Creates a new GetContractInvoiceDayDetailsResp instance using the specified properties.
         * @function create
         * @memberof contractpb.GetContractInvoiceDayDetailsResp
         * @static
         * @param {contractpb.IGetContractInvoiceDayDetailsResp=} [properties] Properties to set
         * @returns {contractpb.GetContractInvoiceDayDetailsResp} GetContractInvoiceDayDetailsResp instance
         */
        GetContractInvoiceDayDetailsResp.create = function create(properties) {
            return new GetContractInvoiceDayDetailsResp(properties);
        };

        /**
         * Encodes the specified GetContractInvoiceDayDetailsResp message. Does not implicitly {@link contractpb.GetContractInvoiceDayDetailsResp.verify|verify} messages.
         * @function encode
         * @memberof contractpb.GetContractInvoiceDayDetailsResp
         * @static
         * @param {contractpb.IGetContractInvoiceDayDetailsResp} m GetContractInvoiceDayDetailsResp message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetContractInvoiceDayDetailsResp.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.error != null && Object.hasOwnProperty.call(m, "error"))
                $root.common.Error.encode(m.error, w.uint32(10).fork()).ldelim();
            if (m.invoiceDay != null && Object.hasOwnProperty.call(m, "invoiceDay"))
                w.uint32(16).int32(m.invoiceDay);
            if (m.invoiceDayLastModified != null && Object.hasOwnProperty.call(m, "invoiceDayLastModified"))
                $root.google.protobuf.Timestamp.encode(m.invoiceDayLastModified, w.uint32(26).fork()).ldelim();
            if (m.invoiceDayUpdateCounter != null && Object.hasOwnProperty.call(m, "invoiceDayUpdateCounter"))
                w.uint32(32).int32(m.invoiceDayUpdateCounter);
            return w;
        };

        /**
         * Decodes a GetContractInvoiceDayDetailsResp message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.GetContractInvoiceDayDetailsResp
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.GetContractInvoiceDayDetailsResp} GetContractInvoiceDayDetailsResp
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetContractInvoiceDayDetailsResp.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.GetContractInvoiceDayDetailsResp();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.error = $root.common.Error.decode(r, r.uint32());
                    break;
                case 2:
                    m.invoiceDay = r.int32();
                    break;
                case 3:
                    m.invoiceDayLastModified = $root.google.protobuf.Timestamp.decode(r, r.uint32());
                    break;
                case 4:
                    m.invoiceDayUpdateCounter = r.int32();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return GetContractInvoiceDayDetailsResp;
    })();

    contractpb.GetContractDiscrepancyRequest = (function() {

        /**
         * Properties of a GetContractDiscrepancyRequest.
         * @memberof contractpb
         * @interface IGetContractDiscrepancyRequest
         * @property {common.IDate|null} [startDate] GetContractDiscrepancyRequest startDate
         * @property {common.IDate|null} [endDate] GetContractDiscrepancyRequest endDate
         */

        /**
         * Constructs a new GetContractDiscrepancyRequest.
         * @memberof contractpb
         * @classdesc Represents a GetContractDiscrepancyRequest.
         * @implements IGetContractDiscrepancyRequest
         * @constructor
         * @param {contractpb.IGetContractDiscrepancyRequest=} [p] Properties to set
         */
        function GetContractDiscrepancyRequest(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * GetContractDiscrepancyRequest startDate.
         * @member {common.IDate|null|undefined} startDate
         * @memberof contractpb.GetContractDiscrepancyRequest
         * @instance
         */
        GetContractDiscrepancyRequest.prototype.startDate = null;

        /**
         * GetContractDiscrepancyRequest endDate.
         * @member {common.IDate|null|undefined} endDate
         * @memberof contractpb.GetContractDiscrepancyRequest
         * @instance
         */
        GetContractDiscrepancyRequest.prototype.endDate = null;

        /**
         * Creates a new GetContractDiscrepancyRequest instance using the specified properties.
         * @function create
         * @memberof contractpb.GetContractDiscrepancyRequest
         * @static
         * @param {contractpb.IGetContractDiscrepancyRequest=} [properties] Properties to set
         * @returns {contractpb.GetContractDiscrepancyRequest} GetContractDiscrepancyRequest instance
         */
        GetContractDiscrepancyRequest.create = function create(properties) {
            return new GetContractDiscrepancyRequest(properties);
        };

        /**
         * Encodes the specified GetContractDiscrepancyRequest message. Does not implicitly {@link contractpb.GetContractDiscrepancyRequest.verify|verify} messages.
         * @function encode
         * @memberof contractpb.GetContractDiscrepancyRequest
         * @static
         * @param {contractpb.IGetContractDiscrepancyRequest} m GetContractDiscrepancyRequest message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetContractDiscrepancyRequest.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.startDate != null && Object.hasOwnProperty.call(m, "startDate"))
                $root.common.Date.encode(m.startDate, w.uint32(10).fork()).ldelim();
            if (m.endDate != null && Object.hasOwnProperty.call(m, "endDate"))
                $root.common.Date.encode(m.endDate, w.uint32(18).fork()).ldelim();
            return w;
        };

        /**
         * Decodes a GetContractDiscrepancyRequest message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.GetContractDiscrepancyRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.GetContractDiscrepancyRequest} GetContractDiscrepancyRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetContractDiscrepancyRequest.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.GetContractDiscrepancyRequest();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.startDate = $root.common.Date.decode(r, r.uint32());
                    break;
                case 2:
                    m.endDate = $root.common.Date.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return GetContractDiscrepancyRequest;
    })();

    contractpb.GetContractDiscrepancyResponse = (function() {

        /**
         * Properties of a GetContractDiscrepancyResponse.
         * @memberof contractpb
         * @interface IGetContractDiscrepancyResponse
         * @property {common.IError|null} [error] GetContractDiscrepancyResponse error
         */

        /**
         * Constructs a new GetContractDiscrepancyResponse.
         * @memberof contractpb
         * @classdesc Represents a GetContractDiscrepancyResponse.
         * @implements IGetContractDiscrepancyResponse
         * @constructor
         * @param {contractpb.IGetContractDiscrepancyResponse=} [p] Properties to set
         */
        function GetContractDiscrepancyResponse(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * GetContractDiscrepancyResponse error.
         * @member {common.IError|null|undefined} error
         * @memberof contractpb.GetContractDiscrepancyResponse
         * @instance
         */
        GetContractDiscrepancyResponse.prototype.error = null;

        /**
         * Creates a new GetContractDiscrepancyResponse instance using the specified properties.
         * @function create
         * @memberof contractpb.GetContractDiscrepancyResponse
         * @static
         * @param {contractpb.IGetContractDiscrepancyResponse=} [properties] Properties to set
         * @returns {contractpb.GetContractDiscrepancyResponse} GetContractDiscrepancyResponse instance
         */
        GetContractDiscrepancyResponse.create = function create(properties) {
            return new GetContractDiscrepancyResponse(properties);
        };

        /**
         * Encodes the specified GetContractDiscrepancyResponse message. Does not implicitly {@link contractpb.GetContractDiscrepancyResponse.verify|verify} messages.
         * @function encode
         * @memberof contractpb.GetContractDiscrepancyResponse
         * @static
         * @param {contractpb.IGetContractDiscrepancyResponse} m GetContractDiscrepancyResponse message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetContractDiscrepancyResponse.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.error != null && Object.hasOwnProperty.call(m, "error"))
                $root.common.Error.encode(m.error, w.uint32(10).fork()).ldelim();
            return w;
        };

        /**
         * Decodes a GetContractDiscrepancyResponse message from the specified reader or buffer.
         * @function decode
         * @memberof contractpb.GetContractDiscrepancyResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {contractpb.GetContractDiscrepancyResponse} GetContractDiscrepancyResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetContractDiscrepancyResponse.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.contractpb.GetContractDiscrepancyResponse();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.error = $root.common.Error.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return GetContractDiscrepancyResponse;
    })();

    contractpb.ContractCoverages = (function() {

        /**
         * Constructs a new ContractCoverages service.
         * @memberof contractpb
         * @classdesc Represents a ContractCoverages
         * @extends $protobuf.rpc.Service
         * @constructor
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         */
        function ContractCoverages(rpcImpl, requestDelimited, responseDelimited) {
            $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
        }

        (ContractCoverages.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = ContractCoverages;

        /**
         * Creates new ContractCoverages service using the specified rpc implementation.
         * @function create
         * @memberof contractpb.ContractCoverages
         * @static
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         * @returns {ContractCoverages} RPC service. Useful where requests and/or responses are streamed.
         */
        ContractCoverages.create = function create(rpcImpl, requestDelimited, responseDelimited) {
            return new this(rpcImpl, requestDelimited, responseDelimited);
        };

        /**
         * Callback as used by {@link contractpb.ContractCoverages#getContractCoverages}.
         * @memberof contractpb.ContractCoverages
         * @typedef GetContractCoveragesCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {coreproductpb.GetProductsResponse} [response] GetProductsResponse
         */

        /**
         * Calls GetContractCoverages.
         * @function getContractCoverages
         * @memberof contractpb.ContractCoverages
         * @instance
         * @param {contractpb.IContractCoverageRequest} request ContractCoverageRequest message or plain object
         * @param {contractpb.ContractCoverages.GetContractCoveragesCallback} callback Node-style callback called with the error, if any, and GetProductsResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(ContractCoverages.prototype.getContractCoverages = function getContractCoverages(request, callback) {
            return this.rpcCall(getContractCoverages, $root.contractpb.ContractCoverageRequest, $root.coreproductpb.GetProductsResponse, request, callback);
        }, "name", { value: "GetContractCoverages" });

        /**
         * Calls GetContractCoverages.
         * @function getContractCoverages
         * @memberof contractpb.ContractCoverages
         * @instance
         * @param {contractpb.IContractCoverageRequest} request ContractCoverageRequest message or plain object
         * @returns {Promise<coreproductpb.GetProductsResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link contractpb.ContractCoverages#updateContractCoverages}.
         * @memberof contractpb.ContractCoverages
         * @typedef UpdateContractCoveragesCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {contractpb.UpdateCoveragesResponse} [response] UpdateCoveragesResponse
         */

        /**
         * Calls UpdateContractCoverages.
         * @function updateContractCoverages
         * @memberof contractpb.ContractCoverages
         * @instance
         * @param {contractpb.IUpdateCoveragesRequest} request UpdateCoveragesRequest message or plain object
         * @param {contractpb.ContractCoverages.UpdateContractCoveragesCallback} callback Node-style callback called with the error, if any, and UpdateCoveragesResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(ContractCoverages.prototype.updateContractCoverages = function updateContractCoverages(request, callback) {
            return this.rpcCall(updateContractCoverages, $root.contractpb.UpdateCoveragesRequest, $root.contractpb.UpdateCoveragesResponse, request, callback);
        }, "name", { value: "UpdateContractCoverages" });

        /**
         * Calls UpdateContractCoverages.
         * @function updateContractCoverages
         * @memberof contractpb.ContractCoverages
         * @instance
         * @param {contractpb.IUpdateCoveragesRequest} request UpdateCoveragesRequest message or plain object
         * @returns {Promise<contractpb.UpdateCoveragesResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link contractpb.ContractCoverages#deleteContractCoverage}.
         * @memberof contractpb.ContractCoverages
         * @typedef DeleteContractCoverageCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {contractpb.DeleteContractCoverageResponse} [response] DeleteContractCoverageResponse
         */

        /**
         * Calls DeleteContractCoverage.
         * @function deleteContractCoverage
         * @memberof contractpb.ContractCoverages
         * @instance
         * @param {contractpb.IDeleteContractCoverageRequest} request DeleteContractCoverageRequest message or plain object
         * @param {contractpb.ContractCoverages.DeleteContractCoverageCallback} callback Node-style callback called with the error, if any, and DeleteContractCoverageResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(ContractCoverages.prototype.deleteContractCoverage = function deleteContractCoverage(request, callback) {
            return this.rpcCall(deleteContractCoverage, $root.contractpb.DeleteContractCoverageRequest, $root.contractpb.DeleteContractCoverageResponse, request, callback);
        }, "name", { value: "DeleteContractCoverage" });

        /**
         * Calls DeleteContractCoverage.
         * @function deleteContractCoverage
         * @memberof contractpb.ContractCoverages
         * @instance
         * @param {contractpb.IDeleteContractCoverageRequest} request DeleteContractCoverageRequest message or plain object
         * @returns {Promise<contractpb.DeleteContractCoverageResponse>} Promise
         * @variation 2
         */

        return ContractCoverages;
    })();

    contractpb.AsyncRequest = (function() {

        /**
         * Constructs a new AsyncRequest service.
         * @memberof contractpb
         * @classdesc Represents an AsyncRequest
         * @extends $protobuf.rpc.Service
         * @constructor
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         */
        function AsyncRequest(rpcImpl, requestDelimited, responseDelimited) {
            $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
        }

        (AsyncRequest.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = AsyncRequest;

        /**
         * Creates new AsyncRequest service using the specified rpc implementation.
         * @function create
         * @memberof contractpb.AsyncRequest
         * @static
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         * @returns {AsyncRequest} RPC service. Useful where requests and/or responses are streamed.
         */
        AsyncRequest.create = function create(rpcImpl, requestDelimited, responseDelimited) {
            return new this(rpcImpl, requestDelimited, responseDelimited);
        };

        /**
         * Callback as used by {@link contractpb.AsyncRequest#getAsyncRequestObject}.
         * @memberof contractpb.AsyncRequest
         * @typedef GetAsyncRequestObjectCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {contractpb.AsyncReqDetailsResponse} [response] AsyncReqDetailsResponse
         */

        /**
         * Calls GetAsyncRequestObject.
         * @function getAsyncRequestObject
         * @memberof contractpb.AsyncRequest
         * @instance
         * @param {contractpb.IAsyncReqDetailsRequest} request AsyncReqDetailsRequest message or plain object
         * @param {contractpb.AsyncRequest.GetAsyncRequestObjectCallback} callback Node-style callback called with the error, if any, and AsyncReqDetailsResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(AsyncRequest.prototype.getAsyncRequestObject = function getAsyncRequestObject(request, callback) {
            return this.rpcCall(getAsyncRequestObject, $root.contractpb.AsyncReqDetailsRequest, $root.contractpb.AsyncReqDetailsResponse, request, callback);
        }, "name", { value: "GetAsyncRequestObject" });

        /**
         * Calls GetAsyncRequestObject.
         * @function getAsyncRequestObject
         * @memberof contractpb.AsyncRequest
         * @instance
         * @param {contractpb.IAsyncReqDetailsRequest} request AsyncReqDetailsRequest message or plain object
         * @returns {Promise<contractpb.AsyncReqDetailsResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link contractpb.AsyncRequest#updateAsyncRequestObject}.
         * @memberof contractpb.AsyncRequest
         * @typedef UpdateAsyncRequestObjectCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {contractpb.AsyncReqProcessorUpdateResponse} [response] AsyncReqProcessorUpdateResponse
         */

        /**
         * Calls UpdateAsyncRequestObject.
         * @function updateAsyncRequestObject
         * @memberof contractpb.AsyncRequest
         * @instance
         * @param {contractpb.IAsyncReqProcessorUpdateRequest} request AsyncReqProcessorUpdateRequest message or plain object
         * @param {contractpb.AsyncRequest.UpdateAsyncRequestObjectCallback} callback Node-style callback called with the error, if any, and AsyncReqProcessorUpdateResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(AsyncRequest.prototype.updateAsyncRequestObject = function updateAsyncRequestObject(request, callback) {
            return this.rpcCall(updateAsyncRequestObject, $root.contractpb.AsyncReqProcessorUpdateRequest, $root.contractpb.AsyncReqProcessorUpdateResponse, request, callback);
        }, "name", { value: "UpdateAsyncRequestObject" });

        /**
         * Calls UpdateAsyncRequestObject.
         * @function updateAsyncRequestObject
         * @memberof contractpb.AsyncRequest
         * @instance
         * @param {contractpb.IAsyncReqProcessorUpdateRequest} request AsyncReqProcessorUpdateRequest message or plain object
         * @returns {Promise<contractpb.AsyncReqProcessorUpdateResponse>} Promise
         * @variation 2
         */

        return AsyncRequest;
    })();

    contractpb.ContractByID = (function() {

        /**
         * Constructs a new ContractByID service.
         * @memberof contractpb
         * @classdesc Represents a ContractByID
         * @extends $protobuf.rpc.Service
         * @constructor
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         */
        function ContractByID(rpcImpl, requestDelimited, responseDelimited) {
            $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
        }

        (ContractByID.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = ContractByID;

        /**
         * Creates new ContractByID service using the specified rpc implementation.
         * @function create
         * @memberof contractpb.ContractByID
         * @static
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         * @returns {ContractByID} RPC service. Useful where requests and/or responses are streamed.
         */
        ContractByID.create = function create(rpcImpl, requestDelimited, responseDelimited) {
            return new this(rpcImpl, requestDelimited, responseDelimited);
        };

        /**
         * Callback as used by {@link contractpb.ContractByID#updateContractByID}.
         * @memberof contractpb.ContractByID
         * @typedef UpdateContractByIDCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {contractpb.UpdateContractResponse} [response] UpdateContractResponse
         */

        /**
         * Calls UpdateContractByID.
         * @function updateContractByID
         * @memberof contractpb.ContractByID
         * @instance
         * @param {contractpb.IUpdateContractRequest} request UpdateContractRequest message or plain object
         * @param {contractpb.ContractByID.UpdateContractByIDCallback} callback Node-style callback called with the error, if any, and UpdateContractResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(ContractByID.prototype.updateContractByID = function updateContractByID(request, callback) {
            return this.rpcCall(updateContractByID, $root.contractpb.UpdateContractRequest, $root.contractpb.UpdateContractResponse, request, callback);
        }, "name", { value: "UpdateContractByID" });

        /**
         * Calls UpdateContractByID.
         * @function updateContractByID
         * @memberof contractpb.ContractByID
         * @instance
         * @param {contractpb.IUpdateContractRequest} request UpdateContractRequest message or plain object
         * @returns {Promise<contractpb.UpdateContractResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link contractpb.ContractByID#deleteContractByID}.
         * @memberof contractpb.ContractByID
         * @typedef DeleteContractByIDCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {contractpb.DeleteContractResponse} [response] DeleteContractResponse
         */

        /**
         * Calls DeleteContractByID.
         * @function deleteContractByID
         * @memberof contractpb.ContractByID
         * @instance
         * @param {contractpb.IDeleteContractRequest} request DeleteContractRequest message or plain object
         * @param {contractpb.ContractByID.DeleteContractByIDCallback} callback Node-style callback called with the error, if any, and DeleteContractResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(ContractByID.prototype.deleteContractByID = function deleteContractByID(request, callback) {
            return this.rpcCall(deleteContractByID, $root.contractpb.DeleteContractRequest, $root.contractpb.DeleteContractResponse, request, callback);
        }, "name", { value: "DeleteContractByID" });

        /**
         * Calls DeleteContractByID.
         * @function deleteContractByID
         * @memberof contractpb.ContractByID
         * @instance
         * @param {contractpb.IDeleteContractRequest} request DeleteContractRequest message or plain object
         * @returns {Promise<contractpb.DeleteContractResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link contractpb.ContractByID#getContractByID}.
         * @memberof contractpb.ContractByID
         * @typedef GetContractByIDCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {contractpb.ContractResponse} [response] ContractResponse
         */

        /**
         * Calls GetContractByID.
         * @function getContractByID
         * @memberof contractpb.ContractByID
         * @instance
         * @param {google.protobuf.IEmpty} request Empty message or plain object
         * @param {contractpb.ContractByID.GetContractByIDCallback} callback Node-style callback called with the error, if any, and ContractResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(ContractByID.prototype.getContractByID = function getContractByID(request, callback) {
            return this.rpcCall(getContractByID, $root.google.protobuf.Empty, $root.contractpb.ContractResponse, request, callback);
        }, "name", { value: "GetContractByID" });

        /**
         * Calls GetContractByID.
         * @function getContractByID
         * @memberof contractpb.ContractByID
         * @instance
         * @param {google.protobuf.IEmpty} request Empty message or plain object
         * @returns {Promise<contractpb.ContractResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link contractpb.ContractByID#getRenewalHierarchy}.
         * @memberof contractpb.ContractByID
         * @typedef GetRenewalHierarchyCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {contractpb.GetRenewalHierarchyResponse} [response] GetRenewalHierarchyResponse
         */

        /**
         * Calls GetRenewalHierarchy.
         * @function getRenewalHierarchy
         * @memberof contractpb.ContractByID
         * @instance
         * @param {contractpb.IGetRenewalHierarchyRequest} request GetRenewalHierarchyRequest message or plain object
         * @param {contractpb.ContractByID.GetRenewalHierarchyCallback} callback Node-style callback called with the error, if any, and GetRenewalHierarchyResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(ContractByID.prototype.getRenewalHierarchy = function getRenewalHierarchy(request, callback) {
            return this.rpcCall(getRenewalHierarchy, $root.contractpb.GetRenewalHierarchyRequest, $root.contractpb.GetRenewalHierarchyResponse, request, callback);
        }, "name", { value: "GetRenewalHierarchy" });

        /**
         * Calls GetRenewalHierarchy.
         * @function getRenewalHierarchy
         * @memberof contractpb.ContractByID
         * @instance
         * @param {contractpb.IGetRenewalHierarchyRequest} request GetRenewalHierarchyRequest message or plain object
         * @returns {Promise<contractpb.GetRenewalHierarchyResponse>} Promise
         * @variation 2
         */

        return ContractByID;
    })();

    contractpb.BillingDate = (function() {

        /**
         * Constructs a new BillingDate service.
         * @memberof contractpb
         * @classdesc Represents a BillingDate
         * @extends $protobuf.rpc.Service
         * @constructor
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         */
        function BillingDate(rpcImpl, requestDelimited, responseDelimited) {
            $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
        }

        (BillingDate.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = BillingDate;

        /**
         * Creates new BillingDate service using the specified rpc implementation.
         * @function create
         * @memberof contractpb.BillingDate
         * @static
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         * @returns {BillingDate} RPC service. Useful where requests and/or responses are streamed.
         */
        BillingDate.create = function create(rpcImpl, requestDelimited, responseDelimited) {
            return new this(rpcImpl, requestDelimited, responseDelimited);
        };

        /**
         * Callback as used by {@link contractpb.BillingDate#getBillingDateChangeability}.
         * @memberof contractpb.BillingDate
         * @typedef GetBillingDateChangeabilityCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {contractpb.BillingDateChangeabilityResponse} [response] BillingDateChangeabilityResponse
         */

        /**
         * Calls GetBillingDateChangeability.
         * @function getBillingDateChangeability
         * @memberof contractpb.BillingDate
         * @instance
         * @param {contractpb.IBillingDateChangeabilityRequest} request BillingDateChangeabilityRequest message or plain object
         * @param {contractpb.BillingDate.GetBillingDateChangeabilityCallback} callback Node-style callback called with the error, if any, and BillingDateChangeabilityResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(BillingDate.prototype.getBillingDateChangeability = function getBillingDateChangeability(request, callback) {
            return this.rpcCall(getBillingDateChangeability, $root.contractpb.BillingDateChangeabilityRequest, $root.contractpb.BillingDateChangeabilityResponse, request, callback);
        }, "name", { value: "GetBillingDateChangeability" });

        /**
         * Calls GetBillingDateChangeability.
         * @function getBillingDateChangeability
         * @memberof contractpb.BillingDate
         * @instance
         * @param {contractpb.IBillingDateChangeabilityRequest} request BillingDateChangeabilityRequest message or plain object
         * @returns {Promise<contractpb.BillingDateChangeabilityResponse>} Promise
         * @variation 2
         */

        return BillingDate;
    })();

    contractpb.CreateContract = (function() {

        /**
         * Constructs a new CreateContract service.
         * @memberof contractpb
         * @classdesc Represents a CreateContract
         * @extends $protobuf.rpc.Service
         * @constructor
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         */
        function CreateContract(rpcImpl, requestDelimited, responseDelimited) {
            $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
        }

        (CreateContract.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = CreateContract;

        /**
         * Creates new CreateContract service using the specified rpc implementation.
         * @function create
         * @memberof contractpb.CreateContract
         * @static
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         * @returns {CreateContract} RPC service. Useful where requests and/or responses are streamed.
         */
        CreateContract.create = function create(rpcImpl, requestDelimited, responseDelimited) {
            return new this(rpcImpl, requestDelimited, responseDelimited);
        };

        /**
         * Callback as used by {@link contractpb.CreateContract#createContract}.
         * @memberof contractpb.CreateContract
         * @typedef CreateContractCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {contractpb.CreateContractResponse} [response] CreateContractResponse
         */

        /**
         * Calls CreateContract.
         * @function createContract
         * @memberof contractpb.CreateContract
         * @instance
         * @param {contractpb.ICreateContractRequest} request CreateContractRequest message or plain object
         * @param {contractpb.CreateContract.CreateContractCallback} callback Node-style callback called with the error, if any, and CreateContractResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(CreateContract.prototype.createContract = function createContract(request, callback) {
            return this.rpcCall(createContract, $root.contractpb.CreateContractRequest, $root.contractpb.CreateContractResponse, request, callback);
        }, "name", { value: "CreateContract" });

        /**
         * Calls CreateContract.
         * @function createContract
         * @memberof contractpb.CreateContract
         * @instance
         * @param {contractpb.ICreateContractRequest} request CreateContractRequest message or plain object
         * @returns {Promise<contractpb.CreateContractResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link contractpb.CreateContract#createContractV2}.
         * @memberof contractpb.CreateContract
         * @typedef CreateContractV2Callback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {contractpb.CreateContractResponse} [response] CreateContractResponse
         */

        /**
         * Calls CreateContractV2.
         * @function createContractV2
         * @memberof contractpb.CreateContract
         * @instance
         * @param {contractpb.ICreateContractRequest} request CreateContractRequest message or plain object
         * @param {contractpb.CreateContract.CreateContractV2Callback} callback Node-style callback called with the error, if any, and CreateContractResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(CreateContract.prototype.createContractV2 = function createContractV2(request, callback) {
            return this.rpcCall(createContractV2, $root.contractpb.CreateContractRequest, $root.contractpb.CreateContractResponse, request, callback);
        }, "name", { value: "CreateContractV2" });

        /**
         * Calls CreateContractV2.
         * @function createContractV2
         * @memberof contractpb.CreateContract
         * @instance
         * @param {contractpb.ICreateContractRequest} request CreateContractRequest message or plain object
         * @returns {Promise<contractpb.CreateContractResponse>} Promise
         * @variation 2
         */

        return CreateContract;
    })();

    contractpb.Contracts = (function() {

        /**
         * Constructs a new Contracts service.
         * @memberof contractpb
         * @classdesc Represents a Contracts
         * @extends $protobuf.rpc.Service
         * @constructor
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         */
        function Contracts(rpcImpl, requestDelimited, responseDelimited) {
            $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
        }

        (Contracts.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = Contracts;

        /**
         * Creates new Contracts service using the specified rpc implementation.
         * @function create
         * @memberof contractpb.Contracts
         * @static
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         * @returns {Contracts} RPC service. Useful where requests and/or responses are streamed.
         */
        Contracts.create = function create(rpcImpl, requestDelimited, responseDelimited) {
            return new this(rpcImpl, requestDelimited, responseDelimited);
        };

        /**
         * Callback as used by {@link contractpb.Contracts#getContracts}.
         * @memberof contractpb.Contracts
         * @typedef GetContractsCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {contractpb.ContractUnifiedSearchResponse} [response] ContractUnifiedSearchResponse
         */

        /**
         * Calls GetContracts.
         * @function getContracts
         * @memberof contractpb.Contracts
         * @instance
         * @param {contractpb.IContractUnifiedSearchRequest} request ContractUnifiedSearchRequest message or plain object
         * @param {contractpb.Contracts.GetContractsCallback} callback Node-style callback called with the error, if any, and ContractUnifiedSearchResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(Contracts.prototype.getContracts = function getContracts(request, callback) {
            return this.rpcCall(getContracts, $root.contractpb.ContractUnifiedSearchRequest, $root.contractpb.ContractUnifiedSearchResponse, request, callback);
        }, "name", { value: "GetContracts" });

        /**
         * Calls GetContracts.
         * @function getContracts
         * @memberof contractpb.Contracts
         * @instance
         * @param {contractpb.IContractUnifiedSearchRequest} request ContractUnifiedSearchRequest message or plain object
         * @returns {Promise<contractpb.ContractUnifiedSearchResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link contractpb.Contracts#updateContractStatus}.
         * @memberof contractpb.Contracts
         * @typedef UpdateContractStatusCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {contractpb.UpdateContractStatusResponse} [response] UpdateContractStatusResponse
         */

        /**
         * Calls UpdateContractStatus.
         * @function updateContractStatus
         * @memberof contractpb.Contracts
         * @instance
         * @param {contractpb.IUpdateContractStatusRequest} request UpdateContractStatusRequest message or plain object
         * @param {contractpb.Contracts.UpdateContractStatusCallback} callback Node-style callback called with the error, if any, and UpdateContractStatusResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(Contracts.prototype.updateContractStatus = function updateContractStatus(request, callback) {
            return this.rpcCall(updateContractStatus, $root.contractpb.UpdateContractStatusRequest, $root.contractpb.UpdateContractStatusResponse, request, callback);
        }, "name", { value: "UpdateContractStatus" });

        /**
         * Calls UpdateContractStatus.
         * @function updateContractStatus
         * @memberof contractpb.Contracts
         * @instance
         * @param {contractpb.IUpdateContractStatusRequest} request UpdateContractStatusRequest message or plain object
         * @returns {Promise<contractpb.UpdateContractStatusResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link contractpb.Contracts#getContractDocument}.
         * @memberof contractpb.Contracts
         * @typedef GetContractDocumentCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {contractpb.ContractDownloadResponseV2} [response] ContractDownloadResponseV2
         */

        /**
         * Calls GetContractDocument.
         * @function getContractDocument
         * @memberof contractpb.Contracts
         * @instance
         * @param {contractpb.IContractDownloadRequestV2} request ContractDownloadRequestV2 message or plain object
         * @param {contractpb.Contracts.GetContractDocumentCallback} callback Node-style callback called with the error, if any, and ContractDownloadResponseV2
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(Contracts.prototype.getContractDocument = function getContractDocument(request, callback) {
            return this.rpcCall(getContractDocument, $root.contractpb.ContractDownloadRequestV2, $root.contractpb.ContractDownloadResponseV2, request, callback);
        }, "name", { value: "GetContractDocument" });

        /**
         * Calls GetContractDocument.
         * @function getContractDocument
         * @memberof contractpb.Contracts
         * @instance
         * @param {contractpb.IContractDownloadRequestV2} request ContractDownloadRequestV2 message or plain object
         * @returns {Promise<contractpb.ContractDownloadResponseV2>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link contractpb.Contracts#getContractsOnPvID}.
         * @memberof contractpb.Contracts
         * @typedef GetContractsOnPvIDCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {contractpb.GetContractsOnPvIDResponse} [response] GetContractsOnPvIDResponse
         */

        /**
         * Calls GetContractsOnPvID.
         * @function getContractsOnPvID
         * @memberof contractpb.Contracts
         * @instance
         * @param {contractpb.IGetContractsOnPvIDReq} request GetContractsOnPvIDReq message or plain object
         * @param {contractpb.Contracts.GetContractsOnPvIDCallback} callback Node-style callback called with the error, if any, and GetContractsOnPvIDResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(Contracts.prototype.getContractsOnPvID = function getContractsOnPvID(request, callback) {
            return this.rpcCall(getContractsOnPvID, $root.contractpb.GetContractsOnPvIDReq, $root.contractpb.GetContractsOnPvIDResponse, request, callback);
        }, "name", { value: "GetContractsOnPvID" });

        /**
         * Calls GetContractsOnPvID.
         * @function getContractsOnPvID
         * @memberof contractpb.Contracts
         * @instance
         * @param {contractpb.IGetContractsOnPvIDReq} request GetContractsOnPvIDReq message or plain object
         * @returns {Promise<contractpb.GetContractsOnPvIDResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link contractpb.Contracts#getExistingCutomerContractsV2}.
         * @memberof contractpb.Contracts
         * @typedef GetExistingCutomerContractsV2Callback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {contractpb.ExistingCustomerContractsResponseV2} [response] ExistingCustomerContractsResponseV2
         */

        /**
         * Calls GetExistingCutomerContractsV2.
         * @function getExistingCutomerContractsV2
         * @memberof contractpb.Contracts
         * @instance
         * @param {contractpb.IExistingCustomerContractsRequestV2} request ExistingCustomerContractsRequestV2 message or plain object
         * @param {contractpb.Contracts.GetExistingCutomerContractsV2Callback} callback Node-style callback called with the error, if any, and ExistingCustomerContractsResponseV2
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(Contracts.prototype.getExistingCutomerContractsV2 = function getExistingCutomerContractsV2(request, callback) {
            return this.rpcCall(getExistingCutomerContractsV2, $root.contractpb.ExistingCustomerContractsRequestV2, $root.contractpb.ExistingCustomerContractsResponseV2, request, callback);
        }, "name", { value: "GetExistingCutomerContractsV2" });

        /**
         * Calls GetExistingCutomerContractsV2.
         * @function getExistingCutomerContractsV2
         * @memberof contractpb.Contracts
         * @instance
         * @param {contractpb.IExistingCustomerContractsRequestV2} request ExistingCustomerContractsRequestV2 message or plain object
         * @returns {Promise<contractpb.ExistingCustomerContractsResponseV2>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link contractpb.Contracts#getChangeTracker}.
         * @memberof contractpb.Contracts
         * @typedef GetChangeTrackerCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {contractpb.ContractChangeTrackerResponse} [response] ContractChangeTrackerResponse
         */

        /**
         * Calls GetChangeTracker.
         * @function getChangeTracker
         * @memberof contractpb.Contracts
         * @instance
         * @param {contractpb.IContractChangeTrackerRequest} request ContractChangeTrackerRequest message or plain object
         * @param {contractpb.Contracts.GetChangeTrackerCallback} callback Node-style callback called with the error, if any, and ContractChangeTrackerResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(Contracts.prototype.getChangeTracker = function getChangeTracker(request, callback) {
            return this.rpcCall(getChangeTracker, $root.contractpb.ContractChangeTrackerRequest, $root.contractpb.ContractChangeTrackerResponse, request, callback);
        }, "name", { value: "GetChangeTracker" });

        /**
         * Calls GetChangeTracker.
         * @function getChangeTracker
         * @memberof contractpb.Contracts
         * @instance
         * @param {contractpb.IContractChangeTrackerRequest} request ContractChangeTrackerRequest message or plain object
         * @returns {Promise<contractpb.ContractChangeTrackerResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link contractpb.Contracts#updateContractPropertyV2}.
         * @memberof contractpb.Contracts
         * @typedef UpdateContractPropertyV2Callback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {contractpb.UpdateContractPropertyResponseV2} [response] UpdateContractPropertyResponseV2
         */

        /**
         * Calls UpdateContractPropertyV2.
         * @function updateContractPropertyV2
         * @memberof contractpb.Contracts
         * @instance
         * @param {contractpb.IUpdateContractPropertyRequestV2} request UpdateContractPropertyRequestV2 message or plain object
         * @param {contractpb.Contracts.UpdateContractPropertyV2Callback} callback Node-style callback called with the error, if any, and UpdateContractPropertyResponseV2
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(Contracts.prototype.updateContractPropertyV2 = function updateContractPropertyV2(request, callback) {
            return this.rpcCall(updateContractPropertyV2, $root.contractpb.UpdateContractPropertyRequestV2, $root.contractpb.UpdateContractPropertyResponseV2, request, callback);
        }, "name", { value: "UpdateContractPropertyV2" });

        /**
         * Calls UpdateContractPropertyV2.
         * @function updateContractPropertyV2
         * @memberof contractpb.Contracts
         * @instance
         * @param {contractpb.IUpdateContractPropertyRequestV2} request UpdateContractPropertyRequestV2 message or plain object
         * @returns {Promise<contractpb.UpdateContractPropertyResponseV2>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link contractpb.Contracts#cancelContractV2}.
         * @memberof contractpb.Contracts
         * @typedef CancelContractV2Callback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {contractpb.CancelContractResponseV2} [response] CancelContractResponseV2
         */

        /**
         * Calls CancelContractV2.
         * @function cancelContractV2
         * @memberof contractpb.Contracts
         * @instance
         * @param {contractpb.ICancelContractRequestV2} request CancelContractRequestV2 message or plain object
         * @param {contractpb.Contracts.CancelContractV2Callback} callback Node-style callback called with the error, if any, and CancelContractResponseV2
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(Contracts.prototype.cancelContractV2 = function cancelContractV2(request, callback) {
            return this.rpcCall(cancelContractV2, $root.contractpb.CancelContractRequestV2, $root.contractpb.CancelContractResponseV2, request, callback);
        }, "name", { value: "CancelContractV2" });

        /**
         * Calls CancelContractV2.
         * @function cancelContractV2
         * @memberof contractpb.Contracts
         * @instance
         * @param {contractpb.ICancelContractRequestV2} request CancelContractRequestV2 message or plain object
         * @returns {Promise<contractpb.CancelContractResponseV2>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link contractpb.Contracts#getContractProperty}.
         * @memberof contractpb.Contracts
         * @typedef GetContractPropertyCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {contractpb.ContractProperty} [response] ContractProperty
         */

        /**
         * Calls GetContractProperty.
         * @function getContractProperty
         * @memberof contractpb.Contracts
         * @instance
         * @param {google.protobuf.IEmpty} request Empty message or plain object
         * @param {contractpb.Contracts.GetContractPropertyCallback} callback Node-style callback called with the error, if any, and ContractProperty
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(Contracts.prototype.getContractProperty = function getContractProperty(request, callback) {
            return this.rpcCall(getContractProperty, $root.google.protobuf.Empty, $root.contractpb.ContractProperty, request, callback);
        }, "name", { value: "GetContractProperty" });

        /**
         * Calls GetContractProperty.
         * @function getContractProperty
         * @memberof contractpb.Contracts
         * @instance
         * @param {google.protobuf.IEmpty} request Empty message or plain object
         * @returns {Promise<contractpb.ContractProperty>} Promise
         * @variation 2
         */

        return Contracts;
    })();

    contractpb.Cancellation = (function() {

        /**
         * Constructs a new Cancellation service.
         * @memberof contractpb
         * @classdesc Represents a Cancellation
         * @extends $protobuf.rpc.Service
         * @constructor
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         */
        function Cancellation(rpcImpl, requestDelimited, responseDelimited) {
            $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
        }

        (Cancellation.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = Cancellation;

        /**
         * Creates new Cancellation service using the specified rpc implementation.
         * @function create
         * @memberof contractpb.Cancellation
         * @static
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         * @returns {Cancellation} RPC service. Useful where requests and/or responses are streamed.
         */
        Cancellation.create = function create(rpcImpl, requestDelimited, responseDelimited) {
            return new this(rpcImpl, requestDelimited, responseDelimited);
        };

        /**
         * Callback as used by {@link contractpb.Cancellation#getContractCancellationCosts}.
         * @memberof contractpb.Cancellation
         * @typedef GetContractCancellationCostsCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {contractpb.GetContractCostsResp} [response] GetContractCostsResp
         */

        /**
         * Calls GetContractCancellationCosts.
         * @function getContractCancellationCosts
         * @memberof contractpb.Cancellation
         * @instance
         * @param {contractpb.IGetCancellationCostReq} request GetCancellationCostReq message or plain object
         * @param {contractpb.Cancellation.GetContractCancellationCostsCallback} callback Node-style callback called with the error, if any, and GetContractCostsResp
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(Cancellation.prototype.getContractCancellationCosts = function getContractCancellationCosts(request, callback) {
            return this.rpcCall(getContractCancellationCosts, $root.contractpb.GetCancellationCostReq, $root.contractpb.GetContractCostsResp, request, callback);
        }, "name", { value: "GetContractCancellationCosts" });

        /**
         * Calls GetContractCancellationCosts.
         * @function getContractCancellationCosts
         * @memberof contractpb.Cancellation
         * @instance
         * @param {contractpb.IGetCancellationCostReq} request GetCancellationCostReq message or plain object
         * @returns {Promise<contractpb.GetContractCostsResp>} Promise
         * @variation 2
         */

        return Cancellation;
    })();

    contractpb.Invoice = (function() {

        /**
         * Constructs a new Invoice service.
         * @memberof contractpb
         * @classdesc Represents an Invoice
         * @extends $protobuf.rpc.Service
         * @constructor
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         */
        function Invoice(rpcImpl, requestDelimited, responseDelimited) {
            $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
        }

        (Invoice.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = Invoice;

        /**
         * Creates new Invoice service using the specified rpc implementation.
         * @function create
         * @memberof contractpb.Invoice
         * @static
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         * @returns {Invoice} RPC service. Useful where requests and/or responses are streamed.
         */
        Invoice.create = function create(rpcImpl, requestDelimited, responseDelimited) {
            return new this(rpcImpl, requestDelimited, responseDelimited);
        };

        /**
         * Callback as used by {@link contractpb.Invoice#getContractInvoiceDayDetails}.
         * @memberof contractpb.Invoice
         * @typedef GetContractInvoiceDayDetailsCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {contractpb.GetContractInvoiceDayDetailsResp} [response] GetContractInvoiceDayDetailsResp
         */

        /**
         * Calls GetContractInvoiceDayDetails.
         * @function getContractInvoiceDayDetails
         * @memberof contractpb.Invoice
         * @instance
         * @param {contractpb.IGetContractInvoiceDayDetailsReq} request GetContractInvoiceDayDetailsReq message or plain object
         * @param {contractpb.Invoice.GetContractInvoiceDayDetailsCallback} callback Node-style callback called with the error, if any, and GetContractInvoiceDayDetailsResp
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(Invoice.prototype.getContractInvoiceDayDetails = function getContractInvoiceDayDetails(request, callback) {
            return this.rpcCall(getContractInvoiceDayDetails, $root.contractpb.GetContractInvoiceDayDetailsReq, $root.contractpb.GetContractInvoiceDayDetailsResp, request, callback);
        }, "name", { value: "GetContractInvoiceDayDetails" });

        /**
         * Calls GetContractInvoiceDayDetails.
         * @function getContractInvoiceDayDetails
         * @memberof contractpb.Invoice
         * @instance
         * @param {contractpb.IGetContractInvoiceDayDetailsReq} request GetContractInvoiceDayDetailsReq message or plain object
         * @returns {Promise<contractpb.GetContractInvoiceDayDetailsResp>} Promise
         * @variation 2
         */

        return Invoice;
    })();

    contractpb.Date = (function() {

        /**
         * Constructs a new Date service.
         * @memberof contractpb
         * @classdesc Represents a Date
         * @extends $protobuf.rpc.Service
         * @constructor
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         */
        function Date(rpcImpl, requestDelimited, responseDelimited) {
            $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
        }

        (Date.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = Date;

        /**
         * Creates new Date service using the specified rpc implementation.
         * @function create
         * @memberof contractpb.Date
         * @static
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         * @returns {Date} RPC service. Useful where requests and/or responses are streamed.
         */
        Date.create = function create(rpcImpl, requestDelimited, responseDelimited) {
            return new this(rpcImpl, requestDelimited, responseDelimited);
        };

        /**
         * Callback as used by {@link contractpb.Date#updateContractDate}.
         * @memberof contractpb.Date
         * @typedef UpdateContractDateCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {google.protobuf.Empty} [response] Empty
         */

        /**
         * Calls UpdateContractDate.
         * @function updateContractDate
         * @memberof contractpb.Date
         * @instance
         * @param {contractpb.IContractDates} request ContractDates message or plain object
         * @param {contractpb.Date.UpdateContractDateCallback} callback Node-style callback called with the error, if any, and Empty
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(Date.prototype.updateContractDate = function updateContractDate(request, callback) {
            return this.rpcCall(updateContractDate, $root.contractpb.ContractDates, $root.google.protobuf.Empty, request, callback);
        }, "name", { value: "UpdateContractDate" });

        /**
         * Calls UpdateContractDate.
         * @function updateContractDate
         * @memberof contractpb.Date
         * @instance
         * @param {contractpb.IContractDates} request ContractDates message or plain object
         * @returns {Promise<google.protobuf.Empty>} Promise
         * @variation 2
         */

        return Date;
    })();

    contractpb.ContractDiscrepancy = (function() {

        /**
         * Constructs a new ContractDiscrepancy service.
         * @memberof contractpb
         * @classdesc Represents a ContractDiscrepancy
         * @extends $protobuf.rpc.Service
         * @constructor
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         */
        function ContractDiscrepancy(rpcImpl, requestDelimited, responseDelimited) {
            $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
        }

        (ContractDiscrepancy.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = ContractDiscrepancy;

        /**
         * Creates new ContractDiscrepancy service using the specified rpc implementation.
         * @function create
         * @memberof contractpb.ContractDiscrepancy
         * @static
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         * @returns {ContractDiscrepancy} RPC service. Useful where requests and/or responses are streamed.
         */
        ContractDiscrepancy.create = function create(rpcImpl, requestDelimited, responseDelimited) {
            return new this(rpcImpl, requestDelimited, responseDelimited);
        };

        /**
         * Callback as used by {@link contractpb.ContractDiscrepancy#getContractDiscrepancy}.
         * @memberof contractpb.ContractDiscrepancy
         * @typedef GetContractDiscrepancyCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {contractpb.GetContractDiscrepancyResponse} [response] GetContractDiscrepancyResponse
         */

        /**
         * Calls GetContractDiscrepancy.
         * @function getContractDiscrepancy
         * @memberof contractpb.ContractDiscrepancy
         * @instance
         * @param {contractpb.IGetContractDiscrepancyRequest} request GetContractDiscrepancyRequest message or plain object
         * @param {contractpb.ContractDiscrepancy.GetContractDiscrepancyCallback} callback Node-style callback called with the error, if any, and GetContractDiscrepancyResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(ContractDiscrepancy.prototype.getContractDiscrepancy = function getContractDiscrepancy(request, callback) {
            return this.rpcCall(getContractDiscrepancy, $root.contractpb.GetContractDiscrepancyRequest, $root.contractpb.GetContractDiscrepancyResponse, request, callback);
        }, "name", { value: "GetContractDiscrepancy" });

        /**
         * Calls GetContractDiscrepancy.
         * @function getContractDiscrepancy
         * @memberof contractpb.ContractDiscrepancy
         * @instance
         * @param {contractpb.IGetContractDiscrepancyRequest} request GetContractDiscrepancyRequest message or plain object
         * @returns {Promise<contractpb.GetContractDiscrepancyResponse>} Promise
         * @variation 2
         */

        return ContractDiscrepancy;
    })();

    return contractpb;
})();

export const coreproductpb = $root.coreproductpb = (() => {

    /**
     * Namespace coreproductpb.
     * @exports coreproductpb
     * @namespace
     */
    const coreproductpb = {};

    /**
     * CustomerType enum.
     * @name coreproductpb.CustomerType
     * @enum {number}
     * @property {number} CustomerType_ALL=0 CustomerType_ALL value
     * @property {number} CustomerType_HOMEOWNER=1 CustomerType_HOMEOWNER value
     * @property {number} CustomerType_BUYER=2 CustomerType_BUYER value
     * @property {number} CustomerType_SELLER=3 CustomerType_SELLER value
     * @property {number} CustomerType_SELLER_BUYER=4 CustomerType_SELLER_BUYER value
     */
    coreproductpb.CustomerType = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "CustomerType_ALL"] = 0;
        values[valuesById[1] = "CustomerType_HOMEOWNER"] = 1;
        values[valuesById[2] = "CustomerType_BUYER"] = 2;
        values[valuesById[3] = "CustomerType_SELLER"] = 3;
        values[valuesById[4] = "CustomerType_SELLER_BUYER"] = 4;
        return values;
    })();

    /**
     * SalesChannelType enum.
     * @name coreproductpb.SalesChannelType
     * @enum {number}
     * @property {number} SalesChannelType_ALL=0 SalesChannelType_ALL value
     * @property {number} SalesChannelType_HOMEOWNER=1 SalesChannelType_HOMEOWNER value
     * @property {number} SalesChannelType_RENEWAL=2 SalesChannelType_RENEWAL value
     * @property {number} SalesChannelType_REAL_ESTATE=3 SalesChannelType_REAL_ESTATE value
     */
    coreproductpb.SalesChannelType = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "SalesChannelType_ALL"] = 0;
        values[valuesById[1] = "SalesChannelType_HOMEOWNER"] = 1;
        values[valuesById[2] = "SalesChannelType_RENEWAL"] = 2;
        values[valuesById[3] = "SalesChannelType_REAL_ESTATE"] = 3;
        return values;
    })();

    /**
     * PurchaseChannel enum.
     * @name coreproductpb.PurchaseChannel
     * @enum {number}
     * @property {number} PurchaseChannel_OTHER=0 PurchaseChannel_OTHER value
     * @property {number} PurchaseChannel_PHONE=1 PurchaseChannel_PHONE value
     * @property {number} PurchaseChannel_WEB=2 PurchaseChannel_WEB value
     * @property {number} PurchaseChannel_CHAT=3 PurchaseChannel_CHAT value
     */
    coreproductpb.PurchaseChannel = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "PurchaseChannel_OTHER"] = 0;
        values[valuesById[1] = "PurchaseChannel_PHONE"] = 1;
        values[valuesById[2] = "PurchaseChannel_WEB"] = 2;
        values[valuesById[3] = "PurchaseChannel_CHAT"] = 3;
        return values;
    })();

    /**
     * DwellingType enum.
     * @name coreproductpb.DwellingType
     * @enum {number}
     * @property {number} DwellingType_UNKNOWN=0 DwellingType_UNKNOWN value
     * @property {number} DwellingType_SINGLE_FAMILY=1 DwellingType_SINGLE_FAMILY value
     * @property {number} DwellingType_CONDO=2 DwellingType_CONDO value
     * @property {number} DwellingType_TOWNHOME=3 DwellingType_TOWNHOME value
     * @property {number} DwellingType_MOBILE_HOME=4 DwellingType_MOBILE_HOME value
     * @property {number} DwellingType_DUPLEX=5 DwellingType_DUPLEX value
     * @property {number} DwellingType_TRIPLEX=6 DwellingType_TRIPLEX value
     * @property {number} DwellingType_FOUR_PLEX=7 DwellingType_FOUR_PLEX value
     * @property {number} DwellingType_MULTI_UNIT=8 DwellingType_MULTI_UNIT value
     */
    coreproductpb.DwellingType = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "DwellingType_UNKNOWN"] = 0;
        values[valuesById[1] = "DwellingType_SINGLE_FAMILY"] = 1;
        values[valuesById[2] = "DwellingType_CONDO"] = 2;
        values[valuesById[3] = "DwellingType_TOWNHOME"] = 3;
        values[valuesById[4] = "DwellingType_MOBILE_HOME"] = 4;
        values[valuesById[5] = "DwellingType_DUPLEX"] = 5;
        values[valuesById[6] = "DwellingType_TRIPLEX"] = 6;
        values[valuesById[7] = "DwellingType_FOUR_PLEX"] = 7;
        values[valuesById[8] = "DwellingType_MULTI_UNIT"] = 8;
        return values;
    })();

    /**
     * PaymentTerms enum.
     * @name coreproductpb.PaymentTerms
     * @enum {number}
     * @property {number} PaymentTerms_UNKNOWN=0 PaymentTerms_UNKNOWN value
     * @property {number} PaymentTerms_MONTHLY=1 PaymentTerms_MONTHLY value
     * @property {number} PaymentTerms_ANNUAL=2 PaymentTerms_ANNUAL value
     * @property {number} PaymentTerms_QUARTERLY=3 PaymentTerms_QUARTERLY value
     * @property {number} PaymentTerms_SEMIANNUAL=4 PaymentTerms_SEMIANNUAL value
     */
    coreproductpb.PaymentTerms = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "PaymentTerms_UNKNOWN"] = 0;
        values[valuesById[1] = "PaymentTerms_MONTHLY"] = 1;
        values[valuesById[2] = "PaymentTerms_ANNUAL"] = 2;
        values[valuesById[3] = "PaymentTerms_QUARTERLY"] = 3;
        values[valuesById[4] = "PaymentTerms_SEMIANNUAL"] = 4;
        return values;
    })();

    /**
     * LimitationLevel enum.
     * @name coreproductpb.LimitationLevel
     * @enum {number}
     * @property {number} LimitationLevel_SKU=0 LimitationLevel_SKU value
     * @property {number} LimitationLevel_PRODUCT=1 LimitationLevel_PRODUCT value
     * @property {number} LimitationLevel_ITEM=2 LimitationLevel_ITEM value
     * @property {number} LimitationLevel_COMPONENT=3 LimitationLevel_COMPONENT value
     */
    coreproductpb.LimitationLevel = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "LimitationLevel_SKU"] = 0;
        values[valuesById[1] = "LimitationLevel_PRODUCT"] = 1;
        values[valuesById[2] = "LimitationLevel_ITEM"] = 2;
        values[valuesById[3] = "LimitationLevel_COMPONENT"] = 3;
        return values;
    })();

    /**
     * LimitationType enum.
     * @name coreproductpb.LimitationType
     * @enum {number}
     * @property {number} LimitationType_UNKNOWN=0 LimitationType_UNKNOWN value
     * @property {number} LimitationType_PER_OCCURRENCE=1 LimitationType_PER_OCCURRENCE value
     * @property {number} LimitationType_PER_CONTRACT_TERM=2 LimitationType_PER_CONTRACT_TERM value
     * @property {number} LimitationType_PAYOUT_MAX=3 LimitationType_PAYOUT_MAX value
     */
    coreproductpb.LimitationType = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "LimitationType_UNKNOWN"] = 0;
        values[valuesById[1] = "LimitationType_PER_OCCURRENCE"] = 1;
        values[valuesById[2] = "LimitationType_PER_CONTRACT_TERM"] = 2;
        values[valuesById[3] = "LimitationType_PAYOUT_MAX"] = 3;
        return values;
    })();

    /**
     * DistributorType enum.
     * @name coreproductpb.DistributorType
     * @enum {number}
     * @property {number} DistributorType_UNKNOWN=0 DistributorType_UNKNOWN value
     * @property {number} DistributorType_RE=1 DistributorType_RE value
     * @property {number} DistributorType_FSBO=2 DistributorType_FSBO value
     * @property {number} DistributorType_DS=3 DistributorType_DS value
     * @property {number} DistributorType_MG=4 DistributorType_MG value
     * @property {number} DistributorType_LOCAL=5 DistributorType_LOCAL value
     * @property {number} DistributorType_REG=6 DistributorType_REG value
     * @property {number} DistributorType_PM=7 DistributorType_PM value
     * @property {number} DistributorType_NH=8 DistributorType_NH value
     * @property {number} DistributorType_CC=9 DistributorType_CC value
     * @property {number} DistributorType_OTH=10 DistributorType_OTH value
     */
    coreproductpb.DistributorType = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "DistributorType_UNKNOWN"] = 0;
        values[valuesById[1] = "DistributorType_RE"] = 1;
        values[valuesById[2] = "DistributorType_FSBO"] = 2;
        values[valuesById[3] = "DistributorType_DS"] = 3;
        values[valuesById[4] = "DistributorType_MG"] = 4;
        values[valuesById[5] = "DistributorType_LOCAL"] = 5;
        values[valuesById[6] = "DistributorType_REG"] = 6;
        values[valuesById[7] = "DistributorType_PM"] = 7;
        values[valuesById[8] = "DistributorType_NH"] = 8;
        values[valuesById[9] = "DistributorType_CC"] = 9;
        values[valuesById[10] = "DistributorType_OTH"] = 10;
        return values;
    })();

    /**
     * SalesGroupType enum.
     * @name coreproductpb.SalesGroupType
     * @enum {number}
     * @property {number} SalesGroup_UNKNOWN=0 SalesGroup_UNKNOWN value
     * @property {number} SalesGroup_RN=1 SalesGroup_RN value
     * @property {number} SalesGroup_RO=2 SalesGroup_RO value
     * @property {number} SalesGroup_RELO=3 SalesGroup_RELO value
     * @property {number} SalesGroup_DC=4 SalesGroup_DC value
     * @property {number} SalesGroup_NAR=5 SalesGroup_NAR value
     * @property {number} SalesGroup_NHB=6 SalesGroup_NHB value
     * @property {number} SalesGroup_NHE=7 SalesGroup_NHE value
     * @property {number} SalesGroup_EMPTY=10 SalesGroup_EMPTY value
     */
    coreproductpb.SalesGroupType = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "SalesGroup_UNKNOWN"] = 0;
        values[valuesById[1] = "SalesGroup_RN"] = 1;
        values[valuesById[2] = "SalesGroup_RO"] = 2;
        values[valuesById[3] = "SalesGroup_RELO"] = 3;
        values[valuesById[4] = "SalesGroup_DC"] = 4;
        values[valuesById[5] = "SalesGroup_NAR"] = 5;
        values[valuesById[6] = "SalesGroup_NHB"] = 6;
        values[valuesById[7] = "SalesGroup_NHE"] = 7;
        values[valuesById[10] = "SalesGroup_EMPTY"] = 10;
        return values;
    })();

    /**
     * V2Status enum.
     * @name coreproductpb.V2Status
     * @enum {number}
     * @property {number} V2STATUS_UNDEFINED=0 V2STATUS_UNDEFINED value
     * @property {number} V2STATUS_ACTIVE=1 V2STATUS_ACTIVE value
     * @property {number} V2STATUS_INACTIVE=2 V2STATUS_INACTIVE value
     */
    coreproductpb.V2Status = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "V2STATUS_UNDEFINED"] = 0;
        values[valuesById[1] = "V2STATUS_ACTIVE"] = 1;
        values[valuesById[2] = "V2STATUS_INACTIVE"] = 2;
        return values;
    })();

    coreproductpb.MetaData = (function() {

        /**
         * Properties of a MetaData.
         * @memberof coreproductpb
         * @interface IMetaData
         * @property {number|Long|null} [createdOn] MetaData createdOn
         * @property {number|Long|null} [updatedOn] MetaData updatedOn
         * @property {number|Long|null} [deletedOn] MetaData deletedOn
         */

        /**
         * Constructs a new MetaData.
         * @memberof coreproductpb
         * @classdesc Represents a MetaData.
         * @implements IMetaData
         * @constructor
         * @param {coreproductpb.IMetaData=} [p] Properties to set
         */
        function MetaData(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * MetaData createdOn.
         * @member {number|Long} createdOn
         * @memberof coreproductpb.MetaData
         * @instance
         */
        MetaData.prototype.createdOn = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * MetaData updatedOn.
         * @member {number|Long} updatedOn
         * @memberof coreproductpb.MetaData
         * @instance
         */
        MetaData.prototype.updatedOn = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * MetaData deletedOn.
         * @member {number|Long} deletedOn
         * @memberof coreproductpb.MetaData
         * @instance
         */
        MetaData.prototype.deletedOn = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Creates a new MetaData instance using the specified properties.
         * @function create
         * @memberof coreproductpb.MetaData
         * @static
         * @param {coreproductpb.IMetaData=} [properties] Properties to set
         * @returns {coreproductpb.MetaData} MetaData instance
         */
        MetaData.create = function create(properties) {
            return new MetaData(properties);
        };

        /**
         * Encodes the specified MetaData message. Does not implicitly {@link coreproductpb.MetaData.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.MetaData
         * @static
         * @param {coreproductpb.IMetaData} m MetaData message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MetaData.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.createdOn != null && Object.hasOwnProperty.call(m, "createdOn"))
                w.uint32(8).int64(m.createdOn);
            if (m.updatedOn != null && Object.hasOwnProperty.call(m, "updatedOn"))
                w.uint32(16).int64(m.updatedOn);
            if (m.deletedOn != null && Object.hasOwnProperty.call(m, "deletedOn"))
                w.uint32(24).int64(m.deletedOn);
            return w;
        };

        /**
         * Decodes a MetaData message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.MetaData
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.MetaData} MetaData
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MetaData.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.MetaData();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.createdOn = r.int64();
                    break;
                case 2:
                    m.updatedOn = r.int64();
                    break;
                case 3:
                    m.deletedOn = r.int64();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return MetaData;
    })();

    coreproductpb.Term = (function() {

        /**
         * Properties of a Term.
         * @memberof coreproductpb
         * @interface ITerm
         * @property {number|null} [length] Term length
         * @property {string|null} [timeUnit] Term timeUnit
         */

        /**
         * Constructs a new Term.
         * @memberof coreproductpb
         * @classdesc Represents a Term.
         * @implements ITerm
         * @constructor
         * @param {coreproductpb.ITerm=} [p] Properties to set
         */
        function Term(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * Term length.
         * @member {number} length
         * @memberof coreproductpb.Term
         * @instance
         */
        Term.prototype.length = 0;

        /**
         * Term timeUnit.
         * @member {string} timeUnit
         * @memberof coreproductpb.Term
         * @instance
         */
        Term.prototype.timeUnit = "";

        /**
         * Creates a new Term instance using the specified properties.
         * @function create
         * @memberof coreproductpb.Term
         * @static
         * @param {coreproductpb.ITerm=} [properties] Properties to set
         * @returns {coreproductpb.Term} Term instance
         */
        Term.create = function create(properties) {
            return new Term(properties);
        };

        /**
         * Encodes the specified Term message. Does not implicitly {@link coreproductpb.Term.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.Term
         * @static
         * @param {coreproductpb.ITerm} m Term message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Term.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.length != null && Object.hasOwnProperty.call(m, "length"))
                w.uint32(8).uint32(m.length);
            if (m.timeUnit != null && Object.hasOwnProperty.call(m, "timeUnit"))
                w.uint32(18).string(m.timeUnit);
            return w;
        };

        /**
         * Decodes a Term message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.Term
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.Term} Term
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Term.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.Term();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.length = r.uint32();
                    break;
                case 2:
                    m.timeUnit = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return Term;
    })();

    coreproductpb.DisplayOptions = (function() {

        /**
         * Properties of a DisplayOptions.
         * @memberof coreproductpb
         * @interface IDisplayOptions
         * @property {boolean|null} [packaged] DisplayOptions packaged
         * @property {number|null} [pickCount] DisplayOptions pickCount
         */

        /**
         * Constructs a new DisplayOptions.
         * @memberof coreproductpb
         * @classdesc Represents a DisplayOptions.
         * @implements IDisplayOptions
         * @constructor
         * @param {coreproductpb.IDisplayOptions=} [p] Properties to set
         */
        function DisplayOptions(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * DisplayOptions packaged.
         * @member {boolean} packaged
         * @memberof coreproductpb.DisplayOptions
         * @instance
         */
        DisplayOptions.prototype.packaged = false;

        /**
         * DisplayOptions pickCount.
         * @member {number} pickCount
         * @memberof coreproductpb.DisplayOptions
         * @instance
         */
        DisplayOptions.prototype.pickCount = 0;

        /**
         * Creates a new DisplayOptions instance using the specified properties.
         * @function create
         * @memberof coreproductpb.DisplayOptions
         * @static
         * @param {coreproductpb.IDisplayOptions=} [properties] Properties to set
         * @returns {coreproductpb.DisplayOptions} DisplayOptions instance
         */
        DisplayOptions.create = function create(properties) {
            return new DisplayOptions(properties);
        };

        /**
         * Encodes the specified DisplayOptions message. Does not implicitly {@link coreproductpb.DisplayOptions.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.DisplayOptions
         * @static
         * @param {coreproductpb.IDisplayOptions} m DisplayOptions message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        DisplayOptions.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.packaged != null && Object.hasOwnProperty.call(m, "packaged"))
                w.uint32(8).bool(m.packaged);
            if (m.pickCount != null && Object.hasOwnProperty.call(m, "pickCount"))
                w.uint32(16).uint32(m.pickCount);
            return w;
        };

        /**
         * Decodes a DisplayOptions message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.DisplayOptions
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.DisplayOptions} DisplayOptions
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        DisplayOptions.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.DisplayOptions();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.packaged = r.bool();
                    break;
                case 2:
                    m.pickCount = r.uint32();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return DisplayOptions;
    })();

    coreproductpb.SquareFootageRange = (function() {

        /**
         * Properties of a SquareFootageRange.
         * @memberof coreproductpb
         * @interface ISquareFootageRange
         * @property {number|null} [min] SquareFootageRange min
         * @property {number|null} [max] SquareFootageRange max
         */

        /**
         * Constructs a new SquareFootageRange.
         * @memberof coreproductpb
         * @classdesc Represents a SquareFootageRange.
         * @implements ISquareFootageRange
         * @constructor
         * @param {coreproductpb.ISquareFootageRange=} [p] Properties to set
         */
        function SquareFootageRange(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * SquareFootageRange min.
         * @member {number} min
         * @memberof coreproductpb.SquareFootageRange
         * @instance
         */
        SquareFootageRange.prototype.min = 0;

        /**
         * SquareFootageRange max.
         * @member {number} max
         * @memberof coreproductpb.SquareFootageRange
         * @instance
         */
        SquareFootageRange.prototype.max = 0;

        /**
         * Creates a new SquareFootageRange instance using the specified properties.
         * @function create
         * @memberof coreproductpb.SquareFootageRange
         * @static
         * @param {coreproductpb.ISquareFootageRange=} [properties] Properties to set
         * @returns {coreproductpb.SquareFootageRange} SquareFootageRange instance
         */
        SquareFootageRange.create = function create(properties) {
            return new SquareFootageRange(properties);
        };

        /**
         * Encodes the specified SquareFootageRange message. Does not implicitly {@link coreproductpb.SquareFootageRange.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.SquareFootageRange
         * @static
         * @param {coreproductpb.ISquareFootageRange} m SquareFootageRange message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SquareFootageRange.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.min != null && Object.hasOwnProperty.call(m, "min"))
                w.uint32(8).uint32(m.min);
            if (m.max != null && Object.hasOwnProperty.call(m, "max"))
                w.uint32(16).uint32(m.max);
            return w;
        };

        /**
         * Decodes a SquareFootageRange message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.SquareFootageRange
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.SquareFootageRange} SquareFootageRange
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SquareFootageRange.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.SquareFootageRange();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.min = r.uint32();
                    break;
                case 2:
                    m.max = r.uint32();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return SquareFootageRange;
    })();

    coreproductpb.ContractTerms = (function() {

        /**
         * Properties of a ContractTerms.
         * @memberof coreproductpb
         * @interface IContractTerms
         * @property {number|null} [months] ContractTerms months
         * @property {number|null} [recallDays] ContractTerms recallDays
         * @property {number|null} [marketingSolicitationDays] ContractTerms marketingSolicitationDays
         * @property {number|null} [waitingPeriodInDays] ContractTerms waitingPeriodInDays
         * @property {number|null} [changePeriodDays] ContractTerms changePeriodDays
         * @property {number|Long|null} [monthlyCreditCardFee] ContractTerms monthlyCreditCardFee
         * @property {Array.<coreproductpb.PaymentTerms>|null} [eligiblePaymentTerms] ContractTerms eligiblePaymentTerms
         * @property {boolean|null} [financingEligible] ContractTerms financingEligible
         */

        /**
         * Constructs a new ContractTerms.
         * @memberof coreproductpb
         * @classdesc Represents a ContractTerms.
         * @implements IContractTerms
         * @constructor
         * @param {coreproductpb.IContractTerms=} [p] Properties to set
         */
        function ContractTerms(p) {
            this.eligiblePaymentTerms = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * ContractTerms months.
         * @member {number} months
         * @memberof coreproductpb.ContractTerms
         * @instance
         */
        ContractTerms.prototype.months = 0;

        /**
         * ContractTerms recallDays.
         * @member {number} recallDays
         * @memberof coreproductpb.ContractTerms
         * @instance
         */
        ContractTerms.prototype.recallDays = 0;

        /**
         * ContractTerms marketingSolicitationDays.
         * @member {number} marketingSolicitationDays
         * @memberof coreproductpb.ContractTerms
         * @instance
         */
        ContractTerms.prototype.marketingSolicitationDays = 0;

        /**
         * ContractTerms waitingPeriodInDays.
         * @member {number} waitingPeriodInDays
         * @memberof coreproductpb.ContractTerms
         * @instance
         */
        ContractTerms.prototype.waitingPeriodInDays = 0;

        /**
         * ContractTerms changePeriodDays.
         * @member {number} changePeriodDays
         * @memberof coreproductpb.ContractTerms
         * @instance
         */
        ContractTerms.prototype.changePeriodDays = 0;

        /**
         * ContractTerms monthlyCreditCardFee.
         * @member {number|Long} monthlyCreditCardFee
         * @memberof coreproductpb.ContractTerms
         * @instance
         */
        ContractTerms.prototype.monthlyCreditCardFee = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * ContractTerms eligiblePaymentTerms.
         * @member {Array.<coreproductpb.PaymentTerms>} eligiblePaymentTerms
         * @memberof coreproductpb.ContractTerms
         * @instance
         */
        ContractTerms.prototype.eligiblePaymentTerms = $util.emptyArray;

        /**
         * ContractTerms financingEligible.
         * @member {boolean} financingEligible
         * @memberof coreproductpb.ContractTerms
         * @instance
         */
        ContractTerms.prototype.financingEligible = false;

        /**
         * Creates a new ContractTerms instance using the specified properties.
         * @function create
         * @memberof coreproductpb.ContractTerms
         * @static
         * @param {coreproductpb.IContractTerms=} [properties] Properties to set
         * @returns {coreproductpb.ContractTerms} ContractTerms instance
         */
        ContractTerms.create = function create(properties) {
            return new ContractTerms(properties);
        };

        /**
         * Encodes the specified ContractTerms message. Does not implicitly {@link coreproductpb.ContractTerms.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.ContractTerms
         * @static
         * @param {coreproductpb.IContractTerms} m ContractTerms message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ContractTerms.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.months != null && Object.hasOwnProperty.call(m, "months"))
                w.uint32(8).uint32(m.months);
            if (m.recallDays != null && Object.hasOwnProperty.call(m, "recallDays"))
                w.uint32(16).uint32(m.recallDays);
            if (m.marketingSolicitationDays != null && Object.hasOwnProperty.call(m, "marketingSolicitationDays"))
                w.uint32(24).uint32(m.marketingSolicitationDays);
            if (m.waitingPeriodInDays != null && Object.hasOwnProperty.call(m, "waitingPeriodInDays"))
                w.uint32(32).uint32(m.waitingPeriodInDays);
            if (m.changePeriodDays != null && Object.hasOwnProperty.call(m, "changePeriodDays"))
                w.uint32(40).uint32(m.changePeriodDays);
            if (m.monthlyCreditCardFee != null && Object.hasOwnProperty.call(m, "monthlyCreditCardFee"))
                w.uint32(48).uint64(m.monthlyCreditCardFee);
            if (m.eligiblePaymentTerms != null && m.eligiblePaymentTerms.length) {
                w.uint32(58).fork();
                for (var i = 0; i < m.eligiblePaymentTerms.length; ++i)
                    w.int32(m.eligiblePaymentTerms[i]);
                w.ldelim();
            }
            if (m.financingEligible != null && Object.hasOwnProperty.call(m, "financingEligible"))
                w.uint32(64).bool(m.financingEligible);
            return w;
        };

        /**
         * Decodes a ContractTerms message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.ContractTerms
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.ContractTerms} ContractTerms
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ContractTerms.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.ContractTerms();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.months = r.uint32();
                    break;
                case 2:
                    m.recallDays = r.uint32();
                    break;
                case 3:
                    m.marketingSolicitationDays = r.uint32();
                    break;
                case 4:
                    m.waitingPeriodInDays = r.uint32();
                    break;
                case 5:
                    m.changePeriodDays = r.uint32();
                    break;
                case 6:
                    m.monthlyCreditCardFee = r.uint64();
                    break;
                case 7:
                    if (!(m.eligiblePaymentTerms && m.eligiblePaymentTerms.length))
                        m.eligiblePaymentTerms = [];
                    if ((t & 7) === 2) {
                        var c2 = r.uint32() + r.pos;
                        while (r.pos < c2)
                            m.eligiblePaymentTerms.push(r.int32());
                    } else
                        m.eligiblePaymentTerms.push(r.int32());
                    break;
                case 8:
                    m.financingEligible = r.bool();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return ContractTerms;
    })();

    coreproductpb.ProductGroup = (function() {

        /**
         * Properties of a ProductGroup.
         * @memberof coreproductpb
         * @interface IProductGroup
         * @property {string|null} [description] ProductGroup description
         * @property {number|Long|null} [starGroupID] ProductGroup starGroupID
         * @property {number|null} [maximum] ProductGroup maximum
         * @property {Array.<string>|null} [skuIDs] ProductGroup skuIDs
         */

        /**
         * Constructs a new ProductGroup.
         * @memberof coreproductpb
         * @classdesc Represents a ProductGroup.
         * @implements IProductGroup
         * @constructor
         * @param {coreproductpb.IProductGroup=} [p] Properties to set
         */
        function ProductGroup(p) {
            this.skuIDs = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * ProductGroup description.
         * @member {string} description
         * @memberof coreproductpb.ProductGroup
         * @instance
         */
        ProductGroup.prototype.description = "";

        /**
         * ProductGroup starGroupID.
         * @member {number|Long} starGroupID
         * @memberof coreproductpb.ProductGroup
         * @instance
         */
        ProductGroup.prototype.starGroupID = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * ProductGroup maximum.
         * @member {number} maximum
         * @memberof coreproductpb.ProductGroup
         * @instance
         */
        ProductGroup.prototype.maximum = 0;

        /**
         * ProductGroup skuIDs.
         * @member {Array.<string>} skuIDs
         * @memberof coreproductpb.ProductGroup
         * @instance
         */
        ProductGroup.prototype.skuIDs = $util.emptyArray;

        /**
         * Creates a new ProductGroup instance using the specified properties.
         * @function create
         * @memberof coreproductpb.ProductGroup
         * @static
         * @param {coreproductpb.IProductGroup=} [properties] Properties to set
         * @returns {coreproductpb.ProductGroup} ProductGroup instance
         */
        ProductGroup.create = function create(properties) {
            return new ProductGroup(properties);
        };

        /**
         * Encodes the specified ProductGroup message. Does not implicitly {@link coreproductpb.ProductGroup.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.ProductGroup
         * @static
         * @param {coreproductpb.IProductGroup} m ProductGroup message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ProductGroup.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.description != null && Object.hasOwnProperty.call(m, "description"))
                w.uint32(10).string(m.description);
            if (m.starGroupID != null && Object.hasOwnProperty.call(m, "starGroupID"))
                w.uint32(16).uint64(m.starGroupID);
            if (m.maximum != null && Object.hasOwnProperty.call(m, "maximum"))
                w.uint32(24).uint32(m.maximum);
            if (m.skuIDs != null && m.skuIDs.length) {
                for (var i = 0; i < m.skuIDs.length; ++i)
                    w.uint32(34).string(m.skuIDs[i]);
            }
            return w;
        };

        /**
         * Decodes a ProductGroup message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.ProductGroup
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.ProductGroup} ProductGroup
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ProductGroup.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.ProductGroup();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.description = r.string();
                    break;
                case 2:
                    m.starGroupID = r.uint64();
                    break;
                case 3:
                    m.maximum = r.uint32();
                    break;
                case 4:
                    if (!(m.skuIDs && m.skuIDs.length))
                        m.skuIDs = [];
                    m.skuIDs.push(r.string());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return ProductGroup;
    })();

    coreproductpb.ProductDetails = (function() {

        /**
         * Properties of a ProductDetails.
         * @memberof coreproductpb
         * @interface IProductDetails
         * @property {Array.<coreproductpb.IProductGroup>|null} [productGroup] ProductDetails productGroup
         * @property {coreproductpb.ITerm|null} [listingTerm] ProductDetails listingTerm
         */

        /**
         * Constructs a new ProductDetails.
         * @memberof coreproductpb
         * @classdesc Represents a ProductDetails.
         * @implements IProductDetails
         * @constructor
         * @param {coreproductpb.IProductDetails=} [p] Properties to set
         */
        function ProductDetails(p) {
            this.productGroup = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * ProductDetails productGroup.
         * @member {Array.<coreproductpb.IProductGroup>} productGroup
         * @memberof coreproductpb.ProductDetails
         * @instance
         */
        ProductDetails.prototype.productGroup = $util.emptyArray;

        /**
         * ProductDetails listingTerm.
         * @member {coreproductpb.ITerm|null|undefined} listingTerm
         * @memberof coreproductpb.ProductDetails
         * @instance
         */
        ProductDetails.prototype.listingTerm = null;

        /**
         * Creates a new ProductDetails instance using the specified properties.
         * @function create
         * @memberof coreproductpb.ProductDetails
         * @static
         * @param {coreproductpb.IProductDetails=} [properties] Properties to set
         * @returns {coreproductpb.ProductDetails} ProductDetails instance
         */
        ProductDetails.create = function create(properties) {
            return new ProductDetails(properties);
        };

        /**
         * Encodes the specified ProductDetails message. Does not implicitly {@link coreproductpb.ProductDetails.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.ProductDetails
         * @static
         * @param {coreproductpb.IProductDetails} m ProductDetails message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ProductDetails.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.productGroup != null && m.productGroup.length) {
                for (var i = 0; i < m.productGroup.length; ++i)
                    $root.coreproductpb.ProductGroup.encode(m.productGroup[i], w.uint32(10).fork()).ldelim();
            }
            if (m.listingTerm != null && Object.hasOwnProperty.call(m, "listingTerm"))
                $root.coreproductpb.Term.encode(m.listingTerm, w.uint32(18).fork()).ldelim();
            return w;
        };

        /**
         * Decodes a ProductDetails message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.ProductDetails
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.ProductDetails} ProductDetails
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ProductDetails.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.ProductDetails();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    if (!(m.productGroup && m.productGroup.length))
                        m.productGroup = [];
                    m.productGroup.push($root.coreproductpb.ProductGroup.decode(r, r.uint32()));
                    break;
                case 2:
                    m.listingTerm = $root.coreproductpb.Term.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return ProductDetails;
    })();

    coreproductpb.CompactProductDetails = (function() {

        /**
         * Properties of a CompactProductDetails.
         * @memberof coreproductpb
         * @interface ICompactProductDetails
         * @property {Array.<coreproductpb.IProductGroup>|null} [productGroup] CompactProductDetails productGroup
         * @property {coreproductpb.ITerm|null} [listingTerm] CompactProductDetails listingTerm
         */

        /**
         * Constructs a new CompactProductDetails.
         * @memberof coreproductpb
         * @classdesc Represents a CompactProductDetails.
         * @implements ICompactProductDetails
         * @constructor
         * @param {coreproductpb.ICompactProductDetails=} [p] Properties to set
         */
        function CompactProductDetails(p) {
            this.productGroup = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * CompactProductDetails productGroup.
         * @member {Array.<coreproductpb.IProductGroup>} productGroup
         * @memberof coreproductpb.CompactProductDetails
         * @instance
         */
        CompactProductDetails.prototype.productGroup = $util.emptyArray;

        /**
         * CompactProductDetails listingTerm.
         * @member {coreproductpb.ITerm|null|undefined} listingTerm
         * @memberof coreproductpb.CompactProductDetails
         * @instance
         */
        CompactProductDetails.prototype.listingTerm = null;

        /**
         * Creates a new CompactProductDetails instance using the specified properties.
         * @function create
         * @memberof coreproductpb.CompactProductDetails
         * @static
         * @param {coreproductpb.ICompactProductDetails=} [properties] Properties to set
         * @returns {coreproductpb.CompactProductDetails} CompactProductDetails instance
         */
        CompactProductDetails.create = function create(properties) {
            return new CompactProductDetails(properties);
        };

        /**
         * Encodes the specified CompactProductDetails message. Does not implicitly {@link coreproductpb.CompactProductDetails.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.CompactProductDetails
         * @static
         * @param {coreproductpb.ICompactProductDetails} m CompactProductDetails message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CompactProductDetails.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.productGroup != null && m.productGroup.length) {
                for (var i = 0; i < m.productGroup.length; ++i)
                    $root.coreproductpb.ProductGroup.encode(m.productGroup[i], w.uint32(10).fork()).ldelim();
            }
            if (m.listingTerm != null && Object.hasOwnProperty.call(m, "listingTerm"))
                $root.coreproductpb.Term.encode(m.listingTerm, w.uint32(18).fork()).ldelim();
            return w;
        };

        /**
         * Decodes a CompactProductDetails message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.CompactProductDetails
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.CompactProductDetails} CompactProductDetails
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CompactProductDetails.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.CompactProductDetails();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    if (!(m.productGroup && m.productGroup.length))
                        m.productGroup = [];
                    m.productGroup.push($root.coreproductpb.ProductGroup.decode(r, r.uint32()));
                    break;
                case 2:
                    m.listingTerm = $root.coreproductpb.Term.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return CompactProductDetails;
    })();

    coreproductpb.CompactProductResponse = (function() {

        /**
         * Properties of a CompactProductResponse.
         * @memberof coreproductpb
         * @interface ICompactProductResponse
         * @property {string|null} [productFamilyID] CompactProductResponse productFamilyID
         * @property {string|null} [productFamilyName] CompactProductResponse productFamilyName
         * @property {string|null} [productID] CompactProductResponse productID
         * @property {string|null} [productName] CompactProductResponse productName
         * @property {string|null} [internalDescription] CompactProductResponse internalDescription
         * @property {string|null} [externalDescription] CompactProductResponse externalDescription
         * @property {Array.<number|Long>|null} [serviceFees] CompactProductResponse serviceFees
         * @property {coreproductpb.IDisplayOptions|null} [options] CompactProductResponse options
         * @property {Array.<coreproductpb.CompactProductResponse.ICompactSku>|null} [standardSKUs] CompactProductResponse standardSKUs
         * @property {Array.<coreproductpb.CompactProductResponse.ICompactSku>|null} [optionalSKUs] CompactProductResponse optionalSKUs
         * @property {string|null} [starPVID] CompactProductResponse starPVID
         * @property {string|null} [starProductPlanID] CompactProductResponse starProductPlanID
         * @property {string|null} [starOldPV] CompactProductResponse starOldPV
         * @property {common.IRange_U32|null} [guestSuites] CompactProductResponse guestSuites
         * @property {number|null} [contractTermMonths] CompactProductResponse contractTermMonths
         * @property {coreproductpb.IProductDetails|null} [productDetails] CompactProductResponse productDetails
         * @property {number|Long|null} [effectiveOn] CompactProductResponse effectiveOn
         * @property {number|Long|null} [expirationOn] CompactProductResponse expirationOn
         * @property {Array.<string>|null} [salesGroup] CompactProductResponse salesGroup
         * @property {coreproductpb.ICompactProductAttributes|null} [attributes] CompactProductResponse attributes
         */

        /**
         * Constructs a new CompactProductResponse.
         * @memberof coreproductpb
         * @classdesc Represents a CompactProductResponse.
         * @implements ICompactProductResponse
         * @constructor
         * @param {coreproductpb.ICompactProductResponse=} [p] Properties to set
         */
        function CompactProductResponse(p) {
            this.serviceFees = [];
            this.standardSKUs = [];
            this.optionalSKUs = [];
            this.salesGroup = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * CompactProductResponse productFamilyID.
         * @member {string} productFamilyID
         * @memberof coreproductpb.CompactProductResponse
         * @instance
         */
        CompactProductResponse.prototype.productFamilyID = "";

        /**
         * CompactProductResponse productFamilyName.
         * @member {string} productFamilyName
         * @memberof coreproductpb.CompactProductResponse
         * @instance
         */
        CompactProductResponse.prototype.productFamilyName = "";

        /**
         * CompactProductResponse productID.
         * @member {string} productID
         * @memberof coreproductpb.CompactProductResponse
         * @instance
         */
        CompactProductResponse.prototype.productID = "";

        /**
         * CompactProductResponse productName.
         * @member {string} productName
         * @memberof coreproductpb.CompactProductResponse
         * @instance
         */
        CompactProductResponse.prototype.productName = "";

        /**
         * CompactProductResponse internalDescription.
         * @member {string} internalDescription
         * @memberof coreproductpb.CompactProductResponse
         * @instance
         */
        CompactProductResponse.prototype.internalDescription = "";

        /**
         * CompactProductResponse externalDescription.
         * @member {string} externalDescription
         * @memberof coreproductpb.CompactProductResponse
         * @instance
         */
        CompactProductResponse.prototype.externalDescription = "";

        /**
         * CompactProductResponse serviceFees.
         * @member {Array.<number|Long>} serviceFees
         * @memberof coreproductpb.CompactProductResponse
         * @instance
         */
        CompactProductResponse.prototype.serviceFees = $util.emptyArray;

        /**
         * CompactProductResponse options.
         * @member {coreproductpb.IDisplayOptions|null|undefined} options
         * @memberof coreproductpb.CompactProductResponse
         * @instance
         */
        CompactProductResponse.prototype.options = null;

        /**
         * CompactProductResponse standardSKUs.
         * @member {Array.<coreproductpb.CompactProductResponse.ICompactSku>} standardSKUs
         * @memberof coreproductpb.CompactProductResponse
         * @instance
         */
        CompactProductResponse.prototype.standardSKUs = $util.emptyArray;

        /**
         * CompactProductResponse optionalSKUs.
         * @member {Array.<coreproductpb.CompactProductResponse.ICompactSku>} optionalSKUs
         * @memberof coreproductpb.CompactProductResponse
         * @instance
         */
        CompactProductResponse.prototype.optionalSKUs = $util.emptyArray;

        /**
         * CompactProductResponse starPVID.
         * @member {string} starPVID
         * @memberof coreproductpb.CompactProductResponse
         * @instance
         */
        CompactProductResponse.prototype.starPVID = "";

        /**
         * CompactProductResponse starProductPlanID.
         * @member {string} starProductPlanID
         * @memberof coreproductpb.CompactProductResponse
         * @instance
         */
        CompactProductResponse.prototype.starProductPlanID = "";

        /**
         * CompactProductResponse starOldPV.
         * @member {string} starOldPV
         * @memberof coreproductpb.CompactProductResponse
         * @instance
         */
        CompactProductResponse.prototype.starOldPV = "";

        /**
         * CompactProductResponse guestSuites.
         * @member {common.IRange_U32|null|undefined} guestSuites
         * @memberof coreproductpb.CompactProductResponse
         * @instance
         */
        CompactProductResponse.prototype.guestSuites = null;

        /**
         * CompactProductResponse contractTermMonths.
         * @member {number} contractTermMonths
         * @memberof coreproductpb.CompactProductResponse
         * @instance
         */
        CompactProductResponse.prototype.contractTermMonths = 0;

        /**
         * CompactProductResponse productDetails.
         * @member {coreproductpb.IProductDetails|null|undefined} productDetails
         * @memberof coreproductpb.CompactProductResponse
         * @instance
         */
        CompactProductResponse.prototype.productDetails = null;

        /**
         * CompactProductResponse effectiveOn.
         * @member {number|Long} effectiveOn
         * @memberof coreproductpb.CompactProductResponse
         * @instance
         */
        CompactProductResponse.prototype.effectiveOn = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * CompactProductResponse expirationOn.
         * @member {number|Long} expirationOn
         * @memberof coreproductpb.CompactProductResponse
         * @instance
         */
        CompactProductResponse.prototype.expirationOn = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * CompactProductResponse salesGroup.
         * @member {Array.<string>} salesGroup
         * @memberof coreproductpb.CompactProductResponse
         * @instance
         */
        CompactProductResponse.prototype.salesGroup = $util.emptyArray;

        /**
         * CompactProductResponse attributes.
         * @member {coreproductpb.ICompactProductAttributes|null|undefined} attributes
         * @memberof coreproductpb.CompactProductResponse
         * @instance
         */
        CompactProductResponse.prototype.attributes = null;

        /**
         * Creates a new CompactProductResponse instance using the specified properties.
         * @function create
         * @memberof coreproductpb.CompactProductResponse
         * @static
         * @param {coreproductpb.ICompactProductResponse=} [properties] Properties to set
         * @returns {coreproductpb.CompactProductResponse} CompactProductResponse instance
         */
        CompactProductResponse.create = function create(properties) {
            return new CompactProductResponse(properties);
        };

        /**
         * Encodes the specified CompactProductResponse message. Does not implicitly {@link coreproductpb.CompactProductResponse.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.CompactProductResponse
         * @static
         * @param {coreproductpb.ICompactProductResponse} m CompactProductResponse message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CompactProductResponse.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.productFamilyID != null && Object.hasOwnProperty.call(m, "productFamilyID"))
                w.uint32(10).string(m.productFamilyID);
            if (m.productFamilyName != null && Object.hasOwnProperty.call(m, "productFamilyName"))
                w.uint32(18).string(m.productFamilyName);
            if (m.productID != null && Object.hasOwnProperty.call(m, "productID"))
                w.uint32(26).string(m.productID);
            if (m.productName != null && Object.hasOwnProperty.call(m, "productName"))
                w.uint32(34).string(m.productName);
            if (m.internalDescription != null && Object.hasOwnProperty.call(m, "internalDescription"))
                w.uint32(42).string(m.internalDescription);
            if (m.externalDescription != null && Object.hasOwnProperty.call(m, "externalDescription"))
                w.uint32(50).string(m.externalDescription);
            if (m.serviceFees != null && m.serviceFees.length) {
                w.uint32(58).fork();
                for (var i = 0; i < m.serviceFees.length; ++i)
                    w.uint64(m.serviceFees[i]);
                w.ldelim();
            }
            if (m.options != null && Object.hasOwnProperty.call(m, "options"))
                $root.coreproductpb.DisplayOptions.encode(m.options, w.uint32(66).fork()).ldelim();
            if (m.standardSKUs != null && m.standardSKUs.length) {
                for (var i = 0; i < m.standardSKUs.length; ++i)
                    $root.coreproductpb.CompactProductResponse.CompactSku.encode(m.standardSKUs[i], w.uint32(82).fork()).ldelim();
            }
            if (m.optionalSKUs != null && m.optionalSKUs.length) {
                for (var i = 0; i < m.optionalSKUs.length; ++i)
                    $root.coreproductpb.CompactProductResponse.CompactSku.encode(m.optionalSKUs[i], w.uint32(90).fork()).ldelim();
            }
            if (m.starPVID != null && Object.hasOwnProperty.call(m, "starPVID"))
                w.uint32(98).string(m.starPVID);
            if (m.starProductPlanID != null && Object.hasOwnProperty.call(m, "starProductPlanID"))
                w.uint32(106).string(m.starProductPlanID);
            if (m.starOldPV != null && Object.hasOwnProperty.call(m, "starOldPV"))
                w.uint32(114).string(m.starOldPV);
            if (m.guestSuites != null && Object.hasOwnProperty.call(m, "guestSuites"))
                $root.common.Range_U32.encode(m.guestSuites, w.uint32(122).fork()).ldelim();
            if (m.contractTermMonths != null && Object.hasOwnProperty.call(m, "contractTermMonths"))
                w.uint32(128).uint32(m.contractTermMonths);
            if (m.productDetails != null && Object.hasOwnProperty.call(m, "productDetails"))
                $root.coreproductpb.ProductDetails.encode(m.productDetails, w.uint32(138).fork()).ldelim();
            if (m.effectiveOn != null && Object.hasOwnProperty.call(m, "effectiveOn"))
                w.uint32(144).uint64(m.effectiveOn);
            if (m.expirationOn != null && Object.hasOwnProperty.call(m, "expirationOn"))
                w.uint32(152).uint64(m.expirationOn);
            if (m.salesGroup != null && m.salesGroup.length) {
                for (var i = 0; i < m.salesGroup.length; ++i)
                    w.uint32(162).string(m.salesGroup[i]);
            }
            if (m.attributes != null && Object.hasOwnProperty.call(m, "attributes"))
                $root.coreproductpb.CompactProductAttributes.encode(m.attributes, w.uint32(170).fork()).ldelim();
            return w;
        };

        /**
         * Decodes a CompactProductResponse message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.CompactProductResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.CompactProductResponse} CompactProductResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CompactProductResponse.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.CompactProductResponse();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.productFamilyID = r.string();
                    break;
                case 2:
                    m.productFamilyName = r.string();
                    break;
                case 3:
                    m.productID = r.string();
                    break;
                case 4:
                    m.productName = r.string();
                    break;
                case 5:
                    m.internalDescription = r.string();
                    break;
                case 6:
                    m.externalDescription = r.string();
                    break;
                case 7:
                    if (!(m.serviceFees && m.serviceFees.length))
                        m.serviceFees = [];
                    if ((t & 7) === 2) {
                        var c2 = r.uint32() + r.pos;
                        while (r.pos < c2)
                            m.serviceFees.push(r.uint64());
                    } else
                        m.serviceFees.push(r.uint64());
                    break;
                case 8:
                    m.options = $root.coreproductpb.DisplayOptions.decode(r, r.uint32());
                    break;
                case 10:
                    if (!(m.standardSKUs && m.standardSKUs.length))
                        m.standardSKUs = [];
                    m.standardSKUs.push($root.coreproductpb.CompactProductResponse.CompactSku.decode(r, r.uint32()));
                    break;
                case 11:
                    if (!(m.optionalSKUs && m.optionalSKUs.length))
                        m.optionalSKUs = [];
                    m.optionalSKUs.push($root.coreproductpb.CompactProductResponse.CompactSku.decode(r, r.uint32()));
                    break;
                case 12:
                    m.starPVID = r.string();
                    break;
                case 13:
                    m.starProductPlanID = r.string();
                    break;
                case 14:
                    m.starOldPV = r.string();
                    break;
                case 15:
                    m.guestSuites = $root.common.Range_U32.decode(r, r.uint32());
                    break;
                case 16:
                    m.contractTermMonths = r.uint32();
                    break;
                case 17:
                    m.productDetails = $root.coreproductpb.ProductDetails.decode(r, r.uint32());
                    break;
                case 18:
                    m.effectiveOn = r.uint64();
                    break;
                case 19:
                    m.expirationOn = r.uint64();
                    break;
                case 20:
                    if (!(m.salesGroup && m.salesGroup.length))
                        m.salesGroup = [];
                    m.salesGroup.push(r.string());
                    break;
                case 21:
                    m.attributes = $root.coreproductpb.CompactProductAttributes.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        CompactProductResponse.CompactSku = (function() {

            /**
             * Properties of a CompactSku.
             * @memberof coreproductpb.CompactProductResponse
             * @interface ICompactSku
             * @property {string|null} [skuID] CompactSku skuID
             * @property {string|null} [salesItemName] CompactSku salesItemName
             * @property {string|null} [category] CompactSku category
             * @property {string|null} [starCoverageId] CompactSku starCoverageId
             * @property {string|null} [customerType] CompactSku customerType
             * @property {coreproductpb.ICompactFeatureAttributes|null} [featureAttributes] CompactSku featureAttributes
             * @property {google.protobuf.ITimestamp|null} [expirationDate] CompactSku expirationDate
             */

            /**
             * Constructs a new CompactSku.
             * @memberof coreproductpb.CompactProductResponse
             * @classdesc Represents a CompactSku.
             * @implements ICompactSku
             * @constructor
             * @param {coreproductpb.CompactProductResponse.ICompactSku=} [p] Properties to set
             */
            function CompactSku(p) {
                if (p)
                    for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                        if (p[ks[i]] != null)
                            this[ks[i]] = p[ks[i]];
            }

            /**
             * CompactSku skuID.
             * @member {string} skuID
             * @memberof coreproductpb.CompactProductResponse.CompactSku
             * @instance
             */
            CompactSku.prototype.skuID = "";

            /**
             * CompactSku salesItemName.
             * @member {string} salesItemName
             * @memberof coreproductpb.CompactProductResponse.CompactSku
             * @instance
             */
            CompactSku.prototype.salesItemName = "";

            /**
             * CompactSku category.
             * @member {string} category
             * @memberof coreproductpb.CompactProductResponse.CompactSku
             * @instance
             */
            CompactSku.prototype.category = "";

            /**
             * CompactSku starCoverageId.
             * @member {string} starCoverageId
             * @memberof coreproductpb.CompactProductResponse.CompactSku
             * @instance
             */
            CompactSku.prototype.starCoverageId = "";

            /**
             * CompactSku customerType.
             * @member {string} customerType
             * @memberof coreproductpb.CompactProductResponse.CompactSku
             * @instance
             */
            CompactSku.prototype.customerType = "";

            /**
             * CompactSku featureAttributes.
             * @member {coreproductpb.ICompactFeatureAttributes|null|undefined} featureAttributes
             * @memberof coreproductpb.CompactProductResponse.CompactSku
             * @instance
             */
            CompactSku.prototype.featureAttributes = null;

            /**
             * CompactSku expirationDate.
             * @member {google.protobuf.ITimestamp|null|undefined} expirationDate
             * @memberof coreproductpb.CompactProductResponse.CompactSku
             * @instance
             */
            CompactSku.prototype.expirationDate = null;

            /**
             * Creates a new CompactSku instance using the specified properties.
             * @function create
             * @memberof coreproductpb.CompactProductResponse.CompactSku
             * @static
             * @param {coreproductpb.CompactProductResponse.ICompactSku=} [properties] Properties to set
             * @returns {coreproductpb.CompactProductResponse.CompactSku} CompactSku instance
             */
            CompactSku.create = function create(properties) {
                return new CompactSku(properties);
            };

            /**
             * Encodes the specified CompactSku message. Does not implicitly {@link coreproductpb.CompactProductResponse.CompactSku.verify|verify} messages.
             * @function encode
             * @memberof coreproductpb.CompactProductResponse.CompactSku
             * @static
             * @param {coreproductpb.CompactProductResponse.ICompactSku} m CompactSku message or plain object to encode
             * @param {$protobuf.Writer} [w] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            CompactSku.encode = function encode(m, w) {
                if (!w)
                    w = $Writer.create();
                if (m.skuID != null && Object.hasOwnProperty.call(m, "skuID"))
                    w.uint32(10).string(m.skuID);
                if (m.salesItemName != null && Object.hasOwnProperty.call(m, "salesItemName"))
                    w.uint32(18).string(m.salesItemName);
                if (m.category != null && Object.hasOwnProperty.call(m, "category"))
                    w.uint32(26).string(m.category);
                if (m.starCoverageId != null && Object.hasOwnProperty.call(m, "starCoverageId"))
                    w.uint32(34).string(m.starCoverageId);
                if (m.customerType != null && Object.hasOwnProperty.call(m, "customerType"))
                    w.uint32(42).string(m.customerType);
                if (m.featureAttributes != null && Object.hasOwnProperty.call(m, "featureAttributes"))
                    $root.coreproductpb.CompactFeatureAttributes.encode(m.featureAttributes, w.uint32(50).fork()).ldelim();
                if (m.expirationDate != null && Object.hasOwnProperty.call(m, "expirationDate"))
                    $root.google.protobuf.Timestamp.encode(m.expirationDate, w.uint32(58).fork()).ldelim();
                return w;
            };

            /**
             * Decodes a CompactSku message from the specified reader or buffer.
             * @function decode
             * @memberof coreproductpb.CompactProductResponse.CompactSku
             * @static
             * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
             * @param {number} [l] Message length if known beforehand
             * @returns {coreproductpb.CompactProductResponse.CompactSku} CompactSku
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            CompactSku.decode = function decode(r, l) {
                if (!(r instanceof $Reader))
                    r = $Reader.create(r);
                var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.CompactProductResponse.CompactSku();
                while (r.pos < c) {
                    var t = r.uint32();
                    switch (t >>> 3) {
                    case 1:
                        m.skuID = r.string();
                        break;
                    case 2:
                        m.salesItemName = r.string();
                        break;
                    case 3:
                        m.category = r.string();
                        break;
                    case 4:
                        m.starCoverageId = r.string();
                        break;
                    case 5:
                        m.customerType = r.string();
                        break;
                    case 6:
                        m.featureAttributes = $root.coreproductpb.CompactFeatureAttributes.decode(r, r.uint32());
                        break;
                    case 7:
                        m.expirationDate = $root.google.protobuf.Timestamp.decode(r, r.uint32());
                        break;
                    default:
                        r.skipType(t & 7);
                        break;
                    }
                }
                return m;
            };

            return CompactSku;
        })();

        return CompactProductResponse;
    })();

    coreproductpb.ProductOptions = (function() {

        /**
         * Properties of a ProductOptions.
         * @memberof coreproductpb
         * @interface IProductOptions
         * @property {string|null} [brandId] ProductOptions brandId
         * @property {boolean|null} [includeSellerCoverage] ProductOptions includeSellerCoverage
         * @property {number|null} [termOfContract] ProductOptions termOfContract
         * @property {coreproductpb.SalesChannelType|null} [salesChannel] ProductOptions salesChannel
         * @property {coreproductpb.PurchaseChannel|null} [purchaseChannel] ProductOptions purchaseChannel
         * @property {boolean|null} [acCoverage] ProductOptions acCoverage
         * @property {string|null} [tenant] ProductOptions tenant
         * @property {coreproductpb.SalesGroupType|null} [salesGroup] ProductOptions salesGroup
         * @property {Array.<string>|null} [includedTags] ProductOptions includedTags
         * @property {Array.<string>|null} [excludedTags] ProductOptions excludedTags
         */

        /**
         * Constructs a new ProductOptions.
         * @memberof coreproductpb
         * @classdesc Represents a ProductOptions.
         * @implements IProductOptions
         * @constructor
         * @param {coreproductpb.IProductOptions=} [p] Properties to set
         */
        function ProductOptions(p) {
            this.includedTags = [];
            this.excludedTags = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * ProductOptions brandId.
         * @member {string} brandId
         * @memberof coreproductpb.ProductOptions
         * @instance
         */
        ProductOptions.prototype.brandId = "";

        /**
         * ProductOptions includeSellerCoverage.
         * @member {boolean} includeSellerCoverage
         * @memberof coreproductpb.ProductOptions
         * @instance
         */
        ProductOptions.prototype.includeSellerCoverage = false;

        /**
         * ProductOptions termOfContract.
         * @member {number} termOfContract
         * @memberof coreproductpb.ProductOptions
         * @instance
         */
        ProductOptions.prototype.termOfContract = 0;

        /**
         * ProductOptions salesChannel.
         * @member {coreproductpb.SalesChannelType} salesChannel
         * @memberof coreproductpb.ProductOptions
         * @instance
         */
        ProductOptions.prototype.salesChannel = 0;

        /**
         * ProductOptions purchaseChannel.
         * @member {coreproductpb.PurchaseChannel} purchaseChannel
         * @memberof coreproductpb.ProductOptions
         * @instance
         */
        ProductOptions.prototype.purchaseChannel = 0;

        /**
         * ProductOptions acCoverage.
         * @member {boolean} acCoverage
         * @memberof coreproductpb.ProductOptions
         * @instance
         */
        ProductOptions.prototype.acCoverage = false;

        /**
         * ProductOptions tenant.
         * @member {string} tenant
         * @memberof coreproductpb.ProductOptions
         * @instance
         */
        ProductOptions.prototype.tenant = "";

        /**
         * ProductOptions salesGroup.
         * @member {coreproductpb.SalesGroupType} salesGroup
         * @memberof coreproductpb.ProductOptions
         * @instance
         */
        ProductOptions.prototype.salesGroup = 0;

        /**
         * ProductOptions includedTags.
         * @member {Array.<string>} includedTags
         * @memberof coreproductpb.ProductOptions
         * @instance
         */
        ProductOptions.prototype.includedTags = $util.emptyArray;

        /**
         * ProductOptions excludedTags.
         * @member {Array.<string>} excludedTags
         * @memberof coreproductpb.ProductOptions
         * @instance
         */
        ProductOptions.prototype.excludedTags = $util.emptyArray;

        /**
         * Creates a new ProductOptions instance using the specified properties.
         * @function create
         * @memberof coreproductpb.ProductOptions
         * @static
         * @param {coreproductpb.IProductOptions=} [properties] Properties to set
         * @returns {coreproductpb.ProductOptions} ProductOptions instance
         */
        ProductOptions.create = function create(properties) {
            return new ProductOptions(properties);
        };

        /**
         * Encodes the specified ProductOptions message. Does not implicitly {@link coreproductpb.ProductOptions.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.ProductOptions
         * @static
         * @param {coreproductpb.IProductOptions} m ProductOptions message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ProductOptions.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.brandId != null && Object.hasOwnProperty.call(m, "brandId"))
                w.uint32(10).string(m.brandId);
            if (m.includeSellerCoverage != null && Object.hasOwnProperty.call(m, "includeSellerCoverage"))
                w.uint32(16).bool(m.includeSellerCoverage);
            if (m.termOfContract != null && Object.hasOwnProperty.call(m, "termOfContract"))
                w.uint32(24).uint32(m.termOfContract);
            if (m.salesChannel != null && Object.hasOwnProperty.call(m, "salesChannel"))
                w.uint32(32).int32(m.salesChannel);
            if (m.purchaseChannel != null && Object.hasOwnProperty.call(m, "purchaseChannel"))
                w.uint32(40).int32(m.purchaseChannel);
            if (m.acCoverage != null && Object.hasOwnProperty.call(m, "acCoverage"))
                w.uint32(48).bool(m.acCoverage);
            if (m.tenant != null && Object.hasOwnProperty.call(m, "tenant"))
                w.uint32(58).string(m.tenant);
            if (m.salesGroup != null && Object.hasOwnProperty.call(m, "salesGroup"))
                w.uint32(64).int32(m.salesGroup);
            if (m.includedTags != null && m.includedTags.length) {
                for (var i = 0; i < m.includedTags.length; ++i)
                    w.uint32(74).string(m.includedTags[i]);
            }
            if (m.excludedTags != null && m.excludedTags.length) {
                for (var i = 0; i < m.excludedTags.length; ++i)
                    w.uint32(82).string(m.excludedTags[i]);
            }
            return w;
        };

        /**
         * Decodes a ProductOptions message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.ProductOptions
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.ProductOptions} ProductOptions
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ProductOptions.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.ProductOptions();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.brandId = r.string();
                    break;
                case 2:
                    m.includeSellerCoverage = r.bool();
                    break;
                case 3:
                    m.termOfContract = r.uint32();
                    break;
                case 4:
                    m.salesChannel = r.int32();
                    break;
                case 5:
                    m.purchaseChannel = r.int32();
                    break;
                case 6:
                    m.acCoverage = r.bool();
                    break;
                case 7:
                    m.tenant = r.string();
                    break;
                case 8:
                    m.salesGroup = r.int32();
                    break;
                case 9:
                    if (!(m.includedTags && m.includedTags.length))
                        m.includedTags = [];
                    m.includedTags.push(r.string());
                    break;
                case 10:
                    if (!(m.excludedTags && m.excludedTags.length))
                        m.excludedTags = [];
                    m.excludedTags.push(r.string());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return ProductOptions;
    })();

    coreproductpb.PropertyFeatures = (function() {

        /**
         * Properties of a PropertyFeatures.
         * @memberof coreproductpb
         * @interface IPropertyFeatures
         * @property {number|null} [age] PropertyFeatures age
         * @property {string|null} [zip] PropertyFeatures zip
         * @property {string|null} [state] PropertyFeatures state
         * @property {coreproductpb.ISquareFootageRange|null} [squareFootageRange] PropertyFeatures squareFootageRange
         * @property {coreproductpb.DwellingType|null} [dwellingType] PropertyFeatures dwellingType
         * @property {boolean|null} [newConstruction] PropertyFeatures newConstruction
         */

        /**
         * Constructs a new PropertyFeatures.
         * @memberof coreproductpb
         * @classdesc Represents a PropertyFeatures.
         * @implements IPropertyFeatures
         * @constructor
         * @param {coreproductpb.IPropertyFeatures=} [p] Properties to set
         */
        function PropertyFeatures(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * PropertyFeatures age.
         * @member {number} age
         * @memberof coreproductpb.PropertyFeatures
         * @instance
         */
        PropertyFeatures.prototype.age = 0;

        /**
         * PropertyFeatures zip.
         * @member {string} zip
         * @memberof coreproductpb.PropertyFeatures
         * @instance
         */
        PropertyFeatures.prototype.zip = "";

        /**
         * PropertyFeatures state.
         * @member {string} state
         * @memberof coreproductpb.PropertyFeatures
         * @instance
         */
        PropertyFeatures.prototype.state = "";

        /**
         * PropertyFeatures squareFootageRange.
         * @member {coreproductpb.ISquareFootageRange|null|undefined} squareFootageRange
         * @memberof coreproductpb.PropertyFeatures
         * @instance
         */
        PropertyFeatures.prototype.squareFootageRange = null;

        /**
         * PropertyFeatures dwellingType.
         * @member {coreproductpb.DwellingType} dwellingType
         * @memberof coreproductpb.PropertyFeatures
         * @instance
         */
        PropertyFeatures.prototype.dwellingType = 0;

        /**
         * PropertyFeatures newConstruction.
         * @member {boolean} newConstruction
         * @memberof coreproductpb.PropertyFeatures
         * @instance
         */
        PropertyFeatures.prototype.newConstruction = false;

        /**
         * Creates a new PropertyFeatures instance using the specified properties.
         * @function create
         * @memberof coreproductpb.PropertyFeatures
         * @static
         * @param {coreproductpb.IPropertyFeatures=} [properties] Properties to set
         * @returns {coreproductpb.PropertyFeatures} PropertyFeatures instance
         */
        PropertyFeatures.create = function create(properties) {
            return new PropertyFeatures(properties);
        };

        /**
         * Encodes the specified PropertyFeatures message. Does not implicitly {@link coreproductpb.PropertyFeatures.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.PropertyFeatures
         * @static
         * @param {coreproductpb.IPropertyFeatures} m PropertyFeatures message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PropertyFeatures.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.age != null && Object.hasOwnProperty.call(m, "age"))
                w.uint32(8).uint32(m.age);
            if (m.zip != null && Object.hasOwnProperty.call(m, "zip"))
                w.uint32(18).string(m.zip);
            if (m.state != null && Object.hasOwnProperty.call(m, "state"))
                w.uint32(26).string(m.state);
            if (m.squareFootageRange != null && Object.hasOwnProperty.call(m, "squareFootageRange"))
                $root.coreproductpb.SquareFootageRange.encode(m.squareFootageRange, w.uint32(34).fork()).ldelim();
            if (m.dwellingType != null && Object.hasOwnProperty.call(m, "dwellingType"))
                w.uint32(40).int32(m.dwellingType);
            if (m.newConstruction != null && Object.hasOwnProperty.call(m, "newConstruction"))
                w.uint32(48).bool(m.newConstruction);
            return w;
        };

        /**
         * Decodes a PropertyFeatures message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.PropertyFeatures
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.PropertyFeatures} PropertyFeatures
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PropertyFeatures.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.PropertyFeatures();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.age = r.uint32();
                    break;
                case 2:
                    m.zip = r.string();
                    break;
                case 3:
                    m.state = r.string();
                    break;
                case 4:
                    m.squareFootageRange = $root.coreproductpb.SquareFootageRange.decode(r, r.uint32());
                    break;
                case 5:
                    m.dwellingType = r.int32();
                    break;
                case 6:
                    m.newConstruction = r.bool();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return PropertyFeatures;
    })();

    coreproductpb.Distributor = (function() {

        /**
         * Properties of a Distributor.
         * @memberof coreproductpb
         * @interface IDistributor
         * @property {coreproductpb.DistributorType|null} [type] Distributor type
         * @property {string|null} [officeID] Distributor officeID
         * @property {string|null} [franchiseID] Distributor franchiseID
         */

        /**
         * Constructs a new Distributor.
         * @memberof coreproductpb
         * @classdesc Represents a Distributor.
         * @implements IDistributor
         * @constructor
         * @param {coreproductpb.IDistributor=} [p] Properties to set
         */
        function Distributor(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * Distributor type.
         * @member {coreproductpb.DistributorType} type
         * @memberof coreproductpb.Distributor
         * @instance
         */
        Distributor.prototype.type = 0;

        /**
         * Distributor officeID.
         * @member {string} officeID
         * @memberof coreproductpb.Distributor
         * @instance
         */
        Distributor.prototype.officeID = "";

        /**
         * Distributor franchiseID.
         * @member {string} franchiseID
         * @memberof coreproductpb.Distributor
         * @instance
         */
        Distributor.prototype.franchiseID = "";

        /**
         * Creates a new Distributor instance using the specified properties.
         * @function create
         * @memberof coreproductpb.Distributor
         * @static
         * @param {coreproductpb.IDistributor=} [properties] Properties to set
         * @returns {coreproductpb.Distributor} Distributor instance
         */
        Distributor.create = function create(properties) {
            return new Distributor(properties);
        };

        /**
         * Encodes the specified Distributor message. Does not implicitly {@link coreproductpb.Distributor.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.Distributor
         * @static
         * @param {coreproductpb.IDistributor} m Distributor message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Distributor.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.type != null && Object.hasOwnProperty.call(m, "type"))
                w.uint32(8).int32(m.type);
            if (m.officeID != null && Object.hasOwnProperty.call(m, "officeID"))
                w.uint32(18).string(m.officeID);
            if (m.franchiseID != null && Object.hasOwnProperty.call(m, "franchiseID"))
                w.uint32(26).string(m.franchiseID);
            return w;
        };

        /**
         * Decodes a Distributor message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.Distributor
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.Distributor} Distributor
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Distributor.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.Distributor();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.type = r.int32();
                    break;
                case 2:
                    m.officeID = r.string();
                    break;
                case 3:
                    m.franchiseID = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return Distributor;
    })();

    coreproductpb.Limitation = (function() {

        /**
         * Properties of a Limitation.
         * @memberof coreproductpb
         * @interface ILimitation
         * @property {coreproductpb.LimitationLevel|null} [limitationLevel] Limitation limitationLevel
         * @property {coreproductpb.LimitationType|null} [limitationType] Limitation limitationType
         * @property {string|null} [limitationReferenceID] Limitation limitationReferenceID
         * @property {number|Long|null} [amountInCents] Limitation amountInCents
         */

        /**
         * Constructs a new Limitation.
         * @memberof coreproductpb
         * @classdesc Represents a Limitation.
         * @implements ILimitation
         * @constructor
         * @param {coreproductpb.ILimitation=} [p] Properties to set
         */
        function Limitation(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * Limitation limitationLevel.
         * @member {coreproductpb.LimitationLevel} limitationLevel
         * @memberof coreproductpb.Limitation
         * @instance
         */
        Limitation.prototype.limitationLevel = 0;

        /**
         * Limitation limitationType.
         * @member {coreproductpb.LimitationType} limitationType
         * @memberof coreproductpb.Limitation
         * @instance
         */
        Limitation.prototype.limitationType = 0;

        /**
         * Limitation limitationReferenceID.
         * @member {string} limitationReferenceID
         * @memberof coreproductpb.Limitation
         * @instance
         */
        Limitation.prototype.limitationReferenceID = "";

        /**
         * Limitation amountInCents.
         * @member {number|Long} amountInCents
         * @memberof coreproductpb.Limitation
         * @instance
         */
        Limitation.prototype.amountInCents = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * Creates a new Limitation instance using the specified properties.
         * @function create
         * @memberof coreproductpb.Limitation
         * @static
         * @param {coreproductpb.ILimitation=} [properties] Properties to set
         * @returns {coreproductpb.Limitation} Limitation instance
         */
        Limitation.create = function create(properties) {
            return new Limitation(properties);
        };

        /**
         * Encodes the specified Limitation message. Does not implicitly {@link coreproductpb.Limitation.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.Limitation
         * @static
         * @param {coreproductpb.ILimitation} m Limitation message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Limitation.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.limitationLevel != null && Object.hasOwnProperty.call(m, "limitationLevel"))
                w.uint32(8).int32(m.limitationLevel);
            if (m.limitationType != null && Object.hasOwnProperty.call(m, "limitationType"))
                w.uint32(16).int32(m.limitationType);
            if (m.limitationReferenceID != null && Object.hasOwnProperty.call(m, "limitationReferenceID"))
                w.uint32(26).string(m.limitationReferenceID);
            if (m.amountInCents != null && Object.hasOwnProperty.call(m, "amountInCents"))
                w.uint32(32).uint64(m.amountInCents);
            return w;
        };

        /**
         * Decodes a Limitation message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.Limitation
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.Limitation} Limitation
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Limitation.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.Limitation();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.limitationLevel = r.int32();
                    break;
                case 2:
                    m.limitationType = r.int32();
                    break;
                case 3:
                    m.limitationReferenceID = r.string();
                    break;
                case 4:
                    m.amountInCents = r.uint64();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return Limitation;
    })();

    coreproductpb.SKU = (function() {

        /**
         * Properties of a SKU.
         * @memberof coreproductpb
         * @interface ISKU
         * @property {string|null} [id] SKU id
         * @property {string|null} [name] SKU name
         * @property {string|null} [salesItemName] SKU salesItemName
         * @property {string|null} [description] SKU description
         * @property {number|null} [serviceRequestLimit] SKU serviceRequestLimit
         * @property {number|Long|null} [serviceFeePerRequest] SKU serviceFeePerRequest
         * @property {string|null} [salesItemCategory] SKU salesItemCategory
         * @property {string|null} [marketingJSON] SKU marketingJSON
         * @property {Array.<coreproductpb.ICoverageItem>|null} [coverageItems] SKU coverageItems
         * @property {Array.<string>|null} [excludedComponentID] SKU excludedComponentID
         * @property {Array.<coreproductpb.ILimitation>|null} [limitations] SKU limitations
         * @property {string|null} [starCoverageId] SKU starCoverageId
         * @property {Array.<string>|null} [tags] SKU tags
         * @property {string|null} [customerType] SKU customerType
         * @property {coreproductpb.ICompactFeatureAttributes|null} [featureAttributes] SKU featureAttributes
         * @property {google.protobuf.ITimestamp|null} [expirationDate] SKU expirationDate
         */

        /**
         * Constructs a new SKU.
         * @memberof coreproductpb
         * @classdesc Represents a SKU.
         * @implements ISKU
         * @constructor
         * @param {coreproductpb.ISKU=} [p] Properties to set
         */
        function SKU(p) {
            this.coverageItems = [];
            this.excludedComponentID = [];
            this.limitations = [];
            this.tags = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * SKU id.
         * @member {string} id
         * @memberof coreproductpb.SKU
         * @instance
         */
        SKU.prototype.id = "";

        /**
         * SKU name.
         * @member {string} name
         * @memberof coreproductpb.SKU
         * @instance
         */
        SKU.prototype.name = "";

        /**
         * SKU salesItemName.
         * @member {string} salesItemName
         * @memberof coreproductpb.SKU
         * @instance
         */
        SKU.prototype.salesItemName = "";

        /**
         * SKU description.
         * @member {string} description
         * @memberof coreproductpb.SKU
         * @instance
         */
        SKU.prototype.description = "";

        /**
         * SKU serviceRequestLimit.
         * @member {number} serviceRequestLimit
         * @memberof coreproductpb.SKU
         * @instance
         */
        SKU.prototype.serviceRequestLimit = 0;

        /**
         * SKU serviceFeePerRequest.
         * @member {number|Long} serviceFeePerRequest
         * @memberof coreproductpb.SKU
         * @instance
         */
        SKU.prototype.serviceFeePerRequest = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * SKU salesItemCategory.
         * @member {string} salesItemCategory
         * @memberof coreproductpb.SKU
         * @instance
         */
        SKU.prototype.salesItemCategory = "";

        /**
         * SKU marketingJSON.
         * @member {string} marketingJSON
         * @memberof coreproductpb.SKU
         * @instance
         */
        SKU.prototype.marketingJSON = "";

        /**
         * SKU coverageItems.
         * @member {Array.<coreproductpb.ICoverageItem>} coverageItems
         * @memberof coreproductpb.SKU
         * @instance
         */
        SKU.prototype.coverageItems = $util.emptyArray;

        /**
         * SKU excludedComponentID.
         * @member {Array.<string>} excludedComponentID
         * @memberof coreproductpb.SKU
         * @instance
         */
        SKU.prototype.excludedComponentID = $util.emptyArray;

        /**
         * SKU limitations.
         * @member {Array.<coreproductpb.ILimitation>} limitations
         * @memberof coreproductpb.SKU
         * @instance
         */
        SKU.prototype.limitations = $util.emptyArray;

        /**
         * SKU starCoverageId.
         * @member {string} starCoverageId
         * @memberof coreproductpb.SKU
         * @instance
         */
        SKU.prototype.starCoverageId = "";

        /**
         * SKU tags.
         * @member {Array.<string>} tags
         * @memberof coreproductpb.SKU
         * @instance
         */
        SKU.prototype.tags = $util.emptyArray;

        /**
         * SKU customerType.
         * @member {string} customerType
         * @memberof coreproductpb.SKU
         * @instance
         */
        SKU.prototype.customerType = "";

        /**
         * SKU featureAttributes.
         * @member {coreproductpb.ICompactFeatureAttributes|null|undefined} featureAttributes
         * @memberof coreproductpb.SKU
         * @instance
         */
        SKU.prototype.featureAttributes = null;

        /**
         * SKU expirationDate.
         * @member {google.protobuf.ITimestamp|null|undefined} expirationDate
         * @memberof coreproductpb.SKU
         * @instance
         */
        SKU.prototype.expirationDate = null;

        /**
         * Creates a new SKU instance using the specified properties.
         * @function create
         * @memberof coreproductpb.SKU
         * @static
         * @param {coreproductpb.ISKU=} [properties] Properties to set
         * @returns {coreproductpb.SKU} SKU instance
         */
        SKU.create = function create(properties) {
            return new SKU(properties);
        };

        /**
         * Encodes the specified SKU message. Does not implicitly {@link coreproductpb.SKU.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.SKU
         * @static
         * @param {coreproductpb.ISKU} m SKU message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SKU.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.id != null && Object.hasOwnProperty.call(m, "id"))
                w.uint32(10).string(m.id);
            if (m.name != null && Object.hasOwnProperty.call(m, "name"))
                w.uint32(18).string(m.name);
            if (m.salesItemName != null && Object.hasOwnProperty.call(m, "salesItemName"))
                w.uint32(26).string(m.salesItemName);
            if (m.description != null && Object.hasOwnProperty.call(m, "description"))
                w.uint32(34).string(m.description);
            if (m.serviceRequestLimit != null && Object.hasOwnProperty.call(m, "serviceRequestLimit"))
                w.uint32(40).uint32(m.serviceRequestLimit);
            if (m.serviceFeePerRequest != null && Object.hasOwnProperty.call(m, "serviceFeePerRequest"))
                w.uint32(48).uint64(m.serviceFeePerRequest);
            if (m.salesItemCategory != null && Object.hasOwnProperty.call(m, "salesItemCategory"))
                w.uint32(58).string(m.salesItemCategory);
            if (m.marketingJSON != null && Object.hasOwnProperty.call(m, "marketingJSON"))
                w.uint32(66).string(m.marketingJSON);
            if (m.coverageItems != null && m.coverageItems.length) {
                for (var i = 0; i < m.coverageItems.length; ++i)
                    $root.coreproductpb.CoverageItem.encode(m.coverageItems[i], w.uint32(74).fork()).ldelim();
            }
            if (m.excludedComponentID != null && m.excludedComponentID.length) {
                for (var i = 0; i < m.excludedComponentID.length; ++i)
                    w.uint32(82).string(m.excludedComponentID[i]);
            }
            if (m.limitations != null && m.limitations.length) {
                for (var i = 0; i < m.limitations.length; ++i)
                    $root.coreproductpb.Limitation.encode(m.limitations[i], w.uint32(90).fork()).ldelim();
            }
            if (m.starCoverageId != null && Object.hasOwnProperty.call(m, "starCoverageId"))
                w.uint32(98).string(m.starCoverageId);
            if (m.tags != null && m.tags.length) {
                for (var i = 0; i < m.tags.length; ++i)
                    w.uint32(106).string(m.tags[i]);
            }
            if (m.customerType != null && Object.hasOwnProperty.call(m, "customerType"))
                w.uint32(114).string(m.customerType);
            if (m.featureAttributes != null && Object.hasOwnProperty.call(m, "featureAttributes"))
                $root.coreproductpb.CompactFeatureAttributes.encode(m.featureAttributes, w.uint32(122).fork()).ldelim();
            if (m.expirationDate != null && Object.hasOwnProperty.call(m, "expirationDate"))
                $root.google.protobuf.Timestamp.encode(m.expirationDate, w.uint32(130).fork()).ldelim();
            return w;
        };

        /**
         * Decodes a SKU message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.SKU
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.SKU} SKU
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SKU.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.SKU();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.id = r.string();
                    break;
                case 2:
                    m.name = r.string();
                    break;
                case 3:
                    m.salesItemName = r.string();
                    break;
                case 4:
                    m.description = r.string();
                    break;
                case 5:
                    m.serviceRequestLimit = r.uint32();
                    break;
                case 6:
                    m.serviceFeePerRequest = r.uint64();
                    break;
                case 7:
                    m.salesItemCategory = r.string();
                    break;
                case 8:
                    m.marketingJSON = r.string();
                    break;
                case 9:
                    if (!(m.coverageItems && m.coverageItems.length))
                        m.coverageItems = [];
                    m.coverageItems.push($root.coreproductpb.CoverageItem.decode(r, r.uint32()));
                    break;
                case 10:
                    if (!(m.excludedComponentID && m.excludedComponentID.length))
                        m.excludedComponentID = [];
                    m.excludedComponentID.push(r.string());
                    break;
                case 11:
                    if (!(m.limitations && m.limitations.length))
                        m.limitations = [];
                    m.limitations.push($root.coreproductpb.Limitation.decode(r, r.uint32()));
                    break;
                case 12:
                    m.starCoverageId = r.string();
                    break;
                case 13:
                    if (!(m.tags && m.tags.length))
                        m.tags = [];
                    m.tags.push(r.string());
                    break;
                case 14:
                    m.customerType = r.string();
                    break;
                case 15:
                    m.featureAttributes = $root.coreproductpb.CompactFeatureAttributes.decode(r, r.uint32());
                    break;
                case 16:
                    m.expirationDate = $root.google.protobuf.Timestamp.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return SKU;
    })();

    coreproductpb.CoverageItem = (function() {

        /**
         * Properties of a CoverageItem.
         * @memberof coreproductpb
         * @interface ICoverageItem
         * @property {string|null} [itemID] CoverageItem itemID
         * @property {string|null} [styleID] CoverageItem styleID
         * @property {coreproductpb.ICompactFeatureAttributes|null} [featureAttributes] CoverageItem featureAttributes
         */

        /**
         * Constructs a new CoverageItem.
         * @memberof coreproductpb
         * @classdesc Represents a CoverageItem.
         * @implements ICoverageItem
         * @constructor
         * @param {coreproductpb.ICoverageItem=} [p] Properties to set
         */
        function CoverageItem(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * CoverageItem itemID.
         * @member {string} itemID
         * @memberof coreproductpb.CoverageItem
         * @instance
         */
        CoverageItem.prototype.itemID = "";

        /**
         * CoverageItem styleID.
         * @member {string} styleID
         * @memberof coreproductpb.CoverageItem
         * @instance
         */
        CoverageItem.prototype.styleID = "";

        /**
         * CoverageItem featureAttributes.
         * @member {coreproductpb.ICompactFeatureAttributes|null|undefined} featureAttributes
         * @memberof coreproductpb.CoverageItem
         * @instance
         */
        CoverageItem.prototype.featureAttributes = null;

        /**
         * Creates a new CoverageItem instance using the specified properties.
         * @function create
         * @memberof coreproductpb.CoverageItem
         * @static
         * @param {coreproductpb.ICoverageItem=} [properties] Properties to set
         * @returns {coreproductpb.CoverageItem} CoverageItem instance
         */
        CoverageItem.create = function create(properties) {
            return new CoverageItem(properties);
        };

        /**
         * Encodes the specified CoverageItem message. Does not implicitly {@link coreproductpb.CoverageItem.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.CoverageItem
         * @static
         * @param {coreproductpb.ICoverageItem} m CoverageItem message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CoverageItem.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.itemID != null && Object.hasOwnProperty.call(m, "itemID"))
                w.uint32(10).string(m.itemID);
            if (m.styleID != null && Object.hasOwnProperty.call(m, "styleID"))
                w.uint32(18).string(m.styleID);
            if (m.featureAttributes != null && Object.hasOwnProperty.call(m, "featureAttributes"))
                $root.coreproductpb.CompactFeatureAttributes.encode(m.featureAttributes, w.uint32(26).fork()).ldelim();
            return w;
        };

        /**
         * Decodes a CoverageItem message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.CoverageItem
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.CoverageItem} CoverageItem
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CoverageItem.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.CoverageItem();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.itemID = r.string();
                    break;
                case 2:
                    m.styleID = r.string();
                    break;
                case 3:
                    m.featureAttributes = $root.coreproductpb.CompactFeatureAttributes.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return CoverageItem;
    })();

    coreproductpb.PropertyLimits = (function() {

        /**
         * Properties of a PropertyLimits.
         * @memberof coreproductpb
         * @interface IPropertyLimits
         * @property {common.IRange_U32|null} [age] PropertyLimits age
         * @property {common.IRange_U32|null} [size] PropertyLimits size
         * @property {common.IRange_U32|null} [guestSuites] PropertyLimits guestSuites
         * @property {Array.<coreproductpb.DwellingType>|null} [propertyType] PropertyLimits propertyType
         * @property {boolean|null} [forNewConstruction] PropertyLimits forNewConstruction
         */

        /**
         * Constructs a new PropertyLimits.
         * @memberof coreproductpb
         * @classdesc Represents a PropertyLimits.
         * @implements IPropertyLimits
         * @constructor
         * @param {coreproductpb.IPropertyLimits=} [p] Properties to set
         */
        function PropertyLimits(p) {
            this.propertyType = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * PropertyLimits age.
         * @member {common.IRange_U32|null|undefined} age
         * @memberof coreproductpb.PropertyLimits
         * @instance
         */
        PropertyLimits.prototype.age = null;

        /**
         * PropertyLimits size.
         * @member {common.IRange_U32|null|undefined} size
         * @memberof coreproductpb.PropertyLimits
         * @instance
         */
        PropertyLimits.prototype.size = null;

        /**
         * PropertyLimits guestSuites.
         * @member {common.IRange_U32|null|undefined} guestSuites
         * @memberof coreproductpb.PropertyLimits
         * @instance
         */
        PropertyLimits.prototype.guestSuites = null;

        /**
         * PropertyLimits propertyType.
         * @member {Array.<coreproductpb.DwellingType>} propertyType
         * @memberof coreproductpb.PropertyLimits
         * @instance
         */
        PropertyLimits.prototype.propertyType = $util.emptyArray;

        /**
         * PropertyLimits forNewConstruction.
         * @member {boolean} forNewConstruction
         * @memberof coreproductpb.PropertyLimits
         * @instance
         */
        PropertyLimits.prototype.forNewConstruction = false;

        /**
         * Creates a new PropertyLimits instance using the specified properties.
         * @function create
         * @memberof coreproductpb.PropertyLimits
         * @static
         * @param {coreproductpb.IPropertyLimits=} [properties] Properties to set
         * @returns {coreproductpb.PropertyLimits} PropertyLimits instance
         */
        PropertyLimits.create = function create(properties) {
            return new PropertyLimits(properties);
        };

        /**
         * Encodes the specified PropertyLimits message. Does not implicitly {@link coreproductpb.PropertyLimits.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.PropertyLimits
         * @static
         * @param {coreproductpb.IPropertyLimits} m PropertyLimits message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PropertyLimits.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.age != null && Object.hasOwnProperty.call(m, "age"))
                $root.common.Range_U32.encode(m.age, w.uint32(10).fork()).ldelim();
            if (m.size != null && Object.hasOwnProperty.call(m, "size"))
                $root.common.Range_U32.encode(m.size, w.uint32(18).fork()).ldelim();
            if (m.guestSuites != null && Object.hasOwnProperty.call(m, "guestSuites"))
                $root.common.Range_U32.encode(m.guestSuites, w.uint32(26).fork()).ldelim();
            if (m.propertyType != null && m.propertyType.length) {
                w.uint32(34).fork();
                for (var i = 0; i < m.propertyType.length; ++i)
                    w.int32(m.propertyType[i]);
                w.ldelim();
            }
            if (m.forNewConstruction != null && Object.hasOwnProperty.call(m, "forNewConstruction"))
                w.uint32(40).bool(m.forNewConstruction);
            return w;
        };

        /**
         * Decodes a PropertyLimits message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.PropertyLimits
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.PropertyLimits} PropertyLimits
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PropertyLimits.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.PropertyLimits();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.age = $root.common.Range_U32.decode(r, r.uint32());
                    break;
                case 2:
                    m.size = $root.common.Range_U32.decode(r, r.uint32());
                    break;
                case 3:
                    m.guestSuites = $root.common.Range_U32.decode(r, r.uint32());
                    break;
                case 4:
                    if (!(m.propertyType && m.propertyType.length))
                        m.propertyType = [];
                    if ((t & 7) === 2) {
                        var c2 = r.uint32() + r.pos;
                        while (r.pos < c2)
                            m.propertyType.push(r.int32());
                    } else
                        m.propertyType.push(r.int32());
                    break;
                case 5:
                    m.forNewConstruction = r.bool();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return PropertyLimits;
    })();

    coreproductpb.ProductFamilyDetails = (function() {

        /**
         * Properties of a ProductFamilyDetails.
         * @memberof coreproductpb
         * @interface IProductFamilyDetails
         * @property {string|null} [productFamilyID] ProductFamilyDetails productFamilyID
         * @property {string|null} [starProductPlanID] ProductFamilyDetails starProductPlanID
         * @property {string|null} [starProductID] ProductFamilyDetails starProductID
         * @property {string|null} [tenant] ProductFamilyDetails tenant
         * @property {string|null} [description] ProductFamilyDetails description
         */

        /**
         * Constructs a new ProductFamilyDetails.
         * @memberof coreproductpb
         * @classdesc Represents a ProductFamilyDetails.
         * @implements IProductFamilyDetails
         * @constructor
         * @param {coreproductpb.IProductFamilyDetails=} [p] Properties to set
         */
        function ProductFamilyDetails(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * ProductFamilyDetails productFamilyID.
         * @member {string} productFamilyID
         * @memberof coreproductpb.ProductFamilyDetails
         * @instance
         */
        ProductFamilyDetails.prototype.productFamilyID = "";

        /**
         * ProductFamilyDetails starProductPlanID.
         * @member {string} starProductPlanID
         * @memberof coreproductpb.ProductFamilyDetails
         * @instance
         */
        ProductFamilyDetails.prototype.starProductPlanID = "";

        /**
         * ProductFamilyDetails starProductID.
         * @member {string} starProductID
         * @memberof coreproductpb.ProductFamilyDetails
         * @instance
         */
        ProductFamilyDetails.prototype.starProductID = "";

        /**
         * ProductFamilyDetails tenant.
         * @member {string} tenant
         * @memberof coreproductpb.ProductFamilyDetails
         * @instance
         */
        ProductFamilyDetails.prototype.tenant = "";

        /**
         * ProductFamilyDetails description.
         * @member {string} description
         * @memberof coreproductpb.ProductFamilyDetails
         * @instance
         */
        ProductFamilyDetails.prototype.description = "";

        /**
         * Creates a new ProductFamilyDetails instance using the specified properties.
         * @function create
         * @memberof coreproductpb.ProductFamilyDetails
         * @static
         * @param {coreproductpb.IProductFamilyDetails=} [properties] Properties to set
         * @returns {coreproductpb.ProductFamilyDetails} ProductFamilyDetails instance
         */
        ProductFamilyDetails.create = function create(properties) {
            return new ProductFamilyDetails(properties);
        };

        /**
         * Encodes the specified ProductFamilyDetails message. Does not implicitly {@link coreproductpb.ProductFamilyDetails.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.ProductFamilyDetails
         * @static
         * @param {coreproductpb.IProductFamilyDetails} m ProductFamilyDetails message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ProductFamilyDetails.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.productFamilyID != null && Object.hasOwnProperty.call(m, "productFamilyID"))
                w.uint32(10).string(m.productFamilyID);
            if (m.starProductPlanID != null && Object.hasOwnProperty.call(m, "starProductPlanID"))
                w.uint32(18).string(m.starProductPlanID);
            if (m.starProductID != null && Object.hasOwnProperty.call(m, "starProductID"))
                w.uint32(26).string(m.starProductID);
            if (m.tenant != null && Object.hasOwnProperty.call(m, "tenant"))
                w.uint32(34).string(m.tenant);
            if (m.description != null && Object.hasOwnProperty.call(m, "description"))
                w.uint32(42).string(m.description);
            return w;
        };

        /**
         * Decodes a ProductFamilyDetails message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.ProductFamilyDetails
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.ProductFamilyDetails} ProductFamilyDetails
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ProductFamilyDetails.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.ProductFamilyDetails();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.productFamilyID = r.string();
                    break;
                case 2:
                    m.starProductPlanID = r.string();
                    break;
                case 3:
                    m.starProductID = r.string();
                    break;
                case 4:
                    m.tenant = r.string();
                    break;
                case 5:
                    m.description = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return ProductFamilyDetails;
    })();

    coreproductpb.ProductSKUTags = (function() {

        /**
         * Properties of a ProductSKUTags.
         * @memberof coreproductpb
         * @interface IProductSKUTags
         * @property {Array.<string>|null} [standardSKUs] ProductSKUTags standardSKUs
         * @property {Array.<string>|null} [optionalSKUs] ProductSKUTags optionalSKUs
         */

        /**
         * Constructs a new ProductSKUTags.
         * @memberof coreproductpb
         * @classdesc Represents a ProductSKUTags.
         * @implements IProductSKUTags
         * @constructor
         * @param {coreproductpb.IProductSKUTags=} [p] Properties to set
         */
        function ProductSKUTags(p) {
            this.standardSKUs = [];
            this.optionalSKUs = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * ProductSKUTags standardSKUs.
         * @member {Array.<string>} standardSKUs
         * @memberof coreproductpb.ProductSKUTags
         * @instance
         */
        ProductSKUTags.prototype.standardSKUs = $util.emptyArray;

        /**
         * ProductSKUTags optionalSKUs.
         * @member {Array.<string>} optionalSKUs
         * @memberof coreproductpb.ProductSKUTags
         * @instance
         */
        ProductSKUTags.prototype.optionalSKUs = $util.emptyArray;

        /**
         * Creates a new ProductSKUTags instance using the specified properties.
         * @function create
         * @memberof coreproductpb.ProductSKUTags
         * @static
         * @param {coreproductpb.IProductSKUTags=} [properties] Properties to set
         * @returns {coreproductpb.ProductSKUTags} ProductSKUTags instance
         */
        ProductSKUTags.create = function create(properties) {
            return new ProductSKUTags(properties);
        };

        /**
         * Encodes the specified ProductSKUTags message. Does not implicitly {@link coreproductpb.ProductSKUTags.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.ProductSKUTags
         * @static
         * @param {coreproductpb.IProductSKUTags} m ProductSKUTags message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ProductSKUTags.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.standardSKUs != null && m.standardSKUs.length) {
                for (var i = 0; i < m.standardSKUs.length; ++i)
                    w.uint32(10).string(m.standardSKUs[i]);
            }
            if (m.optionalSKUs != null && m.optionalSKUs.length) {
                for (var i = 0; i < m.optionalSKUs.length; ++i)
                    w.uint32(18).string(m.optionalSKUs[i]);
            }
            return w;
        };

        /**
         * Decodes a ProductSKUTags message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.ProductSKUTags
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.ProductSKUTags} ProductSKUTags
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ProductSKUTags.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.ProductSKUTags();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    if (!(m.standardSKUs && m.standardSKUs.length))
                        m.standardSKUs = [];
                    m.standardSKUs.push(r.string());
                    break;
                case 2:
                    if (!(m.optionalSKUs && m.optionalSKUs.length))
                        m.optionalSKUs = [];
                    m.optionalSKUs.push(r.string());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return ProductSKUTags;
    })();

    coreproductpb.Product = (function() {

        /**
         * Properties of a Product.
         * @memberof coreproductpb
         * @interface IProduct
         * @property {string|null} [id] Product id
         * @property {string|null} [name] Product name
         * @property {string|null} [productFamilyID] Product productFamilyID
         * @property {string|null} [internalDescription] Product internalDescription
         * @property {string|null} [externalDescription] Product externalDescription
         * @property {Array.<coreproductpb.CustomerType>|null} [customerTypes] Product customerTypes
         * @property {Array.<string>|null} [standardSKUIDs] Product standardSKUIDs
         * @property {Array.<string>|null} [optionalSKUIDs] Product optionalSKUIDs
         * @property {Array.<coreproductpb.IDisplayOptions>|null} [options] Product options
         * @property {Array.<coreproductpb.IContractTerms>|null} [contractTerms] Product contractTerms
         * @property {Array.<coreproductpb.ILimitation>|null} [productLimitations] Product productLimitations
         * @property {number|Long|null} [effectiveOn] Product effectiveOn
         * @property {number|Long|null} [expirationOn] Product expirationOn
         * @property {coreproductpb.IMetaData|null} [meta] Product meta
         * @property {string|null} [starOldPV] Product starOldPV
         * @property {coreproductpb.ICompactProductDetails|null} [compactProductDetails] Product compactProductDetails
         * @property {Array.<string>|null} [salesGroup] Product salesGroup
         * @property {Array.<number|Long>|null} [serviceFees] Product serviceFees
         * @property {coreproductpb.IPropertyLimits|null} [propertyLimits] Product propertyLimits
         * @property {coreproductpb.IProductFamilyDetails|null} [familyDetails] Product familyDetails
         * @property {coreproductpb.ICompactProductAttributes|null} [attributes] Product attributes
         */

        /**
         * Constructs a new Product.
         * @memberof coreproductpb
         * @classdesc Represents a Product.
         * @implements IProduct
         * @constructor
         * @param {coreproductpb.IProduct=} [p] Properties to set
         */
        function Product(p) {
            this.customerTypes = [];
            this.standardSKUIDs = [];
            this.optionalSKUIDs = [];
            this.options = [];
            this.contractTerms = [];
            this.productLimitations = [];
            this.salesGroup = [];
            this.serviceFees = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * Product id.
         * @member {string} id
         * @memberof coreproductpb.Product
         * @instance
         */
        Product.prototype.id = "";

        /**
         * Product name.
         * @member {string} name
         * @memberof coreproductpb.Product
         * @instance
         */
        Product.prototype.name = "";

        /**
         * Product productFamilyID.
         * @member {string} productFamilyID
         * @memberof coreproductpb.Product
         * @instance
         */
        Product.prototype.productFamilyID = "";

        /**
         * Product internalDescription.
         * @member {string} internalDescription
         * @memberof coreproductpb.Product
         * @instance
         */
        Product.prototype.internalDescription = "";

        /**
         * Product externalDescription.
         * @member {string} externalDescription
         * @memberof coreproductpb.Product
         * @instance
         */
        Product.prototype.externalDescription = "";

        /**
         * Product customerTypes.
         * @member {Array.<coreproductpb.CustomerType>} customerTypes
         * @memberof coreproductpb.Product
         * @instance
         */
        Product.prototype.customerTypes = $util.emptyArray;

        /**
         * Product standardSKUIDs.
         * @member {Array.<string>} standardSKUIDs
         * @memberof coreproductpb.Product
         * @instance
         */
        Product.prototype.standardSKUIDs = $util.emptyArray;

        /**
         * Product optionalSKUIDs.
         * @member {Array.<string>} optionalSKUIDs
         * @memberof coreproductpb.Product
         * @instance
         */
        Product.prototype.optionalSKUIDs = $util.emptyArray;

        /**
         * Product options.
         * @member {Array.<coreproductpb.IDisplayOptions>} options
         * @memberof coreproductpb.Product
         * @instance
         */
        Product.prototype.options = $util.emptyArray;

        /**
         * Product contractTerms.
         * @member {Array.<coreproductpb.IContractTerms>} contractTerms
         * @memberof coreproductpb.Product
         * @instance
         */
        Product.prototype.contractTerms = $util.emptyArray;

        /**
         * Product productLimitations.
         * @member {Array.<coreproductpb.ILimitation>} productLimitations
         * @memberof coreproductpb.Product
         * @instance
         */
        Product.prototype.productLimitations = $util.emptyArray;

        /**
         * Product effectiveOn.
         * @member {number|Long} effectiveOn
         * @memberof coreproductpb.Product
         * @instance
         */
        Product.prototype.effectiveOn = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * Product expirationOn.
         * @member {number|Long} expirationOn
         * @memberof coreproductpb.Product
         * @instance
         */
        Product.prototype.expirationOn = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * Product meta.
         * @member {coreproductpb.IMetaData|null|undefined} meta
         * @memberof coreproductpb.Product
         * @instance
         */
        Product.prototype.meta = null;

        /**
         * Product starOldPV.
         * @member {string} starOldPV
         * @memberof coreproductpb.Product
         * @instance
         */
        Product.prototype.starOldPV = "";

        /**
         * Product compactProductDetails.
         * @member {coreproductpb.ICompactProductDetails|null|undefined} compactProductDetails
         * @memberof coreproductpb.Product
         * @instance
         */
        Product.prototype.compactProductDetails = null;

        /**
         * Product salesGroup.
         * @member {Array.<string>} salesGroup
         * @memberof coreproductpb.Product
         * @instance
         */
        Product.prototype.salesGroup = $util.emptyArray;

        /**
         * Product serviceFees.
         * @member {Array.<number|Long>} serviceFees
         * @memberof coreproductpb.Product
         * @instance
         */
        Product.prototype.serviceFees = $util.emptyArray;

        /**
         * Product propertyLimits.
         * @member {coreproductpb.IPropertyLimits|null|undefined} propertyLimits
         * @memberof coreproductpb.Product
         * @instance
         */
        Product.prototype.propertyLimits = null;

        /**
         * Product familyDetails.
         * @member {coreproductpb.IProductFamilyDetails|null|undefined} familyDetails
         * @memberof coreproductpb.Product
         * @instance
         */
        Product.prototype.familyDetails = null;

        /**
         * Product attributes.
         * @member {coreproductpb.ICompactProductAttributes|null|undefined} attributes
         * @memberof coreproductpb.Product
         * @instance
         */
        Product.prototype.attributes = null;

        /**
         * Creates a new Product instance using the specified properties.
         * @function create
         * @memberof coreproductpb.Product
         * @static
         * @param {coreproductpb.IProduct=} [properties] Properties to set
         * @returns {coreproductpb.Product} Product instance
         */
        Product.create = function create(properties) {
            return new Product(properties);
        };

        /**
         * Encodes the specified Product message. Does not implicitly {@link coreproductpb.Product.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.Product
         * @static
         * @param {coreproductpb.IProduct} m Product message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Product.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.id != null && Object.hasOwnProperty.call(m, "id"))
                w.uint32(10).string(m.id);
            if (m.name != null && Object.hasOwnProperty.call(m, "name"))
                w.uint32(18).string(m.name);
            if (m.productFamilyID != null && Object.hasOwnProperty.call(m, "productFamilyID"))
                w.uint32(26).string(m.productFamilyID);
            if (m.internalDescription != null && Object.hasOwnProperty.call(m, "internalDescription"))
                w.uint32(34).string(m.internalDescription);
            if (m.externalDescription != null && Object.hasOwnProperty.call(m, "externalDescription"))
                w.uint32(42).string(m.externalDescription);
            if (m.customerTypes != null && m.customerTypes.length) {
                w.uint32(50).fork();
                for (var i = 0; i < m.customerTypes.length; ++i)
                    w.int32(m.customerTypes[i]);
                w.ldelim();
            }
            if (m.standardSKUIDs != null && m.standardSKUIDs.length) {
                for (var i = 0; i < m.standardSKUIDs.length; ++i)
                    w.uint32(58).string(m.standardSKUIDs[i]);
            }
            if (m.optionalSKUIDs != null && m.optionalSKUIDs.length) {
                for (var i = 0; i < m.optionalSKUIDs.length; ++i)
                    w.uint32(66).string(m.optionalSKUIDs[i]);
            }
            if (m.options != null && m.options.length) {
                for (var i = 0; i < m.options.length; ++i)
                    $root.coreproductpb.DisplayOptions.encode(m.options[i], w.uint32(74).fork()).ldelim();
            }
            if (m.contractTerms != null && m.contractTerms.length) {
                for (var i = 0; i < m.contractTerms.length; ++i)
                    $root.coreproductpb.ContractTerms.encode(m.contractTerms[i], w.uint32(82).fork()).ldelim();
            }
            if (m.productLimitations != null && m.productLimitations.length) {
                for (var i = 0; i < m.productLimitations.length; ++i)
                    $root.coreproductpb.Limitation.encode(m.productLimitations[i], w.uint32(90).fork()).ldelim();
            }
            if (m.effectiveOn != null && Object.hasOwnProperty.call(m, "effectiveOn"))
                w.uint32(96).uint64(m.effectiveOn);
            if (m.expirationOn != null && Object.hasOwnProperty.call(m, "expirationOn"))
                w.uint32(104).uint64(m.expirationOn);
            if (m.meta != null && Object.hasOwnProperty.call(m, "meta"))
                $root.coreproductpb.MetaData.encode(m.meta, w.uint32(114).fork()).ldelim();
            if (m.starOldPV != null && Object.hasOwnProperty.call(m, "starOldPV"))
                w.uint32(122).string(m.starOldPV);
            if (m.compactProductDetails != null && Object.hasOwnProperty.call(m, "compactProductDetails"))
                $root.coreproductpb.CompactProductDetails.encode(m.compactProductDetails, w.uint32(138).fork()).ldelim();
            if (m.salesGroup != null && m.salesGroup.length) {
                for (var i = 0; i < m.salesGroup.length; ++i)
                    w.uint32(146).string(m.salesGroup[i]);
            }
            if (m.serviceFees != null && m.serviceFees.length) {
                w.uint32(154).fork();
                for (var i = 0; i < m.serviceFees.length; ++i)
                    w.uint64(m.serviceFees[i]);
                w.ldelim();
            }
            if (m.propertyLimits != null && Object.hasOwnProperty.call(m, "propertyLimits"))
                $root.coreproductpb.PropertyLimits.encode(m.propertyLimits, w.uint32(162).fork()).ldelim();
            if (m.familyDetails != null && Object.hasOwnProperty.call(m, "familyDetails"))
                $root.coreproductpb.ProductFamilyDetails.encode(m.familyDetails, w.uint32(170).fork()).ldelim();
            if (m.attributes != null && Object.hasOwnProperty.call(m, "attributes"))
                $root.coreproductpb.CompactProductAttributes.encode(m.attributes, w.uint32(178).fork()).ldelim();
            return w;
        };

        /**
         * Decodes a Product message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.Product
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.Product} Product
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Product.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.Product();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.id = r.string();
                    break;
                case 2:
                    m.name = r.string();
                    break;
                case 3:
                    m.productFamilyID = r.string();
                    break;
                case 4:
                    m.internalDescription = r.string();
                    break;
                case 5:
                    m.externalDescription = r.string();
                    break;
                case 6:
                    if (!(m.customerTypes && m.customerTypes.length))
                        m.customerTypes = [];
                    if ((t & 7) === 2) {
                        var c2 = r.uint32() + r.pos;
                        while (r.pos < c2)
                            m.customerTypes.push(r.int32());
                    } else
                        m.customerTypes.push(r.int32());
                    break;
                case 7:
                    if (!(m.standardSKUIDs && m.standardSKUIDs.length))
                        m.standardSKUIDs = [];
                    m.standardSKUIDs.push(r.string());
                    break;
                case 8:
                    if (!(m.optionalSKUIDs && m.optionalSKUIDs.length))
                        m.optionalSKUIDs = [];
                    m.optionalSKUIDs.push(r.string());
                    break;
                case 9:
                    if (!(m.options && m.options.length))
                        m.options = [];
                    m.options.push($root.coreproductpb.DisplayOptions.decode(r, r.uint32()));
                    break;
                case 10:
                    if (!(m.contractTerms && m.contractTerms.length))
                        m.contractTerms = [];
                    m.contractTerms.push($root.coreproductpb.ContractTerms.decode(r, r.uint32()));
                    break;
                case 11:
                    if (!(m.productLimitations && m.productLimitations.length))
                        m.productLimitations = [];
                    m.productLimitations.push($root.coreproductpb.Limitation.decode(r, r.uint32()));
                    break;
                case 12:
                    m.effectiveOn = r.uint64();
                    break;
                case 13:
                    m.expirationOn = r.uint64();
                    break;
                case 14:
                    m.meta = $root.coreproductpb.MetaData.decode(r, r.uint32());
                    break;
                case 15:
                    m.starOldPV = r.string();
                    break;
                case 17:
                    m.compactProductDetails = $root.coreproductpb.CompactProductDetails.decode(r, r.uint32());
                    break;
                case 18:
                    if (!(m.salesGroup && m.salesGroup.length))
                        m.salesGroup = [];
                    m.salesGroup.push(r.string());
                    break;
                case 19:
                    if (!(m.serviceFees && m.serviceFees.length))
                        m.serviceFees = [];
                    if ((t & 7) === 2) {
                        var c2 = r.uint32() + r.pos;
                        while (r.pos < c2)
                            m.serviceFees.push(r.uint64());
                    } else
                        m.serviceFees.push(r.uint64());
                    break;
                case 20:
                    m.propertyLimits = $root.coreproductpb.PropertyLimits.decode(r, r.uint32());
                    break;
                case 21:
                    m.familyDetails = $root.coreproductpb.ProductFamilyDetails.decode(r, r.uint32());
                    break;
                case 22:
                    m.attributes = $root.coreproductpb.CompactProductAttributes.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return Product;
    })();

    coreproductpb.CompactProductAttributes = (function() {

        /**
         * Properties of a CompactProductAttributes.
         * @memberof coreproductpb
         * @interface ICompactProductAttributes
         * @property {common.IMoney|null} [aggregateCashOutAmount] CompactProductAttributes aggregateCashOutAmount
         * @property {coreproductpb.TypedValue.ITimePeriod|null} [postCashOutAssetRepairWaitPeriod] CompactProductAttributes postCashOutAssetRepairWaitPeriod
         * @property {common.IMoney|null} [aggregateRepairAmount] CompactProductAttributes aggregateRepairAmount
         * @property {common.IMoney|null} [diagnosisFee] CompactProductAttributes diagnosisFee
         * @property {common.IMoney|null} [maxItemRepairAmount] CompactProductAttributes maxItemRepairAmount
         * @property {common.IMoney|null} [maxCashOutAmount] CompactProductAttributes maxCashOutAmount
         * @property {common.IMoney|null} [maintenanceFee] CompactProductAttributes maintenanceFee
         * @property {number|null} [maxStreemCallCount] CompactProductAttributes maxStreemCallCount
         */

        /**
         * Constructs a new CompactProductAttributes.
         * @memberof coreproductpb
         * @classdesc Represents a CompactProductAttributes.
         * @implements ICompactProductAttributes
         * @constructor
         * @param {coreproductpb.ICompactProductAttributes=} [p] Properties to set
         */
        function CompactProductAttributes(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * CompactProductAttributes aggregateCashOutAmount.
         * @member {common.IMoney|null|undefined} aggregateCashOutAmount
         * @memberof coreproductpb.CompactProductAttributes
         * @instance
         */
        CompactProductAttributes.prototype.aggregateCashOutAmount = null;

        /**
         * CompactProductAttributes postCashOutAssetRepairWaitPeriod.
         * @member {coreproductpb.TypedValue.ITimePeriod|null|undefined} postCashOutAssetRepairWaitPeriod
         * @memberof coreproductpb.CompactProductAttributes
         * @instance
         */
        CompactProductAttributes.prototype.postCashOutAssetRepairWaitPeriod = null;

        /**
         * CompactProductAttributes aggregateRepairAmount.
         * @member {common.IMoney|null|undefined} aggregateRepairAmount
         * @memberof coreproductpb.CompactProductAttributes
         * @instance
         */
        CompactProductAttributes.prototype.aggregateRepairAmount = null;

        /**
         * CompactProductAttributes diagnosisFee.
         * @member {common.IMoney|null|undefined} diagnosisFee
         * @memberof coreproductpb.CompactProductAttributes
         * @instance
         */
        CompactProductAttributes.prototype.diagnosisFee = null;

        /**
         * CompactProductAttributes maxItemRepairAmount.
         * @member {common.IMoney|null|undefined} maxItemRepairAmount
         * @memberof coreproductpb.CompactProductAttributes
         * @instance
         */
        CompactProductAttributes.prototype.maxItemRepairAmount = null;

        /**
         * CompactProductAttributes maxCashOutAmount.
         * @member {common.IMoney|null|undefined} maxCashOutAmount
         * @memberof coreproductpb.CompactProductAttributes
         * @instance
         */
        CompactProductAttributes.prototype.maxCashOutAmount = null;

        /**
         * CompactProductAttributes maintenanceFee.
         * @member {common.IMoney|null|undefined} maintenanceFee
         * @memberof coreproductpb.CompactProductAttributes
         * @instance
         */
        CompactProductAttributes.prototype.maintenanceFee = null;

        /**
         * CompactProductAttributes maxStreemCallCount.
         * @member {number} maxStreemCallCount
         * @memberof coreproductpb.CompactProductAttributes
         * @instance
         */
        CompactProductAttributes.prototype.maxStreemCallCount = 0;

        /**
         * Creates a new CompactProductAttributes instance using the specified properties.
         * @function create
         * @memberof coreproductpb.CompactProductAttributes
         * @static
         * @param {coreproductpb.ICompactProductAttributes=} [properties] Properties to set
         * @returns {coreproductpb.CompactProductAttributes} CompactProductAttributes instance
         */
        CompactProductAttributes.create = function create(properties) {
            return new CompactProductAttributes(properties);
        };

        /**
         * Encodes the specified CompactProductAttributes message. Does not implicitly {@link coreproductpb.CompactProductAttributes.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.CompactProductAttributes
         * @static
         * @param {coreproductpb.ICompactProductAttributes} m CompactProductAttributes message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CompactProductAttributes.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.aggregateCashOutAmount != null && Object.hasOwnProperty.call(m, "aggregateCashOutAmount"))
                $root.common.Money.encode(m.aggregateCashOutAmount, w.uint32(10).fork()).ldelim();
            if (m.postCashOutAssetRepairWaitPeriod != null && Object.hasOwnProperty.call(m, "postCashOutAssetRepairWaitPeriod"))
                $root.coreproductpb.TypedValue.TimePeriod.encode(m.postCashOutAssetRepairWaitPeriod, w.uint32(18).fork()).ldelim();
            if (m.aggregateRepairAmount != null && Object.hasOwnProperty.call(m, "aggregateRepairAmount"))
                $root.common.Money.encode(m.aggregateRepairAmount, w.uint32(26).fork()).ldelim();
            if (m.diagnosisFee != null && Object.hasOwnProperty.call(m, "diagnosisFee"))
                $root.common.Money.encode(m.diagnosisFee, w.uint32(34).fork()).ldelim();
            if (m.maxItemRepairAmount != null && Object.hasOwnProperty.call(m, "maxItemRepairAmount"))
                $root.common.Money.encode(m.maxItemRepairAmount, w.uint32(42).fork()).ldelim();
            if (m.maxCashOutAmount != null && Object.hasOwnProperty.call(m, "maxCashOutAmount"))
                $root.common.Money.encode(m.maxCashOutAmount, w.uint32(50).fork()).ldelim();
            if (m.maintenanceFee != null && Object.hasOwnProperty.call(m, "maintenanceFee"))
                $root.common.Money.encode(m.maintenanceFee, w.uint32(58).fork()).ldelim();
            if (m.maxStreemCallCount != null && Object.hasOwnProperty.call(m, "maxStreemCallCount"))
                w.uint32(64).int32(m.maxStreemCallCount);
            return w;
        };

        /**
         * Decodes a CompactProductAttributes message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.CompactProductAttributes
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.CompactProductAttributes} CompactProductAttributes
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CompactProductAttributes.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.CompactProductAttributes();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.aggregateCashOutAmount = $root.common.Money.decode(r, r.uint32());
                    break;
                case 2:
                    m.postCashOutAssetRepairWaitPeriod = $root.coreproductpb.TypedValue.TimePeriod.decode(r, r.uint32());
                    break;
                case 3:
                    m.aggregateRepairAmount = $root.common.Money.decode(r, r.uint32());
                    break;
                case 4:
                    m.diagnosisFee = $root.common.Money.decode(r, r.uint32());
                    break;
                case 5:
                    m.maxItemRepairAmount = $root.common.Money.decode(r, r.uint32());
                    break;
                case 6:
                    m.maxCashOutAmount = $root.common.Money.decode(r, r.uint32());
                    break;
                case 7:
                    m.maintenanceFee = $root.common.Money.decode(r, r.uint32());
                    break;
                case 8:
                    m.maxStreemCallCount = r.int32();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return CompactProductAttributes;
    })();

    coreproductpb.CompactFeatureAttributes = (function() {

        /**
         * Properties of a CompactFeatureAttributes.
         * @memberof coreproductpb
         * @interface ICompactFeatureAttributes
         * @property {common.IMoney|null} [aggregateRepairAmount] CompactFeatureAttributes aggregateRepairAmount
         * @property {common.IMoney|null} [diagnosisFee] CompactFeatureAttributes diagnosisFee
         * @property {common.IMoney|null} [maxItemRepairAmount] CompactFeatureAttributes maxItemRepairAmount
         * @property {common.IMoney|null} [maxCashOutAmount] CompactFeatureAttributes maxCashOutAmount
         * @property {common.IMoney|null} [maintenanceFee] CompactFeatureAttributes maintenanceFee
         * @property {common.IMoney|null} [aggregateCashOutAmount] CompactFeatureAttributes aggregateCashOutAmount
         */

        /**
         * Constructs a new CompactFeatureAttributes.
         * @memberof coreproductpb
         * @classdesc Represents a CompactFeatureAttributes.
         * @implements ICompactFeatureAttributes
         * @constructor
         * @param {coreproductpb.ICompactFeatureAttributes=} [p] Properties to set
         */
        function CompactFeatureAttributes(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * CompactFeatureAttributes aggregateRepairAmount.
         * @member {common.IMoney|null|undefined} aggregateRepairAmount
         * @memberof coreproductpb.CompactFeatureAttributes
         * @instance
         */
        CompactFeatureAttributes.prototype.aggregateRepairAmount = null;

        /**
         * CompactFeatureAttributes diagnosisFee.
         * @member {common.IMoney|null|undefined} diagnosisFee
         * @memberof coreproductpb.CompactFeatureAttributes
         * @instance
         */
        CompactFeatureAttributes.prototype.diagnosisFee = null;

        /**
         * CompactFeatureAttributes maxItemRepairAmount.
         * @member {common.IMoney|null|undefined} maxItemRepairAmount
         * @memberof coreproductpb.CompactFeatureAttributes
         * @instance
         */
        CompactFeatureAttributes.prototype.maxItemRepairAmount = null;

        /**
         * CompactFeatureAttributes maxCashOutAmount.
         * @member {common.IMoney|null|undefined} maxCashOutAmount
         * @memberof coreproductpb.CompactFeatureAttributes
         * @instance
         */
        CompactFeatureAttributes.prototype.maxCashOutAmount = null;

        /**
         * CompactFeatureAttributes maintenanceFee.
         * @member {common.IMoney|null|undefined} maintenanceFee
         * @memberof coreproductpb.CompactFeatureAttributes
         * @instance
         */
        CompactFeatureAttributes.prototype.maintenanceFee = null;

        /**
         * CompactFeatureAttributes aggregateCashOutAmount.
         * @member {common.IMoney|null|undefined} aggregateCashOutAmount
         * @memberof coreproductpb.CompactFeatureAttributes
         * @instance
         */
        CompactFeatureAttributes.prototype.aggregateCashOutAmount = null;

        /**
         * Creates a new CompactFeatureAttributes instance using the specified properties.
         * @function create
         * @memberof coreproductpb.CompactFeatureAttributes
         * @static
         * @param {coreproductpb.ICompactFeatureAttributes=} [properties] Properties to set
         * @returns {coreproductpb.CompactFeatureAttributes} CompactFeatureAttributes instance
         */
        CompactFeatureAttributes.create = function create(properties) {
            return new CompactFeatureAttributes(properties);
        };

        /**
         * Encodes the specified CompactFeatureAttributes message. Does not implicitly {@link coreproductpb.CompactFeatureAttributes.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.CompactFeatureAttributes
         * @static
         * @param {coreproductpb.ICompactFeatureAttributes} m CompactFeatureAttributes message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CompactFeatureAttributes.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.aggregateRepairAmount != null && Object.hasOwnProperty.call(m, "aggregateRepairAmount"))
                $root.common.Money.encode(m.aggregateRepairAmount, w.uint32(10).fork()).ldelim();
            if (m.diagnosisFee != null && Object.hasOwnProperty.call(m, "diagnosisFee"))
                $root.common.Money.encode(m.diagnosisFee, w.uint32(18).fork()).ldelim();
            if (m.maxItemRepairAmount != null && Object.hasOwnProperty.call(m, "maxItemRepairAmount"))
                $root.common.Money.encode(m.maxItemRepairAmount, w.uint32(26).fork()).ldelim();
            if (m.maxCashOutAmount != null && Object.hasOwnProperty.call(m, "maxCashOutAmount"))
                $root.common.Money.encode(m.maxCashOutAmount, w.uint32(34).fork()).ldelim();
            if (m.maintenanceFee != null && Object.hasOwnProperty.call(m, "maintenanceFee"))
                $root.common.Money.encode(m.maintenanceFee, w.uint32(42).fork()).ldelim();
            if (m.aggregateCashOutAmount != null && Object.hasOwnProperty.call(m, "aggregateCashOutAmount"))
                $root.common.Money.encode(m.aggregateCashOutAmount, w.uint32(50).fork()).ldelim();
            return w;
        };

        /**
         * Decodes a CompactFeatureAttributes message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.CompactFeatureAttributes
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.CompactFeatureAttributes} CompactFeatureAttributes
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CompactFeatureAttributes.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.CompactFeatureAttributes();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.aggregateRepairAmount = $root.common.Money.decode(r, r.uint32());
                    break;
                case 2:
                    m.diagnosisFee = $root.common.Money.decode(r, r.uint32());
                    break;
                case 3:
                    m.maxItemRepairAmount = $root.common.Money.decode(r, r.uint32());
                    break;
                case 4:
                    m.maxCashOutAmount = $root.common.Money.decode(r, r.uint32());
                    break;
                case 5:
                    m.maintenanceFee = $root.common.Money.decode(r, r.uint32());
                    break;
                case 6:
                    m.aggregateCashOutAmount = $root.common.Money.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return CompactFeatureAttributes;
    })();

    coreproductpb.Feature = (function() {

        /**
         * Properties of a Feature.
         * @memberof coreproductpb
         * @interface IFeature
         * @property {coreproductpb.FeatureMasterDataType|null} [masterDataType] Feature masterDataType
         * @property {string|null} [masterDataID] Feature masterDataID
         * @property {string|null} [name] Feature name
         * @property {coreproductpb.IFeatureAttributes|null} [attributes] Feature attributes
         * @property {Array.<coreproductpb.IFeature>|null} [includes] Feature includes
         * @property {Array.<coreproductpb.IFeature>|null} [excludes] Feature excludes
         */

        /**
         * Constructs a new Feature.
         * @memberof coreproductpb
         * @classdesc Represents a Feature.
         * @implements IFeature
         * @constructor
         * @param {coreproductpb.IFeature=} [p] Properties to set
         */
        function Feature(p) {
            this.includes = [];
            this.excludes = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * Feature masterDataType.
         * @member {coreproductpb.FeatureMasterDataType} masterDataType
         * @memberof coreproductpb.Feature
         * @instance
         */
        Feature.prototype.masterDataType = 0;

        /**
         * Feature masterDataID.
         * @member {string} masterDataID
         * @memberof coreproductpb.Feature
         * @instance
         */
        Feature.prototype.masterDataID = "";

        /**
         * Feature name.
         * @member {string} name
         * @memberof coreproductpb.Feature
         * @instance
         */
        Feature.prototype.name = "";

        /**
         * Feature attributes.
         * @member {coreproductpb.IFeatureAttributes|null|undefined} attributes
         * @memberof coreproductpb.Feature
         * @instance
         */
        Feature.prototype.attributes = null;

        /**
         * Feature includes.
         * @member {Array.<coreproductpb.IFeature>} includes
         * @memberof coreproductpb.Feature
         * @instance
         */
        Feature.prototype.includes = $util.emptyArray;

        /**
         * Feature excludes.
         * @member {Array.<coreproductpb.IFeature>} excludes
         * @memberof coreproductpb.Feature
         * @instance
         */
        Feature.prototype.excludes = $util.emptyArray;

        /**
         * Creates a new Feature instance using the specified properties.
         * @function create
         * @memberof coreproductpb.Feature
         * @static
         * @param {coreproductpb.IFeature=} [properties] Properties to set
         * @returns {coreproductpb.Feature} Feature instance
         */
        Feature.create = function create(properties) {
            return new Feature(properties);
        };

        /**
         * Encodes the specified Feature message. Does not implicitly {@link coreproductpb.Feature.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.Feature
         * @static
         * @param {coreproductpb.IFeature} m Feature message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Feature.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.masterDataType != null && Object.hasOwnProperty.call(m, "masterDataType"))
                w.uint32(8).int32(m.masterDataType);
            if (m.masterDataID != null && Object.hasOwnProperty.call(m, "masterDataID"))
                w.uint32(18).string(m.masterDataID);
            if (m.name != null && Object.hasOwnProperty.call(m, "name"))
                w.uint32(26).string(m.name);
            if (m.attributes != null && Object.hasOwnProperty.call(m, "attributes"))
                $root.coreproductpb.FeatureAttributes.encode(m.attributes, w.uint32(34).fork()).ldelim();
            if (m.includes != null && m.includes.length) {
                for (var i = 0; i < m.includes.length; ++i)
                    $root.coreproductpb.Feature.encode(m.includes[i], w.uint32(42).fork()).ldelim();
            }
            if (m.excludes != null && m.excludes.length) {
                for (var i = 0; i < m.excludes.length; ++i)
                    $root.coreproductpb.Feature.encode(m.excludes[i], w.uint32(50).fork()).ldelim();
            }
            return w;
        };

        /**
         * Decodes a Feature message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.Feature
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.Feature} Feature
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Feature.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.Feature();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.masterDataType = r.int32();
                    break;
                case 2:
                    m.masterDataID = r.string();
                    break;
                case 3:
                    m.name = r.string();
                    break;
                case 4:
                    m.attributes = $root.coreproductpb.FeatureAttributes.decode(r, r.uint32());
                    break;
                case 5:
                    if (!(m.includes && m.includes.length))
                        m.includes = [];
                    m.includes.push($root.coreproductpb.Feature.decode(r, r.uint32()));
                    break;
                case 6:
                    if (!(m.excludes && m.excludes.length))
                        m.excludes = [];
                    m.excludes.push($root.coreproductpb.Feature.decode(r, r.uint32()));
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return Feature;
    })();

    coreproductpb.FeatureAttributes = (function() {

        /**
         * Properties of a FeatureAttributes.
         * @memberof coreproductpb
         * @interface IFeatureAttributes
         * @property {coreproductpb.IPickAttributes|null} [pickAttributes] FeatureAttributes pickAttributes
         * @property {coreproductpb.FeatureAttributes.ICoverageAttributes|null} [coverageAttributes] FeatureAttributes coverageAttributes
         * @property {coreproductpb.FeatureAttributes.IItemAttributes|null} [itemAttributes] FeatureAttributes itemAttributes
         * @property {coreproductpb.FeatureAttributes.IMaintenanceServiceAttributes|null} [maintenanceServiceAttributes] FeatureAttributes maintenanceServiceAttributes
         * @property {coreproductpb.FeatureAttributes.IFeatureCoverageAttributes|null} [featureCoverageAttributes] FeatureAttributes featureCoverageAttributes
         */

        /**
         * Constructs a new FeatureAttributes.
         * @memberof coreproductpb
         * @classdesc Represents a FeatureAttributes.
         * @implements IFeatureAttributes
         * @constructor
         * @param {coreproductpb.IFeatureAttributes=} [p] Properties to set
         */
        function FeatureAttributes(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * FeatureAttributes pickAttributes.
         * @member {coreproductpb.IPickAttributes|null|undefined} pickAttributes
         * @memberof coreproductpb.FeatureAttributes
         * @instance
         */
        FeatureAttributes.prototype.pickAttributes = null;

        /**
         * FeatureAttributes coverageAttributes.
         * @member {coreproductpb.FeatureAttributes.ICoverageAttributes|null|undefined} coverageAttributes
         * @memberof coreproductpb.FeatureAttributes
         * @instance
         */
        FeatureAttributes.prototype.coverageAttributes = null;

        /**
         * FeatureAttributes itemAttributes.
         * @member {coreproductpb.FeatureAttributes.IItemAttributes|null|undefined} itemAttributes
         * @memberof coreproductpb.FeatureAttributes
         * @instance
         */
        FeatureAttributes.prototype.itemAttributes = null;

        /**
         * FeatureAttributes maintenanceServiceAttributes.
         * @member {coreproductpb.FeatureAttributes.IMaintenanceServiceAttributes|null|undefined} maintenanceServiceAttributes
         * @memberof coreproductpb.FeatureAttributes
         * @instance
         */
        FeatureAttributes.prototype.maintenanceServiceAttributes = null;

        /**
         * FeatureAttributes featureCoverageAttributes.
         * @member {coreproductpb.FeatureAttributes.IFeatureCoverageAttributes|null|undefined} featureCoverageAttributes
         * @memberof coreproductpb.FeatureAttributes
         * @instance
         */
        FeatureAttributes.prototype.featureCoverageAttributes = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        /**
         * FeatureAttributes featureAttributes.
         * @member {"coverageAttributes"|"itemAttributes"|"maintenanceServiceAttributes"|"featureCoverageAttributes"|undefined} featureAttributes
         * @memberof coreproductpb.FeatureAttributes
         * @instance
         */
        Object.defineProperty(FeatureAttributes.prototype, "featureAttributes", {
            get: $util.oneOfGetter($oneOfFields = ["coverageAttributes", "itemAttributes", "maintenanceServiceAttributes", "featureCoverageAttributes"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new FeatureAttributes instance using the specified properties.
         * @function create
         * @memberof coreproductpb.FeatureAttributes
         * @static
         * @param {coreproductpb.IFeatureAttributes=} [properties] Properties to set
         * @returns {coreproductpb.FeatureAttributes} FeatureAttributes instance
         */
        FeatureAttributes.create = function create(properties) {
            return new FeatureAttributes(properties);
        };

        /**
         * Encodes the specified FeatureAttributes message. Does not implicitly {@link coreproductpb.FeatureAttributes.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.FeatureAttributes
         * @static
         * @param {coreproductpb.IFeatureAttributes} m FeatureAttributes message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        FeatureAttributes.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.pickAttributes != null && Object.hasOwnProperty.call(m, "pickAttributes"))
                $root.coreproductpb.PickAttributes.encode(m.pickAttributes, w.uint32(10).fork()).ldelim();
            if (m.coverageAttributes != null && Object.hasOwnProperty.call(m, "coverageAttributes"))
                $root.coreproductpb.FeatureAttributes.CoverageAttributes.encode(m.coverageAttributes, w.uint32(18).fork()).ldelim();
            if (m.itemAttributes != null && Object.hasOwnProperty.call(m, "itemAttributes"))
                $root.coreproductpb.FeatureAttributes.ItemAttributes.encode(m.itemAttributes, w.uint32(26).fork()).ldelim();
            if (m.maintenanceServiceAttributes != null && Object.hasOwnProperty.call(m, "maintenanceServiceAttributes"))
                $root.coreproductpb.FeatureAttributes.MaintenanceServiceAttributes.encode(m.maintenanceServiceAttributes, w.uint32(34).fork()).ldelim();
            if (m.featureCoverageAttributes != null && Object.hasOwnProperty.call(m, "featureCoverageAttributes"))
                $root.coreproductpb.FeatureAttributes.FeatureCoverageAttributes.encode(m.featureCoverageAttributes, w.uint32(42).fork()).ldelim();
            return w;
        };

        /**
         * Decodes a FeatureAttributes message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.FeatureAttributes
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.FeatureAttributes} FeatureAttributes
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        FeatureAttributes.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.FeatureAttributes();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.pickAttributes = $root.coreproductpb.PickAttributes.decode(r, r.uint32());
                    break;
                case 2:
                    m.coverageAttributes = $root.coreproductpb.FeatureAttributes.CoverageAttributes.decode(r, r.uint32());
                    break;
                case 3:
                    m.itemAttributes = $root.coreproductpb.FeatureAttributes.ItemAttributes.decode(r, r.uint32());
                    break;
                case 4:
                    m.maintenanceServiceAttributes = $root.coreproductpb.FeatureAttributes.MaintenanceServiceAttributes.decode(r, r.uint32());
                    break;
                case 5:
                    m.featureCoverageAttributes = $root.coreproductpb.FeatureAttributes.FeatureCoverageAttributes.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        FeatureAttributes.CoverageAttributes = (function() {

            /**
             * Properties of a CoverageAttributes.
             * @memberof coreproductpb.FeatureAttributes
             * @interface ICoverageAttributes
             * @property {string|null} [description] CoverageAttributes description
             * @property {string|null} [starCoverageID] CoverageAttributes starCoverageID
             * @property {common.IMoney|null} [aggregateRepairAmount] CoverageAttributes aggregateRepairAmount
             * @property {common.IMoney|null} [aggregateCashoutAmount] CoverageAttributes aggregateCashoutAmount
             * @property {common.IMoney|null} [diagnosisFee] CoverageAttributes diagnosisFee
             * @property {common.IMoney|null} [maxItemRepairAmount] CoverageAttributes maxItemRepairAmount
             * @property {common.IMoney|null} [maxCashOutAmount] CoverageAttributes maxCashOutAmount
             * @property {common.IMoney|null} [maintenanceFee] CoverageAttributes maintenanceFee
             * @property {string|null} [listingCoverageBeneficiary] CoverageAttributes listingCoverageBeneficiary
             * @property {Array.<string>|null} [tags] CoverageAttributes tags
             * @property {number|null} [maxFreeServiceCount] CoverageAttributes maxFreeServiceCount
             * @property {google.protobuf.ITimestamp|null} [expirationDate] CoverageAttributes expirationDate
             * @property {number|null} [maxCount] CoverageAttributes maxCount
             */

            /**
             * Constructs a new CoverageAttributes.
             * @memberof coreproductpb.FeatureAttributes
             * @classdesc Represents a CoverageAttributes.
             * @implements ICoverageAttributes
             * @constructor
             * @param {coreproductpb.FeatureAttributes.ICoverageAttributes=} [p] Properties to set
             */
            function CoverageAttributes(p) {
                this.tags = [];
                if (p)
                    for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                        if (p[ks[i]] != null)
                            this[ks[i]] = p[ks[i]];
            }

            /**
             * CoverageAttributes description.
             * @member {string} description
             * @memberof coreproductpb.FeatureAttributes.CoverageAttributes
             * @instance
             */
            CoverageAttributes.prototype.description = "";

            /**
             * CoverageAttributes starCoverageID.
             * @member {string} starCoverageID
             * @memberof coreproductpb.FeatureAttributes.CoverageAttributes
             * @instance
             */
            CoverageAttributes.prototype.starCoverageID = "";

            /**
             * CoverageAttributes aggregateRepairAmount.
             * @member {common.IMoney|null|undefined} aggregateRepairAmount
             * @memberof coreproductpb.FeatureAttributes.CoverageAttributes
             * @instance
             */
            CoverageAttributes.prototype.aggregateRepairAmount = null;

            /**
             * CoverageAttributes aggregateCashoutAmount.
             * @member {common.IMoney|null|undefined} aggregateCashoutAmount
             * @memberof coreproductpb.FeatureAttributes.CoverageAttributes
             * @instance
             */
            CoverageAttributes.prototype.aggregateCashoutAmount = null;

            /**
             * CoverageAttributes diagnosisFee.
             * @member {common.IMoney|null|undefined} diagnosisFee
             * @memberof coreproductpb.FeatureAttributes.CoverageAttributes
             * @instance
             */
            CoverageAttributes.prototype.diagnosisFee = null;

            /**
             * CoverageAttributes maxItemRepairAmount.
             * @member {common.IMoney|null|undefined} maxItemRepairAmount
             * @memberof coreproductpb.FeatureAttributes.CoverageAttributes
             * @instance
             */
            CoverageAttributes.prototype.maxItemRepairAmount = null;

            /**
             * CoverageAttributes maxCashOutAmount.
             * @member {common.IMoney|null|undefined} maxCashOutAmount
             * @memberof coreproductpb.FeatureAttributes.CoverageAttributes
             * @instance
             */
            CoverageAttributes.prototype.maxCashOutAmount = null;

            /**
             * CoverageAttributes maintenanceFee.
             * @member {common.IMoney|null|undefined} maintenanceFee
             * @memberof coreproductpb.FeatureAttributes.CoverageAttributes
             * @instance
             */
            CoverageAttributes.prototype.maintenanceFee = null;

            /**
             * CoverageAttributes listingCoverageBeneficiary.
             * @member {string} listingCoverageBeneficiary
             * @memberof coreproductpb.FeatureAttributes.CoverageAttributes
             * @instance
             */
            CoverageAttributes.prototype.listingCoverageBeneficiary = "";

            /**
             * CoverageAttributes tags.
             * @member {Array.<string>} tags
             * @memberof coreproductpb.FeatureAttributes.CoverageAttributes
             * @instance
             */
            CoverageAttributes.prototype.tags = $util.emptyArray;

            /**
             * CoverageAttributes maxFreeServiceCount.
             * @member {number} maxFreeServiceCount
             * @memberof coreproductpb.FeatureAttributes.CoverageAttributes
             * @instance
             */
            CoverageAttributes.prototype.maxFreeServiceCount = 0;

            /**
             * CoverageAttributes expirationDate.
             * @member {google.protobuf.ITimestamp|null|undefined} expirationDate
             * @memberof coreproductpb.FeatureAttributes.CoverageAttributes
             * @instance
             */
            CoverageAttributes.prototype.expirationDate = null;

            /**
             * CoverageAttributes maxCount.
             * @member {number} maxCount
             * @memberof coreproductpb.FeatureAttributes.CoverageAttributes
             * @instance
             */
            CoverageAttributes.prototype.maxCount = 0;

            /**
             * Creates a new CoverageAttributes instance using the specified properties.
             * @function create
             * @memberof coreproductpb.FeatureAttributes.CoverageAttributes
             * @static
             * @param {coreproductpb.FeatureAttributes.ICoverageAttributes=} [properties] Properties to set
             * @returns {coreproductpb.FeatureAttributes.CoverageAttributes} CoverageAttributes instance
             */
            CoverageAttributes.create = function create(properties) {
                return new CoverageAttributes(properties);
            };

            /**
             * Encodes the specified CoverageAttributes message. Does not implicitly {@link coreproductpb.FeatureAttributes.CoverageAttributes.verify|verify} messages.
             * @function encode
             * @memberof coreproductpb.FeatureAttributes.CoverageAttributes
             * @static
             * @param {coreproductpb.FeatureAttributes.ICoverageAttributes} m CoverageAttributes message or plain object to encode
             * @param {$protobuf.Writer} [w] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            CoverageAttributes.encode = function encode(m, w) {
                if (!w)
                    w = $Writer.create();
                if (m.description != null && Object.hasOwnProperty.call(m, "description"))
                    w.uint32(10).string(m.description);
                if (m.starCoverageID != null && Object.hasOwnProperty.call(m, "starCoverageID"))
                    w.uint32(18).string(m.starCoverageID);
                if (m.aggregateRepairAmount != null && Object.hasOwnProperty.call(m, "aggregateRepairAmount"))
                    $root.common.Money.encode(m.aggregateRepairAmount, w.uint32(26).fork()).ldelim();
                if (m.aggregateCashoutAmount != null && Object.hasOwnProperty.call(m, "aggregateCashoutAmount"))
                    $root.common.Money.encode(m.aggregateCashoutAmount, w.uint32(34).fork()).ldelim();
                if (m.diagnosisFee != null && Object.hasOwnProperty.call(m, "diagnosisFee"))
                    $root.common.Money.encode(m.diagnosisFee, w.uint32(42).fork()).ldelim();
                if (m.maxItemRepairAmount != null && Object.hasOwnProperty.call(m, "maxItemRepairAmount"))
                    $root.common.Money.encode(m.maxItemRepairAmount, w.uint32(50).fork()).ldelim();
                if (m.maxCashOutAmount != null && Object.hasOwnProperty.call(m, "maxCashOutAmount"))
                    $root.common.Money.encode(m.maxCashOutAmount, w.uint32(58).fork()).ldelim();
                if (m.maintenanceFee != null && Object.hasOwnProperty.call(m, "maintenanceFee"))
                    $root.common.Money.encode(m.maintenanceFee, w.uint32(66).fork()).ldelim();
                if (m.listingCoverageBeneficiary != null && Object.hasOwnProperty.call(m, "listingCoverageBeneficiary"))
                    w.uint32(74).string(m.listingCoverageBeneficiary);
                if (m.tags != null && m.tags.length) {
                    for (var i = 0; i < m.tags.length; ++i)
                        w.uint32(82).string(m.tags[i]);
                }
                if (m.maxFreeServiceCount != null && Object.hasOwnProperty.call(m, "maxFreeServiceCount"))
                    w.uint32(88).int32(m.maxFreeServiceCount);
                if (m.expirationDate != null && Object.hasOwnProperty.call(m, "expirationDate"))
                    $root.google.protobuf.Timestamp.encode(m.expirationDate, w.uint32(98).fork()).ldelim();
                if (m.maxCount != null && Object.hasOwnProperty.call(m, "maxCount"))
                    w.uint32(104).int32(m.maxCount);
                return w;
            };

            /**
             * Decodes a CoverageAttributes message from the specified reader or buffer.
             * @function decode
             * @memberof coreproductpb.FeatureAttributes.CoverageAttributes
             * @static
             * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
             * @param {number} [l] Message length if known beforehand
             * @returns {coreproductpb.FeatureAttributes.CoverageAttributes} CoverageAttributes
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            CoverageAttributes.decode = function decode(r, l) {
                if (!(r instanceof $Reader))
                    r = $Reader.create(r);
                var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.FeatureAttributes.CoverageAttributes();
                while (r.pos < c) {
                    var t = r.uint32();
                    switch (t >>> 3) {
                    case 1:
                        m.description = r.string();
                        break;
                    case 2:
                        m.starCoverageID = r.string();
                        break;
                    case 3:
                        m.aggregateRepairAmount = $root.common.Money.decode(r, r.uint32());
                        break;
                    case 4:
                        m.aggregateCashoutAmount = $root.common.Money.decode(r, r.uint32());
                        break;
                    case 5:
                        m.diagnosisFee = $root.common.Money.decode(r, r.uint32());
                        break;
                    case 6:
                        m.maxItemRepairAmount = $root.common.Money.decode(r, r.uint32());
                        break;
                    case 7:
                        m.maxCashOutAmount = $root.common.Money.decode(r, r.uint32());
                        break;
                    case 8:
                        m.maintenanceFee = $root.common.Money.decode(r, r.uint32());
                        break;
                    case 9:
                        m.listingCoverageBeneficiary = r.string();
                        break;
                    case 10:
                        if (!(m.tags && m.tags.length))
                            m.tags = [];
                        m.tags.push(r.string());
                        break;
                    case 11:
                        m.maxFreeServiceCount = r.int32();
                        break;
                    case 12:
                        m.expirationDate = $root.google.protobuf.Timestamp.decode(r, r.uint32());
                        break;
                    case 13:
                        m.maxCount = r.int32();
                        break;
                    default:
                        r.skipType(t & 7);
                        break;
                    }
                }
                return m;
            };

            return CoverageAttributes;
        })();

        FeatureAttributes.ItemAttributes = (function() {

            /**
             * Properties of an ItemAttributes.
             * @memberof coreproductpb.FeatureAttributes
             * @interface IItemAttributes
             * @property {string|null} [styleID] ItemAttributes styleID
             * @property {string|null} [tradeID] ItemAttributes tradeID
             * @property {string|null} [tradeCode] ItemAttributes tradeCode
             * @property {string|null} [starItemID] ItemAttributes starItemID
             * @property {string|null} [starTradeCode] ItemAttributes starTradeCode
             * @property {common.IMoney|null} [aggregateRepairAmount] ItemAttributes aggregateRepairAmount
             * @property {common.IMoney|null} [aggregateCashOutAmount] ItemAttributes aggregateCashOutAmount
             * @property {common.IMoney|null} [diagnosisFee] ItemAttributes diagnosisFee
             * @property {common.IMoney|null} [maxItemRepairAmount] ItemAttributes maxItemRepairAmount
             * @property {common.IMoney|null} [maxCashOutAmount] ItemAttributes maxCashOutAmount
             * @property {string|null} [listingCoverageBeneficiary] ItemAttributes listingCoverageBeneficiary
             * @property {number|null} [maxItemFreeServiceCount] ItemAttributes maxItemFreeServiceCount
             * @property {number|null} [maxItemServiceCount] ItemAttributes maxItemServiceCount
             */

            /**
             * Constructs a new ItemAttributes.
             * @memberof coreproductpb.FeatureAttributes
             * @classdesc Represents an ItemAttributes.
             * @implements IItemAttributes
             * @constructor
             * @param {coreproductpb.FeatureAttributes.IItemAttributes=} [p] Properties to set
             */
            function ItemAttributes(p) {
                if (p)
                    for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                        if (p[ks[i]] != null)
                            this[ks[i]] = p[ks[i]];
            }

            /**
             * ItemAttributes styleID.
             * @member {string} styleID
             * @memberof coreproductpb.FeatureAttributes.ItemAttributes
             * @instance
             */
            ItemAttributes.prototype.styleID = "";

            /**
             * ItemAttributes tradeID.
             * @member {string} tradeID
             * @memberof coreproductpb.FeatureAttributes.ItemAttributes
             * @instance
             */
            ItemAttributes.prototype.tradeID = "";

            /**
             * ItemAttributes tradeCode.
             * @member {string} tradeCode
             * @memberof coreproductpb.FeatureAttributes.ItemAttributes
             * @instance
             */
            ItemAttributes.prototype.tradeCode = "";

            /**
             * ItemAttributes starItemID.
             * @member {string} starItemID
             * @memberof coreproductpb.FeatureAttributes.ItemAttributes
             * @instance
             */
            ItemAttributes.prototype.starItemID = "";

            /**
             * ItemAttributes starTradeCode.
             * @member {string} starTradeCode
             * @memberof coreproductpb.FeatureAttributes.ItemAttributes
             * @instance
             */
            ItemAttributes.prototype.starTradeCode = "";

            /**
             * ItemAttributes aggregateRepairAmount.
             * @member {common.IMoney|null|undefined} aggregateRepairAmount
             * @memberof coreproductpb.FeatureAttributes.ItemAttributes
             * @instance
             */
            ItemAttributes.prototype.aggregateRepairAmount = null;

            /**
             * ItemAttributes aggregateCashOutAmount.
             * @member {common.IMoney|null|undefined} aggregateCashOutAmount
             * @memberof coreproductpb.FeatureAttributes.ItemAttributes
             * @instance
             */
            ItemAttributes.prototype.aggregateCashOutAmount = null;

            /**
             * ItemAttributes diagnosisFee.
             * @member {common.IMoney|null|undefined} diagnosisFee
             * @memberof coreproductpb.FeatureAttributes.ItemAttributes
             * @instance
             */
            ItemAttributes.prototype.diagnosisFee = null;

            /**
             * ItemAttributes maxItemRepairAmount.
             * @member {common.IMoney|null|undefined} maxItemRepairAmount
             * @memberof coreproductpb.FeatureAttributes.ItemAttributes
             * @instance
             */
            ItemAttributes.prototype.maxItemRepairAmount = null;

            /**
             * ItemAttributes maxCashOutAmount.
             * @member {common.IMoney|null|undefined} maxCashOutAmount
             * @memberof coreproductpb.FeatureAttributes.ItemAttributes
             * @instance
             */
            ItemAttributes.prototype.maxCashOutAmount = null;

            /**
             * ItemAttributes listingCoverageBeneficiary.
             * @member {string} listingCoverageBeneficiary
             * @memberof coreproductpb.FeatureAttributes.ItemAttributes
             * @instance
             */
            ItemAttributes.prototype.listingCoverageBeneficiary = "";

            /**
             * ItemAttributes maxItemFreeServiceCount.
             * @member {number} maxItemFreeServiceCount
             * @memberof coreproductpb.FeatureAttributes.ItemAttributes
             * @instance
             */
            ItemAttributes.prototype.maxItemFreeServiceCount = 0;

            /**
             * ItemAttributes maxItemServiceCount.
             * @member {number} maxItemServiceCount
             * @memberof coreproductpb.FeatureAttributes.ItemAttributes
             * @instance
             */
            ItemAttributes.prototype.maxItemServiceCount = 0;

            /**
             * Creates a new ItemAttributes instance using the specified properties.
             * @function create
             * @memberof coreproductpb.FeatureAttributes.ItemAttributes
             * @static
             * @param {coreproductpb.FeatureAttributes.IItemAttributes=} [properties] Properties to set
             * @returns {coreproductpb.FeatureAttributes.ItemAttributes} ItemAttributes instance
             */
            ItemAttributes.create = function create(properties) {
                return new ItemAttributes(properties);
            };

            /**
             * Encodes the specified ItemAttributes message. Does not implicitly {@link coreproductpb.FeatureAttributes.ItemAttributes.verify|verify} messages.
             * @function encode
             * @memberof coreproductpb.FeatureAttributes.ItemAttributes
             * @static
             * @param {coreproductpb.FeatureAttributes.IItemAttributes} m ItemAttributes message or plain object to encode
             * @param {$protobuf.Writer} [w] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ItemAttributes.encode = function encode(m, w) {
                if (!w)
                    w = $Writer.create();
                if (m.styleID != null && Object.hasOwnProperty.call(m, "styleID"))
                    w.uint32(10).string(m.styleID);
                if (m.tradeID != null && Object.hasOwnProperty.call(m, "tradeID"))
                    w.uint32(18).string(m.tradeID);
                if (m.tradeCode != null && Object.hasOwnProperty.call(m, "tradeCode"))
                    w.uint32(26).string(m.tradeCode);
                if (m.starItemID != null && Object.hasOwnProperty.call(m, "starItemID"))
                    w.uint32(34).string(m.starItemID);
                if (m.starTradeCode != null && Object.hasOwnProperty.call(m, "starTradeCode"))
                    w.uint32(42).string(m.starTradeCode);
                if (m.aggregateRepairAmount != null && Object.hasOwnProperty.call(m, "aggregateRepairAmount"))
                    $root.common.Money.encode(m.aggregateRepairAmount, w.uint32(50).fork()).ldelim();
                if (m.aggregateCashOutAmount != null && Object.hasOwnProperty.call(m, "aggregateCashOutAmount"))
                    $root.common.Money.encode(m.aggregateCashOutAmount, w.uint32(58).fork()).ldelim();
                if (m.diagnosisFee != null && Object.hasOwnProperty.call(m, "diagnosisFee"))
                    $root.common.Money.encode(m.diagnosisFee, w.uint32(66).fork()).ldelim();
                if (m.maxItemRepairAmount != null && Object.hasOwnProperty.call(m, "maxItemRepairAmount"))
                    $root.common.Money.encode(m.maxItemRepairAmount, w.uint32(74).fork()).ldelim();
                if (m.maxCashOutAmount != null && Object.hasOwnProperty.call(m, "maxCashOutAmount"))
                    $root.common.Money.encode(m.maxCashOutAmount, w.uint32(82).fork()).ldelim();
                if (m.listingCoverageBeneficiary != null && Object.hasOwnProperty.call(m, "listingCoverageBeneficiary"))
                    w.uint32(90).string(m.listingCoverageBeneficiary);
                if (m.maxItemFreeServiceCount != null && Object.hasOwnProperty.call(m, "maxItemFreeServiceCount"))
                    w.uint32(96).int32(m.maxItemFreeServiceCount);
                if (m.maxItemServiceCount != null && Object.hasOwnProperty.call(m, "maxItemServiceCount"))
                    w.uint32(104).int32(m.maxItemServiceCount);
                return w;
            };

            /**
             * Decodes an ItemAttributes message from the specified reader or buffer.
             * @function decode
             * @memberof coreproductpb.FeatureAttributes.ItemAttributes
             * @static
             * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
             * @param {number} [l] Message length if known beforehand
             * @returns {coreproductpb.FeatureAttributes.ItemAttributes} ItemAttributes
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ItemAttributes.decode = function decode(r, l) {
                if (!(r instanceof $Reader))
                    r = $Reader.create(r);
                var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.FeatureAttributes.ItemAttributes();
                while (r.pos < c) {
                    var t = r.uint32();
                    switch (t >>> 3) {
                    case 1:
                        m.styleID = r.string();
                        break;
                    case 2:
                        m.tradeID = r.string();
                        break;
                    case 3:
                        m.tradeCode = r.string();
                        break;
                    case 4:
                        m.starItemID = r.string();
                        break;
                    case 5:
                        m.starTradeCode = r.string();
                        break;
                    case 6:
                        m.aggregateRepairAmount = $root.common.Money.decode(r, r.uint32());
                        break;
                    case 7:
                        m.aggregateCashOutAmount = $root.common.Money.decode(r, r.uint32());
                        break;
                    case 8:
                        m.diagnosisFee = $root.common.Money.decode(r, r.uint32());
                        break;
                    case 9:
                        m.maxItemRepairAmount = $root.common.Money.decode(r, r.uint32());
                        break;
                    case 10:
                        m.maxCashOutAmount = $root.common.Money.decode(r, r.uint32());
                        break;
                    case 11:
                        m.listingCoverageBeneficiary = r.string();
                        break;
                    case 12:
                        m.maxItemFreeServiceCount = r.int32();
                        break;
                    case 13:
                        m.maxItemServiceCount = r.int32();
                        break;
                    default:
                        r.skipType(t & 7);
                        break;
                    }
                }
                return m;
            };

            return ItemAttributes;
        })();

        FeatureAttributes.MaintenanceServiceAttributes = (function() {

            /**
             * Properties of a MaintenanceServiceAttributes.
             * @memberof coreproductpb.FeatureAttributes
             * @interface IMaintenanceServiceAttributes
             * @property {string|null} [styleID] MaintenanceServiceAttributes styleID
             * @property {string|null} [tradeID] MaintenanceServiceAttributes tradeID
             * @property {string|null} [tradeCode] MaintenanceServiceAttributes tradeCode
             * @property {string|null} [starItemID] MaintenanceServiceAttributes starItemID
             * @property {string|null} [starTradeCode] MaintenanceServiceAttributes starTradeCode
             * @property {common.IMoney|null} [maintenanceFee] MaintenanceServiceAttributes maintenanceFee
             * @property {string|null} [listingCoverageBeneficiary] MaintenanceServiceAttributes listingCoverageBeneficiary
             * @property {common.IMoney|null} [aggregateRepairAmount] MaintenanceServiceAttributes aggregateRepairAmount
             * @property {common.IMoney|null} [aggregateCashOutAmount] MaintenanceServiceAttributes aggregateCashOutAmount
             * @property {common.IMoney|null} [diagnosisFee] MaintenanceServiceAttributes diagnosisFee
             * @property {common.IMoney|null} [maxItemRepairAmount] MaintenanceServiceAttributes maxItemRepairAmount
             * @property {common.IMoney|null} [maxCashOutAmount] MaintenanceServiceAttributes maxCashOutAmount
             * @property {number|null} [maxItemFreeServiceCount] MaintenanceServiceAttributes maxItemFreeServiceCount
             * @property {number|null} [maxItemServiceCount] MaintenanceServiceAttributes maxItemServiceCount
             */

            /**
             * Constructs a new MaintenanceServiceAttributes.
             * @memberof coreproductpb.FeatureAttributes
             * @classdesc Represents a MaintenanceServiceAttributes.
             * @implements IMaintenanceServiceAttributes
             * @constructor
             * @param {coreproductpb.FeatureAttributes.IMaintenanceServiceAttributes=} [p] Properties to set
             */
            function MaintenanceServiceAttributes(p) {
                if (p)
                    for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                        if (p[ks[i]] != null)
                            this[ks[i]] = p[ks[i]];
            }

            /**
             * MaintenanceServiceAttributes styleID.
             * @member {string} styleID
             * @memberof coreproductpb.FeatureAttributes.MaintenanceServiceAttributes
             * @instance
             */
            MaintenanceServiceAttributes.prototype.styleID = "";

            /**
             * MaintenanceServiceAttributes tradeID.
             * @member {string} tradeID
             * @memberof coreproductpb.FeatureAttributes.MaintenanceServiceAttributes
             * @instance
             */
            MaintenanceServiceAttributes.prototype.tradeID = "";

            /**
             * MaintenanceServiceAttributes tradeCode.
             * @member {string} tradeCode
             * @memberof coreproductpb.FeatureAttributes.MaintenanceServiceAttributes
             * @instance
             */
            MaintenanceServiceAttributes.prototype.tradeCode = "";

            /**
             * MaintenanceServiceAttributes starItemID.
             * @member {string} starItemID
             * @memberof coreproductpb.FeatureAttributes.MaintenanceServiceAttributes
             * @instance
             */
            MaintenanceServiceAttributes.prototype.starItemID = "";

            /**
             * MaintenanceServiceAttributes starTradeCode.
             * @member {string} starTradeCode
             * @memberof coreproductpb.FeatureAttributes.MaintenanceServiceAttributes
             * @instance
             */
            MaintenanceServiceAttributes.prototype.starTradeCode = "";

            /**
             * MaintenanceServiceAttributes maintenanceFee.
             * @member {common.IMoney|null|undefined} maintenanceFee
             * @memberof coreproductpb.FeatureAttributes.MaintenanceServiceAttributes
             * @instance
             */
            MaintenanceServiceAttributes.prototype.maintenanceFee = null;

            /**
             * MaintenanceServiceAttributes listingCoverageBeneficiary.
             * @member {string} listingCoverageBeneficiary
             * @memberof coreproductpb.FeatureAttributes.MaintenanceServiceAttributes
             * @instance
             */
            MaintenanceServiceAttributes.prototype.listingCoverageBeneficiary = "";

            /**
             * MaintenanceServiceAttributes aggregateRepairAmount.
             * @member {common.IMoney|null|undefined} aggregateRepairAmount
             * @memberof coreproductpb.FeatureAttributes.MaintenanceServiceAttributes
             * @instance
             */
            MaintenanceServiceAttributes.prototype.aggregateRepairAmount = null;

            /**
             * MaintenanceServiceAttributes aggregateCashOutAmount.
             * @member {common.IMoney|null|undefined} aggregateCashOutAmount
             * @memberof coreproductpb.FeatureAttributes.MaintenanceServiceAttributes
             * @instance
             */
            MaintenanceServiceAttributes.prototype.aggregateCashOutAmount = null;

            /**
             * MaintenanceServiceAttributes diagnosisFee.
             * @member {common.IMoney|null|undefined} diagnosisFee
             * @memberof coreproductpb.FeatureAttributes.MaintenanceServiceAttributes
             * @instance
             */
            MaintenanceServiceAttributes.prototype.diagnosisFee = null;

            /**
             * MaintenanceServiceAttributes maxItemRepairAmount.
             * @member {common.IMoney|null|undefined} maxItemRepairAmount
             * @memberof coreproductpb.FeatureAttributes.MaintenanceServiceAttributes
             * @instance
             */
            MaintenanceServiceAttributes.prototype.maxItemRepairAmount = null;

            /**
             * MaintenanceServiceAttributes maxCashOutAmount.
             * @member {common.IMoney|null|undefined} maxCashOutAmount
             * @memberof coreproductpb.FeatureAttributes.MaintenanceServiceAttributes
             * @instance
             */
            MaintenanceServiceAttributes.prototype.maxCashOutAmount = null;

            /**
             * MaintenanceServiceAttributes maxItemFreeServiceCount.
             * @member {number} maxItemFreeServiceCount
             * @memberof coreproductpb.FeatureAttributes.MaintenanceServiceAttributes
             * @instance
             */
            MaintenanceServiceAttributes.prototype.maxItemFreeServiceCount = 0;

            /**
             * MaintenanceServiceAttributes maxItemServiceCount.
             * @member {number} maxItemServiceCount
             * @memberof coreproductpb.FeatureAttributes.MaintenanceServiceAttributes
             * @instance
             */
            MaintenanceServiceAttributes.prototype.maxItemServiceCount = 0;

            /**
             * Creates a new MaintenanceServiceAttributes instance using the specified properties.
             * @function create
             * @memberof coreproductpb.FeatureAttributes.MaintenanceServiceAttributes
             * @static
             * @param {coreproductpb.FeatureAttributes.IMaintenanceServiceAttributes=} [properties] Properties to set
             * @returns {coreproductpb.FeatureAttributes.MaintenanceServiceAttributes} MaintenanceServiceAttributes instance
             */
            MaintenanceServiceAttributes.create = function create(properties) {
                return new MaintenanceServiceAttributes(properties);
            };

            /**
             * Encodes the specified MaintenanceServiceAttributes message. Does not implicitly {@link coreproductpb.FeatureAttributes.MaintenanceServiceAttributes.verify|verify} messages.
             * @function encode
             * @memberof coreproductpb.FeatureAttributes.MaintenanceServiceAttributes
             * @static
             * @param {coreproductpb.FeatureAttributes.IMaintenanceServiceAttributes} m MaintenanceServiceAttributes message or plain object to encode
             * @param {$protobuf.Writer} [w] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            MaintenanceServiceAttributes.encode = function encode(m, w) {
                if (!w)
                    w = $Writer.create();
                if (m.styleID != null && Object.hasOwnProperty.call(m, "styleID"))
                    w.uint32(10).string(m.styleID);
                if (m.tradeID != null && Object.hasOwnProperty.call(m, "tradeID"))
                    w.uint32(18).string(m.tradeID);
                if (m.tradeCode != null && Object.hasOwnProperty.call(m, "tradeCode"))
                    w.uint32(26).string(m.tradeCode);
                if (m.starItemID != null && Object.hasOwnProperty.call(m, "starItemID"))
                    w.uint32(34).string(m.starItemID);
                if (m.starTradeCode != null && Object.hasOwnProperty.call(m, "starTradeCode"))
                    w.uint32(42).string(m.starTradeCode);
                if (m.maintenanceFee != null && Object.hasOwnProperty.call(m, "maintenanceFee"))
                    $root.common.Money.encode(m.maintenanceFee, w.uint32(50).fork()).ldelim();
                if (m.listingCoverageBeneficiary != null && Object.hasOwnProperty.call(m, "listingCoverageBeneficiary"))
                    w.uint32(58).string(m.listingCoverageBeneficiary);
                if (m.aggregateRepairAmount != null && Object.hasOwnProperty.call(m, "aggregateRepairAmount"))
                    $root.common.Money.encode(m.aggregateRepairAmount, w.uint32(66).fork()).ldelim();
                if (m.aggregateCashOutAmount != null && Object.hasOwnProperty.call(m, "aggregateCashOutAmount"))
                    $root.common.Money.encode(m.aggregateCashOutAmount, w.uint32(74).fork()).ldelim();
                if (m.diagnosisFee != null && Object.hasOwnProperty.call(m, "diagnosisFee"))
                    $root.common.Money.encode(m.diagnosisFee, w.uint32(82).fork()).ldelim();
                if (m.maxItemRepairAmount != null && Object.hasOwnProperty.call(m, "maxItemRepairAmount"))
                    $root.common.Money.encode(m.maxItemRepairAmount, w.uint32(90).fork()).ldelim();
                if (m.maxCashOutAmount != null && Object.hasOwnProperty.call(m, "maxCashOutAmount"))
                    $root.common.Money.encode(m.maxCashOutAmount, w.uint32(98).fork()).ldelim();
                if (m.maxItemFreeServiceCount != null && Object.hasOwnProperty.call(m, "maxItemFreeServiceCount"))
                    w.uint32(104).int32(m.maxItemFreeServiceCount);
                if (m.maxItemServiceCount != null && Object.hasOwnProperty.call(m, "maxItemServiceCount"))
                    w.uint32(112).int32(m.maxItemServiceCount);
                return w;
            };

            /**
             * Decodes a MaintenanceServiceAttributes message from the specified reader or buffer.
             * @function decode
             * @memberof coreproductpb.FeatureAttributes.MaintenanceServiceAttributes
             * @static
             * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
             * @param {number} [l] Message length if known beforehand
             * @returns {coreproductpb.FeatureAttributes.MaintenanceServiceAttributes} MaintenanceServiceAttributes
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            MaintenanceServiceAttributes.decode = function decode(r, l) {
                if (!(r instanceof $Reader))
                    r = $Reader.create(r);
                var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.FeatureAttributes.MaintenanceServiceAttributes();
                while (r.pos < c) {
                    var t = r.uint32();
                    switch (t >>> 3) {
                    case 1:
                        m.styleID = r.string();
                        break;
                    case 2:
                        m.tradeID = r.string();
                        break;
                    case 3:
                        m.tradeCode = r.string();
                        break;
                    case 4:
                        m.starItemID = r.string();
                        break;
                    case 5:
                        m.starTradeCode = r.string();
                        break;
                    case 6:
                        m.maintenanceFee = $root.common.Money.decode(r, r.uint32());
                        break;
                    case 7:
                        m.listingCoverageBeneficiary = r.string();
                        break;
                    case 8:
                        m.aggregateRepairAmount = $root.common.Money.decode(r, r.uint32());
                        break;
                    case 9:
                        m.aggregateCashOutAmount = $root.common.Money.decode(r, r.uint32());
                        break;
                    case 10:
                        m.diagnosisFee = $root.common.Money.decode(r, r.uint32());
                        break;
                    case 11:
                        m.maxItemRepairAmount = $root.common.Money.decode(r, r.uint32());
                        break;
                    case 12:
                        m.maxCashOutAmount = $root.common.Money.decode(r, r.uint32());
                        break;
                    case 13:
                        m.maxItemFreeServiceCount = r.int32();
                        break;
                    case 14:
                        m.maxItemServiceCount = r.int32();
                        break;
                    default:
                        r.skipType(t & 7);
                        break;
                    }
                }
                return m;
            };

            return MaintenanceServiceAttributes;
        })();

        FeatureAttributes.FeatureCoverageAttributes = (function() {

            /**
             * Properties of a FeatureCoverageAttributes.
             * @memberof coreproductpb.FeatureAttributes
             * @interface IFeatureCoverageAttributes
             * @property {string|null} [description] FeatureCoverageAttributes description
             * @property {string|null} [starCoverageID] FeatureCoverageAttributes starCoverageID
             * @property {common.IMoney|null} [fee] FeatureCoverageAttributes fee
             * @property {number|null} [maxCount] FeatureCoverageAttributes maxCount
             * @property {Array.<string>|null} [tags] FeatureCoverageAttributes tags
             * @property {common.IMoney|null} [aggregateRepairAmount] FeatureCoverageAttributes aggregateRepairAmount
             * @property {common.IMoney|null} [aggregateCashoutAmount] FeatureCoverageAttributes aggregateCashoutAmount
             * @property {common.IMoney|null} [diagnosisFee] FeatureCoverageAttributes diagnosisFee
             * @property {common.IMoney|null} [maxItemRepairAmount] FeatureCoverageAttributes maxItemRepairAmount
             * @property {common.IMoney|null} [maxCashOutAmount] FeatureCoverageAttributes maxCashOutAmount
             * @property {common.IMoney|null} [maintenanceFee] FeatureCoverageAttributes maintenanceFee
             * @property {string|null} [listingCoverageBeneficiary] FeatureCoverageAttributes listingCoverageBeneficiary
             * @property {number|null} [maxFreeServiceCount] FeatureCoverageAttributes maxFreeServiceCount
             * @property {google.protobuf.ITimestamp|null} [expirationDate] FeatureCoverageAttributes expirationDate
             */

            /**
             * Constructs a new FeatureCoverageAttributes.
             * @memberof coreproductpb.FeatureAttributes
             * @classdesc Represents a FeatureCoverageAttributes.
             * @implements IFeatureCoverageAttributes
             * @constructor
             * @param {coreproductpb.FeatureAttributes.IFeatureCoverageAttributes=} [p] Properties to set
             */
            function FeatureCoverageAttributes(p) {
                this.tags = [];
                if (p)
                    for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                        if (p[ks[i]] != null)
                            this[ks[i]] = p[ks[i]];
            }

            /**
             * FeatureCoverageAttributes description.
             * @member {string} description
             * @memberof coreproductpb.FeatureAttributes.FeatureCoverageAttributes
             * @instance
             */
            FeatureCoverageAttributes.prototype.description = "";

            /**
             * FeatureCoverageAttributes starCoverageID.
             * @member {string} starCoverageID
             * @memberof coreproductpb.FeatureAttributes.FeatureCoverageAttributes
             * @instance
             */
            FeatureCoverageAttributes.prototype.starCoverageID = "";

            /**
             * FeatureCoverageAttributes fee.
             * @member {common.IMoney|null|undefined} fee
             * @memberof coreproductpb.FeatureAttributes.FeatureCoverageAttributes
             * @instance
             */
            FeatureCoverageAttributes.prototype.fee = null;

            /**
             * FeatureCoverageAttributes maxCount.
             * @member {number} maxCount
             * @memberof coreproductpb.FeatureAttributes.FeatureCoverageAttributes
             * @instance
             */
            FeatureCoverageAttributes.prototype.maxCount = 0;

            /**
             * FeatureCoverageAttributes tags.
             * @member {Array.<string>} tags
             * @memberof coreproductpb.FeatureAttributes.FeatureCoverageAttributes
             * @instance
             */
            FeatureCoverageAttributes.prototype.tags = $util.emptyArray;

            /**
             * FeatureCoverageAttributes aggregateRepairAmount.
             * @member {common.IMoney|null|undefined} aggregateRepairAmount
             * @memberof coreproductpb.FeatureAttributes.FeatureCoverageAttributes
             * @instance
             */
            FeatureCoverageAttributes.prototype.aggregateRepairAmount = null;

            /**
             * FeatureCoverageAttributes aggregateCashoutAmount.
             * @member {common.IMoney|null|undefined} aggregateCashoutAmount
             * @memberof coreproductpb.FeatureAttributes.FeatureCoverageAttributes
             * @instance
             */
            FeatureCoverageAttributes.prototype.aggregateCashoutAmount = null;

            /**
             * FeatureCoverageAttributes diagnosisFee.
             * @member {common.IMoney|null|undefined} diagnosisFee
             * @memberof coreproductpb.FeatureAttributes.FeatureCoverageAttributes
             * @instance
             */
            FeatureCoverageAttributes.prototype.diagnosisFee = null;

            /**
             * FeatureCoverageAttributes maxItemRepairAmount.
             * @member {common.IMoney|null|undefined} maxItemRepairAmount
             * @memberof coreproductpb.FeatureAttributes.FeatureCoverageAttributes
             * @instance
             */
            FeatureCoverageAttributes.prototype.maxItemRepairAmount = null;

            /**
             * FeatureCoverageAttributes maxCashOutAmount.
             * @member {common.IMoney|null|undefined} maxCashOutAmount
             * @memberof coreproductpb.FeatureAttributes.FeatureCoverageAttributes
             * @instance
             */
            FeatureCoverageAttributes.prototype.maxCashOutAmount = null;

            /**
             * FeatureCoverageAttributes maintenanceFee.
             * @member {common.IMoney|null|undefined} maintenanceFee
             * @memberof coreproductpb.FeatureAttributes.FeatureCoverageAttributes
             * @instance
             */
            FeatureCoverageAttributes.prototype.maintenanceFee = null;

            /**
             * FeatureCoverageAttributes listingCoverageBeneficiary.
             * @member {string} listingCoverageBeneficiary
             * @memberof coreproductpb.FeatureAttributes.FeatureCoverageAttributes
             * @instance
             */
            FeatureCoverageAttributes.prototype.listingCoverageBeneficiary = "";

            /**
             * FeatureCoverageAttributes maxFreeServiceCount.
             * @member {number} maxFreeServiceCount
             * @memberof coreproductpb.FeatureAttributes.FeatureCoverageAttributes
             * @instance
             */
            FeatureCoverageAttributes.prototype.maxFreeServiceCount = 0;

            /**
             * FeatureCoverageAttributes expirationDate.
             * @member {google.protobuf.ITimestamp|null|undefined} expirationDate
             * @memberof coreproductpb.FeatureAttributes.FeatureCoverageAttributes
             * @instance
             */
            FeatureCoverageAttributes.prototype.expirationDate = null;

            /**
             * Creates a new FeatureCoverageAttributes instance using the specified properties.
             * @function create
             * @memberof coreproductpb.FeatureAttributes.FeatureCoverageAttributes
             * @static
             * @param {coreproductpb.FeatureAttributes.IFeatureCoverageAttributes=} [properties] Properties to set
             * @returns {coreproductpb.FeatureAttributes.FeatureCoverageAttributes} FeatureCoverageAttributes instance
             */
            FeatureCoverageAttributes.create = function create(properties) {
                return new FeatureCoverageAttributes(properties);
            };

            /**
             * Encodes the specified FeatureCoverageAttributes message. Does not implicitly {@link coreproductpb.FeatureAttributes.FeatureCoverageAttributes.verify|verify} messages.
             * @function encode
             * @memberof coreproductpb.FeatureAttributes.FeatureCoverageAttributes
             * @static
             * @param {coreproductpb.FeatureAttributes.IFeatureCoverageAttributes} m FeatureCoverageAttributes message or plain object to encode
             * @param {$protobuf.Writer} [w] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            FeatureCoverageAttributes.encode = function encode(m, w) {
                if (!w)
                    w = $Writer.create();
                if (m.description != null && Object.hasOwnProperty.call(m, "description"))
                    w.uint32(10).string(m.description);
                if (m.starCoverageID != null && Object.hasOwnProperty.call(m, "starCoverageID"))
                    w.uint32(18).string(m.starCoverageID);
                if (m.fee != null && Object.hasOwnProperty.call(m, "fee"))
                    $root.common.Money.encode(m.fee, w.uint32(26).fork()).ldelim();
                if (m.maxCount != null && Object.hasOwnProperty.call(m, "maxCount"))
                    w.uint32(32).int32(m.maxCount);
                if (m.tags != null && m.tags.length) {
                    for (var i = 0; i < m.tags.length; ++i)
                        w.uint32(42).string(m.tags[i]);
                }
                if (m.aggregateRepairAmount != null && Object.hasOwnProperty.call(m, "aggregateRepairAmount"))
                    $root.common.Money.encode(m.aggregateRepairAmount, w.uint32(50).fork()).ldelim();
                if (m.aggregateCashoutAmount != null && Object.hasOwnProperty.call(m, "aggregateCashoutAmount"))
                    $root.common.Money.encode(m.aggregateCashoutAmount, w.uint32(58).fork()).ldelim();
                if (m.diagnosisFee != null && Object.hasOwnProperty.call(m, "diagnosisFee"))
                    $root.common.Money.encode(m.diagnosisFee, w.uint32(66).fork()).ldelim();
                if (m.maxItemRepairAmount != null && Object.hasOwnProperty.call(m, "maxItemRepairAmount"))
                    $root.common.Money.encode(m.maxItemRepairAmount, w.uint32(74).fork()).ldelim();
                if (m.maxCashOutAmount != null && Object.hasOwnProperty.call(m, "maxCashOutAmount"))
                    $root.common.Money.encode(m.maxCashOutAmount, w.uint32(82).fork()).ldelim();
                if (m.maintenanceFee != null && Object.hasOwnProperty.call(m, "maintenanceFee"))
                    $root.common.Money.encode(m.maintenanceFee, w.uint32(90).fork()).ldelim();
                if (m.listingCoverageBeneficiary != null && Object.hasOwnProperty.call(m, "listingCoverageBeneficiary"))
                    w.uint32(98).string(m.listingCoverageBeneficiary);
                if (m.maxFreeServiceCount != null && Object.hasOwnProperty.call(m, "maxFreeServiceCount"))
                    w.uint32(104).int32(m.maxFreeServiceCount);
                if (m.expirationDate != null && Object.hasOwnProperty.call(m, "expirationDate"))
                    $root.google.protobuf.Timestamp.encode(m.expirationDate, w.uint32(114).fork()).ldelim();
                return w;
            };

            /**
             * Decodes a FeatureCoverageAttributes message from the specified reader or buffer.
             * @function decode
             * @memberof coreproductpb.FeatureAttributes.FeatureCoverageAttributes
             * @static
             * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
             * @param {number} [l] Message length if known beforehand
             * @returns {coreproductpb.FeatureAttributes.FeatureCoverageAttributes} FeatureCoverageAttributes
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            FeatureCoverageAttributes.decode = function decode(r, l) {
                if (!(r instanceof $Reader))
                    r = $Reader.create(r);
                var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.FeatureAttributes.FeatureCoverageAttributes();
                while (r.pos < c) {
                    var t = r.uint32();
                    switch (t >>> 3) {
                    case 1:
                        m.description = r.string();
                        break;
                    case 2:
                        m.starCoverageID = r.string();
                        break;
                    case 3:
                        m.fee = $root.common.Money.decode(r, r.uint32());
                        break;
                    case 4:
                        m.maxCount = r.int32();
                        break;
                    case 5:
                        if (!(m.tags && m.tags.length))
                            m.tags = [];
                        m.tags.push(r.string());
                        break;
                    case 6:
                        m.aggregateRepairAmount = $root.common.Money.decode(r, r.uint32());
                        break;
                    case 7:
                        m.aggregateCashoutAmount = $root.common.Money.decode(r, r.uint32());
                        break;
                    case 8:
                        m.diagnosisFee = $root.common.Money.decode(r, r.uint32());
                        break;
                    case 9:
                        m.maxItemRepairAmount = $root.common.Money.decode(r, r.uint32());
                        break;
                    case 10:
                        m.maxCashOutAmount = $root.common.Money.decode(r, r.uint32());
                        break;
                    case 11:
                        m.maintenanceFee = $root.common.Money.decode(r, r.uint32());
                        break;
                    case 12:
                        m.listingCoverageBeneficiary = r.string();
                        break;
                    case 13:
                        m.maxFreeServiceCount = r.int32();
                        break;
                    case 14:
                        m.expirationDate = $root.google.protobuf.Timestamp.decode(r, r.uint32());
                        break;
                    default:
                        r.skipType(t & 7);
                        break;
                    }
                }
                return m;
            };

            return FeatureCoverageAttributes;
        })();

        return FeatureAttributes;
    })();

    coreproductpb.AddOnFeatures = (function() {

        /**
         * Properties of an AddOnFeatures.
         * @memberof coreproductpb
         * @interface IAddOnFeatures
         * @property {Array.<coreproductpb.IFeature>|null} [options] AddOnFeatures options
         * @property {Array.<coreproductpb.IPickRule>|null} [pickRules] AddOnFeatures pickRules
         */

        /**
         * Constructs a new AddOnFeatures.
         * @memberof coreproductpb
         * @classdesc Represents an AddOnFeatures.
         * @implements IAddOnFeatures
         * @constructor
         * @param {coreproductpb.IAddOnFeatures=} [p] Properties to set
         */
        function AddOnFeatures(p) {
            this.options = [];
            this.pickRules = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * AddOnFeatures options.
         * @member {Array.<coreproductpb.IFeature>} options
         * @memberof coreproductpb.AddOnFeatures
         * @instance
         */
        AddOnFeatures.prototype.options = $util.emptyArray;

        /**
         * AddOnFeatures pickRules.
         * @member {Array.<coreproductpb.IPickRule>} pickRules
         * @memberof coreproductpb.AddOnFeatures
         * @instance
         */
        AddOnFeatures.prototype.pickRules = $util.emptyArray;

        /**
         * Creates a new AddOnFeatures instance using the specified properties.
         * @function create
         * @memberof coreproductpb.AddOnFeatures
         * @static
         * @param {coreproductpb.IAddOnFeatures=} [properties] Properties to set
         * @returns {coreproductpb.AddOnFeatures} AddOnFeatures instance
         */
        AddOnFeatures.create = function create(properties) {
            return new AddOnFeatures(properties);
        };

        /**
         * Encodes the specified AddOnFeatures message. Does not implicitly {@link coreproductpb.AddOnFeatures.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.AddOnFeatures
         * @static
         * @param {coreproductpb.IAddOnFeatures} m AddOnFeatures message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AddOnFeatures.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.options != null && m.options.length) {
                for (var i = 0; i < m.options.length; ++i)
                    $root.coreproductpb.Feature.encode(m.options[i], w.uint32(10).fork()).ldelim();
            }
            if (m.pickRules != null && m.pickRules.length) {
                for (var i = 0; i < m.pickRules.length; ++i)
                    $root.coreproductpb.PickRule.encode(m.pickRules[i], w.uint32(18).fork()).ldelim();
            }
            return w;
        };

        /**
         * Decodes an AddOnFeatures message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.AddOnFeatures
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.AddOnFeatures} AddOnFeatures
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AddOnFeatures.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.AddOnFeatures();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    if (!(m.options && m.options.length))
                        m.options = [];
                    m.options.push($root.coreproductpb.Feature.decode(r, r.uint32()));
                    break;
                case 2:
                    if (!(m.pickRules && m.pickRules.length))
                        m.pickRules = [];
                    m.pickRules.push($root.coreproductpb.PickRule.decode(r, r.uint32()));
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return AddOnFeatures;
    })();

    coreproductpb.FeatureBundle = (function() {

        /**
         * Properties of a FeatureBundle.
         * @memberof coreproductpb
         * @interface IFeatureBundle
         * @property {string|null} [bundleID] FeatureBundle bundleID
         * @property {string|null} [name] FeatureBundle name
         * @property {Array.<coreproductpb.IFeature>|null} [baseFeatures] FeatureBundle baseFeatures
         * @property {coreproductpb.IAddOnFeatures|null} [addOnFeatures] FeatureBundle addOnFeatures
         * @property {coreproductpb.FeatureBundle.IFeatureBundleAttributes|null} [attributes] FeatureBundle attributes
         */

        /**
         * Constructs a new FeatureBundle.
         * @memberof coreproductpb
         * @classdesc Represents a FeatureBundle.
         * @implements IFeatureBundle
         * @constructor
         * @param {coreproductpb.IFeatureBundle=} [p] Properties to set
         */
        function FeatureBundle(p) {
            this.baseFeatures = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * FeatureBundle bundleID.
         * @member {string} bundleID
         * @memberof coreproductpb.FeatureBundle
         * @instance
         */
        FeatureBundle.prototype.bundleID = "";

        /**
         * FeatureBundle name.
         * @member {string} name
         * @memberof coreproductpb.FeatureBundle
         * @instance
         */
        FeatureBundle.prototype.name = "";

        /**
         * FeatureBundle baseFeatures.
         * @member {Array.<coreproductpb.IFeature>} baseFeatures
         * @memberof coreproductpb.FeatureBundle
         * @instance
         */
        FeatureBundle.prototype.baseFeatures = $util.emptyArray;

        /**
         * FeatureBundle addOnFeatures.
         * @member {coreproductpb.IAddOnFeatures|null|undefined} addOnFeatures
         * @memberof coreproductpb.FeatureBundle
         * @instance
         */
        FeatureBundle.prototype.addOnFeatures = null;

        /**
         * FeatureBundle attributes.
         * @member {coreproductpb.FeatureBundle.IFeatureBundleAttributes|null|undefined} attributes
         * @memberof coreproductpb.FeatureBundle
         * @instance
         */
        FeatureBundle.prototype.attributes = null;

        /**
         * Creates a new FeatureBundle instance using the specified properties.
         * @function create
         * @memberof coreproductpb.FeatureBundle
         * @static
         * @param {coreproductpb.IFeatureBundle=} [properties] Properties to set
         * @returns {coreproductpb.FeatureBundle} FeatureBundle instance
         */
        FeatureBundle.create = function create(properties) {
            return new FeatureBundle(properties);
        };

        /**
         * Encodes the specified FeatureBundle message. Does not implicitly {@link coreproductpb.FeatureBundle.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.FeatureBundle
         * @static
         * @param {coreproductpb.IFeatureBundle} m FeatureBundle message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        FeatureBundle.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.bundleID != null && Object.hasOwnProperty.call(m, "bundleID"))
                w.uint32(10).string(m.bundleID);
            if (m.name != null && Object.hasOwnProperty.call(m, "name"))
                w.uint32(18).string(m.name);
            if (m.baseFeatures != null && m.baseFeatures.length) {
                for (var i = 0; i < m.baseFeatures.length; ++i)
                    $root.coreproductpb.Feature.encode(m.baseFeatures[i], w.uint32(26).fork()).ldelim();
            }
            if (m.addOnFeatures != null && Object.hasOwnProperty.call(m, "addOnFeatures"))
                $root.coreproductpb.AddOnFeatures.encode(m.addOnFeatures, w.uint32(34).fork()).ldelim();
            if (m.attributes != null && Object.hasOwnProperty.call(m, "attributes"))
                $root.coreproductpb.FeatureBundle.FeatureBundleAttributes.encode(m.attributes, w.uint32(42).fork()).ldelim();
            return w;
        };

        /**
         * Decodes a FeatureBundle message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.FeatureBundle
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.FeatureBundle} FeatureBundle
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        FeatureBundle.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.FeatureBundle();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.bundleID = r.string();
                    break;
                case 2:
                    m.name = r.string();
                    break;
                case 3:
                    if (!(m.baseFeatures && m.baseFeatures.length))
                        m.baseFeatures = [];
                    m.baseFeatures.push($root.coreproductpb.Feature.decode(r, r.uint32()));
                    break;
                case 4:
                    m.addOnFeatures = $root.coreproductpb.AddOnFeatures.decode(r, r.uint32());
                    break;
                case 5:
                    m.attributes = $root.coreproductpb.FeatureBundle.FeatureBundleAttributes.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        FeatureBundle.FeatureBundleAttributes = (function() {

            /**
             * Properties of a FeatureBundleAttributes.
             * @memberof coreproductpb.FeatureBundle
             * @interface IFeatureBundleAttributes
             * @property {string|null} [starCoverageGroupID] FeatureBundleAttributes starCoverageGroupID
             * @property {coreproductpb.IPickAttributes|null} [pickAttributes] FeatureBundleAttributes pickAttributes
             */

            /**
             * Constructs a new FeatureBundleAttributes.
             * @memberof coreproductpb.FeatureBundle
             * @classdesc Represents a FeatureBundleAttributes.
             * @implements IFeatureBundleAttributes
             * @constructor
             * @param {coreproductpb.FeatureBundle.IFeatureBundleAttributes=} [p] Properties to set
             */
            function FeatureBundleAttributes(p) {
                if (p)
                    for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                        if (p[ks[i]] != null)
                            this[ks[i]] = p[ks[i]];
            }

            /**
             * FeatureBundleAttributes starCoverageGroupID.
             * @member {string} starCoverageGroupID
             * @memberof coreproductpb.FeatureBundle.FeatureBundleAttributes
             * @instance
             */
            FeatureBundleAttributes.prototype.starCoverageGroupID = "";

            /**
             * FeatureBundleAttributes pickAttributes.
             * @member {coreproductpb.IPickAttributes|null|undefined} pickAttributes
             * @memberof coreproductpb.FeatureBundle.FeatureBundleAttributes
             * @instance
             */
            FeatureBundleAttributes.prototype.pickAttributes = null;

            /**
             * Creates a new FeatureBundleAttributes instance using the specified properties.
             * @function create
             * @memberof coreproductpb.FeatureBundle.FeatureBundleAttributes
             * @static
             * @param {coreproductpb.FeatureBundle.IFeatureBundleAttributes=} [properties] Properties to set
             * @returns {coreproductpb.FeatureBundle.FeatureBundleAttributes} FeatureBundleAttributes instance
             */
            FeatureBundleAttributes.create = function create(properties) {
                return new FeatureBundleAttributes(properties);
            };

            /**
             * Encodes the specified FeatureBundleAttributes message. Does not implicitly {@link coreproductpb.FeatureBundle.FeatureBundleAttributes.verify|verify} messages.
             * @function encode
             * @memberof coreproductpb.FeatureBundle.FeatureBundleAttributes
             * @static
             * @param {coreproductpb.FeatureBundle.IFeatureBundleAttributes} m FeatureBundleAttributes message or plain object to encode
             * @param {$protobuf.Writer} [w] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            FeatureBundleAttributes.encode = function encode(m, w) {
                if (!w)
                    w = $Writer.create();
                if (m.starCoverageGroupID != null && Object.hasOwnProperty.call(m, "starCoverageGroupID"))
                    w.uint32(10).string(m.starCoverageGroupID);
                if (m.pickAttributes != null && Object.hasOwnProperty.call(m, "pickAttributes"))
                    $root.coreproductpb.PickAttributes.encode(m.pickAttributes, w.uint32(18).fork()).ldelim();
                return w;
            };

            /**
             * Decodes a FeatureBundleAttributes message from the specified reader or buffer.
             * @function decode
             * @memberof coreproductpb.FeatureBundle.FeatureBundleAttributes
             * @static
             * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
             * @param {number} [l] Message length if known beforehand
             * @returns {coreproductpb.FeatureBundle.FeatureBundleAttributes} FeatureBundleAttributes
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            FeatureBundleAttributes.decode = function decode(r, l) {
                if (!(r instanceof $Reader))
                    r = $Reader.create(r);
                var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.FeatureBundle.FeatureBundleAttributes();
                while (r.pos < c) {
                    var t = r.uint32();
                    switch (t >>> 3) {
                    case 1:
                        m.starCoverageGroupID = r.string();
                        break;
                    case 2:
                        m.pickAttributes = $root.coreproductpb.PickAttributes.decode(r, r.uint32());
                        break;
                    default:
                        r.skipType(t & 7);
                        break;
                    }
                }
                return m;
            };

            return FeatureBundleAttributes;
        })();

        return FeatureBundle;
    })();

    coreproductpb.AddOnFeatureBundles = (function() {

        /**
         * Properties of an AddOnFeatureBundles.
         * @memberof coreproductpb
         * @interface IAddOnFeatureBundles
         * @property {Array.<coreproductpb.IFeatureBundle>|null} [options] AddOnFeatureBundles options
         * @property {Array.<coreproductpb.IPickRule>|null} [pickRules] AddOnFeatureBundles pickRules
         */

        /**
         * Constructs a new AddOnFeatureBundles.
         * @memberof coreproductpb
         * @classdesc Represents an AddOnFeatureBundles.
         * @implements IAddOnFeatureBundles
         * @constructor
         * @param {coreproductpb.IAddOnFeatureBundles=} [p] Properties to set
         */
        function AddOnFeatureBundles(p) {
            this.options = [];
            this.pickRules = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * AddOnFeatureBundles options.
         * @member {Array.<coreproductpb.IFeatureBundle>} options
         * @memberof coreproductpb.AddOnFeatureBundles
         * @instance
         */
        AddOnFeatureBundles.prototype.options = $util.emptyArray;

        /**
         * AddOnFeatureBundles pickRules.
         * @member {Array.<coreproductpb.IPickRule>} pickRules
         * @memberof coreproductpb.AddOnFeatureBundles
         * @instance
         */
        AddOnFeatureBundles.prototype.pickRules = $util.emptyArray;

        /**
         * Creates a new AddOnFeatureBundles instance using the specified properties.
         * @function create
         * @memberof coreproductpb.AddOnFeatureBundles
         * @static
         * @param {coreproductpb.IAddOnFeatureBundles=} [properties] Properties to set
         * @returns {coreproductpb.AddOnFeatureBundles} AddOnFeatureBundles instance
         */
        AddOnFeatureBundles.create = function create(properties) {
            return new AddOnFeatureBundles(properties);
        };

        /**
         * Encodes the specified AddOnFeatureBundles message. Does not implicitly {@link coreproductpb.AddOnFeatureBundles.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.AddOnFeatureBundles
         * @static
         * @param {coreproductpb.IAddOnFeatureBundles} m AddOnFeatureBundles message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AddOnFeatureBundles.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.options != null && m.options.length) {
                for (var i = 0; i < m.options.length; ++i)
                    $root.coreproductpb.FeatureBundle.encode(m.options[i], w.uint32(10).fork()).ldelim();
            }
            if (m.pickRules != null && m.pickRules.length) {
                for (var i = 0; i < m.pickRules.length; ++i)
                    $root.coreproductpb.PickRule.encode(m.pickRules[i], w.uint32(18).fork()).ldelim();
            }
            return w;
        };

        /**
         * Decodes an AddOnFeatureBundles message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.AddOnFeatureBundles
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.AddOnFeatureBundles} AddOnFeatureBundles
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AddOnFeatureBundles.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.AddOnFeatureBundles();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    if (!(m.options && m.options.length))
                        m.options = [];
                    m.options.push($root.coreproductpb.FeatureBundle.decode(r, r.uint32()));
                    break;
                case 2:
                    if (!(m.pickRules && m.pickRules.length))
                        m.pickRules = [];
                    m.pickRules.push($root.coreproductpb.PickRule.decode(r, r.uint32()));
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return AddOnFeatureBundles;
    })();

    coreproductpb.ProductFeatures = (function() {

        /**
         * Properties of a ProductFeatures.
         * @memberof coreproductpb
         * @interface IProductFeatures
         * @property {Array.<coreproductpb.IFeature>|null} [baseFeatures] ProductFeatures baseFeatures
         * @property {coreproductpb.IAddOnFeatures|null} [addOnFeatures] ProductFeatures addOnFeatures
         * @property {Array.<coreproductpb.IFeatureBundle>|null} [baseFeatureBundles] ProductFeatures baseFeatureBundles
         * @property {coreproductpb.IAddOnFeatureBundles|null} [addOnFeatureBundles] ProductFeatures addOnFeatureBundles
         */

        /**
         * Constructs a new ProductFeatures.
         * @memberof coreproductpb
         * @classdesc Represents a ProductFeatures.
         * @implements IProductFeatures
         * @constructor
         * @param {coreproductpb.IProductFeatures=} [p] Properties to set
         */
        function ProductFeatures(p) {
            this.baseFeatures = [];
            this.baseFeatureBundles = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * ProductFeatures baseFeatures.
         * @member {Array.<coreproductpb.IFeature>} baseFeatures
         * @memberof coreproductpb.ProductFeatures
         * @instance
         */
        ProductFeatures.prototype.baseFeatures = $util.emptyArray;

        /**
         * ProductFeatures addOnFeatures.
         * @member {coreproductpb.IAddOnFeatures|null|undefined} addOnFeatures
         * @memberof coreproductpb.ProductFeatures
         * @instance
         */
        ProductFeatures.prototype.addOnFeatures = null;

        /**
         * ProductFeatures baseFeatureBundles.
         * @member {Array.<coreproductpb.IFeatureBundle>} baseFeatureBundles
         * @memberof coreproductpb.ProductFeatures
         * @instance
         */
        ProductFeatures.prototype.baseFeatureBundles = $util.emptyArray;

        /**
         * ProductFeatures addOnFeatureBundles.
         * @member {coreproductpb.IAddOnFeatureBundles|null|undefined} addOnFeatureBundles
         * @memberof coreproductpb.ProductFeatures
         * @instance
         */
        ProductFeatures.prototype.addOnFeatureBundles = null;

        /**
         * Creates a new ProductFeatures instance using the specified properties.
         * @function create
         * @memberof coreproductpb.ProductFeatures
         * @static
         * @param {coreproductpb.IProductFeatures=} [properties] Properties to set
         * @returns {coreproductpb.ProductFeatures} ProductFeatures instance
         */
        ProductFeatures.create = function create(properties) {
            return new ProductFeatures(properties);
        };

        /**
         * Encodes the specified ProductFeatures message. Does not implicitly {@link coreproductpb.ProductFeatures.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.ProductFeatures
         * @static
         * @param {coreproductpb.IProductFeatures} m ProductFeatures message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ProductFeatures.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.baseFeatures != null && m.baseFeatures.length) {
                for (var i = 0; i < m.baseFeatures.length; ++i)
                    $root.coreproductpb.Feature.encode(m.baseFeatures[i], w.uint32(10).fork()).ldelim();
            }
            if (m.addOnFeatures != null && Object.hasOwnProperty.call(m, "addOnFeatures"))
                $root.coreproductpb.AddOnFeatures.encode(m.addOnFeatures, w.uint32(18).fork()).ldelim();
            if (m.baseFeatureBundles != null && m.baseFeatureBundles.length) {
                for (var i = 0; i < m.baseFeatureBundles.length; ++i)
                    $root.coreproductpb.FeatureBundle.encode(m.baseFeatureBundles[i], w.uint32(26).fork()).ldelim();
            }
            if (m.addOnFeatureBundles != null && Object.hasOwnProperty.call(m, "addOnFeatureBundles"))
                $root.coreproductpb.AddOnFeatureBundles.encode(m.addOnFeatureBundles, w.uint32(34).fork()).ldelim();
            return w;
        };

        /**
         * Decodes a ProductFeatures message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.ProductFeatures
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.ProductFeatures} ProductFeatures
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ProductFeatures.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.ProductFeatures();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    if (!(m.baseFeatures && m.baseFeatures.length))
                        m.baseFeatures = [];
                    m.baseFeatures.push($root.coreproductpb.Feature.decode(r, r.uint32()));
                    break;
                case 2:
                    m.addOnFeatures = $root.coreproductpb.AddOnFeatures.decode(r, r.uint32());
                    break;
                case 3:
                    if (!(m.baseFeatureBundles && m.baseFeatureBundles.length))
                        m.baseFeatureBundles = [];
                    m.baseFeatureBundles.push($root.coreproductpb.FeatureBundle.decode(r, r.uint32()));
                    break;
                case 4:
                    m.addOnFeatureBundles = $root.coreproductpb.AddOnFeatureBundles.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return ProductFeatures;
    })();

    coreproductpb.PickAttributes = (function() {

        /**
         * Properties of a PickAttributes.
         * @memberof coreproductpb
         * @interface IPickAttributes
         * @property {boolean|null} [picked] PickAttributes picked
         * @property {number|null} [quantity] PickAttributes quantity
         * @property {common.IMoney|null} [price] PickAttributes price
         */

        /**
         * Constructs a new PickAttributes.
         * @memberof coreproductpb
         * @classdesc Represents a PickAttributes.
         * @implements IPickAttributes
         * @constructor
         * @param {coreproductpb.IPickAttributes=} [p] Properties to set
         */
        function PickAttributes(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * PickAttributes picked.
         * @member {boolean} picked
         * @memberof coreproductpb.PickAttributes
         * @instance
         */
        PickAttributes.prototype.picked = false;

        /**
         * PickAttributes quantity.
         * @member {number} quantity
         * @memberof coreproductpb.PickAttributes
         * @instance
         */
        PickAttributes.prototype.quantity = 0;

        /**
         * PickAttributes price.
         * @member {common.IMoney|null|undefined} price
         * @memberof coreproductpb.PickAttributes
         * @instance
         */
        PickAttributes.prototype.price = null;

        /**
         * Creates a new PickAttributes instance using the specified properties.
         * @function create
         * @memberof coreproductpb.PickAttributes
         * @static
         * @param {coreproductpb.IPickAttributes=} [properties] Properties to set
         * @returns {coreproductpb.PickAttributes} PickAttributes instance
         */
        PickAttributes.create = function create(properties) {
            return new PickAttributes(properties);
        };

        /**
         * Encodes the specified PickAttributes message. Does not implicitly {@link coreproductpb.PickAttributes.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.PickAttributes
         * @static
         * @param {coreproductpb.IPickAttributes} m PickAttributes message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PickAttributes.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.picked != null && Object.hasOwnProperty.call(m, "picked"))
                w.uint32(8).bool(m.picked);
            if (m.quantity != null && Object.hasOwnProperty.call(m, "quantity"))
                w.uint32(16).uint32(m.quantity);
            if (m.price != null && Object.hasOwnProperty.call(m, "price"))
                $root.common.Money.encode(m.price, w.uint32(26).fork()).ldelim();
            return w;
        };

        /**
         * Decodes a PickAttributes message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.PickAttributes
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.PickAttributes} PickAttributes
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PickAttributes.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.PickAttributes();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.picked = r.bool();
                    break;
                case 2:
                    m.quantity = r.uint32();
                    break;
                case 3:
                    m.price = $root.common.Money.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return PickAttributes;
    })();

    coreproductpb.ProductAvailabilityByLocationRequest = (function() {

        /**
         * Properties of a ProductAvailabilityByLocationRequest.
         * @memberof coreproductpb
         * @interface IProductAvailabilityByLocationRequest
         * @property {string|null} [zipCode] ProductAvailabilityByLocationRequest zipCode
         * @property {string|null} [state] ProductAvailabilityByLocationRequest state
         * @property {google.protobuf.ITimestamp|null} [contractTimestamp] ProductAvailabilityByLocationRequest contractTimestamp
         * @property {string|null} [tenant] ProductAvailabilityByLocationRequest tenant
         * @property {coreproductpb.SalesChannelType|null} [salesChannel] ProductAvailabilityByLocationRequest salesChannel
         * @property {coreproductpb.PurchaseChannel|null} [purchaseChannel] ProductAvailabilityByLocationRequest purchaseChannel
         */

        /**
         * Constructs a new ProductAvailabilityByLocationRequest.
         * @memberof coreproductpb
         * @classdesc Represents a ProductAvailabilityByLocationRequest.
         * @implements IProductAvailabilityByLocationRequest
         * @constructor
         * @param {coreproductpb.IProductAvailabilityByLocationRequest=} [p] Properties to set
         */
        function ProductAvailabilityByLocationRequest(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * ProductAvailabilityByLocationRequest zipCode.
         * @member {string} zipCode
         * @memberof coreproductpb.ProductAvailabilityByLocationRequest
         * @instance
         */
        ProductAvailabilityByLocationRequest.prototype.zipCode = "";

        /**
         * ProductAvailabilityByLocationRequest state.
         * @member {string} state
         * @memberof coreproductpb.ProductAvailabilityByLocationRequest
         * @instance
         */
        ProductAvailabilityByLocationRequest.prototype.state = "";

        /**
         * ProductAvailabilityByLocationRequest contractTimestamp.
         * @member {google.protobuf.ITimestamp|null|undefined} contractTimestamp
         * @memberof coreproductpb.ProductAvailabilityByLocationRequest
         * @instance
         */
        ProductAvailabilityByLocationRequest.prototype.contractTimestamp = null;

        /**
         * ProductAvailabilityByLocationRequest tenant.
         * @member {string} tenant
         * @memberof coreproductpb.ProductAvailabilityByLocationRequest
         * @instance
         */
        ProductAvailabilityByLocationRequest.prototype.tenant = "";

        /**
         * ProductAvailabilityByLocationRequest salesChannel.
         * @member {coreproductpb.SalesChannelType} salesChannel
         * @memberof coreproductpb.ProductAvailabilityByLocationRequest
         * @instance
         */
        ProductAvailabilityByLocationRequest.prototype.salesChannel = 0;

        /**
         * ProductAvailabilityByLocationRequest purchaseChannel.
         * @member {coreproductpb.PurchaseChannel} purchaseChannel
         * @memberof coreproductpb.ProductAvailabilityByLocationRequest
         * @instance
         */
        ProductAvailabilityByLocationRequest.prototype.purchaseChannel = 0;

        /**
         * Creates a new ProductAvailabilityByLocationRequest instance using the specified properties.
         * @function create
         * @memberof coreproductpb.ProductAvailabilityByLocationRequest
         * @static
         * @param {coreproductpb.IProductAvailabilityByLocationRequest=} [properties] Properties to set
         * @returns {coreproductpb.ProductAvailabilityByLocationRequest} ProductAvailabilityByLocationRequest instance
         */
        ProductAvailabilityByLocationRequest.create = function create(properties) {
            return new ProductAvailabilityByLocationRequest(properties);
        };

        /**
         * Encodes the specified ProductAvailabilityByLocationRequest message. Does not implicitly {@link coreproductpb.ProductAvailabilityByLocationRequest.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.ProductAvailabilityByLocationRequest
         * @static
         * @param {coreproductpb.IProductAvailabilityByLocationRequest} m ProductAvailabilityByLocationRequest message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ProductAvailabilityByLocationRequest.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.zipCode != null && Object.hasOwnProperty.call(m, "zipCode"))
                w.uint32(10).string(m.zipCode);
            if (m.state != null && Object.hasOwnProperty.call(m, "state"))
                w.uint32(18).string(m.state);
            if (m.contractTimestamp != null && Object.hasOwnProperty.call(m, "contractTimestamp"))
                $root.google.protobuf.Timestamp.encode(m.contractTimestamp, w.uint32(26).fork()).ldelim();
            if (m.tenant != null && Object.hasOwnProperty.call(m, "tenant"))
                w.uint32(34).string(m.tenant);
            if (m.salesChannel != null && Object.hasOwnProperty.call(m, "salesChannel"))
                w.uint32(40).int32(m.salesChannel);
            if (m.purchaseChannel != null && Object.hasOwnProperty.call(m, "purchaseChannel"))
                w.uint32(48).int32(m.purchaseChannel);
            return w;
        };

        /**
         * Decodes a ProductAvailabilityByLocationRequest message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.ProductAvailabilityByLocationRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.ProductAvailabilityByLocationRequest} ProductAvailabilityByLocationRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ProductAvailabilityByLocationRequest.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.ProductAvailabilityByLocationRequest();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.zipCode = r.string();
                    break;
                case 2:
                    m.state = r.string();
                    break;
                case 3:
                    m.contractTimestamp = $root.google.protobuf.Timestamp.decode(r, r.uint32());
                    break;
                case 4:
                    m.tenant = r.string();
                    break;
                case 5:
                    m.salesChannel = r.int32();
                    break;
                case 6:
                    m.purchaseChannel = r.int32();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return ProductAvailabilityByLocationRequest;
    })();

    coreproductpb.ProductAvailabilityByLocationResponse = (function() {

        /**
         * Properties of a ProductAvailabilityByLocationResponse.
         * @memberof coreproductpb
         * @interface IProductAvailabilityByLocationResponse
         * @property {Object.<string,boolean>|null} [availabilityMappingByState] ProductAvailabilityByLocationResponse availabilityMappingByState
         */

        /**
         * Constructs a new ProductAvailabilityByLocationResponse.
         * @memberof coreproductpb
         * @classdesc Represents a ProductAvailabilityByLocationResponse.
         * @implements IProductAvailabilityByLocationResponse
         * @constructor
         * @param {coreproductpb.IProductAvailabilityByLocationResponse=} [p] Properties to set
         */
        function ProductAvailabilityByLocationResponse(p) {
            this.availabilityMappingByState = {};
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * ProductAvailabilityByLocationResponse availabilityMappingByState.
         * @member {Object.<string,boolean>} availabilityMappingByState
         * @memberof coreproductpb.ProductAvailabilityByLocationResponse
         * @instance
         */
        ProductAvailabilityByLocationResponse.prototype.availabilityMappingByState = $util.emptyObject;

        /**
         * Creates a new ProductAvailabilityByLocationResponse instance using the specified properties.
         * @function create
         * @memberof coreproductpb.ProductAvailabilityByLocationResponse
         * @static
         * @param {coreproductpb.IProductAvailabilityByLocationResponse=} [properties] Properties to set
         * @returns {coreproductpb.ProductAvailabilityByLocationResponse} ProductAvailabilityByLocationResponse instance
         */
        ProductAvailabilityByLocationResponse.create = function create(properties) {
            return new ProductAvailabilityByLocationResponse(properties);
        };

        /**
         * Encodes the specified ProductAvailabilityByLocationResponse message. Does not implicitly {@link coreproductpb.ProductAvailabilityByLocationResponse.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.ProductAvailabilityByLocationResponse
         * @static
         * @param {coreproductpb.IProductAvailabilityByLocationResponse} m ProductAvailabilityByLocationResponse message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ProductAvailabilityByLocationResponse.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.availabilityMappingByState != null && Object.hasOwnProperty.call(m, "availabilityMappingByState")) {
                for (var ks = Object.keys(m.availabilityMappingByState), i = 0; i < ks.length; ++i) {
                    w.uint32(10).fork().uint32(10).string(ks[i]).uint32(16).bool(m.availabilityMappingByState[ks[i]]).ldelim();
                }
            }
            return w;
        };

        /**
         * Decodes a ProductAvailabilityByLocationResponse message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.ProductAvailabilityByLocationResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.ProductAvailabilityByLocationResponse} ProductAvailabilityByLocationResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ProductAvailabilityByLocationResponse.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.ProductAvailabilityByLocationResponse(), k, value;
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    if (m.availabilityMappingByState === $util.emptyObject)
                        m.availabilityMappingByState = {};
                    var c2 = r.uint32() + r.pos;
                    k = "";
                    value = false;
                    while (r.pos < c2) {
                        var tag2 = r.uint32();
                        switch (tag2 >>> 3) {
                        case 1:
                            k = r.string();
                            break;
                        case 2:
                            value = r.bool();
                            break;
                        default:
                            r.skipType(tag2 & 7);
                            break;
                        }
                    }
                    m.availabilityMappingByState[k] = value;
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return ProductAvailabilityByLocationResponse;
    })();

    coreproductpb.ProductAvailabilityRequest = (function() {

        /**
         * Properties of a ProductAvailabilityRequest.
         * @memberof coreproductpb
         * @interface IProductAvailabilityRequest
         * @property {string|null} [officeID] ProductAvailabilityRequest officeID
         * @property {string|null} [franchiseID] ProductAvailabilityRequest franchiseID
         * @property {string|null} [salesSourceId] ProductAvailabilityRequest salesSourceId
         * @property {coreproductpb.CustomerType|null} [customerType] ProductAvailabilityRequest customerType
         * @property {coreproductpb.IProductOptions|null} [productOptions] ProductAvailabilityRequest productOptions
         * @property {coreproductpb.IPropertyFeatures|null} [propertyFeatures] ProductAvailabilityRequest propertyFeatures
         * @property {coreproductpb.IDistributor|null} [distributor] ProductAvailabilityRequest distributor
         */

        /**
         * Constructs a new ProductAvailabilityRequest.
         * @memberof coreproductpb
         * @classdesc Represents a ProductAvailabilityRequest.
         * @implements IProductAvailabilityRequest
         * @constructor
         * @param {coreproductpb.IProductAvailabilityRequest=} [p] Properties to set
         */
        function ProductAvailabilityRequest(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * ProductAvailabilityRequest officeID.
         * @member {string} officeID
         * @memberof coreproductpb.ProductAvailabilityRequest
         * @instance
         */
        ProductAvailabilityRequest.prototype.officeID = "";

        /**
         * ProductAvailabilityRequest franchiseID.
         * @member {string} franchiseID
         * @memberof coreproductpb.ProductAvailabilityRequest
         * @instance
         */
        ProductAvailabilityRequest.prototype.franchiseID = "";

        /**
         * ProductAvailabilityRequest salesSourceId.
         * @member {string} salesSourceId
         * @memberof coreproductpb.ProductAvailabilityRequest
         * @instance
         */
        ProductAvailabilityRequest.prototype.salesSourceId = "";

        /**
         * ProductAvailabilityRequest customerType.
         * @member {coreproductpb.CustomerType} customerType
         * @memberof coreproductpb.ProductAvailabilityRequest
         * @instance
         */
        ProductAvailabilityRequest.prototype.customerType = 0;

        /**
         * ProductAvailabilityRequest productOptions.
         * @member {coreproductpb.IProductOptions|null|undefined} productOptions
         * @memberof coreproductpb.ProductAvailabilityRequest
         * @instance
         */
        ProductAvailabilityRequest.prototype.productOptions = null;

        /**
         * ProductAvailabilityRequest propertyFeatures.
         * @member {coreproductpb.IPropertyFeatures|null|undefined} propertyFeatures
         * @memberof coreproductpb.ProductAvailabilityRequest
         * @instance
         */
        ProductAvailabilityRequest.prototype.propertyFeatures = null;

        /**
         * ProductAvailabilityRequest distributor.
         * @member {coreproductpb.IDistributor|null|undefined} distributor
         * @memberof coreproductpb.ProductAvailabilityRequest
         * @instance
         */
        ProductAvailabilityRequest.prototype.distributor = null;

        /**
         * Creates a new ProductAvailabilityRequest instance using the specified properties.
         * @function create
         * @memberof coreproductpb.ProductAvailabilityRequest
         * @static
         * @param {coreproductpb.IProductAvailabilityRequest=} [properties] Properties to set
         * @returns {coreproductpb.ProductAvailabilityRequest} ProductAvailabilityRequest instance
         */
        ProductAvailabilityRequest.create = function create(properties) {
            return new ProductAvailabilityRequest(properties);
        };

        /**
         * Encodes the specified ProductAvailabilityRequest message. Does not implicitly {@link coreproductpb.ProductAvailabilityRequest.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.ProductAvailabilityRequest
         * @static
         * @param {coreproductpb.IProductAvailabilityRequest} m ProductAvailabilityRequest message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ProductAvailabilityRequest.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.officeID != null && Object.hasOwnProperty.call(m, "officeID"))
                w.uint32(10).string(m.officeID);
            if (m.franchiseID != null && Object.hasOwnProperty.call(m, "franchiseID"))
                w.uint32(18).string(m.franchiseID);
            if (m.salesSourceId != null && Object.hasOwnProperty.call(m, "salesSourceId"))
                w.uint32(26).string(m.salesSourceId);
            if (m.customerType != null && Object.hasOwnProperty.call(m, "customerType"))
                w.uint32(32).int32(m.customerType);
            if (m.productOptions != null && Object.hasOwnProperty.call(m, "productOptions"))
                $root.coreproductpb.ProductOptions.encode(m.productOptions, w.uint32(42).fork()).ldelim();
            if (m.propertyFeatures != null && Object.hasOwnProperty.call(m, "propertyFeatures"))
                $root.coreproductpb.PropertyFeatures.encode(m.propertyFeatures, w.uint32(50).fork()).ldelim();
            if (m.distributor != null && Object.hasOwnProperty.call(m, "distributor"))
                $root.coreproductpb.Distributor.encode(m.distributor, w.uint32(58).fork()).ldelim();
            return w;
        };

        /**
         * Decodes a ProductAvailabilityRequest message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.ProductAvailabilityRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.ProductAvailabilityRequest} ProductAvailabilityRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ProductAvailabilityRequest.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.ProductAvailabilityRequest();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.officeID = r.string();
                    break;
                case 2:
                    m.franchiseID = r.string();
                    break;
                case 3:
                    m.salesSourceId = r.string();
                    break;
                case 4:
                    m.customerType = r.int32();
                    break;
                case 5:
                    m.productOptions = $root.coreproductpb.ProductOptions.decode(r, r.uint32());
                    break;
                case 6:
                    m.propertyFeatures = $root.coreproductpb.PropertyFeatures.decode(r, r.uint32());
                    break;
                case 7:
                    m.distributor = $root.coreproductpb.Distributor.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return ProductAvailabilityRequest;
    })();

    coreproductpb.ProductAvailabilityResponse = (function() {

        /**
         * Properties of a ProductAvailabilityResponse.
         * @memberof coreproductpb
         * @interface IProductAvailabilityResponse
         * @property {Array.<coreproductpb.ICompactProductResponse>|null} [availableProducts] ProductAvailabilityResponse availableProducts
         * @property {Array.<common.IError>|null} [errors] ProductAvailabilityResponse errors
         * @property {boolean|null} [isDefault] ProductAvailabilityResponse isDefault
         */

        /**
         * Constructs a new ProductAvailabilityResponse.
         * @memberof coreproductpb
         * @classdesc Represents a ProductAvailabilityResponse.
         * @implements IProductAvailabilityResponse
         * @constructor
         * @param {coreproductpb.IProductAvailabilityResponse=} [p] Properties to set
         */
        function ProductAvailabilityResponse(p) {
            this.availableProducts = [];
            this.errors = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * ProductAvailabilityResponse availableProducts.
         * @member {Array.<coreproductpb.ICompactProductResponse>} availableProducts
         * @memberof coreproductpb.ProductAvailabilityResponse
         * @instance
         */
        ProductAvailabilityResponse.prototype.availableProducts = $util.emptyArray;

        /**
         * ProductAvailabilityResponse errors.
         * @member {Array.<common.IError>} errors
         * @memberof coreproductpb.ProductAvailabilityResponse
         * @instance
         */
        ProductAvailabilityResponse.prototype.errors = $util.emptyArray;

        /**
         * ProductAvailabilityResponse isDefault.
         * @member {boolean} isDefault
         * @memberof coreproductpb.ProductAvailabilityResponse
         * @instance
         */
        ProductAvailabilityResponse.prototype.isDefault = false;

        /**
         * Creates a new ProductAvailabilityResponse instance using the specified properties.
         * @function create
         * @memberof coreproductpb.ProductAvailabilityResponse
         * @static
         * @param {coreproductpb.IProductAvailabilityResponse=} [properties] Properties to set
         * @returns {coreproductpb.ProductAvailabilityResponse} ProductAvailabilityResponse instance
         */
        ProductAvailabilityResponse.create = function create(properties) {
            return new ProductAvailabilityResponse(properties);
        };

        /**
         * Encodes the specified ProductAvailabilityResponse message. Does not implicitly {@link coreproductpb.ProductAvailabilityResponse.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.ProductAvailabilityResponse
         * @static
         * @param {coreproductpb.IProductAvailabilityResponse} m ProductAvailabilityResponse message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ProductAvailabilityResponse.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.availableProducts != null && m.availableProducts.length) {
                for (var i = 0; i < m.availableProducts.length; ++i)
                    $root.coreproductpb.CompactProductResponse.encode(m.availableProducts[i], w.uint32(10).fork()).ldelim();
            }
            if (m.errors != null && m.errors.length) {
                for (var i = 0; i < m.errors.length; ++i)
                    $root.common.Error.encode(m.errors[i], w.uint32(18).fork()).ldelim();
            }
            if (m.isDefault != null && Object.hasOwnProperty.call(m, "isDefault"))
                w.uint32(24).bool(m.isDefault);
            return w;
        };

        /**
         * Decodes a ProductAvailabilityResponse message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.ProductAvailabilityResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.ProductAvailabilityResponse} ProductAvailabilityResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ProductAvailabilityResponse.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.ProductAvailabilityResponse();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    if (!(m.availableProducts && m.availableProducts.length))
                        m.availableProducts = [];
                    m.availableProducts.push($root.coreproductpb.CompactProductResponse.decode(r, r.uint32()));
                    break;
                case 2:
                    if (!(m.errors && m.errors.length))
                        m.errors = [];
                    m.errors.push($root.common.Error.decode(r, r.uint32()));
                    break;
                case 3:
                    m.isDefault = r.bool();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return ProductAvailabilityResponse;
    })();

    coreproductpb.GroupedProductAvailabilityResponse = (function() {

        /**
         * Properties of a GroupedProductAvailabilityResponse.
         * @memberof coreproductpb
         * @interface IGroupedProductAvailabilityResponse
         * @property {Array.<coreproductpb.ICompactGroupedProductResponse>|null} [availableGroupedProducts] GroupedProductAvailabilityResponse availableGroupedProducts
         * @property {boolean|null} [isDefault] GroupedProductAvailabilityResponse isDefault
         */

        /**
         * Constructs a new GroupedProductAvailabilityResponse.
         * @memberof coreproductpb
         * @classdesc Represents a GroupedProductAvailabilityResponse.
         * @implements IGroupedProductAvailabilityResponse
         * @constructor
         * @param {coreproductpb.IGroupedProductAvailabilityResponse=} [p] Properties to set
         */
        function GroupedProductAvailabilityResponse(p) {
            this.availableGroupedProducts = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * GroupedProductAvailabilityResponse availableGroupedProducts.
         * @member {Array.<coreproductpb.ICompactGroupedProductResponse>} availableGroupedProducts
         * @memberof coreproductpb.GroupedProductAvailabilityResponse
         * @instance
         */
        GroupedProductAvailabilityResponse.prototype.availableGroupedProducts = $util.emptyArray;

        /**
         * GroupedProductAvailabilityResponse isDefault.
         * @member {boolean} isDefault
         * @memberof coreproductpb.GroupedProductAvailabilityResponse
         * @instance
         */
        GroupedProductAvailabilityResponse.prototype.isDefault = false;

        /**
         * Creates a new GroupedProductAvailabilityResponse instance using the specified properties.
         * @function create
         * @memberof coreproductpb.GroupedProductAvailabilityResponse
         * @static
         * @param {coreproductpb.IGroupedProductAvailabilityResponse=} [properties] Properties to set
         * @returns {coreproductpb.GroupedProductAvailabilityResponse} GroupedProductAvailabilityResponse instance
         */
        GroupedProductAvailabilityResponse.create = function create(properties) {
            return new GroupedProductAvailabilityResponse(properties);
        };

        /**
         * Encodes the specified GroupedProductAvailabilityResponse message. Does not implicitly {@link coreproductpb.GroupedProductAvailabilityResponse.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.GroupedProductAvailabilityResponse
         * @static
         * @param {coreproductpb.IGroupedProductAvailabilityResponse} m GroupedProductAvailabilityResponse message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GroupedProductAvailabilityResponse.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.availableGroupedProducts != null && m.availableGroupedProducts.length) {
                for (var i = 0; i < m.availableGroupedProducts.length; ++i)
                    $root.coreproductpb.CompactGroupedProductResponse.encode(m.availableGroupedProducts[i], w.uint32(10).fork()).ldelim();
            }
            if (m.isDefault != null && Object.hasOwnProperty.call(m, "isDefault"))
                w.uint32(24).bool(m.isDefault);
            return w;
        };

        /**
         * Decodes a GroupedProductAvailabilityResponse message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.GroupedProductAvailabilityResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.GroupedProductAvailabilityResponse} GroupedProductAvailabilityResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GroupedProductAvailabilityResponse.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.GroupedProductAvailabilityResponse();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    if (!(m.availableGroupedProducts && m.availableGroupedProducts.length))
                        m.availableGroupedProducts = [];
                    m.availableGroupedProducts.push($root.coreproductpb.CompactGroupedProductResponse.decode(r, r.uint32()));
                    break;
                case 3:
                    m.isDefault = r.bool();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return GroupedProductAvailabilityResponse;
    })();

    coreproductpb.CompactGroupedProductResponse = (function() {

        /**
         * Properties of a CompactGroupedProductResponse.
         * @memberof coreproductpb
         * @interface ICompactGroupedProductResponse
         * @property {string|null} [productFamilyID] CompactGroupedProductResponse productFamilyID
         * @property {string|null} [productFamilyName] CompactGroupedProductResponse productFamilyName
         * @property {string|null} [companyCode] CompactGroupedProductResponse companyCode
         * @property {Array.<coreproductpb.ICompactProductResponse>|null} [availableProducts] CompactGroupedProductResponse availableProducts
         */

        /**
         * Constructs a new CompactGroupedProductResponse.
         * @memberof coreproductpb
         * @classdesc Represents a CompactGroupedProductResponse.
         * @implements ICompactGroupedProductResponse
         * @constructor
         * @param {coreproductpb.ICompactGroupedProductResponse=} [p] Properties to set
         */
        function CompactGroupedProductResponse(p) {
            this.availableProducts = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * CompactGroupedProductResponse productFamilyID.
         * @member {string} productFamilyID
         * @memberof coreproductpb.CompactGroupedProductResponse
         * @instance
         */
        CompactGroupedProductResponse.prototype.productFamilyID = "";

        /**
         * CompactGroupedProductResponse productFamilyName.
         * @member {string} productFamilyName
         * @memberof coreproductpb.CompactGroupedProductResponse
         * @instance
         */
        CompactGroupedProductResponse.prototype.productFamilyName = "";

        /**
         * CompactGroupedProductResponse companyCode.
         * @member {string} companyCode
         * @memberof coreproductpb.CompactGroupedProductResponse
         * @instance
         */
        CompactGroupedProductResponse.prototype.companyCode = "";

        /**
         * CompactGroupedProductResponse availableProducts.
         * @member {Array.<coreproductpb.ICompactProductResponse>} availableProducts
         * @memberof coreproductpb.CompactGroupedProductResponse
         * @instance
         */
        CompactGroupedProductResponse.prototype.availableProducts = $util.emptyArray;

        /**
         * Creates a new CompactGroupedProductResponse instance using the specified properties.
         * @function create
         * @memberof coreproductpb.CompactGroupedProductResponse
         * @static
         * @param {coreproductpb.ICompactGroupedProductResponse=} [properties] Properties to set
         * @returns {coreproductpb.CompactGroupedProductResponse} CompactGroupedProductResponse instance
         */
        CompactGroupedProductResponse.create = function create(properties) {
            return new CompactGroupedProductResponse(properties);
        };

        /**
         * Encodes the specified CompactGroupedProductResponse message. Does not implicitly {@link coreproductpb.CompactGroupedProductResponse.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.CompactGroupedProductResponse
         * @static
         * @param {coreproductpb.ICompactGroupedProductResponse} m CompactGroupedProductResponse message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CompactGroupedProductResponse.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.productFamilyID != null && Object.hasOwnProperty.call(m, "productFamilyID"))
                w.uint32(10).string(m.productFamilyID);
            if (m.productFamilyName != null && Object.hasOwnProperty.call(m, "productFamilyName"))
                w.uint32(18).string(m.productFamilyName);
            if (m.companyCode != null && Object.hasOwnProperty.call(m, "companyCode"))
                w.uint32(26).string(m.companyCode);
            if (m.availableProducts != null && m.availableProducts.length) {
                for (var i = 0; i < m.availableProducts.length; ++i)
                    $root.coreproductpb.CompactProductResponse.encode(m.availableProducts[i], w.uint32(34).fork()).ldelim();
            }
            return w;
        };

        /**
         * Decodes a CompactGroupedProductResponse message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.CompactGroupedProductResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.CompactGroupedProductResponse} CompactGroupedProductResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CompactGroupedProductResponse.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.CompactGroupedProductResponse();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.productFamilyID = r.string();
                    break;
                case 2:
                    m.productFamilyName = r.string();
                    break;
                case 3:
                    m.companyCode = r.string();
                    break;
                case 4:
                    if (!(m.availableProducts && m.availableProducts.length))
                        m.availableProducts = [];
                    m.availableProducts.push($root.coreproductpb.CompactProductResponse.decode(r, r.uint32()));
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return CompactGroupedProductResponse;
    })();

    coreproductpb.ProductAvailabilityByDateRequest = (function() {

        /**
         * Properties of a ProductAvailabilityByDateRequest.
         * @memberof coreproductpb
         * @interface IProductAvailabilityByDateRequest
         * @property {coreproductpb.IProductAvailabilityRequest|null} [productAvailabilityRequest] ProductAvailabilityByDateRequest productAvailabilityRequest
         * @property {number|Long|null} [contractTime] ProductAvailabilityByDateRequest contractTime
         * @property {google.protobuf.ITimestamp|null} [contractTimestamp] ProductAvailabilityByDateRequest contractTimestamp
         */

        /**
         * Constructs a new ProductAvailabilityByDateRequest.
         * @memberof coreproductpb
         * @classdesc Represents a ProductAvailabilityByDateRequest.
         * @implements IProductAvailabilityByDateRequest
         * @constructor
         * @param {coreproductpb.IProductAvailabilityByDateRequest=} [p] Properties to set
         */
        function ProductAvailabilityByDateRequest(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * ProductAvailabilityByDateRequest productAvailabilityRequest.
         * @member {coreproductpb.IProductAvailabilityRequest|null|undefined} productAvailabilityRequest
         * @memberof coreproductpb.ProductAvailabilityByDateRequest
         * @instance
         */
        ProductAvailabilityByDateRequest.prototype.productAvailabilityRequest = null;

        /**
         * ProductAvailabilityByDateRequest contractTime.
         * @member {number|Long} contractTime
         * @memberof coreproductpb.ProductAvailabilityByDateRequest
         * @instance
         */
        ProductAvailabilityByDateRequest.prototype.contractTime = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * ProductAvailabilityByDateRequest contractTimestamp.
         * @member {google.protobuf.ITimestamp|null|undefined} contractTimestamp
         * @memberof coreproductpb.ProductAvailabilityByDateRequest
         * @instance
         */
        ProductAvailabilityByDateRequest.prototype.contractTimestamp = null;

        /**
         * Creates a new ProductAvailabilityByDateRequest instance using the specified properties.
         * @function create
         * @memberof coreproductpb.ProductAvailabilityByDateRequest
         * @static
         * @param {coreproductpb.IProductAvailabilityByDateRequest=} [properties] Properties to set
         * @returns {coreproductpb.ProductAvailabilityByDateRequest} ProductAvailabilityByDateRequest instance
         */
        ProductAvailabilityByDateRequest.create = function create(properties) {
            return new ProductAvailabilityByDateRequest(properties);
        };

        /**
         * Encodes the specified ProductAvailabilityByDateRequest message. Does not implicitly {@link coreproductpb.ProductAvailabilityByDateRequest.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.ProductAvailabilityByDateRequest
         * @static
         * @param {coreproductpb.IProductAvailabilityByDateRequest} m ProductAvailabilityByDateRequest message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ProductAvailabilityByDateRequest.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.productAvailabilityRequest != null && Object.hasOwnProperty.call(m, "productAvailabilityRequest"))
                $root.coreproductpb.ProductAvailabilityRequest.encode(m.productAvailabilityRequest, w.uint32(10).fork()).ldelim();
            if (m.contractTime != null && Object.hasOwnProperty.call(m, "contractTime"))
                w.uint32(16).uint64(m.contractTime);
            if (m.contractTimestamp != null && Object.hasOwnProperty.call(m, "contractTimestamp"))
                $root.google.protobuf.Timestamp.encode(m.contractTimestamp, w.uint32(26).fork()).ldelim();
            return w;
        };

        /**
         * Decodes a ProductAvailabilityByDateRequest message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.ProductAvailabilityByDateRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.ProductAvailabilityByDateRequest} ProductAvailabilityByDateRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ProductAvailabilityByDateRequest.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.ProductAvailabilityByDateRequest();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.productAvailabilityRequest = $root.coreproductpb.ProductAvailabilityRequest.decode(r, r.uint32());
                    break;
                case 2:
                    m.contractTime = r.uint64();
                    break;
                case 3:
                    m.contractTimestamp = $root.google.protobuf.Timestamp.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return ProductAvailabilityByDateRequest;
    })();

    coreproductpb.ProductAvailabilityByDateResponse = (function() {

        /**
         * Properties of a ProductAvailabilityByDateResponse.
         * @memberof coreproductpb
         * @interface IProductAvailabilityByDateResponse
         * @property {Array.<coreproductpb.ICompactProductResponse>|null} [availableProducts] ProductAvailabilityByDateResponse availableProducts
         * @property {Array.<common.IError>|null} [errors] ProductAvailabilityByDateResponse errors
         * @property {boolean|null} [isDefault] ProductAvailabilityByDateResponse isDefault
         */

        /**
         * Constructs a new ProductAvailabilityByDateResponse.
         * @memberof coreproductpb
         * @classdesc Represents a ProductAvailabilityByDateResponse.
         * @implements IProductAvailabilityByDateResponse
         * @constructor
         * @param {coreproductpb.IProductAvailabilityByDateResponse=} [p] Properties to set
         */
        function ProductAvailabilityByDateResponse(p) {
            this.availableProducts = [];
            this.errors = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * ProductAvailabilityByDateResponse availableProducts.
         * @member {Array.<coreproductpb.ICompactProductResponse>} availableProducts
         * @memberof coreproductpb.ProductAvailabilityByDateResponse
         * @instance
         */
        ProductAvailabilityByDateResponse.prototype.availableProducts = $util.emptyArray;

        /**
         * ProductAvailabilityByDateResponse errors.
         * @member {Array.<common.IError>} errors
         * @memberof coreproductpb.ProductAvailabilityByDateResponse
         * @instance
         */
        ProductAvailabilityByDateResponse.prototype.errors = $util.emptyArray;

        /**
         * ProductAvailabilityByDateResponse isDefault.
         * @member {boolean} isDefault
         * @memberof coreproductpb.ProductAvailabilityByDateResponse
         * @instance
         */
        ProductAvailabilityByDateResponse.prototype.isDefault = false;

        /**
         * Creates a new ProductAvailabilityByDateResponse instance using the specified properties.
         * @function create
         * @memberof coreproductpb.ProductAvailabilityByDateResponse
         * @static
         * @param {coreproductpb.IProductAvailabilityByDateResponse=} [properties] Properties to set
         * @returns {coreproductpb.ProductAvailabilityByDateResponse} ProductAvailabilityByDateResponse instance
         */
        ProductAvailabilityByDateResponse.create = function create(properties) {
            return new ProductAvailabilityByDateResponse(properties);
        };

        /**
         * Encodes the specified ProductAvailabilityByDateResponse message. Does not implicitly {@link coreproductpb.ProductAvailabilityByDateResponse.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.ProductAvailabilityByDateResponse
         * @static
         * @param {coreproductpb.IProductAvailabilityByDateResponse} m ProductAvailabilityByDateResponse message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ProductAvailabilityByDateResponse.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.availableProducts != null && m.availableProducts.length) {
                for (var i = 0; i < m.availableProducts.length; ++i)
                    $root.coreproductpb.CompactProductResponse.encode(m.availableProducts[i], w.uint32(10).fork()).ldelim();
            }
            if (m.errors != null && m.errors.length) {
                for (var i = 0; i < m.errors.length; ++i)
                    $root.common.Error.encode(m.errors[i], w.uint32(18).fork()).ldelim();
            }
            if (m.isDefault != null && Object.hasOwnProperty.call(m, "isDefault"))
                w.uint32(24).bool(m.isDefault);
            return w;
        };

        /**
         * Decodes a ProductAvailabilityByDateResponse message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.ProductAvailabilityByDateResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.ProductAvailabilityByDateResponse} ProductAvailabilityByDateResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ProductAvailabilityByDateResponse.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.ProductAvailabilityByDateResponse();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    if (!(m.availableProducts && m.availableProducts.length))
                        m.availableProducts = [];
                    m.availableProducts.push($root.coreproductpb.CompactProductResponse.decode(r, r.uint32()));
                    break;
                case 2:
                    if (!(m.errors && m.errors.length))
                        m.errors = [];
                    m.errors.push($root.common.Error.decode(r, r.uint32()));
                    break;
                case 3:
                    m.isDefault = r.bool();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return ProductAvailabilityByDateResponse;
    })();

    coreproductpb.ProductAvailabilityStatusRequest = (function() {

        /**
         * Properties of a ProductAvailabilityStatusRequest.
         * @memberof coreproductpb
         * @interface IProductAvailabilityStatusRequest
         * @property {number|Long|null} [contractTime] ProductAvailabilityStatusRequest contractTime
         * @property {string|null} [tenant] ProductAvailabilityStatusRequest tenant
         * @property {coreproductpb.SalesChannelType|null} [salesChannel] ProductAvailabilityStatusRequest salesChannel
         * @property {coreproductpb.PurchaseChannel|null} [purchaseChannel] ProductAvailabilityStatusRequest purchaseChannel
         * @property {coreproductpb.IPropertyFeatures|null} [propertyFeatures] ProductAvailabilityStatusRequest propertyFeatures
         * @property {google.protobuf.ITimestamp|null} [contractTimestamp] ProductAvailabilityStatusRequest contractTimestamp
         * @property {string|null} [salesSourceId] ProductAvailabilityStatusRequest salesSourceId
         * @property {coreproductpb.IDistributor|null} [distributor] ProductAvailabilityStatusRequest distributor
         * @property {coreproductpb.SalesGroupType|null} [salesGroup] ProductAvailabilityStatusRequest salesGroup
         */

        /**
         * Constructs a new ProductAvailabilityStatusRequest.
         * @memberof coreproductpb
         * @classdesc Represents a ProductAvailabilityStatusRequest.
         * @implements IProductAvailabilityStatusRequest
         * @constructor
         * @param {coreproductpb.IProductAvailabilityStatusRequest=} [p] Properties to set
         */
        function ProductAvailabilityStatusRequest(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * ProductAvailabilityStatusRequest contractTime.
         * @member {number|Long} contractTime
         * @memberof coreproductpb.ProductAvailabilityStatusRequest
         * @instance
         */
        ProductAvailabilityStatusRequest.prototype.contractTime = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * ProductAvailabilityStatusRequest tenant.
         * @member {string} tenant
         * @memberof coreproductpb.ProductAvailabilityStatusRequest
         * @instance
         */
        ProductAvailabilityStatusRequest.prototype.tenant = "";

        /**
         * ProductAvailabilityStatusRequest salesChannel.
         * @member {coreproductpb.SalesChannelType} salesChannel
         * @memberof coreproductpb.ProductAvailabilityStatusRequest
         * @instance
         */
        ProductAvailabilityStatusRequest.prototype.salesChannel = 0;

        /**
         * ProductAvailabilityStatusRequest purchaseChannel.
         * @member {coreproductpb.PurchaseChannel} purchaseChannel
         * @memberof coreproductpb.ProductAvailabilityStatusRequest
         * @instance
         */
        ProductAvailabilityStatusRequest.prototype.purchaseChannel = 0;

        /**
         * ProductAvailabilityStatusRequest propertyFeatures.
         * @member {coreproductpb.IPropertyFeatures|null|undefined} propertyFeatures
         * @memberof coreproductpb.ProductAvailabilityStatusRequest
         * @instance
         */
        ProductAvailabilityStatusRequest.prototype.propertyFeatures = null;

        /**
         * ProductAvailabilityStatusRequest contractTimestamp.
         * @member {google.protobuf.ITimestamp|null|undefined} contractTimestamp
         * @memberof coreproductpb.ProductAvailabilityStatusRequest
         * @instance
         */
        ProductAvailabilityStatusRequest.prototype.contractTimestamp = null;

        /**
         * ProductAvailabilityStatusRequest salesSourceId.
         * @member {string} salesSourceId
         * @memberof coreproductpb.ProductAvailabilityStatusRequest
         * @instance
         */
        ProductAvailabilityStatusRequest.prototype.salesSourceId = "";

        /**
         * ProductAvailabilityStatusRequest distributor.
         * @member {coreproductpb.IDistributor|null|undefined} distributor
         * @memberof coreproductpb.ProductAvailabilityStatusRequest
         * @instance
         */
        ProductAvailabilityStatusRequest.prototype.distributor = null;

        /**
         * ProductAvailabilityStatusRequest salesGroup.
         * @member {coreproductpb.SalesGroupType} salesGroup
         * @memberof coreproductpb.ProductAvailabilityStatusRequest
         * @instance
         */
        ProductAvailabilityStatusRequest.prototype.salesGroup = 0;

        /**
         * Creates a new ProductAvailabilityStatusRequest instance using the specified properties.
         * @function create
         * @memberof coreproductpb.ProductAvailabilityStatusRequest
         * @static
         * @param {coreproductpb.IProductAvailabilityStatusRequest=} [properties] Properties to set
         * @returns {coreproductpb.ProductAvailabilityStatusRequest} ProductAvailabilityStatusRequest instance
         */
        ProductAvailabilityStatusRequest.create = function create(properties) {
            return new ProductAvailabilityStatusRequest(properties);
        };

        /**
         * Encodes the specified ProductAvailabilityStatusRequest message. Does not implicitly {@link coreproductpb.ProductAvailabilityStatusRequest.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.ProductAvailabilityStatusRequest
         * @static
         * @param {coreproductpb.IProductAvailabilityStatusRequest} m ProductAvailabilityStatusRequest message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ProductAvailabilityStatusRequest.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.contractTime != null && Object.hasOwnProperty.call(m, "contractTime"))
                w.uint32(8).uint64(m.contractTime);
            if (m.tenant != null && Object.hasOwnProperty.call(m, "tenant"))
                w.uint32(18).string(m.tenant);
            if (m.salesChannel != null && Object.hasOwnProperty.call(m, "salesChannel"))
                w.uint32(24).int32(m.salesChannel);
            if (m.purchaseChannel != null && Object.hasOwnProperty.call(m, "purchaseChannel"))
                w.uint32(32).int32(m.purchaseChannel);
            if (m.propertyFeatures != null && Object.hasOwnProperty.call(m, "propertyFeatures"))
                $root.coreproductpb.PropertyFeatures.encode(m.propertyFeatures, w.uint32(42).fork()).ldelim();
            if (m.contractTimestamp != null && Object.hasOwnProperty.call(m, "contractTimestamp"))
                $root.google.protobuf.Timestamp.encode(m.contractTimestamp, w.uint32(50).fork()).ldelim();
            if (m.salesSourceId != null && Object.hasOwnProperty.call(m, "salesSourceId"))
                w.uint32(58).string(m.salesSourceId);
            if (m.distributor != null && Object.hasOwnProperty.call(m, "distributor"))
                $root.coreproductpb.Distributor.encode(m.distributor, w.uint32(66).fork()).ldelim();
            if (m.salesGroup != null && Object.hasOwnProperty.call(m, "salesGroup"))
                w.uint32(72).int32(m.salesGroup);
            return w;
        };

        /**
         * Decodes a ProductAvailabilityStatusRequest message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.ProductAvailabilityStatusRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.ProductAvailabilityStatusRequest} ProductAvailabilityStatusRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ProductAvailabilityStatusRequest.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.ProductAvailabilityStatusRequest();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.contractTime = r.uint64();
                    break;
                case 2:
                    m.tenant = r.string();
                    break;
                case 3:
                    m.salesChannel = r.int32();
                    break;
                case 4:
                    m.purchaseChannel = r.int32();
                    break;
                case 5:
                    m.propertyFeatures = $root.coreproductpb.PropertyFeatures.decode(r, r.uint32());
                    break;
                case 6:
                    m.contractTimestamp = $root.google.protobuf.Timestamp.decode(r, r.uint32());
                    break;
                case 7:
                    m.salesSourceId = r.string();
                    break;
                case 8:
                    m.distributor = $root.coreproductpb.Distributor.decode(r, r.uint32());
                    break;
                case 9:
                    m.salesGroup = r.int32();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return ProductAvailabilityStatusRequest;
    })();

    coreproductpb.ProductAvailabilityStatusResponse = (function() {

        /**
         * Properties of a ProductAvailabilityStatusResponse.
         * @memberof coreproductpb
         * @interface IProductAvailabilityStatusResponse
         * @property {boolean|null} [guestUnitsAvailable] ProductAvailabilityStatusResponse guestUnitsAvailable
         * @property {boolean|null} [guestUnitsAvailableOptionalOnly] ProductAvailabilityStatusResponse guestUnitsAvailableOptionalOnly
         * @property {boolean|null} [availableAC] ProductAvailabilityStatusResponse availableAC
         * @property {boolean|null} [availableACOptional] ProductAvailabilityStatusResponse availableACOptional
         * @property {boolean|null} [noACProducts] ProductAvailabilityStatusResponse noACProducts
         * @property {boolean|null} [sellerCoverageAvailable] ProductAvailabilityStatusResponse sellerCoverageAvailable
         * @property {Array.<number|Long>|null} [contractTerms] ProductAvailabilityStatusResponse contractTerms
         * @property {boolean|null} [newConstruction] ProductAvailabilityStatusResponse newConstruction
         * @property {Array.<coreproductpb.SalesGroupType>|null} [salesGroups] ProductAvailabilityStatusResponse salesGroups
         * @property {boolean|null} [defaultProduct] ProductAvailabilityStatusResponse defaultProduct
         */

        /**
         * Constructs a new ProductAvailabilityStatusResponse.
         * @memberof coreproductpb
         * @classdesc Represents a ProductAvailabilityStatusResponse.
         * @implements IProductAvailabilityStatusResponse
         * @constructor
         * @param {coreproductpb.IProductAvailabilityStatusResponse=} [p] Properties to set
         */
        function ProductAvailabilityStatusResponse(p) {
            this.contractTerms = [];
            this.salesGroups = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * ProductAvailabilityStatusResponse guestUnitsAvailable.
         * @member {boolean} guestUnitsAvailable
         * @memberof coreproductpb.ProductAvailabilityStatusResponse
         * @instance
         */
        ProductAvailabilityStatusResponse.prototype.guestUnitsAvailable = false;

        /**
         * ProductAvailabilityStatusResponse guestUnitsAvailableOptionalOnly.
         * @member {boolean} guestUnitsAvailableOptionalOnly
         * @memberof coreproductpb.ProductAvailabilityStatusResponse
         * @instance
         */
        ProductAvailabilityStatusResponse.prototype.guestUnitsAvailableOptionalOnly = false;

        /**
         * ProductAvailabilityStatusResponse availableAC.
         * @member {boolean} availableAC
         * @memberof coreproductpb.ProductAvailabilityStatusResponse
         * @instance
         */
        ProductAvailabilityStatusResponse.prototype.availableAC = false;

        /**
         * ProductAvailabilityStatusResponse availableACOptional.
         * @member {boolean} availableACOptional
         * @memberof coreproductpb.ProductAvailabilityStatusResponse
         * @instance
         */
        ProductAvailabilityStatusResponse.prototype.availableACOptional = false;

        /**
         * ProductAvailabilityStatusResponse noACProducts.
         * @member {boolean} noACProducts
         * @memberof coreproductpb.ProductAvailabilityStatusResponse
         * @instance
         */
        ProductAvailabilityStatusResponse.prototype.noACProducts = false;

        /**
         * ProductAvailabilityStatusResponse sellerCoverageAvailable.
         * @member {boolean} sellerCoverageAvailable
         * @memberof coreproductpb.ProductAvailabilityStatusResponse
         * @instance
         */
        ProductAvailabilityStatusResponse.prototype.sellerCoverageAvailable = false;

        /**
         * ProductAvailabilityStatusResponse contractTerms.
         * @member {Array.<number|Long>} contractTerms
         * @memberof coreproductpb.ProductAvailabilityStatusResponse
         * @instance
         */
        ProductAvailabilityStatusResponse.prototype.contractTerms = $util.emptyArray;

        /**
         * ProductAvailabilityStatusResponse newConstruction.
         * @member {boolean} newConstruction
         * @memberof coreproductpb.ProductAvailabilityStatusResponse
         * @instance
         */
        ProductAvailabilityStatusResponse.prototype.newConstruction = false;

        /**
         * ProductAvailabilityStatusResponse salesGroups.
         * @member {Array.<coreproductpb.SalesGroupType>} salesGroups
         * @memberof coreproductpb.ProductAvailabilityStatusResponse
         * @instance
         */
        ProductAvailabilityStatusResponse.prototype.salesGroups = $util.emptyArray;

        /**
         * ProductAvailabilityStatusResponse defaultProduct.
         * @member {boolean} defaultProduct
         * @memberof coreproductpb.ProductAvailabilityStatusResponse
         * @instance
         */
        ProductAvailabilityStatusResponse.prototype.defaultProduct = false;

        /**
         * Creates a new ProductAvailabilityStatusResponse instance using the specified properties.
         * @function create
         * @memberof coreproductpb.ProductAvailabilityStatusResponse
         * @static
         * @param {coreproductpb.IProductAvailabilityStatusResponse=} [properties] Properties to set
         * @returns {coreproductpb.ProductAvailabilityStatusResponse} ProductAvailabilityStatusResponse instance
         */
        ProductAvailabilityStatusResponse.create = function create(properties) {
            return new ProductAvailabilityStatusResponse(properties);
        };

        /**
         * Encodes the specified ProductAvailabilityStatusResponse message. Does not implicitly {@link coreproductpb.ProductAvailabilityStatusResponse.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.ProductAvailabilityStatusResponse
         * @static
         * @param {coreproductpb.IProductAvailabilityStatusResponse} m ProductAvailabilityStatusResponse message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ProductAvailabilityStatusResponse.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.guestUnitsAvailable != null && Object.hasOwnProperty.call(m, "guestUnitsAvailable"))
                w.uint32(8).bool(m.guestUnitsAvailable);
            if (m.guestUnitsAvailableOptionalOnly != null && Object.hasOwnProperty.call(m, "guestUnitsAvailableOptionalOnly"))
                w.uint32(16).bool(m.guestUnitsAvailableOptionalOnly);
            if (m.availableAC != null && Object.hasOwnProperty.call(m, "availableAC"))
                w.uint32(24).bool(m.availableAC);
            if (m.availableACOptional != null && Object.hasOwnProperty.call(m, "availableACOptional"))
                w.uint32(32).bool(m.availableACOptional);
            if (m.noACProducts != null && Object.hasOwnProperty.call(m, "noACProducts"))
                w.uint32(40).bool(m.noACProducts);
            if (m.sellerCoverageAvailable != null && Object.hasOwnProperty.call(m, "sellerCoverageAvailable"))
                w.uint32(48).bool(m.sellerCoverageAvailable);
            if (m.contractTerms != null && m.contractTerms.length) {
                w.uint32(58).fork();
                for (var i = 0; i < m.contractTerms.length; ++i)
                    w.uint64(m.contractTerms[i]);
                w.ldelim();
            }
            if (m.newConstruction != null && Object.hasOwnProperty.call(m, "newConstruction"))
                w.uint32(64).bool(m.newConstruction);
            if (m.salesGroups != null && m.salesGroups.length) {
                w.uint32(74).fork();
                for (var i = 0; i < m.salesGroups.length; ++i)
                    w.int32(m.salesGroups[i]);
                w.ldelim();
            }
            if (m.defaultProduct != null && Object.hasOwnProperty.call(m, "defaultProduct"))
                w.uint32(80).bool(m.defaultProduct);
            return w;
        };

        /**
         * Decodes a ProductAvailabilityStatusResponse message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.ProductAvailabilityStatusResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.ProductAvailabilityStatusResponse} ProductAvailabilityStatusResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ProductAvailabilityStatusResponse.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.ProductAvailabilityStatusResponse();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.guestUnitsAvailable = r.bool();
                    break;
                case 2:
                    m.guestUnitsAvailableOptionalOnly = r.bool();
                    break;
                case 3:
                    m.availableAC = r.bool();
                    break;
                case 4:
                    m.availableACOptional = r.bool();
                    break;
                case 5:
                    m.noACProducts = r.bool();
                    break;
                case 6:
                    m.sellerCoverageAvailable = r.bool();
                    break;
                case 7:
                    if (!(m.contractTerms && m.contractTerms.length))
                        m.contractTerms = [];
                    if ((t & 7) === 2) {
                        var c2 = r.uint32() + r.pos;
                        while (r.pos < c2)
                            m.contractTerms.push(r.uint64());
                    } else
                        m.contractTerms.push(r.uint64());
                    break;
                case 8:
                    m.newConstruction = r.bool();
                    break;
                case 9:
                    if (!(m.salesGroups && m.salesGroups.length))
                        m.salesGroups = [];
                    if ((t & 7) === 2) {
                        var c2 = r.uint32() + r.pos;
                        while (r.pos < c2)
                            m.salesGroups.push(r.int32());
                    } else
                        m.salesGroups.push(r.int32());
                    break;
                case 10:
                    m.defaultProduct = r.bool();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return ProductAvailabilityStatusResponse;
    })();

    coreproductpb.ProductsRequest = (function() {

        /**
         * Properties of a ProductsRequest.
         * @memberof coreproductpb
         * @interface IProductsRequest
         * @property {string|null} [productID] ProductsRequest productID
         */

        /**
         * Constructs a new ProductsRequest.
         * @memberof coreproductpb
         * @classdesc Represents a ProductsRequest.
         * @implements IProductsRequest
         * @constructor
         * @param {coreproductpb.IProductsRequest=} [p] Properties to set
         */
        function ProductsRequest(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * ProductsRequest productID.
         * @member {string} productID
         * @memberof coreproductpb.ProductsRequest
         * @instance
         */
        ProductsRequest.prototype.productID = "";

        /**
         * Creates a new ProductsRequest instance using the specified properties.
         * @function create
         * @memberof coreproductpb.ProductsRequest
         * @static
         * @param {coreproductpb.IProductsRequest=} [properties] Properties to set
         * @returns {coreproductpb.ProductsRequest} ProductsRequest instance
         */
        ProductsRequest.create = function create(properties) {
            return new ProductsRequest(properties);
        };

        /**
         * Encodes the specified ProductsRequest message. Does not implicitly {@link coreproductpb.ProductsRequest.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.ProductsRequest
         * @static
         * @param {coreproductpb.IProductsRequest} m ProductsRequest message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ProductsRequest.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.productID != null && Object.hasOwnProperty.call(m, "productID"))
                w.uint32(10).string(m.productID);
            return w;
        };

        /**
         * Decodes a ProductsRequest message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.ProductsRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.ProductsRequest} ProductsRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ProductsRequest.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.ProductsRequest();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.productID = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return ProductsRequest;
    })();

    coreproductpb.ProductsResponse = (function() {

        /**
         * Properties of a ProductsResponse.
         * @memberof coreproductpb
         * @interface IProductsResponse
         * @property {coreproductpb.IProduct|null} [product] ProductsResponse product
         * @property {coreproductpb.IProductSKUTags|null} [tags] ProductsResponse tags
         */

        /**
         * Constructs a new ProductsResponse.
         * @memberof coreproductpb
         * @classdesc Represents a ProductsResponse.
         * @implements IProductsResponse
         * @constructor
         * @param {coreproductpb.IProductsResponse=} [p] Properties to set
         */
        function ProductsResponse(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * ProductsResponse product.
         * @member {coreproductpb.IProduct|null|undefined} product
         * @memberof coreproductpb.ProductsResponse
         * @instance
         */
        ProductsResponse.prototype.product = null;

        /**
         * ProductsResponse tags.
         * @member {coreproductpb.IProductSKUTags|null|undefined} tags
         * @memberof coreproductpb.ProductsResponse
         * @instance
         */
        ProductsResponse.prototype.tags = null;

        /**
         * Creates a new ProductsResponse instance using the specified properties.
         * @function create
         * @memberof coreproductpb.ProductsResponse
         * @static
         * @param {coreproductpb.IProductsResponse=} [properties] Properties to set
         * @returns {coreproductpb.ProductsResponse} ProductsResponse instance
         */
        ProductsResponse.create = function create(properties) {
            return new ProductsResponse(properties);
        };

        /**
         * Encodes the specified ProductsResponse message. Does not implicitly {@link coreproductpb.ProductsResponse.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.ProductsResponse
         * @static
         * @param {coreproductpb.IProductsResponse} m ProductsResponse message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ProductsResponse.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.product != null && Object.hasOwnProperty.call(m, "product"))
                $root.coreproductpb.Product.encode(m.product, w.uint32(10).fork()).ldelim();
            if (m.tags != null && Object.hasOwnProperty.call(m, "tags"))
                $root.coreproductpb.ProductSKUTags.encode(m.tags, w.uint32(18).fork()).ldelim();
            return w;
        };

        /**
         * Decodes a ProductsResponse message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.ProductsResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.ProductsResponse} ProductsResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ProductsResponse.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.ProductsResponse();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.product = $root.coreproductpb.Product.decode(r, r.uint32());
                    break;
                case 2:
                    m.tags = $root.coreproductpb.ProductSKUTags.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return ProductsResponse;
    })();

    coreproductpb.SKUByIDRequest = (function() {

        /**
         * Properties of a SKUByIDRequest.
         * @memberof coreproductpb
         * @interface ISKUByIDRequest
         * @property {string|null} [productID] SKUByIDRequest productID
         * @property {Array.<string>|null} [SKUs] SKUByIDRequest SKUs
         */

        /**
         * Constructs a new SKUByIDRequest.
         * @memberof coreproductpb
         * @classdesc Represents a SKUByIDRequest.
         * @implements ISKUByIDRequest
         * @constructor
         * @param {coreproductpb.ISKUByIDRequest=} [p] Properties to set
         */
        function SKUByIDRequest(p) {
            this.SKUs = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * SKUByIDRequest productID.
         * @member {string} productID
         * @memberof coreproductpb.SKUByIDRequest
         * @instance
         */
        SKUByIDRequest.prototype.productID = "";

        /**
         * SKUByIDRequest SKUs.
         * @member {Array.<string>} SKUs
         * @memberof coreproductpb.SKUByIDRequest
         * @instance
         */
        SKUByIDRequest.prototype.SKUs = $util.emptyArray;

        /**
         * Creates a new SKUByIDRequest instance using the specified properties.
         * @function create
         * @memberof coreproductpb.SKUByIDRequest
         * @static
         * @param {coreproductpb.ISKUByIDRequest=} [properties] Properties to set
         * @returns {coreproductpb.SKUByIDRequest} SKUByIDRequest instance
         */
        SKUByIDRequest.create = function create(properties) {
            return new SKUByIDRequest(properties);
        };

        /**
         * Encodes the specified SKUByIDRequest message. Does not implicitly {@link coreproductpb.SKUByIDRequest.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.SKUByIDRequest
         * @static
         * @param {coreproductpb.ISKUByIDRequest} m SKUByIDRequest message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SKUByIDRequest.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.productID != null && Object.hasOwnProperty.call(m, "productID"))
                w.uint32(10).string(m.productID);
            if (m.SKUs != null && m.SKUs.length) {
                for (var i = 0; i < m.SKUs.length; ++i)
                    w.uint32(18).string(m.SKUs[i]);
            }
            return w;
        };

        /**
         * Decodes a SKUByIDRequest message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.SKUByIDRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.SKUByIDRequest} SKUByIDRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SKUByIDRequest.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.SKUByIDRequest();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.productID = r.string();
                    break;
                case 2:
                    if (!(m.SKUs && m.SKUs.length))
                        m.SKUs = [];
                    m.SKUs.push(r.string());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return SKUByIDRequest;
    })();

    coreproductpb.SKUByIDResponse = (function() {

        /**
         * Properties of a SKUByIDResponse.
         * @memberof coreproductpb
         * @interface ISKUByIDResponse
         * @property {Array.<coreproductpb.ISKU>|null} [SKUs] SKUByIDResponse SKUs
         * @property {Array.<common.IError>|null} [errors] SKUByIDResponse errors
         */

        /**
         * Constructs a new SKUByIDResponse.
         * @memberof coreproductpb
         * @classdesc Represents a SKUByIDResponse.
         * @implements ISKUByIDResponse
         * @constructor
         * @param {coreproductpb.ISKUByIDResponse=} [p] Properties to set
         */
        function SKUByIDResponse(p) {
            this.SKUs = [];
            this.errors = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * SKUByIDResponse SKUs.
         * @member {Array.<coreproductpb.ISKU>} SKUs
         * @memberof coreproductpb.SKUByIDResponse
         * @instance
         */
        SKUByIDResponse.prototype.SKUs = $util.emptyArray;

        /**
         * SKUByIDResponse errors.
         * @member {Array.<common.IError>} errors
         * @memberof coreproductpb.SKUByIDResponse
         * @instance
         */
        SKUByIDResponse.prototype.errors = $util.emptyArray;

        /**
         * Creates a new SKUByIDResponse instance using the specified properties.
         * @function create
         * @memberof coreproductpb.SKUByIDResponse
         * @static
         * @param {coreproductpb.ISKUByIDResponse=} [properties] Properties to set
         * @returns {coreproductpb.SKUByIDResponse} SKUByIDResponse instance
         */
        SKUByIDResponse.create = function create(properties) {
            return new SKUByIDResponse(properties);
        };

        /**
         * Encodes the specified SKUByIDResponse message. Does not implicitly {@link coreproductpb.SKUByIDResponse.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.SKUByIDResponse
         * @static
         * @param {coreproductpb.ISKUByIDResponse} m SKUByIDResponse message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SKUByIDResponse.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.SKUs != null && m.SKUs.length) {
                for (var i = 0; i < m.SKUs.length; ++i)
                    $root.coreproductpb.SKU.encode(m.SKUs[i], w.uint32(10).fork()).ldelim();
            }
            if (m.errors != null && m.errors.length) {
                for (var i = 0; i < m.errors.length; ++i)
                    $root.common.Error.encode(m.errors[i], w.uint32(18).fork()).ldelim();
            }
            return w;
        };

        /**
         * Decodes a SKUByIDResponse message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.SKUByIDResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.SKUByIDResponse} SKUByIDResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SKUByIDResponse.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.SKUByIDResponse();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    if (!(m.SKUs && m.SKUs.length))
                        m.SKUs = [];
                    m.SKUs.push($root.coreproductpb.SKU.decode(r, r.uint32()));
                    break;
                case 2:
                    if (!(m.errors && m.errors.length))
                        m.errors = [];
                    m.errors.push($root.common.Error.decode(r, r.uint32()));
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return SKUByIDResponse;
    })();

    coreproductpb.ProductTagsResponse = (function() {

        /**
         * Properties of a ProductTagsResponse.
         * @memberof coreproductpb
         * @interface IProductTagsResponse
         * @property {Array.<string>|null} [tags] ProductTagsResponse tags
         */

        /**
         * Constructs a new ProductTagsResponse.
         * @memberof coreproductpb
         * @classdesc Represents a ProductTagsResponse.
         * @implements IProductTagsResponse
         * @constructor
         * @param {coreproductpb.IProductTagsResponse=} [p] Properties to set
         */
        function ProductTagsResponse(p) {
            this.tags = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * ProductTagsResponse tags.
         * @member {Array.<string>} tags
         * @memberof coreproductpb.ProductTagsResponse
         * @instance
         */
        ProductTagsResponse.prototype.tags = $util.emptyArray;

        /**
         * Creates a new ProductTagsResponse instance using the specified properties.
         * @function create
         * @memberof coreproductpb.ProductTagsResponse
         * @static
         * @param {coreproductpb.IProductTagsResponse=} [properties] Properties to set
         * @returns {coreproductpb.ProductTagsResponse} ProductTagsResponse instance
         */
        ProductTagsResponse.create = function create(properties) {
            return new ProductTagsResponse(properties);
        };

        /**
         * Encodes the specified ProductTagsResponse message. Does not implicitly {@link coreproductpb.ProductTagsResponse.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.ProductTagsResponse
         * @static
         * @param {coreproductpb.IProductTagsResponse} m ProductTagsResponse message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ProductTagsResponse.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.tags != null && m.tags.length) {
                for (var i = 0; i < m.tags.length; ++i)
                    w.uint32(10).string(m.tags[i]);
            }
            return w;
        };

        /**
         * Decodes a ProductTagsResponse message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.ProductTagsResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.ProductTagsResponse} ProductTagsResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ProductTagsResponse.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.ProductTagsResponse();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    if (!(m.tags && m.tags.length))
                        m.tags = [];
                    m.tags.push(r.string());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return ProductTagsResponse;
    })();

    coreproductpb.GetProductsRequest = (function() {

        /**
         * Properties of a GetProductsRequest.
         * @memberof coreproductpb
         * @interface IGetProductsRequest
         * @property {string|null} [starPVID] GetProductsRequest starPVID
         * @property {string|null} [productID] GetProductsRequest productID
         * @property {boolean|null} [getTestProducts] GetProductsRequest getTestProducts
         */

        /**
         * Constructs a new GetProductsRequest.
         * @memberof coreproductpb
         * @classdesc Represents a GetProductsRequest.
         * @implements IGetProductsRequest
         * @constructor
         * @param {coreproductpb.IGetProductsRequest=} [p] Properties to set
         */
        function GetProductsRequest(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * GetProductsRequest starPVID.
         * @member {string|null|undefined} starPVID
         * @memberof coreproductpb.GetProductsRequest
         * @instance
         */
        GetProductsRequest.prototype.starPVID = null;

        /**
         * GetProductsRequest productID.
         * @member {string|null|undefined} productID
         * @memberof coreproductpb.GetProductsRequest
         * @instance
         */
        GetProductsRequest.prototype.productID = null;

        /**
         * GetProductsRequest getTestProducts.
         * @member {boolean} getTestProducts
         * @memberof coreproductpb.GetProductsRequest
         * @instance
         */
        GetProductsRequest.prototype.getTestProducts = false;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        /**
         * GetProductsRequest id.
         * @member {"starPVID"|"productID"|undefined} id
         * @memberof coreproductpb.GetProductsRequest
         * @instance
         */
        Object.defineProperty(GetProductsRequest.prototype, "id", {
            get: $util.oneOfGetter($oneOfFields = ["starPVID", "productID"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new GetProductsRequest instance using the specified properties.
         * @function create
         * @memberof coreproductpb.GetProductsRequest
         * @static
         * @param {coreproductpb.IGetProductsRequest=} [properties] Properties to set
         * @returns {coreproductpb.GetProductsRequest} GetProductsRequest instance
         */
        GetProductsRequest.create = function create(properties) {
            return new GetProductsRequest(properties);
        };

        /**
         * Encodes the specified GetProductsRequest message. Does not implicitly {@link coreproductpb.GetProductsRequest.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.GetProductsRequest
         * @static
         * @param {coreproductpb.IGetProductsRequest} m GetProductsRequest message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetProductsRequest.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.starPVID != null && Object.hasOwnProperty.call(m, "starPVID"))
                w.uint32(10).string(m.starPVID);
            if (m.productID != null && Object.hasOwnProperty.call(m, "productID"))
                w.uint32(18).string(m.productID);
            if (m.getTestProducts != null && Object.hasOwnProperty.call(m, "getTestProducts"))
                w.uint32(24).bool(m.getTestProducts);
            return w;
        };

        /**
         * Decodes a GetProductsRequest message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.GetProductsRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.GetProductsRequest} GetProductsRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetProductsRequest.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.GetProductsRequest();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.starPVID = r.string();
                    break;
                case 2:
                    m.productID = r.string();
                    break;
                case 3:
                    m.getTestProducts = r.bool();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return GetProductsRequest;
    })();

    coreproductpb.GetProductsResponse = (function() {

        /**
         * Properties of a GetProductsResponse.
         * @memberof coreproductpb
         * @interface IGetProductsResponse
         * @property {coreproductpb.IProductResponse|null} [product] GetProductsResponse product
         * @property {Array.<common.IError>|null} [errors] GetProductsResponse errors
         */

        /**
         * Constructs a new GetProductsResponse.
         * @memberof coreproductpb
         * @classdesc Represents a GetProductsResponse.
         * @implements IGetProductsResponse
         * @constructor
         * @param {coreproductpb.IGetProductsResponse=} [p] Properties to set
         */
        function GetProductsResponse(p) {
            this.errors = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * GetProductsResponse product.
         * @member {coreproductpb.IProductResponse|null|undefined} product
         * @memberof coreproductpb.GetProductsResponse
         * @instance
         */
        GetProductsResponse.prototype.product = null;

        /**
         * GetProductsResponse errors.
         * @member {Array.<common.IError>} errors
         * @memberof coreproductpb.GetProductsResponse
         * @instance
         */
        GetProductsResponse.prototype.errors = $util.emptyArray;

        /**
         * Creates a new GetProductsResponse instance using the specified properties.
         * @function create
         * @memberof coreproductpb.GetProductsResponse
         * @static
         * @param {coreproductpb.IGetProductsResponse=} [properties] Properties to set
         * @returns {coreproductpb.GetProductsResponse} GetProductsResponse instance
         */
        GetProductsResponse.create = function create(properties) {
            return new GetProductsResponse(properties);
        };

        /**
         * Encodes the specified GetProductsResponse message. Does not implicitly {@link coreproductpb.GetProductsResponse.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.GetProductsResponse
         * @static
         * @param {coreproductpb.IGetProductsResponse} m GetProductsResponse message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetProductsResponse.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.product != null && Object.hasOwnProperty.call(m, "product"))
                $root.coreproductpb.ProductResponse.encode(m.product, w.uint32(10).fork()).ldelim();
            if (m.errors != null && m.errors.length) {
                for (var i = 0; i < m.errors.length; ++i)
                    $root.common.Error.encode(m.errors[i], w.uint32(18).fork()).ldelim();
            }
            return w;
        };

        /**
         * Decodes a GetProductsResponse message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.GetProductsResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.GetProductsResponse} GetProductsResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetProductsResponse.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.GetProductsResponse();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.product = $root.coreproductpb.ProductResponse.decode(r, r.uint32());
                    break;
                case 2:
                    if (!(m.errors && m.errors.length))
                        m.errors = [];
                    m.errors.push($root.common.Error.decode(r, r.uint32()));
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return GetProductsResponse;
    })();

    coreproductpb.ProductFeatureTags = (function() {

        /**
         * Properties of a ProductFeatureTags.
         * @memberof coreproductpb
         * @interface IProductFeatureTags
         * @property {Array.<string>|null} [baseCoveragesTags] ProductFeatureTags baseCoveragesTags
         * @property {Array.<string>|null} [addOnCoveragesTags] ProductFeatureTags addOnCoveragesTags
         * @property {boolean|null} [isACProduct] ProductFeatureTags isACProduct
         */

        /**
         * Constructs a new ProductFeatureTags.
         * @memberof coreproductpb
         * @classdesc Represents a ProductFeatureTags.
         * @implements IProductFeatureTags
         * @constructor
         * @param {coreproductpb.IProductFeatureTags=} [p] Properties to set
         */
        function ProductFeatureTags(p) {
            this.baseCoveragesTags = [];
            this.addOnCoveragesTags = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * ProductFeatureTags baseCoveragesTags.
         * @member {Array.<string>} baseCoveragesTags
         * @memberof coreproductpb.ProductFeatureTags
         * @instance
         */
        ProductFeatureTags.prototype.baseCoveragesTags = $util.emptyArray;

        /**
         * ProductFeatureTags addOnCoveragesTags.
         * @member {Array.<string>} addOnCoveragesTags
         * @memberof coreproductpb.ProductFeatureTags
         * @instance
         */
        ProductFeatureTags.prototype.addOnCoveragesTags = $util.emptyArray;

        /**
         * ProductFeatureTags isACProduct.
         * @member {boolean} isACProduct
         * @memberof coreproductpb.ProductFeatureTags
         * @instance
         */
        ProductFeatureTags.prototype.isACProduct = false;

        /**
         * Creates a new ProductFeatureTags instance using the specified properties.
         * @function create
         * @memberof coreproductpb.ProductFeatureTags
         * @static
         * @param {coreproductpb.IProductFeatureTags=} [properties] Properties to set
         * @returns {coreproductpb.ProductFeatureTags} ProductFeatureTags instance
         */
        ProductFeatureTags.create = function create(properties) {
            return new ProductFeatureTags(properties);
        };

        /**
         * Encodes the specified ProductFeatureTags message. Does not implicitly {@link coreproductpb.ProductFeatureTags.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.ProductFeatureTags
         * @static
         * @param {coreproductpb.IProductFeatureTags} m ProductFeatureTags message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ProductFeatureTags.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.baseCoveragesTags != null && m.baseCoveragesTags.length) {
                for (var i = 0; i < m.baseCoveragesTags.length; ++i)
                    w.uint32(10).string(m.baseCoveragesTags[i]);
            }
            if (m.addOnCoveragesTags != null && m.addOnCoveragesTags.length) {
                for (var i = 0; i < m.addOnCoveragesTags.length; ++i)
                    w.uint32(18).string(m.addOnCoveragesTags[i]);
            }
            if (m.isACProduct != null && Object.hasOwnProperty.call(m, "isACProduct"))
                w.uint32(24).bool(m.isACProduct);
            return w;
        };

        /**
         * Decodes a ProductFeatureTags message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.ProductFeatureTags
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.ProductFeatureTags} ProductFeatureTags
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ProductFeatureTags.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.ProductFeatureTags();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    if (!(m.baseCoveragesTags && m.baseCoveragesTags.length))
                        m.baseCoveragesTags = [];
                    m.baseCoveragesTags.push(r.string());
                    break;
                case 2:
                    if (!(m.addOnCoveragesTags && m.addOnCoveragesTags.length))
                        m.addOnCoveragesTags = [];
                    m.addOnCoveragesTags.push(r.string());
                    break;
                case 3:
                    m.isACProduct = r.bool();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return ProductFeatureTags;
    })();

    coreproductpb.ProductResponse = (function() {

        /**
         * Properties of a ProductResponse.
         * @memberof coreproductpb
         * @interface IProductResponse
         * @property {string|null} [productTemplateID] ProductResponse productTemplateID
         * @property {string|null} [productID] ProductResponse productID
         * @property {string|null} [starPVID] ProductResponse starPVID
         * @property {string|null} [starOldPV] ProductResponse starOldPV
         * @property {string|null} [productType] ProductResponse productType
         * @property {string|null} [name] ProductResponse name
         * @property {string|null} [description] ProductResponse description
         * @property {coreproductpb.IProductAttributes|null} [attributes] ProductResponse attributes
         * @property {coreproductpb.IProductFeatures|null} [features] ProductResponse features
         * @property {google.protobuf.ITimestamp|null} [effectiveDate] ProductResponse effectiveDate
         * @property {google.protobuf.ITimestamp|null} [sunsetDate] ProductResponse sunsetDate
         * @property {google.protobuf.ITimestamp|null} [expirationDate] ProductResponse expirationDate
         * @property {string|null} [productTemplateVersionID] ProductResponse productTemplateVersionID
         * @property {string|null} [starProductPlanID] ProductResponse starProductPlanID
         * @property {string|null} [starProductID] ProductResponse starProductID
         * @property {coreproductpb.IProductFeatureTags|null} [productTags] ProductResponse productTags
         */

        /**
         * Constructs a new ProductResponse.
         * @memberof coreproductpb
         * @classdesc Represents a ProductResponse.
         * @implements IProductResponse
         * @constructor
         * @param {coreproductpb.IProductResponse=} [p] Properties to set
         */
        function ProductResponse(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * ProductResponse productTemplateID.
         * @member {string} productTemplateID
         * @memberof coreproductpb.ProductResponse
         * @instance
         */
        ProductResponse.prototype.productTemplateID = "";

        /**
         * ProductResponse productID.
         * @member {string} productID
         * @memberof coreproductpb.ProductResponse
         * @instance
         */
        ProductResponse.prototype.productID = "";

        /**
         * ProductResponse starPVID.
         * @member {string} starPVID
         * @memberof coreproductpb.ProductResponse
         * @instance
         */
        ProductResponse.prototype.starPVID = "";

        /**
         * ProductResponse starOldPV.
         * @member {string} starOldPV
         * @memberof coreproductpb.ProductResponse
         * @instance
         */
        ProductResponse.prototype.starOldPV = "";

        /**
         * ProductResponse productType.
         * @member {string} productType
         * @memberof coreproductpb.ProductResponse
         * @instance
         */
        ProductResponse.prototype.productType = "";

        /**
         * ProductResponse name.
         * @member {string} name
         * @memberof coreproductpb.ProductResponse
         * @instance
         */
        ProductResponse.prototype.name = "";

        /**
         * ProductResponse description.
         * @member {string} description
         * @memberof coreproductpb.ProductResponse
         * @instance
         */
        ProductResponse.prototype.description = "";

        /**
         * ProductResponse attributes.
         * @member {coreproductpb.IProductAttributes|null|undefined} attributes
         * @memberof coreproductpb.ProductResponse
         * @instance
         */
        ProductResponse.prototype.attributes = null;

        /**
         * ProductResponse features.
         * @member {coreproductpb.IProductFeatures|null|undefined} features
         * @memberof coreproductpb.ProductResponse
         * @instance
         */
        ProductResponse.prototype.features = null;

        /**
         * ProductResponse effectiveDate.
         * @member {google.protobuf.ITimestamp|null|undefined} effectiveDate
         * @memberof coreproductpb.ProductResponse
         * @instance
         */
        ProductResponse.prototype.effectiveDate = null;

        /**
         * ProductResponse sunsetDate.
         * @member {google.protobuf.ITimestamp|null|undefined} sunsetDate
         * @memberof coreproductpb.ProductResponse
         * @instance
         */
        ProductResponse.prototype.sunsetDate = null;

        /**
         * ProductResponse expirationDate.
         * @member {google.protobuf.ITimestamp|null|undefined} expirationDate
         * @memberof coreproductpb.ProductResponse
         * @instance
         */
        ProductResponse.prototype.expirationDate = null;

        /**
         * ProductResponse productTemplateVersionID.
         * @member {string} productTemplateVersionID
         * @memberof coreproductpb.ProductResponse
         * @instance
         */
        ProductResponse.prototype.productTemplateVersionID = "";

        /**
         * ProductResponse starProductPlanID.
         * @member {string} starProductPlanID
         * @memberof coreproductpb.ProductResponse
         * @instance
         */
        ProductResponse.prototype.starProductPlanID = "";

        /**
         * ProductResponse starProductID.
         * @member {string} starProductID
         * @memberof coreproductpb.ProductResponse
         * @instance
         */
        ProductResponse.prototype.starProductID = "";

        /**
         * ProductResponse productTags.
         * @member {coreproductpb.IProductFeatureTags|null|undefined} productTags
         * @memberof coreproductpb.ProductResponse
         * @instance
         */
        ProductResponse.prototype.productTags = null;

        /**
         * Creates a new ProductResponse instance using the specified properties.
         * @function create
         * @memberof coreproductpb.ProductResponse
         * @static
         * @param {coreproductpb.IProductResponse=} [properties] Properties to set
         * @returns {coreproductpb.ProductResponse} ProductResponse instance
         */
        ProductResponse.create = function create(properties) {
            return new ProductResponse(properties);
        };

        /**
         * Encodes the specified ProductResponse message. Does not implicitly {@link coreproductpb.ProductResponse.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.ProductResponse
         * @static
         * @param {coreproductpb.IProductResponse} m ProductResponse message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ProductResponse.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.productTemplateID != null && Object.hasOwnProperty.call(m, "productTemplateID"))
                w.uint32(10).string(m.productTemplateID);
            if (m.productID != null && Object.hasOwnProperty.call(m, "productID"))
                w.uint32(18).string(m.productID);
            if (m.starPVID != null && Object.hasOwnProperty.call(m, "starPVID"))
                w.uint32(26).string(m.starPVID);
            if (m.starOldPV != null && Object.hasOwnProperty.call(m, "starOldPV"))
                w.uint32(34).string(m.starOldPV);
            if (m.productType != null && Object.hasOwnProperty.call(m, "productType"))
                w.uint32(42).string(m.productType);
            if (m.name != null && Object.hasOwnProperty.call(m, "name"))
                w.uint32(50).string(m.name);
            if (m.description != null && Object.hasOwnProperty.call(m, "description"))
                w.uint32(58).string(m.description);
            if (m.attributes != null && Object.hasOwnProperty.call(m, "attributes"))
                $root.coreproductpb.ProductAttributes.encode(m.attributes, w.uint32(66).fork()).ldelim();
            if (m.features != null && Object.hasOwnProperty.call(m, "features"))
                $root.coreproductpb.ProductFeatures.encode(m.features, w.uint32(74).fork()).ldelim();
            if (m.effectiveDate != null && Object.hasOwnProperty.call(m, "effectiveDate"))
                $root.google.protobuf.Timestamp.encode(m.effectiveDate, w.uint32(82).fork()).ldelim();
            if (m.sunsetDate != null && Object.hasOwnProperty.call(m, "sunsetDate"))
                $root.google.protobuf.Timestamp.encode(m.sunsetDate, w.uint32(90).fork()).ldelim();
            if (m.expirationDate != null && Object.hasOwnProperty.call(m, "expirationDate"))
                $root.google.protobuf.Timestamp.encode(m.expirationDate, w.uint32(98).fork()).ldelim();
            if (m.productTemplateVersionID != null && Object.hasOwnProperty.call(m, "productTemplateVersionID"))
                w.uint32(106).string(m.productTemplateVersionID);
            if (m.starProductPlanID != null && Object.hasOwnProperty.call(m, "starProductPlanID"))
                w.uint32(114).string(m.starProductPlanID);
            if (m.starProductID != null && Object.hasOwnProperty.call(m, "starProductID"))
                w.uint32(122).string(m.starProductID);
            if (m.productTags != null && Object.hasOwnProperty.call(m, "productTags"))
                $root.coreproductpb.ProductFeatureTags.encode(m.productTags, w.uint32(130).fork()).ldelim();
            return w;
        };

        /**
         * Decodes a ProductResponse message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.ProductResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.ProductResponse} ProductResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ProductResponse.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.ProductResponse();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.productTemplateID = r.string();
                    break;
                case 2:
                    m.productID = r.string();
                    break;
                case 3:
                    m.starPVID = r.string();
                    break;
                case 4:
                    m.starOldPV = r.string();
                    break;
                case 5:
                    m.productType = r.string();
                    break;
                case 6:
                    m.name = r.string();
                    break;
                case 7:
                    m.description = r.string();
                    break;
                case 8:
                    m.attributes = $root.coreproductpb.ProductAttributes.decode(r, r.uint32());
                    break;
                case 9:
                    m.features = $root.coreproductpb.ProductFeatures.decode(r, r.uint32());
                    break;
                case 10:
                    m.effectiveDate = $root.google.protobuf.Timestamp.decode(r, r.uint32());
                    break;
                case 11:
                    m.sunsetDate = $root.google.protobuf.Timestamp.decode(r, r.uint32());
                    break;
                case 12:
                    m.expirationDate = $root.google.protobuf.Timestamp.decode(r, r.uint32());
                    break;
                case 13:
                    m.productTemplateVersionID = r.string();
                    break;
                case 14:
                    m.starProductPlanID = r.string();
                    break;
                case 15:
                    m.starProductID = r.string();
                    break;
                case 16:
                    m.productTags = $root.coreproductpb.ProductFeatureTags.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return ProductResponse;
    })();

    coreproductpb.StarPublishInfo = (function() {

        /**
         * Properties of a StarPublishInfo.
         * @memberof coreproductpb
         * @interface IStarPublishInfo
         * @property {boolean|null} [newProduct] StarPublishInfo newProduct
         * @property {boolean|null} [updateProduct] StarPublishInfo updateProduct
         * @property {boolean|null} [expireProduct] StarPublishInfo expireProduct
         * @property {boolean|null} [productStarPublished] StarPublishInfo productStarPublished
         * @property {string|null} [publicationError] StarPublishInfo publicationError
         */

        /**
         * Constructs a new StarPublishInfo.
         * @memberof coreproductpb
         * @classdesc Represents a StarPublishInfo.
         * @implements IStarPublishInfo
         * @constructor
         * @param {coreproductpb.IStarPublishInfo=} [p] Properties to set
         */
        function StarPublishInfo(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * StarPublishInfo newProduct.
         * @member {boolean} newProduct
         * @memberof coreproductpb.StarPublishInfo
         * @instance
         */
        StarPublishInfo.prototype.newProduct = false;

        /**
         * StarPublishInfo updateProduct.
         * @member {boolean} updateProduct
         * @memberof coreproductpb.StarPublishInfo
         * @instance
         */
        StarPublishInfo.prototype.updateProduct = false;

        /**
         * StarPublishInfo expireProduct.
         * @member {boolean} expireProduct
         * @memberof coreproductpb.StarPublishInfo
         * @instance
         */
        StarPublishInfo.prototype.expireProduct = false;

        /**
         * StarPublishInfo productStarPublished.
         * @member {boolean} productStarPublished
         * @memberof coreproductpb.StarPublishInfo
         * @instance
         */
        StarPublishInfo.prototype.productStarPublished = false;

        /**
         * StarPublishInfo publicationError.
         * @member {string} publicationError
         * @memberof coreproductpb.StarPublishInfo
         * @instance
         */
        StarPublishInfo.prototype.publicationError = "";

        /**
         * Creates a new StarPublishInfo instance using the specified properties.
         * @function create
         * @memberof coreproductpb.StarPublishInfo
         * @static
         * @param {coreproductpb.IStarPublishInfo=} [properties] Properties to set
         * @returns {coreproductpb.StarPublishInfo} StarPublishInfo instance
         */
        StarPublishInfo.create = function create(properties) {
            return new StarPublishInfo(properties);
        };

        /**
         * Encodes the specified StarPublishInfo message. Does not implicitly {@link coreproductpb.StarPublishInfo.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.StarPublishInfo
         * @static
         * @param {coreproductpb.IStarPublishInfo} m StarPublishInfo message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        StarPublishInfo.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.newProduct != null && Object.hasOwnProperty.call(m, "newProduct"))
                w.uint32(8).bool(m.newProduct);
            if (m.updateProduct != null && Object.hasOwnProperty.call(m, "updateProduct"))
                w.uint32(16).bool(m.updateProduct);
            if (m.expireProduct != null && Object.hasOwnProperty.call(m, "expireProduct"))
                w.uint32(24).bool(m.expireProduct);
            if (m.productStarPublished != null && Object.hasOwnProperty.call(m, "productStarPublished"))
                w.uint32(32).bool(m.productStarPublished);
            if (m.publicationError != null && Object.hasOwnProperty.call(m, "publicationError"))
                w.uint32(42).string(m.publicationError);
            return w;
        };

        /**
         * Decodes a StarPublishInfo message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.StarPublishInfo
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.StarPublishInfo} StarPublishInfo
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        StarPublishInfo.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.StarPublishInfo();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.newProduct = r.bool();
                    break;
                case 2:
                    m.updateProduct = r.bool();
                    break;
                case 3:
                    m.expireProduct = r.bool();
                    break;
                case 4:
                    m.productStarPublished = r.bool();
                    break;
                case 5:
                    m.publicationError = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return StarPublishInfo;
    })();

    coreproductpb.AdminProductResponse = (function() {

        /**
         * Properties of an AdminProductResponse.
         * @memberof coreproductpb
         * @interface IAdminProductResponse
         * @property {string|null} [productTemplateID] AdminProductResponse productTemplateID
         * @property {string|null} [productID] AdminProductResponse productID
         * @property {string|null} [starPVID] AdminProductResponse starPVID
         * @property {string|null} [starOldPV] AdminProductResponse starOldPV
         * @property {string|null} [productType] AdminProductResponse productType
         * @property {string|null} [name] AdminProductResponse name
         * @property {string|null} [description] AdminProductResponse description
         * @property {coreproductpb.IAdminProductAttributes|null} [attributes] AdminProductResponse attributes
         * @property {coreproductpb.IProductFeatures|null} [features] AdminProductResponse features
         * @property {google.protobuf.ITimestamp|null} [effectiveDate] AdminProductResponse effectiveDate
         * @property {google.protobuf.ITimestamp|null} [sunsetDate] AdminProductResponse sunsetDate
         * @property {google.protobuf.ITimestamp|null} [expirationDate] AdminProductResponse expirationDate
         * @property {string|null} [productTemplateVersionID] AdminProductResponse productTemplateVersionID
         * @property {coreproductpb.IStarPublishInfo|null} [starPublishInfo] AdminProductResponse starPublishInfo
         * @property {string|null} [starProductPlanID] AdminProductResponse starProductPlanID
         * @property {string|null} [starProductID] AdminProductResponse starProductID
         * @property {string|null} [status] AdminProductResponse status
         */

        /**
         * Constructs a new AdminProductResponse.
         * @memberof coreproductpb
         * @classdesc Represents an AdminProductResponse.
         * @implements IAdminProductResponse
         * @constructor
         * @param {coreproductpb.IAdminProductResponse=} [p] Properties to set
         */
        function AdminProductResponse(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * AdminProductResponse productTemplateID.
         * @member {string} productTemplateID
         * @memberof coreproductpb.AdminProductResponse
         * @instance
         */
        AdminProductResponse.prototype.productTemplateID = "";

        /**
         * AdminProductResponse productID.
         * @member {string} productID
         * @memberof coreproductpb.AdminProductResponse
         * @instance
         */
        AdminProductResponse.prototype.productID = "";

        /**
         * AdminProductResponse starPVID.
         * @member {string} starPVID
         * @memberof coreproductpb.AdminProductResponse
         * @instance
         */
        AdminProductResponse.prototype.starPVID = "";

        /**
         * AdminProductResponse starOldPV.
         * @member {string} starOldPV
         * @memberof coreproductpb.AdminProductResponse
         * @instance
         */
        AdminProductResponse.prototype.starOldPV = "";

        /**
         * AdminProductResponse productType.
         * @member {string} productType
         * @memberof coreproductpb.AdminProductResponse
         * @instance
         */
        AdminProductResponse.prototype.productType = "";

        /**
         * AdminProductResponse name.
         * @member {string} name
         * @memberof coreproductpb.AdminProductResponse
         * @instance
         */
        AdminProductResponse.prototype.name = "";

        /**
         * AdminProductResponse description.
         * @member {string} description
         * @memberof coreproductpb.AdminProductResponse
         * @instance
         */
        AdminProductResponse.prototype.description = "";

        /**
         * AdminProductResponse attributes.
         * @member {coreproductpb.IAdminProductAttributes|null|undefined} attributes
         * @memberof coreproductpb.AdminProductResponse
         * @instance
         */
        AdminProductResponse.prototype.attributes = null;

        /**
         * AdminProductResponse features.
         * @member {coreproductpb.IProductFeatures|null|undefined} features
         * @memberof coreproductpb.AdminProductResponse
         * @instance
         */
        AdminProductResponse.prototype.features = null;

        /**
         * AdminProductResponse effectiveDate.
         * @member {google.protobuf.ITimestamp|null|undefined} effectiveDate
         * @memberof coreproductpb.AdminProductResponse
         * @instance
         */
        AdminProductResponse.prototype.effectiveDate = null;

        /**
         * AdminProductResponse sunsetDate.
         * @member {google.protobuf.ITimestamp|null|undefined} sunsetDate
         * @memberof coreproductpb.AdminProductResponse
         * @instance
         */
        AdminProductResponse.prototype.sunsetDate = null;

        /**
         * AdminProductResponse expirationDate.
         * @member {google.protobuf.ITimestamp|null|undefined} expirationDate
         * @memberof coreproductpb.AdminProductResponse
         * @instance
         */
        AdminProductResponse.prototype.expirationDate = null;

        /**
         * AdminProductResponse productTemplateVersionID.
         * @member {string} productTemplateVersionID
         * @memberof coreproductpb.AdminProductResponse
         * @instance
         */
        AdminProductResponse.prototype.productTemplateVersionID = "";

        /**
         * AdminProductResponse starPublishInfo.
         * @member {coreproductpb.IStarPublishInfo|null|undefined} starPublishInfo
         * @memberof coreproductpb.AdminProductResponse
         * @instance
         */
        AdminProductResponse.prototype.starPublishInfo = null;

        /**
         * AdminProductResponse starProductPlanID.
         * @member {string} starProductPlanID
         * @memberof coreproductpb.AdminProductResponse
         * @instance
         */
        AdminProductResponse.prototype.starProductPlanID = "";

        /**
         * AdminProductResponse starProductID.
         * @member {string} starProductID
         * @memberof coreproductpb.AdminProductResponse
         * @instance
         */
        AdminProductResponse.prototype.starProductID = "";

        /**
         * AdminProductResponse status.
         * @member {string} status
         * @memberof coreproductpb.AdminProductResponse
         * @instance
         */
        AdminProductResponse.prototype.status = "";

        /**
         * Creates a new AdminProductResponse instance using the specified properties.
         * @function create
         * @memberof coreproductpb.AdminProductResponse
         * @static
         * @param {coreproductpb.IAdminProductResponse=} [properties] Properties to set
         * @returns {coreproductpb.AdminProductResponse} AdminProductResponse instance
         */
        AdminProductResponse.create = function create(properties) {
            return new AdminProductResponse(properties);
        };

        /**
         * Encodes the specified AdminProductResponse message. Does not implicitly {@link coreproductpb.AdminProductResponse.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.AdminProductResponse
         * @static
         * @param {coreproductpb.IAdminProductResponse} m AdminProductResponse message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AdminProductResponse.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.productTemplateID != null && Object.hasOwnProperty.call(m, "productTemplateID"))
                w.uint32(10).string(m.productTemplateID);
            if (m.productID != null && Object.hasOwnProperty.call(m, "productID"))
                w.uint32(18).string(m.productID);
            if (m.starPVID != null && Object.hasOwnProperty.call(m, "starPVID"))
                w.uint32(26).string(m.starPVID);
            if (m.starOldPV != null && Object.hasOwnProperty.call(m, "starOldPV"))
                w.uint32(34).string(m.starOldPV);
            if (m.productType != null && Object.hasOwnProperty.call(m, "productType"))
                w.uint32(42).string(m.productType);
            if (m.name != null && Object.hasOwnProperty.call(m, "name"))
                w.uint32(50).string(m.name);
            if (m.description != null && Object.hasOwnProperty.call(m, "description"))
                w.uint32(58).string(m.description);
            if (m.attributes != null && Object.hasOwnProperty.call(m, "attributes"))
                $root.coreproductpb.AdminProductAttributes.encode(m.attributes, w.uint32(66).fork()).ldelim();
            if (m.features != null && Object.hasOwnProperty.call(m, "features"))
                $root.coreproductpb.ProductFeatures.encode(m.features, w.uint32(74).fork()).ldelim();
            if (m.effectiveDate != null && Object.hasOwnProperty.call(m, "effectiveDate"))
                $root.google.protobuf.Timestamp.encode(m.effectiveDate, w.uint32(82).fork()).ldelim();
            if (m.sunsetDate != null && Object.hasOwnProperty.call(m, "sunsetDate"))
                $root.google.protobuf.Timestamp.encode(m.sunsetDate, w.uint32(90).fork()).ldelim();
            if (m.expirationDate != null && Object.hasOwnProperty.call(m, "expirationDate"))
                $root.google.protobuf.Timestamp.encode(m.expirationDate, w.uint32(98).fork()).ldelim();
            if (m.productTemplateVersionID != null && Object.hasOwnProperty.call(m, "productTemplateVersionID"))
                w.uint32(106).string(m.productTemplateVersionID);
            if (m.starPublishInfo != null && Object.hasOwnProperty.call(m, "starPublishInfo"))
                $root.coreproductpb.StarPublishInfo.encode(m.starPublishInfo, w.uint32(114).fork()).ldelim();
            if (m.starProductPlanID != null && Object.hasOwnProperty.call(m, "starProductPlanID"))
                w.uint32(122).string(m.starProductPlanID);
            if (m.starProductID != null && Object.hasOwnProperty.call(m, "starProductID"))
                w.uint32(130).string(m.starProductID);
            if (m.status != null && Object.hasOwnProperty.call(m, "status"))
                w.uint32(138).string(m.status);
            return w;
        };

        /**
         * Decodes an AdminProductResponse message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.AdminProductResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.AdminProductResponse} AdminProductResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AdminProductResponse.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.AdminProductResponse();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.productTemplateID = r.string();
                    break;
                case 2:
                    m.productID = r.string();
                    break;
                case 3:
                    m.starPVID = r.string();
                    break;
                case 4:
                    m.starOldPV = r.string();
                    break;
                case 5:
                    m.productType = r.string();
                    break;
                case 6:
                    m.name = r.string();
                    break;
                case 7:
                    m.description = r.string();
                    break;
                case 8:
                    m.attributes = $root.coreproductpb.AdminProductAttributes.decode(r, r.uint32());
                    break;
                case 9:
                    m.features = $root.coreproductpb.ProductFeatures.decode(r, r.uint32());
                    break;
                case 10:
                    m.effectiveDate = $root.google.protobuf.Timestamp.decode(r, r.uint32());
                    break;
                case 11:
                    m.sunsetDate = $root.google.protobuf.Timestamp.decode(r, r.uint32());
                    break;
                case 12:
                    m.expirationDate = $root.google.protobuf.Timestamp.decode(r, r.uint32());
                    break;
                case 13:
                    m.productTemplateVersionID = r.string();
                    break;
                case 14:
                    m.starPublishInfo = $root.coreproductpb.StarPublishInfo.decode(r, r.uint32());
                    break;
                case 15:
                    m.starProductPlanID = r.string();
                    break;
                case 16:
                    m.starProductID = r.string();
                    break;
                case 17:
                    m.status = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return AdminProductResponse;
    })();

    coreproductpb.AdminProductAttributes = (function() {

        /**
         * Properties of an AdminProductAttributes.
         * @memberof coreproductpb
         * @interface IAdminProductAttributes
         * @property {string|null} [brand] AdminProductAttributes brand
         * @property {string|null} [salesChannel] AdminProductAttributes salesChannel
         * @property {coreproductpb.TypedValue.ITimePeriod|null} [recallPeriod] AdminProductAttributes recallPeriod
         * @property {coreproductpb.TypedValue.ITimePeriod|null} [contractTerm] AdminProductAttributes contractTerm
         * @property {coreproductpb.TypedValue.ITimePeriod|null} [listingCoverageTerm] AdminProductAttributes listingCoverageTerm
         * @property {string|null} [listingCoverageBeneficiary] AdminProductAttributes listingCoverageBeneficiary
         * @property {coreproductpb.AdminProductAttributes.IAdminGeography|null} [geography] AdminProductAttributes geography
         * @property {coreproductpb.TypedValue.IStringList|null} [propertyType] AdminProductAttributes propertyType
         * @property {coreproductpb.TypedValue.IAreaRange|null} [propertySize] AdminProductAttributes propertySize
         * @property {coreproductpb.TypedValue.ITimePeriodRange|null} [propertyAge] AdminProductAttributes propertyAge
         * @property {coreproductpb.TypedValue.IStringList|null} [franchise] AdminProductAttributes franchise
         * @property {string|null} [salesGroup] AdminProductAttributes salesGroup
         * @property {coreproductpb.TypedValue.IStarFulfillmentList|null} [starFulfillments] AdminProductAttributes starFulfillments
         * @property {coreproductpb.TypedValue.IStarRemarkList|null} [starRemarks] AdminProductAttributes starRemarks
         * @property {coreproductpb.TypedValue.ITimePeriod|null} [repairWaitPeriod] AdminProductAttributes repairWaitPeriod
         * @property {coreproductpb.TypedValue.ITimePeriod|null} [maintenanceWaitPeriod] AdminProductAttributes maintenanceWaitPeriod
         * @property {common.IMoney|null} [aggregateCashOutAmount] AdminProductAttributes aggregateCashOutAmount
         * @property {coreproductpb.TypedValue.ITimePeriod|null} [postCashOutAssetRepairWaitPeriod] AdminProductAttributes postCashOutAssetRepairWaitPeriod
         * @property {common.IMoney|null} [aggregateRepairAmount] AdminProductAttributes aggregateRepairAmount
         * @property {common.IMoney|null} [diagnosisFee] AdminProductAttributes diagnosisFee
         * @property {common.IMoney|null} [maxItemRepairAmount] AdminProductAttributes maxItemRepairAmount
         * @property {common.IMoney|null} [maxCashOutAmount] AdminProductAttributes maxCashOutAmount
         * @property {common.IMoney|null} [maintenanceFee] AdminProductAttributes maintenanceFee
         * @property {number|null} [maxStreemCallCount] AdminProductAttributes maxStreemCallCount
         * @property {string|null} [geographyReferenceID] AdminProductAttributes geographyReferenceID
         */

        /**
         * Constructs a new AdminProductAttributes.
         * @memberof coreproductpb
         * @classdesc Represents an AdminProductAttributes.
         * @implements IAdminProductAttributes
         * @constructor
         * @param {coreproductpb.IAdminProductAttributes=} [p] Properties to set
         */
        function AdminProductAttributes(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * AdminProductAttributes brand.
         * @member {string} brand
         * @memberof coreproductpb.AdminProductAttributes
         * @instance
         */
        AdminProductAttributes.prototype.brand = "";

        /**
         * AdminProductAttributes salesChannel.
         * @member {string} salesChannel
         * @memberof coreproductpb.AdminProductAttributes
         * @instance
         */
        AdminProductAttributes.prototype.salesChannel = "";

        /**
         * AdminProductAttributes recallPeriod.
         * @member {coreproductpb.TypedValue.ITimePeriod|null|undefined} recallPeriod
         * @memberof coreproductpb.AdminProductAttributes
         * @instance
         */
        AdminProductAttributes.prototype.recallPeriod = null;

        /**
         * AdminProductAttributes contractTerm.
         * @member {coreproductpb.TypedValue.ITimePeriod|null|undefined} contractTerm
         * @memberof coreproductpb.AdminProductAttributes
         * @instance
         */
        AdminProductAttributes.prototype.contractTerm = null;

        /**
         * AdminProductAttributes listingCoverageTerm.
         * @member {coreproductpb.TypedValue.ITimePeriod|null|undefined} listingCoverageTerm
         * @memberof coreproductpb.AdminProductAttributes
         * @instance
         */
        AdminProductAttributes.prototype.listingCoverageTerm = null;

        /**
         * AdminProductAttributes listingCoverageBeneficiary.
         * @member {string} listingCoverageBeneficiary
         * @memberof coreproductpb.AdminProductAttributes
         * @instance
         */
        AdminProductAttributes.prototype.listingCoverageBeneficiary = "";

        /**
         * AdminProductAttributes geography.
         * @member {coreproductpb.AdminProductAttributes.IAdminGeography|null|undefined} geography
         * @memberof coreproductpb.AdminProductAttributes
         * @instance
         */
        AdminProductAttributes.prototype.geography = null;

        /**
         * AdminProductAttributes propertyType.
         * @member {coreproductpb.TypedValue.IStringList|null|undefined} propertyType
         * @memberof coreproductpb.AdminProductAttributes
         * @instance
         */
        AdminProductAttributes.prototype.propertyType = null;

        /**
         * AdminProductAttributes propertySize.
         * @member {coreproductpb.TypedValue.IAreaRange|null|undefined} propertySize
         * @memberof coreproductpb.AdminProductAttributes
         * @instance
         */
        AdminProductAttributes.prototype.propertySize = null;

        /**
         * AdminProductAttributes propertyAge.
         * @member {coreproductpb.TypedValue.ITimePeriodRange|null|undefined} propertyAge
         * @memberof coreproductpb.AdminProductAttributes
         * @instance
         */
        AdminProductAttributes.prototype.propertyAge = null;

        /**
         * AdminProductAttributes franchise.
         * @member {coreproductpb.TypedValue.IStringList|null|undefined} franchise
         * @memberof coreproductpb.AdminProductAttributes
         * @instance
         */
        AdminProductAttributes.prototype.franchise = null;

        /**
         * AdminProductAttributes salesGroup.
         * @member {string} salesGroup
         * @memberof coreproductpb.AdminProductAttributes
         * @instance
         */
        AdminProductAttributes.prototype.salesGroup = "";

        /**
         * AdminProductAttributes starFulfillments.
         * @member {coreproductpb.TypedValue.IStarFulfillmentList|null|undefined} starFulfillments
         * @memberof coreproductpb.AdminProductAttributes
         * @instance
         */
        AdminProductAttributes.prototype.starFulfillments = null;

        /**
         * AdminProductAttributes starRemarks.
         * @member {coreproductpb.TypedValue.IStarRemarkList|null|undefined} starRemarks
         * @memberof coreproductpb.AdminProductAttributes
         * @instance
         */
        AdminProductAttributes.prototype.starRemarks = null;

        /**
         * AdminProductAttributes repairWaitPeriod.
         * @member {coreproductpb.TypedValue.ITimePeriod|null|undefined} repairWaitPeriod
         * @memberof coreproductpb.AdminProductAttributes
         * @instance
         */
        AdminProductAttributes.prototype.repairWaitPeriod = null;

        /**
         * AdminProductAttributes maintenanceWaitPeriod.
         * @member {coreproductpb.TypedValue.ITimePeriod|null|undefined} maintenanceWaitPeriod
         * @memberof coreproductpb.AdminProductAttributes
         * @instance
         */
        AdminProductAttributes.prototype.maintenanceWaitPeriod = null;

        /**
         * AdminProductAttributes aggregateCashOutAmount.
         * @member {common.IMoney|null|undefined} aggregateCashOutAmount
         * @memberof coreproductpb.AdminProductAttributes
         * @instance
         */
        AdminProductAttributes.prototype.aggregateCashOutAmount = null;

        /**
         * AdminProductAttributes postCashOutAssetRepairWaitPeriod.
         * @member {coreproductpb.TypedValue.ITimePeriod|null|undefined} postCashOutAssetRepairWaitPeriod
         * @memberof coreproductpb.AdminProductAttributes
         * @instance
         */
        AdminProductAttributes.prototype.postCashOutAssetRepairWaitPeriod = null;

        /**
         * AdminProductAttributes aggregateRepairAmount.
         * @member {common.IMoney|null|undefined} aggregateRepairAmount
         * @memberof coreproductpb.AdminProductAttributes
         * @instance
         */
        AdminProductAttributes.prototype.aggregateRepairAmount = null;

        /**
         * AdminProductAttributes diagnosisFee.
         * @member {common.IMoney|null|undefined} diagnosisFee
         * @memberof coreproductpb.AdminProductAttributes
         * @instance
         */
        AdminProductAttributes.prototype.diagnosisFee = null;

        /**
         * AdminProductAttributes maxItemRepairAmount.
         * @member {common.IMoney|null|undefined} maxItemRepairAmount
         * @memberof coreproductpb.AdminProductAttributes
         * @instance
         */
        AdminProductAttributes.prototype.maxItemRepairAmount = null;

        /**
         * AdminProductAttributes maxCashOutAmount.
         * @member {common.IMoney|null|undefined} maxCashOutAmount
         * @memberof coreproductpb.AdminProductAttributes
         * @instance
         */
        AdminProductAttributes.prototype.maxCashOutAmount = null;

        /**
         * AdminProductAttributes maintenanceFee.
         * @member {common.IMoney|null|undefined} maintenanceFee
         * @memberof coreproductpb.AdminProductAttributes
         * @instance
         */
        AdminProductAttributes.prototype.maintenanceFee = null;

        /**
         * AdminProductAttributes maxStreemCallCount.
         * @member {number} maxStreemCallCount
         * @memberof coreproductpb.AdminProductAttributes
         * @instance
         */
        AdminProductAttributes.prototype.maxStreemCallCount = 0;

        /**
         * AdminProductAttributes geographyReferenceID.
         * @member {string} geographyReferenceID
         * @memberof coreproductpb.AdminProductAttributes
         * @instance
         */
        AdminProductAttributes.prototype.geographyReferenceID = "";

        /**
         * Creates a new AdminProductAttributes instance using the specified properties.
         * @function create
         * @memberof coreproductpb.AdminProductAttributes
         * @static
         * @param {coreproductpb.IAdminProductAttributes=} [properties] Properties to set
         * @returns {coreproductpb.AdminProductAttributes} AdminProductAttributes instance
         */
        AdminProductAttributes.create = function create(properties) {
            return new AdminProductAttributes(properties);
        };

        /**
         * Encodes the specified AdminProductAttributes message. Does not implicitly {@link coreproductpb.AdminProductAttributes.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.AdminProductAttributes
         * @static
         * @param {coreproductpb.IAdminProductAttributes} m AdminProductAttributes message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AdminProductAttributes.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.brand != null && Object.hasOwnProperty.call(m, "brand"))
                w.uint32(10).string(m.brand);
            if (m.salesChannel != null && Object.hasOwnProperty.call(m, "salesChannel"))
                w.uint32(18).string(m.salesChannel);
            if (m.recallPeriod != null && Object.hasOwnProperty.call(m, "recallPeriod"))
                $root.coreproductpb.TypedValue.TimePeriod.encode(m.recallPeriod, w.uint32(26).fork()).ldelim();
            if (m.contractTerm != null && Object.hasOwnProperty.call(m, "contractTerm"))
                $root.coreproductpb.TypedValue.TimePeriod.encode(m.contractTerm, w.uint32(34).fork()).ldelim();
            if (m.listingCoverageTerm != null && Object.hasOwnProperty.call(m, "listingCoverageTerm"))
                $root.coreproductpb.TypedValue.TimePeriod.encode(m.listingCoverageTerm, w.uint32(42).fork()).ldelim();
            if (m.listingCoverageBeneficiary != null && Object.hasOwnProperty.call(m, "listingCoverageBeneficiary"))
                w.uint32(50).string(m.listingCoverageBeneficiary);
            if (m.geography != null && Object.hasOwnProperty.call(m, "geography"))
                $root.coreproductpb.AdminProductAttributes.AdminGeography.encode(m.geography, w.uint32(58).fork()).ldelim();
            if (m.propertyType != null && Object.hasOwnProperty.call(m, "propertyType"))
                $root.coreproductpb.TypedValue.StringList.encode(m.propertyType, w.uint32(66).fork()).ldelim();
            if (m.propertySize != null && Object.hasOwnProperty.call(m, "propertySize"))
                $root.coreproductpb.TypedValue.AreaRange.encode(m.propertySize, w.uint32(74).fork()).ldelim();
            if (m.propertyAge != null && Object.hasOwnProperty.call(m, "propertyAge"))
                $root.coreproductpb.TypedValue.TimePeriodRange.encode(m.propertyAge, w.uint32(82).fork()).ldelim();
            if (m.franchise != null && Object.hasOwnProperty.call(m, "franchise"))
                $root.coreproductpb.TypedValue.StringList.encode(m.franchise, w.uint32(90).fork()).ldelim();
            if (m.salesGroup != null && Object.hasOwnProperty.call(m, "salesGroup"))
                w.uint32(98).string(m.salesGroup);
            if (m.starFulfillments != null && Object.hasOwnProperty.call(m, "starFulfillments"))
                $root.coreproductpb.TypedValue.StarFulfillmentList.encode(m.starFulfillments, w.uint32(106).fork()).ldelim();
            if (m.starRemarks != null && Object.hasOwnProperty.call(m, "starRemarks"))
                $root.coreproductpb.TypedValue.StarRemarkList.encode(m.starRemarks, w.uint32(114).fork()).ldelim();
            if (m.repairWaitPeriod != null && Object.hasOwnProperty.call(m, "repairWaitPeriod"))
                $root.coreproductpb.TypedValue.TimePeriod.encode(m.repairWaitPeriod, w.uint32(122).fork()).ldelim();
            if (m.maintenanceWaitPeriod != null && Object.hasOwnProperty.call(m, "maintenanceWaitPeriod"))
                $root.coreproductpb.TypedValue.TimePeriod.encode(m.maintenanceWaitPeriod, w.uint32(130).fork()).ldelim();
            if (m.aggregateCashOutAmount != null && Object.hasOwnProperty.call(m, "aggregateCashOutAmount"))
                $root.common.Money.encode(m.aggregateCashOutAmount, w.uint32(138).fork()).ldelim();
            if (m.postCashOutAssetRepairWaitPeriod != null && Object.hasOwnProperty.call(m, "postCashOutAssetRepairWaitPeriod"))
                $root.coreproductpb.TypedValue.TimePeriod.encode(m.postCashOutAssetRepairWaitPeriod, w.uint32(146).fork()).ldelim();
            if (m.aggregateRepairAmount != null && Object.hasOwnProperty.call(m, "aggregateRepairAmount"))
                $root.common.Money.encode(m.aggregateRepairAmount, w.uint32(154).fork()).ldelim();
            if (m.diagnosisFee != null && Object.hasOwnProperty.call(m, "diagnosisFee"))
                $root.common.Money.encode(m.diagnosisFee, w.uint32(162).fork()).ldelim();
            if (m.maxItemRepairAmount != null && Object.hasOwnProperty.call(m, "maxItemRepairAmount"))
                $root.common.Money.encode(m.maxItemRepairAmount, w.uint32(170).fork()).ldelim();
            if (m.maxCashOutAmount != null && Object.hasOwnProperty.call(m, "maxCashOutAmount"))
                $root.common.Money.encode(m.maxCashOutAmount, w.uint32(178).fork()).ldelim();
            if (m.maintenanceFee != null && Object.hasOwnProperty.call(m, "maintenanceFee"))
                $root.common.Money.encode(m.maintenanceFee, w.uint32(186).fork()).ldelim();
            if (m.maxStreemCallCount != null && Object.hasOwnProperty.call(m, "maxStreemCallCount"))
                w.uint32(192).int32(m.maxStreemCallCount);
            if (m.geographyReferenceID != null && Object.hasOwnProperty.call(m, "geographyReferenceID"))
                w.uint32(202).string(m.geographyReferenceID);
            return w;
        };

        /**
         * Decodes an AdminProductAttributes message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.AdminProductAttributes
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.AdminProductAttributes} AdminProductAttributes
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AdminProductAttributes.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.AdminProductAttributes();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.brand = r.string();
                    break;
                case 2:
                    m.salesChannel = r.string();
                    break;
                case 3:
                    m.recallPeriod = $root.coreproductpb.TypedValue.TimePeriod.decode(r, r.uint32());
                    break;
                case 4:
                    m.contractTerm = $root.coreproductpb.TypedValue.TimePeriod.decode(r, r.uint32());
                    break;
                case 5:
                    m.listingCoverageTerm = $root.coreproductpb.TypedValue.TimePeriod.decode(r, r.uint32());
                    break;
                case 6:
                    m.listingCoverageBeneficiary = r.string();
                    break;
                case 7:
                    m.geography = $root.coreproductpb.AdminProductAttributes.AdminGeography.decode(r, r.uint32());
                    break;
                case 8:
                    m.propertyType = $root.coreproductpb.TypedValue.StringList.decode(r, r.uint32());
                    break;
                case 9:
                    m.propertySize = $root.coreproductpb.TypedValue.AreaRange.decode(r, r.uint32());
                    break;
                case 10:
                    m.propertyAge = $root.coreproductpb.TypedValue.TimePeriodRange.decode(r, r.uint32());
                    break;
                case 11:
                    m.franchise = $root.coreproductpb.TypedValue.StringList.decode(r, r.uint32());
                    break;
                case 12:
                    m.salesGroup = r.string();
                    break;
                case 13:
                    m.starFulfillments = $root.coreproductpb.TypedValue.StarFulfillmentList.decode(r, r.uint32());
                    break;
                case 14:
                    m.starRemarks = $root.coreproductpb.TypedValue.StarRemarkList.decode(r, r.uint32());
                    break;
                case 15:
                    m.repairWaitPeriod = $root.coreproductpb.TypedValue.TimePeriod.decode(r, r.uint32());
                    break;
                case 16:
                    m.maintenanceWaitPeriod = $root.coreproductpb.TypedValue.TimePeriod.decode(r, r.uint32());
                    break;
                case 17:
                    m.aggregateCashOutAmount = $root.common.Money.decode(r, r.uint32());
                    break;
                case 18:
                    m.postCashOutAssetRepairWaitPeriod = $root.coreproductpb.TypedValue.TimePeriod.decode(r, r.uint32());
                    break;
                case 19:
                    m.aggregateRepairAmount = $root.common.Money.decode(r, r.uint32());
                    break;
                case 20:
                    m.diagnosisFee = $root.common.Money.decode(r, r.uint32());
                    break;
                case 21:
                    m.maxItemRepairAmount = $root.common.Money.decode(r, r.uint32());
                    break;
                case 22:
                    m.maxCashOutAmount = $root.common.Money.decode(r, r.uint32());
                    break;
                case 23:
                    m.maintenanceFee = $root.common.Money.decode(r, r.uint32());
                    break;
                case 24:
                    m.maxStreemCallCount = r.int32();
                    break;
                case 25:
                    m.geographyReferenceID = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        AdminProductAttributes.AdminGeography = (function() {

            /**
             * Properties of an AdminGeography.
             * @memberof coreproductpb.AdminProductAttributes
             * @interface IAdminGeography
             * @property {boolean|null} [nationwide] AdminGeography nationwide
             * @property {coreproductpb.IStateIncludeExclude|null} [states] AdminGeography states
             * @property {coreproductpb.IZipCodeIncludeExclude|null} [zipCodes] AdminGeography zipCodes
             * @property {google.protobuf.ITimestamp|null} [expirationDate] AdminGeography expirationDate
             * @property {google.protobuf.ITimestamp|null} [effectiveDate] AdminGeography effectiveDate
             */

            /**
             * Constructs a new AdminGeography.
             * @memberof coreproductpb.AdminProductAttributes
             * @classdesc Represents an AdminGeography.
             * @implements IAdminGeography
             * @constructor
             * @param {coreproductpb.AdminProductAttributes.IAdminGeography=} [p] Properties to set
             */
            function AdminGeography(p) {
                if (p)
                    for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                        if (p[ks[i]] != null)
                            this[ks[i]] = p[ks[i]];
            }

            /**
             * AdminGeography nationwide.
             * @member {boolean} nationwide
             * @memberof coreproductpb.AdminProductAttributes.AdminGeography
             * @instance
             */
            AdminGeography.prototype.nationwide = false;

            /**
             * AdminGeography states.
             * @member {coreproductpb.IStateIncludeExclude|null|undefined} states
             * @memberof coreproductpb.AdminProductAttributes.AdminGeography
             * @instance
             */
            AdminGeography.prototype.states = null;

            /**
             * AdminGeography zipCodes.
             * @member {coreproductpb.IZipCodeIncludeExclude|null|undefined} zipCodes
             * @memberof coreproductpb.AdminProductAttributes.AdminGeography
             * @instance
             */
            AdminGeography.prototype.zipCodes = null;

            /**
             * AdminGeography expirationDate.
             * @member {google.protobuf.ITimestamp|null|undefined} expirationDate
             * @memberof coreproductpb.AdminProductAttributes.AdminGeography
             * @instance
             */
            AdminGeography.prototype.expirationDate = null;

            /**
             * AdminGeography effectiveDate.
             * @member {google.protobuf.ITimestamp|null|undefined} effectiveDate
             * @memberof coreproductpb.AdminProductAttributes.AdminGeography
             * @instance
             */
            AdminGeography.prototype.effectiveDate = null;

            /**
             * Creates a new AdminGeography instance using the specified properties.
             * @function create
             * @memberof coreproductpb.AdminProductAttributes.AdminGeography
             * @static
             * @param {coreproductpb.AdminProductAttributes.IAdminGeography=} [properties] Properties to set
             * @returns {coreproductpb.AdminProductAttributes.AdminGeography} AdminGeography instance
             */
            AdminGeography.create = function create(properties) {
                return new AdminGeography(properties);
            };

            /**
             * Encodes the specified AdminGeography message. Does not implicitly {@link coreproductpb.AdminProductAttributes.AdminGeography.verify|verify} messages.
             * @function encode
             * @memberof coreproductpb.AdminProductAttributes.AdminGeography
             * @static
             * @param {coreproductpb.AdminProductAttributes.IAdminGeography} m AdminGeography message or plain object to encode
             * @param {$protobuf.Writer} [w] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            AdminGeography.encode = function encode(m, w) {
                if (!w)
                    w = $Writer.create();
                if (m.nationwide != null && Object.hasOwnProperty.call(m, "nationwide"))
                    w.uint32(8).bool(m.nationwide);
                if (m.states != null && Object.hasOwnProperty.call(m, "states"))
                    $root.coreproductpb.StateIncludeExclude.encode(m.states, w.uint32(18).fork()).ldelim();
                if (m.zipCodes != null && Object.hasOwnProperty.call(m, "zipCodes"))
                    $root.coreproductpb.ZipCodeIncludeExclude.encode(m.zipCodes, w.uint32(26).fork()).ldelim();
                if (m.expirationDate != null && Object.hasOwnProperty.call(m, "expirationDate"))
                    $root.google.protobuf.Timestamp.encode(m.expirationDate, w.uint32(34).fork()).ldelim();
                if (m.effectiveDate != null && Object.hasOwnProperty.call(m, "effectiveDate"))
                    $root.google.protobuf.Timestamp.encode(m.effectiveDate, w.uint32(42).fork()).ldelim();
                return w;
            };

            /**
             * Decodes an AdminGeography message from the specified reader or buffer.
             * @function decode
             * @memberof coreproductpb.AdminProductAttributes.AdminGeography
             * @static
             * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
             * @param {number} [l] Message length if known beforehand
             * @returns {coreproductpb.AdminProductAttributes.AdminGeography} AdminGeography
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            AdminGeography.decode = function decode(r, l) {
                if (!(r instanceof $Reader))
                    r = $Reader.create(r);
                var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.AdminProductAttributes.AdminGeography();
                while (r.pos < c) {
                    var t = r.uint32();
                    switch (t >>> 3) {
                    case 1:
                        m.nationwide = r.bool();
                        break;
                    case 2:
                        m.states = $root.coreproductpb.StateIncludeExclude.decode(r, r.uint32());
                        break;
                    case 3:
                        m.zipCodes = $root.coreproductpb.ZipCodeIncludeExclude.decode(r, r.uint32());
                        break;
                    case 4:
                        m.expirationDate = $root.google.protobuf.Timestamp.decode(r, r.uint32());
                        break;
                    case 5:
                        m.effectiveDate = $root.google.protobuf.Timestamp.decode(r, r.uint32());
                        break;
                    default:
                        r.skipType(t & 7);
                        break;
                    }
                }
                return m;
            };

            return AdminGeography;
        })();

        return AdminProductAttributes;
    })();

    coreproductpb.ProductAttributes = (function() {

        /**
         * Properties of a ProductAttributes.
         * @memberof coreproductpb
         * @interface IProductAttributes
         * @property {string|null} [brand] ProductAttributes brand
         * @property {string|null} [salesChannel] ProductAttributes salesChannel
         * @property {coreproductpb.TypedValue.ITimePeriod|null} [recallPeriod] ProductAttributes recallPeriod
         * @property {coreproductpb.TypedValue.ITimePeriod|null} [contractTerm] ProductAttributes contractTerm
         * @property {coreproductpb.TypedValue.ITimePeriod|null} [listingCoverageTerm] ProductAttributes listingCoverageTerm
         * @property {string|null} [listingCoverageBeneficiary] ProductAttributes listingCoverageBeneficiary
         * @property {coreproductpb.TypedValue.IGeography|null} [geography] ProductAttributes geography
         * @property {coreproductpb.TypedValue.IStringList|null} [propertyType] ProductAttributes propertyType
         * @property {coreproductpb.TypedValue.IAreaRange|null} [propertySize] ProductAttributes propertySize
         * @property {coreproductpb.TypedValue.ITimePeriodRange|null} [propertyAge] ProductAttributes propertyAge
         * @property {coreproductpb.TypedValue.IStringList|null} [franchise] ProductAttributes franchise
         * @property {string|null} [salesGroup] ProductAttributes salesGroup
         * @property {coreproductpb.TypedValue.IStarFulfillmentList|null} [starFulfillments] ProductAttributes starFulfillments
         * @property {coreproductpb.TypedValue.IStarRemarkList|null} [starRemarks] ProductAttributes starRemarks
         * @property {coreproductpb.TypedValue.ITimePeriod|null} [repairWaitPeriod] ProductAttributes repairWaitPeriod
         * @property {coreproductpb.TypedValue.ITimePeriod|null} [maintenanceWaitPeriod] ProductAttributes maintenanceWaitPeriod
         * @property {common.IMoney|null} [aggregateCashOutAmount] ProductAttributes aggregateCashOutAmount
         * @property {coreproductpb.TypedValue.ITimePeriod|null} [postCashOutAssetRepairWaitPeriod] ProductAttributes postCashOutAssetRepairWaitPeriod
         * @property {common.IMoney|null} [aggregateRepairAmount] ProductAttributes aggregateRepairAmount
         * @property {common.IMoney|null} [diagnosisFee] ProductAttributes diagnosisFee
         * @property {common.IMoney|null} [maxItemRepairAmount] ProductAttributes maxItemRepairAmount
         * @property {common.IMoney|null} [maxCashOutAmount] ProductAttributes maxCashOutAmount
         * @property {common.IMoney|null} [maintenanceFee] ProductAttributes maintenanceFee
         * @property {number|null} [maxStreemCallCount] ProductAttributes maxStreemCallCount
         */

        /**
         * Constructs a new ProductAttributes.
         * @memberof coreproductpb
         * @classdesc Represents a ProductAttributes.
         * @implements IProductAttributes
         * @constructor
         * @param {coreproductpb.IProductAttributes=} [p] Properties to set
         */
        function ProductAttributes(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * ProductAttributes brand.
         * @member {string} brand
         * @memberof coreproductpb.ProductAttributes
         * @instance
         */
        ProductAttributes.prototype.brand = "";

        /**
         * ProductAttributes salesChannel.
         * @member {string} salesChannel
         * @memberof coreproductpb.ProductAttributes
         * @instance
         */
        ProductAttributes.prototype.salesChannel = "";

        /**
         * ProductAttributes recallPeriod.
         * @member {coreproductpb.TypedValue.ITimePeriod|null|undefined} recallPeriod
         * @memberof coreproductpb.ProductAttributes
         * @instance
         */
        ProductAttributes.prototype.recallPeriod = null;

        /**
         * ProductAttributes contractTerm.
         * @member {coreproductpb.TypedValue.ITimePeriod|null|undefined} contractTerm
         * @memberof coreproductpb.ProductAttributes
         * @instance
         */
        ProductAttributes.prototype.contractTerm = null;

        /**
         * ProductAttributes listingCoverageTerm.
         * @member {coreproductpb.TypedValue.ITimePeriod|null|undefined} listingCoverageTerm
         * @memberof coreproductpb.ProductAttributes
         * @instance
         */
        ProductAttributes.prototype.listingCoverageTerm = null;

        /**
         * ProductAttributes listingCoverageBeneficiary.
         * @member {string} listingCoverageBeneficiary
         * @memberof coreproductpb.ProductAttributes
         * @instance
         */
        ProductAttributes.prototype.listingCoverageBeneficiary = "";

        /**
         * ProductAttributes geography.
         * @member {coreproductpb.TypedValue.IGeography|null|undefined} geography
         * @memberof coreproductpb.ProductAttributes
         * @instance
         */
        ProductAttributes.prototype.geography = null;

        /**
         * ProductAttributes propertyType.
         * @member {coreproductpb.TypedValue.IStringList|null|undefined} propertyType
         * @memberof coreproductpb.ProductAttributes
         * @instance
         */
        ProductAttributes.prototype.propertyType = null;

        /**
         * ProductAttributes propertySize.
         * @member {coreproductpb.TypedValue.IAreaRange|null|undefined} propertySize
         * @memberof coreproductpb.ProductAttributes
         * @instance
         */
        ProductAttributes.prototype.propertySize = null;

        /**
         * ProductAttributes propertyAge.
         * @member {coreproductpb.TypedValue.ITimePeriodRange|null|undefined} propertyAge
         * @memberof coreproductpb.ProductAttributes
         * @instance
         */
        ProductAttributes.prototype.propertyAge = null;

        /**
         * ProductAttributes franchise.
         * @member {coreproductpb.TypedValue.IStringList|null|undefined} franchise
         * @memberof coreproductpb.ProductAttributes
         * @instance
         */
        ProductAttributes.prototype.franchise = null;

        /**
         * ProductAttributes salesGroup.
         * @member {string} salesGroup
         * @memberof coreproductpb.ProductAttributes
         * @instance
         */
        ProductAttributes.prototype.salesGroup = "";

        /**
         * ProductAttributes starFulfillments.
         * @member {coreproductpb.TypedValue.IStarFulfillmentList|null|undefined} starFulfillments
         * @memberof coreproductpb.ProductAttributes
         * @instance
         */
        ProductAttributes.prototype.starFulfillments = null;

        /**
         * ProductAttributes starRemarks.
         * @member {coreproductpb.TypedValue.IStarRemarkList|null|undefined} starRemarks
         * @memberof coreproductpb.ProductAttributes
         * @instance
         */
        ProductAttributes.prototype.starRemarks = null;

        /**
         * ProductAttributes repairWaitPeriod.
         * @member {coreproductpb.TypedValue.ITimePeriod|null|undefined} repairWaitPeriod
         * @memberof coreproductpb.ProductAttributes
         * @instance
         */
        ProductAttributes.prototype.repairWaitPeriod = null;

        /**
         * ProductAttributes maintenanceWaitPeriod.
         * @member {coreproductpb.TypedValue.ITimePeriod|null|undefined} maintenanceWaitPeriod
         * @memberof coreproductpb.ProductAttributes
         * @instance
         */
        ProductAttributes.prototype.maintenanceWaitPeriod = null;

        /**
         * ProductAttributes aggregateCashOutAmount.
         * @member {common.IMoney|null|undefined} aggregateCashOutAmount
         * @memberof coreproductpb.ProductAttributes
         * @instance
         */
        ProductAttributes.prototype.aggregateCashOutAmount = null;

        /**
         * ProductAttributes postCashOutAssetRepairWaitPeriod.
         * @member {coreproductpb.TypedValue.ITimePeriod|null|undefined} postCashOutAssetRepairWaitPeriod
         * @memberof coreproductpb.ProductAttributes
         * @instance
         */
        ProductAttributes.prototype.postCashOutAssetRepairWaitPeriod = null;

        /**
         * ProductAttributes aggregateRepairAmount.
         * @member {common.IMoney|null|undefined} aggregateRepairAmount
         * @memberof coreproductpb.ProductAttributes
         * @instance
         */
        ProductAttributes.prototype.aggregateRepairAmount = null;

        /**
         * ProductAttributes diagnosisFee.
         * @member {common.IMoney|null|undefined} diagnosisFee
         * @memberof coreproductpb.ProductAttributes
         * @instance
         */
        ProductAttributes.prototype.diagnosisFee = null;

        /**
         * ProductAttributes maxItemRepairAmount.
         * @member {common.IMoney|null|undefined} maxItemRepairAmount
         * @memberof coreproductpb.ProductAttributes
         * @instance
         */
        ProductAttributes.prototype.maxItemRepairAmount = null;

        /**
         * ProductAttributes maxCashOutAmount.
         * @member {common.IMoney|null|undefined} maxCashOutAmount
         * @memberof coreproductpb.ProductAttributes
         * @instance
         */
        ProductAttributes.prototype.maxCashOutAmount = null;

        /**
         * ProductAttributes maintenanceFee.
         * @member {common.IMoney|null|undefined} maintenanceFee
         * @memberof coreproductpb.ProductAttributes
         * @instance
         */
        ProductAttributes.prototype.maintenanceFee = null;

        /**
         * ProductAttributes maxStreemCallCount.
         * @member {number} maxStreemCallCount
         * @memberof coreproductpb.ProductAttributes
         * @instance
         */
        ProductAttributes.prototype.maxStreemCallCount = 0;

        /**
         * Creates a new ProductAttributes instance using the specified properties.
         * @function create
         * @memberof coreproductpb.ProductAttributes
         * @static
         * @param {coreproductpb.IProductAttributes=} [properties] Properties to set
         * @returns {coreproductpb.ProductAttributes} ProductAttributes instance
         */
        ProductAttributes.create = function create(properties) {
            return new ProductAttributes(properties);
        };

        /**
         * Encodes the specified ProductAttributes message. Does not implicitly {@link coreproductpb.ProductAttributes.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.ProductAttributes
         * @static
         * @param {coreproductpb.IProductAttributes} m ProductAttributes message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ProductAttributes.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.brand != null && Object.hasOwnProperty.call(m, "brand"))
                w.uint32(10).string(m.brand);
            if (m.salesChannel != null && Object.hasOwnProperty.call(m, "salesChannel"))
                w.uint32(18).string(m.salesChannel);
            if (m.recallPeriod != null && Object.hasOwnProperty.call(m, "recallPeriod"))
                $root.coreproductpb.TypedValue.TimePeriod.encode(m.recallPeriod, w.uint32(26).fork()).ldelim();
            if (m.contractTerm != null && Object.hasOwnProperty.call(m, "contractTerm"))
                $root.coreproductpb.TypedValue.TimePeriod.encode(m.contractTerm, w.uint32(34).fork()).ldelim();
            if (m.listingCoverageTerm != null && Object.hasOwnProperty.call(m, "listingCoverageTerm"))
                $root.coreproductpb.TypedValue.TimePeriod.encode(m.listingCoverageTerm, w.uint32(42).fork()).ldelim();
            if (m.listingCoverageBeneficiary != null && Object.hasOwnProperty.call(m, "listingCoverageBeneficiary"))
                w.uint32(50).string(m.listingCoverageBeneficiary);
            if (m.geography != null && Object.hasOwnProperty.call(m, "geography"))
                $root.coreproductpb.TypedValue.Geography.encode(m.geography, w.uint32(58).fork()).ldelim();
            if (m.propertyType != null && Object.hasOwnProperty.call(m, "propertyType"))
                $root.coreproductpb.TypedValue.StringList.encode(m.propertyType, w.uint32(66).fork()).ldelim();
            if (m.propertySize != null && Object.hasOwnProperty.call(m, "propertySize"))
                $root.coreproductpb.TypedValue.AreaRange.encode(m.propertySize, w.uint32(74).fork()).ldelim();
            if (m.propertyAge != null && Object.hasOwnProperty.call(m, "propertyAge"))
                $root.coreproductpb.TypedValue.TimePeriodRange.encode(m.propertyAge, w.uint32(82).fork()).ldelim();
            if (m.franchise != null && Object.hasOwnProperty.call(m, "franchise"))
                $root.coreproductpb.TypedValue.StringList.encode(m.franchise, w.uint32(90).fork()).ldelim();
            if (m.salesGroup != null && Object.hasOwnProperty.call(m, "salesGroup"))
                w.uint32(98).string(m.salesGroup);
            if (m.starFulfillments != null && Object.hasOwnProperty.call(m, "starFulfillments"))
                $root.coreproductpb.TypedValue.StarFulfillmentList.encode(m.starFulfillments, w.uint32(106).fork()).ldelim();
            if (m.starRemarks != null && Object.hasOwnProperty.call(m, "starRemarks"))
                $root.coreproductpb.TypedValue.StarRemarkList.encode(m.starRemarks, w.uint32(114).fork()).ldelim();
            if (m.repairWaitPeriod != null && Object.hasOwnProperty.call(m, "repairWaitPeriod"))
                $root.coreproductpb.TypedValue.TimePeriod.encode(m.repairWaitPeriod, w.uint32(122).fork()).ldelim();
            if (m.maintenanceWaitPeriod != null && Object.hasOwnProperty.call(m, "maintenanceWaitPeriod"))
                $root.coreproductpb.TypedValue.TimePeriod.encode(m.maintenanceWaitPeriod, w.uint32(130).fork()).ldelim();
            if (m.aggregateCashOutAmount != null && Object.hasOwnProperty.call(m, "aggregateCashOutAmount"))
                $root.common.Money.encode(m.aggregateCashOutAmount, w.uint32(138).fork()).ldelim();
            if (m.postCashOutAssetRepairWaitPeriod != null && Object.hasOwnProperty.call(m, "postCashOutAssetRepairWaitPeriod"))
                $root.coreproductpb.TypedValue.TimePeriod.encode(m.postCashOutAssetRepairWaitPeriod, w.uint32(146).fork()).ldelim();
            if (m.aggregateRepairAmount != null && Object.hasOwnProperty.call(m, "aggregateRepairAmount"))
                $root.common.Money.encode(m.aggregateRepairAmount, w.uint32(154).fork()).ldelim();
            if (m.diagnosisFee != null && Object.hasOwnProperty.call(m, "diagnosisFee"))
                $root.common.Money.encode(m.diagnosisFee, w.uint32(162).fork()).ldelim();
            if (m.maxItemRepairAmount != null && Object.hasOwnProperty.call(m, "maxItemRepairAmount"))
                $root.common.Money.encode(m.maxItemRepairAmount, w.uint32(170).fork()).ldelim();
            if (m.maxCashOutAmount != null && Object.hasOwnProperty.call(m, "maxCashOutAmount"))
                $root.common.Money.encode(m.maxCashOutAmount, w.uint32(178).fork()).ldelim();
            if (m.maintenanceFee != null && Object.hasOwnProperty.call(m, "maintenanceFee"))
                $root.common.Money.encode(m.maintenanceFee, w.uint32(186).fork()).ldelim();
            if (m.maxStreemCallCount != null && Object.hasOwnProperty.call(m, "maxStreemCallCount"))
                w.uint32(192).int32(m.maxStreemCallCount);
            return w;
        };

        /**
         * Decodes a ProductAttributes message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.ProductAttributes
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.ProductAttributes} ProductAttributes
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ProductAttributes.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.ProductAttributes();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.brand = r.string();
                    break;
                case 2:
                    m.salesChannel = r.string();
                    break;
                case 3:
                    m.recallPeriod = $root.coreproductpb.TypedValue.TimePeriod.decode(r, r.uint32());
                    break;
                case 4:
                    m.contractTerm = $root.coreproductpb.TypedValue.TimePeriod.decode(r, r.uint32());
                    break;
                case 5:
                    m.listingCoverageTerm = $root.coreproductpb.TypedValue.TimePeriod.decode(r, r.uint32());
                    break;
                case 6:
                    m.listingCoverageBeneficiary = r.string();
                    break;
                case 7:
                    m.geography = $root.coreproductpb.TypedValue.Geography.decode(r, r.uint32());
                    break;
                case 8:
                    m.propertyType = $root.coreproductpb.TypedValue.StringList.decode(r, r.uint32());
                    break;
                case 9:
                    m.propertySize = $root.coreproductpb.TypedValue.AreaRange.decode(r, r.uint32());
                    break;
                case 10:
                    m.propertyAge = $root.coreproductpb.TypedValue.TimePeriodRange.decode(r, r.uint32());
                    break;
                case 11:
                    m.franchise = $root.coreproductpb.TypedValue.StringList.decode(r, r.uint32());
                    break;
                case 12:
                    m.salesGroup = r.string();
                    break;
                case 13:
                    m.starFulfillments = $root.coreproductpb.TypedValue.StarFulfillmentList.decode(r, r.uint32());
                    break;
                case 14:
                    m.starRemarks = $root.coreproductpb.TypedValue.StarRemarkList.decode(r, r.uint32());
                    break;
                case 15:
                    m.repairWaitPeriod = $root.coreproductpb.TypedValue.TimePeriod.decode(r, r.uint32());
                    break;
                case 16:
                    m.maintenanceWaitPeriod = $root.coreproductpb.TypedValue.TimePeriod.decode(r, r.uint32());
                    break;
                case 17:
                    m.aggregateCashOutAmount = $root.common.Money.decode(r, r.uint32());
                    break;
                case 18:
                    m.postCashOutAssetRepairWaitPeriod = $root.coreproductpb.TypedValue.TimePeriod.decode(r, r.uint32());
                    break;
                case 19:
                    m.aggregateRepairAmount = $root.common.Money.decode(r, r.uint32());
                    break;
                case 20:
                    m.diagnosisFee = $root.common.Money.decode(r, r.uint32());
                    break;
                case 21:
                    m.maxItemRepairAmount = $root.common.Money.decode(r, r.uint32());
                    break;
                case 22:
                    m.maxCashOutAmount = $root.common.Money.decode(r, r.uint32());
                    break;
                case 23:
                    m.maintenanceFee = $root.common.Money.decode(r, r.uint32());
                    break;
                case 24:
                    m.maxStreemCallCount = r.int32();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return ProductAttributes;
    })();

    coreproductpb.GetProductsByTemplateIDRequest = (function() {

        /**
         * Properties of a GetProductsByTemplateIDRequest.
         * @memberof coreproductpb
         * @interface IGetProductsByTemplateIDRequest
         * @property {string|null} [productTemplateID] GetProductsByTemplateIDRequest productTemplateID
         * @property {string|null} [productTemplateVersionID] GetProductsByTemplateIDRequest productTemplateVersionID
         * @property {common.IPaginationRequest|null} [pagination] GetProductsByTemplateIDRequest pagination
         */

        /**
         * Constructs a new GetProductsByTemplateIDRequest.
         * @memberof coreproductpb
         * @classdesc Represents a GetProductsByTemplateIDRequest.
         * @implements IGetProductsByTemplateIDRequest
         * @constructor
         * @param {coreproductpb.IGetProductsByTemplateIDRequest=} [p] Properties to set
         */
        function GetProductsByTemplateIDRequest(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * GetProductsByTemplateIDRequest productTemplateID.
         * @member {string} productTemplateID
         * @memberof coreproductpb.GetProductsByTemplateIDRequest
         * @instance
         */
        GetProductsByTemplateIDRequest.prototype.productTemplateID = "";

        /**
         * GetProductsByTemplateIDRequest productTemplateVersionID.
         * @member {string} productTemplateVersionID
         * @memberof coreproductpb.GetProductsByTemplateIDRequest
         * @instance
         */
        GetProductsByTemplateIDRequest.prototype.productTemplateVersionID = "";

        /**
         * GetProductsByTemplateIDRequest pagination.
         * @member {common.IPaginationRequest|null|undefined} pagination
         * @memberof coreproductpb.GetProductsByTemplateIDRequest
         * @instance
         */
        GetProductsByTemplateIDRequest.prototype.pagination = null;

        /**
         * Creates a new GetProductsByTemplateIDRequest instance using the specified properties.
         * @function create
         * @memberof coreproductpb.GetProductsByTemplateIDRequest
         * @static
         * @param {coreproductpb.IGetProductsByTemplateIDRequest=} [properties] Properties to set
         * @returns {coreproductpb.GetProductsByTemplateIDRequest} GetProductsByTemplateIDRequest instance
         */
        GetProductsByTemplateIDRequest.create = function create(properties) {
            return new GetProductsByTemplateIDRequest(properties);
        };

        /**
         * Encodes the specified GetProductsByTemplateIDRequest message. Does not implicitly {@link coreproductpb.GetProductsByTemplateIDRequest.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.GetProductsByTemplateIDRequest
         * @static
         * @param {coreproductpb.IGetProductsByTemplateIDRequest} m GetProductsByTemplateIDRequest message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetProductsByTemplateIDRequest.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.productTemplateID != null && Object.hasOwnProperty.call(m, "productTemplateID"))
                w.uint32(10).string(m.productTemplateID);
            if (m.productTemplateVersionID != null && Object.hasOwnProperty.call(m, "productTemplateVersionID"))
                w.uint32(18).string(m.productTemplateVersionID);
            if (m.pagination != null && Object.hasOwnProperty.call(m, "pagination"))
                $root.common.PaginationRequest.encode(m.pagination, w.uint32(26).fork()).ldelim();
            return w;
        };

        /**
         * Decodes a GetProductsByTemplateIDRequest message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.GetProductsByTemplateIDRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.GetProductsByTemplateIDRequest} GetProductsByTemplateIDRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetProductsByTemplateIDRequest.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.GetProductsByTemplateIDRequest();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.productTemplateID = r.string();
                    break;
                case 2:
                    m.productTemplateVersionID = r.string();
                    break;
                case 3:
                    m.pagination = $root.common.PaginationRequest.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return GetProductsByTemplateIDRequest;
    })();

    coreproductpb.GetProductsByTemplateIDResponse = (function() {

        /**
         * Properties of a GetProductsByTemplateIDResponse.
         * @memberof coreproductpb
         * @interface IGetProductsByTemplateIDResponse
         * @property {Array.<coreproductpb.IAdminProductResponse>|null} [product] GetProductsByTemplateIDResponse product
         * @property {Array.<common.IError>|null} [errors] GetProductsByTemplateIDResponse errors
         * @property {common.IPagination|null} [pagination] GetProductsByTemplateIDResponse pagination
         */

        /**
         * Constructs a new GetProductsByTemplateIDResponse.
         * @memberof coreproductpb
         * @classdesc Represents a GetProductsByTemplateIDResponse.
         * @implements IGetProductsByTemplateIDResponse
         * @constructor
         * @param {coreproductpb.IGetProductsByTemplateIDResponse=} [p] Properties to set
         */
        function GetProductsByTemplateIDResponse(p) {
            this.product = [];
            this.errors = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * GetProductsByTemplateIDResponse product.
         * @member {Array.<coreproductpb.IAdminProductResponse>} product
         * @memberof coreproductpb.GetProductsByTemplateIDResponse
         * @instance
         */
        GetProductsByTemplateIDResponse.prototype.product = $util.emptyArray;

        /**
         * GetProductsByTemplateIDResponse errors.
         * @member {Array.<common.IError>} errors
         * @memberof coreproductpb.GetProductsByTemplateIDResponse
         * @instance
         */
        GetProductsByTemplateIDResponse.prototype.errors = $util.emptyArray;

        /**
         * GetProductsByTemplateIDResponse pagination.
         * @member {common.IPagination|null|undefined} pagination
         * @memberof coreproductpb.GetProductsByTemplateIDResponse
         * @instance
         */
        GetProductsByTemplateIDResponse.prototype.pagination = null;

        /**
         * Creates a new GetProductsByTemplateIDResponse instance using the specified properties.
         * @function create
         * @memberof coreproductpb.GetProductsByTemplateIDResponse
         * @static
         * @param {coreproductpb.IGetProductsByTemplateIDResponse=} [properties] Properties to set
         * @returns {coreproductpb.GetProductsByTemplateIDResponse} GetProductsByTemplateIDResponse instance
         */
        GetProductsByTemplateIDResponse.create = function create(properties) {
            return new GetProductsByTemplateIDResponse(properties);
        };

        /**
         * Encodes the specified GetProductsByTemplateIDResponse message. Does not implicitly {@link coreproductpb.GetProductsByTemplateIDResponse.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.GetProductsByTemplateIDResponse
         * @static
         * @param {coreproductpb.IGetProductsByTemplateIDResponse} m GetProductsByTemplateIDResponse message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetProductsByTemplateIDResponse.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.product != null && m.product.length) {
                for (var i = 0; i < m.product.length; ++i)
                    $root.coreproductpb.AdminProductResponse.encode(m.product[i], w.uint32(10).fork()).ldelim();
            }
            if (m.errors != null && m.errors.length) {
                for (var i = 0; i < m.errors.length; ++i)
                    $root.common.Error.encode(m.errors[i], w.uint32(18).fork()).ldelim();
            }
            if (m.pagination != null && Object.hasOwnProperty.call(m, "pagination"))
                $root.common.Pagination.encode(m.pagination, w.uint32(26).fork()).ldelim();
            return w;
        };

        /**
         * Decodes a GetProductsByTemplateIDResponse message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.GetProductsByTemplateIDResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.GetProductsByTemplateIDResponse} GetProductsByTemplateIDResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetProductsByTemplateIDResponse.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.GetProductsByTemplateIDResponse();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    if (!(m.product && m.product.length))
                        m.product = [];
                    m.product.push($root.coreproductpb.AdminProductResponse.decode(r, r.uint32()));
                    break;
                case 2:
                    if (!(m.errors && m.errors.length))
                        m.errors = [];
                    m.errors.push($root.common.Error.decode(r, r.uint32()));
                    break;
                case 3:
                    m.pagination = $root.common.Pagination.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return GetProductsByTemplateIDResponse;
    })();

    coreproductpb.GetProductsSearchV2Request = (function() {

        /**
         * Properties of a GetProductsSearchV2Request.
         * @memberof coreproductpb
         * @interface IGetProductsSearchV2Request
         * @property {Array.<coreproductpb.GetProductsSearchV2Request.ProductResponseFieldset>|null} [responseFields] GetProductsSearchV2Request responseFields
         * @property {Array.<coreproductpb.ISortByField>|null} [sortByFields] GetProductsSearchV2Request sortByFields
         * @property {common.IPaginationRequest|null} [pagination] GetProductsSearchV2Request pagination
         * @property {coreproductpb.GetProductsSearchV2Request.IBaseGetProductFilter|null} [baseFilter] GetProductsSearchV2Request baseFilter
         * @property {coreproductpb.GetProductsSearchV2Request.IRepeatedString|null} [productTemplateIDs] GetProductsSearchV2Request productTemplateIDs
         * @property {coreproductpb.GetProductsSearchV2Request.IRepeatedString|null} [productTemplateVersionIDs] GetProductsSearchV2Request productTemplateVersionIDs
         * @property {coreproductpb.GetProductsSearchV2Request.IRepeatedString|null} [starProductVersionIDs] GetProductsSearchV2Request starProductVersionIDs
         * @property {coreproductpb.GetProductsSearchV2Request.IRepeatedString|null} [starProductPlanIDs] GetProductsSearchV2Request starProductPlanIDs
         * @property {boolean|null} [onlyProductWorkbenchProducts] GetProductsSearchV2Request onlyProductWorkbenchProducts
         * @property {boolean|null} [getTestProducts] GetProductsSearchV2Request getTestProducts
         * @property {boolean|null} [includeExpiredProducts] GetProductsSearchV2Request includeExpiredProducts
         */

        /**
         * Constructs a new GetProductsSearchV2Request.
         * @memberof coreproductpb
         * @classdesc Represents a GetProductsSearchV2Request.
         * @implements IGetProductsSearchV2Request
         * @constructor
         * @param {coreproductpb.IGetProductsSearchV2Request=} [p] Properties to set
         */
        function GetProductsSearchV2Request(p) {
            this.responseFields = [];
            this.sortByFields = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * GetProductsSearchV2Request responseFields.
         * @member {Array.<coreproductpb.GetProductsSearchV2Request.ProductResponseFieldset>} responseFields
         * @memberof coreproductpb.GetProductsSearchV2Request
         * @instance
         */
        GetProductsSearchV2Request.prototype.responseFields = $util.emptyArray;

        /**
         * GetProductsSearchV2Request sortByFields.
         * @member {Array.<coreproductpb.ISortByField>} sortByFields
         * @memberof coreproductpb.GetProductsSearchV2Request
         * @instance
         */
        GetProductsSearchV2Request.prototype.sortByFields = $util.emptyArray;

        /**
         * GetProductsSearchV2Request pagination.
         * @member {common.IPaginationRequest|null|undefined} pagination
         * @memberof coreproductpb.GetProductsSearchV2Request
         * @instance
         */
        GetProductsSearchV2Request.prototype.pagination = null;

        /**
         * GetProductsSearchV2Request baseFilter.
         * @member {coreproductpb.GetProductsSearchV2Request.IBaseGetProductFilter|null|undefined} baseFilter
         * @memberof coreproductpb.GetProductsSearchV2Request
         * @instance
         */
        GetProductsSearchV2Request.prototype.baseFilter = null;

        /**
         * GetProductsSearchV2Request productTemplateIDs.
         * @member {coreproductpb.GetProductsSearchV2Request.IRepeatedString|null|undefined} productTemplateIDs
         * @memberof coreproductpb.GetProductsSearchV2Request
         * @instance
         */
        GetProductsSearchV2Request.prototype.productTemplateIDs = null;

        /**
         * GetProductsSearchV2Request productTemplateVersionIDs.
         * @member {coreproductpb.GetProductsSearchV2Request.IRepeatedString|null|undefined} productTemplateVersionIDs
         * @memberof coreproductpb.GetProductsSearchV2Request
         * @instance
         */
        GetProductsSearchV2Request.prototype.productTemplateVersionIDs = null;

        /**
         * GetProductsSearchV2Request starProductVersionIDs.
         * @member {coreproductpb.GetProductsSearchV2Request.IRepeatedString|null|undefined} starProductVersionIDs
         * @memberof coreproductpb.GetProductsSearchV2Request
         * @instance
         */
        GetProductsSearchV2Request.prototype.starProductVersionIDs = null;

        /**
         * GetProductsSearchV2Request starProductPlanIDs.
         * @member {coreproductpb.GetProductsSearchV2Request.IRepeatedString|null|undefined} starProductPlanIDs
         * @memberof coreproductpb.GetProductsSearchV2Request
         * @instance
         */
        GetProductsSearchV2Request.prototype.starProductPlanIDs = null;

        /**
         * GetProductsSearchV2Request onlyProductWorkbenchProducts.
         * @member {boolean} onlyProductWorkbenchProducts
         * @memberof coreproductpb.GetProductsSearchV2Request
         * @instance
         */
        GetProductsSearchV2Request.prototype.onlyProductWorkbenchProducts = false;

        /**
         * GetProductsSearchV2Request getTestProducts.
         * @member {boolean} getTestProducts
         * @memberof coreproductpb.GetProductsSearchV2Request
         * @instance
         */
        GetProductsSearchV2Request.prototype.getTestProducts = false;

        /**
         * GetProductsSearchV2Request includeExpiredProducts.
         * @member {boolean} includeExpiredProducts
         * @memberof coreproductpb.GetProductsSearchV2Request
         * @instance
         */
        GetProductsSearchV2Request.prototype.includeExpiredProducts = false;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        /**
         * GetProductsSearchV2Request searchFilter.
         * @member {"baseFilter"|"productTemplateIDs"|"productTemplateVersionIDs"|"starProductVersionIDs"|"starProductPlanIDs"|undefined} searchFilter
         * @memberof coreproductpb.GetProductsSearchV2Request
         * @instance
         */
        Object.defineProperty(GetProductsSearchV2Request.prototype, "searchFilter", {
            get: $util.oneOfGetter($oneOfFields = ["baseFilter", "productTemplateIDs", "productTemplateVersionIDs", "starProductVersionIDs", "starProductPlanIDs"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new GetProductsSearchV2Request instance using the specified properties.
         * @function create
         * @memberof coreproductpb.GetProductsSearchV2Request
         * @static
         * @param {coreproductpb.IGetProductsSearchV2Request=} [properties] Properties to set
         * @returns {coreproductpb.GetProductsSearchV2Request} GetProductsSearchV2Request instance
         */
        GetProductsSearchV2Request.create = function create(properties) {
            return new GetProductsSearchV2Request(properties);
        };

        /**
         * Encodes the specified GetProductsSearchV2Request message. Does not implicitly {@link coreproductpb.GetProductsSearchV2Request.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.GetProductsSearchV2Request
         * @static
         * @param {coreproductpb.IGetProductsSearchV2Request} m GetProductsSearchV2Request message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetProductsSearchV2Request.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.responseFields != null && m.responseFields.length) {
                w.uint32(10).fork();
                for (var i = 0; i < m.responseFields.length; ++i)
                    w.int32(m.responseFields[i]);
                w.ldelim();
            }
            if (m.sortByFields != null && m.sortByFields.length) {
                for (var i = 0; i < m.sortByFields.length; ++i)
                    $root.coreproductpb.SortByField.encode(m.sortByFields[i], w.uint32(18).fork()).ldelim();
            }
            if (m.pagination != null && Object.hasOwnProperty.call(m, "pagination"))
                $root.common.PaginationRequest.encode(m.pagination, w.uint32(26).fork()).ldelim();
            if (m.baseFilter != null && Object.hasOwnProperty.call(m, "baseFilter"))
                $root.coreproductpb.GetProductsSearchV2Request.BaseGetProductFilter.encode(m.baseFilter, w.uint32(34).fork()).ldelim();
            if (m.productTemplateIDs != null && Object.hasOwnProperty.call(m, "productTemplateIDs"))
                $root.coreproductpb.GetProductsSearchV2Request.RepeatedString.encode(m.productTemplateIDs, w.uint32(42).fork()).ldelim();
            if (m.productTemplateVersionIDs != null && Object.hasOwnProperty.call(m, "productTemplateVersionIDs"))
                $root.coreproductpb.GetProductsSearchV2Request.RepeatedString.encode(m.productTemplateVersionIDs, w.uint32(50).fork()).ldelim();
            if (m.starProductVersionIDs != null && Object.hasOwnProperty.call(m, "starProductVersionIDs"))
                $root.coreproductpb.GetProductsSearchV2Request.RepeatedString.encode(m.starProductVersionIDs, w.uint32(58).fork()).ldelim();
            if (m.starProductPlanIDs != null && Object.hasOwnProperty.call(m, "starProductPlanIDs"))
                $root.coreproductpb.GetProductsSearchV2Request.RepeatedString.encode(m.starProductPlanIDs, w.uint32(66).fork()).ldelim();
            if (m.onlyProductWorkbenchProducts != null && Object.hasOwnProperty.call(m, "onlyProductWorkbenchProducts"))
                w.uint32(72).bool(m.onlyProductWorkbenchProducts);
            if (m.getTestProducts != null && Object.hasOwnProperty.call(m, "getTestProducts"))
                w.uint32(80).bool(m.getTestProducts);
            if (m.includeExpiredProducts != null && Object.hasOwnProperty.call(m, "includeExpiredProducts"))
                w.uint32(88).bool(m.includeExpiredProducts);
            return w;
        };

        /**
         * Decodes a GetProductsSearchV2Request message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.GetProductsSearchV2Request
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.GetProductsSearchV2Request} GetProductsSearchV2Request
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetProductsSearchV2Request.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.GetProductsSearchV2Request();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    if (!(m.responseFields && m.responseFields.length))
                        m.responseFields = [];
                    if ((t & 7) === 2) {
                        var c2 = r.uint32() + r.pos;
                        while (r.pos < c2)
                            m.responseFields.push(r.int32());
                    } else
                        m.responseFields.push(r.int32());
                    break;
                case 2:
                    if (!(m.sortByFields && m.sortByFields.length))
                        m.sortByFields = [];
                    m.sortByFields.push($root.coreproductpb.SortByField.decode(r, r.uint32()));
                    break;
                case 3:
                    m.pagination = $root.common.PaginationRequest.decode(r, r.uint32());
                    break;
                case 4:
                    m.baseFilter = $root.coreproductpb.GetProductsSearchV2Request.BaseGetProductFilter.decode(r, r.uint32());
                    break;
                case 5:
                    m.productTemplateIDs = $root.coreproductpb.GetProductsSearchV2Request.RepeatedString.decode(r, r.uint32());
                    break;
                case 6:
                    m.productTemplateVersionIDs = $root.coreproductpb.GetProductsSearchV2Request.RepeatedString.decode(r, r.uint32());
                    break;
                case 7:
                    m.starProductVersionIDs = $root.coreproductpb.GetProductsSearchV2Request.RepeatedString.decode(r, r.uint32());
                    break;
                case 8:
                    m.starProductPlanIDs = $root.coreproductpb.GetProductsSearchV2Request.RepeatedString.decode(r, r.uint32());
                    break;
                case 9:
                    m.onlyProductWorkbenchProducts = r.bool();
                    break;
                case 10:
                    m.getTestProducts = r.bool();
                    break;
                case 11:
                    m.includeExpiredProducts = r.bool();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        /**
         * ProductResponseFieldset enum.
         * @name coreproductpb.GetProductsSearchV2Request.ProductResponseFieldset
         * @enum {number}
         * @property {number} PRF_ESSENTIAL=0 PRF_ESSENTIAL value
         * @property {number} PRF_BASE_ATTRIBUTES=1 PRF_BASE_ATTRIBUTES value
         * @property {number} PRF_DETAILS_ATTRIBUTES=2 PRF_DETAILS_ATTRIBUTES value
         * @property {number} PRF_ESSENTIAL_FEATURES=3 PRF_ESSENTIAL_FEATURES value
         * @property {number} PRF_BASE_FEATURES=4 PRF_BASE_FEATURES value
         * @property {number} PRF_DETAILS_FEATURES=5 PRF_DETAILS_FEATURES value
         * @property {number} PRF_PRODUCT_TAGS=6 PRF_PRODUCT_TAGS value
         */
        GetProductsSearchV2Request.ProductResponseFieldset = (function() {
            const valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "PRF_ESSENTIAL"] = 0;
            values[valuesById[1] = "PRF_BASE_ATTRIBUTES"] = 1;
            values[valuesById[2] = "PRF_DETAILS_ATTRIBUTES"] = 2;
            values[valuesById[3] = "PRF_ESSENTIAL_FEATURES"] = 3;
            values[valuesById[4] = "PRF_BASE_FEATURES"] = 4;
            values[valuesById[5] = "PRF_DETAILS_FEATURES"] = 5;
            values[valuesById[6] = "PRF_PRODUCT_TAGS"] = 6;
            return values;
        })();

        GetProductsSearchV2Request.BaseGetProductFilter = (function() {

            /**
             * Properties of a BaseGetProductFilter.
             * @memberof coreproductpb.GetProductsSearchV2Request
             * @interface IBaseGetProductFilter
             * @property {coreproductpb.IAvailabilityFilter|null} [attributes] BaseGetProductFilter attributes
             * @property {coreproductpb.IServiceabilityFilter|null} [service] BaseGetProductFilter service
             * @property {coreproductpb.IFeatureFilter|null} [feature] BaseGetProductFilter feature
             * @property {common.IDate|null} [asOnDate] BaseGetProductFilter asOnDate
             * @property {google.protobuf.ITimestamp|null} [asAtTimestamp] BaseGetProductFilter asAtTimestamp
             * @property {Array.<string>|null} [starProductPlanIDs] BaseGetProductFilter starProductPlanIDs
             */

            /**
             * Constructs a new BaseGetProductFilter.
             * @memberof coreproductpb.GetProductsSearchV2Request
             * @classdesc Represents a BaseGetProductFilter.
             * @implements IBaseGetProductFilter
             * @constructor
             * @param {coreproductpb.GetProductsSearchV2Request.IBaseGetProductFilter=} [p] Properties to set
             */
            function BaseGetProductFilter(p) {
                this.starProductPlanIDs = [];
                if (p)
                    for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                        if (p[ks[i]] != null)
                            this[ks[i]] = p[ks[i]];
            }

            /**
             * BaseGetProductFilter attributes.
             * @member {coreproductpb.IAvailabilityFilter|null|undefined} attributes
             * @memberof coreproductpb.GetProductsSearchV2Request.BaseGetProductFilter
             * @instance
             */
            BaseGetProductFilter.prototype.attributes = null;

            /**
             * BaseGetProductFilter service.
             * @member {coreproductpb.IServiceabilityFilter|null|undefined} service
             * @memberof coreproductpb.GetProductsSearchV2Request.BaseGetProductFilter
             * @instance
             */
            BaseGetProductFilter.prototype.service = null;

            /**
             * BaseGetProductFilter feature.
             * @member {coreproductpb.IFeatureFilter|null|undefined} feature
             * @memberof coreproductpb.GetProductsSearchV2Request.BaseGetProductFilter
             * @instance
             */
            BaseGetProductFilter.prototype.feature = null;

            /**
             * BaseGetProductFilter asOnDate.
             * @member {common.IDate|null|undefined} asOnDate
             * @memberof coreproductpb.GetProductsSearchV2Request.BaseGetProductFilter
             * @instance
             */
            BaseGetProductFilter.prototype.asOnDate = null;

            /**
             * BaseGetProductFilter asAtTimestamp.
             * @member {google.protobuf.ITimestamp|null|undefined} asAtTimestamp
             * @memberof coreproductpb.GetProductsSearchV2Request.BaseGetProductFilter
             * @instance
             */
            BaseGetProductFilter.prototype.asAtTimestamp = null;

            /**
             * BaseGetProductFilter starProductPlanIDs.
             * @member {Array.<string>} starProductPlanIDs
             * @memberof coreproductpb.GetProductsSearchV2Request.BaseGetProductFilter
             * @instance
             */
            BaseGetProductFilter.prototype.starProductPlanIDs = $util.emptyArray;

            // OneOf field names bound to virtual getters and setters
            let $oneOfFields;

            /**
             * BaseGetProductFilter datetimeReference.
             * @member {"asOnDate"|"asAtTimestamp"|undefined} datetimeReference
             * @memberof coreproductpb.GetProductsSearchV2Request.BaseGetProductFilter
             * @instance
             */
            Object.defineProperty(BaseGetProductFilter.prototype, "datetimeReference", {
                get: $util.oneOfGetter($oneOfFields = ["asOnDate", "asAtTimestamp"]),
                set: $util.oneOfSetter($oneOfFields)
            });

            /**
             * Creates a new BaseGetProductFilter instance using the specified properties.
             * @function create
             * @memberof coreproductpb.GetProductsSearchV2Request.BaseGetProductFilter
             * @static
             * @param {coreproductpb.GetProductsSearchV2Request.IBaseGetProductFilter=} [properties] Properties to set
             * @returns {coreproductpb.GetProductsSearchV2Request.BaseGetProductFilter} BaseGetProductFilter instance
             */
            BaseGetProductFilter.create = function create(properties) {
                return new BaseGetProductFilter(properties);
            };

            /**
             * Encodes the specified BaseGetProductFilter message. Does not implicitly {@link coreproductpb.GetProductsSearchV2Request.BaseGetProductFilter.verify|verify} messages.
             * @function encode
             * @memberof coreproductpb.GetProductsSearchV2Request.BaseGetProductFilter
             * @static
             * @param {coreproductpb.GetProductsSearchV2Request.IBaseGetProductFilter} m BaseGetProductFilter message or plain object to encode
             * @param {$protobuf.Writer} [w] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            BaseGetProductFilter.encode = function encode(m, w) {
                if (!w)
                    w = $Writer.create();
                if (m.attributes != null && Object.hasOwnProperty.call(m, "attributes"))
                    $root.coreproductpb.AvailabilityFilter.encode(m.attributes, w.uint32(10).fork()).ldelim();
                if (m.service != null && Object.hasOwnProperty.call(m, "service"))
                    $root.coreproductpb.ServiceabilityFilter.encode(m.service, w.uint32(18).fork()).ldelim();
                if (m.feature != null && Object.hasOwnProperty.call(m, "feature"))
                    $root.coreproductpb.FeatureFilter.encode(m.feature, w.uint32(26).fork()).ldelim();
                if (m.asOnDate != null && Object.hasOwnProperty.call(m, "asOnDate"))
                    $root.common.Date.encode(m.asOnDate, w.uint32(34).fork()).ldelim();
                if (m.asAtTimestamp != null && Object.hasOwnProperty.call(m, "asAtTimestamp"))
                    $root.google.protobuf.Timestamp.encode(m.asAtTimestamp, w.uint32(42).fork()).ldelim();
                if (m.starProductPlanIDs != null && m.starProductPlanIDs.length) {
                    for (var i = 0; i < m.starProductPlanIDs.length; ++i)
                        w.uint32(66).string(m.starProductPlanIDs[i]);
                }
                return w;
            };

            /**
             * Decodes a BaseGetProductFilter message from the specified reader or buffer.
             * @function decode
             * @memberof coreproductpb.GetProductsSearchV2Request.BaseGetProductFilter
             * @static
             * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
             * @param {number} [l] Message length if known beforehand
             * @returns {coreproductpb.GetProductsSearchV2Request.BaseGetProductFilter} BaseGetProductFilter
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            BaseGetProductFilter.decode = function decode(r, l) {
                if (!(r instanceof $Reader))
                    r = $Reader.create(r);
                var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.GetProductsSearchV2Request.BaseGetProductFilter();
                while (r.pos < c) {
                    var t = r.uint32();
                    switch (t >>> 3) {
                    case 1:
                        m.attributes = $root.coreproductpb.AvailabilityFilter.decode(r, r.uint32());
                        break;
                    case 2:
                        m.service = $root.coreproductpb.ServiceabilityFilter.decode(r, r.uint32());
                        break;
                    case 3:
                        m.feature = $root.coreproductpb.FeatureFilter.decode(r, r.uint32());
                        break;
                    case 4:
                        m.asOnDate = $root.common.Date.decode(r, r.uint32());
                        break;
                    case 5:
                        m.asAtTimestamp = $root.google.protobuf.Timestamp.decode(r, r.uint32());
                        break;
                    case 8:
                        if (!(m.starProductPlanIDs && m.starProductPlanIDs.length))
                            m.starProductPlanIDs = [];
                        m.starProductPlanIDs.push(r.string());
                        break;
                    default:
                        r.skipType(t & 7);
                        break;
                    }
                }
                return m;
            };

            return BaseGetProductFilter;
        })();

        GetProductsSearchV2Request.RepeatedString = (function() {

            /**
             * Properties of a RepeatedString.
             * @memberof coreproductpb.GetProductsSearchV2Request
             * @interface IRepeatedString
             * @property {Array.<string>|null} [value] RepeatedString value
             */

            /**
             * Constructs a new RepeatedString.
             * @memberof coreproductpb.GetProductsSearchV2Request
             * @classdesc Represents a RepeatedString.
             * @implements IRepeatedString
             * @constructor
             * @param {coreproductpb.GetProductsSearchV2Request.IRepeatedString=} [p] Properties to set
             */
            function RepeatedString(p) {
                this.value = [];
                if (p)
                    for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                        if (p[ks[i]] != null)
                            this[ks[i]] = p[ks[i]];
            }

            /**
             * RepeatedString value.
             * @member {Array.<string>} value
             * @memberof coreproductpb.GetProductsSearchV2Request.RepeatedString
             * @instance
             */
            RepeatedString.prototype.value = $util.emptyArray;

            /**
             * Creates a new RepeatedString instance using the specified properties.
             * @function create
             * @memberof coreproductpb.GetProductsSearchV2Request.RepeatedString
             * @static
             * @param {coreproductpb.GetProductsSearchV2Request.IRepeatedString=} [properties] Properties to set
             * @returns {coreproductpb.GetProductsSearchV2Request.RepeatedString} RepeatedString instance
             */
            RepeatedString.create = function create(properties) {
                return new RepeatedString(properties);
            };

            /**
             * Encodes the specified RepeatedString message. Does not implicitly {@link coreproductpb.GetProductsSearchV2Request.RepeatedString.verify|verify} messages.
             * @function encode
             * @memberof coreproductpb.GetProductsSearchV2Request.RepeatedString
             * @static
             * @param {coreproductpb.GetProductsSearchV2Request.IRepeatedString} m RepeatedString message or plain object to encode
             * @param {$protobuf.Writer} [w] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            RepeatedString.encode = function encode(m, w) {
                if (!w)
                    w = $Writer.create();
                if (m.value != null && m.value.length) {
                    for (var i = 0; i < m.value.length; ++i)
                        w.uint32(10).string(m.value[i]);
                }
                return w;
            };

            /**
             * Decodes a RepeatedString message from the specified reader or buffer.
             * @function decode
             * @memberof coreproductpb.GetProductsSearchV2Request.RepeatedString
             * @static
             * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
             * @param {number} [l] Message length if known beforehand
             * @returns {coreproductpb.GetProductsSearchV2Request.RepeatedString} RepeatedString
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            RepeatedString.decode = function decode(r, l) {
                if (!(r instanceof $Reader))
                    r = $Reader.create(r);
                var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.GetProductsSearchV2Request.RepeatedString();
                while (r.pos < c) {
                    var t = r.uint32();
                    switch (t >>> 3) {
                    case 1:
                        if (!(m.value && m.value.length))
                            m.value = [];
                        m.value.push(r.string());
                        break;
                    default:
                        r.skipType(t & 7);
                        break;
                    }
                }
                return m;
            };

            return RepeatedString;
        })();

        return GetProductsSearchV2Request;
    })();

    coreproductpb.SortByField = (function() {

        /**
         * Properties of a SortByField.
         * @memberof coreproductpb
         * @interface ISortByField
         * @property {coreproductpb.SortField|null} [sortField] SortByField sortField
         * @property {coreproductpb.SortMechanism|null} [sortMechanism] SortByField sortMechanism
         */

        /**
         * Constructs a new SortByField.
         * @memberof coreproductpb
         * @classdesc Represents a SortByField.
         * @implements ISortByField
         * @constructor
         * @param {coreproductpb.ISortByField=} [p] Properties to set
         */
        function SortByField(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * SortByField sortField.
         * @member {coreproductpb.SortField} sortField
         * @memberof coreproductpb.SortByField
         * @instance
         */
        SortByField.prototype.sortField = 0;

        /**
         * SortByField sortMechanism.
         * @member {coreproductpb.SortMechanism} sortMechanism
         * @memberof coreproductpb.SortByField
         * @instance
         */
        SortByField.prototype.sortMechanism = 0;

        /**
         * Creates a new SortByField instance using the specified properties.
         * @function create
         * @memberof coreproductpb.SortByField
         * @static
         * @param {coreproductpb.ISortByField=} [properties] Properties to set
         * @returns {coreproductpb.SortByField} SortByField instance
         */
        SortByField.create = function create(properties) {
            return new SortByField(properties);
        };

        /**
         * Encodes the specified SortByField message. Does not implicitly {@link coreproductpb.SortByField.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.SortByField
         * @static
         * @param {coreproductpb.ISortByField} m SortByField message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SortByField.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.sortField != null && Object.hasOwnProperty.call(m, "sortField"))
                w.uint32(8).int32(m.sortField);
            if (m.sortMechanism != null && Object.hasOwnProperty.call(m, "sortMechanism"))
                w.uint32(16).int32(m.sortMechanism);
            return w;
        };

        /**
         * Decodes a SortByField message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.SortByField
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.SortByField} SortByField
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SortByField.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.SortByField();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.sortField = r.int32();
                    break;
                case 2:
                    m.sortMechanism = r.int32();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return SortByField;
    })();

    /**
     * SortField enum.
     * @name coreproductpb.SortField
     * @enum {number}
     * @property {number} EFFECTIVE_DATE=0 EFFECTIVE_DATE value
     * @property {number} PRODUCT_TEMPLATE_NAME=1 PRODUCT_TEMPLATE_NAME value
     * @property {number} PRODUCT_TEMPLATE_DESCRIPTION=2 PRODUCT_TEMPLATE_DESCRIPTION value
     */
    coreproductpb.SortField = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "EFFECTIVE_DATE"] = 0;
        values[valuesById[1] = "PRODUCT_TEMPLATE_NAME"] = 1;
        values[valuesById[2] = "PRODUCT_TEMPLATE_DESCRIPTION"] = 2;
        return values;
    })();

    /**
     * SortMechanism enum.
     * @name coreproductpb.SortMechanism
     * @enum {number}
     * @property {number} DESCENDING=0 DESCENDING value
     * @property {number} ASCENDING=1 ASCENDING value
     */
    coreproductpb.SortMechanism = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "DESCENDING"] = 0;
        values[valuesById[1] = "ASCENDING"] = 1;
        return values;
    })();

    coreproductpb.AvailabilityFilter = (function() {

        /**
         * Properties of an AvailabilityFilter.
         * @memberof coreproductpb
         * @interface IAvailabilityFilter
         * @property {Array.<string>|null} [productType] AvailabilityFilter productType
         * @property {Array.<string>|null} [brand] AvailabilityFilter brand
         * @property {Array.<string>|null} [salesChannel] AvailabilityFilter salesChannel
         * @property {Array.<string>|null} [salesGroup] AvailabilityFilter salesGroup
         * @property {Array.<coreproductpb.TypedValue.ITimePeriod>|null} [contractTerms] AvailabilityFilter contractTerms
         * @property {Array.<string>|null} [franchise] AvailabilityFilter franchise
         * @property {common.USStateAlphaCode|null} [states] AvailabilityFilter states
         * @property {string|null} [zipCodes] AvailabilityFilter zipCodes
         * @property {Array.<string>|null} [propertyType] AvailabilityFilter propertyType
         * @property {coreproductpb.TypedValue.IArea|null} [propertySize] AvailabilityFilter propertySize
         * @property {coreproductpb.TypedValue.IAreaRange|null} [propertySizeRange] AvailabilityFilter propertySizeRange
         * @property {coreproductpb.TypedValue.ITimePeriod|null} [propertyAge] AvailabilityFilter propertyAge
         * @property {coreproductpb.TypedValue.ITimePeriodRange|null} [propertyAgeRange] AvailabilityFilter propertyAgeRange
         */

        /**
         * Constructs a new AvailabilityFilter.
         * @memberof coreproductpb
         * @classdesc Represents an AvailabilityFilter.
         * @implements IAvailabilityFilter
         * @constructor
         * @param {coreproductpb.IAvailabilityFilter=} [p] Properties to set
         */
        function AvailabilityFilter(p) {
            this.productType = [];
            this.brand = [];
            this.salesChannel = [];
            this.salesGroup = [];
            this.contractTerms = [];
            this.franchise = [];
            this.propertyType = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * AvailabilityFilter productType.
         * @member {Array.<string>} productType
         * @memberof coreproductpb.AvailabilityFilter
         * @instance
         */
        AvailabilityFilter.prototype.productType = $util.emptyArray;

        /**
         * AvailabilityFilter brand.
         * @member {Array.<string>} brand
         * @memberof coreproductpb.AvailabilityFilter
         * @instance
         */
        AvailabilityFilter.prototype.brand = $util.emptyArray;

        /**
         * AvailabilityFilter salesChannel.
         * @member {Array.<string>} salesChannel
         * @memberof coreproductpb.AvailabilityFilter
         * @instance
         */
        AvailabilityFilter.prototype.salesChannel = $util.emptyArray;

        /**
         * AvailabilityFilter salesGroup.
         * @member {Array.<string>} salesGroup
         * @memberof coreproductpb.AvailabilityFilter
         * @instance
         */
        AvailabilityFilter.prototype.salesGroup = $util.emptyArray;

        /**
         * AvailabilityFilter contractTerms.
         * @member {Array.<coreproductpb.TypedValue.ITimePeriod>} contractTerms
         * @memberof coreproductpb.AvailabilityFilter
         * @instance
         */
        AvailabilityFilter.prototype.contractTerms = $util.emptyArray;

        /**
         * AvailabilityFilter franchise.
         * @member {Array.<string>} franchise
         * @memberof coreproductpb.AvailabilityFilter
         * @instance
         */
        AvailabilityFilter.prototype.franchise = $util.emptyArray;

        /**
         * AvailabilityFilter states.
         * @member {common.USStateAlphaCode} states
         * @memberof coreproductpb.AvailabilityFilter
         * @instance
         */
        AvailabilityFilter.prototype.states = 0;

        /**
         * AvailabilityFilter zipCodes.
         * @member {string} zipCodes
         * @memberof coreproductpb.AvailabilityFilter
         * @instance
         */
        AvailabilityFilter.prototype.zipCodes = "";

        /**
         * AvailabilityFilter propertyType.
         * @member {Array.<string>} propertyType
         * @memberof coreproductpb.AvailabilityFilter
         * @instance
         */
        AvailabilityFilter.prototype.propertyType = $util.emptyArray;

        /**
         * AvailabilityFilter propertySize.
         * @member {coreproductpb.TypedValue.IArea|null|undefined} propertySize
         * @memberof coreproductpb.AvailabilityFilter
         * @instance
         */
        AvailabilityFilter.prototype.propertySize = null;

        /**
         * AvailabilityFilter propertySizeRange.
         * @member {coreproductpb.TypedValue.IAreaRange|null|undefined} propertySizeRange
         * @memberof coreproductpb.AvailabilityFilter
         * @instance
         */
        AvailabilityFilter.prototype.propertySizeRange = null;

        /**
         * AvailabilityFilter propertyAge.
         * @member {coreproductpb.TypedValue.ITimePeriod|null|undefined} propertyAge
         * @memberof coreproductpb.AvailabilityFilter
         * @instance
         */
        AvailabilityFilter.prototype.propertyAge = null;

        /**
         * AvailabilityFilter propertyAgeRange.
         * @member {coreproductpb.TypedValue.ITimePeriodRange|null|undefined} propertyAgeRange
         * @memberof coreproductpb.AvailabilityFilter
         * @instance
         */
        AvailabilityFilter.prototype.propertyAgeRange = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        /**
         * AvailabilityFilter propertySizeParams.
         * @member {"propertySize"|"propertySizeRange"|undefined} propertySizeParams
         * @memberof coreproductpb.AvailabilityFilter
         * @instance
         */
        Object.defineProperty(AvailabilityFilter.prototype, "propertySizeParams", {
            get: $util.oneOfGetter($oneOfFields = ["propertySize", "propertySizeRange"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * AvailabilityFilter propertyAgeParams.
         * @member {"propertyAge"|"propertyAgeRange"|undefined} propertyAgeParams
         * @memberof coreproductpb.AvailabilityFilter
         * @instance
         */
        Object.defineProperty(AvailabilityFilter.prototype, "propertyAgeParams", {
            get: $util.oneOfGetter($oneOfFields = ["propertyAge", "propertyAgeRange"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new AvailabilityFilter instance using the specified properties.
         * @function create
         * @memberof coreproductpb.AvailabilityFilter
         * @static
         * @param {coreproductpb.IAvailabilityFilter=} [properties] Properties to set
         * @returns {coreproductpb.AvailabilityFilter} AvailabilityFilter instance
         */
        AvailabilityFilter.create = function create(properties) {
            return new AvailabilityFilter(properties);
        };

        /**
         * Encodes the specified AvailabilityFilter message. Does not implicitly {@link coreproductpb.AvailabilityFilter.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.AvailabilityFilter
         * @static
         * @param {coreproductpb.IAvailabilityFilter} m AvailabilityFilter message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AvailabilityFilter.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.productType != null && m.productType.length) {
                for (var i = 0; i < m.productType.length; ++i)
                    w.uint32(10).string(m.productType[i]);
            }
            if (m.brand != null && m.brand.length) {
                for (var i = 0; i < m.brand.length; ++i)
                    w.uint32(18).string(m.brand[i]);
            }
            if (m.salesChannel != null && m.salesChannel.length) {
                for (var i = 0; i < m.salesChannel.length; ++i)
                    w.uint32(26).string(m.salesChannel[i]);
            }
            if (m.salesGroup != null && m.salesGroup.length) {
                for (var i = 0; i < m.salesGroup.length; ++i)
                    w.uint32(34).string(m.salesGroup[i]);
            }
            if (m.contractTerms != null && m.contractTerms.length) {
                for (var i = 0; i < m.contractTerms.length; ++i)
                    $root.coreproductpb.TypedValue.TimePeriod.encode(m.contractTerms[i], w.uint32(42).fork()).ldelim();
            }
            if (m.franchise != null && m.franchise.length) {
                for (var i = 0; i < m.franchise.length; ++i)
                    w.uint32(50).string(m.franchise[i]);
            }
            if (m.states != null && Object.hasOwnProperty.call(m, "states"))
                w.uint32(56).int32(m.states);
            if (m.zipCodes != null && Object.hasOwnProperty.call(m, "zipCodes"))
                w.uint32(66).string(m.zipCodes);
            if (m.propertyType != null && m.propertyType.length) {
                for (var i = 0; i < m.propertyType.length; ++i)
                    w.uint32(74).string(m.propertyType[i]);
            }
            if (m.propertySize != null && Object.hasOwnProperty.call(m, "propertySize"))
                $root.coreproductpb.TypedValue.Area.encode(m.propertySize, w.uint32(82).fork()).ldelim();
            if (m.propertySizeRange != null && Object.hasOwnProperty.call(m, "propertySizeRange"))
                $root.coreproductpb.TypedValue.AreaRange.encode(m.propertySizeRange, w.uint32(90).fork()).ldelim();
            if (m.propertyAge != null && Object.hasOwnProperty.call(m, "propertyAge"))
                $root.coreproductpb.TypedValue.TimePeriod.encode(m.propertyAge, w.uint32(98).fork()).ldelim();
            if (m.propertyAgeRange != null && Object.hasOwnProperty.call(m, "propertyAgeRange"))
                $root.coreproductpb.TypedValue.TimePeriodRange.encode(m.propertyAgeRange, w.uint32(106).fork()).ldelim();
            return w;
        };

        /**
         * Decodes an AvailabilityFilter message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.AvailabilityFilter
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.AvailabilityFilter} AvailabilityFilter
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AvailabilityFilter.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.AvailabilityFilter();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    if (!(m.productType && m.productType.length))
                        m.productType = [];
                    m.productType.push(r.string());
                    break;
                case 2:
                    if (!(m.brand && m.brand.length))
                        m.brand = [];
                    m.brand.push(r.string());
                    break;
                case 3:
                    if (!(m.salesChannel && m.salesChannel.length))
                        m.salesChannel = [];
                    m.salesChannel.push(r.string());
                    break;
                case 4:
                    if (!(m.salesGroup && m.salesGroup.length))
                        m.salesGroup = [];
                    m.salesGroup.push(r.string());
                    break;
                case 5:
                    if (!(m.contractTerms && m.contractTerms.length))
                        m.contractTerms = [];
                    m.contractTerms.push($root.coreproductpb.TypedValue.TimePeriod.decode(r, r.uint32()));
                    break;
                case 6:
                    if (!(m.franchise && m.franchise.length))
                        m.franchise = [];
                    m.franchise.push(r.string());
                    break;
                case 7:
                    m.states = r.int32();
                    break;
                case 8:
                    m.zipCodes = r.string();
                    break;
                case 9:
                    if (!(m.propertyType && m.propertyType.length))
                        m.propertyType = [];
                    m.propertyType.push(r.string());
                    break;
                case 10:
                    m.propertySize = $root.coreproductpb.TypedValue.Area.decode(r, r.uint32());
                    break;
                case 11:
                    m.propertySizeRange = $root.coreproductpb.TypedValue.AreaRange.decode(r, r.uint32());
                    break;
                case 12:
                    m.propertyAge = $root.coreproductpb.TypedValue.TimePeriod.decode(r, r.uint32());
                    break;
                case 13:
                    m.propertyAgeRange = $root.coreproductpb.TypedValue.TimePeriodRange.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return AvailabilityFilter;
    })();

    coreproductpb.ServiceabilityFilter = (function() {

        /**
         * Properties of a ServiceabilityFilter.
         * @memberof coreproductpb
         * @interface IServiceabilityFilter
         * @property {Array.<string>|null} [listingCoverageBeneficiary] ServiceabilityFilter listingCoverageBeneficiary
         */

        /**
         * Constructs a new ServiceabilityFilter.
         * @memberof coreproductpb
         * @classdesc Represents a ServiceabilityFilter.
         * @implements IServiceabilityFilter
         * @constructor
         * @param {coreproductpb.IServiceabilityFilter=} [p] Properties to set
         */
        function ServiceabilityFilter(p) {
            this.listingCoverageBeneficiary = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * ServiceabilityFilter listingCoverageBeneficiary.
         * @member {Array.<string>} listingCoverageBeneficiary
         * @memberof coreproductpb.ServiceabilityFilter
         * @instance
         */
        ServiceabilityFilter.prototype.listingCoverageBeneficiary = $util.emptyArray;

        /**
         * Creates a new ServiceabilityFilter instance using the specified properties.
         * @function create
         * @memberof coreproductpb.ServiceabilityFilter
         * @static
         * @param {coreproductpb.IServiceabilityFilter=} [properties] Properties to set
         * @returns {coreproductpb.ServiceabilityFilter} ServiceabilityFilter instance
         */
        ServiceabilityFilter.create = function create(properties) {
            return new ServiceabilityFilter(properties);
        };

        /**
         * Encodes the specified ServiceabilityFilter message. Does not implicitly {@link coreproductpb.ServiceabilityFilter.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.ServiceabilityFilter
         * @static
         * @param {coreproductpb.IServiceabilityFilter} m ServiceabilityFilter message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ServiceabilityFilter.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.listingCoverageBeneficiary != null && m.listingCoverageBeneficiary.length) {
                for (var i = 0; i < m.listingCoverageBeneficiary.length; ++i)
                    w.uint32(10).string(m.listingCoverageBeneficiary[i]);
            }
            return w;
        };

        /**
         * Decodes a ServiceabilityFilter message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.ServiceabilityFilter
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.ServiceabilityFilter} ServiceabilityFilter
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ServiceabilityFilter.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.ServiceabilityFilter();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    if (!(m.listingCoverageBeneficiary && m.listingCoverageBeneficiary.length))
                        m.listingCoverageBeneficiary = [];
                    m.listingCoverageBeneficiary.push(r.string());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return ServiceabilityFilter;
    })();

    coreproductpb.FeatureFilter = (function() {

        /**
         * Properties of a FeatureFilter.
         * @memberof coreproductpb
         * @interface IFeatureFilter
         * @property {coreproductpb.IProductTagsFilter|null} [includedTags] FeatureFilter includedTags
         * @property {coreproductpb.IProductTagsFilter|null} [excludedTags] FeatureFilter excludedTags
         */

        /**
         * Constructs a new FeatureFilter.
         * @memberof coreproductpb
         * @classdesc Represents a FeatureFilter.
         * @implements IFeatureFilter
         * @constructor
         * @param {coreproductpb.IFeatureFilter=} [p] Properties to set
         */
        function FeatureFilter(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * FeatureFilter includedTags.
         * @member {coreproductpb.IProductTagsFilter|null|undefined} includedTags
         * @memberof coreproductpb.FeatureFilter
         * @instance
         */
        FeatureFilter.prototype.includedTags = null;

        /**
         * FeatureFilter excludedTags.
         * @member {coreproductpb.IProductTagsFilter|null|undefined} excludedTags
         * @memberof coreproductpb.FeatureFilter
         * @instance
         */
        FeatureFilter.prototype.excludedTags = null;

        /**
         * Creates a new FeatureFilter instance using the specified properties.
         * @function create
         * @memberof coreproductpb.FeatureFilter
         * @static
         * @param {coreproductpb.IFeatureFilter=} [properties] Properties to set
         * @returns {coreproductpb.FeatureFilter} FeatureFilter instance
         */
        FeatureFilter.create = function create(properties) {
            return new FeatureFilter(properties);
        };

        /**
         * Encodes the specified FeatureFilter message. Does not implicitly {@link coreproductpb.FeatureFilter.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.FeatureFilter
         * @static
         * @param {coreproductpb.IFeatureFilter} m FeatureFilter message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        FeatureFilter.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.includedTags != null && Object.hasOwnProperty.call(m, "includedTags"))
                $root.coreproductpb.ProductTagsFilter.encode(m.includedTags, w.uint32(10).fork()).ldelim();
            if (m.excludedTags != null && Object.hasOwnProperty.call(m, "excludedTags"))
                $root.coreproductpb.ProductTagsFilter.encode(m.excludedTags, w.uint32(18).fork()).ldelim();
            return w;
        };

        /**
         * Decodes a FeatureFilter message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.FeatureFilter
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.FeatureFilter} FeatureFilter
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        FeatureFilter.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.FeatureFilter();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.includedTags = $root.coreproductpb.ProductTagsFilter.decode(r, r.uint32());
                    break;
                case 2:
                    m.excludedTags = $root.coreproductpb.ProductTagsFilter.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return FeatureFilter;
    })();

    coreproductpb.ProductTagsFilter = (function() {

        /**
         * Properties of a ProductTagsFilter.
         * @memberof coreproductpb
         * @interface IProductTagsFilter
         * @property {Array.<string>|null} [tags] ProductTagsFilter tags
         */

        /**
         * Constructs a new ProductTagsFilter.
         * @memberof coreproductpb
         * @classdesc Represents a ProductTagsFilter.
         * @implements IProductTagsFilter
         * @constructor
         * @param {coreproductpb.IProductTagsFilter=} [p] Properties to set
         */
        function ProductTagsFilter(p) {
            this.tags = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * ProductTagsFilter tags.
         * @member {Array.<string>} tags
         * @memberof coreproductpb.ProductTagsFilter
         * @instance
         */
        ProductTagsFilter.prototype.tags = $util.emptyArray;

        /**
         * Creates a new ProductTagsFilter instance using the specified properties.
         * @function create
         * @memberof coreproductpb.ProductTagsFilter
         * @static
         * @param {coreproductpb.IProductTagsFilter=} [properties] Properties to set
         * @returns {coreproductpb.ProductTagsFilter} ProductTagsFilter instance
         */
        ProductTagsFilter.create = function create(properties) {
            return new ProductTagsFilter(properties);
        };

        /**
         * Encodes the specified ProductTagsFilter message. Does not implicitly {@link coreproductpb.ProductTagsFilter.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.ProductTagsFilter
         * @static
         * @param {coreproductpb.IProductTagsFilter} m ProductTagsFilter message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ProductTagsFilter.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.tags != null && m.tags.length) {
                for (var i = 0; i < m.tags.length; ++i)
                    w.uint32(10).string(m.tags[i]);
            }
            return w;
        };

        /**
         * Decodes a ProductTagsFilter message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.ProductTagsFilter
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.ProductTagsFilter} ProductTagsFilter
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ProductTagsFilter.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.ProductTagsFilter();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    if (!(m.tags && m.tags.length))
                        m.tags = [];
                    m.tags.push(r.string());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return ProductTagsFilter;
    })();

    coreproductpb.GetProductsSearchV2Response = (function() {

        /**
         * Properties of a GetProductsSearchV2Response.
         * @memberof coreproductpb
         * @interface IGetProductsSearchV2Response
         * @property {Array.<coreproductpb.ISearchV2Product>|null} [products] GetProductsSearchV2Response products
         * @property {boolean|null} [isDefault] GetProductsSearchV2Response isDefault
         * @property {common.IPagination|null} [pagination] GetProductsSearchV2Response pagination
         * @property {Array.<common.IError>|null} [errors] GetProductsSearchV2Response errors
         */

        /**
         * Constructs a new GetProductsSearchV2Response.
         * @memberof coreproductpb
         * @classdesc Represents a GetProductsSearchV2Response.
         * @implements IGetProductsSearchV2Response
         * @constructor
         * @param {coreproductpb.IGetProductsSearchV2Response=} [p] Properties to set
         */
        function GetProductsSearchV2Response(p) {
            this.products = [];
            this.errors = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * GetProductsSearchV2Response products.
         * @member {Array.<coreproductpb.ISearchV2Product>} products
         * @memberof coreproductpb.GetProductsSearchV2Response
         * @instance
         */
        GetProductsSearchV2Response.prototype.products = $util.emptyArray;

        /**
         * GetProductsSearchV2Response isDefault.
         * @member {boolean} isDefault
         * @memberof coreproductpb.GetProductsSearchV2Response
         * @instance
         */
        GetProductsSearchV2Response.prototype.isDefault = false;

        /**
         * GetProductsSearchV2Response pagination.
         * @member {common.IPagination|null|undefined} pagination
         * @memberof coreproductpb.GetProductsSearchV2Response
         * @instance
         */
        GetProductsSearchV2Response.prototype.pagination = null;

        /**
         * GetProductsSearchV2Response errors.
         * @member {Array.<common.IError>} errors
         * @memberof coreproductpb.GetProductsSearchV2Response
         * @instance
         */
        GetProductsSearchV2Response.prototype.errors = $util.emptyArray;

        /**
         * Creates a new GetProductsSearchV2Response instance using the specified properties.
         * @function create
         * @memberof coreproductpb.GetProductsSearchV2Response
         * @static
         * @param {coreproductpb.IGetProductsSearchV2Response=} [properties] Properties to set
         * @returns {coreproductpb.GetProductsSearchV2Response} GetProductsSearchV2Response instance
         */
        GetProductsSearchV2Response.create = function create(properties) {
            return new GetProductsSearchV2Response(properties);
        };

        /**
         * Encodes the specified GetProductsSearchV2Response message. Does not implicitly {@link coreproductpb.GetProductsSearchV2Response.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.GetProductsSearchV2Response
         * @static
         * @param {coreproductpb.IGetProductsSearchV2Response} m GetProductsSearchV2Response message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetProductsSearchV2Response.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.products != null && m.products.length) {
                for (var i = 0; i < m.products.length; ++i)
                    $root.coreproductpb.SearchV2Product.encode(m.products[i], w.uint32(10).fork()).ldelim();
            }
            if (m.isDefault != null && Object.hasOwnProperty.call(m, "isDefault"))
                w.uint32(16).bool(m.isDefault);
            if (m.pagination != null && Object.hasOwnProperty.call(m, "pagination"))
                $root.common.Pagination.encode(m.pagination, w.uint32(26).fork()).ldelim();
            if (m.errors != null && m.errors.length) {
                for (var i = 0; i < m.errors.length; ++i)
                    $root.common.Error.encode(m.errors[i], w.uint32(34).fork()).ldelim();
            }
            return w;
        };

        /**
         * Decodes a GetProductsSearchV2Response message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.GetProductsSearchV2Response
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.GetProductsSearchV2Response} GetProductsSearchV2Response
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetProductsSearchV2Response.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.GetProductsSearchV2Response();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    if (!(m.products && m.products.length))
                        m.products = [];
                    m.products.push($root.coreproductpb.SearchV2Product.decode(r, r.uint32()));
                    break;
                case 2:
                    m.isDefault = r.bool();
                    break;
                case 3:
                    m.pagination = $root.common.Pagination.decode(r, r.uint32());
                    break;
                case 4:
                    if (!(m.errors && m.errors.length))
                        m.errors = [];
                    m.errors.push($root.common.Error.decode(r, r.uint32()));
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return GetProductsSearchV2Response;
    })();

    coreproductpb.SearchV2Product = (function() {

        /**
         * Properties of a SearchV2Product.
         * @memberof coreproductpb
         * @interface ISearchV2Product
         * @property {string|null} [productTemplateID] SearchV2Product productTemplateID
         * @property {string|null} [productTemplateVersionID] SearchV2Product productTemplateVersionID
         * @property {string|null} [productID] SearchV2Product productID
         * @property {string|null} [starPVID] SearchV2Product starPVID
         * @property {string|null} [starOldPV] SearchV2Product starOldPV
         * @property {string|null} [productType] SearchV2Product productType
         * @property {string|null} [name] SearchV2Product name
         * @property {string|null} [description] SearchV2Product description
         * @property {coreproductpb.ISearchV2AttributesForProduct|null} [attributes] SearchV2Product attributes
         * @property {coreproductpb.ISearchV2ProductFeatures|null} [features] SearchV2Product features
         * @property {google.protobuf.ITimestamp|null} [effectiveDate] SearchV2Product effectiveDate
         * @property {google.protobuf.ITimestamp|null} [expirationDate] SearchV2Product expirationDate
         * @property {string|null} [starProductPlanID] SearchV2Product starProductPlanID
         * @property {string|null} [starProductID] SearchV2Product starProductID
         * @property {coreproductpb.IProductFeatureTags|null} [productTags] SearchV2Product productTags
         */

        /**
         * Constructs a new SearchV2Product.
         * @memberof coreproductpb
         * @classdesc Represents a SearchV2Product.
         * @implements ISearchV2Product
         * @constructor
         * @param {coreproductpb.ISearchV2Product=} [p] Properties to set
         */
        function SearchV2Product(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * SearchV2Product productTemplateID.
         * @member {string} productTemplateID
         * @memberof coreproductpb.SearchV2Product
         * @instance
         */
        SearchV2Product.prototype.productTemplateID = "";

        /**
         * SearchV2Product productTemplateVersionID.
         * @member {string} productTemplateVersionID
         * @memberof coreproductpb.SearchV2Product
         * @instance
         */
        SearchV2Product.prototype.productTemplateVersionID = "";

        /**
         * SearchV2Product productID.
         * @member {string} productID
         * @memberof coreproductpb.SearchV2Product
         * @instance
         */
        SearchV2Product.prototype.productID = "";

        /**
         * SearchV2Product starPVID.
         * @member {string} starPVID
         * @memberof coreproductpb.SearchV2Product
         * @instance
         */
        SearchV2Product.prototype.starPVID = "";

        /**
         * SearchV2Product starOldPV.
         * @member {string} starOldPV
         * @memberof coreproductpb.SearchV2Product
         * @instance
         */
        SearchV2Product.prototype.starOldPV = "";

        /**
         * SearchV2Product productType.
         * @member {string} productType
         * @memberof coreproductpb.SearchV2Product
         * @instance
         */
        SearchV2Product.prototype.productType = "";

        /**
         * SearchV2Product name.
         * @member {string} name
         * @memberof coreproductpb.SearchV2Product
         * @instance
         */
        SearchV2Product.prototype.name = "";

        /**
         * SearchV2Product description.
         * @member {string} description
         * @memberof coreproductpb.SearchV2Product
         * @instance
         */
        SearchV2Product.prototype.description = "";

        /**
         * SearchV2Product attributes.
         * @member {coreproductpb.ISearchV2AttributesForProduct|null|undefined} attributes
         * @memberof coreproductpb.SearchV2Product
         * @instance
         */
        SearchV2Product.prototype.attributes = null;

        /**
         * SearchV2Product features.
         * @member {coreproductpb.ISearchV2ProductFeatures|null|undefined} features
         * @memberof coreproductpb.SearchV2Product
         * @instance
         */
        SearchV2Product.prototype.features = null;

        /**
         * SearchV2Product effectiveDate.
         * @member {google.protobuf.ITimestamp|null|undefined} effectiveDate
         * @memberof coreproductpb.SearchV2Product
         * @instance
         */
        SearchV2Product.prototype.effectiveDate = null;

        /**
         * SearchV2Product expirationDate.
         * @member {google.protobuf.ITimestamp|null|undefined} expirationDate
         * @memberof coreproductpb.SearchV2Product
         * @instance
         */
        SearchV2Product.prototype.expirationDate = null;

        /**
         * SearchV2Product starProductPlanID.
         * @member {string} starProductPlanID
         * @memberof coreproductpb.SearchV2Product
         * @instance
         */
        SearchV2Product.prototype.starProductPlanID = "";

        /**
         * SearchV2Product starProductID.
         * @member {string} starProductID
         * @memberof coreproductpb.SearchV2Product
         * @instance
         */
        SearchV2Product.prototype.starProductID = "";

        /**
         * SearchV2Product productTags.
         * @member {coreproductpb.IProductFeatureTags|null|undefined} productTags
         * @memberof coreproductpb.SearchV2Product
         * @instance
         */
        SearchV2Product.prototype.productTags = null;

        /**
         * Creates a new SearchV2Product instance using the specified properties.
         * @function create
         * @memberof coreproductpb.SearchV2Product
         * @static
         * @param {coreproductpb.ISearchV2Product=} [properties] Properties to set
         * @returns {coreproductpb.SearchV2Product} SearchV2Product instance
         */
        SearchV2Product.create = function create(properties) {
            return new SearchV2Product(properties);
        };

        /**
         * Encodes the specified SearchV2Product message. Does not implicitly {@link coreproductpb.SearchV2Product.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.SearchV2Product
         * @static
         * @param {coreproductpb.ISearchV2Product} m SearchV2Product message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SearchV2Product.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.productTemplateID != null && Object.hasOwnProperty.call(m, "productTemplateID"))
                w.uint32(10).string(m.productTemplateID);
            if (m.productTemplateVersionID != null && Object.hasOwnProperty.call(m, "productTemplateVersionID"))
                w.uint32(18).string(m.productTemplateVersionID);
            if (m.productID != null && Object.hasOwnProperty.call(m, "productID"))
                w.uint32(26).string(m.productID);
            if (m.starPVID != null && Object.hasOwnProperty.call(m, "starPVID"))
                w.uint32(34).string(m.starPVID);
            if (m.starOldPV != null && Object.hasOwnProperty.call(m, "starOldPV"))
                w.uint32(42).string(m.starOldPV);
            if (m.productType != null && Object.hasOwnProperty.call(m, "productType"))
                w.uint32(50).string(m.productType);
            if (m.name != null && Object.hasOwnProperty.call(m, "name"))
                w.uint32(58).string(m.name);
            if (m.description != null && Object.hasOwnProperty.call(m, "description"))
                w.uint32(66).string(m.description);
            if (m.attributes != null && Object.hasOwnProperty.call(m, "attributes"))
                $root.coreproductpb.SearchV2AttributesForProduct.encode(m.attributes, w.uint32(74).fork()).ldelim();
            if (m.features != null && Object.hasOwnProperty.call(m, "features"))
                $root.coreproductpb.SearchV2ProductFeatures.encode(m.features, w.uint32(82).fork()).ldelim();
            if (m.effectiveDate != null && Object.hasOwnProperty.call(m, "effectiveDate"))
                $root.google.protobuf.Timestamp.encode(m.effectiveDate, w.uint32(90).fork()).ldelim();
            if (m.expirationDate != null && Object.hasOwnProperty.call(m, "expirationDate"))
                $root.google.protobuf.Timestamp.encode(m.expirationDate, w.uint32(98).fork()).ldelim();
            if (m.starProductPlanID != null && Object.hasOwnProperty.call(m, "starProductPlanID"))
                w.uint32(106).string(m.starProductPlanID);
            if (m.starProductID != null && Object.hasOwnProperty.call(m, "starProductID"))
                w.uint32(114).string(m.starProductID);
            if (m.productTags != null && Object.hasOwnProperty.call(m, "productTags"))
                $root.coreproductpb.ProductFeatureTags.encode(m.productTags, w.uint32(122).fork()).ldelim();
            return w;
        };

        /**
         * Decodes a SearchV2Product message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.SearchV2Product
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.SearchV2Product} SearchV2Product
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SearchV2Product.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.SearchV2Product();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.productTemplateID = r.string();
                    break;
                case 2:
                    m.productTemplateVersionID = r.string();
                    break;
                case 3:
                    m.productID = r.string();
                    break;
                case 4:
                    m.starPVID = r.string();
                    break;
                case 5:
                    m.starOldPV = r.string();
                    break;
                case 6:
                    m.productType = r.string();
                    break;
                case 7:
                    m.name = r.string();
                    break;
                case 8:
                    m.description = r.string();
                    break;
                case 9:
                    m.attributes = $root.coreproductpb.SearchV2AttributesForProduct.decode(r, r.uint32());
                    break;
                case 10:
                    m.features = $root.coreproductpb.SearchV2ProductFeatures.decode(r, r.uint32());
                    break;
                case 11:
                    m.effectiveDate = $root.google.protobuf.Timestamp.decode(r, r.uint32());
                    break;
                case 12:
                    m.expirationDate = $root.google.protobuf.Timestamp.decode(r, r.uint32());
                    break;
                case 13:
                    m.starProductPlanID = r.string();
                    break;
                case 14:
                    m.starProductID = r.string();
                    break;
                case 15:
                    m.productTags = $root.coreproductpb.ProductFeatureTags.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return SearchV2Product;
    })();

    coreproductpb.SearchV2AttributesForProduct = (function() {

        /**
         * Properties of a SearchV2AttributesForProduct.
         * @memberof coreproductpb
         * @interface ISearchV2AttributesForProduct
         * @property {coreproductpb.ISearchV2BaseAttributesForProduct|null} [base] SearchV2AttributesForProduct base
         * @property {coreproductpb.ISearchV2DetailsProductAttributes|null} [details] SearchV2AttributesForProduct details
         */

        /**
         * Constructs a new SearchV2AttributesForProduct.
         * @memberof coreproductpb
         * @classdesc Represents a SearchV2AttributesForProduct.
         * @implements ISearchV2AttributesForProduct
         * @constructor
         * @param {coreproductpb.ISearchV2AttributesForProduct=} [p] Properties to set
         */
        function SearchV2AttributesForProduct(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * SearchV2AttributesForProduct base.
         * @member {coreproductpb.ISearchV2BaseAttributesForProduct|null|undefined} base
         * @memberof coreproductpb.SearchV2AttributesForProduct
         * @instance
         */
        SearchV2AttributesForProduct.prototype.base = null;

        /**
         * SearchV2AttributesForProduct details.
         * @member {coreproductpb.ISearchV2DetailsProductAttributes|null|undefined} details
         * @memberof coreproductpb.SearchV2AttributesForProduct
         * @instance
         */
        SearchV2AttributesForProduct.prototype.details = null;

        /**
         * Creates a new SearchV2AttributesForProduct instance using the specified properties.
         * @function create
         * @memberof coreproductpb.SearchV2AttributesForProduct
         * @static
         * @param {coreproductpb.ISearchV2AttributesForProduct=} [properties] Properties to set
         * @returns {coreproductpb.SearchV2AttributesForProduct} SearchV2AttributesForProduct instance
         */
        SearchV2AttributesForProduct.create = function create(properties) {
            return new SearchV2AttributesForProduct(properties);
        };

        /**
         * Encodes the specified SearchV2AttributesForProduct message. Does not implicitly {@link coreproductpb.SearchV2AttributesForProduct.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.SearchV2AttributesForProduct
         * @static
         * @param {coreproductpb.ISearchV2AttributesForProduct} m SearchV2AttributesForProduct message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SearchV2AttributesForProduct.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.base != null && Object.hasOwnProperty.call(m, "base"))
                $root.coreproductpb.SearchV2BaseAttributesForProduct.encode(m.base, w.uint32(10).fork()).ldelim();
            if (m.details != null && Object.hasOwnProperty.call(m, "details"))
                $root.coreproductpb.SearchV2DetailsProductAttributes.encode(m.details, w.uint32(18).fork()).ldelim();
            return w;
        };

        /**
         * Decodes a SearchV2AttributesForProduct message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.SearchV2AttributesForProduct
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.SearchV2AttributesForProduct} SearchV2AttributesForProduct
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SearchV2AttributesForProduct.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.SearchV2AttributesForProduct();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.base = $root.coreproductpb.SearchV2BaseAttributesForProduct.decode(r, r.uint32());
                    break;
                case 2:
                    m.details = $root.coreproductpb.SearchV2DetailsProductAttributes.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return SearchV2AttributesForProduct;
    })();

    coreproductpb.SearchV2BaseAttributesForProduct = (function() {

        /**
         * Properties of a SearchV2BaseAttributesForProduct.
         * @memberof coreproductpb
         * @interface ISearchV2BaseAttributesForProduct
         * @property {string|null} [brand] SearchV2BaseAttributesForProduct brand
         * @property {string|null} [salesChannel] SearchV2BaseAttributesForProduct salesChannel
         * @property {coreproductpb.TypedValue.ITimePeriod|null} [recallPeriod] SearchV2BaseAttributesForProduct recallPeriod
         * @property {coreproductpb.TypedValue.ITimePeriod|null} [contractTerm] SearchV2BaseAttributesForProduct contractTerm
         * @property {coreproductpb.TypedValue.ITimePeriod|null} [listingCoverageTerm] SearchV2BaseAttributesForProduct listingCoverageTerm
         * @property {string|null} [listingCoverageBeneficiary] SearchV2BaseAttributesForProduct listingCoverageBeneficiary
         * @property {string|null} [salesGroup] SearchV2BaseAttributesForProduct salesGroup
         * @property {coreproductpb.TypedValue.IStarFulfillmentList|null} [starFulfillments] SearchV2BaseAttributesForProduct starFulfillments
         * @property {coreproductpb.TypedValue.IStarRemarkList|null} [starRemarks] SearchV2BaseAttributesForProduct starRemarks
         * @property {coreproductpb.TypedValue.ITimePeriod|null} [repairWaitPeriod] SearchV2BaseAttributesForProduct repairWaitPeriod
         * @property {coreproductpb.TypedValue.ITimePeriod|null} [maintenanceWaitPeriod] SearchV2BaseAttributesForProduct maintenanceWaitPeriod
         * @property {common.IMoney|null} [aggregateCashOutAmount] SearchV2BaseAttributesForProduct aggregateCashOutAmount
         * @property {coreproductpb.TypedValue.ITimePeriod|null} [postCashOutAssetRepairWaitPeriod] SearchV2BaseAttributesForProduct postCashOutAssetRepairWaitPeriod
         * @property {common.IMoney|null} [aggregateRepairAmount] SearchV2BaseAttributesForProduct aggregateRepairAmount
         * @property {common.IMoney|null} [diagnosisFee] SearchV2BaseAttributesForProduct diagnosisFee
         * @property {common.IMoney|null} [maxItemRepairAmount] SearchV2BaseAttributesForProduct maxItemRepairAmount
         * @property {common.IMoney|null} [maxCashOutAmount] SearchV2BaseAttributesForProduct maxCashOutAmount
         * @property {common.IMoney|null} [maintenanceFee] SearchV2BaseAttributesForProduct maintenanceFee
         * @property {number|null} [maxStreemCallCount] SearchV2BaseAttributesForProduct maxStreemCallCount
         */

        /**
         * Constructs a new SearchV2BaseAttributesForProduct.
         * @memberof coreproductpb
         * @classdesc Represents a SearchV2BaseAttributesForProduct.
         * @implements ISearchV2BaseAttributesForProduct
         * @constructor
         * @param {coreproductpb.ISearchV2BaseAttributesForProduct=} [p] Properties to set
         */
        function SearchV2BaseAttributesForProduct(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * SearchV2BaseAttributesForProduct brand.
         * @member {string} brand
         * @memberof coreproductpb.SearchV2BaseAttributesForProduct
         * @instance
         */
        SearchV2BaseAttributesForProduct.prototype.brand = "";

        /**
         * SearchV2BaseAttributesForProduct salesChannel.
         * @member {string} salesChannel
         * @memberof coreproductpb.SearchV2BaseAttributesForProduct
         * @instance
         */
        SearchV2BaseAttributesForProduct.prototype.salesChannel = "";

        /**
         * SearchV2BaseAttributesForProduct recallPeriod.
         * @member {coreproductpb.TypedValue.ITimePeriod|null|undefined} recallPeriod
         * @memberof coreproductpb.SearchV2BaseAttributesForProduct
         * @instance
         */
        SearchV2BaseAttributesForProduct.prototype.recallPeriod = null;

        /**
         * SearchV2BaseAttributesForProduct contractTerm.
         * @member {coreproductpb.TypedValue.ITimePeriod|null|undefined} contractTerm
         * @memberof coreproductpb.SearchV2BaseAttributesForProduct
         * @instance
         */
        SearchV2BaseAttributesForProduct.prototype.contractTerm = null;

        /**
         * SearchV2BaseAttributesForProduct listingCoverageTerm.
         * @member {coreproductpb.TypedValue.ITimePeriod|null|undefined} listingCoverageTerm
         * @memberof coreproductpb.SearchV2BaseAttributesForProduct
         * @instance
         */
        SearchV2BaseAttributesForProduct.prototype.listingCoverageTerm = null;

        /**
         * SearchV2BaseAttributesForProduct listingCoverageBeneficiary.
         * @member {string} listingCoverageBeneficiary
         * @memberof coreproductpb.SearchV2BaseAttributesForProduct
         * @instance
         */
        SearchV2BaseAttributesForProduct.prototype.listingCoverageBeneficiary = "";

        /**
         * SearchV2BaseAttributesForProduct salesGroup.
         * @member {string} salesGroup
         * @memberof coreproductpb.SearchV2BaseAttributesForProduct
         * @instance
         */
        SearchV2BaseAttributesForProduct.prototype.salesGroup = "";

        /**
         * SearchV2BaseAttributesForProduct starFulfillments.
         * @member {coreproductpb.TypedValue.IStarFulfillmentList|null|undefined} starFulfillments
         * @memberof coreproductpb.SearchV2BaseAttributesForProduct
         * @instance
         */
        SearchV2BaseAttributesForProduct.prototype.starFulfillments = null;

        /**
         * SearchV2BaseAttributesForProduct starRemarks.
         * @member {coreproductpb.TypedValue.IStarRemarkList|null|undefined} starRemarks
         * @memberof coreproductpb.SearchV2BaseAttributesForProduct
         * @instance
         */
        SearchV2BaseAttributesForProduct.prototype.starRemarks = null;

        /**
         * SearchV2BaseAttributesForProduct repairWaitPeriod.
         * @member {coreproductpb.TypedValue.ITimePeriod|null|undefined} repairWaitPeriod
         * @memberof coreproductpb.SearchV2BaseAttributesForProduct
         * @instance
         */
        SearchV2BaseAttributesForProduct.prototype.repairWaitPeriod = null;

        /**
         * SearchV2BaseAttributesForProduct maintenanceWaitPeriod.
         * @member {coreproductpb.TypedValue.ITimePeriod|null|undefined} maintenanceWaitPeriod
         * @memberof coreproductpb.SearchV2BaseAttributesForProduct
         * @instance
         */
        SearchV2BaseAttributesForProduct.prototype.maintenanceWaitPeriod = null;

        /**
         * SearchV2BaseAttributesForProduct aggregateCashOutAmount.
         * @member {common.IMoney|null|undefined} aggregateCashOutAmount
         * @memberof coreproductpb.SearchV2BaseAttributesForProduct
         * @instance
         */
        SearchV2BaseAttributesForProduct.prototype.aggregateCashOutAmount = null;

        /**
         * SearchV2BaseAttributesForProduct postCashOutAssetRepairWaitPeriod.
         * @member {coreproductpb.TypedValue.ITimePeriod|null|undefined} postCashOutAssetRepairWaitPeriod
         * @memberof coreproductpb.SearchV2BaseAttributesForProduct
         * @instance
         */
        SearchV2BaseAttributesForProduct.prototype.postCashOutAssetRepairWaitPeriod = null;

        /**
         * SearchV2BaseAttributesForProduct aggregateRepairAmount.
         * @member {common.IMoney|null|undefined} aggregateRepairAmount
         * @memberof coreproductpb.SearchV2BaseAttributesForProduct
         * @instance
         */
        SearchV2BaseAttributesForProduct.prototype.aggregateRepairAmount = null;

        /**
         * SearchV2BaseAttributesForProduct diagnosisFee.
         * @member {common.IMoney|null|undefined} diagnosisFee
         * @memberof coreproductpb.SearchV2BaseAttributesForProduct
         * @instance
         */
        SearchV2BaseAttributesForProduct.prototype.diagnosisFee = null;

        /**
         * SearchV2BaseAttributesForProduct maxItemRepairAmount.
         * @member {common.IMoney|null|undefined} maxItemRepairAmount
         * @memberof coreproductpb.SearchV2BaseAttributesForProduct
         * @instance
         */
        SearchV2BaseAttributesForProduct.prototype.maxItemRepairAmount = null;

        /**
         * SearchV2BaseAttributesForProduct maxCashOutAmount.
         * @member {common.IMoney|null|undefined} maxCashOutAmount
         * @memberof coreproductpb.SearchV2BaseAttributesForProduct
         * @instance
         */
        SearchV2BaseAttributesForProduct.prototype.maxCashOutAmount = null;

        /**
         * SearchV2BaseAttributesForProduct maintenanceFee.
         * @member {common.IMoney|null|undefined} maintenanceFee
         * @memberof coreproductpb.SearchV2BaseAttributesForProduct
         * @instance
         */
        SearchV2BaseAttributesForProduct.prototype.maintenanceFee = null;

        /**
         * SearchV2BaseAttributesForProduct maxStreemCallCount.
         * @member {number} maxStreemCallCount
         * @memberof coreproductpb.SearchV2BaseAttributesForProduct
         * @instance
         */
        SearchV2BaseAttributesForProduct.prototype.maxStreemCallCount = 0;

        /**
         * Creates a new SearchV2BaseAttributesForProduct instance using the specified properties.
         * @function create
         * @memberof coreproductpb.SearchV2BaseAttributesForProduct
         * @static
         * @param {coreproductpb.ISearchV2BaseAttributesForProduct=} [properties] Properties to set
         * @returns {coreproductpb.SearchV2BaseAttributesForProduct} SearchV2BaseAttributesForProduct instance
         */
        SearchV2BaseAttributesForProduct.create = function create(properties) {
            return new SearchV2BaseAttributesForProduct(properties);
        };

        /**
         * Encodes the specified SearchV2BaseAttributesForProduct message. Does not implicitly {@link coreproductpb.SearchV2BaseAttributesForProduct.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.SearchV2BaseAttributesForProduct
         * @static
         * @param {coreproductpb.ISearchV2BaseAttributesForProduct} m SearchV2BaseAttributesForProduct message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SearchV2BaseAttributesForProduct.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.brand != null && Object.hasOwnProperty.call(m, "brand"))
                w.uint32(10).string(m.brand);
            if (m.salesChannel != null && Object.hasOwnProperty.call(m, "salesChannel"))
                w.uint32(18).string(m.salesChannel);
            if (m.recallPeriod != null && Object.hasOwnProperty.call(m, "recallPeriod"))
                $root.coreproductpb.TypedValue.TimePeriod.encode(m.recallPeriod, w.uint32(26).fork()).ldelim();
            if (m.contractTerm != null && Object.hasOwnProperty.call(m, "contractTerm"))
                $root.coreproductpb.TypedValue.TimePeriod.encode(m.contractTerm, w.uint32(34).fork()).ldelim();
            if (m.listingCoverageTerm != null && Object.hasOwnProperty.call(m, "listingCoverageTerm"))
                $root.coreproductpb.TypedValue.TimePeriod.encode(m.listingCoverageTerm, w.uint32(42).fork()).ldelim();
            if (m.listingCoverageBeneficiary != null && Object.hasOwnProperty.call(m, "listingCoverageBeneficiary"))
                w.uint32(50).string(m.listingCoverageBeneficiary);
            if (m.salesGroup != null && Object.hasOwnProperty.call(m, "salesGroup"))
                w.uint32(58).string(m.salesGroup);
            if (m.starFulfillments != null && Object.hasOwnProperty.call(m, "starFulfillments"))
                $root.coreproductpb.TypedValue.StarFulfillmentList.encode(m.starFulfillments, w.uint32(66).fork()).ldelim();
            if (m.starRemarks != null && Object.hasOwnProperty.call(m, "starRemarks"))
                $root.coreproductpb.TypedValue.StarRemarkList.encode(m.starRemarks, w.uint32(74).fork()).ldelim();
            if (m.repairWaitPeriod != null && Object.hasOwnProperty.call(m, "repairWaitPeriod"))
                $root.coreproductpb.TypedValue.TimePeriod.encode(m.repairWaitPeriod, w.uint32(82).fork()).ldelim();
            if (m.maintenanceWaitPeriod != null && Object.hasOwnProperty.call(m, "maintenanceWaitPeriod"))
                $root.coreproductpb.TypedValue.TimePeriod.encode(m.maintenanceWaitPeriod, w.uint32(90).fork()).ldelim();
            if (m.aggregateCashOutAmount != null && Object.hasOwnProperty.call(m, "aggregateCashOutAmount"))
                $root.common.Money.encode(m.aggregateCashOutAmount, w.uint32(98).fork()).ldelim();
            if (m.postCashOutAssetRepairWaitPeriod != null && Object.hasOwnProperty.call(m, "postCashOutAssetRepairWaitPeriod"))
                $root.coreproductpb.TypedValue.TimePeriod.encode(m.postCashOutAssetRepairWaitPeriod, w.uint32(106).fork()).ldelim();
            if (m.aggregateRepairAmount != null && Object.hasOwnProperty.call(m, "aggregateRepairAmount"))
                $root.common.Money.encode(m.aggregateRepairAmount, w.uint32(114).fork()).ldelim();
            if (m.diagnosisFee != null && Object.hasOwnProperty.call(m, "diagnosisFee"))
                $root.common.Money.encode(m.diagnosisFee, w.uint32(122).fork()).ldelim();
            if (m.maxItemRepairAmount != null && Object.hasOwnProperty.call(m, "maxItemRepairAmount"))
                $root.common.Money.encode(m.maxItemRepairAmount, w.uint32(130).fork()).ldelim();
            if (m.maxCashOutAmount != null && Object.hasOwnProperty.call(m, "maxCashOutAmount"))
                $root.common.Money.encode(m.maxCashOutAmount, w.uint32(138).fork()).ldelim();
            if (m.maintenanceFee != null && Object.hasOwnProperty.call(m, "maintenanceFee"))
                $root.common.Money.encode(m.maintenanceFee, w.uint32(146).fork()).ldelim();
            if (m.maxStreemCallCount != null && Object.hasOwnProperty.call(m, "maxStreemCallCount"))
                w.uint32(152).int32(m.maxStreemCallCount);
            return w;
        };

        /**
         * Decodes a SearchV2BaseAttributesForProduct message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.SearchV2BaseAttributesForProduct
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.SearchV2BaseAttributesForProduct} SearchV2BaseAttributesForProduct
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SearchV2BaseAttributesForProduct.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.SearchV2BaseAttributesForProduct();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.brand = r.string();
                    break;
                case 2:
                    m.salesChannel = r.string();
                    break;
                case 3:
                    m.recallPeriod = $root.coreproductpb.TypedValue.TimePeriod.decode(r, r.uint32());
                    break;
                case 4:
                    m.contractTerm = $root.coreproductpb.TypedValue.TimePeriod.decode(r, r.uint32());
                    break;
                case 5:
                    m.listingCoverageTerm = $root.coreproductpb.TypedValue.TimePeriod.decode(r, r.uint32());
                    break;
                case 6:
                    m.listingCoverageBeneficiary = r.string();
                    break;
                case 7:
                    m.salesGroup = r.string();
                    break;
                case 8:
                    m.starFulfillments = $root.coreproductpb.TypedValue.StarFulfillmentList.decode(r, r.uint32());
                    break;
                case 9:
                    m.starRemarks = $root.coreproductpb.TypedValue.StarRemarkList.decode(r, r.uint32());
                    break;
                case 10:
                    m.repairWaitPeriod = $root.coreproductpb.TypedValue.TimePeriod.decode(r, r.uint32());
                    break;
                case 11:
                    m.maintenanceWaitPeriod = $root.coreproductpb.TypedValue.TimePeriod.decode(r, r.uint32());
                    break;
                case 12:
                    m.aggregateCashOutAmount = $root.common.Money.decode(r, r.uint32());
                    break;
                case 13:
                    m.postCashOutAssetRepairWaitPeriod = $root.coreproductpb.TypedValue.TimePeriod.decode(r, r.uint32());
                    break;
                case 14:
                    m.aggregateRepairAmount = $root.common.Money.decode(r, r.uint32());
                    break;
                case 15:
                    m.diagnosisFee = $root.common.Money.decode(r, r.uint32());
                    break;
                case 16:
                    m.maxItemRepairAmount = $root.common.Money.decode(r, r.uint32());
                    break;
                case 17:
                    m.maxCashOutAmount = $root.common.Money.decode(r, r.uint32());
                    break;
                case 18:
                    m.maintenanceFee = $root.common.Money.decode(r, r.uint32());
                    break;
                case 19:
                    m.maxStreemCallCount = r.int32();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return SearchV2BaseAttributesForProduct;
    })();

    coreproductpb.SearchV2DetailsProductAttributes = (function() {

        /**
         * Properties of a SearchV2DetailsProductAttributes.
         * @memberof coreproductpb
         * @interface ISearchV2DetailsProductAttributes
         * @property {coreproductpb.TypedValue.IGeography|null} [geography] SearchV2DetailsProductAttributes geography
         * @property {coreproductpb.TypedValue.IStringList|null} [propertyType] SearchV2DetailsProductAttributes propertyType
         * @property {coreproductpb.TypedValue.IAreaRange|null} [propertySize] SearchV2DetailsProductAttributes propertySize
         * @property {coreproductpb.TypedValue.ITimePeriodRange|null} [propertyAge] SearchV2DetailsProductAttributes propertyAge
         * @property {coreproductpb.TypedValue.IStringList|null} [franchise] SearchV2DetailsProductAttributes franchise
         */

        /**
         * Constructs a new SearchV2DetailsProductAttributes.
         * @memberof coreproductpb
         * @classdesc Represents a SearchV2DetailsProductAttributes.
         * @implements ISearchV2DetailsProductAttributes
         * @constructor
         * @param {coreproductpb.ISearchV2DetailsProductAttributes=} [p] Properties to set
         */
        function SearchV2DetailsProductAttributes(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * SearchV2DetailsProductAttributes geography.
         * @member {coreproductpb.TypedValue.IGeography|null|undefined} geography
         * @memberof coreproductpb.SearchV2DetailsProductAttributes
         * @instance
         */
        SearchV2DetailsProductAttributes.prototype.geography = null;

        /**
         * SearchV2DetailsProductAttributes propertyType.
         * @member {coreproductpb.TypedValue.IStringList|null|undefined} propertyType
         * @memberof coreproductpb.SearchV2DetailsProductAttributes
         * @instance
         */
        SearchV2DetailsProductAttributes.prototype.propertyType = null;

        /**
         * SearchV2DetailsProductAttributes propertySize.
         * @member {coreproductpb.TypedValue.IAreaRange|null|undefined} propertySize
         * @memberof coreproductpb.SearchV2DetailsProductAttributes
         * @instance
         */
        SearchV2DetailsProductAttributes.prototype.propertySize = null;

        /**
         * SearchV2DetailsProductAttributes propertyAge.
         * @member {coreproductpb.TypedValue.ITimePeriodRange|null|undefined} propertyAge
         * @memberof coreproductpb.SearchV2DetailsProductAttributes
         * @instance
         */
        SearchV2DetailsProductAttributes.prototype.propertyAge = null;

        /**
         * SearchV2DetailsProductAttributes franchise.
         * @member {coreproductpb.TypedValue.IStringList|null|undefined} franchise
         * @memberof coreproductpb.SearchV2DetailsProductAttributes
         * @instance
         */
        SearchV2DetailsProductAttributes.prototype.franchise = null;

        /**
         * Creates a new SearchV2DetailsProductAttributes instance using the specified properties.
         * @function create
         * @memberof coreproductpb.SearchV2DetailsProductAttributes
         * @static
         * @param {coreproductpb.ISearchV2DetailsProductAttributes=} [properties] Properties to set
         * @returns {coreproductpb.SearchV2DetailsProductAttributes} SearchV2DetailsProductAttributes instance
         */
        SearchV2DetailsProductAttributes.create = function create(properties) {
            return new SearchV2DetailsProductAttributes(properties);
        };

        /**
         * Encodes the specified SearchV2DetailsProductAttributes message. Does not implicitly {@link coreproductpb.SearchV2DetailsProductAttributes.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.SearchV2DetailsProductAttributes
         * @static
         * @param {coreproductpb.ISearchV2DetailsProductAttributes} m SearchV2DetailsProductAttributes message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SearchV2DetailsProductAttributes.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.geography != null && Object.hasOwnProperty.call(m, "geography"))
                $root.coreproductpb.TypedValue.Geography.encode(m.geography, w.uint32(10).fork()).ldelim();
            if (m.propertyType != null && Object.hasOwnProperty.call(m, "propertyType"))
                $root.coreproductpb.TypedValue.StringList.encode(m.propertyType, w.uint32(18).fork()).ldelim();
            if (m.propertySize != null && Object.hasOwnProperty.call(m, "propertySize"))
                $root.coreproductpb.TypedValue.AreaRange.encode(m.propertySize, w.uint32(26).fork()).ldelim();
            if (m.propertyAge != null && Object.hasOwnProperty.call(m, "propertyAge"))
                $root.coreproductpb.TypedValue.TimePeriodRange.encode(m.propertyAge, w.uint32(34).fork()).ldelim();
            if (m.franchise != null && Object.hasOwnProperty.call(m, "franchise"))
                $root.coreproductpb.TypedValue.StringList.encode(m.franchise, w.uint32(42).fork()).ldelim();
            return w;
        };

        /**
         * Decodes a SearchV2DetailsProductAttributes message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.SearchV2DetailsProductAttributes
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.SearchV2DetailsProductAttributes} SearchV2DetailsProductAttributes
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SearchV2DetailsProductAttributes.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.SearchV2DetailsProductAttributes();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.geography = $root.coreproductpb.TypedValue.Geography.decode(r, r.uint32());
                    break;
                case 2:
                    m.propertyType = $root.coreproductpb.TypedValue.StringList.decode(r, r.uint32());
                    break;
                case 3:
                    m.propertySize = $root.coreproductpb.TypedValue.AreaRange.decode(r, r.uint32());
                    break;
                case 4:
                    m.propertyAge = $root.coreproductpb.TypedValue.TimePeriodRange.decode(r, r.uint32());
                    break;
                case 5:
                    m.franchise = $root.coreproductpb.TypedValue.StringList.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return SearchV2DetailsProductAttributes;
    })();

    coreproductpb.SearchV2ProductFeatures = (function() {

        /**
         * Properties of a SearchV2ProductFeatures.
         * @memberof coreproductpb
         * @interface ISearchV2ProductFeatures
         * @property {Array.<coreproductpb.ISearchV2Feature>|null} [baseFeatures] SearchV2ProductFeatures baseFeatures
         * @property {coreproductpb.ISearchV2AddOnFeatures|null} [addOnFeatures] SearchV2ProductFeatures addOnFeatures
         * @property {Array.<coreproductpb.ISearchV2FeatureBundle>|null} [baseFeatureBundles] SearchV2ProductFeatures baseFeatureBundles
         * @property {coreproductpb.ISearchV2AddOnFeatureBundles|null} [addOnFeatureBundles] SearchV2ProductFeatures addOnFeatureBundles
         */

        /**
         * Constructs a new SearchV2ProductFeatures.
         * @memberof coreproductpb
         * @classdesc Represents a SearchV2ProductFeatures.
         * @implements ISearchV2ProductFeatures
         * @constructor
         * @param {coreproductpb.ISearchV2ProductFeatures=} [p] Properties to set
         */
        function SearchV2ProductFeatures(p) {
            this.baseFeatures = [];
            this.baseFeatureBundles = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * SearchV2ProductFeatures baseFeatures.
         * @member {Array.<coreproductpb.ISearchV2Feature>} baseFeatures
         * @memberof coreproductpb.SearchV2ProductFeatures
         * @instance
         */
        SearchV2ProductFeatures.prototype.baseFeatures = $util.emptyArray;

        /**
         * SearchV2ProductFeatures addOnFeatures.
         * @member {coreproductpb.ISearchV2AddOnFeatures|null|undefined} addOnFeatures
         * @memberof coreproductpb.SearchV2ProductFeatures
         * @instance
         */
        SearchV2ProductFeatures.prototype.addOnFeatures = null;

        /**
         * SearchV2ProductFeatures baseFeatureBundles.
         * @member {Array.<coreproductpb.ISearchV2FeatureBundle>} baseFeatureBundles
         * @memberof coreproductpb.SearchV2ProductFeatures
         * @instance
         */
        SearchV2ProductFeatures.prototype.baseFeatureBundles = $util.emptyArray;

        /**
         * SearchV2ProductFeatures addOnFeatureBundles.
         * @member {coreproductpb.ISearchV2AddOnFeatureBundles|null|undefined} addOnFeatureBundles
         * @memberof coreproductpb.SearchV2ProductFeatures
         * @instance
         */
        SearchV2ProductFeatures.prototype.addOnFeatureBundles = null;

        /**
         * Creates a new SearchV2ProductFeatures instance using the specified properties.
         * @function create
         * @memberof coreproductpb.SearchV2ProductFeatures
         * @static
         * @param {coreproductpb.ISearchV2ProductFeatures=} [properties] Properties to set
         * @returns {coreproductpb.SearchV2ProductFeatures} SearchV2ProductFeatures instance
         */
        SearchV2ProductFeatures.create = function create(properties) {
            return new SearchV2ProductFeatures(properties);
        };

        /**
         * Encodes the specified SearchV2ProductFeatures message. Does not implicitly {@link coreproductpb.SearchV2ProductFeatures.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.SearchV2ProductFeatures
         * @static
         * @param {coreproductpb.ISearchV2ProductFeatures} m SearchV2ProductFeatures message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SearchV2ProductFeatures.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.baseFeatures != null && m.baseFeatures.length) {
                for (var i = 0; i < m.baseFeatures.length; ++i)
                    $root.coreproductpb.SearchV2Feature.encode(m.baseFeatures[i], w.uint32(10).fork()).ldelim();
            }
            if (m.addOnFeatures != null && Object.hasOwnProperty.call(m, "addOnFeatures"))
                $root.coreproductpb.SearchV2AddOnFeatures.encode(m.addOnFeatures, w.uint32(18).fork()).ldelim();
            if (m.baseFeatureBundles != null && m.baseFeatureBundles.length) {
                for (var i = 0; i < m.baseFeatureBundles.length; ++i)
                    $root.coreproductpb.SearchV2FeatureBundle.encode(m.baseFeatureBundles[i], w.uint32(26).fork()).ldelim();
            }
            if (m.addOnFeatureBundles != null && Object.hasOwnProperty.call(m, "addOnFeatureBundles"))
                $root.coreproductpb.SearchV2AddOnFeatureBundles.encode(m.addOnFeatureBundles, w.uint32(34).fork()).ldelim();
            return w;
        };

        /**
         * Decodes a SearchV2ProductFeatures message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.SearchV2ProductFeatures
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.SearchV2ProductFeatures} SearchV2ProductFeatures
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SearchV2ProductFeatures.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.SearchV2ProductFeatures();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    if (!(m.baseFeatures && m.baseFeatures.length))
                        m.baseFeatures = [];
                    m.baseFeatures.push($root.coreproductpb.SearchV2Feature.decode(r, r.uint32()));
                    break;
                case 2:
                    m.addOnFeatures = $root.coreproductpb.SearchV2AddOnFeatures.decode(r, r.uint32());
                    break;
                case 3:
                    if (!(m.baseFeatureBundles && m.baseFeatureBundles.length))
                        m.baseFeatureBundles = [];
                    m.baseFeatureBundles.push($root.coreproductpb.SearchV2FeatureBundle.decode(r, r.uint32()));
                    break;
                case 4:
                    m.addOnFeatureBundles = $root.coreproductpb.SearchV2AddOnFeatureBundles.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return SearchV2ProductFeatures;
    })();

    coreproductpb.SearchV2Feature = (function() {

        /**
         * Properties of a SearchV2Feature.
         * @memberof coreproductpb
         * @interface ISearchV2Feature
         * @property {coreproductpb.FeatureMasterDataType|null} [masterDataType] SearchV2Feature masterDataType
         * @property {string|null} [masterDataID] SearchV2Feature masterDataID
         * @property {string|null} [name] SearchV2Feature name
         * @property {Array.<coreproductpb.ISearchV2Feature>|null} [includes] SearchV2Feature includes
         * @property {Array.<coreproductpb.ISearchV2Feature>|null} [excludes] SearchV2Feature excludes
         * @property {coreproductpb.ISearchV2CoverageAttributes|null} [coverageAttributes] SearchV2Feature coverageAttributes
         * @property {coreproductpb.ISearchV2ItemAttributes|null} [itemAttributes] SearchV2Feature itemAttributes
         * @property {coreproductpb.ISearchV2MaintenanceServiceAttributes|null} [maintenanceServiceAttributes] SearchV2Feature maintenanceServiceAttributes
         * @property {coreproductpb.ISearchV2FeatureCoverageAttributes|null} [featureCoverageAttributes] SearchV2Feature featureCoverageAttributes
         */

        /**
         * Constructs a new SearchV2Feature.
         * @memberof coreproductpb
         * @classdesc Represents a SearchV2Feature.
         * @implements ISearchV2Feature
         * @constructor
         * @param {coreproductpb.ISearchV2Feature=} [p] Properties to set
         */
        function SearchV2Feature(p) {
            this.includes = [];
            this.excludes = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * SearchV2Feature masterDataType.
         * @member {coreproductpb.FeatureMasterDataType} masterDataType
         * @memberof coreproductpb.SearchV2Feature
         * @instance
         */
        SearchV2Feature.prototype.masterDataType = 0;

        /**
         * SearchV2Feature masterDataID.
         * @member {string} masterDataID
         * @memberof coreproductpb.SearchV2Feature
         * @instance
         */
        SearchV2Feature.prototype.masterDataID = "";

        /**
         * SearchV2Feature name.
         * @member {string} name
         * @memberof coreproductpb.SearchV2Feature
         * @instance
         */
        SearchV2Feature.prototype.name = "";

        /**
         * SearchV2Feature includes.
         * @member {Array.<coreproductpb.ISearchV2Feature>} includes
         * @memberof coreproductpb.SearchV2Feature
         * @instance
         */
        SearchV2Feature.prototype.includes = $util.emptyArray;

        /**
         * SearchV2Feature excludes.
         * @member {Array.<coreproductpb.ISearchV2Feature>} excludes
         * @memberof coreproductpb.SearchV2Feature
         * @instance
         */
        SearchV2Feature.prototype.excludes = $util.emptyArray;

        /**
         * SearchV2Feature coverageAttributes.
         * @member {coreproductpb.ISearchV2CoverageAttributes|null|undefined} coverageAttributes
         * @memberof coreproductpb.SearchV2Feature
         * @instance
         */
        SearchV2Feature.prototype.coverageAttributes = null;

        /**
         * SearchV2Feature itemAttributes.
         * @member {coreproductpb.ISearchV2ItemAttributes|null|undefined} itemAttributes
         * @memberof coreproductpb.SearchV2Feature
         * @instance
         */
        SearchV2Feature.prototype.itemAttributes = null;

        /**
         * SearchV2Feature maintenanceServiceAttributes.
         * @member {coreproductpb.ISearchV2MaintenanceServiceAttributes|null|undefined} maintenanceServiceAttributes
         * @memberof coreproductpb.SearchV2Feature
         * @instance
         */
        SearchV2Feature.prototype.maintenanceServiceAttributes = null;

        /**
         * SearchV2Feature featureCoverageAttributes.
         * @member {coreproductpb.ISearchV2FeatureCoverageAttributes|null|undefined} featureCoverageAttributes
         * @memberof coreproductpb.SearchV2Feature
         * @instance
         */
        SearchV2Feature.prototype.featureCoverageAttributes = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        /**
         * SearchV2Feature featureAttributes.
         * @member {"coverageAttributes"|"itemAttributes"|"maintenanceServiceAttributes"|"featureCoverageAttributes"|undefined} featureAttributes
         * @memberof coreproductpb.SearchV2Feature
         * @instance
         */
        Object.defineProperty(SearchV2Feature.prototype, "featureAttributes", {
            get: $util.oneOfGetter($oneOfFields = ["coverageAttributes", "itemAttributes", "maintenanceServiceAttributes", "featureCoverageAttributes"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new SearchV2Feature instance using the specified properties.
         * @function create
         * @memberof coreproductpb.SearchV2Feature
         * @static
         * @param {coreproductpb.ISearchV2Feature=} [properties] Properties to set
         * @returns {coreproductpb.SearchV2Feature} SearchV2Feature instance
         */
        SearchV2Feature.create = function create(properties) {
            return new SearchV2Feature(properties);
        };

        /**
         * Encodes the specified SearchV2Feature message. Does not implicitly {@link coreproductpb.SearchV2Feature.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.SearchV2Feature
         * @static
         * @param {coreproductpb.ISearchV2Feature} m SearchV2Feature message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SearchV2Feature.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.masterDataType != null && Object.hasOwnProperty.call(m, "masterDataType"))
                w.uint32(8).int32(m.masterDataType);
            if (m.masterDataID != null && Object.hasOwnProperty.call(m, "masterDataID"))
                w.uint32(18).string(m.masterDataID);
            if (m.name != null && Object.hasOwnProperty.call(m, "name"))
                w.uint32(26).string(m.name);
            if (m.includes != null && m.includes.length) {
                for (var i = 0; i < m.includes.length; ++i)
                    $root.coreproductpb.SearchV2Feature.encode(m.includes[i], w.uint32(34).fork()).ldelim();
            }
            if (m.excludes != null && m.excludes.length) {
                for (var i = 0; i < m.excludes.length; ++i)
                    $root.coreproductpb.SearchV2Feature.encode(m.excludes[i], w.uint32(42).fork()).ldelim();
            }
            if (m.coverageAttributes != null && Object.hasOwnProperty.call(m, "coverageAttributes"))
                $root.coreproductpb.SearchV2CoverageAttributes.encode(m.coverageAttributes, w.uint32(50).fork()).ldelim();
            if (m.itemAttributes != null && Object.hasOwnProperty.call(m, "itemAttributes"))
                $root.coreproductpb.SearchV2ItemAttributes.encode(m.itemAttributes, w.uint32(58).fork()).ldelim();
            if (m.maintenanceServiceAttributes != null && Object.hasOwnProperty.call(m, "maintenanceServiceAttributes"))
                $root.coreproductpb.SearchV2MaintenanceServiceAttributes.encode(m.maintenanceServiceAttributes, w.uint32(66).fork()).ldelim();
            if (m.featureCoverageAttributes != null && Object.hasOwnProperty.call(m, "featureCoverageAttributes"))
                $root.coreproductpb.SearchV2FeatureCoverageAttributes.encode(m.featureCoverageAttributes, w.uint32(74).fork()).ldelim();
            return w;
        };

        /**
         * Decodes a SearchV2Feature message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.SearchV2Feature
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.SearchV2Feature} SearchV2Feature
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SearchV2Feature.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.SearchV2Feature();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.masterDataType = r.int32();
                    break;
                case 2:
                    m.masterDataID = r.string();
                    break;
                case 3:
                    m.name = r.string();
                    break;
                case 4:
                    if (!(m.includes && m.includes.length))
                        m.includes = [];
                    m.includes.push($root.coreproductpb.SearchV2Feature.decode(r, r.uint32()));
                    break;
                case 5:
                    if (!(m.excludes && m.excludes.length))
                        m.excludes = [];
                    m.excludes.push($root.coreproductpb.SearchV2Feature.decode(r, r.uint32()));
                    break;
                case 6:
                    m.coverageAttributes = $root.coreproductpb.SearchV2CoverageAttributes.decode(r, r.uint32());
                    break;
                case 7:
                    m.itemAttributes = $root.coreproductpb.SearchV2ItemAttributes.decode(r, r.uint32());
                    break;
                case 8:
                    m.maintenanceServiceAttributes = $root.coreproductpb.SearchV2MaintenanceServiceAttributes.decode(r, r.uint32());
                    break;
                case 9:
                    m.featureCoverageAttributes = $root.coreproductpb.SearchV2FeatureCoverageAttributes.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return SearchV2Feature;
    })();

    coreproductpb.SearchV2CoverageAttributes = (function() {

        /**
         * Properties of a SearchV2CoverageAttributes.
         * @memberof coreproductpb
         * @interface ISearchV2CoverageAttributes
         * @property {string|null} [description] SearchV2CoverageAttributes description
         * @property {string|null} [starCoverageID] SearchV2CoverageAttributes starCoverageID
         * @property {coreproductpb.SearchV2CoverageAttributes.IBaseCoverageAttributes|null} [base] SearchV2CoverageAttributes base
         * @property {coreproductpb.SearchV2CoverageAttributes.IDetailsCoverageAttributes|null} [details] SearchV2CoverageAttributes details
         * @property {google.protobuf.ITimestamp|null} [expirationDate] SearchV2CoverageAttributes expirationDate
         */

        /**
         * Constructs a new SearchV2CoverageAttributes.
         * @memberof coreproductpb
         * @classdesc Represents a SearchV2CoverageAttributes.
         * @implements ISearchV2CoverageAttributes
         * @constructor
         * @param {coreproductpb.ISearchV2CoverageAttributes=} [p] Properties to set
         */
        function SearchV2CoverageAttributes(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * SearchV2CoverageAttributes description.
         * @member {string} description
         * @memberof coreproductpb.SearchV2CoverageAttributes
         * @instance
         */
        SearchV2CoverageAttributes.prototype.description = "";

        /**
         * SearchV2CoverageAttributes starCoverageID.
         * @member {string} starCoverageID
         * @memberof coreproductpb.SearchV2CoverageAttributes
         * @instance
         */
        SearchV2CoverageAttributes.prototype.starCoverageID = "";

        /**
         * SearchV2CoverageAttributes base.
         * @member {coreproductpb.SearchV2CoverageAttributes.IBaseCoverageAttributes|null|undefined} base
         * @memberof coreproductpb.SearchV2CoverageAttributes
         * @instance
         */
        SearchV2CoverageAttributes.prototype.base = null;

        /**
         * SearchV2CoverageAttributes details.
         * @member {coreproductpb.SearchV2CoverageAttributes.IDetailsCoverageAttributes|null|undefined} details
         * @memberof coreproductpb.SearchV2CoverageAttributes
         * @instance
         */
        SearchV2CoverageAttributes.prototype.details = null;

        /**
         * SearchV2CoverageAttributes expirationDate.
         * @member {google.protobuf.ITimestamp|null|undefined} expirationDate
         * @memberof coreproductpb.SearchV2CoverageAttributes
         * @instance
         */
        SearchV2CoverageAttributes.prototype.expirationDate = null;

        /**
         * Creates a new SearchV2CoverageAttributes instance using the specified properties.
         * @function create
         * @memberof coreproductpb.SearchV2CoverageAttributes
         * @static
         * @param {coreproductpb.ISearchV2CoverageAttributes=} [properties] Properties to set
         * @returns {coreproductpb.SearchV2CoverageAttributes} SearchV2CoverageAttributes instance
         */
        SearchV2CoverageAttributes.create = function create(properties) {
            return new SearchV2CoverageAttributes(properties);
        };

        /**
         * Encodes the specified SearchV2CoverageAttributes message. Does not implicitly {@link coreproductpb.SearchV2CoverageAttributes.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.SearchV2CoverageAttributes
         * @static
         * @param {coreproductpb.ISearchV2CoverageAttributes} m SearchV2CoverageAttributes message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SearchV2CoverageAttributes.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.description != null && Object.hasOwnProperty.call(m, "description"))
                w.uint32(10).string(m.description);
            if (m.starCoverageID != null && Object.hasOwnProperty.call(m, "starCoverageID"))
                w.uint32(18).string(m.starCoverageID);
            if (m.base != null && Object.hasOwnProperty.call(m, "base"))
                $root.coreproductpb.SearchV2CoverageAttributes.BaseCoverageAttributes.encode(m.base, w.uint32(26).fork()).ldelim();
            if (m.details != null && Object.hasOwnProperty.call(m, "details"))
                $root.coreproductpb.SearchV2CoverageAttributes.DetailsCoverageAttributes.encode(m.details, w.uint32(34).fork()).ldelim();
            if (m.expirationDate != null && Object.hasOwnProperty.call(m, "expirationDate"))
                $root.google.protobuf.Timestamp.encode(m.expirationDate, w.uint32(74).fork()).ldelim();
            return w;
        };

        /**
         * Decodes a SearchV2CoverageAttributes message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.SearchV2CoverageAttributes
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.SearchV2CoverageAttributes} SearchV2CoverageAttributes
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SearchV2CoverageAttributes.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.SearchV2CoverageAttributes();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.description = r.string();
                    break;
                case 2:
                    m.starCoverageID = r.string();
                    break;
                case 3:
                    m.base = $root.coreproductpb.SearchV2CoverageAttributes.BaseCoverageAttributes.decode(r, r.uint32());
                    break;
                case 4:
                    m.details = $root.coreproductpb.SearchV2CoverageAttributes.DetailsCoverageAttributes.decode(r, r.uint32());
                    break;
                case 9:
                    m.expirationDate = $root.google.protobuf.Timestamp.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        SearchV2CoverageAttributes.BaseCoverageAttributes = (function() {

            /**
             * Properties of a BaseCoverageAttributes.
             * @memberof coreproductpb.SearchV2CoverageAttributes
             * @interface IBaseCoverageAttributes
             * @property {common.IMoney|null} [aggregateRepairAmount] BaseCoverageAttributes aggregateRepairAmount
             * @property {common.IMoney|null} [aggregateCashoutAmount] BaseCoverageAttributes aggregateCashoutAmount
             * @property {common.IMoney|null} [diagnosisFee] BaseCoverageAttributes diagnosisFee
             * @property {common.IMoney|null} [maxItemRepairAmount] BaseCoverageAttributes maxItemRepairAmount
             * @property {common.IMoney|null} [maxCashOutAmount] BaseCoverageAttributes maxCashOutAmount
             * @property {common.IMoney|null} [maintenanceFee] BaseCoverageAttributes maintenanceFee
             * @property {string|null} [listingCoverageBeneficiary] BaseCoverageAttributes listingCoverageBeneficiary
             * @property {number|null} [maxFreeServiceCount] BaseCoverageAttributes maxFreeServiceCount
             * @property {number|null} [maxCount] BaseCoverageAttributes maxCount
             */

            /**
             * Constructs a new BaseCoverageAttributes.
             * @memberof coreproductpb.SearchV2CoverageAttributes
             * @classdesc Represents a BaseCoverageAttributes.
             * @implements IBaseCoverageAttributes
             * @constructor
             * @param {coreproductpb.SearchV2CoverageAttributes.IBaseCoverageAttributes=} [p] Properties to set
             */
            function BaseCoverageAttributes(p) {
                if (p)
                    for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                        if (p[ks[i]] != null)
                            this[ks[i]] = p[ks[i]];
            }

            /**
             * BaseCoverageAttributes aggregateRepairAmount.
             * @member {common.IMoney|null|undefined} aggregateRepairAmount
             * @memberof coreproductpb.SearchV2CoverageAttributes.BaseCoverageAttributes
             * @instance
             */
            BaseCoverageAttributes.prototype.aggregateRepairAmount = null;

            /**
             * BaseCoverageAttributes aggregateCashoutAmount.
             * @member {common.IMoney|null|undefined} aggregateCashoutAmount
             * @memberof coreproductpb.SearchV2CoverageAttributes.BaseCoverageAttributes
             * @instance
             */
            BaseCoverageAttributes.prototype.aggregateCashoutAmount = null;

            /**
             * BaseCoverageAttributes diagnosisFee.
             * @member {common.IMoney|null|undefined} diagnosisFee
             * @memberof coreproductpb.SearchV2CoverageAttributes.BaseCoverageAttributes
             * @instance
             */
            BaseCoverageAttributes.prototype.diagnosisFee = null;

            /**
             * BaseCoverageAttributes maxItemRepairAmount.
             * @member {common.IMoney|null|undefined} maxItemRepairAmount
             * @memberof coreproductpb.SearchV2CoverageAttributes.BaseCoverageAttributes
             * @instance
             */
            BaseCoverageAttributes.prototype.maxItemRepairAmount = null;

            /**
             * BaseCoverageAttributes maxCashOutAmount.
             * @member {common.IMoney|null|undefined} maxCashOutAmount
             * @memberof coreproductpb.SearchV2CoverageAttributes.BaseCoverageAttributes
             * @instance
             */
            BaseCoverageAttributes.prototype.maxCashOutAmount = null;

            /**
             * BaseCoverageAttributes maintenanceFee.
             * @member {common.IMoney|null|undefined} maintenanceFee
             * @memberof coreproductpb.SearchV2CoverageAttributes.BaseCoverageAttributes
             * @instance
             */
            BaseCoverageAttributes.prototype.maintenanceFee = null;

            /**
             * BaseCoverageAttributes listingCoverageBeneficiary.
             * @member {string} listingCoverageBeneficiary
             * @memberof coreproductpb.SearchV2CoverageAttributes.BaseCoverageAttributes
             * @instance
             */
            BaseCoverageAttributes.prototype.listingCoverageBeneficiary = "";

            /**
             * BaseCoverageAttributes maxFreeServiceCount.
             * @member {number} maxFreeServiceCount
             * @memberof coreproductpb.SearchV2CoverageAttributes.BaseCoverageAttributes
             * @instance
             */
            BaseCoverageAttributes.prototype.maxFreeServiceCount = 0;

            /**
             * BaseCoverageAttributes maxCount.
             * @member {number} maxCount
             * @memberof coreproductpb.SearchV2CoverageAttributes.BaseCoverageAttributes
             * @instance
             */
            BaseCoverageAttributes.prototype.maxCount = 0;

            /**
             * Creates a new BaseCoverageAttributes instance using the specified properties.
             * @function create
             * @memberof coreproductpb.SearchV2CoverageAttributes.BaseCoverageAttributes
             * @static
             * @param {coreproductpb.SearchV2CoverageAttributes.IBaseCoverageAttributes=} [properties] Properties to set
             * @returns {coreproductpb.SearchV2CoverageAttributes.BaseCoverageAttributes} BaseCoverageAttributes instance
             */
            BaseCoverageAttributes.create = function create(properties) {
                return new BaseCoverageAttributes(properties);
            };

            /**
             * Encodes the specified BaseCoverageAttributes message. Does not implicitly {@link coreproductpb.SearchV2CoverageAttributes.BaseCoverageAttributes.verify|verify} messages.
             * @function encode
             * @memberof coreproductpb.SearchV2CoverageAttributes.BaseCoverageAttributes
             * @static
             * @param {coreproductpb.SearchV2CoverageAttributes.IBaseCoverageAttributes} m BaseCoverageAttributes message or plain object to encode
             * @param {$protobuf.Writer} [w] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            BaseCoverageAttributes.encode = function encode(m, w) {
                if (!w)
                    w = $Writer.create();
                if (m.aggregateRepairAmount != null && Object.hasOwnProperty.call(m, "aggregateRepairAmount"))
                    $root.common.Money.encode(m.aggregateRepairAmount, w.uint32(10).fork()).ldelim();
                if (m.aggregateCashoutAmount != null && Object.hasOwnProperty.call(m, "aggregateCashoutAmount"))
                    $root.common.Money.encode(m.aggregateCashoutAmount, w.uint32(18).fork()).ldelim();
                if (m.diagnosisFee != null && Object.hasOwnProperty.call(m, "diagnosisFee"))
                    $root.common.Money.encode(m.diagnosisFee, w.uint32(26).fork()).ldelim();
                if (m.maxItemRepairAmount != null && Object.hasOwnProperty.call(m, "maxItemRepairAmount"))
                    $root.common.Money.encode(m.maxItemRepairAmount, w.uint32(34).fork()).ldelim();
                if (m.maxCashOutAmount != null && Object.hasOwnProperty.call(m, "maxCashOutAmount"))
                    $root.common.Money.encode(m.maxCashOutAmount, w.uint32(42).fork()).ldelim();
                if (m.maintenanceFee != null && Object.hasOwnProperty.call(m, "maintenanceFee"))
                    $root.common.Money.encode(m.maintenanceFee, w.uint32(50).fork()).ldelim();
                if (m.listingCoverageBeneficiary != null && Object.hasOwnProperty.call(m, "listingCoverageBeneficiary"))
                    w.uint32(58).string(m.listingCoverageBeneficiary);
                if (m.maxFreeServiceCount != null && Object.hasOwnProperty.call(m, "maxFreeServiceCount"))
                    w.uint32(64).int32(m.maxFreeServiceCount);
                if (m.maxCount != null && Object.hasOwnProperty.call(m, "maxCount"))
                    w.uint32(72).int32(m.maxCount);
                return w;
            };

            /**
             * Decodes a BaseCoverageAttributes message from the specified reader or buffer.
             * @function decode
             * @memberof coreproductpb.SearchV2CoverageAttributes.BaseCoverageAttributes
             * @static
             * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
             * @param {number} [l] Message length if known beforehand
             * @returns {coreproductpb.SearchV2CoverageAttributes.BaseCoverageAttributes} BaseCoverageAttributes
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            BaseCoverageAttributes.decode = function decode(r, l) {
                if (!(r instanceof $Reader))
                    r = $Reader.create(r);
                var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.SearchV2CoverageAttributes.BaseCoverageAttributes();
                while (r.pos < c) {
                    var t = r.uint32();
                    switch (t >>> 3) {
                    case 1:
                        m.aggregateRepairAmount = $root.common.Money.decode(r, r.uint32());
                        break;
                    case 2:
                        m.aggregateCashoutAmount = $root.common.Money.decode(r, r.uint32());
                        break;
                    case 3:
                        m.diagnosisFee = $root.common.Money.decode(r, r.uint32());
                        break;
                    case 4:
                        m.maxItemRepairAmount = $root.common.Money.decode(r, r.uint32());
                        break;
                    case 5:
                        m.maxCashOutAmount = $root.common.Money.decode(r, r.uint32());
                        break;
                    case 6:
                        m.maintenanceFee = $root.common.Money.decode(r, r.uint32());
                        break;
                    case 7:
                        m.listingCoverageBeneficiary = r.string();
                        break;
                    case 8:
                        m.maxFreeServiceCount = r.int32();
                        break;
                    case 9:
                        m.maxCount = r.int32();
                        break;
                    default:
                        r.skipType(t & 7);
                        break;
                    }
                }
                return m;
            };

            return BaseCoverageAttributes;
        })();

        SearchV2CoverageAttributes.DetailsCoverageAttributes = (function() {

            /**
             * Properties of a DetailsCoverageAttributes.
             * @memberof coreproductpb.SearchV2CoverageAttributes
             * @interface IDetailsCoverageAttributes
             * @property {Array.<string>|null} [tags] DetailsCoverageAttributes tags
             */

            /**
             * Constructs a new DetailsCoverageAttributes.
             * @memberof coreproductpb.SearchV2CoverageAttributes
             * @classdesc Represents a DetailsCoverageAttributes.
             * @implements IDetailsCoverageAttributes
             * @constructor
             * @param {coreproductpb.SearchV2CoverageAttributes.IDetailsCoverageAttributes=} [p] Properties to set
             */
            function DetailsCoverageAttributes(p) {
                this.tags = [];
                if (p)
                    for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                        if (p[ks[i]] != null)
                            this[ks[i]] = p[ks[i]];
            }

            /**
             * DetailsCoverageAttributes tags.
             * @member {Array.<string>} tags
             * @memberof coreproductpb.SearchV2CoverageAttributes.DetailsCoverageAttributes
             * @instance
             */
            DetailsCoverageAttributes.prototype.tags = $util.emptyArray;

            /**
             * Creates a new DetailsCoverageAttributes instance using the specified properties.
             * @function create
             * @memberof coreproductpb.SearchV2CoverageAttributes.DetailsCoverageAttributes
             * @static
             * @param {coreproductpb.SearchV2CoverageAttributes.IDetailsCoverageAttributes=} [properties] Properties to set
             * @returns {coreproductpb.SearchV2CoverageAttributes.DetailsCoverageAttributes} DetailsCoverageAttributes instance
             */
            DetailsCoverageAttributes.create = function create(properties) {
                return new DetailsCoverageAttributes(properties);
            };

            /**
             * Encodes the specified DetailsCoverageAttributes message. Does not implicitly {@link coreproductpb.SearchV2CoverageAttributes.DetailsCoverageAttributes.verify|verify} messages.
             * @function encode
             * @memberof coreproductpb.SearchV2CoverageAttributes.DetailsCoverageAttributes
             * @static
             * @param {coreproductpb.SearchV2CoverageAttributes.IDetailsCoverageAttributes} m DetailsCoverageAttributes message or plain object to encode
             * @param {$protobuf.Writer} [w] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            DetailsCoverageAttributes.encode = function encode(m, w) {
                if (!w)
                    w = $Writer.create();
                if (m.tags != null && m.tags.length) {
                    for (var i = 0; i < m.tags.length; ++i)
                        w.uint32(10).string(m.tags[i]);
                }
                return w;
            };

            /**
             * Decodes a DetailsCoverageAttributes message from the specified reader or buffer.
             * @function decode
             * @memberof coreproductpb.SearchV2CoverageAttributes.DetailsCoverageAttributes
             * @static
             * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
             * @param {number} [l] Message length if known beforehand
             * @returns {coreproductpb.SearchV2CoverageAttributes.DetailsCoverageAttributes} DetailsCoverageAttributes
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            DetailsCoverageAttributes.decode = function decode(r, l) {
                if (!(r instanceof $Reader))
                    r = $Reader.create(r);
                var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.SearchV2CoverageAttributes.DetailsCoverageAttributes();
                while (r.pos < c) {
                    var t = r.uint32();
                    switch (t >>> 3) {
                    case 1:
                        if (!(m.tags && m.tags.length))
                            m.tags = [];
                        m.tags.push(r.string());
                        break;
                    default:
                        r.skipType(t & 7);
                        break;
                    }
                }
                return m;
            };

            return DetailsCoverageAttributes;
        })();

        return SearchV2CoverageAttributes;
    })();

    coreproductpb.SearchV2ItemAttributes = (function() {

        /**
         * Properties of a SearchV2ItemAttributes.
         * @memberof coreproductpb
         * @interface ISearchV2ItemAttributes
         * @property {string|null} [styleID] SearchV2ItemAttributes styleID
         * @property {string|null} [tradeID] SearchV2ItemAttributes tradeID
         * @property {string|null} [tradeCode] SearchV2ItemAttributes tradeCode
         * @property {string|null} [starItemID] SearchV2ItemAttributes starItemID
         * @property {string|null} [starTradeCode] SearchV2ItemAttributes starTradeCode
         * @property {common.IMoney|null} [aggregateRepairAmount] SearchV2ItemAttributes aggregateRepairAmount
         * @property {coreproductpb.SearchV2ItemAttributes.IBaseItemAttributes|null} [base] SearchV2ItemAttributes base
         */

        /**
         * Constructs a new SearchV2ItemAttributes.
         * @memberof coreproductpb
         * @classdesc Represents a SearchV2ItemAttributes.
         * @implements ISearchV2ItemAttributes
         * @constructor
         * @param {coreproductpb.ISearchV2ItemAttributes=} [p] Properties to set
         */
        function SearchV2ItemAttributes(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * SearchV2ItemAttributes styleID.
         * @member {string} styleID
         * @memberof coreproductpb.SearchV2ItemAttributes
         * @instance
         */
        SearchV2ItemAttributes.prototype.styleID = "";

        /**
         * SearchV2ItemAttributes tradeID.
         * @member {string} tradeID
         * @memberof coreproductpb.SearchV2ItemAttributes
         * @instance
         */
        SearchV2ItemAttributes.prototype.tradeID = "";

        /**
         * SearchV2ItemAttributes tradeCode.
         * @member {string} tradeCode
         * @memberof coreproductpb.SearchV2ItemAttributes
         * @instance
         */
        SearchV2ItemAttributes.prototype.tradeCode = "";

        /**
         * SearchV2ItemAttributes starItemID.
         * @member {string} starItemID
         * @memberof coreproductpb.SearchV2ItemAttributes
         * @instance
         */
        SearchV2ItemAttributes.prototype.starItemID = "";

        /**
         * SearchV2ItemAttributes starTradeCode.
         * @member {string} starTradeCode
         * @memberof coreproductpb.SearchV2ItemAttributes
         * @instance
         */
        SearchV2ItemAttributes.prototype.starTradeCode = "";

        /**
         * SearchV2ItemAttributes aggregateRepairAmount.
         * @member {common.IMoney|null|undefined} aggregateRepairAmount
         * @memberof coreproductpb.SearchV2ItemAttributes
         * @instance
         */
        SearchV2ItemAttributes.prototype.aggregateRepairAmount = null;

        /**
         * SearchV2ItemAttributes base.
         * @member {coreproductpb.SearchV2ItemAttributes.IBaseItemAttributes|null|undefined} base
         * @memberof coreproductpb.SearchV2ItemAttributes
         * @instance
         */
        SearchV2ItemAttributes.prototype.base = null;

        /**
         * Creates a new SearchV2ItemAttributes instance using the specified properties.
         * @function create
         * @memberof coreproductpb.SearchV2ItemAttributes
         * @static
         * @param {coreproductpb.ISearchV2ItemAttributes=} [properties] Properties to set
         * @returns {coreproductpb.SearchV2ItemAttributes} SearchV2ItemAttributes instance
         */
        SearchV2ItemAttributes.create = function create(properties) {
            return new SearchV2ItemAttributes(properties);
        };

        /**
         * Encodes the specified SearchV2ItemAttributes message. Does not implicitly {@link coreproductpb.SearchV2ItemAttributes.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.SearchV2ItemAttributes
         * @static
         * @param {coreproductpb.ISearchV2ItemAttributes} m SearchV2ItemAttributes message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SearchV2ItemAttributes.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.styleID != null && Object.hasOwnProperty.call(m, "styleID"))
                w.uint32(10).string(m.styleID);
            if (m.tradeID != null && Object.hasOwnProperty.call(m, "tradeID"))
                w.uint32(18).string(m.tradeID);
            if (m.tradeCode != null && Object.hasOwnProperty.call(m, "tradeCode"))
                w.uint32(26).string(m.tradeCode);
            if (m.starItemID != null && Object.hasOwnProperty.call(m, "starItemID"))
                w.uint32(34).string(m.starItemID);
            if (m.starTradeCode != null && Object.hasOwnProperty.call(m, "starTradeCode"))
                w.uint32(42).string(m.starTradeCode);
            if (m.aggregateRepairAmount != null && Object.hasOwnProperty.call(m, "aggregateRepairAmount"))
                $root.common.Money.encode(m.aggregateRepairAmount, w.uint32(50).fork()).ldelim();
            if (m.base != null && Object.hasOwnProperty.call(m, "base"))
                $root.coreproductpb.SearchV2ItemAttributes.BaseItemAttributes.encode(m.base, w.uint32(58).fork()).ldelim();
            return w;
        };

        /**
         * Decodes a SearchV2ItemAttributes message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.SearchV2ItemAttributes
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.SearchV2ItemAttributes} SearchV2ItemAttributes
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SearchV2ItemAttributes.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.SearchV2ItemAttributes();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.styleID = r.string();
                    break;
                case 2:
                    m.tradeID = r.string();
                    break;
                case 3:
                    m.tradeCode = r.string();
                    break;
                case 4:
                    m.starItemID = r.string();
                    break;
                case 5:
                    m.starTradeCode = r.string();
                    break;
                case 6:
                    m.aggregateRepairAmount = $root.common.Money.decode(r, r.uint32());
                    break;
                case 7:
                    m.base = $root.coreproductpb.SearchV2ItemAttributes.BaseItemAttributes.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        SearchV2ItemAttributes.BaseItemAttributes = (function() {

            /**
             * Properties of a BaseItemAttributes.
             * @memberof coreproductpb.SearchV2ItemAttributes
             * @interface IBaseItemAttributes
             * @property {common.IMoney|null} [aggregateCashOutAmount] BaseItemAttributes aggregateCashOutAmount
             * @property {common.IMoney|null} [diagnosisFee] BaseItemAttributes diagnosisFee
             * @property {common.IMoney|null} [maxItemRepairAmount] BaseItemAttributes maxItemRepairAmount
             * @property {common.IMoney|null} [maxCashOutAmount] BaseItemAttributes maxCashOutAmount
             * @property {string|null} [listingCoverageBeneficiary] BaseItemAttributes listingCoverageBeneficiary
             * @property {number|null} [maxItemFreeServiceCount] BaseItemAttributes maxItemFreeServiceCount
             * @property {number|null} [maxItemServiceCount] BaseItemAttributes maxItemServiceCount
             */

            /**
             * Constructs a new BaseItemAttributes.
             * @memberof coreproductpb.SearchV2ItemAttributes
             * @classdesc Represents a BaseItemAttributes.
             * @implements IBaseItemAttributes
             * @constructor
             * @param {coreproductpb.SearchV2ItemAttributes.IBaseItemAttributes=} [p] Properties to set
             */
            function BaseItemAttributes(p) {
                if (p)
                    for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                        if (p[ks[i]] != null)
                            this[ks[i]] = p[ks[i]];
            }

            /**
             * BaseItemAttributes aggregateCashOutAmount.
             * @member {common.IMoney|null|undefined} aggregateCashOutAmount
             * @memberof coreproductpb.SearchV2ItemAttributes.BaseItemAttributes
             * @instance
             */
            BaseItemAttributes.prototype.aggregateCashOutAmount = null;

            /**
             * BaseItemAttributes diagnosisFee.
             * @member {common.IMoney|null|undefined} diagnosisFee
             * @memberof coreproductpb.SearchV2ItemAttributes.BaseItemAttributes
             * @instance
             */
            BaseItemAttributes.prototype.diagnosisFee = null;

            /**
             * BaseItemAttributes maxItemRepairAmount.
             * @member {common.IMoney|null|undefined} maxItemRepairAmount
             * @memberof coreproductpb.SearchV2ItemAttributes.BaseItemAttributes
             * @instance
             */
            BaseItemAttributes.prototype.maxItemRepairAmount = null;

            /**
             * BaseItemAttributes maxCashOutAmount.
             * @member {common.IMoney|null|undefined} maxCashOutAmount
             * @memberof coreproductpb.SearchV2ItemAttributes.BaseItemAttributes
             * @instance
             */
            BaseItemAttributes.prototype.maxCashOutAmount = null;

            /**
             * BaseItemAttributes listingCoverageBeneficiary.
             * @member {string} listingCoverageBeneficiary
             * @memberof coreproductpb.SearchV2ItemAttributes.BaseItemAttributes
             * @instance
             */
            BaseItemAttributes.prototype.listingCoverageBeneficiary = "";

            /**
             * BaseItemAttributes maxItemFreeServiceCount.
             * @member {number} maxItemFreeServiceCount
             * @memberof coreproductpb.SearchV2ItemAttributes.BaseItemAttributes
             * @instance
             */
            BaseItemAttributes.prototype.maxItemFreeServiceCount = 0;

            /**
             * BaseItemAttributes maxItemServiceCount.
             * @member {number} maxItemServiceCount
             * @memberof coreproductpb.SearchV2ItemAttributes.BaseItemAttributes
             * @instance
             */
            BaseItemAttributes.prototype.maxItemServiceCount = 0;

            /**
             * Creates a new BaseItemAttributes instance using the specified properties.
             * @function create
             * @memberof coreproductpb.SearchV2ItemAttributes.BaseItemAttributes
             * @static
             * @param {coreproductpb.SearchV2ItemAttributes.IBaseItemAttributes=} [properties] Properties to set
             * @returns {coreproductpb.SearchV2ItemAttributes.BaseItemAttributes} BaseItemAttributes instance
             */
            BaseItemAttributes.create = function create(properties) {
                return new BaseItemAttributes(properties);
            };

            /**
             * Encodes the specified BaseItemAttributes message. Does not implicitly {@link coreproductpb.SearchV2ItemAttributes.BaseItemAttributes.verify|verify} messages.
             * @function encode
             * @memberof coreproductpb.SearchV2ItemAttributes.BaseItemAttributes
             * @static
             * @param {coreproductpb.SearchV2ItemAttributes.IBaseItemAttributes} m BaseItemAttributes message or plain object to encode
             * @param {$protobuf.Writer} [w] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            BaseItemAttributes.encode = function encode(m, w) {
                if (!w)
                    w = $Writer.create();
                if (m.aggregateCashOutAmount != null && Object.hasOwnProperty.call(m, "aggregateCashOutAmount"))
                    $root.common.Money.encode(m.aggregateCashOutAmount, w.uint32(10).fork()).ldelim();
                if (m.diagnosisFee != null && Object.hasOwnProperty.call(m, "diagnosisFee"))
                    $root.common.Money.encode(m.diagnosisFee, w.uint32(18).fork()).ldelim();
                if (m.maxItemRepairAmount != null && Object.hasOwnProperty.call(m, "maxItemRepairAmount"))
                    $root.common.Money.encode(m.maxItemRepairAmount, w.uint32(26).fork()).ldelim();
                if (m.maxCashOutAmount != null && Object.hasOwnProperty.call(m, "maxCashOutAmount"))
                    $root.common.Money.encode(m.maxCashOutAmount, w.uint32(34).fork()).ldelim();
                if (m.listingCoverageBeneficiary != null && Object.hasOwnProperty.call(m, "listingCoverageBeneficiary"))
                    w.uint32(42).string(m.listingCoverageBeneficiary);
                if (m.maxItemFreeServiceCount != null && Object.hasOwnProperty.call(m, "maxItemFreeServiceCount"))
                    w.uint32(48).int32(m.maxItemFreeServiceCount);
                if (m.maxItemServiceCount != null && Object.hasOwnProperty.call(m, "maxItemServiceCount"))
                    w.uint32(56).int32(m.maxItemServiceCount);
                return w;
            };

            /**
             * Decodes a BaseItemAttributes message from the specified reader or buffer.
             * @function decode
             * @memberof coreproductpb.SearchV2ItemAttributes.BaseItemAttributes
             * @static
             * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
             * @param {number} [l] Message length if known beforehand
             * @returns {coreproductpb.SearchV2ItemAttributes.BaseItemAttributes} BaseItemAttributes
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            BaseItemAttributes.decode = function decode(r, l) {
                if (!(r instanceof $Reader))
                    r = $Reader.create(r);
                var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.SearchV2ItemAttributes.BaseItemAttributes();
                while (r.pos < c) {
                    var t = r.uint32();
                    switch (t >>> 3) {
                    case 1:
                        m.aggregateCashOutAmount = $root.common.Money.decode(r, r.uint32());
                        break;
                    case 2:
                        m.diagnosisFee = $root.common.Money.decode(r, r.uint32());
                        break;
                    case 3:
                        m.maxItemRepairAmount = $root.common.Money.decode(r, r.uint32());
                        break;
                    case 4:
                        m.maxCashOutAmount = $root.common.Money.decode(r, r.uint32());
                        break;
                    case 5:
                        m.listingCoverageBeneficiary = r.string();
                        break;
                    case 6:
                        m.maxItemFreeServiceCount = r.int32();
                        break;
                    case 7:
                        m.maxItemServiceCount = r.int32();
                        break;
                    default:
                        r.skipType(t & 7);
                        break;
                    }
                }
                return m;
            };

            return BaseItemAttributes;
        })();

        return SearchV2ItemAttributes;
    })();

    coreproductpb.SearchV2MaintenanceServiceAttributes = (function() {

        /**
         * Properties of a SearchV2MaintenanceServiceAttributes.
         * @memberof coreproductpb
         * @interface ISearchV2MaintenanceServiceAttributes
         * @property {string|null} [styleID] SearchV2MaintenanceServiceAttributes styleID
         * @property {string|null} [tradeID] SearchV2MaintenanceServiceAttributes tradeID
         * @property {string|null} [tradeCode] SearchV2MaintenanceServiceAttributes tradeCode
         * @property {string|null} [starItemID] SearchV2MaintenanceServiceAttributes starItemID
         * @property {string|null} [starTradeCode] SearchV2MaintenanceServiceAttributes starTradeCode
         * @property {coreproductpb.SearchV2MaintenanceServiceAttributes.IBaseMaintenanceServiceAttributes|null} [base] SearchV2MaintenanceServiceAttributes base
         */

        /**
         * Constructs a new SearchV2MaintenanceServiceAttributes.
         * @memberof coreproductpb
         * @classdesc Represents a SearchV2MaintenanceServiceAttributes.
         * @implements ISearchV2MaintenanceServiceAttributes
         * @constructor
         * @param {coreproductpb.ISearchV2MaintenanceServiceAttributes=} [p] Properties to set
         */
        function SearchV2MaintenanceServiceAttributes(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * SearchV2MaintenanceServiceAttributes styleID.
         * @member {string} styleID
         * @memberof coreproductpb.SearchV2MaintenanceServiceAttributes
         * @instance
         */
        SearchV2MaintenanceServiceAttributes.prototype.styleID = "";

        /**
         * SearchV2MaintenanceServiceAttributes tradeID.
         * @member {string} tradeID
         * @memberof coreproductpb.SearchV2MaintenanceServiceAttributes
         * @instance
         */
        SearchV2MaintenanceServiceAttributes.prototype.tradeID = "";

        /**
         * SearchV2MaintenanceServiceAttributes tradeCode.
         * @member {string} tradeCode
         * @memberof coreproductpb.SearchV2MaintenanceServiceAttributes
         * @instance
         */
        SearchV2MaintenanceServiceAttributes.prototype.tradeCode = "";

        /**
         * SearchV2MaintenanceServiceAttributes starItemID.
         * @member {string} starItemID
         * @memberof coreproductpb.SearchV2MaintenanceServiceAttributes
         * @instance
         */
        SearchV2MaintenanceServiceAttributes.prototype.starItemID = "";

        /**
         * SearchV2MaintenanceServiceAttributes starTradeCode.
         * @member {string} starTradeCode
         * @memberof coreproductpb.SearchV2MaintenanceServiceAttributes
         * @instance
         */
        SearchV2MaintenanceServiceAttributes.prototype.starTradeCode = "";

        /**
         * SearchV2MaintenanceServiceAttributes base.
         * @member {coreproductpb.SearchV2MaintenanceServiceAttributes.IBaseMaintenanceServiceAttributes|null|undefined} base
         * @memberof coreproductpb.SearchV2MaintenanceServiceAttributes
         * @instance
         */
        SearchV2MaintenanceServiceAttributes.prototype.base = null;

        /**
         * Creates a new SearchV2MaintenanceServiceAttributes instance using the specified properties.
         * @function create
         * @memberof coreproductpb.SearchV2MaintenanceServiceAttributes
         * @static
         * @param {coreproductpb.ISearchV2MaintenanceServiceAttributes=} [properties] Properties to set
         * @returns {coreproductpb.SearchV2MaintenanceServiceAttributes} SearchV2MaintenanceServiceAttributes instance
         */
        SearchV2MaintenanceServiceAttributes.create = function create(properties) {
            return new SearchV2MaintenanceServiceAttributes(properties);
        };

        /**
         * Encodes the specified SearchV2MaintenanceServiceAttributes message. Does not implicitly {@link coreproductpb.SearchV2MaintenanceServiceAttributes.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.SearchV2MaintenanceServiceAttributes
         * @static
         * @param {coreproductpb.ISearchV2MaintenanceServiceAttributes} m SearchV2MaintenanceServiceAttributes message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SearchV2MaintenanceServiceAttributes.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.styleID != null && Object.hasOwnProperty.call(m, "styleID"))
                w.uint32(10).string(m.styleID);
            if (m.tradeID != null && Object.hasOwnProperty.call(m, "tradeID"))
                w.uint32(18).string(m.tradeID);
            if (m.tradeCode != null && Object.hasOwnProperty.call(m, "tradeCode"))
                w.uint32(26).string(m.tradeCode);
            if (m.starItemID != null && Object.hasOwnProperty.call(m, "starItemID"))
                w.uint32(34).string(m.starItemID);
            if (m.starTradeCode != null && Object.hasOwnProperty.call(m, "starTradeCode"))
                w.uint32(42).string(m.starTradeCode);
            if (m.base != null && Object.hasOwnProperty.call(m, "base"))
                $root.coreproductpb.SearchV2MaintenanceServiceAttributes.BaseMaintenanceServiceAttributes.encode(m.base, w.uint32(50).fork()).ldelim();
            return w;
        };

        /**
         * Decodes a SearchV2MaintenanceServiceAttributes message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.SearchV2MaintenanceServiceAttributes
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.SearchV2MaintenanceServiceAttributes} SearchV2MaintenanceServiceAttributes
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SearchV2MaintenanceServiceAttributes.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.SearchV2MaintenanceServiceAttributes();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.styleID = r.string();
                    break;
                case 2:
                    m.tradeID = r.string();
                    break;
                case 3:
                    m.tradeCode = r.string();
                    break;
                case 4:
                    m.starItemID = r.string();
                    break;
                case 5:
                    m.starTradeCode = r.string();
                    break;
                case 6:
                    m.base = $root.coreproductpb.SearchV2MaintenanceServiceAttributes.BaseMaintenanceServiceAttributes.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        SearchV2MaintenanceServiceAttributes.BaseMaintenanceServiceAttributes = (function() {

            /**
             * Properties of a BaseMaintenanceServiceAttributes.
             * @memberof coreproductpb.SearchV2MaintenanceServiceAttributes
             * @interface IBaseMaintenanceServiceAttributes
             * @property {common.IMoney|null} [maintenanceFee] BaseMaintenanceServiceAttributes maintenanceFee
             * @property {string|null} [listingCoverageBeneficiary] BaseMaintenanceServiceAttributes listingCoverageBeneficiary
             * @property {common.IMoney|null} [aggregateRepairAmount] BaseMaintenanceServiceAttributes aggregateRepairAmount
             * @property {common.IMoney|null} [aggregateCashOutAmount] BaseMaintenanceServiceAttributes aggregateCashOutAmount
             * @property {common.IMoney|null} [diagnosisFee] BaseMaintenanceServiceAttributes diagnosisFee
             * @property {common.IMoney|null} [maxItemRepairAmount] BaseMaintenanceServiceAttributes maxItemRepairAmount
             * @property {common.IMoney|null} [maxCashOutAmount] BaseMaintenanceServiceAttributes maxCashOutAmount
             * @property {number|null} [maxItemFreeServiceCount] BaseMaintenanceServiceAttributes maxItemFreeServiceCount
             * @property {number|null} [maxItemServiceCount] BaseMaintenanceServiceAttributes maxItemServiceCount
             */

            /**
             * Constructs a new BaseMaintenanceServiceAttributes.
             * @memberof coreproductpb.SearchV2MaintenanceServiceAttributes
             * @classdesc Represents a BaseMaintenanceServiceAttributes.
             * @implements IBaseMaintenanceServiceAttributes
             * @constructor
             * @param {coreproductpb.SearchV2MaintenanceServiceAttributes.IBaseMaintenanceServiceAttributes=} [p] Properties to set
             */
            function BaseMaintenanceServiceAttributes(p) {
                if (p)
                    for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                        if (p[ks[i]] != null)
                            this[ks[i]] = p[ks[i]];
            }

            /**
             * BaseMaintenanceServiceAttributes maintenanceFee.
             * @member {common.IMoney|null|undefined} maintenanceFee
             * @memberof coreproductpb.SearchV2MaintenanceServiceAttributes.BaseMaintenanceServiceAttributes
             * @instance
             */
            BaseMaintenanceServiceAttributes.prototype.maintenanceFee = null;

            /**
             * BaseMaintenanceServiceAttributes listingCoverageBeneficiary.
             * @member {string} listingCoverageBeneficiary
             * @memberof coreproductpb.SearchV2MaintenanceServiceAttributes.BaseMaintenanceServiceAttributes
             * @instance
             */
            BaseMaintenanceServiceAttributes.prototype.listingCoverageBeneficiary = "";

            /**
             * BaseMaintenanceServiceAttributes aggregateRepairAmount.
             * @member {common.IMoney|null|undefined} aggregateRepairAmount
             * @memberof coreproductpb.SearchV2MaintenanceServiceAttributes.BaseMaintenanceServiceAttributes
             * @instance
             */
            BaseMaintenanceServiceAttributes.prototype.aggregateRepairAmount = null;

            /**
             * BaseMaintenanceServiceAttributes aggregateCashOutAmount.
             * @member {common.IMoney|null|undefined} aggregateCashOutAmount
             * @memberof coreproductpb.SearchV2MaintenanceServiceAttributes.BaseMaintenanceServiceAttributes
             * @instance
             */
            BaseMaintenanceServiceAttributes.prototype.aggregateCashOutAmount = null;

            /**
             * BaseMaintenanceServiceAttributes diagnosisFee.
             * @member {common.IMoney|null|undefined} diagnosisFee
             * @memberof coreproductpb.SearchV2MaintenanceServiceAttributes.BaseMaintenanceServiceAttributes
             * @instance
             */
            BaseMaintenanceServiceAttributes.prototype.diagnosisFee = null;

            /**
             * BaseMaintenanceServiceAttributes maxItemRepairAmount.
             * @member {common.IMoney|null|undefined} maxItemRepairAmount
             * @memberof coreproductpb.SearchV2MaintenanceServiceAttributes.BaseMaintenanceServiceAttributes
             * @instance
             */
            BaseMaintenanceServiceAttributes.prototype.maxItemRepairAmount = null;

            /**
             * BaseMaintenanceServiceAttributes maxCashOutAmount.
             * @member {common.IMoney|null|undefined} maxCashOutAmount
             * @memberof coreproductpb.SearchV2MaintenanceServiceAttributes.BaseMaintenanceServiceAttributes
             * @instance
             */
            BaseMaintenanceServiceAttributes.prototype.maxCashOutAmount = null;

            /**
             * BaseMaintenanceServiceAttributes maxItemFreeServiceCount.
             * @member {number} maxItemFreeServiceCount
             * @memberof coreproductpb.SearchV2MaintenanceServiceAttributes.BaseMaintenanceServiceAttributes
             * @instance
             */
            BaseMaintenanceServiceAttributes.prototype.maxItemFreeServiceCount = 0;

            /**
             * BaseMaintenanceServiceAttributes maxItemServiceCount.
             * @member {number} maxItemServiceCount
             * @memberof coreproductpb.SearchV2MaintenanceServiceAttributes.BaseMaintenanceServiceAttributes
             * @instance
             */
            BaseMaintenanceServiceAttributes.prototype.maxItemServiceCount = 0;

            /**
             * Creates a new BaseMaintenanceServiceAttributes instance using the specified properties.
             * @function create
             * @memberof coreproductpb.SearchV2MaintenanceServiceAttributes.BaseMaintenanceServiceAttributes
             * @static
             * @param {coreproductpb.SearchV2MaintenanceServiceAttributes.IBaseMaintenanceServiceAttributes=} [properties] Properties to set
             * @returns {coreproductpb.SearchV2MaintenanceServiceAttributes.BaseMaintenanceServiceAttributes} BaseMaintenanceServiceAttributes instance
             */
            BaseMaintenanceServiceAttributes.create = function create(properties) {
                return new BaseMaintenanceServiceAttributes(properties);
            };

            /**
             * Encodes the specified BaseMaintenanceServiceAttributes message. Does not implicitly {@link coreproductpb.SearchV2MaintenanceServiceAttributes.BaseMaintenanceServiceAttributes.verify|verify} messages.
             * @function encode
             * @memberof coreproductpb.SearchV2MaintenanceServiceAttributes.BaseMaintenanceServiceAttributes
             * @static
             * @param {coreproductpb.SearchV2MaintenanceServiceAttributes.IBaseMaintenanceServiceAttributes} m BaseMaintenanceServiceAttributes message or plain object to encode
             * @param {$protobuf.Writer} [w] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            BaseMaintenanceServiceAttributes.encode = function encode(m, w) {
                if (!w)
                    w = $Writer.create();
                if (m.maintenanceFee != null && Object.hasOwnProperty.call(m, "maintenanceFee"))
                    $root.common.Money.encode(m.maintenanceFee, w.uint32(10).fork()).ldelim();
                if (m.listingCoverageBeneficiary != null && Object.hasOwnProperty.call(m, "listingCoverageBeneficiary"))
                    w.uint32(18).string(m.listingCoverageBeneficiary);
                if (m.aggregateRepairAmount != null && Object.hasOwnProperty.call(m, "aggregateRepairAmount"))
                    $root.common.Money.encode(m.aggregateRepairAmount, w.uint32(26).fork()).ldelim();
                if (m.aggregateCashOutAmount != null && Object.hasOwnProperty.call(m, "aggregateCashOutAmount"))
                    $root.common.Money.encode(m.aggregateCashOutAmount, w.uint32(34).fork()).ldelim();
                if (m.diagnosisFee != null && Object.hasOwnProperty.call(m, "diagnosisFee"))
                    $root.common.Money.encode(m.diagnosisFee, w.uint32(42).fork()).ldelim();
                if (m.maxItemRepairAmount != null && Object.hasOwnProperty.call(m, "maxItemRepairAmount"))
                    $root.common.Money.encode(m.maxItemRepairAmount, w.uint32(50).fork()).ldelim();
                if (m.maxCashOutAmount != null && Object.hasOwnProperty.call(m, "maxCashOutAmount"))
                    $root.common.Money.encode(m.maxCashOutAmount, w.uint32(58).fork()).ldelim();
                if (m.maxItemFreeServiceCount != null && Object.hasOwnProperty.call(m, "maxItemFreeServiceCount"))
                    w.uint32(64).int32(m.maxItemFreeServiceCount);
                if (m.maxItemServiceCount != null && Object.hasOwnProperty.call(m, "maxItemServiceCount"))
                    w.uint32(72).int32(m.maxItemServiceCount);
                return w;
            };

            /**
             * Decodes a BaseMaintenanceServiceAttributes message from the specified reader or buffer.
             * @function decode
             * @memberof coreproductpb.SearchV2MaintenanceServiceAttributes.BaseMaintenanceServiceAttributes
             * @static
             * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
             * @param {number} [l] Message length if known beforehand
             * @returns {coreproductpb.SearchV2MaintenanceServiceAttributes.BaseMaintenanceServiceAttributes} BaseMaintenanceServiceAttributes
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            BaseMaintenanceServiceAttributes.decode = function decode(r, l) {
                if (!(r instanceof $Reader))
                    r = $Reader.create(r);
                var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.SearchV2MaintenanceServiceAttributes.BaseMaintenanceServiceAttributes();
                while (r.pos < c) {
                    var t = r.uint32();
                    switch (t >>> 3) {
                    case 1:
                        m.maintenanceFee = $root.common.Money.decode(r, r.uint32());
                        break;
                    case 2:
                        m.listingCoverageBeneficiary = r.string();
                        break;
                    case 3:
                        m.aggregateRepairAmount = $root.common.Money.decode(r, r.uint32());
                        break;
                    case 4:
                        m.aggregateCashOutAmount = $root.common.Money.decode(r, r.uint32());
                        break;
                    case 5:
                        m.diagnosisFee = $root.common.Money.decode(r, r.uint32());
                        break;
                    case 6:
                        m.maxItemRepairAmount = $root.common.Money.decode(r, r.uint32());
                        break;
                    case 7:
                        m.maxCashOutAmount = $root.common.Money.decode(r, r.uint32());
                        break;
                    case 8:
                        m.maxItemFreeServiceCount = r.int32();
                        break;
                    case 9:
                        m.maxItemServiceCount = r.int32();
                        break;
                    default:
                        r.skipType(t & 7);
                        break;
                    }
                }
                return m;
            };

            return BaseMaintenanceServiceAttributes;
        })();

        return SearchV2MaintenanceServiceAttributes;
    })();

    coreproductpb.SearchV2FeatureCoverageAttributes = (function() {

        /**
         * Properties of a SearchV2FeatureCoverageAttributes.
         * @memberof coreproductpb
         * @interface ISearchV2FeatureCoverageAttributes
         * @property {string|null} [description] SearchV2FeatureCoverageAttributes description
         * @property {string|null} [starCoverageID] SearchV2FeatureCoverageAttributes starCoverageID
         * @property {coreproductpb.SearchV2FeatureCoverageAttributes.IBaseFeatureCoverageAttributes|null} [base] SearchV2FeatureCoverageAttributes base
         * @property {coreproductpb.SearchV2FeatureCoverageAttributes.IDetailsFeatureCoverageAttributes|null} [details] SearchV2FeatureCoverageAttributes details
         * @property {google.protobuf.ITimestamp|null} [expirationDate] SearchV2FeatureCoverageAttributes expirationDate
         */

        /**
         * Constructs a new SearchV2FeatureCoverageAttributes.
         * @memberof coreproductpb
         * @classdesc Represents a SearchV2FeatureCoverageAttributes.
         * @implements ISearchV2FeatureCoverageAttributes
         * @constructor
         * @param {coreproductpb.ISearchV2FeatureCoverageAttributes=} [p] Properties to set
         */
        function SearchV2FeatureCoverageAttributes(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * SearchV2FeatureCoverageAttributes description.
         * @member {string} description
         * @memberof coreproductpb.SearchV2FeatureCoverageAttributes
         * @instance
         */
        SearchV2FeatureCoverageAttributes.prototype.description = "";

        /**
         * SearchV2FeatureCoverageAttributes starCoverageID.
         * @member {string} starCoverageID
         * @memberof coreproductpb.SearchV2FeatureCoverageAttributes
         * @instance
         */
        SearchV2FeatureCoverageAttributes.prototype.starCoverageID = "";

        /**
         * SearchV2FeatureCoverageAttributes base.
         * @member {coreproductpb.SearchV2FeatureCoverageAttributes.IBaseFeatureCoverageAttributes|null|undefined} base
         * @memberof coreproductpb.SearchV2FeatureCoverageAttributes
         * @instance
         */
        SearchV2FeatureCoverageAttributes.prototype.base = null;

        /**
         * SearchV2FeatureCoverageAttributes details.
         * @member {coreproductpb.SearchV2FeatureCoverageAttributes.IDetailsFeatureCoverageAttributes|null|undefined} details
         * @memberof coreproductpb.SearchV2FeatureCoverageAttributes
         * @instance
         */
        SearchV2FeatureCoverageAttributes.prototype.details = null;

        /**
         * SearchV2FeatureCoverageAttributes expirationDate.
         * @member {google.protobuf.ITimestamp|null|undefined} expirationDate
         * @memberof coreproductpb.SearchV2FeatureCoverageAttributes
         * @instance
         */
        SearchV2FeatureCoverageAttributes.prototype.expirationDate = null;

        /**
         * Creates a new SearchV2FeatureCoverageAttributes instance using the specified properties.
         * @function create
         * @memberof coreproductpb.SearchV2FeatureCoverageAttributes
         * @static
         * @param {coreproductpb.ISearchV2FeatureCoverageAttributes=} [properties] Properties to set
         * @returns {coreproductpb.SearchV2FeatureCoverageAttributes} SearchV2FeatureCoverageAttributes instance
         */
        SearchV2FeatureCoverageAttributes.create = function create(properties) {
            return new SearchV2FeatureCoverageAttributes(properties);
        };

        /**
         * Encodes the specified SearchV2FeatureCoverageAttributes message. Does not implicitly {@link coreproductpb.SearchV2FeatureCoverageAttributes.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.SearchV2FeatureCoverageAttributes
         * @static
         * @param {coreproductpb.ISearchV2FeatureCoverageAttributes} m SearchV2FeatureCoverageAttributes message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SearchV2FeatureCoverageAttributes.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.description != null && Object.hasOwnProperty.call(m, "description"))
                w.uint32(10).string(m.description);
            if (m.starCoverageID != null && Object.hasOwnProperty.call(m, "starCoverageID"))
                w.uint32(18).string(m.starCoverageID);
            if (m.base != null && Object.hasOwnProperty.call(m, "base"))
                $root.coreproductpb.SearchV2FeatureCoverageAttributes.BaseFeatureCoverageAttributes.encode(m.base, w.uint32(26).fork()).ldelim();
            if (m.details != null && Object.hasOwnProperty.call(m, "details"))
                $root.coreproductpb.SearchV2FeatureCoverageAttributes.DetailsFeatureCoverageAttributes.encode(m.details, w.uint32(34).fork()).ldelim();
            if (m.expirationDate != null && Object.hasOwnProperty.call(m, "expirationDate"))
                $root.google.protobuf.Timestamp.encode(m.expirationDate, w.uint32(90).fork()).ldelim();
            return w;
        };

        /**
         * Decodes a SearchV2FeatureCoverageAttributes message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.SearchV2FeatureCoverageAttributes
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.SearchV2FeatureCoverageAttributes} SearchV2FeatureCoverageAttributes
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SearchV2FeatureCoverageAttributes.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.SearchV2FeatureCoverageAttributes();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.description = r.string();
                    break;
                case 2:
                    m.starCoverageID = r.string();
                    break;
                case 3:
                    m.base = $root.coreproductpb.SearchV2FeatureCoverageAttributes.BaseFeatureCoverageAttributes.decode(r, r.uint32());
                    break;
                case 4:
                    m.details = $root.coreproductpb.SearchV2FeatureCoverageAttributes.DetailsFeatureCoverageAttributes.decode(r, r.uint32());
                    break;
                case 11:
                    m.expirationDate = $root.google.protobuf.Timestamp.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        SearchV2FeatureCoverageAttributes.BaseFeatureCoverageAttributes = (function() {

            /**
             * Properties of a BaseFeatureCoverageAttributes.
             * @memberof coreproductpb.SearchV2FeatureCoverageAttributes
             * @interface IBaseFeatureCoverageAttributes
             * @property {common.IMoney|null} [fee] BaseFeatureCoverageAttributes fee
             * @property {number|null} [maxCount] BaseFeatureCoverageAttributes maxCount
             * @property {common.IMoney|null} [aggregateRepairAmount] BaseFeatureCoverageAttributes aggregateRepairAmount
             * @property {common.IMoney|null} [aggregateCashoutAmount] BaseFeatureCoverageAttributes aggregateCashoutAmount
             * @property {common.IMoney|null} [diagnosisFee] BaseFeatureCoverageAttributes diagnosisFee
             * @property {common.IMoney|null} [maxItemRepairAmount] BaseFeatureCoverageAttributes maxItemRepairAmount
             * @property {common.IMoney|null} [maxCashOutAmount] BaseFeatureCoverageAttributes maxCashOutAmount
             * @property {common.IMoney|null} [maintenanceFee] BaseFeatureCoverageAttributes maintenanceFee
             * @property {string|null} [listingCoverageBeneficiary] BaseFeatureCoverageAttributes listingCoverageBeneficiary
             * @property {number|null} [maxFreeServiceCount] BaseFeatureCoverageAttributes maxFreeServiceCount
             */

            /**
             * Constructs a new BaseFeatureCoverageAttributes.
             * @memberof coreproductpb.SearchV2FeatureCoverageAttributes
             * @classdesc Represents a BaseFeatureCoverageAttributes.
             * @implements IBaseFeatureCoverageAttributes
             * @constructor
             * @param {coreproductpb.SearchV2FeatureCoverageAttributes.IBaseFeatureCoverageAttributes=} [p] Properties to set
             */
            function BaseFeatureCoverageAttributes(p) {
                if (p)
                    for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                        if (p[ks[i]] != null)
                            this[ks[i]] = p[ks[i]];
            }

            /**
             * BaseFeatureCoverageAttributes fee.
             * @member {common.IMoney|null|undefined} fee
             * @memberof coreproductpb.SearchV2FeatureCoverageAttributes.BaseFeatureCoverageAttributes
             * @instance
             */
            BaseFeatureCoverageAttributes.prototype.fee = null;

            /**
             * BaseFeatureCoverageAttributes maxCount.
             * @member {number} maxCount
             * @memberof coreproductpb.SearchV2FeatureCoverageAttributes.BaseFeatureCoverageAttributes
             * @instance
             */
            BaseFeatureCoverageAttributes.prototype.maxCount = 0;

            /**
             * BaseFeatureCoverageAttributes aggregateRepairAmount.
             * @member {common.IMoney|null|undefined} aggregateRepairAmount
             * @memberof coreproductpb.SearchV2FeatureCoverageAttributes.BaseFeatureCoverageAttributes
             * @instance
             */
            BaseFeatureCoverageAttributes.prototype.aggregateRepairAmount = null;

            /**
             * BaseFeatureCoverageAttributes aggregateCashoutAmount.
             * @member {common.IMoney|null|undefined} aggregateCashoutAmount
             * @memberof coreproductpb.SearchV2FeatureCoverageAttributes.BaseFeatureCoverageAttributes
             * @instance
             */
            BaseFeatureCoverageAttributes.prototype.aggregateCashoutAmount = null;

            /**
             * BaseFeatureCoverageAttributes diagnosisFee.
             * @member {common.IMoney|null|undefined} diagnosisFee
             * @memberof coreproductpb.SearchV2FeatureCoverageAttributes.BaseFeatureCoverageAttributes
             * @instance
             */
            BaseFeatureCoverageAttributes.prototype.diagnosisFee = null;

            /**
             * BaseFeatureCoverageAttributes maxItemRepairAmount.
             * @member {common.IMoney|null|undefined} maxItemRepairAmount
             * @memberof coreproductpb.SearchV2FeatureCoverageAttributes.BaseFeatureCoverageAttributes
             * @instance
             */
            BaseFeatureCoverageAttributes.prototype.maxItemRepairAmount = null;

            /**
             * BaseFeatureCoverageAttributes maxCashOutAmount.
             * @member {common.IMoney|null|undefined} maxCashOutAmount
             * @memberof coreproductpb.SearchV2FeatureCoverageAttributes.BaseFeatureCoverageAttributes
             * @instance
             */
            BaseFeatureCoverageAttributes.prototype.maxCashOutAmount = null;

            /**
             * BaseFeatureCoverageAttributes maintenanceFee.
             * @member {common.IMoney|null|undefined} maintenanceFee
             * @memberof coreproductpb.SearchV2FeatureCoverageAttributes.BaseFeatureCoverageAttributes
             * @instance
             */
            BaseFeatureCoverageAttributes.prototype.maintenanceFee = null;

            /**
             * BaseFeatureCoverageAttributes listingCoverageBeneficiary.
             * @member {string} listingCoverageBeneficiary
             * @memberof coreproductpb.SearchV2FeatureCoverageAttributes.BaseFeatureCoverageAttributes
             * @instance
             */
            BaseFeatureCoverageAttributes.prototype.listingCoverageBeneficiary = "";

            /**
             * BaseFeatureCoverageAttributes maxFreeServiceCount.
             * @member {number} maxFreeServiceCount
             * @memberof coreproductpb.SearchV2FeatureCoverageAttributes.BaseFeatureCoverageAttributes
             * @instance
             */
            BaseFeatureCoverageAttributes.prototype.maxFreeServiceCount = 0;

            /**
             * Creates a new BaseFeatureCoverageAttributes instance using the specified properties.
             * @function create
             * @memberof coreproductpb.SearchV2FeatureCoverageAttributes.BaseFeatureCoverageAttributes
             * @static
             * @param {coreproductpb.SearchV2FeatureCoverageAttributes.IBaseFeatureCoverageAttributes=} [properties] Properties to set
             * @returns {coreproductpb.SearchV2FeatureCoverageAttributes.BaseFeatureCoverageAttributes} BaseFeatureCoverageAttributes instance
             */
            BaseFeatureCoverageAttributes.create = function create(properties) {
                return new BaseFeatureCoverageAttributes(properties);
            };

            /**
             * Encodes the specified BaseFeatureCoverageAttributes message. Does not implicitly {@link coreproductpb.SearchV2FeatureCoverageAttributes.BaseFeatureCoverageAttributes.verify|verify} messages.
             * @function encode
             * @memberof coreproductpb.SearchV2FeatureCoverageAttributes.BaseFeatureCoverageAttributes
             * @static
             * @param {coreproductpb.SearchV2FeatureCoverageAttributes.IBaseFeatureCoverageAttributes} m BaseFeatureCoverageAttributes message or plain object to encode
             * @param {$protobuf.Writer} [w] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            BaseFeatureCoverageAttributes.encode = function encode(m, w) {
                if (!w)
                    w = $Writer.create();
                if (m.fee != null && Object.hasOwnProperty.call(m, "fee"))
                    $root.common.Money.encode(m.fee, w.uint32(10).fork()).ldelim();
                if (m.maxCount != null && Object.hasOwnProperty.call(m, "maxCount"))
                    w.uint32(16).int32(m.maxCount);
                if (m.aggregateRepairAmount != null && Object.hasOwnProperty.call(m, "aggregateRepairAmount"))
                    $root.common.Money.encode(m.aggregateRepairAmount, w.uint32(26).fork()).ldelim();
                if (m.aggregateCashoutAmount != null && Object.hasOwnProperty.call(m, "aggregateCashoutAmount"))
                    $root.common.Money.encode(m.aggregateCashoutAmount, w.uint32(34).fork()).ldelim();
                if (m.diagnosisFee != null && Object.hasOwnProperty.call(m, "diagnosisFee"))
                    $root.common.Money.encode(m.diagnosisFee, w.uint32(42).fork()).ldelim();
                if (m.maxItemRepairAmount != null && Object.hasOwnProperty.call(m, "maxItemRepairAmount"))
                    $root.common.Money.encode(m.maxItemRepairAmount, w.uint32(50).fork()).ldelim();
                if (m.maxCashOutAmount != null && Object.hasOwnProperty.call(m, "maxCashOutAmount"))
                    $root.common.Money.encode(m.maxCashOutAmount, w.uint32(58).fork()).ldelim();
                if (m.maintenanceFee != null && Object.hasOwnProperty.call(m, "maintenanceFee"))
                    $root.common.Money.encode(m.maintenanceFee, w.uint32(66).fork()).ldelim();
                if (m.listingCoverageBeneficiary != null && Object.hasOwnProperty.call(m, "listingCoverageBeneficiary"))
                    w.uint32(74).string(m.listingCoverageBeneficiary);
                if (m.maxFreeServiceCount != null && Object.hasOwnProperty.call(m, "maxFreeServiceCount"))
                    w.uint32(80).int32(m.maxFreeServiceCount);
                return w;
            };

            /**
             * Decodes a BaseFeatureCoverageAttributes message from the specified reader or buffer.
             * @function decode
             * @memberof coreproductpb.SearchV2FeatureCoverageAttributes.BaseFeatureCoverageAttributes
             * @static
             * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
             * @param {number} [l] Message length if known beforehand
             * @returns {coreproductpb.SearchV2FeatureCoverageAttributes.BaseFeatureCoverageAttributes} BaseFeatureCoverageAttributes
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            BaseFeatureCoverageAttributes.decode = function decode(r, l) {
                if (!(r instanceof $Reader))
                    r = $Reader.create(r);
                var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.SearchV2FeatureCoverageAttributes.BaseFeatureCoverageAttributes();
                while (r.pos < c) {
                    var t = r.uint32();
                    switch (t >>> 3) {
                    case 1:
                        m.fee = $root.common.Money.decode(r, r.uint32());
                        break;
                    case 2:
                        m.maxCount = r.int32();
                        break;
                    case 3:
                        m.aggregateRepairAmount = $root.common.Money.decode(r, r.uint32());
                        break;
                    case 4:
                        m.aggregateCashoutAmount = $root.common.Money.decode(r, r.uint32());
                        break;
                    case 5:
                        m.diagnosisFee = $root.common.Money.decode(r, r.uint32());
                        break;
                    case 6:
                        m.maxItemRepairAmount = $root.common.Money.decode(r, r.uint32());
                        break;
                    case 7:
                        m.maxCashOutAmount = $root.common.Money.decode(r, r.uint32());
                        break;
                    case 8:
                        m.maintenanceFee = $root.common.Money.decode(r, r.uint32());
                        break;
                    case 9:
                        m.listingCoverageBeneficiary = r.string();
                        break;
                    case 10:
                        m.maxFreeServiceCount = r.int32();
                        break;
                    default:
                        r.skipType(t & 7);
                        break;
                    }
                }
                return m;
            };

            return BaseFeatureCoverageAttributes;
        })();

        SearchV2FeatureCoverageAttributes.DetailsFeatureCoverageAttributes = (function() {

            /**
             * Properties of a DetailsFeatureCoverageAttributes.
             * @memberof coreproductpb.SearchV2FeatureCoverageAttributes
             * @interface IDetailsFeatureCoverageAttributes
             * @property {Array.<string>|null} [tags] DetailsFeatureCoverageAttributes tags
             */

            /**
             * Constructs a new DetailsFeatureCoverageAttributes.
             * @memberof coreproductpb.SearchV2FeatureCoverageAttributes
             * @classdesc Represents a DetailsFeatureCoverageAttributes.
             * @implements IDetailsFeatureCoverageAttributes
             * @constructor
             * @param {coreproductpb.SearchV2FeatureCoverageAttributes.IDetailsFeatureCoverageAttributes=} [p] Properties to set
             */
            function DetailsFeatureCoverageAttributes(p) {
                this.tags = [];
                if (p)
                    for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                        if (p[ks[i]] != null)
                            this[ks[i]] = p[ks[i]];
            }

            /**
             * DetailsFeatureCoverageAttributes tags.
             * @member {Array.<string>} tags
             * @memberof coreproductpb.SearchV2FeatureCoverageAttributes.DetailsFeatureCoverageAttributes
             * @instance
             */
            DetailsFeatureCoverageAttributes.prototype.tags = $util.emptyArray;

            /**
             * Creates a new DetailsFeatureCoverageAttributes instance using the specified properties.
             * @function create
             * @memberof coreproductpb.SearchV2FeatureCoverageAttributes.DetailsFeatureCoverageAttributes
             * @static
             * @param {coreproductpb.SearchV2FeatureCoverageAttributes.IDetailsFeatureCoverageAttributes=} [properties] Properties to set
             * @returns {coreproductpb.SearchV2FeatureCoverageAttributes.DetailsFeatureCoverageAttributes} DetailsFeatureCoverageAttributes instance
             */
            DetailsFeatureCoverageAttributes.create = function create(properties) {
                return new DetailsFeatureCoverageAttributes(properties);
            };

            /**
             * Encodes the specified DetailsFeatureCoverageAttributes message. Does not implicitly {@link coreproductpb.SearchV2FeatureCoverageAttributes.DetailsFeatureCoverageAttributes.verify|verify} messages.
             * @function encode
             * @memberof coreproductpb.SearchV2FeatureCoverageAttributes.DetailsFeatureCoverageAttributes
             * @static
             * @param {coreproductpb.SearchV2FeatureCoverageAttributes.IDetailsFeatureCoverageAttributes} m DetailsFeatureCoverageAttributes message or plain object to encode
             * @param {$protobuf.Writer} [w] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            DetailsFeatureCoverageAttributes.encode = function encode(m, w) {
                if (!w)
                    w = $Writer.create();
                if (m.tags != null && m.tags.length) {
                    for (var i = 0; i < m.tags.length; ++i)
                        w.uint32(10).string(m.tags[i]);
                }
                return w;
            };

            /**
             * Decodes a DetailsFeatureCoverageAttributes message from the specified reader or buffer.
             * @function decode
             * @memberof coreproductpb.SearchV2FeatureCoverageAttributes.DetailsFeatureCoverageAttributes
             * @static
             * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
             * @param {number} [l] Message length if known beforehand
             * @returns {coreproductpb.SearchV2FeatureCoverageAttributes.DetailsFeatureCoverageAttributes} DetailsFeatureCoverageAttributes
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            DetailsFeatureCoverageAttributes.decode = function decode(r, l) {
                if (!(r instanceof $Reader))
                    r = $Reader.create(r);
                var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.SearchV2FeatureCoverageAttributes.DetailsFeatureCoverageAttributes();
                while (r.pos < c) {
                    var t = r.uint32();
                    switch (t >>> 3) {
                    case 1:
                        if (!(m.tags && m.tags.length))
                            m.tags = [];
                        m.tags.push(r.string());
                        break;
                    default:
                        r.skipType(t & 7);
                        break;
                    }
                }
                return m;
            };

            return DetailsFeatureCoverageAttributes;
        })();

        return SearchV2FeatureCoverageAttributes;
    })();

    coreproductpb.SearchV2AddOnFeatures = (function() {

        /**
         * Properties of a SearchV2AddOnFeatures.
         * @memberof coreproductpb
         * @interface ISearchV2AddOnFeatures
         * @property {Array.<coreproductpb.ISearchV2Feature>|null} [features] SearchV2AddOnFeatures features
         * @property {Array.<coreproductpb.IPickRule>|null} [pickRules] SearchV2AddOnFeatures pickRules
         */

        /**
         * Constructs a new SearchV2AddOnFeatures.
         * @memberof coreproductpb
         * @classdesc Represents a SearchV2AddOnFeatures.
         * @implements ISearchV2AddOnFeatures
         * @constructor
         * @param {coreproductpb.ISearchV2AddOnFeatures=} [p] Properties to set
         */
        function SearchV2AddOnFeatures(p) {
            this.features = [];
            this.pickRules = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * SearchV2AddOnFeatures features.
         * @member {Array.<coreproductpb.ISearchV2Feature>} features
         * @memberof coreproductpb.SearchV2AddOnFeatures
         * @instance
         */
        SearchV2AddOnFeatures.prototype.features = $util.emptyArray;

        /**
         * SearchV2AddOnFeatures pickRules.
         * @member {Array.<coreproductpb.IPickRule>} pickRules
         * @memberof coreproductpb.SearchV2AddOnFeatures
         * @instance
         */
        SearchV2AddOnFeatures.prototype.pickRules = $util.emptyArray;

        /**
         * Creates a new SearchV2AddOnFeatures instance using the specified properties.
         * @function create
         * @memberof coreproductpb.SearchV2AddOnFeatures
         * @static
         * @param {coreproductpb.ISearchV2AddOnFeatures=} [properties] Properties to set
         * @returns {coreproductpb.SearchV2AddOnFeatures} SearchV2AddOnFeatures instance
         */
        SearchV2AddOnFeatures.create = function create(properties) {
            return new SearchV2AddOnFeatures(properties);
        };

        /**
         * Encodes the specified SearchV2AddOnFeatures message. Does not implicitly {@link coreproductpb.SearchV2AddOnFeatures.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.SearchV2AddOnFeatures
         * @static
         * @param {coreproductpb.ISearchV2AddOnFeatures} m SearchV2AddOnFeatures message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SearchV2AddOnFeatures.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.features != null && m.features.length) {
                for (var i = 0; i < m.features.length; ++i)
                    $root.coreproductpb.SearchV2Feature.encode(m.features[i], w.uint32(10).fork()).ldelim();
            }
            if (m.pickRules != null && m.pickRules.length) {
                for (var i = 0; i < m.pickRules.length; ++i)
                    $root.coreproductpb.PickRule.encode(m.pickRules[i], w.uint32(18).fork()).ldelim();
            }
            return w;
        };

        /**
         * Decodes a SearchV2AddOnFeatures message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.SearchV2AddOnFeatures
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.SearchV2AddOnFeatures} SearchV2AddOnFeatures
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SearchV2AddOnFeatures.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.SearchV2AddOnFeatures();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    if (!(m.features && m.features.length))
                        m.features = [];
                    m.features.push($root.coreproductpb.SearchV2Feature.decode(r, r.uint32()));
                    break;
                case 2:
                    if (!(m.pickRules && m.pickRules.length))
                        m.pickRules = [];
                    m.pickRules.push($root.coreproductpb.PickRule.decode(r, r.uint32()));
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return SearchV2AddOnFeatures;
    })();

    coreproductpb.SearchV2FeatureBundle = (function() {

        /**
         * Properties of a SearchV2FeatureBundle.
         * @memberof coreproductpb
         * @interface ISearchV2FeatureBundle
         * @property {string|null} [bundleID] SearchV2FeatureBundle bundleID
         * @property {string|null} [name] SearchV2FeatureBundle name
         * @property {Array.<coreproductpb.ISearchV2Feature>|null} [baseFeatures] SearchV2FeatureBundle baseFeatures
         * @property {coreproductpb.ISearchV2AddOnFeatures|null} [addOnFeatures] SearchV2FeatureBundle addOnFeatures
         * @property {coreproductpb.SearchV2FeatureBundle.ISearchV2FeatureBundleAttributes|null} [attributes] SearchV2FeatureBundle attributes
         */

        /**
         * Constructs a new SearchV2FeatureBundle.
         * @memberof coreproductpb
         * @classdesc Represents a SearchV2FeatureBundle.
         * @implements ISearchV2FeatureBundle
         * @constructor
         * @param {coreproductpb.ISearchV2FeatureBundle=} [p] Properties to set
         */
        function SearchV2FeatureBundle(p) {
            this.baseFeatures = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * SearchV2FeatureBundle bundleID.
         * @member {string} bundleID
         * @memberof coreproductpb.SearchV2FeatureBundle
         * @instance
         */
        SearchV2FeatureBundle.prototype.bundleID = "";

        /**
         * SearchV2FeatureBundle name.
         * @member {string} name
         * @memberof coreproductpb.SearchV2FeatureBundle
         * @instance
         */
        SearchV2FeatureBundle.prototype.name = "";

        /**
         * SearchV2FeatureBundle baseFeatures.
         * @member {Array.<coreproductpb.ISearchV2Feature>} baseFeatures
         * @memberof coreproductpb.SearchV2FeatureBundle
         * @instance
         */
        SearchV2FeatureBundle.prototype.baseFeatures = $util.emptyArray;

        /**
         * SearchV2FeatureBundle addOnFeatures.
         * @member {coreproductpb.ISearchV2AddOnFeatures|null|undefined} addOnFeatures
         * @memberof coreproductpb.SearchV2FeatureBundle
         * @instance
         */
        SearchV2FeatureBundle.prototype.addOnFeatures = null;

        /**
         * SearchV2FeatureBundle attributes.
         * @member {coreproductpb.SearchV2FeatureBundle.ISearchV2FeatureBundleAttributes|null|undefined} attributes
         * @memberof coreproductpb.SearchV2FeatureBundle
         * @instance
         */
        SearchV2FeatureBundle.prototype.attributes = null;

        /**
         * Creates a new SearchV2FeatureBundle instance using the specified properties.
         * @function create
         * @memberof coreproductpb.SearchV2FeatureBundle
         * @static
         * @param {coreproductpb.ISearchV2FeatureBundle=} [properties] Properties to set
         * @returns {coreproductpb.SearchV2FeatureBundle} SearchV2FeatureBundle instance
         */
        SearchV2FeatureBundle.create = function create(properties) {
            return new SearchV2FeatureBundle(properties);
        };

        /**
         * Encodes the specified SearchV2FeatureBundle message. Does not implicitly {@link coreproductpb.SearchV2FeatureBundle.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.SearchV2FeatureBundle
         * @static
         * @param {coreproductpb.ISearchV2FeatureBundle} m SearchV2FeatureBundle message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SearchV2FeatureBundle.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.bundleID != null && Object.hasOwnProperty.call(m, "bundleID"))
                w.uint32(10).string(m.bundleID);
            if (m.name != null && Object.hasOwnProperty.call(m, "name"))
                w.uint32(18).string(m.name);
            if (m.baseFeatures != null && m.baseFeatures.length) {
                for (var i = 0; i < m.baseFeatures.length; ++i)
                    $root.coreproductpb.SearchV2Feature.encode(m.baseFeatures[i], w.uint32(26).fork()).ldelim();
            }
            if (m.addOnFeatures != null && Object.hasOwnProperty.call(m, "addOnFeatures"))
                $root.coreproductpb.SearchV2AddOnFeatures.encode(m.addOnFeatures, w.uint32(34).fork()).ldelim();
            if (m.attributes != null && Object.hasOwnProperty.call(m, "attributes"))
                $root.coreproductpb.SearchV2FeatureBundle.SearchV2FeatureBundleAttributes.encode(m.attributes, w.uint32(42).fork()).ldelim();
            return w;
        };

        /**
         * Decodes a SearchV2FeatureBundle message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.SearchV2FeatureBundle
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.SearchV2FeatureBundle} SearchV2FeatureBundle
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SearchV2FeatureBundle.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.SearchV2FeatureBundle();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.bundleID = r.string();
                    break;
                case 2:
                    m.name = r.string();
                    break;
                case 3:
                    if (!(m.baseFeatures && m.baseFeatures.length))
                        m.baseFeatures = [];
                    m.baseFeatures.push($root.coreproductpb.SearchV2Feature.decode(r, r.uint32()));
                    break;
                case 4:
                    m.addOnFeatures = $root.coreproductpb.SearchV2AddOnFeatures.decode(r, r.uint32());
                    break;
                case 5:
                    m.attributes = $root.coreproductpb.SearchV2FeatureBundle.SearchV2FeatureBundleAttributes.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        SearchV2FeatureBundle.SearchV2FeatureBundleAttributes = (function() {

            /**
             * Properties of a SearchV2FeatureBundleAttributes.
             * @memberof coreproductpb.SearchV2FeatureBundle
             * @interface ISearchV2FeatureBundleAttributes
             * @property {string|null} [starCoverageGroupID] SearchV2FeatureBundleAttributes starCoverageGroupID
             */

            /**
             * Constructs a new SearchV2FeatureBundleAttributes.
             * @memberof coreproductpb.SearchV2FeatureBundle
             * @classdesc Represents a SearchV2FeatureBundleAttributes.
             * @implements ISearchV2FeatureBundleAttributes
             * @constructor
             * @param {coreproductpb.SearchV2FeatureBundle.ISearchV2FeatureBundleAttributes=} [p] Properties to set
             */
            function SearchV2FeatureBundleAttributes(p) {
                if (p)
                    for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                        if (p[ks[i]] != null)
                            this[ks[i]] = p[ks[i]];
            }

            /**
             * SearchV2FeatureBundleAttributes starCoverageGroupID.
             * @member {string} starCoverageGroupID
             * @memberof coreproductpb.SearchV2FeatureBundle.SearchV2FeatureBundleAttributes
             * @instance
             */
            SearchV2FeatureBundleAttributes.prototype.starCoverageGroupID = "";

            /**
             * Creates a new SearchV2FeatureBundleAttributes instance using the specified properties.
             * @function create
             * @memberof coreproductpb.SearchV2FeatureBundle.SearchV2FeatureBundleAttributes
             * @static
             * @param {coreproductpb.SearchV2FeatureBundle.ISearchV2FeatureBundleAttributes=} [properties] Properties to set
             * @returns {coreproductpb.SearchV2FeatureBundle.SearchV2FeatureBundleAttributes} SearchV2FeatureBundleAttributes instance
             */
            SearchV2FeatureBundleAttributes.create = function create(properties) {
                return new SearchV2FeatureBundleAttributes(properties);
            };

            /**
             * Encodes the specified SearchV2FeatureBundleAttributes message. Does not implicitly {@link coreproductpb.SearchV2FeatureBundle.SearchV2FeatureBundleAttributes.verify|verify} messages.
             * @function encode
             * @memberof coreproductpb.SearchV2FeatureBundle.SearchV2FeatureBundleAttributes
             * @static
             * @param {coreproductpb.SearchV2FeatureBundle.ISearchV2FeatureBundleAttributes} m SearchV2FeatureBundleAttributes message or plain object to encode
             * @param {$protobuf.Writer} [w] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            SearchV2FeatureBundleAttributes.encode = function encode(m, w) {
                if (!w)
                    w = $Writer.create();
                if (m.starCoverageGroupID != null && Object.hasOwnProperty.call(m, "starCoverageGroupID"))
                    w.uint32(10).string(m.starCoverageGroupID);
                return w;
            };

            /**
             * Decodes a SearchV2FeatureBundleAttributes message from the specified reader or buffer.
             * @function decode
             * @memberof coreproductpb.SearchV2FeatureBundle.SearchV2FeatureBundleAttributes
             * @static
             * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
             * @param {number} [l] Message length if known beforehand
             * @returns {coreproductpb.SearchV2FeatureBundle.SearchV2FeatureBundleAttributes} SearchV2FeatureBundleAttributes
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            SearchV2FeatureBundleAttributes.decode = function decode(r, l) {
                if (!(r instanceof $Reader))
                    r = $Reader.create(r);
                var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.SearchV2FeatureBundle.SearchV2FeatureBundleAttributes();
                while (r.pos < c) {
                    var t = r.uint32();
                    switch (t >>> 3) {
                    case 1:
                        m.starCoverageGroupID = r.string();
                        break;
                    default:
                        r.skipType(t & 7);
                        break;
                    }
                }
                return m;
            };

            return SearchV2FeatureBundleAttributes;
        })();

        return SearchV2FeatureBundle;
    })();

    coreproductpb.SearchV2AddOnFeatureBundles = (function() {

        /**
         * Properties of a SearchV2AddOnFeatureBundles.
         * @memberof coreproductpb
         * @interface ISearchV2AddOnFeatureBundles
         * @property {Array.<coreproductpb.ISearchV2FeatureBundle>|null} [options] SearchV2AddOnFeatureBundles options
         * @property {Array.<coreproductpb.IPickRule>|null} [pickRules] SearchV2AddOnFeatureBundles pickRules
         */

        /**
         * Constructs a new SearchV2AddOnFeatureBundles.
         * @memberof coreproductpb
         * @classdesc Represents a SearchV2AddOnFeatureBundles.
         * @implements ISearchV2AddOnFeatureBundles
         * @constructor
         * @param {coreproductpb.ISearchV2AddOnFeatureBundles=} [p] Properties to set
         */
        function SearchV2AddOnFeatureBundles(p) {
            this.options = [];
            this.pickRules = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * SearchV2AddOnFeatureBundles options.
         * @member {Array.<coreproductpb.ISearchV2FeatureBundle>} options
         * @memberof coreproductpb.SearchV2AddOnFeatureBundles
         * @instance
         */
        SearchV2AddOnFeatureBundles.prototype.options = $util.emptyArray;

        /**
         * SearchV2AddOnFeatureBundles pickRules.
         * @member {Array.<coreproductpb.IPickRule>} pickRules
         * @memberof coreproductpb.SearchV2AddOnFeatureBundles
         * @instance
         */
        SearchV2AddOnFeatureBundles.prototype.pickRules = $util.emptyArray;

        /**
         * Creates a new SearchV2AddOnFeatureBundles instance using the specified properties.
         * @function create
         * @memberof coreproductpb.SearchV2AddOnFeatureBundles
         * @static
         * @param {coreproductpb.ISearchV2AddOnFeatureBundles=} [properties] Properties to set
         * @returns {coreproductpb.SearchV2AddOnFeatureBundles} SearchV2AddOnFeatureBundles instance
         */
        SearchV2AddOnFeatureBundles.create = function create(properties) {
            return new SearchV2AddOnFeatureBundles(properties);
        };

        /**
         * Encodes the specified SearchV2AddOnFeatureBundles message. Does not implicitly {@link coreproductpb.SearchV2AddOnFeatureBundles.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.SearchV2AddOnFeatureBundles
         * @static
         * @param {coreproductpb.ISearchV2AddOnFeatureBundles} m SearchV2AddOnFeatureBundles message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SearchV2AddOnFeatureBundles.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.options != null && m.options.length) {
                for (var i = 0; i < m.options.length; ++i)
                    $root.coreproductpb.SearchV2FeatureBundle.encode(m.options[i], w.uint32(10).fork()).ldelim();
            }
            if (m.pickRules != null && m.pickRules.length) {
                for (var i = 0; i < m.pickRules.length; ++i)
                    $root.coreproductpb.PickRule.encode(m.pickRules[i], w.uint32(18).fork()).ldelim();
            }
            return w;
        };

        /**
         * Decodes a SearchV2AddOnFeatureBundles message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.SearchV2AddOnFeatureBundles
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.SearchV2AddOnFeatureBundles} SearchV2AddOnFeatureBundles
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SearchV2AddOnFeatureBundles.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.SearchV2AddOnFeatureBundles();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    if (!(m.options && m.options.length))
                        m.options = [];
                    m.options.push($root.coreproductpb.SearchV2FeatureBundle.decode(r, r.uint32()));
                    break;
                case 2:
                    if (!(m.pickRules && m.pickRules.length))
                        m.pickRules = [];
                    m.pickRules.push($root.coreproductpb.PickRule.decode(r, r.uint32()));
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return SearchV2AddOnFeatureBundles;
    })();

    coreproductpb.GetProductRenewalRequest = (function() {

        /**
         * Properties of a GetProductRenewalRequest.
         * @memberof coreproductpb
         * @interface IGetProductRenewalRequest
         * @property {string|null} [starPVID] GetProductRenewalRequest starPVID
         * @property {string|null} [productID] GetProductRenewalRequest productID
         * @property {common.USStateAlphaCode|null} [state] GetProductRenewalRequest state
         * @property {google.protobuf.ITimestamp|null} [effectiveDate] GetProductRenewalRequest effectiveDate
         * @property {Array.<coreproductpb.GetProductRenewalRequest.ProductRenewalResponseFieldset>|null} [productRenewalResponseFieldset] GetProductRenewalRequest productRenewalResponseFieldset
         * @property {boolean|null} [includeExpiredCurrentProductDetail] GetProductRenewalRequest includeExpiredCurrentProductDetail
         */

        /**
         * Constructs a new GetProductRenewalRequest.
         * @memberof coreproductpb
         * @classdesc Represents a GetProductRenewalRequest.
         * @implements IGetProductRenewalRequest
         * @constructor
         * @param {coreproductpb.IGetProductRenewalRequest=} [p] Properties to set
         */
        function GetProductRenewalRequest(p) {
            this.productRenewalResponseFieldset = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * GetProductRenewalRequest starPVID.
         * @member {string|null|undefined} starPVID
         * @memberof coreproductpb.GetProductRenewalRequest
         * @instance
         */
        GetProductRenewalRequest.prototype.starPVID = null;

        /**
         * GetProductRenewalRequest productID.
         * @member {string|null|undefined} productID
         * @memberof coreproductpb.GetProductRenewalRequest
         * @instance
         */
        GetProductRenewalRequest.prototype.productID = null;

        /**
         * GetProductRenewalRequest state.
         * @member {common.USStateAlphaCode} state
         * @memberof coreproductpb.GetProductRenewalRequest
         * @instance
         */
        GetProductRenewalRequest.prototype.state = 0;

        /**
         * GetProductRenewalRequest effectiveDate.
         * @member {google.protobuf.ITimestamp|null|undefined} effectiveDate
         * @memberof coreproductpb.GetProductRenewalRequest
         * @instance
         */
        GetProductRenewalRequest.prototype.effectiveDate = null;

        /**
         * GetProductRenewalRequest productRenewalResponseFieldset.
         * @member {Array.<coreproductpb.GetProductRenewalRequest.ProductRenewalResponseFieldset>} productRenewalResponseFieldset
         * @memberof coreproductpb.GetProductRenewalRequest
         * @instance
         */
        GetProductRenewalRequest.prototype.productRenewalResponseFieldset = $util.emptyArray;

        /**
         * GetProductRenewalRequest includeExpiredCurrentProductDetail.
         * @member {boolean} includeExpiredCurrentProductDetail
         * @memberof coreproductpb.GetProductRenewalRequest
         * @instance
         */
        GetProductRenewalRequest.prototype.includeExpiredCurrentProductDetail = false;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        /**
         * GetProductRenewalRequest currentProductID.
         * @member {"starPVID"|"productID"|undefined} currentProductID
         * @memberof coreproductpb.GetProductRenewalRequest
         * @instance
         */
        Object.defineProperty(GetProductRenewalRequest.prototype, "currentProductID", {
            get: $util.oneOfGetter($oneOfFields = ["starPVID", "productID"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new GetProductRenewalRequest instance using the specified properties.
         * @function create
         * @memberof coreproductpb.GetProductRenewalRequest
         * @static
         * @param {coreproductpb.IGetProductRenewalRequest=} [properties] Properties to set
         * @returns {coreproductpb.GetProductRenewalRequest} GetProductRenewalRequest instance
         */
        GetProductRenewalRequest.create = function create(properties) {
            return new GetProductRenewalRequest(properties);
        };

        /**
         * Encodes the specified GetProductRenewalRequest message. Does not implicitly {@link coreproductpb.GetProductRenewalRequest.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.GetProductRenewalRequest
         * @static
         * @param {coreproductpb.IGetProductRenewalRequest} m GetProductRenewalRequest message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetProductRenewalRequest.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.starPVID != null && Object.hasOwnProperty.call(m, "starPVID"))
                w.uint32(10).string(m.starPVID);
            if (m.productID != null && Object.hasOwnProperty.call(m, "productID"))
                w.uint32(18).string(m.productID);
            if (m.state != null && Object.hasOwnProperty.call(m, "state"))
                w.uint32(24).int32(m.state);
            if (m.effectiveDate != null && Object.hasOwnProperty.call(m, "effectiveDate"))
                $root.google.protobuf.Timestamp.encode(m.effectiveDate, w.uint32(34).fork()).ldelim();
            if (m.productRenewalResponseFieldset != null && m.productRenewalResponseFieldset.length) {
                w.uint32(42).fork();
                for (var i = 0; i < m.productRenewalResponseFieldset.length; ++i)
                    w.int32(m.productRenewalResponseFieldset[i]);
                w.ldelim();
            }
            if (m.includeExpiredCurrentProductDetail != null && Object.hasOwnProperty.call(m, "includeExpiredCurrentProductDetail"))
                w.uint32(48).bool(m.includeExpiredCurrentProductDetail);
            return w;
        };

        /**
         * Decodes a GetProductRenewalRequest message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.GetProductRenewalRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.GetProductRenewalRequest} GetProductRenewalRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetProductRenewalRequest.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.GetProductRenewalRequest();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.starPVID = r.string();
                    break;
                case 2:
                    m.productID = r.string();
                    break;
                case 3:
                    m.state = r.int32();
                    break;
                case 4:
                    m.effectiveDate = $root.google.protobuf.Timestamp.decode(r, r.uint32());
                    break;
                case 5:
                    if (!(m.productRenewalResponseFieldset && m.productRenewalResponseFieldset.length))
                        m.productRenewalResponseFieldset = [];
                    if ((t & 7) === 2) {
                        var c2 = r.uint32() + r.pos;
                        while (r.pos < c2)
                            m.productRenewalResponseFieldset.push(r.int32());
                    } else
                        m.productRenewalResponseFieldset.push(r.int32());
                    break;
                case 6:
                    m.includeExpiredCurrentProductDetail = r.bool();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        /**
         * ProductRenewalResponseFieldset enum.
         * @name coreproductpb.GetProductRenewalRequest.ProductRenewalResponseFieldset
         * @enum {number}
         * @property {number} PRRF_CURRENT_PRODUCT=0 PRRF_CURRENT_PRODUCT value
         * @property {number} PRPF_ATTRIBUTES=1 PRPF_ATTRIBUTES value
         * @property {number} PRPF_BASE_FEATURES_RENEWALMAPPING=2 PRPF_BASE_FEATURES_RENEWALMAPPING value
         * @property {number} PRPF_ADDON_FEATURES_RENEWALMAPPING=3 PRPF_ADDON_FEATURES_RENEWALMAPPING value
         * @property {number} PRPF_ADDON_FEATURE_BUNDLES_RENEWALMAPPING=4 PRPF_ADDON_FEATURE_BUNDLES_RENEWALMAPPING value
         * @property {number} PRPF_FEATURE_HIERARCHY=5 PRPF_FEATURE_HIERARCHY value
         */
        GetProductRenewalRequest.ProductRenewalResponseFieldset = (function() {
            const valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "PRRF_CURRENT_PRODUCT"] = 0;
            values[valuesById[1] = "PRPF_ATTRIBUTES"] = 1;
            values[valuesById[2] = "PRPF_BASE_FEATURES_RENEWALMAPPING"] = 2;
            values[valuesById[3] = "PRPF_ADDON_FEATURES_RENEWALMAPPING"] = 3;
            values[valuesById[4] = "PRPF_ADDON_FEATURE_BUNDLES_RENEWALMAPPING"] = 4;
            values[valuesById[5] = "PRPF_FEATURE_HIERARCHY"] = 5;
            return values;
        })();

        return GetProductRenewalRequest;
    })();

    coreproductpb.GetProductRenewalResponse = (function() {

        /**
         * Properties of a GetProductRenewalResponse.
         * @memberof coreproductpb
         * @interface IGetProductRenewalResponse
         * @property {Array.<coreproductpb.IProductRenewalResponse>|null} [renewalProducts] GetProductRenewalResponse renewalProducts
         * @property {coreproductpb.IProductResponse|null} [currentProduct] GetProductRenewalResponse currentProduct
         * @property {Array.<common.IError>|null} [errors] GetProductRenewalResponse errors
         */

        /**
         * Constructs a new GetProductRenewalResponse.
         * @memberof coreproductpb
         * @classdesc Represents a GetProductRenewalResponse.
         * @implements IGetProductRenewalResponse
         * @constructor
         * @param {coreproductpb.IGetProductRenewalResponse=} [p] Properties to set
         */
        function GetProductRenewalResponse(p) {
            this.renewalProducts = [];
            this.errors = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * GetProductRenewalResponse renewalProducts.
         * @member {Array.<coreproductpb.IProductRenewalResponse>} renewalProducts
         * @memberof coreproductpb.GetProductRenewalResponse
         * @instance
         */
        GetProductRenewalResponse.prototype.renewalProducts = $util.emptyArray;

        /**
         * GetProductRenewalResponse currentProduct.
         * @member {coreproductpb.IProductResponse|null|undefined} currentProduct
         * @memberof coreproductpb.GetProductRenewalResponse
         * @instance
         */
        GetProductRenewalResponse.prototype.currentProduct = null;

        /**
         * GetProductRenewalResponse errors.
         * @member {Array.<common.IError>} errors
         * @memberof coreproductpb.GetProductRenewalResponse
         * @instance
         */
        GetProductRenewalResponse.prototype.errors = $util.emptyArray;

        /**
         * Creates a new GetProductRenewalResponse instance using the specified properties.
         * @function create
         * @memberof coreproductpb.GetProductRenewalResponse
         * @static
         * @param {coreproductpb.IGetProductRenewalResponse=} [properties] Properties to set
         * @returns {coreproductpb.GetProductRenewalResponse} GetProductRenewalResponse instance
         */
        GetProductRenewalResponse.create = function create(properties) {
            return new GetProductRenewalResponse(properties);
        };

        /**
         * Encodes the specified GetProductRenewalResponse message. Does not implicitly {@link coreproductpb.GetProductRenewalResponse.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.GetProductRenewalResponse
         * @static
         * @param {coreproductpb.IGetProductRenewalResponse} m GetProductRenewalResponse message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetProductRenewalResponse.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.renewalProducts != null && m.renewalProducts.length) {
                for (var i = 0; i < m.renewalProducts.length; ++i)
                    $root.coreproductpb.ProductRenewalResponse.encode(m.renewalProducts[i], w.uint32(10).fork()).ldelim();
            }
            if (m.currentProduct != null && Object.hasOwnProperty.call(m, "currentProduct"))
                $root.coreproductpb.ProductResponse.encode(m.currentProduct, w.uint32(18).fork()).ldelim();
            if (m.errors != null && m.errors.length) {
                for (var i = 0; i < m.errors.length; ++i)
                    $root.common.Error.encode(m.errors[i], w.uint32(26).fork()).ldelim();
            }
            return w;
        };

        /**
         * Decodes a GetProductRenewalResponse message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.GetProductRenewalResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.GetProductRenewalResponse} GetProductRenewalResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetProductRenewalResponse.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.GetProductRenewalResponse();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    if (!(m.renewalProducts && m.renewalProducts.length))
                        m.renewalProducts = [];
                    m.renewalProducts.push($root.coreproductpb.ProductRenewalResponse.decode(r, r.uint32()));
                    break;
                case 2:
                    m.currentProduct = $root.coreproductpb.ProductResponse.decode(r, r.uint32());
                    break;
                case 3:
                    if (!(m.errors && m.errors.length))
                        m.errors = [];
                    m.errors.push($root.common.Error.decode(r, r.uint32()));
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return GetProductRenewalResponse;
    })();

    coreproductpb.ProductRenewalResponse = (function() {

        /**
         * Properties of a ProductRenewalResponse.
         * @memberof coreproductpb
         * @interface IProductRenewalResponse
         * @property {string|null} [productTemplateID] ProductRenewalResponse productTemplateID
         * @property {string|null} [productID] ProductRenewalResponse productID
         * @property {string|null} [starPVID] ProductRenewalResponse starPVID
         * @property {string|null} [starOldPV] ProductRenewalResponse starOldPV
         * @property {string|null} [productType] ProductRenewalResponse productType
         * @property {string|null} [name] ProductRenewalResponse name
         * @property {string|null} [description] ProductRenewalResponse description
         * @property {coreproductpb.IProductAttributes|null} [attributes] ProductRenewalResponse attributes
         * @property {coreproductpb.IProductRenewalFeatures|null} [features] ProductRenewalResponse features
         * @property {string|null} [productTemplateVersionID] ProductRenewalResponse productTemplateVersionID
         * @property {google.protobuf.ITimestamp|null} [effectiveDate] ProductRenewalResponse effectiveDate
         * @property {google.protobuf.ITimestamp|null} [expirationDate] ProductRenewalResponse expirationDate
         * @property {google.protobuf.ITimestamp|null} [renewalEffectiveDate] ProductRenewalResponse renewalEffectiveDate
         * @property {common.USStateAlphaCode|null} [state] ProductRenewalResponse state
         * @property {boolean|null} [renewalProductLikeForLike] ProductRenewalResponse renewalProductLikeForLike
         * @property {string|null} [starProductPlanID] ProductRenewalResponse starProductPlanID
         * @property {string|null} [starProductID] ProductRenewalResponse starProductID
         * @property {coreproductpb.IProductFeatureTags|null} [productTags] ProductRenewalResponse productTags
         */

        /**
         * Constructs a new ProductRenewalResponse.
         * @memberof coreproductpb
         * @classdesc Represents a ProductRenewalResponse.
         * @implements IProductRenewalResponse
         * @constructor
         * @param {coreproductpb.IProductRenewalResponse=} [p] Properties to set
         */
        function ProductRenewalResponse(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * ProductRenewalResponse productTemplateID.
         * @member {string} productTemplateID
         * @memberof coreproductpb.ProductRenewalResponse
         * @instance
         */
        ProductRenewalResponse.prototype.productTemplateID = "";

        /**
         * ProductRenewalResponse productID.
         * @member {string} productID
         * @memberof coreproductpb.ProductRenewalResponse
         * @instance
         */
        ProductRenewalResponse.prototype.productID = "";

        /**
         * ProductRenewalResponse starPVID.
         * @member {string} starPVID
         * @memberof coreproductpb.ProductRenewalResponse
         * @instance
         */
        ProductRenewalResponse.prototype.starPVID = "";

        /**
         * ProductRenewalResponse starOldPV.
         * @member {string} starOldPV
         * @memberof coreproductpb.ProductRenewalResponse
         * @instance
         */
        ProductRenewalResponse.prototype.starOldPV = "";

        /**
         * ProductRenewalResponse productType.
         * @member {string} productType
         * @memberof coreproductpb.ProductRenewalResponse
         * @instance
         */
        ProductRenewalResponse.prototype.productType = "";

        /**
         * ProductRenewalResponse name.
         * @member {string} name
         * @memberof coreproductpb.ProductRenewalResponse
         * @instance
         */
        ProductRenewalResponse.prototype.name = "";

        /**
         * ProductRenewalResponse description.
         * @member {string} description
         * @memberof coreproductpb.ProductRenewalResponse
         * @instance
         */
        ProductRenewalResponse.prototype.description = "";

        /**
         * ProductRenewalResponse attributes.
         * @member {coreproductpb.IProductAttributes|null|undefined} attributes
         * @memberof coreproductpb.ProductRenewalResponse
         * @instance
         */
        ProductRenewalResponse.prototype.attributes = null;

        /**
         * ProductRenewalResponse features.
         * @member {coreproductpb.IProductRenewalFeatures|null|undefined} features
         * @memberof coreproductpb.ProductRenewalResponse
         * @instance
         */
        ProductRenewalResponse.prototype.features = null;

        /**
         * ProductRenewalResponse productTemplateVersionID.
         * @member {string} productTemplateVersionID
         * @memberof coreproductpb.ProductRenewalResponse
         * @instance
         */
        ProductRenewalResponse.prototype.productTemplateVersionID = "";

        /**
         * ProductRenewalResponse effectiveDate.
         * @member {google.protobuf.ITimestamp|null|undefined} effectiveDate
         * @memberof coreproductpb.ProductRenewalResponse
         * @instance
         */
        ProductRenewalResponse.prototype.effectiveDate = null;

        /**
         * ProductRenewalResponse expirationDate.
         * @member {google.protobuf.ITimestamp|null|undefined} expirationDate
         * @memberof coreproductpb.ProductRenewalResponse
         * @instance
         */
        ProductRenewalResponse.prototype.expirationDate = null;

        /**
         * ProductRenewalResponse renewalEffectiveDate.
         * @member {google.protobuf.ITimestamp|null|undefined} renewalEffectiveDate
         * @memberof coreproductpb.ProductRenewalResponse
         * @instance
         */
        ProductRenewalResponse.prototype.renewalEffectiveDate = null;

        /**
         * ProductRenewalResponse state.
         * @member {common.USStateAlphaCode} state
         * @memberof coreproductpb.ProductRenewalResponse
         * @instance
         */
        ProductRenewalResponse.prototype.state = 0;

        /**
         * ProductRenewalResponse renewalProductLikeForLike.
         * @member {boolean} renewalProductLikeForLike
         * @memberof coreproductpb.ProductRenewalResponse
         * @instance
         */
        ProductRenewalResponse.prototype.renewalProductLikeForLike = false;

        /**
         * ProductRenewalResponse starProductPlanID.
         * @member {string} starProductPlanID
         * @memberof coreproductpb.ProductRenewalResponse
         * @instance
         */
        ProductRenewalResponse.prototype.starProductPlanID = "";

        /**
         * ProductRenewalResponse starProductID.
         * @member {string} starProductID
         * @memberof coreproductpb.ProductRenewalResponse
         * @instance
         */
        ProductRenewalResponse.prototype.starProductID = "";

        /**
         * ProductRenewalResponse productTags.
         * @member {coreproductpb.IProductFeatureTags|null|undefined} productTags
         * @memberof coreproductpb.ProductRenewalResponse
         * @instance
         */
        ProductRenewalResponse.prototype.productTags = null;

        /**
         * Creates a new ProductRenewalResponse instance using the specified properties.
         * @function create
         * @memberof coreproductpb.ProductRenewalResponse
         * @static
         * @param {coreproductpb.IProductRenewalResponse=} [properties] Properties to set
         * @returns {coreproductpb.ProductRenewalResponse} ProductRenewalResponse instance
         */
        ProductRenewalResponse.create = function create(properties) {
            return new ProductRenewalResponse(properties);
        };

        /**
         * Encodes the specified ProductRenewalResponse message. Does not implicitly {@link coreproductpb.ProductRenewalResponse.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.ProductRenewalResponse
         * @static
         * @param {coreproductpb.IProductRenewalResponse} m ProductRenewalResponse message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ProductRenewalResponse.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.productTemplateID != null && Object.hasOwnProperty.call(m, "productTemplateID"))
                w.uint32(10).string(m.productTemplateID);
            if (m.productID != null && Object.hasOwnProperty.call(m, "productID"))
                w.uint32(18).string(m.productID);
            if (m.starPVID != null && Object.hasOwnProperty.call(m, "starPVID"))
                w.uint32(26).string(m.starPVID);
            if (m.starOldPV != null && Object.hasOwnProperty.call(m, "starOldPV"))
                w.uint32(34).string(m.starOldPV);
            if (m.productType != null && Object.hasOwnProperty.call(m, "productType"))
                w.uint32(42).string(m.productType);
            if (m.name != null && Object.hasOwnProperty.call(m, "name"))
                w.uint32(50).string(m.name);
            if (m.description != null && Object.hasOwnProperty.call(m, "description"))
                w.uint32(58).string(m.description);
            if (m.attributes != null && Object.hasOwnProperty.call(m, "attributes"))
                $root.coreproductpb.ProductAttributes.encode(m.attributes, w.uint32(66).fork()).ldelim();
            if (m.features != null && Object.hasOwnProperty.call(m, "features"))
                $root.coreproductpb.ProductRenewalFeatures.encode(m.features, w.uint32(74).fork()).ldelim();
            if (m.productTemplateVersionID != null && Object.hasOwnProperty.call(m, "productTemplateVersionID"))
                w.uint32(82).string(m.productTemplateVersionID);
            if (m.effectiveDate != null && Object.hasOwnProperty.call(m, "effectiveDate"))
                $root.google.protobuf.Timestamp.encode(m.effectiveDate, w.uint32(90).fork()).ldelim();
            if (m.expirationDate != null && Object.hasOwnProperty.call(m, "expirationDate"))
                $root.google.protobuf.Timestamp.encode(m.expirationDate, w.uint32(98).fork()).ldelim();
            if (m.renewalEffectiveDate != null && Object.hasOwnProperty.call(m, "renewalEffectiveDate"))
                $root.google.protobuf.Timestamp.encode(m.renewalEffectiveDate, w.uint32(106).fork()).ldelim();
            if (m.state != null && Object.hasOwnProperty.call(m, "state"))
                w.uint32(112).int32(m.state);
            if (m.renewalProductLikeForLike != null && Object.hasOwnProperty.call(m, "renewalProductLikeForLike"))
                w.uint32(120).bool(m.renewalProductLikeForLike);
            if (m.starProductPlanID != null && Object.hasOwnProperty.call(m, "starProductPlanID"))
                w.uint32(130).string(m.starProductPlanID);
            if (m.starProductID != null && Object.hasOwnProperty.call(m, "starProductID"))
                w.uint32(138).string(m.starProductID);
            if (m.productTags != null && Object.hasOwnProperty.call(m, "productTags"))
                $root.coreproductpb.ProductFeatureTags.encode(m.productTags, w.uint32(146).fork()).ldelim();
            return w;
        };

        /**
         * Decodes a ProductRenewalResponse message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.ProductRenewalResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.ProductRenewalResponse} ProductRenewalResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ProductRenewalResponse.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.ProductRenewalResponse();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.productTemplateID = r.string();
                    break;
                case 2:
                    m.productID = r.string();
                    break;
                case 3:
                    m.starPVID = r.string();
                    break;
                case 4:
                    m.starOldPV = r.string();
                    break;
                case 5:
                    m.productType = r.string();
                    break;
                case 6:
                    m.name = r.string();
                    break;
                case 7:
                    m.description = r.string();
                    break;
                case 8:
                    m.attributes = $root.coreproductpb.ProductAttributes.decode(r, r.uint32());
                    break;
                case 9:
                    m.features = $root.coreproductpb.ProductRenewalFeatures.decode(r, r.uint32());
                    break;
                case 10:
                    m.productTemplateVersionID = r.string();
                    break;
                case 11:
                    m.effectiveDate = $root.google.protobuf.Timestamp.decode(r, r.uint32());
                    break;
                case 12:
                    m.expirationDate = $root.google.protobuf.Timestamp.decode(r, r.uint32());
                    break;
                case 13:
                    m.renewalEffectiveDate = $root.google.protobuf.Timestamp.decode(r, r.uint32());
                    break;
                case 14:
                    m.state = r.int32();
                    break;
                case 15:
                    m.renewalProductLikeForLike = r.bool();
                    break;
                case 16:
                    m.starProductPlanID = r.string();
                    break;
                case 17:
                    m.starProductID = r.string();
                    break;
                case 18:
                    m.productTags = $root.coreproductpb.ProductFeatureTags.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return ProductRenewalResponse;
    })();

    coreproductpb.ProductRenewalFeatures = (function() {

        /**
         * Properties of a ProductRenewalFeatures.
         * @memberof coreproductpb
         * @interface IProductRenewalFeatures
         * @property {Array.<coreproductpb.IFeatureRenewalMapping>|null} [baseFeaturesRenewalMapping] ProductRenewalFeatures baseFeaturesRenewalMapping
         * @property {Array.<coreproductpb.IFeatureRenewalMapping>|null} [addOnFeaturesRenewalMapping] ProductRenewalFeatures addOnFeaturesRenewalMapping
         * @property {Array.<coreproductpb.IFeatureBundleRenewalMapping>|null} [addOnFeatureBundlesRenewalMapping] ProductRenewalFeatures addOnFeatureBundlesRenewalMapping
         */

        /**
         * Constructs a new ProductRenewalFeatures.
         * @memberof coreproductpb
         * @classdesc Represents a ProductRenewalFeatures.
         * @implements IProductRenewalFeatures
         * @constructor
         * @param {coreproductpb.IProductRenewalFeatures=} [p] Properties to set
         */
        function ProductRenewalFeatures(p) {
            this.baseFeaturesRenewalMapping = [];
            this.addOnFeaturesRenewalMapping = [];
            this.addOnFeatureBundlesRenewalMapping = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * ProductRenewalFeatures baseFeaturesRenewalMapping.
         * @member {Array.<coreproductpb.IFeatureRenewalMapping>} baseFeaturesRenewalMapping
         * @memberof coreproductpb.ProductRenewalFeatures
         * @instance
         */
        ProductRenewalFeatures.prototype.baseFeaturesRenewalMapping = $util.emptyArray;

        /**
         * ProductRenewalFeatures addOnFeaturesRenewalMapping.
         * @member {Array.<coreproductpb.IFeatureRenewalMapping>} addOnFeaturesRenewalMapping
         * @memberof coreproductpb.ProductRenewalFeatures
         * @instance
         */
        ProductRenewalFeatures.prototype.addOnFeaturesRenewalMapping = $util.emptyArray;

        /**
         * ProductRenewalFeatures addOnFeatureBundlesRenewalMapping.
         * @member {Array.<coreproductpb.IFeatureBundleRenewalMapping>} addOnFeatureBundlesRenewalMapping
         * @memberof coreproductpb.ProductRenewalFeatures
         * @instance
         */
        ProductRenewalFeatures.prototype.addOnFeatureBundlesRenewalMapping = $util.emptyArray;

        /**
         * Creates a new ProductRenewalFeatures instance using the specified properties.
         * @function create
         * @memberof coreproductpb.ProductRenewalFeatures
         * @static
         * @param {coreproductpb.IProductRenewalFeatures=} [properties] Properties to set
         * @returns {coreproductpb.ProductRenewalFeatures} ProductRenewalFeatures instance
         */
        ProductRenewalFeatures.create = function create(properties) {
            return new ProductRenewalFeatures(properties);
        };

        /**
         * Encodes the specified ProductRenewalFeatures message. Does not implicitly {@link coreproductpb.ProductRenewalFeatures.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.ProductRenewalFeatures
         * @static
         * @param {coreproductpb.IProductRenewalFeatures} m ProductRenewalFeatures message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ProductRenewalFeatures.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.baseFeaturesRenewalMapping != null && m.baseFeaturesRenewalMapping.length) {
                for (var i = 0; i < m.baseFeaturesRenewalMapping.length; ++i)
                    $root.coreproductpb.FeatureRenewalMapping.encode(m.baseFeaturesRenewalMapping[i], w.uint32(10).fork()).ldelim();
            }
            if (m.addOnFeaturesRenewalMapping != null && m.addOnFeaturesRenewalMapping.length) {
                for (var i = 0; i < m.addOnFeaturesRenewalMapping.length; ++i)
                    $root.coreproductpb.FeatureRenewalMapping.encode(m.addOnFeaturesRenewalMapping[i], w.uint32(18).fork()).ldelim();
            }
            if (m.addOnFeatureBundlesRenewalMapping != null && m.addOnFeatureBundlesRenewalMapping.length) {
                for (var i = 0; i < m.addOnFeatureBundlesRenewalMapping.length; ++i)
                    $root.coreproductpb.FeatureBundleRenewalMapping.encode(m.addOnFeatureBundlesRenewalMapping[i], w.uint32(26).fork()).ldelim();
            }
            return w;
        };

        /**
         * Decodes a ProductRenewalFeatures message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.ProductRenewalFeatures
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.ProductRenewalFeatures} ProductRenewalFeatures
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ProductRenewalFeatures.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.ProductRenewalFeatures();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    if (!(m.baseFeaturesRenewalMapping && m.baseFeaturesRenewalMapping.length))
                        m.baseFeaturesRenewalMapping = [];
                    m.baseFeaturesRenewalMapping.push($root.coreproductpb.FeatureRenewalMapping.decode(r, r.uint32()));
                    break;
                case 2:
                    if (!(m.addOnFeaturesRenewalMapping && m.addOnFeaturesRenewalMapping.length))
                        m.addOnFeaturesRenewalMapping = [];
                    m.addOnFeaturesRenewalMapping.push($root.coreproductpb.FeatureRenewalMapping.decode(r, r.uint32()));
                    break;
                case 3:
                    if (!(m.addOnFeatureBundlesRenewalMapping && m.addOnFeatureBundlesRenewalMapping.length))
                        m.addOnFeatureBundlesRenewalMapping = [];
                    m.addOnFeatureBundlesRenewalMapping.push($root.coreproductpb.FeatureBundleRenewalMapping.decode(r, r.uint32()));
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return ProductRenewalFeatures;
    })();

    coreproductpb.FeatureRenewalMapping = (function() {

        /**
         * Properties of a FeatureRenewalMapping.
         * @memberof coreproductpb
         * @interface IFeatureRenewalMapping
         * @property {coreproductpb.IFeature|null} [currentFeature] FeatureRenewalMapping currentFeature
         * @property {coreproductpb.IFeature|null} [renewalFeature] FeatureRenewalMapping renewalFeature
         */

        /**
         * Constructs a new FeatureRenewalMapping.
         * @memberof coreproductpb
         * @classdesc Represents a FeatureRenewalMapping.
         * @implements IFeatureRenewalMapping
         * @constructor
         * @param {coreproductpb.IFeatureRenewalMapping=} [p] Properties to set
         */
        function FeatureRenewalMapping(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * FeatureRenewalMapping currentFeature.
         * @member {coreproductpb.IFeature|null|undefined} currentFeature
         * @memberof coreproductpb.FeatureRenewalMapping
         * @instance
         */
        FeatureRenewalMapping.prototype.currentFeature = null;

        /**
         * FeatureRenewalMapping renewalFeature.
         * @member {coreproductpb.IFeature|null|undefined} renewalFeature
         * @memberof coreproductpb.FeatureRenewalMapping
         * @instance
         */
        FeatureRenewalMapping.prototype.renewalFeature = null;

        /**
         * Creates a new FeatureRenewalMapping instance using the specified properties.
         * @function create
         * @memberof coreproductpb.FeatureRenewalMapping
         * @static
         * @param {coreproductpb.IFeatureRenewalMapping=} [properties] Properties to set
         * @returns {coreproductpb.FeatureRenewalMapping} FeatureRenewalMapping instance
         */
        FeatureRenewalMapping.create = function create(properties) {
            return new FeatureRenewalMapping(properties);
        };

        /**
         * Encodes the specified FeatureRenewalMapping message. Does not implicitly {@link coreproductpb.FeatureRenewalMapping.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.FeatureRenewalMapping
         * @static
         * @param {coreproductpb.IFeatureRenewalMapping} m FeatureRenewalMapping message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        FeatureRenewalMapping.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.currentFeature != null && Object.hasOwnProperty.call(m, "currentFeature"))
                $root.coreproductpb.Feature.encode(m.currentFeature, w.uint32(10).fork()).ldelim();
            if (m.renewalFeature != null && Object.hasOwnProperty.call(m, "renewalFeature"))
                $root.coreproductpb.Feature.encode(m.renewalFeature, w.uint32(18).fork()).ldelim();
            return w;
        };

        /**
         * Decodes a FeatureRenewalMapping message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.FeatureRenewalMapping
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.FeatureRenewalMapping} FeatureRenewalMapping
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        FeatureRenewalMapping.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.FeatureRenewalMapping();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.currentFeature = $root.coreproductpb.Feature.decode(r, r.uint32());
                    break;
                case 2:
                    m.renewalFeature = $root.coreproductpb.Feature.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return FeatureRenewalMapping;
    })();

    coreproductpb.FeatureBundleRenewalMapping = (function() {

        /**
         * Properties of a FeatureBundleRenewalMapping.
         * @memberof coreproductpb
         * @interface IFeatureBundleRenewalMapping
         * @property {coreproductpb.IFeatureBundle|null} [currentFeatureBundle] FeatureBundleRenewalMapping currentFeatureBundle
         * @property {coreproductpb.IFeatureBundle|null} [renewalFeatureBundle] FeatureBundleRenewalMapping renewalFeatureBundle
         */

        /**
         * Constructs a new FeatureBundleRenewalMapping.
         * @memberof coreproductpb
         * @classdesc Represents a FeatureBundleRenewalMapping.
         * @implements IFeatureBundleRenewalMapping
         * @constructor
         * @param {coreproductpb.IFeatureBundleRenewalMapping=} [p] Properties to set
         */
        function FeatureBundleRenewalMapping(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * FeatureBundleRenewalMapping currentFeatureBundle.
         * @member {coreproductpb.IFeatureBundle|null|undefined} currentFeatureBundle
         * @memberof coreproductpb.FeatureBundleRenewalMapping
         * @instance
         */
        FeatureBundleRenewalMapping.prototype.currentFeatureBundle = null;

        /**
         * FeatureBundleRenewalMapping renewalFeatureBundle.
         * @member {coreproductpb.IFeatureBundle|null|undefined} renewalFeatureBundle
         * @memberof coreproductpb.FeatureBundleRenewalMapping
         * @instance
         */
        FeatureBundleRenewalMapping.prototype.renewalFeatureBundle = null;

        /**
         * Creates a new FeatureBundleRenewalMapping instance using the specified properties.
         * @function create
         * @memberof coreproductpb.FeatureBundleRenewalMapping
         * @static
         * @param {coreproductpb.IFeatureBundleRenewalMapping=} [properties] Properties to set
         * @returns {coreproductpb.FeatureBundleRenewalMapping} FeatureBundleRenewalMapping instance
         */
        FeatureBundleRenewalMapping.create = function create(properties) {
            return new FeatureBundleRenewalMapping(properties);
        };

        /**
         * Encodes the specified FeatureBundleRenewalMapping message. Does not implicitly {@link coreproductpb.FeatureBundleRenewalMapping.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.FeatureBundleRenewalMapping
         * @static
         * @param {coreproductpb.IFeatureBundleRenewalMapping} m FeatureBundleRenewalMapping message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        FeatureBundleRenewalMapping.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.currentFeatureBundle != null && Object.hasOwnProperty.call(m, "currentFeatureBundle"))
                $root.coreproductpb.FeatureBundle.encode(m.currentFeatureBundle, w.uint32(10).fork()).ldelim();
            if (m.renewalFeatureBundle != null && Object.hasOwnProperty.call(m, "renewalFeatureBundle"))
                $root.coreproductpb.FeatureBundle.encode(m.renewalFeatureBundle, w.uint32(18).fork()).ldelim();
            return w;
        };

        /**
         * Decodes a FeatureBundleRenewalMapping message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.FeatureBundleRenewalMapping
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.FeatureBundleRenewalMapping} FeatureBundleRenewalMapping
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        FeatureBundleRenewalMapping.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.FeatureBundleRenewalMapping();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.currentFeatureBundle = $root.coreproductpb.FeatureBundle.decode(r, r.uint32());
                    break;
                case 2:
                    m.renewalFeatureBundle = $root.coreproductpb.FeatureBundle.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return FeatureBundleRenewalMapping;
    })();

    coreproductpb.GetProductAttributeValuesRequest = (function() {

        /**
         * Properties of a GetProductAttributeValuesRequest.
         * @memberof coreproductpb
         * @interface IGetProductAttributeValuesRequest
         * @property {coreproductpb.GetProductAttributeValuesRequest.AttributeValuesName|null} [name] GetProductAttributeValuesRequest name
         * @property {coreproductpb.DataRecordStatus|null} [status] GetProductAttributeValuesRequest status
         * @property {string|null} [id] GetProductAttributeValuesRequest id
         * @property {common.IPaginationRequest|null} [pagination] GetProductAttributeValuesRequest pagination
         */

        /**
         * Constructs a new GetProductAttributeValuesRequest.
         * @memberof coreproductpb
         * @classdesc Represents a GetProductAttributeValuesRequest.
         * @implements IGetProductAttributeValuesRequest
         * @constructor
         * @param {coreproductpb.IGetProductAttributeValuesRequest=} [p] Properties to set
         */
        function GetProductAttributeValuesRequest(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * GetProductAttributeValuesRequest name.
         * @member {coreproductpb.GetProductAttributeValuesRequest.AttributeValuesName} name
         * @memberof coreproductpb.GetProductAttributeValuesRequest
         * @instance
         */
        GetProductAttributeValuesRequest.prototype.name = 0;

        /**
         * GetProductAttributeValuesRequest status.
         * @member {coreproductpb.DataRecordStatus} status
         * @memberof coreproductpb.GetProductAttributeValuesRequest
         * @instance
         */
        GetProductAttributeValuesRequest.prototype.status = 0;

        /**
         * GetProductAttributeValuesRequest id.
         * @member {string} id
         * @memberof coreproductpb.GetProductAttributeValuesRequest
         * @instance
         */
        GetProductAttributeValuesRequest.prototype.id = "";

        /**
         * GetProductAttributeValuesRequest pagination.
         * @member {common.IPaginationRequest|null|undefined} pagination
         * @memberof coreproductpb.GetProductAttributeValuesRequest
         * @instance
         */
        GetProductAttributeValuesRequest.prototype.pagination = null;

        /**
         * Creates a new GetProductAttributeValuesRequest instance using the specified properties.
         * @function create
         * @memberof coreproductpb.GetProductAttributeValuesRequest
         * @static
         * @param {coreproductpb.IGetProductAttributeValuesRequest=} [properties] Properties to set
         * @returns {coreproductpb.GetProductAttributeValuesRequest} GetProductAttributeValuesRequest instance
         */
        GetProductAttributeValuesRequest.create = function create(properties) {
            return new GetProductAttributeValuesRequest(properties);
        };

        /**
         * Encodes the specified GetProductAttributeValuesRequest message. Does not implicitly {@link coreproductpb.GetProductAttributeValuesRequest.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.GetProductAttributeValuesRequest
         * @static
         * @param {coreproductpb.IGetProductAttributeValuesRequest} m GetProductAttributeValuesRequest message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetProductAttributeValuesRequest.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.name != null && Object.hasOwnProperty.call(m, "name"))
                w.uint32(8).int32(m.name);
            if (m.status != null && Object.hasOwnProperty.call(m, "status"))
                w.uint32(16).int32(m.status);
            if (m.id != null && Object.hasOwnProperty.call(m, "id"))
                w.uint32(26).string(m.id);
            if (m.pagination != null && Object.hasOwnProperty.call(m, "pagination"))
                $root.common.PaginationRequest.encode(m.pagination, w.uint32(34).fork()).ldelim();
            return w;
        };

        /**
         * Decodes a GetProductAttributeValuesRequest message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.GetProductAttributeValuesRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.GetProductAttributeValuesRequest} GetProductAttributeValuesRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetProductAttributeValuesRequest.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.GetProductAttributeValuesRequest();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.name = r.int32();
                    break;
                case 2:
                    m.status = r.int32();
                    break;
                case 3:
                    m.id = r.string();
                    break;
                case 4:
                    m.pagination = $root.common.PaginationRequest.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        /**
         * AttributeValuesName enum.
         * @name coreproductpb.GetProductAttributeValuesRequest.AttributeValuesName
         * @enum {number}
         * @property {number} AVN_UNDEFINED=0 AVN_UNDEFINED value
         * @property {number} AVN_PRODUCT_TYPE=1 AVN_PRODUCT_TYPE value
         */
        GetProductAttributeValuesRequest.AttributeValuesName = (function() {
            const valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "AVN_UNDEFINED"] = 0;
            values[valuesById[1] = "AVN_PRODUCT_TYPE"] = 1;
            return values;
        })();

        return GetProductAttributeValuesRequest;
    })();

    coreproductpb.GetProductAttributeValuesResponse = (function() {

        /**
         * Properties of a GetProductAttributeValuesResponse.
         * @memberof coreproductpb
         * @interface IGetProductAttributeValuesResponse
         * @property {Array.<coreproductpb.IProductAttributeValue>|null} [values] GetProductAttributeValuesResponse values
         * @property {Array.<common.IError>|null} [errors] GetProductAttributeValuesResponse errors
         * @property {common.IPagination|null} [pagination] GetProductAttributeValuesResponse pagination
         */

        /**
         * Constructs a new GetProductAttributeValuesResponse.
         * @memberof coreproductpb
         * @classdesc Represents a GetProductAttributeValuesResponse.
         * @implements IGetProductAttributeValuesResponse
         * @constructor
         * @param {coreproductpb.IGetProductAttributeValuesResponse=} [p] Properties to set
         */
        function GetProductAttributeValuesResponse(p) {
            this.values = [];
            this.errors = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * GetProductAttributeValuesResponse values.
         * @member {Array.<coreproductpb.IProductAttributeValue>} values
         * @memberof coreproductpb.GetProductAttributeValuesResponse
         * @instance
         */
        GetProductAttributeValuesResponse.prototype.values = $util.emptyArray;

        /**
         * GetProductAttributeValuesResponse errors.
         * @member {Array.<common.IError>} errors
         * @memberof coreproductpb.GetProductAttributeValuesResponse
         * @instance
         */
        GetProductAttributeValuesResponse.prototype.errors = $util.emptyArray;

        /**
         * GetProductAttributeValuesResponse pagination.
         * @member {common.IPagination|null|undefined} pagination
         * @memberof coreproductpb.GetProductAttributeValuesResponse
         * @instance
         */
        GetProductAttributeValuesResponse.prototype.pagination = null;

        /**
         * Creates a new GetProductAttributeValuesResponse instance using the specified properties.
         * @function create
         * @memberof coreproductpb.GetProductAttributeValuesResponse
         * @static
         * @param {coreproductpb.IGetProductAttributeValuesResponse=} [properties] Properties to set
         * @returns {coreproductpb.GetProductAttributeValuesResponse} GetProductAttributeValuesResponse instance
         */
        GetProductAttributeValuesResponse.create = function create(properties) {
            return new GetProductAttributeValuesResponse(properties);
        };

        /**
         * Encodes the specified GetProductAttributeValuesResponse message. Does not implicitly {@link coreproductpb.GetProductAttributeValuesResponse.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.GetProductAttributeValuesResponse
         * @static
         * @param {coreproductpb.IGetProductAttributeValuesResponse} m GetProductAttributeValuesResponse message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetProductAttributeValuesResponse.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.values != null && m.values.length) {
                for (var i = 0; i < m.values.length; ++i)
                    $root.coreproductpb.ProductAttributeValue.encode(m.values[i], w.uint32(10).fork()).ldelim();
            }
            if (m.errors != null && m.errors.length) {
                for (var i = 0; i < m.errors.length; ++i)
                    $root.common.Error.encode(m.errors[i], w.uint32(18).fork()).ldelim();
            }
            if (m.pagination != null && Object.hasOwnProperty.call(m, "pagination"))
                $root.common.Pagination.encode(m.pagination, w.uint32(26).fork()).ldelim();
            return w;
        };

        /**
         * Decodes a GetProductAttributeValuesResponse message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.GetProductAttributeValuesResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.GetProductAttributeValuesResponse} GetProductAttributeValuesResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetProductAttributeValuesResponse.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.GetProductAttributeValuesResponse();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    if (!(m.values && m.values.length))
                        m.values = [];
                    m.values.push($root.coreproductpb.ProductAttributeValue.decode(r, r.uint32()));
                    break;
                case 2:
                    if (!(m.errors && m.errors.length))
                        m.errors = [];
                    m.errors.push($root.common.Error.decode(r, r.uint32()));
                    break;
                case 3:
                    m.pagination = $root.common.Pagination.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return GetProductAttributeValuesResponse;
    })();

    coreproductpb.ProductAttributeValue = (function() {

        /**
         * Properties of a ProductAttributeValue.
         * @memberof coreproductpb
         * @interface IProductAttributeValue
         * @property {string|null} [id] ProductAttributeValue id
         * @property {string|null} [value] ProductAttributeValue value
         * @property {coreproductpb.DataRecordStatus|null} [status] ProductAttributeValue status
         */

        /**
         * Constructs a new ProductAttributeValue.
         * @memberof coreproductpb
         * @classdesc Represents a ProductAttributeValue.
         * @implements IProductAttributeValue
         * @constructor
         * @param {coreproductpb.IProductAttributeValue=} [p] Properties to set
         */
        function ProductAttributeValue(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * ProductAttributeValue id.
         * @member {string} id
         * @memberof coreproductpb.ProductAttributeValue
         * @instance
         */
        ProductAttributeValue.prototype.id = "";

        /**
         * ProductAttributeValue value.
         * @member {string} value
         * @memberof coreproductpb.ProductAttributeValue
         * @instance
         */
        ProductAttributeValue.prototype.value = "";

        /**
         * ProductAttributeValue status.
         * @member {coreproductpb.DataRecordStatus} status
         * @memberof coreproductpb.ProductAttributeValue
         * @instance
         */
        ProductAttributeValue.prototype.status = 0;

        /**
         * Creates a new ProductAttributeValue instance using the specified properties.
         * @function create
         * @memberof coreproductpb.ProductAttributeValue
         * @static
         * @param {coreproductpb.IProductAttributeValue=} [properties] Properties to set
         * @returns {coreproductpb.ProductAttributeValue} ProductAttributeValue instance
         */
        ProductAttributeValue.create = function create(properties) {
            return new ProductAttributeValue(properties);
        };

        /**
         * Encodes the specified ProductAttributeValue message. Does not implicitly {@link coreproductpb.ProductAttributeValue.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.ProductAttributeValue
         * @static
         * @param {coreproductpb.IProductAttributeValue} m ProductAttributeValue message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ProductAttributeValue.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.id != null && Object.hasOwnProperty.call(m, "id"))
                w.uint32(10).string(m.id);
            if (m.value != null && Object.hasOwnProperty.call(m, "value"))
                w.uint32(18).string(m.value);
            if (m.status != null && Object.hasOwnProperty.call(m, "status"))
                w.uint32(24).int32(m.status);
            return w;
        };

        /**
         * Decodes a ProductAttributeValue message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.ProductAttributeValue
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.ProductAttributeValue} ProductAttributeValue
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ProductAttributeValue.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.ProductAttributeValue();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.id = r.string();
                    break;
                case 2:
                    m.value = r.string();
                    break;
                case 3:
                    m.status = r.int32();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return ProductAttributeValue;
    })();

    coreproductpb.GetV2CoveragesRequest = (function() {

        /**
         * Properties of a GetV2CoveragesRequest.
         * @memberof coreproductpb
         * @interface IGetV2CoveragesRequest
         * @property {string|null} [coverageStarID] GetV2CoveragesRequest coverageStarID
         * @property {string|null} [coverageID] GetV2CoveragesRequest coverageID
         * @property {Array.<coreproductpb.V2Status>|null} [status] GetV2CoveragesRequest status
         * @property {common.IPaginationRequest|null} [pagination] GetV2CoveragesRequest pagination
         * @property {coreproductpb.CoverageType|null} [type] GetV2CoveragesRequest type
         * @property {boolean|null} [includeItems] GetV2CoveragesRequest includeItems
         */

        /**
         * Constructs a new GetV2CoveragesRequest.
         * @memberof coreproductpb
         * @classdesc Represents a GetV2CoveragesRequest.
         * @implements IGetV2CoveragesRequest
         * @constructor
         * @param {coreproductpb.IGetV2CoveragesRequest=} [p] Properties to set
         */
        function GetV2CoveragesRequest(p) {
            this.status = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * GetV2CoveragesRequest coverageStarID.
         * @member {string|null|undefined} coverageStarID
         * @memberof coreproductpb.GetV2CoveragesRequest
         * @instance
         */
        GetV2CoveragesRequest.prototype.coverageStarID = null;

        /**
         * GetV2CoveragesRequest coverageID.
         * @member {string|null|undefined} coverageID
         * @memberof coreproductpb.GetV2CoveragesRequest
         * @instance
         */
        GetV2CoveragesRequest.prototype.coverageID = null;

        /**
         * GetV2CoveragesRequest status.
         * @member {Array.<coreproductpb.V2Status>} status
         * @memberof coreproductpb.GetV2CoveragesRequest
         * @instance
         */
        GetV2CoveragesRequest.prototype.status = $util.emptyArray;

        /**
         * GetV2CoveragesRequest pagination.
         * @member {common.IPaginationRequest|null|undefined} pagination
         * @memberof coreproductpb.GetV2CoveragesRequest
         * @instance
         */
        GetV2CoveragesRequest.prototype.pagination = null;

        /**
         * GetV2CoveragesRequest type.
         * @member {coreproductpb.CoverageType} type
         * @memberof coreproductpb.GetV2CoveragesRequest
         * @instance
         */
        GetV2CoveragesRequest.prototype.type = 0;

        /**
         * GetV2CoveragesRequest includeItems.
         * @member {boolean} includeItems
         * @memberof coreproductpb.GetV2CoveragesRequest
         * @instance
         */
        GetV2CoveragesRequest.prototype.includeItems = false;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        /**
         * GetV2CoveragesRequest id.
         * @member {"coverageStarID"|"coverageID"|undefined} id
         * @memberof coreproductpb.GetV2CoveragesRequest
         * @instance
         */
        Object.defineProperty(GetV2CoveragesRequest.prototype, "id", {
            get: $util.oneOfGetter($oneOfFields = ["coverageStarID", "coverageID"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new GetV2CoveragesRequest instance using the specified properties.
         * @function create
         * @memberof coreproductpb.GetV2CoveragesRequest
         * @static
         * @param {coreproductpb.IGetV2CoveragesRequest=} [properties] Properties to set
         * @returns {coreproductpb.GetV2CoveragesRequest} GetV2CoveragesRequest instance
         */
        GetV2CoveragesRequest.create = function create(properties) {
            return new GetV2CoveragesRequest(properties);
        };

        /**
         * Encodes the specified GetV2CoveragesRequest message. Does not implicitly {@link coreproductpb.GetV2CoveragesRequest.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.GetV2CoveragesRequest
         * @static
         * @param {coreproductpb.IGetV2CoveragesRequest} m GetV2CoveragesRequest message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetV2CoveragesRequest.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.coverageStarID != null && Object.hasOwnProperty.call(m, "coverageStarID"))
                w.uint32(10).string(m.coverageStarID);
            if (m.coverageID != null && Object.hasOwnProperty.call(m, "coverageID"))
                w.uint32(18).string(m.coverageID);
            if (m.status != null && m.status.length) {
                w.uint32(26).fork();
                for (var i = 0; i < m.status.length; ++i)
                    w.int32(m.status[i]);
                w.ldelim();
            }
            if (m.pagination != null && Object.hasOwnProperty.call(m, "pagination"))
                $root.common.PaginationRequest.encode(m.pagination, w.uint32(34).fork()).ldelim();
            if (m.type != null && Object.hasOwnProperty.call(m, "type"))
                w.uint32(40).int32(m.type);
            if (m.includeItems != null && Object.hasOwnProperty.call(m, "includeItems"))
                w.uint32(48).bool(m.includeItems);
            return w;
        };

        /**
         * Decodes a GetV2CoveragesRequest message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.GetV2CoveragesRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.GetV2CoveragesRequest} GetV2CoveragesRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetV2CoveragesRequest.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.GetV2CoveragesRequest();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.coverageStarID = r.string();
                    break;
                case 2:
                    m.coverageID = r.string();
                    break;
                case 3:
                    if (!(m.status && m.status.length))
                        m.status = [];
                    if ((t & 7) === 2) {
                        var c2 = r.uint32() + r.pos;
                        while (r.pos < c2)
                            m.status.push(r.int32());
                    } else
                        m.status.push(r.int32());
                    break;
                case 4:
                    m.pagination = $root.common.PaginationRequest.decode(r, r.uint32());
                    break;
                case 5:
                    m.type = r.int32();
                    break;
                case 6:
                    m.includeItems = r.bool();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return GetV2CoveragesRequest;
    })();

    coreproductpb.GetV2CoveragesResponse = (function() {

        /**
         * Properties of a GetV2CoveragesResponse.
         * @memberof coreproductpb
         * @interface IGetV2CoveragesResponse
         * @property {Array.<coreproductpb.IV2Coverage>|null} [coverages] GetV2CoveragesResponse coverages
         * @property {Array.<common.IError>|null} [errors] GetV2CoveragesResponse errors
         * @property {common.IPagination|null} [pagination] GetV2CoveragesResponse pagination
         */

        /**
         * Constructs a new GetV2CoveragesResponse.
         * @memberof coreproductpb
         * @classdesc Represents a GetV2CoveragesResponse.
         * @implements IGetV2CoveragesResponse
         * @constructor
         * @param {coreproductpb.IGetV2CoveragesResponse=} [p] Properties to set
         */
        function GetV2CoveragesResponse(p) {
            this.coverages = [];
            this.errors = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * GetV2CoveragesResponse coverages.
         * @member {Array.<coreproductpb.IV2Coverage>} coverages
         * @memberof coreproductpb.GetV2CoveragesResponse
         * @instance
         */
        GetV2CoveragesResponse.prototype.coverages = $util.emptyArray;

        /**
         * GetV2CoveragesResponse errors.
         * @member {Array.<common.IError>} errors
         * @memberof coreproductpb.GetV2CoveragesResponse
         * @instance
         */
        GetV2CoveragesResponse.prototype.errors = $util.emptyArray;

        /**
         * GetV2CoveragesResponse pagination.
         * @member {common.IPagination|null|undefined} pagination
         * @memberof coreproductpb.GetV2CoveragesResponse
         * @instance
         */
        GetV2CoveragesResponse.prototype.pagination = null;

        /**
         * Creates a new GetV2CoveragesResponse instance using the specified properties.
         * @function create
         * @memberof coreproductpb.GetV2CoveragesResponse
         * @static
         * @param {coreproductpb.IGetV2CoveragesResponse=} [properties] Properties to set
         * @returns {coreproductpb.GetV2CoveragesResponse} GetV2CoveragesResponse instance
         */
        GetV2CoveragesResponse.create = function create(properties) {
            return new GetV2CoveragesResponse(properties);
        };

        /**
         * Encodes the specified GetV2CoveragesResponse message. Does not implicitly {@link coreproductpb.GetV2CoveragesResponse.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.GetV2CoveragesResponse
         * @static
         * @param {coreproductpb.IGetV2CoveragesResponse} m GetV2CoveragesResponse message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetV2CoveragesResponse.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.coverages != null && m.coverages.length) {
                for (var i = 0; i < m.coverages.length; ++i)
                    $root.coreproductpb.V2Coverage.encode(m.coverages[i], w.uint32(10).fork()).ldelim();
            }
            if (m.errors != null && m.errors.length) {
                for (var i = 0; i < m.errors.length; ++i)
                    $root.common.Error.encode(m.errors[i], w.uint32(18).fork()).ldelim();
            }
            if (m.pagination != null && Object.hasOwnProperty.call(m, "pagination"))
                $root.common.Pagination.encode(m.pagination, w.uint32(26).fork()).ldelim();
            return w;
        };

        /**
         * Decodes a GetV2CoveragesResponse message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.GetV2CoveragesResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.GetV2CoveragesResponse} GetV2CoveragesResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetV2CoveragesResponse.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.GetV2CoveragesResponse();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    if (!(m.coverages && m.coverages.length))
                        m.coverages = [];
                    m.coverages.push($root.coreproductpb.V2Coverage.decode(r, r.uint32()));
                    break;
                case 2:
                    if (!(m.errors && m.errors.length))
                        m.errors = [];
                    m.errors.push($root.common.Error.decode(r, r.uint32()));
                    break;
                case 3:
                    m.pagination = $root.common.Pagination.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return GetV2CoveragesResponse;
    })();

    coreproductpb.V2Coverage = (function() {

        /**
         * Properties of a V2Coverage.
         * @memberof coreproductpb
         * @interface IV2Coverage
         * @property {string|null} [coverageID] V2Coverage coverageID
         * @property {string|null} [starCoverageID] V2Coverage starCoverageID
         * @property {string|null} [name] V2Coverage name
         * @property {string|null} [description] V2Coverage description
         * @property {coreproductpb.V2Status|null} [status] V2Coverage status
         * @property {coreproductpb.CoverageType|null} [type] V2Coverage type
         * @property {Array.<string>|null} [tags] V2Coverage tags
         * @property {Array.<coreproductpb.Coverage.ICoverageItem>|null} [items] V2Coverage items
         * @property {google.protobuf.ITimestamp|null} [effectiveDate] V2Coverage effectiveDate
         * @property {google.protobuf.ITimestamp|null} [expirationDate] V2Coverage expirationDate
         */

        /**
         * Constructs a new V2Coverage.
         * @memberof coreproductpb
         * @classdesc Represents a V2Coverage.
         * @implements IV2Coverage
         * @constructor
         * @param {coreproductpb.IV2Coverage=} [p] Properties to set
         */
        function V2Coverage(p) {
            this.tags = [];
            this.items = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * V2Coverage coverageID.
         * @member {string} coverageID
         * @memberof coreproductpb.V2Coverage
         * @instance
         */
        V2Coverage.prototype.coverageID = "";

        /**
         * V2Coverage starCoverageID.
         * @member {string} starCoverageID
         * @memberof coreproductpb.V2Coverage
         * @instance
         */
        V2Coverage.prototype.starCoverageID = "";

        /**
         * V2Coverage name.
         * @member {string} name
         * @memberof coreproductpb.V2Coverage
         * @instance
         */
        V2Coverage.prototype.name = "";

        /**
         * V2Coverage description.
         * @member {string} description
         * @memberof coreproductpb.V2Coverage
         * @instance
         */
        V2Coverage.prototype.description = "";

        /**
         * V2Coverage status.
         * @member {coreproductpb.V2Status} status
         * @memberof coreproductpb.V2Coverage
         * @instance
         */
        V2Coverage.prototype.status = 0;

        /**
         * V2Coverage type.
         * @member {coreproductpb.CoverageType} type
         * @memberof coreproductpb.V2Coverage
         * @instance
         */
        V2Coverage.prototype.type = 0;

        /**
         * V2Coverage tags.
         * @member {Array.<string>} tags
         * @memberof coreproductpb.V2Coverage
         * @instance
         */
        V2Coverage.prototype.tags = $util.emptyArray;

        /**
         * V2Coverage items.
         * @member {Array.<coreproductpb.Coverage.ICoverageItem>} items
         * @memberof coreproductpb.V2Coverage
         * @instance
         */
        V2Coverage.prototype.items = $util.emptyArray;

        /**
         * V2Coverage effectiveDate.
         * @member {google.protobuf.ITimestamp|null|undefined} effectiveDate
         * @memberof coreproductpb.V2Coverage
         * @instance
         */
        V2Coverage.prototype.effectiveDate = null;

        /**
         * V2Coverage expirationDate.
         * @member {google.protobuf.ITimestamp|null|undefined} expirationDate
         * @memberof coreproductpb.V2Coverage
         * @instance
         */
        V2Coverage.prototype.expirationDate = null;

        /**
         * Creates a new V2Coverage instance using the specified properties.
         * @function create
         * @memberof coreproductpb.V2Coverage
         * @static
         * @param {coreproductpb.IV2Coverage=} [properties] Properties to set
         * @returns {coreproductpb.V2Coverage} V2Coverage instance
         */
        V2Coverage.create = function create(properties) {
            return new V2Coverage(properties);
        };

        /**
         * Encodes the specified V2Coverage message. Does not implicitly {@link coreproductpb.V2Coverage.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.V2Coverage
         * @static
         * @param {coreproductpb.IV2Coverage} m V2Coverage message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        V2Coverage.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.coverageID != null && Object.hasOwnProperty.call(m, "coverageID"))
                w.uint32(10).string(m.coverageID);
            if (m.starCoverageID != null && Object.hasOwnProperty.call(m, "starCoverageID"))
                w.uint32(18).string(m.starCoverageID);
            if (m.name != null && Object.hasOwnProperty.call(m, "name"))
                w.uint32(26).string(m.name);
            if (m.description != null && Object.hasOwnProperty.call(m, "description"))
                w.uint32(34).string(m.description);
            if (m.status != null && Object.hasOwnProperty.call(m, "status"))
                w.uint32(40).int32(m.status);
            if (m.type != null && Object.hasOwnProperty.call(m, "type"))
                w.uint32(48).int32(m.type);
            if (m.tags != null && m.tags.length) {
                for (var i = 0; i < m.tags.length; ++i)
                    w.uint32(58).string(m.tags[i]);
            }
            if (m.items != null && m.items.length) {
                for (var i = 0; i < m.items.length; ++i)
                    $root.coreproductpb.Coverage.CoverageItem.encode(m.items[i], w.uint32(66).fork()).ldelim();
            }
            if (m.effectiveDate != null && Object.hasOwnProperty.call(m, "effectiveDate"))
                $root.google.protobuf.Timestamp.encode(m.effectiveDate, w.uint32(74).fork()).ldelim();
            if (m.expirationDate != null && Object.hasOwnProperty.call(m, "expirationDate"))
                $root.google.protobuf.Timestamp.encode(m.expirationDate, w.uint32(82).fork()).ldelim();
            return w;
        };

        /**
         * Decodes a V2Coverage message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.V2Coverage
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.V2Coverage} V2Coverage
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        V2Coverage.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.V2Coverage();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.coverageID = r.string();
                    break;
                case 2:
                    m.starCoverageID = r.string();
                    break;
                case 3:
                    m.name = r.string();
                    break;
                case 4:
                    m.description = r.string();
                    break;
                case 5:
                    m.status = r.int32();
                    break;
                case 6:
                    m.type = r.int32();
                    break;
                case 7:
                    if (!(m.tags && m.tags.length))
                        m.tags = [];
                    m.tags.push(r.string());
                    break;
                case 8:
                    if (!(m.items && m.items.length))
                        m.items = [];
                    m.items.push($root.coreproductpb.Coverage.CoverageItem.decode(r, r.uint32()));
                    break;
                case 9:
                    m.effectiveDate = $root.google.protobuf.Timestamp.decode(r, r.uint32());
                    break;
                case 10:
                    m.expirationDate = $root.google.protobuf.Timestamp.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return V2Coverage;
    })();

    /**
     * ProductTemplateVersionLifeCycleStage enum.
     * @name coreproductpb.ProductTemplateVersionLifeCycleStage
     * @enum {number}
     * @property {number} PTVLCS_UNDEFINED=0 PTVLCS_UNDEFINED value
     * @property {number} PTVLCS_DRAFT=1 PTVLCS_DRAFT value
     * @property {number} PTVLCS_TEST=2 PTVLCS_TEST value
     * @property {number} PTVLCS_EFFECTIVE=3 PTVLCS_EFFECTIVE value
     * @property {number} PTVLCS_SUNSET=4 PTVLCS_SUNSET value
     * @property {number} PTVLCS_EXPIRED=5 PTVLCS_EXPIRED value
     */
    coreproductpb.ProductTemplateVersionLifeCycleStage = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "PTVLCS_UNDEFINED"] = 0;
        values[valuesById[1] = "PTVLCS_DRAFT"] = 1;
        values[valuesById[2] = "PTVLCS_TEST"] = 2;
        values[valuesById[3] = "PTVLCS_EFFECTIVE"] = 3;
        values[valuesById[4] = "PTVLCS_SUNSET"] = 4;
        values[valuesById[5] = "PTVLCS_EXPIRED"] = 5;
        return values;
    })();

    /**
     * ConditionalOperator enum.
     * @name coreproductpb.ConditionalOperator
     * @enum {number}
     * @property {number} CO_UNDEFINED=0 CO_UNDEFINED value
     * @property {number} CO_IS_EQUAL_TO=1 CO_IS_EQUAL_TO value
     * @property {number} CO_IS_NOT_EQUAL_TO=2 CO_IS_NOT_EQUAL_TO value
     * @property {number} CO_IS_IN_LIST=3 CO_IS_IN_LIST value
     * @property {number} CO_IS_NOT_IN_LIST=4 CO_IS_NOT_IN_LIST value
     */
    coreproductpb.ConditionalOperator = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "CO_UNDEFINED"] = 0;
        values[valuesById[1] = "CO_IS_EQUAL_TO"] = 1;
        values[valuesById[2] = "CO_IS_NOT_EQUAL_TO"] = 2;
        values[valuesById[3] = "CO_IS_IN_LIST"] = 3;
        values[valuesById[4] = "CO_IS_NOT_IN_LIST"] = 4;
        return values;
    })();

    /**
     * TimePeriodUnit enum.
     * @name coreproductpb.TimePeriodUnit
     * @enum {number}
     * @property {number} TPU_UNDEFINED=0 TPU_UNDEFINED value
     * @property {number} TPU_DAY=1 TPU_DAY value
     * @property {number} TPU_WEEK=2 TPU_WEEK value
     * @property {number} TPU_MONTH=3 TPU_MONTH value
     * @property {number} TPU_YEAR=4 TPU_YEAR value
     * @property {number} TPU_CORE_PRODUCT_NULL=5 TPU_CORE_PRODUCT_NULL value
     */
    coreproductpb.TimePeriodUnit = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "TPU_UNDEFINED"] = 0;
        values[valuesById[1] = "TPU_DAY"] = 1;
        values[valuesById[2] = "TPU_WEEK"] = 2;
        values[valuesById[3] = "TPU_MONTH"] = 3;
        values[valuesById[4] = "TPU_YEAR"] = 4;
        values[valuesById[5] = "TPU_CORE_PRODUCT_NULL"] = 5;
        return values;
    })();

    /**
     * AreaUnit enum.
     * @name coreproductpb.AreaUnit
     * @enum {number}
     * @property {number} AU_UNDEFINED=0 AU_UNDEFINED value
     * @property {number} AU_SQUARE_FOOT=1 AU_SQUARE_FOOT value
     * @property {number} AU_CORE_PRODUCT_NULL=2 AU_CORE_PRODUCT_NULL value
     */
    coreproductpb.AreaUnit = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "AU_UNDEFINED"] = 0;
        values[valuesById[1] = "AU_SQUARE_FOOT"] = 1;
        values[valuesById[2] = "AU_CORE_PRODUCT_NULL"] = 2;
        return values;
    })();

    /**
     * FeatureMasterDataType enum.
     * @name coreproductpb.FeatureMasterDataType
     * @enum {number}
     * @property {number} FMDT_UNDEFINED=0 FMDT_UNDEFINED value
     * @property {number} FMDT_PRODUCT_MS_COVERAGE=1 FMDT_PRODUCT_MS_COVERAGE value
     * @property {number} FMDT_STAR_COVERAGE=2 FMDT_STAR_COVERAGE value
     * @property {number} FMDT_STAR_ITEM=3 FMDT_STAR_ITEM value
     * @property {number} FMDT_ITEM_MS_ITEM=4 FMDT_ITEM_MS_ITEM value
     * @property {number} FMDT_ITEM_MS_COMPONENT=5 FMDT_ITEM_MS_COMPONENT value
     * @property {number} FMDT_ITEM_MS_MAINTENANCE_SERVICE=6 FMDT_ITEM_MS_MAINTENANCE_SERVICE value
     * @property {number} FMDT_JOB_MS_JOB=7 FMDT_JOB_MS_JOB value
     * @property {number} FMDT_JOB_MS_JOB_LINE_ITEM=8 FMDT_JOB_MS_JOB_LINE_ITEM value
     * @property {number} FMDT_PRODUCT_MS_FEATURE_COVERAGE=9 FMDT_PRODUCT_MS_FEATURE_COVERAGE value
     */
    coreproductpb.FeatureMasterDataType = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "FMDT_UNDEFINED"] = 0;
        values[valuesById[1] = "FMDT_PRODUCT_MS_COVERAGE"] = 1;
        values[valuesById[2] = "FMDT_STAR_COVERAGE"] = 2;
        values[valuesById[3] = "FMDT_STAR_ITEM"] = 3;
        values[valuesById[4] = "FMDT_ITEM_MS_ITEM"] = 4;
        values[valuesById[5] = "FMDT_ITEM_MS_COMPONENT"] = 5;
        values[valuesById[6] = "FMDT_ITEM_MS_MAINTENANCE_SERVICE"] = 6;
        values[valuesById[7] = "FMDT_JOB_MS_JOB"] = 7;
        values[valuesById[8] = "FMDT_JOB_MS_JOB_LINE_ITEM"] = 8;
        values[valuesById[9] = "FMDT_PRODUCT_MS_FEATURE_COVERAGE"] = 9;
        return values;
    })();

    /**
     * PickStrategy enum.
     * @name coreproductpb.PickStrategy
     * @enum {number}
     * @property {number} PS_UNDEFINED=0 PS_UNDEFINED value
     * @property {number} PS_SINGLE_QUANTITY_OF_EACH_OPTION=1 PS_SINGLE_QUANTITY_OF_EACH_OPTION value
     * @property {number} PS_MULTIPLE_QUANTITY_OF_EACH_OPTION=2 PS_MULTIPLE_QUANTITY_OF_EACH_OPTION value
     * @property {number} PS_SINGLE_QUANTITY_OF_EACH_OPTION_TYPE=3 PS_SINGLE_QUANTITY_OF_EACH_OPTION_TYPE value
     */
    coreproductpb.PickStrategy = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "PS_UNDEFINED"] = 0;
        values[valuesById[1] = "PS_SINGLE_QUANTITY_OF_EACH_OPTION"] = 1;
        values[valuesById[2] = "PS_MULTIPLE_QUANTITY_OF_EACH_OPTION"] = 2;
        values[valuesById[3] = "PS_SINGLE_QUANTITY_OF_EACH_OPTION_TYPE"] = 3;
        return values;
    })();

    /**
     * DataRecordStatus enum.
     * @name coreproductpb.DataRecordStatus
     * @enum {number}
     * @property {number} AVS_UNDEFINED=0 AVS_UNDEFINED value
     * @property {number} AVS_ACTIVE=1 AVS_ACTIVE value
     * @property {number} AVS_INACTIVE=2 AVS_INACTIVE value
     * @property {number} AVS_CREATING=3 AVS_CREATING value
     * @property {number} AVS_UPDATING=4 AVS_UPDATING value
     * @property {number} AVS_READY_TO_USE=5 AVS_READY_TO_USE value
     * @property {number} AVS_FAILED=6 AVS_FAILED value
     * @property {number} AVS_CANCELLED=7 AVS_CANCELLED value
     */
    coreproductpb.DataRecordStatus = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "AVS_UNDEFINED"] = 0;
        values[valuesById[1] = "AVS_ACTIVE"] = 1;
        values[valuesById[2] = "AVS_INACTIVE"] = 2;
        values[valuesById[3] = "AVS_CREATING"] = 3;
        values[valuesById[4] = "AVS_UPDATING"] = 4;
        values[valuesById[5] = "AVS_READY_TO_USE"] = 5;
        values[valuesById[6] = "AVS_FAILED"] = 6;
        values[valuesById[7] = "AVS_CANCELLED"] = 7;
        return values;
    })();

    /**
     * DataType enum.
     * @name coreproductpb.DataType
     * @enum {number}
     * @property {number} DT_UNDEFINED=0 DT_UNDEFINED value
     * @property {number} DT_NUMBER=1 DT_NUMBER value
     * @property {number} DT_NUMBER_LIST=2 DT_NUMBER_LIST value
     * @property {number} DT_STRING=3 DT_STRING value
     * @property {number} DT_STRING_LIST=4 DT_STRING_LIST value
     * @property {number} DT_TIME_PERIOD=5 DT_TIME_PERIOD value
     * @property {number} DT_TIME_PERIOD_LIST=6 DT_TIME_PERIOD_LIST value
     * @property {number} DT_TIME_PERIOD_RANGE=7 DT_TIME_PERIOD_RANGE value
     * @property {number} DT_TIME_PERIOD_RANGE_LIST=8 DT_TIME_PERIOD_RANGE_LIST value
     * @property {number} DT_AREA=9 DT_AREA value
     * @property {number} DT_AREA_LIST=10 DT_AREA_LIST value
     * @property {number} DT_AREA_RANGE=11 DT_AREA_RANGE value
     * @property {number} DT_AREA_RANGE_LIST=12 DT_AREA_RANGE_LIST value
     * @property {number} DT_GEOGRAPHY=13 DT_GEOGRAPHY value
     * @property {number} DT_MONEY=14 DT_MONEY value
     * @property {number} DT_MONEY_LIST=15 DT_MONEY_LIST value
     * @property {number} DT_STAR_REMARK_LIST=16 DT_STAR_REMARK_LIST value
     * @property {number} DT_STAR_FULFILLMENT_LIST=17 DT_STAR_FULFILLMENT_LIST value
     * @property {number} DT_DATE_TIMESTAMP=18 DT_DATE_TIMESTAMP value
     * @property {number} DT_DATE_TIMESTAMP_LIST=19 DT_DATE_TIMESTAMP_LIST value
     */
    coreproductpb.DataType = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "DT_UNDEFINED"] = 0;
        values[valuesById[1] = "DT_NUMBER"] = 1;
        values[valuesById[2] = "DT_NUMBER_LIST"] = 2;
        values[valuesById[3] = "DT_STRING"] = 3;
        values[valuesById[4] = "DT_STRING_LIST"] = 4;
        values[valuesById[5] = "DT_TIME_PERIOD"] = 5;
        values[valuesById[6] = "DT_TIME_PERIOD_LIST"] = 6;
        values[valuesById[7] = "DT_TIME_PERIOD_RANGE"] = 7;
        values[valuesById[8] = "DT_TIME_PERIOD_RANGE_LIST"] = 8;
        values[valuesById[9] = "DT_AREA"] = 9;
        values[valuesById[10] = "DT_AREA_LIST"] = 10;
        values[valuesById[11] = "DT_AREA_RANGE"] = 11;
        values[valuesById[12] = "DT_AREA_RANGE_LIST"] = 12;
        values[valuesById[13] = "DT_GEOGRAPHY"] = 13;
        values[valuesById[14] = "DT_MONEY"] = 14;
        values[valuesById[15] = "DT_MONEY_LIST"] = 15;
        values[valuesById[16] = "DT_STAR_REMARK_LIST"] = 16;
        values[valuesById[17] = "DT_STAR_FULFILLMENT_LIST"] = 17;
        values[valuesById[18] = "DT_DATE_TIMESTAMP"] = 18;
        values[valuesById[19] = "DT_DATE_TIMESTAMP_LIST"] = 19;
        return values;
    })();

    /**
     * PublishToStarStatus enum.
     * @name coreproductpb.PublishToStarStatus
     * @enum {number}
     * @property {number} PTS_DIRTY=0 PTS_DIRTY value
     * @property {number} PTS_IN_PROGRESS=1 PTS_IN_PROGRESS value
     * @property {number} PTS_COMPLETED=2 PTS_COMPLETED value
     * @property {number} PTS_FAILED=3 PTS_FAILED value
     * @property {number} PTS_IN_QUEUE=4 PTS_IN_QUEUE value
     */
    coreproductpb.PublishToStarStatus = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "PTS_DIRTY"] = 0;
        values[valuesById[1] = "PTS_IN_PROGRESS"] = 1;
        values[valuesById[2] = "PTS_COMPLETED"] = 2;
        values[valuesById[3] = "PTS_FAILED"] = 3;
        values[valuesById[4] = "PTS_IN_QUEUE"] = 4;
        return values;
    })();

    /**
     * ExportProductTemplateStatus enum.
     * @name coreproductpb.ExportProductTemplateStatus
     * @enum {number}
     * @property {number} EPT_UNDEFINED=0 EPT_UNDEFINED value
     * @property {number} EPT_EXPORTING=1 EPT_EXPORTING value
     * @property {number} EPT_COMPLETED=2 EPT_COMPLETED value
     * @property {number} EPT_FAILED=3 EPT_FAILED value
     */
    coreproductpb.ExportProductTemplateStatus = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "EPT_UNDEFINED"] = 0;
        values[valuesById[1] = "EPT_EXPORTING"] = 1;
        values[valuesById[2] = "EPT_COMPLETED"] = 2;
        values[valuesById[3] = "EPT_FAILED"] = 3;
        return values;
    })();

    /**
     * ImportProductTemplateStatus enum.
     * @name coreproductpb.ImportProductTemplateStatus
     * @enum {number}
     * @property {number} IPT_UNDEFINED=0 IPT_UNDEFINED value
     * @property {number} IPT_IN_QUEUE=1 IPT_IN_QUEUE value
     * @property {number} IPT_EXECUTING=2 IPT_EXECUTING value
     * @property {number} IPT_EXECUTED=3 IPT_EXECUTED value
     * @property {number} IPT_FAILED=4 IPT_FAILED value
     */
    coreproductpb.ImportProductTemplateStatus = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "IPT_UNDEFINED"] = 0;
        values[valuesById[1] = "IPT_IN_QUEUE"] = 1;
        values[valuesById[2] = "IPT_EXECUTING"] = 2;
        values[valuesById[3] = "IPT_EXECUTED"] = 3;
        values[valuesById[4] = "IPT_FAILED"] = 4;
        return values;
    })();

    /**
     * ScheduledLifecycleStageStatus enum.
     * @name coreproductpb.ScheduledLifecycleStageStatus
     * @enum {number}
     * @property {number} SLSS_UNDEFINED=0 SLSS_UNDEFINED value
     * @property {number} SLSS_SCHEDULED=1 SLSS_SCHEDULED value
     * @property {number} SLSS_CANCELLED=2 SLSS_CANCELLED value
     */
    coreproductpb.ScheduledLifecycleStageStatus = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "SLSS_UNDEFINED"] = 0;
        values[valuesById[1] = "SLSS_SCHEDULED"] = 1;
        values[valuesById[2] = "SLSS_CANCELLED"] = 2;
        return values;
    })();

    /**
     * CoverageType enum.
     * @name coreproductpb.CoverageType
     * @enum {number}
     * @property {number} CT_UNDEFINED=0 CT_UNDEFINED value
     * @property {number} CT_COVERAGE=1 CT_COVERAGE value
     * @property {number} CT_FEATURE_COVERAGE=2 CT_FEATURE_COVERAGE value
     * @property {number} CT_STAR_COVERAGE=3 CT_STAR_COVERAGE value
     */
    coreproductpb.CoverageType = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "CT_UNDEFINED"] = 0;
        values[valuesById[1] = "CT_COVERAGE"] = 1;
        values[valuesById[2] = "CT_FEATURE_COVERAGE"] = 2;
        values[valuesById[3] = "CT_STAR_COVERAGE"] = 3;
        return values;
    })();

    coreproductpb.StateIncludeExclude = (function() {

        /**
         * Properties of a StateIncludeExclude.
         * @memberof coreproductpb
         * @interface IStateIncludeExclude
         * @property {Array.<common.USStateAlphaCode>|null} [includes] StateIncludeExclude includes
         * @property {Array.<common.USStateAlphaCode>|null} [excludes] StateIncludeExclude excludes
         */

        /**
         * Constructs a new StateIncludeExclude.
         * @memberof coreproductpb
         * @classdesc Represents a StateIncludeExclude.
         * @implements IStateIncludeExclude
         * @constructor
         * @param {coreproductpb.IStateIncludeExclude=} [p] Properties to set
         */
        function StateIncludeExclude(p) {
            this.includes = [];
            this.excludes = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * StateIncludeExclude includes.
         * @member {Array.<common.USStateAlphaCode>} includes
         * @memberof coreproductpb.StateIncludeExclude
         * @instance
         */
        StateIncludeExclude.prototype.includes = $util.emptyArray;

        /**
         * StateIncludeExclude excludes.
         * @member {Array.<common.USStateAlphaCode>} excludes
         * @memberof coreproductpb.StateIncludeExclude
         * @instance
         */
        StateIncludeExclude.prototype.excludes = $util.emptyArray;

        /**
         * Creates a new StateIncludeExclude instance using the specified properties.
         * @function create
         * @memberof coreproductpb.StateIncludeExclude
         * @static
         * @param {coreproductpb.IStateIncludeExclude=} [properties] Properties to set
         * @returns {coreproductpb.StateIncludeExclude} StateIncludeExclude instance
         */
        StateIncludeExclude.create = function create(properties) {
            return new StateIncludeExclude(properties);
        };

        /**
         * Encodes the specified StateIncludeExclude message. Does not implicitly {@link coreproductpb.StateIncludeExclude.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.StateIncludeExclude
         * @static
         * @param {coreproductpb.IStateIncludeExclude} m StateIncludeExclude message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        StateIncludeExclude.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.includes != null && m.includes.length) {
                w.uint32(10).fork();
                for (var i = 0; i < m.includes.length; ++i)
                    w.int32(m.includes[i]);
                w.ldelim();
            }
            if (m.excludes != null && m.excludes.length) {
                w.uint32(18).fork();
                for (var i = 0; i < m.excludes.length; ++i)
                    w.int32(m.excludes[i]);
                w.ldelim();
            }
            return w;
        };

        /**
         * Decodes a StateIncludeExclude message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.StateIncludeExclude
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.StateIncludeExclude} StateIncludeExclude
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        StateIncludeExclude.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.StateIncludeExclude();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    if (!(m.includes && m.includes.length))
                        m.includes = [];
                    if ((t & 7) === 2) {
                        var c2 = r.uint32() + r.pos;
                        while (r.pos < c2)
                            m.includes.push(r.int32());
                    } else
                        m.includes.push(r.int32());
                    break;
                case 2:
                    if (!(m.excludes && m.excludes.length))
                        m.excludes = [];
                    if ((t & 7) === 2) {
                        var c2 = r.uint32() + r.pos;
                        while (r.pos < c2)
                            m.excludes.push(r.int32());
                    } else
                        m.excludes.push(r.int32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return StateIncludeExclude;
    })();

    coreproductpb.ZipCodeIncludeExclude = (function() {

        /**
         * Properties of a ZipCodeIncludeExclude.
         * @memberof coreproductpb
         * @interface IZipCodeIncludeExclude
         * @property {Array.<string>|null} [includes] ZipCodeIncludeExclude includes
         * @property {Array.<string>|null} [excludes] ZipCodeIncludeExclude excludes
         */

        /**
         * Constructs a new ZipCodeIncludeExclude.
         * @memberof coreproductpb
         * @classdesc Represents a ZipCodeIncludeExclude.
         * @implements IZipCodeIncludeExclude
         * @constructor
         * @param {coreproductpb.IZipCodeIncludeExclude=} [p] Properties to set
         */
        function ZipCodeIncludeExclude(p) {
            this.includes = [];
            this.excludes = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * ZipCodeIncludeExclude includes.
         * @member {Array.<string>} includes
         * @memberof coreproductpb.ZipCodeIncludeExclude
         * @instance
         */
        ZipCodeIncludeExclude.prototype.includes = $util.emptyArray;

        /**
         * ZipCodeIncludeExclude excludes.
         * @member {Array.<string>} excludes
         * @memberof coreproductpb.ZipCodeIncludeExclude
         * @instance
         */
        ZipCodeIncludeExclude.prototype.excludes = $util.emptyArray;

        /**
         * Creates a new ZipCodeIncludeExclude instance using the specified properties.
         * @function create
         * @memberof coreproductpb.ZipCodeIncludeExclude
         * @static
         * @param {coreproductpb.IZipCodeIncludeExclude=} [properties] Properties to set
         * @returns {coreproductpb.ZipCodeIncludeExclude} ZipCodeIncludeExclude instance
         */
        ZipCodeIncludeExclude.create = function create(properties) {
            return new ZipCodeIncludeExclude(properties);
        };

        /**
         * Encodes the specified ZipCodeIncludeExclude message. Does not implicitly {@link coreproductpb.ZipCodeIncludeExclude.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.ZipCodeIncludeExclude
         * @static
         * @param {coreproductpb.IZipCodeIncludeExclude} m ZipCodeIncludeExclude message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ZipCodeIncludeExclude.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.includes != null && m.includes.length) {
                for (var i = 0; i < m.includes.length; ++i)
                    w.uint32(10).string(m.includes[i]);
            }
            if (m.excludes != null && m.excludes.length) {
                for (var i = 0; i < m.excludes.length; ++i)
                    w.uint32(18).string(m.excludes[i]);
            }
            return w;
        };

        /**
         * Decodes a ZipCodeIncludeExclude message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.ZipCodeIncludeExclude
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.ZipCodeIncludeExclude} ZipCodeIncludeExclude
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ZipCodeIncludeExclude.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.ZipCodeIncludeExclude();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    if (!(m.includes && m.includes.length))
                        m.includes = [];
                    m.includes.push(r.string());
                    break;
                case 2:
                    if (!(m.excludes && m.excludes.length))
                        m.excludes = [];
                    m.excludes.push(r.string());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return ZipCodeIncludeExclude;
    })();

    coreproductpb.TypedValue = (function() {

        /**
         * Properties of a TypedValue.
         * @memberof coreproductpb
         * @interface ITypedValue
         * @property {number|null} [numberValue] TypedValue numberValue
         * @property {coreproductpb.TypedValue.INumberList|null} [numberList] TypedValue numberList
         * @property {string|null} [stringValue] TypedValue stringValue
         * @property {coreproductpb.TypedValue.IStringList|null} [stringList] TypedValue stringList
         * @property {coreproductpb.TypedValue.ITimePeriod|null} [timePeriodValue] TypedValue timePeriodValue
         * @property {coreproductpb.TypedValue.ITimePeriodList|null} [timePeriodList] TypedValue timePeriodList
         * @property {coreproductpb.TypedValue.ITimePeriodRange|null} [timePeriodRange] TypedValue timePeriodRange
         * @property {coreproductpb.TypedValue.ITimePeriodRangeList|null} [timePeriodRangeList] TypedValue timePeriodRangeList
         * @property {coreproductpb.TypedValue.IArea|null} [areaValue] TypedValue areaValue
         * @property {coreproductpb.TypedValue.IAreaList|null} [areaList] TypedValue areaList
         * @property {coreproductpb.TypedValue.IAreaRange|null} [areaRange] TypedValue areaRange
         * @property {coreproductpb.TypedValue.IAreaRangeList|null} [areaRangeList] TypedValue areaRangeList
         * @property {coreproductpb.TypedValue.IGeography|null} [geographyValue] TypedValue geographyValue
         * @property {common.IMoney|null} [money] TypedValue money
         * @property {coreproductpb.TypedValue.IMoneyList|null} [moneyList] TypedValue moneyList
         * @property {coreproductpb.TypedValue.IStarRemarkList|null} [starRemarkList] TypedValue starRemarkList
         * @property {coreproductpb.TypedValue.IStarFulfillmentList|null} [starFulfillmentList] TypedValue starFulfillmentList
         * @property {google.protobuf.ITimestamp|null} [dateTimestampValue] TypedValue dateTimestampValue
         * @property {coreproductpb.TypedValue.IDateTimestampList|null} [dateTimestampList] TypedValue dateTimestampList
         */

        /**
         * Constructs a new TypedValue.
         * @memberof coreproductpb
         * @classdesc Represents a TypedValue.
         * @implements ITypedValue
         * @constructor
         * @param {coreproductpb.ITypedValue=} [p] Properties to set
         */
        function TypedValue(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * TypedValue numberValue.
         * @member {number|null|undefined} numberValue
         * @memberof coreproductpb.TypedValue
         * @instance
         */
        TypedValue.prototype.numberValue = null;

        /**
         * TypedValue numberList.
         * @member {coreproductpb.TypedValue.INumberList|null|undefined} numberList
         * @memberof coreproductpb.TypedValue
         * @instance
         */
        TypedValue.prototype.numberList = null;

        /**
         * TypedValue stringValue.
         * @member {string|null|undefined} stringValue
         * @memberof coreproductpb.TypedValue
         * @instance
         */
        TypedValue.prototype.stringValue = null;

        /**
         * TypedValue stringList.
         * @member {coreproductpb.TypedValue.IStringList|null|undefined} stringList
         * @memberof coreproductpb.TypedValue
         * @instance
         */
        TypedValue.prototype.stringList = null;

        /**
         * TypedValue timePeriodValue.
         * @member {coreproductpb.TypedValue.ITimePeriod|null|undefined} timePeriodValue
         * @memberof coreproductpb.TypedValue
         * @instance
         */
        TypedValue.prototype.timePeriodValue = null;

        /**
         * TypedValue timePeriodList.
         * @member {coreproductpb.TypedValue.ITimePeriodList|null|undefined} timePeriodList
         * @memberof coreproductpb.TypedValue
         * @instance
         */
        TypedValue.prototype.timePeriodList = null;

        /**
         * TypedValue timePeriodRange.
         * @member {coreproductpb.TypedValue.ITimePeriodRange|null|undefined} timePeriodRange
         * @memberof coreproductpb.TypedValue
         * @instance
         */
        TypedValue.prototype.timePeriodRange = null;

        /**
         * TypedValue timePeriodRangeList.
         * @member {coreproductpb.TypedValue.ITimePeriodRangeList|null|undefined} timePeriodRangeList
         * @memberof coreproductpb.TypedValue
         * @instance
         */
        TypedValue.prototype.timePeriodRangeList = null;

        /**
         * TypedValue areaValue.
         * @member {coreproductpb.TypedValue.IArea|null|undefined} areaValue
         * @memberof coreproductpb.TypedValue
         * @instance
         */
        TypedValue.prototype.areaValue = null;

        /**
         * TypedValue areaList.
         * @member {coreproductpb.TypedValue.IAreaList|null|undefined} areaList
         * @memberof coreproductpb.TypedValue
         * @instance
         */
        TypedValue.prototype.areaList = null;

        /**
         * TypedValue areaRange.
         * @member {coreproductpb.TypedValue.IAreaRange|null|undefined} areaRange
         * @memberof coreproductpb.TypedValue
         * @instance
         */
        TypedValue.prototype.areaRange = null;

        /**
         * TypedValue areaRangeList.
         * @member {coreproductpb.TypedValue.IAreaRangeList|null|undefined} areaRangeList
         * @memberof coreproductpb.TypedValue
         * @instance
         */
        TypedValue.prototype.areaRangeList = null;

        /**
         * TypedValue geographyValue.
         * @member {coreproductpb.TypedValue.IGeography|null|undefined} geographyValue
         * @memberof coreproductpb.TypedValue
         * @instance
         */
        TypedValue.prototype.geographyValue = null;

        /**
         * TypedValue money.
         * @member {common.IMoney|null|undefined} money
         * @memberof coreproductpb.TypedValue
         * @instance
         */
        TypedValue.prototype.money = null;

        /**
         * TypedValue moneyList.
         * @member {coreproductpb.TypedValue.IMoneyList|null|undefined} moneyList
         * @memberof coreproductpb.TypedValue
         * @instance
         */
        TypedValue.prototype.moneyList = null;

        /**
         * TypedValue starRemarkList.
         * @member {coreproductpb.TypedValue.IStarRemarkList|null|undefined} starRemarkList
         * @memberof coreproductpb.TypedValue
         * @instance
         */
        TypedValue.prototype.starRemarkList = null;

        /**
         * TypedValue starFulfillmentList.
         * @member {coreproductpb.TypedValue.IStarFulfillmentList|null|undefined} starFulfillmentList
         * @memberof coreproductpb.TypedValue
         * @instance
         */
        TypedValue.prototype.starFulfillmentList = null;

        /**
         * TypedValue dateTimestampValue.
         * @member {google.protobuf.ITimestamp|null|undefined} dateTimestampValue
         * @memberof coreproductpb.TypedValue
         * @instance
         */
        TypedValue.prototype.dateTimestampValue = null;

        /**
         * TypedValue dateTimestampList.
         * @member {coreproductpb.TypedValue.IDateTimestampList|null|undefined} dateTimestampList
         * @memberof coreproductpb.TypedValue
         * @instance
         */
        TypedValue.prototype.dateTimestampList = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        /**
         * TypedValue typedValue.
         * @member {"numberValue"|"numberList"|"stringValue"|"stringList"|"timePeriodValue"|"timePeriodList"|"timePeriodRange"|"timePeriodRangeList"|"areaValue"|"areaList"|"areaRange"|"areaRangeList"|"geographyValue"|"money"|"moneyList"|"starRemarkList"|"starFulfillmentList"|"dateTimestampValue"|"dateTimestampList"|undefined} typedValue
         * @memberof coreproductpb.TypedValue
         * @instance
         */
        Object.defineProperty(TypedValue.prototype, "typedValue", {
            get: $util.oneOfGetter($oneOfFields = ["numberValue", "numberList", "stringValue", "stringList", "timePeriodValue", "timePeriodList", "timePeriodRange", "timePeriodRangeList", "areaValue", "areaList", "areaRange", "areaRangeList", "geographyValue", "money", "moneyList", "starRemarkList", "starFulfillmentList", "dateTimestampValue", "dateTimestampList"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new TypedValue instance using the specified properties.
         * @function create
         * @memberof coreproductpb.TypedValue
         * @static
         * @param {coreproductpb.ITypedValue=} [properties] Properties to set
         * @returns {coreproductpb.TypedValue} TypedValue instance
         */
        TypedValue.create = function create(properties) {
            return new TypedValue(properties);
        };

        /**
         * Encodes the specified TypedValue message. Does not implicitly {@link coreproductpb.TypedValue.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.TypedValue
         * @static
         * @param {coreproductpb.ITypedValue} m TypedValue message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        TypedValue.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.numberValue != null && Object.hasOwnProperty.call(m, "numberValue"))
                w.uint32(8).int32(m.numberValue);
            if (m.numberList != null && Object.hasOwnProperty.call(m, "numberList"))
                $root.coreproductpb.TypedValue.NumberList.encode(m.numberList, w.uint32(18).fork()).ldelim();
            if (m.stringValue != null && Object.hasOwnProperty.call(m, "stringValue"))
                w.uint32(26).string(m.stringValue);
            if (m.stringList != null && Object.hasOwnProperty.call(m, "stringList"))
                $root.coreproductpb.TypedValue.StringList.encode(m.stringList, w.uint32(34).fork()).ldelim();
            if (m.timePeriodValue != null && Object.hasOwnProperty.call(m, "timePeriodValue"))
                $root.coreproductpb.TypedValue.TimePeriod.encode(m.timePeriodValue, w.uint32(42).fork()).ldelim();
            if (m.timePeriodList != null && Object.hasOwnProperty.call(m, "timePeriodList"))
                $root.coreproductpb.TypedValue.TimePeriodList.encode(m.timePeriodList, w.uint32(50).fork()).ldelim();
            if (m.timePeriodRange != null && Object.hasOwnProperty.call(m, "timePeriodRange"))
                $root.coreproductpb.TypedValue.TimePeriodRange.encode(m.timePeriodRange, w.uint32(58).fork()).ldelim();
            if (m.timePeriodRangeList != null && Object.hasOwnProperty.call(m, "timePeriodRangeList"))
                $root.coreproductpb.TypedValue.TimePeriodRangeList.encode(m.timePeriodRangeList, w.uint32(66).fork()).ldelim();
            if (m.areaValue != null && Object.hasOwnProperty.call(m, "areaValue"))
                $root.coreproductpb.TypedValue.Area.encode(m.areaValue, w.uint32(74).fork()).ldelim();
            if (m.areaList != null && Object.hasOwnProperty.call(m, "areaList"))
                $root.coreproductpb.TypedValue.AreaList.encode(m.areaList, w.uint32(82).fork()).ldelim();
            if (m.areaRange != null && Object.hasOwnProperty.call(m, "areaRange"))
                $root.coreproductpb.TypedValue.AreaRange.encode(m.areaRange, w.uint32(90).fork()).ldelim();
            if (m.areaRangeList != null && Object.hasOwnProperty.call(m, "areaRangeList"))
                $root.coreproductpb.TypedValue.AreaRangeList.encode(m.areaRangeList, w.uint32(98).fork()).ldelim();
            if (m.geographyValue != null && Object.hasOwnProperty.call(m, "geographyValue"))
                $root.coreproductpb.TypedValue.Geography.encode(m.geographyValue, w.uint32(106).fork()).ldelim();
            if (m.money != null && Object.hasOwnProperty.call(m, "money"))
                $root.common.Money.encode(m.money, w.uint32(114).fork()).ldelim();
            if (m.moneyList != null && Object.hasOwnProperty.call(m, "moneyList"))
                $root.coreproductpb.TypedValue.MoneyList.encode(m.moneyList, w.uint32(122).fork()).ldelim();
            if (m.starRemarkList != null && Object.hasOwnProperty.call(m, "starRemarkList"))
                $root.coreproductpb.TypedValue.StarRemarkList.encode(m.starRemarkList, w.uint32(130).fork()).ldelim();
            if (m.starFulfillmentList != null && Object.hasOwnProperty.call(m, "starFulfillmentList"))
                $root.coreproductpb.TypedValue.StarFulfillmentList.encode(m.starFulfillmentList, w.uint32(138).fork()).ldelim();
            if (m.dateTimestampValue != null && Object.hasOwnProperty.call(m, "dateTimestampValue"))
                $root.google.protobuf.Timestamp.encode(m.dateTimestampValue, w.uint32(146).fork()).ldelim();
            if (m.dateTimestampList != null && Object.hasOwnProperty.call(m, "dateTimestampList"))
                $root.coreproductpb.TypedValue.DateTimestampList.encode(m.dateTimestampList, w.uint32(154).fork()).ldelim();
            return w;
        };

        /**
         * Decodes a TypedValue message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.TypedValue
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.TypedValue} TypedValue
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        TypedValue.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.TypedValue();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.numberValue = r.int32();
                    break;
                case 2:
                    m.numberList = $root.coreproductpb.TypedValue.NumberList.decode(r, r.uint32());
                    break;
                case 3:
                    m.stringValue = r.string();
                    break;
                case 4:
                    m.stringList = $root.coreproductpb.TypedValue.StringList.decode(r, r.uint32());
                    break;
                case 5:
                    m.timePeriodValue = $root.coreproductpb.TypedValue.TimePeriod.decode(r, r.uint32());
                    break;
                case 6:
                    m.timePeriodList = $root.coreproductpb.TypedValue.TimePeriodList.decode(r, r.uint32());
                    break;
                case 7:
                    m.timePeriodRange = $root.coreproductpb.TypedValue.TimePeriodRange.decode(r, r.uint32());
                    break;
                case 8:
                    m.timePeriodRangeList = $root.coreproductpb.TypedValue.TimePeriodRangeList.decode(r, r.uint32());
                    break;
                case 9:
                    m.areaValue = $root.coreproductpb.TypedValue.Area.decode(r, r.uint32());
                    break;
                case 10:
                    m.areaList = $root.coreproductpb.TypedValue.AreaList.decode(r, r.uint32());
                    break;
                case 11:
                    m.areaRange = $root.coreproductpb.TypedValue.AreaRange.decode(r, r.uint32());
                    break;
                case 12:
                    m.areaRangeList = $root.coreproductpb.TypedValue.AreaRangeList.decode(r, r.uint32());
                    break;
                case 13:
                    m.geographyValue = $root.coreproductpb.TypedValue.Geography.decode(r, r.uint32());
                    break;
                case 14:
                    m.money = $root.common.Money.decode(r, r.uint32());
                    break;
                case 15:
                    m.moneyList = $root.coreproductpb.TypedValue.MoneyList.decode(r, r.uint32());
                    break;
                case 16:
                    m.starRemarkList = $root.coreproductpb.TypedValue.StarRemarkList.decode(r, r.uint32());
                    break;
                case 17:
                    m.starFulfillmentList = $root.coreproductpb.TypedValue.StarFulfillmentList.decode(r, r.uint32());
                    break;
                case 18:
                    m.dateTimestampValue = $root.google.protobuf.Timestamp.decode(r, r.uint32());
                    break;
                case 19:
                    m.dateTimestampList = $root.coreproductpb.TypedValue.DateTimestampList.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        TypedValue.NumberList = (function() {

            /**
             * Properties of a NumberList.
             * @memberof coreproductpb.TypedValue
             * @interface INumberList
             * @property {Array.<number>|null} [list] NumberList list
             */

            /**
             * Constructs a new NumberList.
             * @memberof coreproductpb.TypedValue
             * @classdesc Represents a NumberList.
             * @implements INumberList
             * @constructor
             * @param {coreproductpb.TypedValue.INumberList=} [p] Properties to set
             */
            function NumberList(p) {
                this.list = [];
                if (p)
                    for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                        if (p[ks[i]] != null)
                            this[ks[i]] = p[ks[i]];
            }

            /**
             * NumberList list.
             * @member {Array.<number>} list
             * @memberof coreproductpb.TypedValue.NumberList
             * @instance
             */
            NumberList.prototype.list = $util.emptyArray;

            /**
             * Creates a new NumberList instance using the specified properties.
             * @function create
             * @memberof coreproductpb.TypedValue.NumberList
             * @static
             * @param {coreproductpb.TypedValue.INumberList=} [properties] Properties to set
             * @returns {coreproductpb.TypedValue.NumberList} NumberList instance
             */
            NumberList.create = function create(properties) {
                return new NumberList(properties);
            };

            /**
             * Encodes the specified NumberList message. Does not implicitly {@link coreproductpb.TypedValue.NumberList.verify|verify} messages.
             * @function encode
             * @memberof coreproductpb.TypedValue.NumberList
             * @static
             * @param {coreproductpb.TypedValue.INumberList} m NumberList message or plain object to encode
             * @param {$protobuf.Writer} [w] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            NumberList.encode = function encode(m, w) {
                if (!w)
                    w = $Writer.create();
                if (m.list != null && m.list.length) {
                    w.uint32(10).fork();
                    for (var i = 0; i < m.list.length; ++i)
                        w.int32(m.list[i]);
                    w.ldelim();
                }
                return w;
            };

            /**
             * Decodes a NumberList message from the specified reader or buffer.
             * @function decode
             * @memberof coreproductpb.TypedValue.NumberList
             * @static
             * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
             * @param {number} [l] Message length if known beforehand
             * @returns {coreproductpb.TypedValue.NumberList} NumberList
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            NumberList.decode = function decode(r, l) {
                if (!(r instanceof $Reader))
                    r = $Reader.create(r);
                var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.TypedValue.NumberList();
                while (r.pos < c) {
                    var t = r.uint32();
                    switch (t >>> 3) {
                    case 1:
                        if (!(m.list && m.list.length))
                            m.list = [];
                        if ((t & 7) === 2) {
                            var c2 = r.uint32() + r.pos;
                            while (r.pos < c2)
                                m.list.push(r.int32());
                        } else
                            m.list.push(r.int32());
                        break;
                    default:
                        r.skipType(t & 7);
                        break;
                    }
                }
                return m;
            };

            return NumberList;
        })();

        TypedValue.StringList = (function() {

            /**
             * Properties of a StringList.
             * @memberof coreproductpb.TypedValue
             * @interface IStringList
             * @property {Array.<string>|null} [list] StringList list
             */

            /**
             * Constructs a new StringList.
             * @memberof coreproductpb.TypedValue
             * @classdesc Represents a StringList.
             * @implements IStringList
             * @constructor
             * @param {coreproductpb.TypedValue.IStringList=} [p] Properties to set
             */
            function StringList(p) {
                this.list = [];
                if (p)
                    for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                        if (p[ks[i]] != null)
                            this[ks[i]] = p[ks[i]];
            }

            /**
             * StringList list.
             * @member {Array.<string>} list
             * @memberof coreproductpb.TypedValue.StringList
             * @instance
             */
            StringList.prototype.list = $util.emptyArray;

            /**
             * Creates a new StringList instance using the specified properties.
             * @function create
             * @memberof coreproductpb.TypedValue.StringList
             * @static
             * @param {coreproductpb.TypedValue.IStringList=} [properties] Properties to set
             * @returns {coreproductpb.TypedValue.StringList} StringList instance
             */
            StringList.create = function create(properties) {
                return new StringList(properties);
            };

            /**
             * Encodes the specified StringList message. Does not implicitly {@link coreproductpb.TypedValue.StringList.verify|verify} messages.
             * @function encode
             * @memberof coreproductpb.TypedValue.StringList
             * @static
             * @param {coreproductpb.TypedValue.IStringList} m StringList message or plain object to encode
             * @param {$protobuf.Writer} [w] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            StringList.encode = function encode(m, w) {
                if (!w)
                    w = $Writer.create();
                if (m.list != null && m.list.length) {
                    for (var i = 0; i < m.list.length; ++i)
                        w.uint32(10).string(m.list[i]);
                }
                return w;
            };

            /**
             * Decodes a StringList message from the specified reader or buffer.
             * @function decode
             * @memberof coreproductpb.TypedValue.StringList
             * @static
             * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
             * @param {number} [l] Message length if known beforehand
             * @returns {coreproductpb.TypedValue.StringList} StringList
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            StringList.decode = function decode(r, l) {
                if (!(r instanceof $Reader))
                    r = $Reader.create(r);
                var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.TypedValue.StringList();
                while (r.pos < c) {
                    var t = r.uint32();
                    switch (t >>> 3) {
                    case 1:
                        if (!(m.list && m.list.length))
                            m.list = [];
                        m.list.push(r.string());
                        break;
                    default:
                        r.skipType(t & 7);
                        break;
                    }
                }
                return m;
            };

            return StringList;
        })();

        TypedValue.TimePeriod = (function() {

            /**
             * Properties of a TimePeriod.
             * @memberof coreproductpb.TypedValue
             * @interface ITimePeriod
             * @property {number|null} [value] TimePeriod value
             * @property {coreproductpb.TimePeriodUnit|null} [unit] TimePeriod unit
             */

            /**
             * Constructs a new TimePeriod.
             * @memberof coreproductpb.TypedValue
             * @classdesc Represents a TimePeriod.
             * @implements ITimePeriod
             * @constructor
             * @param {coreproductpb.TypedValue.ITimePeriod=} [p] Properties to set
             */
            function TimePeriod(p) {
                if (p)
                    for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                        if (p[ks[i]] != null)
                            this[ks[i]] = p[ks[i]];
            }

            /**
             * TimePeriod value.
             * @member {number} value
             * @memberof coreproductpb.TypedValue.TimePeriod
             * @instance
             */
            TimePeriod.prototype.value = 0;

            /**
             * TimePeriod unit.
             * @member {coreproductpb.TimePeriodUnit} unit
             * @memberof coreproductpb.TypedValue.TimePeriod
             * @instance
             */
            TimePeriod.prototype.unit = 0;

            /**
             * Creates a new TimePeriod instance using the specified properties.
             * @function create
             * @memberof coreproductpb.TypedValue.TimePeriod
             * @static
             * @param {coreproductpb.TypedValue.ITimePeriod=} [properties] Properties to set
             * @returns {coreproductpb.TypedValue.TimePeriod} TimePeriod instance
             */
            TimePeriod.create = function create(properties) {
                return new TimePeriod(properties);
            };

            /**
             * Encodes the specified TimePeriod message. Does not implicitly {@link coreproductpb.TypedValue.TimePeriod.verify|verify} messages.
             * @function encode
             * @memberof coreproductpb.TypedValue.TimePeriod
             * @static
             * @param {coreproductpb.TypedValue.ITimePeriod} m TimePeriod message or plain object to encode
             * @param {$protobuf.Writer} [w] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            TimePeriod.encode = function encode(m, w) {
                if (!w)
                    w = $Writer.create();
                if (m.value != null && Object.hasOwnProperty.call(m, "value"))
                    w.uint32(8).int32(m.value);
                if (m.unit != null && Object.hasOwnProperty.call(m, "unit"))
                    w.uint32(16).int32(m.unit);
                return w;
            };

            /**
             * Decodes a TimePeriod message from the specified reader or buffer.
             * @function decode
             * @memberof coreproductpb.TypedValue.TimePeriod
             * @static
             * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
             * @param {number} [l] Message length if known beforehand
             * @returns {coreproductpb.TypedValue.TimePeriod} TimePeriod
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            TimePeriod.decode = function decode(r, l) {
                if (!(r instanceof $Reader))
                    r = $Reader.create(r);
                var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.TypedValue.TimePeriod();
                while (r.pos < c) {
                    var t = r.uint32();
                    switch (t >>> 3) {
                    case 1:
                        m.value = r.int32();
                        break;
                    case 2:
                        m.unit = r.int32();
                        break;
                    default:
                        r.skipType(t & 7);
                        break;
                    }
                }
                return m;
            };

            return TimePeriod;
        })();

        TypedValue.TimePeriodList = (function() {

            /**
             * Properties of a TimePeriodList.
             * @memberof coreproductpb.TypedValue
             * @interface ITimePeriodList
             * @property {Array.<coreproductpb.TypedValue.ITimePeriod>|null} [list] TimePeriodList list
             */

            /**
             * Constructs a new TimePeriodList.
             * @memberof coreproductpb.TypedValue
             * @classdesc Represents a TimePeriodList.
             * @implements ITimePeriodList
             * @constructor
             * @param {coreproductpb.TypedValue.ITimePeriodList=} [p] Properties to set
             */
            function TimePeriodList(p) {
                this.list = [];
                if (p)
                    for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                        if (p[ks[i]] != null)
                            this[ks[i]] = p[ks[i]];
            }

            /**
             * TimePeriodList list.
             * @member {Array.<coreproductpb.TypedValue.ITimePeriod>} list
             * @memberof coreproductpb.TypedValue.TimePeriodList
             * @instance
             */
            TimePeriodList.prototype.list = $util.emptyArray;

            /**
             * Creates a new TimePeriodList instance using the specified properties.
             * @function create
             * @memberof coreproductpb.TypedValue.TimePeriodList
             * @static
             * @param {coreproductpb.TypedValue.ITimePeriodList=} [properties] Properties to set
             * @returns {coreproductpb.TypedValue.TimePeriodList} TimePeriodList instance
             */
            TimePeriodList.create = function create(properties) {
                return new TimePeriodList(properties);
            };

            /**
             * Encodes the specified TimePeriodList message. Does not implicitly {@link coreproductpb.TypedValue.TimePeriodList.verify|verify} messages.
             * @function encode
             * @memberof coreproductpb.TypedValue.TimePeriodList
             * @static
             * @param {coreproductpb.TypedValue.ITimePeriodList} m TimePeriodList message or plain object to encode
             * @param {$protobuf.Writer} [w] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            TimePeriodList.encode = function encode(m, w) {
                if (!w)
                    w = $Writer.create();
                if (m.list != null && m.list.length) {
                    for (var i = 0; i < m.list.length; ++i)
                        $root.coreproductpb.TypedValue.TimePeriod.encode(m.list[i], w.uint32(10).fork()).ldelim();
                }
                return w;
            };

            /**
             * Decodes a TimePeriodList message from the specified reader or buffer.
             * @function decode
             * @memberof coreproductpb.TypedValue.TimePeriodList
             * @static
             * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
             * @param {number} [l] Message length if known beforehand
             * @returns {coreproductpb.TypedValue.TimePeriodList} TimePeriodList
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            TimePeriodList.decode = function decode(r, l) {
                if (!(r instanceof $Reader))
                    r = $Reader.create(r);
                var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.TypedValue.TimePeriodList();
                while (r.pos < c) {
                    var t = r.uint32();
                    switch (t >>> 3) {
                    case 1:
                        if (!(m.list && m.list.length))
                            m.list = [];
                        m.list.push($root.coreproductpb.TypedValue.TimePeriod.decode(r, r.uint32()));
                        break;
                    default:
                        r.skipType(t & 7);
                        break;
                    }
                }
                return m;
            };

            return TimePeriodList;
        })();

        TypedValue.TimePeriodRange = (function() {

            /**
             * Properties of a TimePeriodRange.
             * @memberof coreproductpb.TypedValue
             * @interface ITimePeriodRange
             * @property {number|null} [min] TimePeriodRange min
             * @property {number|null} [max] TimePeriodRange max
             * @property {coreproductpb.TimePeriodUnit|null} [unit] TimePeriodRange unit
             */

            /**
             * Constructs a new TimePeriodRange.
             * @memberof coreproductpb.TypedValue
             * @classdesc Represents a TimePeriodRange.
             * @implements ITimePeriodRange
             * @constructor
             * @param {coreproductpb.TypedValue.ITimePeriodRange=} [p] Properties to set
             */
            function TimePeriodRange(p) {
                if (p)
                    for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                        if (p[ks[i]] != null)
                            this[ks[i]] = p[ks[i]];
            }

            /**
             * TimePeriodRange min.
             * @member {number} min
             * @memberof coreproductpb.TypedValue.TimePeriodRange
             * @instance
             */
            TimePeriodRange.prototype.min = 0;

            /**
             * TimePeriodRange max.
             * @member {number} max
             * @memberof coreproductpb.TypedValue.TimePeriodRange
             * @instance
             */
            TimePeriodRange.prototype.max = 0;

            /**
             * TimePeriodRange unit.
             * @member {coreproductpb.TimePeriodUnit} unit
             * @memberof coreproductpb.TypedValue.TimePeriodRange
             * @instance
             */
            TimePeriodRange.prototype.unit = 0;

            /**
             * Creates a new TimePeriodRange instance using the specified properties.
             * @function create
             * @memberof coreproductpb.TypedValue.TimePeriodRange
             * @static
             * @param {coreproductpb.TypedValue.ITimePeriodRange=} [properties] Properties to set
             * @returns {coreproductpb.TypedValue.TimePeriodRange} TimePeriodRange instance
             */
            TimePeriodRange.create = function create(properties) {
                return new TimePeriodRange(properties);
            };

            /**
             * Encodes the specified TimePeriodRange message. Does not implicitly {@link coreproductpb.TypedValue.TimePeriodRange.verify|verify} messages.
             * @function encode
             * @memberof coreproductpb.TypedValue.TimePeriodRange
             * @static
             * @param {coreproductpb.TypedValue.ITimePeriodRange} m TimePeriodRange message or plain object to encode
             * @param {$protobuf.Writer} [w] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            TimePeriodRange.encode = function encode(m, w) {
                if (!w)
                    w = $Writer.create();
                if (m.min != null && Object.hasOwnProperty.call(m, "min"))
                    w.uint32(8).int32(m.min);
                if (m.max != null && Object.hasOwnProperty.call(m, "max"))
                    w.uint32(16).int32(m.max);
                if (m.unit != null && Object.hasOwnProperty.call(m, "unit"))
                    w.uint32(24).int32(m.unit);
                return w;
            };

            /**
             * Decodes a TimePeriodRange message from the specified reader or buffer.
             * @function decode
             * @memberof coreproductpb.TypedValue.TimePeriodRange
             * @static
             * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
             * @param {number} [l] Message length if known beforehand
             * @returns {coreproductpb.TypedValue.TimePeriodRange} TimePeriodRange
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            TimePeriodRange.decode = function decode(r, l) {
                if (!(r instanceof $Reader))
                    r = $Reader.create(r);
                var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.TypedValue.TimePeriodRange();
                while (r.pos < c) {
                    var t = r.uint32();
                    switch (t >>> 3) {
                    case 1:
                        m.min = r.int32();
                        break;
                    case 2:
                        m.max = r.int32();
                        break;
                    case 3:
                        m.unit = r.int32();
                        break;
                    default:
                        r.skipType(t & 7);
                        break;
                    }
                }
                return m;
            };

            return TimePeriodRange;
        })();

        TypedValue.TimePeriodRangeList = (function() {

            /**
             * Properties of a TimePeriodRangeList.
             * @memberof coreproductpb.TypedValue
             * @interface ITimePeriodRangeList
             * @property {Array.<coreproductpb.TypedValue.ITimePeriodRange>|null} [list] TimePeriodRangeList list
             */

            /**
             * Constructs a new TimePeriodRangeList.
             * @memberof coreproductpb.TypedValue
             * @classdesc Represents a TimePeriodRangeList.
             * @implements ITimePeriodRangeList
             * @constructor
             * @param {coreproductpb.TypedValue.ITimePeriodRangeList=} [p] Properties to set
             */
            function TimePeriodRangeList(p) {
                this.list = [];
                if (p)
                    for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                        if (p[ks[i]] != null)
                            this[ks[i]] = p[ks[i]];
            }

            /**
             * TimePeriodRangeList list.
             * @member {Array.<coreproductpb.TypedValue.ITimePeriodRange>} list
             * @memberof coreproductpb.TypedValue.TimePeriodRangeList
             * @instance
             */
            TimePeriodRangeList.prototype.list = $util.emptyArray;

            /**
             * Creates a new TimePeriodRangeList instance using the specified properties.
             * @function create
             * @memberof coreproductpb.TypedValue.TimePeriodRangeList
             * @static
             * @param {coreproductpb.TypedValue.ITimePeriodRangeList=} [properties] Properties to set
             * @returns {coreproductpb.TypedValue.TimePeriodRangeList} TimePeriodRangeList instance
             */
            TimePeriodRangeList.create = function create(properties) {
                return new TimePeriodRangeList(properties);
            };

            /**
             * Encodes the specified TimePeriodRangeList message. Does not implicitly {@link coreproductpb.TypedValue.TimePeriodRangeList.verify|verify} messages.
             * @function encode
             * @memberof coreproductpb.TypedValue.TimePeriodRangeList
             * @static
             * @param {coreproductpb.TypedValue.ITimePeriodRangeList} m TimePeriodRangeList message or plain object to encode
             * @param {$protobuf.Writer} [w] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            TimePeriodRangeList.encode = function encode(m, w) {
                if (!w)
                    w = $Writer.create();
                if (m.list != null && m.list.length) {
                    for (var i = 0; i < m.list.length; ++i)
                        $root.coreproductpb.TypedValue.TimePeriodRange.encode(m.list[i], w.uint32(10).fork()).ldelim();
                }
                return w;
            };

            /**
             * Decodes a TimePeriodRangeList message from the specified reader or buffer.
             * @function decode
             * @memberof coreproductpb.TypedValue.TimePeriodRangeList
             * @static
             * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
             * @param {number} [l] Message length if known beforehand
             * @returns {coreproductpb.TypedValue.TimePeriodRangeList} TimePeriodRangeList
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            TimePeriodRangeList.decode = function decode(r, l) {
                if (!(r instanceof $Reader))
                    r = $Reader.create(r);
                var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.TypedValue.TimePeriodRangeList();
                while (r.pos < c) {
                    var t = r.uint32();
                    switch (t >>> 3) {
                    case 1:
                        if (!(m.list && m.list.length))
                            m.list = [];
                        m.list.push($root.coreproductpb.TypedValue.TimePeriodRange.decode(r, r.uint32()));
                        break;
                    default:
                        r.skipType(t & 7);
                        break;
                    }
                }
                return m;
            };

            return TimePeriodRangeList;
        })();

        TypedValue.Area = (function() {

            /**
             * Properties of an Area.
             * @memberof coreproductpb.TypedValue
             * @interface IArea
             * @property {number|null} [value] Area value
             * @property {coreproductpb.AreaUnit|null} [unit] Area unit
             */

            /**
             * Constructs a new Area.
             * @memberof coreproductpb.TypedValue
             * @classdesc Represents an Area.
             * @implements IArea
             * @constructor
             * @param {coreproductpb.TypedValue.IArea=} [p] Properties to set
             */
            function Area(p) {
                if (p)
                    for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                        if (p[ks[i]] != null)
                            this[ks[i]] = p[ks[i]];
            }

            /**
             * Area value.
             * @member {number} value
             * @memberof coreproductpb.TypedValue.Area
             * @instance
             */
            Area.prototype.value = 0;

            /**
             * Area unit.
             * @member {coreproductpb.AreaUnit} unit
             * @memberof coreproductpb.TypedValue.Area
             * @instance
             */
            Area.prototype.unit = 0;

            /**
             * Creates a new Area instance using the specified properties.
             * @function create
             * @memberof coreproductpb.TypedValue.Area
             * @static
             * @param {coreproductpb.TypedValue.IArea=} [properties] Properties to set
             * @returns {coreproductpb.TypedValue.Area} Area instance
             */
            Area.create = function create(properties) {
                return new Area(properties);
            };

            /**
             * Encodes the specified Area message. Does not implicitly {@link coreproductpb.TypedValue.Area.verify|verify} messages.
             * @function encode
             * @memberof coreproductpb.TypedValue.Area
             * @static
             * @param {coreproductpb.TypedValue.IArea} m Area message or plain object to encode
             * @param {$protobuf.Writer} [w] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Area.encode = function encode(m, w) {
                if (!w)
                    w = $Writer.create();
                if (m.value != null && Object.hasOwnProperty.call(m, "value"))
                    w.uint32(8).int32(m.value);
                if (m.unit != null && Object.hasOwnProperty.call(m, "unit"))
                    w.uint32(16).int32(m.unit);
                return w;
            };

            /**
             * Decodes an Area message from the specified reader or buffer.
             * @function decode
             * @memberof coreproductpb.TypedValue.Area
             * @static
             * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
             * @param {number} [l] Message length if known beforehand
             * @returns {coreproductpb.TypedValue.Area} Area
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Area.decode = function decode(r, l) {
                if (!(r instanceof $Reader))
                    r = $Reader.create(r);
                var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.TypedValue.Area();
                while (r.pos < c) {
                    var t = r.uint32();
                    switch (t >>> 3) {
                    case 1:
                        m.value = r.int32();
                        break;
                    case 2:
                        m.unit = r.int32();
                        break;
                    default:
                        r.skipType(t & 7);
                        break;
                    }
                }
                return m;
            };

            return Area;
        })();

        TypedValue.AreaList = (function() {

            /**
             * Properties of an AreaList.
             * @memberof coreproductpb.TypedValue
             * @interface IAreaList
             * @property {Array.<coreproductpb.TypedValue.IArea>|null} [list] AreaList list
             */

            /**
             * Constructs a new AreaList.
             * @memberof coreproductpb.TypedValue
             * @classdesc Represents an AreaList.
             * @implements IAreaList
             * @constructor
             * @param {coreproductpb.TypedValue.IAreaList=} [p] Properties to set
             */
            function AreaList(p) {
                this.list = [];
                if (p)
                    for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                        if (p[ks[i]] != null)
                            this[ks[i]] = p[ks[i]];
            }

            /**
             * AreaList list.
             * @member {Array.<coreproductpb.TypedValue.IArea>} list
             * @memberof coreproductpb.TypedValue.AreaList
             * @instance
             */
            AreaList.prototype.list = $util.emptyArray;

            /**
             * Creates a new AreaList instance using the specified properties.
             * @function create
             * @memberof coreproductpb.TypedValue.AreaList
             * @static
             * @param {coreproductpb.TypedValue.IAreaList=} [properties] Properties to set
             * @returns {coreproductpb.TypedValue.AreaList} AreaList instance
             */
            AreaList.create = function create(properties) {
                return new AreaList(properties);
            };

            /**
             * Encodes the specified AreaList message. Does not implicitly {@link coreproductpb.TypedValue.AreaList.verify|verify} messages.
             * @function encode
             * @memberof coreproductpb.TypedValue.AreaList
             * @static
             * @param {coreproductpb.TypedValue.IAreaList} m AreaList message or plain object to encode
             * @param {$protobuf.Writer} [w] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            AreaList.encode = function encode(m, w) {
                if (!w)
                    w = $Writer.create();
                if (m.list != null && m.list.length) {
                    for (var i = 0; i < m.list.length; ++i)
                        $root.coreproductpb.TypedValue.Area.encode(m.list[i], w.uint32(10).fork()).ldelim();
                }
                return w;
            };

            /**
             * Decodes an AreaList message from the specified reader or buffer.
             * @function decode
             * @memberof coreproductpb.TypedValue.AreaList
             * @static
             * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
             * @param {number} [l] Message length if known beforehand
             * @returns {coreproductpb.TypedValue.AreaList} AreaList
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            AreaList.decode = function decode(r, l) {
                if (!(r instanceof $Reader))
                    r = $Reader.create(r);
                var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.TypedValue.AreaList();
                while (r.pos < c) {
                    var t = r.uint32();
                    switch (t >>> 3) {
                    case 1:
                        if (!(m.list && m.list.length))
                            m.list = [];
                        m.list.push($root.coreproductpb.TypedValue.Area.decode(r, r.uint32()));
                        break;
                    default:
                        r.skipType(t & 7);
                        break;
                    }
                }
                return m;
            };

            return AreaList;
        })();

        TypedValue.AreaRange = (function() {

            /**
             * Properties of an AreaRange.
             * @memberof coreproductpb.TypedValue
             * @interface IAreaRange
             * @property {number|null} [min] AreaRange min
             * @property {number|null} [max] AreaRange max
             * @property {coreproductpb.AreaUnit|null} [unit] AreaRange unit
             */

            /**
             * Constructs a new AreaRange.
             * @memberof coreproductpb.TypedValue
             * @classdesc Represents an AreaRange.
             * @implements IAreaRange
             * @constructor
             * @param {coreproductpb.TypedValue.IAreaRange=} [p] Properties to set
             */
            function AreaRange(p) {
                if (p)
                    for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                        if (p[ks[i]] != null)
                            this[ks[i]] = p[ks[i]];
            }

            /**
             * AreaRange min.
             * @member {number} min
             * @memberof coreproductpb.TypedValue.AreaRange
             * @instance
             */
            AreaRange.prototype.min = 0;

            /**
             * AreaRange max.
             * @member {number} max
             * @memberof coreproductpb.TypedValue.AreaRange
             * @instance
             */
            AreaRange.prototype.max = 0;

            /**
             * AreaRange unit.
             * @member {coreproductpb.AreaUnit} unit
             * @memberof coreproductpb.TypedValue.AreaRange
             * @instance
             */
            AreaRange.prototype.unit = 0;

            /**
             * Creates a new AreaRange instance using the specified properties.
             * @function create
             * @memberof coreproductpb.TypedValue.AreaRange
             * @static
             * @param {coreproductpb.TypedValue.IAreaRange=} [properties] Properties to set
             * @returns {coreproductpb.TypedValue.AreaRange} AreaRange instance
             */
            AreaRange.create = function create(properties) {
                return new AreaRange(properties);
            };

            /**
             * Encodes the specified AreaRange message. Does not implicitly {@link coreproductpb.TypedValue.AreaRange.verify|verify} messages.
             * @function encode
             * @memberof coreproductpb.TypedValue.AreaRange
             * @static
             * @param {coreproductpb.TypedValue.IAreaRange} m AreaRange message or plain object to encode
             * @param {$protobuf.Writer} [w] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            AreaRange.encode = function encode(m, w) {
                if (!w)
                    w = $Writer.create();
                if (m.min != null && Object.hasOwnProperty.call(m, "min"))
                    w.uint32(8).int32(m.min);
                if (m.max != null && Object.hasOwnProperty.call(m, "max"))
                    w.uint32(16).int32(m.max);
                if (m.unit != null && Object.hasOwnProperty.call(m, "unit"))
                    w.uint32(24).int32(m.unit);
                return w;
            };

            /**
             * Decodes an AreaRange message from the specified reader or buffer.
             * @function decode
             * @memberof coreproductpb.TypedValue.AreaRange
             * @static
             * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
             * @param {number} [l] Message length if known beforehand
             * @returns {coreproductpb.TypedValue.AreaRange} AreaRange
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            AreaRange.decode = function decode(r, l) {
                if (!(r instanceof $Reader))
                    r = $Reader.create(r);
                var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.TypedValue.AreaRange();
                while (r.pos < c) {
                    var t = r.uint32();
                    switch (t >>> 3) {
                    case 1:
                        m.min = r.int32();
                        break;
                    case 2:
                        m.max = r.int32();
                        break;
                    case 3:
                        m.unit = r.int32();
                        break;
                    default:
                        r.skipType(t & 7);
                        break;
                    }
                }
                return m;
            };

            return AreaRange;
        })();

        TypedValue.AreaRangeList = (function() {

            /**
             * Properties of an AreaRangeList.
             * @memberof coreproductpb.TypedValue
             * @interface IAreaRangeList
             * @property {Array.<coreproductpb.TypedValue.IAreaRange>|null} [list] AreaRangeList list
             */

            /**
             * Constructs a new AreaRangeList.
             * @memberof coreproductpb.TypedValue
             * @classdesc Represents an AreaRangeList.
             * @implements IAreaRangeList
             * @constructor
             * @param {coreproductpb.TypedValue.IAreaRangeList=} [p] Properties to set
             */
            function AreaRangeList(p) {
                this.list = [];
                if (p)
                    for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                        if (p[ks[i]] != null)
                            this[ks[i]] = p[ks[i]];
            }

            /**
             * AreaRangeList list.
             * @member {Array.<coreproductpb.TypedValue.IAreaRange>} list
             * @memberof coreproductpb.TypedValue.AreaRangeList
             * @instance
             */
            AreaRangeList.prototype.list = $util.emptyArray;

            /**
             * Creates a new AreaRangeList instance using the specified properties.
             * @function create
             * @memberof coreproductpb.TypedValue.AreaRangeList
             * @static
             * @param {coreproductpb.TypedValue.IAreaRangeList=} [properties] Properties to set
             * @returns {coreproductpb.TypedValue.AreaRangeList} AreaRangeList instance
             */
            AreaRangeList.create = function create(properties) {
                return new AreaRangeList(properties);
            };

            /**
             * Encodes the specified AreaRangeList message. Does not implicitly {@link coreproductpb.TypedValue.AreaRangeList.verify|verify} messages.
             * @function encode
             * @memberof coreproductpb.TypedValue.AreaRangeList
             * @static
             * @param {coreproductpb.TypedValue.IAreaRangeList} m AreaRangeList message or plain object to encode
             * @param {$protobuf.Writer} [w] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            AreaRangeList.encode = function encode(m, w) {
                if (!w)
                    w = $Writer.create();
                if (m.list != null && m.list.length) {
                    for (var i = 0; i < m.list.length; ++i)
                        $root.coreproductpb.TypedValue.AreaRange.encode(m.list[i], w.uint32(10).fork()).ldelim();
                }
                return w;
            };

            /**
             * Decodes an AreaRangeList message from the specified reader or buffer.
             * @function decode
             * @memberof coreproductpb.TypedValue.AreaRangeList
             * @static
             * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
             * @param {number} [l] Message length if known beforehand
             * @returns {coreproductpb.TypedValue.AreaRangeList} AreaRangeList
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            AreaRangeList.decode = function decode(r, l) {
                if (!(r instanceof $Reader))
                    r = $Reader.create(r);
                var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.TypedValue.AreaRangeList();
                while (r.pos < c) {
                    var t = r.uint32();
                    switch (t >>> 3) {
                    case 1:
                        if (!(m.list && m.list.length))
                            m.list = [];
                        m.list.push($root.coreproductpb.TypedValue.AreaRange.decode(r, r.uint32()));
                        break;
                    default:
                        r.skipType(t & 7);
                        break;
                    }
                }
                return m;
            };

            return AreaRangeList;
        })();

        TypedValue.Geography = (function() {

            /**
             * Properties of a Geography.
             * @memberof coreproductpb.TypedValue
             * @interface IGeography
             * @property {boolean|null} [nationwide] Geography nationwide
             * @property {coreproductpb.IStateIncludeExclude|null} [states] Geography states
             * @property {coreproductpb.IZipCodeIncludeExclude|null} [zipCodes] Geography zipCodes
             */

            /**
             * Constructs a new Geography.
             * @memberof coreproductpb.TypedValue
             * @classdesc Represents a Geography.
             * @implements IGeography
             * @constructor
             * @param {coreproductpb.TypedValue.IGeography=} [p] Properties to set
             */
            function Geography(p) {
                if (p)
                    for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                        if (p[ks[i]] != null)
                            this[ks[i]] = p[ks[i]];
            }

            /**
             * Geography nationwide.
             * @member {boolean} nationwide
             * @memberof coreproductpb.TypedValue.Geography
             * @instance
             */
            Geography.prototype.nationwide = false;

            /**
             * Geography states.
             * @member {coreproductpb.IStateIncludeExclude|null|undefined} states
             * @memberof coreproductpb.TypedValue.Geography
             * @instance
             */
            Geography.prototype.states = null;

            /**
             * Geography zipCodes.
             * @member {coreproductpb.IZipCodeIncludeExclude|null|undefined} zipCodes
             * @memberof coreproductpb.TypedValue.Geography
             * @instance
             */
            Geography.prototype.zipCodes = null;

            /**
             * Creates a new Geography instance using the specified properties.
             * @function create
             * @memberof coreproductpb.TypedValue.Geography
             * @static
             * @param {coreproductpb.TypedValue.IGeography=} [properties] Properties to set
             * @returns {coreproductpb.TypedValue.Geography} Geography instance
             */
            Geography.create = function create(properties) {
                return new Geography(properties);
            };

            /**
             * Encodes the specified Geography message. Does not implicitly {@link coreproductpb.TypedValue.Geography.verify|verify} messages.
             * @function encode
             * @memberof coreproductpb.TypedValue.Geography
             * @static
             * @param {coreproductpb.TypedValue.IGeography} m Geography message or plain object to encode
             * @param {$protobuf.Writer} [w] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Geography.encode = function encode(m, w) {
                if (!w)
                    w = $Writer.create();
                if (m.nationwide != null && Object.hasOwnProperty.call(m, "nationwide"))
                    w.uint32(8).bool(m.nationwide);
                if (m.states != null && Object.hasOwnProperty.call(m, "states"))
                    $root.coreproductpb.StateIncludeExclude.encode(m.states, w.uint32(18).fork()).ldelim();
                if (m.zipCodes != null && Object.hasOwnProperty.call(m, "zipCodes"))
                    $root.coreproductpb.ZipCodeIncludeExclude.encode(m.zipCodes, w.uint32(26).fork()).ldelim();
                return w;
            };

            /**
             * Decodes a Geography message from the specified reader or buffer.
             * @function decode
             * @memberof coreproductpb.TypedValue.Geography
             * @static
             * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
             * @param {number} [l] Message length if known beforehand
             * @returns {coreproductpb.TypedValue.Geography} Geography
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Geography.decode = function decode(r, l) {
                if (!(r instanceof $Reader))
                    r = $Reader.create(r);
                var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.TypedValue.Geography();
                while (r.pos < c) {
                    var t = r.uint32();
                    switch (t >>> 3) {
                    case 1:
                        m.nationwide = r.bool();
                        break;
                    case 2:
                        m.states = $root.coreproductpb.StateIncludeExclude.decode(r, r.uint32());
                        break;
                    case 3:
                        m.zipCodes = $root.coreproductpb.ZipCodeIncludeExclude.decode(r, r.uint32());
                        break;
                    default:
                        r.skipType(t & 7);
                        break;
                    }
                }
                return m;
            };

            return Geography;
        })();

        TypedValue.MoneyList = (function() {

            /**
             * Properties of a MoneyList.
             * @memberof coreproductpb.TypedValue
             * @interface IMoneyList
             * @property {Array.<common.IMoney>|null} [list] MoneyList list
             */

            /**
             * Constructs a new MoneyList.
             * @memberof coreproductpb.TypedValue
             * @classdesc Represents a MoneyList.
             * @implements IMoneyList
             * @constructor
             * @param {coreproductpb.TypedValue.IMoneyList=} [p] Properties to set
             */
            function MoneyList(p) {
                this.list = [];
                if (p)
                    for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                        if (p[ks[i]] != null)
                            this[ks[i]] = p[ks[i]];
            }

            /**
             * MoneyList list.
             * @member {Array.<common.IMoney>} list
             * @memberof coreproductpb.TypedValue.MoneyList
             * @instance
             */
            MoneyList.prototype.list = $util.emptyArray;

            /**
             * Creates a new MoneyList instance using the specified properties.
             * @function create
             * @memberof coreproductpb.TypedValue.MoneyList
             * @static
             * @param {coreproductpb.TypedValue.IMoneyList=} [properties] Properties to set
             * @returns {coreproductpb.TypedValue.MoneyList} MoneyList instance
             */
            MoneyList.create = function create(properties) {
                return new MoneyList(properties);
            };

            /**
             * Encodes the specified MoneyList message. Does not implicitly {@link coreproductpb.TypedValue.MoneyList.verify|verify} messages.
             * @function encode
             * @memberof coreproductpb.TypedValue.MoneyList
             * @static
             * @param {coreproductpb.TypedValue.IMoneyList} m MoneyList message or plain object to encode
             * @param {$protobuf.Writer} [w] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            MoneyList.encode = function encode(m, w) {
                if (!w)
                    w = $Writer.create();
                if (m.list != null && m.list.length) {
                    for (var i = 0; i < m.list.length; ++i)
                        $root.common.Money.encode(m.list[i], w.uint32(10).fork()).ldelim();
                }
                return w;
            };

            /**
             * Decodes a MoneyList message from the specified reader or buffer.
             * @function decode
             * @memberof coreproductpb.TypedValue.MoneyList
             * @static
             * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
             * @param {number} [l] Message length if known beforehand
             * @returns {coreproductpb.TypedValue.MoneyList} MoneyList
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            MoneyList.decode = function decode(r, l) {
                if (!(r instanceof $Reader))
                    r = $Reader.create(r);
                var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.TypedValue.MoneyList();
                while (r.pos < c) {
                    var t = r.uint32();
                    switch (t >>> 3) {
                    case 1:
                        if (!(m.list && m.list.length))
                            m.list = [];
                        m.list.push($root.common.Money.decode(r, r.uint32()));
                        break;
                    default:
                        r.skipType(t & 7);
                        break;
                    }
                }
                return m;
            };

            return MoneyList;
        })();

        TypedValue.StarRemarkList = (function() {

            /**
             * Properties of a StarRemarkList.
             * @memberof coreproductpb.TypedValue
             * @interface IStarRemarkList
             * @property {Array.<coreproductpb.TypedValue.StarRemarkList.IStarRemark>|null} [starRemarkList] StarRemarkList starRemarkList
             */

            /**
             * Constructs a new StarRemarkList.
             * @memberof coreproductpb.TypedValue
             * @classdesc Represents a StarRemarkList.
             * @implements IStarRemarkList
             * @constructor
             * @param {coreproductpb.TypedValue.IStarRemarkList=} [p] Properties to set
             */
            function StarRemarkList(p) {
                this.starRemarkList = [];
                if (p)
                    for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                        if (p[ks[i]] != null)
                            this[ks[i]] = p[ks[i]];
            }

            /**
             * StarRemarkList starRemarkList.
             * @member {Array.<coreproductpb.TypedValue.StarRemarkList.IStarRemark>} starRemarkList
             * @memberof coreproductpb.TypedValue.StarRemarkList
             * @instance
             */
            StarRemarkList.prototype.starRemarkList = $util.emptyArray;

            /**
             * Creates a new StarRemarkList instance using the specified properties.
             * @function create
             * @memberof coreproductpb.TypedValue.StarRemarkList
             * @static
             * @param {coreproductpb.TypedValue.IStarRemarkList=} [properties] Properties to set
             * @returns {coreproductpb.TypedValue.StarRemarkList} StarRemarkList instance
             */
            StarRemarkList.create = function create(properties) {
                return new StarRemarkList(properties);
            };

            /**
             * Encodes the specified StarRemarkList message. Does not implicitly {@link coreproductpb.TypedValue.StarRemarkList.verify|verify} messages.
             * @function encode
             * @memberof coreproductpb.TypedValue.StarRemarkList
             * @static
             * @param {coreproductpb.TypedValue.IStarRemarkList} m StarRemarkList message or plain object to encode
             * @param {$protobuf.Writer} [w] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            StarRemarkList.encode = function encode(m, w) {
                if (!w)
                    w = $Writer.create();
                if (m.starRemarkList != null && m.starRemarkList.length) {
                    for (var i = 0; i < m.starRemarkList.length; ++i)
                        $root.coreproductpb.TypedValue.StarRemarkList.StarRemark.encode(m.starRemarkList[i], w.uint32(10).fork()).ldelim();
                }
                return w;
            };

            /**
             * Decodes a StarRemarkList message from the specified reader or buffer.
             * @function decode
             * @memberof coreproductpb.TypedValue.StarRemarkList
             * @static
             * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
             * @param {number} [l] Message length if known beforehand
             * @returns {coreproductpb.TypedValue.StarRemarkList} StarRemarkList
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            StarRemarkList.decode = function decode(r, l) {
                if (!(r instanceof $Reader))
                    r = $Reader.create(r);
                var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.TypedValue.StarRemarkList();
                while (r.pos < c) {
                    var t = r.uint32();
                    switch (t >>> 3) {
                    case 1:
                        if (!(m.starRemarkList && m.starRemarkList.length))
                            m.starRemarkList = [];
                        m.starRemarkList.push($root.coreproductpb.TypedValue.StarRemarkList.StarRemark.decode(r, r.uint32()));
                        break;
                    default:
                        r.skipType(t & 7);
                        break;
                    }
                }
                return m;
            };

            StarRemarkList.StarRemark = (function() {

                /**
                 * Properties of a StarRemark.
                 * @memberof coreproductpb.TypedValue.StarRemarkList
                 * @interface IStarRemark
                 * @property {string|null} [type] StarRemark type
                 * @property {string|null} [text] StarRemark text
                 */

                /**
                 * Constructs a new StarRemark.
                 * @memberof coreproductpb.TypedValue.StarRemarkList
                 * @classdesc Represents a StarRemark.
                 * @implements IStarRemark
                 * @constructor
                 * @param {coreproductpb.TypedValue.StarRemarkList.IStarRemark=} [p] Properties to set
                 */
                function StarRemark(p) {
                    if (p)
                        for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                            if (p[ks[i]] != null)
                                this[ks[i]] = p[ks[i]];
                }

                /**
                 * StarRemark type.
                 * @member {string} type
                 * @memberof coreproductpb.TypedValue.StarRemarkList.StarRemark
                 * @instance
                 */
                StarRemark.prototype.type = "";

                /**
                 * StarRemark text.
                 * @member {string} text
                 * @memberof coreproductpb.TypedValue.StarRemarkList.StarRemark
                 * @instance
                 */
                StarRemark.prototype.text = "";

                /**
                 * Creates a new StarRemark instance using the specified properties.
                 * @function create
                 * @memberof coreproductpb.TypedValue.StarRemarkList.StarRemark
                 * @static
                 * @param {coreproductpb.TypedValue.StarRemarkList.IStarRemark=} [properties] Properties to set
                 * @returns {coreproductpb.TypedValue.StarRemarkList.StarRemark} StarRemark instance
                 */
                StarRemark.create = function create(properties) {
                    return new StarRemark(properties);
                };

                /**
                 * Encodes the specified StarRemark message. Does not implicitly {@link coreproductpb.TypedValue.StarRemarkList.StarRemark.verify|verify} messages.
                 * @function encode
                 * @memberof coreproductpb.TypedValue.StarRemarkList.StarRemark
                 * @static
                 * @param {coreproductpb.TypedValue.StarRemarkList.IStarRemark} m StarRemark message or plain object to encode
                 * @param {$protobuf.Writer} [w] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                StarRemark.encode = function encode(m, w) {
                    if (!w)
                        w = $Writer.create();
                    if (m.type != null && Object.hasOwnProperty.call(m, "type"))
                        w.uint32(10).string(m.type);
                    if (m.text != null && Object.hasOwnProperty.call(m, "text"))
                        w.uint32(18).string(m.text);
                    return w;
                };

                /**
                 * Decodes a StarRemark message from the specified reader or buffer.
                 * @function decode
                 * @memberof coreproductpb.TypedValue.StarRemarkList.StarRemark
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
                 * @param {number} [l] Message length if known beforehand
                 * @returns {coreproductpb.TypedValue.StarRemarkList.StarRemark} StarRemark
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                StarRemark.decode = function decode(r, l) {
                    if (!(r instanceof $Reader))
                        r = $Reader.create(r);
                    var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.TypedValue.StarRemarkList.StarRemark();
                    while (r.pos < c) {
                        var t = r.uint32();
                        switch (t >>> 3) {
                        case 1:
                            m.type = r.string();
                            break;
                        case 2:
                            m.text = r.string();
                            break;
                        default:
                            r.skipType(t & 7);
                            break;
                        }
                    }
                    return m;
                };

                return StarRemark;
            })();

            return StarRemarkList;
        })();

        TypedValue.StarFulfillmentList = (function() {

            /**
             * Properties of a StarFulfillmentList.
             * @memberof coreproductpb.TypedValue
             * @interface IStarFulfillmentList
             * @property {Array.<coreproductpb.TypedValue.StarFulfillmentList.IStarFulfillment>|null} [starFulfillment] StarFulfillmentList starFulfillment
             */

            /**
             * Constructs a new StarFulfillmentList.
             * @memberof coreproductpb.TypedValue
             * @classdesc Represents a StarFulfillmentList.
             * @implements IStarFulfillmentList
             * @constructor
             * @param {coreproductpb.TypedValue.IStarFulfillmentList=} [p] Properties to set
             */
            function StarFulfillmentList(p) {
                this.starFulfillment = [];
                if (p)
                    for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                        if (p[ks[i]] != null)
                            this[ks[i]] = p[ks[i]];
            }

            /**
             * StarFulfillmentList starFulfillment.
             * @member {Array.<coreproductpb.TypedValue.StarFulfillmentList.IStarFulfillment>} starFulfillment
             * @memberof coreproductpb.TypedValue.StarFulfillmentList
             * @instance
             */
            StarFulfillmentList.prototype.starFulfillment = $util.emptyArray;

            /**
             * Creates a new StarFulfillmentList instance using the specified properties.
             * @function create
             * @memberof coreproductpb.TypedValue.StarFulfillmentList
             * @static
             * @param {coreproductpb.TypedValue.IStarFulfillmentList=} [properties] Properties to set
             * @returns {coreproductpb.TypedValue.StarFulfillmentList} StarFulfillmentList instance
             */
            StarFulfillmentList.create = function create(properties) {
                return new StarFulfillmentList(properties);
            };

            /**
             * Encodes the specified StarFulfillmentList message. Does not implicitly {@link coreproductpb.TypedValue.StarFulfillmentList.verify|verify} messages.
             * @function encode
             * @memberof coreproductpb.TypedValue.StarFulfillmentList
             * @static
             * @param {coreproductpb.TypedValue.IStarFulfillmentList} m StarFulfillmentList message or plain object to encode
             * @param {$protobuf.Writer} [w] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            StarFulfillmentList.encode = function encode(m, w) {
                if (!w)
                    w = $Writer.create();
                if (m.starFulfillment != null && m.starFulfillment.length) {
                    for (var i = 0; i < m.starFulfillment.length; ++i)
                        $root.coreproductpb.TypedValue.StarFulfillmentList.StarFulfillment.encode(m.starFulfillment[i], w.uint32(10).fork()).ldelim();
                }
                return w;
            };

            /**
             * Decodes a StarFulfillmentList message from the specified reader or buffer.
             * @function decode
             * @memberof coreproductpb.TypedValue.StarFulfillmentList
             * @static
             * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
             * @param {number} [l] Message length if known beforehand
             * @returns {coreproductpb.TypedValue.StarFulfillmentList} StarFulfillmentList
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            StarFulfillmentList.decode = function decode(r, l) {
                if (!(r instanceof $Reader))
                    r = $Reader.create(r);
                var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.TypedValue.StarFulfillmentList();
                while (r.pos < c) {
                    var t = r.uint32();
                    switch (t >>> 3) {
                    case 1:
                        if (!(m.starFulfillment && m.starFulfillment.length))
                            m.starFulfillment = [];
                        m.starFulfillment.push($root.coreproductpb.TypedValue.StarFulfillmentList.StarFulfillment.decode(r, r.uint32()));
                        break;
                    default:
                        r.skipType(t & 7);
                        break;
                    }
                }
                return m;
            };

            StarFulfillmentList.StarFulfillment = (function() {

                /**
                 * Properties of a StarFulfillment.
                 * @memberof coreproductpb.TypedValue.StarFulfillmentList
                 * @interface IStarFulfillment
                 * @property {string|null} [fulfillmentType] StarFulfillment fulfillmentType
                 * @property {string|null} [formCode] StarFulfillment formCode
                 */

                /**
                 * Constructs a new StarFulfillment.
                 * @memberof coreproductpb.TypedValue.StarFulfillmentList
                 * @classdesc Represents a StarFulfillment.
                 * @implements IStarFulfillment
                 * @constructor
                 * @param {coreproductpb.TypedValue.StarFulfillmentList.IStarFulfillment=} [p] Properties to set
                 */
                function StarFulfillment(p) {
                    if (p)
                        for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                            if (p[ks[i]] != null)
                                this[ks[i]] = p[ks[i]];
                }

                /**
                 * StarFulfillment fulfillmentType.
                 * @member {string} fulfillmentType
                 * @memberof coreproductpb.TypedValue.StarFulfillmentList.StarFulfillment
                 * @instance
                 */
                StarFulfillment.prototype.fulfillmentType = "";

                /**
                 * StarFulfillment formCode.
                 * @member {string} formCode
                 * @memberof coreproductpb.TypedValue.StarFulfillmentList.StarFulfillment
                 * @instance
                 */
                StarFulfillment.prototype.formCode = "";

                /**
                 * Creates a new StarFulfillment instance using the specified properties.
                 * @function create
                 * @memberof coreproductpb.TypedValue.StarFulfillmentList.StarFulfillment
                 * @static
                 * @param {coreproductpb.TypedValue.StarFulfillmentList.IStarFulfillment=} [properties] Properties to set
                 * @returns {coreproductpb.TypedValue.StarFulfillmentList.StarFulfillment} StarFulfillment instance
                 */
                StarFulfillment.create = function create(properties) {
                    return new StarFulfillment(properties);
                };

                /**
                 * Encodes the specified StarFulfillment message. Does not implicitly {@link coreproductpb.TypedValue.StarFulfillmentList.StarFulfillment.verify|verify} messages.
                 * @function encode
                 * @memberof coreproductpb.TypedValue.StarFulfillmentList.StarFulfillment
                 * @static
                 * @param {coreproductpb.TypedValue.StarFulfillmentList.IStarFulfillment} m StarFulfillment message or plain object to encode
                 * @param {$protobuf.Writer} [w] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                StarFulfillment.encode = function encode(m, w) {
                    if (!w)
                        w = $Writer.create();
                    if (m.fulfillmentType != null && Object.hasOwnProperty.call(m, "fulfillmentType"))
                        w.uint32(10).string(m.fulfillmentType);
                    if (m.formCode != null && Object.hasOwnProperty.call(m, "formCode"))
                        w.uint32(18).string(m.formCode);
                    return w;
                };

                /**
                 * Decodes a StarFulfillment message from the specified reader or buffer.
                 * @function decode
                 * @memberof coreproductpb.TypedValue.StarFulfillmentList.StarFulfillment
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
                 * @param {number} [l] Message length if known beforehand
                 * @returns {coreproductpb.TypedValue.StarFulfillmentList.StarFulfillment} StarFulfillment
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                StarFulfillment.decode = function decode(r, l) {
                    if (!(r instanceof $Reader))
                        r = $Reader.create(r);
                    var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.TypedValue.StarFulfillmentList.StarFulfillment();
                    while (r.pos < c) {
                        var t = r.uint32();
                        switch (t >>> 3) {
                        case 1:
                            m.fulfillmentType = r.string();
                            break;
                        case 2:
                            m.formCode = r.string();
                            break;
                        default:
                            r.skipType(t & 7);
                            break;
                        }
                    }
                    return m;
                };

                return StarFulfillment;
            })();

            return StarFulfillmentList;
        })();

        TypedValue.DateTimestampList = (function() {

            /**
             * Properties of a DateTimestampList.
             * @memberof coreproductpb.TypedValue
             * @interface IDateTimestampList
             * @property {Array.<google.protobuf.ITimestamp>|null} [list] DateTimestampList list
             */

            /**
             * Constructs a new DateTimestampList.
             * @memberof coreproductpb.TypedValue
             * @classdesc Represents a DateTimestampList.
             * @implements IDateTimestampList
             * @constructor
             * @param {coreproductpb.TypedValue.IDateTimestampList=} [p] Properties to set
             */
            function DateTimestampList(p) {
                this.list = [];
                if (p)
                    for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                        if (p[ks[i]] != null)
                            this[ks[i]] = p[ks[i]];
            }

            /**
             * DateTimestampList list.
             * @member {Array.<google.protobuf.ITimestamp>} list
             * @memberof coreproductpb.TypedValue.DateTimestampList
             * @instance
             */
            DateTimestampList.prototype.list = $util.emptyArray;

            /**
             * Creates a new DateTimestampList instance using the specified properties.
             * @function create
             * @memberof coreproductpb.TypedValue.DateTimestampList
             * @static
             * @param {coreproductpb.TypedValue.IDateTimestampList=} [properties] Properties to set
             * @returns {coreproductpb.TypedValue.DateTimestampList} DateTimestampList instance
             */
            DateTimestampList.create = function create(properties) {
                return new DateTimestampList(properties);
            };

            /**
             * Encodes the specified DateTimestampList message. Does not implicitly {@link coreproductpb.TypedValue.DateTimestampList.verify|verify} messages.
             * @function encode
             * @memberof coreproductpb.TypedValue.DateTimestampList
             * @static
             * @param {coreproductpb.TypedValue.IDateTimestampList} m DateTimestampList message or plain object to encode
             * @param {$protobuf.Writer} [w] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            DateTimestampList.encode = function encode(m, w) {
                if (!w)
                    w = $Writer.create();
                if (m.list != null && m.list.length) {
                    for (var i = 0; i < m.list.length; ++i)
                        $root.google.protobuf.Timestamp.encode(m.list[i], w.uint32(10).fork()).ldelim();
                }
                return w;
            };

            /**
             * Decodes a DateTimestampList message from the specified reader or buffer.
             * @function decode
             * @memberof coreproductpb.TypedValue.DateTimestampList
             * @static
             * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
             * @param {number} [l] Message length if known beforehand
             * @returns {coreproductpb.TypedValue.DateTimestampList} DateTimestampList
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            DateTimestampList.decode = function decode(r, l) {
                if (!(r instanceof $Reader))
                    r = $Reader.create(r);
                var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.TypedValue.DateTimestampList();
                while (r.pos < c) {
                    var t = r.uint32();
                    switch (t >>> 3) {
                    case 1:
                        if (!(m.list && m.list.length))
                            m.list = [];
                        m.list.push($root.google.protobuf.Timestamp.decode(r, r.uint32()));
                        break;
                    default:
                        r.skipType(t & 7);
                        break;
                    }
                }
                return m;
            };

            return DateTimestampList;
        })();

        return TypedValue;
    })();

    coreproductpb.AttributeCondition = (function() {

        /**
         * Properties of an AttributeCondition.
         * @memberof coreproductpb
         * @interface IAttributeCondition
         * @property {string|null} [name] AttributeCondition name
         * @property {coreproductpb.ConditionalOperator|null} [operator] AttributeCondition operator
         * @property {Array.<coreproductpb.ITypedValue>|null} [value] AttributeCondition value
         */

        /**
         * Constructs a new AttributeCondition.
         * @memberof coreproductpb
         * @classdesc Represents an AttributeCondition.
         * @implements IAttributeCondition
         * @constructor
         * @param {coreproductpb.IAttributeCondition=} [p] Properties to set
         */
        function AttributeCondition(p) {
            this.value = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * AttributeCondition name.
         * @member {string} name
         * @memberof coreproductpb.AttributeCondition
         * @instance
         */
        AttributeCondition.prototype.name = "";

        /**
         * AttributeCondition operator.
         * @member {coreproductpb.ConditionalOperator} operator
         * @memberof coreproductpb.AttributeCondition
         * @instance
         */
        AttributeCondition.prototype.operator = 0;

        /**
         * AttributeCondition value.
         * @member {Array.<coreproductpb.ITypedValue>} value
         * @memberof coreproductpb.AttributeCondition
         * @instance
         */
        AttributeCondition.prototype.value = $util.emptyArray;

        /**
         * Creates a new AttributeCondition instance using the specified properties.
         * @function create
         * @memberof coreproductpb.AttributeCondition
         * @static
         * @param {coreproductpb.IAttributeCondition=} [properties] Properties to set
         * @returns {coreproductpb.AttributeCondition} AttributeCondition instance
         */
        AttributeCondition.create = function create(properties) {
            return new AttributeCondition(properties);
        };

        /**
         * Encodes the specified AttributeCondition message. Does not implicitly {@link coreproductpb.AttributeCondition.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.AttributeCondition
         * @static
         * @param {coreproductpb.IAttributeCondition} m AttributeCondition message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AttributeCondition.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.name != null && Object.hasOwnProperty.call(m, "name"))
                w.uint32(10).string(m.name);
            if (m.operator != null && Object.hasOwnProperty.call(m, "operator"))
                w.uint32(16).int32(m.operator);
            if (m.value != null && m.value.length) {
                for (var i = 0; i < m.value.length; ++i)
                    $root.coreproductpb.TypedValue.encode(m.value[i], w.uint32(26).fork()).ldelim();
            }
            return w;
        };

        /**
         * Decodes an AttributeCondition message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.AttributeCondition
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.AttributeCondition} AttributeCondition
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AttributeCondition.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.AttributeCondition();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.name = r.string();
                    break;
                case 2:
                    m.operator = r.int32();
                    break;
                case 3:
                    if (!(m.value && m.value.length))
                        m.value = [];
                    m.value.push($root.coreproductpb.TypedValue.decode(r, r.uint32()));
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return AttributeCondition;
    })();

    coreproductpb.ValueRule = (function() {

        /**
         * Properties of a ValueRule.
         * @memberof coreproductpb
         * @interface IValueRule
         * @property {coreproductpb.ITypedValue|null} [value] ValueRule value
         * @property {Array.<coreproductpb.IAttributeCondition>|null} [inclusionConditions] ValueRule inclusionConditions
         */

        /**
         * Constructs a new ValueRule.
         * @memberof coreproductpb
         * @classdesc Represents a ValueRule.
         * @implements IValueRule
         * @constructor
         * @param {coreproductpb.IValueRule=} [p] Properties to set
         */
        function ValueRule(p) {
            this.inclusionConditions = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * ValueRule value.
         * @member {coreproductpb.ITypedValue|null|undefined} value
         * @memberof coreproductpb.ValueRule
         * @instance
         */
        ValueRule.prototype.value = null;

        /**
         * ValueRule inclusionConditions.
         * @member {Array.<coreproductpb.IAttributeCondition>} inclusionConditions
         * @memberof coreproductpb.ValueRule
         * @instance
         */
        ValueRule.prototype.inclusionConditions = $util.emptyArray;

        /**
         * Creates a new ValueRule instance using the specified properties.
         * @function create
         * @memberof coreproductpb.ValueRule
         * @static
         * @param {coreproductpb.IValueRule=} [properties] Properties to set
         * @returns {coreproductpb.ValueRule} ValueRule instance
         */
        ValueRule.create = function create(properties) {
            return new ValueRule(properties);
        };

        /**
         * Encodes the specified ValueRule message. Does not implicitly {@link coreproductpb.ValueRule.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.ValueRule
         * @static
         * @param {coreproductpb.IValueRule} m ValueRule message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ValueRule.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.value != null && Object.hasOwnProperty.call(m, "value"))
                $root.coreproductpb.TypedValue.encode(m.value, w.uint32(10).fork()).ldelim();
            if (m.inclusionConditions != null && m.inclusionConditions.length) {
                for (var i = 0; i < m.inclusionConditions.length; ++i)
                    $root.coreproductpb.AttributeCondition.encode(m.inclusionConditions[i], w.uint32(18).fork()).ldelim();
            }
            return w;
        };

        /**
         * Decodes a ValueRule message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.ValueRule
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.ValueRule} ValueRule
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ValueRule.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.ValueRule();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.value = $root.coreproductpb.TypedValue.decode(r, r.uint32());
                    break;
                case 2:
                    if (!(m.inclusionConditions && m.inclusionConditions.length))
                        m.inclusionConditions = [];
                    m.inclusionConditions.push($root.coreproductpb.AttributeCondition.decode(r, r.uint32()));
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return ValueRule;
    })();

    coreproductpb.AttributeValueOverrideRule = (function() {

        /**
         * Properties of an AttributeValueOverrideRule.
         * @memberof coreproductpb
         * @interface IAttributeValueOverrideRule
         * @property {Array.<coreproductpb.IAttributeValuePair>|null} [overrides] AttributeValueOverrideRule overrides
         * @property {Array.<coreproductpb.IAttributeCondition>|null} [inclusionConditions] AttributeValueOverrideRule inclusionConditions
         */

        /**
         * Constructs a new AttributeValueOverrideRule.
         * @memberof coreproductpb
         * @classdesc Represents an AttributeValueOverrideRule.
         * @implements IAttributeValueOverrideRule
         * @constructor
         * @param {coreproductpb.IAttributeValueOverrideRule=} [p] Properties to set
         */
        function AttributeValueOverrideRule(p) {
            this.overrides = [];
            this.inclusionConditions = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * AttributeValueOverrideRule overrides.
         * @member {Array.<coreproductpb.IAttributeValuePair>} overrides
         * @memberof coreproductpb.AttributeValueOverrideRule
         * @instance
         */
        AttributeValueOverrideRule.prototype.overrides = $util.emptyArray;

        /**
         * AttributeValueOverrideRule inclusionConditions.
         * @member {Array.<coreproductpb.IAttributeCondition>} inclusionConditions
         * @memberof coreproductpb.AttributeValueOverrideRule
         * @instance
         */
        AttributeValueOverrideRule.prototype.inclusionConditions = $util.emptyArray;

        /**
         * Creates a new AttributeValueOverrideRule instance using the specified properties.
         * @function create
         * @memberof coreproductpb.AttributeValueOverrideRule
         * @static
         * @param {coreproductpb.IAttributeValueOverrideRule=} [properties] Properties to set
         * @returns {coreproductpb.AttributeValueOverrideRule} AttributeValueOverrideRule instance
         */
        AttributeValueOverrideRule.create = function create(properties) {
            return new AttributeValueOverrideRule(properties);
        };

        /**
         * Encodes the specified AttributeValueOverrideRule message. Does not implicitly {@link coreproductpb.AttributeValueOverrideRule.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.AttributeValueOverrideRule
         * @static
         * @param {coreproductpb.IAttributeValueOverrideRule} m AttributeValueOverrideRule message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AttributeValueOverrideRule.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.overrides != null && m.overrides.length) {
                for (var i = 0; i < m.overrides.length; ++i)
                    $root.coreproductpb.AttributeValuePair.encode(m.overrides[i], w.uint32(10).fork()).ldelim();
            }
            if (m.inclusionConditions != null && m.inclusionConditions.length) {
                for (var i = 0; i < m.inclusionConditions.length; ++i)
                    $root.coreproductpb.AttributeCondition.encode(m.inclusionConditions[i], w.uint32(18).fork()).ldelim();
            }
            return w;
        };

        /**
         * Decodes an AttributeValueOverrideRule message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.AttributeValueOverrideRule
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.AttributeValueOverrideRule} AttributeValueOverrideRule
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AttributeValueOverrideRule.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.AttributeValueOverrideRule();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    if (!(m.overrides && m.overrides.length))
                        m.overrides = [];
                    m.overrides.push($root.coreproductpb.AttributeValuePair.decode(r, r.uint32()));
                    break;
                case 2:
                    if (!(m.inclusionConditions && m.inclusionConditions.length))
                        m.inclusionConditions = [];
                    m.inclusionConditions.push($root.coreproductpb.AttributeCondition.decode(r, r.uint32()));
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return AttributeValueOverrideRule;
    })();

    coreproductpb.AttributeValuePair = (function() {

        /**
         * Properties of an AttributeValuePair.
         * @memberof coreproductpb
         * @interface IAttributeValuePair
         * @property {string|null} [name] AttributeValuePair name
         * @property {coreproductpb.ITypedValue|null} [value] AttributeValuePair value
         */

        /**
         * Constructs a new AttributeValuePair.
         * @memberof coreproductpb
         * @classdesc Represents an AttributeValuePair.
         * @implements IAttributeValuePair
         * @constructor
         * @param {coreproductpb.IAttributeValuePair=} [p] Properties to set
         */
        function AttributeValuePair(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * AttributeValuePair name.
         * @member {string} name
         * @memberof coreproductpb.AttributeValuePair
         * @instance
         */
        AttributeValuePair.prototype.name = "";

        /**
         * AttributeValuePair value.
         * @member {coreproductpb.ITypedValue|null|undefined} value
         * @memberof coreproductpb.AttributeValuePair
         * @instance
         */
        AttributeValuePair.prototype.value = null;

        /**
         * Creates a new AttributeValuePair instance using the specified properties.
         * @function create
         * @memberof coreproductpb.AttributeValuePair
         * @static
         * @param {coreproductpb.IAttributeValuePair=} [properties] Properties to set
         * @returns {coreproductpb.AttributeValuePair} AttributeValuePair instance
         */
        AttributeValuePair.create = function create(properties) {
            return new AttributeValuePair(properties);
        };

        /**
         * Encodes the specified AttributeValuePair message. Does not implicitly {@link coreproductpb.AttributeValuePair.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.AttributeValuePair
         * @static
         * @param {coreproductpb.IAttributeValuePair} m AttributeValuePair message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AttributeValuePair.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.name != null && Object.hasOwnProperty.call(m, "name"))
                w.uint32(10).string(m.name);
            if (m.value != null && Object.hasOwnProperty.call(m, "value"))
                $root.coreproductpb.TypedValue.encode(m.value, w.uint32(18).fork()).ldelim();
            return w;
        };

        /**
         * Decodes an AttributeValuePair message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.AttributeValuePair
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.AttributeValuePair} AttributeValuePair
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AttributeValuePair.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.AttributeValuePair();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.name = r.string();
                    break;
                case 2:
                    m.value = $root.coreproductpb.TypedValue.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return AttributeValuePair;
    })();

    coreproductpb.PickRule = (function() {

        /**
         * Properties of a PickRule.
         * @memberof coreproductpb
         * @interface IPickRule
         * @property {number|null} [min] PickRule min
         * @property {number|null} [max] PickRule max
         * @property {coreproductpb.PickStrategy|null} [strategy] PickRule strategy
         * @property {Array.<coreproductpb.IAttributeCondition>|null} [inclusionConditions] PickRule inclusionConditions
         */

        /**
         * Constructs a new PickRule.
         * @memberof coreproductpb
         * @classdesc Represents a PickRule.
         * @implements IPickRule
         * @constructor
         * @param {coreproductpb.IPickRule=} [p] Properties to set
         */
        function PickRule(p) {
            this.inclusionConditions = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * PickRule min.
         * @member {number} min
         * @memberof coreproductpb.PickRule
         * @instance
         */
        PickRule.prototype.min = 0;

        /**
         * PickRule max.
         * @member {number} max
         * @memberof coreproductpb.PickRule
         * @instance
         */
        PickRule.prototype.max = 0;

        /**
         * PickRule strategy.
         * @member {coreproductpb.PickStrategy} strategy
         * @memberof coreproductpb.PickRule
         * @instance
         */
        PickRule.prototype.strategy = 0;

        /**
         * PickRule inclusionConditions.
         * @member {Array.<coreproductpb.IAttributeCondition>} inclusionConditions
         * @memberof coreproductpb.PickRule
         * @instance
         */
        PickRule.prototype.inclusionConditions = $util.emptyArray;

        /**
         * Creates a new PickRule instance using the specified properties.
         * @function create
         * @memberof coreproductpb.PickRule
         * @static
         * @param {coreproductpb.IPickRule=} [properties] Properties to set
         * @returns {coreproductpb.PickRule} PickRule instance
         */
        PickRule.create = function create(properties) {
            return new PickRule(properties);
        };

        /**
         * Encodes the specified PickRule message. Does not implicitly {@link coreproductpb.PickRule.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.PickRule
         * @static
         * @param {coreproductpb.IPickRule} m PickRule message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PickRule.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.min != null && Object.hasOwnProperty.call(m, "min"))
                w.uint32(8).int32(m.min);
            if (m.max != null && Object.hasOwnProperty.call(m, "max"))
                w.uint32(16).int32(m.max);
            if (m.strategy != null && Object.hasOwnProperty.call(m, "strategy"))
                w.uint32(24).int32(m.strategy);
            if (m.inclusionConditions != null && m.inclusionConditions.length) {
                for (var i = 0; i < m.inclusionConditions.length; ++i)
                    $root.coreproductpb.AttributeCondition.encode(m.inclusionConditions[i], w.uint32(34).fork()).ldelim();
            }
            return w;
        };

        /**
         * Decodes a PickRule message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.PickRule
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.PickRule} PickRule
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PickRule.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.PickRule();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.min = r.int32();
                    break;
                case 2:
                    m.max = r.int32();
                    break;
                case 3:
                    m.strategy = r.int32();
                    break;
                case 4:
                    if (!(m.inclusionConditions && m.inclusionConditions.length))
                        m.inclusionConditions = [];
                    m.inclusionConditions.push($root.coreproductpb.AttributeCondition.decode(r, r.uint32()));
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return PickRule;
    })();

    coreproductpb.ProductTemplate = (function() {

        /**
         * Properties of a ProductTemplate.
         * @memberof coreproductpb
         * @interface IProductTemplate
         * @property {string|null} [productTemplateID] ProductTemplate productTemplateID
         * @property {string|null} [type] ProductTemplate type
         * @property {string|null} [name] ProductTemplate name
         * @property {coreproductpb.IProductTemplateVersion|null} [currentVersion] ProductTemplate currentVersion
         * @property {Array.<coreproductpb.IProductTemplateVersion>|null} [versionHistory] ProductTemplate versionHistory
         * @property {Array.<common.IAuditTrailEntry>|null} [auditTrail] deprecated - This will provide an audit record of the template's progression through each stage.
         * @property {google.protobuf.ITimestamp|null} [createdOn] ProductTemplate createdOn
         * @property {google.protobuf.ITimestamp|null} [updatedOn] ProductTemplate updatedOn
         * @property {string|null} [createdBy] ProductTemplate createdBy
         * @property {string|null} [updatedBy] ProductTemplate updatedBy
         */

        /**
         * Constructs a new ProductTemplate.
         * @memberof coreproductpb
         * @classdesc Represents a ProductTemplate.
         * @implements IProductTemplate
         * @constructor
         * @param {coreproductpb.IProductTemplate=} [p] Properties to set
         */
        function ProductTemplate(p) {
            this.versionHistory = [];
            this.auditTrail = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * ProductTemplate productTemplateID.
         * @member {string} productTemplateID
         * @memberof coreproductpb.ProductTemplate
         * @instance
         */
        ProductTemplate.prototype.productTemplateID = "";

        /**
         * ProductTemplate type.
         * @member {string} type
         * @memberof coreproductpb.ProductTemplate
         * @instance
         */
        ProductTemplate.prototype.type = "";

        /**
         * ProductTemplate name.
         * @member {string} name
         * @memberof coreproductpb.ProductTemplate
         * @instance
         */
        ProductTemplate.prototype.name = "";

        /**
         * ProductTemplate currentVersion.
         * @member {coreproductpb.IProductTemplateVersion|null|undefined} currentVersion
         * @memberof coreproductpb.ProductTemplate
         * @instance
         */
        ProductTemplate.prototype.currentVersion = null;

        /**
         * ProductTemplate versionHistory.
         * @member {Array.<coreproductpb.IProductTemplateVersion>} versionHistory
         * @memberof coreproductpb.ProductTemplate
         * @instance
         */
        ProductTemplate.prototype.versionHistory = $util.emptyArray;

        /**
         * deprecated - This will provide an audit record of the template's progression through each stage.
         * @member {Array.<common.IAuditTrailEntry>} auditTrail
         * @memberof coreproductpb.ProductTemplate
         * @instance
         */
        ProductTemplate.prototype.auditTrail = $util.emptyArray;

        /**
         * ProductTemplate createdOn.
         * @member {google.protobuf.ITimestamp|null|undefined} createdOn
         * @memberof coreproductpb.ProductTemplate
         * @instance
         */
        ProductTemplate.prototype.createdOn = null;

        /**
         * ProductTemplate updatedOn.
         * @member {google.protobuf.ITimestamp|null|undefined} updatedOn
         * @memberof coreproductpb.ProductTemplate
         * @instance
         */
        ProductTemplate.prototype.updatedOn = null;

        /**
         * ProductTemplate createdBy.
         * @member {string} createdBy
         * @memberof coreproductpb.ProductTemplate
         * @instance
         */
        ProductTemplate.prototype.createdBy = "";

        /**
         * ProductTemplate updatedBy.
         * @member {string} updatedBy
         * @memberof coreproductpb.ProductTemplate
         * @instance
         */
        ProductTemplate.prototype.updatedBy = "";

        /**
         * Creates a new ProductTemplate instance using the specified properties.
         * @function create
         * @memberof coreproductpb.ProductTemplate
         * @static
         * @param {coreproductpb.IProductTemplate=} [properties] Properties to set
         * @returns {coreproductpb.ProductTemplate} ProductTemplate instance
         */
        ProductTemplate.create = function create(properties) {
            return new ProductTemplate(properties);
        };

        /**
         * Encodes the specified ProductTemplate message. Does not implicitly {@link coreproductpb.ProductTemplate.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.ProductTemplate
         * @static
         * @param {coreproductpb.IProductTemplate} m ProductTemplate message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ProductTemplate.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.productTemplateID != null && Object.hasOwnProperty.call(m, "productTemplateID"))
                w.uint32(10).string(m.productTemplateID);
            if (m.type != null && Object.hasOwnProperty.call(m, "type"))
                w.uint32(18).string(m.type);
            if (m.name != null && Object.hasOwnProperty.call(m, "name"))
                w.uint32(26).string(m.name);
            if (m.currentVersion != null && Object.hasOwnProperty.call(m, "currentVersion"))
                $root.coreproductpb.ProductTemplateVersion.encode(m.currentVersion, w.uint32(34).fork()).ldelim();
            if (m.versionHistory != null && m.versionHistory.length) {
                for (var i = 0; i < m.versionHistory.length; ++i)
                    $root.coreproductpb.ProductTemplateVersion.encode(m.versionHistory[i], w.uint32(42).fork()).ldelim();
            }
            if (m.auditTrail != null && m.auditTrail.length) {
                for (var i = 0; i < m.auditTrail.length; ++i)
                    $root.common.AuditTrailEntry.encode(m.auditTrail[i], w.uint32(50).fork()).ldelim();
            }
            if (m.createdOn != null && Object.hasOwnProperty.call(m, "createdOn"))
                $root.google.protobuf.Timestamp.encode(m.createdOn, w.uint32(58).fork()).ldelim();
            if (m.updatedOn != null && Object.hasOwnProperty.call(m, "updatedOn"))
                $root.google.protobuf.Timestamp.encode(m.updatedOn, w.uint32(66).fork()).ldelim();
            if (m.createdBy != null && Object.hasOwnProperty.call(m, "createdBy"))
                w.uint32(74).string(m.createdBy);
            if (m.updatedBy != null && Object.hasOwnProperty.call(m, "updatedBy"))
                w.uint32(82).string(m.updatedBy);
            return w;
        };

        /**
         * Decodes a ProductTemplate message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.ProductTemplate
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.ProductTemplate} ProductTemplate
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ProductTemplate.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.ProductTemplate();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.productTemplateID = r.string();
                    break;
                case 2:
                    m.type = r.string();
                    break;
                case 3:
                    m.name = r.string();
                    break;
                case 4:
                    m.currentVersion = $root.coreproductpb.ProductTemplateVersion.decode(r, r.uint32());
                    break;
                case 5:
                    if (!(m.versionHistory && m.versionHistory.length))
                        m.versionHistory = [];
                    m.versionHistory.push($root.coreproductpb.ProductTemplateVersion.decode(r, r.uint32()));
                    break;
                case 6:
                    if (!(m.auditTrail && m.auditTrail.length))
                        m.auditTrail = [];
                    m.auditTrail.push($root.common.AuditTrailEntry.decode(r, r.uint32()));
                    break;
                case 7:
                    m.createdOn = $root.google.protobuf.Timestamp.decode(r, r.uint32());
                    break;
                case 8:
                    m.updatedOn = $root.google.protobuf.Timestamp.decode(r, r.uint32());
                    break;
                case 9:
                    m.createdBy = r.string();
                    break;
                case 10:
                    m.updatedBy = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return ProductTemplate;
    })();

    coreproductpb.ProductTemplateExportDetails = (function() {

        /**
         * Properties of a ProductTemplateExportDetails.
         * @memberof coreproductpb
         * @interface IProductTemplateExportDetails
         * @property {coreproductpb.ExportProductTemplateStatus|null} [status] ProductTemplateExportDetails status
         * @property {string|null} [versionID] ProductTemplateExportDetails versionID
         * @property {string|null} [mediaFileID] ProductTemplateExportDetails mediaFileID
         */

        /**
         * Constructs a new ProductTemplateExportDetails.
         * @memberof coreproductpb
         * @classdesc Represents a ProductTemplateExportDetails.
         * @implements IProductTemplateExportDetails
         * @constructor
         * @param {coreproductpb.IProductTemplateExportDetails=} [p] Properties to set
         */
        function ProductTemplateExportDetails(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * ProductTemplateExportDetails status.
         * @member {coreproductpb.ExportProductTemplateStatus} status
         * @memberof coreproductpb.ProductTemplateExportDetails
         * @instance
         */
        ProductTemplateExportDetails.prototype.status = 0;

        /**
         * ProductTemplateExportDetails versionID.
         * @member {string} versionID
         * @memberof coreproductpb.ProductTemplateExportDetails
         * @instance
         */
        ProductTemplateExportDetails.prototype.versionID = "";

        /**
         * ProductTemplateExportDetails mediaFileID.
         * @member {string} mediaFileID
         * @memberof coreproductpb.ProductTemplateExportDetails
         * @instance
         */
        ProductTemplateExportDetails.prototype.mediaFileID = "";

        /**
         * Creates a new ProductTemplateExportDetails instance using the specified properties.
         * @function create
         * @memberof coreproductpb.ProductTemplateExportDetails
         * @static
         * @param {coreproductpb.IProductTemplateExportDetails=} [properties] Properties to set
         * @returns {coreproductpb.ProductTemplateExportDetails} ProductTemplateExportDetails instance
         */
        ProductTemplateExportDetails.create = function create(properties) {
            return new ProductTemplateExportDetails(properties);
        };

        /**
         * Encodes the specified ProductTemplateExportDetails message. Does not implicitly {@link coreproductpb.ProductTemplateExportDetails.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.ProductTemplateExportDetails
         * @static
         * @param {coreproductpb.IProductTemplateExportDetails} m ProductTemplateExportDetails message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ProductTemplateExportDetails.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.status != null && Object.hasOwnProperty.call(m, "status"))
                w.uint32(8).int32(m.status);
            if (m.versionID != null && Object.hasOwnProperty.call(m, "versionID"))
                w.uint32(18).string(m.versionID);
            if (m.mediaFileID != null && Object.hasOwnProperty.call(m, "mediaFileID"))
                w.uint32(26).string(m.mediaFileID);
            return w;
        };

        /**
         * Decodes a ProductTemplateExportDetails message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.ProductTemplateExportDetails
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.ProductTemplateExportDetails} ProductTemplateExportDetails
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ProductTemplateExportDetails.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.ProductTemplateExportDetails();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.status = r.int32();
                    break;
                case 2:
                    m.versionID = r.string();
                    break;
                case 3:
                    m.mediaFileID = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return ProductTemplateExportDetails;
    })();

    coreproductpb.ProductTemplateVersion = (function() {

        /**
         * Properties of a ProductTemplateVersion.
         * @memberof coreproductpb
         * @interface IProductTemplateVersion
         * @property {string|null} [description] ProductTemplateVersion description
         * @property {Array.<coreproductpb.IProductTemplateAttributeRule>|null} [attributeRules] ProductTemplateVersion attributeRules
         * @property {coreproductpb.IProductTemplateFeatureRules|null} [featureRules] ProductTemplateVersion featureRules
         * @property {coreproductpb.ProductTemplateVersionLifeCycleStage|null} [lifeCycleStage] ProductTemplateVersion lifeCycleStage
         * @property {google.protobuf.ITimestamp|null} [effectiveDate] ProductTemplateVersion effectiveDate
         * @property {google.protobuf.ITimestamp|null} [expirationDate] ProductTemplateVersion expirationDate
         * @property {google.protobuf.ITimestamp|null} [sunsetDate] ProductTemplateVersion sunsetDate
         * @property {number|Long|null} [initStarPVID] ProductTemplateVersion initStarPVID
         * @property {boolean|null} [publishToStar] ProductTemplateVersion publishToStar
         * @property {coreproductpb.PublishToStarStatus|null} [publishToStarStatus] ProductTemplateVersion publishToStarStatus
         * @property {string|null} [productTemplateVersionID] ProductTemplateVersion productTemplateVersionID
         * @property {string|null} [errorMessage] ProductTemplateVersion errorMessage
         * @property {coreproductpb.ScheduledLifecycleStageStatus|null} [scheduledLifecycleStageStatus] ProductTemplateVersion scheduledLifecycleStageStatus
         * @property {boolean|null} [isScheduledOnlyTestVersionPromotion] ProductTemplateVersion isScheduledOnlyTestVersionPromotion
         * @property {coreproductpb.IProductTemplateExportDetails|null} [exportDetails] ProductTemplateVersion exportDetails
         */

        /**
         * Constructs a new ProductTemplateVersion.
         * @memberof coreproductpb
         * @classdesc Represents a ProductTemplateVersion.
         * @implements IProductTemplateVersion
         * @constructor
         * @param {coreproductpb.IProductTemplateVersion=} [p] Properties to set
         */
        function ProductTemplateVersion(p) {
            this.attributeRules = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * ProductTemplateVersion description.
         * @member {string} description
         * @memberof coreproductpb.ProductTemplateVersion
         * @instance
         */
        ProductTemplateVersion.prototype.description = "";

        /**
         * ProductTemplateVersion attributeRules.
         * @member {Array.<coreproductpb.IProductTemplateAttributeRule>} attributeRules
         * @memberof coreproductpb.ProductTemplateVersion
         * @instance
         */
        ProductTemplateVersion.prototype.attributeRules = $util.emptyArray;

        /**
         * ProductTemplateVersion featureRules.
         * @member {coreproductpb.IProductTemplateFeatureRules|null|undefined} featureRules
         * @memberof coreproductpb.ProductTemplateVersion
         * @instance
         */
        ProductTemplateVersion.prototype.featureRules = null;

        /**
         * ProductTemplateVersion lifeCycleStage.
         * @member {coreproductpb.ProductTemplateVersionLifeCycleStage} lifeCycleStage
         * @memberof coreproductpb.ProductTemplateVersion
         * @instance
         */
        ProductTemplateVersion.prototype.lifeCycleStage = 0;

        /**
         * ProductTemplateVersion effectiveDate.
         * @member {google.protobuf.ITimestamp|null|undefined} effectiveDate
         * @memberof coreproductpb.ProductTemplateVersion
         * @instance
         */
        ProductTemplateVersion.prototype.effectiveDate = null;

        /**
         * ProductTemplateVersion expirationDate.
         * @member {google.protobuf.ITimestamp|null|undefined} expirationDate
         * @memberof coreproductpb.ProductTemplateVersion
         * @instance
         */
        ProductTemplateVersion.prototype.expirationDate = null;

        /**
         * ProductTemplateVersion sunsetDate.
         * @member {google.protobuf.ITimestamp|null|undefined} sunsetDate
         * @memberof coreproductpb.ProductTemplateVersion
         * @instance
         */
        ProductTemplateVersion.prototype.sunsetDate = null;

        /**
         * ProductTemplateVersion initStarPVID.
         * @member {number|Long} initStarPVID
         * @memberof coreproductpb.ProductTemplateVersion
         * @instance
         */
        ProductTemplateVersion.prototype.initStarPVID = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * ProductTemplateVersion publishToStar.
         * @member {boolean} publishToStar
         * @memberof coreproductpb.ProductTemplateVersion
         * @instance
         */
        ProductTemplateVersion.prototype.publishToStar = false;

        /**
         * ProductTemplateVersion publishToStarStatus.
         * @member {coreproductpb.PublishToStarStatus} publishToStarStatus
         * @memberof coreproductpb.ProductTemplateVersion
         * @instance
         */
        ProductTemplateVersion.prototype.publishToStarStatus = 0;

        /**
         * ProductTemplateVersion productTemplateVersionID.
         * @member {string} productTemplateVersionID
         * @memberof coreproductpb.ProductTemplateVersion
         * @instance
         */
        ProductTemplateVersion.prototype.productTemplateVersionID = "";

        /**
         * ProductTemplateVersion errorMessage.
         * @member {string} errorMessage
         * @memberof coreproductpb.ProductTemplateVersion
         * @instance
         */
        ProductTemplateVersion.prototype.errorMessage = "";

        /**
         * ProductTemplateVersion scheduledLifecycleStageStatus.
         * @member {coreproductpb.ScheduledLifecycleStageStatus} scheduledLifecycleStageStatus
         * @memberof coreproductpb.ProductTemplateVersion
         * @instance
         */
        ProductTemplateVersion.prototype.scheduledLifecycleStageStatus = 0;

        /**
         * ProductTemplateVersion isScheduledOnlyTestVersionPromotion.
         * @member {boolean} isScheduledOnlyTestVersionPromotion
         * @memberof coreproductpb.ProductTemplateVersion
         * @instance
         */
        ProductTemplateVersion.prototype.isScheduledOnlyTestVersionPromotion = false;

        /**
         * ProductTemplateVersion exportDetails.
         * @member {coreproductpb.IProductTemplateExportDetails|null|undefined} exportDetails
         * @memberof coreproductpb.ProductTemplateVersion
         * @instance
         */
        ProductTemplateVersion.prototype.exportDetails = null;

        /**
         * Creates a new ProductTemplateVersion instance using the specified properties.
         * @function create
         * @memberof coreproductpb.ProductTemplateVersion
         * @static
         * @param {coreproductpb.IProductTemplateVersion=} [properties] Properties to set
         * @returns {coreproductpb.ProductTemplateVersion} ProductTemplateVersion instance
         */
        ProductTemplateVersion.create = function create(properties) {
            return new ProductTemplateVersion(properties);
        };

        /**
         * Encodes the specified ProductTemplateVersion message. Does not implicitly {@link coreproductpb.ProductTemplateVersion.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.ProductTemplateVersion
         * @static
         * @param {coreproductpb.IProductTemplateVersion} m ProductTemplateVersion message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ProductTemplateVersion.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.description != null && Object.hasOwnProperty.call(m, "description"))
                w.uint32(10).string(m.description);
            if (m.attributeRules != null && m.attributeRules.length) {
                for (var i = 0; i < m.attributeRules.length; ++i)
                    $root.coreproductpb.ProductTemplateAttributeRule.encode(m.attributeRules[i], w.uint32(18).fork()).ldelim();
            }
            if (m.featureRules != null && Object.hasOwnProperty.call(m, "featureRules"))
                $root.coreproductpb.ProductTemplateFeatureRules.encode(m.featureRules, w.uint32(26).fork()).ldelim();
            if (m.lifeCycleStage != null && Object.hasOwnProperty.call(m, "lifeCycleStage"))
                w.uint32(32).int32(m.lifeCycleStage);
            if (m.effectiveDate != null && Object.hasOwnProperty.call(m, "effectiveDate"))
                $root.google.protobuf.Timestamp.encode(m.effectiveDate, w.uint32(42).fork()).ldelim();
            if (m.expirationDate != null && Object.hasOwnProperty.call(m, "expirationDate"))
                $root.google.protobuf.Timestamp.encode(m.expirationDate, w.uint32(50).fork()).ldelim();
            if (m.sunsetDate != null && Object.hasOwnProperty.call(m, "sunsetDate"))
                $root.google.protobuf.Timestamp.encode(m.sunsetDate, w.uint32(58).fork()).ldelim();
            if (m.initStarPVID != null && Object.hasOwnProperty.call(m, "initStarPVID"))
                w.uint32(64).uint64(m.initStarPVID);
            if (m.publishToStar != null && Object.hasOwnProperty.call(m, "publishToStar"))
                w.uint32(72).bool(m.publishToStar);
            if (m.publishToStarStatus != null && Object.hasOwnProperty.call(m, "publishToStarStatus"))
                w.uint32(80).int32(m.publishToStarStatus);
            if (m.productTemplateVersionID != null && Object.hasOwnProperty.call(m, "productTemplateVersionID"))
                w.uint32(90).string(m.productTemplateVersionID);
            if (m.errorMessage != null && Object.hasOwnProperty.call(m, "errorMessage"))
                w.uint32(98).string(m.errorMessage);
            if (m.scheduledLifecycleStageStatus != null && Object.hasOwnProperty.call(m, "scheduledLifecycleStageStatus"))
                w.uint32(104).int32(m.scheduledLifecycleStageStatus);
            if (m.isScheduledOnlyTestVersionPromotion != null && Object.hasOwnProperty.call(m, "isScheduledOnlyTestVersionPromotion"))
                w.uint32(112).bool(m.isScheduledOnlyTestVersionPromotion);
            if (m.exportDetails != null && Object.hasOwnProperty.call(m, "exportDetails"))
                $root.coreproductpb.ProductTemplateExportDetails.encode(m.exportDetails, w.uint32(122).fork()).ldelim();
            return w;
        };

        /**
         * Decodes a ProductTemplateVersion message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.ProductTemplateVersion
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.ProductTemplateVersion} ProductTemplateVersion
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ProductTemplateVersion.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.ProductTemplateVersion();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.description = r.string();
                    break;
                case 2:
                    if (!(m.attributeRules && m.attributeRules.length))
                        m.attributeRules = [];
                    m.attributeRules.push($root.coreproductpb.ProductTemplateAttributeRule.decode(r, r.uint32()));
                    break;
                case 3:
                    m.featureRules = $root.coreproductpb.ProductTemplateFeatureRules.decode(r, r.uint32());
                    break;
                case 4:
                    m.lifeCycleStage = r.int32();
                    break;
                case 5:
                    m.effectiveDate = $root.google.protobuf.Timestamp.decode(r, r.uint32());
                    break;
                case 6:
                    m.expirationDate = $root.google.protobuf.Timestamp.decode(r, r.uint32());
                    break;
                case 7:
                    m.sunsetDate = $root.google.protobuf.Timestamp.decode(r, r.uint32());
                    break;
                case 8:
                    m.initStarPVID = r.uint64();
                    break;
                case 9:
                    m.publishToStar = r.bool();
                    break;
                case 10:
                    m.publishToStarStatus = r.int32();
                    break;
                case 11:
                    m.productTemplateVersionID = r.string();
                    break;
                case 12:
                    m.errorMessage = r.string();
                    break;
                case 13:
                    m.scheduledLifecycleStageStatus = r.int32();
                    break;
                case 14:
                    m.isScheduledOnlyTestVersionPromotion = r.bool();
                    break;
                case 15:
                    m.exportDetails = $root.coreproductpb.ProductTemplateExportDetails.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return ProductTemplateVersion;
    })();

    coreproductpb.ProductTemplateAttributeRule = (function() {

        /**
         * Properties of a ProductTemplateAttributeRule.
         * @memberof coreproductpb
         * @interface IProductTemplateAttributeRule
         * @property {string|null} [name] ProductTemplateAttributeRule name
         * @property {Array.<coreproductpb.IValueRule>|null} [valueRules] ProductTemplateAttributeRule valueRules
         * @property {boolean|null} [causeProductFanOut] ProductTemplateAttributeRule causeProductFanOut
         */

        /**
         * Constructs a new ProductTemplateAttributeRule.
         * @memberof coreproductpb
         * @classdesc Represents a ProductTemplateAttributeRule.
         * @implements IProductTemplateAttributeRule
         * @constructor
         * @param {coreproductpb.IProductTemplateAttributeRule=} [p] Properties to set
         */
        function ProductTemplateAttributeRule(p) {
            this.valueRules = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * ProductTemplateAttributeRule name.
         * @member {string} name
         * @memberof coreproductpb.ProductTemplateAttributeRule
         * @instance
         */
        ProductTemplateAttributeRule.prototype.name = "";

        /**
         * ProductTemplateAttributeRule valueRules.
         * @member {Array.<coreproductpb.IValueRule>} valueRules
         * @memberof coreproductpb.ProductTemplateAttributeRule
         * @instance
         */
        ProductTemplateAttributeRule.prototype.valueRules = $util.emptyArray;

        /**
         * ProductTemplateAttributeRule causeProductFanOut.
         * @member {boolean} causeProductFanOut
         * @memberof coreproductpb.ProductTemplateAttributeRule
         * @instance
         */
        ProductTemplateAttributeRule.prototype.causeProductFanOut = false;

        /**
         * Creates a new ProductTemplateAttributeRule instance using the specified properties.
         * @function create
         * @memberof coreproductpb.ProductTemplateAttributeRule
         * @static
         * @param {coreproductpb.IProductTemplateAttributeRule=} [properties] Properties to set
         * @returns {coreproductpb.ProductTemplateAttributeRule} ProductTemplateAttributeRule instance
         */
        ProductTemplateAttributeRule.create = function create(properties) {
            return new ProductTemplateAttributeRule(properties);
        };

        /**
         * Encodes the specified ProductTemplateAttributeRule message. Does not implicitly {@link coreproductpb.ProductTemplateAttributeRule.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.ProductTemplateAttributeRule
         * @static
         * @param {coreproductpb.IProductTemplateAttributeRule} m ProductTemplateAttributeRule message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ProductTemplateAttributeRule.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.name != null && Object.hasOwnProperty.call(m, "name"))
                w.uint32(10).string(m.name);
            if (m.valueRules != null && m.valueRules.length) {
                for (var i = 0; i < m.valueRules.length; ++i)
                    $root.coreproductpb.ValueRule.encode(m.valueRules[i], w.uint32(18).fork()).ldelim();
            }
            if (m.causeProductFanOut != null && Object.hasOwnProperty.call(m, "causeProductFanOut"))
                w.uint32(24).bool(m.causeProductFanOut);
            return w;
        };

        /**
         * Decodes a ProductTemplateAttributeRule message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.ProductTemplateAttributeRule
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.ProductTemplateAttributeRule} ProductTemplateAttributeRule
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ProductTemplateAttributeRule.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.ProductTemplateAttributeRule();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.name = r.string();
                    break;
                case 2:
                    if (!(m.valueRules && m.valueRules.length))
                        m.valueRules = [];
                    m.valueRules.push($root.coreproductpb.ValueRule.decode(r, r.uint32()));
                    break;
                case 3:
                    m.causeProductFanOut = r.bool();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return ProductTemplateAttributeRule;
    })();

    coreproductpb.ProductTemplateFeatureRules = (function() {

        /**
         * Properties of a ProductTemplateFeatureRules.
         * @memberof coreproductpb
         * @interface IProductTemplateFeatureRules
         * @property {Array.<coreproductpb.IFeatureRule>|null} [baseFeatureRules] ProductTemplateFeatureRules baseFeatureRules
         * @property {coreproductpb.IAddOnFeatureRules|null} [addOnFeatureRules] ProductTemplateFeatureRules addOnFeatureRules
         * @property {Array.<coreproductpb.IFeatureBundleRule>|null} [baseFeatureBundleRules] ProductTemplateFeatureRules baseFeatureBundleRules
         * @property {coreproductpb.IAddOnFeatureBundleRules|null} [addOnFeatureBundleRules] ProductTemplateFeatureRules addOnFeatureBundleRules
         */

        /**
         * Constructs a new ProductTemplateFeatureRules.
         * @memberof coreproductpb
         * @classdesc Represents a ProductTemplateFeatureRules.
         * @implements IProductTemplateFeatureRules
         * @constructor
         * @param {coreproductpb.IProductTemplateFeatureRules=} [p] Properties to set
         */
        function ProductTemplateFeatureRules(p) {
            this.baseFeatureRules = [];
            this.baseFeatureBundleRules = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * ProductTemplateFeatureRules baseFeatureRules.
         * @member {Array.<coreproductpb.IFeatureRule>} baseFeatureRules
         * @memberof coreproductpb.ProductTemplateFeatureRules
         * @instance
         */
        ProductTemplateFeatureRules.prototype.baseFeatureRules = $util.emptyArray;

        /**
         * ProductTemplateFeatureRules addOnFeatureRules.
         * @member {coreproductpb.IAddOnFeatureRules|null|undefined} addOnFeatureRules
         * @memberof coreproductpb.ProductTemplateFeatureRules
         * @instance
         */
        ProductTemplateFeatureRules.prototype.addOnFeatureRules = null;

        /**
         * ProductTemplateFeatureRules baseFeatureBundleRules.
         * @member {Array.<coreproductpb.IFeatureBundleRule>} baseFeatureBundleRules
         * @memberof coreproductpb.ProductTemplateFeatureRules
         * @instance
         */
        ProductTemplateFeatureRules.prototype.baseFeatureBundleRules = $util.emptyArray;

        /**
         * ProductTemplateFeatureRules addOnFeatureBundleRules.
         * @member {coreproductpb.IAddOnFeatureBundleRules|null|undefined} addOnFeatureBundleRules
         * @memberof coreproductpb.ProductTemplateFeatureRules
         * @instance
         */
        ProductTemplateFeatureRules.prototype.addOnFeatureBundleRules = null;

        /**
         * Creates a new ProductTemplateFeatureRules instance using the specified properties.
         * @function create
         * @memberof coreproductpb.ProductTemplateFeatureRules
         * @static
         * @param {coreproductpb.IProductTemplateFeatureRules=} [properties] Properties to set
         * @returns {coreproductpb.ProductTemplateFeatureRules} ProductTemplateFeatureRules instance
         */
        ProductTemplateFeatureRules.create = function create(properties) {
            return new ProductTemplateFeatureRules(properties);
        };

        /**
         * Encodes the specified ProductTemplateFeatureRules message. Does not implicitly {@link coreproductpb.ProductTemplateFeatureRules.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.ProductTemplateFeatureRules
         * @static
         * @param {coreproductpb.IProductTemplateFeatureRules} m ProductTemplateFeatureRules message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ProductTemplateFeatureRules.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.baseFeatureRules != null && m.baseFeatureRules.length) {
                for (var i = 0; i < m.baseFeatureRules.length; ++i)
                    $root.coreproductpb.FeatureRule.encode(m.baseFeatureRules[i], w.uint32(10).fork()).ldelim();
            }
            if (m.addOnFeatureRules != null && Object.hasOwnProperty.call(m, "addOnFeatureRules"))
                $root.coreproductpb.AddOnFeatureRules.encode(m.addOnFeatureRules, w.uint32(18).fork()).ldelim();
            if (m.baseFeatureBundleRules != null && m.baseFeatureBundleRules.length) {
                for (var i = 0; i < m.baseFeatureBundleRules.length; ++i)
                    $root.coreproductpb.FeatureBundleRule.encode(m.baseFeatureBundleRules[i], w.uint32(26).fork()).ldelim();
            }
            if (m.addOnFeatureBundleRules != null && Object.hasOwnProperty.call(m, "addOnFeatureBundleRules"))
                $root.coreproductpb.AddOnFeatureBundleRules.encode(m.addOnFeatureBundleRules, w.uint32(34).fork()).ldelim();
            return w;
        };

        /**
         * Decodes a ProductTemplateFeatureRules message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.ProductTemplateFeatureRules
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.ProductTemplateFeatureRules} ProductTemplateFeatureRules
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ProductTemplateFeatureRules.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.ProductTemplateFeatureRules();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    if (!(m.baseFeatureRules && m.baseFeatureRules.length))
                        m.baseFeatureRules = [];
                    m.baseFeatureRules.push($root.coreproductpb.FeatureRule.decode(r, r.uint32()));
                    break;
                case 2:
                    m.addOnFeatureRules = $root.coreproductpb.AddOnFeatureRules.decode(r, r.uint32());
                    break;
                case 3:
                    if (!(m.baseFeatureBundleRules && m.baseFeatureBundleRules.length))
                        m.baseFeatureBundleRules = [];
                    m.baseFeatureBundleRules.push($root.coreproductpb.FeatureBundleRule.decode(r, r.uint32()));
                    break;
                case 4:
                    m.addOnFeatureBundleRules = $root.coreproductpb.AddOnFeatureBundleRules.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return ProductTemplateFeatureRules;
    })();

    coreproductpb.FeatureRule = (function() {

        /**
         * Properties of a FeatureRule.
         * @memberof coreproductpb
         * @interface IFeatureRule
         * @property {coreproductpb.FeatureMasterDataType|null} [masterDataType] FeatureRule masterDataType
         * @property {string|null} [masterDataID] FeatureRule masterDataID
         * @property {string|null} [name] FeatureRule name
         * @property {Array.<coreproductpb.IAttributeValuePair>|null} [featureAttributes] FeatureRule featureAttributes
         * @property {Array.<coreproductpb.IAttributeValueOverrideRule>|null} [productAttributeOverrideRules] FeatureRule productAttributeOverrideRules
         * @property {Array.<coreproductpb.IFeatureRule>|null} [includes] FeatureRule includes
         * @property {Array.<coreproductpb.IFeatureRule>|null} [excludes] FeatureRule excludes
         * @property {Array.<coreproductpb.IAttributeCondition>|null} [inclusionConditions] FeatureRule inclusionConditions
         */

        /**
         * Constructs a new FeatureRule.
         * @memberof coreproductpb
         * @classdesc Represents a FeatureRule.
         * @implements IFeatureRule
         * @constructor
         * @param {coreproductpb.IFeatureRule=} [p] Properties to set
         */
        function FeatureRule(p) {
            this.featureAttributes = [];
            this.productAttributeOverrideRules = [];
            this.includes = [];
            this.excludes = [];
            this.inclusionConditions = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * FeatureRule masterDataType.
         * @member {coreproductpb.FeatureMasterDataType} masterDataType
         * @memberof coreproductpb.FeatureRule
         * @instance
         */
        FeatureRule.prototype.masterDataType = 0;

        /**
         * FeatureRule masterDataID.
         * @member {string} masterDataID
         * @memberof coreproductpb.FeatureRule
         * @instance
         */
        FeatureRule.prototype.masterDataID = "";

        /**
         * FeatureRule name.
         * @member {string} name
         * @memberof coreproductpb.FeatureRule
         * @instance
         */
        FeatureRule.prototype.name = "";

        /**
         * FeatureRule featureAttributes.
         * @member {Array.<coreproductpb.IAttributeValuePair>} featureAttributes
         * @memberof coreproductpb.FeatureRule
         * @instance
         */
        FeatureRule.prototype.featureAttributes = $util.emptyArray;

        /**
         * FeatureRule productAttributeOverrideRules.
         * @member {Array.<coreproductpb.IAttributeValueOverrideRule>} productAttributeOverrideRules
         * @memberof coreproductpb.FeatureRule
         * @instance
         */
        FeatureRule.prototype.productAttributeOverrideRules = $util.emptyArray;

        /**
         * FeatureRule includes.
         * @member {Array.<coreproductpb.IFeatureRule>} includes
         * @memberof coreproductpb.FeatureRule
         * @instance
         */
        FeatureRule.prototype.includes = $util.emptyArray;

        /**
         * FeatureRule excludes.
         * @member {Array.<coreproductpb.IFeatureRule>} excludes
         * @memberof coreproductpb.FeatureRule
         * @instance
         */
        FeatureRule.prototype.excludes = $util.emptyArray;

        /**
         * FeatureRule inclusionConditions.
         * @member {Array.<coreproductpb.IAttributeCondition>} inclusionConditions
         * @memberof coreproductpb.FeatureRule
         * @instance
         */
        FeatureRule.prototype.inclusionConditions = $util.emptyArray;

        /**
         * Creates a new FeatureRule instance using the specified properties.
         * @function create
         * @memberof coreproductpb.FeatureRule
         * @static
         * @param {coreproductpb.IFeatureRule=} [properties] Properties to set
         * @returns {coreproductpb.FeatureRule} FeatureRule instance
         */
        FeatureRule.create = function create(properties) {
            return new FeatureRule(properties);
        };

        /**
         * Encodes the specified FeatureRule message. Does not implicitly {@link coreproductpb.FeatureRule.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.FeatureRule
         * @static
         * @param {coreproductpb.IFeatureRule} m FeatureRule message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        FeatureRule.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.masterDataType != null && Object.hasOwnProperty.call(m, "masterDataType"))
                w.uint32(8).int32(m.masterDataType);
            if (m.masterDataID != null && Object.hasOwnProperty.call(m, "masterDataID"))
                w.uint32(18).string(m.masterDataID);
            if (m.name != null && Object.hasOwnProperty.call(m, "name"))
                w.uint32(26).string(m.name);
            if (m.featureAttributes != null && m.featureAttributes.length) {
                for (var i = 0; i < m.featureAttributes.length; ++i)
                    $root.coreproductpb.AttributeValuePair.encode(m.featureAttributes[i], w.uint32(34).fork()).ldelim();
            }
            if (m.productAttributeOverrideRules != null && m.productAttributeOverrideRules.length) {
                for (var i = 0; i < m.productAttributeOverrideRules.length; ++i)
                    $root.coreproductpb.AttributeValueOverrideRule.encode(m.productAttributeOverrideRules[i], w.uint32(42).fork()).ldelim();
            }
            if (m.includes != null && m.includes.length) {
                for (var i = 0; i < m.includes.length; ++i)
                    $root.coreproductpb.FeatureRule.encode(m.includes[i], w.uint32(50).fork()).ldelim();
            }
            if (m.excludes != null && m.excludes.length) {
                for (var i = 0; i < m.excludes.length; ++i)
                    $root.coreproductpb.FeatureRule.encode(m.excludes[i], w.uint32(58).fork()).ldelim();
            }
            if (m.inclusionConditions != null && m.inclusionConditions.length) {
                for (var i = 0; i < m.inclusionConditions.length; ++i)
                    $root.coreproductpb.AttributeCondition.encode(m.inclusionConditions[i], w.uint32(66).fork()).ldelim();
            }
            return w;
        };

        /**
         * Decodes a FeatureRule message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.FeatureRule
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.FeatureRule} FeatureRule
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        FeatureRule.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.FeatureRule();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.masterDataType = r.int32();
                    break;
                case 2:
                    m.masterDataID = r.string();
                    break;
                case 3:
                    m.name = r.string();
                    break;
                case 4:
                    if (!(m.featureAttributes && m.featureAttributes.length))
                        m.featureAttributes = [];
                    m.featureAttributes.push($root.coreproductpb.AttributeValuePair.decode(r, r.uint32()));
                    break;
                case 5:
                    if (!(m.productAttributeOverrideRules && m.productAttributeOverrideRules.length))
                        m.productAttributeOverrideRules = [];
                    m.productAttributeOverrideRules.push($root.coreproductpb.AttributeValueOverrideRule.decode(r, r.uint32()));
                    break;
                case 6:
                    if (!(m.includes && m.includes.length))
                        m.includes = [];
                    m.includes.push($root.coreproductpb.FeatureRule.decode(r, r.uint32()));
                    break;
                case 7:
                    if (!(m.excludes && m.excludes.length))
                        m.excludes = [];
                    m.excludes.push($root.coreproductpb.FeatureRule.decode(r, r.uint32()));
                    break;
                case 8:
                    if (!(m.inclusionConditions && m.inclusionConditions.length))
                        m.inclusionConditions = [];
                    m.inclusionConditions.push($root.coreproductpb.AttributeCondition.decode(r, r.uint32()));
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return FeatureRule;
    })();

    coreproductpb.AddOnFeatureRules = (function() {

        /**
         * Properties of an AddOnFeatureRules.
         * @memberof coreproductpb
         * @interface IAddOnFeatureRules
         * @property {Array.<coreproductpb.IFeatureRule>|null} [featureRules] AddOnFeatureRules featureRules
         * @property {Array.<coreproductpb.IPickRule>|null} [pickRules] AddOnFeatureRules pickRules
         */

        /**
         * Constructs a new AddOnFeatureRules.
         * @memberof coreproductpb
         * @classdesc Represents an AddOnFeatureRules.
         * @implements IAddOnFeatureRules
         * @constructor
         * @param {coreproductpb.IAddOnFeatureRules=} [p] Properties to set
         */
        function AddOnFeatureRules(p) {
            this.featureRules = [];
            this.pickRules = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * AddOnFeatureRules featureRules.
         * @member {Array.<coreproductpb.IFeatureRule>} featureRules
         * @memberof coreproductpb.AddOnFeatureRules
         * @instance
         */
        AddOnFeatureRules.prototype.featureRules = $util.emptyArray;

        /**
         * AddOnFeatureRules pickRules.
         * @member {Array.<coreproductpb.IPickRule>} pickRules
         * @memberof coreproductpb.AddOnFeatureRules
         * @instance
         */
        AddOnFeatureRules.prototype.pickRules = $util.emptyArray;

        /**
         * Creates a new AddOnFeatureRules instance using the specified properties.
         * @function create
         * @memberof coreproductpb.AddOnFeatureRules
         * @static
         * @param {coreproductpb.IAddOnFeatureRules=} [properties] Properties to set
         * @returns {coreproductpb.AddOnFeatureRules} AddOnFeatureRules instance
         */
        AddOnFeatureRules.create = function create(properties) {
            return new AddOnFeatureRules(properties);
        };

        /**
         * Encodes the specified AddOnFeatureRules message. Does not implicitly {@link coreproductpb.AddOnFeatureRules.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.AddOnFeatureRules
         * @static
         * @param {coreproductpb.IAddOnFeatureRules} m AddOnFeatureRules message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AddOnFeatureRules.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.featureRules != null && m.featureRules.length) {
                for (var i = 0; i < m.featureRules.length; ++i)
                    $root.coreproductpb.FeatureRule.encode(m.featureRules[i], w.uint32(10).fork()).ldelim();
            }
            if (m.pickRules != null && m.pickRules.length) {
                for (var i = 0; i < m.pickRules.length; ++i)
                    $root.coreproductpb.PickRule.encode(m.pickRules[i], w.uint32(18).fork()).ldelim();
            }
            return w;
        };

        /**
         * Decodes an AddOnFeatureRules message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.AddOnFeatureRules
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.AddOnFeatureRules} AddOnFeatureRules
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AddOnFeatureRules.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.AddOnFeatureRules();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    if (!(m.featureRules && m.featureRules.length))
                        m.featureRules = [];
                    m.featureRules.push($root.coreproductpb.FeatureRule.decode(r, r.uint32()));
                    break;
                case 2:
                    if (!(m.pickRules && m.pickRules.length))
                        m.pickRules = [];
                    m.pickRules.push($root.coreproductpb.PickRule.decode(r, r.uint32()));
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return AddOnFeatureRules;
    })();

    coreproductpb.FeatureBundleRule = (function() {

        /**
         * Properties of a FeatureBundleRule.
         * @memberof coreproductpb
         * @interface IFeatureBundleRule
         * @property {string|null} [name] FeatureBundleRule name
         * @property {Array.<coreproductpb.IFeatureRule>|null} [baseFeatureRules] FeatureBundleRule baseFeatureRules
         * @property {coreproductpb.IAddOnFeatureRules|null} [addOnFeatureRules] FeatureBundleRule addOnFeatureRules
         * @property {Array.<coreproductpb.IAttributeValuePair>|null} [featureBundleAttributes] FeatureBundleRule featureBundleAttributes
         * @property {Array.<coreproductpb.IAttributeCondition>|null} [inclusionConditions] FeatureBundleRule inclusionConditions
         */

        /**
         * Constructs a new FeatureBundleRule.
         * @memberof coreproductpb
         * @classdesc Represents a FeatureBundleRule.
         * @implements IFeatureBundleRule
         * @constructor
         * @param {coreproductpb.IFeatureBundleRule=} [p] Properties to set
         */
        function FeatureBundleRule(p) {
            this.baseFeatureRules = [];
            this.featureBundleAttributes = [];
            this.inclusionConditions = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * FeatureBundleRule name.
         * @member {string} name
         * @memberof coreproductpb.FeatureBundleRule
         * @instance
         */
        FeatureBundleRule.prototype.name = "";

        /**
         * FeatureBundleRule baseFeatureRules.
         * @member {Array.<coreproductpb.IFeatureRule>} baseFeatureRules
         * @memberof coreproductpb.FeatureBundleRule
         * @instance
         */
        FeatureBundleRule.prototype.baseFeatureRules = $util.emptyArray;

        /**
         * FeatureBundleRule addOnFeatureRules.
         * @member {coreproductpb.IAddOnFeatureRules|null|undefined} addOnFeatureRules
         * @memberof coreproductpb.FeatureBundleRule
         * @instance
         */
        FeatureBundleRule.prototype.addOnFeatureRules = null;

        /**
         * FeatureBundleRule featureBundleAttributes.
         * @member {Array.<coreproductpb.IAttributeValuePair>} featureBundleAttributes
         * @memberof coreproductpb.FeatureBundleRule
         * @instance
         */
        FeatureBundleRule.prototype.featureBundleAttributes = $util.emptyArray;

        /**
         * FeatureBundleRule inclusionConditions.
         * @member {Array.<coreproductpb.IAttributeCondition>} inclusionConditions
         * @memberof coreproductpb.FeatureBundleRule
         * @instance
         */
        FeatureBundleRule.prototype.inclusionConditions = $util.emptyArray;

        /**
         * Creates a new FeatureBundleRule instance using the specified properties.
         * @function create
         * @memberof coreproductpb.FeatureBundleRule
         * @static
         * @param {coreproductpb.IFeatureBundleRule=} [properties] Properties to set
         * @returns {coreproductpb.FeatureBundleRule} FeatureBundleRule instance
         */
        FeatureBundleRule.create = function create(properties) {
            return new FeatureBundleRule(properties);
        };

        /**
         * Encodes the specified FeatureBundleRule message. Does not implicitly {@link coreproductpb.FeatureBundleRule.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.FeatureBundleRule
         * @static
         * @param {coreproductpb.IFeatureBundleRule} m FeatureBundleRule message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        FeatureBundleRule.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.name != null && Object.hasOwnProperty.call(m, "name"))
                w.uint32(10).string(m.name);
            if (m.baseFeatureRules != null && m.baseFeatureRules.length) {
                for (var i = 0; i < m.baseFeatureRules.length; ++i)
                    $root.coreproductpb.FeatureRule.encode(m.baseFeatureRules[i], w.uint32(18).fork()).ldelim();
            }
            if (m.addOnFeatureRules != null && Object.hasOwnProperty.call(m, "addOnFeatureRules"))
                $root.coreproductpb.AddOnFeatureRules.encode(m.addOnFeatureRules, w.uint32(26).fork()).ldelim();
            if (m.featureBundleAttributes != null && m.featureBundleAttributes.length) {
                for (var i = 0; i < m.featureBundleAttributes.length; ++i)
                    $root.coreproductpb.AttributeValuePair.encode(m.featureBundleAttributes[i], w.uint32(34).fork()).ldelim();
            }
            if (m.inclusionConditions != null && m.inclusionConditions.length) {
                for (var i = 0; i < m.inclusionConditions.length; ++i)
                    $root.coreproductpb.AttributeCondition.encode(m.inclusionConditions[i], w.uint32(42).fork()).ldelim();
            }
            return w;
        };

        /**
         * Decodes a FeatureBundleRule message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.FeatureBundleRule
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.FeatureBundleRule} FeatureBundleRule
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        FeatureBundleRule.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.FeatureBundleRule();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.name = r.string();
                    break;
                case 2:
                    if (!(m.baseFeatureRules && m.baseFeatureRules.length))
                        m.baseFeatureRules = [];
                    m.baseFeatureRules.push($root.coreproductpb.FeatureRule.decode(r, r.uint32()));
                    break;
                case 3:
                    m.addOnFeatureRules = $root.coreproductpb.AddOnFeatureRules.decode(r, r.uint32());
                    break;
                case 4:
                    if (!(m.featureBundleAttributes && m.featureBundleAttributes.length))
                        m.featureBundleAttributes = [];
                    m.featureBundleAttributes.push($root.coreproductpb.AttributeValuePair.decode(r, r.uint32()));
                    break;
                case 5:
                    if (!(m.inclusionConditions && m.inclusionConditions.length))
                        m.inclusionConditions = [];
                    m.inclusionConditions.push($root.coreproductpb.AttributeCondition.decode(r, r.uint32()));
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return FeatureBundleRule;
    })();

    coreproductpb.AddOnFeatureBundleRules = (function() {

        /**
         * Properties of an AddOnFeatureBundleRules.
         * @memberof coreproductpb
         * @interface IAddOnFeatureBundleRules
         * @property {Array.<coreproductpb.IFeatureBundleRule>|null} [featureBundleRules] AddOnFeatureBundleRules featureBundleRules
         * @property {Array.<coreproductpb.IPickRule>|null} [pickRules] AddOnFeatureBundleRules pickRules
         */

        /**
         * Constructs a new AddOnFeatureBundleRules.
         * @memberof coreproductpb
         * @classdesc Represents an AddOnFeatureBundleRules.
         * @implements IAddOnFeatureBundleRules
         * @constructor
         * @param {coreproductpb.IAddOnFeatureBundleRules=} [p] Properties to set
         */
        function AddOnFeatureBundleRules(p) {
            this.featureBundleRules = [];
            this.pickRules = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * AddOnFeatureBundleRules featureBundleRules.
         * @member {Array.<coreproductpb.IFeatureBundleRule>} featureBundleRules
         * @memberof coreproductpb.AddOnFeatureBundleRules
         * @instance
         */
        AddOnFeatureBundleRules.prototype.featureBundleRules = $util.emptyArray;

        /**
         * AddOnFeatureBundleRules pickRules.
         * @member {Array.<coreproductpb.IPickRule>} pickRules
         * @memberof coreproductpb.AddOnFeatureBundleRules
         * @instance
         */
        AddOnFeatureBundleRules.prototype.pickRules = $util.emptyArray;

        /**
         * Creates a new AddOnFeatureBundleRules instance using the specified properties.
         * @function create
         * @memberof coreproductpb.AddOnFeatureBundleRules
         * @static
         * @param {coreproductpb.IAddOnFeatureBundleRules=} [properties] Properties to set
         * @returns {coreproductpb.AddOnFeatureBundleRules} AddOnFeatureBundleRules instance
         */
        AddOnFeatureBundleRules.create = function create(properties) {
            return new AddOnFeatureBundleRules(properties);
        };

        /**
         * Encodes the specified AddOnFeatureBundleRules message. Does not implicitly {@link coreproductpb.AddOnFeatureBundleRules.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.AddOnFeatureBundleRules
         * @static
         * @param {coreproductpb.IAddOnFeatureBundleRules} m AddOnFeatureBundleRules message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AddOnFeatureBundleRules.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.featureBundleRules != null && m.featureBundleRules.length) {
                for (var i = 0; i < m.featureBundleRules.length; ++i)
                    $root.coreproductpb.FeatureBundleRule.encode(m.featureBundleRules[i], w.uint32(10).fork()).ldelim();
            }
            if (m.pickRules != null && m.pickRules.length) {
                for (var i = 0; i < m.pickRules.length; ++i)
                    $root.coreproductpb.PickRule.encode(m.pickRules[i], w.uint32(18).fork()).ldelim();
            }
            return w;
        };

        /**
         * Decodes an AddOnFeatureBundleRules message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.AddOnFeatureBundleRules
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.AddOnFeatureBundleRules} AddOnFeatureBundleRules
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AddOnFeatureBundleRules.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.AddOnFeatureBundleRules();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    if (!(m.featureBundleRules && m.featureBundleRules.length))
                        m.featureBundleRules = [];
                    m.featureBundleRules.push($root.coreproductpb.FeatureBundleRule.decode(r, r.uint32()));
                    break;
                case 2:
                    if (!(m.pickRules && m.pickRules.length))
                        m.pickRules = [];
                    m.pickRules.push($root.coreproductpb.PickRule.decode(r, r.uint32()));
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return AddOnFeatureBundleRules;
    })();

    coreproductpb.AttributeValue = (function() {

        /**
         * Properties of an AttributeValue.
         * @memberof coreproductpb
         * @interface IAttributeValue
         * @property {string|null} [valueID] AttributeValue valueID
         * @property {string|null} [value] AttributeValue value
         * @property {coreproductpb.DataRecordStatus|null} [status] AttributeValue status
         * @property {Object.<string,string>|null} [metadata] AttributeValue metadata
         * @property {Array.<common.IAuditTrailEntry>|null} [auditTrail] AttributeValue auditTrail
         */

        /**
         * Constructs a new AttributeValue.
         * @memberof coreproductpb
         * @classdesc Represents an AttributeValue.
         * @implements IAttributeValue
         * @constructor
         * @param {coreproductpb.IAttributeValue=} [p] Properties to set
         */
        function AttributeValue(p) {
            this.metadata = {};
            this.auditTrail = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * AttributeValue valueID.
         * @member {string} valueID
         * @memberof coreproductpb.AttributeValue
         * @instance
         */
        AttributeValue.prototype.valueID = "";

        /**
         * AttributeValue value.
         * @member {string} value
         * @memberof coreproductpb.AttributeValue
         * @instance
         */
        AttributeValue.prototype.value = "";

        /**
         * AttributeValue status.
         * @member {coreproductpb.DataRecordStatus} status
         * @memberof coreproductpb.AttributeValue
         * @instance
         */
        AttributeValue.prototype.status = 0;

        /**
         * AttributeValue metadata.
         * @member {Object.<string,string>} metadata
         * @memberof coreproductpb.AttributeValue
         * @instance
         */
        AttributeValue.prototype.metadata = $util.emptyObject;

        /**
         * AttributeValue auditTrail.
         * @member {Array.<common.IAuditTrailEntry>} auditTrail
         * @memberof coreproductpb.AttributeValue
         * @instance
         */
        AttributeValue.prototype.auditTrail = $util.emptyArray;

        /**
         * Creates a new AttributeValue instance using the specified properties.
         * @function create
         * @memberof coreproductpb.AttributeValue
         * @static
         * @param {coreproductpb.IAttributeValue=} [properties] Properties to set
         * @returns {coreproductpb.AttributeValue} AttributeValue instance
         */
        AttributeValue.create = function create(properties) {
            return new AttributeValue(properties);
        };

        /**
         * Encodes the specified AttributeValue message. Does not implicitly {@link coreproductpb.AttributeValue.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.AttributeValue
         * @static
         * @param {coreproductpb.IAttributeValue} m AttributeValue message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AttributeValue.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.valueID != null && Object.hasOwnProperty.call(m, "valueID"))
                w.uint32(10).string(m.valueID);
            if (m.value != null && Object.hasOwnProperty.call(m, "value"))
                w.uint32(18).string(m.value);
            if (m.status != null && Object.hasOwnProperty.call(m, "status"))
                w.uint32(24).int32(m.status);
            if (m.metadata != null && Object.hasOwnProperty.call(m, "metadata")) {
                for (var ks = Object.keys(m.metadata), i = 0; i < ks.length; ++i) {
                    w.uint32(34).fork().uint32(10).string(ks[i]).uint32(18).string(m.metadata[ks[i]]).ldelim();
                }
            }
            if (m.auditTrail != null && m.auditTrail.length) {
                for (var i = 0; i < m.auditTrail.length; ++i)
                    $root.common.AuditTrailEntry.encode(m.auditTrail[i], w.uint32(42).fork()).ldelim();
            }
            return w;
        };

        /**
         * Decodes an AttributeValue message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.AttributeValue
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.AttributeValue} AttributeValue
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AttributeValue.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.AttributeValue(), k, value;
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.valueID = r.string();
                    break;
                case 2:
                    m.value = r.string();
                    break;
                case 3:
                    m.status = r.int32();
                    break;
                case 4:
                    if (m.metadata === $util.emptyObject)
                        m.metadata = {};
                    var c2 = r.uint32() + r.pos;
                    k = "";
                    value = "";
                    while (r.pos < c2) {
                        var tag2 = r.uint32();
                        switch (tag2 >>> 3) {
                        case 1:
                            k = r.string();
                            break;
                        case 2:
                            value = r.string();
                            break;
                        default:
                            r.skipType(tag2 & 7);
                            break;
                        }
                    }
                    m.metadata[k] = value;
                    break;
                case 5:
                    if (!(m.auditTrail && m.auditTrail.length))
                        m.auditTrail = [];
                    m.auditTrail.push($root.common.AuditTrailEntry.decode(r, r.uint32()));
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return AttributeValue;
    })();

    coreproductpb.Attribute = (function() {

        /**
         * Properties of an Attribute.
         * @memberof coreproductpb
         * @interface IAttribute
         * @property {string|null} [name] Attribute name
         * @property {coreproductpb.DataType|null} [dataType] Attribute dataType
         * @property {coreproductpb.Attribute.AttributeType|null} [type] Attribute type
         * @property {boolean|null} [deprecated] Attribute deprecated
         * @property {Array.<string>|null} [incompatibleWith] Attribute incompatibleWith
         * @property {boolean|null} [hasAttributeValues] Attribute hasAttributeValues
         * @property {coreproductpb.Attribute.ProductFanOutSupport|null} [productFanOutSupport] Attribute productFanOutSupport
         * @property {coreproductpb.Attribute.EditableAttribute|null} [editableEffectiveAttribute] Attribute editableEffectiveAttribute
         */

        /**
         * Constructs a new Attribute.
         * @memberof coreproductpb
         * @classdesc Represents an Attribute.
         * @implements IAttribute
         * @constructor
         * @param {coreproductpb.IAttribute=} [p] Properties to set
         */
        function Attribute(p) {
            this.incompatibleWith = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * Attribute name.
         * @member {string} name
         * @memberof coreproductpb.Attribute
         * @instance
         */
        Attribute.prototype.name = "";

        /**
         * Attribute dataType.
         * @member {coreproductpb.DataType} dataType
         * @memberof coreproductpb.Attribute
         * @instance
         */
        Attribute.prototype.dataType = 0;

        /**
         * Attribute type.
         * @member {coreproductpb.Attribute.AttributeType} type
         * @memberof coreproductpb.Attribute
         * @instance
         */
        Attribute.prototype.type = 0;

        /**
         * Attribute deprecated.
         * @member {boolean} deprecated
         * @memberof coreproductpb.Attribute
         * @instance
         */
        Attribute.prototype.deprecated = false;

        /**
         * Attribute incompatibleWith.
         * @member {Array.<string>} incompatibleWith
         * @memberof coreproductpb.Attribute
         * @instance
         */
        Attribute.prototype.incompatibleWith = $util.emptyArray;

        /**
         * Attribute hasAttributeValues.
         * @member {boolean} hasAttributeValues
         * @memberof coreproductpb.Attribute
         * @instance
         */
        Attribute.prototype.hasAttributeValues = false;

        /**
         * Attribute productFanOutSupport.
         * @member {coreproductpb.Attribute.ProductFanOutSupport} productFanOutSupport
         * @memberof coreproductpb.Attribute
         * @instance
         */
        Attribute.prototype.productFanOutSupport = 0;

        /**
         * Attribute editableEffectiveAttribute.
         * @member {coreproductpb.Attribute.EditableAttribute} editableEffectiveAttribute
         * @memberof coreproductpb.Attribute
         * @instance
         */
        Attribute.prototype.editableEffectiveAttribute = 0;

        /**
         * Creates a new Attribute instance using the specified properties.
         * @function create
         * @memberof coreproductpb.Attribute
         * @static
         * @param {coreproductpb.IAttribute=} [properties] Properties to set
         * @returns {coreproductpb.Attribute} Attribute instance
         */
        Attribute.create = function create(properties) {
            return new Attribute(properties);
        };

        /**
         * Encodes the specified Attribute message. Does not implicitly {@link coreproductpb.Attribute.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.Attribute
         * @static
         * @param {coreproductpb.IAttribute} m Attribute message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Attribute.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.name != null && Object.hasOwnProperty.call(m, "name"))
                w.uint32(10).string(m.name);
            if (m.dataType != null && Object.hasOwnProperty.call(m, "dataType"))
                w.uint32(16).int32(m.dataType);
            if (m.type != null && Object.hasOwnProperty.call(m, "type"))
                w.uint32(24).int32(m.type);
            if (m.deprecated != null && Object.hasOwnProperty.call(m, "deprecated"))
                w.uint32(32).bool(m.deprecated);
            if (m.incompatibleWith != null && m.incompatibleWith.length) {
                for (var i = 0; i < m.incompatibleWith.length; ++i)
                    w.uint32(42).string(m.incompatibleWith[i]);
            }
            if (m.hasAttributeValues != null && Object.hasOwnProperty.call(m, "hasAttributeValues"))
                w.uint32(48).bool(m.hasAttributeValues);
            if (m.productFanOutSupport != null && Object.hasOwnProperty.call(m, "productFanOutSupport"))
                w.uint32(56).int32(m.productFanOutSupport);
            if (m.editableEffectiveAttribute != null && Object.hasOwnProperty.call(m, "editableEffectiveAttribute"))
                w.uint32(64).int32(m.editableEffectiveAttribute);
            return w;
        };

        /**
         * Decodes an Attribute message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.Attribute
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.Attribute} Attribute
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Attribute.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.Attribute();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.name = r.string();
                    break;
                case 2:
                    m.dataType = r.int32();
                    break;
                case 3:
                    m.type = r.int32();
                    break;
                case 4:
                    m.deprecated = r.bool();
                    break;
                case 5:
                    if (!(m.incompatibleWith && m.incompatibleWith.length))
                        m.incompatibleWith = [];
                    m.incompatibleWith.push(r.string());
                    break;
                case 6:
                    m.hasAttributeValues = r.bool();
                    break;
                case 7:
                    m.productFanOutSupport = r.int32();
                    break;
                case 8:
                    m.editableEffectiveAttribute = r.int32();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        /**
         * AttributeType enum.
         * @name coreproductpb.Attribute.AttributeType
         * @enum {number}
         * @property {number} AT_UNDEFINED=0 AT_UNDEFINED value
         * @property {number} AT_PRODUCT_TEMPLATE_AVAILABILITY_ATTRIBUTE=1 AT_PRODUCT_TEMPLATE_AVAILABILITY_ATTRIBUTE value
         * @property {number} AT_PRODUCT_AVAILABILITY_ATTRIBUTE=2 AT_PRODUCT_AVAILABILITY_ATTRIBUTE value
         * @property {number} AT_PRODUCT_SERVICEABILITY_ATTRIBUTE=3 AT_PRODUCT_SERVICEABILITY_ATTRIBUTE value
         * @property {number} AT_PRODUCT_SERVICEABILITY_DEFAULT_ATTRIBUTE=4 AT_PRODUCT_SERVICEABILITY_DEFAULT_ATTRIBUTE value
         * @property {number} AT_PRODUCT_FULFILLMENT_ATTRIBUTE=5 AT_PRODUCT_FULFILLMENT_ATTRIBUTE value
         * @property {number} AT_PRODUCT_LEGACY_ATTRIBUTE=6 AT_PRODUCT_LEGACY_ATTRIBUTE value
         * @property {number} AT_PRODUCT_MS_COVERAGE_FEATURE_ATTRIBUTE=7 AT_PRODUCT_MS_COVERAGE_FEATURE_ATTRIBUTE value
         * @property {number} AT_ITEM_MS_ITEM_FEATURE_ATTRIBUTE=8 AT_ITEM_MS_ITEM_FEATURE_ATTRIBUTE value
         * @property {number} AT_MASTER_DATA_ATTRIBUTE=9 AT_MASTER_DATA_ATTRIBUTE value
         * @property {number} AT_PRODUCT_MS_FEATURE_COVERAGE_FEATURE_ATTRIBUTE=10 AT_PRODUCT_MS_FEATURE_COVERAGE_FEATURE_ATTRIBUTE value
         * @property {number} AT_PRODUCT_MS_BUNDLE_FEATURE_ATTRIBUTE=11 AT_PRODUCT_MS_BUNDLE_FEATURE_ATTRIBUTE value
         */
        Attribute.AttributeType = (function() {
            const valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "AT_UNDEFINED"] = 0;
            values[valuesById[1] = "AT_PRODUCT_TEMPLATE_AVAILABILITY_ATTRIBUTE"] = 1;
            values[valuesById[2] = "AT_PRODUCT_AVAILABILITY_ATTRIBUTE"] = 2;
            values[valuesById[3] = "AT_PRODUCT_SERVICEABILITY_ATTRIBUTE"] = 3;
            values[valuesById[4] = "AT_PRODUCT_SERVICEABILITY_DEFAULT_ATTRIBUTE"] = 4;
            values[valuesById[5] = "AT_PRODUCT_FULFILLMENT_ATTRIBUTE"] = 5;
            values[valuesById[6] = "AT_PRODUCT_LEGACY_ATTRIBUTE"] = 6;
            values[valuesById[7] = "AT_PRODUCT_MS_COVERAGE_FEATURE_ATTRIBUTE"] = 7;
            values[valuesById[8] = "AT_ITEM_MS_ITEM_FEATURE_ATTRIBUTE"] = 8;
            values[valuesById[9] = "AT_MASTER_DATA_ATTRIBUTE"] = 9;
            values[valuesById[10] = "AT_PRODUCT_MS_FEATURE_COVERAGE_FEATURE_ATTRIBUTE"] = 10;
            values[valuesById[11] = "AT_PRODUCT_MS_BUNDLE_FEATURE_ATTRIBUTE"] = 11;
            return values;
        })();

        /**
         * ProductFanOutSupport enum.
         * @name coreproductpb.Attribute.ProductFanOutSupport
         * @enum {number}
         * @property {number} PFOS_NEVER=0 PFOS_NEVER value
         * @property {number} PFOS_OPTIONAL=1 PFOS_OPTIONAL value
         * @property {number} PFOS_ALWAYS=2 PFOS_ALWAYS value
         */
        Attribute.ProductFanOutSupport = (function() {
            const valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "PFOS_NEVER"] = 0;
            values[valuesById[1] = "PFOS_OPTIONAL"] = 1;
            values[valuesById[2] = "PFOS_ALWAYS"] = 2;
            return values;
        })();

        /**
         * EditableAttribute enum.
         * @name coreproductpb.Attribute.EditableAttribute
         * @enum {number}
         * @property {number} EA_NEVER_EDITABLE=0 EA_NEVER_EDITABLE value
         * @property {number} EA_EDITABLE=1 EA_EDITABLE value
         * @property {number} EA_NOT_EDITABLE=2 Currently, the system does not support the option to edit this item
         */
        Attribute.EditableAttribute = (function() {
            const valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "EA_NEVER_EDITABLE"] = 0;
            values[valuesById[1] = "EA_EDITABLE"] = 1;
            values[valuesById[2] = "EA_NOT_EDITABLE"] = 2;
            return values;
        })();

        return Attribute;
    })();

    coreproductpb.Configuration = (function() {

        /**
         * Properties of a Configuration.
         * @memberof coreproductpb
         * @interface IConfiguration
         * @property {Array.<coreproductpb.IAttribute>|null} [attributes] Configuration attributes
         * @property {Object.<string,coreproductpb.Configuration.IConditionalOperatorList>|null} [dataTypeToConditionalOperatorsMapping] Configuration dataTypeToConditionalOperatorsMapping
         * @property {Object.<string,coreproductpb.IProductTypeRestrictions>|null} [productTypeRestrictions] Configuration productTypeRestrictions
         */

        /**
         * Constructs a new Configuration.
         * @memberof coreproductpb
         * @classdesc Represents a Configuration.
         * @implements IConfiguration
         * @constructor
         * @param {coreproductpb.IConfiguration=} [p] Properties to set
         */
        function Configuration(p) {
            this.attributes = [];
            this.dataTypeToConditionalOperatorsMapping = {};
            this.productTypeRestrictions = {};
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * Configuration attributes.
         * @member {Array.<coreproductpb.IAttribute>} attributes
         * @memberof coreproductpb.Configuration
         * @instance
         */
        Configuration.prototype.attributes = $util.emptyArray;

        /**
         * Configuration dataTypeToConditionalOperatorsMapping.
         * @member {Object.<string,coreproductpb.Configuration.IConditionalOperatorList>} dataTypeToConditionalOperatorsMapping
         * @memberof coreproductpb.Configuration
         * @instance
         */
        Configuration.prototype.dataTypeToConditionalOperatorsMapping = $util.emptyObject;

        /**
         * Configuration productTypeRestrictions.
         * @member {Object.<string,coreproductpb.IProductTypeRestrictions>} productTypeRestrictions
         * @memberof coreproductpb.Configuration
         * @instance
         */
        Configuration.prototype.productTypeRestrictions = $util.emptyObject;

        /**
         * Creates a new Configuration instance using the specified properties.
         * @function create
         * @memberof coreproductpb.Configuration
         * @static
         * @param {coreproductpb.IConfiguration=} [properties] Properties to set
         * @returns {coreproductpb.Configuration} Configuration instance
         */
        Configuration.create = function create(properties) {
            return new Configuration(properties);
        };

        /**
         * Encodes the specified Configuration message. Does not implicitly {@link coreproductpb.Configuration.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.Configuration
         * @static
         * @param {coreproductpb.IConfiguration} m Configuration message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Configuration.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.attributes != null && m.attributes.length) {
                for (var i = 0; i < m.attributes.length; ++i)
                    $root.coreproductpb.Attribute.encode(m.attributes[i], w.uint32(10).fork()).ldelim();
            }
            if (m.dataTypeToConditionalOperatorsMapping != null && Object.hasOwnProperty.call(m, "dataTypeToConditionalOperatorsMapping")) {
                for (var ks = Object.keys(m.dataTypeToConditionalOperatorsMapping), i = 0; i < ks.length; ++i) {
                    w.uint32(18).fork().uint32(10).string(ks[i]);
                    $root.coreproductpb.Configuration.ConditionalOperatorList.encode(m.dataTypeToConditionalOperatorsMapping[ks[i]], w.uint32(18).fork()).ldelim().ldelim();
                }
            }
            if (m.productTypeRestrictions != null && Object.hasOwnProperty.call(m, "productTypeRestrictions")) {
                for (var ks = Object.keys(m.productTypeRestrictions), i = 0; i < ks.length; ++i) {
                    w.uint32(26).fork().uint32(10).string(ks[i]);
                    $root.coreproductpb.ProductTypeRestrictions.encode(m.productTypeRestrictions[ks[i]], w.uint32(18).fork()).ldelim().ldelim();
                }
            }
            return w;
        };

        /**
         * Decodes a Configuration message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.Configuration
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.Configuration} Configuration
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Configuration.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.Configuration(), k, value;
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    if (!(m.attributes && m.attributes.length))
                        m.attributes = [];
                    m.attributes.push($root.coreproductpb.Attribute.decode(r, r.uint32()));
                    break;
                case 2:
                    if (m.dataTypeToConditionalOperatorsMapping === $util.emptyObject)
                        m.dataTypeToConditionalOperatorsMapping = {};
                    var c2 = r.uint32() + r.pos;
                    k = "";
                    value = null;
                    while (r.pos < c2) {
                        var tag2 = r.uint32();
                        switch (tag2 >>> 3) {
                        case 1:
                            k = r.string();
                            break;
                        case 2:
                            value = $root.coreproductpb.Configuration.ConditionalOperatorList.decode(r, r.uint32());
                            break;
                        default:
                            r.skipType(tag2 & 7);
                            break;
                        }
                    }
                    m.dataTypeToConditionalOperatorsMapping[k] = value;
                    break;
                case 3:
                    if (m.productTypeRestrictions === $util.emptyObject)
                        m.productTypeRestrictions = {};
                    var c2 = r.uint32() + r.pos;
                    k = "";
                    value = null;
                    while (r.pos < c2) {
                        var tag2 = r.uint32();
                        switch (tag2 >>> 3) {
                        case 1:
                            k = r.string();
                            break;
                        case 2:
                            value = $root.coreproductpb.ProductTypeRestrictions.decode(r, r.uint32());
                            break;
                        default:
                            r.skipType(tag2 & 7);
                            break;
                        }
                    }
                    m.productTypeRestrictions[k] = value;
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        Configuration.ConditionalOperatorList = (function() {

            /**
             * Properties of a ConditionalOperatorList.
             * @memberof coreproductpb.Configuration
             * @interface IConditionalOperatorList
             * @property {Array.<coreproductpb.ConditionalOperator>|null} [operators] ConditionalOperatorList operators
             */

            /**
             * Constructs a new ConditionalOperatorList.
             * @memberof coreproductpb.Configuration
             * @classdesc Represents a ConditionalOperatorList.
             * @implements IConditionalOperatorList
             * @constructor
             * @param {coreproductpb.Configuration.IConditionalOperatorList=} [p] Properties to set
             */
            function ConditionalOperatorList(p) {
                this.operators = [];
                if (p)
                    for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                        if (p[ks[i]] != null)
                            this[ks[i]] = p[ks[i]];
            }

            /**
             * ConditionalOperatorList operators.
             * @member {Array.<coreproductpb.ConditionalOperator>} operators
             * @memberof coreproductpb.Configuration.ConditionalOperatorList
             * @instance
             */
            ConditionalOperatorList.prototype.operators = $util.emptyArray;

            /**
             * Creates a new ConditionalOperatorList instance using the specified properties.
             * @function create
             * @memberof coreproductpb.Configuration.ConditionalOperatorList
             * @static
             * @param {coreproductpb.Configuration.IConditionalOperatorList=} [properties] Properties to set
             * @returns {coreproductpb.Configuration.ConditionalOperatorList} ConditionalOperatorList instance
             */
            ConditionalOperatorList.create = function create(properties) {
                return new ConditionalOperatorList(properties);
            };

            /**
             * Encodes the specified ConditionalOperatorList message. Does not implicitly {@link coreproductpb.Configuration.ConditionalOperatorList.verify|verify} messages.
             * @function encode
             * @memberof coreproductpb.Configuration.ConditionalOperatorList
             * @static
             * @param {coreproductpb.Configuration.IConditionalOperatorList} m ConditionalOperatorList message or plain object to encode
             * @param {$protobuf.Writer} [w] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ConditionalOperatorList.encode = function encode(m, w) {
                if (!w)
                    w = $Writer.create();
                if (m.operators != null && m.operators.length) {
                    w.uint32(10).fork();
                    for (var i = 0; i < m.operators.length; ++i)
                        w.int32(m.operators[i]);
                    w.ldelim();
                }
                return w;
            };

            /**
             * Decodes a ConditionalOperatorList message from the specified reader or buffer.
             * @function decode
             * @memberof coreproductpb.Configuration.ConditionalOperatorList
             * @static
             * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
             * @param {number} [l] Message length if known beforehand
             * @returns {coreproductpb.Configuration.ConditionalOperatorList} ConditionalOperatorList
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ConditionalOperatorList.decode = function decode(r, l) {
                if (!(r instanceof $Reader))
                    r = $Reader.create(r);
                var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.Configuration.ConditionalOperatorList();
                while (r.pos < c) {
                    var t = r.uint32();
                    switch (t >>> 3) {
                    case 1:
                        if (!(m.operators && m.operators.length))
                            m.operators = [];
                        if ((t & 7) === 2) {
                            var c2 = r.uint32() + r.pos;
                            while (r.pos < c2)
                                m.operators.push(r.int32());
                        } else
                            m.operators.push(r.int32());
                        break;
                    default:
                        r.skipType(t & 7);
                        break;
                    }
                }
                return m;
            };

            return ConditionalOperatorList;
        })();

        return Configuration;
    })();

    coreproductpb.ProductTypeRestrictions = (function() {

        /**
         * Properties of a ProductTypeRestrictions.
         * @memberof coreproductpb
         * @interface IProductTypeRestrictions
         * @property {Array.<string>|null} [requiredAttributes] ProductTypeRestrictions requiredAttributes
         */

        /**
         * Constructs a new ProductTypeRestrictions.
         * @memberof coreproductpb
         * @classdesc Represents a ProductTypeRestrictions.
         * @implements IProductTypeRestrictions
         * @constructor
         * @param {coreproductpb.IProductTypeRestrictions=} [p] Properties to set
         */
        function ProductTypeRestrictions(p) {
            this.requiredAttributes = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * ProductTypeRestrictions requiredAttributes.
         * @member {Array.<string>} requiredAttributes
         * @memberof coreproductpb.ProductTypeRestrictions
         * @instance
         */
        ProductTypeRestrictions.prototype.requiredAttributes = $util.emptyArray;

        /**
         * Creates a new ProductTypeRestrictions instance using the specified properties.
         * @function create
         * @memberof coreproductpb.ProductTypeRestrictions
         * @static
         * @param {coreproductpb.IProductTypeRestrictions=} [properties] Properties to set
         * @returns {coreproductpb.ProductTypeRestrictions} ProductTypeRestrictions instance
         */
        ProductTypeRestrictions.create = function create(properties) {
            return new ProductTypeRestrictions(properties);
        };

        /**
         * Encodes the specified ProductTypeRestrictions message. Does not implicitly {@link coreproductpb.ProductTypeRestrictions.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.ProductTypeRestrictions
         * @static
         * @param {coreproductpb.IProductTypeRestrictions} m ProductTypeRestrictions message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ProductTypeRestrictions.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.requiredAttributes != null && m.requiredAttributes.length) {
                for (var i = 0; i < m.requiredAttributes.length; ++i)
                    w.uint32(10).string(m.requiredAttributes[i]);
            }
            return w;
        };

        /**
         * Decodes a ProductTypeRestrictions message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.ProductTypeRestrictions
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.ProductTypeRestrictions} ProductTypeRestrictions
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ProductTypeRestrictions.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.ProductTypeRestrictions();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    if (!(m.requiredAttributes && m.requiredAttributes.length))
                        m.requiredAttributes = [];
                    m.requiredAttributes.push(r.string());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return ProductTypeRestrictions;
    })();

    coreproductpb.Coverage = (function() {

        /**
         * Properties of a Coverage.
         * @memberof coreproductpb
         * @interface ICoverage
         * @property {string|null} [coverageID] Coverage coverageID
         * @property {string|null} [starCoverageID] Coverage starCoverageID
         * @property {string|null} [name] Coverage name
         * @property {string|null} [description] Coverage description
         * @property {coreproductpb.DataRecordStatus|null} [status] Coverage status
         * @property {Array.<coreproductpb.Coverage.ICoverageItem>|null} [items] Coverage items
         * @property {google.protobuf.ITimestamp|null} [createdOn] Coverage createdOn
         * @property {google.protobuf.ITimestamp|null} [updatedOn] Coverage updatedOn
         * @property {string|null} [createdBy] Coverage createdBy
         * @property {string|null} [updatedBy] Coverage updatedBy
         * @property {coreproductpb.CoverageType|null} [type] Coverage type
         * @property {Array.<string>|null} [tags] Coverage tags
         * @property {coreproductpb.Coverage.IExistInTemplates|null} [inTemplates] Coverage inTemplates
         * @property {google.protobuf.ITimestamp|null} [effectiveDate] Coverage effectiveDate
         * @property {google.protobuf.ITimestamp|null} [expirationDate] Coverage expirationDate
         */

        /**
         * Constructs a new Coverage.
         * @memberof coreproductpb
         * @classdesc Represents a Coverage.
         * @implements ICoverage
         * @constructor
         * @param {coreproductpb.ICoverage=} [p] Properties to set
         */
        function Coverage(p) {
            this.items = [];
            this.tags = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * Coverage coverageID.
         * @member {string} coverageID
         * @memberof coreproductpb.Coverage
         * @instance
         */
        Coverage.prototype.coverageID = "";

        /**
         * Coverage starCoverageID.
         * @member {string} starCoverageID
         * @memberof coreproductpb.Coverage
         * @instance
         */
        Coverage.prototype.starCoverageID = "";

        /**
         * Coverage name.
         * @member {string} name
         * @memberof coreproductpb.Coverage
         * @instance
         */
        Coverage.prototype.name = "";

        /**
         * Coverage description.
         * @member {string} description
         * @memberof coreproductpb.Coverage
         * @instance
         */
        Coverage.prototype.description = "";

        /**
         * Coverage status.
         * @member {coreproductpb.DataRecordStatus} status
         * @memberof coreproductpb.Coverage
         * @instance
         */
        Coverage.prototype.status = 0;

        /**
         * Coverage items.
         * @member {Array.<coreproductpb.Coverage.ICoverageItem>} items
         * @memberof coreproductpb.Coverage
         * @instance
         */
        Coverage.prototype.items = $util.emptyArray;

        /**
         * Coverage createdOn.
         * @member {google.protobuf.ITimestamp|null|undefined} createdOn
         * @memberof coreproductpb.Coverage
         * @instance
         */
        Coverage.prototype.createdOn = null;

        /**
         * Coverage updatedOn.
         * @member {google.protobuf.ITimestamp|null|undefined} updatedOn
         * @memberof coreproductpb.Coverage
         * @instance
         */
        Coverage.prototype.updatedOn = null;

        /**
         * Coverage createdBy.
         * @member {string} createdBy
         * @memberof coreproductpb.Coverage
         * @instance
         */
        Coverage.prototype.createdBy = "";

        /**
         * Coverage updatedBy.
         * @member {string} updatedBy
         * @memberof coreproductpb.Coverage
         * @instance
         */
        Coverage.prototype.updatedBy = "";

        /**
         * Coverage type.
         * @member {coreproductpb.CoverageType} type
         * @memberof coreproductpb.Coverage
         * @instance
         */
        Coverage.prototype.type = 0;

        /**
         * Coverage tags.
         * @member {Array.<string>} tags
         * @memberof coreproductpb.Coverage
         * @instance
         */
        Coverage.prototype.tags = $util.emptyArray;

        /**
         * Coverage inTemplates.
         * @member {coreproductpb.Coverage.IExistInTemplates|null|undefined} inTemplates
         * @memberof coreproductpb.Coverage
         * @instance
         */
        Coverage.prototype.inTemplates = null;

        /**
         * Coverage effectiveDate.
         * @member {google.protobuf.ITimestamp|null|undefined} effectiveDate
         * @memberof coreproductpb.Coverage
         * @instance
         */
        Coverage.prototype.effectiveDate = null;

        /**
         * Coverage expirationDate.
         * @member {google.protobuf.ITimestamp|null|undefined} expirationDate
         * @memberof coreproductpb.Coverage
         * @instance
         */
        Coverage.prototype.expirationDate = null;

        /**
         * Creates a new Coverage instance using the specified properties.
         * @function create
         * @memberof coreproductpb.Coverage
         * @static
         * @param {coreproductpb.ICoverage=} [properties] Properties to set
         * @returns {coreproductpb.Coverage} Coverage instance
         */
        Coverage.create = function create(properties) {
            return new Coverage(properties);
        };

        /**
         * Encodes the specified Coverage message. Does not implicitly {@link coreproductpb.Coverage.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.Coverage
         * @static
         * @param {coreproductpb.ICoverage} m Coverage message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Coverage.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.coverageID != null && Object.hasOwnProperty.call(m, "coverageID"))
                w.uint32(10).string(m.coverageID);
            if (m.starCoverageID != null && Object.hasOwnProperty.call(m, "starCoverageID"))
                w.uint32(18).string(m.starCoverageID);
            if (m.name != null && Object.hasOwnProperty.call(m, "name"))
                w.uint32(26).string(m.name);
            if (m.description != null && Object.hasOwnProperty.call(m, "description"))
                w.uint32(34).string(m.description);
            if (m.status != null && Object.hasOwnProperty.call(m, "status"))
                w.uint32(40).int32(m.status);
            if (m.items != null && m.items.length) {
                for (var i = 0; i < m.items.length; ++i)
                    $root.coreproductpb.Coverage.CoverageItem.encode(m.items[i], w.uint32(50).fork()).ldelim();
            }
            if (m.createdOn != null && Object.hasOwnProperty.call(m, "createdOn"))
                $root.google.protobuf.Timestamp.encode(m.createdOn, w.uint32(58).fork()).ldelim();
            if (m.updatedOn != null && Object.hasOwnProperty.call(m, "updatedOn"))
                $root.google.protobuf.Timestamp.encode(m.updatedOn, w.uint32(66).fork()).ldelim();
            if (m.createdBy != null && Object.hasOwnProperty.call(m, "createdBy"))
                w.uint32(74).string(m.createdBy);
            if (m.updatedBy != null && Object.hasOwnProperty.call(m, "updatedBy"))
                w.uint32(82).string(m.updatedBy);
            if (m.type != null && Object.hasOwnProperty.call(m, "type"))
                w.uint32(88).int32(m.type);
            if (m.tags != null && m.tags.length) {
                for (var i = 0; i < m.tags.length; ++i)
                    w.uint32(98).string(m.tags[i]);
            }
            if (m.inTemplates != null && Object.hasOwnProperty.call(m, "inTemplates"))
                $root.coreproductpb.Coverage.ExistInTemplates.encode(m.inTemplates, w.uint32(106).fork()).ldelim();
            if (m.effectiveDate != null && Object.hasOwnProperty.call(m, "effectiveDate"))
                $root.google.protobuf.Timestamp.encode(m.effectiveDate, w.uint32(114).fork()).ldelim();
            if (m.expirationDate != null && Object.hasOwnProperty.call(m, "expirationDate"))
                $root.google.protobuf.Timestamp.encode(m.expirationDate, w.uint32(122).fork()).ldelim();
            return w;
        };

        /**
         * Decodes a Coverage message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.Coverage
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.Coverage} Coverage
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Coverage.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.Coverage();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.coverageID = r.string();
                    break;
                case 2:
                    m.starCoverageID = r.string();
                    break;
                case 3:
                    m.name = r.string();
                    break;
                case 4:
                    m.description = r.string();
                    break;
                case 5:
                    m.status = r.int32();
                    break;
                case 6:
                    if (!(m.items && m.items.length))
                        m.items = [];
                    m.items.push($root.coreproductpb.Coverage.CoverageItem.decode(r, r.uint32()));
                    break;
                case 7:
                    m.createdOn = $root.google.protobuf.Timestamp.decode(r, r.uint32());
                    break;
                case 8:
                    m.updatedOn = $root.google.protobuf.Timestamp.decode(r, r.uint32());
                    break;
                case 9:
                    m.createdBy = r.string();
                    break;
                case 10:
                    m.updatedBy = r.string();
                    break;
                case 11:
                    m.type = r.int32();
                    break;
                case 12:
                    if (!(m.tags && m.tags.length))
                        m.tags = [];
                    m.tags.push(r.string());
                    break;
                case 13:
                    m.inTemplates = $root.coreproductpb.Coverage.ExistInTemplates.decode(r, r.uint32());
                    break;
                case 14:
                    m.effectiveDate = $root.google.protobuf.Timestamp.decode(r, r.uint32());
                    break;
                case 15:
                    m.expirationDate = $root.google.protobuf.Timestamp.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        Coverage.CoverageItem = (function() {

            /**
             * Properties of a CoverageItem.
             * @memberof coreproductpb.Coverage
             * @interface ICoverageItem
             * @property {string|null} [itemID] CoverageItem itemID
             * @property {string|null} [name] CoverageItem name
             * @property {string|null} [styleID] CoverageItem styleID
             * @property {string|null} [tradeID] CoverageItem tradeID
             * @property {string|null} [tradeCode] CoverageItem tradeCode
             * @property {number|Long|null} [starItemID] CoverageItem starItemID
             * @property {string|null} [starTradeCode] CoverageItem starTradeCode
             * @property {coreproductpb.CoverageItemType|null} [type] CoverageItem type
             */

            /**
             * Constructs a new CoverageItem.
             * @memberof coreproductpb.Coverage
             * @classdesc Represents a CoverageItem.
             * @implements ICoverageItem
             * @constructor
             * @param {coreproductpb.Coverage.ICoverageItem=} [p] Properties to set
             */
            function CoverageItem(p) {
                if (p)
                    for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                        if (p[ks[i]] != null)
                            this[ks[i]] = p[ks[i]];
            }

            /**
             * CoverageItem itemID.
             * @member {string} itemID
             * @memberof coreproductpb.Coverage.CoverageItem
             * @instance
             */
            CoverageItem.prototype.itemID = "";

            /**
             * CoverageItem name.
             * @member {string} name
             * @memberof coreproductpb.Coverage.CoverageItem
             * @instance
             */
            CoverageItem.prototype.name = "";

            /**
             * CoverageItem styleID.
             * @member {string} styleID
             * @memberof coreproductpb.Coverage.CoverageItem
             * @instance
             */
            CoverageItem.prototype.styleID = "";

            /**
             * CoverageItem tradeID.
             * @member {string} tradeID
             * @memberof coreproductpb.Coverage.CoverageItem
             * @instance
             */
            CoverageItem.prototype.tradeID = "";

            /**
             * CoverageItem tradeCode.
             * @member {string} tradeCode
             * @memberof coreproductpb.Coverage.CoverageItem
             * @instance
             */
            CoverageItem.prototype.tradeCode = "";

            /**
             * CoverageItem starItemID.
             * @member {number|Long} starItemID
             * @memberof coreproductpb.Coverage.CoverageItem
             * @instance
             */
            CoverageItem.prototype.starItemID = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

            /**
             * CoverageItem starTradeCode.
             * @member {string} starTradeCode
             * @memberof coreproductpb.Coverage.CoverageItem
             * @instance
             */
            CoverageItem.prototype.starTradeCode = "";

            /**
             * CoverageItem type.
             * @member {coreproductpb.CoverageItemType} type
             * @memberof coreproductpb.Coverage.CoverageItem
             * @instance
             */
            CoverageItem.prototype.type = 0;

            /**
             * Creates a new CoverageItem instance using the specified properties.
             * @function create
             * @memberof coreproductpb.Coverage.CoverageItem
             * @static
             * @param {coreproductpb.Coverage.ICoverageItem=} [properties] Properties to set
             * @returns {coreproductpb.Coverage.CoverageItem} CoverageItem instance
             */
            CoverageItem.create = function create(properties) {
                return new CoverageItem(properties);
            };

            /**
             * Encodes the specified CoverageItem message. Does not implicitly {@link coreproductpb.Coverage.CoverageItem.verify|verify} messages.
             * @function encode
             * @memberof coreproductpb.Coverage.CoverageItem
             * @static
             * @param {coreproductpb.Coverage.ICoverageItem} m CoverageItem message or plain object to encode
             * @param {$protobuf.Writer} [w] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            CoverageItem.encode = function encode(m, w) {
                if (!w)
                    w = $Writer.create();
                if (m.itemID != null && Object.hasOwnProperty.call(m, "itemID"))
                    w.uint32(10).string(m.itemID);
                if (m.name != null && Object.hasOwnProperty.call(m, "name"))
                    w.uint32(18).string(m.name);
                if (m.styleID != null && Object.hasOwnProperty.call(m, "styleID"))
                    w.uint32(26).string(m.styleID);
                if (m.tradeID != null && Object.hasOwnProperty.call(m, "tradeID"))
                    w.uint32(34).string(m.tradeID);
                if (m.tradeCode != null && Object.hasOwnProperty.call(m, "tradeCode"))
                    w.uint32(42).string(m.tradeCode);
                if (m.starItemID != null && Object.hasOwnProperty.call(m, "starItemID"))
                    w.uint32(48).uint64(m.starItemID);
                if (m.starTradeCode != null && Object.hasOwnProperty.call(m, "starTradeCode"))
                    w.uint32(58).string(m.starTradeCode);
                if (m.type != null && Object.hasOwnProperty.call(m, "type"))
                    w.uint32(64).int32(m.type);
                return w;
            };

            /**
             * Decodes a CoverageItem message from the specified reader or buffer.
             * @function decode
             * @memberof coreproductpb.Coverage.CoverageItem
             * @static
             * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
             * @param {number} [l] Message length if known beforehand
             * @returns {coreproductpb.Coverage.CoverageItem} CoverageItem
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            CoverageItem.decode = function decode(r, l) {
                if (!(r instanceof $Reader))
                    r = $Reader.create(r);
                var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.Coverage.CoverageItem();
                while (r.pos < c) {
                    var t = r.uint32();
                    switch (t >>> 3) {
                    case 1:
                        m.itemID = r.string();
                        break;
                    case 2:
                        m.name = r.string();
                        break;
                    case 3:
                        m.styleID = r.string();
                        break;
                    case 4:
                        m.tradeID = r.string();
                        break;
                    case 5:
                        m.tradeCode = r.string();
                        break;
                    case 6:
                        m.starItemID = r.uint64();
                        break;
                    case 7:
                        m.starTradeCode = r.string();
                        break;
                    case 8:
                        m.type = r.int32();
                        break;
                    default:
                        r.skipType(t & 7);
                        break;
                    }
                }
                return m;
            };

            return CoverageItem;
        })();

        Coverage.ExistInTemplates = (function() {

            /**
             * Properties of an ExistInTemplates.
             * @memberof coreproductpb.Coverage
             * @interface IExistInTemplates
             * @property {boolean|null} [draftTestStage] ExistInTemplates draftTestStage
             * @property {boolean|null} [effectiveStage] ExistInTemplates effectiveStage
             * @property {boolean|null} [expiredStage] ExistInTemplates expiredStage
             */

            /**
             * Constructs a new ExistInTemplates.
             * @memberof coreproductpb.Coverage
             * @classdesc Represents an ExistInTemplates.
             * @implements IExistInTemplates
             * @constructor
             * @param {coreproductpb.Coverage.IExistInTemplates=} [p] Properties to set
             */
            function ExistInTemplates(p) {
                if (p)
                    for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                        if (p[ks[i]] != null)
                            this[ks[i]] = p[ks[i]];
            }

            /**
             * ExistInTemplates draftTestStage.
             * @member {boolean} draftTestStage
             * @memberof coreproductpb.Coverage.ExistInTemplates
             * @instance
             */
            ExistInTemplates.prototype.draftTestStage = false;

            /**
             * ExistInTemplates effectiveStage.
             * @member {boolean} effectiveStage
             * @memberof coreproductpb.Coverage.ExistInTemplates
             * @instance
             */
            ExistInTemplates.prototype.effectiveStage = false;

            /**
             * ExistInTemplates expiredStage.
             * @member {boolean} expiredStage
             * @memberof coreproductpb.Coverage.ExistInTemplates
             * @instance
             */
            ExistInTemplates.prototype.expiredStage = false;

            /**
             * Creates a new ExistInTemplates instance using the specified properties.
             * @function create
             * @memberof coreproductpb.Coverage.ExistInTemplates
             * @static
             * @param {coreproductpb.Coverage.IExistInTemplates=} [properties] Properties to set
             * @returns {coreproductpb.Coverage.ExistInTemplates} ExistInTemplates instance
             */
            ExistInTemplates.create = function create(properties) {
                return new ExistInTemplates(properties);
            };

            /**
             * Encodes the specified ExistInTemplates message. Does not implicitly {@link coreproductpb.Coverage.ExistInTemplates.verify|verify} messages.
             * @function encode
             * @memberof coreproductpb.Coverage.ExistInTemplates
             * @static
             * @param {coreproductpb.Coverage.IExistInTemplates} m ExistInTemplates message or plain object to encode
             * @param {$protobuf.Writer} [w] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ExistInTemplates.encode = function encode(m, w) {
                if (!w)
                    w = $Writer.create();
                if (m.draftTestStage != null && Object.hasOwnProperty.call(m, "draftTestStage"))
                    w.uint32(8).bool(m.draftTestStage);
                if (m.effectiveStage != null && Object.hasOwnProperty.call(m, "effectiveStage"))
                    w.uint32(16).bool(m.effectiveStage);
                if (m.expiredStage != null && Object.hasOwnProperty.call(m, "expiredStage"))
                    w.uint32(24).bool(m.expiredStage);
                return w;
            };

            /**
             * Decodes an ExistInTemplates message from the specified reader or buffer.
             * @function decode
             * @memberof coreproductpb.Coverage.ExistInTemplates
             * @static
             * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
             * @param {number} [l] Message length if known beforehand
             * @returns {coreproductpb.Coverage.ExistInTemplates} ExistInTemplates
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ExistInTemplates.decode = function decode(r, l) {
                if (!(r instanceof $Reader))
                    r = $Reader.create(r);
                var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.Coverage.ExistInTemplates();
                while (r.pos < c) {
                    var t = r.uint32();
                    switch (t >>> 3) {
                    case 1:
                        m.draftTestStage = r.bool();
                        break;
                    case 2:
                        m.effectiveStage = r.bool();
                        break;
                    case 3:
                        m.expiredStage = r.bool();
                        break;
                    default:
                        r.skipType(t & 7);
                        break;
                    }
                }
                return m;
            };

            return ExistInTemplates;
        })();

        return Coverage;
    })();

    /**
     * CoverageItemType enum.
     * @name coreproductpb.CoverageItemType
     * @enum {number}
     * @property {number} CIT_UNDEFINED=0 CIT_UNDEFINED value
     * @property {number} CIT_ITEM_MS_ITEM=1 CIT_ITEM_MS_ITEM value
     * @property {number} CIT_ITEM_MS_MAINTENANCE_SERVICE=2 CIT_ITEM_MS_MAINTENANCE_SERVICE value
     */
    coreproductpb.CoverageItemType = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "CIT_UNDEFINED"] = 0;
        values[valuesById[1] = "CIT_ITEM_MS_ITEM"] = 1;
        values[valuesById[2] = "CIT_ITEM_MS_MAINTENANCE_SERVICE"] = 2;
        return values;
    })();

    coreproductpb.CreateProductTemplateRequest = (function() {

        /**
         * Properties of a CreateProductTemplateRequest.
         * @memberof coreproductpb
         * @interface ICreateProductTemplateRequest
         * @property {string|null} [type] CreateProductTemplateRequest type
         * @property {string|null} [name] CreateProductTemplateRequest name
         */

        /**
         * Constructs a new CreateProductTemplateRequest.
         * @memberof coreproductpb
         * @classdesc Represents a CreateProductTemplateRequest.
         * @implements ICreateProductTemplateRequest
         * @constructor
         * @param {coreproductpb.ICreateProductTemplateRequest=} [p] Properties to set
         */
        function CreateProductTemplateRequest(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * CreateProductTemplateRequest type.
         * @member {string} type
         * @memberof coreproductpb.CreateProductTemplateRequest
         * @instance
         */
        CreateProductTemplateRequest.prototype.type = "";

        /**
         * CreateProductTemplateRequest name.
         * @member {string} name
         * @memberof coreproductpb.CreateProductTemplateRequest
         * @instance
         */
        CreateProductTemplateRequest.prototype.name = "";

        /**
         * Creates a new CreateProductTemplateRequest instance using the specified properties.
         * @function create
         * @memberof coreproductpb.CreateProductTemplateRequest
         * @static
         * @param {coreproductpb.ICreateProductTemplateRequest=} [properties] Properties to set
         * @returns {coreproductpb.CreateProductTemplateRequest} CreateProductTemplateRequest instance
         */
        CreateProductTemplateRequest.create = function create(properties) {
            return new CreateProductTemplateRequest(properties);
        };

        /**
         * Encodes the specified CreateProductTemplateRequest message. Does not implicitly {@link coreproductpb.CreateProductTemplateRequest.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.CreateProductTemplateRequest
         * @static
         * @param {coreproductpb.ICreateProductTemplateRequest} m CreateProductTemplateRequest message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CreateProductTemplateRequest.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.type != null && Object.hasOwnProperty.call(m, "type"))
                w.uint32(10).string(m.type);
            if (m.name != null && Object.hasOwnProperty.call(m, "name"))
                w.uint32(18).string(m.name);
            return w;
        };

        /**
         * Decodes a CreateProductTemplateRequest message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.CreateProductTemplateRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.CreateProductTemplateRequest} CreateProductTemplateRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CreateProductTemplateRequest.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.CreateProductTemplateRequest();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.type = r.string();
                    break;
                case 2:
                    m.name = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return CreateProductTemplateRequest;
    })();

    coreproductpb.CreateProductTemplateResponse = (function() {

        /**
         * Properties of a CreateProductTemplateResponse.
         * @memberof coreproductpb
         * @interface ICreateProductTemplateResponse
         * @property {string|null} [productTemplateID] CreateProductTemplateResponse productTemplateID
         * @property {Array.<common.IError>|null} [errors] CreateProductTemplateResponse errors
         */

        /**
         * Constructs a new CreateProductTemplateResponse.
         * @memberof coreproductpb
         * @classdesc Represents a CreateProductTemplateResponse.
         * @implements ICreateProductTemplateResponse
         * @constructor
         * @param {coreproductpb.ICreateProductTemplateResponse=} [p] Properties to set
         */
        function CreateProductTemplateResponse(p) {
            this.errors = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * CreateProductTemplateResponse productTemplateID.
         * @member {string} productTemplateID
         * @memberof coreproductpb.CreateProductTemplateResponse
         * @instance
         */
        CreateProductTemplateResponse.prototype.productTemplateID = "";

        /**
         * CreateProductTemplateResponse errors.
         * @member {Array.<common.IError>} errors
         * @memberof coreproductpb.CreateProductTemplateResponse
         * @instance
         */
        CreateProductTemplateResponse.prototype.errors = $util.emptyArray;

        /**
         * Creates a new CreateProductTemplateResponse instance using the specified properties.
         * @function create
         * @memberof coreproductpb.CreateProductTemplateResponse
         * @static
         * @param {coreproductpb.ICreateProductTemplateResponse=} [properties] Properties to set
         * @returns {coreproductpb.CreateProductTemplateResponse} CreateProductTemplateResponse instance
         */
        CreateProductTemplateResponse.create = function create(properties) {
            return new CreateProductTemplateResponse(properties);
        };

        /**
         * Encodes the specified CreateProductTemplateResponse message. Does not implicitly {@link coreproductpb.CreateProductTemplateResponse.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.CreateProductTemplateResponse
         * @static
         * @param {coreproductpb.ICreateProductTemplateResponse} m CreateProductTemplateResponse message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CreateProductTemplateResponse.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.productTemplateID != null && Object.hasOwnProperty.call(m, "productTemplateID"))
                w.uint32(10).string(m.productTemplateID);
            if (m.errors != null && m.errors.length) {
                for (var i = 0; i < m.errors.length; ++i)
                    $root.common.Error.encode(m.errors[i], w.uint32(18).fork()).ldelim();
            }
            return w;
        };

        /**
         * Decodes a CreateProductTemplateResponse message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.CreateProductTemplateResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.CreateProductTemplateResponse} CreateProductTemplateResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CreateProductTemplateResponse.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.CreateProductTemplateResponse();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.productTemplateID = r.string();
                    break;
                case 2:
                    if (!(m.errors && m.errors.length))
                        m.errors = [];
                    m.errors.push($root.common.Error.decode(r, r.uint32()));
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return CreateProductTemplateResponse;
    })();

    coreproductpb.ReplaceProductTemplateRequest = (function() {

        /**
         * Properties of a ReplaceProductTemplateRequest.
         * @memberof coreproductpb
         * @interface IReplaceProductTemplateRequest
         * @property {string|null} [productTemplateID] ReplaceProductTemplateRequest productTemplateID
         * @property {string|null} [type] ReplaceProductTemplateRequest type
         * @property {string|null} [name] ReplaceProductTemplateRequest name
         */

        /**
         * Constructs a new ReplaceProductTemplateRequest.
         * @memberof coreproductpb
         * @classdesc Represents a ReplaceProductTemplateRequest.
         * @implements IReplaceProductTemplateRequest
         * @constructor
         * @param {coreproductpb.IReplaceProductTemplateRequest=} [p] Properties to set
         */
        function ReplaceProductTemplateRequest(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * ReplaceProductTemplateRequest productTemplateID.
         * @member {string} productTemplateID
         * @memberof coreproductpb.ReplaceProductTemplateRequest
         * @instance
         */
        ReplaceProductTemplateRequest.prototype.productTemplateID = "";

        /**
         * ReplaceProductTemplateRequest type.
         * @member {string} type
         * @memberof coreproductpb.ReplaceProductTemplateRequest
         * @instance
         */
        ReplaceProductTemplateRequest.prototype.type = "";

        /**
         * ReplaceProductTemplateRequest name.
         * @member {string} name
         * @memberof coreproductpb.ReplaceProductTemplateRequest
         * @instance
         */
        ReplaceProductTemplateRequest.prototype.name = "";

        /**
         * Creates a new ReplaceProductTemplateRequest instance using the specified properties.
         * @function create
         * @memberof coreproductpb.ReplaceProductTemplateRequest
         * @static
         * @param {coreproductpb.IReplaceProductTemplateRequest=} [properties] Properties to set
         * @returns {coreproductpb.ReplaceProductTemplateRequest} ReplaceProductTemplateRequest instance
         */
        ReplaceProductTemplateRequest.create = function create(properties) {
            return new ReplaceProductTemplateRequest(properties);
        };

        /**
         * Encodes the specified ReplaceProductTemplateRequest message. Does not implicitly {@link coreproductpb.ReplaceProductTemplateRequest.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.ReplaceProductTemplateRequest
         * @static
         * @param {coreproductpb.IReplaceProductTemplateRequest} m ReplaceProductTemplateRequest message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ReplaceProductTemplateRequest.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.productTemplateID != null && Object.hasOwnProperty.call(m, "productTemplateID"))
                w.uint32(10).string(m.productTemplateID);
            if (m.type != null && Object.hasOwnProperty.call(m, "type"))
                w.uint32(18).string(m.type);
            if (m.name != null && Object.hasOwnProperty.call(m, "name"))
                w.uint32(26).string(m.name);
            return w;
        };

        /**
         * Decodes a ReplaceProductTemplateRequest message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.ReplaceProductTemplateRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.ReplaceProductTemplateRequest} ReplaceProductTemplateRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ReplaceProductTemplateRequest.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.ReplaceProductTemplateRequest();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.productTemplateID = r.string();
                    break;
                case 2:
                    m.type = r.string();
                    break;
                case 3:
                    m.name = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return ReplaceProductTemplateRequest;
    })();

    coreproductpb.ReplaceProductTemplateResponse = (function() {

        /**
         * Properties of a ReplaceProductTemplateResponse.
         * @memberof coreproductpb
         * @interface IReplaceProductTemplateResponse
         * @property {Array.<common.IError>|null} [errors] ReplaceProductTemplateResponse errors
         */

        /**
         * Constructs a new ReplaceProductTemplateResponse.
         * @memberof coreproductpb
         * @classdesc Represents a ReplaceProductTemplateResponse.
         * @implements IReplaceProductTemplateResponse
         * @constructor
         * @param {coreproductpb.IReplaceProductTemplateResponse=} [p] Properties to set
         */
        function ReplaceProductTemplateResponse(p) {
            this.errors = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * ReplaceProductTemplateResponse errors.
         * @member {Array.<common.IError>} errors
         * @memberof coreproductpb.ReplaceProductTemplateResponse
         * @instance
         */
        ReplaceProductTemplateResponse.prototype.errors = $util.emptyArray;

        /**
         * Creates a new ReplaceProductTemplateResponse instance using the specified properties.
         * @function create
         * @memberof coreproductpb.ReplaceProductTemplateResponse
         * @static
         * @param {coreproductpb.IReplaceProductTemplateResponse=} [properties] Properties to set
         * @returns {coreproductpb.ReplaceProductTemplateResponse} ReplaceProductTemplateResponse instance
         */
        ReplaceProductTemplateResponse.create = function create(properties) {
            return new ReplaceProductTemplateResponse(properties);
        };

        /**
         * Encodes the specified ReplaceProductTemplateResponse message. Does not implicitly {@link coreproductpb.ReplaceProductTemplateResponse.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.ReplaceProductTemplateResponse
         * @static
         * @param {coreproductpb.IReplaceProductTemplateResponse} m ReplaceProductTemplateResponse message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ReplaceProductTemplateResponse.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.errors != null && m.errors.length) {
                for (var i = 0; i < m.errors.length; ++i)
                    $root.common.Error.encode(m.errors[i], w.uint32(10).fork()).ldelim();
            }
            return w;
        };

        /**
         * Decodes a ReplaceProductTemplateResponse message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.ReplaceProductTemplateResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.ReplaceProductTemplateResponse} ReplaceProductTemplateResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ReplaceProductTemplateResponse.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.ReplaceProductTemplateResponse();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    if (!(m.errors && m.errors.length))
                        m.errors = [];
                    m.errors.push($root.common.Error.decode(r, r.uint32()));
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return ReplaceProductTemplateResponse;
    })();

    coreproductpb.ProductTemplatesRequest = (function() {

        /**
         * Properties of a ProductTemplatesRequest.
         * @memberof coreproductpb
         * @interface IProductTemplatesRequest
         * @property {string|null} [productTemplateID] ProductTemplatesRequest productTemplateID
         * @property {boolean|null} [includeAuditTrail] ProductTemplatesRequest includeAuditTrail
         * @property {boolean|null} [includeVersionHistory] ProductTemplatesRequest includeVersionHistory
         * @property {boolean|null} [includeAttributeRules] ProductTemplatesRequest includeAttributeRules
         * @property {boolean|null} [includeFeatureRules] ProductTemplatesRequest includeFeatureRules
         * @property {boolean|null} [includeExportDetails] ProductTemplatesRequest includeExportDetails
         * @property {common.IPaginationRequest|null} [pagination] ProductTemplatesRequest pagination
         * @property {coreproductpb.IProductTemplatesProductType|null} [productType] ProductTemplatesRequest productType
         * @property {string|null} [featureMasterDataID] ProductTemplatesRequest featureMasterDataID
         * @property {string|null} [searchProductTemplateName] ProductTemplatesRequest searchProductTemplateName
         * @property {Array.<string>|null} [searchByBrands] ProductTemplatesRequest searchByBrands
         */

        /**
         * Constructs a new ProductTemplatesRequest.
         * @memberof coreproductpb
         * @classdesc Represents a ProductTemplatesRequest.
         * @implements IProductTemplatesRequest
         * @constructor
         * @param {coreproductpb.IProductTemplatesRequest=} [p] Properties to set
         */
        function ProductTemplatesRequest(p) {
            this.searchByBrands = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * ProductTemplatesRequest productTemplateID.
         * @member {string} productTemplateID
         * @memberof coreproductpb.ProductTemplatesRequest
         * @instance
         */
        ProductTemplatesRequest.prototype.productTemplateID = "";

        /**
         * ProductTemplatesRequest includeAuditTrail.
         * @member {boolean} includeAuditTrail
         * @memberof coreproductpb.ProductTemplatesRequest
         * @instance
         */
        ProductTemplatesRequest.prototype.includeAuditTrail = false;

        /**
         * ProductTemplatesRequest includeVersionHistory.
         * @member {boolean} includeVersionHistory
         * @memberof coreproductpb.ProductTemplatesRequest
         * @instance
         */
        ProductTemplatesRequest.prototype.includeVersionHistory = false;

        /**
         * ProductTemplatesRequest includeAttributeRules.
         * @member {boolean} includeAttributeRules
         * @memberof coreproductpb.ProductTemplatesRequest
         * @instance
         */
        ProductTemplatesRequest.prototype.includeAttributeRules = false;

        /**
         * ProductTemplatesRequest includeFeatureRules.
         * @member {boolean} includeFeatureRules
         * @memberof coreproductpb.ProductTemplatesRequest
         * @instance
         */
        ProductTemplatesRequest.prototype.includeFeatureRules = false;

        /**
         * ProductTemplatesRequest includeExportDetails.
         * @member {boolean} includeExportDetails
         * @memberof coreproductpb.ProductTemplatesRequest
         * @instance
         */
        ProductTemplatesRequest.prototype.includeExportDetails = false;

        /**
         * ProductTemplatesRequest pagination.
         * @member {common.IPaginationRequest|null|undefined} pagination
         * @memberof coreproductpb.ProductTemplatesRequest
         * @instance
         */
        ProductTemplatesRequest.prototype.pagination = null;

        /**
         * ProductTemplatesRequest productType.
         * @member {coreproductpb.IProductTemplatesProductType|null|undefined} productType
         * @memberof coreproductpb.ProductTemplatesRequest
         * @instance
         */
        ProductTemplatesRequest.prototype.productType = null;

        /**
         * ProductTemplatesRequest featureMasterDataID.
         * @member {string} featureMasterDataID
         * @memberof coreproductpb.ProductTemplatesRequest
         * @instance
         */
        ProductTemplatesRequest.prototype.featureMasterDataID = "";

        /**
         * ProductTemplatesRequest searchProductTemplateName.
         * @member {string} searchProductTemplateName
         * @memberof coreproductpb.ProductTemplatesRequest
         * @instance
         */
        ProductTemplatesRequest.prototype.searchProductTemplateName = "";

        /**
         * ProductTemplatesRequest searchByBrands.
         * @member {Array.<string>} searchByBrands
         * @memberof coreproductpb.ProductTemplatesRequest
         * @instance
         */
        ProductTemplatesRequest.prototype.searchByBrands = $util.emptyArray;

        /**
         * Creates a new ProductTemplatesRequest instance using the specified properties.
         * @function create
         * @memberof coreproductpb.ProductTemplatesRequest
         * @static
         * @param {coreproductpb.IProductTemplatesRequest=} [properties] Properties to set
         * @returns {coreproductpb.ProductTemplatesRequest} ProductTemplatesRequest instance
         */
        ProductTemplatesRequest.create = function create(properties) {
            return new ProductTemplatesRequest(properties);
        };

        /**
         * Encodes the specified ProductTemplatesRequest message. Does not implicitly {@link coreproductpb.ProductTemplatesRequest.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.ProductTemplatesRequest
         * @static
         * @param {coreproductpb.IProductTemplatesRequest} m ProductTemplatesRequest message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ProductTemplatesRequest.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.productTemplateID != null && Object.hasOwnProperty.call(m, "productTemplateID"))
                w.uint32(10).string(m.productTemplateID);
            if (m.includeAuditTrail != null && Object.hasOwnProperty.call(m, "includeAuditTrail"))
                w.uint32(16).bool(m.includeAuditTrail);
            if (m.includeVersionHistory != null && Object.hasOwnProperty.call(m, "includeVersionHistory"))
                w.uint32(24).bool(m.includeVersionHistory);
            if (m.includeAttributeRules != null && Object.hasOwnProperty.call(m, "includeAttributeRules"))
                w.uint32(32).bool(m.includeAttributeRules);
            if (m.includeFeatureRules != null && Object.hasOwnProperty.call(m, "includeFeatureRules"))
                w.uint32(40).bool(m.includeFeatureRules);
            if (m.includeExportDetails != null && Object.hasOwnProperty.call(m, "includeExportDetails"))
                w.uint32(48).bool(m.includeExportDetails);
            if (m.pagination != null && Object.hasOwnProperty.call(m, "pagination"))
                $root.common.PaginationRequest.encode(m.pagination, w.uint32(58).fork()).ldelim();
            if (m.productType != null && Object.hasOwnProperty.call(m, "productType"))
                $root.coreproductpb.ProductTemplatesProductType.encode(m.productType, w.uint32(66).fork()).ldelim();
            if (m.featureMasterDataID != null && Object.hasOwnProperty.call(m, "featureMasterDataID"))
                w.uint32(74).string(m.featureMasterDataID);
            if (m.searchProductTemplateName != null && Object.hasOwnProperty.call(m, "searchProductTemplateName"))
                w.uint32(82).string(m.searchProductTemplateName);
            if (m.searchByBrands != null && m.searchByBrands.length) {
                for (var i = 0; i < m.searchByBrands.length; ++i)
                    w.uint32(90).string(m.searchByBrands[i]);
            }
            return w;
        };

        /**
         * Decodes a ProductTemplatesRequest message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.ProductTemplatesRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.ProductTemplatesRequest} ProductTemplatesRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ProductTemplatesRequest.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.ProductTemplatesRequest();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.productTemplateID = r.string();
                    break;
                case 2:
                    m.includeAuditTrail = r.bool();
                    break;
                case 3:
                    m.includeVersionHistory = r.bool();
                    break;
                case 4:
                    m.includeAttributeRules = r.bool();
                    break;
                case 5:
                    m.includeFeatureRules = r.bool();
                    break;
                case 6:
                    m.includeExportDetails = r.bool();
                    break;
                case 7:
                    m.pagination = $root.common.PaginationRequest.decode(r, r.uint32());
                    break;
                case 8:
                    m.productType = $root.coreproductpb.ProductTemplatesProductType.decode(r, r.uint32());
                    break;
                case 9:
                    m.featureMasterDataID = r.string();
                    break;
                case 10:
                    m.searchProductTemplateName = r.string();
                    break;
                case 11:
                    if (!(m.searchByBrands && m.searchByBrands.length))
                        m.searchByBrands = [];
                    m.searchByBrands.push(r.string());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return ProductTemplatesRequest;
    })();

    coreproductpb.ProductTemplatesProductType = (function() {

        /**
         * Properties of a ProductTemplatesProductType.
         * @memberof coreproductpb
         * @interface IProductTemplatesProductType
         * @property {string|null} [productTypeID] ProductTemplatesProductType productTypeID
         * @property {string|null} [starProductTypeID] ProductTemplatesProductType starProductTypeID
         */

        /**
         * Constructs a new ProductTemplatesProductType.
         * @memberof coreproductpb
         * @classdesc Represents a ProductTemplatesProductType.
         * @implements IProductTemplatesProductType
         * @constructor
         * @param {coreproductpb.IProductTemplatesProductType=} [p] Properties to set
         */
        function ProductTemplatesProductType(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * ProductTemplatesProductType productTypeID.
         * @member {string} productTypeID
         * @memberof coreproductpb.ProductTemplatesProductType
         * @instance
         */
        ProductTemplatesProductType.prototype.productTypeID = "";

        /**
         * ProductTemplatesProductType starProductTypeID.
         * @member {string} starProductTypeID
         * @memberof coreproductpb.ProductTemplatesProductType
         * @instance
         */
        ProductTemplatesProductType.prototype.starProductTypeID = "";

        /**
         * Creates a new ProductTemplatesProductType instance using the specified properties.
         * @function create
         * @memberof coreproductpb.ProductTemplatesProductType
         * @static
         * @param {coreproductpb.IProductTemplatesProductType=} [properties] Properties to set
         * @returns {coreproductpb.ProductTemplatesProductType} ProductTemplatesProductType instance
         */
        ProductTemplatesProductType.create = function create(properties) {
            return new ProductTemplatesProductType(properties);
        };

        /**
         * Encodes the specified ProductTemplatesProductType message. Does not implicitly {@link coreproductpb.ProductTemplatesProductType.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.ProductTemplatesProductType
         * @static
         * @param {coreproductpb.IProductTemplatesProductType} m ProductTemplatesProductType message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ProductTemplatesProductType.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.productTypeID != null && Object.hasOwnProperty.call(m, "productTypeID"))
                w.uint32(10).string(m.productTypeID);
            if (m.starProductTypeID != null && Object.hasOwnProperty.call(m, "starProductTypeID"))
                w.uint32(18).string(m.starProductTypeID);
            return w;
        };

        /**
         * Decodes a ProductTemplatesProductType message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.ProductTemplatesProductType
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.ProductTemplatesProductType} ProductTemplatesProductType
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ProductTemplatesProductType.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.ProductTemplatesProductType();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.productTypeID = r.string();
                    break;
                case 2:
                    m.starProductTypeID = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return ProductTemplatesProductType;
    })();

    coreproductpb.ProductTemplatesResponse = (function() {

        /**
         * Properties of a ProductTemplatesResponse.
         * @memberof coreproductpb
         * @interface IProductTemplatesResponse
         * @property {Array.<coreproductpb.IProductTemplate>|null} [productTemplates] ProductTemplatesResponse productTemplates
         * @property {Array.<common.IError>|null} [errors] ProductTemplatesResponse errors
         * @property {common.IPagination|null} [pagination] ProductTemplatesResponse pagination
         */

        /**
         * Constructs a new ProductTemplatesResponse.
         * @memberof coreproductpb
         * @classdesc Represents a ProductTemplatesResponse.
         * @implements IProductTemplatesResponse
         * @constructor
         * @param {coreproductpb.IProductTemplatesResponse=} [p] Properties to set
         */
        function ProductTemplatesResponse(p) {
            this.productTemplates = [];
            this.errors = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * ProductTemplatesResponse productTemplates.
         * @member {Array.<coreproductpb.IProductTemplate>} productTemplates
         * @memberof coreproductpb.ProductTemplatesResponse
         * @instance
         */
        ProductTemplatesResponse.prototype.productTemplates = $util.emptyArray;

        /**
         * ProductTemplatesResponse errors.
         * @member {Array.<common.IError>} errors
         * @memberof coreproductpb.ProductTemplatesResponse
         * @instance
         */
        ProductTemplatesResponse.prototype.errors = $util.emptyArray;

        /**
         * ProductTemplatesResponse pagination.
         * @member {common.IPagination|null|undefined} pagination
         * @memberof coreproductpb.ProductTemplatesResponse
         * @instance
         */
        ProductTemplatesResponse.prototype.pagination = null;

        /**
         * Creates a new ProductTemplatesResponse instance using the specified properties.
         * @function create
         * @memberof coreproductpb.ProductTemplatesResponse
         * @static
         * @param {coreproductpb.IProductTemplatesResponse=} [properties] Properties to set
         * @returns {coreproductpb.ProductTemplatesResponse} ProductTemplatesResponse instance
         */
        ProductTemplatesResponse.create = function create(properties) {
            return new ProductTemplatesResponse(properties);
        };

        /**
         * Encodes the specified ProductTemplatesResponse message. Does not implicitly {@link coreproductpb.ProductTemplatesResponse.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.ProductTemplatesResponse
         * @static
         * @param {coreproductpb.IProductTemplatesResponse} m ProductTemplatesResponse message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ProductTemplatesResponse.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.productTemplates != null && m.productTemplates.length) {
                for (var i = 0; i < m.productTemplates.length; ++i)
                    $root.coreproductpb.ProductTemplate.encode(m.productTemplates[i], w.uint32(10).fork()).ldelim();
            }
            if (m.errors != null && m.errors.length) {
                for (var i = 0; i < m.errors.length; ++i)
                    $root.common.Error.encode(m.errors[i], w.uint32(18).fork()).ldelim();
            }
            if (m.pagination != null && Object.hasOwnProperty.call(m, "pagination"))
                $root.common.Pagination.encode(m.pagination, w.uint32(26).fork()).ldelim();
            return w;
        };

        /**
         * Decodes a ProductTemplatesResponse message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.ProductTemplatesResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.ProductTemplatesResponse} ProductTemplatesResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ProductTemplatesResponse.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.ProductTemplatesResponse();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    if (!(m.productTemplates && m.productTemplates.length))
                        m.productTemplates = [];
                    m.productTemplates.push($root.coreproductpb.ProductTemplate.decode(r, r.uint32()));
                    break;
                case 2:
                    if (!(m.errors && m.errors.length))
                        m.errors = [];
                    m.errors.push($root.common.Error.decode(r, r.uint32()));
                    break;
                case 3:
                    m.pagination = $root.common.Pagination.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return ProductTemplatesResponse;
    })();

    coreproductpb.ReplaceProductTemplateVersionRequest = (function() {

        /**
         * Properties of a ReplaceProductTemplateVersionRequest.
         * @memberof coreproductpb
         * @interface IReplaceProductTemplateVersionRequest
         * @property {string|null} [productTemplateID] ReplaceProductTemplateVersionRequest productTemplateID
         * @property {string|null} [description] ReplaceProductTemplateVersionRequest description
         * @property {boolean|null} [publishToStar] ReplaceProductTemplateVersionRequest publishToStar
         * @property {Array.<coreproductpb.IProductTemplateAttributeRule>|null} [attributeRules] ReplaceProductTemplateVersionRequest attributeRules
         * @property {coreproductpb.IProductTemplateFeatureRules|null} [featureRules] ReplaceProductTemplateVersionRequest featureRules
         * @property {google.protobuf.ITimestamp|null} [effectiveDate] ReplaceProductTemplateVersionRequest effectiveDate
         * @property {google.protobuf.ITimestamp|null} [expirationDate] ReplaceProductTemplateVersionRequest expirationDate
         */

        /**
         * Constructs a new ReplaceProductTemplateVersionRequest.
         * @memberof coreproductpb
         * @classdesc Represents a ReplaceProductTemplateVersionRequest.
         * @implements IReplaceProductTemplateVersionRequest
         * @constructor
         * @param {coreproductpb.IReplaceProductTemplateVersionRequest=} [p] Properties to set
         */
        function ReplaceProductTemplateVersionRequest(p) {
            this.attributeRules = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * ReplaceProductTemplateVersionRequest productTemplateID.
         * @member {string} productTemplateID
         * @memberof coreproductpb.ReplaceProductTemplateVersionRequest
         * @instance
         */
        ReplaceProductTemplateVersionRequest.prototype.productTemplateID = "";

        /**
         * ReplaceProductTemplateVersionRequest description.
         * @member {string} description
         * @memberof coreproductpb.ReplaceProductTemplateVersionRequest
         * @instance
         */
        ReplaceProductTemplateVersionRequest.prototype.description = "";

        /**
         * ReplaceProductTemplateVersionRequest publishToStar.
         * @member {boolean} publishToStar
         * @memberof coreproductpb.ReplaceProductTemplateVersionRequest
         * @instance
         */
        ReplaceProductTemplateVersionRequest.prototype.publishToStar = false;

        /**
         * ReplaceProductTemplateVersionRequest attributeRules.
         * @member {Array.<coreproductpb.IProductTemplateAttributeRule>} attributeRules
         * @memberof coreproductpb.ReplaceProductTemplateVersionRequest
         * @instance
         */
        ReplaceProductTemplateVersionRequest.prototype.attributeRules = $util.emptyArray;

        /**
         * ReplaceProductTemplateVersionRequest featureRules.
         * @member {coreproductpb.IProductTemplateFeatureRules|null|undefined} featureRules
         * @memberof coreproductpb.ReplaceProductTemplateVersionRequest
         * @instance
         */
        ReplaceProductTemplateVersionRequest.prototype.featureRules = null;

        /**
         * ReplaceProductTemplateVersionRequest effectiveDate.
         * @member {google.protobuf.ITimestamp|null|undefined} effectiveDate
         * @memberof coreproductpb.ReplaceProductTemplateVersionRequest
         * @instance
         */
        ReplaceProductTemplateVersionRequest.prototype.effectiveDate = null;

        /**
         * ReplaceProductTemplateVersionRequest expirationDate.
         * @member {google.protobuf.ITimestamp|null|undefined} expirationDate
         * @memberof coreproductpb.ReplaceProductTemplateVersionRequest
         * @instance
         */
        ReplaceProductTemplateVersionRequest.prototype.expirationDate = null;

        /**
         * Creates a new ReplaceProductTemplateVersionRequest instance using the specified properties.
         * @function create
         * @memberof coreproductpb.ReplaceProductTemplateVersionRequest
         * @static
         * @param {coreproductpb.IReplaceProductTemplateVersionRequest=} [properties] Properties to set
         * @returns {coreproductpb.ReplaceProductTemplateVersionRequest} ReplaceProductTemplateVersionRequest instance
         */
        ReplaceProductTemplateVersionRequest.create = function create(properties) {
            return new ReplaceProductTemplateVersionRequest(properties);
        };

        /**
         * Encodes the specified ReplaceProductTemplateVersionRequest message. Does not implicitly {@link coreproductpb.ReplaceProductTemplateVersionRequest.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.ReplaceProductTemplateVersionRequest
         * @static
         * @param {coreproductpb.IReplaceProductTemplateVersionRequest} m ReplaceProductTemplateVersionRequest message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ReplaceProductTemplateVersionRequest.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.productTemplateID != null && Object.hasOwnProperty.call(m, "productTemplateID"))
                w.uint32(10).string(m.productTemplateID);
            if (m.description != null && Object.hasOwnProperty.call(m, "description"))
                w.uint32(18).string(m.description);
            if (m.publishToStar != null && Object.hasOwnProperty.call(m, "publishToStar"))
                w.uint32(24).bool(m.publishToStar);
            if (m.attributeRules != null && m.attributeRules.length) {
                for (var i = 0; i < m.attributeRules.length; ++i)
                    $root.coreproductpb.ProductTemplateAttributeRule.encode(m.attributeRules[i], w.uint32(34).fork()).ldelim();
            }
            if (m.featureRules != null && Object.hasOwnProperty.call(m, "featureRules"))
                $root.coreproductpb.ProductTemplateFeatureRules.encode(m.featureRules, w.uint32(42).fork()).ldelim();
            if (m.effectiveDate != null && Object.hasOwnProperty.call(m, "effectiveDate"))
                $root.google.protobuf.Timestamp.encode(m.effectiveDate, w.uint32(50).fork()).ldelim();
            if (m.expirationDate != null && Object.hasOwnProperty.call(m, "expirationDate"))
                $root.google.protobuf.Timestamp.encode(m.expirationDate, w.uint32(58).fork()).ldelim();
            return w;
        };

        /**
         * Decodes a ReplaceProductTemplateVersionRequest message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.ReplaceProductTemplateVersionRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.ReplaceProductTemplateVersionRequest} ReplaceProductTemplateVersionRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ReplaceProductTemplateVersionRequest.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.ReplaceProductTemplateVersionRequest();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.productTemplateID = r.string();
                    break;
                case 2:
                    m.description = r.string();
                    break;
                case 3:
                    m.publishToStar = r.bool();
                    break;
                case 4:
                    if (!(m.attributeRules && m.attributeRules.length))
                        m.attributeRules = [];
                    m.attributeRules.push($root.coreproductpb.ProductTemplateAttributeRule.decode(r, r.uint32()));
                    break;
                case 5:
                    m.featureRules = $root.coreproductpb.ProductTemplateFeatureRules.decode(r, r.uint32());
                    break;
                case 6:
                    m.effectiveDate = $root.google.protobuf.Timestamp.decode(r, r.uint32());
                    break;
                case 7:
                    m.expirationDate = $root.google.protobuf.Timestamp.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return ReplaceProductTemplateVersionRequest;
    })();

    coreproductpb.ReplaceProductTemplateVersionResponse = (function() {

        /**
         * Properties of a ReplaceProductTemplateVersionResponse.
         * @memberof coreproductpb
         * @interface IReplaceProductTemplateVersionResponse
         * @property {Array.<common.IError>|null} [errors] ReplaceProductTemplateVersionResponse errors
         */

        /**
         * Constructs a new ReplaceProductTemplateVersionResponse.
         * @memberof coreproductpb
         * @classdesc Represents a ReplaceProductTemplateVersionResponse.
         * @implements IReplaceProductTemplateVersionResponse
         * @constructor
         * @param {coreproductpb.IReplaceProductTemplateVersionResponse=} [p] Properties to set
         */
        function ReplaceProductTemplateVersionResponse(p) {
            this.errors = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * ReplaceProductTemplateVersionResponse errors.
         * @member {Array.<common.IError>} errors
         * @memberof coreproductpb.ReplaceProductTemplateVersionResponse
         * @instance
         */
        ReplaceProductTemplateVersionResponse.prototype.errors = $util.emptyArray;

        /**
         * Creates a new ReplaceProductTemplateVersionResponse instance using the specified properties.
         * @function create
         * @memberof coreproductpb.ReplaceProductTemplateVersionResponse
         * @static
         * @param {coreproductpb.IReplaceProductTemplateVersionResponse=} [properties] Properties to set
         * @returns {coreproductpb.ReplaceProductTemplateVersionResponse} ReplaceProductTemplateVersionResponse instance
         */
        ReplaceProductTemplateVersionResponse.create = function create(properties) {
            return new ReplaceProductTemplateVersionResponse(properties);
        };

        /**
         * Encodes the specified ReplaceProductTemplateVersionResponse message. Does not implicitly {@link coreproductpb.ReplaceProductTemplateVersionResponse.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.ReplaceProductTemplateVersionResponse
         * @static
         * @param {coreproductpb.IReplaceProductTemplateVersionResponse} m ReplaceProductTemplateVersionResponse message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ReplaceProductTemplateVersionResponse.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.errors != null && m.errors.length) {
                for (var i = 0; i < m.errors.length; ++i)
                    $root.common.Error.encode(m.errors[i], w.uint32(10).fork()).ldelim();
            }
            return w;
        };

        /**
         * Decodes a ReplaceProductTemplateVersionResponse message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.ReplaceProductTemplateVersionResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.ReplaceProductTemplateVersionResponse} ReplaceProductTemplateVersionResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ReplaceProductTemplateVersionResponse.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.ReplaceProductTemplateVersionResponse();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    if (!(m.errors && m.errors.length))
                        m.errors = [];
                    m.errors.push($root.common.Error.decode(r, r.uint32()));
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return ReplaceProductTemplateVersionResponse;
    })();

    coreproductpb.PatchEffectiveProductTemplateVersionRequest = (function() {

        /**
         * Properties of a PatchEffectiveProductTemplateVersionRequest.
         * @memberof coreproductpb
         * @interface IPatchEffectiveProductTemplateVersionRequest
         * @property {string|null} [productTemplateID] PatchEffectiveProductTemplateVersionRequest productTemplateID
         * @property {string|null} [productTemplateVersionID] PatchEffectiveProductTemplateVersionRequest productTemplateVersionID
         * @property {coreproductpb.IProductTemplateAttributeRule|null} [addNewAttribute] PatchEffectiveProductTemplateVersionRequest addNewAttribute
         * @property {coreproductpb.IPatchEffectiveProductTemplateVersionAttribute|null} [editExistingAttribute] PatchEffectiveProductTemplateVersionRequest editExistingAttribute
         * @property {coreproductpb.IProductTemplateFeatureRules|null} [featureRules] PatchEffectiveProductTemplateVersionRequest featureRules
         * @property {boolean|null} [publishToStar] PatchEffectiveProductTemplateVersionRequest publishToStar
         */

        /**
         * Constructs a new PatchEffectiveProductTemplateVersionRequest.
         * @memberof coreproductpb
         * @classdesc Represents a PatchEffectiveProductTemplateVersionRequest.
         * @implements IPatchEffectiveProductTemplateVersionRequest
         * @constructor
         * @param {coreproductpb.IPatchEffectiveProductTemplateVersionRequest=} [p] Properties to set
         */
        function PatchEffectiveProductTemplateVersionRequest(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * PatchEffectiveProductTemplateVersionRequest productTemplateID.
         * @member {string} productTemplateID
         * @memberof coreproductpb.PatchEffectiveProductTemplateVersionRequest
         * @instance
         */
        PatchEffectiveProductTemplateVersionRequest.prototype.productTemplateID = "";

        /**
         * PatchEffectiveProductTemplateVersionRequest productTemplateVersionID.
         * @member {string} productTemplateVersionID
         * @memberof coreproductpb.PatchEffectiveProductTemplateVersionRequest
         * @instance
         */
        PatchEffectiveProductTemplateVersionRequest.prototype.productTemplateVersionID = "";

        /**
         * PatchEffectiveProductTemplateVersionRequest addNewAttribute.
         * @member {coreproductpb.IProductTemplateAttributeRule|null|undefined} addNewAttribute
         * @memberof coreproductpb.PatchEffectiveProductTemplateVersionRequest
         * @instance
         */
        PatchEffectiveProductTemplateVersionRequest.prototype.addNewAttribute = null;

        /**
         * PatchEffectiveProductTemplateVersionRequest editExistingAttribute.
         * @member {coreproductpb.IPatchEffectiveProductTemplateVersionAttribute|null|undefined} editExistingAttribute
         * @memberof coreproductpb.PatchEffectiveProductTemplateVersionRequest
         * @instance
         */
        PatchEffectiveProductTemplateVersionRequest.prototype.editExistingAttribute = null;

        /**
         * PatchEffectiveProductTemplateVersionRequest featureRules.
         * @member {coreproductpb.IProductTemplateFeatureRules|null|undefined} featureRules
         * @memberof coreproductpb.PatchEffectiveProductTemplateVersionRequest
         * @instance
         */
        PatchEffectiveProductTemplateVersionRequest.prototype.featureRules = null;

        /**
         * PatchEffectiveProductTemplateVersionRequest publishToStar.
         * @member {boolean|null|undefined} publishToStar
         * @memberof coreproductpb.PatchEffectiveProductTemplateVersionRequest
         * @instance
         */
        PatchEffectiveProductTemplateVersionRequest.prototype.publishToStar = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        /**
         * PatchEffectiveProductTemplateVersionRequest productEditAndPublish.
         * @member {"addNewAttribute"|"editExistingAttribute"|"featureRules"|"publishToStar"|undefined} productEditAndPublish
         * @memberof coreproductpb.PatchEffectiveProductTemplateVersionRequest
         * @instance
         */
        Object.defineProperty(PatchEffectiveProductTemplateVersionRequest.prototype, "productEditAndPublish", {
            get: $util.oneOfGetter($oneOfFields = ["addNewAttribute", "editExistingAttribute", "featureRules", "publishToStar"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new PatchEffectiveProductTemplateVersionRequest instance using the specified properties.
         * @function create
         * @memberof coreproductpb.PatchEffectiveProductTemplateVersionRequest
         * @static
         * @param {coreproductpb.IPatchEffectiveProductTemplateVersionRequest=} [properties] Properties to set
         * @returns {coreproductpb.PatchEffectiveProductTemplateVersionRequest} PatchEffectiveProductTemplateVersionRequest instance
         */
        PatchEffectiveProductTemplateVersionRequest.create = function create(properties) {
            return new PatchEffectiveProductTemplateVersionRequest(properties);
        };

        /**
         * Encodes the specified PatchEffectiveProductTemplateVersionRequest message. Does not implicitly {@link coreproductpb.PatchEffectiveProductTemplateVersionRequest.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.PatchEffectiveProductTemplateVersionRequest
         * @static
         * @param {coreproductpb.IPatchEffectiveProductTemplateVersionRequest} m PatchEffectiveProductTemplateVersionRequest message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PatchEffectiveProductTemplateVersionRequest.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.productTemplateID != null && Object.hasOwnProperty.call(m, "productTemplateID"))
                w.uint32(10).string(m.productTemplateID);
            if (m.productTemplateVersionID != null && Object.hasOwnProperty.call(m, "productTemplateVersionID"))
                w.uint32(18).string(m.productTemplateVersionID);
            if (m.addNewAttribute != null && Object.hasOwnProperty.call(m, "addNewAttribute"))
                $root.coreproductpb.ProductTemplateAttributeRule.encode(m.addNewAttribute, w.uint32(26).fork()).ldelim();
            if (m.editExistingAttribute != null && Object.hasOwnProperty.call(m, "editExistingAttribute"))
                $root.coreproductpb.PatchEffectiveProductTemplateVersionAttribute.encode(m.editExistingAttribute, w.uint32(34).fork()).ldelim();
            if (m.featureRules != null && Object.hasOwnProperty.call(m, "featureRules"))
                $root.coreproductpb.ProductTemplateFeatureRules.encode(m.featureRules, w.uint32(42).fork()).ldelim();
            if (m.publishToStar != null && Object.hasOwnProperty.call(m, "publishToStar"))
                w.uint32(48).bool(m.publishToStar);
            return w;
        };

        /**
         * Decodes a PatchEffectiveProductTemplateVersionRequest message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.PatchEffectiveProductTemplateVersionRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.PatchEffectiveProductTemplateVersionRequest} PatchEffectiveProductTemplateVersionRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PatchEffectiveProductTemplateVersionRequest.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.PatchEffectiveProductTemplateVersionRequest();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.productTemplateID = r.string();
                    break;
                case 2:
                    m.productTemplateVersionID = r.string();
                    break;
                case 3:
                    m.addNewAttribute = $root.coreproductpb.ProductTemplateAttributeRule.decode(r, r.uint32());
                    break;
                case 4:
                    m.editExistingAttribute = $root.coreproductpb.PatchEffectiveProductTemplateVersionAttribute.decode(r, r.uint32());
                    break;
                case 5:
                    m.featureRules = $root.coreproductpb.ProductTemplateFeatureRules.decode(r, r.uint32());
                    break;
                case 6:
                    m.publishToStar = r.bool();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return PatchEffectiveProductTemplateVersionRequest;
    })();

    coreproductpb.PatchEffectiveProductTemplateVersionAttribute = (function() {

        /**
         * Properties of a PatchEffectiveProductTemplateVersionAttribute.
         * @memberof coreproductpb
         * @interface IPatchEffectiveProductTemplateVersionAttribute
         * @property {string|null} [attributeName] PatchEffectiveProductTemplateVersionAttribute attributeName
         * @property {Array.<coreproductpb.ITypedValue>|null} [typedValue] PatchEffectiveProductTemplateVersionAttribute typedValue
         */

        /**
         * Constructs a new PatchEffectiveProductTemplateVersionAttribute.
         * @memberof coreproductpb
         * @classdesc Represents a PatchEffectiveProductTemplateVersionAttribute.
         * @implements IPatchEffectiveProductTemplateVersionAttribute
         * @constructor
         * @param {coreproductpb.IPatchEffectiveProductTemplateVersionAttribute=} [p] Properties to set
         */
        function PatchEffectiveProductTemplateVersionAttribute(p) {
            this.typedValue = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * PatchEffectiveProductTemplateVersionAttribute attributeName.
         * @member {string} attributeName
         * @memberof coreproductpb.PatchEffectiveProductTemplateVersionAttribute
         * @instance
         */
        PatchEffectiveProductTemplateVersionAttribute.prototype.attributeName = "";

        /**
         * PatchEffectiveProductTemplateVersionAttribute typedValue.
         * @member {Array.<coreproductpb.ITypedValue>} typedValue
         * @memberof coreproductpb.PatchEffectiveProductTemplateVersionAttribute
         * @instance
         */
        PatchEffectiveProductTemplateVersionAttribute.prototype.typedValue = $util.emptyArray;

        /**
         * Creates a new PatchEffectiveProductTemplateVersionAttribute instance using the specified properties.
         * @function create
         * @memberof coreproductpb.PatchEffectiveProductTemplateVersionAttribute
         * @static
         * @param {coreproductpb.IPatchEffectiveProductTemplateVersionAttribute=} [properties] Properties to set
         * @returns {coreproductpb.PatchEffectiveProductTemplateVersionAttribute} PatchEffectiveProductTemplateVersionAttribute instance
         */
        PatchEffectiveProductTemplateVersionAttribute.create = function create(properties) {
            return new PatchEffectiveProductTemplateVersionAttribute(properties);
        };

        /**
         * Encodes the specified PatchEffectiveProductTemplateVersionAttribute message. Does not implicitly {@link coreproductpb.PatchEffectiveProductTemplateVersionAttribute.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.PatchEffectiveProductTemplateVersionAttribute
         * @static
         * @param {coreproductpb.IPatchEffectiveProductTemplateVersionAttribute} m PatchEffectiveProductTemplateVersionAttribute message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PatchEffectiveProductTemplateVersionAttribute.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.attributeName != null && Object.hasOwnProperty.call(m, "attributeName"))
                w.uint32(10).string(m.attributeName);
            if (m.typedValue != null && m.typedValue.length) {
                for (var i = 0; i < m.typedValue.length; ++i)
                    $root.coreproductpb.TypedValue.encode(m.typedValue[i], w.uint32(18).fork()).ldelim();
            }
            return w;
        };

        /**
         * Decodes a PatchEffectiveProductTemplateVersionAttribute message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.PatchEffectiveProductTemplateVersionAttribute
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.PatchEffectiveProductTemplateVersionAttribute} PatchEffectiveProductTemplateVersionAttribute
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PatchEffectiveProductTemplateVersionAttribute.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.PatchEffectiveProductTemplateVersionAttribute();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.attributeName = r.string();
                    break;
                case 2:
                    if (!(m.typedValue && m.typedValue.length))
                        m.typedValue = [];
                    m.typedValue.push($root.coreproductpb.TypedValue.decode(r, r.uint32()));
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return PatchEffectiveProductTemplateVersionAttribute;
    })();

    coreproductpb.PatchEffectiveProductTemplateVersionResponse = (function() {

        /**
         * Properties of a PatchEffectiveProductTemplateVersionResponse.
         * @memberof coreproductpb
         * @interface IPatchEffectiveProductTemplateVersionResponse
         * @property {Array.<common.IError>|null} [errors] PatchEffectiveProductTemplateVersionResponse errors
         */

        /**
         * Constructs a new PatchEffectiveProductTemplateVersionResponse.
         * @memberof coreproductpb
         * @classdesc Represents a PatchEffectiveProductTemplateVersionResponse.
         * @implements IPatchEffectiveProductTemplateVersionResponse
         * @constructor
         * @param {coreproductpb.IPatchEffectiveProductTemplateVersionResponse=} [p] Properties to set
         */
        function PatchEffectiveProductTemplateVersionResponse(p) {
            this.errors = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * PatchEffectiveProductTemplateVersionResponse errors.
         * @member {Array.<common.IError>} errors
         * @memberof coreproductpb.PatchEffectiveProductTemplateVersionResponse
         * @instance
         */
        PatchEffectiveProductTemplateVersionResponse.prototype.errors = $util.emptyArray;

        /**
         * Creates a new PatchEffectiveProductTemplateVersionResponse instance using the specified properties.
         * @function create
         * @memberof coreproductpb.PatchEffectiveProductTemplateVersionResponse
         * @static
         * @param {coreproductpb.IPatchEffectiveProductTemplateVersionResponse=} [properties] Properties to set
         * @returns {coreproductpb.PatchEffectiveProductTemplateVersionResponse} PatchEffectiveProductTemplateVersionResponse instance
         */
        PatchEffectiveProductTemplateVersionResponse.create = function create(properties) {
            return new PatchEffectiveProductTemplateVersionResponse(properties);
        };

        /**
         * Encodes the specified PatchEffectiveProductTemplateVersionResponse message. Does not implicitly {@link coreproductpb.PatchEffectiveProductTemplateVersionResponse.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.PatchEffectiveProductTemplateVersionResponse
         * @static
         * @param {coreproductpb.IPatchEffectiveProductTemplateVersionResponse} m PatchEffectiveProductTemplateVersionResponse message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PatchEffectiveProductTemplateVersionResponse.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.errors != null && m.errors.length) {
                for (var i = 0; i < m.errors.length; ++i)
                    $root.common.Error.encode(m.errors[i], w.uint32(10).fork()).ldelim();
            }
            return w;
        };

        /**
         * Decodes a PatchEffectiveProductTemplateVersionResponse message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.PatchEffectiveProductTemplateVersionResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.PatchEffectiveProductTemplateVersionResponse} PatchEffectiveProductTemplateVersionResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PatchEffectiveProductTemplateVersionResponse.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.PatchEffectiveProductTemplateVersionResponse();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    if (!(m.errors && m.errors.length))
                        m.errors = [];
                    m.errors.push($root.common.Error.decode(r, r.uint32()));
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return PatchEffectiveProductTemplateVersionResponse;
    })();

    coreproductpb.AttributeValuesRequest = (function() {

        /**
         * Properties of an AttributeValuesRequest.
         * @memberof coreproductpb
         * @interface IAttributeValuesRequest
         * @property {string|null} [attributeName] AttributeValuesRequest attributeName
         * @property {coreproductpb.DataRecordStatus|null} [valueStatus] AttributeValuesRequest valueStatus
         * @property {boolean|null} [includeMetaData] AttributeValuesRequest includeMetaData
         * @property {boolean|null} [includeHistory] AttributeValuesRequest includeHistory
         * @property {common.IPaginationRequest|null} [pagination] AttributeValuesRequest pagination
         */

        /**
         * Constructs a new AttributeValuesRequest.
         * @memberof coreproductpb
         * @classdesc Represents an AttributeValuesRequest.
         * @implements IAttributeValuesRequest
         * @constructor
         * @param {coreproductpb.IAttributeValuesRequest=} [p] Properties to set
         */
        function AttributeValuesRequest(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * AttributeValuesRequest attributeName.
         * @member {string} attributeName
         * @memberof coreproductpb.AttributeValuesRequest
         * @instance
         */
        AttributeValuesRequest.prototype.attributeName = "";

        /**
         * AttributeValuesRequest valueStatus.
         * @member {coreproductpb.DataRecordStatus} valueStatus
         * @memberof coreproductpb.AttributeValuesRequest
         * @instance
         */
        AttributeValuesRequest.prototype.valueStatus = 0;

        /**
         * AttributeValuesRequest includeMetaData.
         * @member {boolean} includeMetaData
         * @memberof coreproductpb.AttributeValuesRequest
         * @instance
         */
        AttributeValuesRequest.prototype.includeMetaData = false;

        /**
         * AttributeValuesRequest includeHistory.
         * @member {boolean} includeHistory
         * @memberof coreproductpb.AttributeValuesRequest
         * @instance
         */
        AttributeValuesRequest.prototype.includeHistory = false;

        /**
         * AttributeValuesRequest pagination.
         * @member {common.IPaginationRequest|null|undefined} pagination
         * @memberof coreproductpb.AttributeValuesRequest
         * @instance
         */
        AttributeValuesRequest.prototype.pagination = null;

        /**
         * Creates a new AttributeValuesRequest instance using the specified properties.
         * @function create
         * @memberof coreproductpb.AttributeValuesRequest
         * @static
         * @param {coreproductpb.IAttributeValuesRequest=} [properties] Properties to set
         * @returns {coreproductpb.AttributeValuesRequest} AttributeValuesRequest instance
         */
        AttributeValuesRequest.create = function create(properties) {
            return new AttributeValuesRequest(properties);
        };

        /**
         * Encodes the specified AttributeValuesRequest message. Does not implicitly {@link coreproductpb.AttributeValuesRequest.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.AttributeValuesRequest
         * @static
         * @param {coreproductpb.IAttributeValuesRequest} m AttributeValuesRequest message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AttributeValuesRequest.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.attributeName != null && Object.hasOwnProperty.call(m, "attributeName"))
                w.uint32(10).string(m.attributeName);
            if (m.valueStatus != null && Object.hasOwnProperty.call(m, "valueStatus"))
                w.uint32(16).int32(m.valueStatus);
            if (m.includeMetaData != null && Object.hasOwnProperty.call(m, "includeMetaData"))
                w.uint32(24).bool(m.includeMetaData);
            if (m.includeHistory != null && Object.hasOwnProperty.call(m, "includeHistory"))
                w.uint32(32).bool(m.includeHistory);
            if (m.pagination != null && Object.hasOwnProperty.call(m, "pagination"))
                $root.common.PaginationRequest.encode(m.pagination, w.uint32(42).fork()).ldelim();
            return w;
        };

        /**
         * Decodes an AttributeValuesRequest message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.AttributeValuesRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.AttributeValuesRequest} AttributeValuesRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AttributeValuesRequest.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.AttributeValuesRequest();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.attributeName = r.string();
                    break;
                case 2:
                    m.valueStatus = r.int32();
                    break;
                case 3:
                    m.includeMetaData = r.bool();
                    break;
                case 4:
                    m.includeHistory = r.bool();
                    break;
                case 5:
                    m.pagination = $root.common.PaginationRequest.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return AttributeValuesRequest;
    })();

    coreproductpb.AttributeValuesResponse = (function() {

        /**
         * Properties of an AttributeValuesResponse.
         * @memberof coreproductpb
         * @interface IAttributeValuesResponse
         * @property {Array.<coreproductpb.IAttributeValue>|null} [values] AttributeValuesResponse values
         * @property {common.IPagination|null} [pagination] AttributeValuesResponse pagination
         * @property {Array.<common.IError>|null} [errors] AttributeValuesResponse errors
         */

        /**
         * Constructs a new AttributeValuesResponse.
         * @memberof coreproductpb
         * @classdesc Represents an AttributeValuesResponse.
         * @implements IAttributeValuesResponse
         * @constructor
         * @param {coreproductpb.IAttributeValuesResponse=} [p] Properties to set
         */
        function AttributeValuesResponse(p) {
            this.values = [];
            this.errors = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * AttributeValuesResponse values.
         * @member {Array.<coreproductpb.IAttributeValue>} values
         * @memberof coreproductpb.AttributeValuesResponse
         * @instance
         */
        AttributeValuesResponse.prototype.values = $util.emptyArray;

        /**
         * AttributeValuesResponse pagination.
         * @member {common.IPagination|null|undefined} pagination
         * @memberof coreproductpb.AttributeValuesResponse
         * @instance
         */
        AttributeValuesResponse.prototype.pagination = null;

        /**
         * AttributeValuesResponse errors.
         * @member {Array.<common.IError>} errors
         * @memberof coreproductpb.AttributeValuesResponse
         * @instance
         */
        AttributeValuesResponse.prototype.errors = $util.emptyArray;

        /**
         * Creates a new AttributeValuesResponse instance using the specified properties.
         * @function create
         * @memberof coreproductpb.AttributeValuesResponse
         * @static
         * @param {coreproductpb.IAttributeValuesResponse=} [properties] Properties to set
         * @returns {coreproductpb.AttributeValuesResponse} AttributeValuesResponse instance
         */
        AttributeValuesResponse.create = function create(properties) {
            return new AttributeValuesResponse(properties);
        };

        /**
         * Encodes the specified AttributeValuesResponse message. Does not implicitly {@link coreproductpb.AttributeValuesResponse.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.AttributeValuesResponse
         * @static
         * @param {coreproductpb.IAttributeValuesResponse} m AttributeValuesResponse message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AttributeValuesResponse.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.values != null && m.values.length) {
                for (var i = 0; i < m.values.length; ++i)
                    $root.coreproductpb.AttributeValue.encode(m.values[i], w.uint32(10).fork()).ldelim();
            }
            if (m.pagination != null && Object.hasOwnProperty.call(m, "pagination"))
                $root.common.Pagination.encode(m.pagination, w.uint32(18).fork()).ldelim();
            if (m.errors != null && m.errors.length) {
                for (var i = 0; i < m.errors.length; ++i)
                    $root.common.Error.encode(m.errors[i], w.uint32(26).fork()).ldelim();
            }
            return w;
        };

        /**
         * Decodes an AttributeValuesResponse message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.AttributeValuesResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.AttributeValuesResponse} AttributeValuesResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AttributeValuesResponse.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.AttributeValuesResponse();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    if (!(m.values && m.values.length))
                        m.values = [];
                    m.values.push($root.coreproductpb.AttributeValue.decode(r, r.uint32()));
                    break;
                case 2:
                    m.pagination = $root.common.Pagination.decode(r, r.uint32());
                    break;
                case 3:
                    if (!(m.errors && m.errors.length))
                        m.errors = [];
                    m.errors.push($root.common.Error.decode(r, r.uint32()));
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return AttributeValuesResponse;
    })();

    coreproductpb.GetConfigurationResponse = (function() {

        /**
         * Properties of a GetConfigurationResponse.
         * @memberof coreproductpb
         * @interface IGetConfigurationResponse
         * @property {coreproductpb.IConfiguration|null} [configuration] GetConfigurationResponse configuration
         * @property {Array.<common.IError>|null} [errors] GetConfigurationResponse errors
         */

        /**
         * Constructs a new GetConfigurationResponse.
         * @memberof coreproductpb
         * @classdesc Represents a GetConfigurationResponse.
         * @implements IGetConfigurationResponse
         * @constructor
         * @param {coreproductpb.IGetConfigurationResponse=} [p] Properties to set
         */
        function GetConfigurationResponse(p) {
            this.errors = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * GetConfigurationResponse configuration.
         * @member {coreproductpb.IConfiguration|null|undefined} configuration
         * @memberof coreproductpb.GetConfigurationResponse
         * @instance
         */
        GetConfigurationResponse.prototype.configuration = null;

        /**
         * GetConfigurationResponse errors.
         * @member {Array.<common.IError>} errors
         * @memberof coreproductpb.GetConfigurationResponse
         * @instance
         */
        GetConfigurationResponse.prototype.errors = $util.emptyArray;

        /**
         * Creates a new GetConfigurationResponse instance using the specified properties.
         * @function create
         * @memberof coreproductpb.GetConfigurationResponse
         * @static
         * @param {coreproductpb.IGetConfigurationResponse=} [properties] Properties to set
         * @returns {coreproductpb.GetConfigurationResponse} GetConfigurationResponse instance
         */
        GetConfigurationResponse.create = function create(properties) {
            return new GetConfigurationResponse(properties);
        };

        /**
         * Encodes the specified GetConfigurationResponse message. Does not implicitly {@link coreproductpb.GetConfigurationResponse.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.GetConfigurationResponse
         * @static
         * @param {coreproductpb.IGetConfigurationResponse} m GetConfigurationResponse message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetConfigurationResponse.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.configuration != null && Object.hasOwnProperty.call(m, "configuration"))
                $root.coreproductpb.Configuration.encode(m.configuration, w.uint32(10).fork()).ldelim();
            if (m.errors != null && m.errors.length) {
                for (var i = 0; i < m.errors.length; ++i)
                    $root.common.Error.encode(m.errors[i], w.uint32(18).fork()).ldelim();
            }
            return w;
        };

        /**
         * Decodes a GetConfigurationResponse message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.GetConfigurationResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.GetConfigurationResponse} GetConfigurationResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetConfigurationResponse.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.GetConfigurationResponse();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.configuration = $root.coreproductpb.Configuration.decode(r, r.uint32());
                    break;
                case 2:
                    if (!(m.errors && m.errors.length))
                        m.errors = [];
                    m.errors.push($root.common.Error.decode(r, r.uint32()));
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return GetConfigurationResponse;
    })();

    coreproductpb.GetCoveragesRequest = (function() {

        /**
         * Properties of a GetCoveragesRequest.
         * @memberof coreproductpb
         * @interface IGetCoveragesRequest
         * @property {string|null} [name] GetCoveragesRequest name
         * @property {Array.<coreproductpb.DataRecordStatus>|null} [status] GetCoveragesRequest status
         * @property {string|null} [productTemplateID] GetCoveragesRequest productTemplateID
         * @property {string|null} [productTemplateVersionID] GetCoveragesRequest productTemplateVersionID
         * @property {common.IPaginationRequest|null} [pagination] GetCoveragesRequest pagination
         * @property {coreproductpb.CoverageType|null} [type] GetCoveragesRequest type
         * @property {string|null} [coverageID] GetCoveragesRequest coverageID
         * @property {boolean|null} [existsInTemplates] GetCoveragesRequest existsInTemplates
         * @property {boolean|null} [includeItemDetails] GetCoveragesRequest includeItemDetails
         */

        /**
         * Constructs a new GetCoveragesRequest.
         * @memberof coreproductpb
         * @classdesc Represents a GetCoveragesRequest.
         * @implements IGetCoveragesRequest
         * @constructor
         * @param {coreproductpb.IGetCoveragesRequest=} [p] Properties to set
         */
        function GetCoveragesRequest(p) {
            this.status = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * GetCoveragesRequest name.
         * @member {string} name
         * @memberof coreproductpb.GetCoveragesRequest
         * @instance
         */
        GetCoveragesRequest.prototype.name = "";

        /**
         * GetCoveragesRequest status.
         * @member {Array.<coreproductpb.DataRecordStatus>} status
         * @memberof coreproductpb.GetCoveragesRequest
         * @instance
         */
        GetCoveragesRequest.prototype.status = $util.emptyArray;

        /**
         * GetCoveragesRequest productTemplateID.
         * @member {string} productTemplateID
         * @memberof coreproductpb.GetCoveragesRequest
         * @instance
         */
        GetCoveragesRequest.prototype.productTemplateID = "";

        /**
         * GetCoveragesRequest productTemplateVersionID.
         * @member {string} productTemplateVersionID
         * @memberof coreproductpb.GetCoveragesRequest
         * @instance
         */
        GetCoveragesRequest.prototype.productTemplateVersionID = "";

        /**
         * GetCoveragesRequest pagination.
         * @member {common.IPaginationRequest|null|undefined} pagination
         * @memberof coreproductpb.GetCoveragesRequest
         * @instance
         */
        GetCoveragesRequest.prototype.pagination = null;

        /**
         * GetCoveragesRequest type.
         * @member {coreproductpb.CoverageType} type
         * @memberof coreproductpb.GetCoveragesRequest
         * @instance
         */
        GetCoveragesRequest.prototype.type = 0;

        /**
         * GetCoveragesRequest coverageID.
         * @member {string} coverageID
         * @memberof coreproductpb.GetCoveragesRequest
         * @instance
         */
        GetCoveragesRequest.prototype.coverageID = "";

        /**
         * GetCoveragesRequest existsInTemplates.
         * @member {boolean} existsInTemplates
         * @memberof coreproductpb.GetCoveragesRequest
         * @instance
         */
        GetCoveragesRequest.prototype.existsInTemplates = false;

        /**
         * GetCoveragesRequest includeItemDetails.
         * @member {boolean} includeItemDetails
         * @memberof coreproductpb.GetCoveragesRequest
         * @instance
         */
        GetCoveragesRequest.prototype.includeItemDetails = false;

        /**
         * Creates a new GetCoveragesRequest instance using the specified properties.
         * @function create
         * @memberof coreproductpb.GetCoveragesRequest
         * @static
         * @param {coreproductpb.IGetCoveragesRequest=} [properties] Properties to set
         * @returns {coreproductpb.GetCoveragesRequest} GetCoveragesRequest instance
         */
        GetCoveragesRequest.create = function create(properties) {
            return new GetCoveragesRequest(properties);
        };

        /**
         * Encodes the specified GetCoveragesRequest message. Does not implicitly {@link coreproductpb.GetCoveragesRequest.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.GetCoveragesRequest
         * @static
         * @param {coreproductpb.IGetCoveragesRequest} m GetCoveragesRequest message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetCoveragesRequest.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.name != null && Object.hasOwnProperty.call(m, "name"))
                w.uint32(10).string(m.name);
            if (m.status != null && m.status.length) {
                w.uint32(18).fork();
                for (var i = 0; i < m.status.length; ++i)
                    w.int32(m.status[i]);
                w.ldelim();
            }
            if (m.productTemplateID != null && Object.hasOwnProperty.call(m, "productTemplateID"))
                w.uint32(26).string(m.productTemplateID);
            if (m.productTemplateVersionID != null && Object.hasOwnProperty.call(m, "productTemplateVersionID"))
                w.uint32(34).string(m.productTemplateVersionID);
            if (m.pagination != null && Object.hasOwnProperty.call(m, "pagination"))
                $root.common.PaginationRequest.encode(m.pagination, w.uint32(42).fork()).ldelim();
            if (m.type != null && Object.hasOwnProperty.call(m, "type"))
                w.uint32(48).int32(m.type);
            if (m.coverageID != null && Object.hasOwnProperty.call(m, "coverageID"))
                w.uint32(58).string(m.coverageID);
            if (m.existsInTemplates != null && Object.hasOwnProperty.call(m, "existsInTemplates"))
                w.uint32(64).bool(m.existsInTemplates);
            if (m.includeItemDetails != null && Object.hasOwnProperty.call(m, "includeItemDetails"))
                w.uint32(72).bool(m.includeItemDetails);
            return w;
        };

        /**
         * Decodes a GetCoveragesRequest message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.GetCoveragesRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.GetCoveragesRequest} GetCoveragesRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetCoveragesRequest.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.GetCoveragesRequest();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.name = r.string();
                    break;
                case 2:
                    if (!(m.status && m.status.length))
                        m.status = [];
                    if ((t & 7) === 2) {
                        var c2 = r.uint32() + r.pos;
                        while (r.pos < c2)
                            m.status.push(r.int32());
                    } else
                        m.status.push(r.int32());
                    break;
                case 3:
                    m.productTemplateID = r.string();
                    break;
                case 4:
                    m.productTemplateVersionID = r.string();
                    break;
                case 5:
                    m.pagination = $root.common.PaginationRequest.decode(r, r.uint32());
                    break;
                case 6:
                    m.type = r.int32();
                    break;
                case 7:
                    m.coverageID = r.string();
                    break;
                case 8:
                    m.existsInTemplates = r.bool();
                    break;
                case 9:
                    m.includeItemDetails = r.bool();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return GetCoveragesRequest;
    })();

    coreproductpb.GetCoveragesResponse = (function() {

        /**
         * Properties of a GetCoveragesResponse.
         * @memberof coreproductpb
         * @interface IGetCoveragesResponse
         * @property {Array.<coreproductpb.ICoverage>|null} [coverages] GetCoveragesResponse coverages
         * @property {Array.<common.IError>|null} [errors] GetCoveragesResponse errors
         * @property {common.IPagination|null} [pagination] GetCoveragesResponse pagination
         * @property {Object.<string,number>|null} [statusesCount] GetCoveragesResponse statusesCount
         */

        /**
         * Constructs a new GetCoveragesResponse.
         * @memberof coreproductpb
         * @classdesc Represents a GetCoveragesResponse.
         * @implements IGetCoveragesResponse
         * @constructor
         * @param {coreproductpb.IGetCoveragesResponse=} [p] Properties to set
         */
        function GetCoveragesResponse(p) {
            this.coverages = [];
            this.errors = [];
            this.statusesCount = {};
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * GetCoveragesResponse coverages.
         * @member {Array.<coreproductpb.ICoverage>} coverages
         * @memberof coreproductpb.GetCoveragesResponse
         * @instance
         */
        GetCoveragesResponse.prototype.coverages = $util.emptyArray;

        /**
         * GetCoveragesResponse errors.
         * @member {Array.<common.IError>} errors
         * @memberof coreproductpb.GetCoveragesResponse
         * @instance
         */
        GetCoveragesResponse.prototype.errors = $util.emptyArray;

        /**
         * GetCoveragesResponse pagination.
         * @member {common.IPagination|null|undefined} pagination
         * @memberof coreproductpb.GetCoveragesResponse
         * @instance
         */
        GetCoveragesResponse.prototype.pagination = null;

        /**
         * GetCoveragesResponse statusesCount.
         * @member {Object.<string,number>} statusesCount
         * @memberof coreproductpb.GetCoveragesResponse
         * @instance
         */
        GetCoveragesResponse.prototype.statusesCount = $util.emptyObject;

        /**
         * Creates a new GetCoveragesResponse instance using the specified properties.
         * @function create
         * @memberof coreproductpb.GetCoveragesResponse
         * @static
         * @param {coreproductpb.IGetCoveragesResponse=} [properties] Properties to set
         * @returns {coreproductpb.GetCoveragesResponse} GetCoveragesResponse instance
         */
        GetCoveragesResponse.create = function create(properties) {
            return new GetCoveragesResponse(properties);
        };

        /**
         * Encodes the specified GetCoveragesResponse message. Does not implicitly {@link coreproductpb.GetCoveragesResponse.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.GetCoveragesResponse
         * @static
         * @param {coreproductpb.IGetCoveragesResponse} m GetCoveragesResponse message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetCoveragesResponse.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.coverages != null && m.coverages.length) {
                for (var i = 0; i < m.coverages.length; ++i)
                    $root.coreproductpb.Coverage.encode(m.coverages[i], w.uint32(10).fork()).ldelim();
            }
            if (m.errors != null && m.errors.length) {
                for (var i = 0; i < m.errors.length; ++i)
                    $root.common.Error.encode(m.errors[i], w.uint32(18).fork()).ldelim();
            }
            if (m.pagination != null && Object.hasOwnProperty.call(m, "pagination"))
                $root.common.Pagination.encode(m.pagination, w.uint32(26).fork()).ldelim();
            if (m.statusesCount != null && Object.hasOwnProperty.call(m, "statusesCount")) {
                for (var ks = Object.keys(m.statusesCount), i = 0; i < ks.length; ++i) {
                    w.uint32(34).fork().uint32(8).int32(ks[i]).uint32(16).int32(m.statusesCount[ks[i]]).ldelim();
                }
            }
            return w;
        };

        /**
         * Decodes a GetCoveragesResponse message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.GetCoveragesResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.GetCoveragesResponse} GetCoveragesResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetCoveragesResponse.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.GetCoveragesResponse(), k, value;
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    if (!(m.coverages && m.coverages.length))
                        m.coverages = [];
                    m.coverages.push($root.coreproductpb.Coverage.decode(r, r.uint32()));
                    break;
                case 2:
                    if (!(m.errors && m.errors.length))
                        m.errors = [];
                    m.errors.push($root.common.Error.decode(r, r.uint32()));
                    break;
                case 3:
                    m.pagination = $root.common.Pagination.decode(r, r.uint32());
                    break;
                case 4:
                    if (m.statusesCount === $util.emptyObject)
                        m.statusesCount = {};
                    var c2 = r.uint32() + r.pos;
                    k = 0;
                    value = 0;
                    while (r.pos < c2) {
                        var tag2 = r.uint32();
                        switch (tag2 >>> 3) {
                        case 1:
                            k = r.int32();
                            break;
                        case 2:
                            value = r.int32();
                            break;
                        default:
                            r.skipType(tag2 & 7);
                            break;
                        }
                    }
                    m.statusesCount[k] = value;
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return GetCoveragesResponse;
    })();

    coreproductpb.CancelCoverageRequest = (function() {

        /**
         * Properties of a CancelCoverageRequest.
         * @memberof coreproductpb
         * @interface ICancelCoverageRequest
         * @property {string|null} [coverageID] CancelCoverageRequest coverageID
         */

        /**
         * Constructs a new CancelCoverageRequest.
         * @memberof coreproductpb
         * @classdesc Represents a CancelCoverageRequest.
         * @implements ICancelCoverageRequest
         * @constructor
         * @param {coreproductpb.ICancelCoverageRequest=} [p] Properties to set
         */
        function CancelCoverageRequest(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * CancelCoverageRequest coverageID.
         * @member {string} coverageID
         * @memberof coreproductpb.CancelCoverageRequest
         * @instance
         */
        CancelCoverageRequest.prototype.coverageID = "";

        /**
         * Creates a new CancelCoverageRequest instance using the specified properties.
         * @function create
         * @memberof coreproductpb.CancelCoverageRequest
         * @static
         * @param {coreproductpb.ICancelCoverageRequest=} [properties] Properties to set
         * @returns {coreproductpb.CancelCoverageRequest} CancelCoverageRequest instance
         */
        CancelCoverageRequest.create = function create(properties) {
            return new CancelCoverageRequest(properties);
        };

        /**
         * Encodes the specified CancelCoverageRequest message. Does not implicitly {@link coreproductpb.CancelCoverageRequest.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.CancelCoverageRequest
         * @static
         * @param {coreproductpb.ICancelCoverageRequest} m CancelCoverageRequest message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CancelCoverageRequest.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.coverageID != null && Object.hasOwnProperty.call(m, "coverageID"))
                w.uint32(10).string(m.coverageID);
            return w;
        };

        /**
         * Decodes a CancelCoverageRequest message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.CancelCoverageRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.CancelCoverageRequest} CancelCoverageRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CancelCoverageRequest.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.CancelCoverageRequest();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.coverageID = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return CancelCoverageRequest;
    })();

    coreproductpb.CancelCoverageResponse = (function() {

        /**
         * Properties of a CancelCoverageResponse.
         * @memberof coreproductpb
         * @interface ICancelCoverageResponse
         * @property {Array.<common.IError>|null} [errors] CancelCoverageResponse errors
         */

        /**
         * Constructs a new CancelCoverageResponse.
         * @memberof coreproductpb
         * @classdesc Represents a CancelCoverageResponse.
         * @implements ICancelCoverageResponse
         * @constructor
         * @param {coreproductpb.ICancelCoverageResponse=} [p] Properties to set
         */
        function CancelCoverageResponse(p) {
            this.errors = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * CancelCoverageResponse errors.
         * @member {Array.<common.IError>} errors
         * @memberof coreproductpb.CancelCoverageResponse
         * @instance
         */
        CancelCoverageResponse.prototype.errors = $util.emptyArray;

        /**
         * Creates a new CancelCoverageResponse instance using the specified properties.
         * @function create
         * @memberof coreproductpb.CancelCoverageResponse
         * @static
         * @param {coreproductpb.ICancelCoverageResponse=} [properties] Properties to set
         * @returns {coreproductpb.CancelCoverageResponse} CancelCoverageResponse instance
         */
        CancelCoverageResponse.create = function create(properties) {
            return new CancelCoverageResponse(properties);
        };

        /**
         * Encodes the specified CancelCoverageResponse message. Does not implicitly {@link coreproductpb.CancelCoverageResponse.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.CancelCoverageResponse
         * @static
         * @param {coreproductpb.ICancelCoverageResponse} m CancelCoverageResponse message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CancelCoverageResponse.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.errors != null && m.errors.length) {
                for (var i = 0; i < m.errors.length; ++i)
                    $root.common.Error.encode(m.errors[i], w.uint32(10).fork()).ldelim();
            }
            return w;
        };

        /**
         * Decodes a CancelCoverageResponse message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.CancelCoverageResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.CancelCoverageResponse} CancelCoverageResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CancelCoverageResponse.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.CancelCoverageResponse();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    if (!(m.errors && m.errors.length))
                        m.errors = [];
                    m.errors.push($root.common.Error.decode(r, r.uint32()));
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return CancelCoverageResponse;
    })();

    coreproductpb.CreateCoverageRequest = (function() {

        /**
         * Properties of a CreateCoverageRequest.
         * @memberof coreproductpb
         * @interface ICreateCoverageRequest
         * @property {string|null} [name] CreateCoverageRequest name
         * @property {string|null} [description] CreateCoverageRequest description
         * @property {Array.<coreproductpb.Coverage.ICoverageItem>|null} [items] CreateCoverageRequest items
         * @property {coreproductpb.CoverageType|null} [type] CreateCoverageRequest type
         * @property {Array.<string>|null} [tags] CreateCoverageRequest tags
         */

        /**
         * Constructs a new CreateCoverageRequest.
         * @memberof coreproductpb
         * @classdesc Represents a CreateCoverageRequest.
         * @implements ICreateCoverageRequest
         * @constructor
         * @param {coreproductpb.ICreateCoverageRequest=} [p] Properties to set
         */
        function CreateCoverageRequest(p) {
            this.items = [];
            this.tags = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * CreateCoverageRequest name.
         * @member {string} name
         * @memberof coreproductpb.CreateCoverageRequest
         * @instance
         */
        CreateCoverageRequest.prototype.name = "";

        /**
         * CreateCoverageRequest description.
         * @member {string} description
         * @memberof coreproductpb.CreateCoverageRequest
         * @instance
         */
        CreateCoverageRequest.prototype.description = "";

        /**
         * CreateCoverageRequest items.
         * @member {Array.<coreproductpb.Coverage.ICoverageItem>} items
         * @memberof coreproductpb.CreateCoverageRequest
         * @instance
         */
        CreateCoverageRequest.prototype.items = $util.emptyArray;

        /**
         * CreateCoverageRequest type.
         * @member {coreproductpb.CoverageType} type
         * @memberof coreproductpb.CreateCoverageRequest
         * @instance
         */
        CreateCoverageRequest.prototype.type = 0;

        /**
         * CreateCoverageRequest tags.
         * @member {Array.<string>} tags
         * @memberof coreproductpb.CreateCoverageRequest
         * @instance
         */
        CreateCoverageRequest.prototype.tags = $util.emptyArray;

        /**
         * Creates a new CreateCoverageRequest instance using the specified properties.
         * @function create
         * @memberof coreproductpb.CreateCoverageRequest
         * @static
         * @param {coreproductpb.ICreateCoverageRequest=} [properties] Properties to set
         * @returns {coreproductpb.CreateCoverageRequest} CreateCoverageRequest instance
         */
        CreateCoverageRequest.create = function create(properties) {
            return new CreateCoverageRequest(properties);
        };

        /**
         * Encodes the specified CreateCoverageRequest message. Does not implicitly {@link coreproductpb.CreateCoverageRequest.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.CreateCoverageRequest
         * @static
         * @param {coreproductpb.ICreateCoverageRequest} m CreateCoverageRequest message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CreateCoverageRequest.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.name != null && Object.hasOwnProperty.call(m, "name"))
                w.uint32(10).string(m.name);
            if (m.description != null && Object.hasOwnProperty.call(m, "description"))
                w.uint32(18).string(m.description);
            if (m.items != null && m.items.length) {
                for (var i = 0; i < m.items.length; ++i)
                    $root.coreproductpb.Coverage.CoverageItem.encode(m.items[i], w.uint32(26).fork()).ldelim();
            }
            if (m.type != null && Object.hasOwnProperty.call(m, "type"))
                w.uint32(32).int32(m.type);
            if (m.tags != null && m.tags.length) {
                for (var i = 0; i < m.tags.length; ++i)
                    w.uint32(42).string(m.tags[i]);
            }
            return w;
        };

        /**
         * Decodes a CreateCoverageRequest message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.CreateCoverageRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.CreateCoverageRequest} CreateCoverageRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CreateCoverageRequest.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.CreateCoverageRequest();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.name = r.string();
                    break;
                case 2:
                    m.description = r.string();
                    break;
                case 3:
                    if (!(m.items && m.items.length))
                        m.items = [];
                    m.items.push($root.coreproductpb.Coverage.CoverageItem.decode(r, r.uint32()));
                    break;
                case 4:
                    m.type = r.int32();
                    break;
                case 5:
                    if (!(m.tags && m.tags.length))
                        m.tags = [];
                    m.tags.push(r.string());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return CreateCoverageRequest;
    })();

    coreproductpb.CreateCoverageResponse = (function() {

        /**
         * Properties of a CreateCoverageResponse.
         * @memberof coreproductpb
         * @interface ICreateCoverageResponse
         * @property {string|null} [coverageID] CreateCoverageResponse coverageID
         * @property {Array.<common.IError>|null} [errors] CreateCoverageResponse errors
         * @property {coreproductpb.CoverageType|null} [type] CreateCoverageResponse type
         */

        /**
         * Constructs a new CreateCoverageResponse.
         * @memberof coreproductpb
         * @classdesc Represents a CreateCoverageResponse.
         * @implements ICreateCoverageResponse
         * @constructor
         * @param {coreproductpb.ICreateCoverageResponse=} [p] Properties to set
         */
        function CreateCoverageResponse(p) {
            this.errors = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * CreateCoverageResponse coverageID.
         * @member {string} coverageID
         * @memberof coreproductpb.CreateCoverageResponse
         * @instance
         */
        CreateCoverageResponse.prototype.coverageID = "";

        /**
         * CreateCoverageResponse errors.
         * @member {Array.<common.IError>} errors
         * @memberof coreproductpb.CreateCoverageResponse
         * @instance
         */
        CreateCoverageResponse.prototype.errors = $util.emptyArray;

        /**
         * CreateCoverageResponse type.
         * @member {coreproductpb.CoverageType} type
         * @memberof coreproductpb.CreateCoverageResponse
         * @instance
         */
        CreateCoverageResponse.prototype.type = 0;

        /**
         * Creates a new CreateCoverageResponse instance using the specified properties.
         * @function create
         * @memberof coreproductpb.CreateCoverageResponse
         * @static
         * @param {coreproductpb.ICreateCoverageResponse=} [properties] Properties to set
         * @returns {coreproductpb.CreateCoverageResponse} CreateCoverageResponse instance
         */
        CreateCoverageResponse.create = function create(properties) {
            return new CreateCoverageResponse(properties);
        };

        /**
         * Encodes the specified CreateCoverageResponse message. Does not implicitly {@link coreproductpb.CreateCoverageResponse.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.CreateCoverageResponse
         * @static
         * @param {coreproductpb.ICreateCoverageResponse} m CreateCoverageResponse message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CreateCoverageResponse.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.coverageID != null && Object.hasOwnProperty.call(m, "coverageID"))
                w.uint32(10).string(m.coverageID);
            if (m.errors != null && m.errors.length) {
                for (var i = 0; i < m.errors.length; ++i)
                    $root.common.Error.encode(m.errors[i], w.uint32(18).fork()).ldelim();
            }
            if (m.type != null && Object.hasOwnProperty.call(m, "type"))
                w.uint32(24).int32(m.type);
            return w;
        };

        /**
         * Decodes a CreateCoverageResponse message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.CreateCoverageResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.CreateCoverageResponse} CreateCoverageResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CreateCoverageResponse.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.CreateCoverageResponse();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.coverageID = r.string();
                    break;
                case 2:
                    if (!(m.errors && m.errors.length))
                        m.errors = [];
                    m.errors.push($root.common.Error.decode(r, r.uint32()));
                    break;
                case 3:
                    m.type = r.int32();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return CreateCoverageResponse;
    })();

    coreproductpb.ReplaceCoverageRequest = (function() {

        /**
         * Properties of a ReplaceCoverageRequest.
         * @memberof coreproductpb
         * @interface IReplaceCoverageRequest
         * @property {string|null} [coverageID] ReplaceCoverageRequest coverageID
         * @property {string|null} [name] ReplaceCoverageRequest name
         * @property {string|null} [description] ReplaceCoverageRequest description
         * @property {Array.<coreproductpb.Coverage.ICoverageItem>|null} [items] ReplaceCoverageRequest items
         * @property {Array.<string>|null} [tags] ReplaceCoverageRequest tags
         * @property {google.protobuf.ITimestamp|null} [expirationDate] ReplaceCoverageRequest expirationDate
         */

        /**
         * Constructs a new ReplaceCoverageRequest.
         * @memberof coreproductpb
         * @classdesc Represents a ReplaceCoverageRequest.
         * @implements IReplaceCoverageRequest
         * @constructor
         * @param {coreproductpb.IReplaceCoverageRequest=} [p] Properties to set
         */
        function ReplaceCoverageRequest(p) {
            this.items = [];
            this.tags = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * ReplaceCoverageRequest coverageID.
         * @member {string} coverageID
         * @memberof coreproductpb.ReplaceCoverageRequest
         * @instance
         */
        ReplaceCoverageRequest.prototype.coverageID = "";

        /**
         * ReplaceCoverageRequest name.
         * @member {string} name
         * @memberof coreproductpb.ReplaceCoverageRequest
         * @instance
         */
        ReplaceCoverageRequest.prototype.name = "";

        /**
         * ReplaceCoverageRequest description.
         * @member {string} description
         * @memberof coreproductpb.ReplaceCoverageRequest
         * @instance
         */
        ReplaceCoverageRequest.prototype.description = "";

        /**
         * ReplaceCoverageRequest items.
         * @member {Array.<coreproductpb.Coverage.ICoverageItem>} items
         * @memberof coreproductpb.ReplaceCoverageRequest
         * @instance
         */
        ReplaceCoverageRequest.prototype.items = $util.emptyArray;

        /**
         * ReplaceCoverageRequest tags.
         * @member {Array.<string>} tags
         * @memberof coreproductpb.ReplaceCoverageRequest
         * @instance
         */
        ReplaceCoverageRequest.prototype.tags = $util.emptyArray;

        /**
         * ReplaceCoverageRequest expirationDate.
         * @member {google.protobuf.ITimestamp|null|undefined} expirationDate
         * @memberof coreproductpb.ReplaceCoverageRequest
         * @instance
         */
        ReplaceCoverageRequest.prototype.expirationDate = null;

        /**
         * Creates a new ReplaceCoverageRequest instance using the specified properties.
         * @function create
         * @memberof coreproductpb.ReplaceCoverageRequest
         * @static
         * @param {coreproductpb.IReplaceCoverageRequest=} [properties] Properties to set
         * @returns {coreproductpb.ReplaceCoverageRequest} ReplaceCoverageRequest instance
         */
        ReplaceCoverageRequest.create = function create(properties) {
            return new ReplaceCoverageRequest(properties);
        };

        /**
         * Encodes the specified ReplaceCoverageRequest message. Does not implicitly {@link coreproductpb.ReplaceCoverageRequest.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.ReplaceCoverageRequest
         * @static
         * @param {coreproductpb.IReplaceCoverageRequest} m ReplaceCoverageRequest message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ReplaceCoverageRequest.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.coverageID != null && Object.hasOwnProperty.call(m, "coverageID"))
                w.uint32(10).string(m.coverageID);
            if (m.name != null && Object.hasOwnProperty.call(m, "name"))
                w.uint32(18).string(m.name);
            if (m.description != null && Object.hasOwnProperty.call(m, "description"))
                w.uint32(26).string(m.description);
            if (m.items != null && m.items.length) {
                for (var i = 0; i < m.items.length; ++i)
                    $root.coreproductpb.Coverage.CoverageItem.encode(m.items[i], w.uint32(34).fork()).ldelim();
            }
            if (m.tags != null && m.tags.length) {
                for (var i = 0; i < m.tags.length; ++i)
                    w.uint32(42).string(m.tags[i]);
            }
            if (m.expirationDate != null && Object.hasOwnProperty.call(m, "expirationDate"))
                $root.google.protobuf.Timestamp.encode(m.expirationDate, w.uint32(50).fork()).ldelim();
            return w;
        };

        /**
         * Decodes a ReplaceCoverageRequest message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.ReplaceCoverageRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.ReplaceCoverageRequest} ReplaceCoverageRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ReplaceCoverageRequest.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.ReplaceCoverageRequest();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.coverageID = r.string();
                    break;
                case 2:
                    m.name = r.string();
                    break;
                case 3:
                    m.description = r.string();
                    break;
                case 4:
                    if (!(m.items && m.items.length))
                        m.items = [];
                    m.items.push($root.coreproductpb.Coverage.CoverageItem.decode(r, r.uint32()));
                    break;
                case 5:
                    if (!(m.tags && m.tags.length))
                        m.tags = [];
                    m.tags.push(r.string());
                    break;
                case 6:
                    m.expirationDate = $root.google.protobuf.Timestamp.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return ReplaceCoverageRequest;
    })();

    coreproductpb.ReplaceCoverageResponse = (function() {

        /**
         * Properties of a ReplaceCoverageResponse.
         * @memberof coreproductpb
         * @interface IReplaceCoverageResponse
         * @property {Array.<common.IError>|null} [errors] ReplaceCoverageResponse errors
         * @property {string|null} [coverageID] ReplaceCoverageResponse coverageID
         * @property {coreproductpb.CoverageType|null} [type] ReplaceCoverageResponse type
         */

        /**
         * Constructs a new ReplaceCoverageResponse.
         * @memberof coreproductpb
         * @classdesc Represents a ReplaceCoverageResponse.
         * @implements IReplaceCoverageResponse
         * @constructor
         * @param {coreproductpb.IReplaceCoverageResponse=} [p] Properties to set
         */
        function ReplaceCoverageResponse(p) {
            this.errors = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * ReplaceCoverageResponse errors.
         * @member {Array.<common.IError>} errors
         * @memberof coreproductpb.ReplaceCoverageResponse
         * @instance
         */
        ReplaceCoverageResponse.prototype.errors = $util.emptyArray;

        /**
         * ReplaceCoverageResponse coverageID.
         * @member {string} coverageID
         * @memberof coreproductpb.ReplaceCoverageResponse
         * @instance
         */
        ReplaceCoverageResponse.prototype.coverageID = "";

        /**
         * ReplaceCoverageResponse type.
         * @member {coreproductpb.CoverageType} type
         * @memberof coreproductpb.ReplaceCoverageResponse
         * @instance
         */
        ReplaceCoverageResponse.prototype.type = 0;

        /**
         * Creates a new ReplaceCoverageResponse instance using the specified properties.
         * @function create
         * @memberof coreproductpb.ReplaceCoverageResponse
         * @static
         * @param {coreproductpb.IReplaceCoverageResponse=} [properties] Properties to set
         * @returns {coreproductpb.ReplaceCoverageResponse} ReplaceCoverageResponse instance
         */
        ReplaceCoverageResponse.create = function create(properties) {
            return new ReplaceCoverageResponse(properties);
        };

        /**
         * Encodes the specified ReplaceCoverageResponse message. Does not implicitly {@link coreproductpb.ReplaceCoverageResponse.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.ReplaceCoverageResponse
         * @static
         * @param {coreproductpb.IReplaceCoverageResponse} m ReplaceCoverageResponse message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ReplaceCoverageResponse.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.errors != null && m.errors.length) {
                for (var i = 0; i < m.errors.length; ++i)
                    $root.common.Error.encode(m.errors[i], w.uint32(10).fork()).ldelim();
            }
            if (m.coverageID != null && Object.hasOwnProperty.call(m, "coverageID"))
                w.uint32(18).string(m.coverageID);
            if (m.type != null && Object.hasOwnProperty.call(m, "type"))
                w.uint32(24).int32(m.type);
            return w;
        };

        /**
         * Decodes a ReplaceCoverageResponse message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.ReplaceCoverageResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.ReplaceCoverageResponse} ReplaceCoverageResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ReplaceCoverageResponse.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.ReplaceCoverageResponse();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    if (!(m.errors && m.errors.length))
                        m.errors = [];
                    m.errors.push($root.common.Error.decode(r, r.uint32()));
                    break;
                case 2:
                    m.coverageID = r.string();
                    break;
                case 3:
                    m.type = r.int32();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return ReplaceCoverageResponse;
    })();

    coreproductpb.PostExportProductTemplateRequest = (function() {

        /**
         * Properties of a PostExportProductTemplateRequest.
         * @memberof coreproductpb
         * @interface IPostExportProductTemplateRequest
         * @property {string|null} [productTemplateID] PostExportProductTemplateRequest productTemplateID
         * @property {string|null} [templateVersionID] PostExportProductTemplateRequest templateVersionID
         */

        /**
         * Constructs a new PostExportProductTemplateRequest.
         * @memberof coreproductpb
         * @classdesc Represents a PostExportProductTemplateRequest.
         * @implements IPostExportProductTemplateRequest
         * @constructor
         * @param {coreproductpb.IPostExportProductTemplateRequest=} [p] Properties to set
         */
        function PostExportProductTemplateRequest(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * PostExportProductTemplateRequest productTemplateID.
         * @member {string} productTemplateID
         * @memberof coreproductpb.PostExportProductTemplateRequest
         * @instance
         */
        PostExportProductTemplateRequest.prototype.productTemplateID = "";

        /**
         * PostExportProductTemplateRequest templateVersionID.
         * @member {string} templateVersionID
         * @memberof coreproductpb.PostExportProductTemplateRequest
         * @instance
         */
        PostExportProductTemplateRequest.prototype.templateVersionID = "";

        /**
         * Creates a new PostExportProductTemplateRequest instance using the specified properties.
         * @function create
         * @memberof coreproductpb.PostExportProductTemplateRequest
         * @static
         * @param {coreproductpb.IPostExportProductTemplateRequest=} [properties] Properties to set
         * @returns {coreproductpb.PostExportProductTemplateRequest} PostExportProductTemplateRequest instance
         */
        PostExportProductTemplateRequest.create = function create(properties) {
            return new PostExportProductTemplateRequest(properties);
        };

        /**
         * Encodes the specified PostExportProductTemplateRequest message. Does not implicitly {@link coreproductpb.PostExportProductTemplateRequest.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.PostExportProductTemplateRequest
         * @static
         * @param {coreproductpb.IPostExportProductTemplateRequest} m PostExportProductTemplateRequest message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PostExportProductTemplateRequest.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.productTemplateID != null && Object.hasOwnProperty.call(m, "productTemplateID"))
                w.uint32(10).string(m.productTemplateID);
            if (m.templateVersionID != null && Object.hasOwnProperty.call(m, "templateVersionID"))
                w.uint32(18).string(m.templateVersionID);
            return w;
        };

        /**
         * Decodes a PostExportProductTemplateRequest message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.PostExportProductTemplateRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.PostExportProductTemplateRequest} PostExportProductTemplateRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PostExportProductTemplateRequest.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.PostExportProductTemplateRequest();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.productTemplateID = r.string();
                    break;
                case 2:
                    m.templateVersionID = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return PostExportProductTemplateRequest;
    })();

    coreproductpb.PostExportProductTemplateResponse = (function() {

        /**
         * Properties of a PostExportProductTemplateResponse.
         * @memberof coreproductpb
         * @interface IPostExportProductTemplateResponse
         * @property {Array.<common.IError>|null} [errors] PostExportProductTemplateResponse errors
         */

        /**
         * Constructs a new PostExportProductTemplateResponse.
         * @memberof coreproductpb
         * @classdesc Represents a PostExportProductTemplateResponse.
         * @implements IPostExportProductTemplateResponse
         * @constructor
         * @param {coreproductpb.IPostExportProductTemplateResponse=} [p] Properties to set
         */
        function PostExportProductTemplateResponse(p) {
            this.errors = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * PostExportProductTemplateResponse errors.
         * @member {Array.<common.IError>} errors
         * @memberof coreproductpb.PostExportProductTemplateResponse
         * @instance
         */
        PostExportProductTemplateResponse.prototype.errors = $util.emptyArray;

        /**
         * Creates a new PostExportProductTemplateResponse instance using the specified properties.
         * @function create
         * @memberof coreproductpb.PostExportProductTemplateResponse
         * @static
         * @param {coreproductpb.IPostExportProductTemplateResponse=} [properties] Properties to set
         * @returns {coreproductpb.PostExportProductTemplateResponse} PostExportProductTemplateResponse instance
         */
        PostExportProductTemplateResponse.create = function create(properties) {
            return new PostExportProductTemplateResponse(properties);
        };

        /**
         * Encodes the specified PostExportProductTemplateResponse message. Does not implicitly {@link coreproductpb.PostExportProductTemplateResponse.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.PostExportProductTemplateResponse
         * @static
         * @param {coreproductpb.IPostExportProductTemplateResponse} m PostExportProductTemplateResponse message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PostExportProductTemplateResponse.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.errors != null && m.errors.length) {
                for (var i = 0; i < m.errors.length; ++i)
                    $root.common.Error.encode(m.errors[i], w.uint32(10).fork()).ldelim();
            }
            return w;
        };

        /**
         * Decodes a PostExportProductTemplateResponse message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.PostExportProductTemplateResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.PostExportProductTemplateResponse} PostExportProductTemplateResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PostExportProductTemplateResponse.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.PostExportProductTemplateResponse();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    if (!(m.errors && m.errors.length))
                        m.errors = [];
                    m.errors.push($root.common.Error.decode(r, r.uint32()));
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return PostExportProductTemplateResponse;
    })();

    coreproductpb.PostImportProductTemplateRequest = (function() {

        /**
         * Properties of a PostImportProductTemplateRequest.
         * @memberof coreproductpb
         * @interface IPostImportProductTemplateRequest
         * @property {string|null} [mediaFileID] PostImportProductTemplateRequest mediaFileID
         * @property {google.protobuf.ITimestamp|null} [effectiveDate] PostImportProductTemplateRequest effectiveDate
         */

        /**
         * Constructs a new PostImportProductTemplateRequest.
         * @memberof coreproductpb
         * @classdesc Represents a PostImportProductTemplateRequest.
         * @implements IPostImportProductTemplateRequest
         * @constructor
         * @param {coreproductpb.IPostImportProductTemplateRequest=} [p] Properties to set
         */
        function PostImportProductTemplateRequest(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * PostImportProductTemplateRequest mediaFileID.
         * @member {string} mediaFileID
         * @memberof coreproductpb.PostImportProductTemplateRequest
         * @instance
         */
        PostImportProductTemplateRequest.prototype.mediaFileID = "";

        /**
         * PostImportProductTemplateRequest effectiveDate.
         * @member {google.protobuf.ITimestamp|null|undefined} effectiveDate
         * @memberof coreproductpb.PostImportProductTemplateRequest
         * @instance
         */
        PostImportProductTemplateRequest.prototype.effectiveDate = null;

        /**
         * Creates a new PostImportProductTemplateRequest instance using the specified properties.
         * @function create
         * @memberof coreproductpb.PostImportProductTemplateRequest
         * @static
         * @param {coreproductpb.IPostImportProductTemplateRequest=} [properties] Properties to set
         * @returns {coreproductpb.PostImportProductTemplateRequest} PostImportProductTemplateRequest instance
         */
        PostImportProductTemplateRequest.create = function create(properties) {
            return new PostImportProductTemplateRequest(properties);
        };

        /**
         * Encodes the specified PostImportProductTemplateRequest message. Does not implicitly {@link coreproductpb.PostImportProductTemplateRequest.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.PostImportProductTemplateRequest
         * @static
         * @param {coreproductpb.IPostImportProductTemplateRequest} m PostImportProductTemplateRequest message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PostImportProductTemplateRequest.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.mediaFileID != null && Object.hasOwnProperty.call(m, "mediaFileID"))
                w.uint32(10).string(m.mediaFileID);
            if (m.effectiveDate != null && Object.hasOwnProperty.call(m, "effectiveDate"))
                $root.google.protobuf.Timestamp.encode(m.effectiveDate, w.uint32(18).fork()).ldelim();
            return w;
        };

        /**
         * Decodes a PostImportProductTemplateRequest message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.PostImportProductTemplateRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.PostImportProductTemplateRequest} PostImportProductTemplateRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PostImportProductTemplateRequest.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.PostImportProductTemplateRequest();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.mediaFileID = r.string();
                    break;
                case 2:
                    m.effectiveDate = $root.google.protobuf.Timestamp.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return PostImportProductTemplateRequest;
    })();

    coreproductpb.PostImportProductTemplateResponse = (function() {

        /**
         * Properties of a PostImportProductTemplateResponse.
         * @memberof coreproductpb
         * @interface IPostImportProductTemplateResponse
         * @property {Array.<common.IError>|null} [errors] PostImportProductTemplateResponse errors
         */

        /**
         * Constructs a new PostImportProductTemplateResponse.
         * @memberof coreproductpb
         * @classdesc Represents a PostImportProductTemplateResponse.
         * @implements IPostImportProductTemplateResponse
         * @constructor
         * @param {coreproductpb.IPostImportProductTemplateResponse=} [p] Properties to set
         */
        function PostImportProductTemplateResponse(p) {
            this.errors = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * PostImportProductTemplateResponse errors.
         * @member {Array.<common.IError>} errors
         * @memberof coreproductpb.PostImportProductTemplateResponse
         * @instance
         */
        PostImportProductTemplateResponse.prototype.errors = $util.emptyArray;

        /**
         * Creates a new PostImportProductTemplateResponse instance using the specified properties.
         * @function create
         * @memberof coreproductpb.PostImportProductTemplateResponse
         * @static
         * @param {coreproductpb.IPostImportProductTemplateResponse=} [properties] Properties to set
         * @returns {coreproductpb.PostImportProductTemplateResponse} PostImportProductTemplateResponse instance
         */
        PostImportProductTemplateResponse.create = function create(properties) {
            return new PostImportProductTemplateResponse(properties);
        };

        /**
         * Encodes the specified PostImportProductTemplateResponse message. Does not implicitly {@link coreproductpb.PostImportProductTemplateResponse.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.PostImportProductTemplateResponse
         * @static
         * @param {coreproductpb.IPostImportProductTemplateResponse} m PostImportProductTemplateResponse message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PostImportProductTemplateResponse.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.errors != null && m.errors.length) {
                for (var i = 0; i < m.errors.length; ++i)
                    $root.common.Error.encode(m.errors[i], w.uint32(10).fork()).ldelim();
            }
            return w;
        };

        /**
         * Decodes a PostImportProductTemplateResponse message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.PostImportProductTemplateResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.PostImportProductTemplateResponse} PostImportProductTemplateResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PostImportProductTemplateResponse.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.PostImportProductTemplateResponse();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    if (!(m.errors && m.errors.length))
                        m.errors = [];
                    m.errors.push($root.common.Error.decode(r, r.uint32()));
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return PostImportProductTemplateResponse;
    })();

    coreproductpb.FeatureCoverage = (function() {

        /**
         * Properties of a FeatureCoverage.
         * @memberof coreproductpb
         * @interface IFeatureCoverage
         * @property {string|null} [featureCoverageID] FeatureCoverage featureCoverageID
         * @property {string|null} [starCoverageID] FeatureCoverage starCoverageID
         * @property {string|null} [name] FeatureCoverage name
         * @property {string|null} [description] FeatureCoverage description
         * @property {coreproductpb.DataRecordStatus|null} [status] FeatureCoverage status
         * @property {Array.<string>|null} [tags] FeatureCoverage tags
         * @property {google.protobuf.ITimestamp|null} [createdOn] FeatureCoverage createdOn
         * @property {google.protobuf.ITimestamp|null} [updatedOn] FeatureCoverage updatedOn
         * @property {string|null} [createdBy] FeatureCoverage createdBy
         * @property {string|null} [updatedBy] FeatureCoverage updatedBy
         */

        /**
         * Constructs a new FeatureCoverage.
         * @memberof coreproductpb
         * @classdesc Represents a FeatureCoverage.
         * @implements IFeatureCoverage
         * @constructor
         * @param {coreproductpb.IFeatureCoverage=} [p] Properties to set
         */
        function FeatureCoverage(p) {
            this.tags = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * FeatureCoverage featureCoverageID.
         * @member {string} featureCoverageID
         * @memberof coreproductpb.FeatureCoverage
         * @instance
         */
        FeatureCoverage.prototype.featureCoverageID = "";

        /**
         * FeatureCoverage starCoverageID.
         * @member {string} starCoverageID
         * @memberof coreproductpb.FeatureCoverage
         * @instance
         */
        FeatureCoverage.prototype.starCoverageID = "";

        /**
         * FeatureCoverage name.
         * @member {string} name
         * @memberof coreproductpb.FeatureCoverage
         * @instance
         */
        FeatureCoverage.prototype.name = "";

        /**
         * FeatureCoverage description.
         * @member {string} description
         * @memberof coreproductpb.FeatureCoverage
         * @instance
         */
        FeatureCoverage.prototype.description = "";

        /**
         * FeatureCoverage status.
         * @member {coreproductpb.DataRecordStatus} status
         * @memberof coreproductpb.FeatureCoverage
         * @instance
         */
        FeatureCoverage.prototype.status = 0;

        /**
         * FeatureCoverage tags.
         * @member {Array.<string>} tags
         * @memberof coreproductpb.FeatureCoverage
         * @instance
         */
        FeatureCoverage.prototype.tags = $util.emptyArray;

        /**
         * FeatureCoverage createdOn.
         * @member {google.protobuf.ITimestamp|null|undefined} createdOn
         * @memberof coreproductpb.FeatureCoverage
         * @instance
         */
        FeatureCoverage.prototype.createdOn = null;

        /**
         * FeatureCoverage updatedOn.
         * @member {google.protobuf.ITimestamp|null|undefined} updatedOn
         * @memberof coreproductpb.FeatureCoverage
         * @instance
         */
        FeatureCoverage.prototype.updatedOn = null;

        /**
         * FeatureCoverage createdBy.
         * @member {string} createdBy
         * @memberof coreproductpb.FeatureCoverage
         * @instance
         */
        FeatureCoverage.prototype.createdBy = "";

        /**
         * FeatureCoverage updatedBy.
         * @member {string} updatedBy
         * @memberof coreproductpb.FeatureCoverage
         * @instance
         */
        FeatureCoverage.prototype.updatedBy = "";

        /**
         * Creates a new FeatureCoverage instance using the specified properties.
         * @function create
         * @memberof coreproductpb.FeatureCoverage
         * @static
         * @param {coreproductpb.IFeatureCoverage=} [properties] Properties to set
         * @returns {coreproductpb.FeatureCoverage} FeatureCoverage instance
         */
        FeatureCoverage.create = function create(properties) {
            return new FeatureCoverage(properties);
        };

        /**
         * Encodes the specified FeatureCoverage message. Does not implicitly {@link coreproductpb.FeatureCoverage.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.FeatureCoverage
         * @static
         * @param {coreproductpb.IFeatureCoverage} m FeatureCoverage message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        FeatureCoverage.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.featureCoverageID != null && Object.hasOwnProperty.call(m, "featureCoverageID"))
                w.uint32(10).string(m.featureCoverageID);
            if (m.starCoverageID != null && Object.hasOwnProperty.call(m, "starCoverageID"))
                w.uint32(18).string(m.starCoverageID);
            if (m.name != null && Object.hasOwnProperty.call(m, "name"))
                w.uint32(26).string(m.name);
            if (m.description != null && Object.hasOwnProperty.call(m, "description"))
                w.uint32(34).string(m.description);
            if (m.status != null && Object.hasOwnProperty.call(m, "status"))
                w.uint32(40).int32(m.status);
            if (m.tags != null && m.tags.length) {
                for (var i = 0; i < m.tags.length; ++i)
                    w.uint32(50).string(m.tags[i]);
            }
            if (m.createdOn != null && Object.hasOwnProperty.call(m, "createdOn"))
                $root.google.protobuf.Timestamp.encode(m.createdOn, w.uint32(58).fork()).ldelim();
            if (m.updatedOn != null && Object.hasOwnProperty.call(m, "updatedOn"))
                $root.google.protobuf.Timestamp.encode(m.updatedOn, w.uint32(66).fork()).ldelim();
            if (m.createdBy != null && Object.hasOwnProperty.call(m, "createdBy"))
                w.uint32(74).string(m.createdBy);
            if (m.updatedBy != null && Object.hasOwnProperty.call(m, "updatedBy"))
                w.uint32(82).string(m.updatedBy);
            return w;
        };

        /**
         * Decodes a FeatureCoverage message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.FeatureCoverage
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.FeatureCoverage} FeatureCoverage
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        FeatureCoverage.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.FeatureCoverage();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.featureCoverageID = r.string();
                    break;
                case 2:
                    m.starCoverageID = r.string();
                    break;
                case 3:
                    m.name = r.string();
                    break;
                case 4:
                    m.description = r.string();
                    break;
                case 5:
                    m.status = r.int32();
                    break;
                case 6:
                    if (!(m.tags && m.tags.length))
                        m.tags = [];
                    m.tags.push(r.string());
                    break;
                case 7:
                    m.createdOn = $root.google.protobuf.Timestamp.decode(r, r.uint32());
                    break;
                case 8:
                    m.updatedOn = $root.google.protobuf.Timestamp.decode(r, r.uint32());
                    break;
                case 9:
                    m.createdBy = r.string();
                    break;
                case 10:
                    m.updatedBy = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return FeatureCoverage;
    })();

    coreproductpb.GetGeographicAvailabilityRequest = (function() {

        /**
         * Properties of a GetGeographicAvailabilityRequest.
         * @memberof coreproductpb
         * @interface IGetGeographicAvailabilityRequest
         * @property {string|null} [geographicAvailabilityID] GetGeographicAvailabilityRequest geographicAvailabilityID
         * @property {boolean|null} [includeProductTemplateDetail] GetGeographicAvailabilityRequest includeProductTemplateDetail
         * @property {Array.<coreproductpb.DataRecordStatus>|null} [status] GetGeographicAvailabilityRequest status
         * @property {common.IPaginationRequest|null} [pagination] GetGeographicAvailabilityRequest pagination
         * @property {string|null} [name] GetGeographicAvailabilityRequest name
         */

        /**
         * Constructs a new GetGeographicAvailabilityRequest.
         * @memberof coreproductpb
         * @classdesc Represents a GetGeographicAvailabilityRequest.
         * @implements IGetGeographicAvailabilityRequest
         * @constructor
         * @param {coreproductpb.IGetGeographicAvailabilityRequest=} [p] Properties to set
         */
        function GetGeographicAvailabilityRequest(p) {
            this.status = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * GetGeographicAvailabilityRequest geographicAvailabilityID.
         * @member {string} geographicAvailabilityID
         * @memberof coreproductpb.GetGeographicAvailabilityRequest
         * @instance
         */
        GetGeographicAvailabilityRequest.prototype.geographicAvailabilityID = "";

        /**
         * GetGeographicAvailabilityRequest includeProductTemplateDetail.
         * @member {boolean} includeProductTemplateDetail
         * @memberof coreproductpb.GetGeographicAvailabilityRequest
         * @instance
         */
        GetGeographicAvailabilityRequest.prototype.includeProductTemplateDetail = false;

        /**
         * GetGeographicAvailabilityRequest status.
         * @member {Array.<coreproductpb.DataRecordStatus>} status
         * @memberof coreproductpb.GetGeographicAvailabilityRequest
         * @instance
         */
        GetGeographicAvailabilityRequest.prototype.status = $util.emptyArray;

        /**
         * GetGeographicAvailabilityRequest pagination.
         * @member {common.IPaginationRequest|null|undefined} pagination
         * @memberof coreproductpb.GetGeographicAvailabilityRequest
         * @instance
         */
        GetGeographicAvailabilityRequest.prototype.pagination = null;

        /**
         * GetGeographicAvailabilityRequest name.
         * @member {string} name
         * @memberof coreproductpb.GetGeographicAvailabilityRequest
         * @instance
         */
        GetGeographicAvailabilityRequest.prototype.name = "";

        /**
         * Creates a new GetGeographicAvailabilityRequest instance using the specified properties.
         * @function create
         * @memberof coreproductpb.GetGeographicAvailabilityRequest
         * @static
         * @param {coreproductpb.IGetGeographicAvailabilityRequest=} [properties] Properties to set
         * @returns {coreproductpb.GetGeographicAvailabilityRequest} GetGeographicAvailabilityRequest instance
         */
        GetGeographicAvailabilityRequest.create = function create(properties) {
            return new GetGeographicAvailabilityRequest(properties);
        };

        /**
         * Encodes the specified GetGeographicAvailabilityRequest message. Does not implicitly {@link coreproductpb.GetGeographicAvailabilityRequest.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.GetGeographicAvailabilityRequest
         * @static
         * @param {coreproductpb.IGetGeographicAvailabilityRequest} m GetGeographicAvailabilityRequest message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetGeographicAvailabilityRequest.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.geographicAvailabilityID != null && Object.hasOwnProperty.call(m, "geographicAvailabilityID"))
                w.uint32(10).string(m.geographicAvailabilityID);
            if (m.includeProductTemplateDetail != null && Object.hasOwnProperty.call(m, "includeProductTemplateDetail"))
                w.uint32(16).bool(m.includeProductTemplateDetail);
            if (m.status != null && m.status.length) {
                w.uint32(26).fork();
                for (var i = 0; i < m.status.length; ++i)
                    w.int32(m.status[i]);
                w.ldelim();
            }
            if (m.pagination != null && Object.hasOwnProperty.call(m, "pagination"))
                $root.common.PaginationRequest.encode(m.pagination, w.uint32(34).fork()).ldelim();
            if (m.name != null && Object.hasOwnProperty.call(m, "name"))
                w.uint32(42).string(m.name);
            return w;
        };

        /**
         * Decodes a GetGeographicAvailabilityRequest message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.GetGeographicAvailabilityRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.GetGeographicAvailabilityRequest} GetGeographicAvailabilityRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetGeographicAvailabilityRequest.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.GetGeographicAvailabilityRequest();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.geographicAvailabilityID = r.string();
                    break;
                case 2:
                    m.includeProductTemplateDetail = r.bool();
                    break;
                case 3:
                    if (!(m.status && m.status.length))
                        m.status = [];
                    if ((t & 7) === 2) {
                        var c2 = r.uint32() + r.pos;
                        while (r.pos < c2)
                            m.status.push(r.int32());
                    } else
                        m.status.push(r.int32());
                    break;
                case 4:
                    m.pagination = $root.common.PaginationRequest.decode(r, r.uint32());
                    break;
                case 5:
                    m.name = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return GetGeographicAvailabilityRequest;
    })();

    coreproductpb.GeographicAvailabilityRuleValue = (function() {

        /**
         * Properties of a GeographicAvailabilityRuleValue.
         * @memberof coreproductpb
         * @interface IGeographicAvailabilityRuleValue
         * @property {boolean|null} [nationwide] GeographicAvailabilityRuleValue nationwide
         * @property {coreproductpb.IStateIncludeExclude|null} [states] GeographicAvailabilityRuleValue states
         * @property {coreproductpb.IZipCodeIncludeExclude|null} [zipCodes] GeographicAvailabilityRuleValue zipCodes
         * @property {google.protobuf.ITimestamp|null} [effectiveDate] GeographicAvailabilityRuleValue effectiveDate
         * @property {google.protobuf.ITimestamp|null} [expirationDate] GeographicAvailabilityRuleValue expirationDate
         */

        /**
         * Constructs a new GeographicAvailabilityRuleValue.
         * @memberof coreproductpb
         * @classdesc Represents a GeographicAvailabilityRuleValue.
         * @implements IGeographicAvailabilityRuleValue
         * @constructor
         * @param {coreproductpb.IGeographicAvailabilityRuleValue=} [p] Properties to set
         */
        function GeographicAvailabilityRuleValue(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * GeographicAvailabilityRuleValue nationwide.
         * @member {boolean} nationwide
         * @memberof coreproductpb.GeographicAvailabilityRuleValue
         * @instance
         */
        GeographicAvailabilityRuleValue.prototype.nationwide = false;

        /**
         * GeographicAvailabilityRuleValue states.
         * @member {coreproductpb.IStateIncludeExclude|null|undefined} states
         * @memberof coreproductpb.GeographicAvailabilityRuleValue
         * @instance
         */
        GeographicAvailabilityRuleValue.prototype.states = null;

        /**
         * GeographicAvailabilityRuleValue zipCodes.
         * @member {coreproductpb.IZipCodeIncludeExclude|null|undefined} zipCodes
         * @memberof coreproductpb.GeographicAvailabilityRuleValue
         * @instance
         */
        GeographicAvailabilityRuleValue.prototype.zipCodes = null;

        /**
         * GeographicAvailabilityRuleValue effectiveDate.
         * @member {google.protobuf.ITimestamp|null|undefined} effectiveDate
         * @memberof coreproductpb.GeographicAvailabilityRuleValue
         * @instance
         */
        GeographicAvailabilityRuleValue.prototype.effectiveDate = null;

        /**
         * GeographicAvailabilityRuleValue expirationDate.
         * @member {google.protobuf.ITimestamp|null|undefined} expirationDate
         * @memberof coreproductpb.GeographicAvailabilityRuleValue
         * @instance
         */
        GeographicAvailabilityRuleValue.prototype.expirationDate = null;

        /**
         * Creates a new GeographicAvailabilityRuleValue instance using the specified properties.
         * @function create
         * @memberof coreproductpb.GeographicAvailabilityRuleValue
         * @static
         * @param {coreproductpb.IGeographicAvailabilityRuleValue=} [properties] Properties to set
         * @returns {coreproductpb.GeographicAvailabilityRuleValue} GeographicAvailabilityRuleValue instance
         */
        GeographicAvailabilityRuleValue.create = function create(properties) {
            return new GeographicAvailabilityRuleValue(properties);
        };

        /**
         * Encodes the specified GeographicAvailabilityRuleValue message. Does not implicitly {@link coreproductpb.GeographicAvailabilityRuleValue.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.GeographicAvailabilityRuleValue
         * @static
         * @param {coreproductpb.IGeographicAvailabilityRuleValue} m GeographicAvailabilityRuleValue message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GeographicAvailabilityRuleValue.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.nationwide != null && Object.hasOwnProperty.call(m, "nationwide"))
                w.uint32(8).bool(m.nationwide);
            if (m.states != null && Object.hasOwnProperty.call(m, "states"))
                $root.coreproductpb.StateIncludeExclude.encode(m.states, w.uint32(18).fork()).ldelim();
            if (m.zipCodes != null && Object.hasOwnProperty.call(m, "zipCodes"))
                $root.coreproductpb.ZipCodeIncludeExclude.encode(m.zipCodes, w.uint32(26).fork()).ldelim();
            if (m.effectiveDate != null && Object.hasOwnProperty.call(m, "effectiveDate"))
                $root.google.protobuf.Timestamp.encode(m.effectiveDate, w.uint32(34).fork()).ldelim();
            if (m.expirationDate != null && Object.hasOwnProperty.call(m, "expirationDate"))
                $root.google.protobuf.Timestamp.encode(m.expirationDate, w.uint32(42).fork()).ldelim();
            return w;
        };

        /**
         * Decodes a GeographicAvailabilityRuleValue message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.GeographicAvailabilityRuleValue
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.GeographicAvailabilityRuleValue} GeographicAvailabilityRuleValue
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GeographicAvailabilityRuleValue.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.GeographicAvailabilityRuleValue();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.nationwide = r.bool();
                    break;
                case 2:
                    m.states = $root.coreproductpb.StateIncludeExclude.decode(r, r.uint32());
                    break;
                case 3:
                    m.zipCodes = $root.coreproductpb.ZipCodeIncludeExclude.decode(r, r.uint32());
                    break;
                case 4:
                    m.effectiveDate = $root.google.protobuf.Timestamp.decode(r, r.uint32());
                    break;
                case 5:
                    m.expirationDate = $root.google.protobuf.Timestamp.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return GeographicAvailabilityRuleValue;
    })();

    coreproductpb.GeographicAvailabilityRule = (function() {

        /**
         * Properties of a GeographicAvailabilityRule.
         * @memberof coreproductpb
         * @interface IGeographicAvailabilityRule
         * @property {coreproductpb.IGeographicAvailabilityRuleValue|null} [value] GeographicAvailabilityRule value
         * @property {google.protobuf.ITimestamp|null} [createdOn] GeographicAvailabilityRule createdOn
         * @property {google.protobuf.ITimestamp|null} [updatedOn] GeographicAvailabilityRule updatedOn
         * @property {string|null} [createdBy] GeographicAvailabilityRule createdBy
         * @property {string|null} [updatedBy] GeographicAvailabilityRule updatedBy
         */

        /**
         * Constructs a new GeographicAvailabilityRule.
         * @memberof coreproductpb
         * @classdesc Represents a GeographicAvailabilityRule.
         * @implements IGeographicAvailabilityRule
         * @constructor
         * @param {coreproductpb.IGeographicAvailabilityRule=} [p] Properties to set
         */
        function GeographicAvailabilityRule(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * GeographicAvailabilityRule value.
         * @member {coreproductpb.IGeographicAvailabilityRuleValue|null|undefined} value
         * @memberof coreproductpb.GeographicAvailabilityRule
         * @instance
         */
        GeographicAvailabilityRule.prototype.value = null;

        /**
         * GeographicAvailabilityRule createdOn.
         * @member {google.protobuf.ITimestamp|null|undefined} createdOn
         * @memberof coreproductpb.GeographicAvailabilityRule
         * @instance
         */
        GeographicAvailabilityRule.prototype.createdOn = null;

        /**
         * GeographicAvailabilityRule updatedOn.
         * @member {google.protobuf.ITimestamp|null|undefined} updatedOn
         * @memberof coreproductpb.GeographicAvailabilityRule
         * @instance
         */
        GeographicAvailabilityRule.prototype.updatedOn = null;

        /**
         * GeographicAvailabilityRule createdBy.
         * @member {string} createdBy
         * @memberof coreproductpb.GeographicAvailabilityRule
         * @instance
         */
        GeographicAvailabilityRule.prototype.createdBy = "";

        /**
         * GeographicAvailabilityRule updatedBy.
         * @member {string} updatedBy
         * @memberof coreproductpb.GeographicAvailabilityRule
         * @instance
         */
        GeographicAvailabilityRule.prototype.updatedBy = "";

        /**
         * Creates a new GeographicAvailabilityRule instance using the specified properties.
         * @function create
         * @memberof coreproductpb.GeographicAvailabilityRule
         * @static
         * @param {coreproductpb.IGeographicAvailabilityRule=} [properties] Properties to set
         * @returns {coreproductpb.GeographicAvailabilityRule} GeographicAvailabilityRule instance
         */
        GeographicAvailabilityRule.create = function create(properties) {
            return new GeographicAvailabilityRule(properties);
        };

        /**
         * Encodes the specified GeographicAvailabilityRule message. Does not implicitly {@link coreproductpb.GeographicAvailabilityRule.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.GeographicAvailabilityRule
         * @static
         * @param {coreproductpb.IGeographicAvailabilityRule} m GeographicAvailabilityRule message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GeographicAvailabilityRule.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.value != null && Object.hasOwnProperty.call(m, "value"))
                $root.coreproductpb.GeographicAvailabilityRuleValue.encode(m.value, w.uint32(10).fork()).ldelim();
            if (m.createdOn != null && Object.hasOwnProperty.call(m, "createdOn"))
                $root.google.protobuf.Timestamp.encode(m.createdOn, w.uint32(18).fork()).ldelim();
            if (m.updatedOn != null && Object.hasOwnProperty.call(m, "updatedOn"))
                $root.google.protobuf.Timestamp.encode(m.updatedOn, w.uint32(26).fork()).ldelim();
            if (m.createdBy != null && Object.hasOwnProperty.call(m, "createdBy"))
                w.uint32(34).string(m.createdBy);
            if (m.updatedBy != null && Object.hasOwnProperty.call(m, "updatedBy"))
                w.uint32(42).string(m.updatedBy);
            return w;
        };

        /**
         * Decodes a GeographicAvailabilityRule message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.GeographicAvailabilityRule
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.GeographicAvailabilityRule} GeographicAvailabilityRule
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GeographicAvailabilityRule.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.GeographicAvailabilityRule();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.value = $root.coreproductpb.GeographicAvailabilityRuleValue.decode(r, r.uint32());
                    break;
                case 2:
                    m.createdOn = $root.google.protobuf.Timestamp.decode(r, r.uint32());
                    break;
                case 3:
                    m.updatedOn = $root.google.protobuf.Timestamp.decode(r, r.uint32());
                    break;
                case 4:
                    m.createdBy = r.string();
                    break;
                case 5:
                    m.updatedBy = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return GeographicAvailabilityRule;
    })();

    coreproductpb.GeographicAvailabilityProductTemplateDetails = (function() {

        /**
         * Properties of a GeographicAvailabilityProductTemplateDetails.
         * @memberof coreproductpb
         * @interface IGeographicAvailabilityProductTemplateDetails
         * @property {string|null} [productTemplateID] GeographicAvailabilityProductTemplateDetails productTemplateID
         * @property {string|null} [productTemplateVersionID] GeographicAvailabilityProductTemplateDetails productTemplateVersionID
         * @property {string|null} [productTemplateName] GeographicAvailabilityProductTemplateDetails productTemplateName
         * @property {string|null} [productTemplateVersionDescription] GeographicAvailabilityProductTemplateDetails productTemplateVersionDescription
         * @property {coreproductpb.ProductTemplateVersionLifeCycleStage|null} [lifeCycleStage] GeographicAvailabilityProductTemplateDetails lifeCycleStage
         */

        /**
         * Constructs a new GeographicAvailabilityProductTemplateDetails.
         * @memberof coreproductpb
         * @classdesc Represents a GeographicAvailabilityProductTemplateDetails.
         * @implements IGeographicAvailabilityProductTemplateDetails
         * @constructor
         * @param {coreproductpb.IGeographicAvailabilityProductTemplateDetails=} [p] Properties to set
         */
        function GeographicAvailabilityProductTemplateDetails(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * GeographicAvailabilityProductTemplateDetails productTemplateID.
         * @member {string} productTemplateID
         * @memberof coreproductpb.GeographicAvailabilityProductTemplateDetails
         * @instance
         */
        GeographicAvailabilityProductTemplateDetails.prototype.productTemplateID = "";

        /**
         * GeographicAvailabilityProductTemplateDetails productTemplateVersionID.
         * @member {string} productTemplateVersionID
         * @memberof coreproductpb.GeographicAvailabilityProductTemplateDetails
         * @instance
         */
        GeographicAvailabilityProductTemplateDetails.prototype.productTemplateVersionID = "";

        /**
         * GeographicAvailabilityProductTemplateDetails productTemplateName.
         * @member {string} productTemplateName
         * @memberof coreproductpb.GeographicAvailabilityProductTemplateDetails
         * @instance
         */
        GeographicAvailabilityProductTemplateDetails.prototype.productTemplateName = "";

        /**
         * GeographicAvailabilityProductTemplateDetails productTemplateVersionDescription.
         * @member {string} productTemplateVersionDescription
         * @memberof coreproductpb.GeographicAvailabilityProductTemplateDetails
         * @instance
         */
        GeographicAvailabilityProductTemplateDetails.prototype.productTemplateVersionDescription = "";

        /**
         * GeographicAvailabilityProductTemplateDetails lifeCycleStage.
         * @member {coreproductpb.ProductTemplateVersionLifeCycleStage} lifeCycleStage
         * @memberof coreproductpb.GeographicAvailabilityProductTemplateDetails
         * @instance
         */
        GeographicAvailabilityProductTemplateDetails.prototype.lifeCycleStage = 0;

        /**
         * Creates a new GeographicAvailabilityProductTemplateDetails instance using the specified properties.
         * @function create
         * @memberof coreproductpb.GeographicAvailabilityProductTemplateDetails
         * @static
         * @param {coreproductpb.IGeographicAvailabilityProductTemplateDetails=} [properties] Properties to set
         * @returns {coreproductpb.GeographicAvailabilityProductTemplateDetails} GeographicAvailabilityProductTemplateDetails instance
         */
        GeographicAvailabilityProductTemplateDetails.create = function create(properties) {
            return new GeographicAvailabilityProductTemplateDetails(properties);
        };

        /**
         * Encodes the specified GeographicAvailabilityProductTemplateDetails message. Does not implicitly {@link coreproductpb.GeographicAvailabilityProductTemplateDetails.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.GeographicAvailabilityProductTemplateDetails
         * @static
         * @param {coreproductpb.IGeographicAvailabilityProductTemplateDetails} m GeographicAvailabilityProductTemplateDetails message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GeographicAvailabilityProductTemplateDetails.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.productTemplateID != null && Object.hasOwnProperty.call(m, "productTemplateID"))
                w.uint32(10).string(m.productTemplateID);
            if (m.productTemplateVersionID != null && Object.hasOwnProperty.call(m, "productTemplateVersionID"))
                w.uint32(18).string(m.productTemplateVersionID);
            if (m.productTemplateName != null && Object.hasOwnProperty.call(m, "productTemplateName"))
                w.uint32(26).string(m.productTemplateName);
            if (m.productTemplateVersionDescription != null && Object.hasOwnProperty.call(m, "productTemplateVersionDescription"))
                w.uint32(34).string(m.productTemplateVersionDescription);
            if (m.lifeCycleStage != null && Object.hasOwnProperty.call(m, "lifeCycleStage"))
                w.uint32(40).int32(m.lifeCycleStage);
            return w;
        };

        /**
         * Decodes a GeographicAvailabilityProductTemplateDetails message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.GeographicAvailabilityProductTemplateDetails
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.GeographicAvailabilityProductTemplateDetails} GeographicAvailabilityProductTemplateDetails
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GeographicAvailabilityProductTemplateDetails.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.GeographicAvailabilityProductTemplateDetails();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.productTemplateID = r.string();
                    break;
                case 2:
                    m.productTemplateVersionID = r.string();
                    break;
                case 3:
                    m.productTemplateName = r.string();
                    break;
                case 4:
                    m.productTemplateVersionDescription = r.string();
                    break;
                case 5:
                    m.lifeCycleStage = r.int32();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return GeographicAvailabilityProductTemplateDetails;
    })();

    coreproductpb.GeographicAvailability = (function() {

        /**
         * Properties of a GeographicAvailability.
         * @memberof coreproductpb
         * @interface IGeographicAvailability
         * @property {string|null} [geographicAvailabilityID] GeographicAvailability geographicAvailabilityID
         * @property {string|null} [name] GeographicAvailability name
         * @property {string|null} [description] GeographicAvailability description
         * @property {Array.<coreproductpb.IGeographicAvailabilityRule>|null} [rules] GeographicAvailability rules
         * @property {coreproductpb.DataRecordStatus|null} [status] GeographicAvailability status
         * @property {google.protobuf.ITimestamp|null} [effectiveDate] GeographicAvailability effectiveDate
         * @property {google.protobuf.ITimestamp|null} [expirationDate] GeographicAvailability expirationDate
         * @property {google.protobuf.ITimestamp|null} [createdOn] GeographicAvailability createdOn
         * @property {google.protobuf.ITimestamp|null} [updatedOn] GeographicAvailability updatedOn
         * @property {string|null} [createdBy] GeographicAvailability createdBy
         * @property {string|null} [updatedBy] GeographicAvailability updatedBy
         * @property {coreproductpb.IGeographicAvailabilityProductTemplateDetails|null} [productTemplateDetail] GeographicAvailability productTemplateDetail
         * @property {boolean|null} [expireAssociatedProducts] GeographicAvailability expireAssociatedProducts
         */

        /**
         * Constructs a new GeographicAvailability.
         * @memberof coreproductpb
         * @classdesc Represents a GeographicAvailability.
         * @implements IGeographicAvailability
         * @constructor
         * @param {coreproductpb.IGeographicAvailability=} [p] Properties to set
         */
        function GeographicAvailability(p) {
            this.rules = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * GeographicAvailability geographicAvailabilityID.
         * @member {string} geographicAvailabilityID
         * @memberof coreproductpb.GeographicAvailability
         * @instance
         */
        GeographicAvailability.prototype.geographicAvailabilityID = "";

        /**
         * GeographicAvailability name.
         * @member {string} name
         * @memberof coreproductpb.GeographicAvailability
         * @instance
         */
        GeographicAvailability.prototype.name = "";

        /**
         * GeographicAvailability description.
         * @member {string} description
         * @memberof coreproductpb.GeographicAvailability
         * @instance
         */
        GeographicAvailability.prototype.description = "";

        /**
         * GeographicAvailability rules.
         * @member {Array.<coreproductpb.IGeographicAvailabilityRule>} rules
         * @memberof coreproductpb.GeographicAvailability
         * @instance
         */
        GeographicAvailability.prototype.rules = $util.emptyArray;

        /**
         * GeographicAvailability status.
         * @member {coreproductpb.DataRecordStatus} status
         * @memberof coreproductpb.GeographicAvailability
         * @instance
         */
        GeographicAvailability.prototype.status = 0;

        /**
         * GeographicAvailability effectiveDate.
         * @member {google.protobuf.ITimestamp|null|undefined} effectiveDate
         * @memberof coreproductpb.GeographicAvailability
         * @instance
         */
        GeographicAvailability.prototype.effectiveDate = null;

        /**
         * GeographicAvailability expirationDate.
         * @member {google.protobuf.ITimestamp|null|undefined} expirationDate
         * @memberof coreproductpb.GeographicAvailability
         * @instance
         */
        GeographicAvailability.prototype.expirationDate = null;

        /**
         * GeographicAvailability createdOn.
         * @member {google.protobuf.ITimestamp|null|undefined} createdOn
         * @memberof coreproductpb.GeographicAvailability
         * @instance
         */
        GeographicAvailability.prototype.createdOn = null;

        /**
         * GeographicAvailability updatedOn.
         * @member {google.protobuf.ITimestamp|null|undefined} updatedOn
         * @memberof coreproductpb.GeographicAvailability
         * @instance
         */
        GeographicAvailability.prototype.updatedOn = null;

        /**
         * GeographicAvailability createdBy.
         * @member {string} createdBy
         * @memberof coreproductpb.GeographicAvailability
         * @instance
         */
        GeographicAvailability.prototype.createdBy = "";

        /**
         * GeographicAvailability updatedBy.
         * @member {string} updatedBy
         * @memberof coreproductpb.GeographicAvailability
         * @instance
         */
        GeographicAvailability.prototype.updatedBy = "";

        /**
         * GeographicAvailability productTemplateDetail.
         * @member {coreproductpb.IGeographicAvailabilityProductTemplateDetails|null|undefined} productTemplateDetail
         * @memberof coreproductpb.GeographicAvailability
         * @instance
         */
        GeographicAvailability.prototype.productTemplateDetail = null;

        /**
         * GeographicAvailability expireAssociatedProducts.
         * @member {boolean} expireAssociatedProducts
         * @memberof coreproductpb.GeographicAvailability
         * @instance
         */
        GeographicAvailability.prototype.expireAssociatedProducts = false;

        /**
         * Creates a new GeographicAvailability instance using the specified properties.
         * @function create
         * @memberof coreproductpb.GeographicAvailability
         * @static
         * @param {coreproductpb.IGeographicAvailability=} [properties] Properties to set
         * @returns {coreproductpb.GeographicAvailability} GeographicAvailability instance
         */
        GeographicAvailability.create = function create(properties) {
            return new GeographicAvailability(properties);
        };

        /**
         * Encodes the specified GeographicAvailability message. Does not implicitly {@link coreproductpb.GeographicAvailability.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.GeographicAvailability
         * @static
         * @param {coreproductpb.IGeographicAvailability} m GeographicAvailability message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GeographicAvailability.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.geographicAvailabilityID != null && Object.hasOwnProperty.call(m, "geographicAvailabilityID"))
                w.uint32(10).string(m.geographicAvailabilityID);
            if (m.name != null && Object.hasOwnProperty.call(m, "name"))
                w.uint32(18).string(m.name);
            if (m.description != null && Object.hasOwnProperty.call(m, "description"))
                w.uint32(26).string(m.description);
            if (m.rules != null && m.rules.length) {
                for (var i = 0; i < m.rules.length; ++i)
                    $root.coreproductpb.GeographicAvailabilityRule.encode(m.rules[i], w.uint32(34).fork()).ldelim();
            }
            if (m.status != null && Object.hasOwnProperty.call(m, "status"))
                w.uint32(40).int32(m.status);
            if (m.effectiveDate != null && Object.hasOwnProperty.call(m, "effectiveDate"))
                $root.google.protobuf.Timestamp.encode(m.effectiveDate, w.uint32(50).fork()).ldelim();
            if (m.expirationDate != null && Object.hasOwnProperty.call(m, "expirationDate"))
                $root.google.protobuf.Timestamp.encode(m.expirationDate, w.uint32(58).fork()).ldelim();
            if (m.createdOn != null && Object.hasOwnProperty.call(m, "createdOn"))
                $root.google.protobuf.Timestamp.encode(m.createdOn, w.uint32(66).fork()).ldelim();
            if (m.updatedOn != null && Object.hasOwnProperty.call(m, "updatedOn"))
                $root.google.protobuf.Timestamp.encode(m.updatedOn, w.uint32(74).fork()).ldelim();
            if (m.createdBy != null && Object.hasOwnProperty.call(m, "createdBy"))
                w.uint32(82).string(m.createdBy);
            if (m.updatedBy != null && Object.hasOwnProperty.call(m, "updatedBy"))
                w.uint32(90).string(m.updatedBy);
            if (m.productTemplateDetail != null && Object.hasOwnProperty.call(m, "productTemplateDetail"))
                $root.coreproductpb.GeographicAvailabilityProductTemplateDetails.encode(m.productTemplateDetail, w.uint32(98).fork()).ldelim();
            if (m.expireAssociatedProducts != null && Object.hasOwnProperty.call(m, "expireAssociatedProducts"))
                w.uint32(104).bool(m.expireAssociatedProducts);
            return w;
        };

        /**
         * Decodes a GeographicAvailability message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.GeographicAvailability
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.GeographicAvailability} GeographicAvailability
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GeographicAvailability.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.GeographicAvailability();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.geographicAvailabilityID = r.string();
                    break;
                case 2:
                    m.name = r.string();
                    break;
                case 3:
                    m.description = r.string();
                    break;
                case 4:
                    if (!(m.rules && m.rules.length))
                        m.rules = [];
                    m.rules.push($root.coreproductpb.GeographicAvailabilityRule.decode(r, r.uint32()));
                    break;
                case 5:
                    m.status = r.int32();
                    break;
                case 6:
                    m.effectiveDate = $root.google.protobuf.Timestamp.decode(r, r.uint32());
                    break;
                case 7:
                    m.expirationDate = $root.google.protobuf.Timestamp.decode(r, r.uint32());
                    break;
                case 8:
                    m.createdOn = $root.google.protobuf.Timestamp.decode(r, r.uint32());
                    break;
                case 9:
                    m.updatedOn = $root.google.protobuf.Timestamp.decode(r, r.uint32());
                    break;
                case 10:
                    m.createdBy = r.string();
                    break;
                case 11:
                    m.updatedBy = r.string();
                    break;
                case 12:
                    m.productTemplateDetail = $root.coreproductpb.GeographicAvailabilityProductTemplateDetails.decode(r, r.uint32());
                    break;
                case 13:
                    m.expireAssociatedProducts = r.bool();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return GeographicAvailability;
    })();

    coreproductpb.GetGeographicAvailabilityResponse = (function() {

        /**
         * Properties of a GetGeographicAvailabilityResponse.
         * @memberof coreproductpb
         * @interface IGetGeographicAvailabilityResponse
         * @property {Array.<coreproductpb.IGeographicAvailability>|null} [geographicAvailabilities] GetGeographicAvailabilityResponse geographicAvailabilities
         * @property {Array.<common.IError>|null} [errors] GetGeographicAvailabilityResponse errors
         * @property {common.IPagination|null} [pagination] GetGeographicAvailabilityResponse pagination
         * @property {Object.<string,number>|null} [statusesCount] GetGeographicAvailabilityResponse statusesCount
         */

        /**
         * Constructs a new GetGeographicAvailabilityResponse.
         * @memberof coreproductpb
         * @classdesc Represents a GetGeographicAvailabilityResponse.
         * @implements IGetGeographicAvailabilityResponse
         * @constructor
         * @param {coreproductpb.IGetGeographicAvailabilityResponse=} [p] Properties to set
         */
        function GetGeographicAvailabilityResponse(p) {
            this.geographicAvailabilities = [];
            this.errors = [];
            this.statusesCount = {};
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * GetGeographicAvailabilityResponse geographicAvailabilities.
         * @member {Array.<coreproductpb.IGeographicAvailability>} geographicAvailabilities
         * @memberof coreproductpb.GetGeographicAvailabilityResponse
         * @instance
         */
        GetGeographicAvailabilityResponse.prototype.geographicAvailabilities = $util.emptyArray;

        /**
         * GetGeographicAvailabilityResponse errors.
         * @member {Array.<common.IError>} errors
         * @memberof coreproductpb.GetGeographicAvailabilityResponse
         * @instance
         */
        GetGeographicAvailabilityResponse.prototype.errors = $util.emptyArray;

        /**
         * GetGeographicAvailabilityResponse pagination.
         * @member {common.IPagination|null|undefined} pagination
         * @memberof coreproductpb.GetGeographicAvailabilityResponse
         * @instance
         */
        GetGeographicAvailabilityResponse.prototype.pagination = null;

        /**
         * GetGeographicAvailabilityResponse statusesCount.
         * @member {Object.<string,number>} statusesCount
         * @memberof coreproductpb.GetGeographicAvailabilityResponse
         * @instance
         */
        GetGeographicAvailabilityResponse.prototype.statusesCount = $util.emptyObject;

        /**
         * Creates a new GetGeographicAvailabilityResponse instance using the specified properties.
         * @function create
         * @memberof coreproductpb.GetGeographicAvailabilityResponse
         * @static
         * @param {coreproductpb.IGetGeographicAvailabilityResponse=} [properties] Properties to set
         * @returns {coreproductpb.GetGeographicAvailabilityResponse} GetGeographicAvailabilityResponse instance
         */
        GetGeographicAvailabilityResponse.create = function create(properties) {
            return new GetGeographicAvailabilityResponse(properties);
        };

        /**
         * Encodes the specified GetGeographicAvailabilityResponse message. Does not implicitly {@link coreproductpb.GetGeographicAvailabilityResponse.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.GetGeographicAvailabilityResponse
         * @static
         * @param {coreproductpb.IGetGeographicAvailabilityResponse} m GetGeographicAvailabilityResponse message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetGeographicAvailabilityResponse.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.geographicAvailabilities != null && m.geographicAvailabilities.length) {
                for (var i = 0; i < m.geographicAvailabilities.length; ++i)
                    $root.coreproductpb.GeographicAvailability.encode(m.geographicAvailabilities[i], w.uint32(10).fork()).ldelim();
            }
            if (m.errors != null && m.errors.length) {
                for (var i = 0; i < m.errors.length; ++i)
                    $root.common.Error.encode(m.errors[i], w.uint32(18).fork()).ldelim();
            }
            if (m.pagination != null && Object.hasOwnProperty.call(m, "pagination"))
                $root.common.Pagination.encode(m.pagination, w.uint32(26).fork()).ldelim();
            if (m.statusesCount != null && Object.hasOwnProperty.call(m, "statusesCount")) {
                for (var ks = Object.keys(m.statusesCount), i = 0; i < ks.length; ++i) {
                    w.uint32(34).fork().uint32(8).int32(ks[i]).uint32(16).int32(m.statusesCount[ks[i]]).ldelim();
                }
            }
            return w;
        };

        /**
         * Decodes a GetGeographicAvailabilityResponse message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.GetGeographicAvailabilityResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.GetGeographicAvailabilityResponse} GetGeographicAvailabilityResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetGeographicAvailabilityResponse.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.GetGeographicAvailabilityResponse(), k, value;
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    if (!(m.geographicAvailabilities && m.geographicAvailabilities.length))
                        m.geographicAvailabilities = [];
                    m.geographicAvailabilities.push($root.coreproductpb.GeographicAvailability.decode(r, r.uint32()));
                    break;
                case 2:
                    if (!(m.errors && m.errors.length))
                        m.errors = [];
                    m.errors.push($root.common.Error.decode(r, r.uint32()));
                    break;
                case 3:
                    m.pagination = $root.common.Pagination.decode(r, r.uint32());
                    break;
                case 4:
                    if (m.statusesCount === $util.emptyObject)
                        m.statusesCount = {};
                    var c2 = r.uint32() + r.pos;
                    k = 0;
                    value = 0;
                    while (r.pos < c2) {
                        var tag2 = r.uint32();
                        switch (tag2 >>> 3) {
                        case 1:
                            k = r.int32();
                            break;
                        case 2:
                            value = r.int32();
                            break;
                        default:
                            r.skipType(tag2 & 7);
                            break;
                        }
                    }
                    m.statusesCount[k] = value;
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return GetGeographicAvailabilityResponse;
    })();

    coreproductpb.PostGeographicAvailabilityRequest = (function() {

        /**
         * Properties of a PostGeographicAvailabilityRequest.
         * @memberof coreproductpb
         * @interface IPostGeographicAvailabilityRequest
         * @property {string|null} [name] PostGeographicAvailabilityRequest name
         * @property {string|null} [description] PostGeographicAvailabilityRequest description
         * @property {Array.<coreproductpb.IGeographicAvailabilityRuleValue>|null} [rules] PostGeographicAvailabilityRequest rules
         * @property {boolean|null} [allowPastDateRules] PostGeographicAvailabilityRequest allowPastDateRules
         */

        /**
         * Constructs a new PostGeographicAvailabilityRequest.
         * @memberof coreproductpb
         * @classdesc Represents a PostGeographicAvailabilityRequest.
         * @implements IPostGeographicAvailabilityRequest
         * @constructor
         * @param {coreproductpb.IPostGeographicAvailabilityRequest=} [p] Properties to set
         */
        function PostGeographicAvailabilityRequest(p) {
            this.rules = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * PostGeographicAvailabilityRequest name.
         * @member {string} name
         * @memberof coreproductpb.PostGeographicAvailabilityRequest
         * @instance
         */
        PostGeographicAvailabilityRequest.prototype.name = "";

        /**
         * PostGeographicAvailabilityRequest description.
         * @member {string} description
         * @memberof coreproductpb.PostGeographicAvailabilityRequest
         * @instance
         */
        PostGeographicAvailabilityRequest.prototype.description = "";

        /**
         * PostGeographicAvailabilityRequest rules.
         * @member {Array.<coreproductpb.IGeographicAvailabilityRuleValue>} rules
         * @memberof coreproductpb.PostGeographicAvailabilityRequest
         * @instance
         */
        PostGeographicAvailabilityRequest.prototype.rules = $util.emptyArray;

        /**
         * PostGeographicAvailabilityRequest allowPastDateRules.
         * @member {boolean} allowPastDateRules
         * @memberof coreproductpb.PostGeographicAvailabilityRequest
         * @instance
         */
        PostGeographicAvailabilityRequest.prototype.allowPastDateRules = false;

        /**
         * Creates a new PostGeographicAvailabilityRequest instance using the specified properties.
         * @function create
         * @memberof coreproductpb.PostGeographicAvailabilityRequest
         * @static
         * @param {coreproductpb.IPostGeographicAvailabilityRequest=} [properties] Properties to set
         * @returns {coreproductpb.PostGeographicAvailabilityRequest} PostGeographicAvailabilityRequest instance
         */
        PostGeographicAvailabilityRequest.create = function create(properties) {
            return new PostGeographicAvailabilityRequest(properties);
        };

        /**
         * Encodes the specified PostGeographicAvailabilityRequest message. Does not implicitly {@link coreproductpb.PostGeographicAvailabilityRequest.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.PostGeographicAvailabilityRequest
         * @static
         * @param {coreproductpb.IPostGeographicAvailabilityRequest} m PostGeographicAvailabilityRequest message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PostGeographicAvailabilityRequest.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.name != null && Object.hasOwnProperty.call(m, "name"))
                w.uint32(10).string(m.name);
            if (m.description != null && Object.hasOwnProperty.call(m, "description"))
                w.uint32(18).string(m.description);
            if (m.rules != null && m.rules.length) {
                for (var i = 0; i < m.rules.length; ++i)
                    $root.coreproductpb.GeographicAvailabilityRuleValue.encode(m.rules[i], w.uint32(26).fork()).ldelim();
            }
            if (m.allowPastDateRules != null && Object.hasOwnProperty.call(m, "allowPastDateRules"))
                w.uint32(32).bool(m.allowPastDateRules);
            return w;
        };

        /**
         * Decodes a PostGeographicAvailabilityRequest message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.PostGeographicAvailabilityRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.PostGeographicAvailabilityRequest} PostGeographicAvailabilityRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PostGeographicAvailabilityRequest.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.PostGeographicAvailabilityRequest();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.name = r.string();
                    break;
                case 2:
                    m.description = r.string();
                    break;
                case 3:
                    if (!(m.rules && m.rules.length))
                        m.rules = [];
                    m.rules.push($root.coreproductpb.GeographicAvailabilityRuleValue.decode(r, r.uint32()));
                    break;
                case 4:
                    m.allowPastDateRules = r.bool();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return PostGeographicAvailabilityRequest;
    })();

    coreproductpb.PostGeographicAvailabilityResponse = (function() {

        /**
         * Properties of a PostGeographicAvailabilityResponse.
         * @memberof coreproductpb
         * @interface IPostGeographicAvailabilityResponse
         * @property {string|null} [geographicAvailabilityID] PostGeographicAvailabilityResponse geographicAvailabilityID
         * @property {Array.<common.IError>|null} [errors] PostGeographicAvailabilityResponse errors
         */

        /**
         * Constructs a new PostGeographicAvailabilityResponse.
         * @memberof coreproductpb
         * @classdesc Represents a PostGeographicAvailabilityResponse.
         * @implements IPostGeographicAvailabilityResponse
         * @constructor
         * @param {coreproductpb.IPostGeographicAvailabilityResponse=} [p] Properties to set
         */
        function PostGeographicAvailabilityResponse(p) {
            this.errors = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * PostGeographicAvailabilityResponse geographicAvailabilityID.
         * @member {string} geographicAvailabilityID
         * @memberof coreproductpb.PostGeographicAvailabilityResponse
         * @instance
         */
        PostGeographicAvailabilityResponse.prototype.geographicAvailabilityID = "";

        /**
         * PostGeographicAvailabilityResponse errors.
         * @member {Array.<common.IError>} errors
         * @memberof coreproductpb.PostGeographicAvailabilityResponse
         * @instance
         */
        PostGeographicAvailabilityResponse.prototype.errors = $util.emptyArray;

        /**
         * Creates a new PostGeographicAvailabilityResponse instance using the specified properties.
         * @function create
         * @memberof coreproductpb.PostGeographicAvailabilityResponse
         * @static
         * @param {coreproductpb.IPostGeographicAvailabilityResponse=} [properties] Properties to set
         * @returns {coreproductpb.PostGeographicAvailabilityResponse} PostGeographicAvailabilityResponse instance
         */
        PostGeographicAvailabilityResponse.create = function create(properties) {
            return new PostGeographicAvailabilityResponse(properties);
        };

        /**
         * Encodes the specified PostGeographicAvailabilityResponse message. Does not implicitly {@link coreproductpb.PostGeographicAvailabilityResponse.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.PostGeographicAvailabilityResponse
         * @static
         * @param {coreproductpb.IPostGeographicAvailabilityResponse} m PostGeographicAvailabilityResponse message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PostGeographicAvailabilityResponse.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.geographicAvailabilityID != null && Object.hasOwnProperty.call(m, "geographicAvailabilityID"))
                w.uint32(10).string(m.geographicAvailabilityID);
            if (m.errors != null && m.errors.length) {
                for (var i = 0; i < m.errors.length; ++i)
                    $root.common.Error.encode(m.errors[i], w.uint32(18).fork()).ldelim();
            }
            return w;
        };

        /**
         * Decodes a PostGeographicAvailabilityResponse message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.PostGeographicAvailabilityResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.PostGeographicAvailabilityResponse} PostGeographicAvailabilityResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PostGeographicAvailabilityResponse.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.PostGeographicAvailabilityResponse();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.geographicAvailabilityID = r.string();
                    break;
                case 2:
                    if (!(m.errors && m.errors.length))
                        m.errors = [];
                    m.errors.push($root.common.Error.decode(r, r.uint32()));
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return PostGeographicAvailabilityResponse;
    })();

    coreproductpb.ReplaceGeographicAvailabilityRequest = (function() {

        /**
         * Properties of a ReplaceGeographicAvailabilityRequest.
         * @memberof coreproductpb
         * @interface IReplaceGeographicAvailabilityRequest
         * @property {string|null} [geographicAvailabilityID] ReplaceGeographicAvailabilityRequest geographicAvailabilityID
         * @property {string|null} [name] ReplaceGeographicAvailabilityRequest name
         * @property {string|null} [description] ReplaceGeographicAvailabilityRequest description
         * @property {Array.<coreproductpb.IGeographicAvailabilityRuleValue>|null} [rules] ReplaceGeographicAvailabilityRequest rules
         * @property {boolean|null} [expireAssociatedProducts] ReplaceGeographicAvailabilityRequest expireAssociatedProducts
         */

        /**
         * Constructs a new ReplaceGeographicAvailabilityRequest.
         * @memberof coreproductpb
         * @classdesc Represents a ReplaceGeographicAvailabilityRequest.
         * @implements IReplaceGeographicAvailabilityRequest
         * @constructor
         * @param {coreproductpb.IReplaceGeographicAvailabilityRequest=} [p] Properties to set
         */
        function ReplaceGeographicAvailabilityRequest(p) {
            this.rules = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * ReplaceGeographicAvailabilityRequest geographicAvailabilityID.
         * @member {string} geographicAvailabilityID
         * @memberof coreproductpb.ReplaceGeographicAvailabilityRequest
         * @instance
         */
        ReplaceGeographicAvailabilityRequest.prototype.geographicAvailabilityID = "";

        /**
         * ReplaceGeographicAvailabilityRequest name.
         * @member {string} name
         * @memberof coreproductpb.ReplaceGeographicAvailabilityRequest
         * @instance
         */
        ReplaceGeographicAvailabilityRequest.prototype.name = "";

        /**
         * ReplaceGeographicAvailabilityRequest description.
         * @member {string} description
         * @memberof coreproductpb.ReplaceGeographicAvailabilityRequest
         * @instance
         */
        ReplaceGeographicAvailabilityRequest.prototype.description = "";

        /**
         * ReplaceGeographicAvailabilityRequest rules.
         * @member {Array.<coreproductpb.IGeographicAvailabilityRuleValue>} rules
         * @memberof coreproductpb.ReplaceGeographicAvailabilityRequest
         * @instance
         */
        ReplaceGeographicAvailabilityRequest.prototype.rules = $util.emptyArray;

        /**
         * ReplaceGeographicAvailabilityRequest expireAssociatedProducts.
         * @member {boolean} expireAssociatedProducts
         * @memberof coreproductpb.ReplaceGeographicAvailabilityRequest
         * @instance
         */
        ReplaceGeographicAvailabilityRequest.prototype.expireAssociatedProducts = false;

        /**
         * Creates a new ReplaceGeographicAvailabilityRequest instance using the specified properties.
         * @function create
         * @memberof coreproductpb.ReplaceGeographicAvailabilityRequest
         * @static
         * @param {coreproductpb.IReplaceGeographicAvailabilityRequest=} [properties] Properties to set
         * @returns {coreproductpb.ReplaceGeographicAvailabilityRequest} ReplaceGeographicAvailabilityRequest instance
         */
        ReplaceGeographicAvailabilityRequest.create = function create(properties) {
            return new ReplaceGeographicAvailabilityRequest(properties);
        };

        /**
         * Encodes the specified ReplaceGeographicAvailabilityRequest message. Does not implicitly {@link coreproductpb.ReplaceGeographicAvailabilityRequest.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.ReplaceGeographicAvailabilityRequest
         * @static
         * @param {coreproductpb.IReplaceGeographicAvailabilityRequest} m ReplaceGeographicAvailabilityRequest message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ReplaceGeographicAvailabilityRequest.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.geographicAvailabilityID != null && Object.hasOwnProperty.call(m, "geographicAvailabilityID"))
                w.uint32(10).string(m.geographicAvailabilityID);
            if (m.name != null && Object.hasOwnProperty.call(m, "name"))
                w.uint32(18).string(m.name);
            if (m.description != null && Object.hasOwnProperty.call(m, "description"))
                w.uint32(26).string(m.description);
            if (m.rules != null && m.rules.length) {
                for (var i = 0; i < m.rules.length; ++i)
                    $root.coreproductpb.GeographicAvailabilityRuleValue.encode(m.rules[i], w.uint32(34).fork()).ldelim();
            }
            if (m.expireAssociatedProducts != null && Object.hasOwnProperty.call(m, "expireAssociatedProducts"))
                w.uint32(40).bool(m.expireAssociatedProducts);
            return w;
        };

        /**
         * Decodes a ReplaceGeographicAvailabilityRequest message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.ReplaceGeographicAvailabilityRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.ReplaceGeographicAvailabilityRequest} ReplaceGeographicAvailabilityRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ReplaceGeographicAvailabilityRequest.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.ReplaceGeographicAvailabilityRequest();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.geographicAvailabilityID = r.string();
                    break;
                case 2:
                    m.name = r.string();
                    break;
                case 3:
                    m.description = r.string();
                    break;
                case 4:
                    if (!(m.rules && m.rules.length))
                        m.rules = [];
                    m.rules.push($root.coreproductpb.GeographicAvailabilityRuleValue.decode(r, r.uint32()));
                    break;
                case 5:
                    m.expireAssociatedProducts = r.bool();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return ReplaceGeographicAvailabilityRequest;
    })();

    coreproductpb.ReplaceGeographicAvailabilityResponse = (function() {

        /**
         * Properties of a ReplaceGeographicAvailabilityResponse.
         * @memberof coreproductpb
         * @interface IReplaceGeographicAvailabilityResponse
         * @property {Array.<common.IError>|null} [errors] ReplaceGeographicAvailabilityResponse errors
         */

        /**
         * Constructs a new ReplaceGeographicAvailabilityResponse.
         * @memberof coreproductpb
         * @classdesc Represents a ReplaceGeographicAvailabilityResponse.
         * @implements IReplaceGeographicAvailabilityResponse
         * @constructor
         * @param {coreproductpb.IReplaceGeographicAvailabilityResponse=} [p] Properties to set
         */
        function ReplaceGeographicAvailabilityResponse(p) {
            this.errors = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * ReplaceGeographicAvailabilityResponse errors.
         * @member {Array.<common.IError>} errors
         * @memberof coreproductpb.ReplaceGeographicAvailabilityResponse
         * @instance
         */
        ReplaceGeographicAvailabilityResponse.prototype.errors = $util.emptyArray;

        /**
         * Creates a new ReplaceGeographicAvailabilityResponse instance using the specified properties.
         * @function create
         * @memberof coreproductpb.ReplaceGeographicAvailabilityResponse
         * @static
         * @param {coreproductpb.IReplaceGeographicAvailabilityResponse=} [properties] Properties to set
         * @returns {coreproductpb.ReplaceGeographicAvailabilityResponse} ReplaceGeographicAvailabilityResponse instance
         */
        ReplaceGeographicAvailabilityResponse.create = function create(properties) {
            return new ReplaceGeographicAvailabilityResponse(properties);
        };

        /**
         * Encodes the specified ReplaceGeographicAvailabilityResponse message. Does not implicitly {@link coreproductpb.ReplaceGeographicAvailabilityResponse.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.ReplaceGeographicAvailabilityResponse
         * @static
         * @param {coreproductpb.IReplaceGeographicAvailabilityResponse} m ReplaceGeographicAvailabilityResponse message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ReplaceGeographicAvailabilityResponse.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.errors != null && m.errors.length) {
                for (var i = 0; i < m.errors.length; ++i)
                    $root.common.Error.encode(m.errors[i], w.uint32(10).fork()).ldelim();
            }
            return w;
        };

        /**
         * Decodes a ReplaceGeographicAvailabilityResponse message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.ReplaceGeographicAvailabilityResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.ReplaceGeographicAvailabilityResponse} ReplaceGeographicAvailabilityResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ReplaceGeographicAvailabilityResponse.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.ReplaceGeographicAvailabilityResponse();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    if (!(m.errors && m.errors.length))
                        m.errors = [];
                    m.errors.push($root.common.Error.decode(r, r.uint32()));
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return ReplaceGeographicAvailabilityResponse;
    })();

    coreproductpb.CancelGeographicAvailabilityRequest = (function() {

        /**
         * Properties of a CancelGeographicAvailabilityRequest.
         * @memberof coreproductpb
         * @interface ICancelGeographicAvailabilityRequest
         * @property {string|null} [geographicAvailabilityID] CancelGeographicAvailabilityRequest geographicAvailabilityID
         */

        /**
         * Constructs a new CancelGeographicAvailabilityRequest.
         * @memberof coreproductpb
         * @classdesc Represents a CancelGeographicAvailabilityRequest.
         * @implements ICancelGeographicAvailabilityRequest
         * @constructor
         * @param {coreproductpb.ICancelGeographicAvailabilityRequest=} [p] Properties to set
         */
        function CancelGeographicAvailabilityRequest(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * CancelGeographicAvailabilityRequest geographicAvailabilityID.
         * @member {string} geographicAvailabilityID
         * @memberof coreproductpb.CancelGeographicAvailabilityRequest
         * @instance
         */
        CancelGeographicAvailabilityRequest.prototype.geographicAvailabilityID = "";

        /**
         * Creates a new CancelGeographicAvailabilityRequest instance using the specified properties.
         * @function create
         * @memberof coreproductpb.CancelGeographicAvailabilityRequest
         * @static
         * @param {coreproductpb.ICancelGeographicAvailabilityRequest=} [properties] Properties to set
         * @returns {coreproductpb.CancelGeographicAvailabilityRequest} CancelGeographicAvailabilityRequest instance
         */
        CancelGeographicAvailabilityRequest.create = function create(properties) {
            return new CancelGeographicAvailabilityRequest(properties);
        };

        /**
         * Encodes the specified CancelGeographicAvailabilityRequest message. Does not implicitly {@link coreproductpb.CancelGeographicAvailabilityRequest.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.CancelGeographicAvailabilityRequest
         * @static
         * @param {coreproductpb.ICancelGeographicAvailabilityRequest} m CancelGeographicAvailabilityRequest message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CancelGeographicAvailabilityRequest.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.geographicAvailabilityID != null && Object.hasOwnProperty.call(m, "geographicAvailabilityID"))
                w.uint32(10).string(m.geographicAvailabilityID);
            return w;
        };

        /**
         * Decodes a CancelGeographicAvailabilityRequest message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.CancelGeographicAvailabilityRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.CancelGeographicAvailabilityRequest} CancelGeographicAvailabilityRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CancelGeographicAvailabilityRequest.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.CancelGeographicAvailabilityRequest();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.geographicAvailabilityID = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return CancelGeographicAvailabilityRequest;
    })();

    coreproductpb.CancelGeographicAvailabilityResponse = (function() {

        /**
         * Properties of a CancelGeographicAvailabilityResponse.
         * @memberof coreproductpb
         * @interface ICancelGeographicAvailabilityResponse
         * @property {Array.<common.IError>|null} [errors] CancelGeographicAvailabilityResponse errors
         */

        /**
         * Constructs a new CancelGeographicAvailabilityResponse.
         * @memberof coreproductpb
         * @classdesc Represents a CancelGeographicAvailabilityResponse.
         * @implements ICancelGeographicAvailabilityResponse
         * @constructor
         * @param {coreproductpb.ICancelGeographicAvailabilityResponse=} [p] Properties to set
         */
        function CancelGeographicAvailabilityResponse(p) {
            this.errors = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * CancelGeographicAvailabilityResponse errors.
         * @member {Array.<common.IError>} errors
         * @memberof coreproductpb.CancelGeographicAvailabilityResponse
         * @instance
         */
        CancelGeographicAvailabilityResponse.prototype.errors = $util.emptyArray;

        /**
         * Creates a new CancelGeographicAvailabilityResponse instance using the specified properties.
         * @function create
         * @memberof coreproductpb.CancelGeographicAvailabilityResponse
         * @static
         * @param {coreproductpb.ICancelGeographicAvailabilityResponse=} [properties] Properties to set
         * @returns {coreproductpb.CancelGeographicAvailabilityResponse} CancelGeographicAvailabilityResponse instance
         */
        CancelGeographicAvailabilityResponse.create = function create(properties) {
            return new CancelGeographicAvailabilityResponse(properties);
        };

        /**
         * Encodes the specified CancelGeographicAvailabilityResponse message. Does not implicitly {@link coreproductpb.CancelGeographicAvailabilityResponse.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.CancelGeographicAvailabilityResponse
         * @static
         * @param {coreproductpb.ICancelGeographicAvailabilityResponse} m CancelGeographicAvailabilityResponse message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CancelGeographicAvailabilityResponse.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.errors != null && m.errors.length) {
                for (var i = 0; i < m.errors.length; ++i)
                    $root.common.Error.encode(m.errors[i], w.uint32(10).fork()).ldelim();
            }
            return w;
        };

        /**
         * Decodes a CancelGeographicAvailabilityResponse message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.CancelGeographicAvailabilityResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.CancelGeographicAvailabilityResponse} CancelGeographicAvailabilityResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CancelGeographicAvailabilityResponse.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.CancelGeographicAvailabilityResponse();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    if (!(m.errors && m.errors.length))
                        m.errors = [];
                    m.errors.push($root.common.Error.decode(r, r.uint32()));
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return CancelGeographicAvailabilityResponse;
    })();

    coreproductpb.PostProductTemplateVersionCloneRequest = (function() {

        /**
         * Properties of a PostProductTemplateVersionCloneRequest.
         * @memberof coreproductpb
         * @interface IPostProductTemplateVersionCloneRequest
         * @property {string|null} [productTemplateID] PostProductTemplateVersionCloneRequest productTemplateID
         * @property {string|null} [productTemplateVersionID] PostProductTemplateVersionCloneRequest productTemplateVersionID
         * @property {google.protobuf.ITimestamp|null} [effectiveDate] PostProductTemplateVersionCloneRequest effectiveDate
         */

        /**
         * Constructs a new PostProductTemplateVersionCloneRequest.
         * @memberof coreproductpb
         * @classdesc Represents a PostProductTemplateVersionCloneRequest.
         * @implements IPostProductTemplateVersionCloneRequest
         * @constructor
         * @param {coreproductpb.IPostProductTemplateVersionCloneRequest=} [p] Properties to set
         */
        function PostProductTemplateVersionCloneRequest(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * PostProductTemplateVersionCloneRequest productTemplateID.
         * @member {string} productTemplateID
         * @memberof coreproductpb.PostProductTemplateVersionCloneRequest
         * @instance
         */
        PostProductTemplateVersionCloneRequest.prototype.productTemplateID = "";

        /**
         * PostProductTemplateVersionCloneRequest productTemplateVersionID.
         * @member {string} productTemplateVersionID
         * @memberof coreproductpb.PostProductTemplateVersionCloneRequest
         * @instance
         */
        PostProductTemplateVersionCloneRequest.prototype.productTemplateVersionID = "";

        /**
         * PostProductTemplateVersionCloneRequest effectiveDate.
         * @member {google.protobuf.ITimestamp|null|undefined} effectiveDate
         * @memberof coreproductpb.PostProductTemplateVersionCloneRequest
         * @instance
         */
        PostProductTemplateVersionCloneRequest.prototype.effectiveDate = null;

        /**
         * Creates a new PostProductTemplateVersionCloneRequest instance using the specified properties.
         * @function create
         * @memberof coreproductpb.PostProductTemplateVersionCloneRequest
         * @static
         * @param {coreproductpb.IPostProductTemplateVersionCloneRequest=} [properties] Properties to set
         * @returns {coreproductpb.PostProductTemplateVersionCloneRequest} PostProductTemplateVersionCloneRequest instance
         */
        PostProductTemplateVersionCloneRequest.create = function create(properties) {
            return new PostProductTemplateVersionCloneRequest(properties);
        };

        /**
         * Encodes the specified PostProductTemplateVersionCloneRequest message. Does not implicitly {@link coreproductpb.PostProductTemplateVersionCloneRequest.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.PostProductTemplateVersionCloneRequest
         * @static
         * @param {coreproductpb.IPostProductTemplateVersionCloneRequest} m PostProductTemplateVersionCloneRequest message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PostProductTemplateVersionCloneRequest.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.productTemplateID != null && Object.hasOwnProperty.call(m, "productTemplateID"))
                w.uint32(10).string(m.productTemplateID);
            if (m.productTemplateVersionID != null && Object.hasOwnProperty.call(m, "productTemplateVersionID"))
                w.uint32(18).string(m.productTemplateVersionID);
            if (m.effectiveDate != null && Object.hasOwnProperty.call(m, "effectiveDate"))
                $root.google.protobuf.Timestamp.encode(m.effectiveDate, w.uint32(26).fork()).ldelim();
            return w;
        };

        /**
         * Decodes a PostProductTemplateVersionCloneRequest message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.PostProductTemplateVersionCloneRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.PostProductTemplateVersionCloneRequest} PostProductTemplateVersionCloneRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PostProductTemplateVersionCloneRequest.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.PostProductTemplateVersionCloneRequest();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.productTemplateID = r.string();
                    break;
                case 2:
                    m.productTemplateVersionID = r.string();
                    break;
                case 3:
                    m.effectiveDate = $root.google.protobuf.Timestamp.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return PostProductTemplateVersionCloneRequest;
    })();

    coreproductpb.PostProductTemplateVersionCloneResponse = (function() {

        /**
         * Properties of a PostProductTemplateVersionCloneResponse.
         * @memberof coreproductpb
         * @interface IPostProductTemplateVersionCloneResponse
         * @property {string|null} [productTemplateVersionID] PostProductTemplateVersionCloneResponse productTemplateVersionID
         * @property {Array.<common.IError>|null} [errors] PostProductTemplateVersionCloneResponse errors
         */

        /**
         * Constructs a new PostProductTemplateVersionCloneResponse.
         * @memberof coreproductpb
         * @classdesc Represents a PostProductTemplateVersionCloneResponse.
         * @implements IPostProductTemplateVersionCloneResponse
         * @constructor
         * @param {coreproductpb.IPostProductTemplateVersionCloneResponse=} [p] Properties to set
         */
        function PostProductTemplateVersionCloneResponse(p) {
            this.errors = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * PostProductTemplateVersionCloneResponse productTemplateVersionID.
         * @member {string} productTemplateVersionID
         * @memberof coreproductpb.PostProductTemplateVersionCloneResponse
         * @instance
         */
        PostProductTemplateVersionCloneResponse.prototype.productTemplateVersionID = "";

        /**
         * PostProductTemplateVersionCloneResponse errors.
         * @member {Array.<common.IError>} errors
         * @memberof coreproductpb.PostProductTemplateVersionCloneResponse
         * @instance
         */
        PostProductTemplateVersionCloneResponse.prototype.errors = $util.emptyArray;

        /**
         * Creates a new PostProductTemplateVersionCloneResponse instance using the specified properties.
         * @function create
         * @memberof coreproductpb.PostProductTemplateVersionCloneResponse
         * @static
         * @param {coreproductpb.IPostProductTemplateVersionCloneResponse=} [properties] Properties to set
         * @returns {coreproductpb.PostProductTemplateVersionCloneResponse} PostProductTemplateVersionCloneResponse instance
         */
        PostProductTemplateVersionCloneResponse.create = function create(properties) {
            return new PostProductTemplateVersionCloneResponse(properties);
        };

        /**
         * Encodes the specified PostProductTemplateVersionCloneResponse message. Does not implicitly {@link coreproductpb.PostProductTemplateVersionCloneResponse.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.PostProductTemplateVersionCloneResponse
         * @static
         * @param {coreproductpb.IPostProductTemplateVersionCloneResponse} m PostProductTemplateVersionCloneResponse message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PostProductTemplateVersionCloneResponse.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.productTemplateVersionID != null && Object.hasOwnProperty.call(m, "productTemplateVersionID"))
                w.uint32(10).string(m.productTemplateVersionID);
            if (m.errors != null && m.errors.length) {
                for (var i = 0; i < m.errors.length; ++i)
                    $root.common.Error.encode(m.errors[i], w.uint32(18).fork()).ldelim();
            }
            return w;
        };

        /**
         * Decodes a PostProductTemplateVersionCloneResponse message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.PostProductTemplateVersionCloneResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.PostProductTemplateVersionCloneResponse} PostProductTemplateVersionCloneResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PostProductTemplateVersionCloneResponse.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.PostProductTemplateVersionCloneResponse();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.productTemplateVersionID = r.string();
                    break;
                case 2:
                    if (!(m.errors && m.errors.length))
                        m.errors = [];
                    m.errors.push($root.common.Error.decode(r, r.uint32()));
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return PostProductTemplateVersionCloneResponse;
    })();

    coreproductpb.ProductTemplateImportDetails = (function() {

        /**
         * Properties of a ProductTemplateImportDetails.
         * @memberof coreproductpb
         * @interface IProductTemplateImportDetails
         * @property {string|null} [importID] ProductTemplateImportDetails importID
         * @property {string|null} [mediaFileID] ProductTemplateImportDetails mediaFileID
         * @property {string|null} [productTemplateID] ProductTemplateImportDetails productTemplateID
         * @property {string|null} [fileName] ProductTemplateImportDetails fileName
         * @property {string|null} [productTemplateName] ProductTemplateImportDetails productTemplateName
         * @property {coreproductpb.ImportProductTemplateStatus|null} [status] ProductTemplateImportDetails status
         * @property {string|null} [failureReason] ProductTemplateImportDetails failureReason
         * @property {google.protobuf.ITimestamp|null} [createdOn] ProductTemplateImportDetails createdOn
         * @property {google.protobuf.ITimestamp|null} [updatedOn] ProductTemplateImportDetails updatedOn
         * @property {string|null} [createdBy] ProductTemplateImportDetails createdBy
         */

        /**
         * Constructs a new ProductTemplateImportDetails.
         * @memberof coreproductpb
         * @classdesc Represents a ProductTemplateImportDetails.
         * @implements IProductTemplateImportDetails
         * @constructor
         * @param {coreproductpb.IProductTemplateImportDetails=} [p] Properties to set
         */
        function ProductTemplateImportDetails(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * ProductTemplateImportDetails importID.
         * @member {string} importID
         * @memberof coreproductpb.ProductTemplateImportDetails
         * @instance
         */
        ProductTemplateImportDetails.prototype.importID = "";

        /**
         * ProductTemplateImportDetails mediaFileID.
         * @member {string} mediaFileID
         * @memberof coreproductpb.ProductTemplateImportDetails
         * @instance
         */
        ProductTemplateImportDetails.prototype.mediaFileID = "";

        /**
         * ProductTemplateImportDetails productTemplateID.
         * @member {string} productTemplateID
         * @memberof coreproductpb.ProductTemplateImportDetails
         * @instance
         */
        ProductTemplateImportDetails.prototype.productTemplateID = "";

        /**
         * ProductTemplateImportDetails fileName.
         * @member {string} fileName
         * @memberof coreproductpb.ProductTemplateImportDetails
         * @instance
         */
        ProductTemplateImportDetails.prototype.fileName = "";

        /**
         * ProductTemplateImportDetails productTemplateName.
         * @member {string} productTemplateName
         * @memberof coreproductpb.ProductTemplateImportDetails
         * @instance
         */
        ProductTemplateImportDetails.prototype.productTemplateName = "";

        /**
         * ProductTemplateImportDetails status.
         * @member {coreproductpb.ImportProductTemplateStatus} status
         * @memberof coreproductpb.ProductTemplateImportDetails
         * @instance
         */
        ProductTemplateImportDetails.prototype.status = 0;

        /**
         * ProductTemplateImportDetails failureReason.
         * @member {string} failureReason
         * @memberof coreproductpb.ProductTemplateImportDetails
         * @instance
         */
        ProductTemplateImportDetails.prototype.failureReason = "";

        /**
         * ProductTemplateImportDetails createdOn.
         * @member {google.protobuf.ITimestamp|null|undefined} createdOn
         * @memberof coreproductpb.ProductTemplateImportDetails
         * @instance
         */
        ProductTemplateImportDetails.prototype.createdOn = null;

        /**
         * ProductTemplateImportDetails updatedOn.
         * @member {google.protobuf.ITimestamp|null|undefined} updatedOn
         * @memberof coreproductpb.ProductTemplateImportDetails
         * @instance
         */
        ProductTemplateImportDetails.prototype.updatedOn = null;

        /**
         * ProductTemplateImportDetails createdBy.
         * @member {string} createdBy
         * @memberof coreproductpb.ProductTemplateImportDetails
         * @instance
         */
        ProductTemplateImportDetails.prototype.createdBy = "";

        /**
         * Creates a new ProductTemplateImportDetails instance using the specified properties.
         * @function create
         * @memberof coreproductpb.ProductTemplateImportDetails
         * @static
         * @param {coreproductpb.IProductTemplateImportDetails=} [properties] Properties to set
         * @returns {coreproductpb.ProductTemplateImportDetails} ProductTemplateImportDetails instance
         */
        ProductTemplateImportDetails.create = function create(properties) {
            return new ProductTemplateImportDetails(properties);
        };

        /**
         * Encodes the specified ProductTemplateImportDetails message. Does not implicitly {@link coreproductpb.ProductTemplateImportDetails.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.ProductTemplateImportDetails
         * @static
         * @param {coreproductpb.IProductTemplateImportDetails} m ProductTemplateImportDetails message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ProductTemplateImportDetails.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.importID != null && Object.hasOwnProperty.call(m, "importID"))
                w.uint32(10).string(m.importID);
            if (m.mediaFileID != null && Object.hasOwnProperty.call(m, "mediaFileID"))
                w.uint32(18).string(m.mediaFileID);
            if (m.productTemplateID != null && Object.hasOwnProperty.call(m, "productTemplateID"))
                w.uint32(26).string(m.productTemplateID);
            if (m.fileName != null && Object.hasOwnProperty.call(m, "fileName"))
                w.uint32(34).string(m.fileName);
            if (m.productTemplateName != null && Object.hasOwnProperty.call(m, "productTemplateName"))
                w.uint32(42).string(m.productTemplateName);
            if (m.status != null && Object.hasOwnProperty.call(m, "status"))
                w.uint32(48).int32(m.status);
            if (m.failureReason != null && Object.hasOwnProperty.call(m, "failureReason"))
                w.uint32(58).string(m.failureReason);
            if (m.createdOn != null && Object.hasOwnProperty.call(m, "createdOn"))
                $root.google.protobuf.Timestamp.encode(m.createdOn, w.uint32(66).fork()).ldelim();
            if (m.updatedOn != null && Object.hasOwnProperty.call(m, "updatedOn"))
                $root.google.protobuf.Timestamp.encode(m.updatedOn, w.uint32(74).fork()).ldelim();
            if (m.createdBy != null && Object.hasOwnProperty.call(m, "createdBy"))
                w.uint32(82).string(m.createdBy);
            return w;
        };

        /**
         * Decodes a ProductTemplateImportDetails message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.ProductTemplateImportDetails
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.ProductTemplateImportDetails} ProductTemplateImportDetails
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ProductTemplateImportDetails.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.ProductTemplateImportDetails();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.importID = r.string();
                    break;
                case 2:
                    m.mediaFileID = r.string();
                    break;
                case 3:
                    m.productTemplateID = r.string();
                    break;
                case 4:
                    m.fileName = r.string();
                    break;
                case 5:
                    m.productTemplateName = r.string();
                    break;
                case 6:
                    m.status = r.int32();
                    break;
                case 7:
                    m.failureReason = r.string();
                    break;
                case 8:
                    m.createdOn = $root.google.protobuf.Timestamp.decode(r, r.uint32());
                    break;
                case 9:
                    m.updatedOn = $root.google.protobuf.Timestamp.decode(r, r.uint32());
                    break;
                case 10:
                    m.createdBy = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return ProductTemplateImportDetails;
    })();

    coreproductpb.GetImportProductTemplateResponse = (function() {

        /**
         * Properties of a GetImportProductTemplateResponse.
         * @memberof coreproductpb
         * @interface IGetImportProductTemplateResponse
         * @property {Array.<coreproductpb.IProductTemplateImportDetails>|null} [importDetails] GetImportProductTemplateResponse importDetails
         * @property {Array.<common.IError>|null} [errors] GetImportProductTemplateResponse errors
         */

        /**
         * Constructs a new GetImportProductTemplateResponse.
         * @memberof coreproductpb
         * @classdesc Represents a GetImportProductTemplateResponse.
         * @implements IGetImportProductTemplateResponse
         * @constructor
         * @param {coreproductpb.IGetImportProductTemplateResponse=} [p] Properties to set
         */
        function GetImportProductTemplateResponse(p) {
            this.importDetails = [];
            this.errors = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * GetImportProductTemplateResponse importDetails.
         * @member {Array.<coreproductpb.IProductTemplateImportDetails>} importDetails
         * @memberof coreproductpb.GetImportProductTemplateResponse
         * @instance
         */
        GetImportProductTemplateResponse.prototype.importDetails = $util.emptyArray;

        /**
         * GetImportProductTemplateResponse errors.
         * @member {Array.<common.IError>} errors
         * @memberof coreproductpb.GetImportProductTemplateResponse
         * @instance
         */
        GetImportProductTemplateResponse.prototype.errors = $util.emptyArray;

        /**
         * Creates a new GetImportProductTemplateResponse instance using the specified properties.
         * @function create
         * @memberof coreproductpb.GetImportProductTemplateResponse
         * @static
         * @param {coreproductpb.IGetImportProductTemplateResponse=} [properties] Properties to set
         * @returns {coreproductpb.GetImportProductTemplateResponse} GetImportProductTemplateResponse instance
         */
        GetImportProductTemplateResponse.create = function create(properties) {
            return new GetImportProductTemplateResponse(properties);
        };

        /**
         * Encodes the specified GetImportProductTemplateResponse message. Does not implicitly {@link coreproductpb.GetImportProductTemplateResponse.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.GetImportProductTemplateResponse
         * @static
         * @param {coreproductpb.IGetImportProductTemplateResponse} m GetImportProductTemplateResponse message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetImportProductTemplateResponse.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.importDetails != null && m.importDetails.length) {
                for (var i = 0; i < m.importDetails.length; ++i)
                    $root.coreproductpb.ProductTemplateImportDetails.encode(m.importDetails[i], w.uint32(10).fork()).ldelim();
            }
            if (m.errors != null && m.errors.length) {
                for (var i = 0; i < m.errors.length; ++i)
                    $root.common.Error.encode(m.errors[i], w.uint32(18).fork()).ldelim();
            }
            return w;
        };

        /**
         * Decodes a GetImportProductTemplateResponse message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.GetImportProductTemplateResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.GetImportProductTemplateResponse} GetImportProductTemplateResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetImportProductTemplateResponse.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.GetImportProductTemplateResponse();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    if (!(m.importDetails && m.importDetails.length))
                        m.importDetails = [];
                    m.importDetails.push($root.coreproductpb.ProductTemplateImportDetails.decode(r, r.uint32()));
                    break;
                case 2:
                    if (!(m.errors && m.errors.length))
                        m.errors = [];
                    m.errors.push($root.common.Error.decode(r, r.uint32()));
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return GetImportProductTemplateResponse;
    })();

    coreproductpb.LifecycleStageChangeScheduleRequest = (function() {

        /**
         * Properties of a LifecycleStageChangeScheduleRequest.
         * @memberof coreproductpb
         * @interface ILifecycleStageChangeScheduleRequest
         * @property {string|null} [productTemplateID] LifecycleStageChangeScheduleRequest productTemplateID
         * @property {string|null} [productTemplateVersionID] LifecycleStageChangeScheduleRequest productTemplateVersionID
         * @property {google.protobuf.ITimestamp|null} [effectiveDate] LifecycleStageChangeScheduleRequest effectiveDate
         * @property {google.protobuf.ITimestamp|null} [expirationDate] LifecycleStageChangeScheduleRequest expirationDate
         */

        /**
         * Constructs a new LifecycleStageChangeScheduleRequest.
         * @memberof coreproductpb
         * @classdesc Represents a LifecycleStageChangeScheduleRequest.
         * @implements ILifecycleStageChangeScheduleRequest
         * @constructor
         * @param {coreproductpb.ILifecycleStageChangeScheduleRequest=} [p] Properties to set
         */
        function LifecycleStageChangeScheduleRequest(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * LifecycleStageChangeScheduleRequest productTemplateID.
         * @member {string} productTemplateID
         * @memberof coreproductpb.LifecycleStageChangeScheduleRequest
         * @instance
         */
        LifecycleStageChangeScheduleRequest.prototype.productTemplateID = "";

        /**
         * LifecycleStageChangeScheduleRequest productTemplateVersionID.
         * @member {string} productTemplateVersionID
         * @memberof coreproductpb.LifecycleStageChangeScheduleRequest
         * @instance
         */
        LifecycleStageChangeScheduleRequest.prototype.productTemplateVersionID = "";

        /**
         * LifecycleStageChangeScheduleRequest effectiveDate.
         * @member {google.protobuf.ITimestamp|null|undefined} effectiveDate
         * @memberof coreproductpb.LifecycleStageChangeScheduleRequest
         * @instance
         */
        LifecycleStageChangeScheduleRequest.prototype.effectiveDate = null;

        /**
         * LifecycleStageChangeScheduleRequest expirationDate.
         * @member {google.protobuf.ITimestamp|null|undefined} expirationDate
         * @memberof coreproductpb.LifecycleStageChangeScheduleRequest
         * @instance
         */
        LifecycleStageChangeScheduleRequest.prototype.expirationDate = null;

        /**
         * Creates a new LifecycleStageChangeScheduleRequest instance using the specified properties.
         * @function create
         * @memberof coreproductpb.LifecycleStageChangeScheduleRequest
         * @static
         * @param {coreproductpb.ILifecycleStageChangeScheduleRequest=} [properties] Properties to set
         * @returns {coreproductpb.LifecycleStageChangeScheduleRequest} LifecycleStageChangeScheduleRequest instance
         */
        LifecycleStageChangeScheduleRequest.create = function create(properties) {
            return new LifecycleStageChangeScheduleRequest(properties);
        };

        /**
         * Encodes the specified LifecycleStageChangeScheduleRequest message. Does not implicitly {@link coreproductpb.LifecycleStageChangeScheduleRequest.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.LifecycleStageChangeScheduleRequest
         * @static
         * @param {coreproductpb.ILifecycleStageChangeScheduleRequest} m LifecycleStageChangeScheduleRequest message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        LifecycleStageChangeScheduleRequest.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.productTemplateID != null && Object.hasOwnProperty.call(m, "productTemplateID"))
                w.uint32(10).string(m.productTemplateID);
            if (m.productTemplateVersionID != null && Object.hasOwnProperty.call(m, "productTemplateVersionID"))
                w.uint32(18).string(m.productTemplateVersionID);
            if (m.effectiveDate != null && Object.hasOwnProperty.call(m, "effectiveDate"))
                $root.google.protobuf.Timestamp.encode(m.effectiveDate, w.uint32(26).fork()).ldelim();
            if (m.expirationDate != null && Object.hasOwnProperty.call(m, "expirationDate"))
                $root.google.protobuf.Timestamp.encode(m.expirationDate, w.uint32(34).fork()).ldelim();
            return w;
        };

        /**
         * Decodes a LifecycleStageChangeScheduleRequest message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.LifecycleStageChangeScheduleRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.LifecycleStageChangeScheduleRequest} LifecycleStageChangeScheduleRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        LifecycleStageChangeScheduleRequest.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.LifecycleStageChangeScheduleRequest();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.productTemplateID = r.string();
                    break;
                case 2:
                    m.productTemplateVersionID = r.string();
                    break;
                case 3:
                    m.effectiveDate = $root.google.protobuf.Timestamp.decode(r, r.uint32());
                    break;
                case 4:
                    m.expirationDate = $root.google.protobuf.Timestamp.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return LifecycleStageChangeScheduleRequest;
    })();

    coreproductpb.LifecycleStageChangeCancellationRequest = (function() {

        /**
         * Properties of a LifecycleStageChangeCancellationRequest.
         * @memberof coreproductpb
         * @interface ILifecycleStageChangeCancellationRequest
         * @property {string|null} [productTemplateID] LifecycleStageChangeCancellationRequest productTemplateID
         * @property {string|null} [productTemplateVersionID] LifecycleStageChangeCancellationRequest productTemplateVersionID
         */

        /**
         * Constructs a new LifecycleStageChangeCancellationRequest.
         * @memberof coreproductpb
         * @classdesc Represents a LifecycleStageChangeCancellationRequest.
         * @implements ILifecycleStageChangeCancellationRequest
         * @constructor
         * @param {coreproductpb.ILifecycleStageChangeCancellationRequest=} [p] Properties to set
         */
        function LifecycleStageChangeCancellationRequest(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * LifecycleStageChangeCancellationRequest productTemplateID.
         * @member {string} productTemplateID
         * @memberof coreproductpb.LifecycleStageChangeCancellationRequest
         * @instance
         */
        LifecycleStageChangeCancellationRequest.prototype.productTemplateID = "";

        /**
         * LifecycleStageChangeCancellationRequest productTemplateVersionID.
         * @member {string} productTemplateVersionID
         * @memberof coreproductpb.LifecycleStageChangeCancellationRequest
         * @instance
         */
        LifecycleStageChangeCancellationRequest.prototype.productTemplateVersionID = "";

        /**
         * Creates a new LifecycleStageChangeCancellationRequest instance using the specified properties.
         * @function create
         * @memberof coreproductpb.LifecycleStageChangeCancellationRequest
         * @static
         * @param {coreproductpb.ILifecycleStageChangeCancellationRequest=} [properties] Properties to set
         * @returns {coreproductpb.LifecycleStageChangeCancellationRequest} LifecycleStageChangeCancellationRequest instance
         */
        LifecycleStageChangeCancellationRequest.create = function create(properties) {
            return new LifecycleStageChangeCancellationRequest(properties);
        };

        /**
         * Encodes the specified LifecycleStageChangeCancellationRequest message. Does not implicitly {@link coreproductpb.LifecycleStageChangeCancellationRequest.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.LifecycleStageChangeCancellationRequest
         * @static
         * @param {coreproductpb.ILifecycleStageChangeCancellationRequest} m LifecycleStageChangeCancellationRequest message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        LifecycleStageChangeCancellationRequest.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.productTemplateID != null && Object.hasOwnProperty.call(m, "productTemplateID"))
                w.uint32(10).string(m.productTemplateID);
            if (m.productTemplateVersionID != null && Object.hasOwnProperty.call(m, "productTemplateVersionID"))
                w.uint32(18).string(m.productTemplateVersionID);
            return w;
        };

        /**
         * Decodes a LifecycleStageChangeCancellationRequest message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.LifecycleStageChangeCancellationRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.LifecycleStageChangeCancellationRequest} LifecycleStageChangeCancellationRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        LifecycleStageChangeCancellationRequest.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.LifecycleStageChangeCancellationRequest();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.productTemplateID = r.string();
                    break;
                case 2:
                    m.productTemplateVersionID = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return LifecycleStageChangeCancellationRequest;
    })();

    coreproductpb.DraftLifecycleStagePromotionRequest = (function() {

        /**
         * Properties of a DraftLifecycleStagePromotionRequest.
         * @memberof coreproductpb
         * @interface IDraftLifecycleStagePromotionRequest
         * @property {string|null} [productTemplateID] DraftLifecycleStagePromotionRequest productTemplateID
         * @property {string|null} [productTemplateVersionID] DraftLifecycleStagePromotionRequest productTemplateVersionID
         */

        /**
         * Constructs a new DraftLifecycleStagePromotionRequest.
         * @memberof coreproductpb
         * @classdesc Represents a DraftLifecycleStagePromotionRequest.
         * @implements IDraftLifecycleStagePromotionRequest
         * @constructor
         * @param {coreproductpb.IDraftLifecycleStagePromotionRequest=} [p] Properties to set
         */
        function DraftLifecycleStagePromotionRequest(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * DraftLifecycleStagePromotionRequest productTemplateID.
         * @member {string} productTemplateID
         * @memberof coreproductpb.DraftLifecycleStagePromotionRequest
         * @instance
         */
        DraftLifecycleStagePromotionRequest.prototype.productTemplateID = "";

        /**
         * DraftLifecycleStagePromotionRequest productTemplateVersionID.
         * @member {string} productTemplateVersionID
         * @memberof coreproductpb.DraftLifecycleStagePromotionRequest
         * @instance
         */
        DraftLifecycleStagePromotionRequest.prototype.productTemplateVersionID = "";

        /**
         * Creates a new DraftLifecycleStagePromotionRequest instance using the specified properties.
         * @function create
         * @memberof coreproductpb.DraftLifecycleStagePromotionRequest
         * @static
         * @param {coreproductpb.IDraftLifecycleStagePromotionRequest=} [properties] Properties to set
         * @returns {coreproductpb.DraftLifecycleStagePromotionRequest} DraftLifecycleStagePromotionRequest instance
         */
        DraftLifecycleStagePromotionRequest.create = function create(properties) {
            return new DraftLifecycleStagePromotionRequest(properties);
        };

        /**
         * Encodes the specified DraftLifecycleStagePromotionRequest message. Does not implicitly {@link coreproductpb.DraftLifecycleStagePromotionRequest.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.DraftLifecycleStagePromotionRequest
         * @static
         * @param {coreproductpb.IDraftLifecycleStagePromotionRequest} m DraftLifecycleStagePromotionRequest message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        DraftLifecycleStagePromotionRequest.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.productTemplateID != null && Object.hasOwnProperty.call(m, "productTemplateID"))
                w.uint32(10).string(m.productTemplateID);
            if (m.productTemplateVersionID != null && Object.hasOwnProperty.call(m, "productTemplateVersionID"))
                w.uint32(18).string(m.productTemplateVersionID);
            return w;
        };

        /**
         * Decodes a DraftLifecycleStagePromotionRequest message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.DraftLifecycleStagePromotionRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.DraftLifecycleStagePromotionRequest} DraftLifecycleStagePromotionRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        DraftLifecycleStagePromotionRequest.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.DraftLifecycleStagePromotionRequest();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.productTemplateID = r.string();
                    break;
                case 2:
                    m.productTemplateVersionID = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return DraftLifecycleStagePromotionRequest;
    })();

    coreproductpb.LifecycleStageChangeResponse = (function() {

        /**
         * Properties of a LifecycleStageChangeResponse.
         * @memberof coreproductpb
         * @interface ILifecycleStageChangeResponse
         * @property {Array.<common.IError>|null} [errors] LifecycleStageChangeResponse errors
         */

        /**
         * Constructs a new LifecycleStageChangeResponse.
         * @memberof coreproductpb
         * @classdesc Represents a LifecycleStageChangeResponse.
         * @implements ILifecycleStageChangeResponse
         * @constructor
         * @param {coreproductpb.ILifecycleStageChangeResponse=} [p] Properties to set
         */
        function LifecycleStageChangeResponse(p) {
            this.errors = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * LifecycleStageChangeResponse errors.
         * @member {Array.<common.IError>} errors
         * @memberof coreproductpb.LifecycleStageChangeResponse
         * @instance
         */
        LifecycleStageChangeResponse.prototype.errors = $util.emptyArray;

        /**
         * Creates a new LifecycleStageChangeResponse instance using the specified properties.
         * @function create
         * @memberof coreproductpb.LifecycleStageChangeResponse
         * @static
         * @param {coreproductpb.ILifecycleStageChangeResponse=} [properties] Properties to set
         * @returns {coreproductpb.LifecycleStageChangeResponse} LifecycleStageChangeResponse instance
         */
        LifecycleStageChangeResponse.create = function create(properties) {
            return new LifecycleStageChangeResponse(properties);
        };

        /**
         * Encodes the specified LifecycleStageChangeResponse message. Does not implicitly {@link coreproductpb.LifecycleStageChangeResponse.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.LifecycleStageChangeResponse
         * @static
         * @param {coreproductpb.ILifecycleStageChangeResponse} m LifecycleStageChangeResponse message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        LifecycleStageChangeResponse.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.errors != null && m.errors.length) {
                for (var i = 0; i < m.errors.length; ++i)
                    $root.common.Error.encode(m.errors[i], w.uint32(10).fork()).ldelim();
            }
            return w;
        };

        /**
         * Decodes a LifecycleStageChangeResponse message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.LifecycleStageChangeResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.LifecycleStageChangeResponse} LifecycleStageChangeResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        LifecycleStageChangeResponse.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.LifecycleStageChangeResponse();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    if (!(m.errors && m.errors.length))
                        m.errors = [];
                    m.errors.push($root.common.Error.decode(r, r.uint32()));
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return LifecycleStageChangeResponse;
    })();

    coreproductpb.PostProductTypesRequest = (function() {

        /**
         * Properties of a PostProductTypesRequest.
         * @memberof coreproductpb
         * @interface IPostProductTypesRequest
         * @property {string|null} [name] PostProductTypesRequest name
         * @property {Array.<coreproductpb.IAssociateProductTypeMapping>|null} [productTypeMapping] PostProductTypesRequest productTypeMapping
         */

        /**
         * Constructs a new PostProductTypesRequest.
         * @memberof coreproductpb
         * @classdesc Represents a PostProductTypesRequest.
         * @implements IPostProductTypesRequest
         * @constructor
         * @param {coreproductpb.IPostProductTypesRequest=} [p] Properties to set
         */
        function PostProductTypesRequest(p) {
            this.productTypeMapping = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * PostProductTypesRequest name.
         * @member {string} name
         * @memberof coreproductpb.PostProductTypesRequest
         * @instance
         */
        PostProductTypesRequest.prototype.name = "";

        /**
         * PostProductTypesRequest productTypeMapping.
         * @member {Array.<coreproductpb.IAssociateProductTypeMapping>} productTypeMapping
         * @memberof coreproductpb.PostProductTypesRequest
         * @instance
         */
        PostProductTypesRequest.prototype.productTypeMapping = $util.emptyArray;

        /**
         * Creates a new PostProductTypesRequest instance using the specified properties.
         * @function create
         * @memberof coreproductpb.PostProductTypesRequest
         * @static
         * @param {coreproductpb.IPostProductTypesRequest=} [properties] Properties to set
         * @returns {coreproductpb.PostProductTypesRequest} PostProductTypesRequest instance
         */
        PostProductTypesRequest.create = function create(properties) {
            return new PostProductTypesRequest(properties);
        };

        /**
         * Encodes the specified PostProductTypesRequest message. Does not implicitly {@link coreproductpb.PostProductTypesRequest.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.PostProductTypesRequest
         * @static
         * @param {coreproductpb.IPostProductTypesRequest} m PostProductTypesRequest message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PostProductTypesRequest.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.name != null && Object.hasOwnProperty.call(m, "name"))
                w.uint32(10).string(m.name);
            if (m.productTypeMapping != null && m.productTypeMapping.length) {
                for (var i = 0; i < m.productTypeMapping.length; ++i)
                    $root.coreproductpb.AssociateProductTypeMapping.encode(m.productTypeMapping[i], w.uint32(18).fork()).ldelim();
            }
            return w;
        };

        /**
         * Decodes a PostProductTypesRequest message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.PostProductTypesRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.PostProductTypesRequest} PostProductTypesRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PostProductTypesRequest.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.PostProductTypesRequest();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.name = r.string();
                    break;
                case 2:
                    if (!(m.productTypeMapping && m.productTypeMapping.length))
                        m.productTypeMapping = [];
                    m.productTypeMapping.push($root.coreproductpb.AssociateProductTypeMapping.decode(r, r.uint32()));
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return PostProductTypesRequest;
    })();

    coreproductpb.AssociateProductTypeMapping = (function() {

        /**
         * Properties of an AssociateProductTypeMapping.
         * @memberof coreproductpb
         * @interface IAssociateProductTypeMapping
         * @property {string|null} [brand] AssociateProductTypeMapping brand
         * @property {string|null} [salesChannel] AssociateProductTypeMapping salesChannel
         */

        /**
         * Constructs a new AssociateProductTypeMapping.
         * @memberof coreproductpb
         * @classdesc Represents an AssociateProductTypeMapping.
         * @implements IAssociateProductTypeMapping
         * @constructor
         * @param {coreproductpb.IAssociateProductTypeMapping=} [p] Properties to set
         */
        function AssociateProductTypeMapping(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * AssociateProductTypeMapping brand.
         * @member {string} brand
         * @memberof coreproductpb.AssociateProductTypeMapping
         * @instance
         */
        AssociateProductTypeMapping.prototype.brand = "";

        /**
         * AssociateProductTypeMapping salesChannel.
         * @member {string} salesChannel
         * @memberof coreproductpb.AssociateProductTypeMapping
         * @instance
         */
        AssociateProductTypeMapping.prototype.salesChannel = "";

        /**
         * Creates a new AssociateProductTypeMapping instance using the specified properties.
         * @function create
         * @memberof coreproductpb.AssociateProductTypeMapping
         * @static
         * @param {coreproductpb.IAssociateProductTypeMapping=} [properties] Properties to set
         * @returns {coreproductpb.AssociateProductTypeMapping} AssociateProductTypeMapping instance
         */
        AssociateProductTypeMapping.create = function create(properties) {
            return new AssociateProductTypeMapping(properties);
        };

        /**
         * Encodes the specified AssociateProductTypeMapping message. Does not implicitly {@link coreproductpb.AssociateProductTypeMapping.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.AssociateProductTypeMapping
         * @static
         * @param {coreproductpb.IAssociateProductTypeMapping} m AssociateProductTypeMapping message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AssociateProductTypeMapping.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.brand != null && Object.hasOwnProperty.call(m, "brand"))
                w.uint32(10).string(m.brand);
            if (m.salesChannel != null && Object.hasOwnProperty.call(m, "salesChannel"))
                w.uint32(18).string(m.salesChannel);
            return w;
        };

        /**
         * Decodes an AssociateProductTypeMapping message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.AssociateProductTypeMapping
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.AssociateProductTypeMapping} AssociateProductTypeMapping
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AssociateProductTypeMapping.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.AssociateProductTypeMapping();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.brand = r.string();
                    break;
                case 2:
                    m.salesChannel = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return AssociateProductTypeMapping;
    })();

    coreproductpb.PostProductTypesResponse = (function() {

        /**
         * Properties of a PostProductTypesResponse.
         * @memberof coreproductpb
         * @interface IPostProductTypesResponse
         * @property {string|null} [productTypeID] PostProductTypesResponse productTypeID
         * @property {Array.<common.IError>|null} [errors] PostProductTypesResponse errors
         */

        /**
         * Constructs a new PostProductTypesResponse.
         * @memberof coreproductpb
         * @classdesc Represents a PostProductTypesResponse.
         * @implements IPostProductTypesResponse
         * @constructor
         * @param {coreproductpb.IPostProductTypesResponse=} [p] Properties to set
         */
        function PostProductTypesResponse(p) {
            this.errors = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * PostProductTypesResponse productTypeID.
         * @member {string} productTypeID
         * @memberof coreproductpb.PostProductTypesResponse
         * @instance
         */
        PostProductTypesResponse.prototype.productTypeID = "";

        /**
         * PostProductTypesResponse errors.
         * @member {Array.<common.IError>} errors
         * @memberof coreproductpb.PostProductTypesResponse
         * @instance
         */
        PostProductTypesResponse.prototype.errors = $util.emptyArray;

        /**
         * Creates a new PostProductTypesResponse instance using the specified properties.
         * @function create
         * @memberof coreproductpb.PostProductTypesResponse
         * @static
         * @param {coreproductpb.IPostProductTypesResponse=} [properties] Properties to set
         * @returns {coreproductpb.PostProductTypesResponse} PostProductTypesResponse instance
         */
        PostProductTypesResponse.create = function create(properties) {
            return new PostProductTypesResponse(properties);
        };

        /**
         * Encodes the specified PostProductTypesResponse message. Does not implicitly {@link coreproductpb.PostProductTypesResponse.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.PostProductTypesResponse
         * @static
         * @param {coreproductpb.IPostProductTypesResponse} m PostProductTypesResponse message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PostProductTypesResponse.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.productTypeID != null && Object.hasOwnProperty.call(m, "productTypeID"))
                w.uint32(10).string(m.productTypeID);
            if (m.errors != null && m.errors.length) {
                for (var i = 0; i < m.errors.length; ++i)
                    $root.common.Error.encode(m.errors[i], w.uint32(18).fork()).ldelim();
            }
            return w;
        };

        /**
         * Decodes a PostProductTypesResponse message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.PostProductTypesResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.PostProductTypesResponse} PostProductTypesResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PostProductTypesResponse.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.PostProductTypesResponse();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.productTypeID = r.string();
                    break;
                case 2:
                    if (!(m.errors && m.errors.length))
                        m.errors = [];
                    m.errors.push($root.common.Error.decode(r, r.uint32()));
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return PostProductTypesResponse;
    })();

    coreproductpb.GetProductTypesRequest = (function() {

        /**
         * Properties of a GetProductTypesRequest.
         * @memberof coreproductpb
         * @interface IGetProductTypesRequest
         * @property {string|null} [productTypeID] GetProductTypesRequest productTypeID
         * @property {string|null} [starProductTypeID] GetProductTypesRequest starProductTypeID
         * @property {Array.<coreproductpb.DataRecordStatus>|null} [status] GetProductTypesRequest status
         * @property {common.IPaginationRequest|null} [pagination] GetProductTypesRequest pagination
         */

        /**
         * Constructs a new GetProductTypesRequest.
         * @memberof coreproductpb
         * @classdesc Represents a GetProductTypesRequest.
         * @implements IGetProductTypesRequest
         * @constructor
         * @param {coreproductpb.IGetProductTypesRequest=} [p] Properties to set
         */
        function GetProductTypesRequest(p) {
            this.status = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * GetProductTypesRequest productTypeID.
         * @member {string} productTypeID
         * @memberof coreproductpb.GetProductTypesRequest
         * @instance
         */
        GetProductTypesRequest.prototype.productTypeID = "";

        /**
         * GetProductTypesRequest starProductTypeID.
         * @member {string} starProductTypeID
         * @memberof coreproductpb.GetProductTypesRequest
         * @instance
         */
        GetProductTypesRequest.prototype.starProductTypeID = "";

        /**
         * GetProductTypesRequest status.
         * @member {Array.<coreproductpb.DataRecordStatus>} status
         * @memberof coreproductpb.GetProductTypesRequest
         * @instance
         */
        GetProductTypesRequest.prototype.status = $util.emptyArray;

        /**
         * GetProductTypesRequest pagination.
         * @member {common.IPaginationRequest|null|undefined} pagination
         * @memberof coreproductpb.GetProductTypesRequest
         * @instance
         */
        GetProductTypesRequest.prototype.pagination = null;

        /**
         * Creates a new GetProductTypesRequest instance using the specified properties.
         * @function create
         * @memberof coreproductpb.GetProductTypesRequest
         * @static
         * @param {coreproductpb.IGetProductTypesRequest=} [properties] Properties to set
         * @returns {coreproductpb.GetProductTypesRequest} GetProductTypesRequest instance
         */
        GetProductTypesRequest.create = function create(properties) {
            return new GetProductTypesRequest(properties);
        };

        /**
         * Encodes the specified GetProductTypesRequest message. Does not implicitly {@link coreproductpb.GetProductTypesRequest.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.GetProductTypesRequest
         * @static
         * @param {coreproductpb.IGetProductTypesRequest} m GetProductTypesRequest message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetProductTypesRequest.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.productTypeID != null && Object.hasOwnProperty.call(m, "productTypeID"))
                w.uint32(10).string(m.productTypeID);
            if (m.starProductTypeID != null && Object.hasOwnProperty.call(m, "starProductTypeID"))
                w.uint32(18).string(m.starProductTypeID);
            if (m.status != null && m.status.length) {
                w.uint32(26).fork();
                for (var i = 0; i < m.status.length; ++i)
                    w.int32(m.status[i]);
                w.ldelim();
            }
            if (m.pagination != null && Object.hasOwnProperty.call(m, "pagination"))
                $root.common.PaginationRequest.encode(m.pagination, w.uint32(34).fork()).ldelim();
            return w;
        };

        /**
         * Decodes a GetProductTypesRequest message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.GetProductTypesRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.GetProductTypesRequest} GetProductTypesRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetProductTypesRequest.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.GetProductTypesRequest();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.productTypeID = r.string();
                    break;
                case 2:
                    m.starProductTypeID = r.string();
                    break;
                case 3:
                    if (!(m.status && m.status.length))
                        m.status = [];
                    if ((t & 7) === 2) {
                        var c2 = r.uint32() + r.pos;
                        while (r.pos < c2)
                            m.status.push(r.int32());
                    } else
                        m.status.push(r.int32());
                    break;
                case 4:
                    m.pagination = $root.common.PaginationRequest.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return GetProductTypesRequest;
    })();

    coreproductpb.GetProductTypesResponse = (function() {

        /**
         * Properties of a GetProductTypesResponse.
         * @memberof coreproductpb
         * @interface IGetProductTypesResponse
         * @property {Array.<coreproductpb.IProductTypeDetail>|null} [productTypeDetails] GetProductTypesResponse productTypeDetails
         * @property {Array.<common.IError>|null} [errors] GetProductTypesResponse errors
         * @property {common.IPagination|null} [pagination] GetProductTypesResponse pagination
         * @property {Object.<string,number>|null} [statusesCount] GetProductTypesResponse statusesCount
         */

        /**
         * Constructs a new GetProductTypesResponse.
         * @memberof coreproductpb
         * @classdesc Represents a GetProductTypesResponse.
         * @implements IGetProductTypesResponse
         * @constructor
         * @param {coreproductpb.IGetProductTypesResponse=} [p] Properties to set
         */
        function GetProductTypesResponse(p) {
            this.productTypeDetails = [];
            this.errors = [];
            this.statusesCount = {};
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * GetProductTypesResponse productTypeDetails.
         * @member {Array.<coreproductpb.IProductTypeDetail>} productTypeDetails
         * @memberof coreproductpb.GetProductTypesResponse
         * @instance
         */
        GetProductTypesResponse.prototype.productTypeDetails = $util.emptyArray;

        /**
         * GetProductTypesResponse errors.
         * @member {Array.<common.IError>} errors
         * @memberof coreproductpb.GetProductTypesResponse
         * @instance
         */
        GetProductTypesResponse.prototype.errors = $util.emptyArray;

        /**
         * GetProductTypesResponse pagination.
         * @member {common.IPagination|null|undefined} pagination
         * @memberof coreproductpb.GetProductTypesResponse
         * @instance
         */
        GetProductTypesResponse.prototype.pagination = null;

        /**
         * GetProductTypesResponse statusesCount.
         * @member {Object.<string,number>} statusesCount
         * @memberof coreproductpb.GetProductTypesResponse
         * @instance
         */
        GetProductTypesResponse.prototype.statusesCount = $util.emptyObject;

        /**
         * Creates a new GetProductTypesResponse instance using the specified properties.
         * @function create
         * @memberof coreproductpb.GetProductTypesResponse
         * @static
         * @param {coreproductpb.IGetProductTypesResponse=} [properties] Properties to set
         * @returns {coreproductpb.GetProductTypesResponse} GetProductTypesResponse instance
         */
        GetProductTypesResponse.create = function create(properties) {
            return new GetProductTypesResponse(properties);
        };

        /**
         * Encodes the specified GetProductTypesResponse message. Does not implicitly {@link coreproductpb.GetProductTypesResponse.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.GetProductTypesResponse
         * @static
         * @param {coreproductpb.IGetProductTypesResponse} m GetProductTypesResponse message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetProductTypesResponse.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.productTypeDetails != null && m.productTypeDetails.length) {
                for (var i = 0; i < m.productTypeDetails.length; ++i)
                    $root.coreproductpb.ProductTypeDetail.encode(m.productTypeDetails[i], w.uint32(10).fork()).ldelim();
            }
            if (m.errors != null && m.errors.length) {
                for (var i = 0; i < m.errors.length; ++i)
                    $root.common.Error.encode(m.errors[i], w.uint32(18).fork()).ldelim();
            }
            if (m.pagination != null && Object.hasOwnProperty.call(m, "pagination"))
                $root.common.Pagination.encode(m.pagination, w.uint32(26).fork()).ldelim();
            if (m.statusesCount != null && Object.hasOwnProperty.call(m, "statusesCount")) {
                for (var ks = Object.keys(m.statusesCount), i = 0; i < ks.length; ++i) {
                    w.uint32(34).fork().uint32(8).int32(ks[i]).uint32(16).int32(m.statusesCount[ks[i]]).ldelim();
                }
            }
            return w;
        };

        /**
         * Decodes a GetProductTypesResponse message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.GetProductTypesResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.GetProductTypesResponse} GetProductTypesResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetProductTypesResponse.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.GetProductTypesResponse(), k, value;
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    if (!(m.productTypeDetails && m.productTypeDetails.length))
                        m.productTypeDetails = [];
                    m.productTypeDetails.push($root.coreproductpb.ProductTypeDetail.decode(r, r.uint32()));
                    break;
                case 2:
                    if (!(m.errors && m.errors.length))
                        m.errors = [];
                    m.errors.push($root.common.Error.decode(r, r.uint32()));
                    break;
                case 3:
                    m.pagination = $root.common.Pagination.decode(r, r.uint32());
                    break;
                case 4:
                    if (m.statusesCount === $util.emptyObject)
                        m.statusesCount = {};
                    var c2 = r.uint32() + r.pos;
                    k = 0;
                    value = 0;
                    while (r.pos < c2) {
                        var tag2 = r.uint32();
                        switch (tag2 >>> 3) {
                        case 1:
                            k = r.int32();
                            break;
                        case 2:
                            value = r.int32();
                            break;
                        default:
                            r.skipType(tag2 & 7);
                            break;
                        }
                    }
                    m.statusesCount[k] = value;
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return GetProductTypesResponse;
    })();

    coreproductpb.ProductTypeDetail = (function() {

        /**
         * Properties of a ProductTypeDetail.
         * @memberof coreproductpb
         * @interface IProductTypeDetail
         * @property {string|null} [productTypeID] ProductTypeDetail productTypeID
         * @property {string|null} [starProductTypeID] ProductTypeDetail starProductTypeID
         * @property {string|null} [name] ProductTypeDetail name
         * @property {google.protobuf.ITimestamp|null} [effectiveDate] ProductTypeDetail effectiveDate
         * @property {google.protobuf.ITimestamp|null} [expirationDate] ProductTypeDetail expirationDate
         * @property {coreproductpb.DataRecordStatus|null} [status] ProductTypeDetail status
         * @property {string|null} [failureReason] ProductTypeDetail failureReason
         * @property {Array.<coreproductpb.IProductTypeMapping>|null} [ProductTypeMapping] ProductTypeDetail ProductTypeMapping
         * @property {google.protobuf.ITimestamp|null} [createdOn] ProductTypeDetail createdOn
         * @property {google.protobuf.ITimestamp|null} [updatedOn] ProductTypeDetail updatedOn
         * @property {string|null} [createdBy] ProductTypeDetail createdBy
         * @property {string|null} [updatedBy] ProductTypeDetail updatedBy
         */

        /**
         * Constructs a new ProductTypeDetail.
         * @memberof coreproductpb
         * @classdesc Represents a ProductTypeDetail.
         * @implements IProductTypeDetail
         * @constructor
         * @param {coreproductpb.IProductTypeDetail=} [p] Properties to set
         */
        function ProductTypeDetail(p) {
            this.ProductTypeMapping = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * ProductTypeDetail productTypeID.
         * @member {string} productTypeID
         * @memberof coreproductpb.ProductTypeDetail
         * @instance
         */
        ProductTypeDetail.prototype.productTypeID = "";

        /**
         * ProductTypeDetail starProductTypeID.
         * @member {string} starProductTypeID
         * @memberof coreproductpb.ProductTypeDetail
         * @instance
         */
        ProductTypeDetail.prototype.starProductTypeID = "";

        /**
         * ProductTypeDetail name.
         * @member {string} name
         * @memberof coreproductpb.ProductTypeDetail
         * @instance
         */
        ProductTypeDetail.prototype.name = "";

        /**
         * ProductTypeDetail effectiveDate.
         * @member {google.protobuf.ITimestamp|null|undefined} effectiveDate
         * @memberof coreproductpb.ProductTypeDetail
         * @instance
         */
        ProductTypeDetail.prototype.effectiveDate = null;

        /**
         * ProductTypeDetail expirationDate.
         * @member {google.protobuf.ITimestamp|null|undefined} expirationDate
         * @memberof coreproductpb.ProductTypeDetail
         * @instance
         */
        ProductTypeDetail.prototype.expirationDate = null;

        /**
         * ProductTypeDetail status.
         * @member {coreproductpb.DataRecordStatus} status
         * @memberof coreproductpb.ProductTypeDetail
         * @instance
         */
        ProductTypeDetail.prototype.status = 0;

        /**
         * ProductTypeDetail failureReason.
         * @member {string} failureReason
         * @memberof coreproductpb.ProductTypeDetail
         * @instance
         */
        ProductTypeDetail.prototype.failureReason = "";

        /**
         * ProductTypeDetail ProductTypeMapping.
         * @member {Array.<coreproductpb.IProductTypeMapping>} ProductTypeMapping
         * @memberof coreproductpb.ProductTypeDetail
         * @instance
         */
        ProductTypeDetail.prototype.ProductTypeMapping = $util.emptyArray;

        /**
         * ProductTypeDetail createdOn.
         * @member {google.protobuf.ITimestamp|null|undefined} createdOn
         * @memberof coreproductpb.ProductTypeDetail
         * @instance
         */
        ProductTypeDetail.prototype.createdOn = null;

        /**
         * ProductTypeDetail updatedOn.
         * @member {google.protobuf.ITimestamp|null|undefined} updatedOn
         * @memberof coreproductpb.ProductTypeDetail
         * @instance
         */
        ProductTypeDetail.prototype.updatedOn = null;

        /**
         * ProductTypeDetail createdBy.
         * @member {string} createdBy
         * @memberof coreproductpb.ProductTypeDetail
         * @instance
         */
        ProductTypeDetail.prototype.createdBy = "";

        /**
         * ProductTypeDetail updatedBy.
         * @member {string} updatedBy
         * @memberof coreproductpb.ProductTypeDetail
         * @instance
         */
        ProductTypeDetail.prototype.updatedBy = "";

        /**
         * Creates a new ProductTypeDetail instance using the specified properties.
         * @function create
         * @memberof coreproductpb.ProductTypeDetail
         * @static
         * @param {coreproductpb.IProductTypeDetail=} [properties] Properties to set
         * @returns {coreproductpb.ProductTypeDetail} ProductTypeDetail instance
         */
        ProductTypeDetail.create = function create(properties) {
            return new ProductTypeDetail(properties);
        };

        /**
         * Encodes the specified ProductTypeDetail message. Does not implicitly {@link coreproductpb.ProductTypeDetail.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.ProductTypeDetail
         * @static
         * @param {coreproductpb.IProductTypeDetail} m ProductTypeDetail message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ProductTypeDetail.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.productTypeID != null && Object.hasOwnProperty.call(m, "productTypeID"))
                w.uint32(10).string(m.productTypeID);
            if (m.starProductTypeID != null && Object.hasOwnProperty.call(m, "starProductTypeID"))
                w.uint32(18).string(m.starProductTypeID);
            if (m.name != null && Object.hasOwnProperty.call(m, "name"))
                w.uint32(26).string(m.name);
            if (m.effectiveDate != null && Object.hasOwnProperty.call(m, "effectiveDate"))
                $root.google.protobuf.Timestamp.encode(m.effectiveDate, w.uint32(34).fork()).ldelim();
            if (m.expirationDate != null && Object.hasOwnProperty.call(m, "expirationDate"))
                $root.google.protobuf.Timestamp.encode(m.expirationDate, w.uint32(42).fork()).ldelim();
            if (m.status != null && Object.hasOwnProperty.call(m, "status"))
                w.uint32(48).int32(m.status);
            if (m.failureReason != null && Object.hasOwnProperty.call(m, "failureReason"))
                w.uint32(58).string(m.failureReason);
            if (m.ProductTypeMapping != null && m.ProductTypeMapping.length) {
                for (var i = 0; i < m.ProductTypeMapping.length; ++i)
                    $root.coreproductpb.ProductTypeMapping.encode(m.ProductTypeMapping[i], w.uint32(66).fork()).ldelim();
            }
            if (m.createdOn != null && Object.hasOwnProperty.call(m, "createdOn"))
                $root.google.protobuf.Timestamp.encode(m.createdOn, w.uint32(74).fork()).ldelim();
            if (m.updatedOn != null && Object.hasOwnProperty.call(m, "updatedOn"))
                $root.google.protobuf.Timestamp.encode(m.updatedOn, w.uint32(82).fork()).ldelim();
            if (m.createdBy != null && Object.hasOwnProperty.call(m, "createdBy"))
                w.uint32(90).string(m.createdBy);
            if (m.updatedBy != null && Object.hasOwnProperty.call(m, "updatedBy"))
                w.uint32(98).string(m.updatedBy);
            return w;
        };

        /**
         * Decodes a ProductTypeDetail message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.ProductTypeDetail
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.ProductTypeDetail} ProductTypeDetail
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ProductTypeDetail.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.ProductTypeDetail();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.productTypeID = r.string();
                    break;
                case 2:
                    m.starProductTypeID = r.string();
                    break;
                case 3:
                    m.name = r.string();
                    break;
                case 4:
                    m.effectiveDate = $root.google.protobuf.Timestamp.decode(r, r.uint32());
                    break;
                case 5:
                    m.expirationDate = $root.google.protobuf.Timestamp.decode(r, r.uint32());
                    break;
                case 6:
                    m.status = r.int32();
                    break;
                case 7:
                    m.failureReason = r.string();
                    break;
                case 8:
                    if (!(m.ProductTypeMapping && m.ProductTypeMapping.length))
                        m.ProductTypeMapping = [];
                    m.ProductTypeMapping.push($root.coreproductpb.ProductTypeMapping.decode(r, r.uint32()));
                    break;
                case 9:
                    m.createdOn = $root.google.protobuf.Timestamp.decode(r, r.uint32());
                    break;
                case 10:
                    m.updatedOn = $root.google.protobuf.Timestamp.decode(r, r.uint32());
                    break;
                case 11:
                    m.createdBy = r.string();
                    break;
                case 12:
                    m.updatedBy = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return ProductTypeDetail;
    })();

    coreproductpb.ProductTypeMapping = (function() {

        /**
         * Properties of a ProductTypeMapping.
         * @memberof coreproductpb
         * @interface IProductTypeMapping
         * @property {string|null} [productTypeMappingID] ProductTypeMapping productTypeMappingID
         * @property {string|null} [brand] ProductTypeMapping brand
         * @property {string|null} [salesChannel] ProductTypeMapping salesChannel
         * @property {google.protobuf.ITimestamp|null} [effectiveDate] ProductTypeMapping effectiveDate
         * @property {google.protobuf.ITimestamp|null} [expirationDate] ProductTypeMapping expirationDate
         * @property {coreproductpb.DataRecordStatus|null} [status] ProductTypeMapping status
         */

        /**
         * Constructs a new ProductTypeMapping.
         * @memberof coreproductpb
         * @classdesc Represents a ProductTypeMapping.
         * @implements IProductTypeMapping
         * @constructor
         * @param {coreproductpb.IProductTypeMapping=} [p] Properties to set
         */
        function ProductTypeMapping(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * ProductTypeMapping productTypeMappingID.
         * @member {string} productTypeMappingID
         * @memberof coreproductpb.ProductTypeMapping
         * @instance
         */
        ProductTypeMapping.prototype.productTypeMappingID = "";

        /**
         * ProductTypeMapping brand.
         * @member {string} brand
         * @memberof coreproductpb.ProductTypeMapping
         * @instance
         */
        ProductTypeMapping.prototype.brand = "";

        /**
         * ProductTypeMapping salesChannel.
         * @member {string} salesChannel
         * @memberof coreproductpb.ProductTypeMapping
         * @instance
         */
        ProductTypeMapping.prototype.salesChannel = "";

        /**
         * ProductTypeMapping effectiveDate.
         * @member {google.protobuf.ITimestamp|null|undefined} effectiveDate
         * @memberof coreproductpb.ProductTypeMapping
         * @instance
         */
        ProductTypeMapping.prototype.effectiveDate = null;

        /**
         * ProductTypeMapping expirationDate.
         * @member {google.protobuf.ITimestamp|null|undefined} expirationDate
         * @memberof coreproductpb.ProductTypeMapping
         * @instance
         */
        ProductTypeMapping.prototype.expirationDate = null;

        /**
         * ProductTypeMapping status.
         * @member {coreproductpb.DataRecordStatus} status
         * @memberof coreproductpb.ProductTypeMapping
         * @instance
         */
        ProductTypeMapping.prototype.status = 0;

        /**
         * Creates a new ProductTypeMapping instance using the specified properties.
         * @function create
         * @memberof coreproductpb.ProductTypeMapping
         * @static
         * @param {coreproductpb.IProductTypeMapping=} [properties] Properties to set
         * @returns {coreproductpb.ProductTypeMapping} ProductTypeMapping instance
         */
        ProductTypeMapping.create = function create(properties) {
            return new ProductTypeMapping(properties);
        };

        /**
         * Encodes the specified ProductTypeMapping message. Does not implicitly {@link coreproductpb.ProductTypeMapping.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.ProductTypeMapping
         * @static
         * @param {coreproductpb.IProductTypeMapping} m ProductTypeMapping message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ProductTypeMapping.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.productTypeMappingID != null && Object.hasOwnProperty.call(m, "productTypeMappingID"))
                w.uint32(10).string(m.productTypeMappingID);
            if (m.brand != null && Object.hasOwnProperty.call(m, "brand"))
                w.uint32(18).string(m.brand);
            if (m.salesChannel != null && Object.hasOwnProperty.call(m, "salesChannel"))
                w.uint32(26).string(m.salesChannel);
            if (m.effectiveDate != null && Object.hasOwnProperty.call(m, "effectiveDate"))
                $root.google.protobuf.Timestamp.encode(m.effectiveDate, w.uint32(34).fork()).ldelim();
            if (m.expirationDate != null && Object.hasOwnProperty.call(m, "expirationDate"))
                $root.google.protobuf.Timestamp.encode(m.expirationDate, w.uint32(42).fork()).ldelim();
            if (m.status != null && Object.hasOwnProperty.call(m, "status"))
                w.uint32(48).int32(m.status);
            return w;
        };

        /**
         * Decodes a ProductTypeMapping message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.ProductTypeMapping
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.ProductTypeMapping} ProductTypeMapping
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ProductTypeMapping.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.ProductTypeMapping();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.productTypeMappingID = r.string();
                    break;
                case 2:
                    m.brand = r.string();
                    break;
                case 3:
                    m.salesChannel = r.string();
                    break;
                case 4:
                    m.effectiveDate = $root.google.protobuf.Timestamp.decode(r, r.uint32());
                    break;
                case 5:
                    m.expirationDate = $root.google.protobuf.Timestamp.decode(r, r.uint32());
                    break;
                case 6:
                    m.status = r.int32();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return ProductTypeMapping;
    })();

    coreproductpb.PutProductTypesRequest = (function() {

        /**
         * Properties of a PutProductTypesRequest.
         * @memberof coreproductpb
         * @interface IPutProductTypesRequest
         * @property {string|null} [productTypeID] PutProductTypesRequest productTypeID
         * @property {string|null} [name] PutProductTypesRequest name
         * @property {Array.<coreproductpb.IAssociateProductTypeMapping>|null} [productTypeMapping] PutProductTypesRequest productTypeMapping
         */

        /**
         * Constructs a new PutProductTypesRequest.
         * @memberof coreproductpb
         * @classdesc Represents a PutProductTypesRequest.
         * @implements IPutProductTypesRequest
         * @constructor
         * @param {coreproductpb.IPutProductTypesRequest=} [p] Properties to set
         */
        function PutProductTypesRequest(p) {
            this.productTypeMapping = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * PutProductTypesRequest productTypeID.
         * @member {string} productTypeID
         * @memberof coreproductpb.PutProductTypesRequest
         * @instance
         */
        PutProductTypesRequest.prototype.productTypeID = "";

        /**
         * PutProductTypesRequest name.
         * @member {string} name
         * @memberof coreproductpb.PutProductTypesRequest
         * @instance
         */
        PutProductTypesRequest.prototype.name = "";

        /**
         * PutProductTypesRequest productTypeMapping.
         * @member {Array.<coreproductpb.IAssociateProductTypeMapping>} productTypeMapping
         * @memberof coreproductpb.PutProductTypesRequest
         * @instance
         */
        PutProductTypesRequest.prototype.productTypeMapping = $util.emptyArray;

        /**
         * Creates a new PutProductTypesRequest instance using the specified properties.
         * @function create
         * @memberof coreproductpb.PutProductTypesRequest
         * @static
         * @param {coreproductpb.IPutProductTypesRequest=} [properties] Properties to set
         * @returns {coreproductpb.PutProductTypesRequest} PutProductTypesRequest instance
         */
        PutProductTypesRequest.create = function create(properties) {
            return new PutProductTypesRequest(properties);
        };

        /**
         * Encodes the specified PutProductTypesRequest message. Does not implicitly {@link coreproductpb.PutProductTypesRequest.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.PutProductTypesRequest
         * @static
         * @param {coreproductpb.IPutProductTypesRequest} m PutProductTypesRequest message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PutProductTypesRequest.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.productTypeID != null && Object.hasOwnProperty.call(m, "productTypeID"))
                w.uint32(10).string(m.productTypeID);
            if (m.name != null && Object.hasOwnProperty.call(m, "name"))
                w.uint32(18).string(m.name);
            if (m.productTypeMapping != null && m.productTypeMapping.length) {
                for (var i = 0; i < m.productTypeMapping.length; ++i)
                    $root.coreproductpb.AssociateProductTypeMapping.encode(m.productTypeMapping[i], w.uint32(26).fork()).ldelim();
            }
            return w;
        };

        /**
         * Decodes a PutProductTypesRequest message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.PutProductTypesRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.PutProductTypesRequest} PutProductTypesRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PutProductTypesRequest.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.PutProductTypesRequest();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.productTypeID = r.string();
                    break;
                case 2:
                    m.name = r.string();
                    break;
                case 3:
                    if (!(m.productTypeMapping && m.productTypeMapping.length))
                        m.productTypeMapping = [];
                    m.productTypeMapping.push($root.coreproductpb.AssociateProductTypeMapping.decode(r, r.uint32()));
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return PutProductTypesRequest;
    })();

    coreproductpb.PutProductTypesResponse = (function() {

        /**
         * Properties of a PutProductTypesResponse.
         * @memberof coreproductpb
         * @interface IPutProductTypesResponse
         * @property {Array.<common.IError>|null} [errors] PutProductTypesResponse errors
         */

        /**
         * Constructs a new PutProductTypesResponse.
         * @memberof coreproductpb
         * @classdesc Represents a PutProductTypesResponse.
         * @implements IPutProductTypesResponse
         * @constructor
         * @param {coreproductpb.IPutProductTypesResponse=} [p] Properties to set
         */
        function PutProductTypesResponse(p) {
            this.errors = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * PutProductTypesResponse errors.
         * @member {Array.<common.IError>} errors
         * @memberof coreproductpb.PutProductTypesResponse
         * @instance
         */
        PutProductTypesResponse.prototype.errors = $util.emptyArray;

        /**
         * Creates a new PutProductTypesResponse instance using the specified properties.
         * @function create
         * @memberof coreproductpb.PutProductTypesResponse
         * @static
         * @param {coreproductpb.IPutProductTypesResponse=} [properties] Properties to set
         * @returns {coreproductpb.PutProductTypesResponse} PutProductTypesResponse instance
         */
        PutProductTypesResponse.create = function create(properties) {
            return new PutProductTypesResponse(properties);
        };

        /**
         * Encodes the specified PutProductTypesResponse message. Does not implicitly {@link coreproductpb.PutProductTypesResponse.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.PutProductTypesResponse
         * @static
         * @param {coreproductpb.IPutProductTypesResponse} m PutProductTypesResponse message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PutProductTypesResponse.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.errors != null && m.errors.length) {
                for (var i = 0; i < m.errors.length; ++i)
                    $root.common.Error.encode(m.errors[i], w.uint32(10).fork()).ldelim();
            }
            return w;
        };

        /**
         * Decodes a PutProductTypesResponse message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.PutProductTypesResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.PutProductTypesResponse} PutProductTypesResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PutProductTypesResponse.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.PutProductTypesResponse();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    if (!(m.errors && m.errors.length))
                        m.errors = [];
                    m.errors.push($root.common.Error.decode(r, r.uint32()));
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return PutProductTypesResponse;
    })();

    coreproductpb.CancelProductTypesRequest = (function() {

        /**
         * Properties of a CancelProductTypesRequest.
         * @memberof coreproductpb
         * @interface ICancelProductTypesRequest
         * @property {string|null} [productTypeID] CancelProductTypesRequest productTypeID
         * @property {string|null} [productTypeMappingID] CancelProductTypesRequest productTypeMappingID
         */

        /**
         * Constructs a new CancelProductTypesRequest.
         * @memberof coreproductpb
         * @classdesc Represents a CancelProductTypesRequest.
         * @implements ICancelProductTypesRequest
         * @constructor
         * @param {coreproductpb.ICancelProductTypesRequest=} [p] Properties to set
         */
        function CancelProductTypesRequest(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * CancelProductTypesRequest productTypeID.
         * @member {string} productTypeID
         * @memberof coreproductpb.CancelProductTypesRequest
         * @instance
         */
        CancelProductTypesRequest.prototype.productTypeID = "";

        /**
         * CancelProductTypesRequest productTypeMappingID.
         * @member {string} productTypeMappingID
         * @memberof coreproductpb.CancelProductTypesRequest
         * @instance
         */
        CancelProductTypesRequest.prototype.productTypeMappingID = "";

        /**
         * Creates a new CancelProductTypesRequest instance using the specified properties.
         * @function create
         * @memberof coreproductpb.CancelProductTypesRequest
         * @static
         * @param {coreproductpb.ICancelProductTypesRequest=} [properties] Properties to set
         * @returns {coreproductpb.CancelProductTypesRequest} CancelProductTypesRequest instance
         */
        CancelProductTypesRequest.create = function create(properties) {
            return new CancelProductTypesRequest(properties);
        };

        /**
         * Encodes the specified CancelProductTypesRequest message. Does not implicitly {@link coreproductpb.CancelProductTypesRequest.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.CancelProductTypesRequest
         * @static
         * @param {coreproductpb.ICancelProductTypesRequest} m CancelProductTypesRequest message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CancelProductTypesRequest.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.productTypeID != null && Object.hasOwnProperty.call(m, "productTypeID"))
                w.uint32(10).string(m.productTypeID);
            if (m.productTypeMappingID != null && Object.hasOwnProperty.call(m, "productTypeMappingID"))
                w.uint32(18).string(m.productTypeMappingID);
            return w;
        };

        /**
         * Decodes a CancelProductTypesRequest message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.CancelProductTypesRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.CancelProductTypesRequest} CancelProductTypesRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CancelProductTypesRequest.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.CancelProductTypesRequest();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.productTypeID = r.string();
                    break;
                case 2:
                    m.productTypeMappingID = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return CancelProductTypesRequest;
    })();

    coreproductpb.CancelProductTypesResponse = (function() {

        /**
         * Properties of a CancelProductTypesResponse.
         * @memberof coreproductpb
         * @interface ICancelProductTypesResponse
         * @property {Array.<common.IError>|null} [errors] CancelProductTypesResponse errors
         */

        /**
         * Constructs a new CancelProductTypesResponse.
         * @memberof coreproductpb
         * @classdesc Represents a CancelProductTypesResponse.
         * @implements ICancelProductTypesResponse
         * @constructor
         * @param {coreproductpb.ICancelProductTypesResponse=} [p] Properties to set
         */
        function CancelProductTypesResponse(p) {
            this.errors = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * CancelProductTypesResponse errors.
         * @member {Array.<common.IError>} errors
         * @memberof coreproductpb.CancelProductTypesResponse
         * @instance
         */
        CancelProductTypesResponse.prototype.errors = $util.emptyArray;

        /**
         * Creates a new CancelProductTypesResponse instance using the specified properties.
         * @function create
         * @memberof coreproductpb.CancelProductTypesResponse
         * @static
         * @param {coreproductpb.ICancelProductTypesResponse=} [properties] Properties to set
         * @returns {coreproductpb.CancelProductTypesResponse} CancelProductTypesResponse instance
         */
        CancelProductTypesResponse.create = function create(properties) {
            return new CancelProductTypesResponse(properties);
        };

        /**
         * Encodes the specified CancelProductTypesResponse message. Does not implicitly {@link coreproductpb.CancelProductTypesResponse.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.CancelProductTypesResponse
         * @static
         * @param {coreproductpb.ICancelProductTypesResponse} m CancelProductTypesResponse message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CancelProductTypesResponse.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.errors != null && m.errors.length) {
                for (var i = 0; i < m.errors.length; ++i)
                    $root.common.Error.encode(m.errors[i], w.uint32(10).fork()).ldelim();
            }
            return w;
        };

        /**
         * Decodes a CancelProductTypesResponse message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.CancelProductTypesResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.CancelProductTypesResponse} CancelProductTypesResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CancelProductTypesResponse.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.CancelProductTypesResponse();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    if (!(m.errors && m.errors.length))
                        m.errors = [];
                    m.errors.push($root.common.Error.decode(r, r.uint32()));
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return CancelProductTypesResponse;
    })();

    coreproductpb.PostProductTemplateCloneRequest = (function() {

        /**
         * Properties of a PostProductTemplateCloneRequest.
         * @memberof coreproductpb
         * @interface IPostProductTemplateCloneRequest
         * @property {string|null} [sourceProductTemplateID] PostProductTemplateCloneRequest sourceProductTemplateID
         * @property {string|null} [sourceProductTemplateVersionID] PostProductTemplateCloneRequest sourceProductTemplateVersionID
         * @property {string|null} [targetName] PostProductTemplateCloneRequest targetName
         * @property {string|null} [targetDescription] PostProductTemplateCloneRequest targetDescription
         * @property {google.protobuf.ITimestamp|null} [targetEffectiveDate] PostProductTemplateCloneRequest targetEffectiveDate
         */

        /**
         * Constructs a new PostProductTemplateCloneRequest.
         * @memberof coreproductpb
         * @classdesc Represents a PostProductTemplateCloneRequest.
         * @implements IPostProductTemplateCloneRequest
         * @constructor
         * @param {coreproductpb.IPostProductTemplateCloneRequest=} [p] Properties to set
         */
        function PostProductTemplateCloneRequest(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * PostProductTemplateCloneRequest sourceProductTemplateID.
         * @member {string} sourceProductTemplateID
         * @memberof coreproductpb.PostProductTemplateCloneRequest
         * @instance
         */
        PostProductTemplateCloneRequest.prototype.sourceProductTemplateID = "";

        /**
         * PostProductTemplateCloneRequest sourceProductTemplateVersionID.
         * @member {string} sourceProductTemplateVersionID
         * @memberof coreproductpb.PostProductTemplateCloneRequest
         * @instance
         */
        PostProductTemplateCloneRequest.prototype.sourceProductTemplateVersionID = "";

        /**
         * PostProductTemplateCloneRequest targetName.
         * @member {string} targetName
         * @memberof coreproductpb.PostProductTemplateCloneRequest
         * @instance
         */
        PostProductTemplateCloneRequest.prototype.targetName = "";

        /**
         * PostProductTemplateCloneRequest targetDescription.
         * @member {string} targetDescription
         * @memberof coreproductpb.PostProductTemplateCloneRequest
         * @instance
         */
        PostProductTemplateCloneRequest.prototype.targetDescription = "";

        /**
         * PostProductTemplateCloneRequest targetEffectiveDate.
         * @member {google.protobuf.ITimestamp|null|undefined} targetEffectiveDate
         * @memberof coreproductpb.PostProductTemplateCloneRequest
         * @instance
         */
        PostProductTemplateCloneRequest.prototype.targetEffectiveDate = null;

        /**
         * Creates a new PostProductTemplateCloneRequest instance using the specified properties.
         * @function create
         * @memberof coreproductpb.PostProductTemplateCloneRequest
         * @static
         * @param {coreproductpb.IPostProductTemplateCloneRequest=} [properties] Properties to set
         * @returns {coreproductpb.PostProductTemplateCloneRequest} PostProductTemplateCloneRequest instance
         */
        PostProductTemplateCloneRequest.create = function create(properties) {
            return new PostProductTemplateCloneRequest(properties);
        };

        /**
         * Encodes the specified PostProductTemplateCloneRequest message. Does not implicitly {@link coreproductpb.PostProductTemplateCloneRequest.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.PostProductTemplateCloneRequest
         * @static
         * @param {coreproductpb.IPostProductTemplateCloneRequest} m PostProductTemplateCloneRequest message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PostProductTemplateCloneRequest.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.sourceProductTemplateID != null && Object.hasOwnProperty.call(m, "sourceProductTemplateID"))
                w.uint32(10).string(m.sourceProductTemplateID);
            if (m.sourceProductTemplateVersionID != null && Object.hasOwnProperty.call(m, "sourceProductTemplateVersionID"))
                w.uint32(18).string(m.sourceProductTemplateVersionID);
            if (m.targetName != null && Object.hasOwnProperty.call(m, "targetName"))
                w.uint32(26).string(m.targetName);
            if (m.targetDescription != null && Object.hasOwnProperty.call(m, "targetDescription"))
                w.uint32(34).string(m.targetDescription);
            if (m.targetEffectiveDate != null && Object.hasOwnProperty.call(m, "targetEffectiveDate"))
                $root.google.protobuf.Timestamp.encode(m.targetEffectiveDate, w.uint32(42).fork()).ldelim();
            return w;
        };

        /**
         * Decodes a PostProductTemplateCloneRequest message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.PostProductTemplateCloneRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.PostProductTemplateCloneRequest} PostProductTemplateCloneRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PostProductTemplateCloneRequest.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.PostProductTemplateCloneRequest();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.sourceProductTemplateID = r.string();
                    break;
                case 2:
                    m.sourceProductTemplateVersionID = r.string();
                    break;
                case 3:
                    m.targetName = r.string();
                    break;
                case 4:
                    m.targetDescription = r.string();
                    break;
                case 5:
                    m.targetEffectiveDate = $root.google.protobuf.Timestamp.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return PostProductTemplateCloneRequest;
    })();

    coreproductpb.PostProductTemplateCloneResponse = (function() {

        /**
         * Properties of a PostProductTemplateCloneResponse.
         * @memberof coreproductpb
         * @interface IPostProductTemplateCloneResponse
         * @property {string|null} [productTemplateID] PostProductTemplateCloneResponse productTemplateID
         * @property {Array.<common.IError>|null} [errors] PostProductTemplateCloneResponse errors
         */

        /**
         * Constructs a new PostProductTemplateCloneResponse.
         * @memberof coreproductpb
         * @classdesc Represents a PostProductTemplateCloneResponse.
         * @implements IPostProductTemplateCloneResponse
         * @constructor
         * @param {coreproductpb.IPostProductTemplateCloneResponse=} [p] Properties to set
         */
        function PostProductTemplateCloneResponse(p) {
            this.errors = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * PostProductTemplateCloneResponse productTemplateID.
         * @member {string} productTemplateID
         * @memberof coreproductpb.PostProductTemplateCloneResponse
         * @instance
         */
        PostProductTemplateCloneResponse.prototype.productTemplateID = "";

        /**
         * PostProductTemplateCloneResponse errors.
         * @member {Array.<common.IError>} errors
         * @memberof coreproductpb.PostProductTemplateCloneResponse
         * @instance
         */
        PostProductTemplateCloneResponse.prototype.errors = $util.emptyArray;

        /**
         * Creates a new PostProductTemplateCloneResponse instance using the specified properties.
         * @function create
         * @memberof coreproductpb.PostProductTemplateCloneResponse
         * @static
         * @param {coreproductpb.IPostProductTemplateCloneResponse=} [properties] Properties to set
         * @returns {coreproductpb.PostProductTemplateCloneResponse} PostProductTemplateCloneResponse instance
         */
        PostProductTemplateCloneResponse.create = function create(properties) {
            return new PostProductTemplateCloneResponse(properties);
        };

        /**
         * Encodes the specified PostProductTemplateCloneResponse message. Does not implicitly {@link coreproductpb.PostProductTemplateCloneResponse.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.PostProductTemplateCloneResponse
         * @static
         * @param {coreproductpb.IPostProductTemplateCloneResponse} m PostProductTemplateCloneResponse message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PostProductTemplateCloneResponse.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.productTemplateID != null && Object.hasOwnProperty.call(m, "productTemplateID"))
                w.uint32(10).string(m.productTemplateID);
            if (m.errors != null && m.errors.length) {
                for (var i = 0; i < m.errors.length; ++i)
                    $root.common.Error.encode(m.errors[i], w.uint32(18).fork()).ldelim();
            }
            return w;
        };

        /**
         * Decodes a PostProductTemplateCloneResponse message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.PostProductTemplateCloneResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.PostProductTemplateCloneResponse} PostProductTemplateCloneResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PostProductTemplateCloneResponse.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.PostProductTemplateCloneResponse();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.productTemplateID = r.string();
                    break;
                case 2:
                    if (!(m.errors && m.errors.length))
                        m.errors = [];
                    m.errors.push($root.common.Error.decode(r, r.uint32()));
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return PostProductTemplateCloneResponse;
    })();

    coreproductpb.UniversalSearchRequest = (function() {

        /**
         * Properties of an UniversalSearchRequest.
         * @memberof coreproductpb
         * @interface IUniversalSearchRequest
         * @property {coreproductpb.UniversalSearchRequest.TableDataPoints|null} [tableDataPoints] UniversalSearchRequest tableDataPoints
         * @property {coreproductpb.UniversalSearchRequest.ISearchProductMatchingRule|null} [searchProductMatchingRule] UniversalSearchRequest searchProductMatchingRule
         * @property {coreproductpb.UniversalSearchRequest.ISearchCoverageMatchingRule|null} [searchCoverageMatchingRule] UniversalSearchRequest searchCoverageMatchingRule
         * @property {coreproductpb.UniversalSearchRequest.ISearchProductDetail|null} [searchProductDetail] UniversalSearchRequest searchProductDetail
         * @property {coreproductpb.UniversalSearchRequest.ISearchCoverageDetail|null} [searchCoverageDetail] UniversalSearchRequest searchCoverageDetail
         */

        /**
         * Constructs a new UniversalSearchRequest.
         * @memberof coreproductpb
         * @classdesc Represents an UniversalSearchRequest.
         * @implements IUniversalSearchRequest
         * @constructor
         * @param {coreproductpb.IUniversalSearchRequest=} [p] Properties to set
         */
        function UniversalSearchRequest(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * UniversalSearchRequest tableDataPoints.
         * @member {coreproductpb.UniversalSearchRequest.TableDataPoints} tableDataPoints
         * @memberof coreproductpb.UniversalSearchRequest
         * @instance
         */
        UniversalSearchRequest.prototype.tableDataPoints = 0;

        /**
         * UniversalSearchRequest searchProductMatchingRule.
         * @member {coreproductpb.UniversalSearchRequest.ISearchProductMatchingRule|null|undefined} searchProductMatchingRule
         * @memberof coreproductpb.UniversalSearchRequest
         * @instance
         */
        UniversalSearchRequest.prototype.searchProductMatchingRule = null;

        /**
         * UniversalSearchRequest searchCoverageMatchingRule.
         * @member {coreproductpb.UniversalSearchRequest.ISearchCoverageMatchingRule|null|undefined} searchCoverageMatchingRule
         * @memberof coreproductpb.UniversalSearchRequest
         * @instance
         */
        UniversalSearchRequest.prototype.searchCoverageMatchingRule = null;

        /**
         * UniversalSearchRequest searchProductDetail.
         * @member {coreproductpb.UniversalSearchRequest.ISearchProductDetail|null|undefined} searchProductDetail
         * @memberof coreproductpb.UniversalSearchRequest
         * @instance
         */
        UniversalSearchRequest.prototype.searchProductDetail = null;

        /**
         * UniversalSearchRequest searchCoverageDetail.
         * @member {coreproductpb.UniversalSearchRequest.ISearchCoverageDetail|null|undefined} searchCoverageDetail
         * @memberof coreproductpb.UniversalSearchRequest
         * @instance
         */
        UniversalSearchRequest.prototype.searchCoverageDetail = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        /**
         * UniversalSearchRequest searchPoint.
         * @member {"searchProductMatchingRule"|"searchCoverageMatchingRule"|"searchProductDetail"|"searchCoverageDetail"|undefined} searchPoint
         * @memberof coreproductpb.UniversalSearchRequest
         * @instance
         */
        Object.defineProperty(UniversalSearchRequest.prototype, "searchPoint", {
            get: $util.oneOfGetter($oneOfFields = ["searchProductMatchingRule", "searchCoverageMatchingRule", "searchProductDetail", "searchCoverageDetail"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new UniversalSearchRequest instance using the specified properties.
         * @function create
         * @memberof coreproductpb.UniversalSearchRequest
         * @static
         * @param {coreproductpb.IUniversalSearchRequest=} [properties] Properties to set
         * @returns {coreproductpb.UniversalSearchRequest} UniversalSearchRequest instance
         */
        UniversalSearchRequest.create = function create(properties) {
            return new UniversalSearchRequest(properties);
        };

        /**
         * Encodes the specified UniversalSearchRequest message. Does not implicitly {@link coreproductpb.UniversalSearchRequest.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.UniversalSearchRequest
         * @static
         * @param {coreproductpb.IUniversalSearchRequest} m UniversalSearchRequest message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UniversalSearchRequest.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.tableDataPoints != null && Object.hasOwnProperty.call(m, "tableDataPoints"))
                w.uint32(8).int32(m.tableDataPoints);
            if (m.searchProductMatchingRule != null && Object.hasOwnProperty.call(m, "searchProductMatchingRule"))
                $root.coreproductpb.UniversalSearchRequest.SearchProductMatchingRule.encode(m.searchProductMatchingRule, w.uint32(18).fork()).ldelim();
            if (m.searchCoverageMatchingRule != null && Object.hasOwnProperty.call(m, "searchCoverageMatchingRule"))
                $root.coreproductpb.UniversalSearchRequest.SearchCoverageMatchingRule.encode(m.searchCoverageMatchingRule, w.uint32(26).fork()).ldelim();
            if (m.searchProductDetail != null && Object.hasOwnProperty.call(m, "searchProductDetail"))
                $root.coreproductpb.UniversalSearchRequest.SearchProductDetail.encode(m.searchProductDetail, w.uint32(34).fork()).ldelim();
            if (m.searchCoverageDetail != null && Object.hasOwnProperty.call(m, "searchCoverageDetail"))
                $root.coreproductpb.UniversalSearchRequest.SearchCoverageDetail.encode(m.searchCoverageDetail, w.uint32(42).fork()).ldelim();
            return w;
        };

        /**
         * Decodes an UniversalSearchRequest message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.UniversalSearchRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.UniversalSearchRequest} UniversalSearchRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UniversalSearchRequest.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.UniversalSearchRequest();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.tableDataPoints = r.int32();
                    break;
                case 2:
                    m.searchProductMatchingRule = $root.coreproductpb.UniversalSearchRequest.SearchProductMatchingRule.decode(r, r.uint32());
                    break;
                case 3:
                    m.searchCoverageMatchingRule = $root.coreproductpb.UniversalSearchRequest.SearchCoverageMatchingRule.decode(r, r.uint32());
                    break;
                case 4:
                    m.searchProductDetail = $root.coreproductpb.UniversalSearchRequest.SearchProductDetail.decode(r, r.uint32());
                    break;
                case 5:
                    m.searchCoverageDetail = $root.coreproductpb.UniversalSearchRequest.SearchCoverageDetail.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        /**
         * TableDataPoints enum.
         * @name coreproductpb.UniversalSearchRequest.TableDataPoints
         * @enum {number}
         * @property {number} TDP_UNDEFINED=0 TDP_UNDEFINED value
         * @property {number} TDP_PRODUCT_MATCHING_DETAIL=1 TDP_PRODUCT_MATCHING_DETAIL value
         * @property {number} TDP_COVERAGE_MATCHING_DETAIL=2 TDP_COVERAGE_MATCHING_DETAIL value
         * @property {number} TDP_PRODUCT_DETAIL=3 TDP_PRODUCT_DETAIL value
         * @property {number} TDP_COVERAGE_DETAIL=4 TDP_COVERAGE_DETAIL value
         */
        UniversalSearchRequest.TableDataPoints = (function() {
            const valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "TDP_UNDEFINED"] = 0;
            values[valuesById[1] = "TDP_PRODUCT_MATCHING_DETAIL"] = 1;
            values[valuesById[2] = "TDP_COVERAGE_MATCHING_DETAIL"] = 2;
            values[valuesById[3] = "TDP_PRODUCT_DETAIL"] = 3;
            values[valuesById[4] = "TDP_COVERAGE_DETAIL"] = 4;
            return values;
        })();

        UniversalSearchRequest.SearchProductMatchingRule = (function() {

            /**
             * Properties of a SearchProductMatchingRule.
             * @memberof coreproductpb.UniversalSearchRequest
             * @interface ISearchProductMatchingRule
             * @property {Array.<string>|null} [currentProductID] SearchProductMatchingRule currentProductID
             * @property {Array.<string>|null} [renewalProductID] SearchProductMatchingRule renewalProductID
             * @property {common.ITimeslot|null} [renewalEffectiveDate] SearchProductMatchingRule renewalEffectiveDate
             */

            /**
             * Constructs a new SearchProductMatchingRule.
             * @memberof coreproductpb.UniversalSearchRequest
             * @classdesc Represents a SearchProductMatchingRule.
             * @implements ISearchProductMatchingRule
             * @constructor
             * @param {coreproductpb.UniversalSearchRequest.ISearchProductMatchingRule=} [p] Properties to set
             */
            function SearchProductMatchingRule(p) {
                this.currentProductID = [];
                this.renewalProductID = [];
                if (p)
                    for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                        if (p[ks[i]] != null)
                            this[ks[i]] = p[ks[i]];
            }

            /**
             * SearchProductMatchingRule currentProductID.
             * @member {Array.<string>} currentProductID
             * @memberof coreproductpb.UniversalSearchRequest.SearchProductMatchingRule
             * @instance
             */
            SearchProductMatchingRule.prototype.currentProductID = $util.emptyArray;

            /**
             * SearchProductMatchingRule renewalProductID.
             * @member {Array.<string>} renewalProductID
             * @memberof coreproductpb.UniversalSearchRequest.SearchProductMatchingRule
             * @instance
             */
            SearchProductMatchingRule.prototype.renewalProductID = $util.emptyArray;

            /**
             * SearchProductMatchingRule renewalEffectiveDate.
             * @member {common.ITimeslot|null|undefined} renewalEffectiveDate
             * @memberof coreproductpb.UniversalSearchRequest.SearchProductMatchingRule
             * @instance
             */
            SearchProductMatchingRule.prototype.renewalEffectiveDate = null;

            /**
             * Creates a new SearchProductMatchingRule instance using the specified properties.
             * @function create
             * @memberof coreproductpb.UniversalSearchRequest.SearchProductMatchingRule
             * @static
             * @param {coreproductpb.UniversalSearchRequest.ISearchProductMatchingRule=} [properties] Properties to set
             * @returns {coreproductpb.UniversalSearchRequest.SearchProductMatchingRule} SearchProductMatchingRule instance
             */
            SearchProductMatchingRule.create = function create(properties) {
                return new SearchProductMatchingRule(properties);
            };

            /**
             * Encodes the specified SearchProductMatchingRule message. Does not implicitly {@link coreproductpb.UniversalSearchRequest.SearchProductMatchingRule.verify|verify} messages.
             * @function encode
             * @memberof coreproductpb.UniversalSearchRequest.SearchProductMatchingRule
             * @static
             * @param {coreproductpb.UniversalSearchRequest.ISearchProductMatchingRule} m SearchProductMatchingRule message or plain object to encode
             * @param {$protobuf.Writer} [w] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            SearchProductMatchingRule.encode = function encode(m, w) {
                if (!w)
                    w = $Writer.create();
                if (m.currentProductID != null && m.currentProductID.length) {
                    for (var i = 0; i < m.currentProductID.length; ++i)
                        w.uint32(10).string(m.currentProductID[i]);
                }
                if (m.renewalProductID != null && m.renewalProductID.length) {
                    for (var i = 0; i < m.renewalProductID.length; ++i)
                        w.uint32(18).string(m.renewalProductID[i]);
                }
                if (m.renewalEffectiveDate != null && Object.hasOwnProperty.call(m, "renewalEffectiveDate"))
                    $root.common.Timeslot.encode(m.renewalEffectiveDate, w.uint32(26).fork()).ldelim();
                return w;
            };

            /**
             * Decodes a SearchProductMatchingRule message from the specified reader or buffer.
             * @function decode
             * @memberof coreproductpb.UniversalSearchRequest.SearchProductMatchingRule
             * @static
             * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
             * @param {number} [l] Message length if known beforehand
             * @returns {coreproductpb.UniversalSearchRequest.SearchProductMatchingRule} SearchProductMatchingRule
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            SearchProductMatchingRule.decode = function decode(r, l) {
                if (!(r instanceof $Reader))
                    r = $Reader.create(r);
                var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.UniversalSearchRequest.SearchProductMatchingRule();
                while (r.pos < c) {
                    var t = r.uint32();
                    switch (t >>> 3) {
                    case 1:
                        if (!(m.currentProductID && m.currentProductID.length))
                            m.currentProductID = [];
                        m.currentProductID.push(r.string());
                        break;
                    case 2:
                        if (!(m.renewalProductID && m.renewalProductID.length))
                            m.renewalProductID = [];
                        m.renewalProductID.push(r.string());
                        break;
                    case 3:
                        m.renewalEffectiveDate = $root.common.Timeslot.decode(r, r.uint32());
                        break;
                    default:
                        r.skipType(t & 7);
                        break;
                    }
                }
                return m;
            };

            return SearchProductMatchingRule;
        })();

        UniversalSearchRequest.SearchCoverageMatchingRule = (function() {

            /**
             * Properties of a SearchCoverageMatchingRule.
             * @memberof coreproductpb.UniversalSearchRequest
             * @interface ISearchCoverageMatchingRule
             * @property {string|null} [coverageID] SearchCoverageMatchingRule coverageID
             * @property {string|null} [oldCoverageCode] SearchCoverageMatchingRule oldCoverageCode
             */

            /**
             * Constructs a new SearchCoverageMatchingRule.
             * @memberof coreproductpb.UniversalSearchRequest
             * @classdesc Represents a SearchCoverageMatchingRule.
             * @implements ISearchCoverageMatchingRule
             * @constructor
             * @param {coreproductpb.UniversalSearchRequest.ISearchCoverageMatchingRule=} [p] Properties to set
             */
            function SearchCoverageMatchingRule(p) {
                if (p)
                    for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                        if (p[ks[i]] != null)
                            this[ks[i]] = p[ks[i]];
            }

            /**
             * SearchCoverageMatchingRule coverageID.
             * @member {string} coverageID
             * @memberof coreproductpb.UniversalSearchRequest.SearchCoverageMatchingRule
             * @instance
             */
            SearchCoverageMatchingRule.prototype.coverageID = "";

            /**
             * SearchCoverageMatchingRule oldCoverageCode.
             * @member {string} oldCoverageCode
             * @memberof coreproductpb.UniversalSearchRequest.SearchCoverageMatchingRule
             * @instance
             */
            SearchCoverageMatchingRule.prototype.oldCoverageCode = "";

            /**
             * Creates a new SearchCoverageMatchingRule instance using the specified properties.
             * @function create
             * @memberof coreproductpb.UniversalSearchRequest.SearchCoverageMatchingRule
             * @static
             * @param {coreproductpb.UniversalSearchRequest.ISearchCoverageMatchingRule=} [properties] Properties to set
             * @returns {coreproductpb.UniversalSearchRequest.SearchCoverageMatchingRule} SearchCoverageMatchingRule instance
             */
            SearchCoverageMatchingRule.create = function create(properties) {
                return new SearchCoverageMatchingRule(properties);
            };

            /**
             * Encodes the specified SearchCoverageMatchingRule message. Does not implicitly {@link coreproductpb.UniversalSearchRequest.SearchCoverageMatchingRule.verify|verify} messages.
             * @function encode
             * @memberof coreproductpb.UniversalSearchRequest.SearchCoverageMatchingRule
             * @static
             * @param {coreproductpb.UniversalSearchRequest.ISearchCoverageMatchingRule} m SearchCoverageMatchingRule message or plain object to encode
             * @param {$protobuf.Writer} [w] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            SearchCoverageMatchingRule.encode = function encode(m, w) {
                if (!w)
                    w = $Writer.create();
                if (m.coverageID != null && Object.hasOwnProperty.call(m, "coverageID"))
                    w.uint32(10).string(m.coverageID);
                if (m.oldCoverageCode != null && Object.hasOwnProperty.call(m, "oldCoverageCode"))
                    w.uint32(18).string(m.oldCoverageCode);
                return w;
            };

            /**
             * Decodes a SearchCoverageMatchingRule message from the specified reader or buffer.
             * @function decode
             * @memberof coreproductpb.UniversalSearchRequest.SearchCoverageMatchingRule
             * @static
             * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
             * @param {number} [l] Message length if known beforehand
             * @returns {coreproductpb.UniversalSearchRequest.SearchCoverageMatchingRule} SearchCoverageMatchingRule
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            SearchCoverageMatchingRule.decode = function decode(r, l) {
                if (!(r instanceof $Reader))
                    r = $Reader.create(r);
                var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.UniversalSearchRequest.SearchCoverageMatchingRule();
                while (r.pos < c) {
                    var t = r.uint32();
                    switch (t >>> 3) {
                    case 1:
                        m.coverageID = r.string();
                        break;
                    case 2:
                        m.oldCoverageCode = r.string();
                        break;
                    default:
                        r.skipType(t & 7);
                        break;
                    }
                }
                return m;
            };

            return SearchCoverageMatchingRule;
        })();

        UniversalSearchRequest.SearchProductDetail = (function() {

            /**
             * Properties of a SearchProductDetail.
             * @memberof coreproductpb.UniversalSearchRequest
             * @interface ISearchProductDetail
             * @property {Array.<string>|null} [starPVID] SearchProductDetail starPVID
             */

            /**
             * Constructs a new SearchProductDetail.
             * @memberof coreproductpb.UniversalSearchRequest
             * @classdesc Represents a SearchProductDetail.
             * @implements ISearchProductDetail
             * @constructor
             * @param {coreproductpb.UniversalSearchRequest.ISearchProductDetail=} [p] Properties to set
             */
            function SearchProductDetail(p) {
                this.starPVID = [];
                if (p)
                    for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                        if (p[ks[i]] != null)
                            this[ks[i]] = p[ks[i]];
            }

            /**
             * SearchProductDetail starPVID.
             * @member {Array.<string>} starPVID
             * @memberof coreproductpb.UniversalSearchRequest.SearchProductDetail
             * @instance
             */
            SearchProductDetail.prototype.starPVID = $util.emptyArray;

            /**
             * Creates a new SearchProductDetail instance using the specified properties.
             * @function create
             * @memberof coreproductpb.UniversalSearchRequest.SearchProductDetail
             * @static
             * @param {coreproductpb.UniversalSearchRequest.ISearchProductDetail=} [properties] Properties to set
             * @returns {coreproductpb.UniversalSearchRequest.SearchProductDetail} SearchProductDetail instance
             */
            SearchProductDetail.create = function create(properties) {
                return new SearchProductDetail(properties);
            };

            /**
             * Encodes the specified SearchProductDetail message. Does not implicitly {@link coreproductpb.UniversalSearchRequest.SearchProductDetail.verify|verify} messages.
             * @function encode
             * @memberof coreproductpb.UniversalSearchRequest.SearchProductDetail
             * @static
             * @param {coreproductpb.UniversalSearchRequest.ISearchProductDetail} m SearchProductDetail message or plain object to encode
             * @param {$protobuf.Writer} [w] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            SearchProductDetail.encode = function encode(m, w) {
                if (!w)
                    w = $Writer.create();
                if (m.starPVID != null && m.starPVID.length) {
                    for (var i = 0; i < m.starPVID.length; ++i)
                        w.uint32(10).string(m.starPVID[i]);
                }
                return w;
            };

            /**
             * Decodes a SearchProductDetail message from the specified reader or buffer.
             * @function decode
             * @memberof coreproductpb.UniversalSearchRequest.SearchProductDetail
             * @static
             * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
             * @param {number} [l] Message length if known beforehand
             * @returns {coreproductpb.UniversalSearchRequest.SearchProductDetail} SearchProductDetail
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            SearchProductDetail.decode = function decode(r, l) {
                if (!(r instanceof $Reader))
                    r = $Reader.create(r);
                var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.UniversalSearchRequest.SearchProductDetail();
                while (r.pos < c) {
                    var t = r.uint32();
                    switch (t >>> 3) {
                    case 1:
                        if (!(m.starPVID && m.starPVID.length))
                            m.starPVID = [];
                        m.starPVID.push(r.string());
                        break;
                    default:
                        r.skipType(t & 7);
                        break;
                    }
                }
                return m;
            };

            return SearchProductDetail;
        })();

        UniversalSearchRequest.SearchCoverageDetail = (function() {

            /**
             * Properties of a SearchCoverageDetail.
             * @memberof coreproductpb.UniversalSearchRequest
             * @interface ISearchCoverageDetail
             * @property {Array.<string>|null} [coverageID] SearchCoverageDetail coverageID
             */

            /**
             * Constructs a new SearchCoverageDetail.
             * @memberof coreproductpb.UniversalSearchRequest
             * @classdesc Represents a SearchCoverageDetail.
             * @implements ISearchCoverageDetail
             * @constructor
             * @param {coreproductpb.UniversalSearchRequest.ISearchCoverageDetail=} [p] Properties to set
             */
            function SearchCoverageDetail(p) {
                this.coverageID = [];
                if (p)
                    for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                        if (p[ks[i]] != null)
                            this[ks[i]] = p[ks[i]];
            }

            /**
             * SearchCoverageDetail coverageID.
             * @member {Array.<string>} coverageID
             * @memberof coreproductpb.UniversalSearchRequest.SearchCoverageDetail
             * @instance
             */
            SearchCoverageDetail.prototype.coverageID = $util.emptyArray;

            /**
             * Creates a new SearchCoverageDetail instance using the specified properties.
             * @function create
             * @memberof coreproductpb.UniversalSearchRequest.SearchCoverageDetail
             * @static
             * @param {coreproductpb.UniversalSearchRequest.ISearchCoverageDetail=} [properties] Properties to set
             * @returns {coreproductpb.UniversalSearchRequest.SearchCoverageDetail} SearchCoverageDetail instance
             */
            SearchCoverageDetail.create = function create(properties) {
                return new SearchCoverageDetail(properties);
            };

            /**
             * Encodes the specified SearchCoverageDetail message. Does not implicitly {@link coreproductpb.UniversalSearchRequest.SearchCoverageDetail.verify|verify} messages.
             * @function encode
             * @memberof coreproductpb.UniversalSearchRequest.SearchCoverageDetail
             * @static
             * @param {coreproductpb.UniversalSearchRequest.ISearchCoverageDetail} m SearchCoverageDetail message or plain object to encode
             * @param {$protobuf.Writer} [w] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            SearchCoverageDetail.encode = function encode(m, w) {
                if (!w)
                    w = $Writer.create();
                if (m.coverageID != null && m.coverageID.length) {
                    for (var i = 0; i < m.coverageID.length; ++i)
                        w.uint32(10).string(m.coverageID[i]);
                }
                return w;
            };

            /**
             * Decodes a SearchCoverageDetail message from the specified reader or buffer.
             * @function decode
             * @memberof coreproductpb.UniversalSearchRequest.SearchCoverageDetail
             * @static
             * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
             * @param {number} [l] Message length if known beforehand
             * @returns {coreproductpb.UniversalSearchRequest.SearchCoverageDetail} SearchCoverageDetail
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            SearchCoverageDetail.decode = function decode(r, l) {
                if (!(r instanceof $Reader))
                    r = $Reader.create(r);
                var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.UniversalSearchRequest.SearchCoverageDetail();
                while (r.pos < c) {
                    var t = r.uint32();
                    switch (t >>> 3) {
                    case 1:
                        if (!(m.coverageID && m.coverageID.length))
                            m.coverageID = [];
                        m.coverageID.push(r.string());
                        break;
                    default:
                        r.skipType(t & 7);
                        break;
                    }
                }
                return m;
            };

            return SearchCoverageDetail;
        })();

        return UniversalSearchRequest;
    })();

    coreproductpb.UniversalSearchResponse = (function() {

        /**
         * Properties of an UniversalSearchResponse.
         * @memberof coreproductpb
         * @interface IUniversalSearchResponse
         * @property {Array.<coreproductpb.ISearchRecord>|null} [searchRecords] UniversalSearchResponse searchRecords
         * @property {Array.<string>|null} [recordDetailsHeaders] UniversalSearchResponse recordDetailsHeaders
         * @property {Array.<string>|null} [additionalDetailHeaders] UniversalSearchResponse additionalDetailHeaders
         * @property {Array.<coreproductpb.IAdditionalRequestDetail>|null} [requestDetails] UniversalSearchResponse requestDetails
         * @property {Array.<common.IError>|null} [errors] UniversalSearchResponse errors
         */

        /**
         * Constructs a new UniversalSearchResponse.
         * @memberof coreproductpb
         * @classdesc Represents an UniversalSearchResponse.
         * @implements IUniversalSearchResponse
         * @constructor
         * @param {coreproductpb.IUniversalSearchResponse=} [p] Properties to set
         */
        function UniversalSearchResponse(p) {
            this.searchRecords = [];
            this.recordDetailsHeaders = [];
            this.additionalDetailHeaders = [];
            this.requestDetails = [];
            this.errors = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * UniversalSearchResponse searchRecords.
         * @member {Array.<coreproductpb.ISearchRecord>} searchRecords
         * @memberof coreproductpb.UniversalSearchResponse
         * @instance
         */
        UniversalSearchResponse.prototype.searchRecords = $util.emptyArray;

        /**
         * UniversalSearchResponse recordDetailsHeaders.
         * @member {Array.<string>} recordDetailsHeaders
         * @memberof coreproductpb.UniversalSearchResponse
         * @instance
         */
        UniversalSearchResponse.prototype.recordDetailsHeaders = $util.emptyArray;

        /**
         * UniversalSearchResponse additionalDetailHeaders.
         * @member {Array.<string>} additionalDetailHeaders
         * @memberof coreproductpb.UniversalSearchResponse
         * @instance
         */
        UniversalSearchResponse.prototype.additionalDetailHeaders = $util.emptyArray;

        /**
         * UniversalSearchResponse requestDetails.
         * @member {Array.<coreproductpb.IAdditionalRequestDetail>} requestDetails
         * @memberof coreproductpb.UniversalSearchResponse
         * @instance
         */
        UniversalSearchResponse.prototype.requestDetails = $util.emptyArray;

        /**
         * UniversalSearchResponse errors.
         * @member {Array.<common.IError>} errors
         * @memberof coreproductpb.UniversalSearchResponse
         * @instance
         */
        UniversalSearchResponse.prototype.errors = $util.emptyArray;

        /**
         * Creates a new UniversalSearchResponse instance using the specified properties.
         * @function create
         * @memberof coreproductpb.UniversalSearchResponse
         * @static
         * @param {coreproductpb.IUniversalSearchResponse=} [properties] Properties to set
         * @returns {coreproductpb.UniversalSearchResponse} UniversalSearchResponse instance
         */
        UniversalSearchResponse.create = function create(properties) {
            return new UniversalSearchResponse(properties);
        };

        /**
         * Encodes the specified UniversalSearchResponse message. Does not implicitly {@link coreproductpb.UniversalSearchResponse.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.UniversalSearchResponse
         * @static
         * @param {coreproductpb.IUniversalSearchResponse} m UniversalSearchResponse message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UniversalSearchResponse.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.searchRecords != null && m.searchRecords.length) {
                for (var i = 0; i < m.searchRecords.length; ++i)
                    $root.coreproductpb.SearchRecord.encode(m.searchRecords[i], w.uint32(10).fork()).ldelim();
            }
            if (m.recordDetailsHeaders != null && m.recordDetailsHeaders.length) {
                for (var i = 0; i < m.recordDetailsHeaders.length; ++i)
                    w.uint32(18).string(m.recordDetailsHeaders[i]);
            }
            if (m.additionalDetailHeaders != null && m.additionalDetailHeaders.length) {
                for (var i = 0; i < m.additionalDetailHeaders.length; ++i)
                    w.uint32(26).string(m.additionalDetailHeaders[i]);
            }
            if (m.requestDetails != null && m.requestDetails.length) {
                for (var i = 0; i < m.requestDetails.length; ++i)
                    $root.coreproductpb.AdditionalRequestDetail.encode(m.requestDetails[i], w.uint32(34).fork()).ldelim();
            }
            if (m.errors != null && m.errors.length) {
                for (var i = 0; i < m.errors.length; ++i)
                    $root.common.Error.encode(m.errors[i], w.uint32(42).fork()).ldelim();
            }
            return w;
        };

        /**
         * Decodes an UniversalSearchResponse message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.UniversalSearchResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.UniversalSearchResponse} UniversalSearchResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UniversalSearchResponse.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.UniversalSearchResponse();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    if (!(m.searchRecords && m.searchRecords.length))
                        m.searchRecords = [];
                    m.searchRecords.push($root.coreproductpb.SearchRecord.decode(r, r.uint32()));
                    break;
                case 2:
                    if (!(m.recordDetailsHeaders && m.recordDetailsHeaders.length))
                        m.recordDetailsHeaders = [];
                    m.recordDetailsHeaders.push(r.string());
                    break;
                case 3:
                    if (!(m.additionalDetailHeaders && m.additionalDetailHeaders.length))
                        m.additionalDetailHeaders = [];
                    m.additionalDetailHeaders.push(r.string());
                    break;
                case 4:
                    if (!(m.requestDetails && m.requestDetails.length))
                        m.requestDetails = [];
                    m.requestDetails.push($root.coreproductpb.AdditionalRequestDetail.decode(r, r.uint32()));
                    break;
                case 5:
                    if (!(m.errors && m.errors.length))
                        m.errors = [];
                    m.errors.push($root.common.Error.decode(r, r.uint32()));
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return UniversalSearchResponse;
    })();

    coreproductpb.SearchRecord = (function() {

        /**
         * Properties of a SearchRecord.
         * @memberof coreproductpb
         * @interface ISearchRecord
         * @property {Object.<string,string>|null} [recordDetails] SearchRecord recordDetails
         * @property {Array.<coreproductpb.IAdditionalDetail>|null} [additionalDetail] SearchRecord additionalDetail
         */

        /**
         * Constructs a new SearchRecord.
         * @memberof coreproductpb
         * @classdesc Represents a SearchRecord.
         * @implements ISearchRecord
         * @constructor
         * @param {coreproductpb.ISearchRecord=} [p] Properties to set
         */
        function SearchRecord(p) {
            this.recordDetails = {};
            this.additionalDetail = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * SearchRecord recordDetails.
         * @member {Object.<string,string>} recordDetails
         * @memberof coreproductpb.SearchRecord
         * @instance
         */
        SearchRecord.prototype.recordDetails = $util.emptyObject;

        /**
         * SearchRecord additionalDetail.
         * @member {Array.<coreproductpb.IAdditionalDetail>} additionalDetail
         * @memberof coreproductpb.SearchRecord
         * @instance
         */
        SearchRecord.prototype.additionalDetail = $util.emptyArray;

        /**
         * Creates a new SearchRecord instance using the specified properties.
         * @function create
         * @memberof coreproductpb.SearchRecord
         * @static
         * @param {coreproductpb.ISearchRecord=} [properties] Properties to set
         * @returns {coreproductpb.SearchRecord} SearchRecord instance
         */
        SearchRecord.create = function create(properties) {
            return new SearchRecord(properties);
        };

        /**
         * Encodes the specified SearchRecord message. Does not implicitly {@link coreproductpb.SearchRecord.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.SearchRecord
         * @static
         * @param {coreproductpb.ISearchRecord} m SearchRecord message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SearchRecord.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.recordDetails != null && Object.hasOwnProperty.call(m, "recordDetails")) {
                for (var ks = Object.keys(m.recordDetails), i = 0; i < ks.length; ++i) {
                    w.uint32(10).fork().uint32(10).string(ks[i]).uint32(18).string(m.recordDetails[ks[i]]).ldelim();
                }
            }
            if (m.additionalDetail != null && m.additionalDetail.length) {
                for (var i = 0; i < m.additionalDetail.length; ++i)
                    $root.coreproductpb.AdditionalDetail.encode(m.additionalDetail[i], w.uint32(18).fork()).ldelim();
            }
            return w;
        };

        /**
         * Decodes a SearchRecord message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.SearchRecord
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.SearchRecord} SearchRecord
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SearchRecord.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.SearchRecord(), k, value;
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    if (m.recordDetails === $util.emptyObject)
                        m.recordDetails = {};
                    var c2 = r.uint32() + r.pos;
                    k = "";
                    value = "";
                    while (r.pos < c2) {
                        var tag2 = r.uint32();
                        switch (tag2 >>> 3) {
                        case 1:
                            k = r.string();
                            break;
                        case 2:
                            value = r.string();
                            break;
                        default:
                            r.skipType(tag2 & 7);
                            break;
                        }
                    }
                    m.recordDetails[k] = value;
                    break;
                case 2:
                    if (!(m.additionalDetail && m.additionalDetail.length))
                        m.additionalDetail = [];
                    m.additionalDetail.push($root.coreproductpb.AdditionalDetail.decode(r, r.uint32()));
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return SearchRecord;
    })();

    coreproductpb.AdditionalDetail = (function() {

        /**
         * Properties of an AdditionalDetail.
         * @memberof coreproductpb
         * @interface IAdditionalDetail
         * @property {Object.<string,string>|null} [data] AdditionalDetail data
         */

        /**
         * Constructs a new AdditionalDetail.
         * @memberof coreproductpb
         * @classdesc Represents an AdditionalDetail.
         * @implements IAdditionalDetail
         * @constructor
         * @param {coreproductpb.IAdditionalDetail=} [p] Properties to set
         */
        function AdditionalDetail(p) {
            this.data = {};
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * AdditionalDetail data.
         * @member {Object.<string,string>} data
         * @memberof coreproductpb.AdditionalDetail
         * @instance
         */
        AdditionalDetail.prototype.data = $util.emptyObject;

        /**
         * Creates a new AdditionalDetail instance using the specified properties.
         * @function create
         * @memberof coreproductpb.AdditionalDetail
         * @static
         * @param {coreproductpb.IAdditionalDetail=} [properties] Properties to set
         * @returns {coreproductpb.AdditionalDetail} AdditionalDetail instance
         */
        AdditionalDetail.create = function create(properties) {
            return new AdditionalDetail(properties);
        };

        /**
         * Encodes the specified AdditionalDetail message. Does not implicitly {@link coreproductpb.AdditionalDetail.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.AdditionalDetail
         * @static
         * @param {coreproductpb.IAdditionalDetail} m AdditionalDetail message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AdditionalDetail.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.data != null && Object.hasOwnProperty.call(m, "data")) {
                for (var ks = Object.keys(m.data), i = 0; i < ks.length; ++i) {
                    w.uint32(10).fork().uint32(10).string(ks[i]).uint32(18).string(m.data[ks[i]]).ldelim();
                }
            }
            return w;
        };

        /**
         * Decodes an AdditionalDetail message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.AdditionalDetail
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.AdditionalDetail} AdditionalDetail
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AdditionalDetail.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.AdditionalDetail(), k, value;
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    if (m.data === $util.emptyObject)
                        m.data = {};
                    var c2 = r.uint32() + r.pos;
                    k = "";
                    value = "";
                    while (r.pos < c2) {
                        var tag2 = r.uint32();
                        switch (tag2 >>> 3) {
                        case 1:
                            k = r.string();
                            break;
                        case 2:
                            value = r.string();
                            break;
                        default:
                            r.skipType(tag2 & 7);
                            break;
                        }
                    }
                    m.data[k] = value;
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return AdditionalDetail;
    })();

    coreproductpb.AdditionalRequestDetail = (function() {

        /**
         * Properties of an AdditionalRequestDetail.
         * @memberof coreproductpb
         * @interface IAdditionalRequestDetail
         * @property {Object.<string,string>|null} [data] AdditionalRequestDetail data
         */

        /**
         * Constructs a new AdditionalRequestDetail.
         * @memberof coreproductpb
         * @classdesc Represents an AdditionalRequestDetail.
         * @implements IAdditionalRequestDetail
         * @constructor
         * @param {coreproductpb.IAdditionalRequestDetail=} [p] Properties to set
         */
        function AdditionalRequestDetail(p) {
            this.data = {};
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * AdditionalRequestDetail data.
         * @member {Object.<string,string>} data
         * @memberof coreproductpb.AdditionalRequestDetail
         * @instance
         */
        AdditionalRequestDetail.prototype.data = $util.emptyObject;

        /**
         * Creates a new AdditionalRequestDetail instance using the specified properties.
         * @function create
         * @memberof coreproductpb.AdditionalRequestDetail
         * @static
         * @param {coreproductpb.IAdditionalRequestDetail=} [properties] Properties to set
         * @returns {coreproductpb.AdditionalRequestDetail} AdditionalRequestDetail instance
         */
        AdditionalRequestDetail.create = function create(properties) {
            return new AdditionalRequestDetail(properties);
        };

        /**
         * Encodes the specified AdditionalRequestDetail message. Does not implicitly {@link coreproductpb.AdditionalRequestDetail.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.AdditionalRequestDetail
         * @static
         * @param {coreproductpb.IAdditionalRequestDetail} m AdditionalRequestDetail message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AdditionalRequestDetail.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.data != null && Object.hasOwnProperty.call(m, "data")) {
                for (var ks = Object.keys(m.data), i = 0; i < ks.length; ++i) {
                    w.uint32(10).fork().uint32(10).string(ks[i]).uint32(18).string(m.data[ks[i]]).ldelim();
                }
            }
            return w;
        };

        /**
         * Decodes an AdditionalRequestDetail message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.AdditionalRequestDetail
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.AdditionalRequestDetail} AdditionalRequestDetail
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AdditionalRequestDetail.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.AdditionalRequestDetail(), k, value;
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    if (m.data === $util.emptyObject)
                        m.data = {};
                    var c2 = r.uint32() + r.pos;
                    k = "";
                    value = "";
                    while (r.pos < c2) {
                        var tag2 = r.uint32();
                        switch (tag2 >>> 3) {
                        case 1:
                            k = r.string();
                            break;
                        case 2:
                            value = r.string();
                            break;
                        default:
                            r.skipType(tag2 & 7);
                            break;
                        }
                    }
                    m.data[k] = value;
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return AdditionalRequestDetail;
    })();

    coreproductpb.CreateCoverageMatchingRequest = (function() {

        /**
         * Properties of a CreateCoverageMatchingRequest.
         * @memberof coreproductpb
         * @interface ICreateCoverageMatchingRequest
         * @property {string|null} [currentCoverageID] CreateCoverageMatchingRequest currentCoverageID
         * @property {string|null} [renewalCoverageID] CreateCoverageMatchingRequest renewalCoverageID
         */

        /**
         * Constructs a new CreateCoverageMatchingRequest.
         * @memberof coreproductpb
         * @classdesc Represents a CreateCoverageMatchingRequest.
         * @implements ICreateCoverageMatchingRequest
         * @constructor
         * @param {coreproductpb.ICreateCoverageMatchingRequest=} [p] Properties to set
         */
        function CreateCoverageMatchingRequest(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * CreateCoverageMatchingRequest currentCoverageID.
         * @member {string} currentCoverageID
         * @memberof coreproductpb.CreateCoverageMatchingRequest
         * @instance
         */
        CreateCoverageMatchingRequest.prototype.currentCoverageID = "";

        /**
         * CreateCoverageMatchingRequest renewalCoverageID.
         * @member {string} renewalCoverageID
         * @memberof coreproductpb.CreateCoverageMatchingRequest
         * @instance
         */
        CreateCoverageMatchingRequest.prototype.renewalCoverageID = "";

        /**
         * Creates a new CreateCoverageMatchingRequest instance using the specified properties.
         * @function create
         * @memberof coreproductpb.CreateCoverageMatchingRequest
         * @static
         * @param {coreproductpb.ICreateCoverageMatchingRequest=} [properties] Properties to set
         * @returns {coreproductpb.CreateCoverageMatchingRequest} CreateCoverageMatchingRequest instance
         */
        CreateCoverageMatchingRequest.create = function create(properties) {
            return new CreateCoverageMatchingRequest(properties);
        };

        /**
         * Encodes the specified CreateCoverageMatchingRequest message. Does not implicitly {@link coreproductpb.CreateCoverageMatchingRequest.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.CreateCoverageMatchingRequest
         * @static
         * @param {coreproductpb.ICreateCoverageMatchingRequest} m CreateCoverageMatchingRequest message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CreateCoverageMatchingRequest.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.currentCoverageID != null && Object.hasOwnProperty.call(m, "currentCoverageID"))
                w.uint32(10).string(m.currentCoverageID);
            if (m.renewalCoverageID != null && Object.hasOwnProperty.call(m, "renewalCoverageID"))
                w.uint32(18).string(m.renewalCoverageID);
            return w;
        };

        /**
         * Decodes a CreateCoverageMatchingRequest message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.CreateCoverageMatchingRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.CreateCoverageMatchingRequest} CreateCoverageMatchingRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CreateCoverageMatchingRequest.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.CreateCoverageMatchingRequest();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.currentCoverageID = r.string();
                    break;
                case 2:
                    m.renewalCoverageID = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return CreateCoverageMatchingRequest;
    })();

    coreproductpb.CreateCoverageMatchingResponse = (function() {

        /**
         * Properties of a CreateCoverageMatchingResponse.
         * @memberof coreproductpb
         * @interface ICreateCoverageMatchingResponse
         * @property {Array.<common.IError>|null} [errors] CreateCoverageMatchingResponse errors
         */

        /**
         * Constructs a new CreateCoverageMatchingResponse.
         * @memberof coreproductpb
         * @classdesc Represents a CreateCoverageMatchingResponse.
         * @implements ICreateCoverageMatchingResponse
         * @constructor
         * @param {coreproductpb.ICreateCoverageMatchingResponse=} [p] Properties to set
         */
        function CreateCoverageMatchingResponse(p) {
            this.errors = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * CreateCoverageMatchingResponse errors.
         * @member {Array.<common.IError>} errors
         * @memberof coreproductpb.CreateCoverageMatchingResponse
         * @instance
         */
        CreateCoverageMatchingResponse.prototype.errors = $util.emptyArray;

        /**
         * Creates a new CreateCoverageMatchingResponse instance using the specified properties.
         * @function create
         * @memberof coreproductpb.CreateCoverageMatchingResponse
         * @static
         * @param {coreproductpb.ICreateCoverageMatchingResponse=} [properties] Properties to set
         * @returns {coreproductpb.CreateCoverageMatchingResponse} CreateCoverageMatchingResponse instance
         */
        CreateCoverageMatchingResponse.create = function create(properties) {
            return new CreateCoverageMatchingResponse(properties);
        };

        /**
         * Encodes the specified CreateCoverageMatchingResponse message. Does not implicitly {@link coreproductpb.CreateCoverageMatchingResponse.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.CreateCoverageMatchingResponse
         * @static
         * @param {coreproductpb.ICreateCoverageMatchingResponse} m CreateCoverageMatchingResponse message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CreateCoverageMatchingResponse.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.errors != null && m.errors.length) {
                for (var i = 0; i < m.errors.length; ++i)
                    $root.common.Error.encode(m.errors[i], w.uint32(10).fork()).ldelim();
            }
            return w;
        };

        /**
         * Decodes a CreateCoverageMatchingResponse message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.CreateCoverageMatchingResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.CreateCoverageMatchingResponse} CreateCoverageMatchingResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CreateCoverageMatchingResponse.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.CreateCoverageMatchingResponse();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    if (!(m.errors && m.errors.length))
                        m.errors = [];
                    m.errors.push($root.common.Error.decode(r, r.uint32()));
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return CreateCoverageMatchingResponse;
    })();

    coreproductpb.GetAuditTrailRequest = (function() {

        /**
         * Properties of a GetAuditTrailRequest.
         * @memberof coreproductpb
         * @interface IGetAuditTrailRequest
         * @property {string|null} [documentID] GetAuditTrailRequest documentID
         * @property {coreproductpb.GetAuditTrailRequest.AuditTrailType|null} [type] GetAuditTrailRequest type
         * @property {common.IPaginationRequest|null} [pagination] GetAuditTrailRequest pagination
         */

        /**
         * Constructs a new GetAuditTrailRequest.
         * @memberof coreproductpb
         * @classdesc Represents a GetAuditTrailRequest.
         * @implements IGetAuditTrailRequest
         * @constructor
         * @param {coreproductpb.IGetAuditTrailRequest=} [p] Properties to set
         */
        function GetAuditTrailRequest(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * GetAuditTrailRequest documentID.
         * @member {string} documentID
         * @memberof coreproductpb.GetAuditTrailRequest
         * @instance
         */
        GetAuditTrailRequest.prototype.documentID = "";

        /**
         * GetAuditTrailRequest type.
         * @member {coreproductpb.GetAuditTrailRequest.AuditTrailType} type
         * @memberof coreproductpb.GetAuditTrailRequest
         * @instance
         */
        GetAuditTrailRequest.prototype.type = 0;

        /**
         * GetAuditTrailRequest pagination.
         * @member {common.IPaginationRequest|null|undefined} pagination
         * @memberof coreproductpb.GetAuditTrailRequest
         * @instance
         */
        GetAuditTrailRequest.prototype.pagination = null;

        /**
         * Creates a new GetAuditTrailRequest instance using the specified properties.
         * @function create
         * @memberof coreproductpb.GetAuditTrailRequest
         * @static
         * @param {coreproductpb.IGetAuditTrailRequest=} [properties] Properties to set
         * @returns {coreproductpb.GetAuditTrailRequest} GetAuditTrailRequest instance
         */
        GetAuditTrailRequest.create = function create(properties) {
            return new GetAuditTrailRequest(properties);
        };

        /**
         * Encodes the specified GetAuditTrailRequest message. Does not implicitly {@link coreproductpb.GetAuditTrailRequest.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.GetAuditTrailRequest
         * @static
         * @param {coreproductpb.IGetAuditTrailRequest} m GetAuditTrailRequest message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetAuditTrailRequest.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.documentID != null && Object.hasOwnProperty.call(m, "documentID"))
                w.uint32(10).string(m.documentID);
            if (m.type != null && Object.hasOwnProperty.call(m, "type"))
                w.uint32(16).int32(m.type);
            if (m.pagination != null && Object.hasOwnProperty.call(m, "pagination"))
                $root.common.PaginationRequest.encode(m.pagination, w.uint32(26).fork()).ldelim();
            return w;
        };

        /**
         * Decodes a GetAuditTrailRequest message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.GetAuditTrailRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.GetAuditTrailRequest} GetAuditTrailRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetAuditTrailRequest.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.GetAuditTrailRequest();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.documentID = r.string();
                    break;
                case 2:
                    m.type = r.int32();
                    break;
                case 3:
                    m.pagination = $root.common.PaginationRequest.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        /**
         * AuditTrailType enum.
         * @name coreproductpb.GetAuditTrailRequest.AuditTrailType
         * @enum {number}
         * @property {number} ATDT_UNDEFINED=0 ATDT_UNDEFINED value
         * @property {number} ATDT_PRODUCT_TEMPLATE=1 ATDT_PRODUCT_TEMPLATE value
         * @property {number} ATDT_PRODUCT_TEMPLATE_VERSION=2 ATDT_PRODUCT_TEMPLATE_VERSION value
         * @property {number} ATDT_COVERAGE=3 ATDT_COVERAGE value
         * @property {number} ATDT_PRODUCT_TYPE=4 ATDT_PRODUCT_TYPE value
         * @property {number} ATDT_ATTRIBUTES=5 ATDT_ATTRIBUTES value
         * @property {number} ATDT_GEOGRAPHIC_AVAILABILITY=6 ATDT_GEOGRAPHIC_AVAILABILITY value
         */
        GetAuditTrailRequest.AuditTrailType = (function() {
            const valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "ATDT_UNDEFINED"] = 0;
            values[valuesById[1] = "ATDT_PRODUCT_TEMPLATE"] = 1;
            values[valuesById[2] = "ATDT_PRODUCT_TEMPLATE_VERSION"] = 2;
            values[valuesById[3] = "ATDT_COVERAGE"] = 3;
            values[valuesById[4] = "ATDT_PRODUCT_TYPE"] = 4;
            values[valuesById[5] = "ATDT_ATTRIBUTES"] = 5;
            values[valuesById[6] = "ATDT_GEOGRAPHIC_AVAILABILITY"] = 6;
            return values;
        })();

        return GetAuditTrailRequest;
    })();

    coreproductpb.GetAuditTrailResponse = (function() {

        /**
         * Properties of a GetAuditTrailResponse.
         * @memberof coreproductpb
         * @interface IGetAuditTrailResponse
         * @property {Array.<coreproductpb.IAuditTrail>|null} [auditTrails] GetAuditTrailResponse auditTrails
         * @property {Array.<common.IError>|null} [errors] GetAuditTrailResponse errors
         * @property {common.IPagination|null} [pagination] GetAuditTrailResponse pagination
         */

        /**
         * Constructs a new GetAuditTrailResponse.
         * @memberof coreproductpb
         * @classdesc Represents a GetAuditTrailResponse.
         * @implements IGetAuditTrailResponse
         * @constructor
         * @param {coreproductpb.IGetAuditTrailResponse=} [p] Properties to set
         */
        function GetAuditTrailResponse(p) {
            this.auditTrails = [];
            this.errors = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * GetAuditTrailResponse auditTrails.
         * @member {Array.<coreproductpb.IAuditTrail>} auditTrails
         * @memberof coreproductpb.GetAuditTrailResponse
         * @instance
         */
        GetAuditTrailResponse.prototype.auditTrails = $util.emptyArray;

        /**
         * GetAuditTrailResponse errors.
         * @member {Array.<common.IError>} errors
         * @memberof coreproductpb.GetAuditTrailResponse
         * @instance
         */
        GetAuditTrailResponse.prototype.errors = $util.emptyArray;

        /**
         * GetAuditTrailResponse pagination.
         * @member {common.IPagination|null|undefined} pagination
         * @memberof coreproductpb.GetAuditTrailResponse
         * @instance
         */
        GetAuditTrailResponse.prototype.pagination = null;

        /**
         * Creates a new GetAuditTrailResponse instance using the specified properties.
         * @function create
         * @memberof coreproductpb.GetAuditTrailResponse
         * @static
         * @param {coreproductpb.IGetAuditTrailResponse=} [properties] Properties to set
         * @returns {coreproductpb.GetAuditTrailResponse} GetAuditTrailResponse instance
         */
        GetAuditTrailResponse.create = function create(properties) {
            return new GetAuditTrailResponse(properties);
        };

        /**
         * Encodes the specified GetAuditTrailResponse message. Does not implicitly {@link coreproductpb.GetAuditTrailResponse.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.GetAuditTrailResponse
         * @static
         * @param {coreproductpb.IGetAuditTrailResponse} m GetAuditTrailResponse message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetAuditTrailResponse.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.auditTrails != null && m.auditTrails.length) {
                for (var i = 0; i < m.auditTrails.length; ++i)
                    $root.coreproductpb.AuditTrail.encode(m.auditTrails[i], w.uint32(10).fork()).ldelim();
            }
            if (m.errors != null && m.errors.length) {
                for (var i = 0; i < m.errors.length; ++i)
                    $root.common.Error.encode(m.errors[i], w.uint32(18).fork()).ldelim();
            }
            if (m.pagination != null && Object.hasOwnProperty.call(m, "pagination"))
                $root.common.Pagination.encode(m.pagination, w.uint32(26).fork()).ldelim();
            return w;
        };

        /**
         * Decodes a GetAuditTrailResponse message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.GetAuditTrailResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.GetAuditTrailResponse} GetAuditTrailResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetAuditTrailResponse.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.GetAuditTrailResponse();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    if (!(m.auditTrails && m.auditTrails.length))
                        m.auditTrails = [];
                    m.auditTrails.push($root.coreproductpb.AuditTrail.decode(r, r.uint32()));
                    break;
                case 2:
                    if (!(m.errors && m.errors.length))
                        m.errors = [];
                    m.errors.push($root.common.Error.decode(r, r.uint32()));
                    break;
                case 3:
                    m.pagination = $root.common.Pagination.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return GetAuditTrailResponse;
    })();

    coreproductpb.AuditTrail = (function() {

        /**
         * Properties of an AuditTrail.
         * @memberof coreproductpb
         * @interface IAuditTrail
         * @property {google.protobuf.ITimestamp|null} [createdOn] AuditTrail createdOn
         * @property {string|null} [createdBy] AuditTrail createdBy
         * @property {Array.<coreproductpb.AuditTrail.IAuditTrailDetail>|null} [details] AuditTrail details
         */

        /**
         * Constructs a new AuditTrail.
         * @memberof coreproductpb
         * @classdesc Represents an AuditTrail.
         * @implements IAuditTrail
         * @constructor
         * @param {coreproductpb.IAuditTrail=} [p] Properties to set
         */
        function AuditTrail(p) {
            this.details = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * AuditTrail createdOn.
         * @member {google.protobuf.ITimestamp|null|undefined} createdOn
         * @memberof coreproductpb.AuditTrail
         * @instance
         */
        AuditTrail.prototype.createdOn = null;

        /**
         * AuditTrail createdBy.
         * @member {string} createdBy
         * @memberof coreproductpb.AuditTrail
         * @instance
         */
        AuditTrail.prototype.createdBy = "";

        /**
         * AuditTrail details.
         * @member {Array.<coreproductpb.AuditTrail.IAuditTrailDetail>} details
         * @memberof coreproductpb.AuditTrail
         * @instance
         */
        AuditTrail.prototype.details = $util.emptyArray;

        /**
         * Creates a new AuditTrail instance using the specified properties.
         * @function create
         * @memberof coreproductpb.AuditTrail
         * @static
         * @param {coreproductpb.IAuditTrail=} [properties] Properties to set
         * @returns {coreproductpb.AuditTrail} AuditTrail instance
         */
        AuditTrail.create = function create(properties) {
            return new AuditTrail(properties);
        };

        /**
         * Encodes the specified AuditTrail message. Does not implicitly {@link coreproductpb.AuditTrail.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.AuditTrail
         * @static
         * @param {coreproductpb.IAuditTrail} m AuditTrail message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AuditTrail.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.createdOn != null && Object.hasOwnProperty.call(m, "createdOn"))
                $root.google.protobuf.Timestamp.encode(m.createdOn, w.uint32(10).fork()).ldelim();
            if (m.createdBy != null && Object.hasOwnProperty.call(m, "createdBy"))
                w.uint32(18).string(m.createdBy);
            if (m.details != null && m.details.length) {
                for (var i = 0; i < m.details.length; ++i)
                    $root.coreproductpb.AuditTrail.AuditTrailDetail.encode(m.details[i], w.uint32(26).fork()).ldelim();
            }
            return w;
        };

        /**
         * Decodes an AuditTrail message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.AuditTrail
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.AuditTrail} AuditTrail
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AuditTrail.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.AuditTrail();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.createdOn = $root.google.protobuf.Timestamp.decode(r, r.uint32());
                    break;
                case 2:
                    m.createdBy = r.string();
                    break;
                case 3:
                    if (!(m.details && m.details.length))
                        m.details = [];
                    m.details.push($root.coreproductpb.AuditTrail.AuditTrailDetail.decode(r, r.uint32()));
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        AuditTrail.AuditTrailDetail = (function() {

            /**
             * Properties of an AuditTrailDetail.
             * @memberof coreproductpb.AuditTrail
             * @interface IAuditTrailDetail
             * @property {string|null} [type] AuditTrailDetail type
             * @property {Array.<string>|null} [breadcrumbs] AuditTrailDetail breadcrumbs
             * @property {Object.<string,string>|null} [metadata] AuditTrailDetail metadata
             * @property {Object.<string,string>|null} [old] AuditTrailDetail old
             * @property {Object.<string,string>|null} ["new"] AuditTrailDetail new
             */

            /**
             * Constructs a new AuditTrailDetail.
             * @memberof coreproductpb.AuditTrail
             * @classdesc Represents an AuditTrailDetail.
             * @implements IAuditTrailDetail
             * @constructor
             * @param {coreproductpb.AuditTrail.IAuditTrailDetail=} [p] Properties to set
             */
            function AuditTrailDetail(p) {
                this.breadcrumbs = [];
                this.metadata = {};
                this.old = {};
                this["new"] = {};
                if (p)
                    for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                        if (p[ks[i]] != null)
                            this[ks[i]] = p[ks[i]];
            }

            /**
             * AuditTrailDetail type.
             * @member {string} type
             * @memberof coreproductpb.AuditTrail.AuditTrailDetail
             * @instance
             */
            AuditTrailDetail.prototype.type = "";

            /**
             * AuditTrailDetail breadcrumbs.
             * @member {Array.<string>} breadcrumbs
             * @memberof coreproductpb.AuditTrail.AuditTrailDetail
             * @instance
             */
            AuditTrailDetail.prototype.breadcrumbs = $util.emptyArray;

            /**
             * AuditTrailDetail metadata.
             * @member {Object.<string,string>} metadata
             * @memberof coreproductpb.AuditTrail.AuditTrailDetail
             * @instance
             */
            AuditTrailDetail.prototype.metadata = $util.emptyObject;

            /**
             * AuditTrailDetail old.
             * @member {Object.<string,string>} old
             * @memberof coreproductpb.AuditTrail.AuditTrailDetail
             * @instance
             */
            AuditTrailDetail.prototype.old = $util.emptyObject;

            /**
             * AuditTrailDetail new.
             * @member {Object.<string,string>} new
             * @memberof coreproductpb.AuditTrail.AuditTrailDetail
             * @instance
             */
            AuditTrailDetail.prototype["new"] = $util.emptyObject;

            /**
             * Creates a new AuditTrailDetail instance using the specified properties.
             * @function create
             * @memberof coreproductpb.AuditTrail.AuditTrailDetail
             * @static
             * @param {coreproductpb.AuditTrail.IAuditTrailDetail=} [properties] Properties to set
             * @returns {coreproductpb.AuditTrail.AuditTrailDetail} AuditTrailDetail instance
             */
            AuditTrailDetail.create = function create(properties) {
                return new AuditTrailDetail(properties);
            };

            /**
             * Encodes the specified AuditTrailDetail message. Does not implicitly {@link coreproductpb.AuditTrail.AuditTrailDetail.verify|verify} messages.
             * @function encode
             * @memberof coreproductpb.AuditTrail.AuditTrailDetail
             * @static
             * @param {coreproductpb.AuditTrail.IAuditTrailDetail} m AuditTrailDetail message or plain object to encode
             * @param {$protobuf.Writer} [w] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            AuditTrailDetail.encode = function encode(m, w) {
                if (!w)
                    w = $Writer.create();
                if (m.type != null && Object.hasOwnProperty.call(m, "type"))
                    w.uint32(10).string(m.type);
                if (m.breadcrumbs != null && m.breadcrumbs.length) {
                    for (var i = 0; i < m.breadcrumbs.length; ++i)
                        w.uint32(18).string(m.breadcrumbs[i]);
                }
                if (m.metadata != null && Object.hasOwnProperty.call(m, "metadata")) {
                    for (var ks = Object.keys(m.metadata), i = 0; i < ks.length; ++i) {
                        w.uint32(26).fork().uint32(10).string(ks[i]).uint32(18).string(m.metadata[ks[i]]).ldelim();
                    }
                }
                if (m.old != null && Object.hasOwnProperty.call(m, "old")) {
                    for (var ks = Object.keys(m.old), i = 0; i < ks.length; ++i) {
                        w.uint32(34).fork().uint32(10).string(ks[i]).uint32(18).string(m.old[ks[i]]).ldelim();
                    }
                }
                if (m["new"] != null && Object.hasOwnProperty.call(m, "new")) {
                    for (var ks = Object.keys(m["new"]), i = 0; i < ks.length; ++i) {
                        w.uint32(42).fork().uint32(10).string(ks[i]).uint32(18).string(m["new"][ks[i]]).ldelim();
                    }
                }
                return w;
            };

            /**
             * Decodes an AuditTrailDetail message from the specified reader or buffer.
             * @function decode
             * @memberof coreproductpb.AuditTrail.AuditTrailDetail
             * @static
             * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
             * @param {number} [l] Message length if known beforehand
             * @returns {coreproductpb.AuditTrail.AuditTrailDetail} AuditTrailDetail
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            AuditTrailDetail.decode = function decode(r, l) {
                if (!(r instanceof $Reader))
                    r = $Reader.create(r);
                var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.AuditTrail.AuditTrailDetail(), k, value;
                while (r.pos < c) {
                    var t = r.uint32();
                    switch (t >>> 3) {
                    case 1:
                        m.type = r.string();
                        break;
                    case 2:
                        if (!(m.breadcrumbs && m.breadcrumbs.length))
                            m.breadcrumbs = [];
                        m.breadcrumbs.push(r.string());
                        break;
                    case 3:
                        if (m.metadata === $util.emptyObject)
                            m.metadata = {};
                        var c2 = r.uint32() + r.pos;
                        k = "";
                        value = "";
                        while (r.pos < c2) {
                            var tag2 = r.uint32();
                            switch (tag2 >>> 3) {
                            case 1:
                                k = r.string();
                                break;
                            case 2:
                                value = r.string();
                                break;
                            default:
                                r.skipType(tag2 & 7);
                                break;
                            }
                        }
                        m.metadata[k] = value;
                        break;
                    case 4:
                        if (m.old === $util.emptyObject)
                            m.old = {};
                        var c2 = r.uint32() + r.pos;
                        k = "";
                        value = "";
                        while (r.pos < c2) {
                            var tag2 = r.uint32();
                            switch (tag2 >>> 3) {
                            case 1:
                                k = r.string();
                                break;
                            case 2:
                                value = r.string();
                                break;
                            default:
                                r.skipType(tag2 & 7);
                                break;
                            }
                        }
                        m.old[k] = value;
                        break;
                    case 5:
                        if (m["new"] === $util.emptyObject)
                            m["new"] = {};
                        var c2 = r.uint32() + r.pos;
                        k = "";
                        value = "";
                        while (r.pos < c2) {
                            var tag2 = r.uint32();
                            switch (tag2 >>> 3) {
                            case 1:
                                k = r.string();
                                break;
                            case 2:
                                value = r.string();
                                break;
                            default:
                                r.skipType(tag2 & 7);
                                break;
                            }
                        }
                        m["new"][k] = value;
                        break;
                    default:
                        r.skipType(t & 7);
                        break;
                    }
                }
                return m;
            };

            return AuditTrailDetail;
        })();

        return AuditTrail;
    })();

    coreproductpb.DeleteCoverageMatchingRequest = (function() {

        /**
         * Properties of a DeleteCoverageMatchingRequest.
         * @memberof coreproductpb
         * @interface IDeleteCoverageMatchingRequest
         * @property {string|null} [currentCoverageID] DeleteCoverageMatchingRequest currentCoverageID
         * @property {string|null} [renewalCoverageID] DeleteCoverageMatchingRequest renewalCoverageID
         */

        /**
         * Constructs a new DeleteCoverageMatchingRequest.
         * @memberof coreproductpb
         * @classdesc Represents a DeleteCoverageMatchingRequest.
         * @implements IDeleteCoverageMatchingRequest
         * @constructor
         * @param {coreproductpb.IDeleteCoverageMatchingRequest=} [p] Properties to set
         */
        function DeleteCoverageMatchingRequest(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * DeleteCoverageMatchingRequest currentCoverageID.
         * @member {string} currentCoverageID
         * @memberof coreproductpb.DeleteCoverageMatchingRequest
         * @instance
         */
        DeleteCoverageMatchingRequest.prototype.currentCoverageID = "";

        /**
         * DeleteCoverageMatchingRequest renewalCoverageID.
         * @member {string} renewalCoverageID
         * @memberof coreproductpb.DeleteCoverageMatchingRequest
         * @instance
         */
        DeleteCoverageMatchingRequest.prototype.renewalCoverageID = "";

        /**
         * Creates a new DeleteCoverageMatchingRequest instance using the specified properties.
         * @function create
         * @memberof coreproductpb.DeleteCoverageMatchingRequest
         * @static
         * @param {coreproductpb.IDeleteCoverageMatchingRequest=} [properties] Properties to set
         * @returns {coreproductpb.DeleteCoverageMatchingRequest} DeleteCoverageMatchingRequest instance
         */
        DeleteCoverageMatchingRequest.create = function create(properties) {
            return new DeleteCoverageMatchingRequest(properties);
        };

        /**
         * Encodes the specified DeleteCoverageMatchingRequest message. Does not implicitly {@link coreproductpb.DeleteCoverageMatchingRequest.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.DeleteCoverageMatchingRequest
         * @static
         * @param {coreproductpb.IDeleteCoverageMatchingRequest} m DeleteCoverageMatchingRequest message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        DeleteCoverageMatchingRequest.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.currentCoverageID != null && Object.hasOwnProperty.call(m, "currentCoverageID"))
                w.uint32(10).string(m.currentCoverageID);
            if (m.renewalCoverageID != null && Object.hasOwnProperty.call(m, "renewalCoverageID"))
                w.uint32(18).string(m.renewalCoverageID);
            return w;
        };

        /**
         * Decodes a DeleteCoverageMatchingRequest message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.DeleteCoverageMatchingRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.DeleteCoverageMatchingRequest} DeleteCoverageMatchingRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        DeleteCoverageMatchingRequest.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.DeleteCoverageMatchingRequest();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.currentCoverageID = r.string();
                    break;
                case 2:
                    m.renewalCoverageID = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return DeleteCoverageMatchingRequest;
    })();

    coreproductpb.DeleteCoverageMatchingResponse = (function() {

        /**
         * Properties of a DeleteCoverageMatchingResponse.
         * @memberof coreproductpb
         * @interface IDeleteCoverageMatchingResponse
         * @property {Array.<common.IError>|null} [errors] DeleteCoverageMatchingResponse errors
         */

        /**
         * Constructs a new DeleteCoverageMatchingResponse.
         * @memberof coreproductpb
         * @classdesc Represents a DeleteCoverageMatchingResponse.
         * @implements IDeleteCoverageMatchingResponse
         * @constructor
         * @param {coreproductpb.IDeleteCoverageMatchingResponse=} [p] Properties to set
         */
        function DeleteCoverageMatchingResponse(p) {
            this.errors = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * DeleteCoverageMatchingResponse errors.
         * @member {Array.<common.IError>} errors
         * @memberof coreproductpb.DeleteCoverageMatchingResponse
         * @instance
         */
        DeleteCoverageMatchingResponse.prototype.errors = $util.emptyArray;

        /**
         * Creates a new DeleteCoverageMatchingResponse instance using the specified properties.
         * @function create
         * @memberof coreproductpb.DeleteCoverageMatchingResponse
         * @static
         * @param {coreproductpb.IDeleteCoverageMatchingResponse=} [properties] Properties to set
         * @returns {coreproductpb.DeleteCoverageMatchingResponse} DeleteCoverageMatchingResponse instance
         */
        DeleteCoverageMatchingResponse.create = function create(properties) {
            return new DeleteCoverageMatchingResponse(properties);
        };

        /**
         * Encodes the specified DeleteCoverageMatchingResponse message. Does not implicitly {@link coreproductpb.DeleteCoverageMatchingResponse.verify|verify} messages.
         * @function encode
         * @memberof coreproductpb.DeleteCoverageMatchingResponse
         * @static
         * @param {coreproductpb.IDeleteCoverageMatchingResponse} m DeleteCoverageMatchingResponse message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        DeleteCoverageMatchingResponse.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.errors != null && m.errors.length) {
                for (var i = 0; i < m.errors.length; ++i)
                    $root.common.Error.encode(m.errors[i], w.uint32(10).fork()).ldelim();
            }
            return w;
        };

        /**
         * Decodes a DeleteCoverageMatchingResponse message from the specified reader or buffer.
         * @function decode
         * @memberof coreproductpb.DeleteCoverageMatchingResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {coreproductpb.DeleteCoverageMatchingResponse} DeleteCoverageMatchingResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        DeleteCoverageMatchingResponse.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.coreproductpb.DeleteCoverageMatchingResponse();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    if (!(m.errors && m.errors.length))
                        m.errors = [];
                    m.errors.push($root.common.Error.decode(r, r.uint32()));
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return DeleteCoverageMatchingResponse;
    })();

    return coreproductpb;
})();

export const orderspb = $root.orderspb = (() => {

    /**
     * Namespace orderspb.
     * @exports orderspb
     * @namespace
     */
    const orderspb = {};

    orderspb.HelloToRequest = (function() {

        /**
         * Properties of a HelloToRequest.
         * @memberof orderspb
         * @interface IHelloToRequest
         * @property {string|null} [guestName] HelloToRequest guestName
         */

        /**
         * Constructs a new HelloToRequest.
         * @memberof orderspb
         * @classdesc Represents a HelloToRequest.
         * @implements IHelloToRequest
         * @constructor
         * @param {orderspb.IHelloToRequest=} [p] Properties to set
         */
        function HelloToRequest(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * HelloToRequest guestName.
         * @member {string} guestName
         * @memberof orderspb.HelloToRequest
         * @instance
         */
        HelloToRequest.prototype.guestName = "";

        /**
         * Creates a new HelloToRequest instance using the specified properties.
         * @function create
         * @memberof orderspb.HelloToRequest
         * @static
         * @param {orderspb.IHelloToRequest=} [properties] Properties to set
         * @returns {orderspb.HelloToRequest} HelloToRequest instance
         */
        HelloToRequest.create = function create(properties) {
            return new HelloToRequest(properties);
        };

        /**
         * Encodes the specified HelloToRequest message. Does not implicitly {@link orderspb.HelloToRequest.verify|verify} messages.
         * @function encode
         * @memberof orderspb.HelloToRequest
         * @static
         * @param {orderspb.IHelloToRequest} m HelloToRequest message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        HelloToRequest.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.guestName != null && Object.hasOwnProperty.call(m, "guestName"))
                w.uint32(10).string(m.guestName);
            return w;
        };

        /**
         * Decodes a HelloToRequest message from the specified reader or buffer.
         * @function decode
         * @memberof orderspb.HelloToRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {orderspb.HelloToRequest} HelloToRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        HelloToRequest.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.orderspb.HelloToRequest();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.guestName = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return HelloToRequest;
    })();

    orderspb.HelloResponse = (function() {

        /**
         * Properties of a HelloResponse.
         * @memberof orderspb
         * @interface IHelloResponse
         * @property {string|null} [greeting] HelloResponse greeting
         */

        /**
         * Constructs a new HelloResponse.
         * @memberof orderspb
         * @classdesc Represents a HelloResponse.
         * @implements IHelloResponse
         * @constructor
         * @param {orderspb.IHelloResponse=} [p] Properties to set
         */
        function HelloResponse(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * HelloResponse greeting.
         * @member {string} greeting
         * @memberof orderspb.HelloResponse
         * @instance
         */
        HelloResponse.prototype.greeting = "";

        /**
         * Creates a new HelloResponse instance using the specified properties.
         * @function create
         * @memberof orderspb.HelloResponse
         * @static
         * @param {orderspb.IHelloResponse=} [properties] Properties to set
         * @returns {orderspb.HelloResponse} HelloResponse instance
         */
        HelloResponse.create = function create(properties) {
            return new HelloResponse(properties);
        };

        /**
         * Encodes the specified HelloResponse message. Does not implicitly {@link orderspb.HelloResponse.verify|verify} messages.
         * @function encode
         * @memberof orderspb.HelloResponse
         * @static
         * @param {orderspb.IHelloResponse} m HelloResponse message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        HelloResponse.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.greeting != null && Object.hasOwnProperty.call(m, "greeting"))
                w.uint32(10).string(m.greeting);
            return w;
        };

        /**
         * Decodes a HelloResponse message from the specified reader or buffer.
         * @function decode
         * @memberof orderspb.HelloResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {orderspb.HelloResponse} HelloResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        HelloResponse.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.orderspb.HelloResponse();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.greeting = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return HelloResponse;
    })();

    orderspb.HealthCheckDetail = (function() {

        /**
         * Properties of a HealthCheckDetail.
         * @memberof orderspb
         * @interface IHealthCheckDetail
         * @property {string|null} [componentID] HealthCheckDetail componentID
         * @property {string|null} [type] HealthCheckDetail type
         * @property {number|null} [observedValue] HealthCheckDetail observedValue
         * @property {string|null} [observedUnit] HealthCheckDetail observedUnit
         * @property {string|null} [status] HealthCheckDetail status
         * @property {google.protobuf.ITimestamp|null} [time] HealthCheckDetail time
         * @property {string|null} [output] HealthCheckDetail output
         */

        /**
         * Constructs a new HealthCheckDetail.
         * @memberof orderspb
         * @classdesc Represents a HealthCheckDetail.
         * @implements IHealthCheckDetail
         * @constructor
         * @param {orderspb.IHealthCheckDetail=} [p] Properties to set
         */
        function HealthCheckDetail(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * HealthCheckDetail componentID.
         * @member {string} componentID
         * @memberof orderspb.HealthCheckDetail
         * @instance
         */
        HealthCheckDetail.prototype.componentID = "";

        /**
         * HealthCheckDetail type.
         * @member {string} type
         * @memberof orderspb.HealthCheckDetail
         * @instance
         */
        HealthCheckDetail.prototype.type = "";

        /**
         * HealthCheckDetail observedValue.
         * @member {number} observedValue
         * @memberof orderspb.HealthCheckDetail
         * @instance
         */
        HealthCheckDetail.prototype.observedValue = 0;

        /**
         * HealthCheckDetail observedUnit.
         * @member {string} observedUnit
         * @memberof orderspb.HealthCheckDetail
         * @instance
         */
        HealthCheckDetail.prototype.observedUnit = "";

        /**
         * HealthCheckDetail status.
         * @member {string} status
         * @memberof orderspb.HealthCheckDetail
         * @instance
         */
        HealthCheckDetail.prototype.status = "";

        /**
         * HealthCheckDetail time.
         * @member {google.protobuf.ITimestamp|null|undefined} time
         * @memberof orderspb.HealthCheckDetail
         * @instance
         */
        HealthCheckDetail.prototype.time = null;

        /**
         * HealthCheckDetail output.
         * @member {string} output
         * @memberof orderspb.HealthCheckDetail
         * @instance
         */
        HealthCheckDetail.prototype.output = "";

        /**
         * Creates a new HealthCheckDetail instance using the specified properties.
         * @function create
         * @memberof orderspb.HealthCheckDetail
         * @static
         * @param {orderspb.IHealthCheckDetail=} [properties] Properties to set
         * @returns {orderspb.HealthCheckDetail} HealthCheckDetail instance
         */
        HealthCheckDetail.create = function create(properties) {
            return new HealthCheckDetail(properties);
        };

        /**
         * Encodes the specified HealthCheckDetail message. Does not implicitly {@link orderspb.HealthCheckDetail.verify|verify} messages.
         * @function encode
         * @memberof orderspb.HealthCheckDetail
         * @static
         * @param {orderspb.IHealthCheckDetail} m HealthCheckDetail message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        HealthCheckDetail.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.componentID != null && Object.hasOwnProperty.call(m, "componentID"))
                w.uint32(10).string(m.componentID);
            if (m.type != null && Object.hasOwnProperty.call(m, "type"))
                w.uint32(18).string(m.type);
            if (m.observedValue != null && Object.hasOwnProperty.call(m, "observedValue"))
                w.uint32(25).double(m.observedValue);
            if (m.observedUnit != null && Object.hasOwnProperty.call(m, "observedUnit"))
                w.uint32(34).string(m.observedUnit);
            if (m.status != null && Object.hasOwnProperty.call(m, "status"))
                w.uint32(42).string(m.status);
            if (m.time != null && Object.hasOwnProperty.call(m, "time"))
                $root.google.protobuf.Timestamp.encode(m.time, w.uint32(50).fork()).ldelim();
            if (m.output != null && Object.hasOwnProperty.call(m, "output"))
                w.uint32(58).string(m.output);
            return w;
        };

        /**
         * Decodes a HealthCheckDetail message from the specified reader or buffer.
         * @function decode
         * @memberof orderspb.HealthCheckDetail
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {orderspb.HealthCheckDetail} HealthCheckDetail
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        HealthCheckDetail.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.orderspb.HealthCheckDetail();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.componentID = r.string();
                    break;
                case 2:
                    m.type = r.string();
                    break;
                case 3:
                    m.observedValue = r.double();
                    break;
                case 4:
                    m.observedUnit = r.string();
                    break;
                case 5:
                    m.status = r.string();
                    break;
                case 6:
                    m.time = $root.google.protobuf.Timestamp.decode(r, r.uint32());
                    break;
                case 7:
                    m.output = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return HealthCheckDetail;
    })();

    orderspb.NamedHealthCheckDetail = (function() {

        /**
         * Properties of a NamedHealthCheckDetail.
         * @memberof orderspb
         * @interface INamedHealthCheckDetail
         * @property {string|null} [name] NamedHealthCheckDetail name
         * @property {Array.<orderspb.IHealthCheckDetail>|null} [details] NamedHealthCheckDetail details
         */

        /**
         * Constructs a new NamedHealthCheckDetail.
         * @memberof orderspb
         * @classdesc Represents a NamedHealthCheckDetail.
         * @implements INamedHealthCheckDetail
         * @constructor
         * @param {orderspb.INamedHealthCheckDetail=} [p] Properties to set
         */
        function NamedHealthCheckDetail(p) {
            this.details = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * NamedHealthCheckDetail name.
         * @member {string} name
         * @memberof orderspb.NamedHealthCheckDetail
         * @instance
         */
        NamedHealthCheckDetail.prototype.name = "";

        /**
         * NamedHealthCheckDetail details.
         * @member {Array.<orderspb.IHealthCheckDetail>} details
         * @memberof orderspb.NamedHealthCheckDetail
         * @instance
         */
        NamedHealthCheckDetail.prototype.details = $util.emptyArray;

        /**
         * Creates a new NamedHealthCheckDetail instance using the specified properties.
         * @function create
         * @memberof orderspb.NamedHealthCheckDetail
         * @static
         * @param {orderspb.INamedHealthCheckDetail=} [properties] Properties to set
         * @returns {orderspb.NamedHealthCheckDetail} NamedHealthCheckDetail instance
         */
        NamedHealthCheckDetail.create = function create(properties) {
            return new NamedHealthCheckDetail(properties);
        };

        /**
         * Encodes the specified NamedHealthCheckDetail message. Does not implicitly {@link orderspb.NamedHealthCheckDetail.verify|verify} messages.
         * @function encode
         * @memberof orderspb.NamedHealthCheckDetail
         * @static
         * @param {orderspb.INamedHealthCheckDetail} m NamedHealthCheckDetail message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        NamedHealthCheckDetail.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.name != null && Object.hasOwnProperty.call(m, "name"))
                w.uint32(10).string(m.name);
            if (m.details != null && m.details.length) {
                for (var i = 0; i < m.details.length; ++i)
                    $root.orderspb.HealthCheckDetail.encode(m.details[i], w.uint32(18).fork()).ldelim();
            }
            return w;
        };

        /**
         * Decodes a NamedHealthCheckDetail message from the specified reader or buffer.
         * @function decode
         * @memberof orderspb.NamedHealthCheckDetail
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {orderspb.NamedHealthCheckDetail} NamedHealthCheckDetail
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        NamedHealthCheckDetail.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.orderspb.NamedHealthCheckDetail();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.name = r.string();
                    break;
                case 2:
                    if (!(m.details && m.details.length))
                        m.details = [];
                    m.details.push($root.orderspb.HealthCheckDetail.decode(r, r.uint32()));
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return NamedHealthCheckDetail;
    })();

    orderspb.HealthCheck = (function() {

        /**
         * Properties of a HealthCheck.
         * @memberof orderspb
         * @interface IHealthCheck
         * @property {string|null} [status] HealthCheck status
         * @property {string|null} [version] HealthCheck version
         * @property {string|null} [releaseID] HealthCheck releaseID
         * @property {Array.<string>|null} [notes] HealthCheck notes
         * @property {string|null} [output] HealthCheck output
         * @property {Array.<orderspb.INamedHealthCheckDetail>|null} [details] HealthCheck details
         */

        /**
         * Constructs a new HealthCheck.
         * @memberof orderspb
         * @classdesc Represents a HealthCheck.
         * @implements IHealthCheck
         * @constructor
         * @param {orderspb.IHealthCheck=} [p] Properties to set
         */
        function HealthCheck(p) {
            this.notes = [];
            this.details = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * HealthCheck status.
         * @member {string} status
         * @memberof orderspb.HealthCheck
         * @instance
         */
        HealthCheck.prototype.status = "";

        /**
         * HealthCheck version.
         * @member {string} version
         * @memberof orderspb.HealthCheck
         * @instance
         */
        HealthCheck.prototype.version = "";

        /**
         * HealthCheck releaseID.
         * @member {string} releaseID
         * @memberof orderspb.HealthCheck
         * @instance
         */
        HealthCheck.prototype.releaseID = "";

        /**
         * HealthCheck notes.
         * @member {Array.<string>} notes
         * @memberof orderspb.HealthCheck
         * @instance
         */
        HealthCheck.prototype.notes = $util.emptyArray;

        /**
         * HealthCheck output.
         * @member {string} output
         * @memberof orderspb.HealthCheck
         * @instance
         */
        HealthCheck.prototype.output = "";

        /**
         * HealthCheck details.
         * @member {Array.<orderspb.INamedHealthCheckDetail>} details
         * @memberof orderspb.HealthCheck
         * @instance
         */
        HealthCheck.prototype.details = $util.emptyArray;

        /**
         * Creates a new HealthCheck instance using the specified properties.
         * @function create
         * @memberof orderspb.HealthCheck
         * @static
         * @param {orderspb.IHealthCheck=} [properties] Properties to set
         * @returns {orderspb.HealthCheck} HealthCheck instance
         */
        HealthCheck.create = function create(properties) {
            return new HealthCheck(properties);
        };

        /**
         * Encodes the specified HealthCheck message. Does not implicitly {@link orderspb.HealthCheck.verify|verify} messages.
         * @function encode
         * @memberof orderspb.HealthCheck
         * @static
         * @param {orderspb.IHealthCheck} m HealthCheck message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        HealthCheck.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.status != null && Object.hasOwnProperty.call(m, "status"))
                w.uint32(10).string(m.status);
            if (m.version != null && Object.hasOwnProperty.call(m, "version"))
                w.uint32(18).string(m.version);
            if (m.releaseID != null && Object.hasOwnProperty.call(m, "releaseID"))
                w.uint32(26).string(m.releaseID);
            if (m.notes != null && m.notes.length) {
                for (var i = 0; i < m.notes.length; ++i)
                    w.uint32(34).string(m.notes[i]);
            }
            if (m.output != null && Object.hasOwnProperty.call(m, "output"))
                w.uint32(42).string(m.output);
            if (m.details != null && m.details.length) {
                for (var i = 0; i < m.details.length; ++i)
                    $root.orderspb.NamedHealthCheckDetail.encode(m.details[i], w.uint32(50).fork()).ldelim();
            }
            return w;
        };

        /**
         * Decodes a HealthCheck message from the specified reader or buffer.
         * @function decode
         * @memberof orderspb.HealthCheck
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {orderspb.HealthCheck} HealthCheck
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        HealthCheck.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.orderspb.HealthCheck();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.status = r.string();
                    break;
                case 2:
                    m.version = r.string();
                    break;
                case 3:
                    m.releaseID = r.string();
                    break;
                case 4:
                    if (!(m.notes && m.notes.length))
                        m.notes = [];
                    m.notes.push(r.string());
                    break;
                case 5:
                    m.output = r.string();
                    break;
                case 6:
                    if (!(m.details && m.details.length))
                        m.details = [];
                    m.details.push($root.orderspb.NamedHealthCheckDetail.decode(r, r.uint32()));
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return HealthCheck;
    })();

    orderspb.HealthCheckResponse = (function() {

        /**
         * Properties of a HealthCheckResponse.
         * @memberof orderspb
         * @interface IHealthCheckResponse
         * @property {orderspb.IHealthCheck|null} [health] HealthCheckResponse health
         */

        /**
         * Constructs a new HealthCheckResponse.
         * @memberof orderspb
         * @classdesc Represents a HealthCheckResponse.
         * @implements IHealthCheckResponse
         * @constructor
         * @param {orderspb.IHealthCheckResponse=} [p] Properties to set
         */
        function HealthCheckResponse(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * HealthCheckResponse health.
         * @member {orderspb.IHealthCheck|null|undefined} health
         * @memberof orderspb.HealthCheckResponse
         * @instance
         */
        HealthCheckResponse.prototype.health = null;

        /**
         * Creates a new HealthCheckResponse instance using the specified properties.
         * @function create
         * @memberof orderspb.HealthCheckResponse
         * @static
         * @param {orderspb.IHealthCheckResponse=} [properties] Properties to set
         * @returns {orderspb.HealthCheckResponse} HealthCheckResponse instance
         */
        HealthCheckResponse.create = function create(properties) {
            return new HealthCheckResponse(properties);
        };

        /**
         * Encodes the specified HealthCheckResponse message. Does not implicitly {@link orderspb.HealthCheckResponse.verify|verify} messages.
         * @function encode
         * @memberof orderspb.HealthCheckResponse
         * @static
         * @param {orderspb.IHealthCheckResponse} m HealthCheckResponse message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        HealthCheckResponse.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.health != null && Object.hasOwnProperty.call(m, "health"))
                $root.orderspb.HealthCheck.encode(m.health, w.uint32(10).fork()).ldelim();
            return w;
        };

        /**
         * Decodes a HealthCheckResponse message from the specified reader or buffer.
         * @function decode
         * @memberof orderspb.HealthCheckResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {orderspb.HealthCheckResponse} HealthCheckResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        HealthCheckResponse.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.orderspb.HealthCheckResponse();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.health = $root.orderspb.HealthCheck.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return HealthCheckResponse;
    })();

    orderspb.RequestValidationErrorResponse = (function() {

        /**
         * Properties of a RequestValidationErrorResponse.
         * @memberof orderspb
         * @interface IRequestValidationErrorResponse
         * @property {Array.<string>|null} [errors] RequestValidationErrorResponse errors
         */

        /**
         * Constructs a new RequestValidationErrorResponse.
         * @memberof orderspb
         * @classdesc Represents a RequestValidationErrorResponse.
         * @implements IRequestValidationErrorResponse
         * @constructor
         * @param {orderspb.IRequestValidationErrorResponse=} [p] Properties to set
         */
        function RequestValidationErrorResponse(p) {
            this.errors = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * RequestValidationErrorResponse errors.
         * @member {Array.<string>} errors
         * @memberof orderspb.RequestValidationErrorResponse
         * @instance
         */
        RequestValidationErrorResponse.prototype.errors = $util.emptyArray;

        /**
         * Creates a new RequestValidationErrorResponse instance using the specified properties.
         * @function create
         * @memberof orderspb.RequestValidationErrorResponse
         * @static
         * @param {orderspb.IRequestValidationErrorResponse=} [properties] Properties to set
         * @returns {orderspb.RequestValidationErrorResponse} RequestValidationErrorResponse instance
         */
        RequestValidationErrorResponse.create = function create(properties) {
            return new RequestValidationErrorResponse(properties);
        };

        /**
         * Encodes the specified RequestValidationErrorResponse message. Does not implicitly {@link orderspb.RequestValidationErrorResponse.verify|verify} messages.
         * @function encode
         * @memberof orderspb.RequestValidationErrorResponse
         * @static
         * @param {orderspb.IRequestValidationErrorResponse} m RequestValidationErrorResponse message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RequestValidationErrorResponse.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.errors != null && m.errors.length) {
                for (var i = 0; i < m.errors.length; ++i)
                    w.uint32(10).string(m.errors[i]);
            }
            return w;
        };

        /**
         * Decodes a RequestValidationErrorResponse message from the specified reader or buffer.
         * @function decode
         * @memberof orderspb.RequestValidationErrorResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {orderspb.RequestValidationErrorResponse} RequestValidationErrorResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RequestValidationErrorResponse.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.orderspb.RequestValidationErrorResponse();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    if (!(m.errors && m.errors.length))
                        m.errors = [];
                    m.errors.push(r.string());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return RequestValidationErrorResponse;
    })();

    orderspb.GiftClaimRequest = (function() {

        /**
         * Properties of a GiftClaimRequest.
         * @memberof orderspb
         * @interface IGiftClaimRequest
         * @property {string|null} [contractID] GiftClaimRequest contractID
         * @property {string|null} [email] GiftClaimRequest email
         */

        /**
         * Constructs a new GiftClaimRequest.
         * @memberof orderspb
         * @classdesc Represents a GiftClaimRequest.
         * @implements IGiftClaimRequest
         * @constructor
         * @param {orderspb.IGiftClaimRequest=} [p] Properties to set
         */
        function GiftClaimRequest(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * GiftClaimRequest contractID.
         * @member {string} contractID
         * @memberof orderspb.GiftClaimRequest
         * @instance
         */
        GiftClaimRequest.prototype.contractID = "";

        /**
         * GiftClaimRequest email.
         * @member {string} email
         * @memberof orderspb.GiftClaimRequest
         * @instance
         */
        GiftClaimRequest.prototype.email = "";

        /**
         * Creates a new GiftClaimRequest instance using the specified properties.
         * @function create
         * @memberof orderspb.GiftClaimRequest
         * @static
         * @param {orderspb.IGiftClaimRequest=} [properties] Properties to set
         * @returns {orderspb.GiftClaimRequest} GiftClaimRequest instance
         */
        GiftClaimRequest.create = function create(properties) {
            return new GiftClaimRequest(properties);
        };

        /**
         * Encodes the specified GiftClaimRequest message. Does not implicitly {@link orderspb.GiftClaimRequest.verify|verify} messages.
         * @function encode
         * @memberof orderspb.GiftClaimRequest
         * @static
         * @param {orderspb.IGiftClaimRequest} m GiftClaimRequest message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GiftClaimRequest.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.contractID != null && Object.hasOwnProperty.call(m, "contractID"))
                w.uint32(10).string(m.contractID);
            if (m.email != null && Object.hasOwnProperty.call(m, "email"))
                w.uint32(18).string(m.email);
            return w;
        };

        /**
         * Decodes a GiftClaimRequest message from the specified reader or buffer.
         * @function decode
         * @memberof orderspb.GiftClaimRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {orderspb.GiftClaimRequest} GiftClaimRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GiftClaimRequest.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.orderspb.GiftClaimRequest();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.contractID = r.string();
                    break;
                case 2:
                    m.email = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return GiftClaimRequest;
    })();

    orderspb.GiftClaimResponse = (function() {

        /**
         * Properties of a GiftClaimResponse.
         * @memberof orderspb
         * @interface IGiftClaimResponse
         * @property {boolean|null} [isGift] GiftClaimResponse isGift
         * @property {boolean|null} [isClaimed] GiftClaimResponse isClaimed
         * @property {string|null} [claimGiftURL] GiftClaimResponse claimGiftURL
         */

        /**
         * Constructs a new GiftClaimResponse.
         * @memberof orderspb
         * @classdesc Represents a GiftClaimResponse.
         * @implements IGiftClaimResponse
         * @constructor
         * @param {orderspb.IGiftClaimResponse=} [p] Properties to set
         */
        function GiftClaimResponse(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * GiftClaimResponse isGift.
         * @member {boolean} isGift
         * @memberof orderspb.GiftClaimResponse
         * @instance
         */
        GiftClaimResponse.prototype.isGift = false;

        /**
         * GiftClaimResponse isClaimed.
         * @member {boolean} isClaimed
         * @memberof orderspb.GiftClaimResponse
         * @instance
         */
        GiftClaimResponse.prototype.isClaimed = false;

        /**
         * GiftClaimResponse claimGiftURL.
         * @member {string} claimGiftURL
         * @memberof orderspb.GiftClaimResponse
         * @instance
         */
        GiftClaimResponse.prototype.claimGiftURL = "";

        /**
         * Creates a new GiftClaimResponse instance using the specified properties.
         * @function create
         * @memberof orderspb.GiftClaimResponse
         * @static
         * @param {orderspb.IGiftClaimResponse=} [properties] Properties to set
         * @returns {orderspb.GiftClaimResponse} GiftClaimResponse instance
         */
        GiftClaimResponse.create = function create(properties) {
            return new GiftClaimResponse(properties);
        };

        /**
         * Encodes the specified GiftClaimResponse message. Does not implicitly {@link orderspb.GiftClaimResponse.verify|verify} messages.
         * @function encode
         * @memberof orderspb.GiftClaimResponse
         * @static
         * @param {orderspb.IGiftClaimResponse} m GiftClaimResponse message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GiftClaimResponse.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.isGift != null && Object.hasOwnProperty.call(m, "isGift"))
                w.uint32(8).bool(m.isGift);
            if (m.isClaimed != null && Object.hasOwnProperty.call(m, "isClaimed"))
                w.uint32(16).bool(m.isClaimed);
            if (m.claimGiftURL != null && Object.hasOwnProperty.call(m, "claimGiftURL"))
                w.uint32(26).string(m.claimGiftURL);
            return w;
        };

        /**
         * Decodes a GiftClaimResponse message from the specified reader or buffer.
         * @function decode
         * @memberof orderspb.GiftClaimResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {orderspb.GiftClaimResponse} GiftClaimResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GiftClaimResponse.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.orderspb.GiftClaimResponse();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.isGift = r.bool();
                    break;
                case 2:
                    m.isClaimed = r.bool();
                    break;
                case 3:
                    m.claimGiftURL = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return GiftClaimResponse;
    })();

    orderspb.Order = (function() {

        /**
         * Properties of an Order.
         * @memberof orderspb
         * @interface IOrder
         * @property {string|null} [orderID] Order orderID
         * @property {string|null} [status] Order status
         * @property {string|null} [userName] Order userName
         * @property {string|null} [salesGenerator] Order salesGenerator
         * @property {string|null} [salesCloser] Order salesCloser
         * @property {string|null} [sourceApplication] Order sourceApplication
         * @property {string|null} [salesSource] Order salesSource
         * @property {string|null} [salesChannel] Order salesChannel
         * @property {orderspb.IPerson|null} [buyer] Order buyer
         * @property {orderspb.IPerson|null} [coBuyer] Order coBuyer
         * @property {Array.<orderspb.IPerson>|null} [administrators] Order administrators
         * @property {orderspb.ISalesPartner|null} [salesPartner] Order salesPartner
         * @property {string|null} [propertyAddressID] Order propertyAddressID
         * @property {addresspb.IAddress|null} [propertyAddress] Order propertyAddress
         * @property {string|null} [mailingAddressID] Order mailingAddressID
         * @property {string|null} [billingAddressID] Order billingAddressID
         * @property {boolean|null} [eFulfillmentEnabled] Order eFulfillmentEnabled
         * @property {orderspb.IPaymentDetail|null} [paymentDetail] Order paymentDetail
         * @property {string|null} [quoteID] Order quoteID
         * @property {google.protobuf.ITimestamp|null} [quoteExpiration] Order quoteExpiration
         * @property {Array.<orderspb.INote>|null} [contractNotes] Order contractNotes
         * @property {string|null} [contractID] Order contractID
         * @property {google.protobuf.ITimestamp|null} [lastModified] Order lastModified
         * @property {google.protobuf.ITimestamp|null} [createdDate] Order createdDate
         * @property {Object.<string,orderspb.ISalesPerson>|null} [salesPersons] Order salesPersons
         * @property {common.Tenant|null} [tenantID] Order tenantID
         * @property {string|null} [ipAddress] Order ipAddress
         * @property {Object.<string,string>|null} [attributes] Order attributes
         * @property {orderspb.IRealEstate|null} [realEstate] Order realEstate
         * @property {Object.<string,string>|null} [events] Order events
         * @property {orderspb.ILeadInfo|null} [leadInfo] Order leadInfo
         * @property {string|null} [userAgent] Order userAgent
         * @property {orderspb.OrderType|null} [orderType] Order orderType
         * @property {string|null} [contractToModify] Order contractToModify
         * @property {propertypb.IProperty|null} [property] Order property
         * @property {google.protobuf.ITimestamp|null} [orderExpiration] Order orderExpiration
         * @property {boolean|null} [isGift] Order isGift
         * @property {orderspb.IGiftDetails|null} [giftDetails] Order giftDetails
         * @property {string|null} [ahsUserID] Order ahsUserID
         * @property {orderspb.PaymentStatus|null} [paymentStatus] Order paymentStatus
         * @property {string|null} [buyerCustomerID] Order buyerCustomerID
         * @property {orderspb.AutoRenew|null} [autoRenew] Order autoRenew
         */

        /**
         * Constructs a new Order.
         * @memberof orderspb
         * @classdesc Represents an Order.
         * @implements IOrder
         * @constructor
         * @param {orderspb.IOrder=} [p] Properties to set
         */
        function Order(p) {
            this.administrators = [];
            this.contractNotes = [];
            this.salesPersons = {};
            this.attributes = {};
            this.events = {};
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * Order orderID.
         * @member {string} orderID
         * @memberof orderspb.Order
         * @instance
         */
        Order.prototype.orderID = "";

        /**
         * Order status.
         * @member {string} status
         * @memberof orderspb.Order
         * @instance
         */
        Order.prototype.status = "";

        /**
         * Order userName.
         * @member {string} userName
         * @memberof orderspb.Order
         * @instance
         */
        Order.prototype.userName = "";

        /**
         * Order salesGenerator.
         * @member {string} salesGenerator
         * @memberof orderspb.Order
         * @instance
         */
        Order.prototype.salesGenerator = "";

        /**
         * Order salesCloser.
         * @member {string} salesCloser
         * @memberof orderspb.Order
         * @instance
         */
        Order.prototype.salesCloser = "";

        /**
         * Order sourceApplication.
         * @member {string} sourceApplication
         * @memberof orderspb.Order
         * @instance
         */
        Order.prototype.sourceApplication = "";

        /**
         * Order salesSource.
         * @member {string} salesSource
         * @memberof orderspb.Order
         * @instance
         */
        Order.prototype.salesSource = "";

        /**
         * Order salesChannel.
         * @member {string} salesChannel
         * @memberof orderspb.Order
         * @instance
         */
        Order.prototype.salesChannel = "";

        /**
         * Order buyer.
         * @member {orderspb.IPerson|null|undefined} buyer
         * @memberof orderspb.Order
         * @instance
         */
        Order.prototype.buyer = null;

        /**
         * Order coBuyer.
         * @member {orderspb.IPerson|null|undefined} coBuyer
         * @memberof orderspb.Order
         * @instance
         */
        Order.prototype.coBuyer = null;

        /**
         * Order administrators.
         * @member {Array.<orderspb.IPerson>} administrators
         * @memberof orderspb.Order
         * @instance
         */
        Order.prototype.administrators = $util.emptyArray;

        /**
         * Order salesPartner.
         * @member {orderspb.ISalesPartner|null|undefined} salesPartner
         * @memberof orderspb.Order
         * @instance
         */
        Order.prototype.salesPartner = null;

        /**
         * Order propertyAddressID.
         * @member {string} propertyAddressID
         * @memberof orderspb.Order
         * @instance
         */
        Order.prototype.propertyAddressID = "";

        /**
         * Order propertyAddress.
         * @member {addresspb.IAddress|null|undefined} propertyAddress
         * @memberof orderspb.Order
         * @instance
         */
        Order.prototype.propertyAddress = null;

        /**
         * Order mailingAddressID.
         * @member {string} mailingAddressID
         * @memberof orderspb.Order
         * @instance
         */
        Order.prototype.mailingAddressID = "";

        /**
         * Order billingAddressID.
         * @member {string} billingAddressID
         * @memberof orderspb.Order
         * @instance
         */
        Order.prototype.billingAddressID = "";

        /**
         * Order eFulfillmentEnabled.
         * @member {boolean} eFulfillmentEnabled
         * @memberof orderspb.Order
         * @instance
         */
        Order.prototype.eFulfillmentEnabled = false;

        /**
         * Order paymentDetail.
         * @member {orderspb.IPaymentDetail|null|undefined} paymentDetail
         * @memberof orderspb.Order
         * @instance
         */
        Order.prototype.paymentDetail = null;

        /**
         * Order quoteID.
         * @member {string} quoteID
         * @memberof orderspb.Order
         * @instance
         */
        Order.prototype.quoteID = "";

        /**
         * Order quoteExpiration.
         * @member {google.protobuf.ITimestamp|null|undefined} quoteExpiration
         * @memberof orderspb.Order
         * @instance
         */
        Order.prototype.quoteExpiration = null;

        /**
         * Order contractNotes.
         * @member {Array.<orderspb.INote>} contractNotes
         * @memberof orderspb.Order
         * @instance
         */
        Order.prototype.contractNotes = $util.emptyArray;

        /**
         * Order contractID.
         * @member {string} contractID
         * @memberof orderspb.Order
         * @instance
         */
        Order.prototype.contractID = "";

        /**
         * Order lastModified.
         * @member {google.protobuf.ITimestamp|null|undefined} lastModified
         * @memberof orderspb.Order
         * @instance
         */
        Order.prototype.lastModified = null;

        /**
         * Order createdDate.
         * @member {google.protobuf.ITimestamp|null|undefined} createdDate
         * @memberof orderspb.Order
         * @instance
         */
        Order.prototype.createdDate = null;

        /**
         * Order salesPersons.
         * @member {Object.<string,orderspb.ISalesPerson>} salesPersons
         * @memberof orderspb.Order
         * @instance
         */
        Order.prototype.salesPersons = $util.emptyObject;

        /**
         * Order tenantID.
         * @member {common.Tenant} tenantID
         * @memberof orderspb.Order
         * @instance
         */
        Order.prototype.tenantID = 0;

        /**
         * Order ipAddress.
         * @member {string} ipAddress
         * @memberof orderspb.Order
         * @instance
         */
        Order.prototype.ipAddress = "";

        /**
         * Order attributes.
         * @member {Object.<string,string>} attributes
         * @memberof orderspb.Order
         * @instance
         */
        Order.prototype.attributes = $util.emptyObject;

        /**
         * Order realEstate.
         * @member {orderspb.IRealEstate|null|undefined} realEstate
         * @memberof orderspb.Order
         * @instance
         */
        Order.prototype.realEstate = null;

        /**
         * Order events.
         * @member {Object.<string,string>} events
         * @memberof orderspb.Order
         * @instance
         */
        Order.prototype.events = $util.emptyObject;

        /**
         * Order leadInfo.
         * @member {orderspb.ILeadInfo|null|undefined} leadInfo
         * @memberof orderspb.Order
         * @instance
         */
        Order.prototype.leadInfo = null;

        /**
         * Order userAgent.
         * @member {string} userAgent
         * @memberof orderspb.Order
         * @instance
         */
        Order.prototype.userAgent = "";

        /**
         * Order orderType.
         * @member {orderspb.OrderType} orderType
         * @memberof orderspb.Order
         * @instance
         */
        Order.prototype.orderType = 0;

        /**
         * Order contractToModify.
         * @member {string} contractToModify
         * @memberof orderspb.Order
         * @instance
         */
        Order.prototype.contractToModify = "";

        /**
         * Order property.
         * @member {propertypb.IProperty|null|undefined} property
         * @memberof orderspb.Order
         * @instance
         */
        Order.prototype.property = null;

        /**
         * Order orderExpiration.
         * @member {google.protobuf.ITimestamp|null|undefined} orderExpiration
         * @memberof orderspb.Order
         * @instance
         */
        Order.prototype.orderExpiration = null;

        /**
         * Order isGift.
         * @member {boolean} isGift
         * @memberof orderspb.Order
         * @instance
         */
        Order.prototype.isGift = false;

        /**
         * Order giftDetails.
         * @member {orderspb.IGiftDetails|null|undefined} giftDetails
         * @memberof orderspb.Order
         * @instance
         */
        Order.prototype.giftDetails = null;

        /**
         * Order ahsUserID.
         * @member {string} ahsUserID
         * @memberof orderspb.Order
         * @instance
         */
        Order.prototype.ahsUserID = "";

        /**
         * Order paymentStatus.
         * @member {orderspb.PaymentStatus} paymentStatus
         * @memberof orderspb.Order
         * @instance
         */
        Order.prototype.paymentStatus = 0;

        /**
         * Order buyerCustomerID.
         * @member {string} buyerCustomerID
         * @memberof orderspb.Order
         * @instance
         */
        Order.prototype.buyerCustomerID = "";

        /**
         * Order autoRenew.
         * @member {orderspb.AutoRenew} autoRenew
         * @memberof orderspb.Order
         * @instance
         */
        Order.prototype.autoRenew = 0;

        /**
         * Creates a new Order instance using the specified properties.
         * @function create
         * @memberof orderspb.Order
         * @static
         * @param {orderspb.IOrder=} [properties] Properties to set
         * @returns {orderspb.Order} Order instance
         */
        Order.create = function create(properties) {
            return new Order(properties);
        };

        /**
         * Encodes the specified Order message. Does not implicitly {@link orderspb.Order.verify|verify} messages.
         * @function encode
         * @memberof orderspb.Order
         * @static
         * @param {orderspb.IOrder} m Order message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Order.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.orderID != null && Object.hasOwnProperty.call(m, "orderID"))
                w.uint32(10).string(m.orderID);
            if (m.status != null && Object.hasOwnProperty.call(m, "status"))
                w.uint32(18).string(m.status);
            if (m.userName != null && Object.hasOwnProperty.call(m, "userName"))
                w.uint32(26).string(m.userName);
            if (m.salesGenerator != null && Object.hasOwnProperty.call(m, "salesGenerator"))
                w.uint32(34).string(m.salesGenerator);
            if (m.salesCloser != null && Object.hasOwnProperty.call(m, "salesCloser"))
                w.uint32(42).string(m.salesCloser);
            if (m.sourceApplication != null && Object.hasOwnProperty.call(m, "sourceApplication"))
                w.uint32(50).string(m.sourceApplication);
            if (m.salesSource != null && Object.hasOwnProperty.call(m, "salesSource"))
                w.uint32(58).string(m.salesSource);
            if (m.salesChannel != null && Object.hasOwnProperty.call(m, "salesChannel"))
                w.uint32(66).string(m.salesChannel);
            if (m.buyer != null && Object.hasOwnProperty.call(m, "buyer"))
                $root.orderspb.Person.encode(m.buyer, w.uint32(74).fork()).ldelim();
            if (m.coBuyer != null && Object.hasOwnProperty.call(m, "coBuyer"))
                $root.orderspb.Person.encode(m.coBuyer, w.uint32(82).fork()).ldelim();
            if (m.administrators != null && m.administrators.length) {
                for (var i = 0; i < m.administrators.length; ++i)
                    $root.orderspb.Person.encode(m.administrators[i], w.uint32(90).fork()).ldelim();
            }
            if (m.salesPartner != null && Object.hasOwnProperty.call(m, "salesPartner"))
                $root.orderspb.SalesPartner.encode(m.salesPartner, w.uint32(98).fork()).ldelim();
            if (m.propertyAddressID != null && Object.hasOwnProperty.call(m, "propertyAddressID"))
                w.uint32(106).string(m.propertyAddressID);
            if (m.propertyAddress != null && Object.hasOwnProperty.call(m, "propertyAddress"))
                $root.addresspb.Address.encode(m.propertyAddress, w.uint32(114).fork()).ldelim();
            if (m.mailingAddressID != null && Object.hasOwnProperty.call(m, "mailingAddressID"))
                w.uint32(122).string(m.mailingAddressID);
            if (m.billingAddressID != null && Object.hasOwnProperty.call(m, "billingAddressID"))
                w.uint32(130).string(m.billingAddressID);
            if (m.eFulfillmentEnabled != null && Object.hasOwnProperty.call(m, "eFulfillmentEnabled"))
                w.uint32(136).bool(m.eFulfillmentEnabled);
            if (m.paymentDetail != null && Object.hasOwnProperty.call(m, "paymentDetail"))
                $root.orderspb.PaymentDetail.encode(m.paymentDetail, w.uint32(146).fork()).ldelim();
            if (m.quoteID != null && Object.hasOwnProperty.call(m, "quoteID"))
                w.uint32(154).string(m.quoteID);
            if (m.quoteExpiration != null && Object.hasOwnProperty.call(m, "quoteExpiration"))
                $root.google.protobuf.Timestamp.encode(m.quoteExpiration, w.uint32(162).fork()).ldelim();
            if (m.contractNotes != null && m.contractNotes.length) {
                for (var i = 0; i < m.contractNotes.length; ++i)
                    $root.orderspb.Note.encode(m.contractNotes[i], w.uint32(170).fork()).ldelim();
            }
            if (m.contractID != null && Object.hasOwnProperty.call(m, "contractID"))
                w.uint32(178).string(m.contractID);
            if (m.lastModified != null && Object.hasOwnProperty.call(m, "lastModified"))
                $root.google.protobuf.Timestamp.encode(m.lastModified, w.uint32(186).fork()).ldelim();
            if (m.createdDate != null && Object.hasOwnProperty.call(m, "createdDate"))
                $root.google.protobuf.Timestamp.encode(m.createdDate, w.uint32(194).fork()).ldelim();
            if (m.salesPersons != null && Object.hasOwnProperty.call(m, "salesPersons")) {
                for (var ks = Object.keys(m.salesPersons), i = 0; i < ks.length; ++i) {
                    w.uint32(202).fork().uint32(10).string(ks[i]);
                    $root.orderspb.SalesPerson.encode(m.salesPersons[ks[i]], w.uint32(18).fork()).ldelim().ldelim();
                }
            }
            if (m.tenantID != null && Object.hasOwnProperty.call(m, "tenantID"))
                w.uint32(208).int32(m.tenantID);
            if (m.ipAddress != null && Object.hasOwnProperty.call(m, "ipAddress"))
                w.uint32(218).string(m.ipAddress);
            if (m.attributes != null && Object.hasOwnProperty.call(m, "attributes")) {
                for (var ks = Object.keys(m.attributes), i = 0; i < ks.length; ++i) {
                    w.uint32(226).fork().uint32(10).string(ks[i]).uint32(18).string(m.attributes[ks[i]]).ldelim();
                }
            }
            if (m.realEstate != null && Object.hasOwnProperty.call(m, "realEstate"))
                $root.orderspb.RealEstate.encode(m.realEstate, w.uint32(234).fork()).ldelim();
            if (m.events != null && Object.hasOwnProperty.call(m, "events")) {
                for (var ks = Object.keys(m.events), i = 0; i < ks.length; ++i) {
                    w.uint32(242).fork().uint32(10).string(ks[i]).uint32(18).string(m.events[ks[i]]).ldelim();
                }
            }
            if (m.leadInfo != null && Object.hasOwnProperty.call(m, "leadInfo"))
                $root.orderspb.LeadInfo.encode(m.leadInfo, w.uint32(250).fork()).ldelim();
            if (m.userAgent != null && Object.hasOwnProperty.call(m, "userAgent"))
                w.uint32(258).string(m.userAgent);
            if (m.orderType != null && Object.hasOwnProperty.call(m, "orderType"))
                w.uint32(264).int32(m.orderType);
            if (m.contractToModify != null && Object.hasOwnProperty.call(m, "contractToModify"))
                w.uint32(274).string(m.contractToModify);
            if (m.property != null && Object.hasOwnProperty.call(m, "property"))
                $root.propertypb.Property.encode(m.property, w.uint32(362).fork()).ldelim();
            if (m.orderExpiration != null && Object.hasOwnProperty.call(m, "orderExpiration"))
                $root.google.protobuf.Timestamp.encode(m.orderExpiration, w.uint32(370).fork()).ldelim();
            if (m.isGift != null && Object.hasOwnProperty.call(m, "isGift"))
                w.uint32(376).bool(m.isGift);
            if (m.giftDetails != null && Object.hasOwnProperty.call(m, "giftDetails"))
                $root.orderspb.GiftDetails.encode(m.giftDetails, w.uint32(386).fork()).ldelim();
            if (m.ahsUserID != null && Object.hasOwnProperty.call(m, "ahsUserID"))
                w.uint32(394).string(m.ahsUserID);
            if (m.paymentStatus != null && Object.hasOwnProperty.call(m, "paymentStatus"))
                w.uint32(400).int32(m.paymentStatus);
            if (m.buyerCustomerID != null && Object.hasOwnProperty.call(m, "buyerCustomerID"))
                w.uint32(410).string(m.buyerCustomerID);
            if (m.autoRenew != null && Object.hasOwnProperty.call(m, "autoRenew"))
                w.uint32(416).int32(m.autoRenew);
            return w;
        };

        /**
         * Decodes an Order message from the specified reader or buffer.
         * @function decode
         * @memberof orderspb.Order
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {orderspb.Order} Order
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Order.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.orderspb.Order(), k, value;
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.orderID = r.string();
                    break;
                case 2:
                    m.status = r.string();
                    break;
                case 3:
                    m.userName = r.string();
                    break;
                case 4:
                    m.salesGenerator = r.string();
                    break;
                case 5:
                    m.salesCloser = r.string();
                    break;
                case 6:
                    m.sourceApplication = r.string();
                    break;
                case 7:
                    m.salesSource = r.string();
                    break;
                case 8:
                    m.salesChannel = r.string();
                    break;
                case 9:
                    m.buyer = $root.orderspb.Person.decode(r, r.uint32());
                    break;
                case 10:
                    m.coBuyer = $root.orderspb.Person.decode(r, r.uint32());
                    break;
                case 11:
                    if (!(m.administrators && m.administrators.length))
                        m.administrators = [];
                    m.administrators.push($root.orderspb.Person.decode(r, r.uint32()));
                    break;
                case 12:
                    m.salesPartner = $root.orderspb.SalesPartner.decode(r, r.uint32());
                    break;
                case 13:
                    m.propertyAddressID = r.string();
                    break;
                case 14:
                    m.propertyAddress = $root.addresspb.Address.decode(r, r.uint32());
                    break;
                case 15:
                    m.mailingAddressID = r.string();
                    break;
                case 16:
                    m.billingAddressID = r.string();
                    break;
                case 17:
                    m.eFulfillmentEnabled = r.bool();
                    break;
                case 18:
                    m.paymentDetail = $root.orderspb.PaymentDetail.decode(r, r.uint32());
                    break;
                case 19:
                    m.quoteID = r.string();
                    break;
                case 20:
                    m.quoteExpiration = $root.google.protobuf.Timestamp.decode(r, r.uint32());
                    break;
                case 21:
                    if (!(m.contractNotes && m.contractNotes.length))
                        m.contractNotes = [];
                    m.contractNotes.push($root.orderspb.Note.decode(r, r.uint32()));
                    break;
                case 22:
                    m.contractID = r.string();
                    break;
                case 23:
                    m.lastModified = $root.google.protobuf.Timestamp.decode(r, r.uint32());
                    break;
                case 24:
                    m.createdDate = $root.google.protobuf.Timestamp.decode(r, r.uint32());
                    break;
                case 25:
                    if (m.salesPersons === $util.emptyObject)
                        m.salesPersons = {};
                    var c2 = r.uint32() + r.pos;
                    k = "";
                    value = null;
                    while (r.pos < c2) {
                        var tag2 = r.uint32();
                        switch (tag2 >>> 3) {
                        case 1:
                            k = r.string();
                            break;
                        case 2:
                            value = $root.orderspb.SalesPerson.decode(r, r.uint32());
                            break;
                        default:
                            r.skipType(tag2 & 7);
                            break;
                        }
                    }
                    m.salesPersons[k] = value;
                    break;
                case 26:
                    m.tenantID = r.int32();
                    break;
                case 27:
                    m.ipAddress = r.string();
                    break;
                case 28:
                    if (m.attributes === $util.emptyObject)
                        m.attributes = {};
                    var c2 = r.uint32() + r.pos;
                    k = "";
                    value = "";
                    while (r.pos < c2) {
                        var tag2 = r.uint32();
                        switch (tag2 >>> 3) {
                        case 1:
                            k = r.string();
                            break;
                        case 2:
                            value = r.string();
                            break;
                        default:
                            r.skipType(tag2 & 7);
                            break;
                        }
                    }
                    m.attributes[k] = value;
                    break;
                case 29:
                    m.realEstate = $root.orderspb.RealEstate.decode(r, r.uint32());
                    break;
                case 30:
                    if (m.events === $util.emptyObject)
                        m.events = {};
                    var c2 = r.uint32() + r.pos;
                    k = "";
                    value = "";
                    while (r.pos < c2) {
                        var tag2 = r.uint32();
                        switch (tag2 >>> 3) {
                        case 1:
                            k = r.string();
                            break;
                        case 2:
                            value = r.string();
                            break;
                        default:
                            r.skipType(tag2 & 7);
                            break;
                        }
                    }
                    m.events[k] = value;
                    break;
                case 31:
                    m.leadInfo = $root.orderspb.LeadInfo.decode(r, r.uint32());
                    break;
                case 32:
                    m.userAgent = r.string();
                    break;
                case 33:
                    m.orderType = r.int32();
                    break;
                case 34:
                    m.contractToModify = r.string();
                    break;
                case 45:
                    m.property = $root.propertypb.Property.decode(r, r.uint32());
                    break;
                case 46:
                    m.orderExpiration = $root.google.protobuf.Timestamp.decode(r, r.uint32());
                    break;
                case 47:
                    m.isGift = r.bool();
                    break;
                case 48:
                    m.giftDetails = $root.orderspb.GiftDetails.decode(r, r.uint32());
                    break;
                case 49:
                    m.ahsUserID = r.string();
                    break;
                case 50:
                    m.paymentStatus = r.int32();
                    break;
                case 51:
                    m.buyerCustomerID = r.string();
                    break;
                case 52:
                    m.autoRenew = r.int32();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return Order;
    })();

    /**
     * OrderType enum.
     * @name orderspb.OrderType
     * @enum {number}
     * @property {number} UNKNOWN=0 UNKNOWN value
     * @property {number} AHS=1 AHS value
     * @property {number} HOME_WARRANTY=1 HOME_WARRANTY value
     * @property {number} PRIME=2 PRIME value
     * @property {number} PREMIUM=3 PREMIUM value
     * @property {number} UPGRADE=4 UPGRADE value
     * @property {number} ADDON=5 ADDON value
     * @property {number} NEW_HOME_EXTENDED=6 NEW_HOME_EXTENDED value
     */
    orderspb.OrderType = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "UNKNOWN"] = 0;
        values[valuesById[1] = "AHS"] = 1;
        values["HOME_WARRANTY"] = 1;
        values[valuesById[2] = "PRIME"] = 2;
        values[valuesById[3] = "PREMIUM"] = 3;
        values[valuesById[4] = "UPGRADE"] = 4;
        values[valuesById[5] = "ADDON"] = 5;
        values[valuesById[6] = "NEW_HOME_EXTENDED"] = 6;
        return values;
    })();

    /**
     * PaymentStatus enum.
     * @name orderspb.PaymentStatus
     * @enum {number}
     * @property {number} UNDEFINED=0 UNDEFINED value
     * @property {number} FAILED=1 FAILED value
     * @property {number} COMPLETE=2 COMPLETE value
     */
    orderspb.PaymentStatus = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "UNDEFINED"] = 0;
        values[valuesById[1] = "FAILED"] = 1;
        values[valuesById[2] = "COMPLETE"] = 2;
        return values;
    })();

    /**
     * AutoRenew enum.
     * @name orderspb.AutoRenew
     * @enum {number}
     * @property {number} LEGACY=0 LEGACY value
     * @property {number} ACCEPT=1 ACCEPT value
     * @property {number} DECLINE=2 DECLINE value
     */
    orderspb.AutoRenew = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "LEGACY"] = 0;
        values[valuesById[1] = "ACCEPT"] = 1;
        values[valuesById[2] = "DECLINE"] = 2;
        return values;
    })();

    orderspb.Person = (function() {

        /**
         * Properties of a Person.
         * @memberof orderspb
         * @interface IPerson
         * @property {string|null} [firstName] Person firstName
         * @property {string|null} [lastName] Person lastName
         * @property {string|null} [email] Person email
         * @property {Array.<orderspb.IPhone>|null} [phones] Person phones
         * @property {string|null} [mailingAddressID] Person mailingAddressID
         */

        /**
         * Constructs a new Person.
         * @memberof orderspb
         * @classdesc Represents a Person.
         * @implements IPerson
         * @constructor
         * @param {orderspb.IPerson=} [p] Properties to set
         */
        function Person(p) {
            this.phones = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * Person firstName.
         * @member {string} firstName
         * @memberof orderspb.Person
         * @instance
         */
        Person.prototype.firstName = "";

        /**
         * Person lastName.
         * @member {string} lastName
         * @memberof orderspb.Person
         * @instance
         */
        Person.prototype.lastName = "";

        /**
         * Person email.
         * @member {string} email
         * @memberof orderspb.Person
         * @instance
         */
        Person.prototype.email = "";

        /**
         * Person phones.
         * @member {Array.<orderspb.IPhone>} phones
         * @memberof orderspb.Person
         * @instance
         */
        Person.prototype.phones = $util.emptyArray;

        /**
         * Person mailingAddressID.
         * @member {string} mailingAddressID
         * @memberof orderspb.Person
         * @instance
         */
        Person.prototype.mailingAddressID = "";

        /**
         * Creates a new Person instance using the specified properties.
         * @function create
         * @memberof orderspb.Person
         * @static
         * @param {orderspb.IPerson=} [properties] Properties to set
         * @returns {orderspb.Person} Person instance
         */
        Person.create = function create(properties) {
            return new Person(properties);
        };

        /**
         * Encodes the specified Person message. Does not implicitly {@link orderspb.Person.verify|verify} messages.
         * @function encode
         * @memberof orderspb.Person
         * @static
         * @param {orderspb.IPerson} m Person message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Person.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.firstName != null && Object.hasOwnProperty.call(m, "firstName"))
                w.uint32(10).string(m.firstName);
            if (m.lastName != null && Object.hasOwnProperty.call(m, "lastName"))
                w.uint32(18).string(m.lastName);
            if (m.email != null && Object.hasOwnProperty.call(m, "email"))
                w.uint32(26).string(m.email);
            if (m.phones != null && m.phones.length) {
                for (var i = 0; i < m.phones.length; ++i)
                    $root.orderspb.Phone.encode(m.phones[i], w.uint32(34).fork()).ldelim();
            }
            if (m.mailingAddressID != null && Object.hasOwnProperty.call(m, "mailingAddressID"))
                w.uint32(42).string(m.mailingAddressID);
            return w;
        };

        /**
         * Decodes a Person message from the specified reader or buffer.
         * @function decode
         * @memberof orderspb.Person
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {orderspb.Person} Person
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Person.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.orderspb.Person();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.firstName = r.string();
                    break;
                case 2:
                    m.lastName = r.string();
                    break;
                case 3:
                    m.email = r.string();
                    break;
                case 4:
                    if (!(m.phones && m.phones.length))
                        m.phones = [];
                    m.phones.push($root.orderspb.Phone.decode(r, r.uint32()));
                    break;
                case 5:
                    m.mailingAddressID = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return Person;
    })();

    orderspb.Phone = (function() {

        /**
         * Properties of a Phone.
         * @memberof orderspb
         * @interface IPhone
         * @property {string|null} [number] Phone number
         * @property {string|null} [type] Phone type
         * @property {string|null} [extension] Phone extension
         */

        /**
         * Constructs a new Phone.
         * @memberof orderspb
         * @classdesc Represents a Phone.
         * @implements IPhone
         * @constructor
         * @param {orderspb.IPhone=} [p] Properties to set
         */
        function Phone(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * Phone number.
         * @member {string} number
         * @memberof orderspb.Phone
         * @instance
         */
        Phone.prototype.number = "";

        /**
         * Phone type.
         * @member {string} type
         * @memberof orderspb.Phone
         * @instance
         */
        Phone.prototype.type = "";

        /**
         * Phone extension.
         * @member {string} extension
         * @memberof orderspb.Phone
         * @instance
         */
        Phone.prototype.extension = "";

        /**
         * Creates a new Phone instance using the specified properties.
         * @function create
         * @memberof orderspb.Phone
         * @static
         * @param {orderspb.IPhone=} [properties] Properties to set
         * @returns {orderspb.Phone} Phone instance
         */
        Phone.create = function create(properties) {
            return new Phone(properties);
        };

        /**
         * Encodes the specified Phone message. Does not implicitly {@link orderspb.Phone.verify|verify} messages.
         * @function encode
         * @memberof orderspb.Phone
         * @static
         * @param {orderspb.IPhone} m Phone message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Phone.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.number != null && Object.hasOwnProperty.call(m, "number"))
                w.uint32(10).string(m.number);
            if (m.type != null && Object.hasOwnProperty.call(m, "type"))
                w.uint32(18).string(m.type);
            if (m.extension != null && Object.hasOwnProperty.call(m, "extension"))
                w.uint32(26).string(m.extension);
            return w;
        };

        /**
         * Decodes a Phone message from the specified reader or buffer.
         * @function decode
         * @memberof orderspb.Phone
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {orderspb.Phone} Phone
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Phone.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.orderspb.Phone();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.number = r.string();
                    break;
                case 2:
                    m.type = r.string();
                    break;
                case 3:
                    m.extension = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return Phone;
    })();

    orderspb.SalesPartner = (function() {

        /**
         * Properties of a SalesPartner.
         * @memberof orderspb
         * @interface ISalesPartner
         * @property {string|null} [partnerID] SalesPartner partnerID
         * @property {string|null} [salesAgentID] SalesPartner salesAgentID
         * @property {string|null} [email] SalesPartner email
         */

        /**
         * Constructs a new SalesPartner.
         * @memberof orderspb
         * @classdesc Represents a SalesPartner.
         * @implements ISalesPartner
         * @constructor
         * @param {orderspb.ISalesPartner=} [p] Properties to set
         */
        function SalesPartner(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * SalesPartner partnerID.
         * @member {string} partnerID
         * @memberof orderspb.SalesPartner
         * @instance
         */
        SalesPartner.prototype.partnerID = "";

        /**
         * SalesPartner salesAgentID.
         * @member {string} salesAgentID
         * @memberof orderspb.SalesPartner
         * @instance
         */
        SalesPartner.prototype.salesAgentID = "";

        /**
         * SalesPartner email.
         * @member {string} email
         * @memberof orderspb.SalesPartner
         * @instance
         */
        SalesPartner.prototype.email = "";

        /**
         * Creates a new SalesPartner instance using the specified properties.
         * @function create
         * @memberof orderspb.SalesPartner
         * @static
         * @param {orderspb.ISalesPartner=} [properties] Properties to set
         * @returns {orderspb.SalesPartner} SalesPartner instance
         */
        SalesPartner.create = function create(properties) {
            return new SalesPartner(properties);
        };

        /**
         * Encodes the specified SalesPartner message. Does not implicitly {@link orderspb.SalesPartner.verify|verify} messages.
         * @function encode
         * @memberof orderspb.SalesPartner
         * @static
         * @param {orderspb.ISalesPartner} m SalesPartner message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SalesPartner.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.partnerID != null && Object.hasOwnProperty.call(m, "partnerID"))
                w.uint32(10).string(m.partnerID);
            if (m.salesAgentID != null && Object.hasOwnProperty.call(m, "salesAgentID"))
                w.uint32(18).string(m.salesAgentID);
            if (m.email != null && Object.hasOwnProperty.call(m, "email"))
                w.uint32(26).string(m.email);
            return w;
        };

        /**
         * Decodes a SalesPartner message from the specified reader or buffer.
         * @function decode
         * @memberof orderspb.SalesPartner
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {orderspb.SalesPartner} SalesPartner
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SalesPartner.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.orderspb.SalesPartner();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.partnerID = r.string();
                    break;
                case 2:
                    m.salesAgentID = r.string();
                    break;
                case 3:
                    m.email = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return SalesPartner;
    })();

    orderspb.PaymentDetail = (function() {

        /**
         * Properties of a PaymentDetail.
         * @memberof orderspb
         * @interface IPaymentDetail
         * @property {string|null} [paymentType] PaymentDetail paymentType
         * @property {boolean|null} [automaticBilling] PaymentDetail automaticBilling
         * @property {google.protobuf.ITimestamp|null} [paymentProcessingDate] PaymentDetail paymentProcessingDate
         * @property {orderspb.IPaymentCard|null} [paymentCard] PaymentDetail paymentCard
         * @property {orderspb.IPaymentACH|null} [paymentACH] PaymentDetail paymentACH
         * @property {number|null} [paymentFrequency] PaymentDetail paymentFrequency
         */

        /**
         * Constructs a new PaymentDetail.
         * @memberof orderspb
         * @classdesc Represents a PaymentDetail.
         * @implements IPaymentDetail
         * @constructor
         * @param {orderspb.IPaymentDetail=} [p] Properties to set
         */
        function PaymentDetail(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * PaymentDetail paymentType.
         * @member {string} paymentType
         * @memberof orderspb.PaymentDetail
         * @instance
         */
        PaymentDetail.prototype.paymentType = "";

        /**
         * PaymentDetail automaticBilling.
         * @member {boolean} automaticBilling
         * @memberof orderspb.PaymentDetail
         * @instance
         */
        PaymentDetail.prototype.automaticBilling = false;

        /**
         * PaymentDetail paymentProcessingDate.
         * @member {google.protobuf.ITimestamp|null|undefined} paymentProcessingDate
         * @memberof orderspb.PaymentDetail
         * @instance
         */
        PaymentDetail.prototype.paymentProcessingDate = null;

        /**
         * PaymentDetail paymentCard.
         * @member {orderspb.IPaymentCard|null|undefined} paymentCard
         * @memberof orderspb.PaymentDetail
         * @instance
         */
        PaymentDetail.prototype.paymentCard = null;

        /**
         * PaymentDetail paymentACH.
         * @member {orderspb.IPaymentACH|null|undefined} paymentACH
         * @memberof orderspb.PaymentDetail
         * @instance
         */
        PaymentDetail.prototype.paymentACH = null;

        /**
         * PaymentDetail paymentFrequency.
         * @member {number} paymentFrequency
         * @memberof orderspb.PaymentDetail
         * @instance
         */
        PaymentDetail.prototype.paymentFrequency = 0;

        /**
         * Creates a new PaymentDetail instance using the specified properties.
         * @function create
         * @memberof orderspb.PaymentDetail
         * @static
         * @param {orderspb.IPaymentDetail=} [properties] Properties to set
         * @returns {orderspb.PaymentDetail} PaymentDetail instance
         */
        PaymentDetail.create = function create(properties) {
            return new PaymentDetail(properties);
        };

        /**
         * Encodes the specified PaymentDetail message. Does not implicitly {@link orderspb.PaymentDetail.verify|verify} messages.
         * @function encode
         * @memberof orderspb.PaymentDetail
         * @static
         * @param {orderspb.IPaymentDetail} m PaymentDetail message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PaymentDetail.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.paymentType != null && Object.hasOwnProperty.call(m, "paymentType"))
                w.uint32(10).string(m.paymentType);
            if (m.automaticBilling != null && Object.hasOwnProperty.call(m, "automaticBilling"))
                w.uint32(16).bool(m.automaticBilling);
            if (m.paymentProcessingDate != null && Object.hasOwnProperty.call(m, "paymentProcessingDate"))
                $root.google.protobuf.Timestamp.encode(m.paymentProcessingDate, w.uint32(26).fork()).ldelim();
            if (m.paymentCard != null && Object.hasOwnProperty.call(m, "paymentCard"))
                $root.orderspb.PaymentCard.encode(m.paymentCard, w.uint32(34).fork()).ldelim();
            if (m.paymentACH != null && Object.hasOwnProperty.call(m, "paymentACH"))
                $root.orderspb.PaymentACH.encode(m.paymentACH, w.uint32(42).fork()).ldelim();
            if (m.paymentFrequency != null && Object.hasOwnProperty.call(m, "paymentFrequency"))
                w.uint32(48).int32(m.paymentFrequency);
            return w;
        };

        /**
         * Decodes a PaymentDetail message from the specified reader or buffer.
         * @function decode
         * @memberof orderspb.PaymentDetail
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {orderspb.PaymentDetail} PaymentDetail
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PaymentDetail.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.orderspb.PaymentDetail();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.paymentType = r.string();
                    break;
                case 2:
                    m.automaticBilling = r.bool();
                    break;
                case 3:
                    m.paymentProcessingDate = $root.google.protobuf.Timestamp.decode(r, r.uint32());
                    break;
                case 4:
                    m.paymentCard = $root.orderspb.PaymentCard.decode(r, r.uint32());
                    break;
                case 5:
                    m.paymentACH = $root.orderspb.PaymentACH.decode(r, r.uint32());
                    break;
                case 6:
                    m.paymentFrequency = r.int32();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return PaymentDetail;
    })();

    orderspb.PaymentCard = (function() {

        /**
         * Properties of a PaymentCard.
         * @memberof orderspb
         * @interface IPaymentCard
         * @property {string|null} [cardType] PaymentCard cardType
         * @property {string|null} [cardID] PaymentCard cardID
         * @property {string|null} [accountID] PaymentCard accountID
         * @property {string|null} [expirationDate] PaymentCard expirationDate
         * @property {string|null} [holderFirstName] PaymentCard holderFirstName
         * @property {string|null} [holderLastName] PaymentCard holderLastName
         * @property {string|null} [token] PaymentCard token
         * @property {string|null} [tokenProvider] PaymentCard tokenProvider
         */

        /**
         * Constructs a new PaymentCard.
         * @memberof orderspb
         * @classdesc Represents a PaymentCard.
         * @implements IPaymentCard
         * @constructor
         * @param {orderspb.IPaymentCard=} [p] Properties to set
         */
        function PaymentCard(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * PaymentCard cardType.
         * @member {string} cardType
         * @memberof orderspb.PaymentCard
         * @instance
         */
        PaymentCard.prototype.cardType = "";

        /**
         * PaymentCard cardID.
         * @member {string} cardID
         * @memberof orderspb.PaymentCard
         * @instance
         */
        PaymentCard.prototype.cardID = "";

        /**
         * PaymentCard accountID.
         * @member {string} accountID
         * @memberof orderspb.PaymentCard
         * @instance
         */
        PaymentCard.prototype.accountID = "";

        /**
         * PaymentCard expirationDate.
         * @member {string} expirationDate
         * @memberof orderspb.PaymentCard
         * @instance
         */
        PaymentCard.prototype.expirationDate = "";

        /**
         * PaymentCard holderFirstName.
         * @member {string} holderFirstName
         * @memberof orderspb.PaymentCard
         * @instance
         */
        PaymentCard.prototype.holderFirstName = "";

        /**
         * PaymentCard holderLastName.
         * @member {string} holderLastName
         * @memberof orderspb.PaymentCard
         * @instance
         */
        PaymentCard.prototype.holderLastName = "";

        /**
         * PaymentCard token.
         * @member {string} token
         * @memberof orderspb.PaymentCard
         * @instance
         */
        PaymentCard.prototype.token = "";

        /**
         * PaymentCard tokenProvider.
         * @member {string} tokenProvider
         * @memberof orderspb.PaymentCard
         * @instance
         */
        PaymentCard.prototype.tokenProvider = "";

        /**
         * Creates a new PaymentCard instance using the specified properties.
         * @function create
         * @memberof orderspb.PaymentCard
         * @static
         * @param {orderspb.IPaymentCard=} [properties] Properties to set
         * @returns {orderspb.PaymentCard} PaymentCard instance
         */
        PaymentCard.create = function create(properties) {
            return new PaymentCard(properties);
        };

        /**
         * Encodes the specified PaymentCard message. Does not implicitly {@link orderspb.PaymentCard.verify|verify} messages.
         * @function encode
         * @memberof orderspb.PaymentCard
         * @static
         * @param {orderspb.IPaymentCard} m PaymentCard message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PaymentCard.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.cardType != null && Object.hasOwnProperty.call(m, "cardType"))
                w.uint32(10).string(m.cardType);
            if (m.cardID != null && Object.hasOwnProperty.call(m, "cardID"))
                w.uint32(18).string(m.cardID);
            if (m.accountID != null && Object.hasOwnProperty.call(m, "accountID"))
                w.uint32(26).string(m.accountID);
            if (m.expirationDate != null && Object.hasOwnProperty.call(m, "expirationDate"))
                w.uint32(34).string(m.expirationDate);
            if (m.holderFirstName != null && Object.hasOwnProperty.call(m, "holderFirstName"))
                w.uint32(42).string(m.holderFirstName);
            if (m.holderLastName != null && Object.hasOwnProperty.call(m, "holderLastName"))
                w.uint32(50).string(m.holderLastName);
            if (m.token != null && Object.hasOwnProperty.call(m, "token"))
                w.uint32(58).string(m.token);
            if (m.tokenProvider != null && Object.hasOwnProperty.call(m, "tokenProvider"))
                w.uint32(66).string(m.tokenProvider);
            return w;
        };

        /**
         * Decodes a PaymentCard message from the specified reader or buffer.
         * @function decode
         * @memberof orderspb.PaymentCard
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {orderspb.PaymentCard} PaymentCard
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PaymentCard.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.orderspb.PaymentCard();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.cardType = r.string();
                    break;
                case 2:
                    m.cardID = r.string();
                    break;
                case 3:
                    m.accountID = r.string();
                    break;
                case 4:
                    m.expirationDate = r.string();
                    break;
                case 5:
                    m.holderFirstName = r.string();
                    break;
                case 6:
                    m.holderLastName = r.string();
                    break;
                case 7:
                    m.token = r.string();
                    break;
                case 8:
                    m.tokenProvider = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return PaymentCard;
    })();

    orderspb.PaymentACH = (function() {

        /**
         * Properties of a PaymentACH.
         * @memberof orderspb
         * @interface IPaymentACH
         * @property {string|null} [routingNumber] PaymentACH routingNumber
         * @property {string|null} [accountNumber] PaymentACH accountNumber
         * @property {string|null} [accountType] PaymentACH accountType
         * @property {string|null} [secTypeCode] PaymentACH secTypeCode
         * @property {string|null} [holderFirstName] PaymentACH holderFirstName
         * @property {string|null} [holderLastName] PaymentACH holderLastName
         * @property {string|null} [paymentID] PaymentACH paymentID
         * @property {string|null} [tokenProvider] PaymentACH tokenProvider
         */

        /**
         * Constructs a new PaymentACH.
         * @memberof orderspb
         * @classdesc Represents a PaymentACH.
         * @implements IPaymentACH
         * @constructor
         * @param {orderspb.IPaymentACH=} [p] Properties to set
         */
        function PaymentACH(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * PaymentACH routingNumber.
         * @member {string} routingNumber
         * @memberof orderspb.PaymentACH
         * @instance
         */
        PaymentACH.prototype.routingNumber = "";

        /**
         * PaymentACH accountNumber.
         * @member {string} accountNumber
         * @memberof orderspb.PaymentACH
         * @instance
         */
        PaymentACH.prototype.accountNumber = "";

        /**
         * PaymentACH accountType.
         * @member {string} accountType
         * @memberof orderspb.PaymentACH
         * @instance
         */
        PaymentACH.prototype.accountType = "";

        /**
         * PaymentACH secTypeCode.
         * @member {string} secTypeCode
         * @memberof orderspb.PaymentACH
         * @instance
         */
        PaymentACH.prototype.secTypeCode = "";

        /**
         * PaymentACH holderFirstName.
         * @member {string} holderFirstName
         * @memberof orderspb.PaymentACH
         * @instance
         */
        PaymentACH.prototype.holderFirstName = "";

        /**
         * PaymentACH holderLastName.
         * @member {string} holderLastName
         * @memberof orderspb.PaymentACH
         * @instance
         */
        PaymentACH.prototype.holderLastName = "";

        /**
         * PaymentACH paymentID.
         * @member {string} paymentID
         * @memberof orderspb.PaymentACH
         * @instance
         */
        PaymentACH.prototype.paymentID = "";

        /**
         * PaymentACH tokenProvider.
         * @member {string} tokenProvider
         * @memberof orderspb.PaymentACH
         * @instance
         */
        PaymentACH.prototype.tokenProvider = "";

        /**
         * Creates a new PaymentACH instance using the specified properties.
         * @function create
         * @memberof orderspb.PaymentACH
         * @static
         * @param {orderspb.IPaymentACH=} [properties] Properties to set
         * @returns {orderspb.PaymentACH} PaymentACH instance
         */
        PaymentACH.create = function create(properties) {
            return new PaymentACH(properties);
        };

        /**
         * Encodes the specified PaymentACH message. Does not implicitly {@link orderspb.PaymentACH.verify|verify} messages.
         * @function encode
         * @memberof orderspb.PaymentACH
         * @static
         * @param {orderspb.IPaymentACH} m PaymentACH message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PaymentACH.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.routingNumber != null && Object.hasOwnProperty.call(m, "routingNumber"))
                w.uint32(10).string(m.routingNumber);
            if (m.accountNumber != null && Object.hasOwnProperty.call(m, "accountNumber"))
                w.uint32(18).string(m.accountNumber);
            if (m.accountType != null && Object.hasOwnProperty.call(m, "accountType"))
                w.uint32(26).string(m.accountType);
            if (m.secTypeCode != null && Object.hasOwnProperty.call(m, "secTypeCode"))
                w.uint32(34).string(m.secTypeCode);
            if (m.holderFirstName != null && Object.hasOwnProperty.call(m, "holderFirstName"))
                w.uint32(42).string(m.holderFirstName);
            if (m.holderLastName != null && Object.hasOwnProperty.call(m, "holderLastName"))
                w.uint32(50).string(m.holderLastName);
            if (m.paymentID != null && Object.hasOwnProperty.call(m, "paymentID"))
                w.uint32(58).string(m.paymentID);
            if (m.tokenProvider != null && Object.hasOwnProperty.call(m, "tokenProvider"))
                w.uint32(66).string(m.tokenProvider);
            return w;
        };

        /**
         * Decodes a PaymentACH message from the specified reader or buffer.
         * @function decode
         * @memberof orderspb.PaymentACH
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {orderspb.PaymentACH} PaymentACH
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PaymentACH.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.orderspb.PaymentACH();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.routingNumber = r.string();
                    break;
                case 2:
                    m.accountNumber = r.string();
                    break;
                case 3:
                    m.accountType = r.string();
                    break;
                case 4:
                    m.secTypeCode = r.string();
                    break;
                case 5:
                    m.holderFirstName = r.string();
                    break;
                case 6:
                    m.holderLastName = r.string();
                    break;
                case 7:
                    m.paymentID = r.string();
                    break;
                case 8:
                    m.tokenProvider = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return PaymentACH;
    })();

    orderspb.Note = (function() {

        /**
         * Properties of a Note.
         * @memberof orderspb
         * @interface INote
         * @property {string|null} [type] Note type
         * @property {string|null} [text] Note text
         */

        /**
         * Constructs a new Note.
         * @memberof orderspb
         * @classdesc Represents a Note.
         * @implements INote
         * @constructor
         * @param {orderspb.INote=} [p] Properties to set
         */
        function Note(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * Note type.
         * @member {string} type
         * @memberof orderspb.Note
         * @instance
         */
        Note.prototype.type = "";

        /**
         * Note text.
         * @member {string} text
         * @memberof orderspb.Note
         * @instance
         */
        Note.prototype.text = "";

        /**
         * Creates a new Note instance using the specified properties.
         * @function create
         * @memberof orderspb.Note
         * @static
         * @param {orderspb.INote=} [properties] Properties to set
         * @returns {orderspb.Note} Note instance
         */
        Note.create = function create(properties) {
            return new Note(properties);
        };

        /**
         * Encodes the specified Note message. Does not implicitly {@link orderspb.Note.verify|verify} messages.
         * @function encode
         * @memberof orderspb.Note
         * @static
         * @param {orderspb.INote} m Note message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Note.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.type != null && Object.hasOwnProperty.call(m, "type"))
                w.uint32(10).string(m.type);
            if (m.text != null && Object.hasOwnProperty.call(m, "text"))
                w.uint32(18).string(m.text);
            return w;
        };

        /**
         * Decodes a Note message from the specified reader or buffer.
         * @function decode
         * @memberof orderspb.Note
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {orderspb.Note} Note
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Note.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.orderspb.Note();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.type = r.string();
                    break;
                case 2:
                    m.text = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return Note;
    })();

    orderspb.GiftDetails = (function() {

        /**
         * Properties of a GiftDetails.
         * @memberof orderspb
         * @interface IGiftDetails
         * @property {orderspb.IPerson|null} [gifter] GiftDetails gifter
         * @property {string|null} [personalizedMessage] GiftDetails personalizedMessage
         * @property {boolean|null} [isGifteeExistingUser] GiftDetails isGifteeExistingUser
         * @property {string|null} [giftToken] GiftDetails giftToken
         * @property {boolean|null} [claimed] GiftDetails claimed
         * @property {google.protobuf.ITimestamp|null} [claimedTimestamp] GiftDetails claimedTimestamp
         * @property {boolean|null} [gifterEmailSent] GiftDetails gifterEmailSent
         * @property {boolean|null} [gifteeEmailSent] GiftDetails gifteeEmailSent
         * @property {string|null} [voucherCode] GiftDetails voucherCode
         * @property {string|null} [gifteeEmailTenant] GiftDetails gifteeEmailTenant
         */

        /**
         * Constructs a new GiftDetails.
         * @memberof orderspb
         * @classdesc Represents a GiftDetails.
         * @implements IGiftDetails
         * @constructor
         * @param {orderspb.IGiftDetails=} [p] Properties to set
         */
        function GiftDetails(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * GiftDetails gifter.
         * @member {orderspb.IPerson|null|undefined} gifter
         * @memberof orderspb.GiftDetails
         * @instance
         */
        GiftDetails.prototype.gifter = null;

        /**
         * GiftDetails personalizedMessage.
         * @member {string} personalizedMessage
         * @memberof orderspb.GiftDetails
         * @instance
         */
        GiftDetails.prototype.personalizedMessage = "";

        /**
         * GiftDetails isGifteeExistingUser.
         * @member {boolean} isGifteeExistingUser
         * @memberof orderspb.GiftDetails
         * @instance
         */
        GiftDetails.prototype.isGifteeExistingUser = false;

        /**
         * GiftDetails giftToken.
         * @member {string} giftToken
         * @memberof orderspb.GiftDetails
         * @instance
         */
        GiftDetails.prototype.giftToken = "";

        /**
         * GiftDetails claimed.
         * @member {boolean} claimed
         * @memberof orderspb.GiftDetails
         * @instance
         */
        GiftDetails.prototype.claimed = false;

        /**
         * GiftDetails claimedTimestamp.
         * @member {google.protobuf.ITimestamp|null|undefined} claimedTimestamp
         * @memberof orderspb.GiftDetails
         * @instance
         */
        GiftDetails.prototype.claimedTimestamp = null;

        /**
         * GiftDetails gifterEmailSent.
         * @member {boolean} gifterEmailSent
         * @memberof orderspb.GiftDetails
         * @instance
         */
        GiftDetails.prototype.gifterEmailSent = false;

        /**
         * GiftDetails gifteeEmailSent.
         * @member {boolean} gifteeEmailSent
         * @memberof orderspb.GiftDetails
         * @instance
         */
        GiftDetails.prototype.gifteeEmailSent = false;

        /**
         * GiftDetails voucherCode.
         * @member {string} voucherCode
         * @memberof orderspb.GiftDetails
         * @instance
         */
        GiftDetails.prototype.voucherCode = "";

        /**
         * GiftDetails gifteeEmailTenant.
         * @member {string} gifteeEmailTenant
         * @memberof orderspb.GiftDetails
         * @instance
         */
        GiftDetails.prototype.gifteeEmailTenant = "";

        /**
         * Creates a new GiftDetails instance using the specified properties.
         * @function create
         * @memberof orderspb.GiftDetails
         * @static
         * @param {orderspb.IGiftDetails=} [properties] Properties to set
         * @returns {orderspb.GiftDetails} GiftDetails instance
         */
        GiftDetails.create = function create(properties) {
            return new GiftDetails(properties);
        };

        /**
         * Encodes the specified GiftDetails message. Does not implicitly {@link orderspb.GiftDetails.verify|verify} messages.
         * @function encode
         * @memberof orderspb.GiftDetails
         * @static
         * @param {orderspb.IGiftDetails} m GiftDetails message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GiftDetails.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.gifter != null && Object.hasOwnProperty.call(m, "gifter"))
                $root.orderspb.Person.encode(m.gifter, w.uint32(10).fork()).ldelim();
            if (m.personalizedMessage != null && Object.hasOwnProperty.call(m, "personalizedMessage"))
                w.uint32(18).string(m.personalizedMessage);
            if (m.isGifteeExistingUser != null && Object.hasOwnProperty.call(m, "isGifteeExistingUser"))
                w.uint32(24).bool(m.isGifteeExistingUser);
            if (m.giftToken != null && Object.hasOwnProperty.call(m, "giftToken"))
                w.uint32(34).string(m.giftToken);
            if (m.claimed != null && Object.hasOwnProperty.call(m, "claimed"))
                w.uint32(40).bool(m.claimed);
            if (m.claimedTimestamp != null && Object.hasOwnProperty.call(m, "claimedTimestamp"))
                $root.google.protobuf.Timestamp.encode(m.claimedTimestamp, w.uint32(50).fork()).ldelim();
            if (m.gifterEmailSent != null && Object.hasOwnProperty.call(m, "gifterEmailSent"))
                w.uint32(56).bool(m.gifterEmailSent);
            if (m.gifteeEmailSent != null && Object.hasOwnProperty.call(m, "gifteeEmailSent"))
                w.uint32(64).bool(m.gifteeEmailSent);
            if (m.voucherCode != null && Object.hasOwnProperty.call(m, "voucherCode"))
                w.uint32(74).string(m.voucherCode);
            if (m.gifteeEmailTenant != null && Object.hasOwnProperty.call(m, "gifteeEmailTenant"))
                w.uint32(82).string(m.gifteeEmailTenant);
            return w;
        };

        /**
         * Decodes a GiftDetails message from the specified reader or buffer.
         * @function decode
         * @memberof orderspb.GiftDetails
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {orderspb.GiftDetails} GiftDetails
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GiftDetails.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.orderspb.GiftDetails();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.gifter = $root.orderspb.Person.decode(r, r.uint32());
                    break;
                case 2:
                    m.personalizedMessage = r.string();
                    break;
                case 3:
                    m.isGifteeExistingUser = r.bool();
                    break;
                case 4:
                    m.giftToken = r.string();
                    break;
                case 5:
                    m.claimed = r.bool();
                    break;
                case 6:
                    m.claimedTimestamp = $root.google.protobuf.Timestamp.decode(r, r.uint32());
                    break;
                case 7:
                    m.gifterEmailSent = r.bool();
                    break;
                case 8:
                    m.gifteeEmailSent = r.bool();
                    break;
                case 9:
                    m.voucherCode = r.string();
                    break;
                case 10:
                    m.gifteeEmailTenant = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return GiftDetails;
    })();

    orderspb.OrderRequest = (function() {

        /**
         * Properties of an OrderRequest.
         * @memberof orderspb
         * @interface IOrderRequest
         * @property {string|null} [userName] OrderRequest userName
         * @property {string|null} [salesGenerator] OrderRequest salesGenerator
         * @property {string|null} [salesCloser] OrderRequest salesCloser
         * @property {orderspb.IPerson|null} [buyer] OrderRequest buyer
         * @property {orderspb.IPerson|null} [coBuyer] OrderRequest coBuyer
         * @property {Array.<orderspb.IPerson>|null} [administrators] OrderRequest administrators
         * @property {string|null} [addressID] OrderRequest addressID
         * @property {string|null} [mailingAddressID] OrderRequest mailingAddressID
         * @property {string|null} [billingAddressID] OrderRequest billingAddressID
         * @property {addresspb.IAddress|null} [address] OrderRequest address
         * @property {orderspb.IPaymentDetail|null} [paymentDetail] OrderRequest paymentDetail
         * @property {string|null} [salesSource] OrderRequest salesSource
         * @property {string|null} [salesChannel] OrderRequest salesChannel
         * @property {orderspb.ISalesPartner|null} [salesPartner] OrderRequest salesPartner
         * @property {string|null} [sourceApplication] OrderRequest sourceApplication
         * @property {Object.<string,orderspb.ISalesPerson>|null} [salesPersons] OrderRequest salesPersons
         * @property {string|null} [ipAddress] OrderRequest ipAddress
         * @property {boolean|null} [eFulfillmentEnabled] OrderRequest eFulfillmentEnabled
         * @property {orderspb.IRealEstate|null} [realEstate] OrderRequest realEstate
         * @property {string|null} [processMethod] OrderRequest processMethod
         * @property {Array.<orderspb.INote>|null} [contractNotes] OrderRequest contractNotes
         * @property {common.Tenant|null} [tenantID] OrderRequest tenantID
         * @property {Object.<string,string>|null} [attributes] OrderRequest attributes
         * @property {Object.<string,string>|null} [events] OrderRequest events
         * @property {string|null} [userAgent] OrderRequest userAgent
         * @property {orderspb.OrderType|null} [orderType] OrderRequest orderType
         * @property {string|null} [contractToModify] OrderRequest contractToModify
         * @property {propertypb.IProperty|null} [property] OrderRequest property
         * @property {google.protobuf.ITimestamp|null} [orderExpiration] OrderRequest orderExpiration
         * @property {boolean|null} [isGift] OrderRequest isGift
         * @property {orderspb.IGiftDetails|null} [giftDetails] OrderRequest giftDetails
         * @property {string|null} [ahsUserID] OrderRequest ahsUserID
         * @property {orderspb.PaymentStatus|null} [paymentStatus] OrderRequest paymentStatus
         * @property {string|null} [buyerCustomerID] OrderRequest buyerCustomerID
         * @property {string|null} [handOffPostID] OrderRequest handOffPostID
         * @property {orderspb.AutoRenew|null} [autoRenew] OrderRequest autoRenew
         * @property {string|null} [status] OrderRequest status
         */

        /**
         * Constructs a new OrderRequest.
         * @memberof orderspb
         * @classdesc Represents an OrderRequest.
         * @implements IOrderRequest
         * @constructor
         * @param {orderspb.IOrderRequest=} [p] Properties to set
         */
        function OrderRequest(p) {
            this.administrators = [];
            this.salesPersons = {};
            this.contractNotes = [];
            this.attributes = {};
            this.events = {};
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * OrderRequest userName.
         * @member {string} userName
         * @memberof orderspb.OrderRequest
         * @instance
         */
        OrderRequest.prototype.userName = "";

        /**
         * OrderRequest salesGenerator.
         * @member {string} salesGenerator
         * @memberof orderspb.OrderRequest
         * @instance
         */
        OrderRequest.prototype.salesGenerator = "";

        /**
         * OrderRequest salesCloser.
         * @member {string} salesCloser
         * @memberof orderspb.OrderRequest
         * @instance
         */
        OrderRequest.prototype.salesCloser = "";

        /**
         * OrderRequest buyer.
         * @member {orderspb.IPerson|null|undefined} buyer
         * @memberof orderspb.OrderRequest
         * @instance
         */
        OrderRequest.prototype.buyer = null;

        /**
         * OrderRequest coBuyer.
         * @member {orderspb.IPerson|null|undefined} coBuyer
         * @memberof orderspb.OrderRequest
         * @instance
         */
        OrderRequest.prototype.coBuyer = null;

        /**
         * OrderRequest administrators.
         * @member {Array.<orderspb.IPerson>} administrators
         * @memberof orderspb.OrderRequest
         * @instance
         */
        OrderRequest.prototype.administrators = $util.emptyArray;

        /**
         * OrderRequest addressID.
         * @member {string} addressID
         * @memberof orderspb.OrderRequest
         * @instance
         */
        OrderRequest.prototype.addressID = "";

        /**
         * OrderRequest mailingAddressID.
         * @member {string} mailingAddressID
         * @memberof orderspb.OrderRequest
         * @instance
         */
        OrderRequest.prototype.mailingAddressID = "";

        /**
         * OrderRequest billingAddressID.
         * @member {string} billingAddressID
         * @memberof orderspb.OrderRequest
         * @instance
         */
        OrderRequest.prototype.billingAddressID = "";

        /**
         * OrderRequest address.
         * @member {addresspb.IAddress|null|undefined} address
         * @memberof orderspb.OrderRequest
         * @instance
         */
        OrderRequest.prototype.address = null;

        /**
         * OrderRequest paymentDetail.
         * @member {orderspb.IPaymentDetail|null|undefined} paymentDetail
         * @memberof orderspb.OrderRequest
         * @instance
         */
        OrderRequest.prototype.paymentDetail = null;

        /**
         * OrderRequest salesSource.
         * @member {string} salesSource
         * @memberof orderspb.OrderRequest
         * @instance
         */
        OrderRequest.prototype.salesSource = "";

        /**
         * OrderRequest salesChannel.
         * @member {string} salesChannel
         * @memberof orderspb.OrderRequest
         * @instance
         */
        OrderRequest.prototype.salesChannel = "";

        /**
         * OrderRequest salesPartner.
         * @member {orderspb.ISalesPartner|null|undefined} salesPartner
         * @memberof orderspb.OrderRequest
         * @instance
         */
        OrderRequest.prototype.salesPartner = null;

        /**
         * OrderRequest sourceApplication.
         * @member {string} sourceApplication
         * @memberof orderspb.OrderRequest
         * @instance
         */
        OrderRequest.prototype.sourceApplication = "";

        /**
         * OrderRequest salesPersons.
         * @member {Object.<string,orderspb.ISalesPerson>} salesPersons
         * @memberof orderspb.OrderRequest
         * @instance
         */
        OrderRequest.prototype.salesPersons = $util.emptyObject;

        /**
         * OrderRequest ipAddress.
         * @member {string} ipAddress
         * @memberof orderspb.OrderRequest
         * @instance
         */
        OrderRequest.prototype.ipAddress = "";

        /**
         * OrderRequest eFulfillmentEnabled.
         * @member {boolean} eFulfillmentEnabled
         * @memberof orderspb.OrderRequest
         * @instance
         */
        OrderRequest.prototype.eFulfillmentEnabled = false;

        /**
         * OrderRequest realEstate.
         * @member {orderspb.IRealEstate|null|undefined} realEstate
         * @memberof orderspb.OrderRequest
         * @instance
         */
        OrderRequest.prototype.realEstate = null;

        /**
         * OrderRequest processMethod.
         * @member {string} processMethod
         * @memberof orderspb.OrderRequest
         * @instance
         */
        OrderRequest.prototype.processMethod = "";

        /**
         * OrderRequest contractNotes.
         * @member {Array.<orderspb.INote>} contractNotes
         * @memberof orderspb.OrderRequest
         * @instance
         */
        OrderRequest.prototype.contractNotes = $util.emptyArray;

        /**
         * OrderRequest tenantID.
         * @member {common.Tenant} tenantID
         * @memberof orderspb.OrderRequest
         * @instance
         */
        OrderRequest.prototype.tenantID = 0;

        /**
         * OrderRequest attributes.
         * @member {Object.<string,string>} attributes
         * @memberof orderspb.OrderRequest
         * @instance
         */
        OrderRequest.prototype.attributes = $util.emptyObject;

        /**
         * OrderRequest events.
         * @member {Object.<string,string>} events
         * @memberof orderspb.OrderRequest
         * @instance
         */
        OrderRequest.prototype.events = $util.emptyObject;

        /**
         * OrderRequest userAgent.
         * @member {string} userAgent
         * @memberof orderspb.OrderRequest
         * @instance
         */
        OrderRequest.prototype.userAgent = "";

        /**
         * OrderRequest orderType.
         * @member {orderspb.OrderType} orderType
         * @memberof orderspb.OrderRequest
         * @instance
         */
        OrderRequest.prototype.orderType = 0;

        /**
         * OrderRequest contractToModify.
         * @member {string} contractToModify
         * @memberof orderspb.OrderRequest
         * @instance
         */
        OrderRequest.prototype.contractToModify = "";

        /**
         * OrderRequest property.
         * @member {propertypb.IProperty|null|undefined} property
         * @memberof orderspb.OrderRequest
         * @instance
         */
        OrderRequest.prototype.property = null;

        /**
         * OrderRequest orderExpiration.
         * @member {google.protobuf.ITimestamp|null|undefined} orderExpiration
         * @memberof orderspb.OrderRequest
         * @instance
         */
        OrderRequest.prototype.orderExpiration = null;

        /**
         * OrderRequest isGift.
         * @member {boolean} isGift
         * @memberof orderspb.OrderRequest
         * @instance
         */
        OrderRequest.prototype.isGift = false;

        /**
         * OrderRequest giftDetails.
         * @member {orderspb.IGiftDetails|null|undefined} giftDetails
         * @memberof orderspb.OrderRequest
         * @instance
         */
        OrderRequest.prototype.giftDetails = null;

        /**
         * OrderRequest ahsUserID.
         * @member {string} ahsUserID
         * @memberof orderspb.OrderRequest
         * @instance
         */
        OrderRequest.prototype.ahsUserID = "";

        /**
         * OrderRequest paymentStatus.
         * @member {orderspb.PaymentStatus} paymentStatus
         * @memberof orderspb.OrderRequest
         * @instance
         */
        OrderRequest.prototype.paymentStatus = 0;

        /**
         * OrderRequest buyerCustomerID.
         * @member {string} buyerCustomerID
         * @memberof orderspb.OrderRequest
         * @instance
         */
        OrderRequest.prototype.buyerCustomerID = "";

        /**
         * OrderRequest handOffPostID.
         * @member {string} handOffPostID
         * @memberof orderspb.OrderRequest
         * @instance
         */
        OrderRequest.prototype.handOffPostID = "";

        /**
         * OrderRequest autoRenew.
         * @member {orderspb.AutoRenew} autoRenew
         * @memberof orderspb.OrderRequest
         * @instance
         */
        OrderRequest.prototype.autoRenew = 0;

        /**
         * OrderRequest status.
         * @member {string} status
         * @memberof orderspb.OrderRequest
         * @instance
         */
        OrderRequest.prototype.status = "";

        /**
         * Creates a new OrderRequest instance using the specified properties.
         * @function create
         * @memberof orderspb.OrderRequest
         * @static
         * @param {orderspb.IOrderRequest=} [properties] Properties to set
         * @returns {orderspb.OrderRequest} OrderRequest instance
         */
        OrderRequest.create = function create(properties) {
            return new OrderRequest(properties);
        };

        /**
         * Encodes the specified OrderRequest message. Does not implicitly {@link orderspb.OrderRequest.verify|verify} messages.
         * @function encode
         * @memberof orderspb.OrderRequest
         * @static
         * @param {orderspb.IOrderRequest} m OrderRequest message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        OrderRequest.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.userName != null && Object.hasOwnProperty.call(m, "userName"))
                w.uint32(10).string(m.userName);
            if (m.salesGenerator != null && Object.hasOwnProperty.call(m, "salesGenerator"))
                w.uint32(18).string(m.salesGenerator);
            if (m.salesCloser != null && Object.hasOwnProperty.call(m, "salesCloser"))
                w.uint32(26).string(m.salesCloser);
            if (m.buyer != null && Object.hasOwnProperty.call(m, "buyer"))
                $root.orderspb.Person.encode(m.buyer, w.uint32(34).fork()).ldelim();
            if (m.coBuyer != null && Object.hasOwnProperty.call(m, "coBuyer"))
                $root.orderspb.Person.encode(m.coBuyer, w.uint32(42).fork()).ldelim();
            if (m.administrators != null && m.administrators.length) {
                for (var i = 0; i < m.administrators.length; ++i)
                    $root.orderspb.Person.encode(m.administrators[i], w.uint32(50).fork()).ldelim();
            }
            if (m.addressID != null && Object.hasOwnProperty.call(m, "addressID"))
                w.uint32(58).string(m.addressID);
            if (m.mailingAddressID != null && Object.hasOwnProperty.call(m, "mailingAddressID"))
                w.uint32(66).string(m.mailingAddressID);
            if (m.billingAddressID != null && Object.hasOwnProperty.call(m, "billingAddressID"))
                w.uint32(74).string(m.billingAddressID);
            if (m.address != null && Object.hasOwnProperty.call(m, "address"))
                $root.addresspb.Address.encode(m.address, w.uint32(82).fork()).ldelim();
            if (m.paymentDetail != null && Object.hasOwnProperty.call(m, "paymentDetail"))
                $root.orderspb.PaymentDetail.encode(m.paymentDetail, w.uint32(90).fork()).ldelim();
            if (m.salesSource != null && Object.hasOwnProperty.call(m, "salesSource"))
                w.uint32(98).string(m.salesSource);
            if (m.salesChannel != null && Object.hasOwnProperty.call(m, "salesChannel"))
                w.uint32(106).string(m.salesChannel);
            if (m.salesPartner != null && Object.hasOwnProperty.call(m, "salesPartner"))
                $root.orderspb.SalesPartner.encode(m.salesPartner, w.uint32(114).fork()).ldelim();
            if (m.sourceApplication != null && Object.hasOwnProperty.call(m, "sourceApplication"))
                w.uint32(122).string(m.sourceApplication);
            if (m.salesPersons != null && Object.hasOwnProperty.call(m, "salesPersons")) {
                for (var ks = Object.keys(m.salesPersons), i = 0; i < ks.length; ++i) {
                    w.uint32(130).fork().uint32(10).string(ks[i]);
                    $root.orderspb.SalesPerson.encode(m.salesPersons[ks[i]], w.uint32(18).fork()).ldelim().ldelim();
                }
            }
            if (m.ipAddress != null && Object.hasOwnProperty.call(m, "ipAddress"))
                w.uint32(138).string(m.ipAddress);
            if (m.eFulfillmentEnabled != null && Object.hasOwnProperty.call(m, "eFulfillmentEnabled"))
                w.uint32(144).bool(m.eFulfillmentEnabled);
            if (m.realEstate != null && Object.hasOwnProperty.call(m, "realEstate"))
                $root.orderspb.RealEstate.encode(m.realEstate, w.uint32(154).fork()).ldelim();
            if (m.processMethod != null && Object.hasOwnProperty.call(m, "processMethod"))
                w.uint32(162).string(m.processMethod);
            if (m.contractNotes != null && m.contractNotes.length) {
                for (var i = 0; i < m.contractNotes.length; ++i)
                    $root.orderspb.Note.encode(m.contractNotes[i], w.uint32(170).fork()).ldelim();
            }
            if (m.tenantID != null && Object.hasOwnProperty.call(m, "tenantID"))
                w.uint32(176).int32(m.tenantID);
            if (m.attributes != null && Object.hasOwnProperty.call(m, "attributes")) {
                for (var ks = Object.keys(m.attributes), i = 0; i < ks.length; ++i) {
                    w.uint32(186).fork().uint32(10).string(ks[i]).uint32(18).string(m.attributes[ks[i]]).ldelim();
                }
            }
            if (m.events != null && Object.hasOwnProperty.call(m, "events")) {
                for (var ks = Object.keys(m.events), i = 0; i < ks.length; ++i) {
                    w.uint32(194).fork().uint32(10).string(ks[i]).uint32(18).string(m.events[ks[i]]).ldelim();
                }
            }
            if (m.userAgent != null && Object.hasOwnProperty.call(m, "userAgent"))
                w.uint32(202).string(m.userAgent);
            if (m.orderType != null && Object.hasOwnProperty.call(m, "orderType"))
                w.uint32(208).int32(m.orderType);
            if (m.contractToModify != null && Object.hasOwnProperty.call(m, "contractToModify"))
                w.uint32(218).string(m.contractToModify);
            if (m.property != null && Object.hasOwnProperty.call(m, "property"))
                $root.propertypb.Property.encode(m.property, w.uint32(226).fork()).ldelim();
            if (m.orderExpiration != null && Object.hasOwnProperty.call(m, "orderExpiration"))
                $root.google.protobuf.Timestamp.encode(m.orderExpiration, w.uint32(234).fork()).ldelim();
            if (m.isGift != null && Object.hasOwnProperty.call(m, "isGift"))
                w.uint32(240).bool(m.isGift);
            if (m.giftDetails != null && Object.hasOwnProperty.call(m, "giftDetails"))
                $root.orderspb.GiftDetails.encode(m.giftDetails, w.uint32(250).fork()).ldelim();
            if (m.ahsUserID != null && Object.hasOwnProperty.call(m, "ahsUserID"))
                w.uint32(258).string(m.ahsUserID);
            if (m.paymentStatus != null && Object.hasOwnProperty.call(m, "paymentStatus"))
                w.uint32(264).int32(m.paymentStatus);
            if (m.buyerCustomerID != null && Object.hasOwnProperty.call(m, "buyerCustomerID"))
                w.uint32(274).string(m.buyerCustomerID);
            if (m.handOffPostID != null && Object.hasOwnProperty.call(m, "handOffPostID"))
                w.uint32(282).string(m.handOffPostID);
            if (m.autoRenew != null && Object.hasOwnProperty.call(m, "autoRenew"))
                w.uint32(288).int32(m.autoRenew);
            if (m.status != null && Object.hasOwnProperty.call(m, "status"))
                w.uint32(298).string(m.status);
            return w;
        };

        /**
         * Decodes an OrderRequest message from the specified reader or buffer.
         * @function decode
         * @memberof orderspb.OrderRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {orderspb.OrderRequest} OrderRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        OrderRequest.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.orderspb.OrderRequest(), k, value;
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.userName = r.string();
                    break;
                case 2:
                    m.salesGenerator = r.string();
                    break;
                case 3:
                    m.salesCloser = r.string();
                    break;
                case 4:
                    m.buyer = $root.orderspb.Person.decode(r, r.uint32());
                    break;
                case 5:
                    m.coBuyer = $root.orderspb.Person.decode(r, r.uint32());
                    break;
                case 6:
                    if (!(m.administrators && m.administrators.length))
                        m.administrators = [];
                    m.administrators.push($root.orderspb.Person.decode(r, r.uint32()));
                    break;
                case 7:
                    m.addressID = r.string();
                    break;
                case 8:
                    m.mailingAddressID = r.string();
                    break;
                case 9:
                    m.billingAddressID = r.string();
                    break;
                case 10:
                    m.address = $root.addresspb.Address.decode(r, r.uint32());
                    break;
                case 11:
                    m.paymentDetail = $root.orderspb.PaymentDetail.decode(r, r.uint32());
                    break;
                case 12:
                    m.salesSource = r.string();
                    break;
                case 13:
                    m.salesChannel = r.string();
                    break;
                case 14:
                    m.salesPartner = $root.orderspb.SalesPartner.decode(r, r.uint32());
                    break;
                case 15:
                    m.sourceApplication = r.string();
                    break;
                case 16:
                    if (m.salesPersons === $util.emptyObject)
                        m.salesPersons = {};
                    var c2 = r.uint32() + r.pos;
                    k = "";
                    value = null;
                    while (r.pos < c2) {
                        var tag2 = r.uint32();
                        switch (tag2 >>> 3) {
                        case 1:
                            k = r.string();
                            break;
                        case 2:
                            value = $root.orderspb.SalesPerson.decode(r, r.uint32());
                            break;
                        default:
                            r.skipType(tag2 & 7);
                            break;
                        }
                    }
                    m.salesPersons[k] = value;
                    break;
                case 17:
                    m.ipAddress = r.string();
                    break;
                case 18:
                    m.eFulfillmentEnabled = r.bool();
                    break;
                case 19:
                    m.realEstate = $root.orderspb.RealEstate.decode(r, r.uint32());
                    break;
                case 20:
                    m.processMethod = r.string();
                    break;
                case 21:
                    if (!(m.contractNotes && m.contractNotes.length))
                        m.contractNotes = [];
                    m.contractNotes.push($root.orderspb.Note.decode(r, r.uint32()));
                    break;
                case 22:
                    m.tenantID = r.int32();
                    break;
                case 23:
                    if (m.attributes === $util.emptyObject)
                        m.attributes = {};
                    var c2 = r.uint32() + r.pos;
                    k = "";
                    value = "";
                    while (r.pos < c2) {
                        var tag2 = r.uint32();
                        switch (tag2 >>> 3) {
                        case 1:
                            k = r.string();
                            break;
                        case 2:
                            value = r.string();
                            break;
                        default:
                            r.skipType(tag2 & 7);
                            break;
                        }
                    }
                    m.attributes[k] = value;
                    break;
                case 24:
                    if (m.events === $util.emptyObject)
                        m.events = {};
                    var c2 = r.uint32() + r.pos;
                    k = "";
                    value = "";
                    while (r.pos < c2) {
                        var tag2 = r.uint32();
                        switch (tag2 >>> 3) {
                        case 1:
                            k = r.string();
                            break;
                        case 2:
                            value = r.string();
                            break;
                        default:
                            r.skipType(tag2 & 7);
                            break;
                        }
                    }
                    m.events[k] = value;
                    break;
                case 25:
                    m.userAgent = r.string();
                    break;
                case 26:
                    m.orderType = r.int32();
                    break;
                case 27:
                    m.contractToModify = r.string();
                    break;
                case 28:
                    m.property = $root.propertypb.Property.decode(r, r.uint32());
                    break;
                case 29:
                    m.orderExpiration = $root.google.protobuf.Timestamp.decode(r, r.uint32());
                    break;
                case 30:
                    m.isGift = r.bool();
                    break;
                case 31:
                    m.giftDetails = $root.orderspb.GiftDetails.decode(r, r.uint32());
                    break;
                case 32:
                    m.ahsUserID = r.string();
                    break;
                case 33:
                    m.paymentStatus = r.int32();
                    break;
                case 34:
                    m.buyerCustomerID = r.string();
                    break;
                case 35:
                    m.handOffPostID = r.string();
                    break;
                case 36:
                    m.autoRenew = r.int32();
                    break;
                case 37:
                    m.status = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return OrderRequest;
    })();

    orderspb.OrderUpdateRequest = (function() {

        /**
         * Properties of an OrderUpdateRequest.
         * @memberof orderspb
         * @interface IOrderUpdateRequest
         * @property {string|null} [userName] OrderUpdateRequest userName
         * @property {string|null} [salesGenerator] OrderUpdateRequest salesGenerator
         * @property {string|null} [salesCloser] OrderUpdateRequest salesCloser
         * @property {string|null} [salesSource] OrderUpdateRequest salesSource
         * @property {string|null} [salesChannel] OrderUpdateRequest salesChannel
         * @property {orderspb.ISalesPartner|null} [salesPartner] OrderUpdateRequest salesPartner
         * @property {string|null} [contractID] OrderUpdateRequest contractID
         * @property {boolean|null} [eFulfillmentEnabled] OrderUpdateRequest eFulfillmentEnabled
         * @property {orderspb.IPaymentDetail|null} [paymentDetail] OrderUpdateRequest paymentDetail
         * @property {orderspb.IPerson|null} [buyer] OrderUpdateRequest buyer
         * @property {string|null} [validate] OrderUpdateRequest validate
         * @property {orderspb.IRealEstate|null} [realEstate] OrderUpdateRequest realEstate
         * @property {common.Tenant|null} [tenantID] OrderUpdateRequest tenantID
         * @property {orderspb.ILeadInfo|null} [leadInfo] OrderUpdateRequest leadInfo
         * @property {google.protobuf.IStringValue|null} [sourceApplication] OrderUpdateRequest sourceApplication
         * @property {google.protobuf.IStringValue|null} [propertyAddressID] OrderUpdateRequest propertyAddressID
         * @property {google.protobuf.IStringValue|null} [billingAddressID] OrderUpdateRequest billingAddressID
         * @property {google.protobuf.IStringValue|null} [mailingAddressID] OrderUpdateRequest mailingAddressID
         * @property {addresspb.IAddress|null} [propertyAddress] OrderUpdateRequest propertyAddress
         * @property {orderspb.IPerson|null} [coBuyer] OrderUpdateRequest coBuyer
         * @property {propertypb.IProperty|null} [Property] OrderUpdateRequest Property
         * @property {orderspb.OrderType|null} [orderType] OrderUpdateRequest orderType
         * @property {Object.<string,string>|null} [attributes] OrderUpdateRequest attributes
         * @property {google.protobuf.ITimestamp|null} [orderExpiration] OrderUpdateRequest orderExpiration
         * @property {boolean|null} [isGift] OrderUpdateRequest isGift
         * @property {orderspb.IGiftDetails|null} [giftDetails] OrderUpdateRequest giftDetails
         * @property {string|null} [ahsUserID] OrderUpdateRequest ahsUserID
         * @property {orderspb.PaymentStatus|null} [paymentStatus] OrderUpdateRequest paymentStatus
         * @property {string|null} [buyerCustomerID] OrderUpdateRequest buyerCustomerID
         * @property {orderspb.AutoRenew|null} [autoRenew] OrderUpdateRequest autoRenew
         */

        /**
         * Constructs a new OrderUpdateRequest.
         * @memberof orderspb
         * @classdesc Represents an OrderUpdateRequest.
         * @implements IOrderUpdateRequest
         * @constructor
         * @param {orderspb.IOrderUpdateRequest=} [p] Properties to set
         */
        function OrderUpdateRequest(p) {
            this.attributes = {};
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * OrderUpdateRequest userName.
         * @member {string} userName
         * @memberof orderspb.OrderUpdateRequest
         * @instance
         */
        OrderUpdateRequest.prototype.userName = "";

        /**
         * OrderUpdateRequest salesGenerator.
         * @member {string} salesGenerator
         * @memberof orderspb.OrderUpdateRequest
         * @instance
         */
        OrderUpdateRequest.prototype.salesGenerator = "";

        /**
         * OrderUpdateRequest salesCloser.
         * @member {string} salesCloser
         * @memberof orderspb.OrderUpdateRequest
         * @instance
         */
        OrderUpdateRequest.prototype.salesCloser = "";

        /**
         * OrderUpdateRequest salesSource.
         * @member {string} salesSource
         * @memberof orderspb.OrderUpdateRequest
         * @instance
         */
        OrderUpdateRequest.prototype.salesSource = "";

        /**
         * OrderUpdateRequest salesChannel.
         * @member {string} salesChannel
         * @memberof orderspb.OrderUpdateRequest
         * @instance
         */
        OrderUpdateRequest.prototype.salesChannel = "";

        /**
         * OrderUpdateRequest salesPartner.
         * @member {orderspb.ISalesPartner|null|undefined} salesPartner
         * @memberof orderspb.OrderUpdateRequest
         * @instance
         */
        OrderUpdateRequest.prototype.salesPartner = null;

        /**
         * OrderUpdateRequest contractID.
         * @member {string} contractID
         * @memberof orderspb.OrderUpdateRequest
         * @instance
         */
        OrderUpdateRequest.prototype.contractID = "";

        /**
         * OrderUpdateRequest eFulfillmentEnabled.
         * @member {boolean} eFulfillmentEnabled
         * @memberof orderspb.OrderUpdateRequest
         * @instance
         */
        OrderUpdateRequest.prototype.eFulfillmentEnabled = false;

        /**
         * OrderUpdateRequest paymentDetail.
         * @member {orderspb.IPaymentDetail|null|undefined} paymentDetail
         * @memberof orderspb.OrderUpdateRequest
         * @instance
         */
        OrderUpdateRequest.prototype.paymentDetail = null;

        /**
         * OrderUpdateRequest buyer.
         * @member {orderspb.IPerson|null|undefined} buyer
         * @memberof orderspb.OrderUpdateRequest
         * @instance
         */
        OrderUpdateRequest.prototype.buyer = null;

        /**
         * OrderUpdateRequest validate.
         * @member {string} validate
         * @memberof orderspb.OrderUpdateRequest
         * @instance
         */
        OrderUpdateRequest.prototype.validate = "";

        /**
         * OrderUpdateRequest realEstate.
         * @member {orderspb.IRealEstate|null|undefined} realEstate
         * @memberof orderspb.OrderUpdateRequest
         * @instance
         */
        OrderUpdateRequest.prototype.realEstate = null;

        /**
         * OrderUpdateRequest tenantID.
         * @member {common.Tenant} tenantID
         * @memberof orderspb.OrderUpdateRequest
         * @instance
         */
        OrderUpdateRequest.prototype.tenantID = 0;

        /**
         * OrderUpdateRequest leadInfo.
         * @member {orderspb.ILeadInfo|null|undefined} leadInfo
         * @memberof orderspb.OrderUpdateRequest
         * @instance
         */
        OrderUpdateRequest.prototype.leadInfo = null;

        /**
         * OrderUpdateRequest sourceApplication.
         * @member {google.protobuf.IStringValue|null|undefined} sourceApplication
         * @memberof orderspb.OrderUpdateRequest
         * @instance
         */
        OrderUpdateRequest.prototype.sourceApplication = null;

        /**
         * OrderUpdateRequest propertyAddressID.
         * @member {google.protobuf.IStringValue|null|undefined} propertyAddressID
         * @memberof orderspb.OrderUpdateRequest
         * @instance
         */
        OrderUpdateRequest.prototype.propertyAddressID = null;

        /**
         * OrderUpdateRequest billingAddressID.
         * @member {google.protobuf.IStringValue|null|undefined} billingAddressID
         * @memberof orderspb.OrderUpdateRequest
         * @instance
         */
        OrderUpdateRequest.prototype.billingAddressID = null;

        /**
         * OrderUpdateRequest mailingAddressID.
         * @member {google.protobuf.IStringValue|null|undefined} mailingAddressID
         * @memberof orderspb.OrderUpdateRequest
         * @instance
         */
        OrderUpdateRequest.prototype.mailingAddressID = null;

        /**
         * OrderUpdateRequest propertyAddress.
         * @member {addresspb.IAddress|null|undefined} propertyAddress
         * @memberof orderspb.OrderUpdateRequest
         * @instance
         */
        OrderUpdateRequest.prototype.propertyAddress = null;

        /**
         * OrderUpdateRequest coBuyer.
         * @member {orderspb.IPerson|null|undefined} coBuyer
         * @memberof orderspb.OrderUpdateRequest
         * @instance
         */
        OrderUpdateRequest.prototype.coBuyer = null;

        /**
         * OrderUpdateRequest Property.
         * @member {propertypb.IProperty|null|undefined} Property
         * @memberof orderspb.OrderUpdateRequest
         * @instance
         */
        OrderUpdateRequest.prototype.Property = null;

        /**
         * OrderUpdateRequest orderType.
         * @member {orderspb.OrderType} orderType
         * @memberof orderspb.OrderUpdateRequest
         * @instance
         */
        OrderUpdateRequest.prototype.orderType = 0;

        /**
         * OrderUpdateRequest attributes.
         * @member {Object.<string,string>} attributes
         * @memberof orderspb.OrderUpdateRequest
         * @instance
         */
        OrderUpdateRequest.prototype.attributes = $util.emptyObject;

        /**
         * OrderUpdateRequest orderExpiration.
         * @member {google.protobuf.ITimestamp|null|undefined} orderExpiration
         * @memberof orderspb.OrderUpdateRequest
         * @instance
         */
        OrderUpdateRequest.prototype.orderExpiration = null;

        /**
         * OrderUpdateRequest isGift.
         * @member {boolean} isGift
         * @memberof orderspb.OrderUpdateRequest
         * @instance
         */
        OrderUpdateRequest.prototype.isGift = false;

        /**
         * OrderUpdateRequest giftDetails.
         * @member {orderspb.IGiftDetails|null|undefined} giftDetails
         * @memberof orderspb.OrderUpdateRequest
         * @instance
         */
        OrderUpdateRequest.prototype.giftDetails = null;

        /**
         * OrderUpdateRequest ahsUserID.
         * @member {string} ahsUserID
         * @memberof orderspb.OrderUpdateRequest
         * @instance
         */
        OrderUpdateRequest.prototype.ahsUserID = "";

        /**
         * OrderUpdateRequest paymentStatus.
         * @member {orderspb.PaymentStatus} paymentStatus
         * @memberof orderspb.OrderUpdateRequest
         * @instance
         */
        OrderUpdateRequest.prototype.paymentStatus = 0;

        /**
         * OrderUpdateRequest buyerCustomerID.
         * @member {string} buyerCustomerID
         * @memberof orderspb.OrderUpdateRequest
         * @instance
         */
        OrderUpdateRequest.prototype.buyerCustomerID = "";

        /**
         * OrderUpdateRequest autoRenew.
         * @member {orderspb.AutoRenew} autoRenew
         * @memberof orderspb.OrderUpdateRequest
         * @instance
         */
        OrderUpdateRequest.prototype.autoRenew = 0;

        /**
         * Creates a new OrderUpdateRequest instance using the specified properties.
         * @function create
         * @memberof orderspb.OrderUpdateRequest
         * @static
         * @param {orderspb.IOrderUpdateRequest=} [properties] Properties to set
         * @returns {orderspb.OrderUpdateRequest} OrderUpdateRequest instance
         */
        OrderUpdateRequest.create = function create(properties) {
            return new OrderUpdateRequest(properties);
        };

        /**
         * Encodes the specified OrderUpdateRequest message. Does not implicitly {@link orderspb.OrderUpdateRequest.verify|verify} messages.
         * @function encode
         * @memberof orderspb.OrderUpdateRequest
         * @static
         * @param {orderspb.IOrderUpdateRequest} m OrderUpdateRequest message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        OrderUpdateRequest.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.userName != null && Object.hasOwnProperty.call(m, "userName"))
                w.uint32(10).string(m.userName);
            if (m.salesGenerator != null && Object.hasOwnProperty.call(m, "salesGenerator"))
                w.uint32(18).string(m.salesGenerator);
            if (m.salesCloser != null && Object.hasOwnProperty.call(m, "salesCloser"))
                w.uint32(26).string(m.salesCloser);
            if (m.salesSource != null && Object.hasOwnProperty.call(m, "salesSource"))
                w.uint32(34).string(m.salesSource);
            if (m.salesChannel != null && Object.hasOwnProperty.call(m, "salesChannel"))
                w.uint32(42).string(m.salesChannel);
            if (m.salesPartner != null && Object.hasOwnProperty.call(m, "salesPartner"))
                $root.orderspb.SalesPartner.encode(m.salesPartner, w.uint32(50).fork()).ldelim();
            if (m.contractID != null && Object.hasOwnProperty.call(m, "contractID"))
                w.uint32(58).string(m.contractID);
            if (m.eFulfillmentEnabled != null && Object.hasOwnProperty.call(m, "eFulfillmentEnabled"))
                w.uint32(64).bool(m.eFulfillmentEnabled);
            if (m.paymentDetail != null && Object.hasOwnProperty.call(m, "paymentDetail"))
                $root.orderspb.PaymentDetail.encode(m.paymentDetail, w.uint32(74).fork()).ldelim();
            if (m.buyer != null && Object.hasOwnProperty.call(m, "buyer"))
                $root.orderspb.Person.encode(m.buyer, w.uint32(82).fork()).ldelim();
            if (m.validate != null && Object.hasOwnProperty.call(m, "validate"))
                w.uint32(90).string(m.validate);
            if (m.realEstate != null && Object.hasOwnProperty.call(m, "realEstate"))
                $root.orderspb.RealEstate.encode(m.realEstate, w.uint32(98).fork()).ldelim();
            if (m.tenantID != null && Object.hasOwnProperty.call(m, "tenantID"))
                w.uint32(104).int32(m.tenantID);
            if (m.leadInfo != null && Object.hasOwnProperty.call(m, "leadInfo"))
                $root.orderspb.LeadInfo.encode(m.leadInfo, w.uint32(114).fork()).ldelim();
            if (m.sourceApplication != null && Object.hasOwnProperty.call(m, "sourceApplication"))
                $root.google.protobuf.StringValue.encode(m.sourceApplication, w.uint32(122).fork()).ldelim();
            if (m.propertyAddressID != null && Object.hasOwnProperty.call(m, "propertyAddressID"))
                $root.google.protobuf.StringValue.encode(m.propertyAddressID, w.uint32(130).fork()).ldelim();
            if (m.billingAddressID != null && Object.hasOwnProperty.call(m, "billingAddressID"))
                $root.google.protobuf.StringValue.encode(m.billingAddressID, w.uint32(138).fork()).ldelim();
            if (m.mailingAddressID != null && Object.hasOwnProperty.call(m, "mailingAddressID"))
                $root.google.protobuf.StringValue.encode(m.mailingAddressID, w.uint32(146).fork()).ldelim();
            if (m.propertyAddress != null && Object.hasOwnProperty.call(m, "propertyAddress"))
                $root.addresspb.Address.encode(m.propertyAddress, w.uint32(154).fork()).ldelim();
            if (m.coBuyer != null && Object.hasOwnProperty.call(m, "coBuyer"))
                $root.orderspb.Person.encode(m.coBuyer, w.uint32(162).fork()).ldelim();
            if (m.Property != null && Object.hasOwnProperty.call(m, "Property"))
                $root.propertypb.Property.encode(m.Property, w.uint32(170).fork()).ldelim();
            if (m.orderType != null && Object.hasOwnProperty.call(m, "orderType"))
                w.uint32(176).int32(m.orderType);
            if (m.attributes != null && Object.hasOwnProperty.call(m, "attributes")) {
                for (var ks = Object.keys(m.attributes), i = 0; i < ks.length; ++i) {
                    w.uint32(186).fork().uint32(10).string(ks[i]).uint32(18).string(m.attributes[ks[i]]).ldelim();
                }
            }
            if (m.orderExpiration != null && Object.hasOwnProperty.call(m, "orderExpiration"))
                $root.google.protobuf.Timestamp.encode(m.orderExpiration, w.uint32(194).fork()).ldelim();
            if (m.isGift != null && Object.hasOwnProperty.call(m, "isGift"))
                w.uint32(200).bool(m.isGift);
            if (m.giftDetails != null && Object.hasOwnProperty.call(m, "giftDetails"))
                $root.orderspb.GiftDetails.encode(m.giftDetails, w.uint32(210).fork()).ldelim();
            if (m.ahsUserID != null && Object.hasOwnProperty.call(m, "ahsUserID"))
                w.uint32(218).string(m.ahsUserID);
            if (m.paymentStatus != null && Object.hasOwnProperty.call(m, "paymentStatus"))
                w.uint32(224).int32(m.paymentStatus);
            if (m.buyerCustomerID != null && Object.hasOwnProperty.call(m, "buyerCustomerID"))
                w.uint32(234).string(m.buyerCustomerID);
            if (m.autoRenew != null && Object.hasOwnProperty.call(m, "autoRenew"))
                w.uint32(240).int32(m.autoRenew);
            return w;
        };

        /**
         * Decodes an OrderUpdateRequest message from the specified reader or buffer.
         * @function decode
         * @memberof orderspb.OrderUpdateRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {orderspb.OrderUpdateRequest} OrderUpdateRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        OrderUpdateRequest.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.orderspb.OrderUpdateRequest(), k, value;
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.userName = r.string();
                    break;
                case 2:
                    m.salesGenerator = r.string();
                    break;
                case 3:
                    m.salesCloser = r.string();
                    break;
                case 4:
                    m.salesSource = r.string();
                    break;
                case 5:
                    m.salesChannel = r.string();
                    break;
                case 6:
                    m.salesPartner = $root.orderspb.SalesPartner.decode(r, r.uint32());
                    break;
                case 7:
                    m.contractID = r.string();
                    break;
                case 8:
                    m.eFulfillmentEnabled = r.bool();
                    break;
                case 9:
                    m.paymentDetail = $root.orderspb.PaymentDetail.decode(r, r.uint32());
                    break;
                case 10:
                    m.buyer = $root.orderspb.Person.decode(r, r.uint32());
                    break;
                case 11:
                    m.validate = r.string();
                    break;
                case 12:
                    m.realEstate = $root.orderspb.RealEstate.decode(r, r.uint32());
                    break;
                case 13:
                    m.tenantID = r.int32();
                    break;
                case 14:
                    m.leadInfo = $root.orderspb.LeadInfo.decode(r, r.uint32());
                    break;
                case 15:
                    m.sourceApplication = $root.google.protobuf.StringValue.decode(r, r.uint32());
                    break;
                case 16:
                    m.propertyAddressID = $root.google.protobuf.StringValue.decode(r, r.uint32());
                    break;
                case 17:
                    m.billingAddressID = $root.google.protobuf.StringValue.decode(r, r.uint32());
                    break;
                case 18:
                    m.mailingAddressID = $root.google.protobuf.StringValue.decode(r, r.uint32());
                    break;
                case 19:
                    m.propertyAddress = $root.addresspb.Address.decode(r, r.uint32());
                    break;
                case 20:
                    m.coBuyer = $root.orderspb.Person.decode(r, r.uint32());
                    break;
                case 21:
                    m.Property = $root.propertypb.Property.decode(r, r.uint32());
                    break;
                case 22:
                    m.orderType = r.int32();
                    break;
                case 23:
                    if (m.attributes === $util.emptyObject)
                        m.attributes = {};
                    var c2 = r.uint32() + r.pos;
                    k = "";
                    value = "";
                    while (r.pos < c2) {
                        var tag2 = r.uint32();
                        switch (tag2 >>> 3) {
                        case 1:
                            k = r.string();
                            break;
                        case 2:
                            value = r.string();
                            break;
                        default:
                            r.skipType(tag2 & 7);
                            break;
                        }
                    }
                    m.attributes[k] = value;
                    break;
                case 24:
                    m.orderExpiration = $root.google.protobuf.Timestamp.decode(r, r.uint32());
                    break;
                case 25:
                    m.isGift = r.bool();
                    break;
                case 26:
                    m.giftDetails = $root.orderspb.GiftDetails.decode(r, r.uint32());
                    break;
                case 27:
                    m.ahsUserID = r.string();
                    break;
                case 28:
                    m.paymentStatus = r.int32();
                    break;
                case 29:
                    m.buyerCustomerID = r.string();
                    break;
                case 30:
                    m.autoRenew = r.int32();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return OrderUpdateRequest;
    })();

    orderspb.OrderQuoteUpdateRequest = (function() {

        /**
         * Properties of an OrderQuoteUpdateRequest.
         * @memberof orderspb
         * @interface IOrderQuoteUpdateRequest
         * @property {string|null} [quoteID] OrderQuoteUpdateRequest quoteID
         * @property {google.protobuf.ITimestamp|null} [quoteExpiration] OrderQuoteUpdateRequest quoteExpiration
         */

        /**
         * Constructs a new OrderQuoteUpdateRequest.
         * @memberof orderspb
         * @classdesc Represents an OrderQuoteUpdateRequest.
         * @implements IOrderQuoteUpdateRequest
         * @constructor
         * @param {orderspb.IOrderQuoteUpdateRequest=} [p] Properties to set
         */
        function OrderQuoteUpdateRequest(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * OrderQuoteUpdateRequest quoteID.
         * @member {string} quoteID
         * @memberof orderspb.OrderQuoteUpdateRequest
         * @instance
         */
        OrderQuoteUpdateRequest.prototype.quoteID = "";

        /**
         * OrderQuoteUpdateRequest quoteExpiration.
         * @member {google.protobuf.ITimestamp|null|undefined} quoteExpiration
         * @memberof orderspb.OrderQuoteUpdateRequest
         * @instance
         */
        OrderQuoteUpdateRequest.prototype.quoteExpiration = null;

        /**
         * Creates a new OrderQuoteUpdateRequest instance using the specified properties.
         * @function create
         * @memberof orderspb.OrderQuoteUpdateRequest
         * @static
         * @param {orderspb.IOrderQuoteUpdateRequest=} [properties] Properties to set
         * @returns {orderspb.OrderQuoteUpdateRequest} OrderQuoteUpdateRequest instance
         */
        OrderQuoteUpdateRequest.create = function create(properties) {
            return new OrderQuoteUpdateRequest(properties);
        };

        /**
         * Encodes the specified OrderQuoteUpdateRequest message. Does not implicitly {@link orderspb.OrderQuoteUpdateRequest.verify|verify} messages.
         * @function encode
         * @memberof orderspb.OrderQuoteUpdateRequest
         * @static
         * @param {orderspb.IOrderQuoteUpdateRequest} m OrderQuoteUpdateRequest message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        OrderQuoteUpdateRequest.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.quoteID != null && Object.hasOwnProperty.call(m, "quoteID"))
                w.uint32(10).string(m.quoteID);
            if (m.quoteExpiration != null && Object.hasOwnProperty.call(m, "quoteExpiration"))
                $root.google.protobuf.Timestamp.encode(m.quoteExpiration, w.uint32(18).fork()).ldelim();
            return w;
        };

        /**
         * Decodes an OrderQuoteUpdateRequest message from the specified reader or buffer.
         * @function decode
         * @memberof orderspb.OrderQuoteUpdateRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {orderspb.OrderQuoteUpdateRequest} OrderQuoteUpdateRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        OrderQuoteUpdateRequest.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.orderspb.OrderQuoteUpdateRequest();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.quoteID = r.string();
                    break;
                case 2:
                    m.quoteExpiration = $root.google.protobuf.Timestamp.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return OrderQuoteUpdateRequest;
    })();

    orderspb.SalesPerson = (function() {

        /**
         * Properties of a SalesPerson.
         * @memberof orderspb
         * @interface ISalesPerson
         * @property {string|null} [eventCount] SalesPerson eventCount
         * @property {google.protobuf.ITimestamp|null} [lastEventTime] SalesPerson lastEventTime
         */

        /**
         * Constructs a new SalesPerson.
         * @memberof orderspb
         * @classdesc Represents a SalesPerson.
         * @implements ISalesPerson
         * @constructor
         * @param {orderspb.ISalesPerson=} [p] Properties to set
         */
        function SalesPerson(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * SalesPerson eventCount.
         * @member {string} eventCount
         * @memberof orderspb.SalesPerson
         * @instance
         */
        SalesPerson.prototype.eventCount = "";

        /**
         * SalesPerson lastEventTime.
         * @member {google.protobuf.ITimestamp|null|undefined} lastEventTime
         * @memberof orderspb.SalesPerson
         * @instance
         */
        SalesPerson.prototype.lastEventTime = null;

        /**
         * Creates a new SalesPerson instance using the specified properties.
         * @function create
         * @memberof orderspb.SalesPerson
         * @static
         * @param {orderspb.ISalesPerson=} [properties] Properties to set
         * @returns {orderspb.SalesPerson} SalesPerson instance
         */
        SalesPerson.create = function create(properties) {
            return new SalesPerson(properties);
        };

        /**
         * Encodes the specified SalesPerson message. Does not implicitly {@link orderspb.SalesPerson.verify|verify} messages.
         * @function encode
         * @memberof orderspb.SalesPerson
         * @static
         * @param {orderspb.ISalesPerson} m SalesPerson message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SalesPerson.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.eventCount != null && Object.hasOwnProperty.call(m, "eventCount"))
                w.uint32(10).string(m.eventCount);
            if (m.lastEventTime != null && Object.hasOwnProperty.call(m, "lastEventTime"))
                $root.google.protobuf.Timestamp.encode(m.lastEventTime, w.uint32(18).fork()).ldelim();
            return w;
        };

        /**
         * Decodes a SalesPerson message from the specified reader or buffer.
         * @function decode
         * @memberof orderspb.SalesPerson
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {orderspb.SalesPerson} SalesPerson
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SalesPerson.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.orderspb.SalesPerson();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.eventCount = r.string();
                    break;
                case 2:
                    m.lastEventTime = $root.google.protobuf.Timestamp.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return SalesPerson;
    })();

    orderspb.AttributeValue = (function() {

        /**
         * Properties of an AttributeValue.
         * @memberof orderspb
         * @interface IAttributeValue
         * @property {string|null} [value] AttributeValue value
         */

        /**
         * Constructs a new AttributeValue.
         * @memberof orderspb
         * @classdesc Represents an AttributeValue.
         * @implements IAttributeValue
         * @constructor
         * @param {orderspb.IAttributeValue=} [p] Properties to set
         */
        function AttributeValue(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * AttributeValue value.
         * @member {string} value
         * @memberof orderspb.AttributeValue
         * @instance
         */
        AttributeValue.prototype.value = "";

        /**
         * Creates a new AttributeValue instance using the specified properties.
         * @function create
         * @memberof orderspb.AttributeValue
         * @static
         * @param {orderspb.IAttributeValue=} [properties] Properties to set
         * @returns {orderspb.AttributeValue} AttributeValue instance
         */
        AttributeValue.create = function create(properties) {
            return new AttributeValue(properties);
        };

        /**
         * Encodes the specified AttributeValue message. Does not implicitly {@link orderspb.AttributeValue.verify|verify} messages.
         * @function encode
         * @memberof orderspb.AttributeValue
         * @static
         * @param {orderspb.IAttributeValue} m AttributeValue message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AttributeValue.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.value != null && Object.hasOwnProperty.call(m, "value"))
                w.uint32(10).string(m.value);
            return w;
        };

        /**
         * Decodes an AttributeValue message from the specified reader or buffer.
         * @function decode
         * @memberof orderspb.AttributeValue
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {orderspb.AttributeValue} AttributeValue
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AttributeValue.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.orderspb.AttributeValue();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.value = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return AttributeValue;
    })();

    orderspb.RealEstate = (function() {

        /**
         * Properties of a RealEstate.
         * @memberof orderspb
         * @interface IRealEstate
         * @property {orderspb.IRealEstateOffice|null} [initiatingOffice] RealEstate initiatingOffice
         * @property {orderspb.IRealEstateOffice|null} [cooperatingOffice] RealEstate cooperatingOffice
         * @property {orderspb.IRealEstateOffice|null} [closingOffice] RealEstate closingOffice
         * @property {string|null} [escrowNumber] RealEstate escrowNumber
         * @property {orderspb.IPerson|null} [caller] RealEstate caller
         * @property {orderspb.IPerson|null} [seller] RealEstate seller
         * @property {orderspb.IPerson|null} [coSeller] RealEstate coSeller
         * @property {Array.<orderspb.IRecipient>|null} [confirmationEmailRecipients] RealEstate confirmationEmailRecipients
         * @property {Array.<orderspb.IRecipient>|null} [invoiceRecipients] RealEstate invoiceRecipients
         * @property {google.protobuf.ITimestamp|null} [estimatedClosingDate] RealEstate estimatedClosingDate
         * @property {string|null} [callerRole] RealEstate callerRole
         * @property {number|null} [guestUnit] RealEstate guestUnit
         * @property {orderspb.IDates|null} [listingDate] RealEstate listingDate
         * @property {orderspb.IDates|null} [listingCoverage] RealEstate listingCoverage
         * @property {orderspb.IOrderQuoteUpdateRequest|null} [quoteDetails] RealEstate quoteDetails
         * @property {string|null} [proratedContractId] RealEstate proratedContractId
         * @property {string|null} [mlsValue] RealEstate mlsValue
         * @property {orderspb.ICancellation|null} [cancellation] RealEstate cancellation
         * @property {google.protobuf.ITimestamp|null} [quoteSharedDate] RealEstate quoteSharedDate
         * @property {orderspb.IBuyerPay|null} [buyerPay] RealEstate buyerPay
         */

        /**
         * Constructs a new RealEstate.
         * @memberof orderspb
         * @classdesc Represents a RealEstate.
         * @implements IRealEstate
         * @constructor
         * @param {orderspb.IRealEstate=} [p] Properties to set
         */
        function RealEstate(p) {
            this.confirmationEmailRecipients = [];
            this.invoiceRecipients = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * RealEstate initiatingOffice.
         * @member {orderspb.IRealEstateOffice|null|undefined} initiatingOffice
         * @memberof orderspb.RealEstate
         * @instance
         */
        RealEstate.prototype.initiatingOffice = null;

        /**
         * RealEstate cooperatingOffice.
         * @member {orderspb.IRealEstateOffice|null|undefined} cooperatingOffice
         * @memberof orderspb.RealEstate
         * @instance
         */
        RealEstate.prototype.cooperatingOffice = null;

        /**
         * RealEstate closingOffice.
         * @member {orderspb.IRealEstateOffice|null|undefined} closingOffice
         * @memberof orderspb.RealEstate
         * @instance
         */
        RealEstate.prototype.closingOffice = null;

        /**
         * RealEstate escrowNumber.
         * @member {string} escrowNumber
         * @memberof orderspb.RealEstate
         * @instance
         */
        RealEstate.prototype.escrowNumber = "";

        /**
         * RealEstate caller.
         * @member {orderspb.IPerson|null|undefined} caller
         * @memberof orderspb.RealEstate
         * @instance
         */
        RealEstate.prototype.caller = null;

        /**
         * RealEstate seller.
         * @member {orderspb.IPerson|null|undefined} seller
         * @memberof orderspb.RealEstate
         * @instance
         */
        RealEstate.prototype.seller = null;

        /**
         * RealEstate coSeller.
         * @member {orderspb.IPerson|null|undefined} coSeller
         * @memberof orderspb.RealEstate
         * @instance
         */
        RealEstate.prototype.coSeller = null;

        /**
         * RealEstate confirmationEmailRecipients.
         * @member {Array.<orderspb.IRecipient>} confirmationEmailRecipients
         * @memberof orderspb.RealEstate
         * @instance
         */
        RealEstate.prototype.confirmationEmailRecipients = $util.emptyArray;

        /**
         * RealEstate invoiceRecipients.
         * @member {Array.<orderspb.IRecipient>} invoiceRecipients
         * @memberof orderspb.RealEstate
         * @instance
         */
        RealEstate.prototype.invoiceRecipients = $util.emptyArray;

        /**
         * RealEstate estimatedClosingDate.
         * @member {google.protobuf.ITimestamp|null|undefined} estimatedClosingDate
         * @memberof orderspb.RealEstate
         * @instance
         */
        RealEstate.prototype.estimatedClosingDate = null;

        /**
         * RealEstate callerRole.
         * @member {string} callerRole
         * @memberof orderspb.RealEstate
         * @instance
         */
        RealEstate.prototype.callerRole = "";

        /**
         * RealEstate guestUnit.
         * @member {number} guestUnit
         * @memberof orderspb.RealEstate
         * @instance
         */
        RealEstate.prototype.guestUnit = 0;

        /**
         * RealEstate listingDate.
         * @member {orderspb.IDates|null|undefined} listingDate
         * @memberof orderspb.RealEstate
         * @instance
         */
        RealEstate.prototype.listingDate = null;

        /**
         * RealEstate listingCoverage.
         * @member {orderspb.IDates|null|undefined} listingCoverage
         * @memberof orderspb.RealEstate
         * @instance
         */
        RealEstate.prototype.listingCoverage = null;

        /**
         * RealEstate quoteDetails.
         * @member {orderspb.IOrderQuoteUpdateRequest|null|undefined} quoteDetails
         * @memberof orderspb.RealEstate
         * @instance
         */
        RealEstate.prototype.quoteDetails = null;

        /**
         * RealEstate proratedContractId.
         * @member {string} proratedContractId
         * @memberof orderspb.RealEstate
         * @instance
         */
        RealEstate.prototype.proratedContractId = "";

        /**
         * RealEstate mlsValue.
         * @member {string} mlsValue
         * @memberof orderspb.RealEstate
         * @instance
         */
        RealEstate.prototype.mlsValue = "";

        /**
         * RealEstate cancellation.
         * @member {orderspb.ICancellation|null|undefined} cancellation
         * @memberof orderspb.RealEstate
         * @instance
         */
        RealEstate.prototype.cancellation = null;

        /**
         * RealEstate quoteSharedDate.
         * @member {google.protobuf.ITimestamp|null|undefined} quoteSharedDate
         * @memberof orderspb.RealEstate
         * @instance
         */
        RealEstate.prototype.quoteSharedDate = null;

        /**
         * RealEstate buyerPay.
         * @member {orderspb.IBuyerPay|null|undefined} buyerPay
         * @memberof orderspb.RealEstate
         * @instance
         */
        RealEstate.prototype.buyerPay = null;

        /**
         * Creates a new RealEstate instance using the specified properties.
         * @function create
         * @memberof orderspb.RealEstate
         * @static
         * @param {orderspb.IRealEstate=} [properties] Properties to set
         * @returns {orderspb.RealEstate} RealEstate instance
         */
        RealEstate.create = function create(properties) {
            return new RealEstate(properties);
        };

        /**
         * Encodes the specified RealEstate message. Does not implicitly {@link orderspb.RealEstate.verify|verify} messages.
         * @function encode
         * @memberof orderspb.RealEstate
         * @static
         * @param {orderspb.IRealEstate} m RealEstate message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RealEstate.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.initiatingOffice != null && Object.hasOwnProperty.call(m, "initiatingOffice"))
                $root.orderspb.RealEstateOffice.encode(m.initiatingOffice, w.uint32(10).fork()).ldelim();
            if (m.cooperatingOffice != null && Object.hasOwnProperty.call(m, "cooperatingOffice"))
                $root.orderspb.RealEstateOffice.encode(m.cooperatingOffice, w.uint32(18).fork()).ldelim();
            if (m.closingOffice != null && Object.hasOwnProperty.call(m, "closingOffice"))
                $root.orderspb.RealEstateOffice.encode(m.closingOffice, w.uint32(26).fork()).ldelim();
            if (m.escrowNumber != null && Object.hasOwnProperty.call(m, "escrowNumber"))
                w.uint32(34).string(m.escrowNumber);
            if (m.caller != null && Object.hasOwnProperty.call(m, "caller"))
                $root.orderspb.Person.encode(m.caller, w.uint32(42).fork()).ldelim();
            if (m.seller != null && Object.hasOwnProperty.call(m, "seller"))
                $root.orderspb.Person.encode(m.seller, w.uint32(50).fork()).ldelim();
            if (m.coSeller != null && Object.hasOwnProperty.call(m, "coSeller"))
                $root.orderspb.Person.encode(m.coSeller, w.uint32(58).fork()).ldelim();
            if (m.confirmationEmailRecipients != null && m.confirmationEmailRecipients.length) {
                for (var i = 0; i < m.confirmationEmailRecipients.length; ++i)
                    $root.orderspb.Recipient.encode(m.confirmationEmailRecipients[i], w.uint32(66).fork()).ldelim();
            }
            if (m.invoiceRecipients != null && m.invoiceRecipients.length) {
                for (var i = 0; i < m.invoiceRecipients.length; ++i)
                    $root.orderspb.Recipient.encode(m.invoiceRecipients[i], w.uint32(74).fork()).ldelim();
            }
            if (m.estimatedClosingDate != null && Object.hasOwnProperty.call(m, "estimatedClosingDate"))
                $root.google.protobuf.Timestamp.encode(m.estimatedClosingDate, w.uint32(82).fork()).ldelim();
            if (m.callerRole != null && Object.hasOwnProperty.call(m, "callerRole"))
                w.uint32(90).string(m.callerRole);
            if (m.guestUnit != null && Object.hasOwnProperty.call(m, "guestUnit"))
                w.uint32(96).int32(m.guestUnit);
            if (m.listingDate != null && Object.hasOwnProperty.call(m, "listingDate"))
                $root.orderspb.Dates.encode(m.listingDate, w.uint32(106).fork()).ldelim();
            if (m.listingCoverage != null && Object.hasOwnProperty.call(m, "listingCoverage"))
                $root.orderspb.Dates.encode(m.listingCoverage, w.uint32(114).fork()).ldelim();
            if (m.quoteDetails != null && Object.hasOwnProperty.call(m, "quoteDetails"))
                $root.orderspb.OrderQuoteUpdateRequest.encode(m.quoteDetails, w.uint32(122).fork()).ldelim();
            if (m.proratedContractId != null && Object.hasOwnProperty.call(m, "proratedContractId"))
                w.uint32(130).string(m.proratedContractId);
            if (m.mlsValue != null && Object.hasOwnProperty.call(m, "mlsValue"))
                w.uint32(138).string(m.mlsValue);
            if (m.cancellation != null && Object.hasOwnProperty.call(m, "cancellation"))
                $root.orderspb.Cancellation.encode(m.cancellation, w.uint32(146).fork()).ldelim();
            if (m.quoteSharedDate != null && Object.hasOwnProperty.call(m, "quoteSharedDate"))
                $root.google.protobuf.Timestamp.encode(m.quoteSharedDate, w.uint32(154).fork()).ldelim();
            if (m.buyerPay != null && Object.hasOwnProperty.call(m, "buyerPay"))
                $root.orderspb.BuyerPay.encode(m.buyerPay, w.uint32(162).fork()).ldelim();
            return w;
        };

        /**
         * Decodes a RealEstate message from the specified reader or buffer.
         * @function decode
         * @memberof orderspb.RealEstate
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {orderspb.RealEstate} RealEstate
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RealEstate.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.orderspb.RealEstate();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.initiatingOffice = $root.orderspb.RealEstateOffice.decode(r, r.uint32());
                    break;
                case 2:
                    m.cooperatingOffice = $root.orderspb.RealEstateOffice.decode(r, r.uint32());
                    break;
                case 3:
                    m.closingOffice = $root.orderspb.RealEstateOffice.decode(r, r.uint32());
                    break;
                case 4:
                    m.escrowNumber = r.string();
                    break;
                case 5:
                    m.caller = $root.orderspb.Person.decode(r, r.uint32());
                    break;
                case 6:
                    m.seller = $root.orderspb.Person.decode(r, r.uint32());
                    break;
                case 7:
                    m.coSeller = $root.orderspb.Person.decode(r, r.uint32());
                    break;
                case 8:
                    if (!(m.confirmationEmailRecipients && m.confirmationEmailRecipients.length))
                        m.confirmationEmailRecipients = [];
                    m.confirmationEmailRecipients.push($root.orderspb.Recipient.decode(r, r.uint32()));
                    break;
                case 9:
                    if (!(m.invoiceRecipients && m.invoiceRecipients.length))
                        m.invoiceRecipients = [];
                    m.invoiceRecipients.push($root.orderspb.Recipient.decode(r, r.uint32()));
                    break;
                case 10:
                    m.estimatedClosingDate = $root.google.protobuf.Timestamp.decode(r, r.uint32());
                    break;
                case 11:
                    m.callerRole = r.string();
                    break;
                case 12:
                    m.guestUnit = r.int32();
                    break;
                case 13:
                    m.listingDate = $root.orderspb.Dates.decode(r, r.uint32());
                    break;
                case 14:
                    m.listingCoverage = $root.orderspb.Dates.decode(r, r.uint32());
                    break;
                case 15:
                    m.quoteDetails = $root.orderspb.OrderQuoteUpdateRequest.decode(r, r.uint32());
                    break;
                case 16:
                    m.proratedContractId = r.string();
                    break;
                case 17:
                    m.mlsValue = r.string();
                    break;
                case 18:
                    m.cancellation = $root.orderspb.Cancellation.decode(r, r.uint32());
                    break;
                case 19:
                    m.quoteSharedDate = $root.google.protobuf.Timestamp.decode(r, r.uint32());
                    break;
                case 20:
                    m.buyerPay = $root.orderspb.BuyerPay.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return RealEstate;
    })();

    orderspb.BuyerPay = (function() {

        /**
         * Properties of a BuyerPay.
         * @memberof orderspb
         * @interface IBuyerPay
         * @property {boolean|null} [isBuyerPay] BuyerPay isBuyerPay
         */

        /**
         * Constructs a new BuyerPay.
         * @memberof orderspb
         * @classdesc Represents a BuyerPay.
         * @implements IBuyerPay
         * @constructor
         * @param {orderspb.IBuyerPay=} [p] Properties to set
         */
        function BuyerPay(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * BuyerPay isBuyerPay.
         * @member {boolean} isBuyerPay
         * @memberof orderspb.BuyerPay
         * @instance
         */
        BuyerPay.prototype.isBuyerPay = false;

        /**
         * Creates a new BuyerPay instance using the specified properties.
         * @function create
         * @memberof orderspb.BuyerPay
         * @static
         * @param {orderspb.IBuyerPay=} [properties] Properties to set
         * @returns {orderspb.BuyerPay} BuyerPay instance
         */
        BuyerPay.create = function create(properties) {
            return new BuyerPay(properties);
        };

        /**
         * Encodes the specified BuyerPay message. Does not implicitly {@link orderspb.BuyerPay.verify|verify} messages.
         * @function encode
         * @memberof orderspb.BuyerPay
         * @static
         * @param {orderspb.IBuyerPay} m BuyerPay message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        BuyerPay.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.isBuyerPay != null && Object.hasOwnProperty.call(m, "isBuyerPay"))
                w.uint32(8).bool(m.isBuyerPay);
            return w;
        };

        /**
         * Decodes a BuyerPay message from the specified reader or buffer.
         * @function decode
         * @memberof orderspb.BuyerPay
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {orderspb.BuyerPay} BuyerPay
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        BuyerPay.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.orderspb.BuyerPay();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.isBuyerPay = r.bool();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return BuyerPay;
    })();

    orderspb.Cancellation = (function() {

        /**
         * Properties of a Cancellation.
         * @memberof orderspb
         * @interface ICancellation
         * @property {number|null} [category] Cancellation category
         * @property {number|null} [subCategory] Cancellation subCategory
         * @property {string|null} [description] Cancellation description
         */

        /**
         * Constructs a new Cancellation.
         * @memberof orderspb
         * @classdesc Represents a Cancellation.
         * @implements ICancellation
         * @constructor
         * @param {orderspb.ICancellation=} [p] Properties to set
         */
        function Cancellation(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * Cancellation category.
         * @member {number} category
         * @memberof orderspb.Cancellation
         * @instance
         */
        Cancellation.prototype.category = 0;

        /**
         * Cancellation subCategory.
         * @member {number} subCategory
         * @memberof orderspb.Cancellation
         * @instance
         */
        Cancellation.prototype.subCategory = 0;

        /**
         * Cancellation description.
         * @member {string} description
         * @memberof orderspb.Cancellation
         * @instance
         */
        Cancellation.prototype.description = "";

        /**
         * Creates a new Cancellation instance using the specified properties.
         * @function create
         * @memberof orderspb.Cancellation
         * @static
         * @param {orderspb.ICancellation=} [properties] Properties to set
         * @returns {orderspb.Cancellation} Cancellation instance
         */
        Cancellation.create = function create(properties) {
            return new Cancellation(properties);
        };

        /**
         * Encodes the specified Cancellation message. Does not implicitly {@link orderspb.Cancellation.verify|verify} messages.
         * @function encode
         * @memberof orderspb.Cancellation
         * @static
         * @param {orderspb.ICancellation} m Cancellation message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Cancellation.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.category != null && Object.hasOwnProperty.call(m, "category"))
                w.uint32(8).int32(m.category);
            if (m.subCategory != null && Object.hasOwnProperty.call(m, "subCategory"))
                w.uint32(16).int32(m.subCategory);
            if (m.description != null && Object.hasOwnProperty.call(m, "description"))
                w.uint32(26).string(m.description);
            return w;
        };

        /**
         * Decodes a Cancellation message from the specified reader or buffer.
         * @function decode
         * @memberof orderspb.Cancellation
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {orderspb.Cancellation} Cancellation
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Cancellation.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.orderspb.Cancellation();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.category = r.int32();
                    break;
                case 2:
                    m.subCategory = r.int32();
                    break;
                case 3:
                    m.description = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return Cancellation;
    })();

    orderspb.RealEstateOffice = (function() {

        /**
         * Properties of a RealEstateOffice.
         * @memberof orderspb
         * @interface IRealEstateOffice
         * @property {string|null} [officeID] RealEstateOffice officeID
         * @property {string|null} [officeType] RealEstateOffice officeType
         * @property {orderspb.RealEstateOffice.IRealEstateAgent|null} [realEstateAgent] RealEstateOffice realEstateAgent
         * @property {string|null} [represents] RealEstateOffice represents
         */

        /**
         * Constructs a new RealEstateOffice.
         * @memberof orderspb
         * @classdesc Represents a RealEstateOffice.
         * @implements IRealEstateOffice
         * @constructor
         * @param {orderspb.IRealEstateOffice=} [p] Properties to set
         */
        function RealEstateOffice(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * RealEstateOffice officeID.
         * @member {string} officeID
         * @memberof orderspb.RealEstateOffice
         * @instance
         */
        RealEstateOffice.prototype.officeID = "";

        /**
         * RealEstateOffice officeType.
         * @member {string} officeType
         * @memberof orderspb.RealEstateOffice
         * @instance
         */
        RealEstateOffice.prototype.officeType = "";

        /**
         * RealEstateOffice realEstateAgent.
         * @member {orderspb.RealEstateOffice.IRealEstateAgent|null|undefined} realEstateAgent
         * @memberof orderspb.RealEstateOffice
         * @instance
         */
        RealEstateOffice.prototype.realEstateAgent = null;

        /**
         * RealEstateOffice represents.
         * @member {string} represents
         * @memberof orderspb.RealEstateOffice
         * @instance
         */
        RealEstateOffice.prototype.represents = "";

        /**
         * Creates a new RealEstateOffice instance using the specified properties.
         * @function create
         * @memberof orderspb.RealEstateOffice
         * @static
         * @param {orderspb.IRealEstateOffice=} [properties] Properties to set
         * @returns {orderspb.RealEstateOffice} RealEstateOffice instance
         */
        RealEstateOffice.create = function create(properties) {
            return new RealEstateOffice(properties);
        };

        /**
         * Encodes the specified RealEstateOffice message. Does not implicitly {@link orderspb.RealEstateOffice.verify|verify} messages.
         * @function encode
         * @memberof orderspb.RealEstateOffice
         * @static
         * @param {orderspb.IRealEstateOffice} m RealEstateOffice message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RealEstateOffice.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.officeID != null && Object.hasOwnProperty.call(m, "officeID"))
                w.uint32(10).string(m.officeID);
            if (m.officeType != null && Object.hasOwnProperty.call(m, "officeType"))
                w.uint32(18).string(m.officeType);
            if (m.realEstateAgent != null && Object.hasOwnProperty.call(m, "realEstateAgent"))
                $root.orderspb.RealEstateOffice.RealEstateAgent.encode(m.realEstateAgent, w.uint32(26).fork()).ldelim();
            if (m.represents != null && Object.hasOwnProperty.call(m, "represents"))
                w.uint32(34).string(m.represents);
            return w;
        };

        /**
         * Decodes a RealEstateOffice message from the specified reader or buffer.
         * @function decode
         * @memberof orderspb.RealEstateOffice
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {orderspb.RealEstateOffice} RealEstateOffice
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RealEstateOffice.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.orderspb.RealEstateOffice();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.officeID = r.string();
                    break;
                case 2:
                    m.officeType = r.string();
                    break;
                case 3:
                    m.realEstateAgent = $root.orderspb.RealEstateOffice.RealEstateAgent.decode(r, r.uint32());
                    break;
                case 4:
                    m.represents = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        RealEstateOffice.RealEstateAgent = (function() {

            /**
             * Properties of a RealEstateAgent.
             * @memberof orderspb.RealEstateOffice
             * @interface IRealEstateAgent
             * @property {string|null} [agentID] RealEstateAgent agentID
             * @property {string|null} [agentFirstName] RealEstateAgent agentFirstName
             * @property {string|null} [agentLastName] RealEstateAgent agentLastName
             * @property {string|null} [agentEmail] RealEstateAgent agentEmail
             */

            /**
             * Constructs a new RealEstateAgent.
             * @memberof orderspb.RealEstateOffice
             * @classdesc Represents a RealEstateAgent.
             * @implements IRealEstateAgent
             * @constructor
             * @param {orderspb.RealEstateOffice.IRealEstateAgent=} [p] Properties to set
             */
            function RealEstateAgent(p) {
                if (p)
                    for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                        if (p[ks[i]] != null)
                            this[ks[i]] = p[ks[i]];
            }

            /**
             * RealEstateAgent agentID.
             * @member {string} agentID
             * @memberof orderspb.RealEstateOffice.RealEstateAgent
             * @instance
             */
            RealEstateAgent.prototype.agentID = "";

            /**
             * RealEstateAgent agentFirstName.
             * @member {string} agentFirstName
             * @memberof orderspb.RealEstateOffice.RealEstateAgent
             * @instance
             */
            RealEstateAgent.prototype.agentFirstName = "";

            /**
             * RealEstateAgent agentLastName.
             * @member {string} agentLastName
             * @memberof orderspb.RealEstateOffice.RealEstateAgent
             * @instance
             */
            RealEstateAgent.prototype.agentLastName = "";

            /**
             * RealEstateAgent agentEmail.
             * @member {string} agentEmail
             * @memberof orderspb.RealEstateOffice.RealEstateAgent
             * @instance
             */
            RealEstateAgent.prototype.agentEmail = "";

            /**
             * Creates a new RealEstateAgent instance using the specified properties.
             * @function create
             * @memberof orderspb.RealEstateOffice.RealEstateAgent
             * @static
             * @param {orderspb.RealEstateOffice.IRealEstateAgent=} [properties] Properties to set
             * @returns {orderspb.RealEstateOffice.RealEstateAgent} RealEstateAgent instance
             */
            RealEstateAgent.create = function create(properties) {
                return new RealEstateAgent(properties);
            };

            /**
             * Encodes the specified RealEstateAgent message. Does not implicitly {@link orderspb.RealEstateOffice.RealEstateAgent.verify|verify} messages.
             * @function encode
             * @memberof orderspb.RealEstateOffice.RealEstateAgent
             * @static
             * @param {orderspb.RealEstateOffice.IRealEstateAgent} m RealEstateAgent message or plain object to encode
             * @param {$protobuf.Writer} [w] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            RealEstateAgent.encode = function encode(m, w) {
                if (!w)
                    w = $Writer.create();
                if (m.agentID != null && Object.hasOwnProperty.call(m, "agentID"))
                    w.uint32(10).string(m.agentID);
                if (m.agentFirstName != null && Object.hasOwnProperty.call(m, "agentFirstName"))
                    w.uint32(18).string(m.agentFirstName);
                if (m.agentLastName != null && Object.hasOwnProperty.call(m, "agentLastName"))
                    w.uint32(26).string(m.agentLastName);
                if (m.agentEmail != null && Object.hasOwnProperty.call(m, "agentEmail"))
                    w.uint32(34).string(m.agentEmail);
                return w;
            };

            /**
             * Decodes a RealEstateAgent message from the specified reader or buffer.
             * @function decode
             * @memberof orderspb.RealEstateOffice.RealEstateAgent
             * @static
             * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
             * @param {number} [l] Message length if known beforehand
             * @returns {orderspb.RealEstateOffice.RealEstateAgent} RealEstateAgent
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            RealEstateAgent.decode = function decode(r, l) {
                if (!(r instanceof $Reader))
                    r = $Reader.create(r);
                var c = l === undefined ? r.len : r.pos + l, m = new $root.orderspb.RealEstateOffice.RealEstateAgent();
                while (r.pos < c) {
                    var t = r.uint32();
                    switch (t >>> 3) {
                    case 1:
                        m.agentID = r.string();
                        break;
                    case 2:
                        m.agentFirstName = r.string();
                        break;
                    case 3:
                        m.agentLastName = r.string();
                        break;
                    case 4:
                        m.agentEmail = r.string();
                        break;
                    default:
                        r.skipType(t & 7);
                        break;
                    }
                }
                return m;
            };

            return RealEstateAgent;
        })();

        return RealEstateOffice;
    })();

    orderspb.Dates = (function() {

        /**
         * Properties of a Dates.
         * @memberof orderspb
         * @interface IDates
         * @property {google.protobuf.ITimestamp|null} [startDate] Dates startDate
         * @property {google.protobuf.ITimestamp|null} [expirationDate] Dates expirationDate
         */

        /**
         * Constructs a new Dates.
         * @memberof orderspb
         * @classdesc Represents a Dates.
         * @implements IDates
         * @constructor
         * @param {orderspb.IDates=} [p] Properties to set
         */
        function Dates(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * Dates startDate.
         * @member {google.protobuf.ITimestamp|null|undefined} startDate
         * @memberof orderspb.Dates
         * @instance
         */
        Dates.prototype.startDate = null;

        /**
         * Dates expirationDate.
         * @member {google.protobuf.ITimestamp|null|undefined} expirationDate
         * @memberof orderspb.Dates
         * @instance
         */
        Dates.prototype.expirationDate = null;

        /**
         * Creates a new Dates instance using the specified properties.
         * @function create
         * @memberof orderspb.Dates
         * @static
         * @param {orderspb.IDates=} [properties] Properties to set
         * @returns {orderspb.Dates} Dates instance
         */
        Dates.create = function create(properties) {
            return new Dates(properties);
        };

        /**
         * Encodes the specified Dates message. Does not implicitly {@link orderspb.Dates.verify|verify} messages.
         * @function encode
         * @memberof orderspb.Dates
         * @static
         * @param {orderspb.IDates} m Dates message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Dates.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.startDate != null && Object.hasOwnProperty.call(m, "startDate"))
                $root.google.protobuf.Timestamp.encode(m.startDate, w.uint32(10).fork()).ldelim();
            if (m.expirationDate != null && Object.hasOwnProperty.call(m, "expirationDate"))
                $root.google.protobuf.Timestamp.encode(m.expirationDate, w.uint32(18).fork()).ldelim();
            return w;
        };

        /**
         * Decodes a Dates message from the specified reader or buffer.
         * @function decode
         * @memberof orderspb.Dates
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {orderspb.Dates} Dates
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Dates.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.orderspb.Dates();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.startDate = $root.google.protobuf.Timestamp.decode(r, r.uint32());
                    break;
                case 2:
                    m.expirationDate = $root.google.protobuf.Timestamp.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return Dates;
    })();

    orderspb.Recipient = (function() {

        /**
         * Properties of a Recipient.
         * @memberof orderspb
         * @interface IRecipient
         * @property {string|null} [email] Recipient email
         * @property {string|null} [recipient] Recipient recipient
         */

        /**
         * Constructs a new Recipient.
         * @memberof orderspb
         * @classdesc Represents a Recipient.
         * @implements IRecipient
         * @constructor
         * @param {orderspb.IRecipient=} [p] Properties to set
         */
        function Recipient(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * Recipient email.
         * @member {string} email
         * @memberof orderspb.Recipient
         * @instance
         */
        Recipient.prototype.email = "";

        /**
         * Recipient recipient.
         * @member {string} recipient
         * @memberof orderspb.Recipient
         * @instance
         */
        Recipient.prototype.recipient = "";

        /**
         * Creates a new Recipient instance using the specified properties.
         * @function create
         * @memberof orderspb.Recipient
         * @static
         * @param {orderspb.IRecipient=} [properties] Properties to set
         * @returns {orderspb.Recipient} Recipient instance
         */
        Recipient.create = function create(properties) {
            return new Recipient(properties);
        };

        /**
         * Encodes the specified Recipient message. Does not implicitly {@link orderspb.Recipient.verify|verify} messages.
         * @function encode
         * @memberof orderspb.Recipient
         * @static
         * @param {orderspb.IRecipient} m Recipient message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Recipient.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.email != null && Object.hasOwnProperty.call(m, "email"))
                w.uint32(10).string(m.email);
            if (m.recipient != null && Object.hasOwnProperty.call(m, "recipient"))
                w.uint32(18).string(m.recipient);
            return w;
        };

        /**
         * Decodes a Recipient message from the specified reader or buffer.
         * @function decode
         * @memberof orderspb.Recipient
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {orderspb.Recipient} Recipient
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Recipient.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.orderspb.Recipient();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.email = r.string();
                    break;
                case 2:
                    m.recipient = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return Recipient;
    })();

    orderspb.LeadInfo = (function() {

        /**
         * Properties of a LeadInfo.
         * @memberof orderspb
         * @interface ILeadInfo
         * @property {number|Long|null} [leadexecID] LeadInfo leadexecID
         * @property {number|Long|null} [salesexecID] LeadInfo salesexecID
         * @property {google.protobuf.ITimestamp|null} [createdDate] LeadInfo createdDate
         * @property {google.protobuf.ITimestamp|null} [lastModifiedDate] LeadInfo lastModifiedDate
         * @property {string|null} [postID] LeadInfo postID
         */

        /**
         * Constructs a new LeadInfo.
         * @memberof orderspb
         * @classdesc Represents a LeadInfo.
         * @implements ILeadInfo
         * @constructor
         * @param {orderspb.ILeadInfo=} [p] Properties to set
         */
        function LeadInfo(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * LeadInfo leadexecID.
         * @member {number|Long} leadexecID
         * @memberof orderspb.LeadInfo
         * @instance
         */
        LeadInfo.prototype.leadexecID = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * LeadInfo salesexecID.
         * @member {number|Long} salesexecID
         * @memberof orderspb.LeadInfo
         * @instance
         */
        LeadInfo.prototype.salesexecID = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * LeadInfo createdDate.
         * @member {google.protobuf.ITimestamp|null|undefined} createdDate
         * @memberof orderspb.LeadInfo
         * @instance
         */
        LeadInfo.prototype.createdDate = null;

        /**
         * LeadInfo lastModifiedDate.
         * @member {google.protobuf.ITimestamp|null|undefined} lastModifiedDate
         * @memberof orderspb.LeadInfo
         * @instance
         */
        LeadInfo.prototype.lastModifiedDate = null;

        /**
         * LeadInfo postID.
         * @member {string} postID
         * @memberof orderspb.LeadInfo
         * @instance
         */
        LeadInfo.prototype.postID = "";

        /**
         * Creates a new LeadInfo instance using the specified properties.
         * @function create
         * @memberof orderspb.LeadInfo
         * @static
         * @param {orderspb.ILeadInfo=} [properties] Properties to set
         * @returns {orderspb.LeadInfo} LeadInfo instance
         */
        LeadInfo.create = function create(properties) {
            return new LeadInfo(properties);
        };

        /**
         * Encodes the specified LeadInfo message. Does not implicitly {@link orderspb.LeadInfo.verify|verify} messages.
         * @function encode
         * @memberof orderspb.LeadInfo
         * @static
         * @param {orderspb.ILeadInfo} m LeadInfo message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        LeadInfo.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.leadexecID != null && Object.hasOwnProperty.call(m, "leadexecID"))
                w.uint32(8).int64(m.leadexecID);
            if (m.salesexecID != null && Object.hasOwnProperty.call(m, "salesexecID"))
                w.uint32(16).int64(m.salesexecID);
            if (m.createdDate != null && Object.hasOwnProperty.call(m, "createdDate"))
                $root.google.protobuf.Timestamp.encode(m.createdDate, w.uint32(26).fork()).ldelim();
            if (m.lastModifiedDate != null && Object.hasOwnProperty.call(m, "lastModifiedDate"))
                $root.google.protobuf.Timestamp.encode(m.lastModifiedDate, w.uint32(34).fork()).ldelim();
            if (m.postID != null && Object.hasOwnProperty.call(m, "postID"))
                w.uint32(42).string(m.postID);
            return w;
        };

        /**
         * Decodes a LeadInfo message from the specified reader or buffer.
         * @function decode
         * @memberof orderspb.LeadInfo
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {orderspb.LeadInfo} LeadInfo
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        LeadInfo.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.orderspb.LeadInfo();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.leadexecID = r.int64();
                    break;
                case 2:
                    m.salesexecID = r.int64();
                    break;
                case 3:
                    m.createdDate = $root.google.protobuf.Timestamp.decode(r, r.uint32());
                    break;
                case 4:
                    m.lastModifiedDate = $root.google.protobuf.Timestamp.decode(r, r.uint32());
                    break;
                case 5:
                    m.postID = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return LeadInfo;
    })();

    orderspb.EmailSentStatus = (function() {

        /**
         * Properties of an EmailSentStatus.
         * @memberof orderspb
         * @interface IEmailSentStatus
         * @property {boolean|null} [Sent] EmailSentStatus Sent
         */

        /**
         * Constructs a new EmailSentStatus.
         * @memberof orderspb
         * @classdesc Represents an EmailSentStatus.
         * @implements IEmailSentStatus
         * @constructor
         * @param {orderspb.IEmailSentStatus=} [p] Properties to set
         */
        function EmailSentStatus(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * EmailSentStatus Sent.
         * @member {boolean} Sent
         * @memberof orderspb.EmailSentStatus
         * @instance
         */
        EmailSentStatus.prototype.Sent = false;

        /**
         * Creates a new EmailSentStatus instance using the specified properties.
         * @function create
         * @memberof orderspb.EmailSentStatus
         * @static
         * @param {orderspb.IEmailSentStatus=} [properties] Properties to set
         * @returns {orderspb.EmailSentStatus} EmailSentStatus instance
         */
        EmailSentStatus.create = function create(properties) {
            return new EmailSentStatus(properties);
        };

        /**
         * Encodes the specified EmailSentStatus message. Does not implicitly {@link orderspb.EmailSentStatus.verify|verify} messages.
         * @function encode
         * @memberof orderspb.EmailSentStatus
         * @static
         * @param {orderspb.IEmailSentStatus} m EmailSentStatus message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        EmailSentStatus.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.Sent != null && Object.hasOwnProperty.call(m, "Sent"))
                w.uint32(8).bool(m.Sent);
            return w;
        };

        /**
         * Decodes an EmailSentStatus message from the specified reader or buffer.
         * @function decode
         * @memberof orderspb.EmailSentStatus
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {orderspb.EmailSentStatus} EmailSentStatus
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        EmailSentStatus.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.orderspb.EmailSentStatus();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.Sent = r.bool();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return EmailSentStatus;
    })();

    orderspb.MyAccountOrder = (function() {

        /**
         * Properties of a MyAccountOrder.
         * @memberof orderspb
         * @interface IMyAccountOrder
         * @property {string|null} [firstName] MyAccountOrder firstName
         * @property {string|null} [lastName] MyAccountOrder lastName
         * @property {string|null} [emailAddress] MyAccountOrder emailAddress
         * @property {string|null} [phoneNumber] MyAccountOrder phoneNumber
         * @property {string|null} [contractID] MyAccountOrder contractID
         * @property {string|null} [customerID] MyAccountOrder customerID
         * @property {common.Tenant|null} [tenantID] MyAccountOrder tenantID
         * @property {boolean|null} [optOutMarketingEmail] MyAccountOrder optOutMarketingEmail
         * @property {boolean|null} [optOutMarketingSMS] MyAccountOrder optOutMarketingSMS
         */

        /**
         * Constructs a new MyAccountOrder.
         * @memberof orderspb
         * @classdesc Represents a MyAccountOrder.
         * @implements IMyAccountOrder
         * @constructor
         * @param {orderspb.IMyAccountOrder=} [p] Properties to set
         */
        function MyAccountOrder(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * MyAccountOrder firstName.
         * @member {string} firstName
         * @memberof orderspb.MyAccountOrder
         * @instance
         */
        MyAccountOrder.prototype.firstName = "";

        /**
         * MyAccountOrder lastName.
         * @member {string} lastName
         * @memberof orderspb.MyAccountOrder
         * @instance
         */
        MyAccountOrder.prototype.lastName = "";

        /**
         * MyAccountOrder emailAddress.
         * @member {string} emailAddress
         * @memberof orderspb.MyAccountOrder
         * @instance
         */
        MyAccountOrder.prototype.emailAddress = "";

        /**
         * MyAccountOrder phoneNumber.
         * @member {string} phoneNumber
         * @memberof orderspb.MyAccountOrder
         * @instance
         */
        MyAccountOrder.prototype.phoneNumber = "";

        /**
         * MyAccountOrder contractID.
         * @member {string} contractID
         * @memberof orderspb.MyAccountOrder
         * @instance
         */
        MyAccountOrder.prototype.contractID = "";

        /**
         * MyAccountOrder customerID.
         * @member {string} customerID
         * @memberof orderspb.MyAccountOrder
         * @instance
         */
        MyAccountOrder.prototype.customerID = "";

        /**
         * MyAccountOrder tenantID.
         * @member {common.Tenant} tenantID
         * @memberof orderspb.MyAccountOrder
         * @instance
         */
        MyAccountOrder.prototype.tenantID = 0;

        /**
         * MyAccountOrder optOutMarketingEmail.
         * @member {boolean} optOutMarketingEmail
         * @memberof orderspb.MyAccountOrder
         * @instance
         */
        MyAccountOrder.prototype.optOutMarketingEmail = false;

        /**
         * MyAccountOrder optOutMarketingSMS.
         * @member {boolean} optOutMarketingSMS
         * @memberof orderspb.MyAccountOrder
         * @instance
         */
        MyAccountOrder.prototype.optOutMarketingSMS = false;

        /**
         * Creates a new MyAccountOrder instance using the specified properties.
         * @function create
         * @memberof orderspb.MyAccountOrder
         * @static
         * @param {orderspb.IMyAccountOrder=} [properties] Properties to set
         * @returns {orderspb.MyAccountOrder} MyAccountOrder instance
         */
        MyAccountOrder.create = function create(properties) {
            return new MyAccountOrder(properties);
        };

        /**
         * Encodes the specified MyAccountOrder message. Does not implicitly {@link orderspb.MyAccountOrder.verify|verify} messages.
         * @function encode
         * @memberof orderspb.MyAccountOrder
         * @static
         * @param {orderspb.IMyAccountOrder} m MyAccountOrder message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MyAccountOrder.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.firstName != null && Object.hasOwnProperty.call(m, "firstName"))
                w.uint32(10).string(m.firstName);
            if (m.lastName != null && Object.hasOwnProperty.call(m, "lastName"))
                w.uint32(18).string(m.lastName);
            if (m.emailAddress != null && Object.hasOwnProperty.call(m, "emailAddress"))
                w.uint32(26).string(m.emailAddress);
            if (m.phoneNumber != null && Object.hasOwnProperty.call(m, "phoneNumber"))
                w.uint32(34).string(m.phoneNumber);
            if (m.contractID != null && Object.hasOwnProperty.call(m, "contractID"))
                w.uint32(42).string(m.contractID);
            if (m.customerID != null && Object.hasOwnProperty.call(m, "customerID"))
                w.uint32(50).string(m.customerID);
            if (m.tenantID != null && Object.hasOwnProperty.call(m, "tenantID"))
                w.uint32(56).int32(m.tenantID);
            if (m.optOutMarketingEmail != null && Object.hasOwnProperty.call(m, "optOutMarketingEmail"))
                w.uint32(64).bool(m.optOutMarketingEmail);
            if (m.optOutMarketingSMS != null && Object.hasOwnProperty.call(m, "optOutMarketingSMS"))
                w.uint32(72).bool(m.optOutMarketingSMS);
            return w;
        };

        /**
         * Decodes a MyAccountOrder message from the specified reader or buffer.
         * @function decode
         * @memberof orderspb.MyAccountOrder
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {orderspb.MyAccountOrder} MyAccountOrder
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MyAccountOrder.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.orderspb.MyAccountOrder();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.firstName = r.string();
                    break;
                case 2:
                    m.lastName = r.string();
                    break;
                case 3:
                    m.emailAddress = r.string();
                    break;
                case 4:
                    m.phoneNumber = r.string();
                    break;
                case 5:
                    m.contractID = r.string();
                    break;
                case 6:
                    m.customerID = r.string();
                    break;
                case 7:
                    m.tenantID = r.int32();
                    break;
                case 8:
                    m.optOutMarketingEmail = r.bool();
                    break;
                case 9:
                    m.optOutMarketingSMS = r.bool();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return MyAccountOrder;
    })();

    orderspb.CancelReasonResponse = (function() {

        /**
         * Properties of a CancelReasonResponse.
         * @memberof orderspb
         * @interface ICancelReasonResponse
         * @property {Array.<orderspb.ICategory>|null} [categories] CancelReasonResponse categories
         */

        /**
         * Constructs a new CancelReasonResponse.
         * @memberof orderspb
         * @classdesc Represents a CancelReasonResponse.
         * @implements ICancelReasonResponse
         * @constructor
         * @param {orderspb.ICancelReasonResponse=} [p] Properties to set
         */
        function CancelReasonResponse(p) {
            this.categories = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * CancelReasonResponse categories.
         * @member {Array.<orderspb.ICategory>} categories
         * @memberof orderspb.CancelReasonResponse
         * @instance
         */
        CancelReasonResponse.prototype.categories = $util.emptyArray;

        /**
         * Creates a new CancelReasonResponse instance using the specified properties.
         * @function create
         * @memberof orderspb.CancelReasonResponse
         * @static
         * @param {orderspb.ICancelReasonResponse=} [properties] Properties to set
         * @returns {orderspb.CancelReasonResponse} CancelReasonResponse instance
         */
        CancelReasonResponse.create = function create(properties) {
            return new CancelReasonResponse(properties);
        };

        /**
         * Encodes the specified CancelReasonResponse message. Does not implicitly {@link orderspb.CancelReasonResponse.verify|verify} messages.
         * @function encode
         * @memberof orderspb.CancelReasonResponse
         * @static
         * @param {orderspb.ICancelReasonResponse} m CancelReasonResponse message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CancelReasonResponse.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.categories != null && m.categories.length) {
                for (var i = 0; i < m.categories.length; ++i)
                    $root.orderspb.Category.encode(m.categories[i], w.uint32(10).fork()).ldelim();
            }
            return w;
        };

        /**
         * Decodes a CancelReasonResponse message from the specified reader or buffer.
         * @function decode
         * @memberof orderspb.CancelReasonResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {orderspb.CancelReasonResponse} CancelReasonResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CancelReasonResponse.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.orderspb.CancelReasonResponse();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    if (!(m.categories && m.categories.length))
                        m.categories = [];
                    m.categories.push($root.orderspb.Category.decode(r, r.uint32()));
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return CancelReasonResponse;
    })();

    orderspb.Category = (function() {

        /**
         * Properties of a Category.
         * @memberof orderspb
         * @interface ICategory
         * @property {number|null} [id] Category id
         * @property {string|null} [name] Category name
         * @property {string|null} [subCategoryTitle] Category subCategoryTitle
         * @property {Array.<orderspb.ISubCategory>|null} [subCategories] Category subCategories
         * @property {string|null} [descriptionQuestion] Category descriptionQuestion
         */

        /**
         * Constructs a new Category.
         * @memberof orderspb
         * @classdesc Represents a Category.
         * @implements ICategory
         * @constructor
         * @param {orderspb.ICategory=} [p] Properties to set
         */
        function Category(p) {
            this.subCategories = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * Category id.
         * @member {number} id
         * @memberof orderspb.Category
         * @instance
         */
        Category.prototype.id = 0;

        /**
         * Category name.
         * @member {string} name
         * @memberof orderspb.Category
         * @instance
         */
        Category.prototype.name = "";

        /**
         * Category subCategoryTitle.
         * @member {string} subCategoryTitle
         * @memberof orderspb.Category
         * @instance
         */
        Category.prototype.subCategoryTitle = "";

        /**
         * Category subCategories.
         * @member {Array.<orderspb.ISubCategory>} subCategories
         * @memberof orderspb.Category
         * @instance
         */
        Category.prototype.subCategories = $util.emptyArray;

        /**
         * Category descriptionQuestion.
         * @member {string} descriptionQuestion
         * @memberof orderspb.Category
         * @instance
         */
        Category.prototype.descriptionQuestion = "";

        /**
         * Creates a new Category instance using the specified properties.
         * @function create
         * @memberof orderspb.Category
         * @static
         * @param {orderspb.ICategory=} [properties] Properties to set
         * @returns {orderspb.Category} Category instance
         */
        Category.create = function create(properties) {
            return new Category(properties);
        };

        /**
         * Encodes the specified Category message. Does not implicitly {@link orderspb.Category.verify|verify} messages.
         * @function encode
         * @memberof orderspb.Category
         * @static
         * @param {orderspb.ICategory} m Category message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Category.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.id != null && Object.hasOwnProperty.call(m, "id"))
                w.uint32(8).int32(m.id);
            if (m.name != null && Object.hasOwnProperty.call(m, "name"))
                w.uint32(18).string(m.name);
            if (m.subCategoryTitle != null && Object.hasOwnProperty.call(m, "subCategoryTitle"))
                w.uint32(26).string(m.subCategoryTitle);
            if (m.subCategories != null && m.subCategories.length) {
                for (var i = 0; i < m.subCategories.length; ++i)
                    $root.orderspb.SubCategory.encode(m.subCategories[i], w.uint32(34).fork()).ldelim();
            }
            if (m.descriptionQuestion != null && Object.hasOwnProperty.call(m, "descriptionQuestion"))
                w.uint32(42).string(m.descriptionQuestion);
            return w;
        };

        /**
         * Decodes a Category message from the specified reader or buffer.
         * @function decode
         * @memberof orderspb.Category
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {orderspb.Category} Category
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Category.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.orderspb.Category();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.id = r.int32();
                    break;
                case 2:
                    m.name = r.string();
                    break;
                case 3:
                    m.subCategoryTitle = r.string();
                    break;
                case 4:
                    if (!(m.subCategories && m.subCategories.length))
                        m.subCategories = [];
                    m.subCategories.push($root.orderspb.SubCategory.decode(r, r.uint32()));
                    break;
                case 5:
                    m.descriptionQuestion = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return Category;
    })();

    orderspb.SubCategory = (function() {

        /**
         * Properties of a SubCategory.
         * @memberof orderspb
         * @interface ISubCategory
         * @property {number|null} [id] SubCategory id
         * @property {string|null} [name] SubCategory name
         */

        /**
         * Constructs a new SubCategory.
         * @memberof orderspb
         * @classdesc Represents a SubCategory.
         * @implements ISubCategory
         * @constructor
         * @param {orderspb.ISubCategory=} [p] Properties to set
         */
        function SubCategory(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * SubCategory id.
         * @member {number} id
         * @memberof orderspb.SubCategory
         * @instance
         */
        SubCategory.prototype.id = 0;

        /**
         * SubCategory name.
         * @member {string} name
         * @memberof orderspb.SubCategory
         * @instance
         */
        SubCategory.prototype.name = "";

        /**
         * Creates a new SubCategory instance using the specified properties.
         * @function create
         * @memberof orderspb.SubCategory
         * @static
         * @param {orderspb.ISubCategory=} [properties] Properties to set
         * @returns {orderspb.SubCategory} SubCategory instance
         */
        SubCategory.create = function create(properties) {
            return new SubCategory(properties);
        };

        /**
         * Encodes the specified SubCategory message. Does not implicitly {@link orderspb.SubCategory.verify|verify} messages.
         * @function encode
         * @memberof orderspb.SubCategory
         * @static
         * @param {orderspb.ISubCategory} m SubCategory message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SubCategory.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.id != null && Object.hasOwnProperty.call(m, "id"))
                w.uint32(8).int32(m.id);
            if (m.name != null && Object.hasOwnProperty.call(m, "name"))
                w.uint32(18).string(m.name);
            return w;
        };

        /**
         * Decodes a SubCategory message from the specified reader or buffer.
         * @function decode
         * @memberof orderspb.SubCategory
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {orderspb.SubCategory} SubCategory
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SubCategory.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.orderspb.SubCategory();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.id = r.int32();
                    break;
                case 2:
                    m.name = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return SubCategory;
    })();

    orderspb.OrderSearchRequest = (function() {

        /**
         * Properties of an OrderSearchRequest.
         * @memberof orderspb
         * @interface IOrderSearchRequest
         * @property {orderspb.IOrderSearchCriteria|null} [criteria] OrderSearchRequest criteria
         * @property {orderspb.IRequestMeta|null} [meta] OrderSearchRequest meta
         */

        /**
         * Constructs a new OrderSearchRequest.
         * @memberof orderspb
         * @classdesc Represents an OrderSearchRequest.
         * @implements IOrderSearchRequest
         * @constructor
         * @param {orderspb.IOrderSearchRequest=} [p] Properties to set
         */
        function OrderSearchRequest(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * OrderSearchRequest criteria.
         * @member {orderspb.IOrderSearchCriteria|null|undefined} criteria
         * @memberof orderspb.OrderSearchRequest
         * @instance
         */
        OrderSearchRequest.prototype.criteria = null;

        /**
         * OrderSearchRequest meta.
         * @member {orderspb.IRequestMeta|null|undefined} meta
         * @memberof orderspb.OrderSearchRequest
         * @instance
         */
        OrderSearchRequest.prototype.meta = null;

        /**
         * Creates a new OrderSearchRequest instance using the specified properties.
         * @function create
         * @memberof orderspb.OrderSearchRequest
         * @static
         * @param {orderspb.IOrderSearchRequest=} [properties] Properties to set
         * @returns {orderspb.OrderSearchRequest} OrderSearchRequest instance
         */
        OrderSearchRequest.create = function create(properties) {
            return new OrderSearchRequest(properties);
        };

        /**
         * Encodes the specified OrderSearchRequest message. Does not implicitly {@link orderspb.OrderSearchRequest.verify|verify} messages.
         * @function encode
         * @memberof orderspb.OrderSearchRequest
         * @static
         * @param {orderspb.IOrderSearchRequest} m OrderSearchRequest message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        OrderSearchRequest.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.criteria != null && Object.hasOwnProperty.call(m, "criteria"))
                $root.orderspb.OrderSearchCriteria.encode(m.criteria, w.uint32(10).fork()).ldelim();
            if (m.meta != null && Object.hasOwnProperty.call(m, "meta"))
                $root.orderspb.RequestMeta.encode(m.meta, w.uint32(18).fork()).ldelim();
            return w;
        };

        /**
         * Decodes an OrderSearchRequest message from the specified reader or buffer.
         * @function decode
         * @memberof orderspb.OrderSearchRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {orderspb.OrderSearchRequest} OrderSearchRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        OrderSearchRequest.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.orderspb.OrderSearchRequest();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.criteria = $root.orderspb.OrderSearchCriteria.decode(r, r.uint32());
                    break;
                case 2:
                    m.meta = $root.orderspb.RequestMeta.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return OrderSearchRequest;
    })();

    orderspb.OrderSearchCriteria = (function() {

        /**
         * Properties of an OrderSearchCriteria.
         * @memberof orderspb
         * @interface IOrderSearchCriteria
         * @property {Array.<string>|null} [status] OrderSearchCriteria status
         * @property {Array.<orderspb.OrderType>|null} [orderType] OrderSearchCriteria orderType
         * @property {Array.<string>|null} [contractID] OrderSearchCriteria contractID
         * @property {Array.<string>|null} [sourceApplication] OrderSearchCriteria sourceApplication
         * @property {Array.<string>|null} [propertyAddressID] OrderSearchCriteria propertyAddressID
         * @property {Array.<orderspb.IKeyValueFilter>|null} [attributes] OrderSearchCriteria attributes
         * @property {orderspb.IPersonCriteria|null} [buyer] OrderSearchCriteria buyer
         * @property {common.ITimeslot|null} [createdDate] OrderSearchCriteria createdDate
         * @property {common.ITimeslot|null} [lastModified] OrderSearchCriteria lastModified
         * @property {common.ITimeslot|null} [quoteExpiration] OrderSearchCriteria quoteExpiration
         * @property {common.ITimeslot|null} [orderExpiration] OrderSearchCriteria orderExpiration
         * @property {orderspb.IRealEstateSearchCriteria|null} [realEstate] OrderSearchCriteria realEstate
         * @property {google.protobuf.IBoolValue|null} [isGift] OrderSearchCriteria isGift
         * @property {Array.<string>|null} [salesChannel] OrderSearchCriteria salesChannel
         * @property {Array.<string>|null} [tenantID] OrderSearchCriteria tenantID
         */

        /**
         * Constructs a new OrderSearchCriteria.
         * @memberof orderspb
         * @classdesc Represents an OrderSearchCriteria.
         * @implements IOrderSearchCriteria
         * @constructor
         * @param {orderspb.IOrderSearchCriteria=} [p] Properties to set
         */
        function OrderSearchCriteria(p) {
            this.status = [];
            this.orderType = [];
            this.contractID = [];
            this.sourceApplication = [];
            this.propertyAddressID = [];
            this.attributes = [];
            this.salesChannel = [];
            this.tenantID = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * OrderSearchCriteria status.
         * @member {Array.<string>} status
         * @memberof orderspb.OrderSearchCriteria
         * @instance
         */
        OrderSearchCriteria.prototype.status = $util.emptyArray;

        /**
         * OrderSearchCriteria orderType.
         * @member {Array.<orderspb.OrderType>} orderType
         * @memberof orderspb.OrderSearchCriteria
         * @instance
         */
        OrderSearchCriteria.prototype.orderType = $util.emptyArray;

        /**
         * OrderSearchCriteria contractID.
         * @member {Array.<string>} contractID
         * @memberof orderspb.OrderSearchCriteria
         * @instance
         */
        OrderSearchCriteria.prototype.contractID = $util.emptyArray;

        /**
         * OrderSearchCriteria sourceApplication.
         * @member {Array.<string>} sourceApplication
         * @memberof orderspb.OrderSearchCriteria
         * @instance
         */
        OrderSearchCriteria.prototype.sourceApplication = $util.emptyArray;

        /**
         * OrderSearchCriteria propertyAddressID.
         * @member {Array.<string>} propertyAddressID
         * @memberof orderspb.OrderSearchCriteria
         * @instance
         */
        OrderSearchCriteria.prototype.propertyAddressID = $util.emptyArray;

        /**
         * OrderSearchCriteria attributes.
         * @member {Array.<orderspb.IKeyValueFilter>} attributes
         * @memberof orderspb.OrderSearchCriteria
         * @instance
         */
        OrderSearchCriteria.prototype.attributes = $util.emptyArray;

        /**
         * OrderSearchCriteria buyer.
         * @member {orderspb.IPersonCriteria|null|undefined} buyer
         * @memberof orderspb.OrderSearchCriteria
         * @instance
         */
        OrderSearchCriteria.prototype.buyer = null;

        /**
         * OrderSearchCriteria createdDate.
         * @member {common.ITimeslot|null|undefined} createdDate
         * @memberof orderspb.OrderSearchCriteria
         * @instance
         */
        OrderSearchCriteria.prototype.createdDate = null;

        /**
         * OrderSearchCriteria lastModified.
         * @member {common.ITimeslot|null|undefined} lastModified
         * @memberof orderspb.OrderSearchCriteria
         * @instance
         */
        OrderSearchCriteria.prototype.lastModified = null;

        /**
         * OrderSearchCriteria quoteExpiration.
         * @member {common.ITimeslot|null|undefined} quoteExpiration
         * @memberof orderspb.OrderSearchCriteria
         * @instance
         */
        OrderSearchCriteria.prototype.quoteExpiration = null;

        /**
         * OrderSearchCriteria orderExpiration.
         * @member {common.ITimeslot|null|undefined} orderExpiration
         * @memberof orderspb.OrderSearchCriteria
         * @instance
         */
        OrderSearchCriteria.prototype.orderExpiration = null;

        /**
         * OrderSearchCriteria realEstate.
         * @member {orderspb.IRealEstateSearchCriteria|null|undefined} realEstate
         * @memberof orderspb.OrderSearchCriteria
         * @instance
         */
        OrderSearchCriteria.prototype.realEstate = null;

        /**
         * OrderSearchCriteria isGift.
         * @member {google.protobuf.IBoolValue|null|undefined} isGift
         * @memberof orderspb.OrderSearchCriteria
         * @instance
         */
        OrderSearchCriteria.prototype.isGift = null;

        /**
         * OrderSearchCriteria salesChannel.
         * @member {Array.<string>} salesChannel
         * @memberof orderspb.OrderSearchCriteria
         * @instance
         */
        OrderSearchCriteria.prototype.salesChannel = $util.emptyArray;

        /**
         * OrderSearchCriteria tenantID.
         * @member {Array.<string>} tenantID
         * @memberof orderspb.OrderSearchCriteria
         * @instance
         */
        OrderSearchCriteria.prototype.tenantID = $util.emptyArray;

        /**
         * Creates a new OrderSearchCriteria instance using the specified properties.
         * @function create
         * @memberof orderspb.OrderSearchCriteria
         * @static
         * @param {orderspb.IOrderSearchCriteria=} [properties] Properties to set
         * @returns {orderspb.OrderSearchCriteria} OrderSearchCriteria instance
         */
        OrderSearchCriteria.create = function create(properties) {
            return new OrderSearchCriteria(properties);
        };

        /**
         * Encodes the specified OrderSearchCriteria message. Does not implicitly {@link orderspb.OrderSearchCriteria.verify|verify} messages.
         * @function encode
         * @memberof orderspb.OrderSearchCriteria
         * @static
         * @param {orderspb.IOrderSearchCriteria} m OrderSearchCriteria message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        OrderSearchCriteria.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.status != null && m.status.length) {
                for (var i = 0; i < m.status.length; ++i)
                    w.uint32(10).string(m.status[i]);
            }
            if (m.orderType != null && m.orderType.length) {
                w.uint32(18).fork();
                for (var i = 0; i < m.orderType.length; ++i)
                    w.int32(m.orderType[i]);
                w.ldelim();
            }
            if (m.contractID != null && m.contractID.length) {
                for (var i = 0; i < m.contractID.length; ++i)
                    w.uint32(26).string(m.contractID[i]);
            }
            if (m.sourceApplication != null && m.sourceApplication.length) {
                for (var i = 0; i < m.sourceApplication.length; ++i)
                    w.uint32(34).string(m.sourceApplication[i]);
            }
            if (m.propertyAddressID != null && m.propertyAddressID.length) {
                for (var i = 0; i < m.propertyAddressID.length; ++i)
                    w.uint32(42).string(m.propertyAddressID[i]);
            }
            if (m.attributes != null && m.attributes.length) {
                for (var i = 0; i < m.attributes.length; ++i)
                    $root.orderspb.KeyValueFilter.encode(m.attributes[i], w.uint32(50).fork()).ldelim();
            }
            if (m.buyer != null && Object.hasOwnProperty.call(m, "buyer"))
                $root.orderspb.PersonCriteria.encode(m.buyer, w.uint32(58).fork()).ldelim();
            if (m.createdDate != null && Object.hasOwnProperty.call(m, "createdDate"))
                $root.common.Timeslot.encode(m.createdDate, w.uint32(66).fork()).ldelim();
            if (m.lastModified != null && Object.hasOwnProperty.call(m, "lastModified"))
                $root.common.Timeslot.encode(m.lastModified, w.uint32(74).fork()).ldelim();
            if (m.quoteExpiration != null && Object.hasOwnProperty.call(m, "quoteExpiration"))
                $root.common.Timeslot.encode(m.quoteExpiration, w.uint32(82).fork()).ldelim();
            if (m.orderExpiration != null && Object.hasOwnProperty.call(m, "orderExpiration"))
                $root.common.Timeslot.encode(m.orderExpiration, w.uint32(90).fork()).ldelim();
            if (m.realEstate != null && Object.hasOwnProperty.call(m, "realEstate"))
                $root.orderspb.RealEstateSearchCriteria.encode(m.realEstate, w.uint32(98).fork()).ldelim();
            if (m.isGift != null && Object.hasOwnProperty.call(m, "isGift"))
                $root.google.protobuf.BoolValue.encode(m.isGift, w.uint32(106).fork()).ldelim();
            if (m.salesChannel != null && m.salesChannel.length) {
                for (var i = 0; i < m.salesChannel.length; ++i)
                    w.uint32(114).string(m.salesChannel[i]);
            }
            if (m.tenantID != null && m.tenantID.length) {
                for (var i = 0; i < m.tenantID.length; ++i)
                    w.uint32(122).string(m.tenantID[i]);
            }
            return w;
        };

        /**
         * Decodes an OrderSearchCriteria message from the specified reader or buffer.
         * @function decode
         * @memberof orderspb.OrderSearchCriteria
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {orderspb.OrderSearchCriteria} OrderSearchCriteria
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        OrderSearchCriteria.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.orderspb.OrderSearchCriteria();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    if (!(m.status && m.status.length))
                        m.status = [];
                    m.status.push(r.string());
                    break;
                case 2:
                    if (!(m.orderType && m.orderType.length))
                        m.orderType = [];
                    if ((t & 7) === 2) {
                        var c2 = r.uint32() + r.pos;
                        while (r.pos < c2)
                            m.orderType.push(r.int32());
                    } else
                        m.orderType.push(r.int32());
                    break;
                case 3:
                    if (!(m.contractID && m.contractID.length))
                        m.contractID = [];
                    m.contractID.push(r.string());
                    break;
                case 4:
                    if (!(m.sourceApplication && m.sourceApplication.length))
                        m.sourceApplication = [];
                    m.sourceApplication.push(r.string());
                    break;
                case 5:
                    if (!(m.propertyAddressID && m.propertyAddressID.length))
                        m.propertyAddressID = [];
                    m.propertyAddressID.push(r.string());
                    break;
                case 6:
                    if (!(m.attributes && m.attributes.length))
                        m.attributes = [];
                    m.attributes.push($root.orderspb.KeyValueFilter.decode(r, r.uint32()));
                    break;
                case 7:
                    m.buyer = $root.orderspb.PersonCriteria.decode(r, r.uint32());
                    break;
                case 8:
                    m.createdDate = $root.common.Timeslot.decode(r, r.uint32());
                    break;
                case 9:
                    m.lastModified = $root.common.Timeslot.decode(r, r.uint32());
                    break;
                case 10:
                    m.quoteExpiration = $root.common.Timeslot.decode(r, r.uint32());
                    break;
                case 11:
                    m.orderExpiration = $root.common.Timeslot.decode(r, r.uint32());
                    break;
                case 12:
                    m.realEstate = $root.orderspb.RealEstateSearchCriteria.decode(r, r.uint32());
                    break;
                case 13:
                    m.isGift = $root.google.protobuf.BoolValue.decode(r, r.uint32());
                    break;
                case 14:
                    if (!(m.salesChannel && m.salesChannel.length))
                        m.salesChannel = [];
                    m.salesChannel.push(r.string());
                    break;
                case 15:
                    if (!(m.tenantID && m.tenantID.length))
                        m.tenantID = [];
                    m.tenantID.push(r.string());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return OrderSearchCriteria;
    })();

    orderspb.RequestMeta = (function() {

        /**
         * Properties of a RequestMeta.
         * @memberof orderspb
         * @interface IRequestMeta
         * @property {number|null} [page] RequestMeta page
         * @property {number|null} [limit] RequestMeta limit
         * @property {string|null} [sortBy] RequestMeta sortBy
         * @property {boolean|null} [asc] RequestMeta asc
         */

        /**
         * Constructs a new RequestMeta.
         * @memberof orderspb
         * @classdesc Represents a RequestMeta.
         * @implements IRequestMeta
         * @constructor
         * @param {orderspb.IRequestMeta=} [p] Properties to set
         */
        function RequestMeta(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * RequestMeta page.
         * @member {number} page
         * @memberof orderspb.RequestMeta
         * @instance
         */
        RequestMeta.prototype.page = 0;

        /**
         * RequestMeta limit.
         * @member {number} limit
         * @memberof orderspb.RequestMeta
         * @instance
         */
        RequestMeta.prototype.limit = 0;

        /**
         * RequestMeta sortBy.
         * @member {string} sortBy
         * @memberof orderspb.RequestMeta
         * @instance
         */
        RequestMeta.prototype.sortBy = "";

        /**
         * RequestMeta asc.
         * @member {boolean} asc
         * @memberof orderspb.RequestMeta
         * @instance
         */
        RequestMeta.prototype.asc = false;

        /**
         * Creates a new RequestMeta instance using the specified properties.
         * @function create
         * @memberof orderspb.RequestMeta
         * @static
         * @param {orderspb.IRequestMeta=} [properties] Properties to set
         * @returns {orderspb.RequestMeta} RequestMeta instance
         */
        RequestMeta.create = function create(properties) {
            return new RequestMeta(properties);
        };

        /**
         * Encodes the specified RequestMeta message. Does not implicitly {@link orderspb.RequestMeta.verify|verify} messages.
         * @function encode
         * @memberof orderspb.RequestMeta
         * @static
         * @param {orderspb.IRequestMeta} m RequestMeta message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RequestMeta.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.page != null && Object.hasOwnProperty.call(m, "page"))
                w.uint32(8).int32(m.page);
            if (m.limit != null && Object.hasOwnProperty.call(m, "limit"))
                w.uint32(16).int32(m.limit);
            if (m.sortBy != null && Object.hasOwnProperty.call(m, "sortBy"))
                w.uint32(34).string(m.sortBy);
            if (m.asc != null && Object.hasOwnProperty.call(m, "asc"))
                w.uint32(40).bool(m.asc);
            return w;
        };

        /**
         * Decodes a RequestMeta message from the specified reader or buffer.
         * @function decode
         * @memberof orderspb.RequestMeta
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {orderspb.RequestMeta} RequestMeta
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RequestMeta.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.orderspb.RequestMeta();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.page = r.int32();
                    break;
                case 2:
                    m.limit = r.int32();
                    break;
                case 4:
                    m.sortBy = r.string();
                    break;
                case 5:
                    m.asc = r.bool();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return RequestMeta;
    })();

    orderspb.OrderSearchResponse = (function() {

        /**
         * Properties of an OrderSearchResponse.
         * @memberof orderspb
         * @interface IOrderSearchResponse
         * @property {Array.<orderspb.IOrder>|null} [results] OrderSearchResponse results
         * @property {orderspb.IResponseMeta|null} [meta] OrderSearchResponse meta
         */

        /**
         * Constructs a new OrderSearchResponse.
         * @memberof orderspb
         * @classdesc Represents an OrderSearchResponse.
         * @implements IOrderSearchResponse
         * @constructor
         * @param {orderspb.IOrderSearchResponse=} [p] Properties to set
         */
        function OrderSearchResponse(p) {
            this.results = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * OrderSearchResponse results.
         * @member {Array.<orderspb.IOrder>} results
         * @memberof orderspb.OrderSearchResponse
         * @instance
         */
        OrderSearchResponse.prototype.results = $util.emptyArray;

        /**
         * OrderSearchResponse meta.
         * @member {orderspb.IResponseMeta|null|undefined} meta
         * @memberof orderspb.OrderSearchResponse
         * @instance
         */
        OrderSearchResponse.prototype.meta = null;

        /**
         * Creates a new OrderSearchResponse instance using the specified properties.
         * @function create
         * @memberof orderspb.OrderSearchResponse
         * @static
         * @param {orderspb.IOrderSearchResponse=} [properties] Properties to set
         * @returns {orderspb.OrderSearchResponse} OrderSearchResponse instance
         */
        OrderSearchResponse.create = function create(properties) {
            return new OrderSearchResponse(properties);
        };

        /**
         * Encodes the specified OrderSearchResponse message. Does not implicitly {@link orderspb.OrderSearchResponse.verify|verify} messages.
         * @function encode
         * @memberof orderspb.OrderSearchResponse
         * @static
         * @param {orderspb.IOrderSearchResponse} m OrderSearchResponse message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        OrderSearchResponse.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.results != null && m.results.length) {
                for (var i = 0; i < m.results.length; ++i)
                    $root.orderspb.Order.encode(m.results[i], w.uint32(10).fork()).ldelim();
            }
            if (m.meta != null && Object.hasOwnProperty.call(m, "meta"))
                $root.orderspb.ResponseMeta.encode(m.meta, w.uint32(18).fork()).ldelim();
            return w;
        };

        /**
         * Decodes an OrderSearchResponse message from the specified reader or buffer.
         * @function decode
         * @memberof orderspb.OrderSearchResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {orderspb.OrderSearchResponse} OrderSearchResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        OrderSearchResponse.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.orderspb.OrderSearchResponse();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    if (!(m.results && m.results.length))
                        m.results = [];
                    m.results.push($root.orderspb.Order.decode(r, r.uint32()));
                    break;
                case 2:
                    m.meta = $root.orderspb.ResponseMeta.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return OrderSearchResponse;
    })();

    orderspb.ResponseMeta = (function() {

        /**
         * Properties of a ResponseMeta.
         * @memberof orderspb
         * @interface IResponseMeta
         * @property {number|null} [page] ResponseMeta page
         * @property {number|null} [limit] ResponseMeta limit
         * @property {number|null} [total] ResponseMeta total
         */

        /**
         * Constructs a new ResponseMeta.
         * @memberof orderspb
         * @classdesc Represents a ResponseMeta.
         * @implements IResponseMeta
         * @constructor
         * @param {orderspb.IResponseMeta=} [p] Properties to set
         */
        function ResponseMeta(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * ResponseMeta page.
         * @member {number} page
         * @memberof orderspb.ResponseMeta
         * @instance
         */
        ResponseMeta.prototype.page = 0;

        /**
         * ResponseMeta limit.
         * @member {number} limit
         * @memberof orderspb.ResponseMeta
         * @instance
         */
        ResponseMeta.prototype.limit = 0;

        /**
         * ResponseMeta total.
         * @member {number} total
         * @memberof orderspb.ResponseMeta
         * @instance
         */
        ResponseMeta.prototype.total = 0;

        /**
         * Creates a new ResponseMeta instance using the specified properties.
         * @function create
         * @memberof orderspb.ResponseMeta
         * @static
         * @param {orderspb.IResponseMeta=} [properties] Properties to set
         * @returns {orderspb.ResponseMeta} ResponseMeta instance
         */
        ResponseMeta.create = function create(properties) {
            return new ResponseMeta(properties);
        };

        /**
         * Encodes the specified ResponseMeta message. Does not implicitly {@link orderspb.ResponseMeta.verify|verify} messages.
         * @function encode
         * @memberof orderspb.ResponseMeta
         * @static
         * @param {orderspb.IResponseMeta} m ResponseMeta message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ResponseMeta.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.page != null && Object.hasOwnProperty.call(m, "page"))
                w.uint32(8).int32(m.page);
            if (m.limit != null && Object.hasOwnProperty.call(m, "limit"))
                w.uint32(16).int32(m.limit);
            if (m.total != null && Object.hasOwnProperty.call(m, "total"))
                w.uint32(24).int32(m.total);
            return w;
        };

        /**
         * Decodes a ResponseMeta message from the specified reader or buffer.
         * @function decode
         * @memberof orderspb.ResponseMeta
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {orderspb.ResponseMeta} ResponseMeta
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ResponseMeta.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.orderspb.ResponseMeta();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.page = r.int32();
                    break;
                case 2:
                    m.limit = r.int32();
                    break;
                case 3:
                    m.total = r.int32();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return ResponseMeta;
    })();

    orderspb.KeyValueFilter = (function() {

        /**
         * Properties of a KeyValueFilter.
         * @memberof orderspb
         * @interface IKeyValueFilter
         * @property {string|null} [key] KeyValueFilter key
         * @property {Array.<string>|null} [values] KeyValueFilter values
         * @property {boolean|null} [exists] KeyValueFilter exists
         */

        /**
         * Constructs a new KeyValueFilter.
         * @memberof orderspb
         * @classdesc Represents a KeyValueFilter.
         * @implements IKeyValueFilter
         * @constructor
         * @param {orderspb.IKeyValueFilter=} [p] Properties to set
         */
        function KeyValueFilter(p) {
            this.values = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * KeyValueFilter key.
         * @member {string} key
         * @memberof orderspb.KeyValueFilter
         * @instance
         */
        KeyValueFilter.prototype.key = "";

        /**
         * KeyValueFilter values.
         * @member {Array.<string>} values
         * @memberof orderspb.KeyValueFilter
         * @instance
         */
        KeyValueFilter.prototype.values = $util.emptyArray;

        /**
         * KeyValueFilter exists.
         * @member {boolean} exists
         * @memberof orderspb.KeyValueFilter
         * @instance
         */
        KeyValueFilter.prototype.exists = false;

        /**
         * Creates a new KeyValueFilter instance using the specified properties.
         * @function create
         * @memberof orderspb.KeyValueFilter
         * @static
         * @param {orderspb.IKeyValueFilter=} [properties] Properties to set
         * @returns {orderspb.KeyValueFilter} KeyValueFilter instance
         */
        KeyValueFilter.create = function create(properties) {
            return new KeyValueFilter(properties);
        };

        /**
         * Encodes the specified KeyValueFilter message. Does not implicitly {@link orderspb.KeyValueFilter.verify|verify} messages.
         * @function encode
         * @memberof orderspb.KeyValueFilter
         * @static
         * @param {orderspb.IKeyValueFilter} m KeyValueFilter message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        KeyValueFilter.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.key != null && Object.hasOwnProperty.call(m, "key"))
                w.uint32(10).string(m.key);
            if (m.values != null && m.values.length) {
                for (var i = 0; i < m.values.length; ++i)
                    w.uint32(18).string(m.values[i]);
            }
            if (m.exists != null && Object.hasOwnProperty.call(m, "exists"))
                w.uint32(24).bool(m.exists);
            return w;
        };

        /**
         * Decodes a KeyValueFilter message from the specified reader or buffer.
         * @function decode
         * @memberof orderspb.KeyValueFilter
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {orderspb.KeyValueFilter} KeyValueFilter
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        KeyValueFilter.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.orderspb.KeyValueFilter();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.key = r.string();
                    break;
                case 2:
                    if (!(m.values && m.values.length))
                        m.values = [];
                    m.values.push(r.string());
                    break;
                case 3:
                    m.exists = r.bool();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return KeyValueFilter;
    })();

    orderspb.PersonCriteria = (function() {

        /**
         * Properties of a PersonCriteria.
         * @memberof orderspb
         * @interface IPersonCriteria
         * @property {Array.<string>|null} [email] PersonCriteria email
         */

        /**
         * Constructs a new PersonCriteria.
         * @memberof orderspb
         * @classdesc Represents a PersonCriteria.
         * @implements IPersonCriteria
         * @constructor
         * @param {orderspb.IPersonCriteria=} [p] Properties to set
         */
        function PersonCriteria(p) {
            this.email = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * PersonCriteria email.
         * @member {Array.<string>} email
         * @memberof orderspb.PersonCriteria
         * @instance
         */
        PersonCriteria.prototype.email = $util.emptyArray;

        /**
         * Creates a new PersonCriteria instance using the specified properties.
         * @function create
         * @memberof orderspb.PersonCriteria
         * @static
         * @param {orderspb.IPersonCriteria=} [properties] Properties to set
         * @returns {orderspb.PersonCriteria} PersonCriteria instance
         */
        PersonCriteria.create = function create(properties) {
            return new PersonCriteria(properties);
        };

        /**
         * Encodes the specified PersonCriteria message. Does not implicitly {@link orderspb.PersonCriteria.verify|verify} messages.
         * @function encode
         * @memberof orderspb.PersonCriteria
         * @static
         * @param {orderspb.IPersonCriteria} m PersonCriteria message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PersonCriteria.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.email != null && m.email.length) {
                for (var i = 0; i < m.email.length; ++i)
                    w.uint32(10).string(m.email[i]);
            }
            return w;
        };

        /**
         * Decodes a PersonCriteria message from the specified reader or buffer.
         * @function decode
         * @memberof orderspb.PersonCriteria
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {orderspb.PersonCriteria} PersonCriteria
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PersonCriteria.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.orderspb.PersonCriteria();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    if (!(m.email && m.email.length))
                        m.email = [];
                    m.email.push(r.string());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return PersonCriteria;
    })();

    orderspb.RealEstateSearchCriteria = (function() {

        /**
         * Properties of a RealEstateSearchCriteria.
         * @memberof orderspb
         * @interface IRealEstateSearchCriteria
         * @property {orderspb.RealEstateSearchCriteria.IRealEstateOfficeFilter|null} [initiatingOffice] RealEstateSearchCriteria initiatingOffice
         * @property {orderspb.RealEstateSearchCriteria.IRealEstateAgentFilter|null} [initiatingAgent] RealEstateSearchCriteria initiatingAgent
         * @property {orderspb.RealEstateSearchCriteria.IRealEstateOfficeFilter|null} [cooperatingOffice] RealEstateSearchCriteria cooperatingOffice
         * @property {orderspb.RealEstateSearchCriteria.IRealEstateAgentFilter|null} [cooperatingAgent] RealEstateSearchCriteria cooperatingAgent
         */

        /**
         * Constructs a new RealEstateSearchCriteria.
         * @memberof orderspb
         * @classdesc Represents a RealEstateSearchCriteria.
         * @implements IRealEstateSearchCriteria
         * @constructor
         * @param {orderspb.IRealEstateSearchCriteria=} [p] Properties to set
         */
        function RealEstateSearchCriteria(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * RealEstateSearchCriteria initiatingOffice.
         * @member {orderspb.RealEstateSearchCriteria.IRealEstateOfficeFilter|null|undefined} initiatingOffice
         * @memberof orderspb.RealEstateSearchCriteria
         * @instance
         */
        RealEstateSearchCriteria.prototype.initiatingOffice = null;

        /**
         * RealEstateSearchCriteria initiatingAgent.
         * @member {orderspb.RealEstateSearchCriteria.IRealEstateAgentFilter|null|undefined} initiatingAgent
         * @memberof orderspb.RealEstateSearchCriteria
         * @instance
         */
        RealEstateSearchCriteria.prototype.initiatingAgent = null;

        /**
         * RealEstateSearchCriteria cooperatingOffice.
         * @member {orderspb.RealEstateSearchCriteria.IRealEstateOfficeFilter|null|undefined} cooperatingOffice
         * @memberof orderspb.RealEstateSearchCriteria
         * @instance
         */
        RealEstateSearchCriteria.prototype.cooperatingOffice = null;

        /**
         * RealEstateSearchCriteria cooperatingAgent.
         * @member {orderspb.RealEstateSearchCriteria.IRealEstateAgentFilter|null|undefined} cooperatingAgent
         * @memberof orderspb.RealEstateSearchCriteria
         * @instance
         */
        RealEstateSearchCriteria.prototype.cooperatingAgent = null;

        /**
         * Creates a new RealEstateSearchCriteria instance using the specified properties.
         * @function create
         * @memberof orderspb.RealEstateSearchCriteria
         * @static
         * @param {orderspb.IRealEstateSearchCriteria=} [properties] Properties to set
         * @returns {orderspb.RealEstateSearchCriteria} RealEstateSearchCriteria instance
         */
        RealEstateSearchCriteria.create = function create(properties) {
            return new RealEstateSearchCriteria(properties);
        };

        /**
         * Encodes the specified RealEstateSearchCriteria message. Does not implicitly {@link orderspb.RealEstateSearchCriteria.verify|verify} messages.
         * @function encode
         * @memberof orderspb.RealEstateSearchCriteria
         * @static
         * @param {orderspb.IRealEstateSearchCriteria} m RealEstateSearchCriteria message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RealEstateSearchCriteria.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.initiatingOffice != null && Object.hasOwnProperty.call(m, "initiatingOffice"))
                $root.orderspb.RealEstateSearchCriteria.RealEstateOfficeFilter.encode(m.initiatingOffice, w.uint32(10).fork()).ldelim();
            if (m.initiatingAgent != null && Object.hasOwnProperty.call(m, "initiatingAgent"))
                $root.orderspb.RealEstateSearchCriteria.RealEstateAgentFilter.encode(m.initiatingAgent, w.uint32(18).fork()).ldelim();
            if (m.cooperatingOffice != null && Object.hasOwnProperty.call(m, "cooperatingOffice"))
                $root.orderspb.RealEstateSearchCriteria.RealEstateOfficeFilter.encode(m.cooperatingOffice, w.uint32(26).fork()).ldelim();
            if (m.cooperatingAgent != null && Object.hasOwnProperty.call(m, "cooperatingAgent"))
                $root.orderspb.RealEstateSearchCriteria.RealEstateAgentFilter.encode(m.cooperatingAgent, w.uint32(34).fork()).ldelim();
            return w;
        };

        /**
         * Decodes a RealEstateSearchCriteria message from the specified reader or buffer.
         * @function decode
         * @memberof orderspb.RealEstateSearchCriteria
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {orderspb.RealEstateSearchCriteria} RealEstateSearchCriteria
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RealEstateSearchCriteria.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.orderspb.RealEstateSearchCriteria();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.initiatingOffice = $root.orderspb.RealEstateSearchCriteria.RealEstateOfficeFilter.decode(r, r.uint32());
                    break;
                case 2:
                    m.initiatingAgent = $root.orderspb.RealEstateSearchCriteria.RealEstateAgentFilter.decode(r, r.uint32());
                    break;
                case 3:
                    m.cooperatingOffice = $root.orderspb.RealEstateSearchCriteria.RealEstateOfficeFilter.decode(r, r.uint32());
                    break;
                case 4:
                    m.cooperatingAgent = $root.orderspb.RealEstateSearchCriteria.RealEstateAgentFilter.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        RealEstateSearchCriteria.RealEstateOfficeFilter = (function() {

            /**
             * Properties of a RealEstateOfficeFilter.
             * @memberof orderspb.RealEstateSearchCriteria
             * @interface IRealEstateOfficeFilter
             * @property {string|null} [officeID] RealEstateOfficeFilter officeID
             * @property {string|null} [represents] RealEstateOfficeFilter represents
             */

            /**
             * Constructs a new RealEstateOfficeFilter.
             * @memberof orderspb.RealEstateSearchCriteria
             * @classdesc Represents a RealEstateOfficeFilter.
             * @implements IRealEstateOfficeFilter
             * @constructor
             * @param {orderspb.RealEstateSearchCriteria.IRealEstateOfficeFilter=} [p] Properties to set
             */
            function RealEstateOfficeFilter(p) {
                if (p)
                    for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                        if (p[ks[i]] != null)
                            this[ks[i]] = p[ks[i]];
            }

            /**
             * RealEstateOfficeFilter officeID.
             * @member {string} officeID
             * @memberof orderspb.RealEstateSearchCriteria.RealEstateOfficeFilter
             * @instance
             */
            RealEstateOfficeFilter.prototype.officeID = "";

            /**
             * RealEstateOfficeFilter represents.
             * @member {string} represents
             * @memberof orderspb.RealEstateSearchCriteria.RealEstateOfficeFilter
             * @instance
             */
            RealEstateOfficeFilter.prototype.represents = "";

            /**
             * Creates a new RealEstateOfficeFilter instance using the specified properties.
             * @function create
             * @memberof orderspb.RealEstateSearchCriteria.RealEstateOfficeFilter
             * @static
             * @param {orderspb.RealEstateSearchCriteria.IRealEstateOfficeFilter=} [properties] Properties to set
             * @returns {orderspb.RealEstateSearchCriteria.RealEstateOfficeFilter} RealEstateOfficeFilter instance
             */
            RealEstateOfficeFilter.create = function create(properties) {
                return new RealEstateOfficeFilter(properties);
            };

            /**
             * Encodes the specified RealEstateOfficeFilter message. Does not implicitly {@link orderspb.RealEstateSearchCriteria.RealEstateOfficeFilter.verify|verify} messages.
             * @function encode
             * @memberof orderspb.RealEstateSearchCriteria.RealEstateOfficeFilter
             * @static
             * @param {orderspb.RealEstateSearchCriteria.IRealEstateOfficeFilter} m RealEstateOfficeFilter message or plain object to encode
             * @param {$protobuf.Writer} [w] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            RealEstateOfficeFilter.encode = function encode(m, w) {
                if (!w)
                    w = $Writer.create();
                if (m.officeID != null && Object.hasOwnProperty.call(m, "officeID"))
                    w.uint32(10).string(m.officeID);
                if (m.represents != null && Object.hasOwnProperty.call(m, "represents"))
                    w.uint32(18).string(m.represents);
                return w;
            };

            /**
             * Decodes a RealEstateOfficeFilter message from the specified reader or buffer.
             * @function decode
             * @memberof orderspb.RealEstateSearchCriteria.RealEstateOfficeFilter
             * @static
             * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
             * @param {number} [l] Message length if known beforehand
             * @returns {orderspb.RealEstateSearchCriteria.RealEstateOfficeFilter} RealEstateOfficeFilter
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            RealEstateOfficeFilter.decode = function decode(r, l) {
                if (!(r instanceof $Reader))
                    r = $Reader.create(r);
                var c = l === undefined ? r.len : r.pos + l, m = new $root.orderspb.RealEstateSearchCriteria.RealEstateOfficeFilter();
                while (r.pos < c) {
                    var t = r.uint32();
                    switch (t >>> 3) {
                    case 1:
                        m.officeID = r.string();
                        break;
                    case 2:
                        m.represents = r.string();
                        break;
                    default:
                        r.skipType(t & 7);
                        break;
                    }
                }
                return m;
            };

            return RealEstateOfficeFilter;
        })();

        RealEstateSearchCriteria.RealEstateAgentFilter = (function() {

            /**
             * Properties of a RealEstateAgentFilter.
             * @memberof orderspb.RealEstateSearchCriteria
             * @interface IRealEstateAgentFilter
             * @property {string|null} [agentID] RealEstateAgentFilter agentID
             * @property {string|null} [represents] RealEstateAgentFilter represents
             */

            /**
             * Constructs a new RealEstateAgentFilter.
             * @memberof orderspb.RealEstateSearchCriteria
             * @classdesc Represents a RealEstateAgentFilter.
             * @implements IRealEstateAgentFilter
             * @constructor
             * @param {orderspb.RealEstateSearchCriteria.IRealEstateAgentFilter=} [p] Properties to set
             */
            function RealEstateAgentFilter(p) {
                if (p)
                    for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                        if (p[ks[i]] != null)
                            this[ks[i]] = p[ks[i]];
            }

            /**
             * RealEstateAgentFilter agentID.
             * @member {string} agentID
             * @memberof orderspb.RealEstateSearchCriteria.RealEstateAgentFilter
             * @instance
             */
            RealEstateAgentFilter.prototype.agentID = "";

            /**
             * RealEstateAgentFilter represents.
             * @member {string} represents
             * @memberof orderspb.RealEstateSearchCriteria.RealEstateAgentFilter
             * @instance
             */
            RealEstateAgentFilter.prototype.represents = "";

            /**
             * Creates a new RealEstateAgentFilter instance using the specified properties.
             * @function create
             * @memberof orderspb.RealEstateSearchCriteria.RealEstateAgentFilter
             * @static
             * @param {orderspb.RealEstateSearchCriteria.IRealEstateAgentFilter=} [properties] Properties to set
             * @returns {orderspb.RealEstateSearchCriteria.RealEstateAgentFilter} RealEstateAgentFilter instance
             */
            RealEstateAgentFilter.create = function create(properties) {
                return new RealEstateAgentFilter(properties);
            };

            /**
             * Encodes the specified RealEstateAgentFilter message. Does not implicitly {@link orderspb.RealEstateSearchCriteria.RealEstateAgentFilter.verify|verify} messages.
             * @function encode
             * @memberof orderspb.RealEstateSearchCriteria.RealEstateAgentFilter
             * @static
             * @param {orderspb.RealEstateSearchCriteria.IRealEstateAgentFilter} m RealEstateAgentFilter message or plain object to encode
             * @param {$protobuf.Writer} [w] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            RealEstateAgentFilter.encode = function encode(m, w) {
                if (!w)
                    w = $Writer.create();
                if (m.agentID != null && Object.hasOwnProperty.call(m, "agentID"))
                    w.uint32(10).string(m.agentID);
                if (m.represents != null && Object.hasOwnProperty.call(m, "represents"))
                    w.uint32(18).string(m.represents);
                return w;
            };

            /**
             * Decodes a RealEstateAgentFilter message from the specified reader or buffer.
             * @function decode
             * @memberof orderspb.RealEstateSearchCriteria.RealEstateAgentFilter
             * @static
             * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
             * @param {number} [l] Message length if known beforehand
             * @returns {orderspb.RealEstateSearchCriteria.RealEstateAgentFilter} RealEstateAgentFilter
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            RealEstateAgentFilter.decode = function decode(r, l) {
                if (!(r instanceof $Reader))
                    r = $Reader.create(r);
                var c = l === undefined ? r.len : r.pos + l, m = new $root.orderspb.RealEstateSearchCriteria.RealEstateAgentFilter();
                while (r.pos < c) {
                    var t = r.uint32();
                    switch (t >>> 3) {
                    case 1:
                        m.agentID = r.string();
                        break;
                    case 2:
                        m.represents = r.string();
                        break;
                    default:
                        r.skipType(t & 7);
                        break;
                    }
                }
                return m;
            };

            return RealEstateAgentFilter;
        })();

        return RealEstateSearchCriteria;
    })();

    return orderspb;
})();

export const addresspb = $root.addresspb = (() => {

    /**
     * Namespace addresspb.
     * @exports addresspb
     * @namespace
     */
    const addresspb = {};

    addresspb.Address = (function() {

        /**
         * Properties of an Address.
         * @memberof addresspb
         * @interface IAddress
         * @property {string|null} [uuid] Address uuid
         * @property {Array.<number>|null} [legacyIdList] Address legacyIdList
         * @property {Array.<addresspb.Address.IExternalSource>|null} [externalSourceIdList] Address externalSourceIdList
         * @property {string|null} [deliveryPointBarcode] Address deliveryPointBarcode
         * @property {string|null} [street1] Address street1
         * @property {string|null} [street2] Address street2
         * @property {string|null} [unitValue] Address unitValue
         * @property {string|null} [city] Address city
         * @property {string|null} [state] Address state
         * @property {string|null} [zip] Address zip
         * @property {string|null} [zipLocal] Address zipLocal
         * @property {string|null} [countryIso3] Address countryIso3
         * @property {addresspb.Address.IAttributes|null} [attributes] Address attributes
         * @property {string|null} [unitType] Address unitType
         * @property {string|null} [county] Address county
         */

        /**
         * Constructs a new Address.
         * @memberof addresspb
         * @classdesc Represents an Address.
         * @implements IAddress
         * @constructor
         * @param {addresspb.IAddress=} [p] Properties to set
         */
        function Address(p) {
            this.legacyIdList = [];
            this.externalSourceIdList = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * Address uuid.
         * @member {string} uuid
         * @memberof addresspb.Address
         * @instance
         */
        Address.prototype.uuid = "";

        /**
         * Address legacyIdList.
         * @member {Array.<number>} legacyIdList
         * @memberof addresspb.Address
         * @instance
         */
        Address.prototype.legacyIdList = $util.emptyArray;

        /**
         * Address externalSourceIdList.
         * @member {Array.<addresspb.Address.IExternalSource>} externalSourceIdList
         * @memberof addresspb.Address
         * @instance
         */
        Address.prototype.externalSourceIdList = $util.emptyArray;

        /**
         * Address deliveryPointBarcode.
         * @member {string} deliveryPointBarcode
         * @memberof addresspb.Address
         * @instance
         */
        Address.prototype.deliveryPointBarcode = "";

        /**
         * Address street1.
         * @member {string} street1
         * @memberof addresspb.Address
         * @instance
         */
        Address.prototype.street1 = "";

        /**
         * Address street2.
         * @member {string} street2
         * @memberof addresspb.Address
         * @instance
         */
        Address.prototype.street2 = "";

        /**
         * Address unitValue.
         * @member {string} unitValue
         * @memberof addresspb.Address
         * @instance
         */
        Address.prototype.unitValue = "";

        /**
         * Address city.
         * @member {string} city
         * @memberof addresspb.Address
         * @instance
         */
        Address.prototype.city = "";

        /**
         * Address state.
         * @member {string} state
         * @memberof addresspb.Address
         * @instance
         */
        Address.prototype.state = "";

        /**
         * Address zip.
         * @member {string} zip
         * @memberof addresspb.Address
         * @instance
         */
        Address.prototype.zip = "";

        /**
         * Address zipLocal.
         * @member {string} zipLocal
         * @memberof addresspb.Address
         * @instance
         */
        Address.prototype.zipLocal = "";

        /**
         * Address countryIso3.
         * @member {string} countryIso3
         * @memberof addresspb.Address
         * @instance
         */
        Address.prototype.countryIso3 = "";

        /**
         * Address attributes.
         * @member {addresspb.Address.IAttributes|null|undefined} attributes
         * @memberof addresspb.Address
         * @instance
         */
        Address.prototype.attributes = null;

        /**
         * Address unitType.
         * @member {string} unitType
         * @memberof addresspb.Address
         * @instance
         */
        Address.prototype.unitType = "";

        /**
         * Address county.
         * @member {string} county
         * @memberof addresspb.Address
         * @instance
         */
        Address.prototype.county = "";

        /**
         * Creates a new Address instance using the specified properties.
         * @function create
         * @memberof addresspb.Address
         * @static
         * @param {addresspb.IAddress=} [properties] Properties to set
         * @returns {addresspb.Address} Address instance
         */
        Address.create = function create(properties) {
            return new Address(properties);
        };

        /**
         * Encodes the specified Address message. Does not implicitly {@link addresspb.Address.verify|verify} messages.
         * @function encode
         * @memberof addresspb.Address
         * @static
         * @param {addresspb.IAddress} m Address message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Address.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.uuid != null && Object.hasOwnProperty.call(m, "uuid"))
                w.uint32(10).string(m.uuid);
            if (m.legacyIdList != null && m.legacyIdList.length) {
                w.uint32(18).fork();
                for (var i = 0; i < m.legacyIdList.length; ++i)
                    w.uint32(m.legacyIdList[i]);
                w.ldelim();
            }
            if (m.deliveryPointBarcode != null && Object.hasOwnProperty.call(m, "deliveryPointBarcode"))
                w.uint32(26).string(m.deliveryPointBarcode);
            if (m.street1 != null && Object.hasOwnProperty.call(m, "street1"))
                w.uint32(34).string(m.street1);
            if (m.street2 != null && Object.hasOwnProperty.call(m, "street2"))
                w.uint32(42).string(m.street2);
            if (m.unitValue != null && Object.hasOwnProperty.call(m, "unitValue"))
                w.uint32(50).string(m.unitValue);
            if (m.city != null && Object.hasOwnProperty.call(m, "city"))
                w.uint32(58).string(m.city);
            if (m.state != null && Object.hasOwnProperty.call(m, "state"))
                w.uint32(66).string(m.state);
            if (m.zip != null && Object.hasOwnProperty.call(m, "zip"))
                w.uint32(74).string(m.zip);
            if (m.zipLocal != null && Object.hasOwnProperty.call(m, "zipLocal"))
                w.uint32(90).string(m.zipLocal);
            if (m.countryIso3 != null && Object.hasOwnProperty.call(m, "countryIso3"))
                w.uint32(98).string(m.countryIso3);
            if (m.attributes != null && Object.hasOwnProperty.call(m, "attributes"))
                $root.addresspb.Address.Attributes.encode(m.attributes, w.uint32(106).fork()).ldelim();
            if (m.unitType != null && Object.hasOwnProperty.call(m, "unitType"))
                w.uint32(114).string(m.unitType);
            if (m.county != null && Object.hasOwnProperty.call(m, "county"))
                w.uint32(122).string(m.county);
            if (m.externalSourceIdList != null && m.externalSourceIdList.length) {
                for (var i = 0; i < m.externalSourceIdList.length; ++i)
                    $root.addresspb.Address.ExternalSource.encode(m.externalSourceIdList[i], w.uint32(138).fork()).ldelim();
            }
            return w;
        };

        /**
         * Decodes an Address message from the specified reader or buffer.
         * @function decode
         * @memberof addresspb.Address
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {addresspb.Address} Address
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Address.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.addresspb.Address();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.uuid = r.string();
                    break;
                case 2:
                    if (!(m.legacyIdList && m.legacyIdList.length))
                        m.legacyIdList = [];
                    if ((t & 7) === 2) {
                        var c2 = r.uint32() + r.pos;
                        while (r.pos < c2)
                            m.legacyIdList.push(r.uint32());
                    } else
                        m.legacyIdList.push(r.uint32());
                    break;
                case 17:
                    if (!(m.externalSourceIdList && m.externalSourceIdList.length))
                        m.externalSourceIdList = [];
                    m.externalSourceIdList.push($root.addresspb.Address.ExternalSource.decode(r, r.uint32()));
                    break;
                case 3:
                    m.deliveryPointBarcode = r.string();
                    break;
                case 4:
                    m.street1 = r.string();
                    break;
                case 5:
                    m.street2 = r.string();
                    break;
                case 6:
                    m.unitValue = r.string();
                    break;
                case 7:
                    m.city = r.string();
                    break;
                case 8:
                    m.state = r.string();
                    break;
                case 9:
                    m.zip = r.string();
                    break;
                case 11:
                    m.zipLocal = r.string();
                    break;
                case 12:
                    m.countryIso3 = r.string();
                    break;
                case 13:
                    m.attributes = $root.addresspb.Address.Attributes.decode(r, r.uint32());
                    break;
                case 14:
                    m.unitType = r.string();
                    break;
                case 15:
                    m.county = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        Address.ExternalSource = (function() {

            /**
             * Properties of an ExternalSource.
             * @memberof addresspb.Address
             * @interface IExternalSource
             * @property {string|null} [name] ExternalSource name
             * @property {number|null} [id] ExternalSource id
             * @property {google.protobuf.ITimestamp|null} [lastUpdated] ExternalSource lastUpdated
             */

            /**
             * Constructs a new ExternalSource.
             * @memberof addresspb.Address
             * @classdesc Represents an ExternalSource.
             * @implements IExternalSource
             * @constructor
             * @param {addresspb.Address.IExternalSource=} [p] Properties to set
             */
            function ExternalSource(p) {
                if (p)
                    for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                        if (p[ks[i]] != null)
                            this[ks[i]] = p[ks[i]];
            }

            /**
             * ExternalSource name.
             * @member {string} name
             * @memberof addresspb.Address.ExternalSource
             * @instance
             */
            ExternalSource.prototype.name = "";

            /**
             * ExternalSource id.
             * @member {number} id
             * @memberof addresspb.Address.ExternalSource
             * @instance
             */
            ExternalSource.prototype.id = 0;

            /**
             * ExternalSource lastUpdated.
             * @member {google.protobuf.ITimestamp|null|undefined} lastUpdated
             * @memberof addresspb.Address.ExternalSource
             * @instance
             */
            ExternalSource.prototype.lastUpdated = null;

            /**
             * Creates a new ExternalSource instance using the specified properties.
             * @function create
             * @memberof addresspb.Address.ExternalSource
             * @static
             * @param {addresspb.Address.IExternalSource=} [properties] Properties to set
             * @returns {addresspb.Address.ExternalSource} ExternalSource instance
             */
            ExternalSource.create = function create(properties) {
                return new ExternalSource(properties);
            };

            /**
             * Encodes the specified ExternalSource message. Does not implicitly {@link addresspb.Address.ExternalSource.verify|verify} messages.
             * @function encode
             * @memberof addresspb.Address.ExternalSource
             * @static
             * @param {addresspb.Address.IExternalSource} m ExternalSource message or plain object to encode
             * @param {$protobuf.Writer} [w] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ExternalSource.encode = function encode(m, w) {
                if (!w)
                    w = $Writer.create();
                if (m.name != null && Object.hasOwnProperty.call(m, "name"))
                    w.uint32(10).string(m.name);
                if (m.id != null && Object.hasOwnProperty.call(m, "id"))
                    w.uint32(16).uint32(m.id);
                if (m.lastUpdated != null && Object.hasOwnProperty.call(m, "lastUpdated"))
                    $root.google.protobuf.Timestamp.encode(m.lastUpdated, w.uint32(26).fork()).ldelim();
                return w;
            };

            /**
             * Decodes an ExternalSource message from the specified reader or buffer.
             * @function decode
             * @memberof addresspb.Address.ExternalSource
             * @static
             * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
             * @param {number} [l] Message length if known beforehand
             * @returns {addresspb.Address.ExternalSource} ExternalSource
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ExternalSource.decode = function decode(r, l) {
                if (!(r instanceof $Reader))
                    r = $Reader.create(r);
                var c = l === undefined ? r.len : r.pos + l, m = new $root.addresspb.Address.ExternalSource();
                while (r.pos < c) {
                    var t = r.uint32();
                    switch (t >>> 3) {
                    case 1:
                        m.name = r.string();
                        break;
                    case 2:
                        m.id = r.uint32();
                        break;
                    case 3:
                        m.lastUpdated = $root.google.protobuf.Timestamp.decode(r, r.uint32());
                        break;
                    default:
                        r.skipType(t & 7);
                        break;
                    }
                }
                return m;
            };

            return ExternalSource;
        })();

        Address.Attributes = (function() {

            /**
             * Properties of an Attributes.
             * @memberof addresspb.Address
             * @interface IAttributes
             * @property {number|null} [latitude] Attributes latitude
             * @property {number|null} [longitude] Attributes longitude
             * @property {addresspb.Address.Attributes.ITimeZone|null} [timezone] Attributes timezone
             * @property {addresspb.Address.Attributes.Status|null} [status] Attributes status
             * @property {google.protobuf.ITimestamp|null} [lastUpdated] Attributes lastUpdated
             * @property {string|null} [recordType] Attributes recordType
             */

            /**
             * Constructs a new Attributes.
             * @memberof addresspb.Address
             * @classdesc Represents an Attributes.
             * @implements IAttributes
             * @constructor
             * @param {addresspb.Address.IAttributes=} [p] Properties to set
             */
            function Attributes(p) {
                if (p)
                    for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                        if (p[ks[i]] != null)
                            this[ks[i]] = p[ks[i]];
            }

            /**
             * Attributes latitude.
             * @member {number} latitude
             * @memberof addresspb.Address.Attributes
             * @instance
             */
            Attributes.prototype.latitude = 0;

            /**
             * Attributes longitude.
             * @member {number} longitude
             * @memberof addresspb.Address.Attributes
             * @instance
             */
            Attributes.prototype.longitude = 0;

            /**
             * Attributes timezone.
             * @member {addresspb.Address.Attributes.ITimeZone|null|undefined} timezone
             * @memberof addresspb.Address.Attributes
             * @instance
             */
            Attributes.prototype.timezone = null;

            /**
             * Attributes status.
             * @member {addresspb.Address.Attributes.Status} status
             * @memberof addresspb.Address.Attributes
             * @instance
             */
            Attributes.prototype.status = 0;

            /**
             * Attributes lastUpdated.
             * @member {google.protobuf.ITimestamp|null|undefined} lastUpdated
             * @memberof addresspb.Address.Attributes
             * @instance
             */
            Attributes.prototype.lastUpdated = null;

            /**
             * Attributes recordType.
             * @member {string} recordType
             * @memberof addresspb.Address.Attributes
             * @instance
             */
            Attributes.prototype.recordType = "";

            /**
             * Creates a new Attributes instance using the specified properties.
             * @function create
             * @memberof addresspb.Address.Attributes
             * @static
             * @param {addresspb.Address.IAttributes=} [properties] Properties to set
             * @returns {addresspb.Address.Attributes} Attributes instance
             */
            Attributes.create = function create(properties) {
                return new Attributes(properties);
            };

            /**
             * Encodes the specified Attributes message. Does not implicitly {@link addresspb.Address.Attributes.verify|verify} messages.
             * @function encode
             * @memberof addresspb.Address.Attributes
             * @static
             * @param {addresspb.Address.IAttributes} m Attributes message or plain object to encode
             * @param {$protobuf.Writer} [w] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Attributes.encode = function encode(m, w) {
                if (!w)
                    w = $Writer.create();
                if (m.latitude != null && Object.hasOwnProperty.call(m, "latitude"))
                    w.uint32(9).double(m.latitude);
                if (m.longitude != null && Object.hasOwnProperty.call(m, "longitude"))
                    w.uint32(17).double(m.longitude);
                if (m.timezone != null && Object.hasOwnProperty.call(m, "timezone"))
                    $root.addresspb.Address.Attributes.TimeZone.encode(m.timezone, w.uint32(26).fork()).ldelim();
                if (m.status != null && Object.hasOwnProperty.call(m, "status"))
                    w.uint32(32).int32(m.status);
                if (m.lastUpdated != null && Object.hasOwnProperty.call(m, "lastUpdated"))
                    $root.google.protobuf.Timestamp.encode(m.lastUpdated, w.uint32(42).fork()).ldelim();
                if (m.recordType != null && Object.hasOwnProperty.call(m, "recordType"))
                    w.uint32(50).string(m.recordType);
                return w;
            };

            /**
             * Decodes an Attributes message from the specified reader or buffer.
             * @function decode
             * @memberof addresspb.Address.Attributes
             * @static
             * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
             * @param {number} [l] Message length if known beforehand
             * @returns {addresspb.Address.Attributes} Attributes
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Attributes.decode = function decode(r, l) {
                if (!(r instanceof $Reader))
                    r = $Reader.create(r);
                var c = l === undefined ? r.len : r.pos + l, m = new $root.addresspb.Address.Attributes();
                while (r.pos < c) {
                    var t = r.uint32();
                    switch (t >>> 3) {
                    case 1:
                        m.latitude = r.double();
                        break;
                    case 2:
                        m.longitude = r.double();
                        break;
                    case 3:
                        m.timezone = $root.addresspb.Address.Attributes.TimeZone.decode(r, r.uint32());
                        break;
                    case 4:
                        m.status = r.int32();
                        break;
                    case 5:
                        m.lastUpdated = $root.google.protobuf.Timestamp.decode(r, r.uint32());
                        break;
                    case 6:
                        m.recordType = r.string();
                        break;
                    default:
                        r.skipType(t & 7);
                        break;
                    }
                }
                return m;
            };

            Attributes.TimeZone = (function() {

                /**
                 * Properties of a TimeZone.
                 * @memberof addresspb.Address.Attributes
                 * @interface ITimeZone
                 * @property {string|null} [name] TimeZone name
                 * @property {number|null} [UTCOffset] TimeZone UTCOffset
                 * @property {boolean|null} [DSTObserved] TimeZone DSTObserved
                 * @property {number|null} [UTCOffsetWith_DST] TimeZone UTCOffsetWith_DST
                 */

                /**
                 * Constructs a new TimeZone.
                 * @memberof addresspb.Address.Attributes
                 * @classdesc Represents a TimeZone.
                 * @implements ITimeZone
                 * @constructor
                 * @param {addresspb.Address.Attributes.ITimeZone=} [p] Properties to set
                 */
                function TimeZone(p) {
                    if (p)
                        for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                            if (p[ks[i]] != null)
                                this[ks[i]] = p[ks[i]];
                }

                /**
                 * TimeZone name.
                 * @member {string} name
                 * @memberof addresspb.Address.Attributes.TimeZone
                 * @instance
                 */
                TimeZone.prototype.name = "";

                /**
                 * TimeZone UTCOffset.
                 * @member {number} UTCOffset
                 * @memberof addresspb.Address.Attributes.TimeZone
                 * @instance
                 */
                TimeZone.prototype.UTCOffset = 0;

                /**
                 * TimeZone DSTObserved.
                 * @member {boolean} DSTObserved
                 * @memberof addresspb.Address.Attributes.TimeZone
                 * @instance
                 */
                TimeZone.prototype.DSTObserved = false;

                /**
                 * TimeZone UTCOffsetWith_DST.
                 * @member {number} UTCOffsetWith_DST
                 * @memberof addresspb.Address.Attributes.TimeZone
                 * @instance
                 */
                TimeZone.prototype.UTCOffsetWith_DST = 0;

                /**
                 * Creates a new TimeZone instance using the specified properties.
                 * @function create
                 * @memberof addresspb.Address.Attributes.TimeZone
                 * @static
                 * @param {addresspb.Address.Attributes.ITimeZone=} [properties] Properties to set
                 * @returns {addresspb.Address.Attributes.TimeZone} TimeZone instance
                 */
                TimeZone.create = function create(properties) {
                    return new TimeZone(properties);
                };

                /**
                 * Encodes the specified TimeZone message. Does not implicitly {@link addresspb.Address.Attributes.TimeZone.verify|verify} messages.
                 * @function encode
                 * @memberof addresspb.Address.Attributes.TimeZone
                 * @static
                 * @param {addresspb.Address.Attributes.ITimeZone} m TimeZone message or plain object to encode
                 * @param {$protobuf.Writer} [w] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                TimeZone.encode = function encode(m, w) {
                    if (!w)
                        w = $Writer.create();
                    if (m.name != null && Object.hasOwnProperty.call(m, "name"))
                        w.uint32(10).string(m.name);
                    if (m.UTCOffset != null && Object.hasOwnProperty.call(m, "UTCOffset"))
                        w.uint32(16).sint32(m.UTCOffset);
                    if (m.DSTObserved != null && Object.hasOwnProperty.call(m, "DSTObserved"))
                        w.uint32(24).bool(m.DSTObserved);
                    if (m.UTCOffsetWith_DST != null && Object.hasOwnProperty.call(m, "UTCOffsetWith_DST"))
                        w.uint32(32).sint32(m.UTCOffsetWith_DST);
                    return w;
                };

                /**
                 * Decodes a TimeZone message from the specified reader or buffer.
                 * @function decode
                 * @memberof addresspb.Address.Attributes.TimeZone
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
                 * @param {number} [l] Message length if known beforehand
                 * @returns {addresspb.Address.Attributes.TimeZone} TimeZone
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                TimeZone.decode = function decode(r, l) {
                    if (!(r instanceof $Reader))
                        r = $Reader.create(r);
                    var c = l === undefined ? r.len : r.pos + l, m = new $root.addresspb.Address.Attributes.TimeZone();
                    while (r.pos < c) {
                        var t = r.uint32();
                        switch (t >>> 3) {
                        case 1:
                            m.name = r.string();
                            break;
                        case 2:
                            m.UTCOffset = r.sint32();
                            break;
                        case 3:
                            m.DSTObserved = r.bool();
                            break;
                        case 4:
                            m.UTCOffsetWith_DST = r.sint32();
                            break;
                        default:
                            r.skipType(t & 7);
                            break;
                        }
                    }
                    return m;
                };

                return TimeZone;
            })();

            /**
             * Status enum.
             * @name addresspb.Address.Attributes.Status
             * @enum {number}
             * @property {number} VERIFIED=0 VERIFIED value
             * @property {number} UNVERIFIED=1 UNVERIFIED value
             * @property {number} MATCHED=2 MATCHED value
             */
            Attributes.Status = (function() {
                const valuesById = {}, values = Object.create(valuesById);
                values[valuesById[0] = "VERIFIED"] = 0;
                values[valuesById[1] = "UNVERIFIED"] = 1;
                values[valuesById[2] = "MATCHED"] = 2;
                return values;
            })();

            return Attributes;
        })();

        return Address;
    })();

    /**
     * ExternalSource enum.
     * @name addresspb.ExternalSource
     * @enum {number}
     * @property {number} UNKNOWN_SOURCE=0 UNKNOWN_SOURCE value
     * @property {number} COMMERCIAL_PROPERTY=1 COMMERCIAL_PROPERTY value
     */
    addresspb.ExternalSource = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "UNKNOWN_SOURCE"] = 0;
        values[valuesById[1] = "COMMERCIAL_PROPERTY"] = 1;
        return values;
    })();

    addresspb.AddressRequest = (function() {

        /**
         * Properties of an AddressRequest.
         * @memberof addresspb
         * @interface IAddressRequest
         * @property {string|null} [street1] AddressRequest street1
         * @property {string|null} [unitType] AddressRequest unitType
         * @property {string|null} [unitValue] AddressRequest unitValue
         * @property {string|null} [city] AddressRequest city
         * @property {string|null} [state] AddressRequest state
         * @property {string|null} [zip] AddressRequest zip
         * @property {string|null} [countryIso3] AddressRequest countryIso3
         * @property {addresspb.ExternalSource|null} [externalSource] AddressRequest externalSource
         * @property {number|null} [externalSourceId] AddressRequest externalSourceId
         * @property {boolean|null} [mustValidate] AddressRequest mustValidate
         */

        /**
         * Constructs a new AddressRequest.
         * @memberof addresspb
         * @classdesc Represents an AddressRequest.
         * @implements IAddressRequest
         * @constructor
         * @param {addresspb.IAddressRequest=} [p] Properties to set
         */
        function AddressRequest(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * AddressRequest street1.
         * @member {string} street1
         * @memberof addresspb.AddressRequest
         * @instance
         */
        AddressRequest.prototype.street1 = "";

        /**
         * AddressRequest unitType.
         * @member {string} unitType
         * @memberof addresspb.AddressRequest
         * @instance
         */
        AddressRequest.prototype.unitType = "";

        /**
         * AddressRequest unitValue.
         * @member {string} unitValue
         * @memberof addresspb.AddressRequest
         * @instance
         */
        AddressRequest.prototype.unitValue = "";

        /**
         * AddressRequest city.
         * @member {string} city
         * @memberof addresspb.AddressRequest
         * @instance
         */
        AddressRequest.prototype.city = "";

        /**
         * AddressRequest state.
         * @member {string} state
         * @memberof addresspb.AddressRequest
         * @instance
         */
        AddressRequest.prototype.state = "";

        /**
         * AddressRequest zip.
         * @member {string} zip
         * @memberof addresspb.AddressRequest
         * @instance
         */
        AddressRequest.prototype.zip = "";

        /**
         * AddressRequest countryIso3.
         * @member {string} countryIso3
         * @memberof addresspb.AddressRequest
         * @instance
         */
        AddressRequest.prototype.countryIso3 = "";

        /**
         * AddressRequest externalSource.
         * @member {addresspb.ExternalSource} externalSource
         * @memberof addresspb.AddressRequest
         * @instance
         */
        AddressRequest.prototype.externalSource = 0;

        /**
         * AddressRequest externalSourceId.
         * @member {number} externalSourceId
         * @memberof addresspb.AddressRequest
         * @instance
         */
        AddressRequest.prototype.externalSourceId = 0;

        /**
         * AddressRequest mustValidate.
         * @member {boolean} mustValidate
         * @memberof addresspb.AddressRequest
         * @instance
         */
        AddressRequest.prototype.mustValidate = false;

        /**
         * Creates a new AddressRequest instance using the specified properties.
         * @function create
         * @memberof addresspb.AddressRequest
         * @static
         * @param {addresspb.IAddressRequest=} [properties] Properties to set
         * @returns {addresspb.AddressRequest} AddressRequest instance
         */
        AddressRequest.create = function create(properties) {
            return new AddressRequest(properties);
        };

        /**
         * Encodes the specified AddressRequest message. Does not implicitly {@link addresspb.AddressRequest.verify|verify} messages.
         * @function encode
         * @memberof addresspb.AddressRequest
         * @static
         * @param {addresspb.IAddressRequest} m AddressRequest message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AddressRequest.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.street1 != null && Object.hasOwnProperty.call(m, "street1"))
                w.uint32(10).string(m.street1);
            if (m.unitValue != null && Object.hasOwnProperty.call(m, "unitValue"))
                w.uint32(18).string(m.unitValue);
            if (m.city != null && Object.hasOwnProperty.call(m, "city"))
                w.uint32(26).string(m.city);
            if (m.state != null && Object.hasOwnProperty.call(m, "state"))
                w.uint32(34).string(m.state);
            if (m.zip != null && Object.hasOwnProperty.call(m, "zip"))
                w.uint32(42).string(m.zip);
            if (m.countryIso3 != null && Object.hasOwnProperty.call(m, "countryIso3"))
                w.uint32(50).string(m.countryIso3);
            if (m.unitType != null && Object.hasOwnProperty.call(m, "unitType"))
                w.uint32(58).string(m.unitType);
            if (m.externalSource != null && Object.hasOwnProperty.call(m, "externalSource"))
                w.uint32(72).int32(m.externalSource);
            if (m.externalSourceId != null && Object.hasOwnProperty.call(m, "externalSourceId"))
                w.uint32(80).uint32(m.externalSourceId);
            if (m.mustValidate != null && Object.hasOwnProperty.call(m, "mustValidate"))
                w.uint32(88).bool(m.mustValidate);
            return w;
        };

        /**
         * Decodes an AddressRequest message from the specified reader or buffer.
         * @function decode
         * @memberof addresspb.AddressRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {addresspb.AddressRequest} AddressRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AddressRequest.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.addresspb.AddressRequest();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.street1 = r.string();
                    break;
                case 7:
                    m.unitType = r.string();
                    break;
                case 2:
                    m.unitValue = r.string();
                    break;
                case 3:
                    m.city = r.string();
                    break;
                case 4:
                    m.state = r.string();
                    break;
                case 5:
                    m.zip = r.string();
                    break;
                case 6:
                    m.countryIso3 = r.string();
                    break;
                case 9:
                    m.externalSource = r.int32();
                    break;
                case 10:
                    m.externalSourceId = r.uint32();
                    break;
                case 11:
                    m.mustValidate = r.bool();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return AddressRequest;
    })();

    addresspb.VerifiedOrUnverifiedAddressRequest = (function() {

        /**
         * Properties of a VerifiedOrUnverifiedAddressRequest.
         * @memberof addresspb
         * @interface IVerifiedOrUnverifiedAddressRequest
         * @property {string|null} [street1] VerifiedOrUnverifiedAddressRequest street1
         * @property {string|null} [unitType] VerifiedOrUnverifiedAddressRequest unitType
         * @property {string|null} [unitValue] VerifiedOrUnverifiedAddressRequest unitValue
         * @property {string|null} [city] VerifiedOrUnverifiedAddressRequest city
         * @property {string|null} [state] VerifiedOrUnverifiedAddressRequest state
         * @property {string|null} [zip] VerifiedOrUnverifiedAddressRequest zip
         * @property {string|null} [countryIso3] VerifiedOrUnverifiedAddressRequest countryIso3
         * @property {addresspb.ExternalSource|null} [externalSource] VerifiedOrUnverifiedAddressRequest externalSource
         * @property {number|null} [externalSourceId] VerifiedOrUnverifiedAddressRequest externalSourceId
         */

        /**
         * Constructs a new VerifiedOrUnverifiedAddressRequest.
         * @memberof addresspb
         * @classdesc Represents a VerifiedOrUnverifiedAddressRequest.
         * @implements IVerifiedOrUnverifiedAddressRequest
         * @constructor
         * @param {addresspb.IVerifiedOrUnverifiedAddressRequest=} [p] Properties to set
         */
        function VerifiedOrUnverifiedAddressRequest(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * VerifiedOrUnverifiedAddressRequest street1.
         * @member {string} street1
         * @memberof addresspb.VerifiedOrUnverifiedAddressRequest
         * @instance
         */
        VerifiedOrUnverifiedAddressRequest.prototype.street1 = "";

        /**
         * VerifiedOrUnverifiedAddressRequest unitType.
         * @member {string} unitType
         * @memberof addresspb.VerifiedOrUnverifiedAddressRequest
         * @instance
         */
        VerifiedOrUnverifiedAddressRequest.prototype.unitType = "";

        /**
         * VerifiedOrUnverifiedAddressRequest unitValue.
         * @member {string} unitValue
         * @memberof addresspb.VerifiedOrUnverifiedAddressRequest
         * @instance
         */
        VerifiedOrUnverifiedAddressRequest.prototype.unitValue = "";

        /**
         * VerifiedOrUnverifiedAddressRequest city.
         * @member {string} city
         * @memberof addresspb.VerifiedOrUnverifiedAddressRequest
         * @instance
         */
        VerifiedOrUnverifiedAddressRequest.prototype.city = "";

        /**
         * VerifiedOrUnverifiedAddressRequest state.
         * @member {string} state
         * @memberof addresspb.VerifiedOrUnverifiedAddressRequest
         * @instance
         */
        VerifiedOrUnverifiedAddressRequest.prototype.state = "";

        /**
         * VerifiedOrUnverifiedAddressRequest zip.
         * @member {string} zip
         * @memberof addresspb.VerifiedOrUnverifiedAddressRequest
         * @instance
         */
        VerifiedOrUnverifiedAddressRequest.prototype.zip = "";

        /**
         * VerifiedOrUnverifiedAddressRequest countryIso3.
         * @member {string} countryIso3
         * @memberof addresspb.VerifiedOrUnverifiedAddressRequest
         * @instance
         */
        VerifiedOrUnverifiedAddressRequest.prototype.countryIso3 = "";

        /**
         * VerifiedOrUnverifiedAddressRequest externalSource.
         * @member {addresspb.ExternalSource} externalSource
         * @memberof addresspb.VerifiedOrUnverifiedAddressRequest
         * @instance
         */
        VerifiedOrUnverifiedAddressRequest.prototype.externalSource = 0;

        /**
         * VerifiedOrUnverifiedAddressRequest externalSourceId.
         * @member {number} externalSourceId
         * @memberof addresspb.VerifiedOrUnverifiedAddressRequest
         * @instance
         */
        VerifiedOrUnverifiedAddressRequest.prototype.externalSourceId = 0;

        /**
         * Creates a new VerifiedOrUnverifiedAddressRequest instance using the specified properties.
         * @function create
         * @memberof addresspb.VerifiedOrUnverifiedAddressRequest
         * @static
         * @param {addresspb.IVerifiedOrUnverifiedAddressRequest=} [properties] Properties to set
         * @returns {addresspb.VerifiedOrUnverifiedAddressRequest} VerifiedOrUnverifiedAddressRequest instance
         */
        VerifiedOrUnverifiedAddressRequest.create = function create(properties) {
            return new VerifiedOrUnverifiedAddressRequest(properties);
        };

        /**
         * Encodes the specified VerifiedOrUnverifiedAddressRequest message. Does not implicitly {@link addresspb.VerifiedOrUnverifiedAddressRequest.verify|verify} messages.
         * @function encode
         * @memberof addresspb.VerifiedOrUnverifiedAddressRequest
         * @static
         * @param {addresspb.IVerifiedOrUnverifiedAddressRequest} m VerifiedOrUnverifiedAddressRequest message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        VerifiedOrUnverifiedAddressRequest.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.street1 != null && Object.hasOwnProperty.call(m, "street1"))
                w.uint32(10).string(m.street1);
            if (m.unitType != null && Object.hasOwnProperty.call(m, "unitType"))
                w.uint32(18).string(m.unitType);
            if (m.unitValue != null && Object.hasOwnProperty.call(m, "unitValue"))
                w.uint32(26).string(m.unitValue);
            if (m.city != null && Object.hasOwnProperty.call(m, "city"))
                w.uint32(34).string(m.city);
            if (m.state != null && Object.hasOwnProperty.call(m, "state"))
                w.uint32(42).string(m.state);
            if (m.zip != null && Object.hasOwnProperty.call(m, "zip"))
                w.uint32(50).string(m.zip);
            if (m.countryIso3 != null && Object.hasOwnProperty.call(m, "countryIso3"))
                w.uint32(58).string(m.countryIso3);
            if (m.externalSource != null && Object.hasOwnProperty.call(m, "externalSource"))
                w.uint32(64).int32(m.externalSource);
            if (m.externalSourceId != null && Object.hasOwnProperty.call(m, "externalSourceId"))
                w.uint32(72).uint32(m.externalSourceId);
            return w;
        };

        /**
         * Decodes a VerifiedOrUnverifiedAddressRequest message from the specified reader or buffer.
         * @function decode
         * @memberof addresspb.VerifiedOrUnverifiedAddressRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {addresspb.VerifiedOrUnverifiedAddressRequest} VerifiedOrUnverifiedAddressRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        VerifiedOrUnverifiedAddressRequest.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.addresspb.VerifiedOrUnverifiedAddressRequest();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.street1 = r.string();
                    break;
                case 2:
                    m.unitType = r.string();
                    break;
                case 3:
                    m.unitValue = r.string();
                    break;
                case 4:
                    m.city = r.string();
                    break;
                case 5:
                    m.state = r.string();
                    break;
                case 6:
                    m.zip = r.string();
                    break;
                case 7:
                    m.countryIso3 = r.string();
                    break;
                case 8:
                    m.externalSource = r.int32();
                    break;
                case 9:
                    m.externalSourceId = r.uint32();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return VerifiedOrUnverifiedAddressRequest;
    })();

    addresspb.AddressResponse = (function() {

        /**
         * Properties of an AddressResponse.
         * @memberof addresspb
         * @interface IAddressResponse
         * @property {addresspb.IAddress|null} [address] AddressResponse address
         * @property {boolean|null} [corrected] AddressResponse corrected
         * @property {Array.<common.IError>|null} [errors] AddressResponse errors
         * @property {common.Status|null} [status] AddressResponse status
         */

        /**
         * Constructs a new AddressResponse.
         * @memberof addresspb
         * @classdesc Represents an AddressResponse.
         * @implements IAddressResponse
         * @constructor
         * @param {addresspb.IAddressResponse=} [p] Properties to set
         */
        function AddressResponse(p) {
            this.errors = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * AddressResponse address.
         * @member {addresspb.IAddress|null|undefined} address
         * @memberof addresspb.AddressResponse
         * @instance
         */
        AddressResponse.prototype.address = null;

        /**
         * AddressResponse corrected.
         * @member {boolean} corrected
         * @memberof addresspb.AddressResponse
         * @instance
         */
        AddressResponse.prototype.corrected = false;

        /**
         * AddressResponse errors.
         * @member {Array.<common.IError>} errors
         * @memberof addresspb.AddressResponse
         * @instance
         */
        AddressResponse.prototype.errors = $util.emptyArray;

        /**
         * AddressResponse status.
         * @member {common.Status} status
         * @memberof addresspb.AddressResponse
         * @instance
         */
        AddressResponse.prototype.status = 0;

        /**
         * Creates a new AddressResponse instance using the specified properties.
         * @function create
         * @memberof addresspb.AddressResponse
         * @static
         * @param {addresspb.IAddressResponse=} [properties] Properties to set
         * @returns {addresspb.AddressResponse} AddressResponse instance
         */
        AddressResponse.create = function create(properties) {
            return new AddressResponse(properties);
        };

        /**
         * Encodes the specified AddressResponse message. Does not implicitly {@link addresspb.AddressResponse.verify|verify} messages.
         * @function encode
         * @memberof addresspb.AddressResponse
         * @static
         * @param {addresspb.IAddressResponse} m AddressResponse message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AddressResponse.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.address != null && Object.hasOwnProperty.call(m, "address"))
                $root.addresspb.Address.encode(m.address, w.uint32(10).fork()).ldelim();
            if (m.corrected != null && Object.hasOwnProperty.call(m, "corrected"))
                w.uint32(16).bool(m.corrected);
            if (m.errors != null && m.errors.length) {
                for (var i = 0; i < m.errors.length; ++i)
                    $root.common.Error.encode(m.errors[i], w.uint32(26).fork()).ldelim();
            }
            if (m.status != null && Object.hasOwnProperty.call(m, "status"))
                w.uint32(32).int32(m.status);
            return w;
        };

        /**
         * Decodes an AddressResponse message from the specified reader or buffer.
         * @function decode
         * @memberof addresspb.AddressResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {addresspb.AddressResponse} AddressResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AddressResponse.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.addresspb.AddressResponse();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.address = $root.addresspb.Address.decode(r, r.uint32());
                    break;
                case 2:
                    m.corrected = r.bool();
                    break;
                case 3:
                    if (!(m.errors && m.errors.length))
                        m.errors = [];
                    m.errors.push($root.common.Error.decode(r, r.uint32()));
                    break;
                case 4:
                    m.status = r.int32();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return AddressResponse;
    })();

    addresspb.TypeAheadAddress = (function() {

        /**
         * Properties of a TypeAheadAddress.
         * @memberof addresspb
         * @interface ITypeAheadAddress
         * @property {string|null} [text] TypeAheadAddress text
         * @property {string|null} [streetLine] TypeAheadAddress streetLine
         * @property {string|null} [city] TypeAheadAddress city
         * @property {string|null} [state] TypeAheadAddress state
         * @property {string|null} [zipCode] TypeAheadAddress zipCode
         */

        /**
         * Constructs a new TypeAheadAddress.
         * @memberof addresspb
         * @classdesc Represents a TypeAheadAddress.
         * @implements ITypeAheadAddress
         * @constructor
         * @param {addresspb.ITypeAheadAddress=} [p] Properties to set
         */
        function TypeAheadAddress(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * TypeAheadAddress text.
         * @member {string} text
         * @memberof addresspb.TypeAheadAddress
         * @instance
         */
        TypeAheadAddress.prototype.text = "";

        /**
         * TypeAheadAddress streetLine.
         * @member {string} streetLine
         * @memberof addresspb.TypeAheadAddress
         * @instance
         */
        TypeAheadAddress.prototype.streetLine = "";

        /**
         * TypeAheadAddress city.
         * @member {string} city
         * @memberof addresspb.TypeAheadAddress
         * @instance
         */
        TypeAheadAddress.prototype.city = "";

        /**
         * TypeAheadAddress state.
         * @member {string} state
         * @memberof addresspb.TypeAheadAddress
         * @instance
         */
        TypeAheadAddress.prototype.state = "";

        /**
         * TypeAheadAddress zipCode.
         * @member {string} zipCode
         * @memberof addresspb.TypeAheadAddress
         * @instance
         */
        TypeAheadAddress.prototype.zipCode = "";

        /**
         * Creates a new TypeAheadAddress instance using the specified properties.
         * @function create
         * @memberof addresspb.TypeAheadAddress
         * @static
         * @param {addresspb.ITypeAheadAddress=} [properties] Properties to set
         * @returns {addresspb.TypeAheadAddress} TypeAheadAddress instance
         */
        TypeAheadAddress.create = function create(properties) {
            return new TypeAheadAddress(properties);
        };

        /**
         * Encodes the specified TypeAheadAddress message. Does not implicitly {@link addresspb.TypeAheadAddress.verify|verify} messages.
         * @function encode
         * @memberof addresspb.TypeAheadAddress
         * @static
         * @param {addresspb.ITypeAheadAddress} m TypeAheadAddress message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        TypeAheadAddress.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.text != null && Object.hasOwnProperty.call(m, "text"))
                w.uint32(10).string(m.text);
            if (m.streetLine != null && Object.hasOwnProperty.call(m, "streetLine"))
                w.uint32(18).string(m.streetLine);
            if (m.city != null && Object.hasOwnProperty.call(m, "city"))
                w.uint32(26).string(m.city);
            if (m.state != null && Object.hasOwnProperty.call(m, "state"))
                w.uint32(34).string(m.state);
            if (m.zipCode != null && Object.hasOwnProperty.call(m, "zipCode"))
                w.uint32(42).string(m.zipCode);
            return w;
        };

        /**
         * Decodes a TypeAheadAddress message from the specified reader or buffer.
         * @function decode
         * @memberof addresspb.TypeAheadAddress
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {addresspb.TypeAheadAddress} TypeAheadAddress
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        TypeAheadAddress.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.addresspb.TypeAheadAddress();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.text = r.string();
                    break;
                case 2:
                    m.streetLine = r.string();
                    break;
                case 3:
                    m.city = r.string();
                    break;
                case 4:
                    m.state = r.string();
                    break;
                case 5:
                    m.zipCode = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return TypeAheadAddress;
    })();

    addresspb.AddressByTypeAheadRequest = (function() {

        /**
         * Properties of an AddressByTypeAheadRequest.
         * @memberof addresspb
         * @interface IAddressByTypeAheadRequest
         * @property {string|null} [streetLine] AddressByTypeAheadRequest streetLine
         * @property {string|null} [unitType] AddressByTypeAheadRequest unitType
         * @property {string|null} [unitValue] AddressByTypeAheadRequest unitValue
         * @property {string|null} [city] AddressByTypeAheadRequest city
         * @property {string|null} [state] AddressByTypeAheadRequest state
         * @property {number|null} [maxSuggestions] AddressByTypeAheadRequest maxSuggestions
         * @property {string|null} [zipCode] AddressByTypeAheadRequest zipCode
         */

        /**
         * Constructs a new AddressByTypeAheadRequest.
         * @memberof addresspb
         * @classdesc Represents an AddressByTypeAheadRequest.
         * @implements IAddressByTypeAheadRequest
         * @constructor
         * @param {addresspb.IAddressByTypeAheadRequest=} [p] Properties to set
         */
        function AddressByTypeAheadRequest(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * AddressByTypeAheadRequest streetLine.
         * @member {string} streetLine
         * @memberof addresspb.AddressByTypeAheadRequest
         * @instance
         */
        AddressByTypeAheadRequest.prototype.streetLine = "";

        /**
         * AddressByTypeAheadRequest unitType.
         * @member {string} unitType
         * @memberof addresspb.AddressByTypeAheadRequest
         * @instance
         */
        AddressByTypeAheadRequest.prototype.unitType = "";

        /**
         * AddressByTypeAheadRequest unitValue.
         * @member {string} unitValue
         * @memberof addresspb.AddressByTypeAheadRequest
         * @instance
         */
        AddressByTypeAheadRequest.prototype.unitValue = "";

        /**
         * AddressByTypeAheadRequest city.
         * @member {string} city
         * @memberof addresspb.AddressByTypeAheadRequest
         * @instance
         */
        AddressByTypeAheadRequest.prototype.city = "";

        /**
         * AddressByTypeAheadRequest state.
         * @member {string} state
         * @memberof addresspb.AddressByTypeAheadRequest
         * @instance
         */
        AddressByTypeAheadRequest.prototype.state = "";

        /**
         * AddressByTypeAheadRequest maxSuggestions.
         * @member {number} maxSuggestions
         * @memberof addresspb.AddressByTypeAheadRequest
         * @instance
         */
        AddressByTypeAheadRequest.prototype.maxSuggestions = 0;

        /**
         * AddressByTypeAheadRequest zipCode.
         * @member {string} zipCode
         * @memberof addresspb.AddressByTypeAheadRequest
         * @instance
         */
        AddressByTypeAheadRequest.prototype.zipCode = "";

        /**
         * Creates a new AddressByTypeAheadRequest instance using the specified properties.
         * @function create
         * @memberof addresspb.AddressByTypeAheadRequest
         * @static
         * @param {addresspb.IAddressByTypeAheadRequest=} [properties] Properties to set
         * @returns {addresspb.AddressByTypeAheadRequest} AddressByTypeAheadRequest instance
         */
        AddressByTypeAheadRequest.create = function create(properties) {
            return new AddressByTypeAheadRequest(properties);
        };

        /**
         * Encodes the specified AddressByTypeAheadRequest message. Does not implicitly {@link addresspb.AddressByTypeAheadRequest.verify|verify} messages.
         * @function encode
         * @memberof addresspb.AddressByTypeAheadRequest
         * @static
         * @param {addresspb.IAddressByTypeAheadRequest} m AddressByTypeAheadRequest message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AddressByTypeAheadRequest.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.streetLine != null && Object.hasOwnProperty.call(m, "streetLine"))
                w.uint32(10).string(m.streetLine);
            if (m.unitValue != null && Object.hasOwnProperty.call(m, "unitValue"))
                w.uint32(18).string(m.unitValue);
            if (m.city != null && Object.hasOwnProperty.call(m, "city"))
                w.uint32(26).string(m.city);
            if (m.state != null && Object.hasOwnProperty.call(m, "state"))
                w.uint32(34).string(m.state);
            if (m.unitType != null && Object.hasOwnProperty.call(m, "unitType"))
                w.uint32(42).string(m.unitType);
            if (m.maxSuggestions != null && Object.hasOwnProperty.call(m, "maxSuggestions"))
                w.uint32(48).uint32(m.maxSuggestions);
            if (m.zipCode != null && Object.hasOwnProperty.call(m, "zipCode"))
                w.uint32(58).string(m.zipCode);
            return w;
        };

        /**
         * Decodes an AddressByTypeAheadRequest message from the specified reader or buffer.
         * @function decode
         * @memberof addresspb.AddressByTypeAheadRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {addresspb.AddressByTypeAheadRequest} AddressByTypeAheadRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AddressByTypeAheadRequest.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.addresspb.AddressByTypeAheadRequest();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.streetLine = r.string();
                    break;
                case 5:
                    m.unitType = r.string();
                    break;
                case 2:
                    m.unitValue = r.string();
                    break;
                case 3:
                    m.city = r.string();
                    break;
                case 4:
                    m.state = r.string();
                    break;
                case 6:
                    m.maxSuggestions = r.uint32();
                    break;
                case 7:
                    m.zipCode = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return AddressByTypeAheadRequest;
    })();

    addresspb.AddressByTypeAheadResponse = (function() {

        /**
         * Properties of an AddressByTypeAheadResponse.
         * @memberof addresspb
         * @interface IAddressByTypeAheadResponse
         * @property {Array.<addresspb.ITypeAheadAddress>|null} [addresses] AddressByTypeAheadResponse addresses
         * @property {Array.<common.IError>|null} [errors] AddressByTypeAheadResponse errors
         * @property {common.Status|null} [status] AddressByTypeAheadResponse status
         */

        /**
         * Constructs a new AddressByTypeAheadResponse.
         * @memberof addresspb
         * @classdesc Represents an AddressByTypeAheadResponse.
         * @implements IAddressByTypeAheadResponse
         * @constructor
         * @param {addresspb.IAddressByTypeAheadResponse=} [p] Properties to set
         */
        function AddressByTypeAheadResponse(p) {
            this.addresses = [];
            this.errors = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * AddressByTypeAheadResponse addresses.
         * @member {Array.<addresspb.ITypeAheadAddress>} addresses
         * @memberof addresspb.AddressByTypeAheadResponse
         * @instance
         */
        AddressByTypeAheadResponse.prototype.addresses = $util.emptyArray;

        /**
         * AddressByTypeAheadResponse errors.
         * @member {Array.<common.IError>} errors
         * @memberof addresspb.AddressByTypeAheadResponse
         * @instance
         */
        AddressByTypeAheadResponse.prototype.errors = $util.emptyArray;

        /**
         * AddressByTypeAheadResponse status.
         * @member {common.Status} status
         * @memberof addresspb.AddressByTypeAheadResponse
         * @instance
         */
        AddressByTypeAheadResponse.prototype.status = 0;

        /**
         * Creates a new AddressByTypeAheadResponse instance using the specified properties.
         * @function create
         * @memberof addresspb.AddressByTypeAheadResponse
         * @static
         * @param {addresspb.IAddressByTypeAheadResponse=} [properties] Properties to set
         * @returns {addresspb.AddressByTypeAheadResponse} AddressByTypeAheadResponse instance
         */
        AddressByTypeAheadResponse.create = function create(properties) {
            return new AddressByTypeAheadResponse(properties);
        };

        /**
         * Encodes the specified AddressByTypeAheadResponse message. Does not implicitly {@link addresspb.AddressByTypeAheadResponse.verify|verify} messages.
         * @function encode
         * @memberof addresspb.AddressByTypeAheadResponse
         * @static
         * @param {addresspb.IAddressByTypeAheadResponse} m AddressByTypeAheadResponse message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AddressByTypeAheadResponse.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.addresses != null && m.addresses.length) {
                for (var i = 0; i < m.addresses.length; ++i)
                    $root.addresspb.TypeAheadAddress.encode(m.addresses[i], w.uint32(10).fork()).ldelim();
            }
            if (m.errors != null && m.errors.length) {
                for (var i = 0; i < m.errors.length; ++i)
                    $root.common.Error.encode(m.errors[i], w.uint32(18).fork()).ldelim();
            }
            if (m.status != null && Object.hasOwnProperty.call(m, "status"))
                w.uint32(24).int32(m.status);
            return w;
        };

        /**
         * Decodes an AddressByTypeAheadResponse message from the specified reader or buffer.
         * @function decode
         * @memberof addresspb.AddressByTypeAheadResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {addresspb.AddressByTypeAheadResponse} AddressByTypeAheadResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AddressByTypeAheadResponse.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.addresspb.AddressByTypeAheadResponse();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    if (!(m.addresses && m.addresses.length))
                        m.addresses = [];
                    m.addresses.push($root.addresspb.TypeAheadAddress.decode(r, r.uint32()));
                    break;
                case 2:
                    if (!(m.errors && m.errors.length))
                        m.errors = [];
                    m.errors.push($root.common.Error.decode(r, r.uint32()));
                    break;
                case 3:
                    m.status = r.int32();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return AddressByTypeAheadResponse;
    })();

    addresspb.UnverifiedAddressRequest = (function() {

        /**
         * Properties of an UnverifiedAddressRequest.
         * @memberof addresspb
         * @interface IUnverifiedAddressRequest
         * @property {addresspb.IAddress|null} [address] UnverifiedAddressRequest address
         * @property {addresspb.ExternalSource|null} [externalSource] UnverifiedAddressRequest externalSource
         * @property {boolean|null} [force] UnverifiedAddressRequest force
         */

        /**
         * Constructs a new UnverifiedAddressRequest.
         * @memberof addresspb
         * @classdesc Represents an UnverifiedAddressRequest.
         * @implements IUnverifiedAddressRequest
         * @constructor
         * @param {addresspb.IUnverifiedAddressRequest=} [p] Properties to set
         */
        function UnverifiedAddressRequest(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * UnverifiedAddressRequest address.
         * @member {addresspb.IAddress|null|undefined} address
         * @memberof addresspb.UnverifiedAddressRequest
         * @instance
         */
        UnverifiedAddressRequest.prototype.address = null;

        /**
         * UnverifiedAddressRequest externalSource.
         * @member {addresspb.ExternalSource} externalSource
         * @memberof addresspb.UnverifiedAddressRequest
         * @instance
         */
        UnverifiedAddressRequest.prototype.externalSource = 0;

        /**
         * UnverifiedAddressRequest force.
         * @member {boolean} force
         * @memberof addresspb.UnverifiedAddressRequest
         * @instance
         */
        UnverifiedAddressRequest.prototype.force = false;

        /**
         * Creates a new UnverifiedAddressRequest instance using the specified properties.
         * @function create
         * @memberof addresspb.UnverifiedAddressRequest
         * @static
         * @param {addresspb.IUnverifiedAddressRequest=} [properties] Properties to set
         * @returns {addresspb.UnverifiedAddressRequest} UnverifiedAddressRequest instance
         */
        UnverifiedAddressRequest.create = function create(properties) {
            return new UnverifiedAddressRequest(properties);
        };

        /**
         * Encodes the specified UnverifiedAddressRequest message. Does not implicitly {@link addresspb.UnverifiedAddressRequest.verify|verify} messages.
         * @function encode
         * @memberof addresspb.UnverifiedAddressRequest
         * @static
         * @param {addresspb.IUnverifiedAddressRequest} m UnverifiedAddressRequest message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UnverifiedAddressRequest.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.address != null && Object.hasOwnProperty.call(m, "address"))
                $root.addresspb.Address.encode(m.address, w.uint32(10).fork()).ldelim();
            if (m.externalSource != null && Object.hasOwnProperty.call(m, "externalSource"))
                w.uint32(24).int32(m.externalSource);
            if (m.force != null && Object.hasOwnProperty.call(m, "force"))
                w.uint32(32).bool(m.force);
            return w;
        };

        /**
         * Decodes an UnverifiedAddressRequest message from the specified reader or buffer.
         * @function decode
         * @memberof addresspb.UnverifiedAddressRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {addresspb.UnverifiedAddressRequest} UnverifiedAddressRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UnverifiedAddressRequest.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.addresspb.UnverifiedAddressRequest();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.address = $root.addresspb.Address.decode(r, r.uint32());
                    break;
                case 3:
                    m.externalSource = r.int32();
                    break;
                case 4:
                    m.force = r.bool();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return UnverifiedAddressRequest;
    })();

    addresspb.UnverifiedAddressResponse = (function() {

        /**
         * Properties of an UnverifiedAddressResponse.
         * @memberof addresspb
         * @interface IUnverifiedAddressResponse
         * @property {addresspb.IAddress|null} [address] UnverifiedAddressResponse address
         * @property {Array.<common.IError>|null} [errors] UnverifiedAddressResponse errors
         * @property {common.Status|null} [status] UnverifiedAddressResponse status
         */

        /**
         * Constructs a new UnverifiedAddressResponse.
         * @memberof addresspb
         * @classdesc Represents an UnverifiedAddressResponse.
         * @implements IUnverifiedAddressResponse
         * @constructor
         * @param {addresspb.IUnverifiedAddressResponse=} [p] Properties to set
         */
        function UnverifiedAddressResponse(p) {
            this.errors = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * UnverifiedAddressResponse address.
         * @member {addresspb.IAddress|null|undefined} address
         * @memberof addresspb.UnverifiedAddressResponse
         * @instance
         */
        UnverifiedAddressResponse.prototype.address = null;

        /**
         * UnverifiedAddressResponse errors.
         * @member {Array.<common.IError>} errors
         * @memberof addresspb.UnverifiedAddressResponse
         * @instance
         */
        UnverifiedAddressResponse.prototype.errors = $util.emptyArray;

        /**
         * UnverifiedAddressResponse status.
         * @member {common.Status} status
         * @memberof addresspb.UnverifiedAddressResponse
         * @instance
         */
        UnverifiedAddressResponse.prototype.status = 0;

        /**
         * Creates a new UnverifiedAddressResponse instance using the specified properties.
         * @function create
         * @memberof addresspb.UnverifiedAddressResponse
         * @static
         * @param {addresspb.IUnverifiedAddressResponse=} [properties] Properties to set
         * @returns {addresspb.UnverifiedAddressResponse} UnverifiedAddressResponse instance
         */
        UnverifiedAddressResponse.create = function create(properties) {
            return new UnverifiedAddressResponse(properties);
        };

        /**
         * Encodes the specified UnverifiedAddressResponse message. Does not implicitly {@link addresspb.UnverifiedAddressResponse.verify|verify} messages.
         * @function encode
         * @memberof addresspb.UnverifiedAddressResponse
         * @static
         * @param {addresspb.IUnverifiedAddressResponse} m UnverifiedAddressResponse message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UnverifiedAddressResponse.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.address != null && Object.hasOwnProperty.call(m, "address"))
                $root.addresspb.Address.encode(m.address, w.uint32(10).fork()).ldelim();
            if (m.errors != null && m.errors.length) {
                for (var i = 0; i < m.errors.length; ++i)
                    $root.common.Error.encode(m.errors[i], w.uint32(18).fork()).ldelim();
            }
            if (m.status != null && Object.hasOwnProperty.call(m, "status"))
                w.uint32(24).int32(m.status);
            return w;
        };

        /**
         * Decodes an UnverifiedAddressResponse message from the specified reader or buffer.
         * @function decode
         * @memberof addresspb.UnverifiedAddressResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {addresspb.UnverifiedAddressResponse} UnverifiedAddressResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UnverifiedAddressResponse.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.addresspb.UnverifiedAddressResponse();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.address = $root.addresspb.Address.decode(r, r.uint32());
                    break;
                case 2:
                    if (!(m.errors && m.errors.length))
                        m.errors = [];
                    m.errors.push($root.common.Error.decode(r, r.uint32()));
                    break;
                case 3:
                    m.status = r.int32();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return UnverifiedAddressResponse;
    })();

    addresspb.AddressByUUIDResponse = (function() {

        /**
         * Properties of an AddressByUUIDResponse.
         * @memberof addresspb
         * @interface IAddressByUUIDResponse
         * @property {addresspb.IAddress|null} [address] AddressByUUIDResponse address
         * @property {Array.<common.IError>|null} [errors] AddressByUUIDResponse errors
         * @property {common.Status|null} [status] AddressByUUIDResponse status
         */

        /**
         * Constructs a new AddressByUUIDResponse.
         * @memberof addresspb
         * @classdesc Represents an AddressByUUIDResponse.
         * @implements IAddressByUUIDResponse
         * @constructor
         * @param {addresspb.IAddressByUUIDResponse=} [p] Properties to set
         */
        function AddressByUUIDResponse(p) {
            this.errors = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * AddressByUUIDResponse address.
         * @member {addresspb.IAddress|null|undefined} address
         * @memberof addresspb.AddressByUUIDResponse
         * @instance
         */
        AddressByUUIDResponse.prototype.address = null;

        /**
         * AddressByUUIDResponse errors.
         * @member {Array.<common.IError>} errors
         * @memberof addresspb.AddressByUUIDResponse
         * @instance
         */
        AddressByUUIDResponse.prototype.errors = $util.emptyArray;

        /**
         * AddressByUUIDResponse status.
         * @member {common.Status} status
         * @memberof addresspb.AddressByUUIDResponse
         * @instance
         */
        AddressByUUIDResponse.prototype.status = 0;

        /**
         * Creates a new AddressByUUIDResponse instance using the specified properties.
         * @function create
         * @memberof addresspb.AddressByUUIDResponse
         * @static
         * @param {addresspb.IAddressByUUIDResponse=} [properties] Properties to set
         * @returns {addresspb.AddressByUUIDResponse} AddressByUUIDResponse instance
         */
        AddressByUUIDResponse.create = function create(properties) {
            return new AddressByUUIDResponse(properties);
        };

        /**
         * Encodes the specified AddressByUUIDResponse message. Does not implicitly {@link addresspb.AddressByUUIDResponse.verify|verify} messages.
         * @function encode
         * @memberof addresspb.AddressByUUIDResponse
         * @static
         * @param {addresspb.IAddressByUUIDResponse} m AddressByUUIDResponse message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AddressByUUIDResponse.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.address != null && Object.hasOwnProperty.call(m, "address"))
                $root.addresspb.Address.encode(m.address, w.uint32(10).fork()).ldelim();
            if (m.errors != null && m.errors.length) {
                for (var i = 0; i < m.errors.length; ++i)
                    $root.common.Error.encode(m.errors[i], w.uint32(18).fork()).ldelim();
            }
            if (m.status != null && Object.hasOwnProperty.call(m, "status"))
                w.uint32(24).int32(m.status);
            return w;
        };

        /**
         * Decodes an AddressByUUIDResponse message from the specified reader or buffer.
         * @function decode
         * @memberof addresspb.AddressByUUIDResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {addresspb.AddressByUUIDResponse} AddressByUUIDResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AddressByUUIDResponse.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.addresspb.AddressByUUIDResponse();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.address = $root.addresspb.Address.decode(r, r.uint32());
                    break;
                case 2:
                    if (!(m.errors && m.errors.length))
                        m.errors = [];
                    m.errors.push($root.common.Error.decode(r, r.uint32()));
                    break;
                case 3:
                    m.status = r.int32();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return AddressByUUIDResponse;
    })();

    addresspb.AddressByLegacyIDRequest = (function() {

        /**
         * Properties of an AddressByLegacyIDRequest.
         * @memberof addresspb
         * @interface IAddressByLegacyIDRequest
         * @property {addresspb.ExternalSource|null} [externalSource] AddressByLegacyIDRequest externalSource
         */

        /**
         * Constructs a new AddressByLegacyIDRequest.
         * @memberof addresspb
         * @classdesc Represents an AddressByLegacyIDRequest.
         * @implements IAddressByLegacyIDRequest
         * @constructor
         * @param {addresspb.IAddressByLegacyIDRequest=} [p] Properties to set
         */
        function AddressByLegacyIDRequest(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * AddressByLegacyIDRequest externalSource.
         * @member {addresspb.ExternalSource} externalSource
         * @memberof addresspb.AddressByLegacyIDRequest
         * @instance
         */
        AddressByLegacyIDRequest.prototype.externalSource = 0;

        /**
         * Creates a new AddressByLegacyIDRequest instance using the specified properties.
         * @function create
         * @memberof addresspb.AddressByLegacyIDRequest
         * @static
         * @param {addresspb.IAddressByLegacyIDRequest=} [properties] Properties to set
         * @returns {addresspb.AddressByLegacyIDRequest} AddressByLegacyIDRequest instance
         */
        AddressByLegacyIDRequest.create = function create(properties) {
            return new AddressByLegacyIDRequest(properties);
        };

        /**
         * Encodes the specified AddressByLegacyIDRequest message. Does not implicitly {@link addresspb.AddressByLegacyIDRequest.verify|verify} messages.
         * @function encode
         * @memberof addresspb.AddressByLegacyIDRequest
         * @static
         * @param {addresspb.IAddressByLegacyIDRequest} m AddressByLegacyIDRequest message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AddressByLegacyIDRequest.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.externalSource != null && Object.hasOwnProperty.call(m, "externalSource"))
                w.uint32(8).int32(m.externalSource);
            return w;
        };

        /**
         * Decodes an AddressByLegacyIDRequest message from the specified reader or buffer.
         * @function decode
         * @memberof addresspb.AddressByLegacyIDRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {addresspb.AddressByLegacyIDRequest} AddressByLegacyIDRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AddressByLegacyIDRequest.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.addresspb.AddressByLegacyIDRequest();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.externalSource = r.int32();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return AddressByLegacyIDRequest;
    })();

    addresspb.AddressByLegacyIDResponse = (function() {

        /**
         * Properties of an AddressByLegacyIDResponse.
         * @memberof addresspb
         * @interface IAddressByLegacyIDResponse
         * @property {addresspb.IAddress|null} [address] AddressByLegacyIDResponse address
         * @property {Array.<common.IError>|null} [errors] AddressByLegacyIDResponse errors
         * @property {common.Status|null} [status] AddressByLegacyIDResponse status
         */

        /**
         * Constructs a new AddressByLegacyIDResponse.
         * @memberof addresspb
         * @classdesc Represents an AddressByLegacyIDResponse.
         * @implements IAddressByLegacyIDResponse
         * @constructor
         * @param {addresspb.IAddressByLegacyIDResponse=} [p] Properties to set
         */
        function AddressByLegacyIDResponse(p) {
            this.errors = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * AddressByLegacyIDResponse address.
         * @member {addresspb.IAddress|null|undefined} address
         * @memberof addresspb.AddressByLegacyIDResponse
         * @instance
         */
        AddressByLegacyIDResponse.prototype.address = null;

        /**
         * AddressByLegacyIDResponse errors.
         * @member {Array.<common.IError>} errors
         * @memberof addresspb.AddressByLegacyIDResponse
         * @instance
         */
        AddressByLegacyIDResponse.prototype.errors = $util.emptyArray;

        /**
         * AddressByLegacyIDResponse status.
         * @member {common.Status} status
         * @memberof addresspb.AddressByLegacyIDResponse
         * @instance
         */
        AddressByLegacyIDResponse.prototype.status = 0;

        /**
         * Creates a new AddressByLegacyIDResponse instance using the specified properties.
         * @function create
         * @memberof addresspb.AddressByLegacyIDResponse
         * @static
         * @param {addresspb.IAddressByLegacyIDResponse=} [properties] Properties to set
         * @returns {addresspb.AddressByLegacyIDResponse} AddressByLegacyIDResponse instance
         */
        AddressByLegacyIDResponse.create = function create(properties) {
            return new AddressByLegacyIDResponse(properties);
        };

        /**
         * Encodes the specified AddressByLegacyIDResponse message. Does not implicitly {@link addresspb.AddressByLegacyIDResponse.verify|verify} messages.
         * @function encode
         * @memberof addresspb.AddressByLegacyIDResponse
         * @static
         * @param {addresspb.IAddressByLegacyIDResponse} m AddressByLegacyIDResponse message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AddressByLegacyIDResponse.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.address != null && Object.hasOwnProperty.call(m, "address"))
                $root.addresspb.Address.encode(m.address, w.uint32(10).fork()).ldelim();
            if (m.errors != null && m.errors.length) {
                for (var i = 0; i < m.errors.length; ++i)
                    $root.common.Error.encode(m.errors[i], w.uint32(18).fork()).ldelim();
            }
            if (m.status != null && Object.hasOwnProperty.call(m, "status"))
                w.uint32(24).int32(m.status);
            return w;
        };

        /**
         * Decodes an AddressByLegacyIDResponse message from the specified reader or buffer.
         * @function decode
         * @memberof addresspb.AddressByLegacyIDResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {addresspb.AddressByLegacyIDResponse} AddressByLegacyIDResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AddressByLegacyIDResponse.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.addresspb.AddressByLegacyIDResponse();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.address = $root.addresspb.Address.decode(r, r.uint32());
                    break;
                case 2:
                    if (!(m.errors && m.errors.length))
                        m.errors = [];
                    m.errors.push($root.common.Error.decode(r, r.uint32()));
                    break;
                case 3:
                    m.status = r.int32();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return AddressByLegacyIDResponse;
    })();

    addresspb.PostLegacyIDToAddressRequest = (function() {

        /**
         * Properties of a PostLegacyIDToAddressRequest.
         * @memberof addresspb
         * @interface IPostLegacyIDToAddressRequest
         * @property {addresspb.ExternalSource|null} [externalSource] PostLegacyIDToAddressRequest externalSource
         */

        /**
         * Constructs a new PostLegacyIDToAddressRequest.
         * @memberof addresspb
         * @classdesc Represents a PostLegacyIDToAddressRequest.
         * @implements IPostLegacyIDToAddressRequest
         * @constructor
         * @param {addresspb.IPostLegacyIDToAddressRequest=} [p] Properties to set
         */
        function PostLegacyIDToAddressRequest(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * PostLegacyIDToAddressRequest externalSource.
         * @member {addresspb.ExternalSource} externalSource
         * @memberof addresspb.PostLegacyIDToAddressRequest
         * @instance
         */
        PostLegacyIDToAddressRequest.prototype.externalSource = 0;

        /**
         * Creates a new PostLegacyIDToAddressRequest instance using the specified properties.
         * @function create
         * @memberof addresspb.PostLegacyIDToAddressRequest
         * @static
         * @param {addresspb.IPostLegacyIDToAddressRequest=} [properties] Properties to set
         * @returns {addresspb.PostLegacyIDToAddressRequest} PostLegacyIDToAddressRequest instance
         */
        PostLegacyIDToAddressRequest.create = function create(properties) {
            return new PostLegacyIDToAddressRequest(properties);
        };

        /**
         * Encodes the specified PostLegacyIDToAddressRequest message. Does not implicitly {@link addresspb.PostLegacyIDToAddressRequest.verify|verify} messages.
         * @function encode
         * @memberof addresspb.PostLegacyIDToAddressRequest
         * @static
         * @param {addresspb.IPostLegacyIDToAddressRequest} m PostLegacyIDToAddressRequest message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PostLegacyIDToAddressRequest.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.externalSource != null && Object.hasOwnProperty.call(m, "externalSource"))
                w.uint32(8).int32(m.externalSource);
            return w;
        };

        /**
         * Decodes a PostLegacyIDToAddressRequest message from the specified reader or buffer.
         * @function decode
         * @memberof addresspb.PostLegacyIDToAddressRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {addresspb.PostLegacyIDToAddressRequest} PostLegacyIDToAddressRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PostLegacyIDToAddressRequest.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.addresspb.PostLegacyIDToAddressRequest();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.externalSource = r.int32();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return PostLegacyIDToAddressRequest;
    })();

    addresspb.DeleteLegacyIDFromAddressRequest = (function() {

        /**
         * Properties of a DeleteLegacyIDFromAddressRequest.
         * @memberof addresspb
         * @interface IDeleteLegacyIDFromAddressRequest
         * @property {addresspb.ExternalSource|null} [externalSource] DeleteLegacyIDFromAddressRequest externalSource
         */

        /**
         * Constructs a new DeleteLegacyIDFromAddressRequest.
         * @memberof addresspb
         * @classdesc Represents a DeleteLegacyIDFromAddressRequest.
         * @implements IDeleteLegacyIDFromAddressRequest
         * @constructor
         * @param {addresspb.IDeleteLegacyIDFromAddressRequest=} [p] Properties to set
         */
        function DeleteLegacyIDFromAddressRequest(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * DeleteLegacyIDFromAddressRequest externalSource.
         * @member {addresspb.ExternalSource} externalSource
         * @memberof addresspb.DeleteLegacyIDFromAddressRequest
         * @instance
         */
        DeleteLegacyIDFromAddressRequest.prototype.externalSource = 0;

        /**
         * Creates a new DeleteLegacyIDFromAddressRequest instance using the specified properties.
         * @function create
         * @memberof addresspb.DeleteLegacyIDFromAddressRequest
         * @static
         * @param {addresspb.IDeleteLegacyIDFromAddressRequest=} [properties] Properties to set
         * @returns {addresspb.DeleteLegacyIDFromAddressRequest} DeleteLegacyIDFromAddressRequest instance
         */
        DeleteLegacyIDFromAddressRequest.create = function create(properties) {
            return new DeleteLegacyIDFromAddressRequest(properties);
        };

        /**
         * Encodes the specified DeleteLegacyIDFromAddressRequest message. Does not implicitly {@link addresspb.DeleteLegacyIDFromAddressRequest.verify|verify} messages.
         * @function encode
         * @memberof addresspb.DeleteLegacyIDFromAddressRequest
         * @static
         * @param {addresspb.IDeleteLegacyIDFromAddressRequest} m DeleteLegacyIDFromAddressRequest message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        DeleteLegacyIDFromAddressRequest.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.externalSource != null && Object.hasOwnProperty.call(m, "externalSource"))
                w.uint32(8).int32(m.externalSource);
            return w;
        };

        /**
         * Decodes a DeleteLegacyIDFromAddressRequest message from the specified reader or buffer.
         * @function decode
         * @memberof addresspb.DeleteLegacyIDFromAddressRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {addresspb.DeleteLegacyIDFromAddressRequest} DeleteLegacyIDFromAddressRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        DeleteLegacyIDFromAddressRequest.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.addresspb.DeleteLegacyIDFromAddressRequest();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.externalSource = r.int32();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return DeleteLegacyIDFromAddressRequest;
    })();

    addresspb.PostOrDeleteLegacyIDFromAddressResponse = (function() {

        /**
         * Properties of a PostOrDeleteLegacyIDFromAddressResponse.
         * @memberof addresspb
         * @interface IPostOrDeleteLegacyIDFromAddressResponse
         * @property {common.Status|null} [status] PostOrDeleteLegacyIDFromAddressResponse status
         * @property {Array.<common.IError>|null} [errors] PostOrDeleteLegacyIDFromAddressResponse errors
         */

        /**
         * Constructs a new PostOrDeleteLegacyIDFromAddressResponse.
         * @memberof addresspb
         * @classdesc Represents a PostOrDeleteLegacyIDFromAddressResponse.
         * @implements IPostOrDeleteLegacyIDFromAddressResponse
         * @constructor
         * @param {addresspb.IPostOrDeleteLegacyIDFromAddressResponse=} [p] Properties to set
         */
        function PostOrDeleteLegacyIDFromAddressResponse(p) {
            this.errors = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * PostOrDeleteLegacyIDFromAddressResponse status.
         * @member {common.Status} status
         * @memberof addresspb.PostOrDeleteLegacyIDFromAddressResponse
         * @instance
         */
        PostOrDeleteLegacyIDFromAddressResponse.prototype.status = 0;

        /**
         * PostOrDeleteLegacyIDFromAddressResponse errors.
         * @member {Array.<common.IError>} errors
         * @memberof addresspb.PostOrDeleteLegacyIDFromAddressResponse
         * @instance
         */
        PostOrDeleteLegacyIDFromAddressResponse.prototype.errors = $util.emptyArray;

        /**
         * Creates a new PostOrDeleteLegacyIDFromAddressResponse instance using the specified properties.
         * @function create
         * @memberof addresspb.PostOrDeleteLegacyIDFromAddressResponse
         * @static
         * @param {addresspb.IPostOrDeleteLegacyIDFromAddressResponse=} [properties] Properties to set
         * @returns {addresspb.PostOrDeleteLegacyIDFromAddressResponse} PostOrDeleteLegacyIDFromAddressResponse instance
         */
        PostOrDeleteLegacyIDFromAddressResponse.create = function create(properties) {
            return new PostOrDeleteLegacyIDFromAddressResponse(properties);
        };

        /**
         * Encodes the specified PostOrDeleteLegacyIDFromAddressResponse message. Does not implicitly {@link addresspb.PostOrDeleteLegacyIDFromAddressResponse.verify|verify} messages.
         * @function encode
         * @memberof addresspb.PostOrDeleteLegacyIDFromAddressResponse
         * @static
         * @param {addresspb.IPostOrDeleteLegacyIDFromAddressResponse} m PostOrDeleteLegacyIDFromAddressResponse message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PostOrDeleteLegacyIDFromAddressResponse.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.status != null && Object.hasOwnProperty.call(m, "status"))
                w.uint32(8).int32(m.status);
            if (m.errors != null && m.errors.length) {
                for (var i = 0; i < m.errors.length; ++i)
                    $root.common.Error.encode(m.errors[i], w.uint32(18).fork()).ldelim();
            }
            return w;
        };

        /**
         * Decodes a PostOrDeleteLegacyIDFromAddressResponse message from the specified reader or buffer.
         * @function decode
         * @memberof addresspb.PostOrDeleteLegacyIDFromAddressResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {addresspb.PostOrDeleteLegacyIDFromAddressResponse} PostOrDeleteLegacyIDFromAddressResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PostOrDeleteLegacyIDFromAddressResponse.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.addresspb.PostOrDeleteLegacyIDFromAddressResponse();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.status = r.int32();
                    break;
                case 2:
                    if (!(m.errors && m.errors.length))
                        m.errors = [];
                    m.errors.push($root.common.Error.decode(r, r.uint32()));
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return PostOrDeleteLegacyIDFromAddressResponse;
    })();

    addresspb.DeleteLegacyIDRequest = (function() {

        /**
         * Properties of a DeleteLegacyIDRequest.
         * @memberof addresspb
         * @interface IDeleteLegacyIDRequest
         * @property {addresspb.ExternalSource|null} [externalSource] DeleteLegacyIDRequest externalSource
         */

        /**
         * Constructs a new DeleteLegacyIDRequest.
         * @memberof addresspb
         * @classdesc Represents a DeleteLegacyIDRequest.
         * @implements IDeleteLegacyIDRequest
         * @constructor
         * @param {addresspb.IDeleteLegacyIDRequest=} [p] Properties to set
         */
        function DeleteLegacyIDRequest(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * DeleteLegacyIDRequest externalSource.
         * @member {addresspb.ExternalSource} externalSource
         * @memberof addresspb.DeleteLegacyIDRequest
         * @instance
         */
        DeleteLegacyIDRequest.prototype.externalSource = 0;

        /**
         * Creates a new DeleteLegacyIDRequest instance using the specified properties.
         * @function create
         * @memberof addresspb.DeleteLegacyIDRequest
         * @static
         * @param {addresspb.IDeleteLegacyIDRequest=} [properties] Properties to set
         * @returns {addresspb.DeleteLegacyIDRequest} DeleteLegacyIDRequest instance
         */
        DeleteLegacyIDRequest.create = function create(properties) {
            return new DeleteLegacyIDRequest(properties);
        };

        /**
         * Encodes the specified DeleteLegacyIDRequest message. Does not implicitly {@link addresspb.DeleteLegacyIDRequest.verify|verify} messages.
         * @function encode
         * @memberof addresspb.DeleteLegacyIDRequest
         * @static
         * @param {addresspb.IDeleteLegacyIDRequest} m DeleteLegacyIDRequest message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        DeleteLegacyIDRequest.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.externalSource != null && Object.hasOwnProperty.call(m, "externalSource"))
                w.uint32(8).int32(m.externalSource);
            return w;
        };

        /**
         * Decodes a DeleteLegacyIDRequest message from the specified reader or buffer.
         * @function decode
         * @memberof addresspb.DeleteLegacyIDRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {addresspb.DeleteLegacyIDRequest} DeleteLegacyIDRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        DeleteLegacyIDRequest.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.addresspb.DeleteLegacyIDRequest();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.externalSource = r.int32();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return DeleteLegacyIDRequest;
    })();

    addresspb.DeleteLegacyIDResponse = (function() {

        /**
         * Properties of a DeleteLegacyIDResponse.
         * @memberof addresspb
         * @interface IDeleteLegacyIDResponse
         * @property {common.Status|null} [status] DeleteLegacyIDResponse status
         * @property {Array.<common.IError>|null} [errors] DeleteLegacyIDResponse errors
         */

        /**
         * Constructs a new DeleteLegacyIDResponse.
         * @memberof addresspb
         * @classdesc Represents a DeleteLegacyIDResponse.
         * @implements IDeleteLegacyIDResponse
         * @constructor
         * @param {addresspb.IDeleteLegacyIDResponse=} [p] Properties to set
         */
        function DeleteLegacyIDResponse(p) {
            this.errors = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * DeleteLegacyIDResponse status.
         * @member {common.Status} status
         * @memberof addresspb.DeleteLegacyIDResponse
         * @instance
         */
        DeleteLegacyIDResponse.prototype.status = 0;

        /**
         * DeleteLegacyIDResponse errors.
         * @member {Array.<common.IError>} errors
         * @memberof addresspb.DeleteLegacyIDResponse
         * @instance
         */
        DeleteLegacyIDResponse.prototype.errors = $util.emptyArray;

        /**
         * Creates a new DeleteLegacyIDResponse instance using the specified properties.
         * @function create
         * @memberof addresspb.DeleteLegacyIDResponse
         * @static
         * @param {addresspb.IDeleteLegacyIDResponse=} [properties] Properties to set
         * @returns {addresspb.DeleteLegacyIDResponse} DeleteLegacyIDResponse instance
         */
        DeleteLegacyIDResponse.create = function create(properties) {
            return new DeleteLegacyIDResponse(properties);
        };

        /**
         * Encodes the specified DeleteLegacyIDResponse message. Does not implicitly {@link addresspb.DeleteLegacyIDResponse.verify|verify} messages.
         * @function encode
         * @memberof addresspb.DeleteLegacyIDResponse
         * @static
         * @param {addresspb.IDeleteLegacyIDResponse} m DeleteLegacyIDResponse message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        DeleteLegacyIDResponse.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.status != null && Object.hasOwnProperty.call(m, "status"))
                w.uint32(8).int32(m.status);
            if (m.errors != null && m.errors.length) {
                for (var i = 0; i < m.errors.length; ++i)
                    $root.common.Error.encode(m.errors[i], w.uint32(18).fork()).ldelim();
            }
            return w;
        };

        /**
         * Decodes a DeleteLegacyIDResponse message from the specified reader or buffer.
         * @function decode
         * @memberof addresspb.DeleteLegacyIDResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {addresspb.DeleteLegacyIDResponse} DeleteLegacyIDResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        DeleteLegacyIDResponse.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.addresspb.DeleteLegacyIDResponse();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.status = r.int32();
                    break;
                case 2:
                    if (!(m.errors && m.errors.length))
                        m.errors = [];
                    m.errors.push($root.common.Error.decode(r, r.uint32()));
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return DeleteLegacyIDResponse;
    })();

    addresspb.ZipCodeDetailsResponse = (function() {

        /**
         * Properties of a ZipCodeDetailsResponse.
         * @memberof addresspb
         * @interface IZipCodeDetailsResponse
         * @property {Array.<addresspb.ZipCodeDetailsResponse.IZipCode>|null} [zipCodes] ZipCodeDetailsResponse zipCodes
         * @property {Array.<addresspb.ZipCodeDetailsResponse.ICityState>|null} [cityStates] ZipCodeDetailsResponse cityStates
         * @property {Array.<common.IError>|null} [errors] ZipCodeDetailsResponse errors
         * @property {common.Status|null} [status] ZipCodeDetailsResponse status
         */

        /**
         * Constructs a new ZipCodeDetailsResponse.
         * @memberof addresspb
         * @classdesc Represents a ZipCodeDetailsResponse.
         * @implements IZipCodeDetailsResponse
         * @constructor
         * @param {addresspb.IZipCodeDetailsResponse=} [p] Properties to set
         */
        function ZipCodeDetailsResponse(p) {
            this.zipCodes = [];
            this.cityStates = [];
            this.errors = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * ZipCodeDetailsResponse zipCodes.
         * @member {Array.<addresspb.ZipCodeDetailsResponse.IZipCode>} zipCodes
         * @memberof addresspb.ZipCodeDetailsResponse
         * @instance
         */
        ZipCodeDetailsResponse.prototype.zipCodes = $util.emptyArray;

        /**
         * ZipCodeDetailsResponse cityStates.
         * @member {Array.<addresspb.ZipCodeDetailsResponse.ICityState>} cityStates
         * @memberof addresspb.ZipCodeDetailsResponse
         * @instance
         */
        ZipCodeDetailsResponse.prototype.cityStates = $util.emptyArray;

        /**
         * ZipCodeDetailsResponse errors.
         * @member {Array.<common.IError>} errors
         * @memberof addresspb.ZipCodeDetailsResponse
         * @instance
         */
        ZipCodeDetailsResponse.prototype.errors = $util.emptyArray;

        /**
         * ZipCodeDetailsResponse status.
         * @member {common.Status} status
         * @memberof addresspb.ZipCodeDetailsResponse
         * @instance
         */
        ZipCodeDetailsResponse.prototype.status = 0;

        /**
         * Creates a new ZipCodeDetailsResponse instance using the specified properties.
         * @function create
         * @memberof addresspb.ZipCodeDetailsResponse
         * @static
         * @param {addresspb.IZipCodeDetailsResponse=} [properties] Properties to set
         * @returns {addresspb.ZipCodeDetailsResponse} ZipCodeDetailsResponse instance
         */
        ZipCodeDetailsResponse.create = function create(properties) {
            return new ZipCodeDetailsResponse(properties);
        };

        /**
         * Encodes the specified ZipCodeDetailsResponse message. Does not implicitly {@link addresspb.ZipCodeDetailsResponse.verify|verify} messages.
         * @function encode
         * @memberof addresspb.ZipCodeDetailsResponse
         * @static
         * @param {addresspb.IZipCodeDetailsResponse} m ZipCodeDetailsResponse message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ZipCodeDetailsResponse.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.zipCodes != null && m.zipCodes.length) {
                for (var i = 0; i < m.zipCodes.length; ++i)
                    $root.addresspb.ZipCodeDetailsResponse.ZipCode.encode(m.zipCodes[i], w.uint32(10).fork()).ldelim();
            }
            if (m.cityStates != null && m.cityStates.length) {
                for (var i = 0; i < m.cityStates.length; ++i)
                    $root.addresspb.ZipCodeDetailsResponse.CityState.encode(m.cityStates[i], w.uint32(18).fork()).ldelim();
            }
            if (m.errors != null && m.errors.length) {
                for (var i = 0; i < m.errors.length; ++i)
                    $root.common.Error.encode(m.errors[i], w.uint32(26).fork()).ldelim();
            }
            if (m.status != null && Object.hasOwnProperty.call(m, "status"))
                w.uint32(32).int32(m.status);
            return w;
        };

        /**
         * Decodes a ZipCodeDetailsResponse message from the specified reader or buffer.
         * @function decode
         * @memberof addresspb.ZipCodeDetailsResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {addresspb.ZipCodeDetailsResponse} ZipCodeDetailsResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ZipCodeDetailsResponse.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.addresspb.ZipCodeDetailsResponse();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    if (!(m.zipCodes && m.zipCodes.length))
                        m.zipCodes = [];
                    m.zipCodes.push($root.addresspb.ZipCodeDetailsResponse.ZipCode.decode(r, r.uint32()));
                    break;
                case 2:
                    if (!(m.cityStates && m.cityStates.length))
                        m.cityStates = [];
                    m.cityStates.push($root.addresspb.ZipCodeDetailsResponse.CityState.decode(r, r.uint32()));
                    break;
                case 3:
                    if (!(m.errors && m.errors.length))
                        m.errors = [];
                    m.errors.push($root.common.Error.decode(r, r.uint32()));
                    break;
                case 4:
                    m.status = r.int32();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        ZipCodeDetailsResponse.ZipCode = (function() {

            /**
             * Properties of a ZipCode.
             * @memberof addresspb.ZipCodeDetailsResponse
             * @interface IZipCode
             * @property {string|null} [zip5] ZipCode zip5
             * @property {string|null} [zipCode] ZipCode zipCode
             * @property {string|null} [defaultCity] ZipCode defaultCity
             * @property {string|null} [countyName] ZipCode countyName
             * @property {string|null} [state] ZipCode state
             * @property {string|null} [stateAbbreviation] ZipCode stateAbbreviation
             * @property {number|null} [latitude] ZipCode latitude
             * @property {number|null} [longitude] ZipCode longitude
             */

            /**
             * Constructs a new ZipCode.
             * @memberof addresspb.ZipCodeDetailsResponse
             * @classdesc Represents a ZipCode.
             * @implements IZipCode
             * @constructor
             * @param {addresspb.ZipCodeDetailsResponse.IZipCode=} [p] Properties to set
             */
            function ZipCode(p) {
                if (p)
                    for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                        if (p[ks[i]] != null)
                            this[ks[i]] = p[ks[i]];
            }

            /**
             * ZipCode zip5.
             * @member {string} zip5
             * @memberof addresspb.ZipCodeDetailsResponse.ZipCode
             * @instance
             */
            ZipCode.prototype.zip5 = "";

            /**
             * ZipCode zipCode.
             * @member {string} zipCode
             * @memberof addresspb.ZipCodeDetailsResponse.ZipCode
             * @instance
             */
            ZipCode.prototype.zipCode = "";

            /**
             * ZipCode defaultCity.
             * @member {string} defaultCity
             * @memberof addresspb.ZipCodeDetailsResponse.ZipCode
             * @instance
             */
            ZipCode.prototype.defaultCity = "";

            /**
             * ZipCode countyName.
             * @member {string} countyName
             * @memberof addresspb.ZipCodeDetailsResponse.ZipCode
             * @instance
             */
            ZipCode.prototype.countyName = "";

            /**
             * ZipCode state.
             * @member {string} state
             * @memberof addresspb.ZipCodeDetailsResponse.ZipCode
             * @instance
             */
            ZipCode.prototype.state = "";

            /**
             * ZipCode stateAbbreviation.
             * @member {string} stateAbbreviation
             * @memberof addresspb.ZipCodeDetailsResponse.ZipCode
             * @instance
             */
            ZipCode.prototype.stateAbbreviation = "";

            /**
             * ZipCode latitude.
             * @member {number} latitude
             * @memberof addresspb.ZipCodeDetailsResponse.ZipCode
             * @instance
             */
            ZipCode.prototype.latitude = 0;

            /**
             * ZipCode longitude.
             * @member {number} longitude
             * @memberof addresspb.ZipCodeDetailsResponse.ZipCode
             * @instance
             */
            ZipCode.prototype.longitude = 0;

            /**
             * Creates a new ZipCode instance using the specified properties.
             * @function create
             * @memberof addresspb.ZipCodeDetailsResponse.ZipCode
             * @static
             * @param {addresspb.ZipCodeDetailsResponse.IZipCode=} [properties] Properties to set
             * @returns {addresspb.ZipCodeDetailsResponse.ZipCode} ZipCode instance
             */
            ZipCode.create = function create(properties) {
                return new ZipCode(properties);
            };

            /**
             * Encodes the specified ZipCode message. Does not implicitly {@link addresspb.ZipCodeDetailsResponse.ZipCode.verify|verify} messages.
             * @function encode
             * @memberof addresspb.ZipCodeDetailsResponse.ZipCode
             * @static
             * @param {addresspb.ZipCodeDetailsResponse.IZipCode} m ZipCode message or plain object to encode
             * @param {$protobuf.Writer} [w] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ZipCode.encode = function encode(m, w) {
                if (!w)
                    w = $Writer.create();
                if (m.zip5 != null && Object.hasOwnProperty.call(m, "zip5"))
                    w.uint32(10).string(m.zip5);
                if (m.zipCode != null && Object.hasOwnProperty.call(m, "zipCode"))
                    w.uint32(18).string(m.zipCode);
                if (m.defaultCity != null && Object.hasOwnProperty.call(m, "defaultCity"))
                    w.uint32(26).string(m.defaultCity);
                if (m.countyName != null && Object.hasOwnProperty.call(m, "countyName"))
                    w.uint32(34).string(m.countyName);
                if (m.state != null && Object.hasOwnProperty.call(m, "state"))
                    w.uint32(42).string(m.state);
                if (m.stateAbbreviation != null && Object.hasOwnProperty.call(m, "stateAbbreviation"))
                    w.uint32(50).string(m.stateAbbreviation);
                if (m.latitude != null && Object.hasOwnProperty.call(m, "latitude"))
                    w.uint32(57).double(m.latitude);
                if (m.longitude != null && Object.hasOwnProperty.call(m, "longitude"))
                    w.uint32(65).double(m.longitude);
                return w;
            };

            /**
             * Decodes a ZipCode message from the specified reader or buffer.
             * @function decode
             * @memberof addresspb.ZipCodeDetailsResponse.ZipCode
             * @static
             * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
             * @param {number} [l] Message length if known beforehand
             * @returns {addresspb.ZipCodeDetailsResponse.ZipCode} ZipCode
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ZipCode.decode = function decode(r, l) {
                if (!(r instanceof $Reader))
                    r = $Reader.create(r);
                var c = l === undefined ? r.len : r.pos + l, m = new $root.addresspb.ZipCodeDetailsResponse.ZipCode();
                while (r.pos < c) {
                    var t = r.uint32();
                    switch (t >>> 3) {
                    case 1:
                        m.zip5 = r.string();
                        break;
                    case 2:
                        m.zipCode = r.string();
                        break;
                    case 3:
                        m.defaultCity = r.string();
                        break;
                    case 4:
                        m.countyName = r.string();
                        break;
                    case 5:
                        m.state = r.string();
                        break;
                    case 6:
                        m.stateAbbreviation = r.string();
                        break;
                    case 7:
                        m.latitude = r.double();
                        break;
                    case 8:
                        m.longitude = r.double();
                        break;
                    default:
                        r.skipType(t & 7);
                        break;
                    }
                }
                return m;
            };

            return ZipCode;
        })();

        ZipCodeDetailsResponse.CityState = (function() {

            /**
             * Properties of a CityState.
             * @memberof addresspb.ZipCodeDetailsResponse
             * @interface ICityState
             * @property {string|null} [city] CityState city
             * @property {string|null} [state] CityState state
             * @property {string|null} [stateAbbreviation] CityState stateAbbreviation
             */

            /**
             * Constructs a new CityState.
             * @memberof addresspb.ZipCodeDetailsResponse
             * @classdesc Represents a CityState.
             * @implements ICityState
             * @constructor
             * @param {addresspb.ZipCodeDetailsResponse.ICityState=} [p] Properties to set
             */
            function CityState(p) {
                if (p)
                    for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                        if (p[ks[i]] != null)
                            this[ks[i]] = p[ks[i]];
            }

            /**
             * CityState city.
             * @member {string} city
             * @memberof addresspb.ZipCodeDetailsResponse.CityState
             * @instance
             */
            CityState.prototype.city = "";

            /**
             * CityState state.
             * @member {string} state
             * @memberof addresspb.ZipCodeDetailsResponse.CityState
             * @instance
             */
            CityState.prototype.state = "";

            /**
             * CityState stateAbbreviation.
             * @member {string} stateAbbreviation
             * @memberof addresspb.ZipCodeDetailsResponse.CityState
             * @instance
             */
            CityState.prototype.stateAbbreviation = "";

            /**
             * Creates a new CityState instance using the specified properties.
             * @function create
             * @memberof addresspb.ZipCodeDetailsResponse.CityState
             * @static
             * @param {addresspb.ZipCodeDetailsResponse.ICityState=} [properties] Properties to set
             * @returns {addresspb.ZipCodeDetailsResponse.CityState} CityState instance
             */
            CityState.create = function create(properties) {
                return new CityState(properties);
            };

            /**
             * Encodes the specified CityState message. Does not implicitly {@link addresspb.ZipCodeDetailsResponse.CityState.verify|verify} messages.
             * @function encode
             * @memberof addresspb.ZipCodeDetailsResponse.CityState
             * @static
             * @param {addresspb.ZipCodeDetailsResponse.ICityState} m CityState message or plain object to encode
             * @param {$protobuf.Writer} [w] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            CityState.encode = function encode(m, w) {
                if (!w)
                    w = $Writer.create();
                if (m.city != null && Object.hasOwnProperty.call(m, "city"))
                    w.uint32(10).string(m.city);
                if (m.state != null && Object.hasOwnProperty.call(m, "state"))
                    w.uint32(18).string(m.state);
                if (m.stateAbbreviation != null && Object.hasOwnProperty.call(m, "stateAbbreviation"))
                    w.uint32(26).string(m.stateAbbreviation);
                return w;
            };

            /**
             * Decodes a CityState message from the specified reader or buffer.
             * @function decode
             * @memberof addresspb.ZipCodeDetailsResponse.CityState
             * @static
             * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
             * @param {number} [l] Message length if known beforehand
             * @returns {addresspb.ZipCodeDetailsResponse.CityState} CityState
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            CityState.decode = function decode(r, l) {
                if (!(r instanceof $Reader))
                    r = $Reader.create(r);
                var c = l === undefined ? r.len : r.pos + l, m = new $root.addresspb.ZipCodeDetailsResponse.CityState();
                while (r.pos < c) {
                    var t = r.uint32();
                    switch (t >>> 3) {
                    case 1:
                        m.city = r.string();
                        break;
                    case 2:
                        m.state = r.string();
                        break;
                    case 3:
                        m.stateAbbreviation = r.string();
                        break;
                    default:
                        r.skipType(t & 7);
                        break;
                    }
                }
                return m;
            };

            return CityState;
        })();

        return ZipCodeDetailsResponse;
    })();

    addresspb.State = (function() {

        /**
         * Properties of a State.
         * @memberof addresspb
         * @interface IState
         * @property {string|null} [state] State state
         * @property {string|null} [stateAbbreviation] State stateAbbreviation
         */

        /**
         * Constructs a new State.
         * @memberof addresspb
         * @classdesc Represents a State.
         * @implements IState
         * @constructor
         * @param {addresspb.IState=} [p] Properties to set
         */
        function State(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * State state.
         * @member {string} state
         * @memberof addresspb.State
         * @instance
         */
        State.prototype.state = "";

        /**
         * State stateAbbreviation.
         * @member {string} stateAbbreviation
         * @memberof addresspb.State
         * @instance
         */
        State.prototype.stateAbbreviation = "";

        /**
         * Creates a new State instance using the specified properties.
         * @function create
         * @memberof addresspb.State
         * @static
         * @param {addresspb.IState=} [properties] Properties to set
         * @returns {addresspb.State} State instance
         */
        State.create = function create(properties) {
            return new State(properties);
        };

        /**
         * Encodes the specified State message. Does not implicitly {@link addresspb.State.verify|verify} messages.
         * @function encode
         * @memberof addresspb.State
         * @static
         * @param {addresspb.IState} m State message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        State.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.state != null && Object.hasOwnProperty.call(m, "state"))
                w.uint32(10).string(m.state);
            if (m.stateAbbreviation != null && Object.hasOwnProperty.call(m, "stateAbbreviation"))
                w.uint32(18).string(m.stateAbbreviation);
            return w;
        };

        /**
         * Decodes a State message from the specified reader or buffer.
         * @function decode
         * @memberof addresspb.State
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {addresspb.State} State
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        State.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.addresspb.State();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.state = r.string();
                    break;
                case 2:
                    m.stateAbbreviation = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return State;
    })();

    addresspb.StatesResponse = (function() {

        /**
         * Properties of a StatesResponse.
         * @memberof addresspb
         * @interface IStatesResponse
         * @property {Array.<addresspb.IState>|null} [states] StatesResponse states
         * @property {Array.<common.IError>|null} [errors] StatesResponse errors
         * @property {common.Status|null} [status] StatesResponse status
         */

        /**
         * Constructs a new StatesResponse.
         * @memberof addresspb
         * @classdesc Represents a StatesResponse.
         * @implements IStatesResponse
         * @constructor
         * @param {addresspb.IStatesResponse=} [p] Properties to set
         */
        function StatesResponse(p) {
            this.states = [];
            this.errors = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * StatesResponse states.
         * @member {Array.<addresspb.IState>} states
         * @memberof addresspb.StatesResponse
         * @instance
         */
        StatesResponse.prototype.states = $util.emptyArray;

        /**
         * StatesResponse errors.
         * @member {Array.<common.IError>} errors
         * @memberof addresspb.StatesResponse
         * @instance
         */
        StatesResponse.prototype.errors = $util.emptyArray;

        /**
         * StatesResponse status.
         * @member {common.Status} status
         * @memberof addresspb.StatesResponse
         * @instance
         */
        StatesResponse.prototype.status = 0;

        /**
         * Creates a new StatesResponse instance using the specified properties.
         * @function create
         * @memberof addresspb.StatesResponse
         * @static
         * @param {addresspb.IStatesResponse=} [properties] Properties to set
         * @returns {addresspb.StatesResponse} StatesResponse instance
         */
        StatesResponse.create = function create(properties) {
            return new StatesResponse(properties);
        };

        /**
         * Encodes the specified StatesResponse message. Does not implicitly {@link addresspb.StatesResponse.verify|verify} messages.
         * @function encode
         * @memberof addresspb.StatesResponse
         * @static
         * @param {addresspb.IStatesResponse} m StatesResponse message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        StatesResponse.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.states != null && m.states.length) {
                for (var i = 0; i < m.states.length; ++i)
                    $root.addresspb.State.encode(m.states[i], w.uint32(10).fork()).ldelim();
            }
            if (m.errors != null && m.errors.length) {
                for (var i = 0; i < m.errors.length; ++i)
                    $root.common.Error.encode(m.errors[i], w.uint32(18).fork()).ldelim();
            }
            if (m.status != null && Object.hasOwnProperty.call(m, "status"))
                w.uint32(24).int32(m.status);
            return w;
        };

        /**
         * Decodes a StatesResponse message from the specified reader or buffer.
         * @function decode
         * @memberof addresspb.StatesResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {addresspb.StatesResponse} StatesResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        StatesResponse.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.addresspb.StatesResponse();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    if (!(m.states && m.states.length))
                        m.states = [];
                    m.states.push($root.addresspb.State.decode(r, r.uint32()));
                    break;
                case 2:
                    if (!(m.errors && m.errors.length))
                        m.errors = [];
                    m.errors.push($root.common.Error.decode(r, r.uint32()));
                    break;
                case 3:
                    m.status = r.int32();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return StatesResponse;
    })();

    addresspb.ZipCodeStateCheckRequest = (function() {

        /**
         * Properties of a ZipCodeStateCheckRequest.
         * @memberof addresspb
         * @interface IZipCodeStateCheckRequest
         * @property {Array.<string>|null} [states] ZipCodeStateCheckRequest states
         * @property {Array.<string>|null} [zipCodes] ZipCodeStateCheckRequest zipCodes
         */

        /**
         * Constructs a new ZipCodeStateCheckRequest.
         * @memberof addresspb
         * @classdesc Represents a ZipCodeStateCheckRequest.
         * @implements IZipCodeStateCheckRequest
         * @constructor
         * @param {addresspb.IZipCodeStateCheckRequest=} [p] Properties to set
         */
        function ZipCodeStateCheckRequest(p) {
            this.states = [];
            this.zipCodes = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * ZipCodeStateCheckRequest states.
         * @member {Array.<string>} states
         * @memberof addresspb.ZipCodeStateCheckRequest
         * @instance
         */
        ZipCodeStateCheckRequest.prototype.states = $util.emptyArray;

        /**
         * ZipCodeStateCheckRequest zipCodes.
         * @member {Array.<string>} zipCodes
         * @memberof addresspb.ZipCodeStateCheckRequest
         * @instance
         */
        ZipCodeStateCheckRequest.prototype.zipCodes = $util.emptyArray;

        /**
         * Creates a new ZipCodeStateCheckRequest instance using the specified properties.
         * @function create
         * @memberof addresspb.ZipCodeStateCheckRequest
         * @static
         * @param {addresspb.IZipCodeStateCheckRequest=} [properties] Properties to set
         * @returns {addresspb.ZipCodeStateCheckRequest} ZipCodeStateCheckRequest instance
         */
        ZipCodeStateCheckRequest.create = function create(properties) {
            return new ZipCodeStateCheckRequest(properties);
        };

        /**
         * Encodes the specified ZipCodeStateCheckRequest message. Does not implicitly {@link addresspb.ZipCodeStateCheckRequest.verify|verify} messages.
         * @function encode
         * @memberof addresspb.ZipCodeStateCheckRequest
         * @static
         * @param {addresspb.IZipCodeStateCheckRequest} m ZipCodeStateCheckRequest message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ZipCodeStateCheckRequest.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.states != null && m.states.length) {
                for (var i = 0; i < m.states.length; ++i)
                    w.uint32(10).string(m.states[i]);
            }
            if (m.zipCodes != null && m.zipCodes.length) {
                for (var i = 0; i < m.zipCodes.length; ++i)
                    w.uint32(18).string(m.zipCodes[i]);
            }
            return w;
        };

        /**
         * Decodes a ZipCodeStateCheckRequest message from the specified reader or buffer.
         * @function decode
         * @memberof addresspb.ZipCodeStateCheckRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {addresspb.ZipCodeStateCheckRequest} ZipCodeStateCheckRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ZipCodeStateCheckRequest.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.addresspb.ZipCodeStateCheckRequest();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    if (!(m.states && m.states.length))
                        m.states = [];
                    m.states.push(r.string());
                    break;
                case 2:
                    if (!(m.zipCodes && m.zipCodes.length))
                        m.zipCodes = [];
                    m.zipCodes.push(r.string());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return ZipCodeStateCheckRequest;
    })();

    addresspb.ZipCodeStateCheckResponse = (function() {

        /**
         * Properties of a ZipCodeStateCheckResponse.
         * @memberof addresspb
         * @interface IZipCodeStateCheckResponse
         * @property {Array.<string>|null} [zipCodesInStates] ZipCodeStateCheckResponse zipCodesInStates
         * @property {Array.<string>|null} [zipCodesNotInStates] ZipCodeStateCheckResponse zipCodesNotInStates
         * @property {Array.<common.IError>|null} [errors] ZipCodeStateCheckResponse errors
         * @property {common.Status|null} [status] ZipCodeStateCheckResponse status
         */

        /**
         * Constructs a new ZipCodeStateCheckResponse.
         * @memberof addresspb
         * @classdesc Represents a ZipCodeStateCheckResponse.
         * @implements IZipCodeStateCheckResponse
         * @constructor
         * @param {addresspb.IZipCodeStateCheckResponse=} [p] Properties to set
         */
        function ZipCodeStateCheckResponse(p) {
            this.zipCodesInStates = [];
            this.zipCodesNotInStates = [];
            this.errors = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * ZipCodeStateCheckResponse zipCodesInStates.
         * @member {Array.<string>} zipCodesInStates
         * @memberof addresspb.ZipCodeStateCheckResponse
         * @instance
         */
        ZipCodeStateCheckResponse.prototype.zipCodesInStates = $util.emptyArray;

        /**
         * ZipCodeStateCheckResponse zipCodesNotInStates.
         * @member {Array.<string>} zipCodesNotInStates
         * @memberof addresspb.ZipCodeStateCheckResponse
         * @instance
         */
        ZipCodeStateCheckResponse.prototype.zipCodesNotInStates = $util.emptyArray;

        /**
         * ZipCodeStateCheckResponse errors.
         * @member {Array.<common.IError>} errors
         * @memberof addresspb.ZipCodeStateCheckResponse
         * @instance
         */
        ZipCodeStateCheckResponse.prototype.errors = $util.emptyArray;

        /**
         * ZipCodeStateCheckResponse status.
         * @member {common.Status} status
         * @memberof addresspb.ZipCodeStateCheckResponse
         * @instance
         */
        ZipCodeStateCheckResponse.prototype.status = 0;

        /**
         * Creates a new ZipCodeStateCheckResponse instance using the specified properties.
         * @function create
         * @memberof addresspb.ZipCodeStateCheckResponse
         * @static
         * @param {addresspb.IZipCodeStateCheckResponse=} [properties] Properties to set
         * @returns {addresspb.ZipCodeStateCheckResponse} ZipCodeStateCheckResponse instance
         */
        ZipCodeStateCheckResponse.create = function create(properties) {
            return new ZipCodeStateCheckResponse(properties);
        };

        /**
         * Encodes the specified ZipCodeStateCheckResponse message. Does not implicitly {@link addresspb.ZipCodeStateCheckResponse.verify|verify} messages.
         * @function encode
         * @memberof addresspb.ZipCodeStateCheckResponse
         * @static
         * @param {addresspb.IZipCodeStateCheckResponse} m ZipCodeStateCheckResponse message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ZipCodeStateCheckResponse.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.zipCodesInStates != null && m.zipCodesInStates.length) {
                for (var i = 0; i < m.zipCodesInStates.length; ++i)
                    w.uint32(10).string(m.zipCodesInStates[i]);
            }
            if (m.zipCodesNotInStates != null && m.zipCodesNotInStates.length) {
                for (var i = 0; i < m.zipCodesNotInStates.length; ++i)
                    w.uint32(18).string(m.zipCodesNotInStates[i]);
            }
            if (m.errors != null && m.errors.length) {
                for (var i = 0; i < m.errors.length; ++i)
                    $root.common.Error.encode(m.errors[i], w.uint32(26).fork()).ldelim();
            }
            if (m.status != null && Object.hasOwnProperty.call(m, "status"))
                w.uint32(32).int32(m.status);
            return w;
        };

        /**
         * Decodes a ZipCodeStateCheckResponse message from the specified reader or buffer.
         * @function decode
         * @memberof addresspb.ZipCodeStateCheckResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {addresspb.ZipCodeStateCheckResponse} ZipCodeStateCheckResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ZipCodeStateCheckResponse.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.addresspb.ZipCodeStateCheckResponse();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    if (!(m.zipCodesInStates && m.zipCodesInStates.length))
                        m.zipCodesInStates = [];
                    m.zipCodesInStates.push(r.string());
                    break;
                case 2:
                    if (!(m.zipCodesNotInStates && m.zipCodesNotInStates.length))
                        m.zipCodesNotInStates = [];
                    m.zipCodesNotInStates.push(r.string());
                    break;
                case 3:
                    if (!(m.errors && m.errors.length))
                        m.errors = [];
                    m.errors.push($root.common.Error.decode(r, r.uint32()));
                    break;
                case 4:
                    m.status = r.int32();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return ZipCodeStateCheckResponse;
    })();

    addresspb.StateZipCodesRequest = (function() {

        /**
         * Properties of a StateZipCodesRequest.
         * @memberof addresspb
         * @interface IStateZipCodesRequest
         * @property {Array.<string>|null} [states] StateZipCodesRequest states
         */

        /**
         * Constructs a new StateZipCodesRequest.
         * @memberof addresspb
         * @classdesc Represents a StateZipCodesRequest.
         * @implements IStateZipCodesRequest
         * @constructor
         * @param {addresspb.IStateZipCodesRequest=} [p] Properties to set
         */
        function StateZipCodesRequest(p) {
            this.states = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * StateZipCodesRequest states.
         * @member {Array.<string>} states
         * @memberof addresspb.StateZipCodesRequest
         * @instance
         */
        StateZipCodesRequest.prototype.states = $util.emptyArray;

        /**
         * Creates a new StateZipCodesRequest instance using the specified properties.
         * @function create
         * @memberof addresspb.StateZipCodesRequest
         * @static
         * @param {addresspb.IStateZipCodesRequest=} [properties] Properties to set
         * @returns {addresspb.StateZipCodesRequest} StateZipCodesRequest instance
         */
        StateZipCodesRequest.create = function create(properties) {
            return new StateZipCodesRequest(properties);
        };

        /**
         * Encodes the specified StateZipCodesRequest message. Does not implicitly {@link addresspb.StateZipCodesRequest.verify|verify} messages.
         * @function encode
         * @memberof addresspb.StateZipCodesRequest
         * @static
         * @param {addresspb.IStateZipCodesRequest} m StateZipCodesRequest message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        StateZipCodesRequest.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.states != null && m.states.length) {
                for (var i = 0; i < m.states.length; ++i)
                    w.uint32(10).string(m.states[i]);
            }
            return w;
        };

        /**
         * Decodes a StateZipCodesRequest message from the specified reader or buffer.
         * @function decode
         * @memberof addresspb.StateZipCodesRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {addresspb.StateZipCodesRequest} StateZipCodesRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        StateZipCodesRequest.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.addresspb.StateZipCodesRequest();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    if (!(m.states && m.states.length))
                        m.states = [];
                    m.states.push(r.string());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return StateZipCodesRequest;
    })();

    addresspb.StateZipCodesResponse = (function() {

        /**
         * Properties of a StateZipCodesResponse.
         * @memberof addresspb
         * @interface IStateZipCodesResponse
         * @property {Array.<string>|null} [zipCodes] StateZipCodesResponse zipCodes
         * @property {Array.<common.IError>|null} [errors] StateZipCodesResponse errors
         * @property {common.Status|null} [status] StateZipCodesResponse status
         */

        /**
         * Constructs a new StateZipCodesResponse.
         * @memberof addresspb
         * @classdesc Represents a StateZipCodesResponse.
         * @implements IStateZipCodesResponse
         * @constructor
         * @param {addresspb.IStateZipCodesResponse=} [p] Properties to set
         */
        function StateZipCodesResponse(p) {
            this.zipCodes = [];
            this.errors = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * StateZipCodesResponse zipCodes.
         * @member {Array.<string>} zipCodes
         * @memberof addresspb.StateZipCodesResponse
         * @instance
         */
        StateZipCodesResponse.prototype.zipCodes = $util.emptyArray;

        /**
         * StateZipCodesResponse errors.
         * @member {Array.<common.IError>} errors
         * @memberof addresspb.StateZipCodesResponse
         * @instance
         */
        StateZipCodesResponse.prototype.errors = $util.emptyArray;

        /**
         * StateZipCodesResponse status.
         * @member {common.Status} status
         * @memberof addresspb.StateZipCodesResponse
         * @instance
         */
        StateZipCodesResponse.prototype.status = 0;

        /**
         * Creates a new StateZipCodesResponse instance using the specified properties.
         * @function create
         * @memberof addresspb.StateZipCodesResponse
         * @static
         * @param {addresspb.IStateZipCodesResponse=} [properties] Properties to set
         * @returns {addresspb.StateZipCodesResponse} StateZipCodesResponse instance
         */
        StateZipCodesResponse.create = function create(properties) {
            return new StateZipCodesResponse(properties);
        };

        /**
         * Encodes the specified StateZipCodesResponse message. Does not implicitly {@link addresspb.StateZipCodesResponse.verify|verify} messages.
         * @function encode
         * @memberof addresspb.StateZipCodesResponse
         * @static
         * @param {addresspb.IStateZipCodesResponse} m StateZipCodesResponse message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        StateZipCodesResponse.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.zipCodes != null && m.zipCodes.length) {
                for (var i = 0; i < m.zipCodes.length; ++i)
                    w.uint32(10).string(m.zipCodes[i]);
            }
            if (m.errors != null && m.errors.length) {
                for (var i = 0; i < m.errors.length; ++i)
                    $root.common.Error.encode(m.errors[i], w.uint32(18).fork()).ldelim();
            }
            if (m.status != null && Object.hasOwnProperty.call(m, "status"))
                w.uint32(24).int32(m.status);
            return w;
        };

        /**
         * Decodes a StateZipCodesResponse message from the specified reader or buffer.
         * @function decode
         * @memberof addresspb.StateZipCodesResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {addresspb.StateZipCodesResponse} StateZipCodesResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        StateZipCodesResponse.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.addresspb.StateZipCodesResponse();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    if (!(m.zipCodes && m.zipCodes.length))
                        m.zipCodes = [];
                    m.zipCodes.push(r.string());
                    break;
                case 2:
                    if (!(m.errors && m.errors.length))
                        m.errors = [];
                    m.errors.push($root.common.Error.decode(r, r.uint32()));
                    break;
                case 3:
                    m.status = r.int32();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return StateZipCodesResponse;
    })();

    addresspb.BulkAddressValidationRequest = (function() {

        /**
         * Properties of a BulkAddressValidationRequest.
         * @memberof addresspb
         * @interface IBulkAddressValidationRequest
         * @property {Array.<addresspb.IAddressRequest>|null} [lookups] BulkAddressValidationRequest lookups
         */

        /**
         * Constructs a new BulkAddressValidationRequest.
         * @memberof addresspb
         * @classdesc Represents a BulkAddressValidationRequest.
         * @implements IBulkAddressValidationRequest
         * @constructor
         * @param {addresspb.IBulkAddressValidationRequest=} [p] Properties to set
         */
        function BulkAddressValidationRequest(p) {
            this.lookups = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * BulkAddressValidationRequest lookups.
         * @member {Array.<addresspb.IAddressRequest>} lookups
         * @memberof addresspb.BulkAddressValidationRequest
         * @instance
         */
        BulkAddressValidationRequest.prototype.lookups = $util.emptyArray;

        /**
         * Creates a new BulkAddressValidationRequest instance using the specified properties.
         * @function create
         * @memberof addresspb.BulkAddressValidationRequest
         * @static
         * @param {addresspb.IBulkAddressValidationRequest=} [properties] Properties to set
         * @returns {addresspb.BulkAddressValidationRequest} BulkAddressValidationRequest instance
         */
        BulkAddressValidationRequest.create = function create(properties) {
            return new BulkAddressValidationRequest(properties);
        };

        /**
         * Encodes the specified BulkAddressValidationRequest message. Does not implicitly {@link addresspb.BulkAddressValidationRequest.verify|verify} messages.
         * @function encode
         * @memberof addresspb.BulkAddressValidationRequest
         * @static
         * @param {addresspb.IBulkAddressValidationRequest} m BulkAddressValidationRequest message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        BulkAddressValidationRequest.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.lookups != null && m.lookups.length) {
                for (var i = 0; i < m.lookups.length; ++i)
                    $root.addresspb.AddressRequest.encode(m.lookups[i], w.uint32(10).fork()).ldelim();
            }
            return w;
        };

        /**
         * Decodes a BulkAddressValidationRequest message from the specified reader or buffer.
         * @function decode
         * @memberof addresspb.BulkAddressValidationRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {addresspb.BulkAddressValidationRequest} BulkAddressValidationRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        BulkAddressValidationRequest.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.addresspb.BulkAddressValidationRequest();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    if (!(m.lookups && m.lookups.length))
                        m.lookups = [];
                    m.lookups.push($root.addresspb.AddressRequest.decode(r, r.uint32()));
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return BulkAddressValidationRequest;
    })();

    addresspb.BulkAddressValidationResponse = (function() {

        /**
         * Properties of a BulkAddressValidationResponse.
         * @memberof addresspb
         * @interface IBulkAddressValidationResponse
         * @property {Array.<addresspb.IAddressResponse>|null} [results] BulkAddressValidationResponse results
         * @property {Array.<common.IError>|null} [errors] BulkAddressValidationResponse errors
         * @property {common.Status|null} [status] BulkAddressValidationResponse status
         */

        /**
         * Constructs a new BulkAddressValidationResponse.
         * @memberof addresspb
         * @classdesc Represents a BulkAddressValidationResponse.
         * @implements IBulkAddressValidationResponse
         * @constructor
         * @param {addresspb.IBulkAddressValidationResponse=} [p] Properties to set
         */
        function BulkAddressValidationResponse(p) {
            this.results = [];
            this.errors = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * BulkAddressValidationResponse results.
         * @member {Array.<addresspb.IAddressResponse>} results
         * @memberof addresspb.BulkAddressValidationResponse
         * @instance
         */
        BulkAddressValidationResponse.prototype.results = $util.emptyArray;

        /**
         * BulkAddressValidationResponse errors.
         * @member {Array.<common.IError>} errors
         * @memberof addresspb.BulkAddressValidationResponse
         * @instance
         */
        BulkAddressValidationResponse.prototype.errors = $util.emptyArray;

        /**
         * BulkAddressValidationResponse status.
         * @member {common.Status} status
         * @memberof addresspb.BulkAddressValidationResponse
         * @instance
         */
        BulkAddressValidationResponse.prototype.status = 0;

        /**
         * Creates a new BulkAddressValidationResponse instance using the specified properties.
         * @function create
         * @memberof addresspb.BulkAddressValidationResponse
         * @static
         * @param {addresspb.IBulkAddressValidationResponse=} [properties] Properties to set
         * @returns {addresspb.BulkAddressValidationResponse} BulkAddressValidationResponse instance
         */
        BulkAddressValidationResponse.create = function create(properties) {
            return new BulkAddressValidationResponse(properties);
        };

        /**
         * Encodes the specified BulkAddressValidationResponse message. Does not implicitly {@link addresspb.BulkAddressValidationResponse.verify|verify} messages.
         * @function encode
         * @memberof addresspb.BulkAddressValidationResponse
         * @static
         * @param {addresspb.IBulkAddressValidationResponse} m BulkAddressValidationResponse message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        BulkAddressValidationResponse.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.results != null && m.results.length) {
                for (var i = 0; i < m.results.length; ++i)
                    $root.addresspb.AddressResponse.encode(m.results[i], w.uint32(10).fork()).ldelim();
            }
            if (m.errors != null && m.errors.length) {
                for (var i = 0; i < m.errors.length; ++i)
                    $root.common.Error.encode(m.errors[i], w.uint32(18).fork()).ldelim();
            }
            if (m.status != null && Object.hasOwnProperty.call(m, "status"))
                w.uint32(24).int32(m.status);
            return w;
        };

        /**
         * Decodes a BulkAddressValidationResponse message from the specified reader or buffer.
         * @function decode
         * @memberof addresspb.BulkAddressValidationResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {addresspb.BulkAddressValidationResponse} BulkAddressValidationResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        BulkAddressValidationResponse.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.addresspb.BulkAddressValidationResponse();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    if (!(m.results && m.results.length))
                        m.results = [];
                    m.results.push($root.addresspb.AddressResponse.decode(r, r.uint32()));
                    break;
                case 2:
                    if (!(m.errors && m.errors.length))
                        m.errors = [];
                    m.errors.push($root.common.Error.decode(r, r.uint32()));
                    break;
                case 3:
                    m.status = r.int32();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return BulkAddressValidationResponse;
    })();

    addresspb.AddressesByLegacyIDsRequest = (function() {

        /**
         * Properties of an AddressesByLegacyIDsRequest.
         * @memberof addresspb
         * @interface IAddressesByLegacyIDsRequest
         * @property {addresspb.ExternalSource|null} [externalSource] AddressesByLegacyIDsRequest externalSource
         * @property {Array.<number>|null} [legacyIds] AddressesByLegacyIDsRequest legacyIds
         */

        /**
         * Constructs a new AddressesByLegacyIDsRequest.
         * @memberof addresspb
         * @classdesc Represents an AddressesByLegacyIDsRequest.
         * @implements IAddressesByLegacyIDsRequest
         * @constructor
         * @param {addresspb.IAddressesByLegacyIDsRequest=} [p] Properties to set
         */
        function AddressesByLegacyIDsRequest(p) {
            this.legacyIds = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * AddressesByLegacyIDsRequest externalSource.
         * @member {addresspb.ExternalSource} externalSource
         * @memberof addresspb.AddressesByLegacyIDsRequest
         * @instance
         */
        AddressesByLegacyIDsRequest.prototype.externalSource = 0;

        /**
         * AddressesByLegacyIDsRequest legacyIds.
         * @member {Array.<number>} legacyIds
         * @memberof addresspb.AddressesByLegacyIDsRequest
         * @instance
         */
        AddressesByLegacyIDsRequest.prototype.legacyIds = $util.emptyArray;

        /**
         * Creates a new AddressesByLegacyIDsRequest instance using the specified properties.
         * @function create
         * @memberof addresspb.AddressesByLegacyIDsRequest
         * @static
         * @param {addresspb.IAddressesByLegacyIDsRequest=} [properties] Properties to set
         * @returns {addresspb.AddressesByLegacyIDsRequest} AddressesByLegacyIDsRequest instance
         */
        AddressesByLegacyIDsRequest.create = function create(properties) {
            return new AddressesByLegacyIDsRequest(properties);
        };

        /**
         * Encodes the specified AddressesByLegacyIDsRequest message. Does not implicitly {@link addresspb.AddressesByLegacyIDsRequest.verify|verify} messages.
         * @function encode
         * @memberof addresspb.AddressesByLegacyIDsRequest
         * @static
         * @param {addresspb.IAddressesByLegacyIDsRequest} m AddressesByLegacyIDsRequest message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AddressesByLegacyIDsRequest.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.externalSource != null && Object.hasOwnProperty.call(m, "externalSource"))
                w.uint32(8).int32(m.externalSource);
            if (m.legacyIds != null && m.legacyIds.length) {
                w.uint32(18).fork();
                for (var i = 0; i < m.legacyIds.length; ++i)
                    w.uint32(m.legacyIds[i]);
                w.ldelim();
            }
            return w;
        };

        /**
         * Decodes an AddressesByLegacyIDsRequest message from the specified reader or buffer.
         * @function decode
         * @memberof addresspb.AddressesByLegacyIDsRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {addresspb.AddressesByLegacyIDsRequest} AddressesByLegacyIDsRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AddressesByLegacyIDsRequest.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.addresspb.AddressesByLegacyIDsRequest();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.externalSource = r.int32();
                    break;
                case 2:
                    if (!(m.legacyIds && m.legacyIds.length))
                        m.legacyIds = [];
                    if ((t & 7) === 2) {
                        var c2 = r.uint32() + r.pos;
                        while (r.pos < c2)
                            m.legacyIds.push(r.uint32());
                    } else
                        m.legacyIds.push(r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return AddressesByLegacyIDsRequest;
    })();

    addresspb.AddressesByLegacyIDsResponse = (function() {

        /**
         * Properties of an AddressesByLegacyIDsResponse.
         * @memberof addresspb
         * @interface IAddressesByLegacyIDsResponse
         * @property {Array.<addresspb.IAddress>|null} [address] AddressesByLegacyIDsResponse address
         * @property {Array.<common.IError>|null} [errors] AddressesByLegacyIDsResponse errors
         * @property {common.Status|null} [status] AddressesByLegacyIDsResponse status
         */

        /**
         * Constructs a new AddressesByLegacyIDsResponse.
         * @memberof addresspb
         * @classdesc Represents an AddressesByLegacyIDsResponse.
         * @implements IAddressesByLegacyIDsResponse
         * @constructor
         * @param {addresspb.IAddressesByLegacyIDsResponse=} [p] Properties to set
         */
        function AddressesByLegacyIDsResponse(p) {
            this.address = [];
            this.errors = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * AddressesByLegacyIDsResponse address.
         * @member {Array.<addresspb.IAddress>} address
         * @memberof addresspb.AddressesByLegacyIDsResponse
         * @instance
         */
        AddressesByLegacyIDsResponse.prototype.address = $util.emptyArray;

        /**
         * AddressesByLegacyIDsResponse errors.
         * @member {Array.<common.IError>} errors
         * @memberof addresspb.AddressesByLegacyIDsResponse
         * @instance
         */
        AddressesByLegacyIDsResponse.prototype.errors = $util.emptyArray;

        /**
         * AddressesByLegacyIDsResponse status.
         * @member {common.Status} status
         * @memberof addresspb.AddressesByLegacyIDsResponse
         * @instance
         */
        AddressesByLegacyIDsResponse.prototype.status = 0;

        /**
         * Creates a new AddressesByLegacyIDsResponse instance using the specified properties.
         * @function create
         * @memberof addresspb.AddressesByLegacyIDsResponse
         * @static
         * @param {addresspb.IAddressesByLegacyIDsResponse=} [properties] Properties to set
         * @returns {addresspb.AddressesByLegacyIDsResponse} AddressesByLegacyIDsResponse instance
         */
        AddressesByLegacyIDsResponse.create = function create(properties) {
            return new AddressesByLegacyIDsResponse(properties);
        };

        /**
         * Encodes the specified AddressesByLegacyIDsResponse message. Does not implicitly {@link addresspb.AddressesByLegacyIDsResponse.verify|verify} messages.
         * @function encode
         * @memberof addresspb.AddressesByLegacyIDsResponse
         * @static
         * @param {addresspb.IAddressesByLegacyIDsResponse} m AddressesByLegacyIDsResponse message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AddressesByLegacyIDsResponse.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.address != null && m.address.length) {
                for (var i = 0; i < m.address.length; ++i)
                    $root.addresspb.Address.encode(m.address[i], w.uint32(10).fork()).ldelim();
            }
            if (m.errors != null && m.errors.length) {
                for (var i = 0; i < m.errors.length; ++i)
                    $root.common.Error.encode(m.errors[i], w.uint32(18).fork()).ldelim();
            }
            if (m.status != null && Object.hasOwnProperty.call(m, "status"))
                w.uint32(24).int32(m.status);
            return w;
        };

        /**
         * Decodes an AddressesByLegacyIDsResponse message from the specified reader or buffer.
         * @function decode
         * @memberof addresspb.AddressesByLegacyIDsResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {addresspb.AddressesByLegacyIDsResponse} AddressesByLegacyIDsResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AddressesByLegacyIDsResponse.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.addresspb.AddressesByLegacyIDsResponse();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    if (!(m.address && m.address.length))
                        m.address = [];
                    m.address.push($root.addresspb.Address.decode(r, r.uint32()));
                    break;
                case 2:
                    if (!(m.errors && m.errors.length))
                        m.errors = [];
                    m.errors.push($root.common.Error.decode(r, r.uint32()));
                    break;
                case 3:
                    m.status = r.int32();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return AddressesByLegacyIDsResponse;
    })();

    addresspb.PostAddressRequest = (function() {

        /**
         * Properties of a PostAddressRequest.
         * @memberof addresspb
         * @interface IPostAddressRequest
         * @property {string|null} [street1] PostAddressRequest street1
         * @property {string|null} [unitType] PostAddressRequest unitType
         * @property {string|null} [unitValue] PostAddressRequest unitValue
         * @property {string|null} [city] PostAddressRequest city
         * @property {string|null} [state] PostAddressRequest state
         * @property {string|null} [zip] PostAddressRequest zip
         * @property {string|null} [countryIso3] PostAddressRequest countryIso3
         * @property {number|null} [exisitingLegacyId] PostAddressRequest exisitingLegacyId
         * @property {boolean|null} [forceCreateNewLegacyId] PostAddressRequest forceCreateNewLegacyId
         */

        /**
         * Constructs a new PostAddressRequest.
         * @memberof addresspb
         * @classdesc Represents a PostAddressRequest.
         * @implements IPostAddressRequest
         * @constructor
         * @param {addresspb.IPostAddressRequest=} [p] Properties to set
         */
        function PostAddressRequest(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * PostAddressRequest street1.
         * @member {string} street1
         * @memberof addresspb.PostAddressRequest
         * @instance
         */
        PostAddressRequest.prototype.street1 = "";

        /**
         * PostAddressRequest unitType.
         * @member {string} unitType
         * @memberof addresspb.PostAddressRequest
         * @instance
         */
        PostAddressRequest.prototype.unitType = "";

        /**
         * PostAddressRequest unitValue.
         * @member {string} unitValue
         * @memberof addresspb.PostAddressRequest
         * @instance
         */
        PostAddressRequest.prototype.unitValue = "";

        /**
         * PostAddressRequest city.
         * @member {string} city
         * @memberof addresspb.PostAddressRequest
         * @instance
         */
        PostAddressRequest.prototype.city = "";

        /**
         * PostAddressRequest state.
         * @member {string} state
         * @memberof addresspb.PostAddressRequest
         * @instance
         */
        PostAddressRequest.prototype.state = "";

        /**
         * PostAddressRequest zip.
         * @member {string} zip
         * @memberof addresspb.PostAddressRequest
         * @instance
         */
        PostAddressRequest.prototype.zip = "";

        /**
         * PostAddressRequest countryIso3.
         * @member {string} countryIso3
         * @memberof addresspb.PostAddressRequest
         * @instance
         */
        PostAddressRequest.prototype.countryIso3 = "";

        /**
         * PostAddressRequest exisitingLegacyId.
         * @member {number} exisitingLegacyId
         * @memberof addresspb.PostAddressRequest
         * @instance
         */
        PostAddressRequest.prototype.exisitingLegacyId = 0;

        /**
         * PostAddressRequest forceCreateNewLegacyId.
         * @member {boolean} forceCreateNewLegacyId
         * @memberof addresspb.PostAddressRequest
         * @instance
         */
        PostAddressRequest.prototype.forceCreateNewLegacyId = false;

        /**
         * Creates a new PostAddressRequest instance using the specified properties.
         * @function create
         * @memberof addresspb.PostAddressRequest
         * @static
         * @param {addresspb.IPostAddressRequest=} [properties] Properties to set
         * @returns {addresspb.PostAddressRequest} PostAddressRequest instance
         */
        PostAddressRequest.create = function create(properties) {
            return new PostAddressRequest(properties);
        };

        /**
         * Encodes the specified PostAddressRequest message. Does not implicitly {@link addresspb.PostAddressRequest.verify|verify} messages.
         * @function encode
         * @memberof addresspb.PostAddressRequest
         * @static
         * @param {addresspb.IPostAddressRequest} m PostAddressRequest message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PostAddressRequest.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.street1 != null && Object.hasOwnProperty.call(m, "street1"))
                w.uint32(10).string(m.street1);
            if (m.unitType != null && Object.hasOwnProperty.call(m, "unitType"))
                w.uint32(18).string(m.unitType);
            if (m.unitValue != null && Object.hasOwnProperty.call(m, "unitValue"))
                w.uint32(26).string(m.unitValue);
            if (m.city != null && Object.hasOwnProperty.call(m, "city"))
                w.uint32(34).string(m.city);
            if (m.state != null && Object.hasOwnProperty.call(m, "state"))
                w.uint32(42).string(m.state);
            if (m.zip != null && Object.hasOwnProperty.call(m, "zip"))
                w.uint32(50).string(m.zip);
            if (m.countryIso3 != null && Object.hasOwnProperty.call(m, "countryIso3"))
                w.uint32(58).string(m.countryIso3);
            if (m.exisitingLegacyId != null && Object.hasOwnProperty.call(m, "exisitingLegacyId"))
                w.uint32(64).uint32(m.exisitingLegacyId);
            if (m.forceCreateNewLegacyId != null && Object.hasOwnProperty.call(m, "forceCreateNewLegacyId"))
                w.uint32(72).bool(m.forceCreateNewLegacyId);
            return w;
        };

        /**
         * Decodes a PostAddressRequest message from the specified reader or buffer.
         * @function decode
         * @memberof addresspb.PostAddressRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {addresspb.PostAddressRequest} PostAddressRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PostAddressRequest.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.addresspb.PostAddressRequest();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.street1 = r.string();
                    break;
                case 2:
                    m.unitType = r.string();
                    break;
                case 3:
                    m.unitValue = r.string();
                    break;
                case 4:
                    m.city = r.string();
                    break;
                case 5:
                    m.state = r.string();
                    break;
                case 6:
                    m.zip = r.string();
                    break;
                case 7:
                    m.countryIso3 = r.string();
                    break;
                case 8:
                    m.exisitingLegacyId = r.uint32();
                    break;
                case 9:
                    m.forceCreateNewLegacyId = r.bool();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return PostAddressRequest;
    })();

    addresspb.PostAddressResponse = (function() {

        /**
         * Properties of a PostAddressResponse.
         * @memberof addresspb
         * @interface IPostAddressResponse
         * @property {addresspb.IAddress|null} [address] PostAddressResponse address
         * @property {Array.<common.IError>|null} [errors] PostAddressResponse errors
         */

        /**
         * Constructs a new PostAddressResponse.
         * @memberof addresspb
         * @classdesc Represents a PostAddressResponse.
         * @implements IPostAddressResponse
         * @constructor
         * @param {addresspb.IPostAddressResponse=} [p] Properties to set
         */
        function PostAddressResponse(p) {
            this.errors = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * PostAddressResponse address.
         * @member {addresspb.IAddress|null|undefined} address
         * @memberof addresspb.PostAddressResponse
         * @instance
         */
        PostAddressResponse.prototype.address = null;

        /**
         * PostAddressResponse errors.
         * @member {Array.<common.IError>} errors
         * @memberof addresspb.PostAddressResponse
         * @instance
         */
        PostAddressResponse.prototype.errors = $util.emptyArray;

        /**
         * Creates a new PostAddressResponse instance using the specified properties.
         * @function create
         * @memberof addresspb.PostAddressResponse
         * @static
         * @param {addresspb.IPostAddressResponse=} [properties] Properties to set
         * @returns {addresspb.PostAddressResponse} PostAddressResponse instance
         */
        PostAddressResponse.create = function create(properties) {
            return new PostAddressResponse(properties);
        };

        /**
         * Encodes the specified PostAddressResponse message. Does not implicitly {@link addresspb.PostAddressResponse.verify|verify} messages.
         * @function encode
         * @memberof addresspb.PostAddressResponse
         * @static
         * @param {addresspb.IPostAddressResponse} m PostAddressResponse message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PostAddressResponse.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.address != null && Object.hasOwnProperty.call(m, "address"))
                $root.addresspb.Address.encode(m.address, w.uint32(10).fork()).ldelim();
            if (m.errors != null && m.errors.length) {
                for (var i = 0; i < m.errors.length; ++i)
                    $root.common.Error.encode(m.errors[i], w.uint32(18).fork()).ldelim();
            }
            return w;
        };

        /**
         * Decodes a PostAddressResponse message from the specified reader or buffer.
         * @function decode
         * @memberof addresspb.PostAddressResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {addresspb.PostAddressResponse} PostAddressResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PostAddressResponse.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.addresspb.PostAddressResponse();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.address = $root.addresspb.Address.decode(r, r.uint32());
                    break;
                case 2:
                    if (!(m.errors && m.errors.length))
                        m.errors = [];
                    m.errors.push($root.common.Error.decode(r, r.uint32()));
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return PostAddressResponse;
    })();

    addresspb.GetCustomerAddress = (function() {

        /**
         * Constructs a new GetCustomerAddress service.
         * @memberof addresspb
         * @classdesc Represents a GetCustomerAddress
         * @extends $protobuf.rpc.Service
         * @constructor
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         */
        function GetCustomerAddress(rpcImpl, requestDelimited, responseDelimited) {
            $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
        }

        (GetCustomerAddress.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = GetCustomerAddress;

        /**
         * Creates new GetCustomerAddress service using the specified rpc implementation.
         * @function create
         * @memberof addresspb.GetCustomerAddress
         * @static
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         * @returns {GetCustomerAddress} RPC service. Useful where requests and/or responses are streamed.
         */
        GetCustomerAddress.create = function create(rpcImpl, requestDelimited, responseDelimited) {
            return new this(rpcImpl, requestDelimited, responseDelimited);
        };

        /**
         * Callback as used by {@link addresspb.GetCustomerAddress#getCustomerAddress}.
         * @memberof addresspb.GetCustomerAddress
         * @typedef GetCustomerAddressCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {addresspb.AddressResponse} [response] AddressResponse
         */

        /**
         * Calls GetCustomerAddress.
         * @function getCustomerAddress
         * @memberof addresspb.GetCustomerAddress
         * @instance
         * @param {addresspb.IAddressRequest} request AddressRequest message or plain object
         * @param {addresspb.GetCustomerAddress.GetCustomerAddressCallback} callback Node-style callback called with the error, if any, and AddressResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(GetCustomerAddress.prototype.getCustomerAddress = function getCustomerAddress(request, callback) {
            return this.rpcCall(getCustomerAddress, $root.addresspb.AddressRequest, $root.addresspb.AddressResponse, request, callback);
        }, "name", { value: "GetCustomerAddress" });

        /**
         * Calls GetCustomerAddress.
         * @function getCustomerAddress
         * @memberof addresspb.GetCustomerAddress
         * @instance
         * @param {addresspb.IAddressRequest} request AddressRequest message or plain object
         * @returns {Promise<addresspb.AddressResponse>} Promise
         * @variation 2
         */

        return GetCustomerAddress;
    })();

    addresspb.DeleteAllByLegacyId = (function() {

        /**
         * Constructs a new DeleteAllByLegacyId service.
         * @memberof addresspb
         * @classdesc Represents a DeleteAllByLegacyId
         * @extends $protobuf.rpc.Service
         * @constructor
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         */
        function DeleteAllByLegacyId(rpcImpl, requestDelimited, responseDelimited) {
            $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
        }

        (DeleteAllByLegacyId.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = DeleteAllByLegacyId;

        /**
         * Creates new DeleteAllByLegacyId service using the specified rpc implementation.
         * @function create
         * @memberof addresspb.DeleteAllByLegacyId
         * @static
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         * @returns {DeleteAllByLegacyId} RPC service. Useful where requests and/or responses are streamed.
         */
        DeleteAllByLegacyId.create = function create(rpcImpl, requestDelimited, responseDelimited) {
            return new this(rpcImpl, requestDelimited, responseDelimited);
        };

        /**
         * Callback as used by {@link addresspb.DeleteAllByLegacyId#deleteByLegacyId}.
         * @memberof addresspb.DeleteAllByLegacyId
         * @typedef DeleteByLegacyIdCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {addresspb.DeleteLegacyIDResponse} [response] DeleteLegacyIDResponse
         */

        /**
         * Calls DeleteByLegacyId.
         * @function deleteByLegacyId
         * @memberof addresspb.DeleteAllByLegacyId
         * @instance
         * @param {addresspb.IDeleteLegacyIDRequest} request DeleteLegacyIDRequest message or plain object
         * @param {addresspb.DeleteAllByLegacyId.DeleteByLegacyIdCallback} callback Node-style callback called with the error, if any, and DeleteLegacyIDResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(DeleteAllByLegacyId.prototype.deleteByLegacyId = function deleteByLegacyId(request, callback) {
            return this.rpcCall(deleteByLegacyId, $root.addresspb.DeleteLegacyIDRequest, $root.addresspb.DeleteLegacyIDResponse, request, callback);
        }, "name", { value: "DeleteByLegacyId" });

        /**
         * Calls DeleteByLegacyId.
         * @function deleteByLegacyId
         * @memberof addresspb.DeleteAllByLegacyId
         * @instance
         * @param {addresspb.IDeleteLegacyIDRequest} request DeleteLegacyIDRequest message or plain object
         * @returns {Promise<addresspb.DeleteLegacyIDResponse>} Promise
         * @variation 2
         */

        return DeleteAllByLegacyId;
    })();

    addresspb.GetCustomerAddressPut = (function() {

        /**
         * Constructs a new GetCustomerAddressPut service.
         * @memberof addresspb
         * @classdesc Represents a GetCustomerAddressPut
         * @extends $protobuf.rpc.Service
         * @constructor
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         */
        function GetCustomerAddressPut(rpcImpl, requestDelimited, responseDelimited) {
            $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
        }

        (GetCustomerAddressPut.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = GetCustomerAddressPut;

        /**
         * Creates new GetCustomerAddressPut service using the specified rpc implementation.
         * @function create
         * @memberof addresspb.GetCustomerAddressPut
         * @static
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         * @returns {GetCustomerAddressPut} RPC service. Useful where requests and/or responses are streamed.
         */
        GetCustomerAddressPut.create = function create(rpcImpl, requestDelimited, responseDelimited) {
            return new this(rpcImpl, requestDelimited, responseDelimited);
        };

        /**
         * Callback as used by {@link addresspb.GetCustomerAddressPut#getCustomerAddressPut}.
         * @memberof addresspb.GetCustomerAddressPut
         * @typedef GetCustomerAddressPutCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {addresspb.AddressResponse} [response] AddressResponse
         */

        /**
         * Calls GetCustomerAddressPut.
         * @function getCustomerAddressPut
         * @memberof addresspb.GetCustomerAddressPut
         * @instance
         * @param {addresspb.IAddressRequest} request AddressRequest message or plain object
         * @param {addresspb.GetCustomerAddressPut.GetCustomerAddressPutCallback} callback Node-style callback called with the error, if any, and AddressResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(GetCustomerAddressPut.prototype.getCustomerAddressPut = function getCustomerAddressPut(request, callback) {
            return this.rpcCall(getCustomerAddressPut, $root.addresspb.AddressRequest, $root.addresspb.AddressResponse, request, callback);
        }, "name", { value: "GetCustomerAddressPut" });

        /**
         * Calls GetCustomerAddressPut.
         * @function getCustomerAddressPut
         * @memberof addresspb.GetCustomerAddressPut
         * @instance
         * @param {addresspb.IAddressRequest} request AddressRequest message or plain object
         * @returns {Promise<addresspb.AddressResponse>} Promise
         * @variation 2
         */

        return GetCustomerAddressPut;
    })();

    addresspb.GetAddressTypeAhead = (function() {

        /**
         * Constructs a new GetAddressTypeAhead service.
         * @memberof addresspb
         * @classdesc Represents a GetAddressTypeAhead
         * @extends $protobuf.rpc.Service
         * @constructor
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         */
        function GetAddressTypeAhead(rpcImpl, requestDelimited, responseDelimited) {
            $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
        }

        (GetAddressTypeAhead.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = GetAddressTypeAhead;

        /**
         * Creates new GetAddressTypeAhead service using the specified rpc implementation.
         * @function create
         * @memberof addresspb.GetAddressTypeAhead
         * @static
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         * @returns {GetAddressTypeAhead} RPC service. Useful where requests and/or responses are streamed.
         */
        GetAddressTypeAhead.create = function create(rpcImpl, requestDelimited, responseDelimited) {
            return new this(rpcImpl, requestDelimited, responseDelimited);
        };

        /**
         * Callback as used by {@link addresspb.GetAddressTypeAhead#getAddressTypeAhead}.
         * @memberof addresspb.GetAddressTypeAhead
         * @typedef GetAddressTypeAheadCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {addresspb.AddressByTypeAheadResponse} [response] AddressByTypeAheadResponse
         */

        /**
         * Calls GetAddressTypeAhead.
         * @function getAddressTypeAhead
         * @memberof addresspb.GetAddressTypeAhead
         * @instance
         * @param {addresspb.IAddressByTypeAheadRequest} request AddressByTypeAheadRequest message or plain object
         * @param {addresspb.GetAddressTypeAhead.GetAddressTypeAheadCallback} callback Node-style callback called with the error, if any, and AddressByTypeAheadResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(GetAddressTypeAhead.prototype.getAddressTypeAhead = function getAddressTypeAhead(request, callback) {
            return this.rpcCall(getAddressTypeAhead, $root.addresspb.AddressByTypeAheadRequest, $root.addresspb.AddressByTypeAheadResponse, request, callback);
        }, "name", { value: "GetAddressTypeAhead" });

        /**
         * Calls GetAddressTypeAhead.
         * @function getAddressTypeAhead
         * @memberof addresspb.GetAddressTypeAhead
         * @instance
         * @param {addresspb.IAddressByTypeAheadRequest} request AddressByTypeAheadRequest message or plain object
         * @returns {Promise<addresspb.AddressByTypeAheadResponse>} Promise
         * @variation 2
         */

        return GetAddressTypeAhead;
    })();

    addresspb.GetTypeAhead = (function() {

        /**
         * Constructs a new GetTypeAhead service.
         * @memberof addresspb
         * @classdesc Represents a GetTypeAhead
         * @extends $protobuf.rpc.Service
         * @constructor
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         */
        function GetTypeAhead(rpcImpl, requestDelimited, responseDelimited) {
            $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
        }

        (GetTypeAhead.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = GetTypeAhead;

        /**
         * Creates new GetTypeAhead service using the specified rpc implementation.
         * @function create
         * @memberof addresspb.GetTypeAhead
         * @static
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         * @returns {GetTypeAhead} RPC service. Useful where requests and/or responses are streamed.
         */
        GetTypeAhead.create = function create(rpcImpl, requestDelimited, responseDelimited) {
            return new this(rpcImpl, requestDelimited, responseDelimited);
        };

        /**
         * Callback as used by {@link addresspb.GetTypeAhead#getTypeAhead}.
         * @memberof addresspb.GetTypeAhead
         * @typedef GetTypeAheadCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {addresspb.AddressByTypeAheadResponse} [response] AddressByTypeAheadResponse
         */

        /**
         * Calls GetTypeAhead.
         * @function getTypeAhead
         * @memberof addresspb.GetTypeAhead
         * @instance
         * @param {addresspb.IAddressByTypeAheadRequest} request AddressByTypeAheadRequest message or plain object
         * @param {addresspb.GetTypeAhead.GetTypeAheadCallback} callback Node-style callback called with the error, if any, and AddressByTypeAheadResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(GetTypeAhead.prototype.getTypeAhead = function getTypeAhead(request, callback) {
            return this.rpcCall(getTypeAhead, $root.addresspb.AddressByTypeAheadRequest, $root.addresspb.AddressByTypeAheadResponse, request, callback);
        }, "name", { value: "GetTypeAhead" });

        /**
         * Calls GetTypeAhead.
         * @function getTypeAhead
         * @memberof addresspb.GetTypeAhead
         * @instance
         * @param {addresspb.IAddressByTypeAheadRequest} request AddressByTypeAheadRequest message or plain object
         * @returns {Promise<addresspb.AddressByTypeAheadResponse>} Promise
         * @variation 2
         */

        return GetTypeAhead;
    })();

    addresspb.CreateCustomerAddress = (function() {

        /**
         * Constructs a new CreateCustomerAddress service.
         * @memberof addresspb
         * @classdesc Represents a CreateCustomerAddress
         * @extends $protobuf.rpc.Service
         * @constructor
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         */
        function CreateCustomerAddress(rpcImpl, requestDelimited, responseDelimited) {
            $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
        }

        (CreateCustomerAddress.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = CreateCustomerAddress;

        /**
         * Creates new CreateCustomerAddress service using the specified rpc implementation.
         * @function create
         * @memberof addresspb.CreateCustomerAddress
         * @static
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         * @returns {CreateCustomerAddress} RPC service. Useful where requests and/or responses are streamed.
         */
        CreateCustomerAddress.create = function create(rpcImpl, requestDelimited, responseDelimited) {
            return new this(rpcImpl, requestDelimited, responseDelimited);
        };

        /**
         * Callback as used by {@link addresspb.CreateCustomerAddress#createCustomerAddress}.
         * @memberof addresspb.CreateCustomerAddress
         * @typedef CreateCustomerAddressCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {addresspb.UnverifiedAddressResponse} [response] UnverifiedAddressResponse
         */

        /**
         * Calls CreateCustomerAddress.
         * @function createCustomerAddress
         * @memberof addresspb.CreateCustomerAddress
         * @instance
         * @param {addresspb.IUnverifiedAddressRequest} request UnverifiedAddressRequest message or plain object
         * @param {addresspb.CreateCustomerAddress.CreateCustomerAddressCallback} callback Node-style callback called with the error, if any, and UnverifiedAddressResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(CreateCustomerAddress.prototype.createCustomerAddress = function createCustomerAddress(request, callback) {
            return this.rpcCall(createCustomerAddress, $root.addresspb.UnverifiedAddressRequest, $root.addresspb.UnverifiedAddressResponse, request, callback);
        }, "name", { value: "CreateCustomerAddress" });

        /**
         * Calls CreateCustomerAddress.
         * @function createCustomerAddress
         * @memberof addresspb.CreateCustomerAddress
         * @instance
         * @param {addresspb.IUnverifiedAddressRequest} request UnverifiedAddressRequest message or plain object
         * @returns {Promise<addresspb.UnverifiedAddressResponse>} Promise
         * @variation 2
         */

        return CreateCustomerAddress;
    })();

    addresspb.VerifyByIdAddress = (function() {

        /**
         * Constructs a new VerifyByIdAddress service.
         * @memberof addresspb
         * @classdesc Represents a VerifyByIdAddress
         * @extends $protobuf.rpc.Service
         * @constructor
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         */
        function VerifyByIdAddress(rpcImpl, requestDelimited, responseDelimited) {
            $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
        }

        (VerifyByIdAddress.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = VerifyByIdAddress;

        /**
         * Creates new VerifyByIdAddress service using the specified rpc implementation.
         * @function create
         * @memberof addresspb.VerifyByIdAddress
         * @static
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         * @returns {VerifyByIdAddress} RPC service. Useful where requests and/or responses are streamed.
         */
        VerifyByIdAddress.create = function create(rpcImpl, requestDelimited, responseDelimited) {
            return new this(rpcImpl, requestDelimited, responseDelimited);
        };

        /**
         * Callback as used by {@link addresspb.VerifyByIdAddress#queryAddress}.
         * @memberof addresspb.VerifyByIdAddress
         * @typedef QueryAddressCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {addresspb.AddressResponse} [response] AddressResponse
         */

        /**
         * Calls QueryAddress.
         * @function queryAddress
         * @memberof addresspb.VerifyByIdAddress
         * @instance
         * @param {google.protobuf.IEmpty} request Empty message or plain object
         * @param {addresspb.VerifyByIdAddress.QueryAddressCallback} callback Node-style callback called with the error, if any, and AddressResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(VerifyByIdAddress.prototype.queryAddress = function queryAddress(request, callback) {
            return this.rpcCall(queryAddress, $root.google.protobuf.Empty, $root.addresspb.AddressResponse, request, callback);
        }, "name", { value: "QueryAddress" });

        /**
         * Calls QueryAddress.
         * @function queryAddress
         * @memberof addresspb.VerifyByIdAddress
         * @instance
         * @param {google.protobuf.IEmpty} request Empty message or plain object
         * @returns {Promise<addresspb.AddressResponse>} Promise
         * @variation 2
         */

        return VerifyByIdAddress;
    })();

    addresspb.GetAddressByUUID = (function() {

        /**
         * Constructs a new GetAddressByUUID service.
         * @memberof addresspb
         * @classdesc Represents a GetAddressByUUID
         * @extends $protobuf.rpc.Service
         * @constructor
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         */
        function GetAddressByUUID(rpcImpl, requestDelimited, responseDelimited) {
            $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
        }

        (GetAddressByUUID.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = GetAddressByUUID;

        /**
         * Creates new GetAddressByUUID service using the specified rpc implementation.
         * @function create
         * @memberof addresspb.GetAddressByUUID
         * @static
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         * @returns {GetAddressByUUID} RPC service. Useful where requests and/or responses are streamed.
         */
        GetAddressByUUID.create = function create(rpcImpl, requestDelimited, responseDelimited) {
            return new this(rpcImpl, requestDelimited, responseDelimited);
        };

        /**
         * Callback as used by {@link addresspb.GetAddressByUUID#getAddressByUUID}.
         * @memberof addresspb.GetAddressByUUID
         * @typedef GetAddressByUUIDCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {addresspb.AddressByUUIDResponse} [response] AddressByUUIDResponse
         */

        /**
         * Calls GetAddressByUUID.
         * @function getAddressByUUID
         * @memberof addresspb.GetAddressByUUID
         * @instance
         * @param {google.protobuf.IEmpty} request Empty message or plain object
         * @param {addresspb.GetAddressByUUID.GetAddressByUUIDCallback} callback Node-style callback called with the error, if any, and AddressByUUIDResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(GetAddressByUUID.prototype.getAddressByUUID = function getAddressByUUID(request, callback) {
            return this.rpcCall(getAddressByUUID, $root.google.protobuf.Empty, $root.addresspb.AddressByUUIDResponse, request, callback);
        }, "name", { value: "GetAddressByUUID" });

        /**
         * Calls GetAddressByUUID.
         * @function getAddressByUUID
         * @memberof addresspb.GetAddressByUUID
         * @instance
         * @param {google.protobuf.IEmpty} request Empty message or plain object
         * @returns {Promise<addresspb.AddressByUUIDResponse>} Promise
         * @variation 2
         */

        return GetAddressByUUID;
    })();

    addresspb.GetAddressByLegacyID = (function() {

        /**
         * Constructs a new GetAddressByLegacyID service.
         * @memberof addresspb
         * @classdesc Represents a GetAddressByLegacyID
         * @extends $protobuf.rpc.Service
         * @constructor
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         */
        function GetAddressByLegacyID(rpcImpl, requestDelimited, responseDelimited) {
            $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
        }

        (GetAddressByLegacyID.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = GetAddressByLegacyID;

        /**
         * Creates new GetAddressByLegacyID service using the specified rpc implementation.
         * @function create
         * @memberof addresspb.GetAddressByLegacyID
         * @static
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         * @returns {GetAddressByLegacyID} RPC service. Useful where requests and/or responses are streamed.
         */
        GetAddressByLegacyID.create = function create(rpcImpl, requestDelimited, responseDelimited) {
            return new this(rpcImpl, requestDelimited, responseDelimited);
        };

        /**
         * Callback as used by {@link addresspb.GetAddressByLegacyID#getAddressByLegacyID}.
         * @memberof addresspb.GetAddressByLegacyID
         * @typedef GetAddressByLegacyIDCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {addresspb.AddressByLegacyIDResponse} [response] AddressByLegacyIDResponse
         */

        /**
         * Calls GetAddressByLegacyID.
         * @function getAddressByLegacyID
         * @memberof addresspb.GetAddressByLegacyID
         * @instance
         * @param {addresspb.IAddressByLegacyIDRequest} request AddressByLegacyIDRequest message or plain object
         * @param {addresspb.GetAddressByLegacyID.GetAddressByLegacyIDCallback} callback Node-style callback called with the error, if any, and AddressByLegacyIDResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(GetAddressByLegacyID.prototype.getAddressByLegacyID = function getAddressByLegacyID(request, callback) {
            return this.rpcCall(getAddressByLegacyID, $root.addresspb.AddressByLegacyIDRequest, $root.addresspb.AddressByLegacyIDResponse, request, callback);
        }, "name", { value: "GetAddressByLegacyID" });

        /**
         * Calls GetAddressByLegacyID.
         * @function getAddressByLegacyID
         * @memberof addresspb.GetAddressByLegacyID
         * @instance
         * @param {addresspb.IAddressByLegacyIDRequest} request AddressByLegacyIDRequest message or plain object
         * @returns {Promise<addresspb.AddressByLegacyIDResponse>} Promise
         * @variation 2
         */

        return GetAddressByLegacyID;
    })();

    addresspb.ZipCodeDetails = (function() {

        /**
         * Constructs a new ZipCodeDetails service.
         * @memberof addresspb
         * @classdesc Represents a ZipCodeDetails
         * @extends $protobuf.rpc.Service
         * @constructor
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         */
        function ZipCodeDetails(rpcImpl, requestDelimited, responseDelimited) {
            $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
        }

        (ZipCodeDetails.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = ZipCodeDetails;

        /**
         * Creates new ZipCodeDetails service using the specified rpc implementation.
         * @function create
         * @memberof addresspb.ZipCodeDetails
         * @static
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         * @returns {ZipCodeDetails} RPC service. Useful where requests and/or responses are streamed.
         */
        ZipCodeDetails.create = function create(rpcImpl, requestDelimited, responseDelimited) {
            return new this(rpcImpl, requestDelimited, responseDelimited);
        };

        /**
         * Callback as used by {@link addresspb.ZipCodeDetails#zipCodeDetails}.
         * @memberof addresspb.ZipCodeDetails
         * @typedef ZipCodeDetailsCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {addresspb.ZipCodeDetailsResponse} [response] ZipCodeDetailsResponse
         */

        /**
         * Calls ZipCodeDetails.
         * @function zipCodeDetails
         * @memberof addresspb.ZipCodeDetails
         * @instance
         * @param {google.protobuf.IEmpty} request Empty message or plain object
         * @param {addresspb.ZipCodeDetails.ZipCodeDetailsCallback} callback Node-style callback called with the error, if any, and ZipCodeDetailsResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(ZipCodeDetails.prototype.zipCodeDetails = function zipCodeDetails(request, callback) {
            return this.rpcCall(zipCodeDetails, $root.google.protobuf.Empty, $root.addresspb.ZipCodeDetailsResponse, request, callback);
        }, "name", { value: "ZipCodeDetails" });

        /**
         * Calls ZipCodeDetails.
         * @function zipCodeDetails
         * @memberof addresspb.ZipCodeDetails
         * @instance
         * @param {google.protobuf.IEmpty} request Empty message or plain object
         * @returns {Promise<addresspb.ZipCodeDetailsResponse>} Promise
         * @variation 2
         */

        return ZipCodeDetails;
    })();

    addresspb.ZipCodeCheck = (function() {

        /**
         * Constructs a new ZipCodeCheck service.
         * @memberof addresspb
         * @classdesc Represents a ZipCodeCheck
         * @extends $protobuf.rpc.Service
         * @constructor
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         */
        function ZipCodeCheck(rpcImpl, requestDelimited, responseDelimited) {
            $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
        }

        (ZipCodeCheck.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = ZipCodeCheck;

        /**
         * Creates new ZipCodeCheck service using the specified rpc implementation.
         * @function create
         * @memberof addresspb.ZipCodeCheck
         * @static
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         * @returns {ZipCodeCheck} RPC service. Useful where requests and/or responses are streamed.
         */
        ZipCodeCheck.create = function create(rpcImpl, requestDelimited, responseDelimited) {
            return new this(rpcImpl, requestDelimited, responseDelimited);
        };

        /**
         * Callback as used by {@link addresspb.ZipCodeCheck#zipCodeCheck}.
         * @memberof addresspb.ZipCodeCheck
         * @typedef ZipCodeCheckCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {addresspb.ZipCodeStateCheckResponse} [response] ZipCodeStateCheckResponse
         */

        /**
         * Calls ZipCodeCheck.
         * @function zipCodeCheck
         * @memberof addresspb.ZipCodeCheck
         * @instance
         * @param {addresspb.IZipCodeStateCheckRequest} request ZipCodeStateCheckRequest message or plain object
         * @param {addresspb.ZipCodeCheck.ZipCodeCheckCallback} callback Node-style callback called with the error, if any, and ZipCodeStateCheckResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(ZipCodeCheck.prototype.zipCodeCheck = function zipCodeCheck(request, callback) {
            return this.rpcCall(zipCodeCheck, $root.addresspb.ZipCodeStateCheckRequest, $root.addresspb.ZipCodeStateCheckResponse, request, callback);
        }, "name", { value: "ZipCodeCheck" });

        /**
         * Calls ZipCodeCheck.
         * @function zipCodeCheck
         * @memberof addresspb.ZipCodeCheck
         * @instance
         * @param {addresspb.IZipCodeStateCheckRequest} request ZipCodeStateCheckRequest message or plain object
         * @returns {Promise<addresspb.ZipCodeStateCheckResponse>} Promise
         * @variation 2
         */

        return ZipCodeCheck;
    })();

    addresspb.GetZipCodeDetails = (function() {

        /**
         * Constructs a new GetZipCodeDetails service.
         * @memberof addresspb
         * @classdesc Represents a GetZipCodeDetails
         * @extends $protobuf.rpc.Service
         * @constructor
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         */
        function GetZipCodeDetails(rpcImpl, requestDelimited, responseDelimited) {
            $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
        }

        (GetZipCodeDetails.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = GetZipCodeDetails;

        /**
         * Creates new GetZipCodeDetails service using the specified rpc implementation.
         * @function create
         * @memberof addresspb.GetZipCodeDetails
         * @static
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         * @returns {GetZipCodeDetails} RPC service. Useful where requests and/or responses are streamed.
         */
        GetZipCodeDetails.create = function create(rpcImpl, requestDelimited, responseDelimited) {
            return new this(rpcImpl, requestDelimited, responseDelimited);
        };

        /**
         * Callback as used by {@link addresspb.GetZipCodeDetails#get}.
         * @memberof addresspb.GetZipCodeDetails
         * @typedef GetCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {addresspb.ZipCodeDetailsResponse} [response] ZipCodeDetailsResponse
         */

        /**
         * Calls Get.
         * @function get
         * @memberof addresspb.GetZipCodeDetails
         * @instance
         * @param {google.protobuf.IEmpty} request Empty message or plain object
         * @param {addresspb.GetZipCodeDetails.GetCallback} callback Node-style callback called with the error, if any, and ZipCodeDetailsResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(GetZipCodeDetails.prototype.get = function get(request, callback) {
            return this.rpcCall(get, $root.google.protobuf.Empty, $root.addresspb.ZipCodeDetailsResponse, request, callback);
        }, "name", { value: "Get" });

        /**
         * Calls Get.
         * @function get
         * @memberof addresspb.GetZipCodeDetails
         * @instance
         * @param {google.protobuf.IEmpty} request Empty message or plain object
         * @returns {Promise<addresspb.ZipCodeDetailsResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link addresspb.GetZipCodeDetails#getZipCodeDetails}.
         * @memberof addresspb.GetZipCodeDetails
         * @typedef GetZipCodeDetailsCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {addresspb.StateZipCodesResponse} [response] StateZipCodesResponse
         */

        /**
         * Calls GetZipCodeDetails.
         * @function getZipCodeDetails
         * @memberof addresspb.GetZipCodeDetails
         * @instance
         * @param {addresspb.IStateZipCodesRequest} request StateZipCodesRequest message or plain object
         * @param {addresspb.GetZipCodeDetails.GetZipCodeDetailsCallback} callback Node-style callback called with the error, if any, and StateZipCodesResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(GetZipCodeDetails.prototype.getZipCodeDetails = function getZipCodeDetails(request, callback) {
            return this.rpcCall(getZipCodeDetails, $root.addresspb.StateZipCodesRequest, $root.addresspb.StateZipCodesResponse, request, callback);
        }, "name", { value: "GetZipCodeDetails" });

        /**
         * Calls GetZipCodeDetails.
         * @function getZipCodeDetails
         * @memberof addresspb.GetZipCodeDetails
         * @instance
         * @param {addresspb.IStateZipCodesRequest} request StateZipCodesRequest message or plain object
         * @returns {Promise<addresspb.StateZipCodesResponse>} Promise
         * @variation 2
         */

        return GetZipCodeDetails;
    })();

    addresspb.States = (function() {

        /**
         * Constructs a new States service.
         * @memberof addresspb
         * @classdesc Represents a States
         * @extends $protobuf.rpc.Service
         * @constructor
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         */
        function States(rpcImpl, requestDelimited, responseDelimited) {
            $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
        }

        (States.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = States;

        /**
         * Creates new States service using the specified rpc implementation.
         * @function create
         * @memberof addresspb.States
         * @static
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         * @returns {States} RPC service. Useful where requests and/or responses are streamed.
         */
        States.create = function create(rpcImpl, requestDelimited, responseDelimited) {
            return new this(rpcImpl, requestDelimited, responseDelimited);
        };

        /**
         * Callback as used by {@link addresspb.States#getStates}.
         * @memberof addresspb.States
         * @typedef GetStatesCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {addresspb.StatesResponse} [response] StatesResponse
         */

        /**
         * Calls GetStates.
         * @function getStates
         * @memberof addresspb.States
         * @instance
         * @param {google.protobuf.IEmpty} request Empty message or plain object
         * @param {addresspb.States.GetStatesCallback} callback Node-style callback called with the error, if any, and StatesResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(States.prototype.getStates = function getStates(request, callback) {
            return this.rpcCall(getStates, $root.google.protobuf.Empty, $root.addresspb.StatesResponse, request, callback);
        }, "name", { value: "GetStates" });

        /**
         * Calls GetStates.
         * @function getStates
         * @memberof addresspb.States
         * @instance
         * @param {google.protobuf.IEmpty} request Empty message or plain object
         * @returns {Promise<addresspb.StatesResponse>} Promise
         * @variation 2
         */

        return States;
    })();

    addresspb.AddLegacyIDToMongo = (function() {

        /**
         * Constructs a new AddLegacyIDToMongo service.
         * @memberof addresspb
         * @classdesc Represents an AddLegacyIDToMongo
         * @extends $protobuf.rpc.Service
         * @constructor
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         */
        function AddLegacyIDToMongo(rpcImpl, requestDelimited, responseDelimited) {
            $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
        }

        (AddLegacyIDToMongo.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = AddLegacyIDToMongo;

        /**
         * Creates new AddLegacyIDToMongo service using the specified rpc implementation.
         * @function create
         * @memberof addresspb.AddLegacyIDToMongo
         * @static
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         * @returns {AddLegacyIDToMongo} RPC service. Useful where requests and/or responses are streamed.
         */
        AddLegacyIDToMongo.create = function create(rpcImpl, requestDelimited, responseDelimited) {
            return new this(rpcImpl, requestDelimited, responseDelimited);
        };

        /**
         * Callback as used by {@link addresspb.AddLegacyIDToMongo#createAddrMongo}.
         * @memberof addresspb.AddLegacyIDToMongo
         * @typedef CreateAddrMongoCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {addresspb.PostOrDeleteLegacyIDFromAddressResponse} [response] PostOrDeleteLegacyIDFromAddressResponse
         */

        /**
         * Calls CreateAddrMongo.
         * @function createAddrMongo
         * @memberof addresspb.AddLegacyIDToMongo
         * @instance
         * @param {addresspb.IPostLegacyIDToAddressRequest} request PostLegacyIDToAddressRequest message or plain object
         * @param {addresspb.AddLegacyIDToMongo.CreateAddrMongoCallback} callback Node-style callback called with the error, if any, and PostOrDeleteLegacyIDFromAddressResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(AddLegacyIDToMongo.prototype.createAddrMongo = function createAddrMongo(request, callback) {
            return this.rpcCall(createAddrMongo, $root.addresspb.PostLegacyIDToAddressRequest, $root.addresspb.PostOrDeleteLegacyIDFromAddressResponse, request, callback);
        }, "name", { value: "CreateAddrMongo" });

        /**
         * Calls CreateAddrMongo.
         * @function createAddrMongo
         * @memberof addresspb.AddLegacyIDToMongo
         * @instance
         * @param {addresspb.IPostLegacyIDToAddressRequest} request PostLegacyIDToAddressRequest message or plain object
         * @returns {Promise<addresspb.PostOrDeleteLegacyIDFromAddressResponse>} Promise
         * @variation 2
         */

        return AddLegacyIDToMongo;
    })();

    addresspb.RemoveLegacyIDFromMongo = (function() {

        /**
         * Constructs a new RemoveLegacyIDFromMongo service.
         * @memberof addresspb
         * @classdesc Represents a RemoveLegacyIDFromMongo
         * @extends $protobuf.rpc.Service
         * @constructor
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         */
        function RemoveLegacyIDFromMongo(rpcImpl, requestDelimited, responseDelimited) {
            $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
        }

        (RemoveLegacyIDFromMongo.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = RemoveLegacyIDFromMongo;

        /**
         * Creates new RemoveLegacyIDFromMongo service using the specified rpc implementation.
         * @function create
         * @memberof addresspb.RemoveLegacyIDFromMongo
         * @static
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         * @returns {RemoveLegacyIDFromMongo} RPC service. Useful where requests and/or responses are streamed.
         */
        RemoveLegacyIDFromMongo.create = function create(rpcImpl, requestDelimited, responseDelimited) {
            return new this(rpcImpl, requestDelimited, responseDelimited);
        };

        /**
         * Callback as used by {@link addresspb.RemoveLegacyIDFromMongo#deleteAddrMongo}.
         * @memberof addresspb.RemoveLegacyIDFromMongo
         * @typedef DeleteAddrMongoCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {addresspb.PostOrDeleteLegacyIDFromAddressResponse} [response] PostOrDeleteLegacyIDFromAddressResponse
         */

        /**
         * Calls DeleteAddrMongo.
         * @function deleteAddrMongo
         * @memberof addresspb.RemoveLegacyIDFromMongo
         * @instance
         * @param {addresspb.IDeleteLegacyIDFromAddressRequest} request DeleteLegacyIDFromAddressRequest message or plain object
         * @param {addresspb.RemoveLegacyIDFromMongo.DeleteAddrMongoCallback} callback Node-style callback called with the error, if any, and PostOrDeleteLegacyIDFromAddressResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(RemoveLegacyIDFromMongo.prototype.deleteAddrMongo = function deleteAddrMongo(request, callback) {
            return this.rpcCall(deleteAddrMongo, $root.addresspb.DeleteLegacyIDFromAddressRequest, $root.addresspb.PostOrDeleteLegacyIDFromAddressResponse, request, callback);
        }, "name", { value: "DeleteAddrMongo" });

        /**
         * Calls DeleteAddrMongo.
         * @function deleteAddrMongo
         * @memberof addresspb.RemoveLegacyIDFromMongo
         * @instance
         * @param {addresspb.IDeleteLegacyIDFromAddressRequest} request DeleteLegacyIDFromAddressRequest message or plain object
         * @returns {Promise<addresspb.PostOrDeleteLegacyIDFromAddressResponse>} Promise
         * @variation 2
         */

        return RemoveLegacyIDFromMongo;
    })();

    addresspb.BulkAddressValidation = (function() {

        /**
         * Constructs a new BulkAddressValidation service.
         * @memberof addresspb
         * @classdesc Represents a BulkAddressValidation
         * @extends $protobuf.rpc.Service
         * @constructor
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         */
        function BulkAddressValidation(rpcImpl, requestDelimited, responseDelimited) {
            $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
        }

        (BulkAddressValidation.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = BulkAddressValidation;

        /**
         * Creates new BulkAddressValidation service using the specified rpc implementation.
         * @function create
         * @memberof addresspb.BulkAddressValidation
         * @static
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         * @returns {BulkAddressValidation} RPC service. Useful where requests and/or responses are streamed.
         */
        BulkAddressValidation.create = function create(rpcImpl, requestDelimited, responseDelimited) {
            return new this(rpcImpl, requestDelimited, responseDelimited);
        };

        /**
         * Callback as used by {@link addresspb.BulkAddressValidation#postBulkAddressesForValidation}.
         * @memberof addresspb.BulkAddressValidation
         * @typedef PostBulkAddressesForValidationCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {addresspb.BulkAddressValidationResponse} [response] BulkAddressValidationResponse
         */

        /**
         * Calls PostBulkAddressesForValidation.
         * @function postBulkAddressesForValidation
         * @memberof addresspb.BulkAddressValidation
         * @instance
         * @param {addresspb.IBulkAddressValidationRequest} request BulkAddressValidationRequest message or plain object
         * @param {addresspb.BulkAddressValidation.PostBulkAddressesForValidationCallback} callback Node-style callback called with the error, if any, and BulkAddressValidationResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(BulkAddressValidation.prototype.postBulkAddressesForValidation = function postBulkAddressesForValidation(request, callback) {
            return this.rpcCall(postBulkAddressesForValidation, $root.addresspb.BulkAddressValidationRequest, $root.addresspb.BulkAddressValidationResponse, request, callback);
        }, "name", { value: "PostBulkAddressesForValidation" });

        /**
         * Calls PostBulkAddressesForValidation.
         * @function postBulkAddressesForValidation
         * @memberof addresspb.BulkAddressValidation
         * @instance
         * @param {addresspb.IBulkAddressValidationRequest} request BulkAddressValidationRequest message or plain object
         * @returns {Promise<addresspb.BulkAddressValidationResponse>} Promise
         * @variation 2
         */

        return BulkAddressValidation;
    })();

    addresspb.GetAddressesByLegacyIDs = (function() {

        /**
         * Constructs a new GetAddressesByLegacyIDs service.
         * @memberof addresspb
         * @classdesc Represents a GetAddressesByLegacyIDs
         * @extends $protobuf.rpc.Service
         * @constructor
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         */
        function GetAddressesByLegacyIDs(rpcImpl, requestDelimited, responseDelimited) {
            $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
        }

        (GetAddressesByLegacyIDs.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = GetAddressesByLegacyIDs;

        /**
         * Creates new GetAddressesByLegacyIDs service using the specified rpc implementation.
         * @function create
         * @memberof addresspb.GetAddressesByLegacyIDs
         * @static
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         * @returns {GetAddressesByLegacyIDs} RPC service. Useful where requests and/or responses are streamed.
         */
        GetAddressesByLegacyIDs.create = function create(rpcImpl, requestDelimited, responseDelimited) {
            return new this(rpcImpl, requestDelimited, responseDelimited);
        };

        /**
         * Callback as used by {@link addresspb.GetAddressesByLegacyIDs#getAddressesByLegacyIDs}.
         * @memberof addresspb.GetAddressesByLegacyIDs
         * @typedef GetAddressesByLegacyIDsCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {addresspb.AddressesByLegacyIDsResponse} [response] AddressesByLegacyIDsResponse
         */

        /**
         * Calls GetAddressesByLegacyIDs.
         * @function getAddressesByLegacyIDs
         * @memberof addresspb.GetAddressesByLegacyIDs
         * @instance
         * @param {addresspb.IAddressesByLegacyIDsRequest} request AddressesByLegacyIDsRequest message or plain object
         * @param {addresspb.GetAddressesByLegacyIDs.GetAddressesByLegacyIDsCallback} callback Node-style callback called with the error, if any, and AddressesByLegacyIDsResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(GetAddressesByLegacyIDs.prototype.getAddressesByLegacyIDs = function getAddressesByLegacyIDs(request, callback) {
            return this.rpcCall(getAddressesByLegacyIDs, $root.addresspb.AddressesByLegacyIDsRequest, $root.addresspb.AddressesByLegacyIDsResponse, request, callback);
        }, "name", { value: "GetAddressesByLegacyIDs" });

        /**
         * Calls GetAddressesByLegacyIDs.
         * @function getAddressesByLegacyIDs
         * @memberof addresspb.GetAddressesByLegacyIDs
         * @instance
         * @param {addresspb.IAddressesByLegacyIDsRequest} request AddressesByLegacyIDsRequest message or plain object
         * @returns {Promise<addresspb.AddressesByLegacyIDsResponse>} Promise
         * @variation 2
         */

        return GetAddressesByLegacyIDs;
    })();

    addresspb.VerifiedOrUnverifiedAddress = (function() {

        /**
         * Constructs a new VerifiedOrUnverifiedAddress service.
         * @memberof addresspb
         * @classdesc Represents a VerifiedOrUnverifiedAddress
         * @extends $protobuf.rpc.Service
         * @constructor
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         */
        function VerifiedOrUnverifiedAddress(rpcImpl, requestDelimited, responseDelimited) {
            $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
        }

        (VerifiedOrUnverifiedAddress.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = VerifiedOrUnverifiedAddress;

        /**
         * Creates new VerifiedOrUnverifiedAddress service using the specified rpc implementation.
         * @function create
         * @memberof addresspb.VerifiedOrUnverifiedAddress
         * @static
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         * @returns {VerifiedOrUnverifiedAddress} RPC service. Useful where requests and/or responses are streamed.
         */
        VerifiedOrUnverifiedAddress.create = function create(rpcImpl, requestDelimited, responseDelimited) {
            return new this(rpcImpl, requestDelimited, responseDelimited);
        };

        /**
         * Callback as used by {@link addresspb.VerifiedOrUnverifiedAddress#verifiedOrUnverifiedAddress}.
         * @memberof addresspb.VerifiedOrUnverifiedAddress
         * @typedef VerifiedOrUnverifiedAddressCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {addresspb.AddressResponse} [response] AddressResponse
         */

        /**
         * Calls VerifiedOrUnverifiedAddress.
         * @function verifiedOrUnverifiedAddress
         * @memberof addresspb.VerifiedOrUnverifiedAddress
         * @instance
         * @param {addresspb.IVerifiedOrUnverifiedAddressRequest} request VerifiedOrUnverifiedAddressRequest message or plain object
         * @param {addresspb.VerifiedOrUnverifiedAddress.VerifiedOrUnverifiedAddressCallback} callback Node-style callback called with the error, if any, and AddressResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(VerifiedOrUnverifiedAddress.prototype.verifiedOrUnverifiedAddress = function verifiedOrUnverifiedAddress(request, callback) {
            return this.rpcCall(verifiedOrUnverifiedAddress, $root.addresspb.VerifiedOrUnverifiedAddressRequest, $root.addresspb.AddressResponse, request, callback);
        }, "name", { value: "VerifiedOrUnverifiedAddress" });

        /**
         * Calls VerifiedOrUnverifiedAddress.
         * @function verifiedOrUnverifiedAddress
         * @memberof addresspb.VerifiedOrUnverifiedAddress
         * @instance
         * @param {addresspb.IVerifiedOrUnverifiedAddressRequest} request VerifiedOrUnverifiedAddressRequest message or plain object
         * @returns {Promise<addresspb.AddressResponse>} Promise
         * @variation 2
         */

        return VerifiedOrUnverifiedAddress;
    })();

    addresspb.PostAddress = (function() {

        /**
         * Constructs a new PostAddress service.
         * @memberof addresspb
         * @classdesc Represents a PostAddress
         * @extends $protobuf.rpc.Service
         * @constructor
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         */
        function PostAddress(rpcImpl, requestDelimited, responseDelimited) {
            $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
        }

        (PostAddress.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = PostAddress;

        /**
         * Creates new PostAddress service using the specified rpc implementation.
         * @function create
         * @memberof addresspb.PostAddress
         * @static
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         * @returns {PostAddress} RPC service. Useful where requests and/or responses are streamed.
         */
        PostAddress.create = function create(rpcImpl, requestDelimited, responseDelimited) {
            return new this(rpcImpl, requestDelimited, responseDelimited);
        };

        /**
         * Callback as used by {@link addresspb.PostAddress#postAddress}.
         * @memberof addresspb.PostAddress
         * @typedef PostAddressCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {addresspb.PostAddressResponse} [response] PostAddressResponse
         */

        /**
         * Calls PostAddress.
         * @function postAddress
         * @memberof addresspb.PostAddress
         * @instance
         * @param {addresspb.IPostAddressRequest} request PostAddressRequest message or plain object
         * @param {addresspb.PostAddress.PostAddressCallback} callback Node-style callback called with the error, if any, and PostAddressResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PostAddress.prototype.postAddress = function postAddress(request, callback) {
            return this.rpcCall(postAddress, $root.addresspb.PostAddressRequest, $root.addresspb.PostAddressResponse, request, callback);
        }, "name", { value: "PostAddress" });

        /**
         * Calls PostAddress.
         * @function postAddress
         * @memberof addresspb.PostAddress
         * @instance
         * @param {addresspb.IPostAddressRequest} request PostAddressRequest message or plain object
         * @returns {Promise<addresspb.PostAddressResponse>} Promise
         * @variation 2
         */

        return PostAddress;
    })();

    return addresspb;
})();

export const google = $root.google = (() => {

    /**
     * Namespace google.
     * @exports google
     * @namespace
     */
    const google = {};

    google.protobuf = (function() {

        /**
         * Namespace protobuf.
         * @memberof google
         * @namespace
         */
        const protobuf = {};

        protobuf.FileDescriptorSet = (function() {

            /**
             * Properties of a FileDescriptorSet.
             * @memberof google.protobuf
             * @interface IFileDescriptorSet
             * @property {Array.<google.protobuf.IFileDescriptorProto>|null} [file] FileDescriptorSet file
             */

            /**
             * Constructs a new FileDescriptorSet.
             * @memberof google.protobuf
             * @classdesc Represents a FileDescriptorSet.
             * @implements IFileDescriptorSet
             * @constructor
             * @param {google.protobuf.IFileDescriptorSet=} [p] Properties to set
             */
            function FileDescriptorSet(p) {
                this.file = [];
                if (p)
                    for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                        if (p[ks[i]] != null)
                            this[ks[i]] = p[ks[i]];
            }

            /**
             * FileDescriptorSet file.
             * @member {Array.<google.protobuf.IFileDescriptorProto>} file
             * @memberof google.protobuf.FileDescriptorSet
             * @instance
             */
            FileDescriptorSet.prototype.file = $util.emptyArray;

            /**
             * Creates a new FileDescriptorSet instance using the specified properties.
             * @function create
             * @memberof google.protobuf.FileDescriptorSet
             * @static
             * @param {google.protobuf.IFileDescriptorSet=} [properties] Properties to set
             * @returns {google.protobuf.FileDescriptorSet} FileDescriptorSet instance
             */
            FileDescriptorSet.create = function create(properties) {
                return new FileDescriptorSet(properties);
            };

            /**
             * Encodes the specified FileDescriptorSet message. Does not implicitly {@link google.protobuf.FileDescriptorSet.verify|verify} messages.
             * @function encode
             * @memberof google.protobuf.FileDescriptorSet
             * @static
             * @param {google.protobuf.IFileDescriptorSet} m FileDescriptorSet message or plain object to encode
             * @param {$protobuf.Writer} [w] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            FileDescriptorSet.encode = function encode(m, w) {
                if (!w)
                    w = $Writer.create();
                if (m.file != null && m.file.length) {
                    for (var i = 0; i < m.file.length; ++i)
                        $root.google.protobuf.FileDescriptorProto.encode(m.file[i], w.uint32(10).fork()).ldelim();
                }
                return w;
            };

            /**
             * Decodes a FileDescriptorSet message from the specified reader or buffer.
             * @function decode
             * @memberof google.protobuf.FileDescriptorSet
             * @static
             * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
             * @param {number} [l] Message length if known beforehand
             * @returns {google.protobuf.FileDescriptorSet} FileDescriptorSet
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            FileDescriptorSet.decode = function decode(r, l) {
                if (!(r instanceof $Reader))
                    r = $Reader.create(r);
                var c = l === undefined ? r.len : r.pos + l, m = new $root.google.protobuf.FileDescriptorSet();
                while (r.pos < c) {
                    var t = r.uint32();
                    switch (t >>> 3) {
                    case 1:
                        if (!(m.file && m.file.length))
                            m.file = [];
                        m.file.push($root.google.protobuf.FileDescriptorProto.decode(r, r.uint32()));
                        break;
                    default:
                        r.skipType(t & 7);
                        break;
                    }
                }
                return m;
            };

            return FileDescriptorSet;
        })();

        protobuf.FileDescriptorProto = (function() {

            /**
             * Properties of a FileDescriptorProto.
             * @memberof google.protobuf
             * @interface IFileDescriptorProto
             * @property {string|null} [name] FileDescriptorProto name
             * @property {string|null} ["package"] FileDescriptorProto package
             * @property {Array.<string>|null} [dependency] FileDescriptorProto dependency
             * @property {Array.<number>|null} [publicDependency] FileDescriptorProto publicDependency
             * @property {Array.<number>|null} [weakDependency] FileDescriptorProto weakDependency
             * @property {Array.<google.protobuf.IDescriptorProto>|null} [messageType] FileDescriptorProto messageType
             * @property {Array.<google.protobuf.IEnumDescriptorProto>|null} [enumType] FileDescriptorProto enumType
             * @property {Array.<google.protobuf.IServiceDescriptorProto>|null} [service] FileDescriptorProto service
             * @property {Array.<google.protobuf.IFieldDescriptorProto>|null} [extension] FileDescriptorProto extension
             * @property {google.protobuf.IFileOptions|null} [options] FileDescriptorProto options
             * @property {google.protobuf.ISourceCodeInfo|null} [sourceCodeInfo] FileDescriptorProto sourceCodeInfo
             * @property {string|null} [syntax] FileDescriptorProto syntax
             */

            /**
             * Constructs a new FileDescriptorProto.
             * @memberof google.protobuf
             * @classdesc Represents a FileDescriptorProto.
             * @implements IFileDescriptorProto
             * @constructor
             * @param {google.protobuf.IFileDescriptorProto=} [p] Properties to set
             */
            function FileDescriptorProto(p) {
                this.dependency = [];
                this.publicDependency = [];
                this.weakDependency = [];
                this.messageType = [];
                this.enumType = [];
                this.service = [];
                this.extension = [];
                if (p)
                    for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                        if (p[ks[i]] != null)
                            this[ks[i]] = p[ks[i]];
            }

            /**
             * FileDescriptorProto name.
             * @member {string} name
             * @memberof google.protobuf.FileDescriptorProto
             * @instance
             */
            FileDescriptorProto.prototype.name = "";

            /**
             * FileDescriptorProto package.
             * @member {string} package
             * @memberof google.protobuf.FileDescriptorProto
             * @instance
             */
            FileDescriptorProto.prototype["package"] = "";

            /**
             * FileDescriptorProto dependency.
             * @member {Array.<string>} dependency
             * @memberof google.protobuf.FileDescriptorProto
             * @instance
             */
            FileDescriptorProto.prototype.dependency = $util.emptyArray;

            /**
             * FileDescriptorProto publicDependency.
             * @member {Array.<number>} publicDependency
             * @memberof google.protobuf.FileDescriptorProto
             * @instance
             */
            FileDescriptorProto.prototype.publicDependency = $util.emptyArray;

            /**
             * FileDescriptorProto weakDependency.
             * @member {Array.<number>} weakDependency
             * @memberof google.protobuf.FileDescriptorProto
             * @instance
             */
            FileDescriptorProto.prototype.weakDependency = $util.emptyArray;

            /**
             * FileDescriptorProto messageType.
             * @member {Array.<google.protobuf.IDescriptorProto>} messageType
             * @memberof google.protobuf.FileDescriptorProto
             * @instance
             */
            FileDescriptorProto.prototype.messageType = $util.emptyArray;

            /**
             * FileDescriptorProto enumType.
             * @member {Array.<google.protobuf.IEnumDescriptorProto>} enumType
             * @memberof google.protobuf.FileDescriptorProto
             * @instance
             */
            FileDescriptorProto.prototype.enumType = $util.emptyArray;

            /**
             * FileDescriptorProto service.
             * @member {Array.<google.protobuf.IServiceDescriptorProto>} service
             * @memberof google.protobuf.FileDescriptorProto
             * @instance
             */
            FileDescriptorProto.prototype.service = $util.emptyArray;

            /**
             * FileDescriptorProto extension.
             * @member {Array.<google.protobuf.IFieldDescriptorProto>} extension
             * @memberof google.protobuf.FileDescriptorProto
             * @instance
             */
            FileDescriptorProto.prototype.extension = $util.emptyArray;

            /**
             * FileDescriptorProto options.
             * @member {google.protobuf.IFileOptions|null|undefined} options
             * @memberof google.protobuf.FileDescriptorProto
             * @instance
             */
            FileDescriptorProto.prototype.options = null;

            /**
             * FileDescriptorProto sourceCodeInfo.
             * @member {google.protobuf.ISourceCodeInfo|null|undefined} sourceCodeInfo
             * @memberof google.protobuf.FileDescriptorProto
             * @instance
             */
            FileDescriptorProto.prototype.sourceCodeInfo = null;

            /**
             * FileDescriptorProto syntax.
             * @member {string} syntax
             * @memberof google.protobuf.FileDescriptorProto
             * @instance
             */
            FileDescriptorProto.prototype.syntax = "";

            /**
             * Creates a new FileDescriptorProto instance using the specified properties.
             * @function create
             * @memberof google.protobuf.FileDescriptorProto
             * @static
             * @param {google.protobuf.IFileDescriptorProto=} [properties] Properties to set
             * @returns {google.protobuf.FileDescriptorProto} FileDescriptorProto instance
             */
            FileDescriptorProto.create = function create(properties) {
                return new FileDescriptorProto(properties);
            };

            /**
             * Encodes the specified FileDescriptorProto message. Does not implicitly {@link google.protobuf.FileDescriptorProto.verify|verify} messages.
             * @function encode
             * @memberof google.protobuf.FileDescriptorProto
             * @static
             * @param {google.protobuf.IFileDescriptorProto} m FileDescriptorProto message or plain object to encode
             * @param {$protobuf.Writer} [w] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            FileDescriptorProto.encode = function encode(m, w) {
                if (!w)
                    w = $Writer.create();
                if (m.name != null && Object.hasOwnProperty.call(m, "name"))
                    w.uint32(10).string(m.name);
                if (m["package"] != null && Object.hasOwnProperty.call(m, "package"))
                    w.uint32(18).string(m["package"]);
                if (m.dependency != null && m.dependency.length) {
                    for (var i = 0; i < m.dependency.length; ++i)
                        w.uint32(26).string(m.dependency[i]);
                }
                if (m.messageType != null && m.messageType.length) {
                    for (var i = 0; i < m.messageType.length; ++i)
                        $root.google.protobuf.DescriptorProto.encode(m.messageType[i], w.uint32(34).fork()).ldelim();
                }
                if (m.enumType != null && m.enumType.length) {
                    for (var i = 0; i < m.enumType.length; ++i)
                        $root.google.protobuf.EnumDescriptorProto.encode(m.enumType[i], w.uint32(42).fork()).ldelim();
                }
                if (m.service != null && m.service.length) {
                    for (var i = 0; i < m.service.length; ++i)
                        $root.google.protobuf.ServiceDescriptorProto.encode(m.service[i], w.uint32(50).fork()).ldelim();
                }
                if (m.extension != null && m.extension.length) {
                    for (var i = 0; i < m.extension.length; ++i)
                        $root.google.protobuf.FieldDescriptorProto.encode(m.extension[i], w.uint32(58).fork()).ldelim();
                }
                if (m.options != null && Object.hasOwnProperty.call(m, "options"))
                    $root.google.protobuf.FileOptions.encode(m.options, w.uint32(66).fork()).ldelim();
                if (m.sourceCodeInfo != null && Object.hasOwnProperty.call(m, "sourceCodeInfo"))
                    $root.google.protobuf.SourceCodeInfo.encode(m.sourceCodeInfo, w.uint32(74).fork()).ldelim();
                if (m.publicDependency != null && m.publicDependency.length) {
                    for (var i = 0; i < m.publicDependency.length; ++i)
                        w.uint32(80).int32(m.publicDependency[i]);
                }
                if (m.weakDependency != null && m.weakDependency.length) {
                    for (var i = 0; i < m.weakDependency.length; ++i)
                        w.uint32(88).int32(m.weakDependency[i]);
                }
                if (m.syntax != null && Object.hasOwnProperty.call(m, "syntax"))
                    w.uint32(98).string(m.syntax);
                return w;
            };

            /**
             * Decodes a FileDescriptorProto message from the specified reader or buffer.
             * @function decode
             * @memberof google.protobuf.FileDescriptorProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
             * @param {number} [l] Message length if known beforehand
             * @returns {google.protobuf.FileDescriptorProto} FileDescriptorProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            FileDescriptorProto.decode = function decode(r, l) {
                if (!(r instanceof $Reader))
                    r = $Reader.create(r);
                var c = l === undefined ? r.len : r.pos + l, m = new $root.google.protobuf.FileDescriptorProto();
                while (r.pos < c) {
                    var t = r.uint32();
                    switch (t >>> 3) {
                    case 1:
                        m.name = r.string();
                        break;
                    case 2:
                        m["package"] = r.string();
                        break;
                    case 3:
                        if (!(m.dependency && m.dependency.length))
                            m.dependency = [];
                        m.dependency.push(r.string());
                        break;
                    case 10:
                        if (!(m.publicDependency && m.publicDependency.length))
                            m.publicDependency = [];
                        if ((t & 7) === 2) {
                            var c2 = r.uint32() + r.pos;
                            while (r.pos < c2)
                                m.publicDependency.push(r.int32());
                        } else
                            m.publicDependency.push(r.int32());
                        break;
                    case 11:
                        if (!(m.weakDependency && m.weakDependency.length))
                            m.weakDependency = [];
                        if ((t & 7) === 2) {
                            var c2 = r.uint32() + r.pos;
                            while (r.pos < c2)
                                m.weakDependency.push(r.int32());
                        } else
                            m.weakDependency.push(r.int32());
                        break;
                    case 4:
                        if (!(m.messageType && m.messageType.length))
                            m.messageType = [];
                        m.messageType.push($root.google.protobuf.DescriptorProto.decode(r, r.uint32()));
                        break;
                    case 5:
                        if (!(m.enumType && m.enumType.length))
                            m.enumType = [];
                        m.enumType.push($root.google.protobuf.EnumDescriptorProto.decode(r, r.uint32()));
                        break;
                    case 6:
                        if (!(m.service && m.service.length))
                            m.service = [];
                        m.service.push($root.google.protobuf.ServiceDescriptorProto.decode(r, r.uint32()));
                        break;
                    case 7:
                        if (!(m.extension && m.extension.length))
                            m.extension = [];
                        m.extension.push($root.google.protobuf.FieldDescriptorProto.decode(r, r.uint32()));
                        break;
                    case 8:
                        m.options = $root.google.protobuf.FileOptions.decode(r, r.uint32());
                        break;
                    case 9:
                        m.sourceCodeInfo = $root.google.protobuf.SourceCodeInfo.decode(r, r.uint32());
                        break;
                    case 12:
                        m.syntax = r.string();
                        break;
                    default:
                        r.skipType(t & 7);
                        break;
                    }
                }
                return m;
            };

            return FileDescriptorProto;
        })();

        protobuf.DescriptorProto = (function() {

            /**
             * Properties of a DescriptorProto.
             * @memberof google.protobuf
             * @interface IDescriptorProto
             * @property {string|null} [name] DescriptorProto name
             * @property {Array.<google.protobuf.IFieldDescriptorProto>|null} [field] DescriptorProto field
             * @property {Array.<google.protobuf.IFieldDescriptorProto>|null} [extension] DescriptorProto extension
             * @property {Array.<google.protobuf.IDescriptorProto>|null} [nestedType] DescriptorProto nestedType
             * @property {Array.<google.protobuf.IEnumDescriptorProto>|null} [enumType] DescriptorProto enumType
             * @property {Array.<google.protobuf.DescriptorProto.IExtensionRange>|null} [extensionRange] DescriptorProto extensionRange
             * @property {Array.<google.protobuf.IOneofDescriptorProto>|null} [oneofDecl] DescriptorProto oneofDecl
             * @property {google.protobuf.IMessageOptions|null} [options] DescriptorProto options
             * @property {Array.<google.protobuf.DescriptorProto.IReservedRange>|null} [reservedRange] DescriptorProto reservedRange
             * @property {Array.<string>|null} [reservedName] DescriptorProto reservedName
             */

            /**
             * Constructs a new DescriptorProto.
             * @memberof google.protobuf
             * @classdesc Represents a DescriptorProto.
             * @implements IDescriptorProto
             * @constructor
             * @param {google.protobuf.IDescriptorProto=} [p] Properties to set
             */
            function DescriptorProto(p) {
                this.field = [];
                this.extension = [];
                this.nestedType = [];
                this.enumType = [];
                this.extensionRange = [];
                this.oneofDecl = [];
                this.reservedRange = [];
                this.reservedName = [];
                if (p)
                    for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                        if (p[ks[i]] != null)
                            this[ks[i]] = p[ks[i]];
            }

            /**
             * DescriptorProto name.
             * @member {string} name
             * @memberof google.protobuf.DescriptorProto
             * @instance
             */
            DescriptorProto.prototype.name = "";

            /**
             * DescriptorProto field.
             * @member {Array.<google.protobuf.IFieldDescriptorProto>} field
             * @memberof google.protobuf.DescriptorProto
             * @instance
             */
            DescriptorProto.prototype.field = $util.emptyArray;

            /**
             * DescriptorProto extension.
             * @member {Array.<google.protobuf.IFieldDescriptorProto>} extension
             * @memberof google.protobuf.DescriptorProto
             * @instance
             */
            DescriptorProto.prototype.extension = $util.emptyArray;

            /**
             * DescriptorProto nestedType.
             * @member {Array.<google.protobuf.IDescriptorProto>} nestedType
             * @memberof google.protobuf.DescriptorProto
             * @instance
             */
            DescriptorProto.prototype.nestedType = $util.emptyArray;

            /**
             * DescriptorProto enumType.
             * @member {Array.<google.protobuf.IEnumDescriptorProto>} enumType
             * @memberof google.protobuf.DescriptorProto
             * @instance
             */
            DescriptorProto.prototype.enumType = $util.emptyArray;

            /**
             * DescriptorProto extensionRange.
             * @member {Array.<google.protobuf.DescriptorProto.IExtensionRange>} extensionRange
             * @memberof google.protobuf.DescriptorProto
             * @instance
             */
            DescriptorProto.prototype.extensionRange = $util.emptyArray;

            /**
             * DescriptorProto oneofDecl.
             * @member {Array.<google.protobuf.IOneofDescriptorProto>} oneofDecl
             * @memberof google.protobuf.DescriptorProto
             * @instance
             */
            DescriptorProto.prototype.oneofDecl = $util.emptyArray;

            /**
             * DescriptorProto options.
             * @member {google.protobuf.IMessageOptions|null|undefined} options
             * @memberof google.protobuf.DescriptorProto
             * @instance
             */
            DescriptorProto.prototype.options = null;

            /**
             * DescriptorProto reservedRange.
             * @member {Array.<google.protobuf.DescriptorProto.IReservedRange>} reservedRange
             * @memberof google.protobuf.DescriptorProto
             * @instance
             */
            DescriptorProto.prototype.reservedRange = $util.emptyArray;

            /**
             * DescriptorProto reservedName.
             * @member {Array.<string>} reservedName
             * @memberof google.protobuf.DescriptorProto
             * @instance
             */
            DescriptorProto.prototype.reservedName = $util.emptyArray;

            /**
             * Creates a new DescriptorProto instance using the specified properties.
             * @function create
             * @memberof google.protobuf.DescriptorProto
             * @static
             * @param {google.protobuf.IDescriptorProto=} [properties] Properties to set
             * @returns {google.protobuf.DescriptorProto} DescriptorProto instance
             */
            DescriptorProto.create = function create(properties) {
                return new DescriptorProto(properties);
            };

            /**
             * Encodes the specified DescriptorProto message. Does not implicitly {@link google.protobuf.DescriptorProto.verify|verify} messages.
             * @function encode
             * @memberof google.protobuf.DescriptorProto
             * @static
             * @param {google.protobuf.IDescriptorProto} m DescriptorProto message or plain object to encode
             * @param {$protobuf.Writer} [w] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            DescriptorProto.encode = function encode(m, w) {
                if (!w)
                    w = $Writer.create();
                if (m.name != null && Object.hasOwnProperty.call(m, "name"))
                    w.uint32(10).string(m.name);
                if (m.field != null && m.field.length) {
                    for (var i = 0; i < m.field.length; ++i)
                        $root.google.protobuf.FieldDescriptorProto.encode(m.field[i], w.uint32(18).fork()).ldelim();
                }
                if (m.nestedType != null && m.nestedType.length) {
                    for (var i = 0; i < m.nestedType.length; ++i)
                        $root.google.protobuf.DescriptorProto.encode(m.nestedType[i], w.uint32(26).fork()).ldelim();
                }
                if (m.enumType != null && m.enumType.length) {
                    for (var i = 0; i < m.enumType.length; ++i)
                        $root.google.protobuf.EnumDescriptorProto.encode(m.enumType[i], w.uint32(34).fork()).ldelim();
                }
                if (m.extensionRange != null && m.extensionRange.length) {
                    for (var i = 0; i < m.extensionRange.length; ++i)
                        $root.google.protobuf.DescriptorProto.ExtensionRange.encode(m.extensionRange[i], w.uint32(42).fork()).ldelim();
                }
                if (m.extension != null && m.extension.length) {
                    for (var i = 0; i < m.extension.length; ++i)
                        $root.google.protobuf.FieldDescriptorProto.encode(m.extension[i], w.uint32(50).fork()).ldelim();
                }
                if (m.options != null && Object.hasOwnProperty.call(m, "options"))
                    $root.google.protobuf.MessageOptions.encode(m.options, w.uint32(58).fork()).ldelim();
                if (m.oneofDecl != null && m.oneofDecl.length) {
                    for (var i = 0; i < m.oneofDecl.length; ++i)
                        $root.google.protobuf.OneofDescriptorProto.encode(m.oneofDecl[i], w.uint32(66).fork()).ldelim();
                }
                if (m.reservedRange != null && m.reservedRange.length) {
                    for (var i = 0; i < m.reservedRange.length; ++i)
                        $root.google.protobuf.DescriptorProto.ReservedRange.encode(m.reservedRange[i], w.uint32(74).fork()).ldelim();
                }
                if (m.reservedName != null && m.reservedName.length) {
                    for (var i = 0; i < m.reservedName.length; ++i)
                        w.uint32(82).string(m.reservedName[i]);
                }
                return w;
            };

            /**
             * Decodes a DescriptorProto message from the specified reader or buffer.
             * @function decode
             * @memberof google.protobuf.DescriptorProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
             * @param {number} [l] Message length if known beforehand
             * @returns {google.protobuf.DescriptorProto} DescriptorProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            DescriptorProto.decode = function decode(r, l) {
                if (!(r instanceof $Reader))
                    r = $Reader.create(r);
                var c = l === undefined ? r.len : r.pos + l, m = new $root.google.protobuf.DescriptorProto();
                while (r.pos < c) {
                    var t = r.uint32();
                    switch (t >>> 3) {
                    case 1:
                        m.name = r.string();
                        break;
                    case 2:
                        if (!(m.field && m.field.length))
                            m.field = [];
                        m.field.push($root.google.protobuf.FieldDescriptorProto.decode(r, r.uint32()));
                        break;
                    case 6:
                        if (!(m.extension && m.extension.length))
                            m.extension = [];
                        m.extension.push($root.google.protobuf.FieldDescriptorProto.decode(r, r.uint32()));
                        break;
                    case 3:
                        if (!(m.nestedType && m.nestedType.length))
                            m.nestedType = [];
                        m.nestedType.push($root.google.protobuf.DescriptorProto.decode(r, r.uint32()));
                        break;
                    case 4:
                        if (!(m.enumType && m.enumType.length))
                            m.enumType = [];
                        m.enumType.push($root.google.protobuf.EnumDescriptorProto.decode(r, r.uint32()));
                        break;
                    case 5:
                        if (!(m.extensionRange && m.extensionRange.length))
                            m.extensionRange = [];
                        m.extensionRange.push($root.google.protobuf.DescriptorProto.ExtensionRange.decode(r, r.uint32()));
                        break;
                    case 8:
                        if (!(m.oneofDecl && m.oneofDecl.length))
                            m.oneofDecl = [];
                        m.oneofDecl.push($root.google.protobuf.OneofDescriptorProto.decode(r, r.uint32()));
                        break;
                    case 7:
                        m.options = $root.google.protobuf.MessageOptions.decode(r, r.uint32());
                        break;
                    case 9:
                        if (!(m.reservedRange && m.reservedRange.length))
                            m.reservedRange = [];
                        m.reservedRange.push($root.google.protobuf.DescriptorProto.ReservedRange.decode(r, r.uint32()));
                        break;
                    case 10:
                        if (!(m.reservedName && m.reservedName.length))
                            m.reservedName = [];
                        m.reservedName.push(r.string());
                        break;
                    default:
                        r.skipType(t & 7);
                        break;
                    }
                }
                return m;
            };

            DescriptorProto.ExtensionRange = (function() {

                /**
                 * Properties of an ExtensionRange.
                 * @memberof google.protobuf.DescriptorProto
                 * @interface IExtensionRange
                 * @property {number|null} [start] ExtensionRange start
                 * @property {number|null} [end] ExtensionRange end
                 */

                /**
                 * Constructs a new ExtensionRange.
                 * @memberof google.protobuf.DescriptorProto
                 * @classdesc Represents an ExtensionRange.
                 * @implements IExtensionRange
                 * @constructor
                 * @param {google.protobuf.DescriptorProto.IExtensionRange=} [p] Properties to set
                 */
                function ExtensionRange(p) {
                    if (p)
                        for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                            if (p[ks[i]] != null)
                                this[ks[i]] = p[ks[i]];
                }

                /**
                 * ExtensionRange start.
                 * @member {number} start
                 * @memberof google.protobuf.DescriptorProto.ExtensionRange
                 * @instance
                 */
                ExtensionRange.prototype.start = 0;

                /**
                 * ExtensionRange end.
                 * @member {number} end
                 * @memberof google.protobuf.DescriptorProto.ExtensionRange
                 * @instance
                 */
                ExtensionRange.prototype.end = 0;

                /**
                 * Creates a new ExtensionRange instance using the specified properties.
                 * @function create
                 * @memberof google.protobuf.DescriptorProto.ExtensionRange
                 * @static
                 * @param {google.protobuf.DescriptorProto.IExtensionRange=} [properties] Properties to set
                 * @returns {google.protobuf.DescriptorProto.ExtensionRange} ExtensionRange instance
                 */
                ExtensionRange.create = function create(properties) {
                    return new ExtensionRange(properties);
                };

                /**
                 * Encodes the specified ExtensionRange message. Does not implicitly {@link google.protobuf.DescriptorProto.ExtensionRange.verify|verify} messages.
                 * @function encode
                 * @memberof google.protobuf.DescriptorProto.ExtensionRange
                 * @static
                 * @param {google.protobuf.DescriptorProto.IExtensionRange} m ExtensionRange message or plain object to encode
                 * @param {$protobuf.Writer} [w] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ExtensionRange.encode = function encode(m, w) {
                    if (!w)
                        w = $Writer.create();
                    if (m.start != null && Object.hasOwnProperty.call(m, "start"))
                        w.uint32(8).int32(m.start);
                    if (m.end != null && Object.hasOwnProperty.call(m, "end"))
                        w.uint32(16).int32(m.end);
                    return w;
                };

                /**
                 * Decodes an ExtensionRange message from the specified reader or buffer.
                 * @function decode
                 * @memberof google.protobuf.DescriptorProto.ExtensionRange
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
                 * @param {number} [l] Message length if known beforehand
                 * @returns {google.protobuf.DescriptorProto.ExtensionRange} ExtensionRange
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ExtensionRange.decode = function decode(r, l) {
                    if (!(r instanceof $Reader))
                        r = $Reader.create(r);
                    var c = l === undefined ? r.len : r.pos + l, m = new $root.google.protobuf.DescriptorProto.ExtensionRange();
                    while (r.pos < c) {
                        var t = r.uint32();
                        switch (t >>> 3) {
                        case 1:
                            m.start = r.int32();
                            break;
                        case 2:
                            m.end = r.int32();
                            break;
                        default:
                            r.skipType(t & 7);
                            break;
                        }
                    }
                    return m;
                };

                return ExtensionRange;
            })();

            DescriptorProto.ReservedRange = (function() {

                /**
                 * Properties of a ReservedRange.
                 * @memberof google.protobuf.DescriptorProto
                 * @interface IReservedRange
                 * @property {number|null} [start] ReservedRange start
                 * @property {number|null} [end] ReservedRange end
                 */

                /**
                 * Constructs a new ReservedRange.
                 * @memberof google.protobuf.DescriptorProto
                 * @classdesc Represents a ReservedRange.
                 * @implements IReservedRange
                 * @constructor
                 * @param {google.protobuf.DescriptorProto.IReservedRange=} [p] Properties to set
                 */
                function ReservedRange(p) {
                    if (p)
                        for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                            if (p[ks[i]] != null)
                                this[ks[i]] = p[ks[i]];
                }

                /**
                 * ReservedRange start.
                 * @member {number} start
                 * @memberof google.protobuf.DescriptorProto.ReservedRange
                 * @instance
                 */
                ReservedRange.prototype.start = 0;

                /**
                 * ReservedRange end.
                 * @member {number} end
                 * @memberof google.protobuf.DescriptorProto.ReservedRange
                 * @instance
                 */
                ReservedRange.prototype.end = 0;

                /**
                 * Creates a new ReservedRange instance using the specified properties.
                 * @function create
                 * @memberof google.protobuf.DescriptorProto.ReservedRange
                 * @static
                 * @param {google.protobuf.DescriptorProto.IReservedRange=} [properties] Properties to set
                 * @returns {google.protobuf.DescriptorProto.ReservedRange} ReservedRange instance
                 */
                ReservedRange.create = function create(properties) {
                    return new ReservedRange(properties);
                };

                /**
                 * Encodes the specified ReservedRange message. Does not implicitly {@link google.protobuf.DescriptorProto.ReservedRange.verify|verify} messages.
                 * @function encode
                 * @memberof google.protobuf.DescriptorProto.ReservedRange
                 * @static
                 * @param {google.protobuf.DescriptorProto.IReservedRange} m ReservedRange message or plain object to encode
                 * @param {$protobuf.Writer} [w] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ReservedRange.encode = function encode(m, w) {
                    if (!w)
                        w = $Writer.create();
                    if (m.start != null && Object.hasOwnProperty.call(m, "start"))
                        w.uint32(8).int32(m.start);
                    if (m.end != null && Object.hasOwnProperty.call(m, "end"))
                        w.uint32(16).int32(m.end);
                    return w;
                };

                /**
                 * Decodes a ReservedRange message from the specified reader or buffer.
                 * @function decode
                 * @memberof google.protobuf.DescriptorProto.ReservedRange
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
                 * @param {number} [l] Message length if known beforehand
                 * @returns {google.protobuf.DescriptorProto.ReservedRange} ReservedRange
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ReservedRange.decode = function decode(r, l) {
                    if (!(r instanceof $Reader))
                        r = $Reader.create(r);
                    var c = l === undefined ? r.len : r.pos + l, m = new $root.google.protobuf.DescriptorProto.ReservedRange();
                    while (r.pos < c) {
                        var t = r.uint32();
                        switch (t >>> 3) {
                        case 1:
                            m.start = r.int32();
                            break;
                        case 2:
                            m.end = r.int32();
                            break;
                        default:
                            r.skipType(t & 7);
                            break;
                        }
                    }
                    return m;
                };

                return ReservedRange;
            })();

            return DescriptorProto;
        })();

        protobuf.FieldDescriptorProto = (function() {

            /**
             * Properties of a FieldDescriptorProto.
             * @memberof google.protobuf
             * @interface IFieldDescriptorProto
             * @property {string|null} [name] FieldDescriptorProto name
             * @property {number|null} [number] FieldDescriptorProto number
             * @property {google.protobuf.FieldDescriptorProto.Label|null} [label] FieldDescriptorProto label
             * @property {google.protobuf.FieldDescriptorProto.Type|null} [type] FieldDescriptorProto type
             * @property {string|null} [typeName] FieldDescriptorProto typeName
             * @property {string|null} [extendee] FieldDescriptorProto extendee
             * @property {string|null} [defaultValue] FieldDescriptorProto defaultValue
             * @property {number|null} [oneofIndex] FieldDescriptorProto oneofIndex
             * @property {string|null} [jsonName] FieldDescriptorProto jsonName
             * @property {google.protobuf.IFieldOptions|null} [options] FieldDescriptorProto options
             */

            /**
             * Constructs a new FieldDescriptorProto.
             * @memberof google.protobuf
             * @classdesc Represents a FieldDescriptorProto.
             * @implements IFieldDescriptorProto
             * @constructor
             * @param {google.protobuf.IFieldDescriptorProto=} [p] Properties to set
             */
            function FieldDescriptorProto(p) {
                if (p)
                    for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                        if (p[ks[i]] != null)
                            this[ks[i]] = p[ks[i]];
            }

            /**
             * FieldDescriptorProto name.
             * @member {string} name
             * @memberof google.protobuf.FieldDescriptorProto
             * @instance
             */
            FieldDescriptorProto.prototype.name = "";

            /**
             * FieldDescriptorProto number.
             * @member {number} number
             * @memberof google.protobuf.FieldDescriptorProto
             * @instance
             */
            FieldDescriptorProto.prototype.number = 0;

            /**
             * FieldDescriptorProto label.
             * @member {google.protobuf.FieldDescriptorProto.Label} label
             * @memberof google.protobuf.FieldDescriptorProto
             * @instance
             */
            FieldDescriptorProto.prototype.label = 1;

            /**
             * FieldDescriptorProto type.
             * @member {google.protobuf.FieldDescriptorProto.Type} type
             * @memberof google.protobuf.FieldDescriptorProto
             * @instance
             */
            FieldDescriptorProto.prototype.type = 1;

            /**
             * FieldDescriptorProto typeName.
             * @member {string} typeName
             * @memberof google.protobuf.FieldDescriptorProto
             * @instance
             */
            FieldDescriptorProto.prototype.typeName = "";

            /**
             * FieldDescriptorProto extendee.
             * @member {string} extendee
             * @memberof google.protobuf.FieldDescriptorProto
             * @instance
             */
            FieldDescriptorProto.prototype.extendee = "";

            /**
             * FieldDescriptorProto defaultValue.
             * @member {string} defaultValue
             * @memberof google.protobuf.FieldDescriptorProto
             * @instance
             */
            FieldDescriptorProto.prototype.defaultValue = "";

            /**
             * FieldDescriptorProto oneofIndex.
             * @member {number} oneofIndex
             * @memberof google.protobuf.FieldDescriptorProto
             * @instance
             */
            FieldDescriptorProto.prototype.oneofIndex = 0;

            /**
             * FieldDescriptorProto jsonName.
             * @member {string} jsonName
             * @memberof google.protobuf.FieldDescriptorProto
             * @instance
             */
            FieldDescriptorProto.prototype.jsonName = "";

            /**
             * FieldDescriptorProto options.
             * @member {google.protobuf.IFieldOptions|null|undefined} options
             * @memberof google.protobuf.FieldDescriptorProto
             * @instance
             */
            FieldDescriptorProto.prototype.options = null;

            /**
             * Creates a new FieldDescriptorProto instance using the specified properties.
             * @function create
             * @memberof google.protobuf.FieldDescriptorProto
             * @static
             * @param {google.protobuf.IFieldDescriptorProto=} [properties] Properties to set
             * @returns {google.protobuf.FieldDescriptorProto} FieldDescriptorProto instance
             */
            FieldDescriptorProto.create = function create(properties) {
                return new FieldDescriptorProto(properties);
            };

            /**
             * Encodes the specified FieldDescriptorProto message. Does not implicitly {@link google.protobuf.FieldDescriptorProto.verify|verify} messages.
             * @function encode
             * @memberof google.protobuf.FieldDescriptorProto
             * @static
             * @param {google.protobuf.IFieldDescriptorProto} m FieldDescriptorProto message or plain object to encode
             * @param {$protobuf.Writer} [w] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            FieldDescriptorProto.encode = function encode(m, w) {
                if (!w)
                    w = $Writer.create();
                if (m.name != null && Object.hasOwnProperty.call(m, "name"))
                    w.uint32(10).string(m.name);
                if (m.extendee != null && Object.hasOwnProperty.call(m, "extendee"))
                    w.uint32(18).string(m.extendee);
                if (m.number != null && Object.hasOwnProperty.call(m, "number"))
                    w.uint32(24).int32(m.number);
                if (m.label != null && Object.hasOwnProperty.call(m, "label"))
                    w.uint32(32).int32(m.label);
                if (m.type != null && Object.hasOwnProperty.call(m, "type"))
                    w.uint32(40).int32(m.type);
                if (m.typeName != null && Object.hasOwnProperty.call(m, "typeName"))
                    w.uint32(50).string(m.typeName);
                if (m.defaultValue != null && Object.hasOwnProperty.call(m, "defaultValue"))
                    w.uint32(58).string(m.defaultValue);
                if (m.options != null && Object.hasOwnProperty.call(m, "options"))
                    $root.google.protobuf.FieldOptions.encode(m.options, w.uint32(66).fork()).ldelim();
                if (m.oneofIndex != null && Object.hasOwnProperty.call(m, "oneofIndex"))
                    w.uint32(72).int32(m.oneofIndex);
                if (m.jsonName != null && Object.hasOwnProperty.call(m, "jsonName"))
                    w.uint32(82).string(m.jsonName);
                return w;
            };

            /**
             * Decodes a FieldDescriptorProto message from the specified reader or buffer.
             * @function decode
             * @memberof google.protobuf.FieldDescriptorProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
             * @param {number} [l] Message length if known beforehand
             * @returns {google.protobuf.FieldDescriptorProto} FieldDescriptorProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            FieldDescriptorProto.decode = function decode(r, l) {
                if (!(r instanceof $Reader))
                    r = $Reader.create(r);
                var c = l === undefined ? r.len : r.pos + l, m = new $root.google.protobuf.FieldDescriptorProto();
                while (r.pos < c) {
                    var t = r.uint32();
                    switch (t >>> 3) {
                    case 1:
                        m.name = r.string();
                        break;
                    case 3:
                        m.number = r.int32();
                        break;
                    case 4:
                        m.label = r.int32();
                        break;
                    case 5:
                        m.type = r.int32();
                        break;
                    case 6:
                        m.typeName = r.string();
                        break;
                    case 2:
                        m.extendee = r.string();
                        break;
                    case 7:
                        m.defaultValue = r.string();
                        break;
                    case 9:
                        m.oneofIndex = r.int32();
                        break;
                    case 10:
                        m.jsonName = r.string();
                        break;
                    case 8:
                        m.options = $root.google.protobuf.FieldOptions.decode(r, r.uint32());
                        break;
                    default:
                        r.skipType(t & 7);
                        break;
                    }
                }
                return m;
            };

            /**
             * Type enum.
             * @name google.protobuf.FieldDescriptorProto.Type
             * @enum {number}
             * @property {number} TYPE_DOUBLE=1 TYPE_DOUBLE value
             * @property {number} TYPE_FLOAT=2 TYPE_FLOAT value
             * @property {number} TYPE_INT64=3 TYPE_INT64 value
             * @property {number} TYPE_UINT64=4 TYPE_UINT64 value
             * @property {number} TYPE_INT32=5 TYPE_INT32 value
             * @property {number} TYPE_FIXED64=6 TYPE_FIXED64 value
             * @property {number} TYPE_FIXED32=7 TYPE_FIXED32 value
             * @property {number} TYPE_BOOL=8 TYPE_BOOL value
             * @property {number} TYPE_STRING=9 TYPE_STRING value
             * @property {number} TYPE_GROUP=10 TYPE_GROUP value
             * @property {number} TYPE_MESSAGE=11 TYPE_MESSAGE value
             * @property {number} TYPE_BYTES=12 TYPE_BYTES value
             * @property {number} TYPE_UINT32=13 TYPE_UINT32 value
             * @property {number} TYPE_ENUM=14 TYPE_ENUM value
             * @property {number} TYPE_SFIXED32=15 TYPE_SFIXED32 value
             * @property {number} TYPE_SFIXED64=16 TYPE_SFIXED64 value
             * @property {number} TYPE_SINT32=17 TYPE_SINT32 value
             * @property {number} TYPE_SINT64=18 TYPE_SINT64 value
             */
            FieldDescriptorProto.Type = (function() {
                const valuesById = {}, values = Object.create(valuesById);
                values[valuesById[1] = "TYPE_DOUBLE"] = 1;
                values[valuesById[2] = "TYPE_FLOAT"] = 2;
                values[valuesById[3] = "TYPE_INT64"] = 3;
                values[valuesById[4] = "TYPE_UINT64"] = 4;
                values[valuesById[5] = "TYPE_INT32"] = 5;
                values[valuesById[6] = "TYPE_FIXED64"] = 6;
                values[valuesById[7] = "TYPE_FIXED32"] = 7;
                values[valuesById[8] = "TYPE_BOOL"] = 8;
                values[valuesById[9] = "TYPE_STRING"] = 9;
                values[valuesById[10] = "TYPE_GROUP"] = 10;
                values[valuesById[11] = "TYPE_MESSAGE"] = 11;
                values[valuesById[12] = "TYPE_BYTES"] = 12;
                values[valuesById[13] = "TYPE_UINT32"] = 13;
                values[valuesById[14] = "TYPE_ENUM"] = 14;
                values[valuesById[15] = "TYPE_SFIXED32"] = 15;
                values[valuesById[16] = "TYPE_SFIXED64"] = 16;
                values[valuesById[17] = "TYPE_SINT32"] = 17;
                values[valuesById[18] = "TYPE_SINT64"] = 18;
                return values;
            })();

            /**
             * Label enum.
             * @name google.protobuf.FieldDescriptorProto.Label
             * @enum {number}
             * @property {number} LABEL_OPTIONAL=1 LABEL_OPTIONAL value
             * @property {number} LABEL_REQUIRED=2 LABEL_REQUIRED value
             * @property {number} LABEL_REPEATED=3 LABEL_REPEATED value
             */
            FieldDescriptorProto.Label = (function() {
                const valuesById = {}, values = Object.create(valuesById);
                values[valuesById[1] = "LABEL_OPTIONAL"] = 1;
                values[valuesById[2] = "LABEL_REQUIRED"] = 2;
                values[valuesById[3] = "LABEL_REPEATED"] = 3;
                return values;
            })();

            return FieldDescriptorProto;
        })();

        protobuf.OneofDescriptorProto = (function() {

            /**
             * Properties of an OneofDescriptorProto.
             * @memberof google.protobuf
             * @interface IOneofDescriptorProto
             * @property {string|null} [name] OneofDescriptorProto name
             * @property {google.protobuf.IOneofOptions|null} [options] OneofDescriptorProto options
             */

            /**
             * Constructs a new OneofDescriptorProto.
             * @memberof google.protobuf
             * @classdesc Represents an OneofDescriptorProto.
             * @implements IOneofDescriptorProto
             * @constructor
             * @param {google.protobuf.IOneofDescriptorProto=} [p] Properties to set
             */
            function OneofDescriptorProto(p) {
                if (p)
                    for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                        if (p[ks[i]] != null)
                            this[ks[i]] = p[ks[i]];
            }

            /**
             * OneofDescriptorProto name.
             * @member {string} name
             * @memberof google.protobuf.OneofDescriptorProto
             * @instance
             */
            OneofDescriptorProto.prototype.name = "";

            /**
             * OneofDescriptorProto options.
             * @member {google.protobuf.IOneofOptions|null|undefined} options
             * @memberof google.protobuf.OneofDescriptorProto
             * @instance
             */
            OneofDescriptorProto.prototype.options = null;

            /**
             * Creates a new OneofDescriptorProto instance using the specified properties.
             * @function create
             * @memberof google.protobuf.OneofDescriptorProto
             * @static
             * @param {google.protobuf.IOneofDescriptorProto=} [properties] Properties to set
             * @returns {google.protobuf.OneofDescriptorProto} OneofDescriptorProto instance
             */
            OneofDescriptorProto.create = function create(properties) {
                return new OneofDescriptorProto(properties);
            };

            /**
             * Encodes the specified OneofDescriptorProto message. Does not implicitly {@link google.protobuf.OneofDescriptorProto.verify|verify} messages.
             * @function encode
             * @memberof google.protobuf.OneofDescriptorProto
             * @static
             * @param {google.protobuf.IOneofDescriptorProto} m OneofDescriptorProto message or plain object to encode
             * @param {$protobuf.Writer} [w] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            OneofDescriptorProto.encode = function encode(m, w) {
                if (!w)
                    w = $Writer.create();
                if (m.name != null && Object.hasOwnProperty.call(m, "name"))
                    w.uint32(10).string(m.name);
                if (m.options != null && Object.hasOwnProperty.call(m, "options"))
                    $root.google.protobuf.OneofOptions.encode(m.options, w.uint32(18).fork()).ldelim();
                return w;
            };

            /**
             * Decodes an OneofDescriptorProto message from the specified reader or buffer.
             * @function decode
             * @memberof google.protobuf.OneofDescriptorProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
             * @param {number} [l] Message length if known beforehand
             * @returns {google.protobuf.OneofDescriptorProto} OneofDescriptorProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            OneofDescriptorProto.decode = function decode(r, l) {
                if (!(r instanceof $Reader))
                    r = $Reader.create(r);
                var c = l === undefined ? r.len : r.pos + l, m = new $root.google.protobuf.OneofDescriptorProto();
                while (r.pos < c) {
                    var t = r.uint32();
                    switch (t >>> 3) {
                    case 1:
                        m.name = r.string();
                        break;
                    case 2:
                        m.options = $root.google.protobuf.OneofOptions.decode(r, r.uint32());
                        break;
                    default:
                        r.skipType(t & 7);
                        break;
                    }
                }
                return m;
            };

            return OneofDescriptorProto;
        })();

        protobuf.EnumDescriptorProto = (function() {

            /**
             * Properties of an EnumDescriptorProto.
             * @memberof google.protobuf
             * @interface IEnumDescriptorProto
             * @property {string|null} [name] EnumDescriptorProto name
             * @property {Array.<google.protobuf.IEnumValueDescriptorProto>|null} [value] EnumDescriptorProto value
             * @property {google.protobuf.IEnumOptions|null} [options] EnumDescriptorProto options
             */

            /**
             * Constructs a new EnumDescriptorProto.
             * @memberof google.protobuf
             * @classdesc Represents an EnumDescriptorProto.
             * @implements IEnumDescriptorProto
             * @constructor
             * @param {google.protobuf.IEnumDescriptorProto=} [p] Properties to set
             */
            function EnumDescriptorProto(p) {
                this.value = [];
                if (p)
                    for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                        if (p[ks[i]] != null)
                            this[ks[i]] = p[ks[i]];
            }

            /**
             * EnumDescriptorProto name.
             * @member {string} name
             * @memberof google.protobuf.EnumDescriptorProto
             * @instance
             */
            EnumDescriptorProto.prototype.name = "";

            /**
             * EnumDescriptorProto value.
             * @member {Array.<google.protobuf.IEnumValueDescriptorProto>} value
             * @memberof google.protobuf.EnumDescriptorProto
             * @instance
             */
            EnumDescriptorProto.prototype.value = $util.emptyArray;

            /**
             * EnumDescriptorProto options.
             * @member {google.protobuf.IEnumOptions|null|undefined} options
             * @memberof google.protobuf.EnumDescriptorProto
             * @instance
             */
            EnumDescriptorProto.prototype.options = null;

            /**
             * Creates a new EnumDescriptorProto instance using the specified properties.
             * @function create
             * @memberof google.protobuf.EnumDescriptorProto
             * @static
             * @param {google.protobuf.IEnumDescriptorProto=} [properties] Properties to set
             * @returns {google.protobuf.EnumDescriptorProto} EnumDescriptorProto instance
             */
            EnumDescriptorProto.create = function create(properties) {
                return new EnumDescriptorProto(properties);
            };

            /**
             * Encodes the specified EnumDescriptorProto message. Does not implicitly {@link google.protobuf.EnumDescriptorProto.verify|verify} messages.
             * @function encode
             * @memberof google.protobuf.EnumDescriptorProto
             * @static
             * @param {google.protobuf.IEnumDescriptorProto} m EnumDescriptorProto message or plain object to encode
             * @param {$protobuf.Writer} [w] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            EnumDescriptorProto.encode = function encode(m, w) {
                if (!w)
                    w = $Writer.create();
                if (m.name != null && Object.hasOwnProperty.call(m, "name"))
                    w.uint32(10).string(m.name);
                if (m.value != null && m.value.length) {
                    for (var i = 0; i < m.value.length; ++i)
                        $root.google.protobuf.EnumValueDescriptorProto.encode(m.value[i], w.uint32(18).fork()).ldelim();
                }
                if (m.options != null && Object.hasOwnProperty.call(m, "options"))
                    $root.google.protobuf.EnumOptions.encode(m.options, w.uint32(26).fork()).ldelim();
                return w;
            };

            /**
             * Decodes an EnumDescriptorProto message from the specified reader or buffer.
             * @function decode
             * @memberof google.protobuf.EnumDescriptorProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
             * @param {number} [l] Message length if known beforehand
             * @returns {google.protobuf.EnumDescriptorProto} EnumDescriptorProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            EnumDescriptorProto.decode = function decode(r, l) {
                if (!(r instanceof $Reader))
                    r = $Reader.create(r);
                var c = l === undefined ? r.len : r.pos + l, m = new $root.google.protobuf.EnumDescriptorProto();
                while (r.pos < c) {
                    var t = r.uint32();
                    switch (t >>> 3) {
                    case 1:
                        m.name = r.string();
                        break;
                    case 2:
                        if (!(m.value && m.value.length))
                            m.value = [];
                        m.value.push($root.google.protobuf.EnumValueDescriptorProto.decode(r, r.uint32()));
                        break;
                    case 3:
                        m.options = $root.google.protobuf.EnumOptions.decode(r, r.uint32());
                        break;
                    default:
                        r.skipType(t & 7);
                        break;
                    }
                }
                return m;
            };

            return EnumDescriptorProto;
        })();

        protobuf.EnumValueDescriptorProto = (function() {

            /**
             * Properties of an EnumValueDescriptorProto.
             * @memberof google.protobuf
             * @interface IEnumValueDescriptorProto
             * @property {string|null} [name] EnumValueDescriptorProto name
             * @property {number|null} [number] EnumValueDescriptorProto number
             * @property {google.protobuf.IEnumValueOptions|null} [options] EnumValueDescriptorProto options
             */

            /**
             * Constructs a new EnumValueDescriptorProto.
             * @memberof google.protobuf
             * @classdesc Represents an EnumValueDescriptorProto.
             * @implements IEnumValueDescriptorProto
             * @constructor
             * @param {google.protobuf.IEnumValueDescriptorProto=} [p] Properties to set
             */
            function EnumValueDescriptorProto(p) {
                if (p)
                    for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                        if (p[ks[i]] != null)
                            this[ks[i]] = p[ks[i]];
            }

            /**
             * EnumValueDescriptorProto name.
             * @member {string} name
             * @memberof google.protobuf.EnumValueDescriptorProto
             * @instance
             */
            EnumValueDescriptorProto.prototype.name = "";

            /**
             * EnumValueDescriptorProto number.
             * @member {number} number
             * @memberof google.protobuf.EnumValueDescriptorProto
             * @instance
             */
            EnumValueDescriptorProto.prototype.number = 0;

            /**
             * EnumValueDescriptorProto options.
             * @member {google.protobuf.IEnumValueOptions|null|undefined} options
             * @memberof google.protobuf.EnumValueDescriptorProto
             * @instance
             */
            EnumValueDescriptorProto.prototype.options = null;

            /**
             * Creates a new EnumValueDescriptorProto instance using the specified properties.
             * @function create
             * @memberof google.protobuf.EnumValueDescriptorProto
             * @static
             * @param {google.protobuf.IEnumValueDescriptorProto=} [properties] Properties to set
             * @returns {google.protobuf.EnumValueDescriptorProto} EnumValueDescriptorProto instance
             */
            EnumValueDescriptorProto.create = function create(properties) {
                return new EnumValueDescriptorProto(properties);
            };

            /**
             * Encodes the specified EnumValueDescriptorProto message. Does not implicitly {@link google.protobuf.EnumValueDescriptorProto.verify|verify} messages.
             * @function encode
             * @memberof google.protobuf.EnumValueDescriptorProto
             * @static
             * @param {google.protobuf.IEnumValueDescriptorProto} m EnumValueDescriptorProto message or plain object to encode
             * @param {$protobuf.Writer} [w] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            EnumValueDescriptorProto.encode = function encode(m, w) {
                if (!w)
                    w = $Writer.create();
                if (m.name != null && Object.hasOwnProperty.call(m, "name"))
                    w.uint32(10).string(m.name);
                if (m.number != null && Object.hasOwnProperty.call(m, "number"))
                    w.uint32(16).int32(m.number);
                if (m.options != null && Object.hasOwnProperty.call(m, "options"))
                    $root.google.protobuf.EnumValueOptions.encode(m.options, w.uint32(26).fork()).ldelim();
                return w;
            };

            /**
             * Decodes an EnumValueDescriptorProto message from the specified reader or buffer.
             * @function decode
             * @memberof google.protobuf.EnumValueDescriptorProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
             * @param {number} [l] Message length if known beforehand
             * @returns {google.protobuf.EnumValueDescriptorProto} EnumValueDescriptorProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            EnumValueDescriptorProto.decode = function decode(r, l) {
                if (!(r instanceof $Reader))
                    r = $Reader.create(r);
                var c = l === undefined ? r.len : r.pos + l, m = new $root.google.protobuf.EnumValueDescriptorProto();
                while (r.pos < c) {
                    var t = r.uint32();
                    switch (t >>> 3) {
                    case 1:
                        m.name = r.string();
                        break;
                    case 2:
                        m.number = r.int32();
                        break;
                    case 3:
                        m.options = $root.google.protobuf.EnumValueOptions.decode(r, r.uint32());
                        break;
                    default:
                        r.skipType(t & 7);
                        break;
                    }
                }
                return m;
            };

            return EnumValueDescriptorProto;
        })();

        protobuf.ServiceDescriptorProto = (function() {

            /**
             * Properties of a ServiceDescriptorProto.
             * @memberof google.protobuf
             * @interface IServiceDescriptorProto
             * @property {string|null} [name] ServiceDescriptorProto name
             * @property {Array.<google.protobuf.IMethodDescriptorProto>|null} [method] ServiceDescriptorProto method
             * @property {google.protobuf.IServiceOptions|null} [options] ServiceDescriptorProto options
             */

            /**
             * Constructs a new ServiceDescriptorProto.
             * @memberof google.protobuf
             * @classdesc Represents a ServiceDescriptorProto.
             * @implements IServiceDescriptorProto
             * @constructor
             * @param {google.protobuf.IServiceDescriptorProto=} [p] Properties to set
             */
            function ServiceDescriptorProto(p) {
                this.method = [];
                if (p)
                    for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                        if (p[ks[i]] != null)
                            this[ks[i]] = p[ks[i]];
            }

            /**
             * ServiceDescriptorProto name.
             * @member {string} name
             * @memberof google.protobuf.ServiceDescriptorProto
             * @instance
             */
            ServiceDescriptorProto.prototype.name = "";

            /**
             * ServiceDescriptorProto method.
             * @member {Array.<google.protobuf.IMethodDescriptorProto>} method
             * @memberof google.protobuf.ServiceDescriptorProto
             * @instance
             */
            ServiceDescriptorProto.prototype.method = $util.emptyArray;

            /**
             * ServiceDescriptorProto options.
             * @member {google.protobuf.IServiceOptions|null|undefined} options
             * @memberof google.protobuf.ServiceDescriptorProto
             * @instance
             */
            ServiceDescriptorProto.prototype.options = null;

            /**
             * Creates a new ServiceDescriptorProto instance using the specified properties.
             * @function create
             * @memberof google.protobuf.ServiceDescriptorProto
             * @static
             * @param {google.protobuf.IServiceDescriptorProto=} [properties] Properties to set
             * @returns {google.protobuf.ServiceDescriptorProto} ServiceDescriptorProto instance
             */
            ServiceDescriptorProto.create = function create(properties) {
                return new ServiceDescriptorProto(properties);
            };

            /**
             * Encodes the specified ServiceDescriptorProto message. Does not implicitly {@link google.protobuf.ServiceDescriptorProto.verify|verify} messages.
             * @function encode
             * @memberof google.protobuf.ServiceDescriptorProto
             * @static
             * @param {google.protobuf.IServiceDescriptorProto} m ServiceDescriptorProto message or plain object to encode
             * @param {$protobuf.Writer} [w] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ServiceDescriptorProto.encode = function encode(m, w) {
                if (!w)
                    w = $Writer.create();
                if (m.name != null && Object.hasOwnProperty.call(m, "name"))
                    w.uint32(10).string(m.name);
                if (m.method != null && m.method.length) {
                    for (var i = 0; i < m.method.length; ++i)
                        $root.google.protobuf.MethodDescriptorProto.encode(m.method[i], w.uint32(18).fork()).ldelim();
                }
                if (m.options != null && Object.hasOwnProperty.call(m, "options"))
                    $root.google.protobuf.ServiceOptions.encode(m.options, w.uint32(26).fork()).ldelim();
                return w;
            };

            /**
             * Decodes a ServiceDescriptorProto message from the specified reader or buffer.
             * @function decode
             * @memberof google.protobuf.ServiceDescriptorProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
             * @param {number} [l] Message length if known beforehand
             * @returns {google.protobuf.ServiceDescriptorProto} ServiceDescriptorProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ServiceDescriptorProto.decode = function decode(r, l) {
                if (!(r instanceof $Reader))
                    r = $Reader.create(r);
                var c = l === undefined ? r.len : r.pos + l, m = new $root.google.protobuf.ServiceDescriptorProto();
                while (r.pos < c) {
                    var t = r.uint32();
                    switch (t >>> 3) {
                    case 1:
                        m.name = r.string();
                        break;
                    case 2:
                        if (!(m.method && m.method.length))
                            m.method = [];
                        m.method.push($root.google.protobuf.MethodDescriptorProto.decode(r, r.uint32()));
                        break;
                    case 3:
                        m.options = $root.google.protobuf.ServiceOptions.decode(r, r.uint32());
                        break;
                    default:
                        r.skipType(t & 7);
                        break;
                    }
                }
                return m;
            };

            return ServiceDescriptorProto;
        })();

        protobuf.MethodDescriptorProto = (function() {

            /**
             * Properties of a MethodDescriptorProto.
             * @memberof google.protobuf
             * @interface IMethodDescriptorProto
             * @property {string|null} [name] MethodDescriptorProto name
             * @property {string|null} [inputType] MethodDescriptorProto inputType
             * @property {string|null} [outputType] MethodDescriptorProto outputType
             * @property {google.protobuf.IMethodOptions|null} [options] MethodDescriptorProto options
             * @property {boolean|null} [clientStreaming] MethodDescriptorProto clientStreaming
             * @property {boolean|null} [serverStreaming] MethodDescriptorProto serverStreaming
             */

            /**
             * Constructs a new MethodDescriptorProto.
             * @memberof google.protobuf
             * @classdesc Represents a MethodDescriptorProto.
             * @implements IMethodDescriptorProto
             * @constructor
             * @param {google.protobuf.IMethodDescriptorProto=} [p] Properties to set
             */
            function MethodDescriptorProto(p) {
                if (p)
                    for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                        if (p[ks[i]] != null)
                            this[ks[i]] = p[ks[i]];
            }

            /**
             * MethodDescriptorProto name.
             * @member {string} name
             * @memberof google.protobuf.MethodDescriptorProto
             * @instance
             */
            MethodDescriptorProto.prototype.name = "";

            /**
             * MethodDescriptorProto inputType.
             * @member {string} inputType
             * @memberof google.protobuf.MethodDescriptorProto
             * @instance
             */
            MethodDescriptorProto.prototype.inputType = "";

            /**
             * MethodDescriptorProto outputType.
             * @member {string} outputType
             * @memberof google.protobuf.MethodDescriptorProto
             * @instance
             */
            MethodDescriptorProto.prototype.outputType = "";

            /**
             * MethodDescriptorProto options.
             * @member {google.protobuf.IMethodOptions|null|undefined} options
             * @memberof google.protobuf.MethodDescriptorProto
             * @instance
             */
            MethodDescriptorProto.prototype.options = null;

            /**
             * MethodDescriptorProto clientStreaming.
             * @member {boolean} clientStreaming
             * @memberof google.protobuf.MethodDescriptorProto
             * @instance
             */
            MethodDescriptorProto.prototype.clientStreaming = false;

            /**
             * MethodDescriptorProto serverStreaming.
             * @member {boolean} serverStreaming
             * @memberof google.protobuf.MethodDescriptorProto
             * @instance
             */
            MethodDescriptorProto.prototype.serverStreaming = false;

            /**
             * Creates a new MethodDescriptorProto instance using the specified properties.
             * @function create
             * @memberof google.protobuf.MethodDescriptorProto
             * @static
             * @param {google.protobuf.IMethodDescriptorProto=} [properties] Properties to set
             * @returns {google.protobuf.MethodDescriptorProto} MethodDescriptorProto instance
             */
            MethodDescriptorProto.create = function create(properties) {
                return new MethodDescriptorProto(properties);
            };

            /**
             * Encodes the specified MethodDescriptorProto message. Does not implicitly {@link google.protobuf.MethodDescriptorProto.verify|verify} messages.
             * @function encode
             * @memberof google.protobuf.MethodDescriptorProto
             * @static
             * @param {google.protobuf.IMethodDescriptorProto} m MethodDescriptorProto message or plain object to encode
             * @param {$protobuf.Writer} [w] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            MethodDescriptorProto.encode = function encode(m, w) {
                if (!w)
                    w = $Writer.create();
                if (m.name != null && Object.hasOwnProperty.call(m, "name"))
                    w.uint32(10).string(m.name);
                if (m.inputType != null && Object.hasOwnProperty.call(m, "inputType"))
                    w.uint32(18).string(m.inputType);
                if (m.outputType != null && Object.hasOwnProperty.call(m, "outputType"))
                    w.uint32(26).string(m.outputType);
                if (m.options != null && Object.hasOwnProperty.call(m, "options"))
                    $root.google.protobuf.MethodOptions.encode(m.options, w.uint32(34).fork()).ldelim();
                if (m.clientStreaming != null && Object.hasOwnProperty.call(m, "clientStreaming"))
                    w.uint32(40).bool(m.clientStreaming);
                if (m.serverStreaming != null && Object.hasOwnProperty.call(m, "serverStreaming"))
                    w.uint32(48).bool(m.serverStreaming);
                return w;
            };

            /**
             * Decodes a MethodDescriptorProto message from the specified reader or buffer.
             * @function decode
             * @memberof google.protobuf.MethodDescriptorProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
             * @param {number} [l] Message length if known beforehand
             * @returns {google.protobuf.MethodDescriptorProto} MethodDescriptorProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            MethodDescriptorProto.decode = function decode(r, l) {
                if (!(r instanceof $Reader))
                    r = $Reader.create(r);
                var c = l === undefined ? r.len : r.pos + l, m = new $root.google.protobuf.MethodDescriptorProto();
                while (r.pos < c) {
                    var t = r.uint32();
                    switch (t >>> 3) {
                    case 1:
                        m.name = r.string();
                        break;
                    case 2:
                        m.inputType = r.string();
                        break;
                    case 3:
                        m.outputType = r.string();
                        break;
                    case 4:
                        m.options = $root.google.protobuf.MethodOptions.decode(r, r.uint32());
                        break;
                    case 5:
                        m.clientStreaming = r.bool();
                        break;
                    case 6:
                        m.serverStreaming = r.bool();
                        break;
                    default:
                        r.skipType(t & 7);
                        break;
                    }
                }
                return m;
            };

            return MethodDescriptorProto;
        })();

        protobuf.FileOptions = (function() {

            /**
             * Properties of a FileOptions.
             * @memberof google.protobuf
             * @interface IFileOptions
             * @property {string|null} [javaPackage] FileOptions javaPackage
             * @property {string|null} [javaOuterClassname] FileOptions javaOuterClassname
             * @property {boolean|null} [javaMultipleFiles] FileOptions javaMultipleFiles
             * @property {boolean|null} [javaGenerateEqualsAndHash] FileOptions javaGenerateEqualsAndHash
             * @property {boolean|null} [javaStringCheckUtf8] FileOptions javaStringCheckUtf8
             * @property {google.protobuf.FileOptions.OptimizeMode|null} [optimizeFor] FileOptions optimizeFor
             * @property {string|null} [goPackage] FileOptions goPackage
             * @property {boolean|null} [ccGenericServices] FileOptions ccGenericServices
             * @property {boolean|null} [javaGenericServices] FileOptions javaGenericServices
             * @property {boolean|null} [pyGenericServices] FileOptions pyGenericServices
             * @property {boolean|null} [deprecated] FileOptions deprecated
             * @property {boolean|null} [ccEnableArenas] FileOptions ccEnableArenas
             * @property {string|null} [objcClassPrefix] FileOptions objcClassPrefix
             * @property {string|null} [csharpNamespace] FileOptions csharpNamespace
             * @property {Array.<google.protobuf.IUninterpretedOption>|null} [uninterpretedOption] FileOptions uninterpretedOption
             * @property {string|null} [".common.serviceCalls"] FileOptions .common.serviceCalls
             */

            /**
             * Constructs a new FileOptions.
             * @memberof google.protobuf
             * @classdesc Represents a FileOptions.
             * @implements IFileOptions
             * @constructor
             * @param {google.protobuf.IFileOptions=} [p] Properties to set
             */
            function FileOptions(p) {
                this.uninterpretedOption = [];
                if (p)
                    for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                        if (p[ks[i]] != null)
                            this[ks[i]] = p[ks[i]];
            }

            /**
             * FileOptions javaPackage.
             * @member {string} javaPackage
             * @memberof google.protobuf.FileOptions
             * @instance
             */
            FileOptions.prototype.javaPackage = "";

            /**
             * FileOptions javaOuterClassname.
             * @member {string} javaOuterClassname
             * @memberof google.protobuf.FileOptions
             * @instance
             */
            FileOptions.prototype.javaOuterClassname = "";

            /**
             * FileOptions javaMultipleFiles.
             * @member {boolean} javaMultipleFiles
             * @memberof google.protobuf.FileOptions
             * @instance
             */
            FileOptions.prototype.javaMultipleFiles = false;

            /**
             * FileOptions javaGenerateEqualsAndHash.
             * @member {boolean} javaGenerateEqualsAndHash
             * @memberof google.protobuf.FileOptions
             * @instance
             */
            FileOptions.prototype.javaGenerateEqualsAndHash = false;

            /**
             * FileOptions javaStringCheckUtf8.
             * @member {boolean} javaStringCheckUtf8
             * @memberof google.protobuf.FileOptions
             * @instance
             */
            FileOptions.prototype.javaStringCheckUtf8 = false;

            /**
             * FileOptions optimizeFor.
             * @member {google.protobuf.FileOptions.OptimizeMode} optimizeFor
             * @memberof google.protobuf.FileOptions
             * @instance
             */
            FileOptions.prototype.optimizeFor = 1;

            /**
             * FileOptions goPackage.
             * @member {string} goPackage
             * @memberof google.protobuf.FileOptions
             * @instance
             */
            FileOptions.prototype.goPackage = "";

            /**
             * FileOptions ccGenericServices.
             * @member {boolean} ccGenericServices
             * @memberof google.protobuf.FileOptions
             * @instance
             */
            FileOptions.prototype.ccGenericServices = false;

            /**
             * FileOptions javaGenericServices.
             * @member {boolean} javaGenericServices
             * @memberof google.protobuf.FileOptions
             * @instance
             */
            FileOptions.prototype.javaGenericServices = false;

            /**
             * FileOptions pyGenericServices.
             * @member {boolean} pyGenericServices
             * @memberof google.protobuf.FileOptions
             * @instance
             */
            FileOptions.prototype.pyGenericServices = false;

            /**
             * FileOptions deprecated.
             * @member {boolean} deprecated
             * @memberof google.protobuf.FileOptions
             * @instance
             */
            FileOptions.prototype.deprecated = false;

            /**
             * FileOptions ccEnableArenas.
             * @member {boolean} ccEnableArenas
             * @memberof google.protobuf.FileOptions
             * @instance
             */
            FileOptions.prototype.ccEnableArenas = false;

            /**
             * FileOptions objcClassPrefix.
             * @member {string} objcClassPrefix
             * @memberof google.protobuf.FileOptions
             * @instance
             */
            FileOptions.prototype.objcClassPrefix = "";

            /**
             * FileOptions csharpNamespace.
             * @member {string} csharpNamespace
             * @memberof google.protobuf.FileOptions
             * @instance
             */
            FileOptions.prototype.csharpNamespace = "";

            /**
             * FileOptions uninterpretedOption.
             * @member {Array.<google.protobuf.IUninterpretedOption>} uninterpretedOption
             * @memberof google.protobuf.FileOptions
             * @instance
             */
            FileOptions.prototype.uninterpretedOption = $util.emptyArray;

            /**
             * FileOptions .common.serviceCalls.
             * @member {string} .common.serviceCalls
             * @memberof google.protobuf.FileOptions
             * @instance
             */
            FileOptions.prototype[".common.serviceCalls"] = "";

            /**
             * Creates a new FileOptions instance using the specified properties.
             * @function create
             * @memberof google.protobuf.FileOptions
             * @static
             * @param {google.protobuf.IFileOptions=} [properties] Properties to set
             * @returns {google.protobuf.FileOptions} FileOptions instance
             */
            FileOptions.create = function create(properties) {
                return new FileOptions(properties);
            };

            /**
             * Encodes the specified FileOptions message. Does not implicitly {@link google.protobuf.FileOptions.verify|verify} messages.
             * @function encode
             * @memberof google.protobuf.FileOptions
             * @static
             * @param {google.protobuf.IFileOptions} m FileOptions message or plain object to encode
             * @param {$protobuf.Writer} [w] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            FileOptions.encode = function encode(m, w) {
                if (!w)
                    w = $Writer.create();
                if (m.javaPackage != null && Object.hasOwnProperty.call(m, "javaPackage"))
                    w.uint32(10).string(m.javaPackage);
                if (m.javaOuterClassname != null && Object.hasOwnProperty.call(m, "javaOuterClassname"))
                    w.uint32(66).string(m.javaOuterClassname);
                if (m.optimizeFor != null && Object.hasOwnProperty.call(m, "optimizeFor"))
                    w.uint32(72).int32(m.optimizeFor);
                if (m.javaMultipleFiles != null && Object.hasOwnProperty.call(m, "javaMultipleFiles"))
                    w.uint32(80).bool(m.javaMultipleFiles);
                if (m.goPackage != null && Object.hasOwnProperty.call(m, "goPackage"))
                    w.uint32(90).string(m.goPackage);
                if (m.ccGenericServices != null && Object.hasOwnProperty.call(m, "ccGenericServices"))
                    w.uint32(128).bool(m.ccGenericServices);
                if (m.javaGenericServices != null && Object.hasOwnProperty.call(m, "javaGenericServices"))
                    w.uint32(136).bool(m.javaGenericServices);
                if (m.pyGenericServices != null && Object.hasOwnProperty.call(m, "pyGenericServices"))
                    w.uint32(144).bool(m.pyGenericServices);
                if (m.javaGenerateEqualsAndHash != null && Object.hasOwnProperty.call(m, "javaGenerateEqualsAndHash"))
                    w.uint32(160).bool(m.javaGenerateEqualsAndHash);
                if (m.deprecated != null && Object.hasOwnProperty.call(m, "deprecated"))
                    w.uint32(184).bool(m.deprecated);
                if (m.javaStringCheckUtf8 != null && Object.hasOwnProperty.call(m, "javaStringCheckUtf8"))
                    w.uint32(216).bool(m.javaStringCheckUtf8);
                if (m.ccEnableArenas != null && Object.hasOwnProperty.call(m, "ccEnableArenas"))
                    w.uint32(248).bool(m.ccEnableArenas);
                if (m.objcClassPrefix != null && Object.hasOwnProperty.call(m, "objcClassPrefix"))
                    w.uint32(290).string(m.objcClassPrefix);
                if (m.csharpNamespace != null && Object.hasOwnProperty.call(m, "csharpNamespace"))
                    w.uint32(298).string(m.csharpNamespace);
                if (m.uninterpretedOption != null && m.uninterpretedOption.length) {
                    for (var i = 0; i < m.uninterpretedOption.length; ++i)
                        $root.google.protobuf.UninterpretedOption.encode(m.uninterpretedOption[i], w.uint32(7994).fork()).ldelim();
                }
                if (m[".common.serviceCalls"] != null && Object.hasOwnProperty.call(m, ".common.serviceCalls"))
                    w.uint32(400034).string(m[".common.serviceCalls"]);
                return w;
            };

            /**
             * Decodes a FileOptions message from the specified reader or buffer.
             * @function decode
             * @memberof google.protobuf.FileOptions
             * @static
             * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
             * @param {number} [l] Message length if known beforehand
             * @returns {google.protobuf.FileOptions} FileOptions
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            FileOptions.decode = function decode(r, l) {
                if (!(r instanceof $Reader))
                    r = $Reader.create(r);
                var c = l === undefined ? r.len : r.pos + l, m = new $root.google.protobuf.FileOptions();
                while (r.pos < c) {
                    var t = r.uint32();
                    switch (t >>> 3) {
                    case 1:
                        m.javaPackage = r.string();
                        break;
                    case 8:
                        m.javaOuterClassname = r.string();
                        break;
                    case 10:
                        m.javaMultipleFiles = r.bool();
                        break;
                    case 20:
                        m.javaGenerateEqualsAndHash = r.bool();
                        break;
                    case 27:
                        m.javaStringCheckUtf8 = r.bool();
                        break;
                    case 9:
                        m.optimizeFor = r.int32();
                        break;
                    case 11:
                        m.goPackage = r.string();
                        break;
                    case 16:
                        m.ccGenericServices = r.bool();
                        break;
                    case 17:
                        m.javaGenericServices = r.bool();
                        break;
                    case 18:
                        m.pyGenericServices = r.bool();
                        break;
                    case 23:
                        m.deprecated = r.bool();
                        break;
                    case 31:
                        m.ccEnableArenas = r.bool();
                        break;
                    case 36:
                        m.objcClassPrefix = r.string();
                        break;
                    case 37:
                        m.csharpNamespace = r.string();
                        break;
                    case 999:
                        if (!(m.uninterpretedOption && m.uninterpretedOption.length))
                            m.uninterpretedOption = [];
                        m.uninterpretedOption.push($root.google.protobuf.UninterpretedOption.decode(r, r.uint32()));
                        break;
                    case 50004:
                        m[".common.serviceCalls"] = r.string();
                        break;
                    default:
                        r.skipType(t & 7);
                        break;
                    }
                }
                return m;
            };

            /**
             * OptimizeMode enum.
             * @name google.protobuf.FileOptions.OptimizeMode
             * @enum {number}
             * @property {number} SPEED=1 SPEED value
             * @property {number} CODE_SIZE=2 CODE_SIZE value
             * @property {number} LITE_RUNTIME=3 LITE_RUNTIME value
             */
            FileOptions.OptimizeMode = (function() {
                const valuesById = {}, values = Object.create(valuesById);
                values[valuesById[1] = "SPEED"] = 1;
                values[valuesById[2] = "CODE_SIZE"] = 2;
                values[valuesById[3] = "LITE_RUNTIME"] = 3;
                return values;
            })();

            return FileOptions;
        })();

        protobuf.MessageOptions = (function() {

            /**
             * Properties of a MessageOptions.
             * @memberof google.protobuf
             * @interface IMessageOptions
             * @property {boolean|null} [messageSetWireFormat] MessageOptions messageSetWireFormat
             * @property {boolean|null} [noStandardDescriptorAccessor] MessageOptions noStandardDescriptorAccessor
             * @property {boolean|null} [deprecated] MessageOptions deprecated
             * @property {boolean|null} [mapEntry] MessageOptions mapEntry
             * @property {Array.<google.protobuf.IUninterpretedOption>|null} [uninterpretedOption] MessageOptions uninterpretedOption
             */

            /**
             * Constructs a new MessageOptions.
             * @memberof google.protobuf
             * @classdesc Represents a MessageOptions.
             * @implements IMessageOptions
             * @constructor
             * @param {google.protobuf.IMessageOptions=} [p] Properties to set
             */
            function MessageOptions(p) {
                this.uninterpretedOption = [];
                if (p)
                    for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                        if (p[ks[i]] != null)
                            this[ks[i]] = p[ks[i]];
            }

            /**
             * MessageOptions messageSetWireFormat.
             * @member {boolean} messageSetWireFormat
             * @memberof google.protobuf.MessageOptions
             * @instance
             */
            MessageOptions.prototype.messageSetWireFormat = false;

            /**
             * MessageOptions noStandardDescriptorAccessor.
             * @member {boolean} noStandardDescriptorAccessor
             * @memberof google.protobuf.MessageOptions
             * @instance
             */
            MessageOptions.prototype.noStandardDescriptorAccessor = false;

            /**
             * MessageOptions deprecated.
             * @member {boolean} deprecated
             * @memberof google.protobuf.MessageOptions
             * @instance
             */
            MessageOptions.prototype.deprecated = false;

            /**
             * MessageOptions mapEntry.
             * @member {boolean} mapEntry
             * @memberof google.protobuf.MessageOptions
             * @instance
             */
            MessageOptions.prototype.mapEntry = false;

            /**
             * MessageOptions uninterpretedOption.
             * @member {Array.<google.protobuf.IUninterpretedOption>} uninterpretedOption
             * @memberof google.protobuf.MessageOptions
             * @instance
             */
            MessageOptions.prototype.uninterpretedOption = $util.emptyArray;

            /**
             * Creates a new MessageOptions instance using the specified properties.
             * @function create
             * @memberof google.protobuf.MessageOptions
             * @static
             * @param {google.protobuf.IMessageOptions=} [properties] Properties to set
             * @returns {google.protobuf.MessageOptions} MessageOptions instance
             */
            MessageOptions.create = function create(properties) {
                return new MessageOptions(properties);
            };

            /**
             * Encodes the specified MessageOptions message. Does not implicitly {@link google.protobuf.MessageOptions.verify|verify} messages.
             * @function encode
             * @memberof google.protobuf.MessageOptions
             * @static
             * @param {google.protobuf.IMessageOptions} m MessageOptions message or plain object to encode
             * @param {$protobuf.Writer} [w] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            MessageOptions.encode = function encode(m, w) {
                if (!w)
                    w = $Writer.create();
                if (m.messageSetWireFormat != null && Object.hasOwnProperty.call(m, "messageSetWireFormat"))
                    w.uint32(8).bool(m.messageSetWireFormat);
                if (m.noStandardDescriptorAccessor != null && Object.hasOwnProperty.call(m, "noStandardDescriptorAccessor"))
                    w.uint32(16).bool(m.noStandardDescriptorAccessor);
                if (m.deprecated != null && Object.hasOwnProperty.call(m, "deprecated"))
                    w.uint32(24).bool(m.deprecated);
                if (m.mapEntry != null && Object.hasOwnProperty.call(m, "mapEntry"))
                    w.uint32(56).bool(m.mapEntry);
                if (m.uninterpretedOption != null && m.uninterpretedOption.length) {
                    for (var i = 0; i < m.uninterpretedOption.length; ++i)
                        $root.google.protobuf.UninterpretedOption.encode(m.uninterpretedOption[i], w.uint32(7994).fork()).ldelim();
                }
                return w;
            };

            /**
             * Decodes a MessageOptions message from the specified reader or buffer.
             * @function decode
             * @memberof google.protobuf.MessageOptions
             * @static
             * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
             * @param {number} [l] Message length if known beforehand
             * @returns {google.protobuf.MessageOptions} MessageOptions
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            MessageOptions.decode = function decode(r, l) {
                if (!(r instanceof $Reader))
                    r = $Reader.create(r);
                var c = l === undefined ? r.len : r.pos + l, m = new $root.google.protobuf.MessageOptions();
                while (r.pos < c) {
                    var t = r.uint32();
                    switch (t >>> 3) {
                    case 1:
                        m.messageSetWireFormat = r.bool();
                        break;
                    case 2:
                        m.noStandardDescriptorAccessor = r.bool();
                        break;
                    case 3:
                        m.deprecated = r.bool();
                        break;
                    case 7:
                        m.mapEntry = r.bool();
                        break;
                    case 999:
                        if (!(m.uninterpretedOption && m.uninterpretedOption.length))
                            m.uninterpretedOption = [];
                        m.uninterpretedOption.push($root.google.protobuf.UninterpretedOption.decode(r, r.uint32()));
                        break;
                    default:
                        r.skipType(t & 7);
                        break;
                    }
                }
                return m;
            };

            return MessageOptions;
        })();

        protobuf.FieldOptions = (function() {

            /**
             * Properties of a FieldOptions.
             * @memberof google.protobuf
             * @interface IFieldOptions
             * @property {google.protobuf.FieldOptions.CType|null} [ctype] FieldOptions ctype
             * @property {boolean|null} [packed] FieldOptions packed
             * @property {google.protobuf.FieldOptions.JSType|null} [jstype] FieldOptions jstype
             * @property {boolean|null} [lazy] FieldOptions lazy
             * @property {boolean|null} [deprecated] FieldOptions deprecated
             * @property {boolean|null} [weak] FieldOptions weak
             * @property {Array.<google.protobuf.IUninterpretedOption>|null} [uninterpretedOption] FieldOptions uninterpretedOption
             * @property {boolean|null} [".common.doNotLog"] FieldOptions .common.doNotLog
             * @property {boolean|null} [".common.internal"] FieldOptions .common.internal
             */

            /**
             * Constructs a new FieldOptions.
             * @memberof google.protobuf
             * @classdesc Represents a FieldOptions.
             * @implements IFieldOptions
             * @constructor
             * @param {google.protobuf.IFieldOptions=} [p] Properties to set
             */
            function FieldOptions(p) {
                this.uninterpretedOption = [];
                if (p)
                    for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                        if (p[ks[i]] != null)
                            this[ks[i]] = p[ks[i]];
            }

            /**
             * FieldOptions ctype.
             * @member {google.protobuf.FieldOptions.CType} ctype
             * @memberof google.protobuf.FieldOptions
             * @instance
             */
            FieldOptions.prototype.ctype = 0;

            /**
             * FieldOptions packed.
             * @member {boolean} packed
             * @memberof google.protobuf.FieldOptions
             * @instance
             */
            FieldOptions.prototype.packed = false;

            /**
             * FieldOptions jstype.
             * @member {google.protobuf.FieldOptions.JSType} jstype
             * @memberof google.protobuf.FieldOptions
             * @instance
             */
            FieldOptions.prototype.jstype = 0;

            /**
             * FieldOptions lazy.
             * @member {boolean} lazy
             * @memberof google.protobuf.FieldOptions
             * @instance
             */
            FieldOptions.prototype.lazy = false;

            /**
             * FieldOptions deprecated.
             * @member {boolean} deprecated
             * @memberof google.protobuf.FieldOptions
             * @instance
             */
            FieldOptions.prototype.deprecated = false;

            /**
             * FieldOptions weak.
             * @member {boolean} weak
             * @memberof google.protobuf.FieldOptions
             * @instance
             */
            FieldOptions.prototype.weak = false;

            /**
             * FieldOptions uninterpretedOption.
             * @member {Array.<google.protobuf.IUninterpretedOption>} uninterpretedOption
             * @memberof google.protobuf.FieldOptions
             * @instance
             */
            FieldOptions.prototype.uninterpretedOption = $util.emptyArray;

            /**
             * FieldOptions .common.doNotLog.
             * @member {boolean} .common.doNotLog
             * @memberof google.protobuf.FieldOptions
             * @instance
             */
            FieldOptions.prototype[".common.doNotLog"] = false;

            /**
             * FieldOptions .common.internal.
             * @member {boolean} .common.internal
             * @memberof google.protobuf.FieldOptions
             * @instance
             */
            FieldOptions.prototype[".common.internal"] = false;

            /**
             * Creates a new FieldOptions instance using the specified properties.
             * @function create
             * @memberof google.protobuf.FieldOptions
             * @static
             * @param {google.protobuf.IFieldOptions=} [properties] Properties to set
             * @returns {google.protobuf.FieldOptions} FieldOptions instance
             */
            FieldOptions.create = function create(properties) {
                return new FieldOptions(properties);
            };

            /**
             * Encodes the specified FieldOptions message. Does not implicitly {@link google.protobuf.FieldOptions.verify|verify} messages.
             * @function encode
             * @memberof google.protobuf.FieldOptions
             * @static
             * @param {google.protobuf.IFieldOptions} m FieldOptions message or plain object to encode
             * @param {$protobuf.Writer} [w] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            FieldOptions.encode = function encode(m, w) {
                if (!w)
                    w = $Writer.create();
                if (m.ctype != null && Object.hasOwnProperty.call(m, "ctype"))
                    w.uint32(8).int32(m.ctype);
                if (m.packed != null && Object.hasOwnProperty.call(m, "packed"))
                    w.uint32(16).bool(m.packed);
                if (m.deprecated != null && Object.hasOwnProperty.call(m, "deprecated"))
                    w.uint32(24).bool(m.deprecated);
                if (m.lazy != null && Object.hasOwnProperty.call(m, "lazy"))
                    w.uint32(40).bool(m.lazy);
                if (m.jstype != null && Object.hasOwnProperty.call(m, "jstype"))
                    w.uint32(48).int32(m.jstype);
                if (m.weak != null && Object.hasOwnProperty.call(m, "weak"))
                    w.uint32(80).bool(m.weak);
                if (m.uninterpretedOption != null && m.uninterpretedOption.length) {
                    for (var i = 0; i < m.uninterpretedOption.length; ++i)
                        $root.google.protobuf.UninterpretedOption.encode(m.uninterpretedOption[i], w.uint32(7994).fork()).ldelim();
                }
                if (m[".common.doNotLog"] != null && Object.hasOwnProperty.call(m, ".common.doNotLog"))
                    w.uint32(400800).bool(m[".common.doNotLog"]);
                if (m[".common.internal"] != null && Object.hasOwnProperty.call(m, ".common.internal"))
                    w.uint32(401600).bool(m[".common.internal"]);
                return w;
            };

            /**
             * Decodes a FieldOptions message from the specified reader or buffer.
             * @function decode
             * @memberof google.protobuf.FieldOptions
             * @static
             * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
             * @param {number} [l] Message length if known beforehand
             * @returns {google.protobuf.FieldOptions} FieldOptions
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            FieldOptions.decode = function decode(r, l) {
                if (!(r instanceof $Reader))
                    r = $Reader.create(r);
                var c = l === undefined ? r.len : r.pos + l, m = new $root.google.protobuf.FieldOptions();
                while (r.pos < c) {
                    var t = r.uint32();
                    switch (t >>> 3) {
                    case 1:
                        m.ctype = r.int32();
                        break;
                    case 2:
                        m.packed = r.bool();
                        break;
                    case 6:
                        m.jstype = r.int32();
                        break;
                    case 5:
                        m.lazy = r.bool();
                        break;
                    case 3:
                        m.deprecated = r.bool();
                        break;
                    case 10:
                        m.weak = r.bool();
                        break;
                    case 999:
                        if (!(m.uninterpretedOption && m.uninterpretedOption.length))
                            m.uninterpretedOption = [];
                        m.uninterpretedOption.push($root.google.protobuf.UninterpretedOption.decode(r, r.uint32()));
                        break;
                    case 50100:
                        m[".common.doNotLog"] = r.bool();
                        break;
                    case 50200:
                        m[".common.internal"] = r.bool();
                        break;
                    default:
                        r.skipType(t & 7);
                        break;
                    }
                }
                return m;
            };

            /**
             * CType enum.
             * @name google.protobuf.FieldOptions.CType
             * @enum {number}
             * @property {number} STRING=0 STRING value
             * @property {number} CORD=1 CORD value
             * @property {number} STRING_PIECE=2 STRING_PIECE value
             */
            FieldOptions.CType = (function() {
                const valuesById = {}, values = Object.create(valuesById);
                values[valuesById[0] = "STRING"] = 0;
                values[valuesById[1] = "CORD"] = 1;
                values[valuesById[2] = "STRING_PIECE"] = 2;
                return values;
            })();

            /**
             * JSType enum.
             * @name google.protobuf.FieldOptions.JSType
             * @enum {number}
             * @property {number} JS_NORMAL=0 JS_NORMAL value
             * @property {number} JS_STRING=1 JS_STRING value
             * @property {number} JS_NUMBER=2 JS_NUMBER value
             */
            FieldOptions.JSType = (function() {
                const valuesById = {}, values = Object.create(valuesById);
                values[valuesById[0] = "JS_NORMAL"] = 0;
                values[valuesById[1] = "JS_STRING"] = 1;
                values[valuesById[2] = "JS_NUMBER"] = 2;
                return values;
            })();

            return FieldOptions;
        })();

        protobuf.OneofOptions = (function() {

            /**
             * Properties of an OneofOptions.
             * @memberof google.protobuf
             * @interface IOneofOptions
             * @property {Array.<google.protobuf.IUninterpretedOption>|null} [uninterpretedOption] OneofOptions uninterpretedOption
             */

            /**
             * Constructs a new OneofOptions.
             * @memberof google.protobuf
             * @classdesc Represents an OneofOptions.
             * @implements IOneofOptions
             * @constructor
             * @param {google.protobuf.IOneofOptions=} [p] Properties to set
             */
            function OneofOptions(p) {
                this.uninterpretedOption = [];
                if (p)
                    for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                        if (p[ks[i]] != null)
                            this[ks[i]] = p[ks[i]];
            }

            /**
             * OneofOptions uninterpretedOption.
             * @member {Array.<google.protobuf.IUninterpretedOption>} uninterpretedOption
             * @memberof google.protobuf.OneofOptions
             * @instance
             */
            OneofOptions.prototype.uninterpretedOption = $util.emptyArray;

            /**
             * Creates a new OneofOptions instance using the specified properties.
             * @function create
             * @memberof google.protobuf.OneofOptions
             * @static
             * @param {google.protobuf.IOneofOptions=} [properties] Properties to set
             * @returns {google.protobuf.OneofOptions} OneofOptions instance
             */
            OneofOptions.create = function create(properties) {
                return new OneofOptions(properties);
            };

            /**
             * Encodes the specified OneofOptions message. Does not implicitly {@link google.protobuf.OneofOptions.verify|verify} messages.
             * @function encode
             * @memberof google.protobuf.OneofOptions
             * @static
             * @param {google.protobuf.IOneofOptions} m OneofOptions message or plain object to encode
             * @param {$protobuf.Writer} [w] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            OneofOptions.encode = function encode(m, w) {
                if (!w)
                    w = $Writer.create();
                if (m.uninterpretedOption != null && m.uninterpretedOption.length) {
                    for (var i = 0; i < m.uninterpretedOption.length; ++i)
                        $root.google.protobuf.UninterpretedOption.encode(m.uninterpretedOption[i], w.uint32(7994).fork()).ldelim();
                }
                return w;
            };

            /**
             * Decodes an OneofOptions message from the specified reader or buffer.
             * @function decode
             * @memberof google.protobuf.OneofOptions
             * @static
             * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
             * @param {number} [l] Message length if known beforehand
             * @returns {google.protobuf.OneofOptions} OneofOptions
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            OneofOptions.decode = function decode(r, l) {
                if (!(r instanceof $Reader))
                    r = $Reader.create(r);
                var c = l === undefined ? r.len : r.pos + l, m = new $root.google.protobuf.OneofOptions();
                while (r.pos < c) {
                    var t = r.uint32();
                    switch (t >>> 3) {
                    case 999:
                        if (!(m.uninterpretedOption && m.uninterpretedOption.length))
                            m.uninterpretedOption = [];
                        m.uninterpretedOption.push($root.google.protobuf.UninterpretedOption.decode(r, r.uint32()));
                        break;
                    default:
                        r.skipType(t & 7);
                        break;
                    }
                }
                return m;
            };

            return OneofOptions;
        })();

        protobuf.EnumOptions = (function() {

            /**
             * Properties of an EnumOptions.
             * @memberof google.protobuf
             * @interface IEnumOptions
             * @property {boolean|null} [allowAlias] EnumOptions allowAlias
             * @property {boolean|null} [deprecated] EnumOptions deprecated
             * @property {Array.<google.protobuf.IUninterpretedOption>|null} [uninterpretedOption] EnumOptions uninterpretedOption
             */

            /**
             * Constructs a new EnumOptions.
             * @memberof google.protobuf
             * @classdesc Represents an EnumOptions.
             * @implements IEnumOptions
             * @constructor
             * @param {google.protobuf.IEnumOptions=} [p] Properties to set
             */
            function EnumOptions(p) {
                this.uninterpretedOption = [];
                if (p)
                    for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                        if (p[ks[i]] != null)
                            this[ks[i]] = p[ks[i]];
            }

            /**
             * EnumOptions allowAlias.
             * @member {boolean} allowAlias
             * @memberof google.protobuf.EnumOptions
             * @instance
             */
            EnumOptions.prototype.allowAlias = false;

            /**
             * EnumOptions deprecated.
             * @member {boolean} deprecated
             * @memberof google.protobuf.EnumOptions
             * @instance
             */
            EnumOptions.prototype.deprecated = false;

            /**
             * EnumOptions uninterpretedOption.
             * @member {Array.<google.protobuf.IUninterpretedOption>} uninterpretedOption
             * @memberof google.protobuf.EnumOptions
             * @instance
             */
            EnumOptions.prototype.uninterpretedOption = $util.emptyArray;

            /**
             * Creates a new EnumOptions instance using the specified properties.
             * @function create
             * @memberof google.protobuf.EnumOptions
             * @static
             * @param {google.protobuf.IEnumOptions=} [properties] Properties to set
             * @returns {google.protobuf.EnumOptions} EnumOptions instance
             */
            EnumOptions.create = function create(properties) {
                return new EnumOptions(properties);
            };

            /**
             * Encodes the specified EnumOptions message. Does not implicitly {@link google.protobuf.EnumOptions.verify|verify} messages.
             * @function encode
             * @memberof google.protobuf.EnumOptions
             * @static
             * @param {google.protobuf.IEnumOptions} m EnumOptions message or plain object to encode
             * @param {$protobuf.Writer} [w] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            EnumOptions.encode = function encode(m, w) {
                if (!w)
                    w = $Writer.create();
                if (m.allowAlias != null && Object.hasOwnProperty.call(m, "allowAlias"))
                    w.uint32(16).bool(m.allowAlias);
                if (m.deprecated != null && Object.hasOwnProperty.call(m, "deprecated"))
                    w.uint32(24).bool(m.deprecated);
                if (m.uninterpretedOption != null && m.uninterpretedOption.length) {
                    for (var i = 0; i < m.uninterpretedOption.length; ++i)
                        $root.google.protobuf.UninterpretedOption.encode(m.uninterpretedOption[i], w.uint32(7994).fork()).ldelim();
                }
                return w;
            };

            /**
             * Decodes an EnumOptions message from the specified reader or buffer.
             * @function decode
             * @memberof google.protobuf.EnumOptions
             * @static
             * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
             * @param {number} [l] Message length if known beforehand
             * @returns {google.protobuf.EnumOptions} EnumOptions
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            EnumOptions.decode = function decode(r, l) {
                if (!(r instanceof $Reader))
                    r = $Reader.create(r);
                var c = l === undefined ? r.len : r.pos + l, m = new $root.google.protobuf.EnumOptions();
                while (r.pos < c) {
                    var t = r.uint32();
                    switch (t >>> 3) {
                    case 2:
                        m.allowAlias = r.bool();
                        break;
                    case 3:
                        m.deprecated = r.bool();
                        break;
                    case 999:
                        if (!(m.uninterpretedOption && m.uninterpretedOption.length))
                            m.uninterpretedOption = [];
                        m.uninterpretedOption.push($root.google.protobuf.UninterpretedOption.decode(r, r.uint32()));
                        break;
                    default:
                        r.skipType(t & 7);
                        break;
                    }
                }
                return m;
            };

            return EnumOptions;
        })();

        protobuf.EnumValueOptions = (function() {

            /**
             * Properties of an EnumValueOptions.
             * @memberof google.protobuf
             * @interface IEnumValueOptions
             * @property {boolean|null} [deprecated] EnumValueOptions deprecated
             * @property {Array.<google.protobuf.IUninterpretedOption>|null} [uninterpretedOption] EnumValueOptions uninterpretedOption
             */

            /**
             * Constructs a new EnumValueOptions.
             * @memberof google.protobuf
             * @classdesc Represents an EnumValueOptions.
             * @implements IEnumValueOptions
             * @constructor
             * @param {google.protobuf.IEnumValueOptions=} [p] Properties to set
             */
            function EnumValueOptions(p) {
                this.uninterpretedOption = [];
                if (p)
                    for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                        if (p[ks[i]] != null)
                            this[ks[i]] = p[ks[i]];
            }

            /**
             * EnumValueOptions deprecated.
             * @member {boolean} deprecated
             * @memberof google.protobuf.EnumValueOptions
             * @instance
             */
            EnumValueOptions.prototype.deprecated = false;

            /**
             * EnumValueOptions uninterpretedOption.
             * @member {Array.<google.protobuf.IUninterpretedOption>} uninterpretedOption
             * @memberof google.protobuf.EnumValueOptions
             * @instance
             */
            EnumValueOptions.prototype.uninterpretedOption = $util.emptyArray;

            /**
             * Creates a new EnumValueOptions instance using the specified properties.
             * @function create
             * @memberof google.protobuf.EnumValueOptions
             * @static
             * @param {google.protobuf.IEnumValueOptions=} [properties] Properties to set
             * @returns {google.protobuf.EnumValueOptions} EnumValueOptions instance
             */
            EnumValueOptions.create = function create(properties) {
                return new EnumValueOptions(properties);
            };

            /**
             * Encodes the specified EnumValueOptions message. Does not implicitly {@link google.protobuf.EnumValueOptions.verify|verify} messages.
             * @function encode
             * @memberof google.protobuf.EnumValueOptions
             * @static
             * @param {google.protobuf.IEnumValueOptions} m EnumValueOptions message or plain object to encode
             * @param {$protobuf.Writer} [w] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            EnumValueOptions.encode = function encode(m, w) {
                if (!w)
                    w = $Writer.create();
                if (m.deprecated != null && Object.hasOwnProperty.call(m, "deprecated"))
                    w.uint32(8).bool(m.deprecated);
                if (m.uninterpretedOption != null && m.uninterpretedOption.length) {
                    for (var i = 0; i < m.uninterpretedOption.length; ++i)
                        $root.google.protobuf.UninterpretedOption.encode(m.uninterpretedOption[i], w.uint32(7994).fork()).ldelim();
                }
                return w;
            };

            /**
             * Decodes an EnumValueOptions message from the specified reader or buffer.
             * @function decode
             * @memberof google.protobuf.EnumValueOptions
             * @static
             * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
             * @param {number} [l] Message length if known beforehand
             * @returns {google.protobuf.EnumValueOptions} EnumValueOptions
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            EnumValueOptions.decode = function decode(r, l) {
                if (!(r instanceof $Reader))
                    r = $Reader.create(r);
                var c = l === undefined ? r.len : r.pos + l, m = new $root.google.protobuf.EnumValueOptions();
                while (r.pos < c) {
                    var t = r.uint32();
                    switch (t >>> 3) {
                    case 1:
                        m.deprecated = r.bool();
                        break;
                    case 999:
                        if (!(m.uninterpretedOption && m.uninterpretedOption.length))
                            m.uninterpretedOption = [];
                        m.uninterpretedOption.push($root.google.protobuf.UninterpretedOption.decode(r, r.uint32()));
                        break;
                    default:
                        r.skipType(t & 7);
                        break;
                    }
                }
                return m;
            };

            return EnumValueOptions;
        })();

        protobuf.ServiceOptions = (function() {

            /**
             * Properties of a ServiceOptions.
             * @memberof google.protobuf
             * @interface IServiceOptions
             * @property {boolean|null} [deprecated] ServiceOptions deprecated
             * @property {Array.<google.protobuf.IUninterpretedOption>|null} [uninterpretedOption] ServiceOptions uninterpretedOption
             * @property {string|null} [".common.URI"] ServiceOptions .common.URI
             */

            /**
             * Constructs a new ServiceOptions.
             * @memberof google.protobuf
             * @classdesc Represents a ServiceOptions.
             * @implements IServiceOptions
             * @constructor
             * @param {google.protobuf.IServiceOptions=} [p] Properties to set
             */
            function ServiceOptions(p) {
                this.uninterpretedOption = [];
                if (p)
                    for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                        if (p[ks[i]] != null)
                            this[ks[i]] = p[ks[i]];
            }

            /**
             * ServiceOptions deprecated.
             * @member {boolean} deprecated
             * @memberof google.protobuf.ServiceOptions
             * @instance
             */
            ServiceOptions.prototype.deprecated = false;

            /**
             * ServiceOptions uninterpretedOption.
             * @member {Array.<google.protobuf.IUninterpretedOption>} uninterpretedOption
             * @memberof google.protobuf.ServiceOptions
             * @instance
             */
            ServiceOptions.prototype.uninterpretedOption = $util.emptyArray;

            /**
             * ServiceOptions .common.URI.
             * @member {string} .common.URI
             * @memberof google.protobuf.ServiceOptions
             * @instance
             */
            ServiceOptions.prototype[".common.URI"] = "";

            /**
             * Creates a new ServiceOptions instance using the specified properties.
             * @function create
             * @memberof google.protobuf.ServiceOptions
             * @static
             * @param {google.protobuf.IServiceOptions=} [properties] Properties to set
             * @returns {google.protobuf.ServiceOptions} ServiceOptions instance
             */
            ServiceOptions.create = function create(properties) {
                return new ServiceOptions(properties);
            };

            /**
             * Encodes the specified ServiceOptions message. Does not implicitly {@link google.protobuf.ServiceOptions.verify|verify} messages.
             * @function encode
             * @memberof google.protobuf.ServiceOptions
             * @static
             * @param {google.protobuf.IServiceOptions} m ServiceOptions message or plain object to encode
             * @param {$protobuf.Writer} [w] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ServiceOptions.encode = function encode(m, w) {
                if (!w)
                    w = $Writer.create();
                if (m.deprecated != null && Object.hasOwnProperty.call(m, "deprecated"))
                    w.uint32(264).bool(m.deprecated);
                if (m.uninterpretedOption != null && m.uninterpretedOption.length) {
                    for (var i = 0; i < m.uninterpretedOption.length; ++i)
                        $root.google.protobuf.UninterpretedOption.encode(m.uninterpretedOption[i], w.uint32(7994).fork()).ldelim();
                }
                if (m[".common.URI"] != null && Object.hasOwnProperty.call(m, ".common.URI"))
                    w.uint32(400010).string(m[".common.URI"]);
                return w;
            };

            /**
             * Decodes a ServiceOptions message from the specified reader or buffer.
             * @function decode
             * @memberof google.protobuf.ServiceOptions
             * @static
             * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
             * @param {number} [l] Message length if known beforehand
             * @returns {google.protobuf.ServiceOptions} ServiceOptions
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ServiceOptions.decode = function decode(r, l) {
                if (!(r instanceof $Reader))
                    r = $Reader.create(r);
                var c = l === undefined ? r.len : r.pos + l, m = new $root.google.protobuf.ServiceOptions();
                while (r.pos < c) {
                    var t = r.uint32();
                    switch (t >>> 3) {
                    case 33:
                        m.deprecated = r.bool();
                        break;
                    case 999:
                        if (!(m.uninterpretedOption && m.uninterpretedOption.length))
                            m.uninterpretedOption = [];
                        m.uninterpretedOption.push($root.google.protobuf.UninterpretedOption.decode(r, r.uint32()));
                        break;
                    case 50001:
                        m[".common.URI"] = r.string();
                        break;
                    default:
                        r.skipType(t & 7);
                        break;
                    }
                }
                return m;
            };

            return ServiceOptions;
        })();

        protobuf.MethodOptions = (function() {

            /**
             * Properties of a MethodOptions.
             * @memberof google.protobuf
             * @interface IMethodOptions
             * @property {boolean|null} [deprecated] MethodOptions deprecated
             * @property {Array.<google.protobuf.IUninterpretedOption>|null} [uninterpretedOption] MethodOptions uninterpretedOption
             * @property {boolean|null} [".common.allowJson"] MethodOptions .common.allowJson
             * @property {string|null} [".common.methodCalls"] MethodOptions .common.methodCalls
             * @property {string|null} [".common.httpMethod"] MethodOptions .common.httpMethod
             * @property {string|null} [".common.methodURI"] MethodOptions .common.methodURI
             */

            /**
             * Constructs a new MethodOptions.
             * @memberof google.protobuf
             * @classdesc Represents a MethodOptions.
             * @implements IMethodOptions
             * @constructor
             * @param {google.protobuf.IMethodOptions=} [p] Properties to set
             */
            function MethodOptions(p) {
                this.uninterpretedOption = [];
                if (p)
                    for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                        if (p[ks[i]] != null)
                            this[ks[i]] = p[ks[i]];
            }

            /**
             * MethodOptions deprecated.
             * @member {boolean} deprecated
             * @memberof google.protobuf.MethodOptions
             * @instance
             */
            MethodOptions.prototype.deprecated = false;

            /**
             * MethodOptions uninterpretedOption.
             * @member {Array.<google.protobuf.IUninterpretedOption>} uninterpretedOption
             * @memberof google.protobuf.MethodOptions
             * @instance
             */
            MethodOptions.prototype.uninterpretedOption = $util.emptyArray;

            /**
             * MethodOptions .common.allowJson.
             * @member {boolean} .common.allowJson
             * @memberof google.protobuf.MethodOptions
             * @instance
             */
            MethodOptions.prototype[".common.allowJson"] = false;

            /**
             * MethodOptions .common.methodCalls.
             * @member {string} .common.methodCalls
             * @memberof google.protobuf.MethodOptions
             * @instance
             */
            MethodOptions.prototype[".common.methodCalls"] = "";

            /**
             * MethodOptions .common.httpMethod.
             * @member {string} .common.httpMethod
             * @memberof google.protobuf.MethodOptions
             * @instance
             */
            MethodOptions.prototype[".common.httpMethod"] = "";

            /**
             * MethodOptions .common.methodURI.
             * @member {string} .common.methodURI
             * @memberof google.protobuf.MethodOptions
             * @instance
             */
            MethodOptions.prototype[".common.methodURI"] = "";

            /**
             * Creates a new MethodOptions instance using the specified properties.
             * @function create
             * @memberof google.protobuf.MethodOptions
             * @static
             * @param {google.protobuf.IMethodOptions=} [properties] Properties to set
             * @returns {google.protobuf.MethodOptions} MethodOptions instance
             */
            MethodOptions.create = function create(properties) {
                return new MethodOptions(properties);
            };

            /**
             * Encodes the specified MethodOptions message. Does not implicitly {@link google.protobuf.MethodOptions.verify|verify} messages.
             * @function encode
             * @memberof google.protobuf.MethodOptions
             * @static
             * @param {google.protobuf.IMethodOptions} m MethodOptions message or plain object to encode
             * @param {$protobuf.Writer} [w] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            MethodOptions.encode = function encode(m, w) {
                if (!w)
                    w = $Writer.create();
                if (m.deprecated != null && Object.hasOwnProperty.call(m, "deprecated"))
                    w.uint32(264).bool(m.deprecated);
                if (m.uninterpretedOption != null && m.uninterpretedOption.length) {
                    for (var i = 0; i < m.uninterpretedOption.length; ++i)
                        $root.google.protobuf.UninterpretedOption.encode(m.uninterpretedOption[i], w.uint32(7994).fork()).ldelim();
                }
                if (m[".common.allowJson"] != null && Object.hasOwnProperty.call(m, ".common.allowJson"))
                    w.uint32(400000).bool(m[".common.allowJson"]);
                if (m[".common.methodCalls"] != null && Object.hasOwnProperty.call(m, ".common.methodCalls"))
                    w.uint32(400018).string(m[".common.methodCalls"]);
                if (m[".common.httpMethod"] != null && Object.hasOwnProperty.call(m, ".common.httpMethod"))
                    w.uint32(400026).string(m[".common.httpMethod"]);
                if (m[".common.methodURI"] != null && Object.hasOwnProperty.call(m, ".common.methodURI"))
                    w.uint32(400042).string(m[".common.methodURI"]);
                return w;
            };

            /**
             * Decodes a MethodOptions message from the specified reader or buffer.
             * @function decode
             * @memberof google.protobuf.MethodOptions
             * @static
             * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
             * @param {number} [l] Message length if known beforehand
             * @returns {google.protobuf.MethodOptions} MethodOptions
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            MethodOptions.decode = function decode(r, l) {
                if (!(r instanceof $Reader))
                    r = $Reader.create(r);
                var c = l === undefined ? r.len : r.pos + l, m = new $root.google.protobuf.MethodOptions();
                while (r.pos < c) {
                    var t = r.uint32();
                    switch (t >>> 3) {
                    case 33:
                        m.deprecated = r.bool();
                        break;
                    case 999:
                        if (!(m.uninterpretedOption && m.uninterpretedOption.length))
                            m.uninterpretedOption = [];
                        m.uninterpretedOption.push($root.google.protobuf.UninterpretedOption.decode(r, r.uint32()));
                        break;
                    case 50000:
                        m[".common.allowJson"] = r.bool();
                        break;
                    case 50002:
                        m[".common.methodCalls"] = r.string();
                        break;
                    case 50003:
                        m[".common.httpMethod"] = r.string();
                        break;
                    case 50005:
                        m[".common.methodURI"] = r.string();
                        break;
                    default:
                        r.skipType(t & 7);
                        break;
                    }
                }
                return m;
            };

            return MethodOptions;
        })();

        protobuf.UninterpretedOption = (function() {

            /**
             * Properties of an UninterpretedOption.
             * @memberof google.protobuf
             * @interface IUninterpretedOption
             * @property {Array.<google.protobuf.UninterpretedOption.INamePart>|null} [name] UninterpretedOption name
             * @property {string|null} [identifierValue] UninterpretedOption identifierValue
             * @property {number|Long|null} [positiveIntValue] UninterpretedOption positiveIntValue
             * @property {number|Long|null} [negativeIntValue] UninterpretedOption negativeIntValue
             * @property {number|null} [doubleValue] UninterpretedOption doubleValue
             * @property {Uint8Array|null} [stringValue] UninterpretedOption stringValue
             * @property {string|null} [aggregateValue] UninterpretedOption aggregateValue
             */

            /**
             * Constructs a new UninterpretedOption.
             * @memberof google.protobuf
             * @classdesc Represents an UninterpretedOption.
             * @implements IUninterpretedOption
             * @constructor
             * @param {google.protobuf.IUninterpretedOption=} [p] Properties to set
             */
            function UninterpretedOption(p) {
                this.name = [];
                if (p)
                    for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                        if (p[ks[i]] != null)
                            this[ks[i]] = p[ks[i]];
            }

            /**
             * UninterpretedOption name.
             * @member {Array.<google.protobuf.UninterpretedOption.INamePart>} name
             * @memberof google.protobuf.UninterpretedOption
             * @instance
             */
            UninterpretedOption.prototype.name = $util.emptyArray;

            /**
             * UninterpretedOption identifierValue.
             * @member {string} identifierValue
             * @memberof google.protobuf.UninterpretedOption
             * @instance
             */
            UninterpretedOption.prototype.identifierValue = "";

            /**
             * UninterpretedOption positiveIntValue.
             * @member {number|Long} positiveIntValue
             * @memberof google.protobuf.UninterpretedOption
             * @instance
             */
            UninterpretedOption.prototype.positiveIntValue = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

            /**
             * UninterpretedOption negativeIntValue.
             * @member {number|Long} negativeIntValue
             * @memberof google.protobuf.UninterpretedOption
             * @instance
             */
            UninterpretedOption.prototype.negativeIntValue = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * UninterpretedOption doubleValue.
             * @member {number} doubleValue
             * @memberof google.protobuf.UninterpretedOption
             * @instance
             */
            UninterpretedOption.prototype.doubleValue = 0;

            /**
             * UninterpretedOption stringValue.
             * @member {Uint8Array} stringValue
             * @memberof google.protobuf.UninterpretedOption
             * @instance
             */
            UninterpretedOption.prototype.stringValue = $util.newBuffer([]);

            /**
             * UninterpretedOption aggregateValue.
             * @member {string} aggregateValue
             * @memberof google.protobuf.UninterpretedOption
             * @instance
             */
            UninterpretedOption.prototype.aggregateValue = "";

            /**
             * Creates a new UninterpretedOption instance using the specified properties.
             * @function create
             * @memberof google.protobuf.UninterpretedOption
             * @static
             * @param {google.protobuf.IUninterpretedOption=} [properties] Properties to set
             * @returns {google.protobuf.UninterpretedOption} UninterpretedOption instance
             */
            UninterpretedOption.create = function create(properties) {
                return new UninterpretedOption(properties);
            };

            /**
             * Encodes the specified UninterpretedOption message. Does not implicitly {@link google.protobuf.UninterpretedOption.verify|verify} messages.
             * @function encode
             * @memberof google.protobuf.UninterpretedOption
             * @static
             * @param {google.protobuf.IUninterpretedOption} m UninterpretedOption message or plain object to encode
             * @param {$protobuf.Writer} [w] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            UninterpretedOption.encode = function encode(m, w) {
                if (!w)
                    w = $Writer.create();
                if (m.name != null && m.name.length) {
                    for (var i = 0; i < m.name.length; ++i)
                        $root.google.protobuf.UninterpretedOption.NamePart.encode(m.name[i], w.uint32(18).fork()).ldelim();
                }
                if (m.identifierValue != null && Object.hasOwnProperty.call(m, "identifierValue"))
                    w.uint32(26).string(m.identifierValue);
                if (m.positiveIntValue != null && Object.hasOwnProperty.call(m, "positiveIntValue"))
                    w.uint32(32).uint64(m.positiveIntValue);
                if (m.negativeIntValue != null && Object.hasOwnProperty.call(m, "negativeIntValue"))
                    w.uint32(40).int64(m.negativeIntValue);
                if (m.doubleValue != null && Object.hasOwnProperty.call(m, "doubleValue"))
                    w.uint32(49).double(m.doubleValue);
                if (m.stringValue != null && Object.hasOwnProperty.call(m, "stringValue"))
                    w.uint32(58).bytes(m.stringValue);
                if (m.aggregateValue != null && Object.hasOwnProperty.call(m, "aggregateValue"))
                    w.uint32(66).string(m.aggregateValue);
                return w;
            };

            /**
             * Decodes an UninterpretedOption message from the specified reader or buffer.
             * @function decode
             * @memberof google.protobuf.UninterpretedOption
             * @static
             * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
             * @param {number} [l] Message length if known beforehand
             * @returns {google.protobuf.UninterpretedOption} UninterpretedOption
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            UninterpretedOption.decode = function decode(r, l) {
                if (!(r instanceof $Reader))
                    r = $Reader.create(r);
                var c = l === undefined ? r.len : r.pos + l, m = new $root.google.protobuf.UninterpretedOption();
                while (r.pos < c) {
                    var t = r.uint32();
                    switch (t >>> 3) {
                    case 2:
                        if (!(m.name && m.name.length))
                            m.name = [];
                        m.name.push($root.google.protobuf.UninterpretedOption.NamePart.decode(r, r.uint32()));
                        break;
                    case 3:
                        m.identifierValue = r.string();
                        break;
                    case 4:
                        m.positiveIntValue = r.uint64();
                        break;
                    case 5:
                        m.negativeIntValue = r.int64();
                        break;
                    case 6:
                        m.doubleValue = r.double();
                        break;
                    case 7:
                        m.stringValue = r.bytes();
                        break;
                    case 8:
                        m.aggregateValue = r.string();
                        break;
                    default:
                        r.skipType(t & 7);
                        break;
                    }
                }
                return m;
            };

            UninterpretedOption.NamePart = (function() {

                /**
                 * Properties of a NamePart.
                 * @memberof google.protobuf.UninterpretedOption
                 * @interface INamePart
                 * @property {string} namePart NamePart namePart
                 * @property {boolean} isExtension NamePart isExtension
                 */

                /**
                 * Constructs a new NamePart.
                 * @memberof google.protobuf.UninterpretedOption
                 * @classdesc Represents a NamePart.
                 * @implements INamePart
                 * @constructor
                 * @param {google.protobuf.UninterpretedOption.INamePart=} [p] Properties to set
                 */
                function NamePart(p) {
                    if (p)
                        for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                            if (p[ks[i]] != null)
                                this[ks[i]] = p[ks[i]];
                }

                /**
                 * NamePart namePart.
                 * @member {string} namePart
                 * @memberof google.protobuf.UninterpretedOption.NamePart
                 * @instance
                 */
                NamePart.prototype.namePart = "";

                /**
                 * NamePart isExtension.
                 * @member {boolean} isExtension
                 * @memberof google.protobuf.UninterpretedOption.NamePart
                 * @instance
                 */
                NamePart.prototype.isExtension = false;

                /**
                 * Creates a new NamePart instance using the specified properties.
                 * @function create
                 * @memberof google.protobuf.UninterpretedOption.NamePart
                 * @static
                 * @param {google.protobuf.UninterpretedOption.INamePart=} [properties] Properties to set
                 * @returns {google.protobuf.UninterpretedOption.NamePart} NamePart instance
                 */
                NamePart.create = function create(properties) {
                    return new NamePart(properties);
                };

                /**
                 * Encodes the specified NamePart message. Does not implicitly {@link google.protobuf.UninterpretedOption.NamePart.verify|verify} messages.
                 * @function encode
                 * @memberof google.protobuf.UninterpretedOption.NamePart
                 * @static
                 * @param {google.protobuf.UninterpretedOption.INamePart} m NamePart message or plain object to encode
                 * @param {$protobuf.Writer} [w] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                NamePart.encode = function encode(m, w) {
                    if (!w)
                        w = $Writer.create();
                    w.uint32(10).string(m.namePart);
                    w.uint32(16).bool(m.isExtension);
                    return w;
                };

                /**
                 * Decodes a NamePart message from the specified reader or buffer.
                 * @function decode
                 * @memberof google.protobuf.UninterpretedOption.NamePart
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
                 * @param {number} [l] Message length if known beforehand
                 * @returns {google.protobuf.UninterpretedOption.NamePart} NamePart
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                NamePart.decode = function decode(r, l) {
                    if (!(r instanceof $Reader))
                        r = $Reader.create(r);
                    var c = l === undefined ? r.len : r.pos + l, m = new $root.google.protobuf.UninterpretedOption.NamePart();
                    while (r.pos < c) {
                        var t = r.uint32();
                        switch (t >>> 3) {
                        case 1:
                            m.namePart = r.string();
                            break;
                        case 2:
                            m.isExtension = r.bool();
                            break;
                        default:
                            r.skipType(t & 7);
                            break;
                        }
                    }
                    if (!m.hasOwnProperty("namePart"))
                        throw $util.ProtocolError("missing required 'namePart'", { instance: m });
                    if (!m.hasOwnProperty("isExtension"))
                        throw $util.ProtocolError("missing required 'isExtension'", { instance: m });
                    return m;
                };

                return NamePart;
            })();

            return UninterpretedOption;
        })();

        protobuf.SourceCodeInfo = (function() {

            /**
             * Properties of a SourceCodeInfo.
             * @memberof google.protobuf
             * @interface ISourceCodeInfo
             * @property {Array.<google.protobuf.SourceCodeInfo.ILocation>|null} [location] SourceCodeInfo location
             */

            /**
             * Constructs a new SourceCodeInfo.
             * @memberof google.protobuf
             * @classdesc Represents a SourceCodeInfo.
             * @implements ISourceCodeInfo
             * @constructor
             * @param {google.protobuf.ISourceCodeInfo=} [p] Properties to set
             */
            function SourceCodeInfo(p) {
                this.location = [];
                if (p)
                    for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                        if (p[ks[i]] != null)
                            this[ks[i]] = p[ks[i]];
            }

            /**
             * SourceCodeInfo location.
             * @member {Array.<google.protobuf.SourceCodeInfo.ILocation>} location
             * @memberof google.protobuf.SourceCodeInfo
             * @instance
             */
            SourceCodeInfo.prototype.location = $util.emptyArray;

            /**
             * Creates a new SourceCodeInfo instance using the specified properties.
             * @function create
             * @memberof google.protobuf.SourceCodeInfo
             * @static
             * @param {google.protobuf.ISourceCodeInfo=} [properties] Properties to set
             * @returns {google.protobuf.SourceCodeInfo} SourceCodeInfo instance
             */
            SourceCodeInfo.create = function create(properties) {
                return new SourceCodeInfo(properties);
            };

            /**
             * Encodes the specified SourceCodeInfo message. Does not implicitly {@link google.protobuf.SourceCodeInfo.verify|verify} messages.
             * @function encode
             * @memberof google.protobuf.SourceCodeInfo
             * @static
             * @param {google.protobuf.ISourceCodeInfo} m SourceCodeInfo message or plain object to encode
             * @param {$protobuf.Writer} [w] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            SourceCodeInfo.encode = function encode(m, w) {
                if (!w)
                    w = $Writer.create();
                if (m.location != null && m.location.length) {
                    for (var i = 0; i < m.location.length; ++i)
                        $root.google.protobuf.SourceCodeInfo.Location.encode(m.location[i], w.uint32(10).fork()).ldelim();
                }
                return w;
            };

            /**
             * Decodes a SourceCodeInfo message from the specified reader or buffer.
             * @function decode
             * @memberof google.protobuf.SourceCodeInfo
             * @static
             * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
             * @param {number} [l] Message length if known beforehand
             * @returns {google.protobuf.SourceCodeInfo} SourceCodeInfo
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            SourceCodeInfo.decode = function decode(r, l) {
                if (!(r instanceof $Reader))
                    r = $Reader.create(r);
                var c = l === undefined ? r.len : r.pos + l, m = new $root.google.protobuf.SourceCodeInfo();
                while (r.pos < c) {
                    var t = r.uint32();
                    switch (t >>> 3) {
                    case 1:
                        if (!(m.location && m.location.length))
                            m.location = [];
                        m.location.push($root.google.protobuf.SourceCodeInfo.Location.decode(r, r.uint32()));
                        break;
                    default:
                        r.skipType(t & 7);
                        break;
                    }
                }
                return m;
            };

            SourceCodeInfo.Location = (function() {

                /**
                 * Properties of a Location.
                 * @memberof google.protobuf.SourceCodeInfo
                 * @interface ILocation
                 * @property {Array.<number>|null} [path] Location path
                 * @property {Array.<number>|null} [span] Location span
                 * @property {string|null} [leadingComments] Location leadingComments
                 * @property {string|null} [trailingComments] Location trailingComments
                 * @property {Array.<string>|null} [leadingDetachedComments] Location leadingDetachedComments
                 */

                /**
                 * Constructs a new Location.
                 * @memberof google.protobuf.SourceCodeInfo
                 * @classdesc Represents a Location.
                 * @implements ILocation
                 * @constructor
                 * @param {google.protobuf.SourceCodeInfo.ILocation=} [p] Properties to set
                 */
                function Location(p) {
                    this.path = [];
                    this.span = [];
                    this.leadingDetachedComments = [];
                    if (p)
                        for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                            if (p[ks[i]] != null)
                                this[ks[i]] = p[ks[i]];
                }

                /**
                 * Location path.
                 * @member {Array.<number>} path
                 * @memberof google.protobuf.SourceCodeInfo.Location
                 * @instance
                 */
                Location.prototype.path = $util.emptyArray;

                /**
                 * Location span.
                 * @member {Array.<number>} span
                 * @memberof google.protobuf.SourceCodeInfo.Location
                 * @instance
                 */
                Location.prototype.span = $util.emptyArray;

                /**
                 * Location leadingComments.
                 * @member {string} leadingComments
                 * @memberof google.protobuf.SourceCodeInfo.Location
                 * @instance
                 */
                Location.prototype.leadingComments = "";

                /**
                 * Location trailingComments.
                 * @member {string} trailingComments
                 * @memberof google.protobuf.SourceCodeInfo.Location
                 * @instance
                 */
                Location.prototype.trailingComments = "";

                /**
                 * Location leadingDetachedComments.
                 * @member {Array.<string>} leadingDetachedComments
                 * @memberof google.protobuf.SourceCodeInfo.Location
                 * @instance
                 */
                Location.prototype.leadingDetachedComments = $util.emptyArray;

                /**
                 * Creates a new Location instance using the specified properties.
                 * @function create
                 * @memberof google.protobuf.SourceCodeInfo.Location
                 * @static
                 * @param {google.protobuf.SourceCodeInfo.ILocation=} [properties] Properties to set
                 * @returns {google.protobuf.SourceCodeInfo.Location} Location instance
                 */
                Location.create = function create(properties) {
                    return new Location(properties);
                };

                /**
                 * Encodes the specified Location message. Does not implicitly {@link google.protobuf.SourceCodeInfo.Location.verify|verify} messages.
                 * @function encode
                 * @memberof google.protobuf.SourceCodeInfo.Location
                 * @static
                 * @param {google.protobuf.SourceCodeInfo.ILocation} m Location message or plain object to encode
                 * @param {$protobuf.Writer} [w] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Location.encode = function encode(m, w) {
                    if (!w)
                        w = $Writer.create();
                    if (m.path != null && m.path.length) {
                        w.uint32(10).fork();
                        for (var i = 0; i < m.path.length; ++i)
                            w.int32(m.path[i]);
                        w.ldelim();
                    }
                    if (m.span != null && m.span.length) {
                        w.uint32(18).fork();
                        for (var i = 0; i < m.span.length; ++i)
                            w.int32(m.span[i]);
                        w.ldelim();
                    }
                    if (m.leadingComments != null && Object.hasOwnProperty.call(m, "leadingComments"))
                        w.uint32(26).string(m.leadingComments);
                    if (m.trailingComments != null && Object.hasOwnProperty.call(m, "trailingComments"))
                        w.uint32(34).string(m.trailingComments);
                    if (m.leadingDetachedComments != null && m.leadingDetachedComments.length) {
                        for (var i = 0; i < m.leadingDetachedComments.length; ++i)
                            w.uint32(50).string(m.leadingDetachedComments[i]);
                    }
                    return w;
                };

                /**
                 * Decodes a Location message from the specified reader or buffer.
                 * @function decode
                 * @memberof google.protobuf.SourceCodeInfo.Location
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
                 * @param {number} [l] Message length if known beforehand
                 * @returns {google.protobuf.SourceCodeInfo.Location} Location
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Location.decode = function decode(r, l) {
                    if (!(r instanceof $Reader))
                        r = $Reader.create(r);
                    var c = l === undefined ? r.len : r.pos + l, m = new $root.google.protobuf.SourceCodeInfo.Location();
                    while (r.pos < c) {
                        var t = r.uint32();
                        switch (t >>> 3) {
                        case 1:
                            if (!(m.path && m.path.length))
                                m.path = [];
                            if ((t & 7) === 2) {
                                var c2 = r.uint32() + r.pos;
                                while (r.pos < c2)
                                    m.path.push(r.int32());
                            } else
                                m.path.push(r.int32());
                            break;
                        case 2:
                            if (!(m.span && m.span.length))
                                m.span = [];
                            if ((t & 7) === 2) {
                                var c2 = r.uint32() + r.pos;
                                while (r.pos < c2)
                                    m.span.push(r.int32());
                            } else
                                m.span.push(r.int32());
                            break;
                        case 3:
                            m.leadingComments = r.string();
                            break;
                        case 4:
                            m.trailingComments = r.string();
                            break;
                        case 6:
                            if (!(m.leadingDetachedComments && m.leadingDetachedComments.length))
                                m.leadingDetachedComments = [];
                            m.leadingDetachedComments.push(r.string());
                            break;
                        default:
                            r.skipType(t & 7);
                            break;
                        }
                    }
                    return m;
                };

                return Location;
            })();

            return SourceCodeInfo;
        })();

        protobuf.GeneratedCodeInfo = (function() {

            /**
             * Properties of a GeneratedCodeInfo.
             * @memberof google.protobuf
             * @interface IGeneratedCodeInfo
             * @property {Array.<google.protobuf.GeneratedCodeInfo.IAnnotation>|null} [annotation] GeneratedCodeInfo annotation
             */

            /**
             * Constructs a new GeneratedCodeInfo.
             * @memberof google.protobuf
             * @classdesc Represents a GeneratedCodeInfo.
             * @implements IGeneratedCodeInfo
             * @constructor
             * @param {google.protobuf.IGeneratedCodeInfo=} [p] Properties to set
             */
            function GeneratedCodeInfo(p) {
                this.annotation = [];
                if (p)
                    for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                        if (p[ks[i]] != null)
                            this[ks[i]] = p[ks[i]];
            }

            /**
             * GeneratedCodeInfo annotation.
             * @member {Array.<google.protobuf.GeneratedCodeInfo.IAnnotation>} annotation
             * @memberof google.protobuf.GeneratedCodeInfo
             * @instance
             */
            GeneratedCodeInfo.prototype.annotation = $util.emptyArray;

            /**
             * Creates a new GeneratedCodeInfo instance using the specified properties.
             * @function create
             * @memberof google.protobuf.GeneratedCodeInfo
             * @static
             * @param {google.protobuf.IGeneratedCodeInfo=} [properties] Properties to set
             * @returns {google.protobuf.GeneratedCodeInfo} GeneratedCodeInfo instance
             */
            GeneratedCodeInfo.create = function create(properties) {
                return new GeneratedCodeInfo(properties);
            };

            /**
             * Encodes the specified GeneratedCodeInfo message. Does not implicitly {@link google.protobuf.GeneratedCodeInfo.verify|verify} messages.
             * @function encode
             * @memberof google.protobuf.GeneratedCodeInfo
             * @static
             * @param {google.protobuf.IGeneratedCodeInfo} m GeneratedCodeInfo message or plain object to encode
             * @param {$protobuf.Writer} [w] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GeneratedCodeInfo.encode = function encode(m, w) {
                if (!w)
                    w = $Writer.create();
                if (m.annotation != null && m.annotation.length) {
                    for (var i = 0; i < m.annotation.length; ++i)
                        $root.google.protobuf.GeneratedCodeInfo.Annotation.encode(m.annotation[i], w.uint32(10).fork()).ldelim();
                }
                return w;
            };

            /**
             * Decodes a GeneratedCodeInfo message from the specified reader or buffer.
             * @function decode
             * @memberof google.protobuf.GeneratedCodeInfo
             * @static
             * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
             * @param {number} [l] Message length if known beforehand
             * @returns {google.protobuf.GeneratedCodeInfo} GeneratedCodeInfo
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GeneratedCodeInfo.decode = function decode(r, l) {
                if (!(r instanceof $Reader))
                    r = $Reader.create(r);
                var c = l === undefined ? r.len : r.pos + l, m = new $root.google.protobuf.GeneratedCodeInfo();
                while (r.pos < c) {
                    var t = r.uint32();
                    switch (t >>> 3) {
                    case 1:
                        if (!(m.annotation && m.annotation.length))
                            m.annotation = [];
                        m.annotation.push($root.google.protobuf.GeneratedCodeInfo.Annotation.decode(r, r.uint32()));
                        break;
                    default:
                        r.skipType(t & 7);
                        break;
                    }
                }
                return m;
            };

            GeneratedCodeInfo.Annotation = (function() {

                /**
                 * Properties of an Annotation.
                 * @memberof google.protobuf.GeneratedCodeInfo
                 * @interface IAnnotation
                 * @property {Array.<number>|null} [path] Annotation path
                 * @property {string|null} [sourceFile] Annotation sourceFile
                 * @property {number|null} [begin] Annotation begin
                 * @property {number|null} [end] Annotation end
                 */

                /**
                 * Constructs a new Annotation.
                 * @memberof google.protobuf.GeneratedCodeInfo
                 * @classdesc Represents an Annotation.
                 * @implements IAnnotation
                 * @constructor
                 * @param {google.protobuf.GeneratedCodeInfo.IAnnotation=} [p] Properties to set
                 */
                function Annotation(p) {
                    this.path = [];
                    if (p)
                        for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                            if (p[ks[i]] != null)
                                this[ks[i]] = p[ks[i]];
                }

                /**
                 * Annotation path.
                 * @member {Array.<number>} path
                 * @memberof google.protobuf.GeneratedCodeInfo.Annotation
                 * @instance
                 */
                Annotation.prototype.path = $util.emptyArray;

                /**
                 * Annotation sourceFile.
                 * @member {string} sourceFile
                 * @memberof google.protobuf.GeneratedCodeInfo.Annotation
                 * @instance
                 */
                Annotation.prototype.sourceFile = "";

                /**
                 * Annotation begin.
                 * @member {number} begin
                 * @memberof google.protobuf.GeneratedCodeInfo.Annotation
                 * @instance
                 */
                Annotation.prototype.begin = 0;

                /**
                 * Annotation end.
                 * @member {number} end
                 * @memberof google.protobuf.GeneratedCodeInfo.Annotation
                 * @instance
                 */
                Annotation.prototype.end = 0;

                /**
                 * Creates a new Annotation instance using the specified properties.
                 * @function create
                 * @memberof google.protobuf.GeneratedCodeInfo.Annotation
                 * @static
                 * @param {google.protobuf.GeneratedCodeInfo.IAnnotation=} [properties] Properties to set
                 * @returns {google.protobuf.GeneratedCodeInfo.Annotation} Annotation instance
                 */
                Annotation.create = function create(properties) {
                    return new Annotation(properties);
                };

                /**
                 * Encodes the specified Annotation message. Does not implicitly {@link google.protobuf.GeneratedCodeInfo.Annotation.verify|verify} messages.
                 * @function encode
                 * @memberof google.protobuf.GeneratedCodeInfo.Annotation
                 * @static
                 * @param {google.protobuf.GeneratedCodeInfo.IAnnotation} m Annotation message or plain object to encode
                 * @param {$protobuf.Writer} [w] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Annotation.encode = function encode(m, w) {
                    if (!w)
                        w = $Writer.create();
                    if (m.path != null && m.path.length) {
                        w.uint32(10).fork();
                        for (var i = 0; i < m.path.length; ++i)
                            w.int32(m.path[i]);
                        w.ldelim();
                    }
                    if (m.sourceFile != null && Object.hasOwnProperty.call(m, "sourceFile"))
                        w.uint32(18).string(m.sourceFile);
                    if (m.begin != null && Object.hasOwnProperty.call(m, "begin"))
                        w.uint32(24).int32(m.begin);
                    if (m.end != null && Object.hasOwnProperty.call(m, "end"))
                        w.uint32(32).int32(m.end);
                    return w;
                };

                /**
                 * Decodes an Annotation message from the specified reader or buffer.
                 * @function decode
                 * @memberof google.protobuf.GeneratedCodeInfo.Annotation
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
                 * @param {number} [l] Message length if known beforehand
                 * @returns {google.protobuf.GeneratedCodeInfo.Annotation} Annotation
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Annotation.decode = function decode(r, l) {
                    if (!(r instanceof $Reader))
                        r = $Reader.create(r);
                    var c = l === undefined ? r.len : r.pos + l, m = new $root.google.protobuf.GeneratedCodeInfo.Annotation();
                    while (r.pos < c) {
                        var t = r.uint32();
                        switch (t >>> 3) {
                        case 1:
                            if (!(m.path && m.path.length))
                                m.path = [];
                            if ((t & 7) === 2) {
                                var c2 = r.uint32() + r.pos;
                                while (r.pos < c2)
                                    m.path.push(r.int32());
                            } else
                                m.path.push(r.int32());
                            break;
                        case 2:
                            m.sourceFile = r.string();
                            break;
                        case 3:
                            m.begin = r.int32();
                            break;
                        case 4:
                            m.end = r.int32();
                            break;
                        default:
                            r.skipType(t & 7);
                            break;
                        }
                    }
                    return m;
                };

                return Annotation;
            })();

            return GeneratedCodeInfo;
        })();

        protobuf.Timestamp = (function() {

            /**
             * Properties of a Timestamp.
             * @memberof google.protobuf
             * @interface ITimestamp
             * @property {number|Long|null} [seconds] Timestamp seconds
             * @property {number|null} [nanos] Timestamp nanos
             */

            /**
             * Constructs a new Timestamp.
             * @memberof google.protobuf
             * @classdesc Represents a Timestamp.
             * @implements ITimestamp
             * @constructor
             * @param {google.protobuf.ITimestamp=} [p] Properties to set
             */
            function Timestamp(p) {
                if (p)
                    for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                        if (p[ks[i]] != null)
                            this[ks[i]] = p[ks[i]];
            }

            /**
             * Timestamp seconds.
             * @member {number|Long} seconds
             * @memberof google.protobuf.Timestamp
             * @instance
             */
            Timestamp.prototype.seconds = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * Timestamp nanos.
             * @member {number} nanos
             * @memberof google.protobuf.Timestamp
             * @instance
             */
            Timestamp.prototype.nanos = 0;

            /**
             * Creates a new Timestamp instance using the specified properties.
             * @function create
             * @memberof google.protobuf.Timestamp
             * @static
             * @param {google.protobuf.ITimestamp=} [properties] Properties to set
             * @returns {google.protobuf.Timestamp} Timestamp instance
             */
            Timestamp.create = function create(properties) {
                return new Timestamp(properties);
            };

            /**
             * Encodes the specified Timestamp message. Does not implicitly {@link google.protobuf.Timestamp.verify|verify} messages.
             * @function encode
             * @memberof google.protobuf.Timestamp
             * @static
             * @param {google.protobuf.ITimestamp} m Timestamp message or plain object to encode
             * @param {$protobuf.Writer} [w] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Timestamp.encode = function encode(m, w) {
                if (!w)
                    w = $Writer.create();
                if (m.seconds != null && Object.hasOwnProperty.call(m, "seconds"))
                    w.uint32(8).int64(m.seconds);
                if (m.nanos != null && Object.hasOwnProperty.call(m, "nanos"))
                    w.uint32(16).int32(m.nanos);
                return w;
            };

            /**
             * Decodes a Timestamp message from the specified reader or buffer.
             * @function decode
             * @memberof google.protobuf.Timestamp
             * @static
             * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
             * @param {number} [l] Message length if known beforehand
             * @returns {google.protobuf.Timestamp} Timestamp
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Timestamp.decode = function decode(r, l) {
                if (!(r instanceof $Reader))
                    r = $Reader.create(r);
                var c = l === undefined ? r.len : r.pos + l, m = new $root.google.protobuf.Timestamp();
                while (r.pos < c) {
                    var t = r.uint32();
                    switch (t >>> 3) {
                    case 1:
                        m.seconds = r.int64();
                        break;
                    case 2:
                        m.nanos = r.int32();
                        break;
                    default:
                        r.skipType(t & 7);
                        break;
                    }
                }
                return m;
            };

            return Timestamp;
        })();

        protobuf.Empty = (function() {

            /**
             * Properties of an Empty.
             * @memberof google.protobuf
             * @interface IEmpty
             */

            /**
             * Constructs a new Empty.
             * @memberof google.protobuf
             * @classdesc Represents an Empty.
             * @implements IEmpty
             * @constructor
             * @param {google.protobuf.IEmpty=} [p] Properties to set
             */
            function Empty(p) {
                if (p)
                    for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                        if (p[ks[i]] != null)
                            this[ks[i]] = p[ks[i]];
            }

            /**
             * Creates a new Empty instance using the specified properties.
             * @function create
             * @memberof google.protobuf.Empty
             * @static
             * @param {google.protobuf.IEmpty=} [properties] Properties to set
             * @returns {google.protobuf.Empty} Empty instance
             */
            Empty.create = function create(properties) {
                return new Empty(properties);
            };

            /**
             * Encodes the specified Empty message. Does not implicitly {@link google.protobuf.Empty.verify|verify} messages.
             * @function encode
             * @memberof google.protobuf.Empty
             * @static
             * @param {google.protobuf.IEmpty} m Empty message or plain object to encode
             * @param {$protobuf.Writer} [w] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Empty.encode = function encode(m, w) {
                if (!w)
                    w = $Writer.create();
                return w;
            };

            /**
             * Decodes an Empty message from the specified reader or buffer.
             * @function decode
             * @memberof google.protobuf.Empty
             * @static
             * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
             * @param {number} [l] Message length if known beforehand
             * @returns {google.protobuf.Empty} Empty
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Empty.decode = function decode(r, l) {
                if (!(r instanceof $Reader))
                    r = $Reader.create(r);
                var c = l === undefined ? r.len : r.pos + l, m = new $root.google.protobuf.Empty();
                while (r.pos < c) {
                    var t = r.uint32();
                    switch (t >>> 3) {
                    default:
                        r.skipType(t & 7);
                        break;
                    }
                }
                return m;
            };

            return Empty;
        })();

        protobuf.DoubleValue = (function() {

            /**
             * Properties of a DoubleValue.
             * @memberof google.protobuf
             * @interface IDoubleValue
             * @property {number|null} [value] DoubleValue value
             */

            /**
             * Constructs a new DoubleValue.
             * @memberof google.protobuf
             * @classdesc Represents a DoubleValue.
             * @implements IDoubleValue
             * @constructor
             * @param {google.protobuf.IDoubleValue=} [p] Properties to set
             */
            function DoubleValue(p) {
                if (p)
                    for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                        if (p[ks[i]] != null)
                            this[ks[i]] = p[ks[i]];
            }

            /**
             * DoubleValue value.
             * @member {number} value
             * @memberof google.protobuf.DoubleValue
             * @instance
             */
            DoubleValue.prototype.value = 0;

            /**
             * Creates a new DoubleValue instance using the specified properties.
             * @function create
             * @memberof google.protobuf.DoubleValue
             * @static
             * @param {google.protobuf.IDoubleValue=} [properties] Properties to set
             * @returns {google.protobuf.DoubleValue} DoubleValue instance
             */
            DoubleValue.create = function create(properties) {
                return new DoubleValue(properties);
            };

            /**
             * Encodes the specified DoubleValue message. Does not implicitly {@link google.protobuf.DoubleValue.verify|verify} messages.
             * @function encode
             * @memberof google.protobuf.DoubleValue
             * @static
             * @param {google.protobuf.IDoubleValue} m DoubleValue message or plain object to encode
             * @param {$protobuf.Writer} [w] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            DoubleValue.encode = function encode(m, w) {
                if (!w)
                    w = $Writer.create();
                if (m.value != null && Object.hasOwnProperty.call(m, "value"))
                    w.uint32(9).double(m.value);
                return w;
            };

            /**
             * Decodes a DoubleValue message from the specified reader or buffer.
             * @function decode
             * @memberof google.protobuf.DoubleValue
             * @static
             * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
             * @param {number} [l] Message length if known beforehand
             * @returns {google.protobuf.DoubleValue} DoubleValue
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            DoubleValue.decode = function decode(r, l) {
                if (!(r instanceof $Reader))
                    r = $Reader.create(r);
                var c = l === undefined ? r.len : r.pos + l, m = new $root.google.protobuf.DoubleValue();
                while (r.pos < c) {
                    var t = r.uint32();
                    switch (t >>> 3) {
                    case 1:
                        m.value = r.double();
                        break;
                    default:
                        r.skipType(t & 7);
                        break;
                    }
                }
                return m;
            };

            return DoubleValue;
        })();

        protobuf.FloatValue = (function() {

            /**
             * Properties of a FloatValue.
             * @memberof google.protobuf
             * @interface IFloatValue
             * @property {number|null} [value] FloatValue value
             */

            /**
             * Constructs a new FloatValue.
             * @memberof google.protobuf
             * @classdesc Represents a FloatValue.
             * @implements IFloatValue
             * @constructor
             * @param {google.protobuf.IFloatValue=} [p] Properties to set
             */
            function FloatValue(p) {
                if (p)
                    for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                        if (p[ks[i]] != null)
                            this[ks[i]] = p[ks[i]];
            }

            /**
             * FloatValue value.
             * @member {number} value
             * @memberof google.protobuf.FloatValue
             * @instance
             */
            FloatValue.prototype.value = 0;

            /**
             * Creates a new FloatValue instance using the specified properties.
             * @function create
             * @memberof google.protobuf.FloatValue
             * @static
             * @param {google.protobuf.IFloatValue=} [properties] Properties to set
             * @returns {google.protobuf.FloatValue} FloatValue instance
             */
            FloatValue.create = function create(properties) {
                return new FloatValue(properties);
            };

            /**
             * Encodes the specified FloatValue message. Does not implicitly {@link google.protobuf.FloatValue.verify|verify} messages.
             * @function encode
             * @memberof google.protobuf.FloatValue
             * @static
             * @param {google.protobuf.IFloatValue} m FloatValue message or plain object to encode
             * @param {$protobuf.Writer} [w] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            FloatValue.encode = function encode(m, w) {
                if (!w)
                    w = $Writer.create();
                if (m.value != null && Object.hasOwnProperty.call(m, "value"))
                    w.uint32(13).float(m.value);
                return w;
            };

            /**
             * Decodes a FloatValue message from the specified reader or buffer.
             * @function decode
             * @memberof google.protobuf.FloatValue
             * @static
             * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
             * @param {number} [l] Message length if known beforehand
             * @returns {google.protobuf.FloatValue} FloatValue
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            FloatValue.decode = function decode(r, l) {
                if (!(r instanceof $Reader))
                    r = $Reader.create(r);
                var c = l === undefined ? r.len : r.pos + l, m = new $root.google.protobuf.FloatValue();
                while (r.pos < c) {
                    var t = r.uint32();
                    switch (t >>> 3) {
                    case 1:
                        m.value = r.float();
                        break;
                    default:
                        r.skipType(t & 7);
                        break;
                    }
                }
                return m;
            };

            return FloatValue;
        })();

        protobuf.Int64Value = (function() {

            /**
             * Properties of an Int64Value.
             * @memberof google.protobuf
             * @interface IInt64Value
             * @property {number|Long|null} [value] Int64Value value
             */

            /**
             * Constructs a new Int64Value.
             * @memberof google.protobuf
             * @classdesc Represents an Int64Value.
             * @implements IInt64Value
             * @constructor
             * @param {google.protobuf.IInt64Value=} [p] Properties to set
             */
            function Int64Value(p) {
                if (p)
                    for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                        if (p[ks[i]] != null)
                            this[ks[i]] = p[ks[i]];
            }

            /**
             * Int64Value value.
             * @member {number|Long} value
             * @memberof google.protobuf.Int64Value
             * @instance
             */
            Int64Value.prototype.value = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * Creates a new Int64Value instance using the specified properties.
             * @function create
             * @memberof google.protobuf.Int64Value
             * @static
             * @param {google.protobuf.IInt64Value=} [properties] Properties to set
             * @returns {google.protobuf.Int64Value} Int64Value instance
             */
            Int64Value.create = function create(properties) {
                return new Int64Value(properties);
            };

            /**
             * Encodes the specified Int64Value message. Does not implicitly {@link google.protobuf.Int64Value.verify|verify} messages.
             * @function encode
             * @memberof google.protobuf.Int64Value
             * @static
             * @param {google.protobuf.IInt64Value} m Int64Value message or plain object to encode
             * @param {$protobuf.Writer} [w] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Int64Value.encode = function encode(m, w) {
                if (!w)
                    w = $Writer.create();
                if (m.value != null && Object.hasOwnProperty.call(m, "value"))
                    w.uint32(8).int64(m.value);
                return w;
            };

            /**
             * Decodes an Int64Value message from the specified reader or buffer.
             * @function decode
             * @memberof google.protobuf.Int64Value
             * @static
             * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
             * @param {number} [l] Message length if known beforehand
             * @returns {google.protobuf.Int64Value} Int64Value
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Int64Value.decode = function decode(r, l) {
                if (!(r instanceof $Reader))
                    r = $Reader.create(r);
                var c = l === undefined ? r.len : r.pos + l, m = new $root.google.protobuf.Int64Value();
                while (r.pos < c) {
                    var t = r.uint32();
                    switch (t >>> 3) {
                    case 1:
                        m.value = r.int64();
                        break;
                    default:
                        r.skipType(t & 7);
                        break;
                    }
                }
                return m;
            };

            return Int64Value;
        })();

        protobuf.UInt64Value = (function() {

            /**
             * Properties of a UInt64Value.
             * @memberof google.protobuf
             * @interface IUInt64Value
             * @property {number|Long|null} [value] UInt64Value value
             */

            /**
             * Constructs a new UInt64Value.
             * @memberof google.protobuf
             * @classdesc Represents a UInt64Value.
             * @implements IUInt64Value
             * @constructor
             * @param {google.protobuf.IUInt64Value=} [p] Properties to set
             */
            function UInt64Value(p) {
                if (p)
                    for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                        if (p[ks[i]] != null)
                            this[ks[i]] = p[ks[i]];
            }

            /**
             * UInt64Value value.
             * @member {number|Long} value
             * @memberof google.protobuf.UInt64Value
             * @instance
             */
            UInt64Value.prototype.value = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

            /**
             * Creates a new UInt64Value instance using the specified properties.
             * @function create
             * @memberof google.protobuf.UInt64Value
             * @static
             * @param {google.protobuf.IUInt64Value=} [properties] Properties to set
             * @returns {google.protobuf.UInt64Value} UInt64Value instance
             */
            UInt64Value.create = function create(properties) {
                return new UInt64Value(properties);
            };

            /**
             * Encodes the specified UInt64Value message. Does not implicitly {@link google.protobuf.UInt64Value.verify|verify} messages.
             * @function encode
             * @memberof google.protobuf.UInt64Value
             * @static
             * @param {google.protobuf.IUInt64Value} m UInt64Value message or plain object to encode
             * @param {$protobuf.Writer} [w] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            UInt64Value.encode = function encode(m, w) {
                if (!w)
                    w = $Writer.create();
                if (m.value != null && Object.hasOwnProperty.call(m, "value"))
                    w.uint32(8).uint64(m.value);
                return w;
            };

            /**
             * Decodes a UInt64Value message from the specified reader or buffer.
             * @function decode
             * @memberof google.protobuf.UInt64Value
             * @static
             * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
             * @param {number} [l] Message length if known beforehand
             * @returns {google.protobuf.UInt64Value} UInt64Value
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            UInt64Value.decode = function decode(r, l) {
                if (!(r instanceof $Reader))
                    r = $Reader.create(r);
                var c = l === undefined ? r.len : r.pos + l, m = new $root.google.protobuf.UInt64Value();
                while (r.pos < c) {
                    var t = r.uint32();
                    switch (t >>> 3) {
                    case 1:
                        m.value = r.uint64();
                        break;
                    default:
                        r.skipType(t & 7);
                        break;
                    }
                }
                return m;
            };

            return UInt64Value;
        })();

        protobuf.Int32Value = (function() {

            /**
             * Properties of an Int32Value.
             * @memberof google.protobuf
             * @interface IInt32Value
             * @property {number|null} [value] Int32Value value
             */

            /**
             * Constructs a new Int32Value.
             * @memberof google.protobuf
             * @classdesc Represents an Int32Value.
             * @implements IInt32Value
             * @constructor
             * @param {google.protobuf.IInt32Value=} [p] Properties to set
             */
            function Int32Value(p) {
                if (p)
                    for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                        if (p[ks[i]] != null)
                            this[ks[i]] = p[ks[i]];
            }

            /**
             * Int32Value value.
             * @member {number} value
             * @memberof google.protobuf.Int32Value
             * @instance
             */
            Int32Value.prototype.value = 0;

            /**
             * Creates a new Int32Value instance using the specified properties.
             * @function create
             * @memberof google.protobuf.Int32Value
             * @static
             * @param {google.protobuf.IInt32Value=} [properties] Properties to set
             * @returns {google.protobuf.Int32Value} Int32Value instance
             */
            Int32Value.create = function create(properties) {
                return new Int32Value(properties);
            };

            /**
             * Encodes the specified Int32Value message. Does not implicitly {@link google.protobuf.Int32Value.verify|verify} messages.
             * @function encode
             * @memberof google.protobuf.Int32Value
             * @static
             * @param {google.protobuf.IInt32Value} m Int32Value message or plain object to encode
             * @param {$protobuf.Writer} [w] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Int32Value.encode = function encode(m, w) {
                if (!w)
                    w = $Writer.create();
                if (m.value != null && Object.hasOwnProperty.call(m, "value"))
                    w.uint32(8).int32(m.value);
                return w;
            };

            /**
             * Decodes an Int32Value message from the specified reader or buffer.
             * @function decode
             * @memberof google.protobuf.Int32Value
             * @static
             * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
             * @param {number} [l] Message length if known beforehand
             * @returns {google.protobuf.Int32Value} Int32Value
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Int32Value.decode = function decode(r, l) {
                if (!(r instanceof $Reader))
                    r = $Reader.create(r);
                var c = l === undefined ? r.len : r.pos + l, m = new $root.google.protobuf.Int32Value();
                while (r.pos < c) {
                    var t = r.uint32();
                    switch (t >>> 3) {
                    case 1:
                        m.value = r.int32();
                        break;
                    default:
                        r.skipType(t & 7);
                        break;
                    }
                }
                return m;
            };

            return Int32Value;
        })();

        protobuf.UInt32Value = (function() {

            /**
             * Properties of a UInt32Value.
             * @memberof google.protobuf
             * @interface IUInt32Value
             * @property {number|null} [value] UInt32Value value
             */

            /**
             * Constructs a new UInt32Value.
             * @memberof google.protobuf
             * @classdesc Represents a UInt32Value.
             * @implements IUInt32Value
             * @constructor
             * @param {google.protobuf.IUInt32Value=} [p] Properties to set
             */
            function UInt32Value(p) {
                if (p)
                    for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                        if (p[ks[i]] != null)
                            this[ks[i]] = p[ks[i]];
            }

            /**
             * UInt32Value value.
             * @member {number} value
             * @memberof google.protobuf.UInt32Value
             * @instance
             */
            UInt32Value.prototype.value = 0;

            /**
             * Creates a new UInt32Value instance using the specified properties.
             * @function create
             * @memberof google.protobuf.UInt32Value
             * @static
             * @param {google.protobuf.IUInt32Value=} [properties] Properties to set
             * @returns {google.protobuf.UInt32Value} UInt32Value instance
             */
            UInt32Value.create = function create(properties) {
                return new UInt32Value(properties);
            };

            /**
             * Encodes the specified UInt32Value message. Does not implicitly {@link google.protobuf.UInt32Value.verify|verify} messages.
             * @function encode
             * @memberof google.protobuf.UInt32Value
             * @static
             * @param {google.protobuf.IUInt32Value} m UInt32Value message or plain object to encode
             * @param {$protobuf.Writer} [w] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            UInt32Value.encode = function encode(m, w) {
                if (!w)
                    w = $Writer.create();
                if (m.value != null && Object.hasOwnProperty.call(m, "value"))
                    w.uint32(8).uint32(m.value);
                return w;
            };

            /**
             * Decodes a UInt32Value message from the specified reader or buffer.
             * @function decode
             * @memberof google.protobuf.UInt32Value
             * @static
             * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
             * @param {number} [l] Message length if known beforehand
             * @returns {google.protobuf.UInt32Value} UInt32Value
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            UInt32Value.decode = function decode(r, l) {
                if (!(r instanceof $Reader))
                    r = $Reader.create(r);
                var c = l === undefined ? r.len : r.pos + l, m = new $root.google.protobuf.UInt32Value();
                while (r.pos < c) {
                    var t = r.uint32();
                    switch (t >>> 3) {
                    case 1:
                        m.value = r.uint32();
                        break;
                    default:
                        r.skipType(t & 7);
                        break;
                    }
                }
                return m;
            };

            return UInt32Value;
        })();

        protobuf.BoolValue = (function() {

            /**
             * Properties of a BoolValue.
             * @memberof google.protobuf
             * @interface IBoolValue
             * @property {boolean|null} [value] BoolValue value
             */

            /**
             * Constructs a new BoolValue.
             * @memberof google.protobuf
             * @classdesc Represents a BoolValue.
             * @implements IBoolValue
             * @constructor
             * @param {google.protobuf.IBoolValue=} [p] Properties to set
             */
            function BoolValue(p) {
                if (p)
                    for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                        if (p[ks[i]] != null)
                            this[ks[i]] = p[ks[i]];
            }

            /**
             * BoolValue value.
             * @member {boolean} value
             * @memberof google.protobuf.BoolValue
             * @instance
             */
            BoolValue.prototype.value = false;

            /**
             * Creates a new BoolValue instance using the specified properties.
             * @function create
             * @memberof google.protobuf.BoolValue
             * @static
             * @param {google.protobuf.IBoolValue=} [properties] Properties to set
             * @returns {google.protobuf.BoolValue} BoolValue instance
             */
            BoolValue.create = function create(properties) {
                return new BoolValue(properties);
            };

            /**
             * Encodes the specified BoolValue message. Does not implicitly {@link google.protobuf.BoolValue.verify|verify} messages.
             * @function encode
             * @memberof google.protobuf.BoolValue
             * @static
             * @param {google.protobuf.IBoolValue} m BoolValue message or plain object to encode
             * @param {$protobuf.Writer} [w] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            BoolValue.encode = function encode(m, w) {
                if (!w)
                    w = $Writer.create();
                if (m.value != null && Object.hasOwnProperty.call(m, "value"))
                    w.uint32(8).bool(m.value);
                return w;
            };

            /**
             * Decodes a BoolValue message from the specified reader or buffer.
             * @function decode
             * @memberof google.protobuf.BoolValue
             * @static
             * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
             * @param {number} [l] Message length if known beforehand
             * @returns {google.protobuf.BoolValue} BoolValue
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            BoolValue.decode = function decode(r, l) {
                if (!(r instanceof $Reader))
                    r = $Reader.create(r);
                var c = l === undefined ? r.len : r.pos + l, m = new $root.google.protobuf.BoolValue();
                while (r.pos < c) {
                    var t = r.uint32();
                    switch (t >>> 3) {
                    case 1:
                        m.value = r.bool();
                        break;
                    default:
                        r.skipType(t & 7);
                        break;
                    }
                }
                return m;
            };

            return BoolValue;
        })();

        protobuf.StringValue = (function() {

            /**
             * Properties of a StringValue.
             * @memberof google.protobuf
             * @interface IStringValue
             * @property {string|null} [value] StringValue value
             */

            /**
             * Constructs a new StringValue.
             * @memberof google.protobuf
             * @classdesc Represents a StringValue.
             * @implements IStringValue
             * @constructor
             * @param {google.protobuf.IStringValue=} [p] Properties to set
             */
            function StringValue(p) {
                if (p)
                    for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                        if (p[ks[i]] != null)
                            this[ks[i]] = p[ks[i]];
            }

            /**
             * StringValue value.
             * @member {string} value
             * @memberof google.protobuf.StringValue
             * @instance
             */
            StringValue.prototype.value = "";

            /**
             * Creates a new StringValue instance using the specified properties.
             * @function create
             * @memberof google.protobuf.StringValue
             * @static
             * @param {google.protobuf.IStringValue=} [properties] Properties to set
             * @returns {google.protobuf.StringValue} StringValue instance
             */
            StringValue.create = function create(properties) {
                return new StringValue(properties);
            };

            /**
             * Encodes the specified StringValue message. Does not implicitly {@link google.protobuf.StringValue.verify|verify} messages.
             * @function encode
             * @memberof google.protobuf.StringValue
             * @static
             * @param {google.protobuf.IStringValue} m StringValue message or plain object to encode
             * @param {$protobuf.Writer} [w] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            StringValue.encode = function encode(m, w) {
                if (!w)
                    w = $Writer.create();
                if (m.value != null && Object.hasOwnProperty.call(m, "value"))
                    w.uint32(10).string(m.value);
                return w;
            };

            /**
             * Decodes a StringValue message from the specified reader or buffer.
             * @function decode
             * @memberof google.protobuf.StringValue
             * @static
             * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
             * @param {number} [l] Message length if known beforehand
             * @returns {google.protobuf.StringValue} StringValue
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            StringValue.decode = function decode(r, l) {
                if (!(r instanceof $Reader))
                    r = $Reader.create(r);
                var c = l === undefined ? r.len : r.pos + l, m = new $root.google.protobuf.StringValue();
                while (r.pos < c) {
                    var t = r.uint32();
                    switch (t >>> 3) {
                    case 1:
                        m.value = r.string();
                        break;
                    default:
                        r.skipType(t & 7);
                        break;
                    }
                }
                return m;
            };

            return StringValue;
        })();

        protobuf.BytesValue = (function() {

            /**
             * Properties of a BytesValue.
             * @memberof google.protobuf
             * @interface IBytesValue
             * @property {Uint8Array|null} [value] BytesValue value
             */

            /**
             * Constructs a new BytesValue.
             * @memberof google.protobuf
             * @classdesc Represents a BytesValue.
             * @implements IBytesValue
             * @constructor
             * @param {google.protobuf.IBytesValue=} [p] Properties to set
             */
            function BytesValue(p) {
                if (p)
                    for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                        if (p[ks[i]] != null)
                            this[ks[i]] = p[ks[i]];
            }

            /**
             * BytesValue value.
             * @member {Uint8Array} value
             * @memberof google.protobuf.BytesValue
             * @instance
             */
            BytesValue.prototype.value = $util.newBuffer([]);

            /**
             * Creates a new BytesValue instance using the specified properties.
             * @function create
             * @memberof google.protobuf.BytesValue
             * @static
             * @param {google.protobuf.IBytesValue=} [properties] Properties to set
             * @returns {google.protobuf.BytesValue} BytesValue instance
             */
            BytesValue.create = function create(properties) {
                return new BytesValue(properties);
            };

            /**
             * Encodes the specified BytesValue message. Does not implicitly {@link google.protobuf.BytesValue.verify|verify} messages.
             * @function encode
             * @memberof google.protobuf.BytesValue
             * @static
             * @param {google.protobuf.IBytesValue} m BytesValue message or plain object to encode
             * @param {$protobuf.Writer} [w] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            BytesValue.encode = function encode(m, w) {
                if (!w)
                    w = $Writer.create();
                if (m.value != null && Object.hasOwnProperty.call(m, "value"))
                    w.uint32(10).bytes(m.value);
                return w;
            };

            /**
             * Decodes a BytesValue message from the specified reader or buffer.
             * @function decode
             * @memberof google.protobuf.BytesValue
             * @static
             * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
             * @param {number} [l] Message length if known beforehand
             * @returns {google.protobuf.BytesValue} BytesValue
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            BytesValue.decode = function decode(r, l) {
                if (!(r instanceof $Reader))
                    r = $Reader.create(r);
                var c = l === undefined ? r.len : r.pos + l, m = new $root.google.protobuf.BytesValue();
                while (r.pos < c) {
                    var t = r.uint32();
                    switch (t >>> 3) {
                    case 1:
                        m.value = r.bytes();
                        break;
                    default:
                        r.skipType(t & 7);
                        break;
                    }
                }
                return m;
            };

            return BytesValue;
        })();

        protobuf.Struct = (function() {

            /**
             * Properties of a Struct.
             * @memberof google.protobuf
             * @interface IStruct
             * @property {Object.<string,google.protobuf.IValue>|null} [fields] Struct fields
             */

            /**
             * Constructs a new Struct.
             * @memberof google.protobuf
             * @classdesc Represents a Struct.
             * @implements IStruct
             * @constructor
             * @param {google.protobuf.IStruct=} [p] Properties to set
             */
            function Struct(p) {
                this.fields = {};
                if (p)
                    for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                        if (p[ks[i]] != null)
                            this[ks[i]] = p[ks[i]];
            }

            /**
             * Struct fields.
             * @member {Object.<string,google.protobuf.IValue>} fields
             * @memberof google.protobuf.Struct
             * @instance
             */
            Struct.prototype.fields = $util.emptyObject;

            /**
             * Creates a new Struct instance using the specified properties.
             * @function create
             * @memberof google.protobuf.Struct
             * @static
             * @param {google.protobuf.IStruct=} [properties] Properties to set
             * @returns {google.protobuf.Struct} Struct instance
             */
            Struct.create = function create(properties) {
                return new Struct(properties);
            };

            /**
             * Encodes the specified Struct message. Does not implicitly {@link google.protobuf.Struct.verify|verify} messages.
             * @function encode
             * @memberof google.protobuf.Struct
             * @static
             * @param {google.protobuf.IStruct} m Struct message or plain object to encode
             * @param {$protobuf.Writer} [w] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Struct.encode = function encode(m, w) {
                if (!w)
                    w = $Writer.create();
                if (m.fields != null && Object.hasOwnProperty.call(m, "fields")) {
                    for (var ks = Object.keys(m.fields), i = 0; i < ks.length; ++i) {
                        w.uint32(10).fork().uint32(10).string(ks[i]);
                        $root.google.protobuf.Value.encode(m.fields[ks[i]], w.uint32(18).fork()).ldelim().ldelim();
                    }
                }
                return w;
            };

            /**
             * Decodes a Struct message from the specified reader or buffer.
             * @function decode
             * @memberof google.protobuf.Struct
             * @static
             * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
             * @param {number} [l] Message length if known beforehand
             * @returns {google.protobuf.Struct} Struct
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Struct.decode = function decode(r, l) {
                if (!(r instanceof $Reader))
                    r = $Reader.create(r);
                var c = l === undefined ? r.len : r.pos + l, m = new $root.google.protobuf.Struct(), k, value;
                while (r.pos < c) {
                    var t = r.uint32();
                    switch (t >>> 3) {
                    case 1:
                        if (m.fields === $util.emptyObject)
                            m.fields = {};
                        var c2 = r.uint32() + r.pos;
                        k = "";
                        value = null;
                        while (r.pos < c2) {
                            var tag2 = r.uint32();
                            switch (tag2 >>> 3) {
                            case 1:
                                k = r.string();
                                break;
                            case 2:
                                value = $root.google.protobuf.Value.decode(r, r.uint32());
                                break;
                            default:
                                r.skipType(tag2 & 7);
                                break;
                            }
                        }
                        m.fields[k] = value;
                        break;
                    default:
                        r.skipType(t & 7);
                        break;
                    }
                }
                return m;
            };

            return Struct;
        })();

        protobuf.Value = (function() {

            /**
             * Properties of a Value.
             * @memberof google.protobuf
             * @interface IValue
             * @property {google.protobuf.NullValue|null} [nullValue] Value nullValue
             * @property {number|null} [numberValue] Value numberValue
             * @property {string|null} [stringValue] Value stringValue
             * @property {boolean|null} [boolValue] Value boolValue
             * @property {google.protobuf.IStruct|null} [structValue] Value structValue
             * @property {google.protobuf.IListValue|null} [listValue] Value listValue
             */

            /**
             * Constructs a new Value.
             * @memberof google.protobuf
             * @classdesc Represents a Value.
             * @implements IValue
             * @constructor
             * @param {google.protobuf.IValue=} [p] Properties to set
             */
            function Value(p) {
                if (p)
                    for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                        if (p[ks[i]] != null)
                            this[ks[i]] = p[ks[i]];
            }

            /**
             * Value nullValue.
             * @member {google.protobuf.NullValue|null|undefined} nullValue
             * @memberof google.protobuf.Value
             * @instance
             */
            Value.prototype.nullValue = null;

            /**
             * Value numberValue.
             * @member {number|null|undefined} numberValue
             * @memberof google.protobuf.Value
             * @instance
             */
            Value.prototype.numberValue = null;

            /**
             * Value stringValue.
             * @member {string|null|undefined} stringValue
             * @memberof google.protobuf.Value
             * @instance
             */
            Value.prototype.stringValue = null;

            /**
             * Value boolValue.
             * @member {boolean|null|undefined} boolValue
             * @memberof google.protobuf.Value
             * @instance
             */
            Value.prototype.boolValue = null;

            /**
             * Value structValue.
             * @member {google.protobuf.IStruct|null|undefined} structValue
             * @memberof google.protobuf.Value
             * @instance
             */
            Value.prototype.structValue = null;

            /**
             * Value listValue.
             * @member {google.protobuf.IListValue|null|undefined} listValue
             * @memberof google.protobuf.Value
             * @instance
             */
            Value.prototype.listValue = null;

            // OneOf field names bound to virtual getters and setters
            let $oneOfFields;

            /**
             * Value kind.
             * @member {"nullValue"|"numberValue"|"stringValue"|"boolValue"|"structValue"|"listValue"|undefined} kind
             * @memberof google.protobuf.Value
             * @instance
             */
            Object.defineProperty(Value.prototype, "kind", {
                get: $util.oneOfGetter($oneOfFields = ["nullValue", "numberValue", "stringValue", "boolValue", "structValue", "listValue"]),
                set: $util.oneOfSetter($oneOfFields)
            });

            /**
             * Creates a new Value instance using the specified properties.
             * @function create
             * @memberof google.protobuf.Value
             * @static
             * @param {google.protobuf.IValue=} [properties] Properties to set
             * @returns {google.protobuf.Value} Value instance
             */
            Value.create = function create(properties) {
                return new Value(properties);
            };

            /**
             * Encodes the specified Value message. Does not implicitly {@link google.protobuf.Value.verify|verify} messages.
             * @function encode
             * @memberof google.protobuf.Value
             * @static
             * @param {google.protobuf.IValue} m Value message or plain object to encode
             * @param {$protobuf.Writer} [w] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Value.encode = function encode(m, w) {
                if (!w)
                    w = $Writer.create();
                if (m.nullValue != null && Object.hasOwnProperty.call(m, "nullValue"))
                    w.uint32(8).int32(m.nullValue);
                if (m.numberValue != null && Object.hasOwnProperty.call(m, "numberValue"))
                    w.uint32(17).double(m.numberValue);
                if (m.stringValue != null && Object.hasOwnProperty.call(m, "stringValue"))
                    w.uint32(26).string(m.stringValue);
                if (m.boolValue != null && Object.hasOwnProperty.call(m, "boolValue"))
                    w.uint32(32).bool(m.boolValue);
                if (m.structValue != null && Object.hasOwnProperty.call(m, "structValue"))
                    $root.google.protobuf.Struct.encode(m.structValue, w.uint32(42).fork()).ldelim();
                if (m.listValue != null && Object.hasOwnProperty.call(m, "listValue"))
                    $root.google.protobuf.ListValue.encode(m.listValue, w.uint32(50).fork()).ldelim();
                return w;
            };

            /**
             * Decodes a Value message from the specified reader or buffer.
             * @function decode
             * @memberof google.protobuf.Value
             * @static
             * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
             * @param {number} [l] Message length if known beforehand
             * @returns {google.protobuf.Value} Value
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Value.decode = function decode(r, l) {
                if (!(r instanceof $Reader))
                    r = $Reader.create(r);
                var c = l === undefined ? r.len : r.pos + l, m = new $root.google.protobuf.Value();
                while (r.pos < c) {
                    var t = r.uint32();
                    switch (t >>> 3) {
                    case 1:
                        m.nullValue = r.int32();
                        break;
                    case 2:
                        m.numberValue = r.double();
                        break;
                    case 3:
                        m.stringValue = r.string();
                        break;
                    case 4:
                        m.boolValue = r.bool();
                        break;
                    case 5:
                        m.structValue = $root.google.protobuf.Struct.decode(r, r.uint32());
                        break;
                    case 6:
                        m.listValue = $root.google.protobuf.ListValue.decode(r, r.uint32());
                        break;
                    default:
                        r.skipType(t & 7);
                        break;
                    }
                }
                return m;
            };

            return Value;
        })();

        /**
         * NullValue enum.
         * @name google.protobuf.NullValue
         * @enum {number}
         * @property {number} NULL_VALUE=0 NULL_VALUE value
         */
        protobuf.NullValue = (function() {
            const valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "NULL_VALUE"] = 0;
            return values;
        })();

        protobuf.ListValue = (function() {

            /**
             * Properties of a ListValue.
             * @memberof google.protobuf
             * @interface IListValue
             * @property {Array.<google.protobuf.IValue>|null} [values] ListValue values
             */

            /**
             * Constructs a new ListValue.
             * @memberof google.protobuf
             * @classdesc Represents a ListValue.
             * @implements IListValue
             * @constructor
             * @param {google.protobuf.IListValue=} [p] Properties to set
             */
            function ListValue(p) {
                this.values = [];
                if (p)
                    for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                        if (p[ks[i]] != null)
                            this[ks[i]] = p[ks[i]];
            }

            /**
             * ListValue values.
             * @member {Array.<google.protobuf.IValue>} values
             * @memberof google.protobuf.ListValue
             * @instance
             */
            ListValue.prototype.values = $util.emptyArray;

            /**
             * Creates a new ListValue instance using the specified properties.
             * @function create
             * @memberof google.protobuf.ListValue
             * @static
             * @param {google.protobuf.IListValue=} [properties] Properties to set
             * @returns {google.protobuf.ListValue} ListValue instance
             */
            ListValue.create = function create(properties) {
                return new ListValue(properties);
            };

            /**
             * Encodes the specified ListValue message. Does not implicitly {@link google.protobuf.ListValue.verify|verify} messages.
             * @function encode
             * @memberof google.protobuf.ListValue
             * @static
             * @param {google.protobuf.IListValue} m ListValue message or plain object to encode
             * @param {$protobuf.Writer} [w] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ListValue.encode = function encode(m, w) {
                if (!w)
                    w = $Writer.create();
                if (m.values != null && m.values.length) {
                    for (var i = 0; i < m.values.length; ++i)
                        $root.google.protobuf.Value.encode(m.values[i], w.uint32(10).fork()).ldelim();
                }
                return w;
            };

            /**
             * Decodes a ListValue message from the specified reader or buffer.
             * @function decode
             * @memberof google.protobuf.ListValue
             * @static
             * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
             * @param {number} [l] Message length if known beforehand
             * @returns {google.protobuf.ListValue} ListValue
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ListValue.decode = function decode(r, l) {
                if (!(r instanceof $Reader))
                    r = $Reader.create(r);
                var c = l === undefined ? r.len : r.pos + l, m = new $root.google.protobuf.ListValue();
                while (r.pos < c) {
                    var t = r.uint32();
                    switch (t >>> 3) {
                    case 1:
                        if (!(m.values && m.values.length))
                            m.values = [];
                        m.values.push($root.google.protobuf.Value.decode(r, r.uint32()));
                        break;
                    default:
                        r.skipType(t & 7);
                        break;
                    }
                }
                return m;
            };

            return ListValue;
        })();

        return protobuf;
    })();

    return google;
})();

export const propertypb = $root.propertypb = (() => {

    /**
     * Namespace propertypb.
     * @exports propertypb
     * @namespace
     */
    const propertypb = {};

    propertypb.Attributes = (function() {

        /**
         * Properties of an Attributes.
         * @memberof propertypb
         * @interface IAttributes
         * @property {propertypb.Attributes.ISquareFootageRange|null} [squareFootageRange] Attributes squareFootageRange
         * @property {number|null} [yearBuilt] Attributes yearBuilt
         * @property {propertypb.Attributes.Zoning|null} [zoning] Attributes zoning
         * @property {propertypb.Attributes.DwellingType|null} [dwellingType] Attributes dwellingType
         * @property {Array.<string>|null} [parcelNumbers] Attributes parcelNumbers
         */

        /**
         * Constructs a new Attributes.
         * @memberof propertypb
         * @classdesc Represents an Attributes.
         * @implements IAttributes
         * @constructor
         * @param {propertypb.IAttributes=} [p] Properties to set
         */
        function Attributes(p) {
            this.parcelNumbers = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * Attributes squareFootageRange.
         * @member {propertypb.Attributes.ISquareFootageRange|null|undefined} squareFootageRange
         * @memberof propertypb.Attributes
         * @instance
         */
        Attributes.prototype.squareFootageRange = null;

        /**
         * Attributes yearBuilt.
         * @member {number} yearBuilt
         * @memberof propertypb.Attributes
         * @instance
         */
        Attributes.prototype.yearBuilt = 0;

        /**
         * Attributes zoning.
         * @member {propertypb.Attributes.Zoning} zoning
         * @memberof propertypb.Attributes
         * @instance
         */
        Attributes.prototype.zoning = 0;

        /**
         * Attributes dwellingType.
         * @member {propertypb.Attributes.DwellingType} dwellingType
         * @memberof propertypb.Attributes
         * @instance
         */
        Attributes.prototype.dwellingType = 0;

        /**
         * Attributes parcelNumbers.
         * @member {Array.<string>} parcelNumbers
         * @memberof propertypb.Attributes
         * @instance
         */
        Attributes.prototype.parcelNumbers = $util.emptyArray;

        /**
         * Creates a new Attributes instance using the specified properties.
         * @function create
         * @memberof propertypb.Attributes
         * @static
         * @param {propertypb.IAttributes=} [properties] Properties to set
         * @returns {propertypb.Attributes} Attributes instance
         */
        Attributes.create = function create(properties) {
            return new Attributes(properties);
        };

        /**
         * Encodes the specified Attributes message. Does not implicitly {@link propertypb.Attributes.verify|verify} messages.
         * @function encode
         * @memberof propertypb.Attributes
         * @static
         * @param {propertypb.IAttributes} m Attributes message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Attributes.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.squareFootageRange != null && Object.hasOwnProperty.call(m, "squareFootageRange"))
                $root.propertypb.Attributes.SquareFootageRange.encode(m.squareFootageRange, w.uint32(10).fork()).ldelim();
            if (m.yearBuilt != null && Object.hasOwnProperty.call(m, "yearBuilt"))
                w.uint32(16).uint32(m.yearBuilt);
            if (m.zoning != null && Object.hasOwnProperty.call(m, "zoning"))
                w.uint32(24).int32(m.zoning);
            if (m.dwellingType != null && Object.hasOwnProperty.call(m, "dwellingType"))
                w.uint32(32).int32(m.dwellingType);
            if (m.parcelNumbers != null && m.parcelNumbers.length) {
                for (var i = 0; i < m.parcelNumbers.length; ++i)
                    w.uint32(42).string(m.parcelNumbers[i]);
            }
            return w;
        };

        /**
         * Decodes an Attributes message from the specified reader or buffer.
         * @function decode
         * @memberof propertypb.Attributes
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {propertypb.Attributes} Attributes
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Attributes.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.propertypb.Attributes();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.squareFootageRange = $root.propertypb.Attributes.SquareFootageRange.decode(r, r.uint32());
                    break;
                case 2:
                    m.yearBuilt = r.uint32();
                    break;
                case 3:
                    m.zoning = r.int32();
                    break;
                case 4:
                    m.dwellingType = r.int32();
                    break;
                case 5:
                    if (!(m.parcelNumbers && m.parcelNumbers.length))
                        m.parcelNumbers = [];
                    m.parcelNumbers.push(r.string());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        Attributes.SquareFootageRange = (function() {

            /**
             * Properties of a SquareFootageRange.
             * @memberof propertypb.Attributes
             * @interface ISquareFootageRange
             * @property {number|null} [min] SquareFootageRange min
             * @property {number|null} [max] SquareFootageRange max
             */

            /**
             * Constructs a new SquareFootageRange.
             * @memberof propertypb.Attributes
             * @classdesc Represents a SquareFootageRange.
             * @implements ISquareFootageRange
             * @constructor
             * @param {propertypb.Attributes.ISquareFootageRange=} [p] Properties to set
             */
            function SquareFootageRange(p) {
                if (p)
                    for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                        if (p[ks[i]] != null)
                            this[ks[i]] = p[ks[i]];
            }

            /**
             * SquareFootageRange min.
             * @member {number} min
             * @memberof propertypb.Attributes.SquareFootageRange
             * @instance
             */
            SquareFootageRange.prototype.min = 0;

            /**
             * SquareFootageRange max.
             * @member {number} max
             * @memberof propertypb.Attributes.SquareFootageRange
             * @instance
             */
            SquareFootageRange.prototype.max = 0;

            /**
             * Creates a new SquareFootageRange instance using the specified properties.
             * @function create
             * @memberof propertypb.Attributes.SquareFootageRange
             * @static
             * @param {propertypb.Attributes.ISquareFootageRange=} [properties] Properties to set
             * @returns {propertypb.Attributes.SquareFootageRange} SquareFootageRange instance
             */
            SquareFootageRange.create = function create(properties) {
                return new SquareFootageRange(properties);
            };

            /**
             * Encodes the specified SquareFootageRange message. Does not implicitly {@link propertypb.Attributes.SquareFootageRange.verify|verify} messages.
             * @function encode
             * @memberof propertypb.Attributes.SquareFootageRange
             * @static
             * @param {propertypb.Attributes.ISquareFootageRange} m SquareFootageRange message or plain object to encode
             * @param {$protobuf.Writer} [w] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            SquareFootageRange.encode = function encode(m, w) {
                if (!w)
                    w = $Writer.create();
                if (m.min != null && Object.hasOwnProperty.call(m, "min"))
                    w.uint32(8).uint32(m.min);
                if (m.max != null && Object.hasOwnProperty.call(m, "max"))
                    w.uint32(16).uint32(m.max);
                return w;
            };

            /**
             * Decodes a SquareFootageRange message from the specified reader or buffer.
             * @function decode
             * @memberof propertypb.Attributes.SquareFootageRange
             * @static
             * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
             * @param {number} [l] Message length if known beforehand
             * @returns {propertypb.Attributes.SquareFootageRange} SquareFootageRange
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            SquareFootageRange.decode = function decode(r, l) {
                if (!(r instanceof $Reader))
                    r = $Reader.create(r);
                var c = l === undefined ? r.len : r.pos + l, m = new $root.propertypb.Attributes.SquareFootageRange();
                while (r.pos < c) {
                    var t = r.uint32();
                    switch (t >>> 3) {
                    case 1:
                        m.min = r.uint32();
                        break;
                    case 2:
                        m.max = r.uint32();
                        break;
                    default:
                        r.skipType(t & 7);
                        break;
                    }
                }
                return m;
            };

            return SquareFootageRange;
        })();

        /**
         * Zoning enum.
         * @name propertypb.Attributes.Zoning
         * @enum {number}
         * @property {number} RESIDENTIAL=0 RESIDENTIAL value
         * @property {number} COMMERCIAL=1 COMMERCIAL value
         * @property {number} UNKNOWN_ZONING=2 UNKNOWN_ZONING value
         */
        Attributes.Zoning = (function() {
            const valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "RESIDENTIAL"] = 0;
            values[valuesById[1] = "COMMERCIAL"] = 1;
            values[valuesById[2] = "UNKNOWN_ZONING"] = 2;
            return values;
        })();

        /**
         * DwellingType enum.
         * @name propertypb.Attributes.DwellingType
         * @enum {number}
         * @property {number} SINGLE_FAMILY=0 SINGLE_FAMILY value
         * @property {number} CONDO=1 CONDO value
         * @property {number} TOWNHOME=2 TOWNHOME value
         * @property {number} MOBILE_HOME=3 MOBILE_HOME value
         * @property {number} DUPLEX=4 DUPLEX value
         * @property {number} TRIPLEX=5 TRIPLEX value
         * @property {number} FOUR_PLEX=6 FOUR_PLEX value
         * @property {number} MULTI_UNIT=7 MULTI_UNIT value
         * @property {number} UNKNOWN_DWELLING_TYPE=8 UNKNOWN_DWELLING_TYPE value
         */
        Attributes.DwellingType = (function() {
            const valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "SINGLE_FAMILY"] = 0;
            values[valuesById[1] = "CONDO"] = 1;
            values[valuesById[2] = "TOWNHOME"] = 2;
            values[valuesById[3] = "MOBILE_HOME"] = 3;
            values[valuesById[4] = "DUPLEX"] = 4;
            values[valuesById[5] = "TRIPLEX"] = 5;
            values[valuesById[6] = "FOUR_PLEX"] = 6;
            values[valuesById[7] = "MULTI_UNIT"] = 7;
            values[valuesById[8] = "UNKNOWN_DWELLING_TYPE"] = 8;
            return values;
        })();

        return Attributes;
    })();

    propertypb.MetaData = (function() {

        /**
         * Properties of a MetaData.
         * @memberof propertypb
         * @interface IMetaData
         * @property {number|Long|null} [createdAt] MetaData createdAt
         * @property {number|Long|null} [lastUpdated] MetaData lastUpdated
         * @property {string|null} [datasource] MetaData datasource
         */

        /**
         * Constructs a new MetaData.
         * @memberof propertypb
         * @classdesc Represents a MetaData.
         * @implements IMetaData
         * @constructor
         * @param {propertypb.IMetaData=} [p] Properties to set
         */
        function MetaData(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * MetaData createdAt.
         * @member {number|Long} createdAt
         * @memberof propertypb.MetaData
         * @instance
         */
        MetaData.prototype.createdAt = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * MetaData lastUpdated.
         * @member {number|Long} lastUpdated
         * @memberof propertypb.MetaData
         * @instance
         */
        MetaData.prototype.lastUpdated = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * MetaData datasource.
         * @member {string} datasource
         * @memberof propertypb.MetaData
         * @instance
         */
        MetaData.prototype.datasource = "";

        /**
         * Creates a new MetaData instance using the specified properties.
         * @function create
         * @memberof propertypb.MetaData
         * @static
         * @param {propertypb.IMetaData=} [properties] Properties to set
         * @returns {propertypb.MetaData} MetaData instance
         */
        MetaData.create = function create(properties) {
            return new MetaData(properties);
        };

        /**
         * Encodes the specified MetaData message. Does not implicitly {@link propertypb.MetaData.verify|verify} messages.
         * @function encode
         * @memberof propertypb.MetaData
         * @static
         * @param {propertypb.IMetaData} m MetaData message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MetaData.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.createdAt != null && Object.hasOwnProperty.call(m, "createdAt"))
                w.uint32(8).int64(m.createdAt);
            if (m.lastUpdated != null && Object.hasOwnProperty.call(m, "lastUpdated"))
                w.uint32(16).int64(m.lastUpdated);
            if (m.datasource != null && Object.hasOwnProperty.call(m, "datasource"))
                w.uint32(26).string(m.datasource);
            return w;
        };

        /**
         * Decodes a MetaData message from the specified reader or buffer.
         * @function decode
         * @memberof propertypb.MetaData
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {propertypb.MetaData} MetaData
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MetaData.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.propertypb.MetaData();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.createdAt = r.int64();
                    break;
                case 2:
                    m.lastUpdated = r.int64();
                    break;
                case 3:
                    m.datasource = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return MetaData;
    })();

    propertypb.Property = (function() {

        /**
         * Properties of a Property.
         * @memberof propertypb
         * @interface IProperty
         * @property {string|null} [ID] Property ID
         * @property {string|null} [addressID] Property addressID
         * @property {Array.<number|Long>|null} [legacyIDs] Property legacyIDs
         * @property {propertypb.IAttributes|null} [attributes] Property attributes
         * @property {propertypb.IMetaData|null} [meta] Property meta
         * @property {number|null} [numberMotherLawUnits] Property numberMotherLawUnits
         * @property {number|null} [propertyValue] Property propertyValue
         */

        /**
         * Constructs a new Property.
         * @memberof propertypb
         * @classdesc Represents a Property.
         * @implements IProperty
         * @constructor
         * @param {propertypb.IProperty=} [p] Properties to set
         */
        function Property(p) {
            this.legacyIDs = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * Property ID.
         * @member {string} ID
         * @memberof propertypb.Property
         * @instance
         */
        Property.prototype.ID = "";

        /**
         * Property addressID.
         * @member {string} addressID
         * @memberof propertypb.Property
         * @instance
         */
        Property.prototype.addressID = "";

        /**
         * Property legacyIDs.
         * @member {Array.<number|Long>} legacyIDs
         * @memberof propertypb.Property
         * @instance
         */
        Property.prototype.legacyIDs = $util.emptyArray;

        /**
         * Property attributes.
         * @member {propertypb.IAttributes|null|undefined} attributes
         * @memberof propertypb.Property
         * @instance
         */
        Property.prototype.attributes = null;

        /**
         * Property meta.
         * @member {propertypb.IMetaData|null|undefined} meta
         * @memberof propertypb.Property
         * @instance
         */
        Property.prototype.meta = null;

        /**
         * Property numberMotherLawUnits.
         * @member {number} numberMotherLawUnits
         * @memberof propertypb.Property
         * @instance
         */
        Property.prototype.numberMotherLawUnits = 0;

        /**
         * Property propertyValue.
         * @member {number} propertyValue
         * @memberof propertypb.Property
         * @instance
         */
        Property.prototype.propertyValue = 0;

        /**
         * Creates a new Property instance using the specified properties.
         * @function create
         * @memberof propertypb.Property
         * @static
         * @param {propertypb.IProperty=} [properties] Properties to set
         * @returns {propertypb.Property} Property instance
         */
        Property.create = function create(properties) {
            return new Property(properties);
        };

        /**
         * Encodes the specified Property message. Does not implicitly {@link propertypb.Property.verify|verify} messages.
         * @function encode
         * @memberof propertypb.Property
         * @static
         * @param {propertypb.IProperty} m Property message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Property.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.ID != null && Object.hasOwnProperty.call(m, "ID"))
                w.uint32(10).string(m.ID);
            if (m.addressID != null && Object.hasOwnProperty.call(m, "addressID"))
                w.uint32(18).string(m.addressID);
            if (m.legacyIDs != null && m.legacyIDs.length) {
                w.uint32(26).fork();
                for (var i = 0; i < m.legacyIDs.length; ++i)
                    w.uint64(m.legacyIDs[i]);
                w.ldelim();
            }
            if (m.attributes != null && Object.hasOwnProperty.call(m, "attributes"))
                $root.propertypb.Attributes.encode(m.attributes, w.uint32(34).fork()).ldelim();
            if (m.meta != null && Object.hasOwnProperty.call(m, "meta"))
                $root.propertypb.MetaData.encode(m.meta, w.uint32(42).fork()).ldelim();
            if (m.numberMotherLawUnits != null && Object.hasOwnProperty.call(m, "numberMotherLawUnits"))
                w.uint32(48).int32(m.numberMotherLawUnits);
            if (m.propertyValue != null && Object.hasOwnProperty.call(m, "propertyValue"))
                w.uint32(56).int32(m.propertyValue);
            return w;
        };

        /**
         * Decodes a Property message from the specified reader or buffer.
         * @function decode
         * @memberof propertypb.Property
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {propertypb.Property} Property
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Property.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.propertypb.Property();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.ID = r.string();
                    break;
                case 2:
                    m.addressID = r.string();
                    break;
                case 3:
                    if (!(m.legacyIDs && m.legacyIDs.length))
                        m.legacyIDs = [];
                    if ((t & 7) === 2) {
                        var c2 = r.uint32() + r.pos;
                        while (r.pos < c2)
                            m.legacyIDs.push(r.uint64());
                    } else
                        m.legacyIDs.push(r.uint64());
                    break;
                case 4:
                    m.attributes = $root.propertypb.Attributes.decode(r, r.uint32());
                    break;
                case 5:
                    m.meta = $root.propertypb.MetaData.decode(r, r.uint32());
                    break;
                case 6:
                    m.numberMotherLawUnits = r.int32();
                    break;
                case 7:
                    m.propertyValue = r.int32();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return Property;
    })();

    propertypb.PropertyByIDRequest = (function() {

        /**
         * Properties of a PropertyByIDRequest.
         * @memberof propertypb
         * @interface IPropertyByIDRequest
         * @property {string|null} [propertyID] PropertyByIDRequest propertyID
         */

        /**
         * Constructs a new PropertyByIDRequest.
         * @memberof propertypb
         * @classdesc Represents a PropertyByIDRequest.
         * @implements IPropertyByIDRequest
         * @constructor
         * @param {propertypb.IPropertyByIDRequest=} [p] Properties to set
         */
        function PropertyByIDRequest(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * PropertyByIDRequest propertyID.
         * @member {string} propertyID
         * @memberof propertypb.PropertyByIDRequest
         * @instance
         */
        PropertyByIDRequest.prototype.propertyID = "";

        /**
         * Creates a new PropertyByIDRequest instance using the specified properties.
         * @function create
         * @memberof propertypb.PropertyByIDRequest
         * @static
         * @param {propertypb.IPropertyByIDRequest=} [properties] Properties to set
         * @returns {propertypb.PropertyByIDRequest} PropertyByIDRequest instance
         */
        PropertyByIDRequest.create = function create(properties) {
            return new PropertyByIDRequest(properties);
        };

        /**
         * Encodes the specified PropertyByIDRequest message. Does not implicitly {@link propertypb.PropertyByIDRequest.verify|verify} messages.
         * @function encode
         * @memberof propertypb.PropertyByIDRequest
         * @static
         * @param {propertypb.IPropertyByIDRequest} m PropertyByIDRequest message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PropertyByIDRequest.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.propertyID != null && Object.hasOwnProperty.call(m, "propertyID"))
                w.uint32(10).string(m.propertyID);
            return w;
        };

        /**
         * Decodes a PropertyByIDRequest message from the specified reader or buffer.
         * @function decode
         * @memberof propertypb.PropertyByIDRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {propertypb.PropertyByIDRequest} PropertyByIDRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PropertyByIDRequest.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.propertypb.PropertyByIDRequest();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.propertyID = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return PropertyByIDRequest;
    })();

    propertypb.PropertyByIDResponse = (function() {

        /**
         * Properties of a PropertyByIDResponse.
         * @memberof propertypb
         * @interface IPropertyByIDResponse
         * @property {propertypb.IProperty|null} [property] PropertyByIDResponse property
         * @property {Array.<common.IError>|null} [errors] PropertyByIDResponse errors
         * @property {common.Status|null} [status] PropertyByIDResponse status
         */

        /**
         * Constructs a new PropertyByIDResponse.
         * @memberof propertypb
         * @classdesc Represents a PropertyByIDResponse.
         * @implements IPropertyByIDResponse
         * @constructor
         * @param {propertypb.IPropertyByIDResponse=} [p] Properties to set
         */
        function PropertyByIDResponse(p) {
            this.errors = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * PropertyByIDResponse property.
         * @member {propertypb.IProperty|null|undefined} property
         * @memberof propertypb.PropertyByIDResponse
         * @instance
         */
        PropertyByIDResponse.prototype.property = null;

        /**
         * PropertyByIDResponse errors.
         * @member {Array.<common.IError>} errors
         * @memberof propertypb.PropertyByIDResponse
         * @instance
         */
        PropertyByIDResponse.prototype.errors = $util.emptyArray;

        /**
         * PropertyByIDResponse status.
         * @member {common.Status} status
         * @memberof propertypb.PropertyByIDResponse
         * @instance
         */
        PropertyByIDResponse.prototype.status = 0;

        /**
         * Creates a new PropertyByIDResponse instance using the specified properties.
         * @function create
         * @memberof propertypb.PropertyByIDResponse
         * @static
         * @param {propertypb.IPropertyByIDResponse=} [properties] Properties to set
         * @returns {propertypb.PropertyByIDResponse} PropertyByIDResponse instance
         */
        PropertyByIDResponse.create = function create(properties) {
            return new PropertyByIDResponse(properties);
        };

        /**
         * Encodes the specified PropertyByIDResponse message. Does not implicitly {@link propertypb.PropertyByIDResponse.verify|verify} messages.
         * @function encode
         * @memberof propertypb.PropertyByIDResponse
         * @static
         * @param {propertypb.IPropertyByIDResponse} m PropertyByIDResponse message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PropertyByIDResponse.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.property != null && Object.hasOwnProperty.call(m, "property"))
                $root.propertypb.Property.encode(m.property, w.uint32(10).fork()).ldelim();
            if (m.errors != null && m.errors.length) {
                for (var i = 0; i < m.errors.length; ++i)
                    $root.common.Error.encode(m.errors[i], w.uint32(18).fork()).ldelim();
            }
            if (m.status != null && Object.hasOwnProperty.call(m, "status"))
                w.uint32(24).int32(m.status);
            return w;
        };

        /**
         * Decodes a PropertyByIDResponse message from the specified reader or buffer.
         * @function decode
         * @memberof propertypb.PropertyByIDResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {propertypb.PropertyByIDResponse} PropertyByIDResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PropertyByIDResponse.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.propertypb.PropertyByIDResponse();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.property = $root.propertypb.Property.decode(r, r.uint32());
                    break;
                case 2:
                    if (!(m.errors && m.errors.length))
                        m.errors = [];
                    m.errors.push($root.common.Error.decode(r, r.uint32()));
                    break;
                case 3:
                    m.status = r.int32();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return PropertyByIDResponse;
    })();

    propertypb.PropertyByAddressIDRequest = (function() {

        /**
         * Properties of a PropertyByAddressIDRequest.
         * @memberof propertypb
         * @interface IPropertyByAddressIDRequest
         * @property {string|null} [addressID] PropertyByAddressIDRequest addressID
         */

        /**
         * Constructs a new PropertyByAddressIDRequest.
         * @memberof propertypb
         * @classdesc Represents a PropertyByAddressIDRequest.
         * @implements IPropertyByAddressIDRequest
         * @constructor
         * @param {propertypb.IPropertyByAddressIDRequest=} [p] Properties to set
         */
        function PropertyByAddressIDRequest(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * PropertyByAddressIDRequest addressID.
         * @member {string} addressID
         * @memberof propertypb.PropertyByAddressIDRequest
         * @instance
         */
        PropertyByAddressIDRequest.prototype.addressID = "";

        /**
         * Creates a new PropertyByAddressIDRequest instance using the specified properties.
         * @function create
         * @memberof propertypb.PropertyByAddressIDRequest
         * @static
         * @param {propertypb.IPropertyByAddressIDRequest=} [properties] Properties to set
         * @returns {propertypb.PropertyByAddressIDRequest} PropertyByAddressIDRequest instance
         */
        PropertyByAddressIDRequest.create = function create(properties) {
            return new PropertyByAddressIDRequest(properties);
        };

        /**
         * Encodes the specified PropertyByAddressIDRequest message. Does not implicitly {@link propertypb.PropertyByAddressIDRequest.verify|verify} messages.
         * @function encode
         * @memberof propertypb.PropertyByAddressIDRequest
         * @static
         * @param {propertypb.IPropertyByAddressIDRequest} m PropertyByAddressIDRequest message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PropertyByAddressIDRequest.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.addressID != null && Object.hasOwnProperty.call(m, "addressID"))
                w.uint32(10).string(m.addressID);
            return w;
        };

        /**
         * Decodes a PropertyByAddressIDRequest message from the specified reader or buffer.
         * @function decode
         * @memberof propertypb.PropertyByAddressIDRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {propertypb.PropertyByAddressIDRequest} PropertyByAddressIDRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PropertyByAddressIDRequest.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.propertypb.PropertyByAddressIDRequest();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.addressID = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return PropertyByAddressIDRequest;
    })();

    propertypb.PropertyByAddressIDResponse = (function() {

        /**
         * Properties of a PropertyByAddressIDResponse.
         * @memberof propertypb
         * @interface IPropertyByAddressIDResponse
         * @property {Array.<propertypb.IProperty>|null} [results] PropertyByAddressIDResponse results
         * @property {Array.<common.IError>|null} [errors] PropertyByAddressIDResponse errors
         * @property {common.Status|null} [status] PropertyByAddressIDResponse status
         */

        /**
         * Constructs a new PropertyByAddressIDResponse.
         * @memberof propertypb
         * @classdesc Represents a PropertyByAddressIDResponse.
         * @implements IPropertyByAddressIDResponse
         * @constructor
         * @param {propertypb.IPropertyByAddressIDResponse=} [p] Properties to set
         */
        function PropertyByAddressIDResponse(p) {
            this.results = [];
            this.errors = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * PropertyByAddressIDResponse results.
         * @member {Array.<propertypb.IProperty>} results
         * @memberof propertypb.PropertyByAddressIDResponse
         * @instance
         */
        PropertyByAddressIDResponse.prototype.results = $util.emptyArray;

        /**
         * PropertyByAddressIDResponse errors.
         * @member {Array.<common.IError>} errors
         * @memberof propertypb.PropertyByAddressIDResponse
         * @instance
         */
        PropertyByAddressIDResponse.prototype.errors = $util.emptyArray;

        /**
         * PropertyByAddressIDResponse status.
         * @member {common.Status} status
         * @memberof propertypb.PropertyByAddressIDResponse
         * @instance
         */
        PropertyByAddressIDResponse.prototype.status = 0;

        /**
         * Creates a new PropertyByAddressIDResponse instance using the specified properties.
         * @function create
         * @memberof propertypb.PropertyByAddressIDResponse
         * @static
         * @param {propertypb.IPropertyByAddressIDResponse=} [properties] Properties to set
         * @returns {propertypb.PropertyByAddressIDResponse} PropertyByAddressIDResponse instance
         */
        PropertyByAddressIDResponse.create = function create(properties) {
            return new PropertyByAddressIDResponse(properties);
        };

        /**
         * Encodes the specified PropertyByAddressIDResponse message. Does not implicitly {@link propertypb.PropertyByAddressIDResponse.verify|verify} messages.
         * @function encode
         * @memberof propertypb.PropertyByAddressIDResponse
         * @static
         * @param {propertypb.IPropertyByAddressIDResponse} m PropertyByAddressIDResponse message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PropertyByAddressIDResponse.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.results != null && m.results.length) {
                for (var i = 0; i < m.results.length; ++i)
                    $root.propertypb.Property.encode(m.results[i], w.uint32(10).fork()).ldelim();
            }
            if (m.errors != null && m.errors.length) {
                for (var i = 0; i < m.errors.length; ++i)
                    $root.common.Error.encode(m.errors[i], w.uint32(18).fork()).ldelim();
            }
            if (m.status != null && Object.hasOwnProperty.call(m, "status"))
                w.uint32(24).int32(m.status);
            return w;
        };

        /**
         * Decodes a PropertyByAddressIDResponse message from the specified reader or buffer.
         * @function decode
         * @memberof propertypb.PropertyByAddressIDResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {propertypb.PropertyByAddressIDResponse} PropertyByAddressIDResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PropertyByAddressIDResponse.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.propertypb.PropertyByAddressIDResponse();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    if (!(m.results && m.results.length))
                        m.results = [];
                    m.results.push($root.propertypb.Property.decode(r, r.uint32()));
                    break;
                case 2:
                    if (!(m.errors && m.errors.length))
                        m.errors = [];
                    m.errors.push($root.common.Error.decode(r, r.uint32()));
                    break;
                case 3:
                    m.status = r.int32();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return PropertyByAddressIDResponse;
    })();

    propertypb.PropertyByLegacyIDRequest = (function() {

        /**
         * Properties of a PropertyByLegacyIDRequest.
         * @memberof propertypb
         * @interface IPropertyByLegacyIDRequest
         * @property {number|Long|null} [legacyID] PropertyByLegacyIDRequest legacyID
         */

        /**
         * Constructs a new PropertyByLegacyIDRequest.
         * @memberof propertypb
         * @classdesc Represents a PropertyByLegacyIDRequest.
         * @implements IPropertyByLegacyIDRequest
         * @constructor
         * @param {propertypb.IPropertyByLegacyIDRequest=} [p] Properties to set
         */
        function PropertyByLegacyIDRequest(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * PropertyByLegacyIDRequest legacyID.
         * @member {number|Long} legacyID
         * @memberof propertypb.PropertyByLegacyIDRequest
         * @instance
         */
        PropertyByLegacyIDRequest.prototype.legacyID = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * Creates a new PropertyByLegacyIDRequest instance using the specified properties.
         * @function create
         * @memberof propertypb.PropertyByLegacyIDRequest
         * @static
         * @param {propertypb.IPropertyByLegacyIDRequest=} [properties] Properties to set
         * @returns {propertypb.PropertyByLegacyIDRequest} PropertyByLegacyIDRequest instance
         */
        PropertyByLegacyIDRequest.create = function create(properties) {
            return new PropertyByLegacyIDRequest(properties);
        };

        /**
         * Encodes the specified PropertyByLegacyIDRequest message. Does not implicitly {@link propertypb.PropertyByLegacyIDRequest.verify|verify} messages.
         * @function encode
         * @memberof propertypb.PropertyByLegacyIDRequest
         * @static
         * @param {propertypb.IPropertyByLegacyIDRequest} m PropertyByLegacyIDRequest message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PropertyByLegacyIDRequest.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.legacyID != null && Object.hasOwnProperty.call(m, "legacyID"))
                w.uint32(8).uint64(m.legacyID);
            return w;
        };

        /**
         * Decodes a PropertyByLegacyIDRequest message from the specified reader or buffer.
         * @function decode
         * @memberof propertypb.PropertyByLegacyIDRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {propertypb.PropertyByLegacyIDRequest} PropertyByLegacyIDRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PropertyByLegacyIDRequest.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.propertypb.PropertyByLegacyIDRequest();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.legacyID = r.uint64();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return PropertyByLegacyIDRequest;
    })();

    propertypb.PropertyByLegacyIDResponse = (function() {

        /**
         * Properties of a PropertyByLegacyIDResponse.
         * @memberof propertypb
         * @interface IPropertyByLegacyIDResponse
         * @property {Array.<propertypb.IProperty>|null} [results] PropertyByLegacyIDResponse results
         * @property {Array.<common.IError>|null} [errors] PropertyByLegacyIDResponse errors
         * @property {common.Status|null} [status] PropertyByLegacyIDResponse status
         */

        /**
         * Constructs a new PropertyByLegacyIDResponse.
         * @memberof propertypb
         * @classdesc Represents a PropertyByLegacyIDResponse.
         * @implements IPropertyByLegacyIDResponse
         * @constructor
         * @param {propertypb.IPropertyByLegacyIDResponse=} [p] Properties to set
         */
        function PropertyByLegacyIDResponse(p) {
            this.results = [];
            this.errors = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * PropertyByLegacyIDResponse results.
         * @member {Array.<propertypb.IProperty>} results
         * @memberof propertypb.PropertyByLegacyIDResponse
         * @instance
         */
        PropertyByLegacyIDResponse.prototype.results = $util.emptyArray;

        /**
         * PropertyByLegacyIDResponse errors.
         * @member {Array.<common.IError>} errors
         * @memberof propertypb.PropertyByLegacyIDResponse
         * @instance
         */
        PropertyByLegacyIDResponse.prototype.errors = $util.emptyArray;

        /**
         * PropertyByLegacyIDResponse status.
         * @member {common.Status} status
         * @memberof propertypb.PropertyByLegacyIDResponse
         * @instance
         */
        PropertyByLegacyIDResponse.prototype.status = 0;

        /**
         * Creates a new PropertyByLegacyIDResponse instance using the specified properties.
         * @function create
         * @memberof propertypb.PropertyByLegacyIDResponse
         * @static
         * @param {propertypb.IPropertyByLegacyIDResponse=} [properties] Properties to set
         * @returns {propertypb.PropertyByLegacyIDResponse} PropertyByLegacyIDResponse instance
         */
        PropertyByLegacyIDResponse.create = function create(properties) {
            return new PropertyByLegacyIDResponse(properties);
        };

        /**
         * Encodes the specified PropertyByLegacyIDResponse message. Does not implicitly {@link propertypb.PropertyByLegacyIDResponse.verify|verify} messages.
         * @function encode
         * @memberof propertypb.PropertyByLegacyIDResponse
         * @static
         * @param {propertypb.IPropertyByLegacyIDResponse} m PropertyByLegacyIDResponse message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PropertyByLegacyIDResponse.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.results != null && m.results.length) {
                for (var i = 0; i < m.results.length; ++i)
                    $root.propertypb.Property.encode(m.results[i], w.uint32(10).fork()).ldelim();
            }
            if (m.errors != null && m.errors.length) {
                for (var i = 0; i < m.errors.length; ++i)
                    $root.common.Error.encode(m.errors[i], w.uint32(18).fork()).ldelim();
            }
            if (m.status != null && Object.hasOwnProperty.call(m, "status"))
                w.uint32(24).int32(m.status);
            return w;
        };

        /**
         * Decodes a PropertyByLegacyIDResponse message from the specified reader or buffer.
         * @function decode
         * @memberof propertypb.PropertyByLegacyIDResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {propertypb.PropertyByLegacyIDResponse} PropertyByLegacyIDResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PropertyByLegacyIDResponse.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.propertypb.PropertyByLegacyIDResponse();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    if (!(m.results && m.results.length))
                        m.results = [];
                    m.results.push($root.propertypb.Property.decode(r, r.uint32()));
                    break;
                case 2:
                    if (!(m.errors && m.errors.length))
                        m.errors = [];
                    m.errors.push($root.common.Error.decode(r, r.uint32()));
                    break;
                case 3:
                    m.status = r.int32();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return PropertyByLegacyIDResponse;
    })();

    propertypb.PropertyCreationRequest = (function() {

        /**
         * Properties of a PropertyCreationRequest.
         * @memberof propertypb
         * @interface IPropertyCreationRequest
         * @property {string|null} [addressID] PropertyCreationRequest addressID
         * @property {Array.<number|Long>|null} [legacyIDs] PropertyCreationRequest legacyIDs
         * @property {propertypb.IAttributes|null} [attributes] PropertyCreationRequest attributes
         * @property {propertypb.IMetaData|null} [meta] PropertyCreationRequest meta
         * @property {number|null} [numberMotherLawUnits] PropertyCreationRequest numberMotherLawUnits
         */

        /**
         * Constructs a new PropertyCreationRequest.
         * @memberof propertypb
         * @classdesc Represents a PropertyCreationRequest.
         * @implements IPropertyCreationRequest
         * @constructor
         * @param {propertypb.IPropertyCreationRequest=} [p] Properties to set
         */
        function PropertyCreationRequest(p) {
            this.legacyIDs = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * PropertyCreationRequest addressID.
         * @member {string} addressID
         * @memberof propertypb.PropertyCreationRequest
         * @instance
         */
        PropertyCreationRequest.prototype.addressID = "";

        /**
         * PropertyCreationRequest legacyIDs.
         * @member {Array.<number|Long>} legacyIDs
         * @memberof propertypb.PropertyCreationRequest
         * @instance
         */
        PropertyCreationRequest.prototype.legacyIDs = $util.emptyArray;

        /**
         * PropertyCreationRequest attributes.
         * @member {propertypb.IAttributes|null|undefined} attributes
         * @memberof propertypb.PropertyCreationRequest
         * @instance
         */
        PropertyCreationRequest.prototype.attributes = null;

        /**
         * PropertyCreationRequest meta.
         * @member {propertypb.IMetaData|null|undefined} meta
         * @memberof propertypb.PropertyCreationRequest
         * @instance
         */
        PropertyCreationRequest.prototype.meta = null;

        /**
         * PropertyCreationRequest numberMotherLawUnits.
         * @member {number} numberMotherLawUnits
         * @memberof propertypb.PropertyCreationRequest
         * @instance
         */
        PropertyCreationRequest.prototype.numberMotherLawUnits = 0;

        /**
         * Creates a new PropertyCreationRequest instance using the specified properties.
         * @function create
         * @memberof propertypb.PropertyCreationRequest
         * @static
         * @param {propertypb.IPropertyCreationRequest=} [properties] Properties to set
         * @returns {propertypb.PropertyCreationRequest} PropertyCreationRequest instance
         */
        PropertyCreationRequest.create = function create(properties) {
            return new PropertyCreationRequest(properties);
        };

        /**
         * Encodes the specified PropertyCreationRequest message. Does not implicitly {@link propertypb.PropertyCreationRequest.verify|verify} messages.
         * @function encode
         * @memberof propertypb.PropertyCreationRequest
         * @static
         * @param {propertypb.IPropertyCreationRequest} m PropertyCreationRequest message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PropertyCreationRequest.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.addressID != null && Object.hasOwnProperty.call(m, "addressID"))
                w.uint32(10).string(m.addressID);
            if (m.legacyIDs != null && m.legacyIDs.length) {
                w.uint32(18).fork();
                for (var i = 0; i < m.legacyIDs.length; ++i)
                    w.uint64(m.legacyIDs[i]);
                w.ldelim();
            }
            if (m.attributes != null && Object.hasOwnProperty.call(m, "attributes"))
                $root.propertypb.Attributes.encode(m.attributes, w.uint32(26).fork()).ldelim();
            if (m.meta != null && Object.hasOwnProperty.call(m, "meta"))
                $root.propertypb.MetaData.encode(m.meta, w.uint32(34).fork()).ldelim();
            if (m.numberMotherLawUnits != null && Object.hasOwnProperty.call(m, "numberMotherLawUnits"))
                w.uint32(40).int32(m.numberMotherLawUnits);
            return w;
        };

        /**
         * Decodes a PropertyCreationRequest message from the specified reader or buffer.
         * @function decode
         * @memberof propertypb.PropertyCreationRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {propertypb.PropertyCreationRequest} PropertyCreationRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PropertyCreationRequest.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.propertypb.PropertyCreationRequest();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.addressID = r.string();
                    break;
                case 2:
                    if (!(m.legacyIDs && m.legacyIDs.length))
                        m.legacyIDs = [];
                    if ((t & 7) === 2) {
                        var c2 = r.uint32() + r.pos;
                        while (r.pos < c2)
                            m.legacyIDs.push(r.uint64());
                    } else
                        m.legacyIDs.push(r.uint64());
                    break;
                case 3:
                    m.attributes = $root.propertypb.Attributes.decode(r, r.uint32());
                    break;
                case 4:
                    m.meta = $root.propertypb.MetaData.decode(r, r.uint32());
                    break;
                case 5:
                    m.numberMotherLawUnits = r.int32();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return PropertyCreationRequest;
    })();

    propertypb.PropertyCreationResponse = (function() {

        /**
         * Properties of a PropertyCreationResponse.
         * @memberof propertypb
         * @interface IPropertyCreationResponse
         * @property {propertypb.IProperty|null} [property] PropertyCreationResponse property
         * @property {Array.<common.IError>|null} [errors] PropertyCreationResponse errors
         * @property {common.Status|null} [status] PropertyCreationResponse status
         */

        /**
         * Constructs a new PropertyCreationResponse.
         * @memberof propertypb
         * @classdesc Represents a PropertyCreationResponse.
         * @implements IPropertyCreationResponse
         * @constructor
         * @param {propertypb.IPropertyCreationResponse=} [p] Properties to set
         */
        function PropertyCreationResponse(p) {
            this.errors = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * PropertyCreationResponse property.
         * @member {propertypb.IProperty|null|undefined} property
         * @memberof propertypb.PropertyCreationResponse
         * @instance
         */
        PropertyCreationResponse.prototype.property = null;

        /**
         * PropertyCreationResponse errors.
         * @member {Array.<common.IError>} errors
         * @memberof propertypb.PropertyCreationResponse
         * @instance
         */
        PropertyCreationResponse.prototype.errors = $util.emptyArray;

        /**
         * PropertyCreationResponse status.
         * @member {common.Status} status
         * @memberof propertypb.PropertyCreationResponse
         * @instance
         */
        PropertyCreationResponse.prototype.status = 0;

        /**
         * Creates a new PropertyCreationResponse instance using the specified properties.
         * @function create
         * @memberof propertypb.PropertyCreationResponse
         * @static
         * @param {propertypb.IPropertyCreationResponse=} [properties] Properties to set
         * @returns {propertypb.PropertyCreationResponse} PropertyCreationResponse instance
         */
        PropertyCreationResponse.create = function create(properties) {
            return new PropertyCreationResponse(properties);
        };

        /**
         * Encodes the specified PropertyCreationResponse message. Does not implicitly {@link propertypb.PropertyCreationResponse.verify|verify} messages.
         * @function encode
         * @memberof propertypb.PropertyCreationResponse
         * @static
         * @param {propertypb.IPropertyCreationResponse} m PropertyCreationResponse message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PropertyCreationResponse.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.property != null && Object.hasOwnProperty.call(m, "property"))
                $root.propertypb.Property.encode(m.property, w.uint32(10).fork()).ldelim();
            if (m.errors != null && m.errors.length) {
                for (var i = 0; i < m.errors.length; ++i)
                    $root.common.Error.encode(m.errors[i], w.uint32(18).fork()).ldelim();
            }
            if (m.status != null && Object.hasOwnProperty.call(m, "status"))
                w.uint32(24).int32(m.status);
            return w;
        };

        /**
         * Decodes a PropertyCreationResponse message from the specified reader or buffer.
         * @function decode
         * @memberof propertypb.PropertyCreationResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {propertypb.PropertyCreationResponse} PropertyCreationResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PropertyCreationResponse.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.propertypb.PropertyCreationResponse();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.property = $root.propertypb.Property.decode(r, r.uint32());
                    break;
                case 2:
                    if (!(m.errors && m.errors.length))
                        m.errors = [];
                    m.errors.push($root.common.Error.decode(r, r.uint32()));
                    break;
                case 3:
                    m.status = r.int32();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return PropertyCreationResponse;
    })();

    propertypb.PropertyModificationRequest = (function() {

        /**
         * Properties of a PropertyModificationRequest.
         * @memberof propertypb
         * @interface IPropertyModificationRequest
         * @property {propertypb.IProperty|null} [property] PropertyModificationRequest property
         */

        /**
         * Constructs a new PropertyModificationRequest.
         * @memberof propertypb
         * @classdesc Represents a PropertyModificationRequest.
         * @implements IPropertyModificationRequest
         * @constructor
         * @param {propertypb.IPropertyModificationRequest=} [p] Properties to set
         */
        function PropertyModificationRequest(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * PropertyModificationRequest property.
         * @member {propertypb.IProperty|null|undefined} property
         * @memberof propertypb.PropertyModificationRequest
         * @instance
         */
        PropertyModificationRequest.prototype.property = null;

        /**
         * Creates a new PropertyModificationRequest instance using the specified properties.
         * @function create
         * @memberof propertypb.PropertyModificationRequest
         * @static
         * @param {propertypb.IPropertyModificationRequest=} [properties] Properties to set
         * @returns {propertypb.PropertyModificationRequest} PropertyModificationRequest instance
         */
        PropertyModificationRequest.create = function create(properties) {
            return new PropertyModificationRequest(properties);
        };

        /**
         * Encodes the specified PropertyModificationRequest message. Does not implicitly {@link propertypb.PropertyModificationRequest.verify|verify} messages.
         * @function encode
         * @memberof propertypb.PropertyModificationRequest
         * @static
         * @param {propertypb.IPropertyModificationRequest} m PropertyModificationRequest message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PropertyModificationRequest.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.property != null && Object.hasOwnProperty.call(m, "property"))
                $root.propertypb.Property.encode(m.property, w.uint32(10).fork()).ldelim();
            return w;
        };

        /**
         * Decodes a PropertyModificationRequest message from the specified reader or buffer.
         * @function decode
         * @memberof propertypb.PropertyModificationRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {propertypb.PropertyModificationRequest} PropertyModificationRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PropertyModificationRequest.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.propertypb.PropertyModificationRequest();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.property = $root.propertypb.Property.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return PropertyModificationRequest;
    })();

    propertypb.PropertyModificationResponse = (function() {

        /**
         * Properties of a PropertyModificationResponse.
         * @memberof propertypb
         * @interface IPropertyModificationResponse
         * @property {propertypb.IProperty|null} [property] PropertyModificationResponse property
         * @property {Array.<common.IError>|null} [errors] PropertyModificationResponse errors
         * @property {common.Status|null} [status] PropertyModificationResponse status
         */

        /**
         * Constructs a new PropertyModificationResponse.
         * @memberof propertypb
         * @classdesc Represents a PropertyModificationResponse.
         * @implements IPropertyModificationResponse
         * @constructor
         * @param {propertypb.IPropertyModificationResponse=} [p] Properties to set
         */
        function PropertyModificationResponse(p) {
            this.errors = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * PropertyModificationResponse property.
         * @member {propertypb.IProperty|null|undefined} property
         * @memberof propertypb.PropertyModificationResponse
         * @instance
         */
        PropertyModificationResponse.prototype.property = null;

        /**
         * PropertyModificationResponse errors.
         * @member {Array.<common.IError>} errors
         * @memberof propertypb.PropertyModificationResponse
         * @instance
         */
        PropertyModificationResponse.prototype.errors = $util.emptyArray;

        /**
         * PropertyModificationResponse status.
         * @member {common.Status} status
         * @memberof propertypb.PropertyModificationResponse
         * @instance
         */
        PropertyModificationResponse.prototype.status = 0;

        /**
         * Creates a new PropertyModificationResponse instance using the specified properties.
         * @function create
         * @memberof propertypb.PropertyModificationResponse
         * @static
         * @param {propertypb.IPropertyModificationResponse=} [properties] Properties to set
         * @returns {propertypb.PropertyModificationResponse} PropertyModificationResponse instance
         */
        PropertyModificationResponse.create = function create(properties) {
            return new PropertyModificationResponse(properties);
        };

        /**
         * Encodes the specified PropertyModificationResponse message. Does not implicitly {@link propertypb.PropertyModificationResponse.verify|verify} messages.
         * @function encode
         * @memberof propertypb.PropertyModificationResponse
         * @static
         * @param {propertypb.IPropertyModificationResponse} m PropertyModificationResponse message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PropertyModificationResponse.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.property != null && Object.hasOwnProperty.call(m, "property"))
                $root.propertypb.Property.encode(m.property, w.uint32(10).fork()).ldelim();
            if (m.errors != null && m.errors.length) {
                for (var i = 0; i < m.errors.length; ++i)
                    $root.common.Error.encode(m.errors[i], w.uint32(18).fork()).ldelim();
            }
            if (m.status != null && Object.hasOwnProperty.call(m, "status"))
                w.uint32(24).int32(m.status);
            return w;
        };

        /**
         * Decodes a PropertyModificationResponse message from the specified reader or buffer.
         * @function decode
         * @memberof propertypb.PropertyModificationResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {propertypb.PropertyModificationResponse} PropertyModificationResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PropertyModificationResponse.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.propertypb.PropertyModificationResponse();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.property = $root.propertypb.Property.decode(r, r.uint32());
                    break;
                case 2:
                    if (!(m.errors && m.errors.length))
                        m.errors = [];
                    m.errors.push($root.common.Error.decode(r, r.uint32()));
                    break;
                case 3:
                    m.status = r.int32();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return PropertyModificationResponse;
    })();

    propertypb.PropertyLegacyIDCreationRequest = (function() {

        /**
         * Properties of a PropertyLegacyIDCreationRequest.
         * @memberof propertypb
         * @interface IPropertyLegacyIDCreationRequest
         * @property {string|null} [propertyID] PropertyLegacyIDCreationRequest propertyID
         * @property {number|Long|null} [legacyID] PropertyLegacyIDCreationRequest legacyID
         */

        /**
         * Constructs a new PropertyLegacyIDCreationRequest.
         * @memberof propertypb
         * @classdesc Represents a PropertyLegacyIDCreationRequest.
         * @implements IPropertyLegacyIDCreationRequest
         * @constructor
         * @param {propertypb.IPropertyLegacyIDCreationRequest=} [p] Properties to set
         */
        function PropertyLegacyIDCreationRequest(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * PropertyLegacyIDCreationRequest propertyID.
         * @member {string} propertyID
         * @memberof propertypb.PropertyLegacyIDCreationRequest
         * @instance
         */
        PropertyLegacyIDCreationRequest.prototype.propertyID = "";

        /**
         * PropertyLegacyIDCreationRequest legacyID.
         * @member {number|Long} legacyID
         * @memberof propertypb.PropertyLegacyIDCreationRequest
         * @instance
         */
        PropertyLegacyIDCreationRequest.prototype.legacyID = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * Creates a new PropertyLegacyIDCreationRequest instance using the specified properties.
         * @function create
         * @memberof propertypb.PropertyLegacyIDCreationRequest
         * @static
         * @param {propertypb.IPropertyLegacyIDCreationRequest=} [properties] Properties to set
         * @returns {propertypb.PropertyLegacyIDCreationRequest} PropertyLegacyIDCreationRequest instance
         */
        PropertyLegacyIDCreationRequest.create = function create(properties) {
            return new PropertyLegacyIDCreationRequest(properties);
        };

        /**
         * Encodes the specified PropertyLegacyIDCreationRequest message. Does not implicitly {@link propertypb.PropertyLegacyIDCreationRequest.verify|verify} messages.
         * @function encode
         * @memberof propertypb.PropertyLegacyIDCreationRequest
         * @static
         * @param {propertypb.IPropertyLegacyIDCreationRequest} m PropertyLegacyIDCreationRequest message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PropertyLegacyIDCreationRequest.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.propertyID != null && Object.hasOwnProperty.call(m, "propertyID"))
                w.uint32(10).string(m.propertyID);
            if (m.legacyID != null && Object.hasOwnProperty.call(m, "legacyID"))
                w.uint32(16).uint64(m.legacyID);
            return w;
        };

        /**
         * Decodes a PropertyLegacyIDCreationRequest message from the specified reader or buffer.
         * @function decode
         * @memberof propertypb.PropertyLegacyIDCreationRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {propertypb.PropertyLegacyIDCreationRequest} PropertyLegacyIDCreationRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PropertyLegacyIDCreationRequest.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.propertypb.PropertyLegacyIDCreationRequest();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.propertyID = r.string();
                    break;
                case 2:
                    m.legacyID = r.uint64();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return PropertyLegacyIDCreationRequest;
    })();

    propertypb.PropertyLegacyIDCreationResponse = (function() {

        /**
         * Properties of a PropertyLegacyIDCreationResponse.
         * @memberof propertypb
         * @interface IPropertyLegacyIDCreationResponse
         * @property {Array.<common.IError>|null} [errors] PropertyLegacyIDCreationResponse errors
         * @property {common.Status|null} [status] PropertyLegacyIDCreationResponse status
         */

        /**
         * Constructs a new PropertyLegacyIDCreationResponse.
         * @memberof propertypb
         * @classdesc Represents a PropertyLegacyIDCreationResponse.
         * @implements IPropertyLegacyIDCreationResponse
         * @constructor
         * @param {propertypb.IPropertyLegacyIDCreationResponse=} [p] Properties to set
         */
        function PropertyLegacyIDCreationResponse(p) {
            this.errors = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * PropertyLegacyIDCreationResponse errors.
         * @member {Array.<common.IError>} errors
         * @memberof propertypb.PropertyLegacyIDCreationResponse
         * @instance
         */
        PropertyLegacyIDCreationResponse.prototype.errors = $util.emptyArray;

        /**
         * PropertyLegacyIDCreationResponse status.
         * @member {common.Status} status
         * @memberof propertypb.PropertyLegacyIDCreationResponse
         * @instance
         */
        PropertyLegacyIDCreationResponse.prototype.status = 0;

        /**
         * Creates a new PropertyLegacyIDCreationResponse instance using the specified properties.
         * @function create
         * @memberof propertypb.PropertyLegacyIDCreationResponse
         * @static
         * @param {propertypb.IPropertyLegacyIDCreationResponse=} [properties] Properties to set
         * @returns {propertypb.PropertyLegacyIDCreationResponse} PropertyLegacyIDCreationResponse instance
         */
        PropertyLegacyIDCreationResponse.create = function create(properties) {
            return new PropertyLegacyIDCreationResponse(properties);
        };

        /**
         * Encodes the specified PropertyLegacyIDCreationResponse message. Does not implicitly {@link propertypb.PropertyLegacyIDCreationResponse.verify|verify} messages.
         * @function encode
         * @memberof propertypb.PropertyLegacyIDCreationResponse
         * @static
         * @param {propertypb.IPropertyLegacyIDCreationResponse} m PropertyLegacyIDCreationResponse message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PropertyLegacyIDCreationResponse.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.errors != null && m.errors.length) {
                for (var i = 0; i < m.errors.length; ++i)
                    $root.common.Error.encode(m.errors[i], w.uint32(10).fork()).ldelim();
            }
            if (m.status != null && Object.hasOwnProperty.call(m, "status"))
                w.uint32(16).int32(m.status);
            return w;
        };

        /**
         * Decodes a PropertyLegacyIDCreationResponse message from the specified reader or buffer.
         * @function decode
         * @memberof propertypb.PropertyLegacyIDCreationResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {propertypb.PropertyLegacyIDCreationResponse} PropertyLegacyIDCreationResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PropertyLegacyIDCreationResponse.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.propertypb.PropertyLegacyIDCreationResponse();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    if (!(m.errors && m.errors.length))
                        m.errors = [];
                    m.errors.push($root.common.Error.decode(r, r.uint32()));
                    break;
                case 2:
                    m.status = r.int32();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return PropertyLegacyIDCreationResponse;
    })();

    propertypb.PropertyLegacyIDDeletionRequest = (function() {

        /**
         * Properties of a PropertyLegacyIDDeletionRequest.
         * @memberof propertypb
         * @interface IPropertyLegacyIDDeletionRequest
         * @property {string|null} [propertyID] PropertyLegacyIDDeletionRequest propertyID
         * @property {number|Long|null} [legacyID] PropertyLegacyIDDeletionRequest legacyID
         */

        /**
         * Constructs a new PropertyLegacyIDDeletionRequest.
         * @memberof propertypb
         * @classdesc Represents a PropertyLegacyIDDeletionRequest.
         * @implements IPropertyLegacyIDDeletionRequest
         * @constructor
         * @param {propertypb.IPropertyLegacyIDDeletionRequest=} [p] Properties to set
         */
        function PropertyLegacyIDDeletionRequest(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * PropertyLegacyIDDeletionRequest propertyID.
         * @member {string} propertyID
         * @memberof propertypb.PropertyLegacyIDDeletionRequest
         * @instance
         */
        PropertyLegacyIDDeletionRequest.prototype.propertyID = "";

        /**
         * PropertyLegacyIDDeletionRequest legacyID.
         * @member {number|Long} legacyID
         * @memberof propertypb.PropertyLegacyIDDeletionRequest
         * @instance
         */
        PropertyLegacyIDDeletionRequest.prototype.legacyID = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * Creates a new PropertyLegacyIDDeletionRequest instance using the specified properties.
         * @function create
         * @memberof propertypb.PropertyLegacyIDDeletionRequest
         * @static
         * @param {propertypb.IPropertyLegacyIDDeletionRequest=} [properties] Properties to set
         * @returns {propertypb.PropertyLegacyIDDeletionRequest} PropertyLegacyIDDeletionRequest instance
         */
        PropertyLegacyIDDeletionRequest.create = function create(properties) {
            return new PropertyLegacyIDDeletionRequest(properties);
        };

        /**
         * Encodes the specified PropertyLegacyIDDeletionRequest message. Does not implicitly {@link propertypb.PropertyLegacyIDDeletionRequest.verify|verify} messages.
         * @function encode
         * @memberof propertypb.PropertyLegacyIDDeletionRequest
         * @static
         * @param {propertypb.IPropertyLegacyIDDeletionRequest} m PropertyLegacyIDDeletionRequest message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PropertyLegacyIDDeletionRequest.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.propertyID != null && Object.hasOwnProperty.call(m, "propertyID"))
                w.uint32(10).string(m.propertyID);
            if (m.legacyID != null && Object.hasOwnProperty.call(m, "legacyID"))
                w.uint32(16).uint64(m.legacyID);
            return w;
        };

        /**
         * Decodes a PropertyLegacyIDDeletionRequest message from the specified reader or buffer.
         * @function decode
         * @memberof propertypb.PropertyLegacyIDDeletionRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {propertypb.PropertyLegacyIDDeletionRequest} PropertyLegacyIDDeletionRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PropertyLegacyIDDeletionRequest.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.propertypb.PropertyLegacyIDDeletionRequest();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.propertyID = r.string();
                    break;
                case 2:
                    m.legacyID = r.uint64();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return PropertyLegacyIDDeletionRequest;
    })();

    propertypb.PropertyLegacyIDDeletionResponse = (function() {

        /**
         * Properties of a PropertyLegacyIDDeletionResponse.
         * @memberof propertypb
         * @interface IPropertyLegacyIDDeletionResponse
         * @property {Array.<common.IError>|null} [errors] PropertyLegacyIDDeletionResponse errors
         * @property {common.Status|null} [status] PropertyLegacyIDDeletionResponse status
         */

        /**
         * Constructs a new PropertyLegacyIDDeletionResponse.
         * @memberof propertypb
         * @classdesc Represents a PropertyLegacyIDDeletionResponse.
         * @implements IPropertyLegacyIDDeletionResponse
         * @constructor
         * @param {propertypb.IPropertyLegacyIDDeletionResponse=} [p] Properties to set
         */
        function PropertyLegacyIDDeletionResponse(p) {
            this.errors = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * PropertyLegacyIDDeletionResponse errors.
         * @member {Array.<common.IError>} errors
         * @memberof propertypb.PropertyLegacyIDDeletionResponse
         * @instance
         */
        PropertyLegacyIDDeletionResponse.prototype.errors = $util.emptyArray;

        /**
         * PropertyLegacyIDDeletionResponse status.
         * @member {common.Status} status
         * @memberof propertypb.PropertyLegacyIDDeletionResponse
         * @instance
         */
        PropertyLegacyIDDeletionResponse.prototype.status = 0;

        /**
         * Creates a new PropertyLegacyIDDeletionResponse instance using the specified properties.
         * @function create
         * @memberof propertypb.PropertyLegacyIDDeletionResponse
         * @static
         * @param {propertypb.IPropertyLegacyIDDeletionResponse=} [properties] Properties to set
         * @returns {propertypb.PropertyLegacyIDDeletionResponse} PropertyLegacyIDDeletionResponse instance
         */
        PropertyLegacyIDDeletionResponse.create = function create(properties) {
            return new PropertyLegacyIDDeletionResponse(properties);
        };

        /**
         * Encodes the specified PropertyLegacyIDDeletionResponse message. Does not implicitly {@link propertypb.PropertyLegacyIDDeletionResponse.verify|verify} messages.
         * @function encode
         * @memberof propertypb.PropertyLegacyIDDeletionResponse
         * @static
         * @param {propertypb.IPropertyLegacyIDDeletionResponse} m PropertyLegacyIDDeletionResponse message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PropertyLegacyIDDeletionResponse.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.errors != null && m.errors.length) {
                for (var i = 0; i < m.errors.length; ++i)
                    $root.common.Error.encode(m.errors[i], w.uint32(10).fork()).ldelim();
            }
            if (m.status != null && Object.hasOwnProperty.call(m, "status"))
                w.uint32(16).int32(m.status);
            return w;
        };

        /**
         * Decodes a PropertyLegacyIDDeletionResponse message from the specified reader or buffer.
         * @function decode
         * @memberof propertypb.PropertyLegacyIDDeletionResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {propertypb.PropertyLegacyIDDeletionResponse} PropertyLegacyIDDeletionResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PropertyLegacyIDDeletionResponse.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.propertypb.PropertyLegacyIDDeletionResponse();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    if (!(m.errors && m.errors.length))
                        m.errors = [];
                    m.errors.push($root.common.Error.decode(r, r.uint32()));
                    break;
                case 2:
                    m.status = r.int32();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return PropertyLegacyIDDeletionResponse;
    })();

    /**
     * ExternalSource enum.
     * @name propertypb.ExternalSource
     * @enum {number}
     * @property {number} UNKNOWN_SOURCE=0 UNKNOWN_SOURCE value
     * @property {number} COMMERCIAL_PROPERTY=1 COMMERCIAL_PROPERTY value
     */
    propertypb.ExternalSource = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "UNKNOWN_SOURCE"] = 0;
        values[valuesById[1] = "COMMERCIAL_PROPERTY"] = 1;
        return values;
    })();

    propertypb.PropertyImportStarRequest = (function() {

        /**
         * Properties of a PropertyImportStarRequest.
         * @memberof propertypb
         * @interface IPropertyImportStarRequest
         * @property {propertypb.ExternalSource|null} [externalSource] PropertyImportStarRequest externalSource
         */

        /**
         * Constructs a new PropertyImportStarRequest.
         * @memberof propertypb
         * @classdesc Represents a PropertyImportStarRequest.
         * @implements IPropertyImportStarRequest
         * @constructor
         * @param {propertypb.IPropertyImportStarRequest=} [p] Properties to set
         */
        function PropertyImportStarRequest(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * PropertyImportStarRequest externalSource.
         * @member {propertypb.ExternalSource} externalSource
         * @memberof propertypb.PropertyImportStarRequest
         * @instance
         */
        PropertyImportStarRequest.prototype.externalSource = 0;

        /**
         * Creates a new PropertyImportStarRequest instance using the specified properties.
         * @function create
         * @memberof propertypb.PropertyImportStarRequest
         * @static
         * @param {propertypb.IPropertyImportStarRequest=} [properties] Properties to set
         * @returns {propertypb.PropertyImportStarRequest} PropertyImportStarRequest instance
         */
        PropertyImportStarRequest.create = function create(properties) {
            return new PropertyImportStarRequest(properties);
        };

        /**
         * Encodes the specified PropertyImportStarRequest message. Does not implicitly {@link propertypb.PropertyImportStarRequest.verify|verify} messages.
         * @function encode
         * @memberof propertypb.PropertyImportStarRequest
         * @static
         * @param {propertypb.IPropertyImportStarRequest} m PropertyImportStarRequest message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PropertyImportStarRequest.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.externalSource != null && Object.hasOwnProperty.call(m, "externalSource"))
                w.uint32(8).int32(m.externalSource);
            return w;
        };

        /**
         * Decodes a PropertyImportStarRequest message from the specified reader or buffer.
         * @function decode
         * @memberof propertypb.PropertyImportStarRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {propertypb.PropertyImportStarRequest} PropertyImportStarRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PropertyImportStarRequest.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.propertypb.PropertyImportStarRequest();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.externalSource = r.int32();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return PropertyImportStarRequest;
    })();

    propertypb.PropertyImportExperianRequest = (function() {

        /**
         * Properties of a PropertyImportExperianRequest.
         * @memberof propertypb
         * @interface IPropertyImportExperianRequest
         * @property {number|null} [fileCount] PropertyImportExperianRequest fileCount
         */

        /**
         * Constructs a new PropertyImportExperianRequest.
         * @memberof propertypb
         * @classdesc Represents a PropertyImportExperianRequest.
         * @implements IPropertyImportExperianRequest
         * @constructor
         * @param {propertypb.IPropertyImportExperianRequest=} [p] Properties to set
         */
        function PropertyImportExperianRequest(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * PropertyImportExperianRequest fileCount.
         * @member {number} fileCount
         * @memberof propertypb.PropertyImportExperianRequest
         * @instance
         */
        PropertyImportExperianRequest.prototype.fileCount = 0;

        /**
         * Creates a new PropertyImportExperianRequest instance using the specified properties.
         * @function create
         * @memberof propertypb.PropertyImportExperianRequest
         * @static
         * @param {propertypb.IPropertyImportExperianRequest=} [properties] Properties to set
         * @returns {propertypb.PropertyImportExperianRequest} PropertyImportExperianRequest instance
         */
        PropertyImportExperianRequest.create = function create(properties) {
            return new PropertyImportExperianRequest(properties);
        };

        /**
         * Encodes the specified PropertyImportExperianRequest message. Does not implicitly {@link propertypb.PropertyImportExperianRequest.verify|verify} messages.
         * @function encode
         * @memberof propertypb.PropertyImportExperianRequest
         * @static
         * @param {propertypb.IPropertyImportExperianRequest} m PropertyImportExperianRequest message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PropertyImportExperianRequest.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.fileCount != null && Object.hasOwnProperty.call(m, "fileCount"))
                w.uint32(8).uint32(m.fileCount);
            return w;
        };

        /**
         * Decodes a PropertyImportExperianRequest message from the specified reader or buffer.
         * @function decode
         * @memberof propertypb.PropertyImportExperianRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {propertypb.PropertyImportExperianRequest} PropertyImportExperianRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PropertyImportExperianRequest.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.propertypb.PropertyImportExperianRequest();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.fileCount = r.uint32();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return PropertyImportExperianRequest;
    })();

    propertypb.PropertyHistoryRequest = (function() {

        /**
         * Properties of a PropertyHistoryRequest.
         * @memberof propertypb
         * @interface IPropertyHistoryRequest
         * @property {string|null} [propertyID] PropertyHistoryRequest propertyID
         */

        /**
         * Constructs a new PropertyHistoryRequest.
         * @memberof propertypb
         * @classdesc Represents a PropertyHistoryRequest.
         * @implements IPropertyHistoryRequest
         * @constructor
         * @param {propertypb.IPropertyHistoryRequest=} [p] Properties to set
         */
        function PropertyHistoryRequest(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * PropertyHistoryRequest propertyID.
         * @member {string} propertyID
         * @memberof propertypb.PropertyHistoryRequest
         * @instance
         */
        PropertyHistoryRequest.prototype.propertyID = "";

        /**
         * Creates a new PropertyHistoryRequest instance using the specified properties.
         * @function create
         * @memberof propertypb.PropertyHistoryRequest
         * @static
         * @param {propertypb.IPropertyHistoryRequest=} [properties] Properties to set
         * @returns {propertypb.PropertyHistoryRequest} PropertyHistoryRequest instance
         */
        PropertyHistoryRequest.create = function create(properties) {
            return new PropertyHistoryRequest(properties);
        };

        /**
         * Encodes the specified PropertyHistoryRequest message. Does not implicitly {@link propertypb.PropertyHistoryRequest.verify|verify} messages.
         * @function encode
         * @memberof propertypb.PropertyHistoryRequest
         * @static
         * @param {propertypb.IPropertyHistoryRequest} m PropertyHistoryRequest message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PropertyHistoryRequest.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.propertyID != null && Object.hasOwnProperty.call(m, "propertyID"))
                w.uint32(10).string(m.propertyID);
            return w;
        };

        /**
         * Decodes a PropertyHistoryRequest message from the specified reader or buffer.
         * @function decode
         * @memberof propertypb.PropertyHistoryRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {propertypb.PropertyHistoryRequest} PropertyHistoryRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PropertyHistoryRequest.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.propertypb.PropertyHistoryRequest();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.propertyID = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return PropertyHistoryRequest;
    })();

    propertypb.PropertyHistoryResponse = (function() {

        /**
         * Properties of a PropertyHistoryResponse.
         * @memberof propertypb
         * @interface IPropertyHistoryResponse
         * @property {Array.<propertypb.IProperty>|null} [results] PropertyHistoryResponse results
         * @property {Array.<common.IError>|null} [errors] PropertyHistoryResponse errors
         * @property {common.Status|null} [status] PropertyHistoryResponse status
         */

        /**
         * Constructs a new PropertyHistoryResponse.
         * @memberof propertypb
         * @classdesc Represents a PropertyHistoryResponse.
         * @implements IPropertyHistoryResponse
         * @constructor
         * @param {propertypb.IPropertyHistoryResponse=} [p] Properties to set
         */
        function PropertyHistoryResponse(p) {
            this.results = [];
            this.errors = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * PropertyHistoryResponse results.
         * @member {Array.<propertypb.IProperty>} results
         * @memberof propertypb.PropertyHistoryResponse
         * @instance
         */
        PropertyHistoryResponse.prototype.results = $util.emptyArray;

        /**
         * PropertyHistoryResponse errors.
         * @member {Array.<common.IError>} errors
         * @memberof propertypb.PropertyHistoryResponse
         * @instance
         */
        PropertyHistoryResponse.prototype.errors = $util.emptyArray;

        /**
         * PropertyHistoryResponse status.
         * @member {common.Status} status
         * @memberof propertypb.PropertyHistoryResponse
         * @instance
         */
        PropertyHistoryResponse.prototype.status = 0;

        /**
         * Creates a new PropertyHistoryResponse instance using the specified properties.
         * @function create
         * @memberof propertypb.PropertyHistoryResponse
         * @static
         * @param {propertypb.IPropertyHistoryResponse=} [properties] Properties to set
         * @returns {propertypb.PropertyHistoryResponse} PropertyHistoryResponse instance
         */
        PropertyHistoryResponse.create = function create(properties) {
            return new PropertyHistoryResponse(properties);
        };

        /**
         * Encodes the specified PropertyHistoryResponse message. Does not implicitly {@link propertypb.PropertyHistoryResponse.verify|verify} messages.
         * @function encode
         * @memberof propertypb.PropertyHistoryResponse
         * @static
         * @param {propertypb.IPropertyHistoryResponse} m PropertyHistoryResponse message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PropertyHistoryResponse.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.results != null && m.results.length) {
                for (var i = 0; i < m.results.length; ++i)
                    $root.propertypb.Property.encode(m.results[i], w.uint32(10).fork()).ldelim();
            }
            if (m.errors != null && m.errors.length) {
                for (var i = 0; i < m.errors.length; ++i)
                    $root.common.Error.encode(m.errors[i], w.uint32(18).fork()).ldelim();
            }
            if (m.status != null && Object.hasOwnProperty.call(m, "status"))
                w.uint32(24).int32(m.status);
            return w;
        };

        /**
         * Decodes a PropertyHistoryResponse message from the specified reader or buffer.
         * @function decode
         * @memberof propertypb.PropertyHistoryResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {propertypb.PropertyHistoryResponse} PropertyHistoryResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PropertyHistoryResponse.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.propertypb.PropertyHistoryResponse();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    if (!(m.results && m.results.length))
                        m.results = [];
                    m.results.push($root.propertypb.Property.decode(r, r.uint32()));
                    break;
                case 2:
                    if (!(m.errors && m.errors.length))
                        m.errors = [];
                    m.errors.push($root.common.Error.decode(r, r.uint32()));
                    break;
                case 3:
                    m.status = r.int32();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return PropertyHistoryResponse;
    })();

    /**
     * The PatchFieldMask is used with the PropertyPatchRequest to indicate what fields should be updated
     * by the PropertyMS, only fields listed in the updateMask will be considered when applying patch
     * operation to any given property document
     * @name propertypb.PatchFieldMask
     * @enum {number}
     * @property {number} UPDATE_UNKNOWN_FIELD=0 UPDATE_UNKNOWN_FIELD value
     * @property {number} UPDATE_SQUARE_FOOT_RANGE=1 UPDATE_SQUARE_FOOT_RANGE value
     * @property {number} UPDATE_DWELLING_TYPE=2 UPDATE_DWELLING_TYPE value
     * @property {number} UPDATE_NUMBER_MOTHER_LAW_UNITS=3 UPDATE_NUMBER_MOTHER_LAW_UNITS value
     * @property {number} UPDATE_PROPERTY_VALUE=4 UPDATE_PROPERTY_VALUE value
     * @property {number} UPDATE_YEAR_BUILT=5 UPDATE_YEAR_BUILT value
     * @property {number} UPDATE_ZONING=6 UPDATE_ZONING value
     * @property {number} UPDATE_PARCEL_NUMBERS=7 UPDATE_PARCEL_NUMBERS value
     */
    propertypb.PatchFieldMask = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "UPDATE_UNKNOWN_FIELD"] = 0;
        values[valuesById[1] = "UPDATE_SQUARE_FOOT_RANGE"] = 1;
        values[valuesById[2] = "UPDATE_DWELLING_TYPE"] = 2;
        values[valuesById[3] = "UPDATE_NUMBER_MOTHER_LAW_UNITS"] = 3;
        values[valuesById[4] = "UPDATE_PROPERTY_VALUE"] = 4;
        values[valuesById[5] = "UPDATE_YEAR_BUILT"] = 5;
        values[valuesById[6] = "UPDATE_ZONING"] = 6;
        values[valuesById[7] = "UPDATE_PARCEL_NUMBERS"] = 7;
        return values;
    })();

    propertypb.PropertyPatchRequest = (function() {

        /**
         * Properties of a PropertyPatchRequest.
         * @memberof propertypb
         * @interface IPropertyPatchRequest
         * @property {string|null} [propertyId] PropertyPatchRequest propertyId
         * @property {number|Long|null} [starPropertyId] PropertyPatchRequest starPropertyId
         * @property {propertypb.IProperty|null} [property] PropertyPatchRequest property
         * @property {Array.<propertypb.PatchFieldMask>|null} [updateMask] PropertyPatchRequest updateMask
         */

        /**
         * Constructs a new PropertyPatchRequest.
         * @memberof propertypb
         * @classdesc Represents a PropertyPatchRequest.
         * @implements IPropertyPatchRequest
         * @constructor
         * @param {propertypb.IPropertyPatchRequest=} [p] Properties to set
         */
        function PropertyPatchRequest(p) {
            this.updateMask = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * PropertyPatchRequest propertyId.
         * @member {string} propertyId
         * @memberof propertypb.PropertyPatchRequest
         * @instance
         */
        PropertyPatchRequest.prototype.propertyId = "";

        /**
         * PropertyPatchRequest starPropertyId.
         * @member {number|Long} starPropertyId
         * @memberof propertypb.PropertyPatchRequest
         * @instance
         */
        PropertyPatchRequest.prototype.starPropertyId = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * PropertyPatchRequest property.
         * @member {propertypb.IProperty|null|undefined} property
         * @memberof propertypb.PropertyPatchRequest
         * @instance
         */
        PropertyPatchRequest.prototype.property = null;

        /**
         * PropertyPatchRequest updateMask.
         * @member {Array.<propertypb.PatchFieldMask>} updateMask
         * @memberof propertypb.PropertyPatchRequest
         * @instance
         */
        PropertyPatchRequest.prototype.updateMask = $util.emptyArray;

        /**
         * Creates a new PropertyPatchRequest instance using the specified properties.
         * @function create
         * @memberof propertypb.PropertyPatchRequest
         * @static
         * @param {propertypb.IPropertyPatchRequest=} [properties] Properties to set
         * @returns {propertypb.PropertyPatchRequest} PropertyPatchRequest instance
         */
        PropertyPatchRequest.create = function create(properties) {
            return new PropertyPatchRequest(properties);
        };

        /**
         * Encodes the specified PropertyPatchRequest message. Does not implicitly {@link propertypb.PropertyPatchRequest.verify|verify} messages.
         * @function encode
         * @memberof propertypb.PropertyPatchRequest
         * @static
         * @param {propertypb.IPropertyPatchRequest} m PropertyPatchRequest message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PropertyPatchRequest.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.propertyId != null && Object.hasOwnProperty.call(m, "propertyId"))
                w.uint32(10).string(m.propertyId);
            if (m.starPropertyId != null && Object.hasOwnProperty.call(m, "starPropertyId"))
                w.uint32(16).uint64(m.starPropertyId);
            if (m.property != null && Object.hasOwnProperty.call(m, "property"))
                $root.propertypb.Property.encode(m.property, w.uint32(50).fork()).ldelim();
            if (m.updateMask != null && m.updateMask.length) {
                w.uint32(66).fork();
                for (var i = 0; i < m.updateMask.length; ++i)
                    w.int32(m.updateMask[i]);
                w.ldelim();
            }
            return w;
        };

        /**
         * Decodes a PropertyPatchRequest message from the specified reader or buffer.
         * @function decode
         * @memberof propertypb.PropertyPatchRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {propertypb.PropertyPatchRequest} PropertyPatchRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PropertyPatchRequest.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.propertypb.PropertyPatchRequest();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.propertyId = r.string();
                    break;
                case 2:
                    m.starPropertyId = r.uint64();
                    break;
                case 6:
                    m.property = $root.propertypb.Property.decode(r, r.uint32());
                    break;
                case 8:
                    if (!(m.updateMask && m.updateMask.length))
                        m.updateMask = [];
                    if ((t & 7) === 2) {
                        var c2 = r.uint32() + r.pos;
                        while (r.pos < c2)
                            m.updateMask.push(r.int32());
                    } else
                        m.updateMask.push(r.int32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return PropertyPatchRequest;
    })();

    propertypb.PropertyPatchResponse = (function() {

        /**
         * Properties of a PropertyPatchResponse.
         * @memberof propertypb
         * @interface IPropertyPatchResponse
         * @property {propertypb.IProperty|null} [property] PropertyPatchResponse property
         * @property {Array.<common.IError>|null} [errors] PropertyPatchResponse errors
         * @property {common.Status|null} [status] PropertyPatchResponse status
         */

        /**
         * Constructs a new PropertyPatchResponse.
         * @memberof propertypb
         * @classdesc Represents a PropertyPatchResponse.
         * @implements IPropertyPatchResponse
         * @constructor
         * @param {propertypb.IPropertyPatchResponse=} [p] Properties to set
         */
        function PropertyPatchResponse(p) {
            this.errors = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * PropertyPatchResponse property.
         * @member {propertypb.IProperty|null|undefined} property
         * @memberof propertypb.PropertyPatchResponse
         * @instance
         */
        PropertyPatchResponse.prototype.property = null;

        /**
         * PropertyPatchResponse errors.
         * @member {Array.<common.IError>} errors
         * @memberof propertypb.PropertyPatchResponse
         * @instance
         */
        PropertyPatchResponse.prototype.errors = $util.emptyArray;

        /**
         * PropertyPatchResponse status.
         * @member {common.Status} status
         * @memberof propertypb.PropertyPatchResponse
         * @instance
         */
        PropertyPatchResponse.prototype.status = 0;

        /**
         * Creates a new PropertyPatchResponse instance using the specified properties.
         * @function create
         * @memberof propertypb.PropertyPatchResponse
         * @static
         * @param {propertypb.IPropertyPatchResponse=} [properties] Properties to set
         * @returns {propertypb.PropertyPatchResponse} PropertyPatchResponse instance
         */
        PropertyPatchResponse.create = function create(properties) {
            return new PropertyPatchResponse(properties);
        };

        /**
         * Encodes the specified PropertyPatchResponse message. Does not implicitly {@link propertypb.PropertyPatchResponse.verify|verify} messages.
         * @function encode
         * @memberof propertypb.PropertyPatchResponse
         * @static
         * @param {propertypb.IPropertyPatchResponse} m PropertyPatchResponse message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PropertyPatchResponse.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.property != null && Object.hasOwnProperty.call(m, "property"))
                $root.propertypb.Property.encode(m.property, w.uint32(10).fork()).ldelim();
            if (m.errors != null && m.errors.length) {
                for (var i = 0; i < m.errors.length; ++i)
                    $root.common.Error.encode(m.errors[i], w.uint32(18).fork()).ldelim();
            }
            if (m.status != null && Object.hasOwnProperty.call(m, "status"))
                w.uint32(24).int32(m.status);
            return w;
        };

        /**
         * Decodes a PropertyPatchResponse message from the specified reader or buffer.
         * @function decode
         * @memberof propertypb.PropertyPatchResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {propertypb.PropertyPatchResponse} PropertyPatchResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PropertyPatchResponse.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.propertypb.PropertyPatchResponse();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.property = $root.propertypb.Property.decode(r, r.uint32());
                    break;
                case 2:
                    if (!(m.errors && m.errors.length))
                        m.errors = [];
                    m.errors.push($root.common.Error.decode(r, r.uint32()));
                    break;
                case 3:
                    m.status = r.int32();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return PropertyPatchResponse;
    })();

    propertypb.CreateProperty = (function() {

        /**
         * Constructs a new CreateProperty service.
         * @memberof propertypb
         * @classdesc Represents a CreateProperty
         * @extends $protobuf.rpc.Service
         * @constructor
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         */
        function CreateProperty(rpcImpl, requestDelimited, responseDelimited) {
            $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
        }

        (CreateProperty.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = CreateProperty;

        /**
         * Creates new CreateProperty service using the specified rpc implementation.
         * @function create
         * @memberof propertypb.CreateProperty
         * @static
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         * @returns {CreateProperty} RPC service. Useful where requests and/or responses are streamed.
         */
        CreateProperty.create = function create(rpcImpl, requestDelimited, responseDelimited) {
            return new this(rpcImpl, requestDelimited, responseDelimited);
        };

        /**
         * Callback as used by {@link propertypb.CreateProperty#createProperty}.
         * @memberof propertypb.CreateProperty
         * @typedef CreatePropertyCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {propertypb.PropertyCreationResponse} [response] PropertyCreationResponse
         */

        /**
         * Calls CreateProperty.
         * @function createProperty
         * @memberof propertypb.CreateProperty
         * @instance
         * @param {propertypb.IPropertyCreationRequest} request PropertyCreationRequest message or plain object
         * @param {propertypb.CreateProperty.CreatePropertyCallback} callback Node-style callback called with the error, if any, and PropertyCreationResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(CreateProperty.prototype.createProperty = function createProperty(request, callback) {
            return this.rpcCall(createProperty, $root.propertypb.PropertyCreationRequest, $root.propertypb.PropertyCreationResponse, request, callback);
        }, "name", { value: "CreateProperty" });

        /**
         * Calls CreateProperty.
         * @function createProperty
         * @memberof propertypb.CreateProperty
         * @instance
         * @param {propertypb.IPropertyCreationRequest} request PropertyCreationRequest message or plain object
         * @returns {Promise<propertypb.PropertyCreationResponse>} Promise
         * @variation 2
         */

        return CreateProperty;
    })();

    propertypb.GetPropertyByID = (function() {

        /**
         * Constructs a new GetPropertyByID service.
         * @memberof propertypb
         * @classdesc Represents a GetPropertyByID
         * @extends $protobuf.rpc.Service
         * @constructor
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         */
        function GetPropertyByID(rpcImpl, requestDelimited, responseDelimited) {
            $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
        }

        (GetPropertyByID.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = GetPropertyByID;

        /**
         * Creates new GetPropertyByID service using the specified rpc implementation.
         * @function create
         * @memberof propertypb.GetPropertyByID
         * @static
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         * @returns {GetPropertyByID} RPC service. Useful where requests and/or responses are streamed.
         */
        GetPropertyByID.create = function create(rpcImpl, requestDelimited, responseDelimited) {
            return new this(rpcImpl, requestDelimited, responseDelimited);
        };

        /**
         * Callback as used by {@link propertypb.GetPropertyByID#getPropertyByID}.
         * @memberof propertypb.GetPropertyByID
         * @typedef GetPropertyByIDCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {propertypb.PropertyByIDResponse} [response] PropertyByIDResponse
         */

        /**
         * Calls GetPropertyByID.
         * @function getPropertyByID
         * @memberof propertypb.GetPropertyByID
         * @instance
         * @param {propertypb.IPropertyByIDRequest} request PropertyByIDRequest message or plain object
         * @param {propertypb.GetPropertyByID.GetPropertyByIDCallback} callback Node-style callback called with the error, if any, and PropertyByIDResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(GetPropertyByID.prototype.getPropertyByID = function getPropertyByID(request, callback) {
            return this.rpcCall(getPropertyByID, $root.propertypb.PropertyByIDRequest, $root.propertypb.PropertyByIDResponse, request, callback);
        }, "name", { value: "GetPropertyByID" });

        /**
         * Calls GetPropertyByID.
         * @function getPropertyByID
         * @memberof propertypb.GetPropertyByID
         * @instance
         * @param {propertypb.IPropertyByIDRequest} request PropertyByIDRequest message or plain object
         * @returns {Promise<propertypb.PropertyByIDResponse>} Promise
         * @variation 2
         */

        return GetPropertyByID;
    })();

    propertypb.UpdateProperty = (function() {

        /**
         * Constructs a new UpdateProperty service.
         * @memberof propertypb
         * @classdesc Represents an UpdateProperty
         * @extends $protobuf.rpc.Service
         * @constructor
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         */
        function UpdateProperty(rpcImpl, requestDelimited, responseDelimited) {
            $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
        }

        (UpdateProperty.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = UpdateProperty;

        /**
         * Creates new UpdateProperty service using the specified rpc implementation.
         * @function create
         * @memberof propertypb.UpdateProperty
         * @static
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         * @returns {UpdateProperty} RPC service. Useful where requests and/or responses are streamed.
         */
        UpdateProperty.create = function create(rpcImpl, requestDelimited, responseDelimited) {
            return new this(rpcImpl, requestDelimited, responseDelimited);
        };

        /**
         * Callback as used by {@link propertypb.UpdateProperty#updateProperty}.
         * @memberof propertypb.UpdateProperty
         * @typedef UpdatePropertyCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {propertypb.PropertyPatchResponse} [response] PropertyPatchResponse
         */

        /**
         * Calls UpdateProperty.
         * @function updateProperty
         * @memberof propertypb.UpdateProperty
         * @instance
         * @param {propertypb.IPropertyPatchRequest} request PropertyPatchRequest message or plain object
         * @param {propertypb.UpdateProperty.UpdatePropertyCallback} callback Node-style callback called with the error, if any, and PropertyPatchResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(UpdateProperty.prototype.updateProperty = function updateProperty(request, callback) {
            return this.rpcCall(updateProperty, $root.propertypb.PropertyPatchRequest, $root.propertypb.PropertyPatchResponse, request, callback);
        }, "name", { value: "UpdateProperty" });

        /**
         * Calls UpdateProperty.
         * @function updateProperty
         * @memberof propertypb.UpdateProperty
         * @instance
         * @param {propertypb.IPropertyPatchRequest} request PropertyPatchRequest message or plain object
         * @returns {Promise<propertypb.PropertyPatchResponse>} Promise
         * @variation 2
         */

        return UpdateProperty;
    })();

    propertypb.ModifyProperty = (function() {

        /**
         * Constructs a new ModifyProperty service.
         * @memberof propertypb
         * @classdesc Represents a ModifyProperty
         * @extends $protobuf.rpc.Service
         * @constructor
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         */
        function ModifyProperty(rpcImpl, requestDelimited, responseDelimited) {
            $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
        }

        (ModifyProperty.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = ModifyProperty;

        /**
         * Creates new ModifyProperty service using the specified rpc implementation.
         * @function create
         * @memberof propertypb.ModifyProperty
         * @static
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         * @returns {ModifyProperty} RPC service. Useful where requests and/or responses are streamed.
         */
        ModifyProperty.create = function create(rpcImpl, requestDelimited, responseDelimited) {
            return new this(rpcImpl, requestDelimited, responseDelimited);
        };

        /**
         * Callback as used by {@link propertypb.ModifyProperty#modifyProperty}.
         * @memberof propertypb.ModifyProperty
         * @typedef ModifyPropertyCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {propertypb.PropertyModificationResponse} [response] PropertyModificationResponse
         */

        /**
         * Calls ModifyProperty.
         * @function modifyProperty
         * @memberof propertypb.ModifyProperty
         * @instance
         * @param {propertypb.IPropertyModificationRequest} request PropertyModificationRequest message or plain object
         * @param {propertypb.ModifyProperty.ModifyPropertyCallback} callback Node-style callback called with the error, if any, and PropertyModificationResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(ModifyProperty.prototype.modifyProperty = function modifyProperty(request, callback) {
            return this.rpcCall(modifyProperty, $root.propertypb.PropertyModificationRequest, $root.propertypb.PropertyModificationResponse, request, callback);
        }, "name", { value: "ModifyProperty" });

        /**
         * Calls ModifyProperty.
         * @function modifyProperty
         * @memberof propertypb.ModifyProperty
         * @instance
         * @param {propertypb.IPropertyModificationRequest} request PropertyModificationRequest message or plain object
         * @returns {Promise<propertypb.PropertyModificationResponse>} Promise
         * @variation 2
         */

        return ModifyProperty;
    })();

    propertypb.GetPropertyByLegacyID = (function() {

        /**
         * Constructs a new GetPropertyByLegacyID service.
         * @memberof propertypb
         * @classdesc Represents a GetPropertyByLegacyID
         * @extends $protobuf.rpc.Service
         * @constructor
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         */
        function GetPropertyByLegacyID(rpcImpl, requestDelimited, responseDelimited) {
            $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
        }

        (GetPropertyByLegacyID.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = GetPropertyByLegacyID;

        /**
         * Creates new GetPropertyByLegacyID service using the specified rpc implementation.
         * @function create
         * @memberof propertypb.GetPropertyByLegacyID
         * @static
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         * @returns {GetPropertyByLegacyID} RPC service. Useful where requests and/or responses are streamed.
         */
        GetPropertyByLegacyID.create = function create(rpcImpl, requestDelimited, responseDelimited) {
            return new this(rpcImpl, requestDelimited, responseDelimited);
        };

        /**
         * Callback as used by {@link propertypb.GetPropertyByLegacyID#getPropertyByLegacyID}.
         * @memberof propertypb.GetPropertyByLegacyID
         * @typedef GetPropertyByLegacyIDCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {propertypb.PropertyByLegacyIDResponse} [response] PropertyByLegacyIDResponse
         */

        /**
         * Calls GetPropertyByLegacyID.
         * @function getPropertyByLegacyID
         * @memberof propertypb.GetPropertyByLegacyID
         * @instance
         * @param {propertypb.IPropertyByLegacyIDRequest} request PropertyByLegacyIDRequest message or plain object
         * @param {propertypb.GetPropertyByLegacyID.GetPropertyByLegacyIDCallback} callback Node-style callback called with the error, if any, and PropertyByLegacyIDResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(GetPropertyByLegacyID.prototype.getPropertyByLegacyID = function getPropertyByLegacyID(request, callback) {
            return this.rpcCall(getPropertyByLegacyID, $root.propertypb.PropertyByLegacyIDRequest, $root.propertypb.PropertyByLegacyIDResponse, request, callback);
        }, "name", { value: "GetPropertyByLegacyID" });

        /**
         * Calls GetPropertyByLegacyID.
         * @function getPropertyByLegacyID
         * @memberof propertypb.GetPropertyByLegacyID
         * @instance
         * @param {propertypb.IPropertyByLegacyIDRequest} request PropertyByLegacyIDRequest message or plain object
         * @returns {Promise<propertypb.PropertyByLegacyIDResponse>} Promise
         * @variation 2
         */

        return GetPropertyByLegacyID;
    })();

    propertypb.GetPropertyByAddressID = (function() {

        /**
         * Constructs a new GetPropertyByAddressID service.
         * @memberof propertypb
         * @classdesc Represents a GetPropertyByAddressID
         * @extends $protobuf.rpc.Service
         * @constructor
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         */
        function GetPropertyByAddressID(rpcImpl, requestDelimited, responseDelimited) {
            $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
        }

        (GetPropertyByAddressID.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = GetPropertyByAddressID;

        /**
         * Creates new GetPropertyByAddressID service using the specified rpc implementation.
         * @function create
         * @memberof propertypb.GetPropertyByAddressID
         * @static
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         * @returns {GetPropertyByAddressID} RPC service. Useful where requests and/or responses are streamed.
         */
        GetPropertyByAddressID.create = function create(rpcImpl, requestDelimited, responseDelimited) {
            return new this(rpcImpl, requestDelimited, responseDelimited);
        };

        /**
         * Callback as used by {@link propertypb.GetPropertyByAddressID#getPropertyByAddressID}.
         * @memberof propertypb.GetPropertyByAddressID
         * @typedef GetPropertyByAddressIDCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {propertypb.PropertyByAddressIDResponse} [response] PropertyByAddressIDResponse
         */

        /**
         * Calls GetPropertyByAddressID.
         * @function getPropertyByAddressID
         * @memberof propertypb.GetPropertyByAddressID
         * @instance
         * @param {propertypb.IPropertyByAddressIDRequest} request PropertyByAddressIDRequest message or plain object
         * @param {propertypb.GetPropertyByAddressID.GetPropertyByAddressIDCallback} callback Node-style callback called with the error, if any, and PropertyByAddressIDResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(GetPropertyByAddressID.prototype.getPropertyByAddressID = function getPropertyByAddressID(request, callback) {
            return this.rpcCall(getPropertyByAddressID, $root.propertypb.PropertyByAddressIDRequest, $root.propertypb.PropertyByAddressIDResponse, request, callback);
        }, "name", { value: "GetPropertyByAddressID" });

        /**
         * Calls GetPropertyByAddressID.
         * @function getPropertyByAddressID
         * @memberof propertypb.GetPropertyByAddressID
         * @instance
         * @param {propertypb.IPropertyByAddressIDRequest} request PropertyByAddressIDRequest message or plain object
         * @returns {Promise<propertypb.PropertyByAddressIDResponse>} Promise
         * @variation 2
         */

        return GetPropertyByAddressID;
    })();

    propertypb.CreateLegacyIdInProperty = (function() {

        /**
         * Constructs a new CreateLegacyIdInProperty service.
         * @memberof propertypb
         * @classdesc Represents a CreateLegacyIdInProperty
         * @extends $protobuf.rpc.Service
         * @constructor
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         */
        function CreateLegacyIdInProperty(rpcImpl, requestDelimited, responseDelimited) {
            $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
        }

        (CreateLegacyIdInProperty.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = CreateLegacyIdInProperty;

        /**
         * Creates new CreateLegacyIdInProperty service using the specified rpc implementation.
         * @function create
         * @memberof propertypb.CreateLegacyIdInProperty
         * @static
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         * @returns {CreateLegacyIdInProperty} RPC service. Useful where requests and/or responses are streamed.
         */
        CreateLegacyIdInProperty.create = function create(rpcImpl, requestDelimited, responseDelimited) {
            return new this(rpcImpl, requestDelimited, responseDelimited);
        };

        /**
         * Callback as used by {@link propertypb.CreateLegacyIdInProperty#createLegacyIdInProperty}.
         * @memberof propertypb.CreateLegacyIdInProperty
         * @typedef CreateLegacyIdInPropertyCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {propertypb.PropertyLegacyIDCreationResponse} [response] PropertyLegacyIDCreationResponse
         */

        /**
         * Calls CreateLegacyIdInProperty.
         * @function createLegacyIdInProperty
         * @memberof propertypb.CreateLegacyIdInProperty
         * @instance
         * @param {propertypb.IPropertyLegacyIDCreationRequest} request PropertyLegacyIDCreationRequest message or plain object
         * @param {propertypb.CreateLegacyIdInProperty.CreateLegacyIdInPropertyCallback} callback Node-style callback called with the error, if any, and PropertyLegacyIDCreationResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(CreateLegacyIdInProperty.prototype.createLegacyIdInProperty = function createLegacyIdInProperty(request, callback) {
            return this.rpcCall(createLegacyIdInProperty, $root.propertypb.PropertyLegacyIDCreationRequest, $root.propertypb.PropertyLegacyIDCreationResponse, request, callback);
        }, "name", { value: "CreateLegacyIdInProperty" });

        /**
         * Calls CreateLegacyIdInProperty.
         * @function createLegacyIdInProperty
         * @memberof propertypb.CreateLegacyIdInProperty
         * @instance
         * @param {propertypb.IPropertyLegacyIDCreationRequest} request PropertyLegacyIDCreationRequest message or plain object
         * @returns {Promise<propertypb.PropertyLegacyIDCreationResponse>} Promise
         * @variation 2
         */

        return CreateLegacyIdInProperty;
    })();

    propertypb.DeleteLegacyIdInProperty = (function() {

        /**
         * Constructs a new DeleteLegacyIdInProperty service.
         * @memberof propertypb
         * @classdesc Represents a DeleteLegacyIdInProperty
         * @extends $protobuf.rpc.Service
         * @constructor
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         */
        function DeleteLegacyIdInProperty(rpcImpl, requestDelimited, responseDelimited) {
            $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
        }

        (DeleteLegacyIdInProperty.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = DeleteLegacyIdInProperty;

        /**
         * Creates new DeleteLegacyIdInProperty service using the specified rpc implementation.
         * @function create
         * @memberof propertypb.DeleteLegacyIdInProperty
         * @static
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         * @returns {DeleteLegacyIdInProperty} RPC service. Useful where requests and/or responses are streamed.
         */
        DeleteLegacyIdInProperty.create = function create(rpcImpl, requestDelimited, responseDelimited) {
            return new this(rpcImpl, requestDelimited, responseDelimited);
        };

        /**
         * Callback as used by {@link propertypb.DeleteLegacyIdInProperty#deleteLegacyIdInProperty}.
         * @memberof propertypb.DeleteLegacyIdInProperty
         * @typedef DeleteLegacyIdInPropertyCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {propertypb.PropertyLegacyIDDeletionResponse} [response] PropertyLegacyIDDeletionResponse
         */

        /**
         * Calls DeleteLegacyIdInProperty.
         * @function deleteLegacyIdInProperty
         * @memberof propertypb.DeleteLegacyIdInProperty
         * @instance
         * @param {propertypb.IPropertyLegacyIDDeletionRequest} request PropertyLegacyIDDeletionRequest message or plain object
         * @param {propertypb.DeleteLegacyIdInProperty.DeleteLegacyIdInPropertyCallback} callback Node-style callback called with the error, if any, and PropertyLegacyIDDeletionResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(DeleteLegacyIdInProperty.prototype.deleteLegacyIdInProperty = function deleteLegacyIdInProperty(request, callback) {
            return this.rpcCall(deleteLegacyIdInProperty, $root.propertypb.PropertyLegacyIDDeletionRequest, $root.propertypb.PropertyLegacyIDDeletionResponse, request, callback);
        }, "name", { value: "DeleteLegacyIdInProperty" });

        /**
         * Calls DeleteLegacyIdInProperty.
         * @function deleteLegacyIdInProperty
         * @memberof propertypb.DeleteLegacyIdInProperty
         * @instance
         * @param {propertypb.IPropertyLegacyIDDeletionRequest} request PropertyLegacyIDDeletionRequest message or plain object
         * @returns {Promise<propertypb.PropertyLegacyIDDeletionResponse>} Promise
         * @variation 2
         */

        return DeleteLegacyIdInProperty;
    })();

    return propertypb;
})();

export { $root as default };
